(() => {
    'use strict';
    var e,
        i = {},
        d = {};
    function a(e) {
        var n = d[e];
        if (void 0 !== n) return n.exports;
        var r = (d[e] = { id: e, loaded: !1, exports: {} });
        return i[e].call(r.exports, r, r.exports, a), (r.loaded = !0), r.exports;
    }
    (a.m = i),
        (e = []),
        (a.O = (n, r, s, l) => {
            if (!r) {
                var o = 1 / 0;
                for (f = 0; f < e.length; f++) {
                    for (var [r, s, l] = e[f], u = !0, t = 0; t < r.length; t++)
                        (!1 & l || o >= l) && Object.keys(a.O).every(p => a.O[p](r[t]))
                            ? r.splice(t--, 1)
                            : ((u = !1), l < o && (o = l));
                    if (u) {
                        e.splice(f--, 1);
                        var c = s();
                        void 0 !== c && (n = c);
                    }
                }
                return n;
            }
            l = l || 0;
            for (var f = e.length; f > 0 && e[f - 1][2] > l; f--) e[f] = e[f - 1];
            e[f] = [r, s, l];
        }),
        (a.n = e => {
            var n = e && e.__esModule ? () => e.default : () => e;
            return a.d(n, { a: n }), n;
        }),
        (a.d = (e, n) => {
            for (var r in n) a.o(n, r) && !a.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: n[r] });
        }),
        (a.o = (e, n) => Object.prototype.hasOwnProperty.call(e, n)),
        (a.nmd = e => ((e.paths = []), e.children || (e.children = []), e)),
        (() => {
            var e = { 121: 0 };
            a.O.j = s => 0 === e[s];
            var n = (s, l) => {
                    var t,
                        c,
                        [f, o, u] = l,
                        v = 0;
                    if (f.some(_ => 0 !== e[_])) {
                        for (t in o) a.o(o, t) && (a.m[t] = o[t]);
                        if (u) var h = u(a);
                    }
                    for (s && s(l); v < f.length; v++) a.o(e, (c = f[v])) && e[c] && e[c][0](), (e[c] = 0);
                    return a.O(h);
                },
                r = (self.webpackChunklforms = self.webpackChunklforms || []);
            r.forEach(n.bind(null, 0)), (r.push = n.bind(null, r.push.bind(r)));
        })();
})();

(self.webpackChunklforms = self.webpackChunklforms || []).push([
    [461],
    { 4050: () => {} },
    s => {
        s((s.s = 4050));
    },
]);

(self.webpackChunklforms = self.webpackChunklforms || []).push([
    [792],
    {
        3759: (se, ae, U) => {
            'use strict';
            let G = null,
                v = 1;
            const p = Symbol('SIGNAL');
            function _(t) {
                const n = G;
                return (G = t), n;
            }
            function j(t) {
                if ((!je(t) || t.dirty) && (t.dirty || t.lastCleanEpoch !== v)) {
                    if (!t.producerMustRecompute(t) && !De(t)) return (t.dirty = !1), void (t.lastCleanEpoch = v);
                    t.producerRecomputeValue(t), (t.dirty = !1), (t.lastCleanEpoch = v);
                }
            }
            function De(t) {
                Ne(t);
                for (let n = 0; n < t.producerNode.length; n++) {
                    const e = t.producerNode[n],
                        i = t.producerLastReadVersion[n];
                    if (i !== e.version || (j(e), i !== e.version)) return !0;
                }
                return !1;
            }
            function b(t, n) {
                if (
                    ((function at(t) {
                        (t.liveConsumerNode ??= []), (t.liveConsumerIndexOfThis ??= []);
                    })(t),
                    Ne(t),
                    1 === t.liveConsumerNode.length)
                )
                    for (let i = 0; i < t.producerNode.length; i++) b(t.producerNode[i], t.producerIndexOfThis[i]);
                const e = t.liveConsumerNode.length - 1;
                if (
                    ((t.liveConsumerNode[n] = t.liveConsumerNode[e]),
                    (t.liveConsumerIndexOfThis[n] = t.liveConsumerIndexOfThis[e]),
                    t.liveConsumerNode.length--,
                    t.liveConsumerIndexOfThis.length--,
                    n < t.liveConsumerNode.length)
                ) {
                    const i = t.liveConsumerIndexOfThis[n],
                        r = t.liveConsumerNode[n];
                    Ne(r), (r.producerIndexOfThis[i] = n);
                }
            }
            function je(t) {
                return t.consumerIsAlwaysLive || (t?.liveConsumerNode?.length ?? 0) > 0;
            }
            function Ne(t) {
                (t.producerNode ??= []), (t.producerIndexOfThis ??= []), (t.producerLastReadVersion ??= []);
            }
            let Sn = null;
            function et(t) {
                return 'function' == typeof t;
            }
            function qn(t) {
                const e = t(i => {
                    Error.call(i), (i.stack = new Error().stack);
                });
                return (e.prototype = Object.create(Error.prototype)), (e.prototype.constructor = e), e;
            }
            const Ji = qn(
                t =>
                    function (e) {
                        t(this),
                            (this.message = e
                                ? `${e.length} errors occurred during unsubscription:\n${e
                                      .map((i, r) => `${r + 1}) ${i.toString()}`)
                                      .join('\n  ')}`
                                : ''),
                            (this.name = 'UnsubscriptionError'),
                            (this.errors = e);
                    },
            );
            function Ti(t, n) {
                if (t) {
                    const e = t.indexOf(n);
                    0 <= e && t.splice(e, 1);
                }
            }
            class ii {
                constructor(n) {
                    (this.initialTeardown = n), (this.closed = !1), (this._parentage = null), (this._finalizers = null);
                }
                unsubscribe() {
                    let n;
                    if (!this.closed) {
                        this.closed = !0;
                        const { _parentage: e } = this;
                        if (e)
                            if (((this._parentage = null), Array.isArray(e))) for (const s of e) s.remove(this);
                            else e.remove(this);
                        const { initialTeardown: i } = this;
                        if (et(i))
                            try {
                                i();
                            } catch (s) {
                                n = s instanceof Ji ? s.errors : [s];
                            }
                        const { _finalizers: r } = this;
                        if (r) {
                            this._finalizers = null;
                            for (const s of r)
                                try {
                                    Ri(s);
                                } catch (o) {
                                    (n = n ?? []), o instanceof Ji ? (n = [...n, ...o.errors]) : n.push(o);
                                }
                        }
                        if (n) throw new Ji(n);
                    }
                }
                add(n) {
                    var e;
                    if (n && n !== this)
                        if (this.closed) Ri(n);
                        else {
                            if (n instanceof ii) {
                                if (n.closed || n._hasParent(this)) return;
                                n._addParent(this);
                            }
                            (this._finalizers = null !== (e = this._finalizers) && void 0 !== e ? e : []).push(n);
                        }
                }
                _hasParent(n) {
                    const { _parentage: e } = this;
                    return e === n || (Array.isArray(e) && e.includes(n));
                }
                _addParent(n) {
                    const { _parentage: e } = this;
                    this._parentage = Array.isArray(e) ? (e.push(n), e) : e ? [e, n] : n;
                }
                _removeParent(n) {
                    const { _parentage: e } = this;
                    e === n ? (this._parentage = null) : Array.isArray(e) && Ti(e, n);
                }
                remove(n) {
                    const { _finalizers: e } = this;
                    e && Ti(e, n), n instanceof ii && n._removeParent(this);
                }
            }
            ii.EMPTY = (() => {
                const t = new ii();
                return (t.closed = !0), t;
            })();
            const Vs = ii.EMPTY;
            function rr(t) {
                return t instanceof ii || (t && 'closed' in t && et(t.remove) && et(t.add) && et(t.unsubscribe));
            }
            function Ri(t) {
                et(t) ? t() : t.unsubscribe();
            }
            const Oi = {
                    onUnhandledError: null,
                    onStoppedNotification: null,
                    Promise: void 0,
                    useDeprecatedSynchronousErrorHandling: !1,
                    useDeprecatedNextContext: !1,
                },
                Hs = {
                    setTimeout(t, n, ...e) {
                        const { delegate: i } = Hs;
                        return i?.setTimeout ? i.setTimeout(t, n, ...e) : setTimeout(t, n, ...e);
                    },
                    clearTimeout(t) {
                        const { delegate: n } = Hs;
                        return (n?.clearTimeout || clearTimeout)(t);
                    },
                    delegate: void 0,
                };
            function pr(t) {
                Hs.setTimeout(() => {
                    const { onUnhandledError: n } = Oi;
                    if (!n) throw t;
                    n(t);
                });
            }
            function Kn() {}
            const Us = Ut('C', void 0, void 0);
            function Ut(t, n, e) {
                return { kind: t, value: n, error: e };
            }
            let sr = null;
            function Es(t) {
                if (Oi.useDeprecatedSynchronousErrorHandling) {
                    const n = !sr;
                    if ((n && (sr = { errorThrown: !1, error: null }), t(), n)) {
                        const { errorThrown: e, error: i } = sr;
                        if (((sr = null), e)) throw i;
                    }
                } else t();
            }
            class Qo extends ii {
                constructor(n) {
                    super(),
                        (this.isStopped = !1),
                        n ? ((this.destination = n), rr(n) && n.add(this)) : (this.destination = Is);
                }
                static create(n, e, i) {
                    return new on(n, e, i);
                }
                next(n) {
                    this.isStopped
                        ? lt(
                              (function gn(t) {
                                  return Ut('N', t, void 0);
                              })(n),
                              this,
                          )
                        : this._next(n);
                }
                error(n) {
                    this.isStopped
                        ? lt(
                              (function ft(t) {
                                  return Ut('E', void 0, t);
                              })(n),
                              this,
                          )
                        : ((this.isStopped = !0), this._error(n));
                }
                complete() {
                    this.isStopped ? lt(Us, this) : ((this.isStopped = !0), this._complete());
                }
                unsubscribe() {
                    this.closed || ((this.isStopped = !0), super.unsubscribe(), (this.destination = null));
                }
                _next(n) {
                    this.destination.next(n);
                }
                _error(n) {
                    try {
                        this.destination.error(n);
                    } finally {
                        this.unsubscribe();
                    }
                }
                _complete() {
                    try {
                        this.destination.complete();
                    } finally {
                        this.unsubscribe();
                    }
                }
            }
            const to = Function.prototype.bind;
            function _e(t, n) {
                return to.call(t, n);
            }
            class ye {
                constructor(n) {
                    this.partialObserver = n;
                }
                next(n) {
                    const { partialObserver: e } = this;
                    if (e.next)
                        try {
                            e.next(n);
                        } catch (i) {
                            kn(i);
                        }
                }
                error(n) {
                    const { partialObserver: e } = this;
                    if (e.error)
                        try {
                            e.error(n);
                        } catch (i) {
                            kn(i);
                        }
                    else kn(n);
                }
                complete() {
                    const { partialObserver: n } = this;
                    if (n.complete)
                        try {
                            n.complete();
                        } catch (e) {
                            kn(e);
                        }
                }
            }
            class on extends Qo {
                constructor(n, e, i) {
                    let r;
                    if ((super(), et(n) || !n)) r = { next: n ?? void 0, error: e ?? void 0, complete: i ?? void 0 };
                    else {
                        let s;
                        this && Oi.useDeprecatedNextContext
                            ? ((s = Object.create(n)),
                              (s.unsubscribe = () => this.unsubscribe()),
                              (r = {
                                  next: n.next && _e(n.next, s),
                                  error: n.error && _e(n.error, s),
                                  complete: n.complete && _e(n.complete, s),
                              }))
                            : (r = n);
                    }
                    this.destination = new ye(r);
                }
            }
            function kn(t) {
                Oi.useDeprecatedSynchronousErrorHandling
                    ? (function hl(t) {
                          Oi.useDeprecatedSynchronousErrorHandling && sr && ((sr.errorThrown = !0), (sr.error = t));
                      })(t)
                    : pr(t);
            }
            function lt(t, n) {
                const { onStoppedNotification: e } = Oi;
                e && Hs.setTimeout(() => e(t, n));
            }
            const Is = {
                    closed: !0,
                    next: Kn,
                    error: function Qn(t) {
                        throw t;
                    },
                    complete: Kn,
                },
                As = ('function' == typeof Symbol && Symbol.observable) || '@@observable';
            function Yn(t) {
                return t;
            }
            let Tn = (() => {
                class t {
                    constructor(e) {
                        e && (this._subscribe = e);
                    }
                    lift(e) {
                        const i = new t();
                        return (i.source = this), (i.operator = e), i;
                    }
                    subscribe(e, i, r) {
                        const s = (function So(t) {
                            return (
                                (t && t instanceof Qo) ||
                                ((function gr(t) {
                                    return t && et(t.next) && et(t.error) && et(t.complete);
                                })(t) &&
                                    rr(t))
                            );
                        })(e)
                            ? e
                            : new on(e, i, r);
                        return (
                            Es(() => {
                                const { operator: o, source: a } = this;
                                s.add(o ? o.call(s, a) : a ? this._subscribe(s) : this._trySubscribe(s));
                            }),
                            s
                        );
                    }
                    _trySubscribe(e) {
                        try {
                            return this._subscribe(e);
                        } catch (i) {
                            e.error(i);
                        }
                    }
                    forEach(e, i) {
                        return new (i = ni(i))((r, s) => {
                            const o = new on({
                                next: a => {
                                    try {
                                        e(a);
                                    } catch (l) {
                                        s(l), o.unsubscribe();
                                    }
                                },
                                error: s,
                                complete: r,
                            });
                            this.subscribe(o);
                        });
                    }
                    _subscribe(e) {
                        var i;
                        return null === (i = this.source) || void 0 === i ? void 0 : i.subscribe(e);
                    }
                    [As]() {
                        return this;
                    }
                    pipe(...e) {
                        return (function no(t) {
                            return 0 === t.length
                                ? Yn
                                : 1 === t.length
                                ? t[0]
                                : function (e) {
                                      return t.reduce((i, r) => r(i), e);
                                  };
                        })(e)(this);
                    }
                    toPromise(e) {
                        return new (e = ni(e))((i, r) => {
                            let s;
                            this.subscribe(
                                o => (s = o),
                                o => r(o),
                                () => i(s),
                            );
                        });
                    }
                }
                return (t.create = n => new t(n)), t;
            })();
            function ni(t) {
                var n;
                return null !== (n = t ?? Oi.Promise) && void 0 !== n ? n : Promise;
            }
            const Hl = qn(
                t =>
                    function () {
                        t(this), (this.name = 'ObjectUnsubscribedError'), (this.message = 'object unsubscribed');
                    },
            );
            let vt = (() => {
                class t extends Tn {
                    constructor() {
                        super(),
                            (this.closed = !1),
                            (this.currentObservers = null),
                            (this.observers = []),
                            (this.isStopped = !1),
                            (this.hasError = !1),
                            (this.thrownError = null);
                    }
                    lift(e) {
                        const i = new io(this, this);
                        return (i.operator = e), i;
                    }
                    _throwIfClosed() {
                        if (this.closed) throw new Hl();
                    }
                    next(e) {
                        Es(() => {
                            if ((this._throwIfClosed(), !this.isStopped)) {
                                this.currentObservers || (this.currentObservers = Array.from(this.observers));
                                for (const i of this.currentObservers) i.next(e);
                            }
                        });
                    }
                    error(e) {
                        Es(() => {
                            if ((this._throwIfClosed(), !this.isStopped)) {
                                (this.hasError = this.isStopped = !0), (this.thrownError = e);
                                const { observers: i } = this;
                                for (; i.length; ) i.shift().error(e);
                            }
                        });
                    }
                    complete() {
                        Es(() => {
                            if ((this._throwIfClosed(), !this.isStopped)) {
                                this.isStopped = !0;
                                const { observers: e } = this;
                                for (; e.length; ) e.shift().complete();
                            }
                        });
                    }
                    unsubscribe() {
                        (this.isStopped = this.closed = !0), (this.observers = this.currentObservers = null);
                    }
                    get observed() {
                        var e;
                        return (null === (e = this.observers) || void 0 === e ? void 0 : e.length) > 0;
                    }
                    _trySubscribe(e) {
                        return this._throwIfClosed(), super._trySubscribe(e);
                    }
                    _subscribe(e) {
                        return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
                    }
                    _innerSubscribe(e) {
                        const { hasError: i, isStopped: r, observers: s } = this;
                        return i || r
                            ? Vs
                            : ((this.currentObservers = null),
                              s.push(e),
                              new ii(() => {
                                  (this.currentObservers = null), Ti(s, e);
                              }));
                    }
                    _checkFinalizedStatuses(e) {
                        const { hasError: i, thrownError: r, isStopped: s } = this;
                        i ? e.error(r) : s && e.complete();
                    }
                    asObservable() {
                        const e = new Tn();
                        return (e.source = this), e;
                    }
                }
                return (t.create = (n, e) => new io(n, e)), t;
            })();
            class io extends vt {
                constructor(n, e) {
                    super(), (this.destination = n), (this.source = e);
                }
                next(n) {
                    var e, i;
                    null === (i = null === (e = this.destination) || void 0 === e ? void 0 : e.next) ||
                        void 0 === i ||
                        i.call(e, n);
                }
                error(n) {
                    var e, i;
                    null === (i = null === (e = this.destination) || void 0 === e ? void 0 : e.error) ||
                        void 0 === i ||
                        i.call(e, n);
                }
                complete() {
                    var n, e;
                    null === (e = null === (n = this.destination) || void 0 === n ? void 0 : n.complete) ||
                        void 0 === e ||
                        e.call(n);
                }
                _subscribe(n) {
                    var e, i;
                    return null !== (i = null === (e = this.source) || void 0 === e ? void 0 : e.subscribe(n)) &&
                        void 0 !== i
                        ? i
                        : Vs;
                }
            }
            class Ke extends vt {
                constructor(n) {
                    super(), (this._value = n);
                }
                get value() {
                    return this.getValue();
                }
                _subscribe(n) {
                    const e = super._subscribe(n);
                    return !e.closed && n.next(this._value), e;
                }
                getValue() {
                    const { hasError: n, thrownError: e, _value: i } = this;
                    if (n) throw e;
                    return this._throwIfClosed(), i;
                }
                next(n) {
                    super.next((this._value = n));
                }
            }
            function mi(t) {
                return n => {
                    if (
                        (function ro(t) {
                            return et(t?.lift);
                        })(n)
                    )
                        return n.lift(function (e) {
                            try {
                                return t(e, this);
                            } catch (i) {
                                this.error(i);
                            }
                        });
                    throw new TypeError('Unable to lift unknown Observable type');
                };
            }
            function ln(t, n, e, i, r) {
                return new za(t, n, e, i, r);
            }
            class za extends Qo {
                constructor(n, e, i, r, s, o) {
                    super(n),
                        (this.onFinalize = s),
                        (this.shouldUnsubscribe = o),
                        (this._next = e
                            ? function (a) {
                                  try {
                                      e(a);
                                  } catch (l) {
                                      n.error(l);
                                  }
                              }
                            : super._next),
                        (this._error = r
                            ? function (a) {
                                  try {
                                      r(a);
                                  } catch (l) {
                                      n.error(l);
                                  } finally {
                                      this.unsubscribe();
                                  }
                              }
                            : super._error),
                        (this._complete = i
                            ? function () {
                                  try {
                                      i();
                                  } catch (a) {
                                      n.error(a);
                                  } finally {
                                      this.unsubscribe();
                                  }
                              }
                            : super._complete);
                }
                unsubscribe() {
                    var n;
                    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
                        const { closed: e } = this;
                        super.unsubscribe(), !e && (null === (n = this.onFinalize) || void 0 === n || n.call(this));
                    }
                }
            }
            function Ct(t, n) {
                return mi((e, i) => {
                    let r = 0;
                    e.subscribe(
                        ln(i, s => {
                            i.next(t.call(n, s, r++));
                        }),
                    );
                });
            }
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */ const fa = 'https://g.co/ng/security#xss';
            class Me extends Error {
                constructor(n, e) {
                    super(
                        (function zr(t, n) {
                            return `NG0${Math.abs(t)}${n ? ': ' + n : ''}`;
                        })(n, e),
                    ),
                        (this.code = n);
                }
            }
            function qs(t) {
                return { toString: t }.toString();
            }
            const ma = '__parameters__';
            function Xo(t, n, e) {
                return qs(() => {
                    const i = (function Ul(t) {
                        return function (...e) {
                            if (t) {
                                const i = t(...e);
                                for (const r in i) this[r] = i[r];
                            }
                        };
                    })(n);
                    function r(...s) {
                        if (this instanceof r) return i.apply(this, s), this;
                        const o = new r(...s);
                        return (a.annotation = o), a;
                        function a(l, c, f) {
                            const g = l.hasOwnProperty(ma) ? l[ma] : Object.defineProperty(l, ma, { value: [] })[ma];
                            for (; g.length <= f; ) g.push(null);
                            return (g[f] = g[f] || []).push(o), l;
                        }
                    }
                    return (
                        e && (r.prototype = Object.create(e.prototype)),
                        (r.prototype.ngMetadataName = t),
                        (r.annotationCls = r),
                        r
                    );
                });
            }
            const Rn = globalThis;
            function Xn(t) {
                for (let n in t) if (t[n] === Xn) return n;
                throw Error('Could not find renamed property on target object.');
            }
            function f0(t, n) {
                for (const e in n) n.hasOwnProperty(e) && !t.hasOwnProperty(e) && (t[e] = n[e]);
            }
            function tr(t) {
                if ('string' == typeof t) return t;
                if (Array.isArray(t)) return '[' + t.map(tr).join(', ') + ']';
                if (null == t) return '' + t;
                if (t.overriddenName) return `${t.overriddenName}`;
                if (t.name) return `${t.name}`;
                const n = t.toString();
                if (null == n) return '' + n;
                const e = n.indexOf('\n');
                return -1 === e ? n : n.substring(0, e);
            }
            function fl(t, n) {
                return null == t || '' === t ? (null === n ? '' : n) : null == n || '' === n ? t : t + ' ' + n;
            }
            const Hu = Xn({ __forward_ref__: Xn });
            function Wt(t) {
                return (
                    (t.__forward_ref__ = Wt),
                    (t.toString = function () {
                        return tr(this());
                    }),
                    t
                );
            }
            function Dt(t) {
                return Zo(t) ? t() : t;
            }
            function Zo(t) {
                return 'function' == typeof t && t.hasOwnProperty(Hu) && t.__forward_ref__ === Wt;
            }
            function We(t) {
                return { token: t.token, providedIn: t.providedIn || null, factory: t.factory, value: void 0 };
            }
            function zn(t) {
                return { providers: t.providers || [], imports: t.imports || [] };
            }
            function ml(t) {
                return qu(t, $l) || qu(t, Yu);
            }
            function qu(t, n) {
                return t.hasOwnProperty(n) ? t[n] : null;
            }
            function jl(t) {
                return t && (t.hasOwnProperty(Rc) || t.hasOwnProperty(b0)) ? t[Rc] : null;
            }
            const $l = Xn({ ɵprov: Xn }),
                Rc = Xn({ ɵinj: Xn }),
                Yu = Xn({ ngInjectableDef: Xn }),
                b0 = Xn({ ngInjectorDef: Xn });
            class $e {
                constructor(n, e) {
                    (this._desc = n),
                        (this.ngMetadataName = 'InjectionToken'),
                        (this.ɵprov = void 0),
                        'number' == typeof e
                            ? (this.__NG_ELEMENT_ID__ = e)
                            : void 0 !== e &&
                              (this.ɵprov = We({
                                  token: this,
                                  providedIn: e.providedIn || 'root',
                                  factory: e.factory,
                              }));
                }
                get multi() {
                    return this;
                }
                toString() {
                    return `InjectionToken ${this._desc}`;
                }
            }
            function Uc(t) {
                return t && !!t.ɵproviders;
            }
            const so = Xn({ ɵcmp: Xn }),
                si = Xn({ ɵdir: Xn }),
                xo = Xn({ ɵpipe: Xn }),
                Ra = Xn({ ɵmod: Xn }),
                ko = Xn({ ɵfac: Xn }),
                Va = Xn({ __NG_ELEMENT_ID__: Xn }),
                u = Xn({ __NG_ENV_ID__: Xn });
            function h(t) {
                return 'string' == typeof t ? t : null == t ? '' : String(t);
            }
            function J(t, n) {
                throw new Me(-201, !1);
            }
            var re = (function (t) {
                return (
                    (t[(t.Default = 0)] = 'Default'),
                    (t[(t.Host = 1)] = 'Host'),
                    (t[(t.Self = 2)] = 'Self'),
                    (t[(t.SkipSelf = 4)] = 'SkipSelf'),
                    (t[(t.Optional = 8)] = 'Optional'),
                    t
                );
            })(re || {});
            let Te;
            function Ae() {
                return Te;
            }
            function ve(t) {
                const n = Te;
                return (Te = t), n;
            }
            function He(t, n, e) {
                const i = ml(t);
                return i && 'root' == i.providedIn
                    ? void 0 === i.value
                        ? (i.value = i.factory())
                        : i.value
                    : e & re.Optional
                    ? null
                    : void 0 !== n
                    ? n
                    : void J();
            }
            const Xt = {},
                nr = '__NG_DI_FLAG__',
                Vi = 'ngTempTokenPath',
                ao = /\n/gm,
                Jo = '__source';
            let mn;
            function _r(t) {
                const n = mn;
                return (mn = t), n;
            }
            function Bc(t, n = re.Default) {
                if (void 0 === mn) throw new Me(-203, !1);
                return null === mn ? He(t, void 0, n) : mn.get(t, n & re.Optional ? null : void 0, n);
            }
            function Se(t, n = re.Default) {
                return (Ae() || Bc)(Dt(t), n);
            }
            function Ue(t, n = re.Default) {
                return Se(t, Ys(n));
            }
            function Ys(t) {
                return typeof t > 'u' || 'number' == typeof t
                    ? t
                    : (t.optional && 8) | (t.host && 1) | (t.self && 2) | (t.skipSelf && 4);
            }
            function lo(t) {
                const n = [];
                for (let e = 0; e < t.length; e++) {
                    const i = Dt(t[e]);
                    if (Array.isArray(i)) {
                        if (0 === i.length) throw new Me(900, !1);
                        let r,
                            s = re.Default;
                        for (let o = 0; o < i.length; o++) {
                            const a = i[o],
                                l = qc(a);
                            'number' == typeof l ? (-1 === l ? (r = a.token) : (s |= l)) : (r = a);
                        }
                        n.push(Se(r, s));
                    } else n.push(Se(i));
                }
                return n;
            }
            function Pr(t, n) {
                return (t[nr] = n), (t.prototype[nr] = n), t;
            }
            function qc(t) {
                return t[nr];
            }
            const oi = Pr(Xo('Optional'), 8),
                Vn = Pr(Xo('SkipSelf'), 4);
            function yr(t, n) {
                return t.hasOwnProperty(ko) ? t[ko] : null;
            }
            function uo(t, n) {
                t.forEach(e => (Array.isArray(e) ? uo(e, n) : n(e)));
            }
            function Yc(t, n, e) {
                n >= t.length ? t.push(e) : t.splice(n, 0, e);
            }
            function ho(t, n) {
                return n >= t.length - 1 ? t.pop() : t.splice(n, 1)[0];
            }
            function br(t, n, e) {
                let i = ta(t, n);
                return (
                    i >= 0
                        ? (t[1 | i] = e)
                        : ((i = ~i),
                          (function ea(t, n, e, i) {
                              let r = t.length;
                              if (r == n) t.push(e, i);
                              else if (1 === r) t.push(i, t[0]), (t[0] = e);
                              else {
                                  for (r--, t.push(t[r - 1], t[r]); r > n; ) (t[r] = t[r - 2]), r--;
                                  (t[n] = e), (t[n + 1] = i);
                              }
                          })(t, i, n, e)),
                    i
                );
            }
            function vl(t, n) {
                const e = ta(t, n);
                if (e >= 0) return t[1 | e];
            }
            function ta(t, n) {
                return (function qa(t, n, e) {
                    let i = 0,
                        r = t.length >> e;
                    for (; r !== i; ) {
                        const s = i + ((r - i) >> 1),
                            o = t[s << e];
                        if (n === o) return s << e;
                        o > n ? (r = s) : (i = s + 1);
                    }
                    return ~(r << e);
                })(t, n, 1);
            }
            const Ls = {},
                An = [],
                na = new $e(''),
                $c = new $e('', -1),
                X = new $e('');
            class le {
                get(n, e = Xt) {
                    if (e === Xt) {
                        const i = new Error(`NullInjectorError: No provider for ${tr(n)}!`);
                        throw ((i.name = 'NullInjectorError'), i);
                    }
                    return e;
                }
            }
            var be = (function (t) {
                    return (t[(t.OnPush = 0)] = 'OnPush'), (t[(t.Default = 1)] = 'Default'), t;
                })(be || {}),
                we = (function (t) {
                    return (
                        (t[(t.Emulated = 0)] = 'Emulated'),
                        (t[(t.None = 2)] = 'None'),
                        (t[(t.ShadowDom = 3)] = 'ShadowDom'),
                        t
                    );
                })(we || {}),
                de = (function (t) {
                    return (
                        (t[(t.None = 0)] = 'None'),
                        (t[(t.SignalBased = 1)] = 'SignalBased'),
                        (t[(t.HasDecoratorInputTransform = 2)] = 'HasDecoratorInputTransform'),
                        t
                    );
                })(de || {});
            function Qe(t, n, e) {
                let i = t.length;
                for (;;) {
                    const r = t.indexOf(n, e);
                    if (-1 === r) return r;
                    if (0 === r || t.charCodeAt(r - 1) <= 32) {
                        const s = n.length;
                        if (r + s === i || t.charCodeAt(r + s) <= 32) return r;
                    }
                    e = r + 1;
                }
            }
            function it(t, n, e) {
                let i = 0;
                for (; i < e.length; ) {
                    const r = e[i];
                    if ('number' == typeof r) {
                        if (0 !== r) break;
                        i++;
                        const s = e[i++],
                            o = e[i++],
                            a = e[i++];
                        t.setAttribute(n, o, a, s);
                    } else {
                        const s = r,
                            o = e[++i];
                        rt(s) ? t.setProperty(n, s, o) : t.setAttribute(n, s, o), i++;
                    }
                }
                return i;
            }
            function pt(t) {
                return 3 === t || 4 === t || 6 === t;
            }
            function rt(t) {
                return 64 === t.charCodeAt(0);
            }
            function It(t, n) {
                if (null !== n && 0 !== n.length)
                    if (null === t || 0 === t.length) t = n.slice();
                    else {
                        let e = -1;
                        for (let i = 0; i < n.length; i++) {
                            const r = n[i];
                            'number' == typeof r
                                ? (e = r)
                                : 0 === e || wt(t, e, r, null, -1 === e || 2 === e ? n[++i] : null);
                        }
                    }
                return t;
            }
            function wt(t, n, e, i, r) {
                let s = 0,
                    o = t.length;
                if (-1 === n) o = -1;
                else
                    for (; s < t.length; ) {
                        const a = t[s++];
                        if ('number' == typeof a) {
                            if (a === n) {
                                o = -1;
                                break;
                            }
                            if (a > n) {
                                o = s - 1;
                                break;
                            }
                        }
                    }
                for (; s < t.length; ) {
                    const a = t[s];
                    if ('number' == typeof a) break;
                    if (a === e) {
                        if (null === i) return void (null !== r && (t[s + 1] = r));
                        if (i === t[s + 1]) return void (t[s + 2] = r);
                    }
                    s++, null !== i && s++, null !== r && s++;
                }
                -1 !== o && (t.splice(o, 0, n), (s = o + 1)),
                    t.splice(s++, 0, e),
                    null !== i && t.splice(s++, 0, i),
                    null !== r && t.splice(s++, 0, r);
            }
            const Yt = 'ng-template';
            function yn(t, n, e, i) {
                let r = 0;
                if (i) {
                    for (; r < n.length && 'string' == typeof n[r]; r += 2)
                        if ('class' === n[r] && -1 !== Qe(n[r + 1].toLowerCase(), e, 0)) return !0;
                } else if (Mt(t)) return !1;
                if (((r = n.indexOf(1, r)), r > -1)) {
                    let s;
                    for (; ++r < n.length && 'string' == typeof (s = n[r]); ) if (s.toLowerCase() === e) return !0;
                }
                return !1;
            }
            function Mt(t) {
                return 4 === t.type && t.value !== Yt;
            }
            function ai(t, n, e) {
                return n === (4 !== t.type || e ? t.value : Yt);
            }
            function ss(t, n, e) {
                let i = 4;
                const r = t.attrs,
                    s =
                        null !== r
                            ? (function Yr(t) {
                                  for (let n = 0; n < t.length; n++) if (pt(t[n])) return n;
                                  return t.length;
                              })(r)
                            : 0;
                let o = !1;
                for (let a = 0; a < n.length; a++) {
                    const l = n[a];
                    if ('number' != typeof l) {
                        if (!o)
                            if (4 & i) {
                                if (((i = 2 | (1 & i)), ('' !== l && !ai(t, l, e)) || ('' === l && 1 === n.length))) {
                                    if (gi(i)) return !1;
                                    o = !0;
                                }
                            } else if (8 & i) {
                                if (null === r || !yn(t, r, l, e)) {
                                    if (gi(i)) return !1;
                                    o = !0;
                                }
                            } else {
                                const c = n[++a],
                                    f = vs(l, r, Mt(t), e);
                                if (-1 === f) {
                                    if (gi(i)) return !1;
                                    o = !0;
                                    continue;
                                }
                                if ('' !== c) {
                                    let g;
                                    if (((g = f > s ? '' : r[f + 1].toLowerCase()), 2 & i && c !== g)) {
                                        if (gi(i)) return !1;
                                        o = !0;
                                    }
                                }
                            }
                    } else {
                        if (!o && !gi(i) && !gi(l)) return !1;
                        if (o && gi(l)) continue;
                        (o = !1), (i = l | (1 & i));
                    }
                }
                return gi(i) || o;
            }
            function gi(t) {
                return !(1 & t);
            }
            function vs(t, n, e, i) {
                if (null === n) return -1;
                let r = 0;
                if (i || !e) {
                    let s = !1;
                    for (; r < n.length; ) {
                        const o = n[r];
                        if (o === t) return r;
                        if (3 === o || 6 === o) s = !0;
                        else {
                            if (1 === o || 2 === o) {
                                let a = n[++r];
                                for (; 'string' == typeof a; ) a = n[++r];
                                continue;
                            }
                            if (4 === o) break;
                            if (0 === o) {
                                r += 4;
                                continue;
                            }
                        }
                        r += s ? 1 : 2;
                    }
                    return -1;
                }
                return (function g3(t, n) {
                    let e = t.indexOf(4);
                    if (e > -1)
                        for (e++; e < t.length; ) {
                            const i = t[e];
                            if ('number' == typeof i) return -1;
                            if (i === n) return e;
                            e++;
                        }
                    return -1;
                })(n, t);
            }
            function js(t, n, e = !1) {
                for (let i = 0; i < n.length; i++) if (ss(t, n[i], e)) return !0;
                return !1;
            }
            function v3(t, n) {
                e: for (let e = 0; e < n.length; e++) {
                    const i = n[e];
                    if (t.length === i.length) {
                        for (let r = 0; r < t.length; r++) if (t[r] !== i[r]) continue e;
                        return !0;
                    }
                }
                return !1;
            }
            function Nh(t, n) {
                return t ? ':not(' + n.trim() + ')' : n;
            }
            function _3(t) {
                let n = t[0],
                    e = 1,
                    i = 2,
                    r = '',
                    s = !1;
                for (; e < t.length; ) {
                    let o = t[e];
                    if ('string' == typeof o)
                        if (2 & i) {
                            const a = t[++e];
                            r += '[' + o + (a.length > 0 ? '="' + a + '"' : '') + ']';
                        } else 8 & i ? (r += '.' + o) : 4 & i && (r += ' ' + o);
                    else '' !== r && !gi(o) && ((n += Nh(s, r)), (r = '')), (i = o), (s = s || !gi(i));
                    e++;
                }
                return '' !== r && (n += Nh(s, r)), n;
            }
            function At(t) {
                return qs(() => {
                    const n = Rh(t),
                        e = {
                            ...n,
                            decls: t.decls,
                            vars: t.vars,
                            template: t.template,
                            consts: t.consts || null,
                            ngContentSelectors: t.ngContentSelectors,
                            onPush: t.changeDetection === be.OnPush,
                            directiveDefs: null,
                            pipeDefs: null,
                            dependencies: (n.standalone && t.dependencies) || null,
                            getStandaloneInjector: null,
                            signals: t.signals ?? !1,
                            data: t.data || {},
                            encapsulation: t.encapsulation || we.Emulated,
                            styles: t.styles || An,
                            _: null,
                            schemas: t.schemas || null,
                            tView: null,
                            id: '',
                        };
                    Vh(e);
                    const i = t.dependencies;
                    return (
                        (e.directiveDefs = Gc(i, !1)),
                        (e.pipeDefs = Gc(i, !0)),
                        (e.id = (function Uh(t) {
                            let n = 0;
                            const e = [
                                t.selectors,
                                t.ngContentSelectors,
                                t.hostVars,
                                t.hostAttrs,
                                t.consts,
                                t.vars,
                                t.decls,
                                t.encapsulation,
                                t.standalone,
                                t.signals,
                                t.exportAs,
                                JSON.stringify(t.inputs),
                                JSON.stringify(t.outputs),
                                Object.getOwnPropertyNames(t.type.prototype),
                                !!t.contentQueries,
                                !!t.viewQuery,
                            ].join('|');
                            for (const r of e) n = (Math.imul(31, n) + r.charCodeAt(0)) | 0;
                            return (n += 2147483648), 'c' + n;
                        })(e)),
                        e
                    );
                });
            }
            function C3(t) {
                return bn(t) || Cr(t);
            }
            function w3(t) {
                return null !== t;
            }
            function Zn(t) {
                return qs(() => ({
                    type: t.type,
                    bootstrap: t.bootstrap || An,
                    declarations: t.declarations || An,
                    imports: t.imports || An,
                    exports: t.exports || An,
                    transitiveCompileScopes: null,
                    schemas: t.schemas || null,
                    id: t.id || null,
                }));
            }
            function Fh(t, n) {
                if (null == t) return Ls;
                const e = {};
                for (const i in t)
                    if (t.hasOwnProperty(i)) {
                        const r = t[i];
                        let s,
                            o,
                            a = de.None;
                        Array.isArray(r) ? ((a = r[0]), (s = r[1]), (o = r[2] ?? s)) : ((s = r), (o = r)),
                            n ? ((e[s] = a !== de.None ? [i, a] : i), (n[s] = o)) : (e[s] = i);
                    }
                return e;
            }
            function gt(t) {
                return qs(() => {
                    const n = Rh(t);
                    return Vh(n), n;
                });
            }
            function jr(t) {
                return {
                    type: t.type,
                    name: t.name,
                    factory: null,
                    pure: !1 !== t.pure,
                    standalone: !0 === t.standalone,
                    onDestroy: t.type.prototype.ngOnDestroy || null,
                };
            }
            function bn(t) {
                return t[so] || null;
            }
            function Cr(t) {
                return t[si] || null;
            }
            function $r(t) {
                return t[xo] || null;
            }
            function Rh(t) {
                const n = {};
                return {
                    type: t.type,
                    providersResolver: null,
                    factory: null,
                    hostBindings: t.hostBindings || null,
                    hostVars: t.hostVars || 0,
                    hostAttrs: t.hostAttrs || null,
                    contentQueries: t.contentQueries || null,
                    declaredInputs: n,
                    inputTransforms: null,
                    inputConfig: t.inputs || Ls,
                    exportAs: t.exportAs || null,
                    standalone: !0 === t.standalone,
                    signals: !0 === t.signals,
                    selectors: t.selectors || An,
                    viewQuery: t.viewQuery || null,
                    features: t.features || null,
                    setInput: null,
                    findHostDirectiveDefs: null,
                    hostDirectives: null,
                    inputs: Fh(t.inputs, n),
                    outputs: Fh(t.outputs),
                    debugInfo: null,
                };
            }
            function Vh(t) {
                t.features?.forEach(n => n(t));
            }
            function Gc(t, n) {
                if (!t) return null;
                const e = n ? $r : C3;
                return () => ('function' == typeof t ? t() : t).map(i => e(i)).filter(w3);
            }
            function _s(t) {
                return { ɵproviders: t };
            }
            function Kl(...t) {
                return { ɵproviders: Ql(0, t), ɵfromNgModule: !0 };
            }
            function Ql(t, ...n) {
                const e = [],
                    i = new Set();
                let r;
                const s = o => {
                    e.push(o);
                };
                return (
                    uo(n, o => {
                        const a = o;
                        pa(a, s, [], i) && ((r ||= []), r.push(a));
                    }),
                    void 0 !== r && w0(r, s),
                    e
                );
            }
            function w0(t, n) {
                for (let e = 0; e < t.length; e++) {
                    const { ngModule: i, providers: r } = t[e];
                    Wu(r, s => {
                        n(s, i);
                    });
                }
            }
            function pa(t, n, e, i) {
                if (!(t = Dt(t))) return !1;
                let r = null,
                    s = jl(t);
                const o = !s && bn(t);
                if (s || o) {
                    if (o && !o.standalone) return !1;
                    r = t;
                } else {
                    const l = t.ngModule;
                    if (((s = jl(l)), !s)) return !1;
                    r = l;
                }
                const a = i.has(r);
                if (o) {
                    if (a) return !1;
                    if ((i.add(r), o.dependencies)) {
                        const l = 'function' == typeof o.dependencies ? o.dependencies() : o.dependencies;
                        for (const c of l) pa(c, n, e, i);
                    }
                } else {
                    if (!s) return !1;
                    {
                        if (null != s.imports && !a) {
                            let c;
                            i.add(r);
                            try {
                                uo(s.imports, f => {
                                    pa(f, n, e, i) && ((c ||= []), c.push(f));
                                });
                            } finally {
                            }
                            void 0 !== c && w0(c, n);
                        }
                        if (!a) {
                            const c = yr(r) || (() => new r());
                            n({ provide: r, useFactory: c, deps: An }, r),
                                n({ provide: X, useValue: r, multi: !0 }, r),
                                n({ provide: na, useValue: () => Se(r), multi: !0 }, r);
                        }
                        const l = s.providers;
                        if (null != l && !a) {
                            const c = t;
                            Wu(l, f => {
                                n(f, c);
                            });
                        }
                    }
                }
                return r !== t && void 0 !== t.providers;
            }
            function Wu(t, n) {
                for (let e of t) Uc(e) && (e = e.ɵproviders), Array.isArray(e) ? Wu(e, n) : n(e);
            }
            const S3 = Xn({ provide: String, useValue: Xn });
            function M0(t) {
                return null !== t && 'object' == typeof t && S3 in t;
            }
            function bl(t) {
                return 'function' == typeof t;
            }
            const S0 = new $e(''),
                Ku = {},
                D3 = {};
            let T0;
            function Qu() {
                return void 0 === T0 && (T0 = new le()), T0;
            }
            class Io {}
            class Xl extends Io {
                get destroyed() {
                    return this._destroyed;
                }
                constructor(n, e, i, r) {
                    super(),
                        (this.parent = e),
                        (this.source = i),
                        (this.scopes = r),
                        (this.records = new Map()),
                        (this._ngOnDestroyHooks = new Set()),
                        (this._onDestroyHooks = []),
                        (this._destroyed = !1),
                        x0(n, o => this.processProvider(o)),
                        this.records.set($c, Zl(void 0, this)),
                        r.has('environment') && this.records.set(Io, Zl(void 0, this));
                    const s = this.records.get(S0);
                    null != s && 'string' == typeof s.value && this.scopes.add(s.value),
                        (this.injectorDefTypes = new Set(this.get(X, An, re.Self)));
                }
                destroy() {
                    this.assertNotDestroyed(), (this._destroyed = !0);
                    const n = _(null);
                    try {
                        for (const i of this._ngOnDestroyHooks) i.ngOnDestroy();
                        const e = this._onDestroyHooks;
                        this._onDestroyHooks = [];
                        for (const i of e) i();
                    } finally {
                        this.records.clear(), this._ngOnDestroyHooks.clear(), this.injectorDefTypes.clear(), _(n);
                    }
                }
                onDestroy(n) {
                    return this.assertNotDestroyed(), this._onDestroyHooks.push(n), () => this.removeOnDestroy(n);
                }
                runInContext(n) {
                    this.assertNotDestroyed();
                    const e = _r(this),
                        i = ve(void 0);
                    try {
                        return n();
                    } finally {
                        _r(e), ve(i);
                    }
                }
                get(n, e = Xt, i = re.Default) {
                    if ((this.assertNotDestroyed(), n.hasOwnProperty(u))) return n[u](this);
                    i = Ys(i);
                    const s = _r(this),
                        o = ve(void 0);
                    try {
                        if (!(i & re.SkipSelf)) {
                            let l = this.records.get(n);
                            if (void 0 === l) {
                                const c =
                                    (function A3(t) {
                                        return 'function' == typeof t || ('object' == typeof t && t instanceof $e);
                                    })(n) && ml(n);
                                (l = c && this.injectableDefInScope(c) ? Zl(D0(n), Ku) : null), this.records.set(n, l);
                            }
                            if (null != l) return this.hydrate(n, l);
                        }
                        return (i & re.Self ? Qu() : this.parent).get(n, (e = i & re.Optional && e === Xt ? null : e));
                    } catch (a) {
                        if ('NullInjectorError' === a.name) {
                            if (((a[Vi] = a[Vi] || []).unshift(tr(n)), s)) throw a;
                            return (function co(t, n, e, i) {
                                const r = t[Vi];
                                throw (
                                    (n[Jo] && r.unshift(n[Jo]),
                                    (t.message = (function Eo(t, n, e, i = null) {
                                        t = t && '\n' === t.charAt(0) && '\u0275' == t.charAt(1) ? t.slice(2) : t;
                                        let r = tr(n);
                                        if (Array.isArray(n)) r = n.map(tr).join(' -> ');
                                        else if ('object' == typeof n) {
                                            let s = [];
                                            for (let o in n)
                                                if (n.hasOwnProperty(o)) {
                                                    let a = n[o];
                                                    s.push(
                                                        o + ':' + ('string' == typeof a ? JSON.stringify(a) : tr(a)),
                                                    );
                                                }
                                            r = `{${s.join(', ')}}`;
                                        }
                                        return `${e}${i ? '(' + i + ')' : ''}[${r}]: ${t.replace(ao, '\n  ')}`;
                                    })('\n' + t.message, r, e, i)),
                                    (t.ngTokenPath = r),
                                    (t[Vi] = null),
                                    t)
                                );
                            })(a, n, 'R3InjectorError', this.source);
                        }
                        throw a;
                    } finally {
                        ve(o), _r(s);
                    }
                }
                resolveInjectorInitializers() {
                    const n = _(null),
                        e = _r(this),
                        i = ve(void 0);
                    try {
                        const s = this.get(na, An, re.Self);
                        for (const o of s) o();
                    } finally {
                        _r(e), ve(i), _(n);
                    }
                }
                toString() {
                    const n = [],
                        e = this.records;
                    for (const i of e.keys()) n.push(tr(i));
                    return `R3Injector[${n.join(', ')}]`;
                }
                assertNotDestroyed() {
                    if (this._destroyed) throw new Me(205, !1);
                }
                processProvider(n) {
                    let e = bl((n = Dt(n))) ? n : Dt(n && n.provide);
                    const i = (function k3(t) {
                        return M0(t) ? Zl(void 0, t.useValue) : Zl(Yh(t), Ku);
                    })(n);
                    if (!bl(n) && !0 === n.multi) {
                        let r = this.records.get(e);
                        r || ((r = Zl(void 0, Ku, !0)), (r.factory = () => lo(r.multi)), this.records.set(e, r)),
                            (e = n),
                            r.multi.push(n);
                    }
                    this.records.set(e, i);
                }
                hydrate(n, e) {
                    const i = _(null);
                    try {
                        return (
                            e.value === Ku && ((e.value = D3), (e.value = e.factory())),
                            'object' == typeof e.value &&
                                e.value &&
                                (function I3(t) {
                                    return null !== t && 'object' == typeof t && 'function' == typeof t.ngOnDestroy;
                                })(e.value) &&
                                this._ngOnDestroyHooks.add(e.value),
                            e.value
                        );
                    } finally {
                        _(i);
                    }
                }
                injectableDefInScope(n) {
                    if (!n.providedIn) return !1;
                    const e = Dt(n.providedIn);
                    return 'string' == typeof e ? 'any' === e || this.scopes.has(e) : this.injectorDefTypes.has(e);
                }
                removeOnDestroy(n) {
                    const e = this._onDestroyHooks.indexOf(n);
                    -1 !== e && this._onDestroyHooks.splice(e, 1);
                }
            }
            function D0(t) {
                const n = ml(t),
                    e = null !== n ? n.factory : yr(t);
                if (null !== e) return e;
                if (t instanceof $e) throw new Me(204, !1);
                if (t instanceof Function)
                    return (function x3(t) {
                        if (t.length > 0) throw new Me(204, !1);
                        const e = (function Fc(t) {
                            return (t && (t[$l] || t[Yu])) || null;
                        })(t);
                        return null !== e ? () => e.factory(t) : () => new t();
                    })(t);
                throw new Me(204, !1);
            }
            function Yh(t, n, e) {
                let i;
                if (bl(t)) {
                    const r = Dt(t);
                    return yr(r) || D0(r);
                }
                if (M0(t)) i = () => Dt(t.useValue);
                else if (
                    (function qh(t) {
                        return !(!t || !t.useFactory);
                    })(t)
                )
                    i = () => t.useFactory(...lo(t.deps || []));
                else if (
                    (function Bh(t) {
                        return !(!t || !t.useExisting);
                    })(t)
                )
                    i = () => Se(Dt(t.useExisting));
                else {
                    const r = Dt(t && (t.useClass || t.provide));
                    if (
                        !(function E3(t) {
                            return !!t.deps;
                        })(t)
                    )
                        return yr(r) || D0(r);
                    i = () => new r(...lo(t.deps));
                }
                return i;
            }
            function Zl(t, n, e = !1) {
                return { factory: t, value: n, multi: e ? [] : void 0 };
            }
            function x0(t, n) {
                for (const e of t) Array.isArray(e) ? x0(e, n) : e && Uc(e) ? x0(e.ɵproviders, n) : n(e);
            }
            function jh() {
                return (
                    void 0 !== Ae() ||
                    null !=
                        (function Hi() {
                            return mn;
                        })()
                );
            }
            const Gh = Function;
            const Ui = 0,
                Be = 1,
                St = 2,
                ar = 3,
                Ao = 4,
                as = 5,
                Fe = 6,
                ec = 7,
                Di = 8,
                lr = 9,
                cn = 10,
                Nt = 11,
                tc = 12,
                Ju = 13,
                nc = 14,
                Ki = 15,
                Xc = 16,
                ic = 17,
                ga = 18,
                $s = 19,
                Qh = 20,
                va = 21,
                e1 = 22,
                Cl = 23,
                Zt = 25,
                I0 = 1,
                fo = 7,
                sc = 9,
                li = 10;
            var A0 = (function (t) {
                return (t[(t.None = 0)] = 'None'), (t[(t.HasTransplantedViews = 2)] = 'HasTransplantedViews'), t;
            })(A0 || {});
            function ls(t) {
                return Array.isArray(t) && 'object' == typeof t[I0];
            }
            function cs(t) {
                return Array.isArray(t) && !0 === t[I0];
            }
            function L0(t) {
                return !!(4 & t.flags);
            }
            function wl(t) {
                return t.componentOffset > -1;
            }
            function n1(t) {
                return !(1 & ~t.flags);
            }
            function Lo(t) {
                return !!t.template;
            }
            function O0(t) {
                return !!(512 & t[St]);
            }
            class m {
                constructor(n, e, i) {
                    (this.previousValue = n), (this.currentValue = e), (this.firstChange = i);
                }
                isFirstChange() {
                    return this.firstChange;
                }
            }
            function S(t, n, e, i) {
                null !== n ? n.applyValueToInputSignal(n, i) : (t[e] = i);
            }
            function D() {
                return Y;
            }
            function Y(t) {
                return t.type.prototype.ngOnChanges && (t.setInput = Ee), oe;
            }
            function oe() {
                const t = pn(this),
                    n = t?.current;
                if (n) {
                    const e = t.previous;
                    if (e === Ls) t.previous = n;
                    else for (let i in n) e[i] = n[i];
                    (t.current = null), this.ngOnChanges(n);
                }
            }
            function Ee(t, n, e, i, r) {
                const s = this.declaredInputs[i],
                    o =
                        pn(t) ||
                        (function vi(t, n) {
                            return (t[xt] = n);
                        })(t, { previous: Ls, current: null }),
                    a = o.current || (o.current = {}),
                    l = o.previous,
                    c = l[s];
                (a[s] = new m(c && c.currentValue, e, l === Ls)), S(t, n, r, e);
            }
            D.ngInherit = !0;
            const xt = '__ngSimpleChanges__';
            function pn(t) {
                return t[xt] || null;
            }
            const Wr = function (t, n, e) {};
            let F5 = !1;
            function xi(t) {
                for (; Array.isArray(t); ) t = t[Ui];
                return t;
            }
            function F0(t, n) {
                return xi(n[t]);
            }
            function Gs(t, n) {
                return xi(n[t.index]);
            }
            function R0(t, n) {
                return t.data[n];
            }
            function s1(t, n) {
                return t[n];
            }
            function Oo(t, n) {
                const e = n[t];
                return ls(e) ? e : e[Ui];
            }
            function H3(t) {
                return !(128 & ~t[St]);
            }
            function Ga(t, n) {
                return null == n ? null : t[n];
            }
            function R5(t) {
                t[ic] = 0;
            }
            function Yk(t) {
                1024 & t[St] || ((t[St] |= 1024), H3(t) && V0(t));
            }
            function U3(t) {
                return !!(9216 & t[St] || t[Cl]?.dirty);
            }
            function B3(t) {
                t[cn].changeDetectionScheduler?.notify(1),
                    U3(t)
                        ? V0(t)
                        : 64 & t[St] &&
                          ((function Hk() {
                              return F5;
                          })()
                              ? ((t[St] |= 1024), V0(t))
                              : t[cn].changeDetectionScheduler?.notify());
            }
            function V0(t) {
                t[cn].changeDetectionScheduler?.notify();
                let n = eu(t);
                for (; null !== n && !(8192 & n[St]) && ((n[St] |= 8192), H3(n)); ) n = eu(n);
            }
            function Zh(t, n) {
                if (!(256 & ~t[St])) throw new Me(911, !1);
                null === t[va] && (t[va] = []), t[va].push(n);
            }
            function eu(t) {
                const n = t[ar];
                return cs(n) ? n[ar] : n;
            }
            const Jt = { lFrame: W5(null), bindingsEnabled: !0, skipHydrationRootTNode: null };
            function U5() {
                return Jt.bindingsEnabled;
            }
            function o1() {
                return null !== Jt.skipHydrationRootTNode;
            }
            function Ie() {
                return Jt.lFrame.lView;
            }
            function Ln() {
                return Jt.lFrame.tView;
            }
            function me(t) {
                return (Jt.lFrame.contextLView = t), t[Di];
            }
            function pe(t) {
                return (Jt.lFrame.contextLView = null), t;
            }
            function _i() {
                let t = B5();
                for (; null !== t && 64 === t.type; ) t = t.parent;
                return t;
            }
            function B5() {
                return Jt.lFrame.currentTNode;
            }
            function Wa(t, n) {
                const e = Jt.lFrame;
                (e.currentTNode = t), (e.isParent = n);
            }
            function Y3() {
                return Jt.lFrame.isParent;
            }
            function j3() {
                Jt.lFrame.isParent = !1;
            }
            function Ws() {
                const t = Jt.lFrame;
                let n = t.bindingRootIndex;
                return -1 === n && (n = t.bindingRootIndex = t.tView.bindingStartIndex), n;
            }
            function Ml() {
                return Jt.lFrame.bindingIndex;
            }
            function ya() {
                return Jt.lFrame.bindingIndex++;
            }
            function Sl(t) {
                const n = Jt.lFrame,
                    e = n.bindingIndex;
                return (n.bindingIndex = n.bindingIndex + t), e;
            }
            function tE(t, n) {
                const e = Jt.lFrame;
                (e.bindingIndex = e.bindingRootIndex = t), $3(n);
            }
            function $3(t) {
                Jt.lFrame.currentDirectiveIndex = t;
            }
            function W3() {
                return Jt.lFrame.currentQueryIndex;
            }
            function Jh(t) {
                Jt.lFrame.currentQueryIndex = t;
            }
            function iE(t) {
                const n = t[Be];
                return 2 === n.type ? n.declTNode : 1 === n.type ? t[as] : null;
            }
            function $5(t, n, e) {
                if (e & re.SkipSelf) {
                    let r = n,
                        s = t;
                    for (
                        ;
                        !((r = r.parent),
                        null !== r || e & re.Host || ((r = iE(s)), null === r || ((s = s[nc]), 10 & r.type)));

                    );
                    if (null === r) return !1;
                    (n = r), (t = s);
                }
                const i = (Jt.lFrame = G5());
                return (i.currentTNode = n), (i.lView = t), !0;
            }
            function K3(t) {
                const n = G5(),
                    e = t[Be];
                (Jt.lFrame = n),
                    (n.currentTNode = e.firstChild),
                    (n.lView = t),
                    (n.tView = e),
                    (n.contextLView = t),
                    (n.bindingIndex = e.bindingStartIndex),
                    (n.inI18n = !1);
            }
            function G5() {
                const t = Jt.lFrame,
                    n = null === t ? null : t.child;
                return null === n ? W5(t) : n;
            }
            function W5(t) {
                const n = {
                    currentTNode: null,
                    isParent: !0,
                    lView: null,
                    tView: null,
                    selectedIndex: -1,
                    contextLView: null,
                    elementDepthCount: 0,
                    currentNamespace: null,
                    currentDirectiveIndex: -1,
                    bindingRootIndex: -1,
                    bindingIndex: -1,
                    currentQueryIndex: 0,
                    parent: t,
                    child: null,
                    inI18n: !1,
                };
                return null !== t && (t.child = n), n;
            }
            function K5() {
                const t = Jt.lFrame;
                return (Jt.lFrame = t.parent), (t.currentTNode = null), (t.lView = null), t;
            }
            const Q5 = K5;
            function Q3() {
                const t = K5();
                (t.isParent = !0),
                    (t.tView = null),
                    (t.selectedIndex = -1),
                    (t.contextLView = null),
                    (t.elementDepthCount = 0),
                    (t.currentDirectiveIndex = -1),
                    (t.currentNamespace = null),
                    (t.bindingRootIndex = -1),
                    (t.bindingIndex = -1),
                    (t.currentQueryIndex = 0);
            }
            function Os() {
                return Jt.lFrame.selectedIndex;
            }
            function tu(t) {
                Jt.lFrame.selectedIndex = t;
            }
            function Bi() {
                const t = Jt.lFrame;
                return R0(t.tView, t.selectedIndex);
            }
            let Z5 = !0;
            function U0() {
                return Z5;
            }
            function Ka(t) {
                Z5 = t;
            }
            function e2(t, n) {
                for (let e = n.directiveStart, i = n.directiveEnd; e < i; e++) {
                    const s = t.data[e].type.prototype,
                        {
                            ngAfterContentInit: o,
                            ngAfterContentChecked: a,
                            ngAfterViewInit: l,
                            ngAfterViewChecked: c,
                            ngOnDestroy: f,
                        } = s;
                    o && (t.contentHooks ??= []).push(-e, o),
                        a && ((t.contentHooks ??= []).push(e, a), (t.contentCheckHooks ??= []).push(e, a)),
                        l && (t.viewHooks ??= []).push(-e, l),
                        c && ((t.viewHooks ??= []).push(e, c), (t.viewCheckHooks ??= []).push(e, c)),
                        null != f && (t.destroyHooks ??= []).push(e, f);
                }
            }
            function t2(t, n, e) {
                J5(t, n, 3, e);
            }
            function n2(t, n, e, i) {
                (3 & t[St]) === e && J5(t, n, e, i);
            }
            function X3(t, n) {
                let e = t[St];
                (3 & e) === n && ((e &= 16383), (e += 1), (t[St] = e));
            }
            function J5(t, n, e, i) {
                const s = i ?? -1,
                    o = n.length - 1;
                let a = 0;
                for (let l = void 0 !== i ? 65535 & t[ic] : 0; l < o; l++)
                    if ('number' == typeof n[l + 1]) {
                        if (((a = n[l]), null != i && a >= i)) break;
                    } else
                        n[l] < 0 && (t[ic] += 65536),
                            (a < s || -1 == s) && (uE(t, e, n, l), (t[ic] = (4294901760 & t[ic]) + l + 2)),
                            l++;
            }
            function e7(t, n) {
                Wr(4, t, n);
                const e = _(null);
                try {
                    n.call(t);
                } finally {
                    _(e), Wr(5, t, n);
                }
            }
            function uE(t, n, e, i) {
                const r = e[i] < 0,
                    s = e[i + 1],
                    a = t[r ? -e[i] : e[i]];
                r ? t[St] >> 14 < t[ic] >> 16 && (3 & t[St]) === n && ((t[St] += 16384), e7(a, s)) : e7(a, s);
            }
            const a1 = -1;
            class B0 {
                constructor(n, e, i) {
                    (this.factory = n), (this.resolving = !1), (this.canSeeViewProviders = e), (this.injectImpl = i);
                }
            }
            function J3(t) {
                return t !== a1;
            }
            function q0(t) {
                return 32767 & t;
            }
            function Y0(t, n) {
                let e = (function pE(t) {
                        return t >> 16;
                    })(t),
                    i = n;
                for (; e > 0; ) (i = i[nc]), e--;
                return i;
            }
            let e6 = !0;
            function r2(t) {
                const n = e6;
                return (e6 = t), n;
            }
            const t7 = 255,
                n7 = 5;
            let gE = 0;
            const Qa = {};
            function s2(t, n) {
                const e = i7(t, n);
                if (-1 !== e) return e;
                const i = n[Be];
                i.firstCreatePass && ((t.injectorIndex = n.length), t6(i.data, t), t6(n, null), t6(i.blueprint, null));
                const r = o2(t, n),
                    s = t.injectorIndex;
                if (J3(r)) {
                    const o = q0(r),
                        a = Y0(r, n),
                        l = a[Be].data;
                    for (let c = 0; c < 8; c++) n[s + c] = a[o + c] | l[o + c];
                }
                return (n[s + 8] = r), s;
            }
            function t6(t, n) {
                t.push(0, 0, 0, 0, 0, 0, 0, 0, n);
            }
            function i7(t, n) {
                return -1 === t.injectorIndex ||
                    (t.parent && t.parent.injectorIndex === t.injectorIndex) ||
                    null === n[t.injectorIndex + 8]
                    ? -1
                    : t.injectorIndex;
            }
            function o2(t, n) {
                if (t.parent && -1 !== t.parent.injectorIndex) return t.parent.injectorIndex;
                let e = 0,
                    i = null,
                    r = n;
                for (; null !== r; ) {
                    if (((i = u7(r)), null === i)) return a1;
                    if ((e++, (r = r[nc]), -1 !== i.injectorIndex)) return i.injectorIndex | (e << 16);
                }
                return a1;
            }
            function n6(t, n, e) {
                !(function vE(t, n, e) {
                    let i;
                    'string' == typeof e ? (i = e.charCodeAt(0) || 0) : e.hasOwnProperty(Va) && (i = e[Va]),
                        null == i && (i = e[Va] = gE++);
                    const r = i & t7;
                    n.data[t + (r >> n7)] |= 1 << r;
                })(t, n, e);
            }
            function r7(t, n, e) {
                if (e & re.Optional || void 0 !== t) return t;
                J();
            }
            function s7(t, n, e, i) {
                if ((e & re.Optional && void 0 === i && (i = null), !(e & (re.Self | re.Host)))) {
                    const r = t[lr],
                        s = ve(void 0);
                    try {
                        return r ? r.get(n, i, e & re.Optional) : He(n, i, e & re.Optional);
                    } finally {
                        ve(s);
                    }
                }
                return r7(i, 0, e);
            }
            function o7(t, n, e, i = re.Default, r) {
                if (null !== t) {
                    if (2048 & n[St] && !(i & re.Self)) {
                        const o = (function wE(t, n, e, i, r) {
                            let s = t,
                                o = n;
                            for (; null !== s && null !== o && 2048 & o[St] && !(512 & o[St]); ) {
                                const a = a7(s, o, e, i | re.Self, Qa);
                                if (a !== Qa) return a;
                                let l = s.parent;
                                if (!l) {
                                    const c = o[Qh];
                                    if (c) {
                                        const f = c.get(e, Qa, i);
                                        if (f !== Qa) return f;
                                    }
                                    (l = u7(o)), (o = o[nc]);
                                }
                                s = l;
                            }
                            return r;
                        })(t, n, e, i, Qa);
                        if (o !== Qa) return o;
                    }
                    const s = a7(t, n, e, i, Qa);
                    if (s !== Qa) return s;
                }
                return s7(n, e, i, r);
            }
            function a7(t, n, e, i, r) {
                const s = (function bE(t) {
                    if ('string' == typeof t) return t.charCodeAt(0) || 0;
                    const n = t.hasOwnProperty(Va) ? t[Va] : void 0;
                    return 'number' == typeof n ? (n >= 0 ? n & t7 : CE) : n;
                })(e);
                if ('function' == typeof s) {
                    if (!$5(n, t, i)) return i & re.Host ? r7(r, 0, i) : s7(n, e, i, r);
                    try {
                        let o;
                        if (((o = s(i)), null != o || i & re.Optional)) return o;
                        J();
                    } finally {
                        Q5();
                    }
                } else if ('number' == typeof s) {
                    let o = null,
                        a = i7(t, n),
                        l = a1,
                        c = i & re.Host ? n[Ki][as] : null;
                    for (
                        (-1 === a || i & re.SkipSelf) &&
                        ((l = -1 === a ? o2(t, n) : n[a + 8]),
                        l !== a1 && c7(i, !1) ? ((o = n[Be]), (a = q0(l)), (n = Y0(l, n))) : (a = -1));
                        -1 !== a;

                    ) {
                        const f = n[Be];
                        if (l7(s, a, f.data)) {
                            const g = yE(a, n, e, o, i, c);
                            if (g !== Qa) return g;
                        }
                        (l = n[a + 8]),
                            l !== a1 && c7(i, n[Be].data[a + 8] === c) && l7(s, a, n)
                                ? ((o = f), (a = q0(l)), (n = Y0(l, n)))
                                : (a = -1);
                    }
                }
                return r;
            }
            function yE(t, n, e, i, r, s) {
                const o = n[Be],
                    a = o.data[t + 8],
                    f = a2(a, o, e, null == i ? wl(a) && e6 : i != o && !!(3 & a.type), r & re.Host && s === a);
                return null !== f ? nu(n, o, f, a) : Qa;
            }
            function a2(t, n, e, i, r) {
                const s = t.providerIndexes,
                    o = n.data,
                    a = 1048575 & s,
                    l = t.directiveStart,
                    f = s >> 20,
                    E = r ? a + f : t.directiveEnd;
                for (let P = i ? a : a + f; P < E; P++) {
                    const V = o[P];
                    if ((P < l && e === V) || (P >= l && V.type === e)) return P;
                }
                if (r) {
                    const P = o[l];
                    if (P && Lo(P) && P.type === e) return l;
                }
                return null;
            }
            function nu(t, n, e, i) {
                let r = t[e];
                const s = n.data;
                if (
                    (function dE(t) {
                        return t instanceof B0;
                    })(r)
                ) {
                    const o = r;
                    o.resolving &&
                        (function A(t, n) {
                            throw (n && n.join(' > '), new Me(-200, t));
                        })(
                            (function y(t) {
                                return 'function' == typeof t
                                    ? t.name || t.toString()
                                    : 'object' == typeof t && null != t && 'function' == typeof t.type
                                    ? t.type.name || t.type.toString()
                                    : h(t);
                            })(s[e]),
                        );
                    const a = r2(o.canSeeViewProviders);
                    o.resolving = !0;
                    const c = o.injectImpl ? ve(o.injectImpl) : null;
                    $5(t, i, re.Default);
                    try {
                        (r = t[e] = o.factory(void 0, s, t, i)),
                            n.firstCreatePass &&
                                e >= i.directiveStart &&
                                (function cE(t, n, e) {
                                    const { ngOnChanges: i, ngOnInit: r, ngDoCheck: s } = n.type.prototype;
                                    if (i) {
                                        const o = Y(n);
                                        (e.preOrderHooks ??= []).push(t, o), (e.preOrderCheckHooks ??= []).push(t, o);
                                    }
                                    r && (e.preOrderHooks ??= []).push(0 - t, r),
                                        s &&
                                            ((e.preOrderHooks ??= []).push(t, s),
                                            (e.preOrderCheckHooks ??= []).push(t, s));
                                })(e, s[e], n);
                    } finally {
                        null !== c && ve(c), r2(a), (o.resolving = !1), Q5();
                    }
                }
                return r;
            }
            function l7(t, n, e) {
                return !!(e[n + (t >> n7)] & (1 << t));
            }
            function c7(t, n) {
                return !(t & re.Self || (t & re.Host && n));
            }
            class Kr {
                constructor(n, e) {
                    (this._tNode = n), (this._lView = e);
                }
                get(n, e, i) {
                    return o7(this._tNode, this._lView, n, Ys(i), e);
                }
            }
            function CE() {
                return new Kr(_i(), Ie());
            }
            function Nr(t) {
                return qs(() => {
                    const n = t.prototype.constructor,
                        e = n[ko] || i6(n),
                        i = Object.prototype;
                    let r = Object.getPrototypeOf(t.prototype).constructor;
                    for (; r && r !== i; ) {
                        const s = r[ko] || i6(r);
                        if (s && s !== e) return s;
                        r = Object.getPrototypeOf(r);
                    }
                    return s => new s();
                });
            }
            function i6(t) {
                return Zo(t)
                    ? () => {
                          const n = i6(Dt(t));
                          return n && n();
                      }
                    : yr(t);
            }
            function u7(t) {
                const n = t[Be],
                    e = n.type;
                return 2 === e ? n.declTNode : 1 === e ? t[as] : null;
            }
            function p7(t, n = null, e = null, i) {
                const r = g7(t, n, e, i);
                return r.resolveInjectorInitializers(), r;
            }
            function g7(t, n = null, e = null, i, r = new Set()) {
                const s = [e || An, Kl(t)];
                return (i = i || ('object' == typeof t ? void 0 : tr(t))), new Xl(s, n || Qu(), i || null, r);
            }
            let ys = (() => {
                class t {
                    static #e = (this.THROW_IF_NOT_FOUND = Xt);
                    static #t = (this.NULL = new le());
                    static create(e, i) {
                        if (Array.isArray(e)) return p7({ name: '' }, i, e, '');
                        {
                            const r = e.name ?? '';
                            return p7({ name: r }, e.parent, e.providers, r);
                        }
                    }
                    static #n = (this.ɵprov = We({ token: t, providedIn: 'any', factory: () => Se($c) }));
                    static #i = (this.__NG_ELEMENT_ID__ = -1);
                }
                return t;
            })();
            /*!
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */ function s6(t) {
                return t.ngOriginalError;
            }
            class Xa {
                constructor() {
                    this._console = console;
                }
                handleError(n) {
                    const e = this._findOriginalError(n);
                    this._console.error('ERROR', n), e && this._console.error('ORIGINAL ERROR', e);
                }
                _findOriginalError(n) {
                    let e = n && s6(n);
                    for (; e && s6(e); ) e = s6(e);
                    return e || null;
                }
            }
            const _7 = new $e('', { providedIn: 'root', factory: () => Ue(Xa).handleError.bind(void 0) });
            let oc = (() => {
                class t {
                    static #e = (this.__NG_ELEMENT_ID__ = AE);
                    static #t = (this.__NG_ENV_ID__ = e => e);
                }
                return t;
            })();
            class IE extends oc {
                constructor(n) {
                    super(), (this._lView = n);
                }
                onDestroy(n) {
                    return (
                        Zh(this._lView, n),
                        () =>
                            (function q3(t, n) {
                                if (null === t[va]) return;
                                const e = t[va].indexOf(n);
                                -1 !== e && t[va].splice(e, 1);
                            })(this._lView, n)
                    );
                }
            }
            function AE() {
                return new IE(Ie());
            }
            function LE() {
                return u1(_i(), Ie());
            }
            function u1(t, n) {
                return new Pn(Gs(t, n));
            }
            let Pn = (() => {
                class t {
                    constructor(e) {
                        this.nativeElement = e;
                    }
                    static #e = (this.__NG_ELEMENT_ID__ = LE);
                }
                return t;
            })();
            function b7(t) {
                return t instanceof Pn ? t.nativeElement : t;
            }
            function o6(t) {
                return n => {
                    setTimeout(t, void 0, n);
                };
            }
            const Ft = class OE extends vt {
                constructor(n = !1) {
                    super(),
                        (this.destroyRef = void 0),
                        (this.__isAsync = n),
                        jh() && (this.destroyRef = Ue(oc, { optional: !0 }) ?? void 0);
                }
                emit(n) {
                    const e = _(null);
                    try {
                        super.next(n);
                    } finally {
                        _(e);
                    }
                }
                subscribe(n, e, i) {
                    let r = n,
                        s = e || (() => null),
                        o = i;
                    if (n && 'object' == typeof n) {
                        const l = n;
                        (r = l.next?.bind(l)), (s = l.error?.bind(l)), (o = l.complete?.bind(l));
                    }
                    this.__isAsync && ((s = o6(s)), r && (r = o6(r)), o && (o = o6(o)));
                    const a = super.subscribe({ next: r, error: s, complete: o });
                    return n instanceof ii && n.add(a), a;
                }
            };
            function zE() {
                return this._results[Symbol.iterator]();
            }
            class j0 {
                static #e = Symbol.iterator;
                get changes() {
                    return (this._changes ??= new Ft());
                }
                constructor(n = !1) {
                    (this._emitDistinctChangesOnly = n),
                        (this.dirty = !0),
                        (this._onDirty = void 0),
                        (this._results = []),
                        (this._changesDetected = !1),
                        (this._changes = void 0),
                        (this.length = 0),
                        (this.first = void 0),
                        (this.last = void 0);
                    const e = j0.prototype;
                    e[Symbol.iterator] || (e[Symbol.iterator] = zE);
                }
                get(n) {
                    return this._results[n];
                }
                map(n) {
                    return this._results.map(n);
                }
                filter(n) {
                    return this._results.filter(n);
                }
                find(n) {
                    return this._results.find(n);
                }
                reduce(n, e) {
                    return this._results.reduce(n, e);
                }
                forEach(n) {
                    this._results.forEach(n);
                }
                some(n) {
                    return this._results.some(n);
                }
                toArray() {
                    return this._results.slice();
                }
                toString() {
                    return this._results.toString();
                }
                reset(n, e) {
                    this.dirty = !1;
                    const i = (function rs(t) {
                        return t.flat(Number.POSITIVE_INFINITY);
                    })(n);
                    (this._changesDetected = !(function Ua(t, n, e) {
                        if (t.length !== n.length) return !1;
                        for (let i = 0; i < t.length; i++) {
                            let r = t[i],
                                s = n[i];
                            if ((e && ((r = e(r)), (s = e(s))), s !== r)) return !1;
                        }
                        return !0;
                    })(this._results, i, e)) &&
                        ((this._results = i),
                        (this.length = i.length),
                        (this.last = i[this.length - 1]),
                        (this.first = i[0]));
                }
                notifyOnChanges() {
                    void 0 !== this._changes &&
                        (this._changesDetected || !this._emitDistinctChangesOnly) &&
                        this._changes.emit(this);
                }
                onDirty(n) {
                    this._onDirty = n;
                }
                setDirty() {
                    (this.dirty = !0), this._onDirty?.();
                }
                destroy() {
                    void 0 !== this._changes && (this._changes.complete(), this._changes.unsubscribe());
                }
            }
            function u2(t) {
                return !(128 & ~t.flags);
            }
            const a6 = new Map();
            let NE = 0;
            const c6 = '__ngContext__';
            function zs(t, n) {
                ls(n)
                    ? ((t[c6] = n[$s]),
                      (function RE(t) {
                          a6.set(t[$s], t);
                      })(n))
                    : (t[c6] = n);
            }
            function I7(t) {
                return L7(t[tc]);
            }
            function A7(t) {
                return L7(t[Ao]);
            }
            function L7(t) {
                for (; null !== t && !cs(t); ) t = t[Ao];
                return t;
            }
            let u6;
            function ac() {
                if (void 0 !== u6) return u6;
                if (typeof document < 'u') return document;
                throw new Me(210, !1);
            }
            const f2 = new $e('', { providedIn: 'root', factory: () => nI }),
                nI = 'ng',
                H7 = new $e(''),
                Za = new $e('', { providedIn: 'platform', factory: () => 'unknown' }),
                W0 = new $e(''),
                K0 = new $e('', {
                    providedIn: 'root',
                    factory: () => ac().body?.querySelector('[ngCspNonce]')?.getAttribute('ngCspNonce') || null,
                });
            let U7 = () => null;
            function _6(t, n, e = !1) {
                return U7(t, n, e);
            }
            const $7 = new $e('', { providedIn: 'root', factory: () => !1 });
            let b2, C2;
            function f1(t) {
                return (
                    (function w6() {
                        if (void 0 === b2 && ((b2 = null), Rn.trustedTypes))
                            try {
                                b2 = Rn.trustedTypes.createPolicy('angular', {
                                    createHTML: t => t,
                                    createScript: t => t,
                                    createScriptURL: t => t,
                                });
                            } catch {}
                        return b2;
                    })()?.createHTML(t) || t
                );
            }
            function W7(t) {
                return (
                    (function M6() {
                        if (void 0 === C2 && ((C2 = null), Rn.trustedTypes))
                            try {
                                C2 = Rn.trustedTypes.createPolicy('angular#unsafe-bypass', {
                                    createHTML: t => t,
                                    createScript: t => t,
                                    createScriptURL: t => t,
                                });
                            } catch {}
                        return C2;
                    })()?.createHTML(t) || t
                );
            }
            class iu {
                constructor(n) {
                    this.changingThisBreaksApplicationSecurity = n;
                }
                toString() {
                    return `SafeValue must use [property]=binding: ${this.changingThisBreaksApplicationSecurity} (see ${fa})`;
                }
            }
            class gI extends iu {
                getTypeName() {
                    return 'HTML';
                }
            }
            class vI extends iu {
                getTypeName() {
                    return 'Style';
                }
            }
            class _I extends iu {
                getTypeName() {
                    return 'Script';
                }
            }
            class yI extends iu {
                getTypeName() {
                    return 'URL';
                }
            }
            class bI extends iu {
                getTypeName() {
                    return 'ResourceURL';
                }
            }
            function zo(t) {
                return t instanceof iu ? t.changingThisBreaksApplicationSecurity : t;
            }
            function Ja(t, n) {
                const e = (function CI(t) {
                    return (t instanceof iu && t.getTypeName()) || null;
                })(t);
                if (null != e && e !== n) {
                    if ('ResourceURL' === e && 'URL' === n) return !0;
                    throw new Error(`Required a safe ${n}, got a ${e} (see ${fa})`);
                }
                return e === n;
            }
            class xI {
                constructor(n) {
                    this.inertDocumentHelper = n;
                }
                getInertBodyElement(n) {
                    n = '<body><remove></remove>' + n;
                    try {
                        const e = new window.DOMParser().parseFromString(f1(n), 'text/html').body;
                        return null === e
                            ? this.inertDocumentHelper.getInertBodyElement(n)
                            : (e.removeChild(e.firstChild), e);
                    } catch {
                        return null;
                    }
                }
            }
            class kI {
                constructor(n) {
                    (this.defaultDoc = n),
                        (this.inertDocument = this.defaultDoc.implementation.createHTMLDocument('sanitization-inert'));
                }
                getInertBodyElement(n) {
                    const e = this.inertDocument.createElement('template');
                    return (e.innerHTML = f1(n)), e;
                }
            }
            const II = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:\/?#]*(?:[\/?#]|$))/i;
            function w2(t) {
                return (t = String(t)).match(II) ? t : 'unsafe:' + t;
            }
            function Tl(t) {
                const n = {};
                for (const e of t.split(',')) n[e] = !0;
                return n;
            }
            function ed(...t) {
                const n = {};
                for (const e of t) for (const i in e) e.hasOwnProperty(i) && (n[i] = !0);
                return n;
            }
            const Z7 = Tl('area,br,col,hr,img,wbr'),
                J7 = Tl('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
                ev = Tl('rp,rt'),
                S6 = ed(
                    Z7,
                    ed(
                        J7,
                        Tl(
                            'address,article,aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul',
                        ),
                    ),
                    ed(
                        ev,
                        Tl(
                            'a,abbr,acronym,audio,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video',
                        ),
                    ),
                    ed(ev, J7),
                ),
                T6 = Tl('background,cite,href,itemtype,longdesc,poster,src,xlink:href'),
                tv = ed(
                    T6,
                    Tl(
                        'abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,scope,scrolling,shape,size,sizes,span,srclang,srcset,start,summary,tabindex,target,title,translate,type,usemap,valign,value,vspace,width',
                    ),
                    Tl(
                        'aria-activedescendant,aria-atomic,aria-autocomplete,aria-busy,aria-checked,aria-colcount,aria-colindex,aria-colspan,aria-controls,aria-current,aria-describedby,aria-details,aria-disabled,aria-dropeffect,aria-errormessage,aria-expanded,aria-flowto,aria-grabbed,aria-haspopup,aria-hidden,aria-invalid,aria-keyshortcuts,aria-label,aria-labelledby,aria-level,aria-live,aria-modal,aria-multiline,aria-multiselectable,aria-orientation,aria-owns,aria-placeholder,aria-posinset,aria-pressed,aria-readonly,aria-relevant,aria-required,aria-roledescription,aria-rowcount,aria-rowindex,aria-rowspan,aria-selected,aria-setsize,aria-sort,aria-valuemax,aria-valuemin,aria-valuenow,aria-valuetext',
                    ),
                ),
                AI = Tl('script,style,template');
            class LI {
                constructor() {
                    (this.sanitizedSomething = !1), (this.buf = []);
                }
                sanitizeChildren(n) {
                    let e = n.firstChild,
                        i = !0,
                        r = [];
                    for (; e; )
                        if (
                            (e.nodeType === Node.ELEMENT_NODE
                                ? (i = this.startElement(e))
                                : e.nodeType === Node.TEXT_NODE
                                ? this.chars(e.nodeValue)
                                : (this.sanitizedSomething = !0),
                            i && e.firstChild)
                        )
                            r.push(e), (e = PI(e));
                        else
                            for (; e; ) {
                                e.nodeType === Node.ELEMENT_NODE && this.endElement(e);
                                let s = zI(e);
                                if (s) {
                                    e = s;
                                    break;
                                }
                                e = r.pop();
                            }
                    return this.buf.join('');
                }
                startElement(n) {
                    const e = nv(n).toLowerCase();
                    if (!S6.hasOwnProperty(e)) return (this.sanitizedSomething = !0), !AI.hasOwnProperty(e);
                    this.buf.push('<'), this.buf.push(e);
                    const i = n.attributes;
                    for (let r = 0; r < i.length; r++) {
                        const s = i.item(r),
                            o = s.name,
                            a = o.toLowerCase();
                        if (!tv.hasOwnProperty(a)) {
                            this.sanitizedSomething = !0;
                            continue;
                        }
                        let l = s.value;
                        T6[a] && (l = w2(l)), this.buf.push(' ', o, '="', rv(l), '"');
                    }
                    return this.buf.push('>'), !0;
                }
                endElement(n) {
                    const e = nv(n).toLowerCase();
                    S6.hasOwnProperty(e) &&
                        !Z7.hasOwnProperty(e) &&
                        (this.buf.push('</'), this.buf.push(e), this.buf.push('>'));
                }
                chars(n) {
                    this.buf.push(rv(n));
                }
            }
            function zI(t) {
                const n = t.nextSibling;
                if (n && t !== n.previousSibling) throw iv(n);
                return n;
            }
            function PI(t) {
                const n = t.firstChild;
                if (
                    n &&
                    (function OI(t, n) {
                        return (
                            (t.compareDocumentPosition(n) & Node.DOCUMENT_POSITION_CONTAINED_BY) !==
                            Node.DOCUMENT_POSITION_CONTAINED_BY
                        );
                    })(t, n)
                )
                    throw iv(n);
                return n;
            }
            function nv(t) {
                const n = t.nodeName;
                return 'string' == typeof n ? n : 'FORM';
            }
            function iv(t) {
                return new Error(`Failed to sanitize html because the element is clobbered: ${t.outerHTML}`);
            }
            const NI = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
                FI = /([^\#-~ |!])/g;
            function rv(t) {
                return t
                    .replace(/&/g, '&amp;')
                    .replace(NI, function (n) {
                        return '&#' + (1024 * (n.charCodeAt(0) - 55296) + (n.charCodeAt(1) - 56320) + 65536) + ';';
                    })
                    .replace(FI, function (n) {
                        return '&#' + n.charCodeAt(0) + ';';
                    })
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
            }
            let M2;
            function sv(t, n) {
                let e = null;
                try {
                    M2 =
                        M2 ||
                        (function X7(t) {
                            const n = new kI(t);
                            return (function EI() {
                                try {
                                    return !!new window.DOMParser().parseFromString(f1(''), 'text/html');
                                } catch {
                                    return !1;
                                }
                            })()
                                ? new xI(n)
                                : n;
                        })(t);
                    let i = n ? String(n) : '';
                    e = M2.getInertBodyElement(i);
                    let r = 5,
                        s = i;
                    do {
                        if (0 === r) throw new Error('Failed to sanitize html because the input is unstable');
                        r--, (i = s), (s = e.innerHTML), (e = M2.getInertBodyElement(i));
                    } while (i !== s);
                    return f1(new LI().sanitizeChildren(D6(e) || e));
                } finally {
                    if (e) {
                        const i = D6(e) || e;
                        for (; i.firstChild; ) i.removeChild(i.firstChild);
                    }
                }
            }
            function D6(t) {
                return 'content' in t &&
                    (function RI(t) {
                        return t.nodeType === Node.ELEMENT_NODE && 'TEMPLATE' === t.nodeName;
                    })(t)
                    ? t.content
                    : null;
            }
            var Po = (function (t) {
                return (
                    (t[(t.NONE = 0)] = 'NONE'),
                    (t[(t.HTML = 1)] = 'HTML'),
                    (t[(t.STYLE = 2)] = 'STYLE'),
                    (t[(t.SCRIPT = 3)] = 'SCRIPT'),
                    (t[(t.URL = 4)] = 'URL'),
                    (t[(t.RESOURCE_URL = 5)] = 'RESOURCE_URL'),
                    t
                );
            })(Po || {});
            function No(t) {
                const n = nd();
                return n ? W7(n.sanitize(Po.HTML, t) || '') : Ja(t, 'HTML') ? W7(zo(t)) : sv(ac(), h(t));
            }
            function td(t) {
                const n = nd();
                return n ? n.sanitize(Po.URL, t) || '' : Ja(t, 'URL') ? zo(t) : w2(h(t));
            }
            function nd() {
                const t = Ie();
                return t && t[cn].sanitizer;
            }
            const jI = /^>|^->|<!--|-->|--!>|<!-$/g,
                $I = /(<|>)/g,
                GI = '\u200b$1\u200b';
            var lc = (function (t) {
                return (t[(t.Important = 1)] = 'Important'), (t[(t.DashCase = 2)] = 'DashCase'), t;
            })(lc || {});
            let I6;
            function A6(t, n) {
                return I6(t, n);
            }
            function p1(t, n, e, i, r) {
                if (null != i) {
                    let s,
                        o = !1;
                    cs(i) ? (s = i) : ls(i) && ((o = !0), (i = i[Ui]));
                    const a = xi(i);
                    0 === t && null !== e
                        ? null == r
                            ? _v(n, e, a)
                            : ru(n, e, a, r || null, !0)
                        : 1 === t && null !== e
                        ? ru(n, e, a, r || null, !0)
                        : 2 === t
                        ? (function sd(t, n, e) {
                              const i = k2(t, n);
                              i &&
                                  (function hA(t, n, e, i) {
                                      t.removeChild(n, e, i);
                                  })(t, i, n, e);
                          })(n, a, o)
                        : 3 === t && n.destroyNode(a),
                        null != s &&
                            (function pA(t, n, e, i, r) {
                                const s = e[fo];
                                s !== xi(e) && p1(n, t, i, s, r);
                                for (let a = li; a < e.length; a++) {
                                    const l = e[a];
                                    I2(l[Be], l, t, n, i, s);
                                }
                            })(n, t, s, e, r);
                }
            }
            function O6(t, n) {
                return t.createComment(
                    (function av(t) {
                        return t.replace(jI, n => n.replace($I, GI));
                    })(n),
                );
            }
            function D2(t, n, e) {
                return t.createElement(n, e);
            }
            function pv(t, n) {
                n[cn].changeDetectionScheduler?.notify(1), I2(t, n, n[Nt], 2, null, null);
            }
            function gv(t, n) {
                const e = t[sc],
                    i = e.indexOf(n);
                e.splice(i, 1);
            }
            function id(t, n) {
                if (t.length <= li) return;
                const e = li + n,
                    i = t[e];
                if (i) {
                    const r = i[Xc];
                    null !== r && r !== t && gv(r, i), n > 0 && (t[e - 1][Ao] = i[Ao]);
                    const s = ho(t, li + n);
                    !(function sA(t, n) {
                        pv(t, n), (n[Ui] = null), (n[as] = null);
                    })(i[Be], i);
                    const o = s[ga];
                    null !== o && o.detachView(s[Be]), (i[ar] = null), (i[Ao] = null), (i[St] &= -129);
                }
                return i;
            }
            function x2(t, n) {
                if (!(256 & n[St])) {
                    const e = n[Nt];
                    e.destroyNode && I2(t, n, e, 3, null, null),
                        (function aA(t) {
                            let n = t[tc];
                            if (!n) return z6(t[Be], t);
                            for (; n; ) {
                                let e = null;
                                if (ls(n)) e = n[tc];
                                else {
                                    const i = n[li];
                                    i && (e = i);
                                }
                                if (!e) {
                                    for (; n && !n[Ao] && n !== t; ) ls(n) && z6(n[Be], n), (n = n[ar]);
                                    null === n && (n = t), ls(n) && z6(n[Be], n), (e = n && n[Ao]);
                                }
                                n = e;
                            }
                        })(n);
                }
            }
            function z6(t, n) {
                if (256 & n[St]) return;
                const e = _(null);
                try {
                    (n[St] &= -129),
                        (n[St] |= 256),
                        n[Cl] &&
                            (function xe(t) {
                                if ((Ne(t), je(t)))
                                    for (let n = 0; n < t.producerNode.length; n++)
                                        b(t.producerNode[n], t.producerIndexOfThis[n]);
                                (t.producerNode.length =
                                    t.producerLastReadVersion.length =
                                    t.producerIndexOfThis.length =
                                        0),
                                    t.liveConsumerNode &&
                                        (t.liveConsumerNode.length = t.liveConsumerIndexOfThis.length = 0);
                            })(n[Cl]),
                        (function dA(t, n) {
                            let e;
                            if (null != t && null != (e = t.destroyHooks))
                                for (let i = 0; i < e.length; i += 2) {
                                    const r = n[e[i]];
                                    if (!(r instanceof B0)) {
                                        const s = e[i + 1];
                                        if (Array.isArray(s))
                                            for (let o = 0; o < s.length; o += 2) {
                                                const a = r[s[o]],
                                                    l = s[o + 1];
                                                Wr(4, a, l);
                                                try {
                                                    l.call(a);
                                                } finally {
                                                    Wr(5, a, l);
                                                }
                                            }
                                        else {
                                            Wr(4, r, s);
                                            try {
                                                s.call(r);
                                            } finally {
                                                Wr(5, r, s);
                                            }
                                        }
                                    }
                                }
                        })(t, n),
                        (function uA(t, n) {
                            const e = t.cleanup,
                                i = n[ec];
                            if (null !== e)
                                for (let s = 0; s < e.length - 1; s += 2)
                                    if ('string' == typeof e[s]) {
                                        const o = e[s + 3];
                                        o >= 0 ? i[o]() : i[-o].unsubscribe(), (s += 2);
                                    } else e[s].call(i[e[s + 1]]);
                            null !== i && (n[ec] = null);
                            const r = n[va];
                            if (null !== r) {
                                n[va] = null;
                                for (let s = 0; s < r.length; s++) (0, r[s])();
                            }
                        })(t, n),
                        1 === n[Be].type && n[Nt].destroy();
                    const i = n[Xc];
                    if (null !== i && cs(n[ar])) {
                        i !== n[ar] && gv(i, n);
                        const r = n[ga];
                        null !== r && r.detachView(t);
                    }
                    !(function VE(t) {
                        a6.delete(t[$s]);
                    })(n);
                } finally {
                    _(e);
                }
            }
            function P6(t, n, e) {
                return (function vv(t, n, e) {
                    let i = n;
                    for (; null !== i && 40 & i.type; ) i = (n = i).parent;
                    if (null === i) return e[Ui];
                    {
                        const { componentOffset: r } = i;
                        if (r > -1) {
                            const { encapsulation: s } = t.data[i.directiveStart + r];
                            if (s === we.None || s === we.Emulated) return null;
                        }
                        return Gs(i, e);
                    }
                })(t, n.parent, e);
            }
            function ru(t, n, e, i, r) {
                t.insertBefore(n, e, i, r);
            }
            function _v(t, n, e) {
                t.appendChild(n, e);
            }
            function yv(t, n, e, i, r) {
                null !== i ? ru(t, n, e, i, r) : _v(t, n, e);
            }
            function k2(t, n) {
                return t.parentNode(n);
            }
            function bv(t, n, e) {
                return wv(t, n, e);
            }
            let N6,
                wv = function Cv(t, n, e) {
                    return 40 & t.type ? Gs(t, e) : null;
                };
            function E2(t, n, e, i) {
                const r = P6(t, i, n),
                    s = n[Nt],
                    a = bv(i.parent || n[as], i, n);
                if (null != r)
                    if (Array.isArray(e)) for (let l = 0; l < e.length; l++) yv(s, r, e[l], a, !1);
                    else yv(s, r, e, a, !1);
                void 0 !== N6 && N6(s, i, n, e, r);
            }
            function rd(t, n) {
                if (null !== n) {
                    const e = n.type;
                    if (3 & e) return Gs(n, t);
                    if (4 & e) return F6(-1, t[n.index]);
                    if (8 & e) {
                        const i = n.child;
                        if (null !== i) return rd(t, i);
                        {
                            const r = t[n.index];
                            return cs(r) ? F6(-1, r) : xi(r);
                        }
                    }
                    if (32 & e) return A6(n, t)() || xi(t[n.index]);
                    {
                        const i = Sv(t, n);
                        return null !== i ? (Array.isArray(i) ? i[0] : rd(eu(t[Ki]), i)) : rd(t, n.next);
                    }
                }
                return null;
            }
            function Sv(t, n) {
                return null !== n ? t[Ki][as].projection[n.projection] : null;
            }
            function F6(t, n) {
                const e = li + t + 1;
                if (e < n.length) {
                    const i = n[e],
                        r = i[Be].firstChild;
                    if (null !== r) return rd(i, r);
                }
                return n[fo];
            }
            function R6(t, n, e, i, r, s, o) {
                for (; null != e; ) {
                    const a = i[e.index],
                        l = e.type;
                    if ((o && 0 === n && (a && zs(xi(a), i), (e.flags |= 2)), 32 & ~e.flags))
                        if (8 & l) R6(t, n, e.child, i, r, s, !1), p1(n, t, r, a, s);
                        else if (32 & l) {
                            const c = A6(e, i);
                            let f;
                            for (; (f = c()); ) p1(n, t, r, f, s);
                            p1(n, t, r, a, s);
                        } else 16 & l ? Dv(t, n, i, e, r, s) : p1(n, t, r, a, s);
                    e = o ? e.projectionNext : e.next;
                }
            }
            function I2(t, n, e, i, r, s) {
                R6(e, i, t.firstChild, n, r, s, !1);
            }
            function Dv(t, n, e, i, r, s) {
                const o = e[Ki],
                    l = o[as].projection[i.projection];
                if (Array.isArray(l)) for (let c = 0; c < l.length; c++) p1(n, t, r, l[c], s);
                else {
                    let c = l;
                    const f = o[ar];
                    u2(i) && (c.flags |= 128), R6(t, n, c, f, r, s, !0);
                }
            }
            function xv(t, n, e) {
                '' === e ? t.removeAttribute(n, 'class') : t.setAttribute(n, 'class', e);
            }
            function kv(t, n, e) {
                const { mergedAttrs: i, classes: r, styles: s } = e;
                null !== i && it(t, n, i),
                    null !== r && xv(t, n, r),
                    null !== s &&
                        (function vA(t, n, e) {
                            t.setAttribute(n, 'style', e);
                        })(t, n, s);
            }
            const un = {};
            function z(t = 1) {
                Ev(Ln(), Ie(), Os() + t, !1);
            }
            function Ev(t, n, e, i) {
                if (!i)
                    if (3 & ~n[St]) {
                        const s = t.preOrderHooks;
                        null !== s && n2(n, s, 0, e);
                    } else {
                        const s = t.preOrderCheckHooks;
                        null !== s && t2(n, s, e);
                    }
                tu(e);
            }
            function te(t, n = re.Default) {
                const e = Ie();
                return null === e ? Se(t, n) : o7(_i(), e, Dt(t), n);
            }
            function Iv(t, n, e, i, r, s) {
                const o = _(null);
                try {
                    let a = null;
                    r & de.SignalBased && (a = n[i][p]),
                        null !== a && void 0 !== a.transformFn && (s = a.transformFn(s)),
                        r & de.HasDecoratorInputTransform && (s = t.inputTransforms[i].call(n, s)),
                        null !== t.setInput ? t.setInput(n, a, s, e, i) : S(n, a, i, s);
                } finally {
                    _(o);
                }
            }
            function A2(t, n, e, i, r, s, o, a, l, c, f) {
                const g = n.blueprint.slice();
                return (
                    (g[Ui] = r),
                    (g[St] = 204 | i),
                    (null !== c || (t && 2048 & t[St])) && (g[St] |= 2048),
                    R5(g),
                    (g[ar] = g[nc] = t),
                    (g[Di] = e),
                    (g[cn] = o || (t && t[cn])),
                    (g[Nt] = a || (t && t[Nt])),
                    (g[lr] = l || (t && t[lr]) || null),
                    (g[as] = s),
                    (g[$s] = (function FE() {
                        return NE++;
                    })()),
                    (g[Fe] = f),
                    (g[Qh] = c),
                    (g[Ki] = 2 == n.type ? t[Ki] : g),
                    g
                );
            }
            function g1(t, n, e, i, r) {
                let s = t.data[n];
                if (null === s)
                    (s = (function V6(t, n, e, i, r) {
                        const s = B5(),
                            o = Y3(),
                            l = (t.data[n] = (function DA(t, n, e, i, r, s) {
                                let o = n ? n.injectorIndex : -1,
                                    a = 0;
                                return (
                                    o1() && (a |= 128),
                                    {
                                        type: e,
                                        index: i,
                                        insertBeforeIndex: null,
                                        injectorIndex: o,
                                        directiveStart: -1,
                                        directiveEnd: -1,
                                        directiveStylingLast: -1,
                                        componentOffset: -1,
                                        propertyBindings: null,
                                        flags: a,
                                        providerIndexes: 0,
                                        value: r,
                                        attrs: s,
                                        mergedAttrs: null,
                                        localNames: null,
                                        initialInputs: void 0,
                                        inputs: null,
                                        outputs: null,
                                        tView: null,
                                        next: null,
                                        prev: null,
                                        projectionNext: null,
                                        child: null,
                                        parent: n,
                                        projection: null,
                                        styles: null,
                                        stylesWithoutHost: null,
                                        residualStyles: void 0,
                                        classes: null,
                                        classesWithoutHost: null,
                                        residualClasses: void 0,
                                        classBindings: 0,
                                        styleBindings: 0,
                                    }
                                );
                            })(0, o ? s : s && s.parent, e, n, i, r));
                        return (
                            null === t.firstChild && (t.firstChild = l),
                            null !== s &&
                                (o
                                    ? null == s.child && null !== l.parent && (s.child = l)
                                    : null === s.next && ((s.next = l), (l.prev = s))),
                            l
                        );
                    })(t, n, e, i, r)),
                        (function eE() {
                            return Jt.lFrame.inI18n;
                        })() && (s.flags |= 32);
                else if (64 & s.type) {
                    (s.type = e), (s.value = i), (s.attrs = r);
                    const o = (function H0() {
                        const t = Jt.lFrame,
                            n = t.currentTNode;
                        return t.isParent ? n : n.parent;
                    })();
                    s.injectorIndex = null === o ? -1 : o.injectorIndex;
                }
                return Wa(s, !0), s;
            }
            function od(t, n, e, i) {
                if (0 === e) return -1;
                const r = n.length;
                for (let s = 0; s < e; s++) n.push(i), t.blueprint.push(i), t.data.push(null);
                return r;
            }
            function Av(t, n, e, i, r) {
                const s = Os(),
                    o = 2 & i;
                try {
                    tu(-1), o && n.length > Zt && Ev(t, n, Zt, !1), Wr(o ? 2 : 0, r), e(i, r);
                } finally {
                    tu(s), Wr(o ? 3 : 1, r);
                }
            }
            function H6(t, n, e) {
                if (L0(n)) {
                    const i = _(null);
                    try {
                        const s = n.directiveEnd;
                        for (let o = n.directiveStart; o < s; o++) {
                            const a = t.data[o];
                            a.contentQueries && a.contentQueries(1, e[o], o);
                        }
                    } finally {
                        _(i);
                    }
                }
            }
            function U6(t, n, e) {
                U5() &&
                    ((function OA(t, n, e, i) {
                        const r = e.directiveStart,
                            s = e.directiveEnd;
                        wl(e) &&
                            (function HA(t, n, e) {
                                const i = Gs(n, t),
                                    r = Lv(e);
                                let o = 16;
                                e.signals ? (o = 4096) : e.onPush && (o = 64);
                                const a = L2(
                                    t,
                                    A2(
                                        t,
                                        r,
                                        null,
                                        o,
                                        i,
                                        n,
                                        null,
                                        t[cn].rendererFactory.createRenderer(i, e),
                                        null,
                                        null,
                                        null,
                                    ),
                                );
                                t[n.index] = a;
                            })(n, e, t.data[r + e.componentOffset]),
                            t.firstCreatePass || s2(e, n),
                            zs(i, n);
                        const o = e.initialInputs;
                        for (let a = r; a < s; a++) {
                            const l = t.data[a],
                                c = nu(n, t, a, e);
                            zs(c, n),
                                null !== o && UA(0, a - r, c, l, 0, o),
                                Lo(l) && (Oo(e.index, n)[Di] = nu(n, t, a, e));
                        }
                    })(t, n, e, Gs(e, n)),
                    !(64 & ~e.flags) && Fv(t, n, e));
            }
            function B6(t, n, e = Gs) {
                const i = n.localNames;
                if (null !== i) {
                    let r = n.index + 1;
                    for (let s = 0; s < i.length; s += 2) {
                        const o = i[s + 1],
                            a = -1 === o ? e(n, t) : t[o];
                        t[r++] = a;
                    }
                }
            }
            function Lv(t) {
                const n = t.tView;
                return null === n || n.incompleteFirstPass
                    ? (t.tView = q6(
                          1,
                          null,
                          t.template,
                          t.decls,
                          t.vars,
                          t.directiveDefs,
                          t.pipeDefs,
                          t.viewQuery,
                          t.schemas,
                          t.consts,
                          t.id,
                      ))
                    : n;
            }
            function q6(t, n, e, i, r, s, o, a, l, c, f) {
                const g = Zt + i,
                    E = g + r,
                    P = (function bA(t, n) {
                        const e = [];
                        for (let i = 0; i < n; i++) e.push(i < t ? null : un);
                        return e;
                    })(g, E),
                    V = 'function' == typeof c ? c() : c;
                return (P[Be] = {
                    type: t,
                    blueprint: P,
                    template: e,
                    queries: null,
                    viewQuery: a,
                    declTNode: n,
                    data: P.slice().fill(null, g),
                    bindingStartIndex: g,
                    expandoStartIndex: E,
                    hostBindingOpCodes: null,
                    firstCreatePass: !0,
                    firstUpdatePass: !0,
                    staticViewQueries: !1,
                    staticContentQueries: !1,
                    preOrderHooks: null,
                    preOrderCheckHooks: null,
                    contentHooks: null,
                    contentCheckHooks: null,
                    viewHooks: null,
                    viewCheckHooks: null,
                    destroyHooks: null,
                    cleanup: null,
                    contentQueries: null,
                    components: null,
                    directiveRegistry: 'function' == typeof s ? s() : s,
                    pipeRegistry: 'function' == typeof o ? o() : o,
                    firstChild: null,
                    schemas: l,
                    consts: V,
                    incompleteFirstPass: !1,
                    ssrId: f,
                });
            }
            let Ov = () => null;
            function zv(t, n, e, i, r) {
                for (let s in n) {
                    if (!n.hasOwnProperty(s)) continue;
                    const o = n[s];
                    if (void 0 === o) continue;
                    i ??= {};
                    let a,
                        l = de.None;
                    Array.isArray(o) ? ((a = o[0]), (l = o[1])) : (a = o);
                    let c = s;
                    if (null !== r) {
                        if (!r.hasOwnProperty(s)) continue;
                        c = r[s];
                    }
                    0 === t ? Pv(i, e, c, a, l) : Pv(i, e, c, a);
                }
                return i;
            }
            function Pv(t, n, e, i, r) {
                let s;
                t.hasOwnProperty(e) ? (s = t[e]).push(n, i) : (s = t[e] = [n, i]), void 0 !== r && s.push(r);
            }
            function po(t, n, e, i, r, s, o, a) {
                const l = Gs(n, e);
                let f,
                    c = n.inputs;
                !a && null != c && (f = c[i])
                    ? (W6(t, e, f, i, r),
                      wl(n) &&
                          (function EA(t, n) {
                              const e = Oo(n, t);
                              16 & e[St] || (e[St] |= 64);
                          })(e, n.index))
                    : 3 & n.type &&
                      ((i = (function kA(t) {
                          return 'class' === t
                              ? 'className'
                              : 'for' === t
                              ? 'htmlFor'
                              : 'formaction' === t
                              ? 'formAction'
                              : 'innerHtml' === t
                              ? 'innerHTML'
                              : 'readonly' === t
                              ? 'readOnly'
                              : 'tabindex' === t
                              ? 'tabIndex'
                              : t;
                      })(i)),
                      (r = null != o ? o(r, n.value || '', i) : r),
                      s.setProperty(l, i, r));
            }
            function Y6(t, n, e, i) {
                if (U5()) {
                    const r = null === i ? null : { '': -1 },
                        s = (function PA(t, n) {
                            const e = t.directiveRegistry;
                            let i = null,
                                r = null;
                            if (e)
                                for (let s = 0; s < e.length; s++) {
                                    const o = e[s];
                                    if (js(n, o.selectors, !1))
                                        if ((i || (i = []), Lo(o)))
                                            if (null !== o.findHostDirectiveDefs) {
                                                const a = [];
                                                (r = r || new Map()),
                                                    o.findHostDirectiveDefs(o, a, r),
                                                    i.unshift(...a, o),
                                                    j6(t, n, a.length);
                                            } else i.unshift(o), j6(t, n, 0);
                                        else (r = r || new Map()), o.findHostDirectiveDefs?.(o, i, r), i.push(o);
                                }
                            return null === i ? null : [i, r];
                        })(t, e);
                    let o, a;
                    null === s ? (o = a = null) : ([o, a] = s),
                        null !== o && Nv(t, n, e, o, r, a),
                        r &&
                            (function NA(t, n, e) {
                                if (n) {
                                    const i = (t.localNames = []);
                                    for (let r = 0; r < n.length; r += 2) {
                                        const s = e[n[r + 1]];
                                        if (null == s) throw new Me(-301, !1);
                                        i.push(n[r], s);
                                    }
                                }
                            })(e, i, r);
                }
                e.mergedAttrs = It(e.mergedAttrs, e.attrs);
            }
            function Nv(t, n, e, i, r, s) {
                for (let c = 0; c < i.length; c++) n6(s2(e, n), t, i[c].type);
                !(function RA(t, n, e) {
                    (t.flags |= 1), (t.directiveStart = n), (t.directiveEnd = n + e), (t.providerIndexes = n);
                })(e, t.data.length, i.length);
                for (let c = 0; c < i.length; c++) {
                    const f = i[c];
                    f.providersResolver && f.providersResolver(f);
                }
                let o = !1,
                    a = !1,
                    l = od(t, n, i.length, null);
                for (let c = 0; c < i.length; c++) {
                    const f = i[c];
                    (e.mergedAttrs = It(e.mergedAttrs, f.hostAttrs)),
                        VA(t, e, n, l, f),
                        FA(l, f, r),
                        null !== f.contentQueries && (e.flags |= 4),
                        (null !== f.hostBindings || null !== f.hostAttrs || 0 !== f.hostVars) && (e.flags |= 64);
                    const g = f.type.prototype;
                    !o &&
                        (g.ngOnChanges || g.ngOnInit || g.ngDoCheck) &&
                        ((t.preOrderHooks ??= []).push(e.index), (o = !0)),
                        !a && (g.ngOnChanges || g.ngDoCheck) && ((t.preOrderCheckHooks ??= []).push(e.index), (a = !0)),
                        l++;
                }
                !(function xA(t, n, e) {
                    const r = n.directiveEnd,
                        s = t.data,
                        o = n.attrs,
                        a = [];
                    let l = null,
                        c = null;
                    for (let f = n.directiveStart; f < r; f++) {
                        const g = s[f],
                            E = e ? e.get(g) : null,
                            V = E ? E.outputs : null;
                        (l = zv(0, g.inputs, f, l, E ? E.inputs : null)), (c = zv(1, g.outputs, f, c, V));
                        const W = null === l || null === o || Mt(n) ? null : BA(l, f, o);
                        a.push(W);
                    }
                    null !== l &&
                        (l.hasOwnProperty('class') && (n.flags |= 8), l.hasOwnProperty('style') && (n.flags |= 16)),
                        (n.initialInputs = a),
                        (n.inputs = l),
                        (n.outputs = c);
                })(t, e, s);
            }
            function Fv(t, n, e) {
                const i = e.directiveStart,
                    r = e.directiveEnd,
                    s = e.index,
                    o = (function nE() {
                        return Jt.lFrame.currentDirectiveIndex;
                    })();
                try {
                    tu(s);
                    for (let a = i; a < r; a++) {
                        const l = t.data[a],
                            c = n[a];
                        $3(a), (null !== l.hostBindings || 0 !== l.hostVars || null !== l.hostAttrs) && zA(l, c);
                    }
                } finally {
                    tu(-1), $3(o);
                }
            }
            function zA(t, n) {
                null !== t.hostBindings && t.hostBindings(1, n);
            }
            function j6(t, n, e) {
                (n.componentOffset = e), (t.components ??= []).push(n.index);
            }
            function FA(t, n, e) {
                if (e) {
                    if (n.exportAs) for (let i = 0; i < n.exportAs.length; i++) e[n.exportAs[i]] = t;
                    Lo(n) && (e[''] = t);
                }
            }
            function VA(t, n, e, i, r) {
                t.data[i] = r;
                const s = r.factory || (r.factory = yr(r.type)),
                    o = new B0(s, Lo(r), te);
                (t.blueprint[i] = o),
                    (e[i] = o),
                    (function AA(t, n, e, i, r) {
                        const s = r.hostBindings;
                        if (s) {
                            let o = t.hostBindingOpCodes;
                            null === o && (o = t.hostBindingOpCodes = []);
                            const a = ~n.index;
                            (function LA(t) {
                                let n = t.length;
                                for (; n > 0; ) {
                                    const e = t[--n];
                                    if ('number' == typeof e && e < 0) return e;
                                }
                                return 0;
                            })(o) != a && o.push(a),
                                o.push(e, i, s);
                        }
                    })(t, n, i, od(t, e, r.hostVars, un), r);
            }
            function el(t, n, e, i, r, s) {
                const o = Gs(t, n);
                !(function $6(t, n, e, i, r, s, o) {
                    if (null == s) t.removeAttribute(n, r, e);
                    else {
                        const a = null == o ? h(s) : o(s, i || '', r);
                        t.setAttribute(n, r, a, e);
                    }
                })(n[Nt], o, s, t.value, e, i, r);
            }
            function UA(t, n, e, i, r, s) {
                const o = s[n];
                if (null !== o) for (let a = 0; a < o.length; ) Iv(i, e, o[a++], o[a++], o[a++], o[a++]);
            }
            function BA(t, n, e) {
                let i = null,
                    r = 0;
                for (; r < e.length; ) {
                    const s = e[r];
                    if (0 !== s)
                        if (5 !== s) {
                            if ('number' == typeof s) break;
                            if (t.hasOwnProperty(s)) {
                                null === i && (i = []);
                                const o = t[s];
                                for (let a = 0; a < o.length; a += 3)
                                    if (o[a] === n) {
                                        i.push(s, o[a + 1], o[a + 2], e[r + 1]);
                                        break;
                                    }
                            }
                            r += 2;
                        } else r += 2;
                    else r += 4;
                }
                return i;
            }
            function Rv(t, n, e, i) {
                return [t, !0, 0, n, null, i, null, e, null, null];
            }
            function Vv(t, n) {
                const e = t.contentQueries;
                if (null !== e) {
                    const i = _(null);
                    try {
                        for (let r = 0; r < e.length; r += 2) {
                            const o = e[r + 1];
                            if (-1 !== o) {
                                const a = t.data[o];
                                Jh(e[r]), a.contentQueries(2, n[o], o);
                            }
                        }
                    } finally {
                        _(i);
                    }
                }
            }
            function L2(t, n) {
                return t[tc] ? (t[Ju][Ao] = n) : (t[tc] = n), (t[Ju] = n), n;
            }
            function G6(t, n, e) {
                Jh(0);
                const i = _(null);
                try {
                    n(t, e);
                } finally {
                    _(i);
                }
            }
            function Hv(t) {
                return t[ec] || (t[ec] = []);
            }
            function Uv(t) {
                return t.cleanup || (t.cleanup = []);
            }
            function O2(t, n) {
                const e = t[lr],
                    i = e ? e.get(Xa, null) : null;
                i && i.handleError(n);
            }
            function W6(t, n, e, i, r) {
                for (let s = 0; s < e.length; ) {
                    const o = e[s++],
                        a = e[s++],
                        l = e[s++];
                    Iv(t.data[o], n[o], i, a, l, r);
                }
            }
            function qA(t, n) {
                const e = Oo(n, t),
                    i = e[Be];
                !(function YA(t, n) {
                    for (let e = n.length; e < t.blueprint.length; e++) n.push(t.blueprint[e]);
                })(i, e);
                const r = e[Ui];
                null !== r && null === e[Fe] && (e[Fe] = _6(r, e[lr])), K6(i, e, e[Di]);
            }
            function K6(t, n, e) {
                K3(n);
                try {
                    const i = t.viewQuery;
                    null !== i && G6(1, i, e);
                    const r = t.template;
                    null !== r && Av(t, n, r, 1, e),
                        t.firstCreatePass && (t.firstCreatePass = !1),
                        n[ga]?.finishViewCreation(t),
                        t.staticContentQueries && Vv(t, n),
                        t.staticViewQueries && G6(2, t.viewQuery, e);
                    const s = t.components;
                    null !== s &&
                        (function jA(t, n) {
                            for (let e = 0; e < n.length; e++) qA(t, n[e]);
                        })(n, s);
                } catch (i) {
                    throw (t.firstCreatePass && ((t.incompleteFirstPass = !0), (t.firstCreatePass = !1)), i);
                } finally {
                    (n[St] &= -5), Q3();
                }
            }
            function ad(t, n, e, i) {
                const r = _(null);
                try {
                    const s = n.tView,
                        l = A2(
                            t,
                            s,
                            e,
                            4096 & t[St] ? 4096 : 16,
                            null,
                            n,
                            null,
                            null,
                            i?.injector ?? null,
                            i?.embeddedViewInjector ?? null,
                            i?.dehydratedView ?? null,
                        );
                    l[Xc] = t[n.index];
                    const f = t[ga];
                    return null !== f && (l[ga] = f.createEmbeddedView(s)), K6(s, l, e), l;
                } finally {
                    _(r);
                }
            }
            function qv(t, n) {
                const e = li + n;
                if (e < t.length) return t[e];
            }
            function v1(t, n) {
                return !n || null === n.firstChild || u2(t);
            }
            function ld(t, n, e, i = !0) {
                const r = n[Be];
                if (
                    ((function lA(t, n, e, i) {
                        const r = li + i,
                            s = e.length;
                        i > 0 && (e[r - 1][Ao] = n),
                            i < s - li ? ((n[Ao] = e[r]), Yc(e, li + i, n)) : (e.push(n), (n[Ao] = null)),
                            (n[ar] = e);
                        const o = n[Xc];
                        null !== o &&
                            e !== o &&
                            (function cA(t, n) {
                                const e = t[sc];
                                n[Ki] !== n[ar][ar][Ki] && (t[St] |= A0.HasTransplantedViews),
                                    null === e ? (t[sc] = [n]) : e.push(n);
                            })(o, n);
                        const a = n[ga];
                        null !== a && a.insertView(t), B3(n), (n[St] |= 128);
                    })(r, n, t, e),
                    i)
                ) {
                    const o = F6(e, t),
                        a = n[Nt],
                        l = k2(a, t[fo]);
                    null !== l &&
                        (function oA(t, n, e, i, r, s) {
                            (i[Ui] = r), (i[as] = n), I2(t, i, e, 1, r, s);
                        })(r, t[as], a, n, l, o);
                }
                const s = n[Fe];
                null !== s && null !== s.firstChild && (s.firstChild = null);
            }
            function Q6(t, n) {
                const e = id(t, n);
                return void 0 !== e && x2(e[Be], e), e;
            }
            function cd(t, n, e, i, r = !1) {
                for (; null !== e; ) {
                    const s = n[e.index];
                    null !== s && i.push(xi(s)), cs(s) && Yv(s, i);
                    const o = e.type;
                    if (8 & o) cd(t, n, e.child, i);
                    else if (32 & o) {
                        const a = A6(e, n);
                        let l;
                        for (; (l = a()); ) i.push(l);
                    } else if (16 & o) {
                        const a = Sv(n, e);
                        if (Array.isArray(a)) i.push(...a);
                        else {
                            const l = eu(n[Ki]);
                            cd(l[Be], l, a, i, !0);
                        }
                    }
                    e = r ? e.projectionNext : e.next;
                }
                return i;
            }
            function Yv(t, n) {
                for (let e = li; e < t.length; e++) {
                    const i = t[e],
                        r = i[Be].firstChild;
                    null !== r && cd(i[Be], i, r, n);
                }
                t[fo] !== t[Ui] && n.push(t[fo]);
            }
            let jv = [];
            const KA = {
                    version: 0,
                    lastCleanEpoch: 0,
                    dirty: !1,
                    producerNode: void 0,
                    producerLastReadVersion: void 0,
                    producerIndexOfThis: void 0,
                    nextProducerIndex: 0,
                    liveConsumerNode: void 0,
                    liveConsumerIndexOfThis: void 0,
                    consumerAllowSignalWrites: !1,
                    consumerIsAlwaysLive: !1,
                    producerMustRecompute: () => !1,
                    producerRecomputeValue: () => {},
                    consumerMarkedDirty: () => {},
                    consumerOnSignalRead: () => {},
                    consumerIsAlwaysLive: !0,
                    consumerMarkedDirty: t => {
                        V0(t.lView);
                    },
                    consumerOnSignalRead() {
                        this.lView[Cl] = this;
                    },
                },
                $v = 100;
            function z2(t, n = !0, e = 0) {
                const i = t[cn],
                    r = i.rendererFactory;
                r.begin?.();
                try {
                    !(function QA(t, n) {
                        X6(t, n);
                        let e = 0;
                        for (; U3(t); ) {
                            if (e === $v) throw new Me(103, !1);
                            e++, X6(t, 1);
                        }
                    })(t, e);
                } catch (o) {
                    throw (n && O2(t, o), o);
                } finally {
                    r.end?.(), i.inlineEffectRunner?.flush();
                }
            }
            function XA(t, n, e, i) {
                const r = n[St];
                if (!(256 & ~r)) return;
                n[cn].inlineEffectRunner?.flush(), K3(n);
                let o = null,
                    a = null;
                (function ZA(t) {
                    return 2 !== t.type;
                })(t) &&
                    ((a = (function $A(t) {
                        return (
                            t[Cl] ??
                            (function GA(t) {
                                const n = jv.pop() ?? Object.create(KA);
                                return (n.lView = t), n;
                            })(t)
                        );
                    })(n)),
                    (o = (function ce(t) {
                        return t && (t.nextProducerIndex = 0), _(t);
                    })(a)));
                try {
                    R5(n),
                        (function Y5(t) {
                            return (Jt.lFrame.bindingIndex = t);
                        })(t.bindingStartIndex),
                        null !== e && Av(t, n, e, 2, i);
                    const l = !(3 & ~r);
                    if (l) {
                        const g = t.preOrderCheckHooks;
                        null !== g && t2(n, g, null);
                    } else {
                        const g = t.preOrderHooks;
                        null !== g && n2(n, g, 0, null), X3(n, 0);
                    }
                    if (
                        ((function JA(t) {
                            for (let n = I7(t); null !== n; n = A7(n)) {
                                if (!(n[St] & A0.HasTransplantedViews)) continue;
                                const e = n[sc];
                                for (let i = 0; i < e.length; i++) {
                                    Yk(e[i]);
                                }
                            }
                        })(n),
                        Gv(n, 0),
                        null !== t.contentQueries && Vv(t, n),
                        l)
                    ) {
                        const g = t.contentCheckHooks;
                        null !== g && t2(n, g);
                    } else {
                        const g = t.contentHooks;
                        null !== g && n2(n, g, 1), X3(n, 1);
                    }
                    !(function yA(t, n) {
                        const e = t.hostBindingOpCodes;
                        if (null !== e)
                            try {
                                for (let i = 0; i < e.length; i++) {
                                    const r = e[i];
                                    if (r < 0) tu(~r);
                                    else {
                                        const s = r,
                                            o = e[++i],
                                            a = e[++i];
                                        tE(o, s), a(2, n[s]);
                                    }
                                }
                            } finally {
                                tu(-1);
                            }
                    })(t, n);
                    const c = t.components;
                    null !== c && Kv(n, c, 0);
                    const f = t.viewQuery;
                    if ((null !== f && G6(2, f, i), l)) {
                        const g = t.viewCheckHooks;
                        null !== g && t2(n, g);
                    } else {
                        const g = t.viewHooks;
                        null !== g && n2(n, g, 2), X3(n, 2);
                    }
                    if ((!0 === t.firstUpdatePass && (t.firstUpdatePass = !1), n[e1])) {
                        for (const g of n[e1]) g();
                        n[e1] = null;
                    }
                    n[St] &= -73;
                } catch (l) {
                    throw (V0(n), l);
                } finally {
                    null !== a &&
                        ((function ge(t, n) {
                            if (
                                (_(n),
                                t &&
                                    void 0 !== t.producerNode &&
                                    void 0 !== t.producerIndexOfThis &&
                                    void 0 !== t.producerLastReadVersion)
                            ) {
                                if (je(t))
                                    for (let e = t.nextProducerIndex; e < t.producerNode.length; e++)
                                        b(t.producerNode[e], t.producerIndexOfThis[e]);
                                for (; t.producerNode.length > t.nextProducerIndex; )
                                    t.producerNode.pop(), t.producerLastReadVersion.pop(), t.producerIndexOfThis.pop();
                            }
                        })(a, o),
                        (function WA(t) {
                            t.lView[Cl] !== t && ((t.lView = null), jv.push(t));
                        })(a)),
                        Q3();
                }
            }
            function Gv(t, n) {
                for (let e = I7(t); null !== e; e = A7(e)) for (let i = li; i < e.length; i++) Wv(e[i], n);
            }
            function eL(t, n, e) {
                Wv(Oo(n, t), e);
            }
            function Wv(t, n) {
                H3(t) && X6(t, n);
            }
            function X6(t, n) {
                const i = t[Be],
                    r = t[St],
                    s = t[Cl];
                let o = !!(0 === n && 16 & r);
                if (
                    ((o ||= !!(64 & r && 0 === n)),
                    (o ||= !!(1024 & r)),
                    (o ||= !(!s?.dirty || !De(s))),
                    s && (s.dirty = !1),
                    (t[St] &= -9217),
                    o)
                )
                    XA(i, t, i.template, t[Di]);
                else if (8192 & r) {
                    Gv(t, 1);
                    const a = i.components;
                    null !== a && Kv(t, a, 1);
                }
            }
            function Kv(t, n, e) {
                for (let i = 0; i < n.length; i++) eL(t, n[i], e);
            }
            function ud(t) {
                for (t[cn].changeDetectionScheduler?.notify(); t; ) {
                    t[St] |= 64;
                    const n = eu(t);
                    if (O0(t) && !n) return t;
                    t = n;
                }
                return null;
            }
            class dd {
                get rootNodes() {
                    const n = this._lView,
                        e = n[Be];
                    return cd(e, n, e.firstChild, []);
                }
                constructor(n, e, i = !0) {
                    (this._lView = n),
                        (this._cdRefInjectingView = e),
                        (this.notifyErrorHandler = i),
                        (this._appRef = null),
                        (this._attachedToViewContainer = !1);
                }
                get context() {
                    return this._lView[Di];
                }
                set context(n) {
                    this._lView[Di] = n;
                }
                get destroyed() {
                    return !(256 & ~this._lView[St]);
                }
                destroy() {
                    if (this._appRef) this._appRef.detachView(this);
                    else if (this._attachedToViewContainer) {
                        const n = this._lView[ar];
                        if (cs(n)) {
                            const e = n[8],
                                i = e ? e.indexOf(this) : -1;
                            i > -1 && (id(n, i), ho(e, i));
                        }
                        this._attachedToViewContainer = !1;
                    }
                    x2(this._lView[Be], this._lView);
                }
                onDestroy(n) {
                    Zh(this._lView, n);
                }
                markForCheck() {
                    ud(this._cdRefInjectingView || this._lView);
                }
                detach() {
                    this._lView[St] &= -129;
                }
                reattach() {
                    B3(this._lView), (this._lView[St] |= 128);
                }
                detectChanges() {
                    (this._lView[St] |= 1024), z2(this._lView, this.notifyErrorHandler);
                }
                checkNoChanges() {}
                attachToViewContainerRef() {
                    if (this._appRef) throw new Me(902, !1);
                    this._attachedToViewContainer = !0;
                }
                detachFromAppRef() {
                    (this._appRef = null), pv(this._lView[Be], this._lView);
                }
                attachToAppRef(n) {
                    if (this._attachedToViewContainer) throw new Me(902, !1);
                    (this._appRef = n), B3(this._lView);
                }
            }
            let Qr = (() => {
                class t {
                    static #e = (this.__NG_ELEMENT_ID__ = iL);
                }
                return t;
            })();
            const tL = Qr,
                nL = class extends tL {
                    constructor(n, e, i) {
                        super(), (this._declarationLView = n), (this._declarationTContainer = e), (this.elementRef = i);
                    }
                    get ssrId() {
                        return this._declarationTContainer.tView?.ssrId || null;
                    }
                    createEmbeddedView(n, e) {
                        return this.createEmbeddedViewImpl(n, e);
                    }
                    createEmbeddedViewImpl(n, e, i) {
                        const r = ad(this._declarationLView, this._declarationTContainer, n, {
                            embeddedViewInjector: e,
                            dehydratedView: i,
                        });
                        return new dd(r);
                    }
                };
            function iL() {
                return P2(_i(), Ie());
            }
            function P2(t, n) {
                return 4 & t.type ? new nL(n, t, u1(t, n)) : null;
            }
            let t9 = () => null;
            function _1(t, n) {
                return t9(t, n);
            }
            class H2 {}
            class xL {}
            class n9 {}
            class EL {
                resolveComponentFactory(n) {
                    throw (function kL(t) {
                        const n = Error(`No component factory found for ${tr(t)}.`);
                        return (n.ngComponent = t), n;
                    })(n);
                }
            }
            let su = (() => {
                class t {
                    static #e = (this.NULL = new EL());
                }
                return t;
            })();
            class y1 {}
            let Ps = (() => {
                    class t {
                        constructor() {
                            this.destroyNode = null;
                        }
                        static #e = (this.__NG_ELEMENT_ID__ = () =>
                            (function IL() {
                                const t = Ie(),
                                    e = Oo(_i().index, t);
                                return (ls(e) ? e : t)[Nt];
                            })());
                    }
                    return t;
                })(),
                AL = (() => {
                    class t {
                        static #e = (this.ɵprov = We({ token: t, providedIn: 'root', factory: () => null }));
                    }
                    return t;
                })();
            const i8 = {},
                r9 = new Set();
            function tl(t) {
                r9.has(t) || (r9.add(t), performance?.mark?.('mark_feature_usage', { detail: { feature: t } }));
            }
            function s9(...t) {}
            class en {
                constructor({
                    enableLongStackTrace: n = !1,
                    shouldCoalesceEventChangeDetection: e = !1,
                    shouldCoalesceRunChangeDetection: i = !1,
                }) {
                    if (
                        ((this.hasPendingMacrotasks = !1),
                        (this.hasPendingMicrotasks = !1),
                        (this.isStable = !0),
                        (this.onUnstable = new Ft(!1)),
                        (this.onMicrotaskEmpty = new Ft(!1)),
                        (this.onStable = new Ft(!1)),
                        (this.onError = new Ft(!1)),
                        typeof Zone > 'u')
                    )
                        throw new Me(908, !1);
                    Zone.assertZonePatched();
                    const r = this;
                    (r._nesting = 0),
                        (r._outer = r._inner = Zone.current),
                        Zone.TaskTrackingZoneSpec && (r._inner = r._inner.fork(new Zone.TaskTrackingZoneSpec())),
                        n && Zone.longStackTraceZoneSpec && (r._inner = r._inner.fork(Zone.longStackTraceZoneSpec)),
                        (r.shouldCoalesceEventChangeDetection = !i && e),
                        (r.shouldCoalesceRunChangeDetection = i),
                        (r.lastRequestAnimationFrameId = -1),
                        (r.nativeRequestAnimationFrame = (function LL() {
                            const t = 'function' == typeof Rn.requestAnimationFrame;
                            let n = Rn[t ? 'requestAnimationFrame' : 'setTimeout'],
                                e = Rn[t ? 'cancelAnimationFrame' : 'clearTimeout'];
                            if (typeof Zone < 'u' && n && e) {
                                const i = n[Zone.__symbol__('OriginalDelegate')];
                                i && (n = i);
                                const r = e[Zone.__symbol__('OriginalDelegate')];
                                r && (e = r);
                            }
                            return { nativeRequestAnimationFrame: n, nativeCancelAnimationFrame: e };
                        })().nativeRequestAnimationFrame),
                        (function PL(t) {
                            const n = () => {
                                !(function zL(t) {
                                    t.isCheckStableRunning ||
                                        -1 !== t.lastRequestAnimationFrameId ||
                                        ((t.lastRequestAnimationFrameId = t.nativeRequestAnimationFrame.call(Rn, () => {
                                            t.fakeTopEventTask ||
                                                (t.fakeTopEventTask = Zone.root.scheduleEventTask(
                                                    'fakeTopEventTask',
                                                    () => {
                                                        (t.lastRequestAnimationFrameId = -1),
                                                            s8(t),
                                                            (t.isCheckStableRunning = !0),
                                                            r8(t),
                                                            (t.isCheckStableRunning = !1);
                                                    },
                                                    void 0,
                                                    () => {},
                                                    () => {},
                                                )),
                                                t.fakeTopEventTask.invoke();
                                        })),
                                        s8(t));
                                })(t);
                            };
                            t._inner = t._inner.fork({
                                name: 'angular',
                                properties: { isAngularZone: !0 },
                                onInvokeTask: (e, i, r, s, o, a) => {
                                    if (
                                        (function NL(t) {
                                            return (
                                                !(!Array.isArray(t) || 1 !== t.length) &&
                                                !0 === t[0].data?.__ignore_ng_zone__
                                            );
                                        })(a)
                                    )
                                        return e.invokeTask(r, s, o, a);
                                    try {
                                        return o9(t), e.invokeTask(r, s, o, a);
                                    } finally {
                                        ((t.shouldCoalesceEventChangeDetection && 'eventTask' === s.type) ||
                                            t.shouldCoalesceRunChangeDetection) &&
                                            n(),
                                            a9(t);
                                    }
                                },
                                onInvoke: (e, i, r, s, o, a, l) => {
                                    try {
                                        return o9(t), e.invoke(r, s, o, a, l);
                                    } finally {
                                        t.shouldCoalesceRunChangeDetection && n(), a9(t);
                                    }
                                },
                                onHasTask: (e, i, r, s) => {
                                    e.hasTask(r, s),
                                        i === r &&
                                            ('microTask' == s.change
                                                ? ((t._hasPendingMicrotasks = s.microTask), s8(t), r8(t))
                                                : 'macroTask' == s.change && (t.hasPendingMacrotasks = s.macroTask));
                                },
                                onHandleError: (e, i, r, s) => (
                                    e.handleError(r, s), t.runOutsideAngular(() => t.onError.emit(s)), !1
                                ),
                            });
                        })(r);
                }
                static isInAngularZone() {
                    return typeof Zone < 'u' && !0 === Zone.current.get('isAngularZone');
                }
                static assertInAngularZone() {
                    if (!en.isInAngularZone()) throw new Me(909, !1);
                }
                static assertNotInAngularZone() {
                    if (en.isInAngularZone()) throw new Me(909, !1);
                }
                run(n, e, i) {
                    return this._inner.run(n, e, i);
                }
                runTask(n, e, i, r) {
                    const s = this._inner,
                        o = s.scheduleEventTask('NgZoneEvent: ' + r, n, OL, s9, s9);
                    try {
                        return s.runTask(o, e, i);
                    } finally {
                        s.cancelTask(o);
                    }
                }
                runGuarded(n, e, i) {
                    return this._inner.runGuarded(n, e, i);
                }
                runOutsideAngular(n) {
                    return this._outer.run(n);
                }
            }
            const OL = {};
            function r8(t) {
                if (0 == t._nesting && !t.hasPendingMicrotasks && !t.isStable)
                    try {
                        t._nesting++, t.onMicrotaskEmpty.emit(null);
                    } finally {
                        if ((t._nesting--, !t.hasPendingMicrotasks))
                            try {
                                t.runOutsideAngular(() => t.onStable.emit(null));
                            } finally {
                                t.isStable = !0;
                            }
                    }
            }
            function s8(t) {
                t.hasPendingMicrotasks = !!(
                    t._hasPendingMicrotasks ||
                    ((t.shouldCoalesceEventChangeDetection || t.shouldCoalesceRunChangeDetection) &&
                        -1 !== t.lastRequestAnimationFrameId)
                );
            }
            function o9(t) {
                t._nesting++, t.isStable && ((t.isStable = !1), t.onUnstable.emit(null));
            }
            function a9(t) {
                t._nesting--, r8(t);
            }
            class l9 {
                constructor() {
                    (this.hasPendingMicrotasks = !1),
                        (this.hasPendingMacrotasks = !1),
                        (this.isStable = !0),
                        (this.onUnstable = new Ft()),
                        (this.onMicrotaskEmpty = new Ft()),
                        (this.onStable = new Ft()),
                        (this.onError = new Ft());
                }
                run(n, e, i) {
                    return n.apply(e, i);
                }
                runGuarded(n, e, i) {
                    return n.apply(e, i);
                }
                runOutsideAngular(n) {
                    return n();
                }
                runTask(n, e, i, r) {
                    return n.apply(e, i);
                }
            }
            let gd = (() => {
                class t {
                    constructor() {
                        (this.handler = null), (this.internalCallbacks = []);
                    }
                    execute() {
                        this.executeInternalCallbacks(), this.handler?.execute();
                    }
                    executeInternalCallbacks() {
                        const e = [...this.internalCallbacks];
                        this.internalCallbacks.length = 0;
                        for (const i of e) i();
                    }
                    ngOnDestroy() {
                        this.handler?.destroy(), (this.handler = null), (this.internalCallbacks.length = 0);
                    }
                    static #e = (this.ɵprov = We({ token: t, providedIn: 'root', factory: () => new t() }));
                }
                return t;
            })();
            function B2(t, n, e) {
                let i = e ? t.styles : null,
                    r = e ? t.classes : null,
                    s = 0;
                if (null !== n)
                    for (let o = 0; o < n.length; o++) {
                        const a = n[o];
                        'number' == typeof a
                            ? (s = a)
                            : 1 == s
                            ? (r = fl(r, a))
                            : 2 == s && (i = fl(i, a + ': ' + n[++o] + ';'));
                    }
                e ? (t.styles = i) : (t.stylesWithoutHost = i), e ? (t.classes = r) : (t.classesWithoutHost = r);
            }
            class m9 extends su {
                constructor(n) {
                    super(), (this.ngModule = n);
                }
                resolveComponentFactory(n) {
                    const e = bn(n);
                    return new yd(e, this.ngModule);
                }
            }
            function p9(t) {
                const n = [];
                for (const e in t) {
                    if (!t.hasOwnProperty(e)) continue;
                    const i = t[e];
                    void 0 !== i && n.push({ propName: Array.isArray(i) ? i[0] : i, templateName: e });
                }
                return n;
            }
            class q2 {
                constructor(n, e) {
                    (this.injector = n), (this.parentInjector = e);
                }
                get(n, e, i) {
                    i = Ys(i);
                    const r = this.injector.get(n, i8, i);
                    return r !== i8 || e === i8 ? r : this.parentInjector.get(n, e, i);
                }
            }
            class yd extends n9 {
                get inputs() {
                    const n = this.componentDef,
                        e = n.inputTransforms,
                        i = p9(n.inputs);
                    if (null !== e) for (const r of i) e.hasOwnProperty(r.propName) && (r.transform = e[r.propName]);
                    return i;
                }
                get outputs() {
                    return p9(this.componentDef.outputs);
                }
                constructor(n, e) {
                    super(),
                        (this.componentDef = n),
                        (this.ngModule = e),
                        (this.componentType = n.type),
                        (this.selector = (function y3(t) {
                            return t.map(_3).join(',');
                        })(n.selectors)),
                        (this.ngContentSelectors = n.ngContentSelectors ? n.ngContentSelectors : []),
                        (this.isBoundToModule = !!e);
                }
                create(n, e, i, r) {
                    const s = _(null);
                    try {
                        let o = (r = r || this.ngModule) instanceof Io ? r : r?.injector;
                        o &&
                            null !== this.componentDef.getStandaloneInjector &&
                            (o = this.componentDef.getStandaloneInjector(o) || o);
                        const a = o ? new q2(n, o) : n,
                            l = a.get(y1, null);
                        if (null === l) throw new Me(407, !1);
                        const c = a.get(AL, null),
                            E = {
                                rendererFactory: l,
                                sanitizer: c,
                                inlineEffectRunner: null,
                                afterRenderEventManager: a.get(gd, null),
                                changeDetectionScheduler: a.get(H2, null),
                            },
                            P = l.createRenderer(null, this.componentDef),
                            V = this.componentDef.selectors[0][0] || 'div',
                            W = i
                                ? (function CA(t, n, e, i) {
                                      const s = i.get($7, !1) || e === we.ShadowDom,
                                          o = t.selectRootElement(n, s);
                                      return (
                                          (function wA(t) {
                                              Ov(t);
                                          })(o),
                                          o
                                      );
                                  })(P, i, this.componentDef.encapsulation, a)
                                : D2(
                                      P,
                                      V,
                                      (function BL(t) {
                                          const n = t.toLowerCase();
                                          return 'svg' === n ? 'svg' : 'math' === n ? 'math' : null;
                                      })(V),
                                  );
                        let ie = 512;
                        this.componentDef.signals ? (ie |= 4096) : this.componentDef.onPush || (ie |= 16);
                        let he = null;
                        null !== W && (he = _6(W, a, !0));
                        const fe = q6(0, null, null, 1, 0, null, null, null, null, null, null),
                            ze = A2(null, fe, null, ie, null, null, E, P, a, null, he);
                        let nt, kt;
                        K3(ze);
                        try {
                            const Tt = this.componentDef;
                            let rn,
                                Nn = null;
                            Tt.findHostDirectiveDefs
                                ? ((rn = []), (Nn = new Map()), Tt.findHostDirectiveDefs(Tt, rn, Nn), rn.push(Tt))
                                : (rn = [Tt]);
                            const vn = (function YL(t, n) {
                                    const e = t[Be],
                                        i = Zt;
                                    return (t[i] = n), g1(e, i, 2, '#host', null);
                                })(ze, W),
                                Si = (function jL(t, n, e, i, r, s, o) {
                                    const a = r[Be];
                                    !(function $L(t, n, e, i) {
                                        for (const r of t) n.mergedAttrs = It(n.mergedAttrs, r.hostAttrs);
                                        null !== n.mergedAttrs && (B2(n, n.mergedAttrs, !0), null !== e && kv(i, e, n));
                                    })(i, t, n, o);
                                    let l = null;
                                    null !== n && (l = _6(n, r[lr]));
                                    const c = s.rendererFactory.createRenderer(n, e);
                                    let f = 16;
                                    e.signals ? (f = 4096) : e.onPush && (f = 64);
                                    const g = A2(r, Lv(e), null, f, r[t.index], t, s, c, null, null, l);
                                    return a.firstCreatePass && j6(a, t, i.length - 1), L2(r, g), (r[t.index] = g);
                                })(vn, W, Tt, rn, ze, E, P);
                            (kt = R0(fe, Zt)),
                                W &&
                                    (function WL(t, n, e, i) {
                                        if (i) it(t, e, ['ng-version', '17.3.11']);
                                        else {
                                            const { attrs: r, classes: s } = (function b3(t) {
                                                const n = [],
                                                    e = [];
                                                let i = 1,
                                                    r = 2;
                                                for (; i < t.length; ) {
                                                    let s = t[i];
                                                    if ('string' == typeof s)
                                                        2 === r ? '' !== s && n.push(s, t[++i]) : 8 === r && e.push(s);
                                                    else {
                                                        if (!gi(r)) break;
                                                        r = s;
                                                    }
                                                    i++;
                                                }
                                                return { attrs: n, classes: e };
                                            })(n.selectors[0]);
                                            r && it(t, e, r), s && s.length > 0 && xv(t, e, s.join(' '));
                                        }
                                    })(P, Tt, W, i),
                                void 0 !== e &&
                                    (function KL(t, n, e) {
                                        const i = (t.projection = []);
                                        for (let r = 0; r < n.length; r++) {
                                            const s = e[r];
                                            i.push(null != s ? Array.from(s) : null);
                                        }
                                    })(kt, this.ngContentSelectors, e),
                                (nt = (function GL(t, n, e, i, r, s) {
                                    const o = _i(),
                                        a = r[Be],
                                        l = Gs(o, r);
                                    Nv(a, r, o, e, null, i);
                                    for (let f = 0; f < e.length; f++) zs(nu(r, a, o.directiveStart + f, o), r);
                                    Fv(a, r, o), l && zs(l, r);
                                    const c = nu(r, a, o.directiveStart + o.componentOffset, o);
                                    if (((t[Di] = r[Di] = c), null !== s)) for (const f of s) f(c, n);
                                    return H6(a, o, r), c;
                                })(Si, Tt, rn, Nn, ze, [QL])),
                                K6(fe, ze, null);
                        } finally {
                            Q3();
                        }
                        return new qL(this.componentType, nt, u1(kt, ze), ze, kt);
                    } finally {
                        _(s);
                    }
                }
            }
            class qL extends xL {
                constructor(n, e, i, r, s) {
                    super(),
                        (this.location = i),
                        (this._rootLView = r),
                        (this._tNode = s),
                        (this.previousInputValues = null),
                        (this.instance = e),
                        (this.hostView = this.changeDetectorRef = new dd(r, void 0, !1)),
                        (this.componentType = n);
                }
                setInput(n, e) {
                    const i = this._tNode.inputs;
                    let r;
                    if (null !== i && (r = i[n])) {
                        if (
                            ((this.previousInputValues ??= new Map()),
                            this.previousInputValues.has(n) && Object.is(this.previousInputValues.get(n), e))
                        )
                            return;
                        const s = this._rootLView;
                        W6(s[Be], s, r, n, e), this.previousInputValues.set(n, e), ud(Oo(this._tNode.index, s));
                    }
                }
                get injector() {
                    return new Kr(this._tNode, this._rootLView);
                }
                destroy() {
                    this.hostView.destroy();
                }
                onDestroy(n) {
                    this.hostView.onDestroy(n);
                }
            }
            function QL() {
                const t = _i();
                e2(Ie()[Be], t);
            }
            let go = (() => {
                class t {
                    static #e = (this.__NG_ELEMENT_ID__ = XL);
                }
                return t;
            })();
            function XL() {
                return _9(_i(), Ie());
            }
            const ZL = go,
                g9 = class extends ZL {
                    constructor(n, e, i) {
                        super(), (this._lContainer = n), (this._hostTNode = e), (this._hostLView = i);
                    }
                    get element() {
                        return u1(this._hostTNode, this._hostLView);
                    }
                    get injector() {
                        return new Kr(this._hostTNode, this._hostLView);
                    }
                    get parentInjector() {
                        const n = o2(this._hostTNode, this._hostLView);
                        if (J3(n)) {
                            const e = Y0(n, this._hostLView),
                                i = q0(n);
                            return new Kr(e[Be].data[i + 8], e);
                        }
                        return new Kr(null, this._hostLView);
                    }
                    clear() {
                        for (; this.length > 0; ) this.remove(this.length - 1);
                    }
                    get(n) {
                        const e = v9(this._lContainer);
                        return (null !== e && e[n]) || null;
                    }
                    get length() {
                        return this._lContainer.length - li;
                    }
                    createEmbeddedView(n, e, i) {
                        let r, s;
                        'number' == typeof i ? (r = i) : null != i && ((r = i.index), (s = i.injector));
                        const o = _1(this._lContainer, n.ssrId),
                            a = n.createEmbeddedViewImpl(e || {}, s, o);
                        return this.insertImpl(a, r, v1(this._hostTNode, o)), a;
                    }
                    createComponent(n, e, i, r, s) {
                        const o =
                            n &&
                            !(function Qc(t) {
                                return 'function' == typeof t;
                            })(n);
                        let a;
                        if (o) a = e;
                        else {
                            const V = e || {};
                            (a = V.index),
                                (i = V.injector),
                                (r = V.projectableNodes),
                                (s = V.environmentInjector || V.ngModuleRef);
                        }
                        const l = o ? n : new yd(bn(n)),
                            c = i || this.parentInjector;
                        if (!s && null == l.ngModule) {
                            const W = (o ? c : this.parentInjector).get(Io, null);
                            W && (s = W);
                        }
                        const f = bn(l.componentType ?? {}),
                            g = _1(this._lContainer, f?.id ?? null),
                            P = l.create(c, r, g?.firstChild ?? null, s);
                        return this.insertImpl(P.hostView, a, v1(this._hostTNode, g)), P;
                    }
                    insert(n, e) {
                        return this.insertImpl(n, e, !0);
                    }
                    insertImpl(n, e, i) {
                        const r = n._lView;
                        if (
                            (function qk(t) {
                                return cs(t[ar]);
                            })(r)
                        ) {
                            const a = this.indexOf(n);
                            if (-1 !== a) this.detach(a);
                            else {
                                const l = r[ar],
                                    c = new g9(l, l[as], l[ar]);
                                c.detach(c.indexOf(n));
                            }
                        }
                        const s = this._adjustIndex(e),
                            o = this._lContainer;
                        return ld(o, r, s, i), n.attachToViewContainerRef(), Yc(c8(o), s, n), n;
                    }
                    move(n, e) {
                        return this.insert(n, e);
                    }
                    indexOf(n) {
                        const e = v9(this._lContainer);
                        return null !== e ? e.indexOf(n) : -1;
                    }
                    remove(n) {
                        const e = this._adjustIndex(n, -1),
                            i = id(this._lContainer, e);
                        i && (ho(c8(this._lContainer), e), x2(i[Be], i));
                    }
                    detach(n) {
                        const e = this._adjustIndex(n, -1),
                            i = id(this._lContainer, e);
                        return i && null != ho(c8(this._lContainer), e) ? new dd(i) : null;
                    }
                    _adjustIndex(n, e = 0) {
                        return n ?? this.length + e;
                    }
                };
            function v9(t) {
                return t[8];
            }
            function c8(t) {
                return t[8] || (t[8] = []);
            }
            function _9(t, n) {
                let e;
                const i = n[t.index];
                return (
                    cs(i) ? (e = i) : ((e = Rv(i, n, null, t)), (n[t.index] = e), L2(n, e)),
                    y9(e, n, t, i),
                    new g9(e, t, n)
                );
            }
            let y9 = function C9(t, n, e, i) {
                    if (t[fo]) return;
                    let r;
                    (r =
                        8 & e.type
                            ? xi(i)
                            : (function JL(t, n) {
                                  const e = t[Nt],
                                      i = e.createComment(''),
                                      r = Gs(n, t);
                                  return (
                                      ru(
                                          e,
                                          k2(e, r),
                                          i,
                                          (function fA(t, n) {
                                              return t.nextSibling(n);
                                          })(e, r),
                                          !1,
                                      ),
                                      i
                                  );
                              })(n, e)),
                        (t[fo] = r);
                },
                u8 = () => !1;
            class d8 {
                constructor(n) {
                    (this.queryList = n), (this.matches = null);
                }
                clone() {
                    return new d8(this.queryList);
                }
                setDirty() {
                    this.queryList.setDirty();
                }
            }
            class h8 {
                constructor(n = []) {
                    this.queries = n;
                }
                createEmbeddedView(n) {
                    const e = n.queries;
                    if (null !== e) {
                        const i = null !== n.contentQueries ? n.contentQueries[0] : e.length,
                            r = [];
                        for (let s = 0; s < i; s++) {
                            const o = e.getByIndex(s);
                            r.push(this.queries[o.indexInDeclarationView].clone());
                        }
                        return new h8(r);
                    }
                    return null;
                }
                insertView(n) {
                    this.dirtyQueriesWithMatches(n);
                }
                detachView(n) {
                    this.dirtyQueriesWithMatches(n);
                }
                finishViewCreation(n) {
                    this.dirtyQueriesWithMatches(n);
                }
                dirtyQueriesWithMatches(n) {
                    for (let e = 0; e < this.queries.length; e++)
                        null !== v8(n, e).matches && this.queries[e].setDirty();
                }
            }
            class w9 {
                constructor(n, e, i = null) {
                    (this.flags = e),
                        (this.read = i),
                        (this.predicate =
                            'string' == typeof n
                                ? (function aO(t) {
                                      return t.split(',').map(n => n.trim());
                                  })(n)
                                : n);
                }
            }
            class f8 {
                constructor(n = []) {
                    this.queries = n;
                }
                elementStart(n, e) {
                    for (let i = 0; i < this.queries.length; i++) this.queries[i].elementStart(n, e);
                }
                elementEnd(n) {
                    for (let e = 0; e < this.queries.length; e++) this.queries[e].elementEnd(n);
                }
                embeddedTView(n) {
                    let e = null;
                    for (let i = 0; i < this.length; i++) {
                        const r = null !== e ? e.length : 0,
                            s = this.getByIndex(i).embeddedTView(n, r);
                        s && ((s.indexInDeclarationView = i), null !== e ? e.push(s) : (e = [s]));
                    }
                    return null !== e ? new f8(e) : null;
                }
                template(n, e) {
                    for (let i = 0; i < this.queries.length; i++) this.queries[i].template(n, e);
                }
                getByIndex(n) {
                    return this.queries[n];
                }
                get length() {
                    return this.queries.length;
                }
                track(n) {
                    this.queries.push(n);
                }
            }
            class m8 {
                constructor(n, e = -1) {
                    (this.metadata = n),
                        (this.matches = null),
                        (this.indexInDeclarationView = -1),
                        (this.crossesNgTemplate = !1),
                        (this._appliesToNextNode = !0),
                        (this._declarationNodeIndex = e);
                }
                elementStart(n, e) {
                    this.isApplyingToNode(e) && this.matchTNode(n, e);
                }
                elementEnd(n) {
                    this._declarationNodeIndex === n.index && (this._appliesToNextNode = !1);
                }
                template(n, e) {
                    this.elementStart(n, e);
                }
                embeddedTView(n, e) {
                    return this.isApplyingToNode(n)
                        ? ((this.crossesNgTemplate = !0), this.addMatch(-n.index, e), new m8(this.metadata))
                        : null;
                }
                isApplyingToNode(n) {
                    if (this._appliesToNextNode && 1 & ~this.metadata.flags) {
                        const e = this._declarationNodeIndex;
                        let i = n.parent;
                        for (; null !== i && 8 & i.type && i.index !== e; ) i = i.parent;
                        return e === (null !== i ? i.index : -1);
                    }
                    return this._appliesToNextNode;
                }
                matchTNode(n, e) {
                    const i = this.metadata.predicate;
                    if (Array.isArray(i))
                        for (let r = 0; r < i.length; r++) {
                            const s = i[r];
                            this.matchTNodeWithReadOption(n, e, iO(e, s)),
                                this.matchTNodeWithReadOption(n, e, a2(e, n, s, !1, !1));
                        }
                    else
                        i === Qr
                            ? 4 & e.type && this.matchTNodeWithReadOption(n, e, -1)
                            : this.matchTNodeWithReadOption(n, e, a2(e, n, i, !1, !1));
                }
                matchTNodeWithReadOption(n, e, i) {
                    if (null !== i) {
                        const r = this.metadata.read;
                        if (null !== r)
                            if (r === Pn || r === go || (r === Qr && 4 & e.type)) this.addMatch(e.index, -2);
                            else {
                                const s = a2(e, n, r, !1, !1);
                                null !== s && this.addMatch(e.index, s);
                            }
                        else this.addMatch(e.index, i);
                    }
                }
                addMatch(n, e) {
                    null === this.matches ? (this.matches = [n, e]) : this.matches.push(n, e);
                }
            }
            function iO(t, n) {
                const e = t.localNames;
                if (null !== e) for (let i = 0; i < e.length; i += 2) if (e[i] === n) return e[i + 1];
                return null;
            }
            function sO(t, n, e, i) {
                return -1 === e
                    ? (function rO(t, n) {
                          return 11 & t.type ? u1(t, n) : 4 & t.type ? P2(t, n) : null;
                      })(n, t)
                    : -2 === e
                    ? (function oO(t, n, e) {
                          return e === Pn ? u1(n, t) : e === Qr ? P2(n, t) : e === go ? _9(n, t) : void 0;
                      })(t, n, i)
                    : nu(t, t[Be], e, n);
            }
            function M9(t, n, e, i) {
                const r = n[ga].queries[i];
                if (null === r.matches) {
                    const s = t.data,
                        o = e.matches,
                        a = [];
                    for (let l = 0; null !== o && l < o.length; l += 2) {
                        const c = o[l];
                        a.push(c < 0 ? null : sO(n, s[c], o[l + 1], e.metadata.read));
                    }
                    r.matches = a;
                }
                return r.matches;
            }
            function p8(t, n, e, i) {
                const r = t.queries.getByIndex(e),
                    s = r.matches;
                if (null !== s) {
                    const o = M9(t, n, r, e);
                    for (let a = 0; a < s.length; a += 2) {
                        const l = s[a];
                        if (l > 0) i.push(o[a / 2]);
                        else {
                            const c = s[a + 1],
                                f = n[-l];
                            for (let g = li; g < f.length; g++) {
                                const E = f[g];
                                E[Xc] === E[ar] && p8(E[Be], E, c, i);
                            }
                            if (null !== f[sc]) {
                                const g = f[sc];
                                for (let E = 0; E < g.length; E++) {
                                    const P = g[E];
                                    p8(P[Be], P, c, i);
                                }
                            }
                        }
                    }
                }
                return i;
            }
            function S9(t, n, e) {
                const i = new j0(!(4 & ~e));
                return (
                    (function TA(t, n, e, i) {
                        const r = Hv(n);
                        r.push(e), t.firstCreatePass && Uv(t).push(i, r.length - 1);
                    })(t, n, i, i.destroy),
                    (n[ga] ??= new h8()).queries.push(new d8(i)) - 1
                );
            }
            function x9(t, n, e) {
                null === t.queries && (t.queries = new f8()), t.queries.track(new m8(n, e));
            }
            function v8(t, n) {
                return t.queries.getByIndex(n);
            }
            function k9(t, n) {
                const e = t[Be],
                    i = v8(e, n);
                return i.crossesNgTemplate ? p8(e, t, n, []) : M9(e, t, i, n);
            }
            function I9(t) {
                return (
                    (function Y2(t) {
                        return 'function' == typeof t && void 0 !== t[p];
                    })(t) && 'function' == typeof t.set
                );
            }
            function Cn(t) {
                let n = (function U9(t) {
                        return Object.getPrototypeOf(t.prototype).constructor;
                    })(t.type),
                    e = !0;
                const i = [t];
                for (; n; ) {
                    let r;
                    if (Lo(t)) r = n.ɵcmp || n.ɵdir;
                    else {
                        if (n.ɵcmp) throw new Me(903, !1);
                        r = n.ɵdir;
                    }
                    if (r) {
                        if (e) {
                            i.push(r);
                            const o = t;
                            (o.inputs = $2(t.inputs)),
                                (o.inputTransforms = $2(t.inputTransforms)),
                                (o.declaredInputs = $2(t.declaredInputs)),
                                (o.outputs = $2(t.outputs));
                            const a = r.hostBindings;
                            a && MO(t, a);
                            const l = r.viewQuery,
                                c = r.contentQueries;
                            if (
                                (l && CO(t, l),
                                c && wO(t, c),
                                yO(t, r),
                                f0(t.outputs, r.outputs),
                                Lo(r) && r.data.animation)
                            ) {
                                const f = t.data;
                                f.animation = (f.animation || []).concat(r.data.animation);
                            }
                        }
                        const s = r.features;
                        if (s)
                            for (let o = 0; o < s.length; o++) {
                                const a = s[o];
                                a && a.ngInherit && a(t), a === Cn && (e = !1);
                            }
                    }
                    n = Object.getPrototypeOf(n);
                }
                !(function bO(t) {
                    let n = 0,
                        e = null;
                    for (let i = t.length - 1; i >= 0; i--) {
                        const r = t[i];
                        (r.hostVars = n += r.hostVars), (r.hostAttrs = It(r.hostAttrs, (e = It(e, r.hostAttrs))));
                    }
                })(i);
            }
            function yO(t, n) {
                for (const e in n.inputs) {
                    if (!n.inputs.hasOwnProperty(e) || t.inputs.hasOwnProperty(e)) continue;
                    const i = n.inputs[e];
                    if (
                        void 0 !== i &&
                        ((t.inputs[e] = i), (t.declaredInputs[e] = n.declaredInputs[e]), null !== n.inputTransforms)
                    ) {
                        const r = Array.isArray(i) ? i[0] : i;
                        if (!n.inputTransforms.hasOwnProperty(r)) continue;
                        (t.inputTransforms ??= {}), (t.inputTransforms[r] = n.inputTransforms[r]);
                    }
                }
            }
            function $2(t) {
                return t === Ls ? {} : t === An ? [] : t;
            }
            function CO(t, n) {
                const e = t.viewQuery;
                t.viewQuery = e
                    ? (i, r) => {
                          n(i, r), e(i, r);
                      }
                    : n;
            }
            function wO(t, n) {
                const e = t.contentQueries;
                t.contentQueries = e
                    ? (i, r, s) => {
                          n(i, r, s), e(i, r, s);
                      }
                    : n;
            }
            function MO(t, n) {
                const e = t.hostBindings;
                t.hostBindings = e
                    ? (i, r) => {
                          n(i, r), e(i, r);
                      }
                    : n;
            }
            function G2(t) {
                const n = t.inputConfig,
                    e = {};
                for (const i in n)
                    if (n.hasOwnProperty(i)) {
                        const r = n[i];
                        Array.isArray(r) && r[3] && (e[i] = r[3]);
                    }
                t.inputTransforms = e;
            }
            class lu {}
            class EO {}
            class y8 extends lu {
                constructor(n, e, i) {
                    super(),
                        (this._parent = e),
                        (this._bootstrapComponents = []),
                        (this.destroyCbs = []),
                        (this.componentFactoryResolver = new m9(this));
                    const r = (function os(t, n) {
                        const e = t[Ra] || null;
                        if (!e && !0 === n) throw new Error(`Type ${tr(t)} does not have '\u0275mod' property.`);
                        return e;
                    })(n);
                    (this._bootstrapComponents = (function Fo(t) {
                        return t instanceof Function ? t() : t;
                    })(r.bootstrap)),
                        (this._r3Injector = g7(
                            n,
                            e,
                            [
                                { provide: lu, useValue: this },
                                { provide: su, useValue: this.componentFactoryResolver },
                                ...i,
                            ],
                            tr(n),
                            new Set(['environment']),
                        )),
                        this._r3Injector.resolveInjectorInitializers(),
                        (this.instance = this._r3Injector.get(n));
                }
                get injector() {
                    return this._r3Injector;
                }
                destroy() {
                    const n = this._r3Injector;
                    !n.destroyed && n.destroy(), this.destroyCbs.forEach(e => e()), (this.destroyCbs = null);
                }
                onDestroy(n) {
                    this.destroyCbs.push(n);
                }
            }
            class b8 extends EO {
                constructor(n) {
                    super(), (this.moduleType = n);
                }
                create(n) {
                    return new y8(this.moduleType, n, []);
                }
            }
            class j9 extends lu {
                constructor(n) {
                    super(), (this.componentFactoryResolver = new m9(this)), (this.instance = null);
                    const e = new Xl(
                        [
                            ...n.providers,
                            { provide: lu, useValue: this },
                            { provide: su, useValue: this.componentFactoryResolver },
                        ],
                        n.parent || Qu(),
                        n.debugName,
                        new Set(['environment']),
                    );
                    (this.injector = e), n.runEnvironmentInitializers && e.resolveInjectorInitializers();
                }
                destroy() {
                    this.injector.destroy();
                }
                onDestroy(n) {
                    this.injector.onDestroy(n);
                }
            }
            let cu = (() => {
                class t {
                    constructor() {
                        (this.taskId = 0), (this.pendingTasks = new Set()), (this.hasPendingTasks = new Ke(!1));
                    }
                    get _hasPendingTasks() {
                        return this.hasPendingTasks.value;
                    }
                    add() {
                        this._hasPendingTasks || this.hasPendingTasks.next(!0);
                        const e = this.taskId++;
                        return this.pendingTasks.add(e), e;
                    }
                    remove(e) {
                        this.pendingTasks.delete(e),
                            0 === this.pendingTasks.size && this._hasPendingTasks && this.hasPendingTasks.next(!1);
                    }
                    ngOnDestroy() {
                        this.pendingTasks.clear(), this._hasPendingTasks && this.hasPendingTasks.next(!1);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            function K2(t) {
                return !!C8(t) && (Array.isArray(t) || (!(t instanceof Map) && Symbol.iterator in t));
            }
            function C8(t) {
                return null !== t && ('function' == typeof t || 'object' == typeof t);
            }
            function nl(t, n, e) {
                return (t[n] = e);
            }
            function Mr(t, n, e) {
                return !Object.is(t[n], e) && ((t[n] = e), !0);
            }
            function uu(t, n, e, i) {
                const r = Mr(t, n, e);
                return Mr(t, n + 1, i) || r;
            }
            function ue(t, n, e, i, r, s, o, a) {
                const l = Ie(),
                    c = Ln(),
                    f = t + Zt,
                    g = c.firstCreatePass
                        ? (function FO(t, n, e, i, r, s, o, a, l) {
                              const c = n.consts,
                                  f = g1(n, t, 4, o || null, Ga(c, a));
                              Y6(n, e, f, Ga(c, l)), e2(n, f);
                              const g = (f.tView = q6(
                                  2,
                                  f,
                                  i,
                                  r,
                                  s,
                                  n.directiveRegistry,
                                  n.pipeRegistry,
                                  null,
                                  n.schemas,
                                  c,
                                  null,
                              ));
                              return (
                                  null !== n.queries &&
                                      (n.queries.template(n, f), (g.queries = n.queries.embeddedTView(f))),
                                  f
                              );
                          })(f, c, l, n, e, i, r, s, o)
                        : c.data[f];
                Wa(g, !1);
                const E = G9(c, l, g, t);
                U0() && E2(c, l, E, g), zs(E, l);
                const P = Rv(E, l, E, g);
                return (
                    (l[f] = P),
                    L2(l, P),
                    (function b9(t, n, e) {
                        return u8(t, n, e);
                    })(P, g, l),
                    n1(g) && U6(c, l, g),
                    null != o && B6(l, g, a),
                    ue
                );
            }
            let G9 = function W9(t, n, e, i) {
                return Ka(!0), n[Nt].createComment('');
            };
            function zi(t, n, e, i) {
                const r = Ie();
                return Mr(r, ya(), n) && (Ln(), el(Bi(), r, t, n, e, i)), zi;
            }
            function k1(t, n, e, i) {
                return Mr(t, ya(), e) ? n + h(e) + i : un;
            }
            function E1(t, n, e, i, r, s) {
                const a = uu(t, Ml(), e, r);
                return Sl(2), a ? n + h(e) + i + h(r) + s : un;
            }
            function I1(t, n, e, i, r, s, o, a) {
                const c = (function Q2(t, n, e, i, r) {
                    const s = uu(t, n, e, i);
                    return Mr(t, n + 2, r) || s;
                })(t, Ml(), e, r, o);
                return Sl(3), c ? n + h(e) + i + h(r) + s + h(o) + a : un;
            }
            function A1(t, n, e, i, r, s, o, a, l, c) {
                const g = (function ia(t, n, e, i, r, s) {
                    const o = uu(t, n, e, i);
                    return uu(t, n + 2, r, s) || o;
                })(t, Ml(), e, r, o, l);
                return Sl(4), g ? n + h(e) + i + h(r) + s + h(o) + a + h(l) + c : un;
            }
            function Bt(t, n, e, i, r, s) {
                const o = Ie(),
                    a = k1(o, n, e, i);
                return a !== un && el(Bi(), o, t, a, r, s), Bt;
            }
            function Dd(t, n, e, i, r, s, o, a) {
                const l = Ie(),
                    c = E1(l, n, e, i, r, s);
                return c !== un && el(Bi(), l, t, c, o, a), Dd;
            }
            function n4(t, n) {
                return (t << 17) | (n << 2);
            }
            function dc(t) {
                return (t >> 17) & 32767;
            }
            function A8(t) {
                return 2 | t;
            }
            function hu(t) {
                return (131068 & t) >> 2;
            }
            function L8(t, n) {
                return (-131069 & t) | (n << 2);
            }
            function O8(t) {
                return 1 | t;
            }
            function M_(t, n, e, i) {
                const r = t[e + 1],
                    s = null === n;
                let o = i ? dc(r) : hu(r),
                    a = !1;
                for (; 0 !== o && (!1 === a || s); ) {
                    const c = t[o + 1];
                    Mz(t[o], n) && ((a = !0), (t[o + 1] = i ? O8(c) : A8(c))), (o = i ? dc(c) : hu(c));
                }
                a && (t[e + 1] = i ? A8(r) : O8(r));
            }
            function Mz(t, n) {
                return (
                    null === t ||
                    null == n ||
                    (Array.isArray(t) ? t[1] : t) === n ||
                    (!(!Array.isArray(t) || 'string' != typeof n) && ta(t, n) >= 0)
                );
            }
            const Xr = { textEnd: 0, key: 0, keyEnd: 0, value: 0, valueEnd: 0 };
            function S_(t) {
                return t.substring(Xr.key, Xr.keyEnd);
            }
            function Sz(t) {
                return t.substring(Xr.value, Xr.valueEnd);
            }
            function T_(t, n) {
                const e = Xr.textEnd;
                return e === n
                    ? -1
                    : ((n = Xr.keyEnd =
                          (function xz(t, n, e) {
                              for (; n < e && t.charCodeAt(n) > 32; ) n++;
                              return n;
                          })(t, (Xr.key = n), e)),
                      N1(t, n, e));
            }
            function D_(t, n) {
                const e = Xr.textEnd;
                let i = (Xr.key = N1(t, n, e));
                return e === i
                    ? -1
                    : ((i = Xr.keyEnd =
                          (function kz(t, n, e) {
                              let i;
                              for (
                                  ;
                                  n < e &&
                                  (45 === (i = t.charCodeAt(n)) ||
                                      95 === i ||
                                      ((-33 & i) >= 65 && (-33 & i) <= 90) ||
                                      (i >= 48 && i <= 57));

                              )
                                  n++;
                              return n;
                          })(t, i, e)),
                      (i = k_(t, i, e)),
                      (i = Xr.value = N1(t, i, e)),
                      (i = Xr.valueEnd =
                          (function Ez(t, n, e) {
                              let i = -1,
                                  r = -1,
                                  s = -1,
                                  o = n,
                                  a = o;
                              for (; o < e; ) {
                                  const l = t.charCodeAt(o++);
                                  if (59 === l) return a;
                                  34 === l || 39 === l
                                      ? (a = o = E_(t, l, o, e))
                                      : n === o - 4 && 85 === s && 82 === r && 76 === i && 40 === l
                                      ? (a = o = E_(t, 41, o, e))
                                      : l > 32 && (a = o),
                                      (s = r),
                                      (r = i),
                                      (i = -33 & l);
                              }
                              return a;
                          })(t, i, e)),
                      k_(t, i, e));
            }
            function x_(t) {
                (Xr.key = 0), (Xr.keyEnd = 0), (Xr.value = 0), (Xr.valueEnd = 0), (Xr.textEnd = t.length);
            }
            function N1(t, n, e) {
                for (; n < e && t.charCodeAt(n) <= 32; ) n++;
                return n;
            }
            function k_(t, n, e, i) {
                return (n = N1(t, n, e)) < e && n++, n;
            }
            function E_(t, n, e, i) {
                let r = -1,
                    s = e;
                for (; s < i; ) {
                    const o = t.charCodeAt(s++);
                    if (o == n && 92 !== r) return s;
                    r = 92 == o && 92 === r ? 0 : o;
                }
                throw new Error();
            }
            function H(t, n, e) {
                const i = Ie();
                return Mr(i, ya(), n) && po(Ln(), Bi(), i, t, n, i[Nt], e, !1), H;
            }
            function z8(t, n, e, i, r) {
                const o = r ? 'class' : 'style';
                W6(t, e, n.inputs[o], o, i);
            }
            function Zr(t, n, e) {
                return Ca(t, n, e, !1), Zr;
            }
            function On(t, n) {
                return Ca(t, n, null, !0), On;
            }
            function Ks(t) {
                wa(L_, Iz, t, !1);
            }
            function Iz(t, n) {
                for (
                    let e = (function Dz(t) {
                        return x_(t), D_(t, N1(t, 0, Xr.textEnd));
                    })(n);
                    e >= 0;
                    e = D_(n, e)
                )
                    L_(t, S_(n), Sz(n));
            }
            function vo(t) {
                wa(Nz, il, t, !0);
            }
            function il(t, n) {
                for (
                    let e = (function Tz(t) {
                        return x_(t), T_(t, N1(t, 0, Xr.textEnd));
                    })(n);
                    e >= 0;
                    e = T_(n, e)
                )
                    br(t, S_(n), !0);
            }
            function Ca(t, n, e, i) {
                const r = Ie(),
                    s = Ln(),
                    o = Sl(2);
                s.firstUpdatePass && A_(s, t, o, i),
                    n !== un &&
                        Mr(r, o, n) &&
                        O_(
                            s,
                            s.data[Os()],
                            r,
                            r[Nt],
                            t,
                            (r[o + 1] = (function Rz(t, n) {
                                return (
                                    null == t ||
                                        '' === t ||
                                        ('string' == typeof n ? (t += n) : 'object' == typeof t && (t = tr(zo(t)))),
                                    t
                                );
                            })(n, e)),
                            i,
                            o,
                        );
            }
            function wa(t, n, e, i) {
                const r = Ln(),
                    s = Sl(2);
                r.firstUpdatePass && A_(r, null, s, i);
                const o = Ie();
                if (e !== un && Mr(o, s, e)) {
                    const a = r.data[Os()];
                    if (P_(a, i) && !I_(r, s)) {
                        let l = i ? a.classesWithoutHost : a.stylesWithoutHost;
                        null !== l && (e = fl(l, e || '')), z8(r, a, o, e, i);
                    } else
                        !(function Fz(t, n, e, i, r, s, o, a) {
                            r === un && (r = An);
                            let l = 0,
                                c = 0,
                                f = 0 < r.length ? r[0] : null,
                                g = 0 < s.length ? s[0] : null;
                            for (; null !== f || null !== g; ) {
                                const E = l < r.length ? r[l + 1] : void 0,
                                    P = c < s.length ? s[c + 1] : void 0;
                                let W,
                                    V = null;
                                f === g
                                    ? ((l += 2), (c += 2), E !== P && ((V = g), (W = P)))
                                    : null === g || (null !== f && f < g)
                                    ? ((l += 2), (V = f))
                                    : ((c += 2), (V = g), (W = P)),
                                    null !== V && O_(t, n, e, i, V, W, o, a),
                                    (f = l < r.length ? r[l] : null),
                                    (g = c < s.length ? s[c] : null);
                            }
                        })(
                            r,
                            a,
                            o,
                            o[Nt],
                            o[s + 1],
                            (o[s + 1] = (function Pz(t, n, e) {
                                if (null == e || '' === e) return An;
                                const i = [],
                                    r = zo(e);
                                if (Array.isArray(r)) for (let s = 0; s < r.length; s++) t(i, r[s], !0);
                                else if ('object' == typeof r) for (const s in r) r.hasOwnProperty(s) && t(i, s, r[s]);
                                else 'string' == typeof r && n(i, r);
                                return i;
                            })(t, n, e)),
                            i,
                            s,
                        );
                }
            }
            function I_(t, n) {
                return n >= t.expandoStartIndex;
            }
            function A_(t, n, e, i) {
                const r = t.data;
                if (null === r[e + 1]) {
                    const s = r[Os()],
                        o = I_(t, e);
                    P_(s, i) && null === n && !o && (n = !1),
                        (n = (function Az(t, n, e, i) {
                            const r = (function G3(t) {
                                const n = Jt.lFrame.currentDirectiveIndex;
                                return -1 === n ? null : t[n];
                            })(t);
                            let s = i ? n.residualClasses : n.residualStyles;
                            if (null === r)
                                0 === (i ? n.classBindings : n.styleBindings) &&
                                    ((e = xd((e = P8(null, t, n, e, i)), n.attrs, i)), (s = null));
                            else {
                                const o = n.directiveStylingLast;
                                if (-1 === o || t[o] !== r)
                                    if (((e = P8(r, t, n, e, i)), null === s)) {
                                        let l = (function Lz(t, n, e) {
                                            const i = e ? n.classBindings : n.styleBindings;
                                            if (0 !== hu(i)) return t[dc(i)];
                                        })(t, n, i);
                                        void 0 !== l &&
                                            Array.isArray(l) &&
                                            ((l = P8(null, t, n, l[1], i)),
                                            (l = xd(l, n.attrs, i)),
                                            (function Oz(t, n, e, i) {
                                                t[dc(e ? n.classBindings : n.styleBindings)] = i;
                                            })(t, n, i, l));
                                    } else
                                        s = (function zz(t, n, e) {
                                            let i;
                                            const r = n.directiveEnd;
                                            for (let s = 1 + n.directiveStylingLast; s < r; s++)
                                                i = xd(i, t[s].hostAttrs, e);
                                            return xd(i, n.attrs, e);
                                        })(t, n, i);
                            }
                            return void 0 !== s && (i ? (n.residualClasses = s) : (n.residualStyles = s)), e;
                        })(r, s, n, i)),
                        (function Cz(t, n, e, i, r, s) {
                            let o = s ? n.classBindings : n.styleBindings,
                                a = dc(o),
                                l = hu(o);
                            t[i] = e;
                            let f,
                                c = !1;
                            if (
                                (Array.isArray(e) ? ((f = e[1]), (null === f || ta(e, f) > 0) && (c = !0)) : (f = e), r)
                            )
                                if (0 !== l) {
                                    const E = dc(t[a + 1]);
                                    (t[i + 1] = n4(E, a)),
                                        0 !== E && (t[E + 1] = L8(t[E + 1], i)),
                                        (t[a + 1] = (function yz(t, n) {
                                            return (131071 & t) | (n << 17);
                                        })(t[a + 1], i));
                                } else (t[i + 1] = n4(a, 0)), 0 !== a && (t[a + 1] = L8(t[a + 1], i)), (a = i);
                            else (t[i + 1] = n4(l, 0)), 0 === a ? (a = i) : (t[l + 1] = L8(t[l + 1], i)), (l = i);
                            c && (t[i + 1] = A8(t[i + 1])),
                                M_(t, f, i, !0),
                                M_(t, f, i, !1),
                                (function wz(t, n, e, i, r) {
                                    const s = r ? t.residualClasses : t.residualStyles;
                                    null != s && 'string' == typeof n && ta(s, n) >= 0 && (e[i + 1] = O8(e[i + 1]));
                                })(n, f, t, i, s),
                                (o = n4(a, l)),
                                s ? (n.classBindings = o) : (n.styleBindings = o);
                        })(r, s, n, e, o, i);
                }
            }
            function P8(t, n, e, i, r) {
                let s = null;
                const o = e.directiveEnd;
                let a = e.directiveStylingLast;
                for (
                    -1 === a ? (a = e.directiveStart) : a++;
                    a < o && ((s = n[a]), (i = xd(i, s.hostAttrs, r)), s !== t);

                )
                    a++;
                return null !== t && (e.directiveStylingLast = a), i;
            }
            function xd(t, n, e) {
                const i = e ? 1 : 2;
                let r = -1;
                if (null !== n)
                    for (let s = 0; s < n.length; s++) {
                        const o = n[s];
                        'number' == typeof o
                            ? (r = o)
                            : r === i &&
                              (Array.isArray(t) || (t = void 0 === t ? [] : ['', t]), br(t, o, !!e || n[++s]));
                    }
                return void 0 === t ? null : t;
            }
            function L_(t, n, e) {
                br(t, n, zo(e));
            }
            function Nz(t, n, e) {
                const i = String(n);
                '' !== i && !i.includes(' ') && br(t, i, e);
            }
            function O_(t, n, e, i, r, s, o, a) {
                if (!(3 & n.type)) return;
                const l = t.data,
                    c = l[a + 1],
                    f = (function bz(t) {
                        return !(1 & ~t);
                    })(c)
                        ? z_(l, n, e, r, hu(c), o)
                        : void 0;
                r4(f) ||
                    (r4(s) ||
                        ((function _z(t) {
                            return !(2 & ~t);
                        })(c) &&
                            (s = z_(l, null, e, r, a, o))),
                    (function gA(t, n, e, i, r) {
                        if (n) r ? t.addClass(e, i) : t.removeClass(e, i);
                        else {
                            let s = -1 === i.indexOf('-') ? void 0 : lc.DashCase;
                            null == r
                                ? t.removeStyle(e, i, s)
                                : ('string' == typeof r &&
                                      r.endsWith('!important') &&
                                      ((r = r.slice(0, -10)), (s |= lc.Important)),
                                  t.setStyle(e, i, r, s));
                        }
                    })(i, o, F0(Os(), e), r, s));
            }
            function z_(t, n, e, i, r, s) {
                const o = null === n;
                let a;
                for (; r > 0; ) {
                    const l = t[r],
                        c = Array.isArray(l),
                        f = c ? l[1] : l,
                        g = null === f;
                    let E = e[r + 1];
                    E === un && (E = g ? An : void 0);
                    let P = g ? vl(E, i) : f === i ? E : void 0;
                    if ((c && !r4(P) && (P = vl(l, i)), r4(P) && ((a = P), o))) return a;
                    const V = t[r + 1];
                    r = o ? dc(V) : hu(V);
                }
                if (null !== n) {
                    let l = s ? n.residualClasses : n.residualStyles;
                    null != l && (a = vl(l, i));
                }
                return a;
            }
            function r4(t) {
                return void 0 !== t;
            }
            function P_(t, n) {
                return !!(t.flags & (n ? 8 : 16));
            }
            function dt(t, n, e) {
                wa(br, il, k1(Ie(), t, n, e), !0);
            }
            function F1(t, n, e, i, r) {
                wa(br, il, E1(Ie(), t, n, e, i, r), !0);
            }
            class jz {
                destroy(n) {}
                updateValue(n, e) {}
                swap(n, e) {
                    const i = Math.min(n, e),
                        r = Math.max(n, e),
                        s = this.detach(r);
                    if (r - i > 1) {
                        const o = this.detach(i);
                        this.attach(i, s), this.attach(r, o);
                    } else this.attach(i, s);
                }
                move(n, e) {
                    this.attach(e, this.detach(n));
                }
            }
            function N8(t, n, e, i, r) {
                return t === e && Object.is(n, i) ? 1 : Object.is(r(t, n), r(e, i)) ? -1 : 0;
            }
            function F8(t, n, e, i) {
                return !(void 0 === n || !n.has(i) || (t.attach(e, n.get(i)), n.delete(i), 0));
            }
            function R_(t, n, e, i, r) {
                if (F8(t, n, i, e(i, r))) t.updateValue(i, r);
                else {
                    const s = t.create(i, r);
                    t.attach(i, s);
                }
            }
            function V_(t, n, e, i) {
                const r = new Set();
                for (let s = n; s <= e; s++) r.add(i(s, t.at(s)));
                return r;
            }
            class H_ {
                constructor() {
                    (this.kvMap = new Map()), (this._vMap = void 0);
                }
                has(n) {
                    return this.kvMap.has(n);
                }
                delete(n) {
                    if (!this.has(n)) return !1;
                    const e = this.kvMap.get(n);
                    return (
                        void 0 !== this._vMap && this._vMap.has(e)
                            ? (this.kvMap.set(n, this._vMap.get(e)), this._vMap.delete(e))
                            : this.kvMap.delete(n),
                        !0
                    );
                }
                get(n) {
                    return this.kvMap.get(n);
                }
                set(n, e) {
                    if (this.kvMap.has(n)) {
                        let i = this.kvMap.get(n);
                        void 0 === this._vMap && (this._vMap = new Map());
                        const r = this._vMap;
                        for (; r.has(i); ) i = r.get(i);
                        r.set(i, e);
                    } else this.kvMap.set(n, e);
                }
                forEach(n) {
                    for (let [e, i] of this.kvMap)
                        if ((n(i, e), void 0 !== this._vMap)) {
                            const r = this._vMap;
                            for (; r.has(i); ) (i = r.get(i)), n(i, e);
                        }
                }
            }
            function dn(t, n, e) {
                tl('NgControlFlow');
                const i = Ie(),
                    r = ya(),
                    s = R8(i, Zt + t);
                if (Mr(i, r, n)) {
                    const a = _(null);
                    try {
                        if ((Q6(s, 0), -1 !== n)) {
                            const l = V8(i[Be], Zt + n),
                                c = _1(s, l.tView.ssrId);
                            ld(s, ad(i, l, e, { dehydratedView: c }), 0, v1(l, c));
                        }
                    } finally {
                        _(a);
                    }
                } else {
                    const a = qv(s, 0);
                    void 0 !== a && (a[Di] = e);
                }
            }
            class Gz {
                constructor(n, e, i) {
                    (this.lContainer = n), (this.$implicit = e), (this.$index = i);
                }
                get $count() {
                    return this.lContainer.length - li;
                }
            }
            function rl(t, n) {
                return n;
            }
            class Kz {
                constructor(n, e, i) {
                    (this.hasEmptyBlock = n), (this.trackByFn = e), (this.liveCollection = i);
                }
            }
            function Jr(t, n, e, i, r, s, o, a, l, c, f, g, E) {
                tl('NgControlFlow');
                const P = void 0 !== l,
                    V = Ie(),
                    W = a ? o.bind(V[Ki][Di]) : o,
                    ie = new Kz(P, W);
                (V[Zt + t] = ie), ue(t + 1, n, e, i, r, s), P && ue(t + 2, l, c, f, g, E);
            }
            class Qz extends jz {
                constructor(n, e, i) {
                    super(),
                        (this.lContainer = n),
                        (this.hostLView = e),
                        (this.templateTNode = i),
                        (this.needsIndexUpdate = !1);
                }
                get length() {
                    return this.lContainer.length - li;
                }
                at(n) {
                    return this.getLView(n)[Di].$implicit;
                }
                attach(n, e) {
                    const i = e[Fe];
                    (this.needsIndexUpdate ||= n !== this.length), ld(this.lContainer, e, n, v1(this.templateTNode, i));
                }
                detach(n) {
                    return (
                        (this.needsIndexUpdate ||= n !== this.length - 1),
                        (function Xz(t, n) {
                            return id(t, n);
                        })(this.lContainer, n)
                    );
                }
                create(n, e) {
                    const i = _1(this.lContainer, this.templateTNode.tView.ssrId);
                    return ad(this.hostLView, this.templateTNode, new Gz(this.lContainer, e, n), { dehydratedView: i });
                }
                destroy(n) {
                    x2(n[Be], n);
                }
                updateValue(n, e) {
                    this.getLView(n)[Di].$implicit = e;
                }
                reset() {
                    this.needsIndexUpdate = !1;
                }
                updateIndexes() {
                    if (this.needsIndexUpdate) for (let n = 0; n < this.length; n++) this.getLView(n)[Di].$index = n;
                }
                getLView(n) {
                    return (function Zz(t, n) {
                        return qv(t, n);
                    })(this.lContainer, n);
                }
            }
            function es(t) {
                const n = _(null),
                    e = Os();
                try {
                    const i = Ie(),
                        r = i[Be],
                        s = i[e];
                    if (void 0 === s.liveCollection) {
                        const a = e + 1,
                            l = R8(i, a),
                            c = V8(r, a);
                        s.liveCollection = new Qz(l, i, c);
                    } else s.liveCollection.reset();
                    const o = s.liveCollection;
                    if (
                        ((function $z(t, n, e) {
                            let i,
                                r,
                                s = 0,
                                o = t.length - 1;
                            if (Array.isArray(n)) {
                                let a = n.length - 1;
                                for (; s <= o && s <= a; ) {
                                    const l = t.at(s),
                                        c = n[s],
                                        f = N8(s, l, s, c, e);
                                    if (0 !== f) {
                                        f < 0 && t.updateValue(s, c), s++;
                                        continue;
                                    }
                                    const g = t.at(o),
                                        E = n[a],
                                        P = N8(o, g, a, E, e);
                                    if (0 !== P) {
                                        P < 0 && t.updateValue(o, E), o--, a--;
                                        continue;
                                    }
                                    const V = e(s, l),
                                        W = e(o, g),
                                        ie = e(s, c);
                                    if (Object.is(ie, W)) {
                                        const he = e(a, E);
                                        Object.is(he, V) ? (t.swap(s, o), t.updateValue(o, E), a--, o--) : t.move(o, s),
                                            t.updateValue(s, c),
                                            s++;
                                    } else if (((i ??= new H_()), (r ??= V_(t, s, o, e)), F8(t, i, s, ie)))
                                        t.updateValue(s, c), s++, o++;
                                    else if (r.has(ie)) i.set(V, t.detach(s)), o--;
                                    else {
                                        const he = t.create(s, n[s]);
                                        t.attach(s, he), s++, o++;
                                    }
                                }
                                for (; s <= a; ) R_(t, i, e, s, n[s]), s++;
                            } else if (null != n) {
                                const a = n[Symbol.iterator]();
                                let l = a.next();
                                for (; !l.done && s <= o; ) {
                                    const c = t.at(s),
                                        f = l.value,
                                        g = N8(s, c, s, f, e);
                                    if (0 !== g) g < 0 && t.updateValue(s, f), s++, (l = a.next());
                                    else {
                                        (i ??= new H_()), (r ??= V_(t, s, o, e));
                                        const E = e(s, f);
                                        if (F8(t, i, s, E)) t.updateValue(s, f), s++, o++, (l = a.next());
                                        else if (r.has(E)) {
                                            const P = e(s, c);
                                            i.set(P, t.detach(s)), o--;
                                        } else t.attach(s, t.create(s, f)), s++, o++, (l = a.next());
                                    }
                                }
                                for (; !l.done; ) R_(t, i, e, t.length, l.value), (l = a.next());
                            }
                            for (; s <= o; ) t.destroy(t.detach(o--));
                            i?.forEach(a => {
                                t.destroy(a);
                            });
                        })(o, t, s.trackByFn),
                        o.updateIndexes(),
                        s.hasEmptyBlock)
                    ) {
                        const a = ya(),
                            l = 0 === o.length;
                        if (Mr(i, a, l)) {
                            const c = e + 2,
                                f = R8(i, c);
                            if (l) {
                                const g = V8(r, c),
                                    E = _1(f, g.tView.ssrId);
                                ld(f, ad(i, g, void 0, { dehydratedView: E }), 0, v1(g, E));
                            } else Q6(f, 0);
                        }
                    }
                } finally {
                    _(n);
                }
            }
            function R8(t, n) {
                return t[n];
            }
            function V8(t, n) {
                return R0(t, n);
            }
            function Z(t, n, e, i) {
                const r = Ie(),
                    s = Ln(),
                    o = Zt + t,
                    a = r[Nt],
                    l = s.firstCreatePass
                        ? (function Jz(t, n, e, i, r, s) {
                              const o = n.consts,
                                  l = g1(n, t, 2, i, Ga(o, r));
                              return (
                                  Y6(n, e, l, Ga(o, s)),
                                  null !== l.attrs && B2(l, l.attrs, !1),
                                  null !== l.mergedAttrs && B2(l, l.mergedAttrs, !0),
                                  null !== n.queries && n.queries.elementStart(n, l),
                                  l
                              );
                          })(o, s, r, n, e, i)
                        : s.data[o],
                    c = U_(s, r, l, a, n, t);
                r[o] = c;
                const f = n1(l);
                return (
                    Wa(l, !0),
                    kv(a, c, l),
                    !(function wd(t) {
                        return !(32 & ~t.flags);
                    })(l) &&
                        U0() &&
                        E2(s, r, c, l),
                    0 ===
                        (function jk() {
                            return Jt.lFrame.elementDepthCount;
                        })() && zs(c, r),
                    (function $k() {
                        Jt.lFrame.elementDepthCount++;
                    })(),
                    f && (U6(s, r, l), H6(s, l, r)),
                    null !== i && B6(r, l),
                    Z
                );
            }
            function ee() {
                let t = _i();
                Y3() ? j3() : ((t = t.parent), Wa(t, !1));
                const n = t;
                (function Wk(t) {
                    return Jt.skipHydrationRootTNode === t;
                })(n) &&
                    (function Zk() {
                        Jt.skipHydrationRootTNode = null;
                    })(),
                    (function Gk() {
                        Jt.lFrame.elementDepthCount--;
                    })();
                const e = Ln();
                return (
                    e.firstCreatePass && (e2(e, t), L0(t) && e.queries.elementEnd(t)),
                    null != n.classesWithoutHost &&
                        (function fE(t) {
                            return !!(8 & t.flags);
                        })(n) &&
                        z8(e, n, Ie(), n.classesWithoutHost, !0),
                    null != n.stylesWithoutHost &&
                        (function mE(t) {
                            return !!(16 & t.flags);
                        })(n) &&
                        z8(e, n, Ie(), n.stylesWithoutHost, !1),
                    ee
                );
            }
            function Oe(t, n, e, i) {
                return Z(t, n, e, i), ee(), Oe;
            }
            let U_ = (t, n, e, i, r, s) => (
                Ka(!0),
                D2(
                    i,
                    r,
                    (function X5() {
                        return Jt.lFrame.currentNamespace;
                    })(),
                )
            );
            function Xe(t, n, e) {
                const i = Ie(),
                    r = Ln(),
                    s = t + Zt,
                    o = r.firstCreatePass
                        ? (function nP(t, n, e, i, r) {
                              const s = n.consts,
                                  o = Ga(s, i),
                                  a = g1(n, t, 8, 'ng-container', o);
                              return (
                                  null !== o && B2(a, o, !0),
                                  Y6(n, e, a, Ga(s, r)),
                                  null !== n.queries && n.queries.elementStart(n, a),
                                  a
                              );
                          })(s, r, i, n, e)
                        : r.data[s];
                Wa(o, !0);
                const a = B_(r, i, o, t);
                return (
                    (i[s] = a),
                    U0() && E2(r, i, a, o),
                    zs(a, i),
                    n1(o) && (U6(r, i, o), H6(r, o, i)),
                    null != e && B6(i, o),
                    Xe
                );
            }
            function Ze() {
                let t = _i();
                const n = Ln();
                return (
                    Y3() ? j3() : ((t = t.parent), Wa(t, !1)),
                    n.firstCreatePass && (e2(n, t), L0(t) && n.queries.elementEnd(t)),
                    Ze
                );
            }
            function Pi(t, n, e) {
                return Xe(t, n, e), Ze(), Pi;
            }
            let B_ = (t, n, e, i) => (Ka(!0), O6(n[Nt], ''));
            function st() {
                return Ie();
            }
            const fu = void 0;
            var oP = [
                'en',
                [['a', 'p'], ['AM', 'PM'], fu],
                [['AM', 'PM'], fu, fu],
                [
                    ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                    ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                    ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                ],
                fu,
                [
                    ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
                    ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                    ],
                ],
                fu,
                [
                    ['B', 'A'],
                    ['BC', 'AD'],
                    ['Before Christ', 'Anno Domini'],
                ],
                0,
                [6, 0],
                ['M/d/yy', 'MMM d, y', 'MMMM d, y', 'EEEE, MMMM d, y'],
                ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'],
                ['{1}, {0}', fu, "{1} 'at' {0}", fu],
                ['.', ',', ';', '%', '+', '-', 'E', '\xd7', '\u2030', '\u221e', 'NaN', ':'],
                ['#,##0.###', '#,##0%', '\xa4#,##0.00', '#E0'],
                'USD',
                '$',
                'US Dollar',
                {},
                'ltr',
                function sP(t) {
                    const e = Math.floor(Math.abs(t)),
                        i = t.toString().replace(/^[^.]*\.?/, '').length;
                    return 1 === e && 0 === i ? 1 : 5;
                },
            ];
            let R1 = {};
            function Qs(t) {
                const n = (function lP(t) {
                    return t.toLowerCase().replace(/_/g, '-');
                })(t);
                let e = $_(n);
                if (e) return e;
                const i = n.split('-')[0];
                if (((e = $_(i)), e)) return e;
                if ('en' === i) return oP;
                throw new Me(701, !1);
            }
            function $_(t) {
                return (
                    t in R1 || (R1[t] = Rn.ng && Rn.ng.common && Rn.ng.common.locales && Rn.ng.common.locales[t]), R1[t]
                );
            }
            var qi = (function (t) {
                return (
                    (t[(t.LocaleId = 0)] = 'LocaleId'),
                    (t[(t.DayPeriodsFormat = 1)] = 'DayPeriodsFormat'),
                    (t[(t.DayPeriodsStandalone = 2)] = 'DayPeriodsStandalone'),
                    (t[(t.DaysFormat = 3)] = 'DaysFormat'),
                    (t[(t.DaysStandalone = 4)] = 'DaysStandalone'),
                    (t[(t.MonthsFormat = 5)] = 'MonthsFormat'),
                    (t[(t.MonthsStandalone = 6)] = 'MonthsStandalone'),
                    (t[(t.Eras = 7)] = 'Eras'),
                    (t[(t.FirstDayOfWeek = 8)] = 'FirstDayOfWeek'),
                    (t[(t.WeekendRange = 9)] = 'WeekendRange'),
                    (t[(t.DateFormat = 10)] = 'DateFormat'),
                    (t[(t.TimeFormat = 11)] = 'TimeFormat'),
                    (t[(t.DateTimeFormat = 12)] = 'DateTimeFormat'),
                    (t[(t.NumberSymbols = 13)] = 'NumberSymbols'),
                    (t[(t.NumberFormats = 14)] = 'NumberFormats'),
                    (t[(t.CurrencyCode = 15)] = 'CurrencyCode'),
                    (t[(t.CurrencySymbol = 16)] = 'CurrencySymbol'),
                    (t[(t.CurrencyName = 17)] = 'CurrencyName'),
                    (t[(t.Currencies = 18)] = 'Currencies'),
                    (t[(t.Directionality = 19)] = 'Directionality'),
                    (t[(t.PluralCase = 20)] = 'PluralCase'),
                    (t[(t.ExtraData = 21)] = 'ExtraData'),
                    t
                );
            })(qi || {});
            const V1 = 'en-US';
            let G_ = V1;
            function Le(t, n, e, i) {
                const r = Ie(),
                    s = Ln(),
                    o = _i();
                return B8(s, r, r[Nt], o, t, n, i), Le;
            }
            function B8(t, n, e, i, r, s, o) {
                const a = n1(i),
                    c = t.firstCreatePass && Uv(t),
                    f = n[Di],
                    g = Hv(n);
                let E = !0;
                if (3 & i.type || o) {
                    const W = Gs(i, n),
                        ie = o ? o(W) : W,
                        he = g.length,
                        fe = o ? nt => o(xi(nt[i.index])) : i.index;
                    let ze = null;
                    if (
                        (!o &&
                            a &&
                            (ze = (function rN(t, n, e, i) {
                                const r = t.cleanup;
                                if (null != r)
                                    for (let s = 0; s < r.length - 1; s += 2) {
                                        const o = r[s];
                                        if (o === e && r[s + 1] === i) {
                                            const a = n[ec],
                                                l = r[s + 2];
                                            return a.length > l ? a[l] : null;
                                        }
                                        'string' == typeof o && (s += 2);
                                    }
                                return null;
                            })(t, n, r, i.index)),
                        null !== ze)
                    )
                        ((ze.__ngLastListenerFn__ || ze).__ngNextListenerFn__ = s),
                            (ze.__ngLastListenerFn__ = s),
                            (E = !1);
                    else {
                        s = Cy(i, n, f, s, !1);
                        const nt = e.listen(ie, r, s);
                        g.push(s, nt), c && c.push(r, fe, he, he + 1);
                    }
                } else s = Cy(i, n, f, s, !1);
                const P = i.outputs;
                let V;
                if (E && null !== P && (V = P[r])) {
                    const W = V.length;
                    if (W)
                        for (let ie = 0; ie < W; ie += 2) {
                            const kt = n[V[ie]][V[ie + 1]].subscribe(s),
                                Tt = g.length;
                            g.push(s, kt), c && c.push(r, i.index, Tt, -(Tt + 1));
                        }
                }
            }
            function by(t, n, e, i) {
                const r = _(null);
                try {
                    return Wr(6, n, e), !1 !== e(i);
                } catch (s) {
                    return O2(t, s), !1;
                } finally {
                    Wr(7, n, e), _(r);
                }
            }
            function Cy(t, n, e, i, r) {
                return function s(o) {
                    if (o === Function) return i;
                    ud(t.componentOffset > -1 ? Oo(t.index, n) : n);
                    let l = by(n, e, i, o),
                        c = s.__ngNextListenerFn__;
                    for (; c; ) (l = by(n, e, c, o) && l), (c = c.__ngNextListenerFn__);
                    return r && !1 === l && o.preventDefault(), l;
                };
            }
            function L(t = 1) {
                return (function rE(t) {
                    return (Jt.lFrame.contextLView = (function V5(t, n) {
                        for (; t > 0; ) (n = n[nc]), t--;
                        return n;
                    })(t, Jt.lFrame.contextLView))[Di];
                })(t);
            }
            function sN(t, n) {
                let e = null;
                const i = (function Ya(t) {
                    const n = t.attrs;
                    if (null != n) {
                        const e = n.indexOf(5);
                        if (!(1 & e)) return n[e + 1];
                    }
                    return null;
                })(t);
                for (let r = 0; r < n.length; r++) {
                    const s = n[r];
                    if ('*' !== s) {
                        if (null === i ? js(t, s, !0) : v3(i, s)) return r;
                    } else e = r;
                }
                return e;
            }
            function H1(t) {
                const n = Ie()[Ki][as];
                if (!n.projection) {
                    const i = (n.projection = (function Ba(t, n) {
                            const e = [];
                            for (let i = 0; i < t; i++) e.push(n);
                            return e;
                        })(t ? t.length : 1, null)),
                        r = i.slice();
                    let s = n.child;
                    for (; null !== s; ) {
                        const o = t ? sN(s, t) : 0;
                        null !== o && (r[o] ? (r[o].projectionNext = s) : (i[o] = s), (r[o] = s)), (s = s.next);
                    }
                }
            }
            function U1(t, n = 0, e) {
                const i = Ie(),
                    r = Ln(),
                    s = g1(r, Zt + t, 16, null, e || null);
                null === s.projection && (s.projection = n),
                    j3(),
                    (!i[Fe] || o1()) &&
                        32 & ~s.flags &&
                        (function mA(t, n, e) {
                            Dv(n[Nt], 0, n, e, P6(t, e, n), bv(e.parent || n[as], e, n));
                        })(r, i, s);
            }
            function ct(t, n, e) {
                return Mn(t, '', n, '', e), ct;
            }
            function Mn(t, n, e, i, r) {
                const s = Ie(),
                    o = k1(s, n, e, i);
                return o !== un && po(Ln(), Bi(), s, t, o, s[Nt], r, !1), Mn;
            }
            function Iy(t, n, e, i) {
                !(function D9(t, n, e, i) {
                    const r = Ln();
                    if (r.firstCreatePass) {
                        const s = _i();
                        x9(r, new w9(n, e, i), s.index),
                            (function lO(t, n) {
                                const e = t.contentQueries || (t.contentQueries = []);
                                n !== (e.length ? e[e.length - 1] : -1) && e.push(t.queries.length - 1, n);
                            })(r, t),
                            !(2 & ~e) && (r.staticContentQueries = !0);
                    }
                    return S9(r, Ie(), e);
                })(t, n, e, i);
            }
            function Fr(t, n, e) {
                !(function T9(t, n, e) {
                    const i = Ln();
                    return (
                        i.firstCreatePass && (x9(i, new w9(t, n, e), -1), !(2 & ~n) && (i.staticViewQueries = !0)),
                        S9(i, Ie(), n)
                    );
                })(t, n, e);
            }
            function Dr(t) {
                const n = Ie(),
                    e = Ln(),
                    i = W3();
                Jh(i + 1);
                const r = v8(e, i);
                if (
                    t.dirty &&
                    (function Bk(t) {
                        return !(4 & ~t[St]);
                    })(n) === !(2 & ~r.metadata.flags)
                ) {
                    if (null === r.matches) t.reset([]);
                    else {
                        const s = k9(n, i);
                        t.reset(s, b7), t.notifyOnChanges();
                    }
                    return !0;
                }
                return !1;
            }
            function xr() {
                return (function g8(t, n) {
                    return t[ga].queries[n].queryList;
                })(Ie(), W3());
            }
            function ts(t) {
                return s1(
                    (function Jk() {
                        return Jt.lFrame.contextLView;
                    })(),
                    Zt + t,
                );
            }
            function Je(t, n = '') {
                const e = Ie(),
                    i = Ln(),
                    r = t + Zt,
                    s = i.firstCreatePass ? g1(i, r, 1, n, null) : i.data[r],
                    o = Hy(i, e, s, n, t);
                (e[r] = o), U0() && E2(i, e, o, s), Wa(s, !1);
            }
            let Hy = (t, n, e, i, r) => (
                Ka(!0),
                (function L6(t, n) {
                    return t.createText(n);
                })(n[Nt], i)
            );
            function hn(t) {
                return jn('', t, ''), hn;
            }
            function jn(t, n, e) {
                const i = Ie(),
                    r = k1(i, t, n, e);
                return (
                    r !== un &&
                        (function Dl(t, n, e) {
                            const i = F0(n, t);
                            !(function mv(t, n, e) {
                                t.setValue(n, e);
                            })(t[Nt], i, e);
                        })(i, Os(), r),
                    jn
                );
            }
            /*!
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            function yi(t, n, e) {
                I9(n) && (n = n());
                const i = Ie();
                return Mr(i, ya(), n) && po(Ln(), Bi(), i, t, n, i[Nt], e, !1), yi;
            }
            function ki(t, n) {
                const e = I9(t);
                return e && t.set(n), e;
            }
            function bi(t, n) {
                const e = Ie(),
                    i = Ln(),
                    r = _i();
                return B8(i, e, e[Nt], r, t, n), bi;
            }
            function q8(t, n, e, i, r) {
                if (((t = Dt(t)), Array.isArray(t))) for (let s = 0; s < t.length; s++) q8(t[s], n, e, i, r);
                else {
                    const s = Ln(),
                        o = Ie(),
                        a = _i();
                    let l = bl(t) ? t : Dt(t.provide);
                    const c = Yh(t),
                        f = 1048575 & a.providerIndexes,
                        g = a.directiveStart,
                        E = a.providerIndexes >> 20;
                    if (bl(t) || !t.multi) {
                        const P = new B0(c, r, te),
                            V = j8(l, n, r ? f : f + E, g);
                        -1 === V
                            ? (n6(s2(a, o), s, l),
                              Y8(s, t, n.length),
                              n.push(l),
                              a.directiveStart++,
                              a.directiveEnd++,
                              r && (a.providerIndexes += 1048576),
                              e.push(P),
                              o.push(P))
                            : ((e[V] = P), (o[V] = P));
                    } else {
                        const P = j8(l, n, f + E, g),
                            V = j8(l, n, f, f + E),
                            ie = V >= 0 && e[V];
                        if ((r && !ie) || (!r && !(P >= 0 && e[P]))) {
                            n6(s2(a, o), s, l);
                            const he = (function SN(t, n, e, i, r) {
                                const s = new B0(t, e, te);
                                return (s.multi = []), (s.index = n), (s.componentProviders = 0), Ky(s, r, i && !e), s;
                            })(r ? MN : wN, e.length, r, i, c);
                            !r && ie && (e[V].providerFactory = he),
                                Y8(s, t, n.length, 0),
                                n.push(l),
                                a.directiveStart++,
                                a.directiveEnd++,
                                r && (a.providerIndexes += 1048576),
                                e.push(he),
                                o.push(he);
                        } else Y8(s, t, P > -1 ? P : V, Ky(e[r ? V : P], c, !r && i));
                        !r && i && ie && e[V].componentProviders++;
                    }
                }
            }
            function Y8(t, n, e, i) {
                const r = bl(n),
                    s = (function T3(t) {
                        return !!t.useClass;
                    })(n);
                if (r || s) {
                    const l = (s ? Dt(n.useClass) : n).prototype.ngOnDestroy;
                    if (l) {
                        const c = t.destroyHooks || (t.destroyHooks = []);
                        if (!r && n.multi) {
                            const f = c.indexOf(e);
                            -1 === f ? c.push(e, [i, l]) : c[f + 1].push(i, l);
                        } else c.push(e, l);
                    }
                }
            }
            function Ky(t, n, e) {
                return e && t.componentProviders++, t.multi.push(n) - 1;
            }
            function j8(t, n, e, i) {
                for (let r = e; r < i; r++) if (n[r] === t) return r;
                return -1;
            }
            function wN(t, n, e, i) {
                return $8(this.multi, []);
            }
            function MN(t, n, e, i) {
                const r = this.multi;
                let s;
                if (this.providerFactory) {
                    const o = this.providerFactory.componentProviders,
                        a = nu(e, e[Be], this.providerFactory.index, i);
                    (s = a.slice(0, o)), $8(r, s);
                    for (let l = o; l < a.length; l++) s.push(a[l]);
                } else (s = []), $8(r, s);
                return s;
            }
            function $8(t, n) {
                for (let e = 0; e < t.length; e++) n.push((0, t[e])());
                return n;
            }
            function $n(t, n = []) {
                return e => {
                    e.providersResolver = (i, r) =>
                        (function CN(t, n, e) {
                            const i = Ln();
                            if (i.firstCreatePass) {
                                const r = Lo(t);
                                q8(e, i.data, i.blueprint, r, !0), q8(n, i.data, i.blueprint, r, !1);
                            }
                        })(i, r ? r(t) : t, n);
                };
            }
            let TN = (() => {
                class t {
                    constructor(e) {
                        (this._injector = e), (this.cachedInjectors = new Map());
                    }
                    getOrCreateStandaloneInjector(e) {
                        if (!e.standalone) return null;
                        if (!this.cachedInjectors.has(e)) {
                            const i = Ql(0, e.type),
                                r =
                                    i.length > 0
                                        ? (function $9(t, n, e = null) {
                                              return new j9({
                                                  providers: t,
                                                  parent: n,
                                                  debugName: e,
                                                  runEnvironmentInitializers: !0,
                                              }).injector;
                                          })([i], this._injector, `Standalone[${e.type.name}]`)
                                        : null;
                            this.cachedInjectors.set(e, r);
                        }
                        return this.cachedInjectors.get(e);
                    }
                    ngOnDestroy() {
                        try {
                            for (const e of this.cachedInjectors.values()) null !== e && e.destroy();
                        } finally {
                            this.cachedInjectors.clear();
                        }
                    }
                    static #e = (this.ɵprov = We({
                        token: t,
                        providedIn: 'environment',
                        factory: () => new t(Se(Io)),
                    }));
                }
                return t;
            })();
            function Qi(t) {
                tl('NgStandalone'), (t.getStandaloneInjector = n => n.get(TN).getOrCreateStandaloneInjector(t));
            }
            function B1(t, n, e) {
                const i = Ws() + t,
                    r = Ie();
                return r[i] === un
                    ? nl(r, i, e ? n.call(e) : n())
                    : (function Cd(t, n) {
                          return t[n];
                      })(r, i);
            }
            function us(t, n, e, i) {
                return Zy(Ie(), Ws(), t, n, e, i);
            }
            function zd(t, n) {
                const e = t[n];
                return e === un ? void 0 : e;
            }
            function Zy(t, n, e, i, r, s) {
                const o = n + e;
                return Mr(t, o, r) ? nl(t, o + 1, s ? i.call(s, r) : i(r)) : zd(t, o + 1);
            }
            function Gn(t, n) {
                const e = Ln();
                let i;
                const r = t + Zt;
                e.firstCreatePass
                    ? ((i = (function PN(t, n) {
                          if (n)
                              for (let e = n.length - 1; e >= 0; e--) {
                                  const i = n[e];
                                  if (t === i.name) return i;
                              }
                      })(n, e.pipeRegistry)),
                      (e.data[r] = i),
                      i.onDestroy && (e.destroyHooks ??= []).push(r, i.onDestroy))
                    : (i = e.data[r]);
                const s = i.factory || (i.factory = yr(i.type)),
                    a = ve(te);
                try {
                    const l = r2(!1),
                        c = s();
                    return (
                        r2(l),
                        (function cN(t, n, e, i) {
                            e >= t.data.length && ((t.data[e] = null), (t.blueprint[e] = null)), (n[e] = i);
                        })(e, Ie(), r, c),
                        c
                    );
                } finally {
                    ve(a);
                }
            }
            function ci(t, n, e) {
                const i = t + Zt,
                    r = Ie(),
                    s = s1(r, i);
                return Pd(r, i) ? Zy(r, Ws(), n, s.transform, e, s) : s.transform(e);
            }
            function u4(t, n, e, i) {
                const r = t + Zt,
                    s = Ie(),
                    o = s1(s, r);
                return Pd(s, r)
                    ? (function Jy(t, n, e, i, r, s, o) {
                          const a = n + e;
                          return uu(t, a, r, s) ? nl(t, a + 2, o ? i.call(o, r, s) : i(r, s)) : zd(t, a + 2);
                      })(s, Ws(), n, o.transform, e, i, o)
                    : o.transform(e, i);
            }
            function Pd(t, n) {
                return t[Be].data[n].pure;
            }
            function Xs(t, n) {
                return P2(t, n);
            }
            const wb = new $e(''),
                f4 = new $e('');
            let em,
                Z8 = (() => {
                    class t {
                        constructor(e, i, r) {
                            (this._ngZone = e),
                                (this.registry = i),
                                (this._pendingCount = 0),
                                (this._isZoneStable = !0),
                                (this._callbacks = []),
                                (this.taskTrackingZone = null),
                                em ||
                                    ((function LF(t) {
                                        em = t;
                                    })(r),
                                    r.addToWindow(i)),
                                this._watchAngularEvents(),
                                e.run(() => {
                                    this.taskTrackingZone =
                                        typeof Zone > 'u' ? null : Zone.current.get('TaskTrackingZone');
                                });
                        }
                        _watchAngularEvents() {
                            this._ngZone.onUnstable.subscribe({
                                next: () => {
                                    this._isZoneStable = !1;
                                },
                            }),
                                this._ngZone.runOutsideAngular(() => {
                                    this._ngZone.onStable.subscribe({
                                        next: () => {
                                            en.assertNotInAngularZone(),
                                                queueMicrotask(() => {
                                                    (this._isZoneStable = !0), this._runCallbacksIfReady();
                                                });
                                        },
                                    });
                                });
                        }
                        increasePendingRequestCount() {
                            return (this._pendingCount += 1), this._pendingCount;
                        }
                        decreasePendingRequestCount() {
                            if (((this._pendingCount -= 1), this._pendingCount < 0))
                                throw new Error('pending async requests below zero');
                            return this._runCallbacksIfReady(), this._pendingCount;
                        }
                        isStable() {
                            return this._isZoneStable && 0 === this._pendingCount && !this._ngZone.hasPendingMacrotasks;
                        }
                        _runCallbacksIfReady() {
                            if (this.isStable())
                                queueMicrotask(() => {
                                    for (; 0 !== this._callbacks.length; ) {
                                        let e = this._callbacks.pop();
                                        clearTimeout(e.timeoutId), e.doneCb();
                                    }
                                });
                            else {
                                let e = this.getPendingTasks();
                                this._callbacks = this._callbacks.filter(
                                    i => !i.updateCb || !i.updateCb(e) || (clearTimeout(i.timeoutId), !1),
                                );
                            }
                        }
                        getPendingTasks() {
                            return this.taskTrackingZone
                                ? this.taskTrackingZone.macroTasks.map(e => ({
                                      source: e.source,
                                      creationLocation: e.creationLocation,
                                      data: e.data,
                                  }))
                                : [];
                        }
                        addCallback(e, i, r) {
                            let s = -1;
                            i &&
                                i > 0 &&
                                (s = setTimeout(() => {
                                    (this._callbacks = this._callbacks.filter(o => o.timeoutId !== s)), e();
                                }, i)),
                                this._callbacks.push({ doneCb: e, timeoutId: s, updateCb: r });
                        }
                        whenStable(e, i, r) {
                            if (r && !this.taskTrackingZone)
                                throw new Error(
                                    'Task tracking zone is required when passing an update callback to whenStable(). Is "zone.js/plugins/task-tracking" loaded?',
                                );
                            this.addCallback(e, i, r), this._runCallbacksIfReady();
                        }
                        getPendingRequestCount() {
                            return this._pendingCount;
                        }
                        registerApplication(e) {
                            this.registry.registerApplication(e, this);
                        }
                        unregisterApplication(e) {
                            this.registry.unregisterApplication(e);
                        }
                        findProviders(e, i, r) {
                            return [];
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(en), Se(J8), Se(f4));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })(),
                J8 = (() => {
                    class t {
                        constructor() {
                            this._applications = new Map();
                        }
                        registerApplication(e, i) {
                            this._applications.set(e, i);
                        }
                        unregisterApplication(e) {
                            this._applications.delete(e);
                        }
                        unregisterAllApplications() {
                            this._applications.clear();
                        }
                        getTestability(e) {
                            return this._applications.get(e) || null;
                        }
                        getAllTestabilities() {
                            return Array.from(this._applications.values());
                        }
                        getAllRootElements() {
                            return Array.from(this._applications.keys());
                        }
                        findTestabilityInTree(e, i = !0) {
                            return em?.findTestabilityInTree(this, e, i) ?? null;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'platform' }));
                    }
                    return t;
                })();
            function m4(t) {
                return !!t && 'function' == typeof t.then;
            }
            function Mb(t) {
                return !!t && 'function' == typeof t.subscribe;
            }
            const OF = new $e('');
            let tm = (() => {
                class t {
                    constructor() {
                        (this.initialized = !1),
                            (this.done = !1),
                            (this.donePromise = new Promise((e, i) => {
                                (this.resolve = e), (this.reject = i);
                            })),
                            (this.appInits = Ue(OF, { optional: !0 }) ?? []);
                    }
                    runInitializers() {
                        if (this.initialized) return;
                        const e = [];
                        for (const r of this.appInits) {
                            const s = r();
                            if (m4(s)) e.push(s);
                            else if (Mb(s)) {
                                const o = new Promise((a, l) => {
                                    s.subscribe({ complete: a, error: l });
                                });
                                e.push(o);
                            }
                        }
                        const i = () => {
                            (this.done = !0), this.resolve();
                        };
                        Promise.all(e)
                            .then(() => {
                                i();
                            })
                            .catch(r => {
                                this.reject(r);
                            }),
                            0 === e.length && i(),
                            (this.initialized = !0);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            const Sb = new $e('');
            function xb(t, n) {
                return Array.isArray(n) ? n.reduce(xb, t) : { ...t, ...n };
            }
            let xl = (() => {
                class t {
                    constructor() {
                        (this._bootstrapListeners = []),
                            (this._runningTick = !1),
                            (this._destroyed = !1),
                            (this._destroyListeners = []),
                            (this._views = []),
                            (this.internalErrorHandler = Ue(_7)),
                            (this.afterRenderEffectManager = Ue(gd)),
                            (this.externalTestViews = new Set()),
                            (this.beforeRender = new vt()),
                            (this.afterTick = new vt()),
                            (this.componentTypes = []),
                            (this.components = []),
                            (this.isStable = Ue(cu).hasPendingTasks.pipe(Ct(e => !e))),
                            (this._injector = Ue(Io));
                    }
                    get destroyed() {
                        return this._destroyed;
                    }
                    get injector() {
                        return this._injector;
                    }
                    bootstrap(e, i) {
                        const r = e instanceof n9;
                        if (!this._injector.get(tm).done)
                            throw (
                                (!r &&
                                    (function yl(t) {
                                        const n = bn(t) || Cr(t) || $r(t);
                                        return null !== n && n.standalone;
                                    })(e),
                                new Me(405, !1))
                            );
                        let o;
                        (o = r ? e : this._injector.get(su).resolveComponentFactory(e)),
                            this.componentTypes.push(o.componentType);
                        const a = (function zF(t) {
                                return t.isBoundToModule;
                            })(o)
                                ? void 0
                                : this._injector.get(lu),
                            c = o.create(ys.NULL, [], i || o.selector, a),
                            f = c.location.nativeElement,
                            g = c.injector.get(wb, null);
                        return (
                            g?.registerApplication(f),
                            c.onDestroy(() => {
                                this.detachView(c.hostView), p4(this.components, c), g?.unregisterApplication(f);
                            }),
                            this._loadComponent(c),
                            c
                        );
                    }
                    tick() {
                        this._tick(!0);
                    }
                    _tick(e) {
                        if (this._runningTick) throw new Me(101, !1);
                        const i = _(null);
                        try {
                            (this._runningTick = !0), this.detectChangesInAttachedViews(e);
                        } catch (r) {
                            this.internalErrorHandler(r);
                        } finally {
                            this.afterTick.next(), (this._runningTick = !1), _(i);
                        }
                    }
                    detectChangesInAttachedViews(e) {
                        let i = 0;
                        const r = this.afterRenderEffectManager;
                        for (;;) {
                            if (i === $v) throw new Me(103, !1);
                            if (e) {
                                const s = 0 === i;
                                this.beforeRender.next(s);
                                for (let { _lView: o, notifyErrorHandler: a } of this._views) NF(o, s, a);
                            }
                            if (
                                (i++,
                                r.executeInternalCallbacks(),
                                ![...this.externalTestViews.keys(), ...this._views].some(({ _lView: s }) => nm(s)) &&
                                    (r.execute(),
                                    ![...this.externalTestViews.keys(), ...this._views].some(({ _lView: s }) => nm(s))))
                            )
                                break;
                        }
                    }
                    attachView(e) {
                        const i = e;
                        this._views.push(i), i.attachToAppRef(this);
                    }
                    detachView(e) {
                        const i = e;
                        p4(this._views, i), i.detachFromAppRef();
                    }
                    _loadComponent(e) {
                        this.attachView(e.hostView), this.tick(), this.components.push(e);
                        const i = this._injector.get(Sb, []);
                        [...this._bootstrapListeners, ...i].forEach(r => r(e));
                    }
                    ngOnDestroy() {
                        if (!this._destroyed)
                            try {
                                this._destroyListeners.forEach(e => e()), this._views.slice().forEach(e => e.destroy());
                            } finally {
                                (this._destroyed = !0),
                                    (this._views = []),
                                    (this._bootstrapListeners = []),
                                    (this._destroyListeners = []);
                            }
                    }
                    onDestroy(e) {
                        return this._destroyListeners.push(e), () => p4(this._destroyListeners, e);
                    }
                    destroy() {
                        if (this._destroyed) throw new Me(406, !1);
                        const e = this._injector;
                        e.destroy && !e.destroyed && e.destroy();
                    }
                    get viewCount() {
                        return this._views.length;
                    }
                    warnIfDestroyed() {}
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            function p4(t, n) {
                const e = t.indexOf(n);
                e > -1 && t.splice(e, 1);
            }
            function NF(t, n, e) {
                (!n && !nm(t)) ||
                    (function FF(t, n, e) {
                        let i;
                        e ? ((i = 0), (t[St] |= 1024)) : (i = 64 & t[St] ? 0 : 1), z2(t, n, i);
                    })(t, e, n);
            }
            function nm(t) {
                return U3(t);
            }
            let UF = (() => {
                class t {
                    constructor() {
                        (this.zone = Ue(en)), (this.applicationRef = Ue(xl));
                    }
                    initialize() {
                        this._onMicrotaskEmptySubscription ||
                            (this._onMicrotaskEmptySubscription = this.zone.onMicrotaskEmpty.subscribe({
                                next: () => {
                                    this.zone.run(() => {
                                        this.applicationRef.tick();
                                    });
                                },
                            }));
                    }
                    ngOnDestroy() {
                        this._onMicrotaskEmptySubscription?.unsubscribe();
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            function BF() {
                const t = Ue(en),
                    n = Ue(Xa);
                return e => t.runOutsideAngular(() => n.handleError(e));
            }
            let YF = (() => {
                class t {
                    constructor() {
                        (this.subscription = new ii()),
                            (this.initialized = !1),
                            (this.zone = Ue(en)),
                            (this.pendingTasks = Ue(cu));
                    }
                    initialize() {
                        if (this.initialized) return;
                        this.initialized = !0;
                        let e = null;
                        !this.zone.isStable &&
                            !this.zone.hasPendingMacrotasks &&
                            !this.zone.hasPendingMicrotasks &&
                            (e = this.pendingTasks.add()),
                            this.zone.runOutsideAngular(() => {
                                this.subscription.add(
                                    this.zone.onStable.subscribe(() => {
                                        en.assertNotInAngularZone(),
                                            queueMicrotask(() => {
                                                null !== e &&
                                                    !this.zone.hasPendingMacrotasks &&
                                                    !this.zone.hasPendingMicrotasks &&
                                                    (this.pendingTasks.remove(e), (e = null));
                                            });
                                    }),
                                );
                            }),
                            this.subscription.add(
                                this.zone.onUnstable.subscribe(() => {
                                    en.assertInAngularZone(), (e ??= this.pendingTasks.add());
                                }),
                            );
                    }
                    ngOnDestroy() {
                        this.subscription.unsubscribe();
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            const kl = new $e('', {
                    providedIn: 'root',
                    factory: () =>
                        Ue(kl, re.Optional | re.SkipSelf) ||
                        (function jF() {
                            return (typeof $localize < 'u' && $localize.locale) || V1;
                        })(),
                }),
                im = new $e('');
            let Ab = (() => {
                    class t {
                        constructor(e) {
                            (this._injector = e),
                                (this._modules = []),
                                (this._destroyListeners = []),
                                (this._destroyed = !1);
                        }
                        bootstrapModuleFactory(e, i) {
                            const r = (function FL(t = 'zone.js', n) {
                                return 'noop' === t ? new l9() : 'zone.js' === t ? new en(n) : t;
                            })(
                                i?.ngZone,
                                (function Ib(t) {
                                    return {
                                        enableLongStackTrace: !1,
                                        shouldCoalesceEventChangeDetection: t?.eventCoalescing ?? !1,
                                        shouldCoalesceRunChangeDetection: t?.runCoalescing ?? !1,
                                    };
                                })({
                                    eventCoalescing: i?.ngZoneEventCoalescing,
                                    runCoalescing: i?.ngZoneRunCoalescing,
                                }),
                            );
                            return r.run(() => {
                                const s = (function AO(t, n, e) {
                                        return new y8(t, n, e);
                                    })(
                                        e.moduleType,
                                        this.injector,
                                        (function Eb(t) {
                                            return [
                                                { provide: en, useFactory: t },
                                                {
                                                    provide: na,
                                                    multi: !0,
                                                    useFactory: () => {
                                                        const n = Ue(UF, { optional: !0 });
                                                        return () => n.initialize();
                                                    },
                                                },
                                                {
                                                    provide: na,
                                                    multi: !0,
                                                    useFactory: () => {
                                                        const n = Ue(YF);
                                                        return () => {
                                                            n.initialize();
                                                        };
                                                    },
                                                },
                                                { provide: _7, useFactory: BF },
                                            ];
                                        })(() => r),
                                    ),
                                    o = s.injector.get(Xa, null);
                                return (
                                    r.runOutsideAngular(() => {
                                        const a = r.onError.subscribe({
                                            next: l => {
                                                o.handleError(l);
                                            },
                                        });
                                        s.onDestroy(() => {
                                            p4(this._modules, s), a.unsubscribe();
                                        });
                                    }),
                                    (function Db(t, n, e) {
                                        try {
                                            const i = e();
                                            return m4(i)
                                                ? i.catch(r => {
                                                      throw (n.runOutsideAngular(() => t.handleError(r)), r);
                                                  })
                                                : i;
                                        } catch (i) {
                                            throw (n.runOutsideAngular(() => t.handleError(i)), i);
                                        }
                                    })(o, r, () => {
                                        const a = s.injector.get(tm);
                                        return (
                                            a.runInitializers(),
                                            a.donePromise.then(
                                                () => (
                                                    (function W_(t) {
                                                        'string' == typeof t &&
                                                            (G_ = t.toLowerCase().replace(/_/g, '-'));
                                                    })(s.injector.get(kl, V1) || V1),
                                                    this._moduleDoBootstrap(s),
                                                    s
                                                ),
                                            )
                                        );
                                    })
                                );
                            });
                        }
                        bootstrapModule(e, i = []) {
                            const r = xb({}, i);
                            return (function HF(t, n, e) {
                                const i = new b8(e);
                                return Promise.resolve(i);
                            })(0, 0, e).then(s => this.bootstrapModuleFactory(s, r));
                        }
                        _moduleDoBootstrap(e) {
                            const i = e.injector.get(xl);
                            if (e._bootstrapComponents.length > 0) e._bootstrapComponents.forEach(r => i.bootstrap(r));
                            else {
                                if (!e.instance.ngDoBootstrap) throw new Me(-403, !1);
                                e.instance.ngDoBootstrap(i);
                            }
                            this._modules.push(e);
                        }
                        onDestroy(e) {
                            this._destroyListeners.push(e);
                        }
                        get injector() {
                            return this._injector;
                        }
                        destroy() {
                            if (this._destroyed) throw new Me(404, !1);
                            this._modules.slice().forEach(i => i.destroy()), this._destroyListeners.forEach(i => i());
                            const e = this._injector.get(im, null);
                            e && (e.forEach(i => i()), e.clear()), (this._destroyed = !0);
                        }
                        get destroyed() {
                            return this._destroyed;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(ys));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'platform' }));
                    }
                    return t;
                })(),
                hc = null;
            const Lb = new $e('');
            function Ob(t, n, e = []) {
                const i = `Platform: ${n}`,
                    r = new $e(i);
                return (s = []) => {
                    let o = rm();
                    if (!o || o.injector.get(Lb, !1)) {
                        const a = [...e, ...s, { provide: r, useValue: !0 }];
                        t
                            ? t(a)
                            : (function WF(t) {
                                  if (hc && !hc.get(Lb, !1)) throw new Me(400, !1);
                                  (function Tb() {
                                      !(function Vt(t) {
                                          Sn = t;
                                      })(() => {
                                          throw new Me(600, !1);
                                      });
                                  })(),
                                      (hc = t);
                                  const n = t.get(Ab);
                                  (function Pb(t) {
                                      t.get(H7, null)?.forEach(e => e());
                                  })(t);
                              })(
                                  (function zb(t = [], n) {
                                      return ys.create({
                                          name: n,
                                          providers: [
                                              { provide: S0, useValue: 'platform' },
                                              { provide: im, useValue: new Set([() => (hc = null)]) },
                                              ...t,
                                          ],
                                      });
                                  })(a, i),
                              );
                    }
                    return (function KF(t) {
                        const n = rm();
                        if (!n) throw new Me(401, !1);
                        return n;
                    })();
                };
            }
            function rm() {
                return hc?.get(Ab) ?? null;
            }
            let kr = (() => {
                class t {
                    static #e = (this.__NG_ELEMENT_ID__ = XF);
                }
                return t;
            })();
            function XF(t) {
                return (function ZF(t, n, e) {
                    if (wl(t) && !e) {
                        const i = Oo(t.index, n);
                        return new dd(i, i);
                    }
                    return 47 & t.type ? new dd(n[Ki], n) : null;
                })(_i(), Ie(), !(16 & ~t));
            }
            class Hb {
                constructor() {}
                supports(n) {
                    return K2(n);
                }
                create(n) {
                    return new iR(n);
                }
            }
            const nR = (t, n) => n;
            class iR {
                constructor(n) {
                    (this.length = 0),
                        (this._linkedRecords = null),
                        (this._unlinkedRecords = null),
                        (this._previousItHead = null),
                        (this._itHead = null),
                        (this._itTail = null),
                        (this._additionsHead = null),
                        (this._additionsTail = null),
                        (this._movesHead = null),
                        (this._movesTail = null),
                        (this._removalsHead = null),
                        (this._removalsTail = null),
                        (this._identityChangesHead = null),
                        (this._identityChangesTail = null),
                        (this._trackByFn = n || nR);
                }
                forEachItem(n) {
                    let e;
                    for (e = this._itHead; null !== e; e = e._next) n(e);
                }
                forEachOperation(n) {
                    let e = this._itHead,
                        i = this._removalsHead,
                        r = 0,
                        s = null;
                    for (; e || i; ) {
                        const o = !i || (e && e.currentIndex < Bb(i, r, s)) ? e : i,
                            a = Bb(o, r, s),
                            l = o.currentIndex;
                        if (o === i) r--, (i = i._nextRemoved);
                        else if (((e = e._next), null == o.previousIndex)) r++;
                        else {
                            s || (s = []);
                            const c = a - r,
                                f = l - r;
                            if (c != f) {
                                for (let E = 0; E < c; E++) {
                                    const P = E < s.length ? s[E] : (s[E] = 0),
                                        V = P + E;
                                    f <= V && V < c && (s[E] = P + 1);
                                }
                                s[o.previousIndex] = f - c;
                            }
                        }
                        a !== l && n(o, a, l);
                    }
                }
                forEachPreviousItem(n) {
                    let e;
                    for (e = this._previousItHead; null !== e; e = e._nextPrevious) n(e);
                }
                forEachAddedItem(n) {
                    let e;
                    for (e = this._additionsHead; null !== e; e = e._nextAdded) n(e);
                }
                forEachMovedItem(n) {
                    let e;
                    for (e = this._movesHead; null !== e; e = e._nextMoved) n(e);
                }
                forEachRemovedItem(n) {
                    let e;
                    for (e = this._removalsHead; null !== e; e = e._nextRemoved) n(e);
                }
                forEachIdentityChange(n) {
                    let e;
                    for (e = this._identityChangesHead; null !== e; e = e._nextIdentityChange) n(e);
                }
                diff(n) {
                    if ((null == n && (n = []), !K2(n))) throw new Me(900, !1);
                    return this.check(n) ? this : null;
                }
                onDestroy() {}
                check(n) {
                    this._reset();
                    let r,
                        s,
                        o,
                        e = this._itHead,
                        i = !1;
                    if (Array.isArray(n)) {
                        this.length = n.length;
                        for (let a = 0; a < this.length; a++)
                            (s = n[a]),
                                (o = this._trackByFn(a, s)),
                                null !== e && Object.is(e.trackById, o)
                                    ? (i && (e = this._verifyReinsertion(e, s, o, a)),
                                      Object.is(e.item, s) || this._addIdentityChange(e, s))
                                    : ((e = this._mismatch(e, s, o, a)), (i = !0)),
                                (e = e._next);
                    } else
                        (r = 0),
                            (function PO(t, n) {
                                if (Array.isArray(t)) for (let e = 0; e < t.length; e++) n(t[e]);
                                else {
                                    const e = t[Symbol.iterator]();
                                    let i;
                                    for (; !(i = e.next()).done; ) n(i.value);
                                }
                            })(n, a => {
                                (o = this._trackByFn(r, a)),
                                    null !== e && Object.is(e.trackById, o)
                                        ? (i && (e = this._verifyReinsertion(e, a, o, r)),
                                          Object.is(e.item, a) || this._addIdentityChange(e, a))
                                        : ((e = this._mismatch(e, a, o, r)), (i = !0)),
                                    (e = e._next),
                                    r++;
                            }),
                            (this.length = r);
                    return this._truncate(e), (this.collection = n), this.isDirty;
                }
                get isDirty() {
                    return (
                        null !== this._additionsHead ||
                        null !== this._movesHead ||
                        null !== this._removalsHead ||
                        null !== this._identityChangesHead
                    );
                }
                _reset() {
                    if (this.isDirty) {
                        let n;
                        for (n = this._previousItHead = this._itHead; null !== n; n = n._next)
                            n._nextPrevious = n._next;
                        for (n = this._additionsHead; null !== n; n = n._nextAdded) n.previousIndex = n.currentIndex;
                        for (
                            this._additionsHead = this._additionsTail = null, n = this._movesHead;
                            null !== n;
                            n = n._nextMoved
                        )
                            n.previousIndex = n.currentIndex;
                        (this._movesHead = this._movesTail = null),
                            (this._removalsHead = this._removalsTail = null),
                            (this._identityChangesHead = this._identityChangesTail = null);
                    }
                }
                _mismatch(n, e, i, r) {
                    let s;
                    return (
                        null === n ? (s = this._itTail) : ((s = n._prev), this._remove(n)),
                        null !== (n = null === this._unlinkedRecords ? null : this._unlinkedRecords.get(i, null))
                            ? (Object.is(n.item, e) || this._addIdentityChange(n, e), this._reinsertAfter(n, s, r))
                            : null !== (n = null === this._linkedRecords ? null : this._linkedRecords.get(i, r))
                            ? (Object.is(n.item, e) || this._addIdentityChange(n, e), this._moveAfter(n, s, r))
                            : (n = this._addAfter(new rR(e, i), s, r)),
                        n
                    );
                }
                _verifyReinsertion(n, e, i, r) {
                    let s = null === this._unlinkedRecords ? null : this._unlinkedRecords.get(i, null);
                    return (
                        null !== s
                            ? (n = this._reinsertAfter(s, n._prev, r))
                            : n.currentIndex != r && ((n.currentIndex = r), this._addToMoves(n, r)),
                        n
                    );
                }
                _truncate(n) {
                    for (; null !== n; ) {
                        const e = n._next;
                        this._addToRemovals(this._unlink(n)), (n = e);
                    }
                    null !== this._unlinkedRecords && this._unlinkedRecords.clear(),
                        null !== this._additionsTail && (this._additionsTail._nextAdded = null),
                        null !== this._movesTail && (this._movesTail._nextMoved = null),
                        null !== this._itTail && (this._itTail._next = null),
                        null !== this._removalsTail && (this._removalsTail._nextRemoved = null),
                        null !== this._identityChangesTail && (this._identityChangesTail._nextIdentityChange = null);
                }
                _reinsertAfter(n, e, i) {
                    null !== this._unlinkedRecords && this._unlinkedRecords.remove(n);
                    const r = n._prevRemoved,
                        s = n._nextRemoved;
                    return (
                        null === r ? (this._removalsHead = s) : (r._nextRemoved = s),
                        null === s ? (this._removalsTail = r) : (s._prevRemoved = r),
                        this._insertAfter(n, e, i),
                        this._addToMoves(n, i),
                        n
                    );
                }
                _moveAfter(n, e, i) {
                    return this._unlink(n), this._insertAfter(n, e, i), this._addToMoves(n, i), n;
                }
                _addAfter(n, e, i) {
                    return (
                        this._insertAfter(n, e, i),
                        (this._additionsTail =
                            null === this._additionsTail
                                ? (this._additionsHead = n)
                                : (this._additionsTail._nextAdded = n)),
                        n
                    );
                }
                _insertAfter(n, e, i) {
                    const r = null === e ? this._itHead : e._next;
                    return (
                        (n._next = r),
                        (n._prev = e),
                        null === r ? (this._itTail = n) : (r._prev = n),
                        null === e ? (this._itHead = n) : (e._next = n),
                        null === this._linkedRecords && (this._linkedRecords = new Ub()),
                        this._linkedRecords.put(n),
                        (n.currentIndex = i),
                        n
                    );
                }
                _remove(n) {
                    return this._addToRemovals(this._unlink(n));
                }
                _unlink(n) {
                    null !== this._linkedRecords && this._linkedRecords.remove(n);
                    const e = n._prev,
                        i = n._next;
                    return (
                        null === e ? (this._itHead = i) : (e._next = i),
                        null === i ? (this._itTail = e) : (i._prev = e),
                        n
                    );
                }
                _addToMoves(n, e) {
                    return (
                        n.previousIndex === e ||
                            (this._movesTail =
                                null === this._movesTail ? (this._movesHead = n) : (this._movesTail._nextMoved = n)),
                        n
                    );
                }
                _addToRemovals(n) {
                    return (
                        null === this._unlinkedRecords && (this._unlinkedRecords = new Ub()),
                        this._unlinkedRecords.put(n),
                        (n.currentIndex = null),
                        (n._nextRemoved = null),
                        null === this._removalsTail
                            ? ((this._removalsTail = this._removalsHead = n), (n._prevRemoved = null))
                            : ((n._prevRemoved = this._removalsTail),
                              (this._removalsTail = this._removalsTail._nextRemoved = n)),
                        n
                    );
                }
                _addIdentityChange(n, e) {
                    return (
                        (n.item = e),
                        (this._identityChangesTail =
                            null === this._identityChangesTail
                                ? (this._identityChangesHead = n)
                                : (this._identityChangesTail._nextIdentityChange = n)),
                        n
                    );
                }
            }
            class rR {
                constructor(n, e) {
                    (this.item = n),
                        (this.trackById = e),
                        (this.currentIndex = null),
                        (this.previousIndex = null),
                        (this._nextPrevious = null),
                        (this._prev = null),
                        (this._next = null),
                        (this._prevDup = null),
                        (this._nextDup = null),
                        (this._prevRemoved = null),
                        (this._nextRemoved = null),
                        (this._nextAdded = null),
                        (this._nextMoved = null),
                        (this._nextIdentityChange = null);
                }
            }
            class sR {
                constructor() {
                    (this._head = null), (this._tail = null);
                }
                add(n) {
                    null === this._head
                        ? ((this._head = this._tail = n), (n._nextDup = null), (n._prevDup = null))
                        : ((this._tail._nextDup = n), (n._prevDup = this._tail), (n._nextDup = null), (this._tail = n));
                }
                get(n, e) {
                    let i;
                    for (i = this._head; null !== i; i = i._nextDup)
                        if ((null === e || e <= i.currentIndex) && Object.is(i.trackById, n)) return i;
                    return null;
                }
                remove(n) {
                    const e = n._prevDup,
                        i = n._nextDup;
                    return (
                        null === e ? (this._head = i) : (e._nextDup = i),
                        null === i ? (this._tail = e) : (i._prevDup = e),
                        null === this._head
                    );
                }
            }
            class Ub {
                constructor() {
                    this.map = new Map();
                }
                put(n) {
                    const e = n.trackById;
                    let i = this.map.get(e);
                    i || ((i = new sR()), this.map.set(e, i)), i.add(n);
                }
                get(n, e) {
                    const r = this.map.get(n);
                    return r ? r.get(n, e) : null;
                }
                remove(n) {
                    const e = n.trackById;
                    return this.map.get(e).remove(n) && this.map.delete(e), n;
                }
                get isEmpty() {
                    return 0 === this.map.size;
                }
                clear() {
                    this.map.clear();
                }
            }
            function Bb(t, n, e) {
                const i = t.previousIndex;
                if (null === i) return i;
                let r = 0;
                return e && i < e.length && (r = e[i]), i + n + r;
            }
            class qb {
                constructor() {}
                supports(n) {
                    return n instanceof Map || C8(n);
                }
                create() {
                    return new oR();
                }
            }
            class oR {
                constructor() {
                    (this._records = new Map()),
                        (this._mapHead = null),
                        (this._appendAfter = null),
                        (this._previousMapHead = null),
                        (this._changesHead = null),
                        (this._changesTail = null),
                        (this._additionsHead = null),
                        (this._additionsTail = null),
                        (this._removalsHead = null),
                        (this._removalsTail = null);
                }
                get isDirty() {
                    return null !== this._additionsHead || null !== this._changesHead || null !== this._removalsHead;
                }
                forEachItem(n) {
                    let e;
                    for (e = this._mapHead; null !== e; e = e._next) n(e);
                }
                forEachPreviousItem(n) {
                    let e;
                    for (e = this._previousMapHead; null !== e; e = e._nextPrevious) n(e);
                }
                forEachChangedItem(n) {
                    let e;
                    for (e = this._changesHead; null !== e; e = e._nextChanged) n(e);
                }
                forEachAddedItem(n) {
                    let e;
                    for (e = this._additionsHead; null !== e; e = e._nextAdded) n(e);
                }
                forEachRemovedItem(n) {
                    let e;
                    for (e = this._removalsHead; null !== e; e = e._nextRemoved) n(e);
                }
                diff(n) {
                    if (n) {
                        if (!(n instanceof Map || C8(n))) throw new Me(900, !1);
                    } else n = new Map();
                    return this.check(n) ? this : null;
                }
                onDestroy() {}
                check(n) {
                    this._reset();
                    let e = this._mapHead;
                    if (
                        ((this._appendAfter = null),
                        this._forEach(n, (i, r) => {
                            if (e && e.key === r) this._maybeAddToChanges(e, i), (this._appendAfter = e), (e = e._next);
                            else {
                                const s = this._getOrCreateRecordForKey(r, i);
                                e = this._insertBeforeOrAppend(e, s);
                            }
                        }),
                        e)
                    ) {
                        e._prev && (e._prev._next = null), (this._removalsHead = e);
                        for (let i = e; null !== i; i = i._nextRemoved)
                            i === this._mapHead && (this._mapHead = null),
                                this._records.delete(i.key),
                                (i._nextRemoved = i._next),
                                (i.previousValue = i.currentValue),
                                (i.currentValue = null),
                                (i._prev = null),
                                (i._next = null);
                    }
                    return (
                        this._changesTail && (this._changesTail._nextChanged = null),
                        this._additionsTail && (this._additionsTail._nextAdded = null),
                        this.isDirty
                    );
                }
                _insertBeforeOrAppend(n, e) {
                    if (n) {
                        const i = n._prev;
                        return (
                            (e._next = n),
                            (e._prev = i),
                            (n._prev = e),
                            i && (i._next = e),
                            n === this._mapHead && (this._mapHead = e),
                            (this._appendAfter = n),
                            n
                        );
                    }
                    return (
                        this._appendAfter
                            ? ((this._appendAfter._next = e), (e._prev = this._appendAfter))
                            : (this._mapHead = e),
                        (this._appendAfter = e),
                        null
                    );
                }
                _getOrCreateRecordForKey(n, e) {
                    if (this._records.has(n)) {
                        const r = this._records.get(n);
                        this._maybeAddToChanges(r, e);
                        const s = r._prev,
                            o = r._next;
                        return s && (s._next = o), o && (o._prev = s), (r._next = null), (r._prev = null), r;
                    }
                    const i = new aR(n);
                    return this._records.set(n, i), (i.currentValue = e), this._addToAdditions(i), i;
                }
                _reset() {
                    if (this.isDirty) {
                        let n;
                        for (this._previousMapHead = this._mapHead, n = this._previousMapHead; null !== n; n = n._next)
                            n._nextPrevious = n._next;
                        for (n = this._changesHead; null !== n; n = n._nextChanged) n.previousValue = n.currentValue;
                        for (n = this._additionsHead; null != n; n = n._nextAdded) n.previousValue = n.currentValue;
                        (this._changesHead = this._changesTail = null),
                            (this._additionsHead = this._additionsTail = null),
                            (this._removalsHead = null);
                    }
                }
                _maybeAddToChanges(n, e) {
                    Object.is(e, n.currentValue) ||
                        ((n.previousValue = n.currentValue), (n.currentValue = e), this._addToChanges(n));
                }
                _addToAdditions(n) {
                    null === this._additionsHead
                        ? (this._additionsHead = this._additionsTail = n)
                        : ((this._additionsTail._nextAdded = n), (this._additionsTail = n));
                }
                _addToChanges(n) {
                    null === this._changesHead
                        ? (this._changesHead = this._changesTail = n)
                        : ((this._changesTail._nextChanged = n), (this._changesTail = n));
                }
                _forEach(n, e) {
                    n instanceof Map ? n.forEach(e) : Object.keys(n).forEach(i => e(n[i], i));
                }
            }
            class aR {
                constructor(n) {
                    (this.key = n),
                        (this.previousValue = null),
                        (this.currentValue = null),
                        (this._nextPrevious = null),
                        (this._next = null),
                        (this._prev = null),
                        (this._nextAdded = null),
                        (this._nextRemoved = null),
                        (this._nextChanged = null);
                }
            }
            function Yb() {
                return new um([new Hb()]);
            }
            let um = (() => {
                class t {
                    static #e = (this.ɵprov = We({ token: t, providedIn: 'root', factory: Yb }));
                    constructor(e) {
                        this.factories = e;
                    }
                    static create(e, i) {
                        if (null != i) {
                            const r = i.factories.slice();
                            e = e.concat(r);
                        }
                        return new t(e);
                    }
                    static extend(e) {
                        return { provide: t, useFactory: i => t.create(e, i || Yb()), deps: [[t, new Vn(), new oi()]] };
                    }
                    find(e) {
                        const i = this.factories.find(r => r.supports(e));
                        if (null != i) return i;
                        throw new Me(901, !1);
                    }
                }
                return t;
            })();
            function jb() {
                return new y4([new qb()]);
            }
            let y4 = (() => {
                class t {
                    static #e = (this.ɵprov = We({ token: t, providedIn: 'root', factory: jb }));
                    constructor(e) {
                        this.factories = e;
                    }
                    static create(e, i) {
                        if (i) {
                            const r = i.factories.slice();
                            e = e.concat(r);
                        }
                        return new t(e);
                    }
                    static extend(e) {
                        return { provide: t, useFactory: i => t.create(e, i || jb()), deps: [[t, new Vn(), new oi()]] };
                    }
                    find(e) {
                        const i = this.factories.find(r => r.supports(e));
                        if (i) return i;
                        throw new Me(901, !1);
                    }
                }
                return t;
            })();
            const uR = Ob(null, 'core', []);
            let dR = (() => {
                class t {
                    constructor(e) {}
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(xl));
                    });
                    static #t = (this.ɵmod = Zn({ type: t }));
                    static #n = (this.ɵinj = zn({}));
                }
                return t;
            })();
            function Ma(t) {
                return 'boolean' == typeof t ? t : null != t && 'false' !== t;
            }
            function fC(t) {
                const n = _(null);
                try {
                    return t();
                } finally {
                    _(n);
                }
            }
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */
            let pC = null;
            function fc() {
                return pC;
            }
            class $R {}
            const Ni = new $e('');
            let gC = (() => {
                    class t {
                        historyGo(e) {
                            throw new Error('');
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: () => Ue(GR), providedIn: 'platform' }));
                    }
                    return t;
                })(),
                GR = (() => {
                    class t extends gC {
                        constructor() {
                            super(),
                                (this._doc = Ue(Ni)),
                                (this._location = window.location),
                                (this._history = window.history);
                        }
                        getBaseHrefFromDOM() {
                            return fc().getBaseHref(this._doc);
                        }
                        onPopState(e) {
                            const i = fc().getGlobalEventTarget(this._doc, 'window');
                            return i.addEventListener('popstate', e, !1), () => i.removeEventListener('popstate', e);
                        }
                        onHashChange(e) {
                            const i = fc().getGlobalEventTarget(this._doc, 'window');
                            return (
                                i.addEventListener('hashchange', e, !1), () => i.removeEventListener('hashchange', e)
                            );
                        }
                        get href() {
                            return this._location.href;
                        }
                        get protocol() {
                            return this._location.protocol;
                        }
                        get hostname() {
                            return this._location.hostname;
                        }
                        get port() {
                            return this._location.port;
                        }
                        get pathname() {
                            return this._location.pathname;
                        }
                        get search() {
                            return this._location.search;
                        }
                        get hash() {
                            return this._location.hash;
                        }
                        set pathname(e) {
                            this._location.pathname = e;
                        }
                        pushState(e, i, r) {
                            this._history.pushState(e, i, r);
                        }
                        replaceState(e, i, r) {
                            this._history.replaceState(e, i, r);
                        }
                        forward() {
                            this._history.forward();
                        }
                        back() {
                            this._history.back();
                        }
                        historyGo(e = 0) {
                            this._history.go(e);
                        }
                        getState() {
                            return this._history.state;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: () => new t(), providedIn: 'platform' }));
                    }
                    return t;
                })();
            function vC(t, n) {
                if (0 == t.length) return n;
                if (0 == n.length) return t;
                let e = 0;
                return (
                    t.endsWith('/') && e++,
                    n.startsWith('/') && e++,
                    2 == e ? t + n.substring(1) : 1 == e ? t + n : t + '/' + n
                );
            }
            function _C(t) {
                const n = t.match(/#|\?|$/),
                    e = (n && n.index) || t.length;
                return t.slice(0, e - ('/' === t[e - 1] ? 1 : 0)) + t.slice(e);
            }
            function pu(t) {
                return t && '?' !== t[0] ? '?' + t : t;
            }
            let fm = (() => {
                class t {
                    historyGo(e) {
                        throw new Error('');
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: () => Ue(KR), providedIn: 'root' }));
                }
                return t;
            })();
            const WR = new $e('');
            let KR = (() => {
                    class t extends fm {
                        constructor(e, i) {
                            super(),
                                (this._platformLocation = e),
                                (this._removeListenerFns = []),
                                (this._baseHref =
                                    i ?? this._platformLocation.getBaseHrefFromDOM() ?? Ue(Ni).location?.origin ?? '');
                        }
                        ngOnDestroy() {
                            for (; this._removeListenerFns.length; ) this._removeListenerFns.pop()();
                        }
                        onPopState(e) {
                            this._removeListenerFns.push(
                                this._platformLocation.onPopState(e),
                                this._platformLocation.onHashChange(e),
                            );
                        }
                        getBaseHref() {
                            return this._baseHref;
                        }
                        prepareExternalUrl(e) {
                            return vC(this._baseHref, e);
                        }
                        path(e = !1) {
                            const i = this._platformLocation.pathname + pu(this._platformLocation.search),
                                r = this._platformLocation.hash;
                            return r && e ? `${i}${r}` : i;
                        }
                        pushState(e, i, r, s) {
                            const o = this.prepareExternalUrl(r + pu(s));
                            this._platformLocation.pushState(e, i, o);
                        }
                        replaceState(e, i, r, s) {
                            const o = this.prepareExternalUrl(r + pu(s));
                            this._platformLocation.replaceState(e, i, o);
                        }
                        forward() {
                            this._platformLocation.forward();
                        }
                        back() {
                            this._platformLocation.back();
                        }
                        getState() {
                            return this._platformLocation.getState();
                        }
                        historyGo(e = 0) {
                            this._platformLocation.historyGo?.(e);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(gC), Se(WR, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                yC = (() => {
                    class t {
                        constructor(e) {
                            (this._subject = new Ft()),
                                (this._urlChangeListeners = []),
                                (this._urlChangeSubscription = null),
                                (this._locationStrategy = e);
                            const i = this._locationStrategy.getBaseHref();
                            (this._basePath = (function ZR(t) {
                                if (new RegExp('^(https?:)?//').test(t)) {
                                    const [, e] = t.split(/\/\/[^\/]+/);
                                    return e;
                                }
                                return t;
                            })(_C(bC(i)))),
                                this._locationStrategy.onPopState(r => {
                                    this._subject.emit({ url: this.path(!0), pop: !0, state: r.state, type: r.type });
                                });
                        }
                        ngOnDestroy() {
                            this._urlChangeSubscription?.unsubscribe(), (this._urlChangeListeners = []);
                        }
                        path(e = !1) {
                            return this.normalize(this._locationStrategy.path(e));
                        }
                        getState() {
                            return this._locationStrategy.getState();
                        }
                        isCurrentPathEqualTo(e, i = '') {
                            return this.path() == this.normalize(e + pu(i));
                        }
                        normalize(e) {
                            return t.stripTrailingSlash(
                                (function XR(t, n) {
                                    if (!t || !n.startsWith(t)) return n;
                                    const e = n.substring(t.length);
                                    return '' === e || ['/', ';', '?', '#'].includes(e[0]) ? e : n;
                                })(this._basePath, bC(e)),
                            );
                        }
                        prepareExternalUrl(e) {
                            return e && '/' !== e[0] && (e = '/' + e), this._locationStrategy.prepareExternalUrl(e);
                        }
                        go(e, i = '', r = null) {
                            this._locationStrategy.pushState(r, '', e, i),
                                this._notifyUrlChangeListeners(this.prepareExternalUrl(e + pu(i)), r);
                        }
                        replaceState(e, i = '', r = null) {
                            this._locationStrategy.replaceState(r, '', e, i),
                                this._notifyUrlChangeListeners(this.prepareExternalUrl(e + pu(i)), r);
                        }
                        forward() {
                            this._locationStrategy.forward();
                        }
                        back() {
                            this._locationStrategy.back();
                        }
                        historyGo(e = 0) {
                            this._locationStrategy.historyGo?.(e);
                        }
                        onUrlChange(e) {
                            return (
                                this._urlChangeListeners.push(e),
                                (this._urlChangeSubscription ??= this.subscribe(i => {
                                    this._notifyUrlChangeListeners(i.url, i.state);
                                })),
                                () => {
                                    const i = this._urlChangeListeners.indexOf(e);
                                    this._urlChangeListeners.splice(i, 1),
                                        0 === this._urlChangeListeners.length &&
                                            (this._urlChangeSubscription?.unsubscribe(),
                                            (this._urlChangeSubscription = null));
                                }
                            );
                        }
                        _notifyUrlChangeListeners(e = '', i) {
                            this._urlChangeListeners.forEach(r => r(e, i));
                        }
                        subscribe(e, i, r) {
                            return this._subject.subscribe({ next: e, error: i, complete: r });
                        }
                        static #e = (this.normalizeQueryParams = pu);
                        static #t = (this.joinWithSlash = vC);
                        static #n = (this.stripTrailingSlash = _C);
                        static #i = (this.ɵfac = function (i) {
                            return new (i || t)(Se(fm));
                        });
                        static #r = (this.ɵprov = We({
                            token: t,
                            factory: () =>
                                (function QR() {
                                    return new yC(Se(fm));
                                })(),
                            providedIn: 'root',
                        }));
                    }
                    return t;
                })();
            function bC(t) {
                return t.replace(/\/index.html$/, '');
            }
            var T4 = (function (t) {
                    return (
                        (t[(t.Decimal = 0)] = 'Decimal'),
                        (t[(t.Percent = 1)] = 'Percent'),
                        (t[(t.Currency = 2)] = 'Currency'),
                        (t[(t.Scientific = 3)] = 'Scientific'),
                        t
                    );
                })(T4 || {}),
                Er = (function (t) {
                    return (t[(t.Format = 0)] = 'Format'), (t[(t.Standalone = 1)] = 'Standalone'), t;
                })(Er || {}),
                Jn = (function (t) {
                    return (
                        (t[(t.Narrow = 0)] = 'Narrow'),
                        (t[(t.Abbreviated = 1)] = 'Abbreviated'),
                        (t[(t.Wide = 2)] = 'Wide'),
                        (t[(t.Short = 3)] = 'Short'),
                        t
                    );
                })(Jn || {}),
                Vo = (function (t) {
                    return (
                        (t[(t.Short = 0)] = 'Short'),
                        (t[(t.Medium = 1)] = 'Medium'),
                        (t[(t.Long = 2)] = 'Long'),
                        (t[(t.Full = 3)] = 'Full'),
                        t
                    );
                })(Vo || {});
            const Rr = {
                Decimal: 0,
                Group: 1,
                List: 2,
                PercentSign: 3,
                PlusSign: 4,
                MinusSign: 5,
                Exponential: 6,
                SuperscriptingExponent: 7,
                PerMille: 8,
                Infinity: 9,
                NaN: 10,
                TimeSeparator: 11,
                CurrencyDecimal: 12,
                CurrencyGroup: 13,
            };
            function gu(t, n, e) {
                const i = Qs(t),
                    s = sa([i[qi.DayPeriodsFormat], i[qi.DayPeriodsStandalone]], n);
                return sa(s, e);
            }
            function D4(t, n) {
                return sa(Qs(t)[qi.DateFormat], n);
            }
            function x4(t, n) {
                return sa(Qs(t)[qi.TimeFormat], n);
            }
            function k4(t, n) {
                return sa(Qs(t)[qi.DateTimeFormat], n);
            }
            function ra(t, n) {
                const e = Qs(t),
                    i = e[qi.NumberSymbols][n];
                if (typeof i > 'u') {
                    if (n === Rr.CurrencyDecimal) return e[qi.NumberSymbols][Rr.Decimal];
                    if (n === Rr.CurrencyGroup) return e[qi.NumberSymbols][Rr.Group];
                }
                return i;
            }
            function wC(t) {
                if (!t[qi.ExtraData])
                    throw new Error(
                        `Missing extra locale data for the locale "${
                            t[qi.LocaleId]
                        }". Use "registerLocaleData" to load new data. See the "I18n guide" on angular.io to know more.`,
                    );
            }
            function sa(t, n) {
                for (let e = n; e > -1; e--) if (typeof t[e] < 'u') return t[e];
                throw new Error('Locale data API: locale data undefined');
            }
            function pm(t) {
                const [n, e] = t.split(':');
                return { hours: +n, minutes: +e };
            }
            const dV =
                    /^(\d{4,})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/,
                E4 = {},
                hV =
                    /((?:[^BEGHLMOSWYZabcdhmswyz']+)|(?:'(?:[^']|'')*')|(?:G{1,5}|y{1,4}|Y{1,4}|M{1,5}|L{1,5}|w{1,2}|W{1}|d{1,2}|E{1,6}|c{1,6}|a{1,5}|b{1,5}|B{1,5}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|O{1,4}))([\s\S]*)/;
            var El = (function (t) {
                    return (
                        (t[(t.Short = 0)] = 'Short'),
                        (t[(t.ShortGMT = 1)] = 'ShortGMT'),
                        (t[(t.Long = 2)] = 'Long'),
                        (t[(t.Extended = 3)] = 'Extended'),
                        t
                    );
                })(El || {}),
                ui = (function (t) {
                    return (
                        (t[(t.FullYear = 0)] = 'FullYear'),
                        (t[(t.Month = 1)] = 'Month'),
                        (t[(t.Date = 2)] = 'Date'),
                        (t[(t.Hours = 3)] = 'Hours'),
                        (t[(t.Minutes = 4)] = 'Minutes'),
                        (t[(t.Seconds = 5)] = 'Seconds'),
                        (t[(t.FractionalSeconds = 6)] = 'FractionalSeconds'),
                        (t[(t.Day = 7)] = 'Day'),
                        t
                    );
                })(ui || {}),
                di = (function (t) {
                    return (
                        (t[(t.DayPeriods = 0)] = 'DayPeriods'),
                        (t[(t.Days = 1)] = 'Days'),
                        (t[(t.Months = 2)] = 'Months'),
                        (t[(t.Eras = 3)] = 'Eras'),
                        t
                    );
                })(di || {});
            function MC(t, n, e, i) {
                let r = (function CV(t) {
                    if (DC(t)) return t;
                    if ('number' == typeof t && !isNaN(t)) return new Date(t);
                    if ('string' == typeof t) {
                        if (((t = t.trim()), /^(\d{4}(-\d{1,2}(-\d{1,2})?)?)$/.test(t))) {
                            const [r, s = 1, o = 1] = t.split('-').map(a => +a);
                            return I4(r, s - 1, o);
                        }
                        const e = parseFloat(t);
                        if (!isNaN(t - e)) return new Date(e);
                        let i;
                        if ((i = t.match(dV)))
                            return (function wV(t) {
                                const n = new Date(0);
                                let e = 0,
                                    i = 0;
                                const r = t[8] ? n.setUTCFullYear : n.setFullYear,
                                    s = t[8] ? n.setUTCHours : n.setHours;
                                t[9] && ((e = Number(t[9] + t[10])), (i = Number(t[9] + t[11]))),
                                    r.call(n, Number(t[1]), Number(t[2]) - 1, Number(t[3]));
                                const o = Number(t[4] || 0) - e,
                                    a = Number(t[5] || 0) - i,
                                    l = Number(t[6] || 0),
                                    c = Math.floor(1e3 * parseFloat('0.' + (t[7] || 0)));
                                return s.call(n, o, a, l, c), n;
                            })(i);
                    }
                    const n = new Date(t);
                    if (!DC(n)) throw new Error(`Unable to convert "${t}" into a date`);
                    return n;
                })(t);
                n = Il(e, n) || n;
                let a,
                    o = [];
                for (; n; ) {
                    if (((a = hV.exec(n)), !a)) {
                        o.push(n);
                        break;
                    }
                    {
                        o = o.concat(a.slice(1));
                        const f = o.pop();
                        if (!f) break;
                        n = f;
                    }
                }
                let l = r.getTimezoneOffset();
                i &&
                    ((l = TC(i, l)),
                    (r = (function bV(t, n, e) {
                        const i = e ? -1 : 1,
                            r = t.getTimezoneOffset();
                        return (function yV(t, n) {
                            return (t = new Date(t.getTime())).setMinutes(t.getMinutes() + n), t;
                        })(t, i * (TC(n, r) - r));
                    })(r, i, !0)));
                let c = '';
                return (
                    o.forEach(f => {
                        const g = (function _V(t) {
                            if (vm[t]) return vm[t];
                            let n;
                            switch (t) {
                                case 'G':
                                case 'GG':
                                case 'GGG':
                                    n = Yi(di.Eras, Jn.Abbreviated);
                                    break;
                                case 'GGGG':
                                    n = Yi(di.Eras, Jn.Wide);
                                    break;
                                case 'GGGGG':
                                    n = Yi(di.Eras, Jn.Narrow);
                                    break;
                                case 'y':
                                    n = Vr(ui.FullYear, 1, 0, !1, !0);
                                    break;
                                case 'yy':
                                    n = Vr(ui.FullYear, 2, 0, !0, !0);
                                    break;
                                case 'yyy':
                                    n = Vr(ui.FullYear, 3, 0, !1, !0);
                                    break;
                                case 'yyyy':
                                    n = Vr(ui.FullYear, 4, 0, !1, !0);
                                    break;
                                case 'Y':
                                    n = z4(1);
                                    break;
                                case 'YY':
                                    n = z4(2, !0);
                                    break;
                                case 'YYY':
                                    n = z4(3);
                                    break;
                                case 'YYYY':
                                    n = z4(4);
                                    break;
                                case 'M':
                                case 'L':
                                    n = Vr(ui.Month, 1, 1);
                                    break;
                                case 'MM':
                                case 'LL':
                                    n = Vr(ui.Month, 2, 1);
                                    break;
                                case 'MMM':
                                    n = Yi(di.Months, Jn.Abbreviated);
                                    break;
                                case 'MMMM':
                                    n = Yi(di.Months, Jn.Wide);
                                    break;
                                case 'MMMMM':
                                    n = Yi(di.Months, Jn.Narrow);
                                    break;
                                case 'LLL':
                                    n = Yi(di.Months, Jn.Abbreviated, Er.Standalone);
                                    break;
                                case 'LLLL':
                                    n = Yi(di.Months, Jn.Wide, Er.Standalone);
                                    break;
                                case 'LLLLL':
                                    n = Yi(di.Months, Jn.Narrow, Er.Standalone);
                                    break;
                                case 'w':
                                    n = gm(1);
                                    break;
                                case 'ww':
                                    n = gm(2);
                                    break;
                                case 'W':
                                    n = gm(1, !0);
                                    break;
                                case 'd':
                                    n = Vr(ui.Date, 1);
                                    break;
                                case 'dd':
                                    n = Vr(ui.Date, 2);
                                    break;
                                case 'c':
                                case 'cc':
                                    n = Vr(ui.Day, 1);
                                    break;
                                case 'ccc':
                                    n = Yi(di.Days, Jn.Abbreviated, Er.Standalone);
                                    break;
                                case 'cccc':
                                    n = Yi(di.Days, Jn.Wide, Er.Standalone);
                                    break;
                                case 'ccccc':
                                    n = Yi(di.Days, Jn.Narrow, Er.Standalone);
                                    break;
                                case 'cccccc':
                                    n = Yi(di.Days, Jn.Short, Er.Standalone);
                                    break;
                                case 'E':
                                case 'EE':
                                case 'EEE':
                                    n = Yi(di.Days, Jn.Abbreviated);
                                    break;
                                case 'EEEE':
                                    n = Yi(di.Days, Jn.Wide);
                                    break;
                                case 'EEEEE':
                                    n = Yi(di.Days, Jn.Narrow);
                                    break;
                                case 'EEEEEE':
                                    n = Yi(di.Days, Jn.Short);
                                    break;
                                case 'a':
                                case 'aa':
                                case 'aaa':
                                    n = Yi(di.DayPeriods, Jn.Abbreviated);
                                    break;
                                case 'aaaa':
                                    n = Yi(di.DayPeriods, Jn.Wide);
                                    break;
                                case 'aaaaa':
                                    n = Yi(di.DayPeriods, Jn.Narrow);
                                    break;
                                case 'b':
                                case 'bb':
                                case 'bbb':
                                    n = Yi(di.DayPeriods, Jn.Abbreviated, Er.Standalone, !0);
                                    break;
                                case 'bbbb':
                                    n = Yi(di.DayPeriods, Jn.Wide, Er.Standalone, !0);
                                    break;
                                case 'bbbbb':
                                    n = Yi(di.DayPeriods, Jn.Narrow, Er.Standalone, !0);
                                    break;
                                case 'B':
                                case 'BB':
                                case 'BBB':
                                    n = Yi(di.DayPeriods, Jn.Abbreviated, Er.Format, !0);
                                    break;
                                case 'BBBB':
                                    n = Yi(di.DayPeriods, Jn.Wide, Er.Format, !0);
                                    break;
                                case 'BBBBB':
                                    n = Yi(di.DayPeriods, Jn.Narrow, Er.Format, !0);
                                    break;
                                case 'h':
                                    n = Vr(ui.Hours, 1, -12);
                                    break;
                                case 'hh':
                                    n = Vr(ui.Hours, 2, -12);
                                    break;
                                case 'H':
                                    n = Vr(ui.Hours, 1);
                                    break;
                                case 'HH':
                                    n = Vr(ui.Hours, 2);
                                    break;
                                case 'm':
                                    n = Vr(ui.Minutes, 1);
                                    break;
                                case 'mm':
                                    n = Vr(ui.Minutes, 2);
                                    break;
                                case 's':
                                    n = Vr(ui.Seconds, 1);
                                    break;
                                case 'ss':
                                    n = Vr(ui.Seconds, 2);
                                    break;
                                case 'S':
                                    n = Vr(ui.FractionalSeconds, 1);
                                    break;
                                case 'SS':
                                    n = Vr(ui.FractionalSeconds, 2);
                                    break;
                                case 'SSS':
                                    n = Vr(ui.FractionalSeconds, 3);
                                    break;
                                case 'Z':
                                case 'ZZ':
                                case 'ZZZ':
                                    n = L4(El.Short);
                                    break;
                                case 'ZZZZZ':
                                    n = L4(El.Extended);
                                    break;
                                case 'O':
                                case 'OO':
                                case 'OOO':
                                case 'z':
                                case 'zz':
                                case 'zzz':
                                    n = L4(El.ShortGMT);
                                    break;
                                case 'OOOO':
                                case 'ZZZZ':
                                case 'zzzz':
                                    n = L4(El.Long);
                                    break;
                                default:
                                    return null;
                            }
                            return (vm[t] = n), n;
                        })(f);
                        c += g ? g(r, e, l) : "''" === f ? "'" : f.replace(/(^'|'$)/g, '').replace(/''/g, "'");
                    }),
                    c
                );
            }
            function I4(t, n, e) {
                const i = new Date(0);
                return i.setFullYear(t, n, e), i.setHours(0, 0, 0), i;
            }
            function Il(t, n) {
                const e = (function eV(t) {
                    return Qs(t)[qi.LocaleId];
                })(t);
                if (((E4[e] ??= {}), E4[e][n])) return E4[e][n];
                let i = '';
                switch (n) {
                    case 'shortDate':
                        i = D4(t, Vo.Short);
                        break;
                    case 'mediumDate':
                        i = D4(t, Vo.Medium);
                        break;
                    case 'longDate':
                        i = D4(t, Vo.Long);
                        break;
                    case 'fullDate':
                        i = D4(t, Vo.Full);
                        break;
                    case 'shortTime':
                        i = x4(t, Vo.Short);
                        break;
                    case 'mediumTime':
                        i = x4(t, Vo.Medium);
                        break;
                    case 'longTime':
                        i = x4(t, Vo.Long);
                        break;
                    case 'fullTime':
                        i = x4(t, Vo.Full);
                        break;
                    case 'short':
                        const r = Il(t, 'shortTime'),
                            s = Il(t, 'shortDate');
                        i = A4(k4(t, Vo.Short), [r, s]);
                        break;
                    case 'medium':
                        const o = Il(t, 'mediumTime'),
                            a = Il(t, 'mediumDate');
                        i = A4(k4(t, Vo.Medium), [o, a]);
                        break;
                    case 'long':
                        const l = Il(t, 'longTime'),
                            c = Il(t, 'longDate');
                        i = A4(k4(t, Vo.Long), [l, c]);
                        break;
                    case 'full':
                        const f = Il(t, 'fullTime'),
                            g = Il(t, 'fullDate');
                        i = A4(k4(t, Vo.Full), [f, g]);
                }
                return i && (E4[e][n] = i), i;
            }
            function A4(t, n) {
                return (
                    n &&
                        (t = t.replace(/\{([^}]+)}/g, function (e, i) {
                            return null != n && i in n ? n[i] : e;
                        })),
                    t
                );
            }
            function Sa(t, n, e = '-', i, r) {
                let s = '';
                (t < 0 || (r && t <= 0)) && (r ? (t = 1 - t) : ((t = -t), (s = e)));
                let o = String(t);
                for (; o.length < n; ) o = '0' + o;
                return i && (o = o.slice(o.length - n)), s + o;
            }
            function Vr(t, n, e = 0, i = !1, r = !1) {
                return function (s, o) {
                    let a = (function mV(t, n) {
                        switch (t) {
                            case ui.FullYear:
                                return n.getFullYear();
                            case ui.Month:
                                return n.getMonth();
                            case ui.Date:
                                return n.getDate();
                            case ui.Hours:
                                return n.getHours();
                            case ui.Minutes:
                                return n.getMinutes();
                            case ui.Seconds:
                                return n.getSeconds();
                            case ui.FractionalSeconds:
                                return n.getMilliseconds();
                            case ui.Day:
                                return n.getDay();
                            default:
                                throw new Error(`Unknown DateType value "${t}".`);
                        }
                    })(t, s);
                    if (((e > 0 || a > -e) && (a += e), t === ui.Hours)) 0 === a && -12 === e && (a = 12);
                    else if (t === ui.FractionalSeconds)
                        return (function fV(t, n) {
                            return Sa(t, 3).substring(0, n);
                        })(a, n);
                    const l = ra(o, Rr.MinusSign);
                    return Sa(a, n, l, i, r);
                };
            }
            function Yi(t, n, e = Er.Format, i = !1) {
                return function (r, s) {
                    return (function pV(t, n, e, i, r, s) {
                        switch (e) {
                            case di.Months:
                                return (function nV(t, n, e) {
                                    const i = Qs(t),
                                        s = sa([i[qi.MonthsFormat], i[qi.MonthsStandalone]], n);
                                    return sa(s, e);
                                })(n, r, i)[t.getMonth()];
                            case di.Days:
                                return (function tV(t, n, e) {
                                    const i = Qs(t),
                                        s = sa([i[qi.DaysFormat], i[qi.DaysStandalone]], n);
                                    return sa(s, e);
                                })(n, r, i)[t.getDay()];
                            case di.DayPeriods:
                                const o = t.getHours(),
                                    a = t.getMinutes();
                                if (s) {
                                    const c = (function oV(t) {
                                            const n = Qs(t);
                                            return (
                                                wC(n),
                                                (n[qi.ExtraData][2] || []).map(i =>
                                                    'string' == typeof i ? pm(i) : [pm(i[0]), pm(i[1])],
                                                )
                                            );
                                        })(n),
                                        f = (function aV(t, n, e) {
                                            const i = Qs(t);
                                            wC(i);
                                            const s = sa([i[qi.ExtraData][0], i[qi.ExtraData][1]], n) || [];
                                            return sa(s, e) || [];
                                        })(n, r, i),
                                        g = c.findIndex(E => {
                                            if (Array.isArray(E)) {
                                                const [P, V] = E,
                                                    W = o >= P.hours && a >= P.minutes,
                                                    ie = o < V.hours || (o === V.hours && a < V.minutes);
                                                if (P.hours < V.hours) {
                                                    if (W && ie) return !0;
                                                } else if (W || ie) return !0;
                                            } else if (E.hours === o && E.minutes === a) return !0;
                                            return !1;
                                        });
                                    if (-1 !== g) return f[g];
                                }
                                return gu(n, r, i)[o < 12 ? 0 : 1];
                            case di.Eras:
                                return (function iV(t, n) {
                                    return sa(Qs(t)[qi.Eras], n);
                                })(n, i)[t.getFullYear() <= 0 ? 0 : 1];
                            default:
                                throw new Error(`unexpected translation type ${e}`);
                        }
                    })(r, s, t, n, e, i);
                };
            }
            function L4(t) {
                return function (n, e, i) {
                    const r = -1 * i,
                        s = ra(e, Rr.MinusSign),
                        o = r > 0 ? Math.floor(r / 60) : Math.ceil(r / 60);
                    switch (t) {
                        case El.Short:
                            return (r >= 0 ? '+' : '') + Sa(o, 2, s) + Sa(Math.abs(r % 60), 2, s);
                        case El.ShortGMT:
                            return 'GMT' + (r >= 0 ? '+' : '') + Sa(o, 1, s);
                        case El.Long:
                            return 'GMT' + (r >= 0 ? '+' : '') + Sa(o, 2, s) + ':' + Sa(Math.abs(r % 60), 2, s);
                        case El.Extended:
                            return 0 === i ? 'Z' : (r >= 0 ? '+' : '') + Sa(o, 2, s) + ':' + Sa(Math.abs(r % 60), 2, s);
                        default:
                            throw new Error(`Unknown zone width "${t}"`);
                    }
                };
            }
            const gV = 0,
                O4 = 4;
            function SC(t) {
                const n = t.getDay(),
                    e = 0 === n ? -3 : O4 - n;
                return I4(t.getFullYear(), t.getMonth(), t.getDate() + e);
            }
            function gm(t, n = !1) {
                return function (e, i) {
                    let r;
                    if (n) {
                        const s = new Date(e.getFullYear(), e.getMonth(), 1).getDay() - 1,
                            o = e.getDate();
                        r = 1 + Math.floor((o + s) / 7);
                    } else {
                        const s = SC(e),
                            o = (function vV(t) {
                                const n = I4(t, gV, 1).getDay();
                                return I4(t, 0, 1 + (n <= O4 ? O4 : O4 + 7) - n);
                            })(s.getFullYear()),
                            a = s.getTime() - o.getTime();
                        r = 1 + Math.round(a / 6048e5);
                    }
                    return Sa(r, t, ra(i, Rr.MinusSign));
                };
            }
            function z4(t, n = !1) {
                return function (e, i) {
                    return Sa(SC(e).getFullYear(), t, ra(i, Rr.MinusSign), n);
                };
            }
            const vm = {};
            function TC(t, n) {
                t = t.replace(/:/g, '');
                const e = Date.parse('Jan 01, 1970 00:00:00 ' + t) / 6e4;
                return isNaN(e) ? n : e;
            }
            function DC(t) {
                return t instanceof Date && !isNaN(t.valueOf());
            }
            const MV = /^(\d+)?\.((\d+)(-(\d+))?)?$/;
            function Cm(t) {
                const n = parseInt(t);
                if (isNaN(n)) throw new Error('Invalid integer literal when parsing ' + t);
                return n;
            }
            function Mm(t, n, e) {
                return (function aP(t, n, e) {
                    'string' != typeof n && ((e = n), (n = t[qi.LocaleId])),
                        (n = n.toLowerCase().replace(/_/g, '-')),
                        (R1[n] = t),
                        e && (R1[n][qi.ExtraData] = e);
                })(t, n, e);
            }
            function IC(t, n) {
                n = encodeURIComponent(n);
                for (const e of t.split(';')) {
                    const i = e.indexOf('='),
                        [r, s] = -1 == i ? [e, ''] : [e.slice(0, i), e.slice(i + 1)];
                    if (r.trim() === n) return decodeURIComponent(s);
                }
                return null;
            }
            const Sm = /\s+/,
                AC = [];
            let sl = (() => {
                class t {
                    constructor(e, i) {
                        (this._ngEl = e), (this._renderer = i), (this.initialClasses = AC), (this.stateMap = new Map());
                    }
                    set klass(e) {
                        this.initialClasses = null != e ? e.trim().split(Sm) : AC;
                    }
                    set ngClass(e) {
                        this.rawClass = 'string' == typeof e ? e.trim().split(Sm) : e;
                    }
                    ngDoCheck() {
                        for (const i of this.initialClasses) this._updateState(i, !0);
                        const e = this.rawClass;
                        if (Array.isArray(e) || e instanceof Set) for (const i of e) this._updateState(i, !0);
                        else if (null != e) for (const i of Object.keys(e)) this._updateState(i, !!e[i]);
                        this._applyStateDiff();
                    }
                    _updateState(e, i) {
                        const r = this.stateMap.get(e);
                        void 0 !== r
                            ? (r.enabled !== i && ((r.changed = !0), (r.enabled = i)), (r.touched = !0))
                            : this.stateMap.set(e, { enabled: i, changed: !0, touched: !0 });
                    }
                    _applyStateDiff() {
                        for (const e of this.stateMap) {
                            const i = e[0],
                                r = e[1];
                            r.changed
                                ? (this._toggleClass(i, r.enabled), (r.changed = !1))
                                : r.touched || (r.enabled && this._toggleClass(i, !1), this.stateMap.delete(i)),
                                (r.touched = !1);
                        }
                    }
                    _toggleClass(e, i) {
                        (e = e.trim()).length > 0 &&
                            e.split(Sm).forEach(r => {
                                i
                                    ? this._renderer.addClass(this._ngEl.nativeElement, r)
                                    : this._renderer.removeClass(this._ngEl.nativeElement, r);
                            });
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Pn), te(Ps));
                    });
                    static #t = (this.ɵdir = gt({
                        type: t,
                        selectors: [['', 'ngClass', '']],
                        inputs: { klass: [de.None, 'class', 'klass'], ngClass: 'ngClass' },
                        standalone: !0,
                    }));
                }
                return t;
            })();
            class PV {
                constructor(n, e, i, r) {
                    (this.$implicit = n), (this.ngForOf = e), (this.index = i), (this.count = r);
                }
                get first() {
                    return 0 === this.index;
                }
                get last() {
                    return this.index === this.count - 1;
                }
                get even() {
                    return this.index % 2 == 0;
                }
                get odd() {
                    return !this.even;
                }
            }
            let oa = (() => {
                class t {
                    set ngForOf(e) {
                        (this._ngForOf = e), (this._ngForOfDirty = !0);
                    }
                    set ngForTrackBy(e) {
                        this._trackByFn = e;
                    }
                    get ngForTrackBy() {
                        return this._trackByFn;
                    }
                    constructor(e, i, r) {
                        (this._viewContainer = e),
                            (this._template = i),
                            (this._differs = r),
                            (this._ngForOf = null),
                            (this._ngForOfDirty = !0),
                            (this._differ = null);
                    }
                    set ngForTemplate(e) {
                        e && (this._template = e);
                    }
                    ngDoCheck() {
                        if (this._ngForOfDirty) {
                            this._ngForOfDirty = !1;
                            const e = this._ngForOf;
                            !this._differ && e && (this._differ = this._differs.find(e).create(this.ngForTrackBy));
                        }
                        if (this._differ) {
                            const e = this._differ.diff(this._ngForOf);
                            e && this._applyChanges(e);
                        }
                    }
                    _applyChanges(e) {
                        const i = this._viewContainer;
                        e.forEachOperation((r, s, o) => {
                            if (null == r.previousIndex)
                                i.createEmbeddedView(
                                    this._template,
                                    new PV(r.item, this._ngForOf, -1, -1),
                                    null === o ? void 0 : o,
                                );
                            else if (null == o) i.remove(null === s ? void 0 : s);
                            else if (null !== s) {
                                const a = i.get(s);
                                i.move(a, o), OC(a, r);
                            }
                        });
                        for (let r = 0, s = i.length; r < s; r++) {
                            const a = i.get(r).context;
                            (a.index = r), (a.count = s), (a.ngForOf = this._ngForOf);
                        }
                        e.forEachIdentityChange(r => {
                            OC(i.get(r.currentIndex), r);
                        });
                    }
                    static ngTemplateContextGuard(e, i) {
                        return !0;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(go), te(Qr), te(um));
                    });
                    static #t = (this.ɵdir = gt({
                        type: t,
                        selectors: [['', 'ngFor', '', 'ngForOf', '']],
                        inputs: { ngForOf: 'ngForOf', ngForTrackBy: 'ngForTrackBy', ngForTemplate: 'ngForTemplate' },
                        standalone: !0,
                    }));
                }
                return t;
            })();
            function OC(t, n) {
                t.context.$implicit = n.item;
            }
            let hi = (() => {
                class t {
                    constructor(e, i) {
                        (this._viewContainer = e),
                            (this._context = new NV()),
                            (this._thenTemplateRef = null),
                            (this._elseTemplateRef = null),
                            (this._thenViewRef = null),
                            (this._elseViewRef = null),
                            (this._thenTemplateRef = i);
                    }
                    set ngIf(e) {
                        (this._context.$implicit = this._context.ngIf = e), this._updateView();
                    }
                    set ngIfThen(e) {
                        zC('ngIfThen', e), (this._thenTemplateRef = e), (this._thenViewRef = null), this._updateView();
                    }
                    set ngIfElse(e) {
                        zC('ngIfElse', e), (this._elseTemplateRef = e), (this._elseViewRef = null), this._updateView();
                    }
                    _updateView() {
                        this._context.$implicit
                            ? this._thenViewRef ||
                              (this._viewContainer.clear(),
                              (this._elseViewRef = null),
                              this._thenTemplateRef &&
                                  (this._thenViewRef = this._viewContainer.createEmbeddedView(
                                      this._thenTemplateRef,
                                      this._context,
                                  )))
                            : this._elseViewRef ||
                              (this._viewContainer.clear(),
                              (this._thenViewRef = null),
                              this._elseTemplateRef &&
                                  (this._elseViewRef = this._viewContainer.createEmbeddedView(
                                      this._elseTemplateRef,
                                      this._context,
                                  )));
                    }
                    static ngTemplateContextGuard(e, i) {
                        return !0;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(go), te(Qr));
                    });
                    static #t = (this.ɵdir = gt({
                        type: t,
                        selectors: [['', 'ngIf', '']],
                        inputs: { ngIf: 'ngIf', ngIfThen: 'ngIfThen', ngIfElse: 'ngIfElse' },
                        standalone: !0,
                    }));
                }
                return t;
            })();
            class NV {
                constructor() {
                    (this.$implicit = null), (this.ngIf = null);
                }
            }
            function zC(t, n) {
                if (n && !n.createEmbeddedView) throw new Error(`${t} must be a TemplateRef, but received '${tr(n)}'.`);
            }
            class Tm {
                constructor(n, e) {
                    (this._viewContainerRef = n), (this._templateRef = e), (this._created = !1);
                }
                create() {
                    (this._created = !0), this._viewContainerRef.createEmbeddedView(this._templateRef);
                }
                destroy() {
                    (this._created = !1), this._viewContainerRef.clear();
                }
                enforceState(n) {
                    n && !this._created ? this.create() : !n && this._created && this.destroy();
                }
            }
            let Ho = (() => {
                    class t {
                        constructor() {
                            (this._defaultViews = []),
                                (this._defaultUsed = !1),
                                (this._caseCount = 0),
                                (this._lastCaseCheckIndex = 0),
                                (this._lastCasesMatched = !1);
                        }
                        set ngSwitch(e) {
                            (this._ngSwitch = e), 0 === this._caseCount && this._updateDefaultCases(!0);
                        }
                        _addCase() {
                            return this._caseCount++;
                        }
                        _addDefault(e) {
                            this._defaultViews.push(e);
                        }
                        _matchCase(e) {
                            const i = e === this._ngSwitch;
                            return (
                                (this._lastCasesMatched ||= i),
                                this._lastCaseCheckIndex++,
                                this._lastCaseCheckIndex === this._caseCount &&
                                    (this._updateDefaultCases(!this._lastCasesMatched),
                                    (this._lastCaseCheckIndex = 0),
                                    (this._lastCasesMatched = !1)),
                                i
                            );
                        }
                        _updateDefaultCases(e) {
                            if (this._defaultViews.length > 0 && e !== this._defaultUsed) {
                                this._defaultUsed = e;
                                for (const i of this._defaultViews) i.enforceState(e);
                            }
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'ngSwitch', '']],
                            inputs: { ngSwitch: 'ngSwitch' },
                            standalone: !0,
                        }));
                    }
                    return t;
                })(),
                Ta = (() => {
                    class t {
                        constructor(e, i, r) {
                            (this.ngSwitch = r), r._addCase(), (this._view = new Tm(e, i));
                        }
                        ngDoCheck() {
                            this._view.enforceState(this.ngSwitch._matchCase(this.ngSwitchCase));
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(go), te(Qr), te(Ho, 9));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'ngSwitchCase', '']],
                            inputs: { ngSwitchCase: 'ngSwitchCase' },
                            standalone: !0,
                        }));
                    }
                    return t;
                })(),
                Bd = (() => {
                    class t {
                        constructor(e, i, r) {
                            r._addDefault(new Tm(e, i));
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(go), te(Qr), te(Ho, 9));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'ngSwitchDefault', '']],
                            standalone: !0,
                        }));
                    }
                    return t;
                })(),
                mc = (() => {
                    class t {
                        constructor(e, i, r) {
                            (this._ngEl = e),
                                (this._differs = i),
                                (this._renderer = r),
                                (this._ngStyle = null),
                                (this._differ = null);
                        }
                        set ngStyle(e) {
                            (this._ngStyle = e), !this._differ && e && (this._differ = this._differs.find(e).create());
                        }
                        ngDoCheck() {
                            if (this._differ) {
                                const e = this._differ.diff(this._ngStyle);
                                e && this._applyChanges(e);
                            }
                        }
                        _setStyle(e, i) {
                            const [r, s] = e.split('.'),
                                o = -1 === r.indexOf('-') ? void 0 : lc.DashCase;
                            null != i
                                ? this._renderer.setStyle(this._ngEl.nativeElement, r, s ? `${i}${s}` : i, o)
                                : this._renderer.removeStyle(this._ngEl.nativeElement, r, o);
                        }
                        _applyChanges(e) {
                            e.forEachRemovedItem(i => this._setStyle(i.key, null)),
                                e.forEachAddedItem(i => this._setStyle(i.key, i.currentValue)),
                                e.forEachChangedItem(i => this._setStyle(i.key, i.currentValue));
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Pn), te(y4), te(Ps));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'ngStyle', '']],
                            inputs: { ngStyle: 'ngStyle' },
                            standalone: !0,
                        }));
                    }
                    return t;
                })(),
                Al = (() => {
                    class t {
                        constructor(e) {
                            (this._viewContainerRef = e),
                                (this._viewRef = null),
                                (this.ngTemplateOutletContext = null),
                                (this.ngTemplateOutlet = null),
                                (this.ngTemplateOutletInjector = null);
                        }
                        ngOnChanges(e) {
                            if (this._shouldRecreateView(e)) {
                                const i = this._viewContainerRef;
                                if ((this._viewRef && i.remove(i.indexOf(this._viewRef)), !this.ngTemplateOutlet))
                                    return void (this._viewRef = null);
                                const r = this._createContextForwardProxy();
                                this._viewRef = i.createEmbeddedView(this.ngTemplateOutlet, r, {
                                    injector: this.ngTemplateOutletInjector ?? void 0,
                                });
                            }
                        }
                        _shouldRecreateView(e) {
                            return !!e.ngTemplateOutlet || !!e.ngTemplateOutletInjector;
                        }
                        _createContextForwardProxy() {
                            return new Proxy(
                                {},
                                {
                                    set: (e, i, r) =>
                                        !!this.ngTemplateOutletContext &&
                                        Reflect.set(this.ngTemplateOutletContext, i, r),
                                    get: (e, i, r) => {
                                        if (this.ngTemplateOutletContext)
                                            return Reflect.get(this.ngTemplateOutletContext, i, r);
                                    },
                                },
                            );
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(go));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'ngTemplateOutlet', '']],
                            inputs: {
                                ngTemplateOutletContext: 'ngTemplateOutletContext',
                                ngTemplateOutlet: 'ngTemplateOutlet',
                                ngTemplateOutletInjector: 'ngTemplateOutletInjector',
                            },
                            standalone: !0,
                            features: [D],
                        }));
                    }
                    return t;
                })();
            function Da(t, n) {
                return new Me(2100, !1);
            }
            class VV {
                createSubscription(n, e) {
                    return fC(() =>
                        n.subscribe({
                            next: e,
                            error: i => {
                                throw i;
                            },
                        }),
                    );
                }
                dispose(n) {
                    fC(() => n.unsubscribe());
                }
            }
            class HV {
                createSubscription(n, e) {
                    return n.then(e, i => {
                        throw i;
                    });
                }
                dispose(n) {}
            }
            const UV = new HV(),
                BV = new VV();
            let NC = (() => {
                    class t {
                        constructor(e) {
                            (this._latestValue = null),
                                (this.markForCheckOnValueUpdate = !0),
                                (this._subscription = null),
                                (this._obj = null),
                                (this._strategy = null),
                                (this._ref = e);
                        }
                        ngOnDestroy() {
                            this._subscription && this._dispose(), (this._ref = null);
                        }
                        transform(e) {
                            if (!this._obj) {
                                if (e)
                                    try {
                                        (this.markForCheckOnValueUpdate = !1), this._subscribe(e);
                                    } finally {
                                        this.markForCheckOnValueUpdate = !0;
                                    }
                                return this._latestValue;
                            }
                            return e !== this._obj ? (this._dispose(), this.transform(e)) : this._latestValue;
                        }
                        _subscribe(e) {
                            (this._obj = e),
                                (this._strategy = this._selectStrategy(e)),
                                (this._subscription = this._strategy.createSubscription(e, i =>
                                    this._updateLatestValue(e, i),
                                ));
                        }
                        _selectStrategy(e) {
                            if (m4(e)) return UV;
                            if (Mb(e)) return BV;
                            throw Da();
                        }
                        _dispose() {
                            this._strategy.dispose(this._subscription),
                                (this._latestValue = null),
                                (this._subscription = null),
                                (this._obj = null);
                        }
                        _updateLatestValue(e, i) {
                            e === this._obj &&
                                ((this._latestValue = i), this.markForCheckOnValueUpdate && this._ref?.markForCheck());
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(kr, 16));
                        });
                        static #t = (this.ɵpipe = jr({ name: 'async', type: t, pure: !1, standalone: !0 }));
                    }
                    return t;
                })(),
                FC = (() => {
                    class t {
                        constructor(e) {
                            (this.differs = e), (this.keyValues = []), (this.compareFn = RC);
                        }
                        transform(e, i = RC) {
                            if (!e || (!(e instanceof Map) && 'object' != typeof e)) return null;
                            this.differ ??= this.differs.find(e).create();
                            const r = this.differ.diff(e),
                                s = i !== this.compareFn;
                            return (
                                r &&
                                    ((this.keyValues = []),
                                    r.forEachItem(o => {
                                        this.keyValues.push(
                                            (function tH(t, n) {
                                                return { key: t, value: n };
                                            })(o.key, o.currentValue),
                                        );
                                    })),
                                (r || s) && (this.keyValues.sort(i), (this.compareFn = i)),
                                this.keyValues
                            );
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(y4, 16));
                        });
                        static #t = (this.ɵpipe = jr({ name: 'keyvalue', type: t, pure: !1, standalone: !0 }));
                    }
                    return t;
                })();
            function RC(t, n) {
                const e = t.key,
                    i = n.key;
                if (e === i) return 0;
                if (void 0 === e) return 1;
                if (void 0 === i) return -1;
                if (null === e) return 1;
                if (null === i) return -1;
                if ('string' == typeof e && 'string' == typeof i) return e < i ? -1 : 1;
                if ('number' == typeof e && 'number' == typeof i) return e - i;
                if ('boolean' == typeof e && 'boolean' == typeof i) return e < i ? -1 : 1;
                const r = String(e),
                    s = String(i);
                return r == s ? 0 : r < s ? -1 : 1;
            }
            let VC = (() => {
                class t {
                    constructor(e) {
                        this._locale = e;
                    }
                    transform(e, i, r) {
                        if (
                            !(function Dm(t) {
                                return !(null == t || '' === t || t != t);
                            })(e)
                        )
                            return null;
                        r ||= this._locale;
                        try {
                            return (function EV(t, n, e) {
                                return (function ym(t, n, e, i, r, s, o = !1) {
                                    let a = '',
                                        l = !1;
                                    if (isFinite(t)) {
                                        let c = (function AV(t) {
                                            let i,
                                                r,
                                                s,
                                                o,
                                                a,
                                                n = Math.abs(t) + '',
                                                e = 0;
                                            for (
                                                (r = n.indexOf('.')) > -1 && (n = n.replace('.', '')),
                                                    (s = n.search(/e/i)) > 0
                                                        ? (r < 0 && (r = s),
                                                          (r += +n.slice(s + 1)),
                                                          (n = n.substring(0, s)))
                                                        : r < 0 && (r = n.length),
                                                    s = 0;
                                                '0' === n.charAt(s);
                                                s++
                                            );
                                            if (s === (a = n.length)) (i = [0]), (r = 1);
                                            else {
                                                for (a--; '0' === n.charAt(a); ) a--;
                                                for (r -= s, i = [], o = 0; s <= a; s++, o++)
                                                    i[o] = Number(n.charAt(s));
                                            }
                                            return (
                                                r > 22 && ((i = i.splice(0, 21)), (e = r - 1), (r = 1)),
                                                { digits: i, exponent: e, integerLen: r }
                                            );
                                        })(t);
                                        o &&
                                            (c = (function IV(t) {
                                                if (0 === t.digits[0]) return t;
                                                const n = t.digits.length - t.integerLen;
                                                return (
                                                    t.exponent
                                                        ? (t.exponent += 2)
                                                        : (0 === n ? t.digits.push(0, 0) : 1 === n && t.digits.push(0),
                                                          (t.integerLen += 2)),
                                                    t
                                                );
                                            })(c));
                                        let f = n.minInt,
                                            g = n.minFrac,
                                            E = n.maxFrac;
                                        if (s) {
                                            const fe = s.match(MV);
                                            if (null === fe) throw new Error(`${s} is not a valid digit info`);
                                            const ze = fe[1],
                                                nt = fe[3],
                                                kt = fe[5];
                                            null != ze && (f = Cm(ze)),
                                                null != nt && (g = Cm(nt)),
                                                null != kt ? (E = Cm(kt)) : null != nt && g > E && (E = g);
                                        }
                                        !(function LV(t, n, e) {
                                            if (n > e)
                                                throw new Error(
                                                    `The minimum number of digits after fraction (${n}) is higher than the maximum (${e}).`,
                                                );
                                            let i = t.digits,
                                                r = i.length - t.integerLen;
                                            const s = Math.min(Math.max(n, r), e);
                                            let o = s + t.integerLen,
                                                a = i[o];
                                            if (o > 0) {
                                                i.splice(Math.max(t.integerLen, o));
                                                for (let g = o; g < i.length; g++) i[g] = 0;
                                            } else {
                                                (r = Math.max(0, r)),
                                                    (t.integerLen = 1),
                                                    (i.length = Math.max(1, (o = s + 1))),
                                                    (i[0] = 0);
                                                for (let g = 1; g < o; g++) i[g] = 0;
                                            }
                                            if (a >= 5)
                                                if (o - 1 < 0) {
                                                    for (let g = 0; g > o; g--) i.unshift(0), t.integerLen++;
                                                    i.unshift(1), t.integerLen++;
                                                } else i[o - 1]++;
                                            for (; r < Math.max(0, s); r++) i.push(0);
                                            let l = 0 !== s;
                                            const c = n + t.integerLen,
                                                f = i.reduceRight(function (g, E, P, V) {
                                                    return (
                                                        (V[P] = (E += g) < 10 ? E : E - 10),
                                                        l && (0 === V[P] && P >= c ? V.pop() : (l = !1)),
                                                        E >= 10 ? 1 : 0
                                                    );
                                                }, 0);
                                            f && (i.unshift(f), t.integerLen++);
                                        })(c, g, E);
                                        let P = c.digits,
                                            V = c.integerLen;
                                        const W = c.exponent;
                                        let ie = [];
                                        for (l = P.every(fe => !fe); V < f; V++) P.unshift(0);
                                        for (; V < 0; V++) P.unshift(0);
                                        V > 0 ? (ie = P.splice(V, P.length)) : ((ie = P), (P = [0]));
                                        const he = [];
                                        for (
                                            P.length >= n.lgSize && he.unshift(P.splice(-n.lgSize, P.length).join(''));
                                            P.length > n.gSize;

                                        )
                                            he.unshift(P.splice(-n.gSize, P.length).join(''));
                                        P.length && he.unshift(P.join('')),
                                            (a = he.join(ra(e, i))),
                                            ie.length && (a += ra(e, r) + ie.join('')),
                                            W && (a += ra(e, Rr.Exponential) + '+' + W);
                                    } else a = ra(e, Rr.Infinity);
                                    return (a = t < 0 && !l ? n.negPre + a + n.negSuf : n.posPre + a + n.posSuf), a;
                                })(
                                    t,
                                    (function bm(t, n = '-') {
                                        const e = {
                                                minInt: 1,
                                                minFrac: 0,
                                                maxFrac: 0,
                                                posPre: '',
                                                posSuf: '',
                                                negPre: '',
                                                negSuf: '',
                                                gSize: 0,
                                                lgSize: 0,
                                            },
                                            i = t.split(';'),
                                            r = i[0],
                                            s = i[1],
                                            o =
                                                -1 !== r.indexOf('.')
                                                    ? r.split('.')
                                                    : [
                                                          r.substring(0, r.lastIndexOf('0') + 1),
                                                          r.substring(r.lastIndexOf('0') + 1),
                                                      ],
                                            a = o[0],
                                            l = o[1] || '';
                                        e.posPre = a.substring(0, a.indexOf('#'));
                                        for (let f = 0; f < l.length; f++) {
                                            const g = l.charAt(f);
                                            '0' === g
                                                ? (e.minFrac = e.maxFrac = f + 1)
                                                : '#' === g
                                                ? (e.maxFrac = f + 1)
                                                : (e.posSuf += g);
                                        }
                                        const c = a.split(',');
                                        if (
                                            ((e.gSize = c[1] ? c[1].length : 0),
                                            (e.lgSize = c[2] || c[1] ? (c[2] || c[1]).length : 0),
                                            s)
                                        ) {
                                            const f = r.length - e.posPre.length - e.posSuf.length,
                                                g = s.indexOf('#');
                                            (e.negPre = s.substring(0, g).replace(/'/g, '')),
                                                (e.negSuf = s.slice(g + f).replace(/'/g, ''));
                                        } else (e.negPre = n + e.posPre), (e.negSuf = e.posSuf);
                                        return e;
                                    })(
                                        (function mm(t, n) {
                                            return Qs(t)[qi.NumberFormats][n];
                                        })(n, T4.Decimal),
                                        ra(n, Rr.MinusSign),
                                    ),
                                    n,
                                    Rr.Group,
                                    Rr.Decimal,
                                    e,
                                );
                            })(
                                (function xm(t) {
                                    if ('string' == typeof t && !isNaN(Number(t) - parseFloat(t))) return Number(t);
                                    if ('number' != typeof t) throw new Error(`${t} is not a number`);
                                    return t;
                                })(e),
                                r,
                                i,
                            );
                        } catch (s) {
                            throw Da();
                        }
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(kl, 16));
                    });
                    static #t = (this.ɵpipe = jr({ name: 'number', type: t, pure: !0, standalone: !0 }));
                }
                return t;
            })();
            let HC = (() => {
                class t {
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵmod = Zn({ type: t }));
                    static #n = (this.ɵinj = zn({}));
                }
                return t;
            })();
            const UC = 'browser';
            function BC(t) {
                return t === UC;
            }
            function qC(t) {
                return 'server' === t;
            }
            class YC {}
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */
            class PH extends $R {
                constructor() {
                    super(...arguments), (this.supportsDOMEvents = !0);
                }
            }
            class Em extends PH {
                static makeCurrent() {
                    !(function jR(t) {
                        pC ??= t;
                    })(new Em());
                }
                onAndCancel(n, e, i) {
                    return (
                        n.addEventListener(e, i),
                        () => {
                            n.removeEventListener(e, i);
                        }
                    );
                }
                dispatchEvent(n, e) {
                    n.dispatchEvent(e);
                }
                remove(n) {
                    n.parentNode && n.parentNode.removeChild(n);
                }
                createElement(n, e) {
                    return (e = e || this.getDefaultDocument()).createElement(n);
                }
                createHtmlDocument() {
                    return document.implementation.createHTMLDocument('fakeTitle');
                }
                getDefaultDocument() {
                    return document;
                }
                isElementNode(n) {
                    return n.nodeType === Node.ELEMENT_NODE;
                }
                isShadowRoot(n) {
                    return n instanceof DocumentFragment;
                }
                getGlobalEventTarget(n, e) {
                    return 'window' === e ? window : 'document' === e ? n : 'body' === e ? n.body : null;
                }
                getBaseHref(n) {
                    const e = (function NH() {
                        return (jd = jd || document.querySelector('base')), jd ? jd.getAttribute('href') : null;
                    })();
                    return null == e
                        ? null
                        : (function FH(t) {
                              return new URL(t, document.baseURI).pathname;
                          })(e);
                }
                resetBaseElement() {
                    jd = null;
                }
                getUserAgent() {
                    return window.navigator.userAgent;
                }
                getCookie(n) {
                    return IC(document.cookie, n);
                }
            }
            let jd = null,
                VH = (() => {
                    class t {
                        build() {
                            return new XMLHttpRequest();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })();
            const Im = new $e('');
            let JC = (() => {
                class t {
                    constructor(e, i) {
                        (this._zone = i),
                            (this._eventNameToPlugin = new Map()),
                            e.forEach(r => {
                                r.manager = this;
                            }),
                            (this._plugins = e.slice().reverse());
                    }
                    addEventListener(e, i, r) {
                        return this._findPluginFor(i).addEventListener(e, i, r);
                    }
                    getZone() {
                        return this._zone;
                    }
                    _findPluginFor(e) {
                        let i = this._eventNameToPlugin.get(e);
                        if (i) return i;
                        if (((i = this._plugins.find(s => s.supports(e))), !i)) throw new Me(5101, !1);
                        return this._eventNameToPlugin.set(e, i), i;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(Im), Se(en));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            class ew {
                constructor(n) {
                    this._doc = n;
                }
            }
            const Am = 'ng-app-id';
            let tw = (() => {
                class t {
                    constructor(e, i, r, s = {}) {
                        (this.doc = e),
                            (this.appId = i),
                            (this.nonce = r),
                            (this.platformId = s),
                            (this.styleRef = new Map()),
                            (this.hostNodes = new Set()),
                            (this.styleNodesInDOM = this.collectServerRenderedStyles()),
                            (this.platformIsServer = qC(s)),
                            this.resetHostNodes();
                    }
                    addStyles(e) {
                        for (const i of e) 1 === this.changeUsageCount(i, 1) && this.onStyleAdded(i);
                    }
                    removeStyles(e) {
                        for (const i of e) this.changeUsageCount(i, -1) <= 0 && this.onStyleRemoved(i);
                    }
                    ngOnDestroy() {
                        const e = this.styleNodesInDOM;
                        e && (e.forEach(i => i.remove()), e.clear());
                        for (const i of this.getAllStyles()) this.onStyleRemoved(i);
                        this.resetHostNodes();
                    }
                    addHost(e) {
                        this.hostNodes.add(e);
                        for (const i of this.getAllStyles()) this.addStyleToHost(e, i);
                    }
                    removeHost(e) {
                        this.hostNodes.delete(e);
                    }
                    getAllStyles() {
                        return this.styleRef.keys();
                    }
                    onStyleAdded(e) {
                        for (const i of this.hostNodes) this.addStyleToHost(i, e);
                    }
                    onStyleRemoved(e) {
                        const i = this.styleRef;
                        i.get(e)?.elements?.forEach(r => r.remove()), i.delete(e);
                    }
                    collectServerRenderedStyles() {
                        const e = this.doc.head?.querySelectorAll(`style[${Am}="${this.appId}"]`);
                        if (e?.length) {
                            const i = new Map();
                            return (
                                e.forEach(r => {
                                    null != r.textContent && i.set(r.textContent, r);
                                }),
                                i
                            );
                        }
                        return null;
                    }
                    changeUsageCount(e, i) {
                        const r = this.styleRef;
                        if (r.has(e)) {
                            const s = r.get(e);
                            return (s.usage += i), s.usage;
                        }
                        return r.set(e, { usage: i, elements: [] }), i;
                    }
                    getStyleElement(e, i) {
                        const r = this.styleNodesInDOM,
                            s = r?.get(i);
                        if (s?.parentNode === e) return r.delete(i), s.removeAttribute(Am), s;
                        {
                            const o = this.doc.createElement('style');
                            return (
                                this.nonce && o.setAttribute('nonce', this.nonce),
                                (o.textContent = i),
                                this.platformIsServer && o.setAttribute(Am, this.appId),
                                e.appendChild(o),
                                o
                            );
                        }
                    }
                    addStyleToHost(e, i) {
                        const r = this.getStyleElement(e, i),
                            s = this.styleRef,
                            o = s.get(i)?.elements;
                        o ? o.push(r) : s.set(i, { elements: [r], usage: 1 });
                    }
                    resetHostNodes() {
                        const e = this.hostNodes;
                        e.clear(), e.add(this.doc.head);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(Ni), Se(f2), Se(K0, 8), Se(Za));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            const Lm = {
                    svg: 'http://www.w3.org/2000/svg',
                    xhtml: 'http://www.w3.org/1999/xhtml',
                    xlink: 'http://www.w3.org/1999/xlink',
                    xml: 'http://www.w3.org/XML/1998/namespace',
                    xmlns: 'http://www.w3.org/2000/xmlns/',
                    math: 'http://www.w3.org/1998/MathML/',
                },
                Om = /%COMP%/g,
                qH = new $e('', { providedIn: 'root', factory: () => !0 });
            function iw(t, n) {
                return n.map(e => e.replace(Om, t));
            }
            let zm = (() => {
                class t {
                    constructor(e, i, r, s, o, a, l, c = null) {
                        (this.eventManager = e),
                            (this.sharedStylesHost = i),
                            (this.appId = r),
                            (this.removeStylesOnCompDestroy = s),
                            (this.doc = o),
                            (this.platformId = a),
                            (this.ngZone = l),
                            (this.nonce = c),
                            (this.rendererByCompId = new Map()),
                            (this.platformIsServer = qC(a)),
                            (this.defaultRenderer = new Pm(e, o, l, this.platformIsServer));
                    }
                    createRenderer(e, i) {
                        if (!e || !i) return this.defaultRenderer;
                        this.platformIsServer &&
                            i.encapsulation === we.ShadowDom &&
                            (i = { ...i, encapsulation: we.Emulated });
                        const r = this.getOrCreateRenderer(e, i);
                        return r instanceof sw ? r.applyToHost(e) : r instanceof Nm && r.applyStyles(), r;
                    }
                    getOrCreateRenderer(e, i) {
                        const r = this.rendererByCompId;
                        let s = r.get(i.id);
                        if (!s) {
                            const o = this.doc,
                                a = this.ngZone,
                                l = this.eventManager,
                                c = this.sharedStylesHost,
                                f = this.removeStylesOnCompDestroy,
                                g = this.platformIsServer;
                            switch (i.encapsulation) {
                                case we.Emulated:
                                    s = new sw(l, c, i, this.appId, f, o, a, g);
                                    break;
                                case we.ShadowDom:
                                    return new WH(l, c, e, i, o, a, this.nonce, g);
                                default:
                                    s = new Nm(l, c, i, f, o, a, g);
                            }
                            r.set(i.id, s);
                        }
                        return s;
                    }
                    ngOnDestroy() {
                        this.rendererByCompId.clear();
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(JC), Se(tw), Se(f2), Se(qH), Se(Ni), Se(Za), Se(en), Se(K0));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            class Pm {
                constructor(n, e, i, r) {
                    (this.eventManager = n),
                        (this.doc = e),
                        (this.ngZone = i),
                        (this.platformIsServer = r),
                        (this.data = Object.create(null)),
                        (this.throwOnSyntheticProps = !0),
                        (this.destroyNode = null);
                }
                destroy() {}
                createElement(n, e) {
                    return e ? this.doc.createElementNS(Lm[e] || e, n) : this.doc.createElement(n);
                }
                createComment(n) {
                    return this.doc.createComment(n);
                }
                createText(n) {
                    return this.doc.createTextNode(n);
                }
                appendChild(n, e) {
                    (rw(n) ? n.content : n).appendChild(e);
                }
                insertBefore(n, e, i) {
                    n && (rw(n) ? n.content : n).insertBefore(e, i);
                }
                removeChild(n, e) {
                    n && n.removeChild(e);
                }
                selectRootElement(n, e) {
                    let i = 'string' == typeof n ? this.doc.querySelector(n) : n;
                    if (!i) throw new Me(-5104, !1);
                    return e || (i.textContent = ''), i;
                }
                parentNode(n) {
                    return n.parentNode;
                }
                nextSibling(n) {
                    return n.nextSibling;
                }
                setAttribute(n, e, i, r) {
                    if (r) {
                        e = r + ':' + e;
                        const s = Lm[r];
                        s ? n.setAttributeNS(s, e, i) : n.setAttribute(e, i);
                    } else n.setAttribute(e, i);
                }
                removeAttribute(n, e, i) {
                    if (i) {
                        const r = Lm[i];
                        r ? n.removeAttributeNS(r, e) : n.removeAttribute(`${i}:${e}`);
                    } else n.removeAttribute(e);
                }
                addClass(n, e) {
                    n.classList.add(e);
                }
                removeClass(n, e) {
                    n.classList.remove(e);
                }
                setStyle(n, e, i, r) {
                    r & (lc.DashCase | lc.Important)
                        ? n.style.setProperty(e, i, r & lc.Important ? 'important' : '')
                        : (n.style[e] = i);
                }
                removeStyle(n, e, i) {
                    i & lc.DashCase ? n.style.removeProperty(e) : (n.style[e] = '');
                }
                setProperty(n, e, i) {
                    null != n && (n[e] = i);
                }
                setValue(n, e) {
                    n.nodeValue = e;
                }
                listen(n, e, i) {
                    if ('string' == typeof n && !(n = fc().getGlobalEventTarget(this.doc, n)))
                        throw new Error(`Unsupported event target ${n} for event ${e}`);
                    return this.eventManager.addEventListener(n, e, this.decoratePreventDefault(i));
                }
                decoratePreventDefault(n) {
                    return e => {
                        if ('__ngUnwrap__' === e) return n;
                        !1 === (this.platformIsServer ? this.ngZone.runGuarded(() => n(e)) : n(e)) &&
                            e.preventDefault();
                    };
                }
            }
            function rw(t) {
                return 'TEMPLATE' === t.tagName && void 0 !== t.content;
            }
            class WH extends Pm {
                constructor(n, e, i, r, s, o, a, l) {
                    super(n, s, o, l),
                        (this.sharedStylesHost = e),
                        (this.hostEl = i),
                        (this.shadowRoot = i.attachShadow({ mode: 'open' })),
                        this.sharedStylesHost.addHost(this.shadowRoot);
                    const c = iw(r.id, r.styles);
                    for (const f of c) {
                        const g = document.createElement('style');
                        a && g.setAttribute('nonce', a), (g.textContent = f), this.shadowRoot.appendChild(g);
                    }
                }
                nodeOrShadowRoot(n) {
                    return n === this.hostEl ? this.shadowRoot : n;
                }
                appendChild(n, e) {
                    return super.appendChild(this.nodeOrShadowRoot(n), e);
                }
                insertBefore(n, e, i) {
                    return super.insertBefore(this.nodeOrShadowRoot(n), e, i);
                }
                removeChild(n, e) {
                    return super.removeChild(this.nodeOrShadowRoot(n), e);
                }
                parentNode(n) {
                    return this.nodeOrShadowRoot(super.parentNode(this.nodeOrShadowRoot(n)));
                }
                destroy() {
                    this.sharedStylesHost.removeHost(this.shadowRoot);
                }
            }
            class Nm extends Pm {
                constructor(n, e, i, r, s, o, a, l) {
                    super(n, s, o, a),
                        (this.sharedStylesHost = e),
                        (this.removeStylesOnCompDestroy = r),
                        (this.styles = l ? iw(l, i.styles) : i.styles);
                }
                applyStyles() {
                    this.sharedStylesHost.addStyles(this.styles);
                }
                destroy() {
                    this.removeStylesOnCompDestroy && this.sharedStylesHost.removeStyles(this.styles);
                }
            }
            class sw extends Nm {
                constructor(n, e, i, r, s, o, a, l) {
                    const c = r + '-' + i.id;
                    super(n, e, i, s, o, a, l, c),
                        (this.contentAttr = (function YH(t) {
                            return '_ngcontent-%COMP%'.replace(Om, t);
                        })(c)),
                        (this.hostAttr = (function jH(t) {
                            return '_nghost-%COMP%'.replace(Om, t);
                        })(c));
                }
                applyToHost(n) {
                    this.applyStyles(), this.setAttribute(n, this.hostAttr, '');
                }
                createElement(n, e) {
                    const i = super.createElement(n, e);
                    return super.setAttribute(i, this.contentAttr, ''), i;
                }
            }
            let KH = (() => {
                class t extends ew {
                    constructor(e) {
                        super(e);
                    }
                    supports(e) {
                        return !0;
                    }
                    addEventListener(e, i, r) {
                        return e.addEventListener(i, r, !1), () => this.removeEventListener(e, i, r);
                    }
                    removeEventListener(e, i, r) {
                        return e.removeEventListener(i, r);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(Ni));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            const ow = ['alt', 'control', 'meta', 'shift'],
                QH = {
                    '\b': 'Backspace',
                    '\t': 'Tab',
                    '\x7f': 'Delete',
                    '\x1b': 'Escape',
                    Del: 'Delete',
                    Esc: 'Escape',
                    Left: 'ArrowLeft',
                    Right: 'ArrowRight',
                    Up: 'ArrowUp',
                    Down: 'ArrowDown',
                    Menu: 'ContextMenu',
                    Scroll: 'ScrollLock',
                    Win: 'OS',
                },
                XH = { alt: t => t.altKey, control: t => t.ctrlKey, meta: t => t.metaKey, shift: t => t.shiftKey };
            let ZH = (() => {
                class t extends ew {
                    constructor(e) {
                        super(e);
                    }
                    supports(e) {
                        return null != t.parseEventName(e);
                    }
                    addEventListener(e, i, r) {
                        const s = t.parseEventName(i),
                            o = t.eventCallback(s.fullKey, r, this.manager.getZone());
                        return this.manager.getZone().runOutsideAngular(() => fc().onAndCancel(e, s.domEventName, o));
                    }
                    static parseEventName(e) {
                        const i = e.toLowerCase().split('.'),
                            r = i.shift();
                        if (0 === i.length || ('keydown' !== r && 'keyup' !== r)) return null;
                        const s = t._normalizeKey(i.pop());
                        let o = '',
                            a = i.indexOf('code');
                        if (
                            (a > -1 && (i.splice(a, 1), (o = 'code.')),
                            ow.forEach(c => {
                                const f = i.indexOf(c);
                                f > -1 && (i.splice(f, 1), (o += c + '.'));
                            }),
                            (o += s),
                            0 != i.length || 0 === s.length)
                        )
                            return null;
                        const l = {};
                        return (l.domEventName = r), (l.fullKey = o), l;
                    }
                    static matchEventFullKeyCode(e, i) {
                        let r = QH[e.key] || e.key,
                            s = '';
                        return (
                            i.indexOf('code.') > -1 && ((r = e.code), (s = 'code.')),
                            !(null == r || !r) &&
                                ((r = r.toLowerCase()),
                                ' ' === r ? (r = 'space') : '.' === r && (r = 'dot'),
                                ow.forEach(o => {
                                    o !== r && (0, XH[o])(e) && (s += o + '.');
                                }),
                                (s += r),
                                s === i)
                        );
                    }
                    static eventCallback(e, i, r) {
                        return s => {
                            t.matchEventFullKeyCode(s, e) && r.runGuarded(() => i(s));
                        };
                    }
                    static _normalizeKey(e) {
                        return 'esc' === e ? 'escape' : e;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(Ni));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            const nU = Ob(uR, 'browser', [
                    { provide: Za, useValue: UC },
                    {
                        provide: H7,
                        useValue: function JH() {
                            Em.makeCurrent();
                        },
                        multi: !0,
                    },
                    {
                        provide: Ni,
                        useFactory: function tU() {
                            return (
                                (function tI(t) {
                                    u6 = t;
                                })(document),
                                document
                            );
                        },
                        deps: [],
                    },
                ]),
                iU = new $e(''),
                cw = [
                    {
                        provide: f4,
                        useClass: class RH {
                            addToWindow(n) {
                                (Rn.getAngularTestability = (i, r = !0) => {
                                    const s = n.findTestabilityInTree(i, r);
                                    if (null == s) throw new Me(5103, !1);
                                    return s;
                                }),
                                    (Rn.getAllAngularTestabilities = () => n.getAllTestabilities()),
                                    (Rn.getAllAngularRootElements = () => n.getAllRootElements()),
                                    Rn.frameworkStabilizers || (Rn.frameworkStabilizers = []),
                                    Rn.frameworkStabilizers.push(i => {
                                        const r = Rn.getAllAngularTestabilities();
                                        let s = r.length;
                                        const o = function () {
                                            s--, 0 == s && i();
                                        };
                                        r.forEach(a => {
                                            a.whenStable(o);
                                        });
                                    });
                            }
                            findTestabilityInTree(n, e, i) {
                                return null == e
                                    ? null
                                    : n.getTestability(e) ??
                                          (i
                                              ? fc().isShadowRoot(e)
                                                  ? this.findTestabilityInTree(n, e.host, !0)
                                                  : this.findTestabilityInTree(n, e.parentElement, !0)
                                              : null);
                            }
                        },
                        deps: [],
                    },
                    { provide: wb, useClass: Z8, deps: [en, J8, f4] },
                    { provide: Z8, useClass: Z8, deps: [en, J8, f4] },
                ],
                uw = [
                    { provide: S0, useValue: 'root' },
                    {
                        provide: Xa,
                        useFactory: function eU() {
                            return new Xa();
                        },
                        deps: [],
                    },
                    { provide: Im, useClass: KH, multi: !0, deps: [Ni, en, Za] },
                    { provide: Im, useClass: ZH, multi: !0, deps: [Ni] },
                    zm,
                    tw,
                    JC,
                    { provide: y1, useExisting: zm },
                    { provide: YC, useClass: VH, deps: [] },
                    [],
                ];
            let dw = (() => {
                    class t {
                        constructor(e) {}
                        static withServerTransition(e) {
                            return { ngModule: t, providers: [{ provide: f2, useValue: e.appId }] };
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(iU, 12));
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ providers: [...uw, ...cw], imports: [HC, dR] }));
                    }
                    return t;
                })(),
                V4 = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({
                            token: t,
                            factory: function (i) {
                                let r = null;
                                return (r = i ? new (i || t)() : Se(aU)), r;
                            },
                            providedIn: 'root',
                        }));
                    }
                    return t;
                })(),
                aU = (() => {
                    class t extends V4 {
                        constructor(e) {
                            super(), (this._doc = e);
                        }
                        sanitize(e, i) {
                            if (null == i) return null;
                            switch (e) {
                                case Po.NONE:
                                    return i;
                                case Po.HTML:
                                    return Ja(i, 'HTML') ? zo(i) : sv(this._doc, String(i)).toString();
                                case Po.STYLE:
                                    return Ja(i, 'Style') ? zo(i) : i;
                                case Po.SCRIPT:
                                    if (Ja(i, 'Script')) return zo(i);
                                    throw new Me(5200, !1);
                                case Po.URL:
                                    return Ja(i, 'URL') ? zo(i) : w2(String(i));
                                case Po.RESOURCE_URL:
                                    if (Ja(i, 'ResourceURL')) return zo(i);
                                    throw new Me(5201, !1);
                                default:
                                    throw new Me(5202, !1);
                            }
                        }
                        bypassSecurityTrustHtml(e) {
                            return (function wI(t) {
                                return new gI(t);
                            })(e);
                        }
                        bypassSecurityTrustStyle(e) {
                            return (function MI(t) {
                                return new vI(t);
                            })(e);
                        }
                        bypassSecurityTrustScript(e) {
                            return (function SI(t) {
                                return new _I(t);
                            })(e);
                        }
                        bypassSecurityTrustUrl(e) {
                            return (function TI(t) {
                                return new yI(t);
                            })(e);
                        }
                        bypassSecurityTrustResourceUrl(e) {
                            return (function DI(t) {
                                return new bI(t);
                            })(e);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Ni));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })();
            function pw(t) {
                return t && et(t.schedule);
            }
            function Fm(t) {
                return t[t.length - 1];
            }
            function Rm(t) {
                return et(Fm(t)) ? t.pop() : void 0;
            }
            function Gd(t) {
                return pw(Fm(t)) ? t.pop() : void 0;
            }
            function Lt(t, n, e, i) {
                var o,
                    r = arguments.length,
                    s = r < 3 ? n : null === i ? (i = Object.getOwnPropertyDescriptor(n, e)) : i;
                if ('object' == typeof Reflect && 'function' == typeof Reflect.decorate)
                    s = Reflect.decorate(t, n, e, i);
                else
                    for (var a = t.length - 1; a >= 0; a--)
                        (o = t[a]) && (s = (r < 3 ? o(s) : r > 3 ? o(n, e, s) : o(n, e)) || s);
                return r > 3 && s && Object.defineProperty(n, e, s), s;
            }
            function pc(t) {
                return this instanceof pc ? ((this.v = t), this) : new pc(t);
            }
            function yw(t) {
                if (!Symbol.asyncIterator) throw new TypeError('Symbol.asyncIterator is not defined.');
                var e,
                    n = t[Symbol.asyncIterator];
                return n
                    ? n.call(t)
                    : ((t = (function Bm(t) {
                          var n = 'function' == typeof Symbol && Symbol.iterator,
                              e = n && t[n],
                              i = 0;
                          if (e) return e.call(t);
                          if (t && 'number' == typeof t.length)
                              return {
                                  next: function () {
                                      return t && i >= t.length && (t = void 0), { value: t && t[i++], done: !t };
                                  },
                              };
                          throw new TypeError(n ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
                      })(t)),
                      (e = {}),
                      i('next'),
                      i('throw'),
                      i('return'),
                      (e[Symbol.asyncIterator] = function () {
                          return this;
                      }),
                      e);
                function i(s) {
                    e[s] =
                        t[s] &&
                        function (o) {
                            return new Promise(function (a, l) {
                                !(function r(s, o, a, l) {
                                    Promise.resolve(l).then(function (c) {
                                        s({ value: c, done: a });
                                    }, o);
                                })(a, l, (o = t[s](o)).done, o.value);
                            });
                        };
                }
            }
            'function' == typeof SuppressedError && SuppressedError;
            const qm = t => t && 'number' == typeof t.length && 'function' != typeof t;
            function bw(t) {
                return et(t?.then);
            }
            function Cw(t) {
                return et(t[As]);
            }
            function ww(t) {
                return Symbol.asyncIterator && et(t?.[Symbol.asyncIterator]);
            }
            function Mw(t) {
                return new TypeError(
                    `You provided ${
                        null !== t && 'object' == typeof t ? 'an invalid object' : `'${t}'`
                    } where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.`,
                );
            }
            const Sw = (function EU() {
                return 'function' == typeof Symbol && Symbol.iterator ? Symbol.iterator : '@@iterator';
            })();
            function Tw(t) {
                return et(t?.[Sw]);
            }
            function Dw(t) {
                return (function _w(t, n, e) {
                    if (!Symbol.asyncIterator) throw new TypeError('Symbol.asyncIterator is not defined.');
                    var r,
                        i = e.apply(t, n || []),
                        s = [];
                    return (
                        (r = {}),
                        a('next'),
                        a('throw'),
                        a('return', function o(P) {
                            return function (V) {
                                return Promise.resolve(V).then(P, g);
                            };
                        }),
                        (r[Symbol.asyncIterator] = function () {
                            return this;
                        }),
                        r
                    );
                    function a(P, V) {
                        i[P] &&
                            ((r[P] = function (W) {
                                return new Promise(function (ie, he) {
                                    s.push([P, W, ie, he]) > 1 || l(P, W);
                                });
                            }),
                            V && (r[P] = V(r[P])));
                    }
                    function l(P, V) {
                        try {
                            !(function c(P) {
                                P.value instanceof pc ? Promise.resolve(P.value.v).then(f, g) : E(s[0][2], P);
                            })(i[P](V));
                        } catch (W) {
                            E(s[0][3], W);
                        }
                    }
                    function f(P) {
                        l('next', P);
                    }
                    function g(P) {
                        l('throw', P);
                    }
                    function E(P, V) {
                        P(V), s.shift(), s.length && l(s[0][0], s[0][1]);
                    }
                })(this, arguments, function* () {
                    const e = t.getReader();
                    try {
                        for (;;) {
                            const { value: i, done: r } = yield pc(e.read());
                            if (r) return yield pc(void 0);
                            yield yield pc(i);
                        }
                    } finally {
                        e.releaseLock();
                    }
                });
            }
            function xw(t) {
                return et(t?.getReader);
            }
            function bs(t) {
                if (t instanceof Tn) return t;
                if (null != t) {
                    if (Cw(t))
                        return (function IU(t) {
                            return new Tn(n => {
                                const e = t[As]();
                                if (et(e.subscribe)) return e.subscribe(n);
                                throw new TypeError('Provided object does not correctly implement Symbol.observable');
                            });
                        })(t);
                    if (qm(t))
                        return (function AU(t) {
                            return new Tn(n => {
                                for (let e = 0; e < t.length && !n.closed; e++) n.next(t[e]);
                                n.complete();
                            });
                        })(t);
                    if (bw(t))
                        return (function LU(t) {
                            return new Tn(n => {
                                t.then(
                                    e => {
                                        n.closed || (n.next(e), n.complete());
                                    },
                                    e => n.error(e),
                                ).then(null, pr);
                            });
                        })(t);
                    if (ww(t)) return kw(t);
                    if (Tw(t))
                        return (function OU(t) {
                            return new Tn(n => {
                                for (const e of t) if ((n.next(e), n.closed)) return;
                                n.complete();
                            });
                        })(t);
                    if (xw(t))
                        return (function zU(t) {
                            return kw(Dw(t));
                        })(t);
                }
                throw Mw(t);
            }
            function kw(t) {
                return new Tn(n => {
                    (function PU(t, n) {
                        var e, i, r, s;
                        return (function gw(t, n, e, i) {
                            return new (e || (e = Promise))(function (s, o) {
                                function a(f) {
                                    try {
                                        c(i.next(f));
                                    } catch (g) {
                                        o(g);
                                    }
                                }
                                function l(f) {
                                    try {
                                        c(i.throw(f));
                                    } catch (g) {
                                        o(g);
                                    }
                                }
                                function c(f) {
                                    f.done
                                        ? s(f.value)
                                        : (function r(s) {
                                              return s instanceof e
                                                  ? s
                                                  : new e(function (o) {
                                                        o(s);
                                                    });
                                          })(f.value).then(a, l);
                                }
                                c((i = i.apply(t, n || [])).next());
                            });
                        })(this, void 0, void 0, function* () {
                            try {
                                for (e = yw(t); !(i = yield e.next()).done; ) if ((n.next(i.value), n.closed)) return;
                            } catch (o) {
                                r = { error: o };
                            } finally {
                                try {
                                    i && !i.done && (s = e.return) && (yield s.call(e));
                                } finally {
                                    if (r) throw r.error;
                                }
                            }
                            n.complete();
                        });
                    })(t, n).catch(e => n.error(e));
                });
            }
            function Ll(t, n, e, i = 0, r = !1) {
                const s = n.schedule(function () {
                    e(), r ? t.add(this.schedule(null, i)) : this.unsubscribe();
                }, i);
                if ((t.add(s), !r)) return s;
            }
            function Ew(t, n = 0) {
                return mi((e, i) => {
                    e.subscribe(
                        ln(
                            i,
                            r => Ll(i, t, () => i.next(r), n),
                            () => Ll(i, t, () => i.complete(), n),
                            r => Ll(i, t, () => i.error(r), n),
                        ),
                    );
                });
            }
            function Iw(t, n = 0) {
                return mi((e, i) => {
                    i.add(t.schedule(() => e.subscribe(i), n));
                });
            }
            function Aw(t, n) {
                if (!t) throw new Error('Iterable cannot be null');
                return new Tn(e => {
                    Ll(e, n, () => {
                        const i = t[Symbol.asyncIterator]();
                        Ll(
                            e,
                            n,
                            () => {
                                i.next().then(r => {
                                    r.done ? e.complete() : e.next(r.value);
                                });
                            },
                            0,
                            !0,
                        );
                    });
                });
            }
            function ol(t, n) {
                return n
                    ? (function UU(t, n) {
                          if (null != t) {
                              if (Cw(t))
                                  return (function NU(t, n) {
                                      return bs(t).pipe(Iw(n), Ew(n));
                                  })(t, n);
                              if (qm(t))
                                  return (function RU(t, n) {
                                      return new Tn(e => {
                                          let i = 0;
                                          return n.schedule(function () {
                                              i === t.length
                                                  ? e.complete()
                                                  : (e.next(t[i++]), e.closed || this.schedule());
                                          });
                                      });
                                  })(t, n);
                              if (bw(t))
                                  return (function FU(t, n) {
                                      return bs(t).pipe(Iw(n), Ew(n));
                                  })(t, n);
                              if (ww(t)) return Aw(t, n);
                              if (Tw(t))
                                  return (function VU(t, n) {
                                      return new Tn(e => {
                                          let i;
                                          return (
                                              Ll(e, n, () => {
                                                  (i = t[Sw]()),
                                                      Ll(
                                                          e,
                                                          n,
                                                          () => {
                                                              let r, s;
                                                              try {
                                                                  ({ value: r, done: s } = i.next());
                                                              } catch (o) {
                                                                  return void e.error(o);
                                                              }
                                                              s ? e.complete() : e.next(r);
                                                          },
                                                          0,
                                                          !0,
                                                      );
                                              }),
                                              () => et(i?.return) && i.return()
                                          );
                                      });
                                  })(t, n);
                              if (xw(t))
                                  return (function HU(t, n) {
                                      return Aw(Dw(t), n);
                                  })(t, n);
                          }
                          throw Mw(t);
                      })(t, n)
                    : bs(t);
            }
            function Uo(...t) {
                return ol(t, Gd(t));
            }
            function G1(t, n, e = 1 / 0) {
                return et(n)
                    ? G1((i, r) => Ct((s, o) => n(i, s, r, o))(bs(t(i, r))), e)
                    : ('number' == typeof n && (e = n),
                      mi((i, r) =>
                          (function BU(t, n, e, i, r, s, o, a) {
                              const l = [];
                              let c = 0,
                                  f = 0,
                                  g = !1;
                              const E = () => {
                                      g && !l.length && !c && n.complete();
                                  },
                                  P = W => (c < i ? V(W) : l.push(W)),
                                  V = W => {
                                      s && n.next(W), c++;
                                      let ie = !1;
                                      bs(e(W, f++)).subscribe(
                                          ln(
                                              n,
                                              he => {
                                                  r?.(he), s ? P(he) : n.next(he);
                                              },
                                              () => {
                                                  ie = !0;
                                              },
                                              void 0,
                                              () => {
                                                  if (ie)
                                                      try {
                                                          for (c--; l.length && c < i; ) {
                                                              const he = l.shift();
                                                              o ? Ll(n, o, () => V(he)) : V(he);
                                                          }
                                                          E();
                                                      } catch (he) {
                                                          n.error(he);
                                                      }
                                              },
                                          ),
                                      );
                                  };
                              return (
                                  t.subscribe(
                                      ln(n, P, () => {
                                          (g = !0), E();
                                      }),
                                  ),
                                  () => {
                                      a?.();
                                  }
                              );
                          })(i, r, t, e),
                      ));
            }
            function al(t, n) {
                return mi((e, i) => {
                    let r = 0;
                    e.subscribe(ln(i, s => t.call(n, s, r++) && i.next(s)));
                });
            }
            function H4(t) {
                return mi((n, e) => {
                    try {
                        n.subscribe(e);
                    } finally {
                        e.add(t);
                    }
                });
            }
            function vu(t, n) {
                return mi((e, i) => {
                    let r = null,
                        s = 0,
                        o = !1;
                    const a = () => o && !r && i.complete();
                    e.subscribe(
                        ln(
                            i,
                            l => {
                                r?.unsubscribe();
                                let c = 0;
                                const f = s++;
                                bs(t(l, f)).subscribe(
                                    (r = ln(
                                        i,
                                        g => i.next(n ? n(l, g, f, c++) : g),
                                        () => {
                                            (r = null), a();
                                        },
                                    )),
                                );
                            },
                            () => {
                                (o = !0), a();
                            },
                        ),
                    );
                });
            }
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */ class U4 {}
            class W1 {}
            class aa {
                constructor(n) {
                    (this.normalizedNames = new Map()),
                        (this.lazyUpdate = null),
                        n
                            ? 'string' == typeof n
                                ? (this.lazyInit = () => {
                                      (this.headers = new Map()),
                                          n.split('\n').forEach(e => {
                                              const i = e.indexOf(':');
                                              if (i > 0) {
                                                  const r = e.slice(0, i),
                                                      s = r.toLowerCase(),
                                                      o = e.slice(i + 1).trim();
                                                  this.maybeSetNormalizedName(r, s),
                                                      this.headers.has(s)
                                                          ? this.headers.get(s).push(o)
                                                          : this.headers.set(s, [o]);
                                              }
                                          });
                                  })
                                : typeof Headers < 'u' && n instanceof Headers
                                ? ((this.headers = new Map()),
                                  n.forEach((e, i) => {
                                      this.setHeaderEntries(i, e);
                                  }))
                                : (this.lazyInit = () => {
                                      (this.headers = new Map()),
                                          Object.entries(n).forEach(([e, i]) => {
                                              this.setHeaderEntries(e, i);
                                          });
                                  })
                            : (this.headers = new Map());
                }
                has(n) {
                    return this.init(), this.headers.has(n.toLowerCase());
                }
                get(n) {
                    this.init();
                    const e = this.headers.get(n.toLowerCase());
                    return e && e.length > 0 ? e[0] : null;
                }
                keys() {
                    return this.init(), Array.from(this.normalizedNames.values());
                }
                getAll(n) {
                    return this.init(), this.headers.get(n.toLowerCase()) || null;
                }
                append(n, e) {
                    return this.clone({ name: n, value: e, op: 'a' });
                }
                set(n, e) {
                    return this.clone({ name: n, value: e, op: 's' });
                }
                delete(n, e) {
                    return this.clone({ name: n, value: e, op: 'd' });
                }
                maybeSetNormalizedName(n, e) {
                    this.normalizedNames.has(e) || this.normalizedNames.set(e, n);
                }
                init() {
                    this.lazyInit &&
                        (this.lazyInit instanceof aa ? this.copyFrom(this.lazyInit) : this.lazyInit(),
                        (this.lazyInit = null),
                        this.lazyUpdate &&
                            (this.lazyUpdate.forEach(n => this.applyUpdate(n)), (this.lazyUpdate = null)));
                }
                copyFrom(n) {
                    n.init(),
                        Array.from(n.headers.keys()).forEach(e => {
                            this.headers.set(e, n.headers.get(e)),
                                this.normalizedNames.set(e, n.normalizedNames.get(e));
                        });
                }
                clone(n) {
                    const e = new aa();
                    return (
                        (e.lazyInit = this.lazyInit && this.lazyInit instanceof aa ? this.lazyInit : this),
                        (e.lazyUpdate = (this.lazyUpdate || []).concat([n])),
                        e
                    );
                }
                applyUpdate(n) {
                    const e = n.name.toLowerCase();
                    switch (n.op) {
                        case 'a':
                        case 's':
                            let i = n.value;
                            if (('string' == typeof i && (i = [i]), 0 === i.length)) return;
                            this.maybeSetNormalizedName(n.name, e);
                            const r = ('a' === n.op ? this.headers.get(e) : void 0) || [];
                            r.push(...i), this.headers.set(e, r);
                            break;
                        case 'd':
                            const s = n.value;
                            if (s) {
                                let o = this.headers.get(e);
                                if (!o) return;
                                (o = o.filter(a => -1 === s.indexOf(a))),
                                    0 === o.length
                                        ? (this.headers.delete(e), this.normalizedNames.delete(e))
                                        : this.headers.set(e, o);
                            } else this.headers.delete(e), this.normalizedNames.delete(e);
                    }
                }
                setHeaderEntries(n, e) {
                    const i = (Array.isArray(e) ? e : [e]).map(s => s.toString()),
                        r = n.toLowerCase();
                    this.headers.set(r, i), this.maybeSetNormalizedName(n, r);
                }
                forEach(n) {
                    this.init(),
                        Array.from(this.normalizedNames.keys()).forEach(e =>
                            n(this.normalizedNames.get(e), this.headers.get(e)),
                        );
                }
            }
            class YU {
                encodeKey(n) {
                    return Lw(n);
                }
                encodeValue(n) {
                    return Lw(n);
                }
                decodeKey(n) {
                    return decodeURIComponent(n);
                }
                decodeValue(n) {
                    return decodeURIComponent(n);
                }
            }
            const $U = /%(\d[a-f0-9])/gi,
                GU = { 40: '@', '3A': ':', 24: '$', '2C': ',', '3B': ';', '3D': '=', '3F': '?', '2F': '/' };
            function Lw(t) {
                return encodeURIComponent(t).replace($U, (n, e) => GU[e] ?? n);
            }
            function B4(t) {
                return `${t}`;
            }
            class gc {
                constructor(n = {}) {
                    if (
                        ((this.updates = null),
                        (this.cloneFrom = null),
                        (this.encoder = n.encoder || new YU()),
                        n.fromString)
                    ) {
                        if (n.fromObject) throw new Error('Cannot specify both fromString and fromObject.');
                        this.map = (function jU(t, n) {
                            const e = new Map();
                            return (
                                t.length > 0 &&
                                    t
                                        .replace(/^\?/, '')
                                        .split('&')
                                        .forEach(r => {
                                            const s = r.indexOf('='),
                                                [o, a] =
                                                    -1 == s
                                                        ? [n.decodeKey(r), '']
                                                        : [n.decodeKey(r.slice(0, s)), n.decodeValue(r.slice(s + 1))],
                                                l = e.get(o) || [];
                                            l.push(a), e.set(o, l);
                                        }),
                                e
                            );
                        })(n.fromString, this.encoder);
                    } else
                        n.fromObject
                            ? ((this.map = new Map()),
                              Object.keys(n.fromObject).forEach(e => {
                                  const i = n.fromObject[e],
                                      r = Array.isArray(i) ? i.map(B4) : [B4(i)];
                                  this.map.set(e, r);
                              }))
                            : (this.map = null);
                }
                has(n) {
                    return this.init(), this.map.has(n);
                }
                get(n) {
                    this.init();
                    const e = this.map.get(n);
                    return e ? e[0] : null;
                }
                getAll(n) {
                    return this.init(), this.map.get(n) || null;
                }
                keys() {
                    return this.init(), Array.from(this.map.keys());
                }
                append(n, e) {
                    return this.clone({ param: n, value: e, op: 'a' });
                }
                appendAll(n) {
                    const e = [];
                    return (
                        Object.keys(n).forEach(i => {
                            const r = n[i];
                            Array.isArray(r)
                                ? r.forEach(s => {
                                      e.push({ param: i, value: s, op: 'a' });
                                  })
                                : e.push({ param: i, value: r, op: 'a' });
                        }),
                        this.clone(e)
                    );
                }
                set(n, e) {
                    return this.clone({ param: n, value: e, op: 's' });
                }
                delete(n, e) {
                    return this.clone({ param: n, value: e, op: 'd' });
                }
                toString() {
                    return (
                        this.init(),
                        this.keys()
                            .map(n => {
                                const e = this.encoder.encodeKey(n);
                                return this.map
                                    .get(n)
                                    .map(i => e + '=' + this.encoder.encodeValue(i))
                                    .join('&');
                            })
                            .filter(n => '' !== n)
                            .join('&')
                    );
                }
                clone(n) {
                    const e = new gc({ encoder: this.encoder });
                    return (e.cloneFrom = this.cloneFrom || this), (e.updates = (this.updates || []).concat(n)), e;
                }
                init() {
                    null === this.map && (this.map = new Map()),
                        null !== this.cloneFrom &&
                            (this.cloneFrom.init(),
                            this.cloneFrom.keys().forEach(n => this.map.set(n, this.cloneFrom.map.get(n))),
                            this.updates.forEach(n => {
                                switch (n.op) {
                                    case 'a':
                                    case 's':
                                        const e = ('a' === n.op ? this.map.get(n.param) : void 0) || [];
                                        e.push(B4(n.value)), this.map.set(n.param, e);
                                        break;
                                    case 'd':
                                        if (void 0 === n.value) {
                                            this.map.delete(n.param);
                                            break;
                                        }
                                        {
                                            let i = this.map.get(n.param) || [];
                                            const r = i.indexOf(B4(n.value));
                                            -1 !== r && i.splice(r, 1),
                                                i.length > 0 ? this.map.set(n.param, i) : this.map.delete(n.param);
                                        }
                                }
                            }),
                            (this.cloneFrom = this.updates = null));
                }
            }
            class WU {
                constructor() {
                    this.map = new Map();
                }
                set(n, e) {
                    return this.map.set(n, e), this;
                }
                get(n) {
                    return this.map.has(n) || this.map.set(n, n.defaultValue()), this.map.get(n);
                }
                delete(n) {
                    return this.map.delete(n), this;
                }
                has(n) {
                    return this.map.has(n);
                }
                keys() {
                    return this.map.keys();
                }
            }
            function Ow(t) {
                return typeof ArrayBuffer < 'u' && t instanceof ArrayBuffer;
            }
            function zw(t) {
                return typeof Blob < 'u' && t instanceof Blob;
            }
            function Pw(t) {
                return typeof FormData < 'u' && t instanceof FormData;
            }
            class Wd {
                constructor(n, e, i, r) {
                    let s;
                    if (
                        ((this.url = e),
                        (this.body = null),
                        (this.reportProgress = !1),
                        (this.withCredentials = !1),
                        (this.responseType = 'json'),
                        (this.method = n.toUpperCase()),
                        (function KU(t) {
                            switch (t) {
                                case 'DELETE':
                                case 'GET':
                                case 'HEAD':
                                case 'OPTIONS':
                                case 'JSONP':
                                    return !1;
                                default:
                                    return !0;
                            }
                        })(this.method) || r
                            ? ((this.body = void 0 !== i ? i : null), (s = r))
                            : (s = i),
                        s &&
                            ((this.reportProgress = !!s.reportProgress),
                            (this.withCredentials = !!s.withCredentials),
                            s.responseType && (this.responseType = s.responseType),
                            s.headers && (this.headers = s.headers),
                            s.context && (this.context = s.context),
                            s.params && (this.params = s.params),
                            (this.transferCache = s.transferCache)),
                        (this.headers ??= new aa()),
                        (this.context ??= new WU()),
                        this.params)
                    ) {
                        const o = this.params.toString();
                        if (0 === o.length) this.urlWithParams = e;
                        else {
                            const a = e.indexOf('?');
                            this.urlWithParams = e + (-1 === a ? '?' : a < e.length - 1 ? '&' : '') + o;
                        }
                    } else (this.params = new gc()), (this.urlWithParams = e);
                }
                serializeBody() {
                    return null === this.body
                        ? null
                        : 'string' == typeof this.body ||
                          Ow(this.body) ||
                          zw(this.body) ||
                          Pw(this.body) ||
                          (function QU(t) {
                              return typeof URLSearchParams < 'u' && t instanceof URLSearchParams;
                          })(this.body)
                        ? this.body
                        : this.body instanceof gc
                        ? this.body.toString()
                        : 'object' == typeof this.body || 'boolean' == typeof this.body || Array.isArray(this.body)
                        ? JSON.stringify(this.body)
                        : this.body.toString();
                }
                detectContentTypeHeader() {
                    return null === this.body || Pw(this.body)
                        ? null
                        : zw(this.body)
                        ? this.body.type || null
                        : Ow(this.body)
                        ? null
                        : 'string' == typeof this.body
                        ? 'text/plain'
                        : this.body instanceof gc
                        ? 'application/x-www-form-urlencoded;charset=UTF-8'
                        : 'object' == typeof this.body || 'number' == typeof this.body || 'boolean' == typeof this.body
                        ? 'application/json'
                        : null;
                }
                clone(n = {}) {
                    const e = n.method || this.method,
                        i = n.url || this.url,
                        r = n.responseType || this.responseType,
                        s = n.transferCache ?? this.transferCache,
                        o = void 0 !== n.body ? n.body : this.body,
                        a = n.withCredentials ?? this.withCredentials,
                        l = n.reportProgress ?? this.reportProgress;
                    let c = n.headers || this.headers,
                        f = n.params || this.params;
                    const g = n.context ?? this.context;
                    return (
                        void 0 !== n.setHeaders &&
                            (c = Object.keys(n.setHeaders).reduce((E, P) => E.set(P, n.setHeaders[P]), c)),
                        n.setParams && (f = Object.keys(n.setParams).reduce((E, P) => E.set(P, n.setParams[P]), f)),
                        new Wd(e, i, o, {
                            params: f,
                            headers: c,
                            context: g,
                            reportProgress: l,
                            responseType: r,
                            withCredentials: a,
                            transferCache: s,
                        })
                    );
                }
            }
            var vc = (function (t) {
                return (
                    (t[(t.Sent = 0)] = 'Sent'),
                    (t[(t.UploadProgress = 1)] = 'UploadProgress'),
                    (t[(t.ResponseHeader = 2)] = 'ResponseHeader'),
                    (t[(t.DownloadProgress = 3)] = 'DownloadProgress'),
                    (t[(t.Response = 4)] = 'Response'),
                    (t[(t.User = 5)] = 'User'),
                    t
                );
            })(vc || {});
            class Ym {
                constructor(n, e = Kd.Ok, i = 'OK') {
                    (this.headers = n.headers || new aa()),
                        (this.status = void 0 !== n.status ? n.status : e),
                        (this.statusText = n.statusText || i),
                        (this.url = n.url || null),
                        (this.ok = this.status >= 200 && this.status < 300);
                }
            }
            class q4 extends Ym {
                constructor(n = {}) {
                    super(n), (this.type = vc.ResponseHeader);
                }
                clone(n = {}) {
                    return new q4({
                        headers: n.headers || this.headers,
                        status: void 0 !== n.status ? n.status : this.status,
                        statusText: n.statusText || this.statusText,
                        url: n.url || this.url || void 0,
                    });
                }
            }
            class _u extends Ym {
                constructor(n = {}) {
                    super(n), (this.type = vc.Response), (this.body = void 0 !== n.body ? n.body : null);
                }
                clone(n = {}) {
                    return new _u({
                        body: void 0 !== n.body ? n.body : this.body,
                        headers: n.headers || this.headers,
                        status: void 0 !== n.status ? n.status : this.status,
                        statusText: n.statusText || this.statusText,
                        url: n.url || this.url || void 0,
                    });
                }
            }
            class K1 extends Ym {
                constructor(n) {
                    super(n, 0, 'Unknown Error'),
                        (this.name = 'HttpErrorResponse'),
                        (this.ok = !1),
                        (this.message =
                            this.status >= 200 && this.status < 300
                                ? `Http failure during parsing for ${n.url || '(unknown url)'}`
                                : `Http failure response for ${n.url || '(unknown url)'}: ${n.status} ${n.statusText}`),
                        (this.error = n.error || null);
                }
            }
            var Kd = (function (t) {
                return (
                    (t[(t.Continue = 100)] = 'Continue'),
                    (t[(t.SwitchingProtocols = 101)] = 'SwitchingProtocols'),
                    (t[(t.Processing = 102)] = 'Processing'),
                    (t[(t.EarlyHints = 103)] = 'EarlyHints'),
                    (t[(t.Ok = 200)] = 'Ok'),
                    (t[(t.Created = 201)] = 'Created'),
                    (t[(t.Accepted = 202)] = 'Accepted'),
                    (t[(t.NonAuthoritativeInformation = 203)] = 'NonAuthoritativeInformation'),
                    (t[(t.NoContent = 204)] = 'NoContent'),
                    (t[(t.ResetContent = 205)] = 'ResetContent'),
                    (t[(t.PartialContent = 206)] = 'PartialContent'),
                    (t[(t.MultiStatus = 207)] = 'MultiStatus'),
                    (t[(t.AlreadyReported = 208)] = 'AlreadyReported'),
                    (t[(t.ImUsed = 226)] = 'ImUsed'),
                    (t[(t.MultipleChoices = 300)] = 'MultipleChoices'),
                    (t[(t.MovedPermanently = 301)] = 'MovedPermanently'),
                    (t[(t.Found = 302)] = 'Found'),
                    (t[(t.SeeOther = 303)] = 'SeeOther'),
                    (t[(t.NotModified = 304)] = 'NotModified'),
                    (t[(t.UseProxy = 305)] = 'UseProxy'),
                    (t[(t.Unused = 306)] = 'Unused'),
                    (t[(t.TemporaryRedirect = 307)] = 'TemporaryRedirect'),
                    (t[(t.PermanentRedirect = 308)] = 'PermanentRedirect'),
                    (t[(t.BadRequest = 400)] = 'BadRequest'),
                    (t[(t.Unauthorized = 401)] = 'Unauthorized'),
                    (t[(t.PaymentRequired = 402)] = 'PaymentRequired'),
                    (t[(t.Forbidden = 403)] = 'Forbidden'),
                    (t[(t.NotFound = 404)] = 'NotFound'),
                    (t[(t.MethodNotAllowed = 405)] = 'MethodNotAllowed'),
                    (t[(t.NotAcceptable = 406)] = 'NotAcceptable'),
                    (t[(t.ProxyAuthenticationRequired = 407)] = 'ProxyAuthenticationRequired'),
                    (t[(t.RequestTimeout = 408)] = 'RequestTimeout'),
                    (t[(t.Conflict = 409)] = 'Conflict'),
                    (t[(t.Gone = 410)] = 'Gone'),
                    (t[(t.LengthRequired = 411)] = 'LengthRequired'),
                    (t[(t.PreconditionFailed = 412)] = 'PreconditionFailed'),
                    (t[(t.PayloadTooLarge = 413)] = 'PayloadTooLarge'),
                    (t[(t.UriTooLong = 414)] = 'UriTooLong'),
                    (t[(t.UnsupportedMediaType = 415)] = 'UnsupportedMediaType'),
                    (t[(t.RangeNotSatisfiable = 416)] = 'RangeNotSatisfiable'),
                    (t[(t.ExpectationFailed = 417)] = 'ExpectationFailed'),
                    (t[(t.ImATeapot = 418)] = 'ImATeapot'),
                    (t[(t.MisdirectedRequest = 421)] = 'MisdirectedRequest'),
                    (t[(t.UnprocessableEntity = 422)] = 'UnprocessableEntity'),
                    (t[(t.Locked = 423)] = 'Locked'),
                    (t[(t.FailedDependency = 424)] = 'FailedDependency'),
                    (t[(t.TooEarly = 425)] = 'TooEarly'),
                    (t[(t.UpgradeRequired = 426)] = 'UpgradeRequired'),
                    (t[(t.PreconditionRequired = 428)] = 'PreconditionRequired'),
                    (t[(t.TooManyRequests = 429)] = 'TooManyRequests'),
                    (t[(t.RequestHeaderFieldsTooLarge = 431)] = 'RequestHeaderFieldsTooLarge'),
                    (t[(t.UnavailableForLegalReasons = 451)] = 'UnavailableForLegalReasons'),
                    (t[(t.InternalServerError = 500)] = 'InternalServerError'),
                    (t[(t.NotImplemented = 501)] = 'NotImplemented'),
                    (t[(t.BadGateway = 502)] = 'BadGateway'),
                    (t[(t.ServiceUnavailable = 503)] = 'ServiceUnavailable'),
                    (t[(t.GatewayTimeout = 504)] = 'GatewayTimeout'),
                    (t[(t.HttpVersionNotSupported = 505)] = 'HttpVersionNotSupported'),
                    (t[(t.VariantAlsoNegotiates = 506)] = 'VariantAlsoNegotiates'),
                    (t[(t.InsufficientStorage = 507)] = 'InsufficientStorage'),
                    (t[(t.LoopDetected = 508)] = 'LoopDetected'),
                    (t[(t.NotExtended = 510)] = 'NotExtended'),
                    (t[(t.NetworkAuthenticationRequired = 511)] = 'NetworkAuthenticationRequired'),
                    t
                );
            })(Kd || {});
            function jm(t, n) {
                return {
                    body: n,
                    headers: t.headers,
                    context: t.context,
                    observe: t.observe,
                    params: t.params,
                    reportProgress: t.reportProgress,
                    responseType: t.responseType,
                    withCredentials: t.withCredentials,
                    transferCache: t.transferCache,
                };
            }
            let $m = (() => {
                class t {
                    constructor(e) {
                        this.handler = e;
                    }
                    request(e, i, r = {}) {
                        let s;
                        if (e instanceof Wd) s = e;
                        else {
                            let l, c;
                            (l = r.headers instanceof aa ? r.headers : new aa(r.headers)),
                                r.params && (c = r.params instanceof gc ? r.params : new gc({ fromObject: r.params })),
                                (s = new Wd(e, i, void 0 !== r.body ? r.body : null, {
                                    headers: l,
                                    context: r.context,
                                    params: c,
                                    reportProgress: r.reportProgress,
                                    responseType: r.responseType || 'json',
                                    withCredentials: r.withCredentials,
                                    transferCache: r.transferCache,
                                }));
                        }
                        const o = Uo(s).pipe(
                            (function qU(t, n) {
                                return et(n) ? G1(t, n, 1) : G1(t, 1);
                            })(l => this.handler.handle(l)),
                        );
                        if (e instanceof Wd || 'events' === r.observe) return o;
                        const a = o.pipe(al(l => l instanceof _u));
                        switch (r.observe || 'body') {
                            case 'body':
                                switch (s.responseType) {
                                    case 'arraybuffer':
                                        return a.pipe(
                                            Ct(l => {
                                                if (null !== l.body && !(l.body instanceof ArrayBuffer))
                                                    throw new Error('Response is not an ArrayBuffer.');
                                                return l.body;
                                            }),
                                        );
                                    case 'blob':
                                        return a.pipe(
                                            Ct(l => {
                                                if (null !== l.body && !(l.body instanceof Blob))
                                                    throw new Error('Response is not a Blob.');
                                                return l.body;
                                            }),
                                        );
                                    case 'text':
                                        return a.pipe(
                                            Ct(l => {
                                                if (null !== l.body && 'string' != typeof l.body)
                                                    throw new Error('Response is not a string.');
                                                return l.body;
                                            }),
                                        );
                                    default:
                                        return a.pipe(Ct(l => l.body));
                                }
                            case 'response':
                                return a;
                            default:
                                throw new Error(`Unreachable: unhandled observe type ${r.observe}}`);
                        }
                    }
                    delete(e, i = {}) {
                        return this.request('DELETE', e, i);
                    }
                    get(e, i = {}) {
                        return this.request('GET', e, i);
                    }
                    head(e, i = {}) {
                        return this.request('HEAD', e, i);
                    }
                    jsonp(e, i) {
                        return this.request('JSONP', e, {
                            params: new gc().append(i, 'JSONP_CALLBACK'),
                            observe: 'body',
                            responseType: 'json',
                        });
                    }
                    options(e, i = {}) {
                        return this.request('OPTIONS', e, i);
                    }
                    patch(e, i, r = {}) {
                        return this.request('PATCH', e, jm(r, i));
                    }
                    post(e, i, r = {}) {
                        return this.request('POST', e, jm(r, i));
                    }
                    put(e, i, r = {}) {
                        return this.request('PUT', e, jm(r, i));
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(U4));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            function Fw(t, n) {
                return n(t);
            }
            function tB(t, n) {
                return (e, i) => n.intercept(e, { handle: r => t(r, i) });
            }
            const iB = new $e(''),
                Qd = new $e(''),
                Rw = new $e(''),
                Vw = new $e('');
            function rB() {
                let t = null;
                return (n, e) => {
                    null === t && (t = (Ue(iB, { optional: !0 }) ?? []).reduceRight(tB, Fw));
                    const i = Ue(cu),
                        r = i.add();
                    return t(n, e).pipe(H4(() => i.remove(r)));
                };
            }
            let Hw = (() => {
                class t extends U4 {
                    constructor(e, i) {
                        super(),
                            (this.backend = e),
                            (this.injector = i),
                            (this.chain = null),
                            (this.pendingTasks = Ue(cu));
                        const r = Ue(Vw, { optional: !0 });
                        this.backend = r ?? e;
                    }
                    handle(e) {
                        if (null === this.chain) {
                            const r = Array.from(new Set([...this.injector.get(Qd), ...this.injector.get(Rw, [])]));
                            this.chain = r.reduceRight(
                                (s, o) =>
                                    (function nB(t, n, e) {
                                        return (i, r) =>
                                            (function Wc(t, n) {
                                                t instanceof Xl && t.assertNotDestroyed();
                                                const i = _r(t),
                                                    r = ve(void 0);
                                                try {
                                                    return n();
                                                } finally {
                                                    _r(i), ve(r);
                                                }
                                            })(e, () => n(i, s => t(s, r)));
                                    })(s, o, this.injector),
                                Fw,
                            );
                        }
                        const i = this.pendingTasks.add();
                        return this.chain(e, r => this.backend.handle(r)).pipe(H4(() => this.pendingTasks.remove(i)));
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(W1), Se(Io));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            const cB = /^\)\]\}',?\n/;
            let Bw = (() => {
                class t {
                    constructor(e) {
                        this.xhrFactory = e;
                    }
                    handle(e) {
                        if ('JSONP' === e.method) throw new Me(-2800, !1);
                        const i = this.xhrFactory;
                        return (i.ɵloadImpl ? ol(i.ɵloadImpl()) : Uo(null)).pipe(
                            vu(
                                () =>
                                    new Tn(s => {
                                        const o = i.build();
                                        if (
                                            (o.open(e.method, e.urlWithParams),
                                            e.withCredentials && (o.withCredentials = !0),
                                            e.headers.forEach((W, ie) => o.setRequestHeader(W, ie.join(','))),
                                            e.headers.has('Accept') ||
                                                o.setRequestHeader('Accept', 'application/json, text/plain, */*'),
                                            !e.headers.has('Content-Type'))
                                        ) {
                                            const W = e.detectContentTypeHeader();
                                            null !== W && o.setRequestHeader('Content-Type', W);
                                        }
                                        if (e.responseType) {
                                            const W = e.responseType.toLowerCase();
                                            o.responseType = 'json' !== W ? W : 'text';
                                        }
                                        const a = e.serializeBody();
                                        let l = null;
                                        const c = () => {
                                                if (null !== l) return l;
                                                const W = o.statusText || 'OK',
                                                    ie = new aa(o.getAllResponseHeaders()),
                                                    he =
                                                        (function uB(t) {
                                                            return 'responseURL' in t && t.responseURL
                                                                ? t.responseURL
                                                                : /^X-Request-URL:/m.test(t.getAllResponseHeaders())
                                                                ? t.getResponseHeader('X-Request-URL')
                                                                : null;
                                                        })(o) || e.url;
                                                return (
                                                    (l = new q4({
                                                        headers: ie,
                                                        status: o.status,
                                                        statusText: W,
                                                        url: he,
                                                    })),
                                                    l
                                                );
                                            },
                                            f = () => {
                                                let { headers: W, status: ie, statusText: he, url: fe } = c(),
                                                    ze = null;
                                                ie !== Kd.NoContent &&
                                                    (ze = typeof o.response > 'u' ? o.responseText : o.response),
                                                    0 === ie && (ie = ze ? Kd.Ok : 0);
                                                let nt = ie >= 200 && ie < 300;
                                                if ('json' === e.responseType && 'string' == typeof ze) {
                                                    const kt = ze;
                                                    ze = ze.replace(cB, '');
                                                    try {
                                                        ze = '' !== ze ? JSON.parse(ze) : null;
                                                    } catch (Tt) {
                                                        (ze = kt), nt && ((nt = !1), (ze = { error: Tt, text: ze }));
                                                    }
                                                }
                                                nt
                                                    ? (s.next(
                                                          new _u({
                                                              body: ze,
                                                              headers: W,
                                                              status: ie,
                                                              statusText: he,
                                                              url: fe || void 0,
                                                          }),
                                                      ),
                                                      s.complete())
                                                    : s.error(
                                                          new K1({
                                                              error: ze,
                                                              headers: W,
                                                              status: ie,
                                                              statusText: he,
                                                              url: fe || void 0,
                                                          }),
                                                      );
                                            },
                                            g = W => {
                                                const { url: ie } = c(),
                                                    he = new K1({
                                                        error: W,
                                                        status: o.status || 0,
                                                        statusText: o.statusText || 'Unknown Error',
                                                        url: ie || void 0,
                                                    });
                                                s.error(he);
                                            };
                                        let E = !1;
                                        const P = W => {
                                                E || (s.next(c()), (E = !0));
                                                let ie = { type: vc.DownloadProgress, loaded: W.loaded };
                                                W.lengthComputable && (ie.total = W.total),
                                                    'text' === e.responseType &&
                                                        o.responseText &&
                                                        (ie.partialText = o.responseText),
                                                    s.next(ie);
                                            },
                                            V = W => {
                                                let ie = { type: vc.UploadProgress, loaded: W.loaded };
                                                W.lengthComputable && (ie.total = W.total), s.next(ie);
                                            };
                                        return (
                                            o.addEventListener('load', f),
                                            o.addEventListener('error', g),
                                            o.addEventListener('timeout', g),
                                            o.addEventListener('abort', g),
                                            e.reportProgress &&
                                                (o.addEventListener('progress', P),
                                                null !== a && o.upload && o.upload.addEventListener('progress', V)),
                                            o.send(a),
                                            s.next({ type: vc.Sent }),
                                            () => {
                                                o.removeEventListener('error', g),
                                                    o.removeEventListener('abort', g),
                                                    o.removeEventListener('load', f),
                                                    o.removeEventListener('timeout', g),
                                                    e.reportProgress &&
                                                        (o.removeEventListener('progress', P),
                                                        null !== a &&
                                                            o.upload &&
                                                            o.upload.removeEventListener('progress', V)),
                                                    o.readyState !== o.DONE && o.abort();
                                            }
                                        );
                                    }),
                            ),
                        );
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(YC));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            const Km = new $e(''),
                qw = new $e('', { providedIn: 'root', factory: () => 'XSRF-TOKEN' }),
                Yw = new $e('', { providedIn: 'root', factory: () => 'X-XSRF-TOKEN' });
            class jw {}
            let fB = (() => {
                class t {
                    constructor(e, i, r) {
                        (this.doc = e),
                            (this.platform = i),
                            (this.cookieName = r),
                            (this.lastCookieString = ''),
                            (this.lastToken = null),
                            (this.parseCount = 0);
                    }
                    getToken() {
                        if ('server' === this.platform) return null;
                        const e = this.doc.cookie || '';
                        return (
                            e !== this.lastCookieString &&
                                (this.parseCount++,
                                (this.lastToken = IC(e, this.cookieName)),
                                (this.lastCookieString = e)),
                            this.lastToken
                        );
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(Ni), Se(Za), Se(qw));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            function mB(t, n) {
                const e = t.url.toLowerCase();
                if (
                    !Ue(Km) ||
                    'GET' === t.method ||
                    'HEAD' === t.method ||
                    e.startsWith('http://') ||
                    e.startsWith('https://')
                )
                    return n(t);
                const i = Ue(jw).getToken(),
                    r = Ue(Yw);
                return null != i && !t.headers.has(r) && (t = t.clone({ headers: t.headers.set(r, i) })), n(t);
            }
            var _c = (function (t) {
                return (
                    (t[(t.Interceptors = 0)] = 'Interceptors'),
                    (t[(t.LegacyInterceptors = 1)] = 'LegacyInterceptors'),
                    (t[(t.CustomXsrfConfiguration = 2)] = 'CustomXsrfConfiguration'),
                    (t[(t.NoXsrfProtection = 3)] = 'NoXsrfProtection'),
                    (t[(t.JsonpSupport = 4)] = 'JsonpSupport'),
                    (t[(t.RequestsMadeViaParent = 5)] = 'RequestsMadeViaParent'),
                    (t[(t.Fetch = 6)] = 'Fetch'),
                    t
                );
            })(_c || {});
            function pB(...t) {
                const n = [
                    $m,
                    Bw,
                    Hw,
                    { provide: U4, useExisting: Hw },
                    { provide: W1, useExisting: Bw },
                    { provide: Qd, useValue: mB, multi: !0 },
                    { provide: Km, useValue: !0 },
                    { provide: jw, useClass: fB },
                ];
                for (const e of t) n.push(...e.ɵproviders);
                return _s(n);
            }
            const $w = new $e('');
            function gB() {
                return (function yu(t, n) {
                    return { ɵkind: t, ɵproviders: n };
                })(_c.LegacyInterceptors, [
                    { provide: $w, useFactory: rB },
                    { provide: Qd, useExisting: $w, multi: !0 },
                ]);
            }
            let vB = (() => {
                class t {
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵmod = Zn({ type: t }));
                    static #n = (this.ɵinj = zn({ providers: [pB(gB())] }));
                }
                return t;
            })();
            /**
             * @license
             * Copyright Google LLC All Rights Reserved.
             *
             * Use of this source code is governed by an MIT-style license that can be
             * found in the LICENSE file at https://angular.io/license
             */
            const bu = void 0,
                SB = [
                    'en',
                    [['a', 'p'], ['AM', 'PM'], bu],
                    [['AM', 'PM'], bu, bu],
                    [
                        ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                        ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                        ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                        ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                    ],
                    bu,
                    [
                        ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
                        ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                        [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                            'August',
                            'September',
                            'October',
                            'November',
                            'December',
                        ],
                    ],
                    bu,
                    [
                        ['B', 'A'],
                        ['BC', 'AD'],
                        ['Before Christ', 'Anno Domini'],
                    ],
                    0,
                    [6, 0],
                    ['M/d/yy', 'MMM d, y', 'MMMM d, y', 'EEEE, MMMM d, y'],
                    ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'],
                    ['{1}, {0}', bu, "{1} 'at' {0}", bu],
                    ['.', ',', ';', '%', '+', '-', 'E', '\xd7', '\u2030', '\u221e', 'NaN', ':'],
                    ['#,##0.###', '#,##0%', '\xa4#,##0.00', '#E0'],
                    'USD',
                    '$',
                    'US Dollar',
                    {},
                    'ltr',
                    function MB(t) {
                        const e = Math.floor(Math.abs(t)),
                            i = t.toString().replace(/^[^.]*\.?/, '').length;
                        return 1 === e && 0 === i ? 1 : 5;
                    },
                ],
                ds = void 0,
                DB = [
                    'de',
                    [['AM', 'PM'], ds, ds],
                    ds,
                    [
                        ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
                        ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
                        ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                        ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
                    ],
                    [
                        ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
                        ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                        ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                        ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
                    ],
                    [
                        ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
                        [
                            'Jan.',
                            'Feb.',
                            'M\xe4rz',
                            'Apr.',
                            'Mai',
                            'Juni',
                            'Juli',
                            'Aug.',
                            'Sept.',
                            'Okt.',
                            'Nov.',
                            'Dez.',
                        ],
                        [
                            'Januar',
                            'Februar',
                            'M\xe4rz',
                            'April',
                            'Mai',
                            'Juni',
                            'Juli',
                            'August',
                            'September',
                            'Oktober',
                            'November',
                            'Dezember',
                        ],
                    ],
                    [
                        ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
                        ['Jan', 'Feb', 'M\xe4r', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                        [
                            'Januar',
                            'Februar',
                            'M\xe4rz',
                            'April',
                            'Mai',
                            'Juni',
                            'Juli',
                            'August',
                            'September',
                            'Oktober',
                            'November',
                            'Dezember',
                        ],
                    ],
                    [['v. Chr.', 'n. Chr.'], ds, ds],
                    1,
                    [6, 0],
                    ['dd.MM.yy', 'dd.MM.y', 'd. MMMM y', 'EEEE, d. MMMM y'],
                    ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
                    ['{1}, {0}', ds, "{1} 'um' {0}", ds],
                    [',', '.', ';', '%', '+', '-', 'E', '\xb7', '\u2030', '\u221e', 'NaN', ':'],
                    ['#,##0.###', '#,##0\xa0%', '#,##0.00\xa0\xa4', '#E0'],
                    'EUR',
                    '\u20ac',
                    'Euro',
                    {
                        ATS: ['\xf6S'],
                        AUD: ['AU$', '$'],
                        BGM: ['BGK'],
                        BGO: ['BGJ'],
                        BYN: [ds, '\u0440.'],
                        CUC: [ds, 'Cub$'],
                        DEM: ['DM'],
                        FKP: [ds, 'Fl\xa3'],
                        GHS: [ds, '\u20b5'],
                        GNF: [ds, 'F.G.'],
                        KMF: [ds, 'FC'],
                        PHP: [ds, '\u20b1'],
                        RON: [ds, 'L'],
                        RUR: [ds, '\u0440.'],
                        RWF: [ds, 'F.Rw'],
                        SYP: [],
                        THB: ['\u0e3f'],
                        TWD: ['NT$'],
                        XXX: [],
                        ZMW: [ds, 'K'],
                    },
                    'ltr',
                    function TB(t) {
                        const e = Math.floor(Math.abs(t)),
                            i = t.toString().replace(/^[^.]*\.?/, '').length;
                        return 1 === e && 0 === i ? 1 : 5;
                    },
                ],
                Ei = void 0,
                kB = [
                    'ro',
                    [['a.m.', 'p.m.'], Ei, Ei],
                    Ei,
                    [
                        ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
                        ['dum.', 'lun.', 'mar.', 'mie.', 'joi', 'vin.', 's\xe2m.'],
                        ['duminic\u0103', 'luni', 'mar\u021bi', 'miercuri', 'joi', 'vineri', 's\xe2mb\u0103t\u0103'],
                        ['du.', 'lu.', 'ma.', 'mi.', 'joi', 'vi.', 's\xe2.'],
                    ],
                    Ei,
                    [
                        ['I', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
                        [
                            'ian.',
                            'feb.',
                            'mar.',
                            'apr.',
                            'mai',
                            'iun.',
                            'iul.',
                            'aug.',
                            'sept.',
                            'oct.',
                            'nov.',
                            'dec.',
                        ],
                        [
                            'ianuarie',
                            'februarie',
                            'martie',
                            'aprilie',
                            'mai',
                            'iunie',
                            'iulie',
                            'august',
                            'septembrie',
                            'octombrie',
                            'noiembrie',
                            'decembrie',
                        ],
                    ],
                    Ei,
                    [['\xee.Hr.', 'd.Hr.'], Ei, ['\xeenainte de Hristos', 'dup\u0103 Hristos']],
                    1,
                    [6, 0],
                    ['dd.MM.y', 'd MMM y', 'd MMMM y', 'EEEE, d MMMM y'],
                    ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
                    ['{1}, {0}', Ei, Ei, Ei],
                    [',', '.', ';', '%', '+', '-', 'E', '\xd7', '\u2030', '\u221e', 'NaN', ':'],
                    ['#,##0.###', '#,##0\xa0%', '#,##0.00\xa0\xa4', '#E0'],
                    'RON',
                    'RON',
                    'leu rom\xe2nesc',
                    {
                        AUD: [Ei, '$'],
                        BRL: [Ei, 'R$'],
                        BYN: [Ei, '\u0440.'],
                        CAD: [Ei, '$'],
                        CNY: [Ei, '\xa5'],
                        EUR: [Ei, '\u20ac'],
                        GBP: [Ei, '\xa3'],
                        HKD: [Ei, '$'],
                        ILS: [Ei, '\u20aa'],
                        INR: [Ei, '\u20b9'],
                        JPY: [Ei, '\xa5'],
                        KRW: [Ei, '\u20a9'],
                        MXN: [Ei, '$'],
                        NZD: [Ei, '$'],
                        PHP: [Ei, '\u20b1'],
                        TWD: [Ei, 'NT$'],
                        USD: [Ei, '$'],
                        VND: [Ei, '\u20ab'],
                        XCD: [Ei, '$'],
                    },
                    'ltr',
                    function xB(t) {
                        const n = t,
                            e = Math.floor(Math.abs(t)),
                            i = t.toString().replace(/^[^.]*\.?/, '').length;
                        return 1 === e && 0 === i
                            ? 1
                            : 0 !== i || 0 === n || (n % 100 === Math.floor(n % 100) && n % 100 >= 2 && n % 100 <= 19)
                            ? 3
                            : 5;
                    },
                ],
                Qm = { now: () => (Qm.delegate || Date).now(), delegate: void 0 };
            class yc extends vt {
                constructor(n = 1 / 0, e = 1 / 0, i = Qm) {
                    super(),
                        (this._bufferSize = n),
                        (this._windowTime = e),
                        (this._timestampProvider = i),
                        (this._buffer = []),
                        (this._infiniteTimeWindow = !0),
                        (this._infiniteTimeWindow = e === 1 / 0),
                        (this._bufferSize = Math.max(1, n)),
                        (this._windowTime = Math.max(1, e));
                }
                next(n) {
                    const {
                        isStopped: e,
                        _buffer: i,
                        _infiniteTimeWindow: r,
                        _timestampProvider: s,
                        _windowTime: o,
                    } = this;
                    e || (i.push(n), !r && i.push(s.now() + o)), this._trimBuffer(), super.next(n);
                }
                _subscribe(n) {
                    this._throwIfClosed(), this._trimBuffer();
                    const e = this._innerSubscribe(n),
                        { _infiniteTimeWindow: i, _buffer: r } = this,
                        s = r.slice();
                    for (let o = 0; o < s.length && !n.closed; o += i ? 1 : 2) n.next(s[o]);
                    return this._checkFinalizedStatuses(n), e;
                }
                _trimBuffer() {
                    const { _bufferSize: n, _timestampProvider: e, _buffer: i, _infiniteTimeWindow: r } = this,
                        s = (r ? 1 : 2) * n;
                    if ((n < 1 / 0 && s < i.length && i.splice(0, i.length - s), !r)) {
                        const o = e.now();
                        let a = 0;
                        for (let l = 1; l < i.length && i[l] <= o; l += 2) a = l;
                        a && i.splice(0, a + 1);
                    }
                }
            }
            function eM(t = 1 / 0) {
                return G1(Yn, t);
            }
            const j4 = new Tn(t => t.complete());
            function Xm(...t) {
                const n = Gd(t),
                    e = (function lU(t, n) {
                        return 'number' == typeof Fm(t) ? t.pop() : n;
                    })(t, 1 / 0),
                    i = t;
                return i.length ? (1 === i.length ? bs(i[0]) : eM(e)(ol(i, n))) : j4;
            }
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */ const $4 = {
                schedule(t, n) {
                    const e = setTimeout(t, n);
                    return () => clearTimeout(e);
                },
                scheduleBeforeRender(t) {
                    if (typeof window > 'u') return $4.schedule(t, 0);
                    if (typeof window.requestAnimationFrame > 'u') return $4.schedule(t, 16);
                    const n = window.requestAnimationFrame(t);
                    return () => window.cancelAnimationFrame(n);
                },
            };
            let Zm;
            function RB(t, n, e) {
                let i = e;
                return (
                    (function AB(t) {
                        return !!t && t.nodeType === Node.ELEMENT_NODE;
                    })(t) &&
                        n.some(
                            (r, s) =>
                                !(
                                    '*' === r ||
                                    !(function OB(t, n) {
                                        if (!Zm) {
                                            const e = Element.prototype;
                                            Zm =
                                                e.matches ||
                                                e.matchesSelector ||
                                                e.mozMatchesSelector ||
                                                e.msMatchesSelector ||
                                                e.oMatchesSelector ||
                                                e.webkitMatchesSelector;
                                        }
                                        return t.nodeType === Node.ELEMENT_NODE && Zm.call(t, n);
                                    })(t, r) ||
                                    ((i = s), 0)
                                ),
                        ),
                    i
                );
            }
            class HB {
                constructor(n, e) {
                    this.componentFactory = e.get(su).resolveComponentFactory(n);
                }
                create(n) {
                    return new UB(this.componentFactory, n);
                }
            }
            class UB {
                constructor(n, e) {
                    (this.componentFactory = n),
                        (this.injector = e),
                        (this.eventEmitters = new yc(1)),
                        (this.events = this.eventEmitters.pipe(vu(i => Xm(...i)))),
                        (this.componentRef = null),
                        (this.viewChangeDetectorRef = null),
                        (this.inputChanges = null),
                        (this.hasInputChanges = !1),
                        (this.implementsOnChanges = !1),
                        (this.scheduledChangeDetectionFn = null),
                        (this.scheduledDestroyFn = null),
                        (this.initialInputValues = new Map()),
                        (this.unchangedInputs = new Set(this.componentFactory.inputs.map(({ propName: i }) => i))),
                        (this.ngZone = this.injector.get(en)),
                        (this.elementZone = typeof Zone > 'u' ? null : this.ngZone.run(() => Zone.current));
                }
                connect(n) {
                    this.runInZone(() => {
                        if (null !== this.scheduledDestroyFn)
                            return this.scheduledDestroyFn(), void (this.scheduledDestroyFn = null);
                        null === this.componentRef && this.initializeComponent(n);
                    });
                }
                disconnect() {
                    this.runInZone(() => {
                        null === this.componentRef ||
                            null !== this.scheduledDestroyFn ||
                            (this.scheduledDestroyFn = $4.schedule(() => {
                                null !== this.componentRef &&
                                    (this.componentRef.destroy(),
                                    (this.componentRef = null),
                                    (this.viewChangeDetectorRef = null));
                            }, 10));
                    });
                }
                getInputValue(n) {
                    return this.runInZone(() =>
                        null === this.componentRef ? this.initialInputValues.get(n) : this.componentRef.instance[n],
                    );
                }
                setInputValue(n, e, i) {
                    this.runInZone(() => {
                        i && (e = i.call(this.componentRef?.instance, e)),
                            null !== this.componentRef
                                ? ((function zB(t, n) {
                                      return t === n || (t != t && n != n);
                                  })(e, this.getInputValue(n)) &&
                                      (void 0 !== e || !this.unchangedInputs.has(n))) ||
                                  (this.recordInputChange(n, e),
                                  this.unchangedInputs.delete(n),
                                  (this.hasInputChanges = !0),
                                  (this.componentRef.instance[n] = e),
                                  this.scheduleDetectChanges())
                                : this.initialInputValues.set(n, e);
                    });
                }
                initializeComponent(n) {
                    const e = ys.create({ providers: [], parent: this.injector }),
                        i = (function FB(t, n) {
                            const e = t.childNodes,
                                i = n.map(() => []);
                            let r = -1;
                            n.some((s, o) => '*' === s && ((r = o), !0));
                            for (let s = 0, o = e.length; s < o; ++s) {
                                const a = e[s],
                                    l = RB(a, n, r);
                                -1 !== l && i[l].push(a);
                            }
                            return i;
                        })(n, this.componentFactory.ngContentSelectors);
                    (this.componentRef = this.componentFactory.create(e, i, n)),
                        (this.viewChangeDetectorRef = this.componentRef.injector.get(kr)),
                        (this.implementsOnChanges = (function LB(t) {
                            return 'function' == typeof t;
                        })(this.componentRef.instance.ngOnChanges)),
                        this.initializeInputs(),
                        this.initializeOutputs(this.componentRef),
                        this.detectChanges(),
                        this.injector.get(xl).attachView(this.componentRef.hostView);
                }
                initializeInputs() {
                    this.componentFactory.inputs.forEach(({ propName: n, transform: e }) => {
                        this.initialInputValues.has(n) && this.setInputValue(n, this.initialInputValues.get(n), e);
                    }),
                        this.initialInputValues.clear();
                }
                initializeOutputs(n) {
                    const e = this.componentFactory.outputs.map(({ propName: i, templateName: r }) =>
                        n.instance[i].pipe(Ct(o => ({ name: r, value: o }))),
                    );
                    this.eventEmitters.next(e);
                }
                callNgOnChanges(n) {
                    if (!this.implementsOnChanges || null === this.inputChanges) return;
                    const e = this.inputChanges;
                    (this.inputChanges = null), n.instance.ngOnChanges(e);
                }
                markViewForCheck(n) {
                    this.hasInputChanges && ((this.hasInputChanges = !1), n.markForCheck());
                }
                scheduleDetectChanges() {
                    this.scheduledChangeDetectionFn ||
                        (this.scheduledChangeDetectionFn = $4.scheduleBeforeRender(() => {
                            (this.scheduledChangeDetectionFn = null), this.detectChanges();
                        }));
                }
                recordInputChange(n, e) {
                    if (!this.implementsOnChanges) return;
                    null === this.inputChanges && (this.inputChanges = {});
                    const i = this.inputChanges[n];
                    if (i) return void (i.currentValue = e);
                    const r = this.unchangedInputs.has(n),
                        s = r ? void 0 : this.getInputValue(n);
                    this.inputChanges[n] = new m(s, e, r);
                }
                detectChanges() {
                    null !== this.componentRef &&
                        (this.callNgOnChanges(this.componentRef),
                        this.markViewForCheck(this.viewChangeDetectorRef),
                        this.componentRef.changeDetectorRef.detectChanges());
                }
                runInZone(n) {
                    return this.elementZone && Zone.current !== this.elementZone ? this.ngZone.run(n) : n();
                }
            }
            class BB extends HTMLElement {
                constructor() {
                    super(...arguments), (this.ngElementEventsSubscription = null);
                }
            }
            const { isArray: YB } = Array,
                { getPrototypeOf: jB, prototype: $B, keys: GB } = Object;
            function tM(t) {
                if (1 === t.length) {
                    const n = t[0];
                    if (YB(n)) return { args: n, keys: null };
                    if (
                        (function WB(t) {
                            return t && 'object' == typeof t && jB(t) === $B;
                        })(n)
                    ) {
                        const e = GB(n);
                        return { args: e.map(i => n[i]), keys: e };
                    }
                }
                return { args: t, keys: null };
            }
            const { isArray: KB } = Array;
            function Jm(t) {
                return Ct(n =>
                    (function QB(t, n) {
                        return KB(n) ? t(...n) : t(n);
                    })(t, n),
                );
            }
            function nM(t, n) {
                return t.reduce((e, i, r) => ((e[i] = n[r]), e), {});
            }
            function G4(...t) {
                const n = Rm(t),
                    { args: e, keys: i } = tM(t),
                    r = new Tn(s => {
                        const { length: o } = e;
                        if (!o) return void s.complete();
                        const a = new Array(o);
                        let l = o,
                            c = o;
                        for (let f = 0; f < o; f++) {
                            let g = !1;
                            bs(e[f]).subscribe(
                                ln(
                                    s,
                                    E => {
                                        g || ((g = !0), c--), (a[f] = E);
                                    },
                                    () => l--,
                                    void 0,
                                    () => {
                                        (!l || !g) && (c || s.next(i ? nM(i, a) : a), s.complete());
                                    },
                                ),
                            );
                        }
                    });
                return n ? r.pipe(Jm(n)) : r;
            }
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */ let iM = (() => {
                    class t {
                        constructor(e, i) {
                            (this._renderer = e),
                                (this._elementRef = i),
                                (this.onChange = r => {}),
                                (this.onTouched = () => {});
                        }
                        setProperty(e, i) {
                            this._renderer.setProperty(this._elementRef.nativeElement, e, i);
                        }
                        registerOnTouched(e) {
                            this.onTouched = e;
                        }
                        registerOnChange(e) {
                            this.onChange = e;
                        }
                        setDisabledState(e) {
                            this.setProperty('disabled', e);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Ps), te(Pn));
                        });
                        static #t = (this.ɵdir = gt({ type: t }));
                    }
                    return t;
                })(),
                Cu = (() => {
                    class t extends iM {
                        static #e = (this.ɵfac = (() => {
                            let e;
                            return function (r) {
                                return (e || (e = Nr(t)))(r || t);
                            };
                        })());
                        static #t = (this.ɵdir = gt({ type: t, features: [Cn] }));
                    }
                    return t;
                })();
            const hs = new $e(''),
                XB = { provide: hs, useExisting: Wt(() => W4), multi: !0 };
            let W4 = (() => {
                class t extends Cu {
                    writeValue(e) {
                        this.setProperty('checked', e);
                    }
                    static #e = (this.ɵfac = (() => {
                        let e;
                        return function (r) {
                            return (e || (e = Nr(t)))(r || t);
                        };
                    })());
                    static #t = (this.ɵdir = gt({
                        type: t,
                        selectors: [
                            ['input', 'type', 'checkbox', 'formControlName', ''],
                            ['input', 'type', 'checkbox', 'formControl', ''],
                            ['input', 'type', 'checkbox', 'ngModel', ''],
                        ],
                        hostBindings: function (i, r) {
                            1 & i &&
                                Le('change', function (o) {
                                    return r.onChange(o.target.checked);
                                })('blur', function () {
                                    return r.onTouched();
                                });
                        },
                        features: [$n([XB]), Cn],
                    }));
                }
                return t;
            })();
            const ZB = { provide: hs, useExisting: Wt(() => xa), multi: !0 },
                eq = new $e('');
            let xa = (() => {
                class t extends iM {
                    constructor(e, i, r) {
                        super(e, i),
                            (this._compositionMode = r),
                            (this._composing = !1),
                            null == this._compositionMode &&
                                (this._compositionMode = !(function JB() {
                                    const t = fc() ? fc().getUserAgent() : '';
                                    return /android (\d+)/.test(t.toLowerCase());
                                })());
                    }
                    writeValue(e) {
                        this.setProperty('value', e ?? '');
                    }
                    _handleInput(e) {
                        (!this._compositionMode || (this._compositionMode && !this._composing)) && this.onChange(e);
                    }
                    _compositionStart() {
                        this._composing = !0;
                    }
                    _compositionEnd(e) {
                        (this._composing = !1), this._compositionMode && this.onChange(e);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Ps), te(Pn), te(eq, 8));
                    });
                    static #t = (this.ɵdir = gt({
                        type: t,
                        selectors: [
                            ['input', 'formControlName', '', 3, 'type', 'checkbox'],
                            ['textarea', 'formControlName', ''],
                            ['input', 'formControl', '', 3, 'type', 'checkbox'],
                            ['textarea', 'formControl', ''],
                            ['input', 'ngModel', '', 3, 'type', 'checkbox'],
                            ['textarea', 'ngModel', ''],
                            ['', 'ngDefaultControl', ''],
                        ],
                        hostBindings: function (i, r) {
                            1 & i &&
                                Le('input', function (o) {
                                    return r._handleInput(o.target.value);
                                })('blur', function () {
                                    return r.onTouched();
                                })('compositionstart', function () {
                                    return r._compositionStart();
                                })('compositionend', function (o) {
                                    return r._compositionEnd(o.target.value);
                                });
                        },
                        features: [$n([ZB]), Cn],
                    }));
                }
                return t;
            })();
            const Ns = new $e(''),
                Cc = new $e('');
            function fM(t) {
                return null != t;
            }
            function mM(t) {
                return m4(t) ? ol(t) : t;
            }
            function pM(t) {
                let n = {};
                return (
                    t.forEach(e => {
                        n = null != e ? { ...n, ...e } : n;
                    }),
                    0 === Object.keys(n).length ? null : n
                );
            }
            function gM(t, n) {
                return n.map(e => e(t));
            }
            function vM(t) {
                return t.map(n =>
                    (function nq(t) {
                        return !t.validate;
                    })(n)
                        ? n
                        : e => n.validate(e),
                );
            }
            function ep(t) {
                return null != t
                    ? (function _M(t) {
                          if (!t) return null;
                          const n = t.filter(fM);
                          return 0 == n.length
                              ? null
                              : function (e) {
                                    return pM(gM(e, n));
                                };
                      })(vM(t))
                    : null;
            }
            function tp(t) {
                return null != t
                    ? (function yM(t) {
                          if (!t) return null;
                          const n = t.filter(fM);
                          return 0 == n.length
                              ? null
                              : function (e) {
                                    return G4(gM(e, n).map(mM)).pipe(Ct(pM));
                                };
                      })(vM(t))
                    : null;
            }
            function bM(t, n) {
                return null === t ? [n] : Array.isArray(t) ? [...t, n] : [t, n];
            }
            function np(t) {
                return t ? (Array.isArray(t) ? t : [t]) : [];
            }
            function Q4(t, n) {
                return Array.isArray(t) ? t.includes(n) : t === n;
            }
            function MM(t, n) {
                const e = np(n);
                return (
                    np(t).forEach(r => {
                        Q4(e, r) || e.push(r);
                    }),
                    e
                );
            }
            function SM(t, n) {
                return np(n).filter(e => !Q4(t, e));
            }
            class TM {
                constructor() {
                    (this._rawValidators = []), (this._rawAsyncValidators = []), (this._onDestroyCallbacks = []);
                }
                get value() {
                    return this.control ? this.control.value : null;
                }
                get valid() {
                    return this.control ? this.control.valid : null;
                }
                get invalid() {
                    return this.control ? this.control.invalid : null;
                }
                get pending() {
                    return this.control ? this.control.pending : null;
                }
                get disabled() {
                    return this.control ? this.control.disabled : null;
                }
                get enabled() {
                    return this.control ? this.control.enabled : null;
                }
                get errors() {
                    return this.control ? this.control.errors : null;
                }
                get pristine() {
                    return this.control ? this.control.pristine : null;
                }
                get dirty() {
                    return this.control ? this.control.dirty : null;
                }
                get touched() {
                    return this.control ? this.control.touched : null;
                }
                get status() {
                    return this.control ? this.control.status : null;
                }
                get untouched() {
                    return this.control ? this.control.untouched : null;
                }
                get statusChanges() {
                    return this.control ? this.control.statusChanges : null;
                }
                get valueChanges() {
                    return this.control ? this.control.valueChanges : null;
                }
                get path() {
                    return null;
                }
                _setValidators(n) {
                    (this._rawValidators = n || []), (this._composedValidatorFn = ep(this._rawValidators));
                }
                _setAsyncValidators(n) {
                    (this._rawAsyncValidators = n || []),
                        (this._composedAsyncValidatorFn = tp(this._rawAsyncValidators));
                }
                get validator() {
                    return this._composedValidatorFn || null;
                }
                get asyncValidator() {
                    return this._composedAsyncValidatorFn || null;
                }
                _registerOnDestroy(n) {
                    this._onDestroyCallbacks.push(n);
                }
                _invokeOnDestroyCallbacks() {
                    this._onDestroyCallbacks.forEach(n => n()), (this._onDestroyCallbacks = []);
                }
                reset(n = void 0) {
                    this.control && this.control.reset(n);
                }
                hasError(n, e) {
                    return !!this.control && this.control.hasError(n, e);
                }
                getError(n, e) {
                    return this.control ? this.control.getError(n, e) : null;
                }
            }
            class Js extends TM {
                get formDirective() {
                    return null;
                }
                get path() {
                    return null;
                }
            }
            class wc extends TM {
                constructor() {
                    super(...arguments), (this._parent = null), (this.name = null), (this.valueAccessor = null);
                }
            }
            class DM {
                constructor(n) {
                    this._cd = n;
                }
                get isTouched() {
                    return !!this._cd?.control?.touched;
                }
                get isUntouched() {
                    return !!this._cd?.control?.untouched;
                }
                get isPristine() {
                    return !!this._cd?.control?.pristine;
                }
                get isDirty() {
                    return !!this._cd?.control?.dirty;
                }
                get isValid() {
                    return !!this._cd?.control?.valid;
                }
                get isInvalid() {
                    return !!this._cd?.control?.invalid;
                }
                get isPending() {
                    return !!this._cd?.control?.pending;
                }
                get isSubmitted() {
                    return !!this._cd?.submitted;
                }
            }
            let eo = (() => {
                    class t extends DM {
                        constructor(e) {
                            super(e);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(wc, 2));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [
                                ['', 'formControlName', ''],
                                ['', 'ngModel', ''],
                                ['', 'formControl', ''],
                            ],
                            hostVars: 14,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('ng-untouched', r.isUntouched)('ng-touched', r.isTouched)(
                                        'ng-pristine',
                                        r.isPristine,
                                    )('ng-dirty', r.isDirty)('ng-valid', r.isValid)('ng-invalid', r.isInvalid)(
                                        'ng-pending',
                                        r.isPending,
                                    );
                            },
                            features: [Cn],
                        }));
                    }
                    return t;
                })(),
                xM = (() => {
                    class t extends DM {
                        constructor(e) {
                            super(e);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Js, 10));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [
                                ['', 'formGroupName', ''],
                                ['', 'formArrayName', ''],
                                ['', 'ngModelGroup', ''],
                                ['', 'formGroup', ''],
                                ['form', 3, 'ngNoForm', ''],
                                ['', 'ngForm', ''],
                            ],
                            hostVars: 16,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('ng-untouched', r.isUntouched)('ng-touched', r.isTouched)(
                                        'ng-pristine',
                                        r.isPristine,
                                    )('ng-dirty', r.isDirty)('ng-valid', r.isValid)('ng-invalid', r.isInvalid)(
                                        'ng-pending',
                                        r.isPending,
                                    )('ng-submitted', r.isSubmitted);
                            },
                            features: [Cn],
                        }));
                    }
                    return t;
                })();
            const Xd = 'VALID',
                Z4 = 'INVALID',
                Q1 = 'PENDING',
                Zd = 'DISABLED';
            function sp(t) {
                return (J4(t) ? t.validators : t) || null;
            }
            function op(t, n) {
                return (J4(n) ? n.asyncValidators : t) || null;
            }
            function J4(t) {
                return null != t && !Array.isArray(t) && 'object' == typeof t;
            }
            class ap {
                constructor(n, e) {
                    (this._pendingDirty = !1),
                        (this._hasOwnPendingAsyncValidator = !1),
                        (this._pendingTouched = !1),
                        (this._onCollectionChange = () => {}),
                        (this._parent = null),
                        (this.pristine = !0),
                        (this.touched = !1),
                        (this._onDisabledChange = []),
                        this._assignValidators(n),
                        this._assignAsyncValidators(e);
                }
                get validator() {
                    return this._composedValidatorFn;
                }
                set validator(n) {
                    this._rawValidators = this._composedValidatorFn = n;
                }
                get asyncValidator() {
                    return this._composedAsyncValidatorFn;
                }
                set asyncValidator(n) {
                    this._rawAsyncValidators = this._composedAsyncValidatorFn = n;
                }
                get parent() {
                    return this._parent;
                }
                get valid() {
                    return this.status === Xd;
                }
                get invalid() {
                    return this.status === Z4;
                }
                get pending() {
                    return this.status == Q1;
                }
                get disabled() {
                    return this.status === Zd;
                }
                get enabled() {
                    return this.status !== Zd;
                }
                get dirty() {
                    return !this.pristine;
                }
                get untouched() {
                    return !this.touched;
                }
                get updateOn() {
                    return this._updateOn ? this._updateOn : this.parent ? this.parent.updateOn : 'change';
                }
                setValidators(n) {
                    this._assignValidators(n);
                }
                setAsyncValidators(n) {
                    this._assignAsyncValidators(n);
                }
                addValidators(n) {
                    this.setValidators(MM(n, this._rawValidators));
                }
                addAsyncValidators(n) {
                    this.setAsyncValidators(MM(n, this._rawAsyncValidators));
                }
                removeValidators(n) {
                    this.setValidators(SM(n, this._rawValidators));
                }
                removeAsyncValidators(n) {
                    this.setAsyncValidators(SM(n, this._rawAsyncValidators));
                }
                hasValidator(n) {
                    return Q4(this._rawValidators, n);
                }
                hasAsyncValidator(n) {
                    return Q4(this._rawAsyncValidators, n);
                }
                clearValidators() {
                    this.validator = null;
                }
                clearAsyncValidators() {
                    this.asyncValidator = null;
                }
                markAsTouched(n = {}) {
                    (this.touched = !0), this._parent && !n.onlySelf && this._parent.markAsTouched(n);
                }
                markAllAsTouched() {
                    this.markAsTouched({ onlySelf: !0 }), this._forEachChild(n => n.markAllAsTouched());
                }
                markAsUntouched(n = {}) {
                    (this.touched = !1),
                        (this._pendingTouched = !1),
                        this._forEachChild(e => {
                            e.markAsUntouched({ onlySelf: !0 });
                        }),
                        this._parent && !n.onlySelf && this._parent._updateTouched(n);
                }
                markAsDirty(n = {}) {
                    (this.pristine = !1), this._parent && !n.onlySelf && this._parent.markAsDirty(n);
                }
                markAsPristine(n = {}) {
                    (this.pristine = !0),
                        (this._pendingDirty = !1),
                        this._forEachChild(e => {
                            e.markAsPristine({ onlySelf: !0 });
                        }),
                        this._parent && !n.onlySelf && this._parent._updatePristine(n);
                }
                markAsPending(n = {}) {
                    (this.status = Q1),
                        !1 !== n.emitEvent && this.statusChanges.emit(this.status),
                        this._parent && !n.onlySelf && this._parent.markAsPending(n);
                }
                disable(n = {}) {
                    const e = this._parentMarkedDirty(n.onlySelf);
                    (this.status = Zd),
                        (this.errors = null),
                        this._forEachChild(i => {
                            i.disable({ ...n, onlySelf: !0 });
                        }),
                        this._updateValue(),
                        !1 !== n.emitEvent &&
                            (this.valueChanges.emit(this.value), this.statusChanges.emit(this.status)),
                        this._updateAncestors({ ...n, skipPristineCheck: e }),
                        this._onDisabledChange.forEach(i => i(!0));
                }
                enable(n = {}) {
                    const e = this._parentMarkedDirty(n.onlySelf);
                    (this.status = Xd),
                        this._forEachChild(i => {
                            i.enable({ ...n, onlySelf: !0 });
                        }),
                        this.updateValueAndValidity({ onlySelf: !0, emitEvent: n.emitEvent }),
                        this._updateAncestors({ ...n, skipPristineCheck: e }),
                        this._onDisabledChange.forEach(i => i(!1));
                }
                _updateAncestors(n) {
                    this._parent &&
                        !n.onlySelf &&
                        (this._parent.updateValueAndValidity(n),
                        n.skipPristineCheck || this._parent._updatePristine(),
                        this._parent._updateTouched());
                }
                setParent(n) {
                    this._parent = n;
                }
                getRawValue() {
                    return this.value;
                }
                updateValueAndValidity(n = {}) {
                    this._setInitialStatus(),
                        this._updateValue(),
                        this.enabled &&
                            (this._cancelExistingSubscription(),
                            (this.errors = this._runValidator()),
                            (this.status = this._calculateStatus()),
                            (this.status === Xd || this.status === Q1) && this._runAsyncValidator(n.emitEvent)),
                        !1 !== n.emitEvent &&
                            (this.valueChanges.emit(this.value), this.statusChanges.emit(this.status)),
                        this._parent && !n.onlySelf && this._parent.updateValueAndValidity(n);
                }
                _updateTreeValidity(n = { emitEvent: !0 }) {
                    this._forEachChild(e => e._updateTreeValidity(n)),
                        this.updateValueAndValidity({ onlySelf: !0, emitEvent: n.emitEvent });
                }
                _setInitialStatus() {
                    this.status = this._allControlsDisabled() ? Zd : Xd;
                }
                _runValidator() {
                    return this.validator ? this.validator(this) : null;
                }
                _runAsyncValidator(n) {
                    if (this.asyncValidator) {
                        (this.status = Q1), (this._hasOwnPendingAsyncValidator = !0);
                        const e = mM(this.asyncValidator(this));
                        this._asyncValidationSubscription = e.subscribe(i => {
                            (this._hasOwnPendingAsyncValidator = !1), this.setErrors(i, { emitEvent: n });
                        });
                    }
                }
                _cancelExistingSubscription() {
                    this._asyncValidationSubscription &&
                        (this._asyncValidationSubscription.unsubscribe(), (this._hasOwnPendingAsyncValidator = !1));
                }
                setErrors(n, e = {}) {
                    (this.errors = n), this._updateControlsErrors(!1 !== e.emitEvent);
                }
                get(n) {
                    let e = n;
                    return null == e || (Array.isArray(e) || (e = e.split('.')), 0 === e.length)
                        ? null
                        : e.reduce((i, r) => i && i._find(r), this);
                }
                getError(n, e) {
                    const i = e ? this.get(e) : this;
                    return i && i.errors ? i.errors[n] : null;
                }
                hasError(n, e) {
                    return !!this.getError(n, e);
                }
                get root() {
                    let n = this;
                    for (; n._parent; ) n = n._parent;
                    return n;
                }
                _updateControlsErrors(n) {
                    (this.status = this._calculateStatus()),
                        n && this.statusChanges.emit(this.status),
                        this._parent && this._parent._updateControlsErrors(n);
                }
                _initObservables() {
                    (this.valueChanges = new Ft()), (this.statusChanges = new Ft());
                }
                _calculateStatus() {
                    return this._allControlsDisabled()
                        ? Zd
                        : this.errors
                        ? Z4
                        : this._hasOwnPendingAsyncValidator || this._anyControlsHaveStatus(Q1)
                        ? Q1
                        : this._anyControlsHaveStatus(Z4)
                        ? Z4
                        : Xd;
                }
                _anyControlsHaveStatus(n) {
                    return this._anyControls(e => e.status === n);
                }
                _anyControlsDirty() {
                    return this._anyControls(n => n.dirty);
                }
                _anyControlsTouched() {
                    return this._anyControls(n => n.touched);
                }
                _updatePristine(n = {}) {
                    (this.pristine = !this._anyControlsDirty()),
                        this._parent && !n.onlySelf && this._parent._updatePristine(n);
                }
                _updateTouched(n = {}) {
                    (this.touched = this._anyControlsTouched()),
                        this._parent && !n.onlySelf && this._parent._updateTouched(n);
                }
                _registerOnCollectionChange(n) {
                    this._onCollectionChange = n;
                }
                _setUpdateStrategy(n) {
                    J4(n) && null != n.updateOn && (this._updateOn = n.updateOn);
                }
                _parentMarkedDirty(n) {
                    return !n && !(!this._parent || !this._parent.dirty) && !this._parent._anyControlsDirty();
                }
                _find(n) {
                    return null;
                }
                _assignValidators(n) {
                    (this._rawValidators = Array.isArray(n) ? n.slice() : n),
                        (this._composedValidatorFn = (function oq(t) {
                            return Array.isArray(t) ? ep(t) : t || null;
                        })(this._rawValidators));
                }
                _assignAsyncValidators(n) {
                    (this._rawAsyncValidators = Array.isArray(n) ? n.slice() : n),
                        (this._composedAsyncValidatorFn = (function aq(t) {
                            return Array.isArray(t) ? tp(t) : t || null;
                        })(this._rawAsyncValidators));
                }
            }
            class lp extends ap {
                constructor(n, e, i) {
                    super(sp(e), op(i, e)),
                        (this.controls = n),
                        this._initObservables(),
                        this._setUpdateStrategy(e),
                        this._setUpControls(),
                        this.updateValueAndValidity({ onlySelf: !0, emitEvent: !!this.asyncValidator });
                }
                registerControl(n, e) {
                    return this.controls[n]
                        ? this.controls[n]
                        : ((this.controls[n] = e),
                          e.setParent(this),
                          e._registerOnCollectionChange(this._onCollectionChange),
                          e);
                }
                addControl(n, e, i = {}) {
                    this.registerControl(n, e),
                        this.updateValueAndValidity({ emitEvent: i.emitEvent }),
                        this._onCollectionChange();
                }
                removeControl(n, e = {}) {
                    this.controls[n] && this.controls[n]._registerOnCollectionChange(() => {}),
                        delete this.controls[n],
                        this.updateValueAndValidity({ emitEvent: e.emitEvent }),
                        this._onCollectionChange();
                }
                setControl(n, e, i = {}) {
                    this.controls[n] && this.controls[n]._registerOnCollectionChange(() => {}),
                        delete this.controls[n],
                        e && this.registerControl(n, e),
                        this.updateValueAndValidity({ emitEvent: i.emitEvent }),
                        this._onCollectionChange();
                }
                contains(n) {
                    return this.controls.hasOwnProperty(n) && this.controls[n].enabled;
                }
                setValue(n, e = {}) {
                    (function IM(t, n, e) {
                        t._forEachChild((i, r) => {
                            if (void 0 === e[r]) throw new Me(1002, '');
                        });
                    })(this, 0, n),
                        Object.keys(n).forEach(i => {
                            (function EM(t, n, e) {
                                const i = t.controls;
                                if (!(n ? Object.keys(i) : i).length) throw new Me(1e3, '');
                                if (!i[e]) throw new Me(1001, '');
                            })(this, !0, i),
                                this.controls[i].setValue(n[i], { onlySelf: !0, emitEvent: e.emitEvent });
                        }),
                        this.updateValueAndValidity(e);
                }
                patchValue(n, e = {}) {
                    null != n &&
                        (Object.keys(n).forEach(i => {
                            const r = this.controls[i];
                            r && r.patchValue(n[i], { onlySelf: !0, emitEvent: e.emitEvent });
                        }),
                        this.updateValueAndValidity(e));
                }
                reset(n = {}, e = {}) {
                    this._forEachChild((i, r) => {
                        i.reset(n ? n[r] : null, { onlySelf: !0, emitEvent: e.emitEvent });
                    }),
                        this._updatePristine(e),
                        this._updateTouched(e),
                        this.updateValueAndValidity(e);
                }
                getRawValue() {
                    return this._reduceChildren({}, (n, e, i) => ((n[i] = e.getRawValue()), n));
                }
                _syncPendingControls() {
                    let n = this._reduceChildren(!1, (e, i) => !!i._syncPendingControls() || e);
                    return n && this.updateValueAndValidity({ onlySelf: !0 }), n;
                }
                _forEachChild(n) {
                    Object.keys(this.controls).forEach(e => {
                        const i = this.controls[e];
                        i && n(i, e);
                    });
                }
                _setUpControls() {
                    this._forEachChild(n => {
                        n.setParent(this), n._registerOnCollectionChange(this._onCollectionChange);
                    });
                }
                _updateValue() {
                    this.value = this._reduceValue();
                }
                _anyControls(n) {
                    for (const [e, i] of Object.entries(this.controls)) if (this.contains(e) && n(i)) return !0;
                    return !1;
                }
                _reduceValue() {
                    return this._reduceChildren({}, (e, i, r) => ((i.enabled || this.disabled) && (e[r] = i.value), e));
                }
                _reduceChildren(n, e) {
                    let i = n;
                    return (
                        this._forEachChild((r, s) => {
                            i = e(i, r, s);
                        }),
                        i
                    );
                }
                _allControlsDisabled() {
                    for (const n of Object.keys(this.controls)) if (this.controls[n].enabled) return !1;
                    return Object.keys(this.controls).length > 0 || this.disabled;
                }
                _find(n) {
                    return this.controls.hasOwnProperty(n) ? this.controls[n] : null;
                }
            }
            const wu = new $e('CallSetDisabledState', { providedIn: 'root', factory: () => Jd }),
                Jd = 'always';
            function eh(t, n, e = Jd) {
                cp(t, n),
                    n.valueAccessor.writeValue(t.value),
                    (t.disabled || 'always' === e) && n.valueAccessor.setDisabledState?.(t.disabled),
                    (function uq(t, n) {
                        n.valueAccessor.registerOnChange(e => {
                            (t._pendingValue = e),
                                (t._pendingChange = !0),
                                (t._pendingDirty = !0),
                                'change' === t.updateOn && AM(t, n);
                        });
                    })(t, n),
                    (function hq(t, n) {
                        const e = (i, r) => {
                            n.valueAccessor.writeValue(i), r && n.viewToModelUpdate(i);
                        };
                        t.registerOnChange(e),
                            n._registerOnDestroy(() => {
                                t._unregisterOnChange(e);
                            });
                    })(t, n),
                    (function dq(t, n) {
                        n.valueAccessor.registerOnTouched(() => {
                            (t._pendingTouched = !0),
                                'blur' === t.updateOn && t._pendingChange && AM(t, n),
                                'submit' !== t.updateOn && t.markAsTouched();
                        });
                    })(t, n),
                    (function cq(t, n) {
                        if (n.valueAccessor.setDisabledState) {
                            const e = i => {
                                n.valueAccessor.setDisabledState(i);
                            };
                            t.registerOnDisabledChange(e),
                                n._registerOnDestroy(() => {
                                    t._unregisterOnDisabledChange(e);
                                });
                        }
                    })(t, n);
            }
            function nf(t, n) {
                t.forEach(e => {
                    e.registerOnValidatorChange && e.registerOnValidatorChange(n);
                });
            }
            function cp(t, n) {
                const e = (function CM(t) {
                    return t._rawValidators;
                })(t);
                null !== n.validator
                    ? t.setValidators(bM(e, n.validator))
                    : 'function' == typeof e && t.setValidators([e]);
                const i = (function wM(t) {
                    return t._rawAsyncValidators;
                })(t);
                null !== n.asyncValidator
                    ? t.setAsyncValidators(bM(i, n.asyncValidator))
                    : 'function' == typeof i && t.setAsyncValidators([i]);
                const r = () => t.updateValueAndValidity();
                nf(n._rawValidators, r), nf(n._rawAsyncValidators, r);
            }
            function AM(t, n) {
                t._pendingDirty && t.markAsDirty(),
                    t.setValue(t._pendingValue, { emitModelToViewChange: !1 }),
                    n.viewToModelUpdate(t._pendingValue),
                    (t._pendingChange = !1);
            }
            const vq = { provide: Js, useExisting: Wt(() => sf) },
                th = Promise.resolve();
            let sf = (() => {
                class t extends Js {
                    constructor(e, i, r) {
                        super(),
                            (this.callSetDisabledState = r),
                            (this.submitted = !1),
                            (this._directives = new Set()),
                            (this.ngSubmit = new Ft()),
                            (this.form = new lp({}, ep(e), tp(i)));
                    }
                    ngAfterViewInit() {
                        this._setUpdateStrategy();
                    }
                    get formDirective() {
                        return this;
                    }
                    get control() {
                        return this.form;
                    }
                    get path() {
                        return [];
                    }
                    get controls() {
                        return this.form.controls;
                    }
                    addControl(e) {
                        th.then(() => {
                            const i = this._findContainer(e.path);
                            (e.control = i.registerControl(e.name, e.control)),
                                eh(e.control, e, this.callSetDisabledState),
                                e.control.updateValueAndValidity({ emitEvent: !1 }),
                                this._directives.add(e);
                        });
                    }
                    getControl(e) {
                        return this.form.get(e.path);
                    }
                    removeControl(e) {
                        th.then(() => {
                            const i = this._findContainer(e.path);
                            i && i.removeControl(e.name), this._directives.delete(e);
                        });
                    }
                    addFormGroup(e) {
                        th.then(() => {
                            const i = this._findContainer(e.path),
                                r = new lp({});
                            (function LM(t, n) {
                                cp(t, n);
                            })(r, e),
                                i.registerControl(e.name, r),
                                r.updateValueAndValidity({ emitEvent: !1 });
                        });
                    }
                    removeFormGroup(e) {
                        th.then(() => {
                            const i = this._findContainer(e.path);
                            i && i.removeControl(e.name);
                        });
                    }
                    getFormGroup(e) {
                        return this.form.get(e.path);
                    }
                    updateModel(e, i) {
                        th.then(() => {
                            this.form.get(e.path).setValue(i);
                        });
                    }
                    setValue(e) {
                        this.control.setValue(e);
                    }
                    onSubmit(e) {
                        return (
                            (this.submitted = !0),
                            (function OM(t, n) {
                                t._syncPendingControls(),
                                    n.forEach(e => {
                                        const i = e.control;
                                        'submit' === i.updateOn &&
                                            i._pendingChange &&
                                            (e.viewToModelUpdate(i._pendingValue), (i._pendingChange = !1));
                                    });
                            })(this.form, this._directives),
                            this.ngSubmit.emit(e),
                            'dialog' === e?.target?.method
                        );
                    }
                    onReset() {
                        this.resetForm();
                    }
                    resetForm(e = void 0) {
                        this.form.reset(e), (this.submitted = !1);
                    }
                    _setUpdateStrategy() {
                        this.options && null != this.options.updateOn && (this.form._updateOn = this.options.updateOn);
                    }
                    _findContainer(e) {
                        return e.pop(), e.length ? this.form.get(e) : this.form;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Ns, 10), te(Cc, 10), te(wu, 8));
                    });
                    static #t = (this.ɵdir = gt({
                        type: t,
                        selectors: [['form', 3, 'ngNoForm', '', 3, 'formGroup', ''], ['ng-form'], ['', 'ngForm', '']],
                        hostBindings: function (i, r) {
                            1 & i &&
                                Le('submit', function (o) {
                                    return r.onSubmit(o);
                                })('reset', function () {
                                    return r.onReset();
                                });
                        },
                        inputs: { options: [de.None, 'ngFormOptions', 'options'] },
                        outputs: { ngSubmit: 'ngSubmit' },
                        exportAs: ['ngForm'],
                        features: [$n([vq]), Cn],
                    }));
                }
                return t;
            })();
            function zM(t, n) {
                const e = t.indexOf(n);
                e > -1 && t.splice(e, 1);
            }
            function PM(t) {
                return (
                    'object' == typeof t && null !== t && 2 === Object.keys(t).length && 'value' in t && 'disabled' in t
                );
            }
            const NM = class extends ap {
                    constructor(n = null, e, i) {
                        super(sp(e), op(i, e)),
                            (this.defaultValue = null),
                            (this._onChange = []),
                            (this._pendingChange = !1),
                            this._applyFormState(n),
                            this._setUpdateStrategy(e),
                            this._initObservables(),
                            this.updateValueAndValidity({ onlySelf: !0, emitEvent: !!this.asyncValidator }),
                            J4(e) &&
                                (e.nonNullable || e.initialValueIsDefault) &&
                                (this.defaultValue = PM(n) ? n.value : n);
                    }
                    setValue(n, e = {}) {
                        (this.value = this._pendingValue = n),
                            this._onChange.length &&
                                !1 !== e.emitModelToViewChange &&
                                this._onChange.forEach(i => i(this.value, !1 !== e.emitViewToModelChange)),
                            this.updateValueAndValidity(e);
                    }
                    patchValue(n, e = {}) {
                        this.setValue(n, e);
                    }
                    reset(n = this.defaultValue, e = {}) {
                        this._applyFormState(n),
                            this.markAsPristine(e),
                            this.markAsUntouched(e),
                            this.setValue(this.value, e),
                            (this._pendingChange = !1);
                    }
                    _updateValue() {}
                    _anyControls(n) {
                        return !1;
                    }
                    _allControlsDisabled() {
                        return this.disabled;
                    }
                    registerOnChange(n) {
                        this._onChange.push(n);
                    }
                    _unregisterOnChange(n) {
                        zM(this._onChange, n);
                    }
                    registerOnDisabledChange(n) {
                        this._onDisabledChange.push(n);
                    }
                    _unregisterOnDisabledChange(n) {
                        zM(this._onDisabledChange, n);
                    }
                    _forEachChild(n) {}
                    _syncPendingControls() {
                        return !(
                            'submit' !== this.updateOn ||
                            (this._pendingDirty && this.markAsDirty(),
                            this._pendingTouched && this.markAsTouched(),
                            !this._pendingChange) ||
                            (this.setValue(this._pendingValue, { onlySelf: !0, emitModelToViewChange: !1 }), 0)
                        );
                    }
                    _applyFormState(n) {
                        PM(n)
                            ? ((this.value = this._pendingValue = n.value),
                              n.disabled
                                  ? this.disable({ onlySelf: !0, emitEvent: !1 })
                                  : this.enable({ onlySelf: !0, emitEvent: !1 }))
                            : (this.value = this._pendingValue = n);
                    }
                },
                bq = { provide: wc, useExisting: Wt(() => Fs) },
                VM = Promise.resolve();
            let Fs = (() => {
                    class t extends wc {
                        constructor(e, i, r, s, o, a) {
                            super(),
                                (this._changeDetectorRef = o),
                                (this.callSetDisabledState = a),
                                (this.control = new NM()),
                                (this._registered = !1),
                                (this.name = ''),
                                (this.update = new Ft()),
                                (this._parent = e),
                                this._setValidators(i),
                                this._setAsyncValidators(r),
                                (this.valueAccessor = (function hp(t, n) {
                                    if (!n) return null;
                                    let e, i, r;
                                    return (
                                        Array.isArray(n),
                                        n.forEach(s => {
                                            s.constructor === xa
                                                ? (e = s)
                                                : (function pq(t) {
                                                      return Object.getPrototypeOf(t.constructor) === Cu;
                                                  })(s)
                                                ? (i = s)
                                                : (r = s);
                                        }),
                                        r || i || e || null
                                    );
                                })(0, s));
                        }
                        ngOnChanges(e) {
                            if ((this._checkForErrors(), !this._registered || 'name' in e)) {
                                if (this._registered && (this._checkName(), this.formDirective)) {
                                    const i = e.name.previousValue;
                                    this.formDirective.removeControl({ name: i, path: this._getPath(i) });
                                }
                                this._setUpControl();
                            }
                            'isDisabled' in e && this._updateDisabled(e),
                                (function dp(t, n) {
                                    if (!t.hasOwnProperty('model')) return !1;
                                    const e = t.model;
                                    return !!e.isFirstChange() || !Object.is(n, e.currentValue);
                                })(e, this.viewModel) && (this._updateValue(this.model), (this.viewModel = this.model));
                        }
                        ngOnDestroy() {
                            this.formDirective && this.formDirective.removeControl(this);
                        }
                        get path() {
                            return this._getPath(this.name);
                        }
                        get formDirective() {
                            return this._parent ? this._parent.formDirective : null;
                        }
                        viewToModelUpdate(e) {
                            (this.viewModel = e), this.update.emit(e);
                        }
                        _setUpControl() {
                            this._setUpdateStrategy(),
                                this._isStandalone() ? this._setUpStandalone() : this.formDirective.addControl(this),
                                (this._registered = !0);
                        }
                        _setUpdateStrategy() {
                            this.options &&
                                null != this.options.updateOn &&
                                (this.control._updateOn = this.options.updateOn);
                        }
                        _isStandalone() {
                            return !this._parent || !(!this.options || !this.options.standalone);
                        }
                        _setUpStandalone() {
                            eh(this.control, this, this.callSetDisabledState),
                                this.control.updateValueAndValidity({ emitEvent: !1 });
                        }
                        _checkForErrors() {
                            this._isStandalone() || this._checkParentType(), this._checkName();
                        }
                        _checkParentType() {}
                        _checkName() {
                            this.options && this.options.name && (this.name = this.options.name), this._isStandalone();
                        }
                        _updateValue(e) {
                            VM.then(() => {
                                this.control.setValue(e, { emitViewToModelChange: !1 }),
                                    this._changeDetectorRef?.markForCheck();
                            });
                        }
                        _updateDisabled(e) {
                            const i = e.isDisabled.currentValue,
                                r = 0 !== i && Ma(i);
                            VM.then(() => {
                                r && !this.control.disabled
                                    ? this.control.disable()
                                    : !r && this.control.disabled && this.control.enable(),
                                    this._changeDetectorRef?.markForCheck();
                            });
                        }
                        _getPath(e) {
                            return this._parent
                                ? (function ef(t, n) {
                                      return [...n.path, t];
                                  })(e, this._parent)
                                : [e];
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Js, 9), te(Ns, 10), te(Cc, 10), te(hs, 10), te(kr, 8), te(wu, 8));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'ngModel', '', 3, 'formControlName', '', 3, 'formControl', '']],
                            inputs: {
                                name: 'name',
                                isDisabled: [de.None, 'disabled', 'isDisabled'],
                                model: [de.None, 'ngModel', 'model'],
                                options: [de.None, 'ngModelOptions', 'options'],
                            },
                            outputs: { update: 'ngModelChange' },
                            exportAs: ['ngModel'],
                            features: [$n([bq]), Cn, D],
                        }));
                    }
                    return t;
                })(),
                HM = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['form', 3, 'ngNoForm', '', 3, 'ngNativeValidate', '']],
                            hostAttrs: ['novalidate', ''],
                        }));
                    }
                    return t;
                })();
            const wq = { provide: hs, useExisting: Wt(() => fp), multi: !0 };
            let Mq = (() => {
                    class t {
                        constructor() {
                            this._accessors = [];
                        }
                        add(e, i) {
                            this._accessors.push([e, i]);
                        }
                        remove(e) {
                            for (let i = this._accessors.length - 1; i >= 0; --i)
                                if (this._accessors[i][1] === e) return void this._accessors.splice(i, 1);
                        }
                        select(e) {
                            this._accessors.forEach(i => {
                                this._isSameGroup(i, e) && i[1] !== e && i[1].fireUncheck(e.value);
                            });
                        }
                        _isSameGroup(e, i) {
                            return !!e[0].control && e[0]._parent === i._control._parent && e[1].name === i.name;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                fp = (() => {
                    class t extends Cu {
                        constructor(e, i, r, s) {
                            super(e, i),
                                (this._registry = r),
                                (this._injector = s),
                                (this.setDisabledStateFired = !1),
                                (this.onChange = () => {}),
                                (this.callSetDisabledState = Ue(wu, { optional: !0 }) ?? Jd);
                        }
                        ngOnInit() {
                            (this._control = this._injector.get(wc)),
                                this._checkName(),
                                this._registry.add(this._control, this);
                        }
                        ngOnDestroy() {
                            this._registry.remove(this);
                        }
                        writeValue(e) {
                            (this._state = e === this.value), this.setProperty('checked', this._state);
                        }
                        registerOnChange(e) {
                            (this._fn = e),
                                (this.onChange = () => {
                                    e(this.value), this._registry.select(this);
                                });
                        }
                        setDisabledState(e) {
                            (this.setDisabledStateFired ||
                                e ||
                                'whenDisabledForLegacyCode' === this.callSetDisabledState) &&
                                this.setProperty('disabled', e),
                                (this.setDisabledStateFired = !0);
                        }
                        fireUncheck(e) {
                            this.writeValue(e);
                        }
                        _checkName() {
                            !this.name && this.formControlName && (this.name = this.formControlName);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Ps), te(Pn), te(Mq), te(ys));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [
                                ['input', 'type', 'radio', 'formControlName', ''],
                                ['input', 'type', 'radio', 'formControl', ''],
                                ['input', 'type', 'radio', 'ngModel', ''],
                            ],
                            hostBindings: function (i, r) {
                                1 & i &&
                                    Le('change', function () {
                                        return r.onChange();
                                    })('blur', function () {
                                        return r.onTouched();
                                    });
                            },
                            inputs: { name: 'name', formControlName: 'formControlName', value: 'value' },
                            features: [$n([wq]), Cn],
                        }));
                    }
                    return t;
                })();
            const mp = new $e('');
            let iS = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })(),
                nh = (() => {
                    class t {
                        static withConfig(e) {
                            return {
                                ngModule: t,
                                providers: [{ provide: wu, useValue: e.callSetDisabledState ?? Jd }],
                            };
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [iS] }));
                    }
                    return t;
                })(),
                jq = (() => {
                    class t {
                        static withConfig(e) {
                            return {
                                ngModule: t,
                                providers: [
                                    { provide: mp, useValue: e.warnOnNgModelWithFormControl ?? 'always' },
                                    { provide: wu, useValue: e.callSetDisabledState ?? Jd },
                                ],
                            };
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [iS] }));
                    }
                    return t;
                })();
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */
            var tn = (function (t) {
                return (
                    (t[(t.State = 0)] = 'State'),
                    (t[(t.Transition = 1)] = 'Transition'),
                    (t[(t.Sequence = 2)] = 'Sequence'),
                    (t[(t.Group = 3)] = 'Group'),
                    (t[(t.Animate = 4)] = 'Animate'),
                    (t[(t.Keyframes = 5)] = 'Keyframes'),
                    (t[(t.Style = 6)] = 'Style'),
                    (t[(t.Trigger = 7)] = 'Trigger'),
                    (t[(t.Reference = 8)] = 'Reference'),
                    (t[(t.AnimateChild = 9)] = 'AnimateChild'),
                    (t[(t.AnimateRef = 10)] = 'AnimateRef'),
                    (t[(t.Query = 11)] = 'Query'),
                    (t[(t.Stagger = 12)] = 'Stagger'),
                    t
                );
            })(tn || {});
            const Ol = '*';
            function Bo(t, n) {
                return { type: tn.Trigger, name: t, definitions: n, options: {} };
            }
            function Ci(t, n = null) {
                return { type: tn.Animate, styles: n, timings: t };
            }
            function zt(t) {
                return { type: tn.Style, styles: t, offset: null };
            }
            function qo(t, n, e) {
                return { type: tn.State, name: t, styles: n, options: e };
            }
            function Ii(t, n, e = null) {
                return { type: tn.Transition, expr: t, animation: n, options: e };
            }
            function rS(t, n, e = null) {
                return { type: tn.Query, selector: t, animation: n, options: e };
            }
            function sS(t, n) {
                return { type: tn.Stagger, timings: t, animation: n };
            }
            class ih {
                constructor(n = 0, e = 0) {
                    (this._onDoneFns = []),
                        (this._onStartFns = []),
                        (this._onDestroyFns = []),
                        (this._originalOnDoneFns = []),
                        (this._originalOnStartFns = []),
                        (this._started = !1),
                        (this._destroyed = !1),
                        (this._finished = !1),
                        (this._position = 0),
                        (this.parentPlayer = null),
                        (this.totalTime = n + e);
                }
                _onFinish() {
                    this._finished ||
                        ((this._finished = !0), this._onDoneFns.forEach(n => n()), (this._onDoneFns = []));
                }
                onStart(n) {
                    this._originalOnStartFns.push(n), this._onStartFns.push(n);
                }
                onDone(n) {
                    this._originalOnDoneFns.push(n), this._onDoneFns.push(n);
                }
                onDestroy(n) {
                    this._onDestroyFns.push(n);
                }
                hasStarted() {
                    return this._started;
                }
                init() {}
                play() {
                    this.hasStarted() || (this._onStart(), this.triggerMicrotask()), (this._started = !0);
                }
                triggerMicrotask() {
                    queueMicrotask(() => this._onFinish());
                }
                _onStart() {
                    this._onStartFns.forEach(n => n()), (this._onStartFns = []);
                }
                pause() {}
                restart() {}
                finish() {
                    this._onFinish();
                }
                destroy() {
                    this._destroyed ||
                        ((this._destroyed = !0),
                        this.hasStarted() || this._onStart(),
                        this.finish(),
                        this._onDestroyFns.forEach(n => n()),
                        (this._onDestroyFns = []));
                }
                reset() {
                    (this._started = !1),
                        (this._finished = !1),
                        (this._onStartFns = this._originalOnStartFns),
                        (this._onDoneFns = this._originalOnDoneFns);
                }
                setPosition(n) {
                    this._position = this.totalTime ? n * this.totalTime : 1;
                }
                getPosition() {
                    return this.totalTime ? this._position / this.totalTime : 1;
                }
                triggerCallback(n) {
                    const e = 'start' == n ? this._onStartFns : this._onDoneFns;
                    e.forEach(i => i()), (e.length = 0);
                }
            }
            class oS {
                constructor(n) {
                    (this._onDoneFns = []),
                        (this._onStartFns = []),
                        (this._finished = !1),
                        (this._started = !1),
                        (this._destroyed = !1),
                        (this._onDestroyFns = []),
                        (this.parentPlayer = null),
                        (this.totalTime = 0),
                        (this.players = n);
                    let e = 0,
                        i = 0,
                        r = 0;
                    const s = this.players.length;
                    0 == s
                        ? queueMicrotask(() => this._onFinish())
                        : this.players.forEach(o => {
                              o.onDone(() => {
                                  ++e == s && this._onFinish();
                              }),
                                  o.onDestroy(() => {
                                      ++i == s && this._onDestroy();
                                  }),
                                  o.onStart(() => {
                                      ++r == s && this._onStart();
                                  });
                          }),
                        (this.totalTime = this.players.reduce((o, a) => Math.max(o, a.totalTime), 0));
                }
                _onFinish() {
                    this._finished ||
                        ((this._finished = !0), this._onDoneFns.forEach(n => n()), (this._onDoneFns = []));
                }
                init() {
                    this.players.forEach(n => n.init());
                }
                onStart(n) {
                    this._onStartFns.push(n);
                }
                _onStart() {
                    this.hasStarted() ||
                        ((this._started = !0), this._onStartFns.forEach(n => n()), (this._onStartFns = []));
                }
                onDone(n) {
                    this._onDoneFns.push(n);
                }
                onDestroy(n) {
                    this._onDestroyFns.push(n);
                }
                hasStarted() {
                    return this._started;
                }
                play() {
                    this.parentPlayer || this.init(), this._onStart(), this.players.forEach(n => n.play());
                }
                pause() {
                    this.players.forEach(n => n.pause());
                }
                restart() {
                    this.players.forEach(n => n.restart());
                }
                finish() {
                    this._onFinish(), this.players.forEach(n => n.finish());
                }
                destroy() {
                    this._onDestroy();
                }
                _onDestroy() {
                    this._destroyed ||
                        ((this._destroyed = !0),
                        this._onFinish(),
                        this.players.forEach(n => n.destroy()),
                        this._onDestroyFns.forEach(n => n()),
                        (this._onDestroyFns = []));
                }
                reset() {
                    this.players.forEach(n => n.reset()),
                        (this._destroyed = !1),
                        (this._finished = !1),
                        (this._started = !1);
                }
                setPosition(n) {
                    const e = n * this.totalTime;
                    this.players.forEach(i => {
                        const r = i.totalTime ? Math.min(1, e / i.totalTime) : 1;
                        i.setPosition(r);
                    });
                }
                getPosition() {
                    const n = this.players.reduce((e, i) => (null === e || i.totalTime > e.totalTime ? i : e), null);
                    return null != n ? n.getPosition() : 0;
                }
                beforeDestroy() {
                    this.players.forEach(n => {
                        n.beforeDestroy && n.beforeDestroy();
                    });
                }
                triggerCallback(n) {
                    const e = 'start' == n ? this._onStartFns : this._onDoneFns;
                    e.forEach(i => i()), (e.length = 0);
                }
            }
            function aS(t) {
                return new Me(3e3, !1);
            }
            function Mc(t) {
                switch (t.length) {
                    case 0:
                        return new ih();
                    case 1:
                        return t[0];
                    default:
                        return new oS(t);
                }
            }
            function lS(t, n, e = new Map(), i = new Map()) {
                const r = [],
                    s = [];
                let o = -1,
                    a = null;
                if (
                    (n.forEach(l => {
                        const c = l.get('offset'),
                            f = c == o,
                            g = (f && a) || new Map();
                        l.forEach((E, P) => {
                            let V = P,
                                W = E;
                            if ('offset' !== P)
                                switch (((V = t.normalizePropertyName(V, r)), W)) {
                                    case '!':
                                        W = e.get(P);
                                        break;
                                    case Ol:
                                        W = i.get(P);
                                        break;
                                    default:
                                        W = t.normalizeStyleValue(P, V, W, r);
                                }
                            g.set(V, W);
                        }),
                            f || s.push(g),
                            (a = g),
                            (o = c);
                    }),
                    r.length)
                )
                    throw (function yY(t) {
                        return new Me(3502, !1);
                    })();
                return s;
            }
            function wp(t, n, e, i) {
                switch (n) {
                    case 'start':
                        t.onStart(() => i(e && Mp(e, 'start', t)));
                        break;
                    case 'done':
                        t.onDone(() => i(e && Mp(e, 'done', t)));
                        break;
                    case 'destroy':
                        t.onDestroy(() => i(e && Mp(e, 'destroy', t)));
                }
            }
            function Mp(t, n, e) {
                const s = Sp(
                        t.element,
                        t.triggerName,
                        t.fromState,
                        t.toState,
                        n || t.phaseName,
                        e.totalTime ?? t.totalTime,
                        !!e.disabled,
                    ),
                    o = t._data;
                return null != o && (s._data = o), s;
            }
            function Sp(t, n, e, i, r = '', s = 0, o) {
                return {
                    element: t,
                    triggerName: n,
                    fromState: e,
                    toState: i,
                    phaseName: r,
                    totalTime: s,
                    disabled: !!o,
                };
            }
            function Yo(t, n, e) {
                let i = t.get(n);
                return i || t.set(n, (i = e)), i;
            }
            function cS(t) {
                const n = t.indexOf(':');
                return [t.substring(1, n), t.slice(n + 1)];
            }
            const AY = typeof document > 'u' ? null : document.documentElement;
            function Tp(t) {
                const n = t.parentNode || t.host || null;
                return n === AY ? null : n;
            }
            let Su = null,
                uS = !1;
            function dS(t, n) {
                for (; n; ) {
                    if (n === t) return !0;
                    n = Tp(n);
                }
                return !1;
            }
            function hS(t, n, e) {
                if (e) return Array.from(t.querySelectorAll(n));
                const i = t.querySelector(n);
                return i ? [i] : [];
            }
            let Dp = (() => {
                class t {
                    validateStyleProperty(e) {
                        return (function OY(t) {
                            Su ||
                                ((Su =
                                    (function zY() {
                                        return typeof document < 'u' ? document.body : null;
                                    })() || {}),
                                (uS = !!Su.style && 'WebkitAppearance' in Su.style));
                            let n = !0;
                            return (
                                Su.style &&
                                    !(function LY(t) {
                                        return 'ebkit' == t.substring(1, 6);
                                    })(t) &&
                                    ((n = t in Su.style),
                                    !n && uS && (n = 'Webkit' + t.charAt(0).toUpperCase() + t.slice(1) in Su.style)),
                                n
                            );
                        })(e);
                    }
                    matchesElement(e, i) {
                        return !1;
                    }
                    containsElement(e, i) {
                        return dS(e, i);
                    }
                    getParentElement(e) {
                        return Tp(e);
                    }
                    query(e, i, r) {
                        return hS(e, i, r);
                    }
                    computeStyle(e, i, r) {
                        return r || '';
                    }
                    animate(e, i, r, s, o, a = [], l) {
                        return new ih(r, s);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                }
                return t;
            })();
            class xp {
                static #e = (this.NOOP = new Dp());
            }
            class kp {}
            const NY = 1e3,
                Ep = 'ng-enter',
                af = 'ng-leave',
                lf = 'ng-trigger',
                cf = '.ng-trigger',
                mS = 'ng-animating',
                Ip = '.ng-animating';
            function zl(t) {
                if ('number' == typeof t) return t;
                const n = t.match(/^(-?[\.\d]+)(m?s)/);
                return !n || n.length < 2 ? 0 : Ap(parseFloat(n[1]), n[2]);
            }
            function Ap(t, n) {
                return 's' === n ? t * NY : t;
            }
            function uf(t, n, e) {
                return t.hasOwnProperty('duration')
                    ? t
                    : (function RY(t, n, e) {
                          let r,
                              s = 0,
                              o = '';
                          if ('string' == typeof t) {
                              const a = t.match(
                                  /^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i,
                              );
                              if (null === a) return n.push(aS()), { duration: 0, delay: 0, easing: '' };
                              r = Ap(parseFloat(a[1]), a[2]);
                              const l = a[3];
                              null != l && (s = Ap(parseFloat(l), a[4]));
                              const c = a[5];
                              c && (o = c);
                          } else r = t;
                          if (!e) {
                              let a = !1,
                                  l = n.length;
                              r < 0 &&
                                  (n.push(
                                      (function Xq() {
                                          return new Me(3100, !1);
                                      })(),
                                  ),
                                  (a = !0)),
                                  s < 0 &&
                                      (n.push(
                                          (function Zq() {
                                              return new Me(3101, !1);
                                          })(),
                                      ),
                                      (a = !0)),
                                  a && n.splice(l, 0, aS());
                          }
                          return { duration: r, delay: s, easing: o };
                      })(t, n, e);
            }
            function ll(t, n, e) {
                n.forEach((i, r) => {
                    const s = Op(r);
                    e && !e.has(r) && e.set(r, t.style[s]), (t.style[s] = i);
                });
            }
            function Tu(t, n) {
                n.forEach((e, i) => {
                    const r = Op(i);
                    t.style[r] = '';
                });
            }
            function rh(t) {
                return Array.isArray(t)
                    ? 1 == t.length
                        ? t[0]
                        : (function $q(t, n = null) {
                              return { type: tn.Sequence, steps: t, options: n };
                          })(t)
                    : t;
            }
            const Lp = new RegExp('{{\\s*(.+?)\\s*}}', 'g');
            function gS(t) {
                let n = [];
                if ('string' == typeof t) {
                    let e;
                    for (; (e = Lp.exec(t)); ) n.push(e[1]);
                    Lp.lastIndex = 0;
                }
                return n;
            }
            function sh(t, n, e) {
                const i = `${t}`,
                    r = i.replace(Lp, (s, o) => {
                        let a = n[o];
                        return (
                            null == a &&
                                (e.push(
                                    (function eY(t) {
                                        return new Me(3003, !1);
                                    })(),
                                ),
                                (a = '')),
                            a.toString()
                        );
                    });
                return r == i ? t : r;
            }
            const UY = /-+([a-z0-9])/g;
            function Op(t) {
                return t.replace(UY, (...n) => n[1].toUpperCase());
            }
            function jo(t, n, e) {
                switch (n.type) {
                    case tn.Trigger:
                        return t.visitTrigger(n, e);
                    case tn.State:
                        return t.visitState(n, e);
                    case tn.Transition:
                        return t.visitTransition(n, e);
                    case tn.Sequence:
                        return t.visitSequence(n, e);
                    case tn.Group:
                        return t.visitGroup(n, e);
                    case tn.Animate:
                        return t.visitAnimate(n, e);
                    case tn.Keyframes:
                        return t.visitKeyframes(n, e);
                    case tn.Style:
                        return t.visitStyle(n, e);
                    case tn.Reference:
                        return t.visitReference(n, e);
                    case tn.AnimateChild:
                        return t.visitAnimateChild(n, e);
                    case tn.AnimateRef:
                        return t.visitAnimateRef(n, e);
                    case tn.Query:
                        return t.visitQuery(n, e);
                    case tn.Stagger:
                        return t.visitStagger(n, e);
                    default:
                        throw (function tY(t) {
                            return new Me(3004, !1);
                        })();
                }
            }
            function zp(t, n) {
                return window.getComputedStyle(t)[n];
            }
            const YY = new Set([
                'width',
                'height',
                'minWidth',
                'minHeight',
                'maxWidth',
                'maxHeight',
                'left',
                'top',
                'bottom',
                'right',
                'fontSize',
                'outlineWidth',
                'outlineOffset',
                'paddingTop',
                'paddingLeft',
                'paddingBottom',
                'paddingRight',
                'marginTop',
                'marginLeft',
                'marginBottom',
                'marginRight',
                'borderRadius',
                'borderWidth',
                'borderTopWidth',
                'borderLeftWidth',
                'borderRightWidth',
                'borderBottomWidth',
                'textIndent',
                'perspective',
            ]);
            class vS extends kp {
                normalizePropertyName(n, e) {
                    return Op(n);
                }
                normalizeStyleValue(n, e, i, r) {
                    let s = '';
                    const o = i.toString().trim();
                    if (YY.has(e) && 0 !== i && '0' !== i)
                        if ('number' == typeof i) s = 'px';
                        else {
                            const a = i.match(/^[+-]?[\d\.]+([a-z]*)$/);
                            a &&
                                0 == a[1].length &&
                                r.push(
                                    (function nY(t, n) {
                                        return new Me(3005, !1);
                                    })(),
                                );
                        }
                    return o + s;
                }
            }
            const df = '*';
            const hf = new Set(['true', '1']),
                ff = new Set(['false', '0']);
            function _S(t, n) {
                const e = hf.has(t) || ff.has(t),
                    i = hf.has(n) || ff.has(n);
                return (r, s) => {
                    let o = t == df || t == r,
                        a = n == df || n == s;
                    return (
                        !o && e && 'boolean' == typeof r && (o = r ? hf.has(t) : ff.has(t)),
                        !a && i && 'boolean' == typeof s && (a = s ? hf.has(n) : ff.has(n)),
                        o && a
                    );
                };
            }
            const WY = new RegExp('s*:selfs*,?', 'g');
            function Pp(t, n, e, i) {
                return new KY(t).build(n, e, i);
            }
            class KY {
                constructor(n) {
                    this._driver = n;
                }
                build(n, e, i) {
                    const r = new ZY(e);
                    return this._resetContextStyleTimingState(r), jo(this, rh(n), r);
                }
                _resetContextStyleTimingState(n) {
                    (n.currentQuerySelector = ''),
                        (n.collectedStyles = new Map()),
                        n.collectedStyles.set('', new Map()),
                        (n.currentTime = 0);
                }
                visitTrigger(n, e) {
                    let i = (e.queryCount = 0),
                        r = (e.depCount = 0);
                    const s = [],
                        o = [];
                    return (
                        '@' == n.name.charAt(0) &&
                            e.errors.push(
                                (function iY() {
                                    return new Me(3006, !1);
                                })(),
                            ),
                        n.definitions.forEach(a => {
                            if ((this._resetContextStyleTimingState(e), a.type == tn.State)) {
                                const l = a,
                                    c = l.name;
                                c
                                    .toString()
                                    .split(/\s*,\s*/)
                                    .forEach(f => {
                                        (l.name = f), s.push(this.visitState(l, e));
                                    }),
                                    (l.name = c);
                            } else if (a.type == tn.Transition) {
                                const l = this.visitTransition(a, e);
                                (i += l.queryCount), (r += l.depCount), o.push(l);
                            } else
                                e.errors.push(
                                    (function rY() {
                                        return new Me(3007, !1);
                                    })(),
                                );
                        }),
                        {
                            type: tn.Trigger,
                            name: n.name,
                            states: s,
                            transitions: o,
                            queryCount: i,
                            depCount: r,
                            options: null,
                        }
                    );
                }
                visitState(n, e) {
                    const i = this.visitStyle(n.styles, e),
                        r = (n.options && n.options.params) || null;
                    if (i.containsDynamicStyles) {
                        const s = new Set(),
                            o = r || {};
                        i.styles.forEach(a => {
                            a instanceof Map &&
                                a.forEach(l => {
                                    gS(l).forEach(c => {
                                        o.hasOwnProperty(c) || s.add(c);
                                    });
                                });
                        }),
                            s.size &&
                                e.errors.push(
                                    (function sY(t, n) {
                                        return new Me(3008, !1);
                                    })(0, s.values()),
                                );
                    }
                    return { type: tn.State, name: n.name, style: i, options: r ? { params: r } : null };
                }
                visitTransition(n, e) {
                    (e.queryCount = 0), (e.depCount = 0);
                    const i = jo(this, rh(n.animation), e),
                        r = (function jY(t, n) {
                            const e = [];
                            return (
                                'string' == typeof t
                                    ? t.split(/\s*,\s*/).forEach(i =>
                                          (function $Y(t, n, e) {
                                              if (':' == t[0]) {
                                                  const l = (function GY(t, n) {
                                                      switch (t) {
                                                          case ':enter':
                                                              return 'void => *';
                                                          case ':leave':
                                                              return '* => void';
                                                          case ':increment':
                                                              return (e, i) => parseFloat(i) > parseFloat(e);
                                                          case ':decrement':
                                                              return (e, i) => parseFloat(i) < parseFloat(e);
                                                          default:
                                                              return (
                                                                  n.push(
                                                                      (function pY(t) {
                                                                          return new Me(3016, !1);
                                                                      })(),
                                                                  ),
                                                                  '* => *'
                                                              );
                                                      }
                                                  })(t, e);
                                                  if ('function' == typeof l) return void n.push(l);
                                                  t = l;
                                              }
                                              const i = t.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
                                              if (null == i || i.length < 4)
                                                  return (
                                                      e.push(
                                                          (function mY(t) {
                                                              return new Me(3015, !1);
                                                          })(),
                                                      ),
                                                      n
                                                  );
                                              const r = i[1],
                                                  s = i[2],
                                                  o = i[3];
                                              n.push(_S(r, o)), '<' == s[0] && (r != df || o != df) && n.push(_S(o, r));
                                          })(i, e, n),
                                      )
                                    : e.push(t),
                                e
                            );
                        })(n.expr, e.errors);
                    return {
                        type: tn.Transition,
                        matchers: r,
                        animation: i,
                        queryCount: e.queryCount,
                        depCount: e.depCount,
                        options: Du(n.options),
                    };
                }
                visitSequence(n, e) {
                    return { type: tn.Sequence, steps: n.steps.map(i => jo(this, i, e)), options: Du(n.options) };
                }
                visitGroup(n, e) {
                    const i = e.currentTime;
                    let r = 0;
                    const s = n.steps.map(o => {
                        e.currentTime = i;
                        const a = jo(this, o, e);
                        return (r = Math.max(r, e.currentTime)), a;
                    });
                    return (e.currentTime = r), { type: tn.Group, steps: s, options: Du(n.options) };
                }
                visitAnimate(n, e) {
                    const i = (function ej(t, n) {
                        if (t.hasOwnProperty('duration')) return t;
                        if ('number' == typeof t) return Np(uf(t, n).duration, 0, '');
                        const e = t;
                        if (e.split(/\s+/).some(s => '{' == s.charAt(0) && '{' == s.charAt(1))) {
                            const s = Np(0, 0, '');
                            return (s.dynamic = !0), (s.strValue = e), s;
                        }
                        const r = uf(e, n);
                        return Np(r.duration, r.delay, r.easing);
                    })(n.timings, e.errors);
                    e.currentAnimateTimings = i;
                    let r,
                        s = n.styles ? n.styles : zt({});
                    if (s.type == tn.Keyframes) r = this.visitKeyframes(s, e);
                    else {
                        let o = n.styles,
                            a = !1;
                        if (!o) {
                            a = !0;
                            const c = {};
                            i.easing && (c.easing = i.easing), (o = zt(c));
                        }
                        e.currentTime += i.duration + i.delay;
                        const l = this.visitStyle(o, e);
                        (l.isEmptyStep = a), (r = l);
                    }
                    return (e.currentAnimateTimings = null), { type: tn.Animate, timings: i, style: r, options: null };
                }
                visitStyle(n, e) {
                    const i = this._makeStyleAst(n, e);
                    return this._validateStyleAst(i, e), i;
                }
                _makeStyleAst(n, e) {
                    const i = [],
                        r = Array.isArray(n.styles) ? n.styles : [n.styles];
                    for (let a of r)
                        'string' == typeof a
                            ? a === Ol
                                ? i.push(a)
                                : e.errors.push(new Me(3002, !1))
                            : i.push(new Map(Object.entries(a)));
                    let s = !1,
                        o = null;
                    return (
                        i.forEach(a => {
                            if (
                                a instanceof Map &&
                                (a.has('easing') && ((o = a.get('easing')), a.delete('easing')), !s)
                            )
                                for (let l of a.values())
                                    if (l.toString().indexOf('{{') >= 0) {
                                        s = !0;
                                        break;
                                    }
                        }),
                        {
                            type: tn.Style,
                            styles: i,
                            easing: o,
                            offset: n.offset,
                            containsDynamicStyles: s,
                            options: null,
                        }
                    );
                }
                _validateStyleAst(n, e) {
                    const i = e.currentAnimateTimings;
                    let r = e.currentTime,
                        s = e.currentTime;
                    i && s > 0 && (s -= i.duration + i.delay),
                        n.styles.forEach(o => {
                            'string' != typeof o &&
                                o.forEach((a, l) => {
                                    const c = e.collectedStyles.get(e.currentQuerySelector),
                                        f = c.get(l);
                                    let g = !0;
                                    f &&
                                        (s != r &&
                                            s >= f.startTime &&
                                            r <= f.endTime &&
                                            (e.errors.push(
                                                (function aY(t, n, e, i, r) {
                                                    return new Me(3010, !1);
                                                })(),
                                            ),
                                            (g = !1)),
                                        (s = f.startTime)),
                                        g && c.set(l, { startTime: s, endTime: r }),
                                        e.options &&
                                            (function HY(t, n, e) {
                                                const i = n.params || {},
                                                    r = gS(t);
                                                r.length &&
                                                    r.forEach(s => {
                                                        i.hasOwnProperty(s) ||
                                                            e.push(
                                                                (function Jq(t) {
                                                                    return new Me(3001, !1);
                                                                })(),
                                                            );
                                                    });
                                            })(a, e.options, e.errors);
                                });
                        });
                }
                visitKeyframes(n, e) {
                    const i = { type: tn.Keyframes, styles: [], options: null };
                    if (!e.currentAnimateTimings)
                        return (
                            e.errors.push(
                                (function lY() {
                                    return new Me(3011, !1);
                                })(),
                            ),
                            i
                        );
                    let s = 0;
                    const o = [];
                    let a = !1,
                        l = !1,
                        c = 0;
                    const f = n.steps.map(he => {
                        const fe = this._makeStyleAst(he, e);
                        let ze =
                                null != fe.offset
                                    ? fe.offset
                                    : (function JY(t) {
                                          if ('string' == typeof t) return null;
                                          let n = null;
                                          if (Array.isArray(t))
                                              t.forEach(e => {
                                                  if (e instanceof Map && e.has('offset')) {
                                                      const i = e;
                                                      (n = parseFloat(i.get('offset'))), i.delete('offset');
                                                  }
                                              });
                                          else if (t instanceof Map && t.has('offset')) {
                                              const e = t;
                                              (n = parseFloat(e.get('offset'))), e.delete('offset');
                                          }
                                          return n;
                                      })(fe.styles),
                            nt = 0;
                        return (
                            null != ze && (s++, (nt = fe.offset = ze)),
                            (l = l || nt < 0 || nt > 1),
                            (a = a || nt < c),
                            (c = nt),
                            o.push(nt),
                            fe
                        );
                    });
                    l &&
                        e.errors.push(
                            (function cY() {
                                return new Me(3012, !1);
                            })(),
                        ),
                        a &&
                            e.errors.push(
                                (function uY() {
                                    return new Me(3200, !1);
                                })(),
                            );
                    const g = n.steps.length;
                    let E = 0;
                    s > 0 && s < g
                        ? e.errors.push(
                              (function dY() {
                                  return new Me(3202, !1);
                              })(),
                          )
                        : 0 == s && (E = 1 / (g - 1));
                    const P = g - 1,
                        V = e.currentTime,
                        W = e.currentAnimateTimings,
                        ie = W.duration;
                    return (
                        f.forEach((he, fe) => {
                            const ze = E > 0 ? (fe == P ? 1 : E * fe) : o[fe],
                                nt = ze * ie;
                            (e.currentTime = V + W.delay + nt),
                                (W.duration = nt),
                                this._validateStyleAst(he, e),
                                (he.offset = ze),
                                i.styles.push(he);
                        }),
                        i
                    );
                }
                visitReference(n, e) {
                    return { type: tn.Reference, animation: jo(this, rh(n.animation), e), options: Du(n.options) };
                }
                visitAnimateChild(n, e) {
                    return e.depCount++, { type: tn.AnimateChild, options: Du(n.options) };
                }
                visitAnimateRef(n, e) {
                    return {
                        type: tn.AnimateRef,
                        animation: this.visitReference(n.animation, e),
                        options: Du(n.options),
                    };
                }
                visitQuery(n, e) {
                    const i = e.currentQuerySelector,
                        r = n.options || {};
                    e.queryCount++, (e.currentQuery = n);
                    const [s, o] = (function QY(t) {
                        const n = !!t.split(/\s*,\s*/).find(e => ':self' == e);
                        return (
                            n && (t = t.replace(WY, '')),
                            (t = t
                                .replace(/@\*/g, cf)
                                .replace(/@\w+/g, e => cf + '-' + e.slice(1))
                                .replace(/:animating/g, Ip)),
                            [t, n]
                        );
                    })(n.selector);
                    (e.currentQuerySelector = i.length ? i + ' ' + s : s),
                        Yo(e.collectedStyles, e.currentQuerySelector, new Map());
                    const a = jo(this, rh(n.animation), e);
                    return (
                        (e.currentQuery = null),
                        (e.currentQuerySelector = i),
                        {
                            type: tn.Query,
                            selector: s,
                            limit: r.limit || 0,
                            optional: !!r.optional,
                            includeSelf: o,
                            animation: a,
                            originalSelector: n.selector,
                            options: Du(n.options),
                        }
                    );
                }
                visitStagger(n, e) {
                    e.currentQuery ||
                        e.errors.push(
                            (function hY() {
                                return new Me(3013, !1);
                            })(),
                        );
                    const i =
                        'full' === n.timings ? { duration: 0, delay: 0, easing: 'full' } : uf(n.timings, e.errors, !0);
                    return { type: tn.Stagger, animation: jo(this, rh(n.animation), e), timings: i, options: null };
                }
            }
            class ZY {
                constructor(n) {
                    (this.errors = n),
                        (this.queryCount = 0),
                        (this.depCount = 0),
                        (this.currentTransition = null),
                        (this.currentQuery = null),
                        (this.currentQuerySelector = null),
                        (this.currentAnimateTimings = null),
                        (this.currentTime = 0),
                        (this.collectedStyles = new Map()),
                        (this.options = null),
                        (this.unsupportedCSSPropertiesFound = new Set());
                }
            }
            function Du(t) {
                return (
                    t
                        ? (t = { ...t }).params &&
                          (t.params = (function XY(t) {
                              return t ? { ...t } : null;
                          })(t.params))
                        : (t = {}),
                    t
                );
            }
            function Np(t, n, e) {
                return { duration: t, delay: n, easing: e };
            }
            function Fp(t, n, e, i, r, s, o = null, a = !1) {
                return {
                    type: 1,
                    element: t,
                    keyframes: n,
                    preStyleProps: e,
                    postStyleProps: i,
                    duration: r,
                    delay: s,
                    totalTime: r + s,
                    easing: o,
                    subTimeline: a,
                };
            }
            class mf {
                constructor() {
                    this._map = new Map();
                }
                get(n) {
                    return this._map.get(n) || [];
                }
                append(n, e) {
                    let i = this._map.get(n);
                    i || this._map.set(n, (i = [])), i.push(...e);
                }
                has(n) {
                    return this._map.has(n);
                }
                clear() {
                    this._map.clear();
                }
            }
            const ij = new RegExp(':enter', 'g'),
                sj = new RegExp(':leave', 'g');
            function Rp(t, n, e, i, r, s = new Map(), o = new Map(), a, l, c = []) {
                return new oj().buildKeyframes(t, n, e, i, r, s, o, a, l, c);
            }
            class oj {
                buildKeyframes(n, e, i, r, s, o, a, l, c, f = []) {
                    c = c || new mf();
                    const g = new Vp(n, e, c, r, s, f, []);
                    g.options = l;
                    const E = l.delay ? zl(l.delay) : 0;
                    g.currentTimeline.delayNextStep(E),
                        g.currentTimeline.setStyles([o], null, g.errors, l),
                        jo(this, i, g);
                    const P = g.timelines.filter(V => V.containsAnimation());
                    if (P.length && a.size) {
                        let V;
                        for (let W = P.length - 1; W >= 0; W--) {
                            const ie = P[W];
                            if (ie.element === e) {
                                V = ie;
                                break;
                            }
                        }
                        V && !V.allowOnlyTimelineStyles() && V.setStyles([a], null, g.errors, l);
                    }
                    return P.length ? P.map(V => V.buildKeyframes()) : [Fp(e, [], [], [], 0, E, '', !1)];
                }
                visitTrigger(n, e) {}
                visitState(n, e) {}
                visitTransition(n, e) {}
                visitAnimateChild(n, e) {
                    const i = e.subInstructions.get(e.element);
                    if (i) {
                        const r = e.createSubContext(n.options),
                            s = e.currentTimeline.currentTime,
                            o = this._visitSubInstructions(i, r, r.options);
                        s != o && e.transformIntoNewTimeline(o);
                    }
                    e.previousNode = n;
                }
                visitAnimateRef(n, e) {
                    const i = e.createSubContext(n.options);
                    i.transformIntoNewTimeline(),
                        this._applyAnimationRefDelays([n.options, n.animation.options], e, i),
                        this.visitReference(n.animation, i),
                        e.transformIntoNewTimeline(i.currentTimeline.currentTime),
                        (e.previousNode = n);
                }
                _applyAnimationRefDelays(n, e, i) {
                    for (const r of n) {
                        const s = r?.delay;
                        if (s) {
                            const o = 'number' == typeof s ? s : zl(sh(s, r?.params ?? {}, e.errors));
                            i.delayNextStep(o);
                        }
                    }
                }
                _visitSubInstructions(n, e, i) {
                    let s = e.currentTimeline.currentTime;
                    const o = null != i.duration ? zl(i.duration) : null,
                        a = null != i.delay ? zl(i.delay) : null;
                    return (
                        0 !== o &&
                            n.forEach(l => {
                                const c = e.appendInstructionToTimeline(l, o, a);
                                s = Math.max(s, c.duration + c.delay);
                            }),
                        s
                    );
                }
                visitReference(n, e) {
                    e.updateOptions(n.options, !0), jo(this, n.animation, e), (e.previousNode = n);
                }
                visitSequence(n, e) {
                    const i = e.subContextCount;
                    let r = e;
                    const s = n.options;
                    if (
                        s &&
                        (s.params || s.delay) &&
                        ((r = e.createSubContext(s)), r.transformIntoNewTimeline(), null != s.delay)
                    ) {
                        r.previousNode.type == tn.Style &&
                            (r.currentTimeline.snapshotCurrentStyles(), (r.previousNode = pf));
                        const o = zl(s.delay);
                        r.delayNextStep(o);
                    }
                    n.steps.length &&
                        (n.steps.forEach(o => jo(this, o, r)),
                        r.currentTimeline.applyStylesToKeyframe(),
                        r.subContextCount > i && r.transformIntoNewTimeline()),
                        (e.previousNode = n);
                }
                visitGroup(n, e) {
                    const i = [];
                    let r = e.currentTimeline.currentTime;
                    const s = n.options && n.options.delay ? zl(n.options.delay) : 0;
                    n.steps.forEach(o => {
                        const a = e.createSubContext(n.options);
                        s && a.delayNextStep(s),
                            jo(this, o, a),
                            (r = Math.max(r, a.currentTimeline.currentTime)),
                            i.push(a.currentTimeline);
                    }),
                        i.forEach(o => e.currentTimeline.mergeTimelineCollectedStyles(o)),
                        e.transformIntoNewTimeline(r),
                        (e.previousNode = n);
                }
                _visitTiming(n, e) {
                    if (n.dynamic) {
                        const i = n.strValue;
                        return uf(e.params ? sh(i, e.params, e.errors) : i, e.errors);
                    }
                    return { duration: n.duration, delay: n.delay, easing: n.easing };
                }
                visitAnimate(n, e) {
                    const i = (e.currentAnimateTimings = this._visitTiming(n.timings, e)),
                        r = e.currentTimeline;
                    i.delay && (e.incrementTime(i.delay), r.snapshotCurrentStyles());
                    const s = n.style;
                    s.type == tn.Keyframes
                        ? this.visitKeyframes(s, e)
                        : (e.incrementTime(i.duration), this.visitStyle(s, e), r.applyStylesToKeyframe()),
                        (e.currentAnimateTimings = null),
                        (e.previousNode = n);
                }
                visitStyle(n, e) {
                    const i = e.currentTimeline,
                        r = e.currentAnimateTimings;
                    !r && i.hasCurrentStyleProperties() && i.forwardFrame();
                    const s = (r && r.easing) || n.easing;
                    n.isEmptyStep ? i.applyEmptyStep(s) : i.setStyles(n.styles, s, e.errors, e.options),
                        (e.previousNode = n);
                }
                visitKeyframes(n, e) {
                    const i = e.currentAnimateTimings,
                        r = e.currentTimeline.duration,
                        s = i.duration,
                        a = e.createSubContext().currentTimeline;
                    (a.easing = i.easing),
                        n.styles.forEach(l => {
                            a.forwardTime((l.offset || 0) * s),
                                a.setStyles(l.styles, l.easing, e.errors, e.options),
                                a.applyStylesToKeyframe();
                        }),
                        e.currentTimeline.mergeTimelineCollectedStyles(a),
                        e.transformIntoNewTimeline(r + s),
                        (e.previousNode = n);
                }
                visitQuery(n, e) {
                    const i = e.currentTimeline.currentTime,
                        r = n.options || {},
                        s = r.delay ? zl(r.delay) : 0;
                    s &&
                        (e.previousNode.type === tn.Style ||
                            (0 == i && e.currentTimeline.hasCurrentStyleProperties())) &&
                        (e.currentTimeline.snapshotCurrentStyles(), (e.previousNode = pf));
                    let o = i;
                    const a = e.invokeQuery(
                        n.selector,
                        n.originalSelector,
                        n.limit,
                        n.includeSelf,
                        !!r.optional,
                        e.errors,
                    );
                    e.currentQueryTotal = a.length;
                    let l = null;
                    a.forEach((c, f) => {
                        e.currentQueryIndex = f;
                        const g = e.createSubContext(n.options, c);
                        s && g.delayNextStep(s),
                            c === e.element && (l = g.currentTimeline),
                            jo(this, n.animation, g),
                            g.currentTimeline.applyStylesToKeyframe(),
                            (o = Math.max(o, g.currentTimeline.currentTime));
                    }),
                        (e.currentQueryIndex = 0),
                        (e.currentQueryTotal = 0),
                        e.transformIntoNewTimeline(o),
                        l &&
                            (e.currentTimeline.mergeTimelineCollectedStyles(l),
                            e.currentTimeline.snapshotCurrentStyles()),
                        (e.previousNode = n);
                }
                visitStagger(n, e) {
                    const i = e.parentContext,
                        r = e.currentTimeline,
                        s = n.timings,
                        o = Math.abs(s.duration),
                        a = o * (e.currentQueryTotal - 1);
                    let l = o * e.currentQueryIndex;
                    switch (s.duration < 0 ? 'reverse' : s.easing) {
                        case 'reverse':
                            l = a - l;
                            break;
                        case 'full':
                            l = i.currentStaggerTime;
                    }
                    const f = e.currentTimeline;
                    l && f.delayNextStep(l);
                    const g = f.currentTime;
                    jo(this, n.animation, e),
                        (e.previousNode = n),
                        (i.currentStaggerTime = r.currentTime - g + (r.startTime - i.currentTimeline.startTime));
                }
            }
            const pf = {};
            class Vp {
                constructor(n, e, i, r, s, o, a, l) {
                    (this._driver = n),
                        (this.element = e),
                        (this.subInstructions = i),
                        (this._enterClassName = r),
                        (this._leaveClassName = s),
                        (this.errors = o),
                        (this.timelines = a),
                        (this.parentContext = null),
                        (this.currentAnimateTimings = null),
                        (this.previousNode = pf),
                        (this.subContextCount = 0),
                        (this.options = {}),
                        (this.currentQueryIndex = 0),
                        (this.currentQueryTotal = 0),
                        (this.currentStaggerTime = 0),
                        (this.currentTimeline = l || new gf(this._driver, e, 0)),
                        a.push(this.currentTimeline);
                }
                get params() {
                    return this.options.params;
                }
                updateOptions(n, e) {
                    if (!n) return;
                    const i = n;
                    let r = this.options;
                    null != i.duration && (r.duration = zl(i.duration)), null != i.delay && (r.delay = zl(i.delay));
                    const s = i.params;
                    if (s) {
                        let o = r.params;
                        o || (o = this.options.params = {}),
                            Object.keys(s).forEach(a => {
                                (!e || !o.hasOwnProperty(a)) && (o[a] = sh(s[a], o, this.errors));
                            });
                    }
                }
                _copyOptions() {
                    const n = {};
                    if (this.options) {
                        const e = this.options.params;
                        if (e) {
                            const i = (n.params = {});
                            Object.keys(e).forEach(r => {
                                i[r] = e[r];
                            });
                        }
                    }
                    return n;
                }
                createSubContext(n = null, e, i) {
                    const r = e || this.element,
                        s = new Vp(
                            this._driver,
                            r,
                            this.subInstructions,
                            this._enterClassName,
                            this._leaveClassName,
                            this.errors,
                            this.timelines,
                            this.currentTimeline.fork(r, i || 0),
                        );
                    return (
                        (s.previousNode = this.previousNode),
                        (s.currentAnimateTimings = this.currentAnimateTimings),
                        (s.options = this._copyOptions()),
                        s.updateOptions(n),
                        (s.currentQueryIndex = this.currentQueryIndex),
                        (s.currentQueryTotal = this.currentQueryTotal),
                        (s.parentContext = this),
                        this.subContextCount++,
                        s
                    );
                }
                transformIntoNewTimeline(n) {
                    return (
                        (this.previousNode = pf),
                        (this.currentTimeline = this.currentTimeline.fork(this.element, n)),
                        this.timelines.push(this.currentTimeline),
                        this.currentTimeline
                    );
                }
                appendInstructionToTimeline(n, e, i) {
                    const r = {
                            duration: e ?? n.duration,
                            delay: this.currentTimeline.currentTime + (i ?? 0) + n.delay,
                            easing: '',
                        },
                        s = new aj(
                            this._driver,
                            n.element,
                            n.keyframes,
                            n.preStyleProps,
                            n.postStyleProps,
                            r,
                            n.stretchStartingKeyframe,
                        );
                    return this.timelines.push(s), r;
                }
                incrementTime(n) {
                    this.currentTimeline.forwardTime(this.currentTimeline.duration + n);
                }
                delayNextStep(n) {
                    n > 0 && this.currentTimeline.delayNextStep(n);
                }
                invokeQuery(n, e, i, r, s, o) {
                    let a = [];
                    if ((r && a.push(this.element), n.length > 0)) {
                        n = (n = n.replace(ij, '.' + this._enterClassName)).replace(sj, '.' + this._leaveClassName);
                        let c = this._driver.query(this.element, n, 1 != i);
                        0 !== i && (c = i < 0 ? c.slice(c.length + i, c.length) : c.slice(0, i)), a.push(...c);
                    }
                    return (
                        !s &&
                            0 == a.length &&
                            o.push(
                                (function fY(t) {
                                    return new Me(3014, !1);
                                })(),
                            ),
                        a
                    );
                }
            }
            class gf {
                constructor(n, e, i, r) {
                    (this._driver = n),
                        (this.element = e),
                        (this.startTime = i),
                        (this._elementTimelineStylesLookup = r),
                        (this.duration = 0),
                        (this.easing = null),
                        (this._previousKeyframe = new Map()),
                        (this._currentKeyframe = new Map()),
                        (this._keyframes = new Map()),
                        (this._styleSummary = new Map()),
                        (this._localTimelineStyles = new Map()),
                        (this._pendingStyles = new Map()),
                        (this._backFill = new Map()),
                        (this._currentEmptyStepKeyframe = null),
                        this._elementTimelineStylesLookup || (this._elementTimelineStylesLookup = new Map()),
                        (this._globalTimelineStyles = this._elementTimelineStylesLookup.get(e)),
                        this._globalTimelineStyles ||
                            ((this._globalTimelineStyles = this._localTimelineStyles),
                            this._elementTimelineStylesLookup.set(e, this._localTimelineStyles)),
                        this._loadKeyframe();
                }
                containsAnimation() {
                    switch (this._keyframes.size) {
                        case 0:
                            return !1;
                        case 1:
                            return this.hasCurrentStyleProperties();
                        default:
                            return !0;
                    }
                }
                hasCurrentStyleProperties() {
                    return this._currentKeyframe.size > 0;
                }
                get currentTime() {
                    return this.startTime + this.duration;
                }
                delayNextStep(n) {
                    const e = 1 === this._keyframes.size && this._pendingStyles.size;
                    this.duration || e
                        ? (this.forwardTime(this.currentTime + n), e && this.snapshotCurrentStyles())
                        : (this.startTime += n);
                }
                fork(n, e) {
                    return (
                        this.applyStylesToKeyframe(),
                        new gf(this._driver, n, e || this.currentTime, this._elementTimelineStylesLookup)
                    );
                }
                _loadKeyframe() {
                    this._currentKeyframe && (this._previousKeyframe = this._currentKeyframe),
                        (this._currentKeyframe = this._keyframes.get(this.duration)),
                        this._currentKeyframe ||
                            ((this._currentKeyframe = new Map()),
                            this._keyframes.set(this.duration, this._currentKeyframe));
                }
                forwardFrame() {
                    (this.duration += 1), this._loadKeyframe();
                }
                forwardTime(n) {
                    this.applyStylesToKeyframe(), (this.duration = n), this._loadKeyframe();
                }
                _updateStyle(n, e) {
                    this._localTimelineStyles.set(n, e),
                        this._globalTimelineStyles.set(n, e),
                        this._styleSummary.set(n, { time: this.currentTime, value: e });
                }
                allowOnlyTimelineStyles() {
                    return this._currentEmptyStepKeyframe !== this._currentKeyframe;
                }
                applyEmptyStep(n) {
                    n && this._previousKeyframe.set('easing', n);
                    for (let [e, i] of this._globalTimelineStyles)
                        this._backFill.set(e, i || Ol), this._currentKeyframe.set(e, Ol);
                    this._currentEmptyStepKeyframe = this._currentKeyframe;
                }
                setStyles(n, e, i, r) {
                    e && this._previousKeyframe.set('easing', e);
                    const s = (r && r.params) || {},
                        o = (function lj(t, n) {
                            const e = new Map();
                            let i;
                            return (
                                t.forEach(r => {
                                    if ('*' === r) {
                                        i ??= n.keys();
                                        for (let s of i) e.set(s, Ol);
                                    } else for (let [s, o] of r) e.set(s, o);
                                }),
                                e
                            );
                        })(n, this._globalTimelineStyles);
                    for (let [a, l] of o) {
                        const c = sh(l, s, i);
                        this._pendingStyles.set(a, c),
                            this._localTimelineStyles.has(a) ||
                                this._backFill.set(a, this._globalTimelineStyles.get(a) ?? Ol),
                            this._updateStyle(a, c);
                    }
                }
                applyStylesToKeyframe() {
                    0 != this._pendingStyles.size &&
                        (this._pendingStyles.forEach((n, e) => {
                            this._currentKeyframe.set(e, n);
                        }),
                        this._pendingStyles.clear(),
                        this._localTimelineStyles.forEach((n, e) => {
                            this._currentKeyframe.has(e) || this._currentKeyframe.set(e, n);
                        }));
                }
                snapshotCurrentStyles() {
                    for (let [n, e] of this._localTimelineStyles)
                        this._pendingStyles.set(n, e), this._updateStyle(n, e);
                }
                getFinalKeyframe() {
                    return this._keyframes.get(this.duration);
                }
                get properties() {
                    const n = [];
                    for (let e in this._currentKeyframe) n.push(e);
                    return n;
                }
                mergeTimelineCollectedStyles(n) {
                    n._styleSummary.forEach((e, i) => {
                        const r = this._styleSummary.get(i);
                        (!r || e.time > r.time) && this._updateStyle(i, e.value);
                    });
                }
                buildKeyframes() {
                    this.applyStylesToKeyframe();
                    const n = new Set(),
                        e = new Set(),
                        i = 1 === this._keyframes.size && 0 === this.duration;
                    let r = [];
                    this._keyframes.forEach((a, l) => {
                        const c = new Map([...this._backFill, ...a]);
                        c.forEach((f, g) => {
                            '!' === f ? n.add(g) : f === Ol && e.add(g);
                        }),
                            i || c.set('offset', l / this.duration),
                            r.push(c);
                    });
                    const s = [...n.values()],
                        o = [...e.values()];
                    if (i) {
                        const a = r[0],
                            l = new Map(a);
                        a.set('offset', 0), l.set('offset', 1), (r = [a, l]);
                    }
                    return Fp(this.element, r, s, o, this.duration, this.startTime, this.easing, !1);
                }
            }
            class aj extends gf {
                constructor(n, e, i, r, s, o, a = !1) {
                    super(n, e, o.delay),
                        (this.keyframes = i),
                        (this.preStyleProps = r),
                        (this.postStyleProps = s),
                        (this._stretchStartingKeyframe = a),
                        (this.timings = { duration: o.duration, delay: o.delay, easing: o.easing });
                }
                containsAnimation() {
                    return this.keyframes.length > 1;
                }
                buildKeyframes() {
                    let n = this.keyframes,
                        { delay: e, duration: i, easing: r } = this.timings;
                    if (this._stretchStartingKeyframe && e) {
                        const s = [],
                            o = i + e,
                            a = e / o,
                            l = new Map(n[0]);
                        l.set('offset', 0), s.push(l);
                        const c = new Map(n[0]);
                        c.set('offset', CS(a)), s.push(c);
                        const f = n.length - 1;
                        for (let g = 1; g <= f; g++) {
                            let E = new Map(n[g]);
                            const P = E.get('offset');
                            E.set('offset', CS((e + P * i) / o)), s.push(E);
                        }
                        (i = o), (e = 0), (r = ''), (n = s);
                    }
                    return Fp(this.element, n, this.preStyleProps, this.postStyleProps, i, e, r, !0);
                }
            }
            function CS(t, n = 3) {
                const e = Math.pow(10, n - 1);
                return Math.round(t * e) / e;
            }
            function wS(t, n, e, i, r, s, o, a, l, c, f, g, E) {
                return {
                    type: 0,
                    element: t,
                    triggerName: n,
                    isRemovalTransition: r,
                    fromState: e,
                    fromStyles: s,
                    toState: i,
                    toStyles: o,
                    timelines: a,
                    queriedElements: l,
                    preStyleProps: c,
                    postStyleProps: f,
                    totalTime: g,
                    errors: E,
                };
            }
            const Hp = {};
            class MS {
                constructor(n, e, i) {
                    (this._triggerName = n), (this.ast = e), (this._stateStyles = i);
                }
                match(n, e, i, r) {
                    return (function cj(t, n, e, i, r) {
                        return t.some(s => s(n, e, i, r));
                    })(this.ast.matchers, n, e, i, r);
                }
                buildStyles(n, e, i) {
                    let r = this._stateStyles.get('*');
                    return (
                        void 0 !== n && (r = this._stateStyles.get(n?.toString()) || r),
                        r ? r.buildStyles(e, i) : new Map()
                    );
                }
                build(n, e, i, r, s, o, a, l, c, f) {
                    const g = [],
                        E = (this.ast.options && this.ast.options.params) || Hp,
                        V = this.buildStyles(i, (a && a.params) || Hp, g),
                        W = (l && l.params) || Hp,
                        ie = this.buildStyles(r, W, g),
                        he = new Set(),
                        fe = new Map(),
                        ze = new Map(),
                        nt = 'void' === r,
                        kt = { params: SS(W, E), delay: this.ast.options?.delay },
                        Tt = f ? [] : Rp(n, e, this.ast.animation, s, o, V, ie, kt, c, g);
                    let rn = 0;
                    return (
                        Tt.forEach(Nn => {
                            rn = Math.max(Nn.duration + Nn.delay, rn);
                        }),
                        g.length
                            ? wS(e, this._triggerName, i, r, nt, V, ie, [], [], fe, ze, rn, g)
                            : (Tt.forEach(Nn => {
                                  const vn = Nn.element,
                                      Si = Yo(fe, vn, new Set());
                                  Nn.preStyleProps.forEach(ir => Si.add(ir));
                                  const ms = Yo(ze, vn, new Set());
                                  Nn.postStyleProps.forEach(ir => ms.add(ir)), vn !== e && he.add(vn);
                              }),
                              wS(e, this._triggerName, i, r, nt, V, ie, Tt, [...he.values()], fe, ze, rn))
                    );
                }
            }
            function SS(t, n) {
                const e = { ...n };
                return (
                    Object.entries(t).forEach(([i, r]) => {
                        null != r && (e[i] = r);
                    }),
                    e
                );
            }
            class uj {
                constructor(n, e, i) {
                    (this.styles = n), (this.defaultParams = e), (this.normalizer = i);
                }
                buildStyles(n, e) {
                    const i = new Map(),
                        r = SS(n, this.defaultParams);
                    return (
                        this.styles.styles.forEach(s => {
                            'string' != typeof s &&
                                s.forEach((o, a) => {
                                    o && (o = sh(o, r, e));
                                    const l = this.normalizer.normalizePropertyName(a, e);
                                    (o = this.normalizer.normalizeStyleValue(a, l, o, e)), i.set(a, o);
                                });
                        }),
                        i
                    );
                }
            }
            class hj {
                constructor(n, e, i) {
                    (this.name = n),
                        (this.ast = e),
                        (this._normalizer = i),
                        (this.transitionFactories = []),
                        (this.states = new Map()),
                        e.states.forEach(r => {
                            this.states.set(r.name, new uj(r.style, (r.options && r.options.params) || {}, i));
                        }),
                        TS(this.states, 'true', '1'),
                        TS(this.states, 'false', '0'),
                        e.transitions.forEach(r => {
                            this.transitionFactories.push(new MS(n, r, this.states));
                        }),
                        (this.fallbackTransition = (function fj(t, n, e) {
                            return new MS(
                                t,
                                {
                                    type: tn.Transition,
                                    animation: { type: tn.Sequence, steps: [], options: null },
                                    matchers: [(o, a) => !0],
                                    options: null,
                                    queryCount: 0,
                                    depCount: 0,
                                },
                                n,
                            );
                        })(n, this.states));
                }
                get containsQueries() {
                    return this.ast.queryCount > 0;
                }
                matchTransition(n, e, i, r) {
                    return this.transitionFactories.find(o => o.match(n, e, i, r)) || null;
                }
                matchStyles(n, e, i) {
                    return this.fallbackTransition.buildStyles(n, e, i);
                }
            }
            function TS(t, n, e) {
                t.has(n) ? t.has(e) || t.set(e, t.get(n)) : t.has(e) && t.set(n, t.get(e));
            }
            const mj = new mf();
            class pj {
                constructor(n, e, i) {
                    (this.bodyNode = n),
                        (this._driver = e),
                        (this._normalizer = i),
                        (this._animations = new Map()),
                        (this._playersById = new Map()),
                        (this.players = []);
                }
                register(n, e) {
                    const i = [],
                        s = Pp(this._driver, e, i, []);
                    if (i.length)
                        throw (function bY(t) {
                            return new Me(3503, !1);
                        })();
                    this._animations.set(n, s);
                }
                _buildPlayer(n, e, i) {
                    const r = n.element,
                        s = lS(this._normalizer, n.keyframes, e, i);
                    return this._driver.animate(r, s, n.duration, n.delay, n.easing, [], !0);
                }
                create(n, e, i = {}) {
                    const r = [],
                        s = this._animations.get(n);
                    let o;
                    const a = new Map();
                    if (
                        (s
                            ? ((o = Rp(this._driver, e, s, Ep, af, new Map(), new Map(), i, mj, r)),
                              o.forEach(f => {
                                  const g = Yo(a, f.element, new Map());
                                  f.postStyleProps.forEach(E => g.set(E, null));
                              }))
                            : (r.push(
                                  (function CY() {
                                      return new Me(3300, !1);
                                  })(),
                              ),
                              (o = [])),
                        r.length)
                    )
                        throw (function wY(t) {
                            return new Me(3504, !1);
                        })();
                    a.forEach((f, g) => {
                        f.forEach((E, P) => {
                            f.set(P, this._driver.computeStyle(g, P, Ol));
                        });
                    });
                    const c = Mc(
                        o.map(f => {
                            const g = a.get(f.element);
                            return this._buildPlayer(f, new Map(), g);
                        }),
                    );
                    return this._playersById.set(n, c), c.onDestroy(() => this.destroy(n)), this.players.push(c), c;
                }
                destroy(n) {
                    const e = this._getPlayer(n);
                    e.destroy(), this._playersById.delete(n);
                    const i = this.players.indexOf(e);
                    i >= 0 && this.players.splice(i, 1);
                }
                _getPlayer(n) {
                    const e = this._playersById.get(n);
                    if (!e)
                        throw (function MY(t) {
                            return new Me(3301, !1);
                        })();
                    return e;
                }
                listen(n, e, i, r) {
                    const s = Sp(e, '', '', '');
                    return wp(this._getPlayer(n), i, s, r), () => {};
                }
                command(n, e, i, r) {
                    if ('register' == i) return void this.register(n, r[0]);
                    if ('create' == i) return void this.create(n, e, r[0] || {});
                    const s = this._getPlayer(n);
                    switch (i) {
                        case 'play':
                            s.play();
                            break;
                        case 'pause':
                            s.pause();
                            break;
                        case 'reset':
                            s.reset();
                            break;
                        case 'restart':
                            s.restart();
                            break;
                        case 'finish':
                            s.finish();
                            break;
                        case 'init':
                            s.init();
                            break;
                        case 'setPosition':
                            s.setPosition(parseFloat(r[0]));
                            break;
                        case 'destroy':
                            this.destroy(n);
                    }
                }
            }
            const DS = 'ng-animate-queued',
                Up = 'ng-animate-disabled',
                bj = [],
                xS = { namespaceId: '', setForRemoval: !1, setForMove: !1, hasAnimation: !1, removedBeforeQueried: !1 },
                Cj = { namespaceId: '', setForMove: !1, setForRemoval: !1, hasAnimation: !1, removedBeforeQueried: !0 },
                ka = '__ng_removed';
            class Bp {
                get params() {
                    return this.options.params;
                }
                constructor(n, e = '') {
                    this.namespaceId = e;
                    const i = n && n.hasOwnProperty('value');
                    if (
                        ((this.value = (function Tj(t) {
                            return t ?? null;
                        })(i ? n.value : n)),
                        i)
                    ) {
                        const { value: s, ...o } = n;
                        this.options = o;
                    } else this.options = {};
                    this.options.params || (this.options.params = {});
                }
                absorbOptions(n) {
                    const e = n.params;
                    if (e) {
                        const i = this.options.params;
                        Object.keys(e).forEach(r => {
                            null == i[r] && (i[r] = e[r]);
                        });
                    }
                }
            }
            const oh = 'void',
                qp = new Bp(oh);
            class wj {
                constructor(n, e, i) {
                    (this.id = n),
                        (this.hostElement = e),
                        (this._engine = i),
                        (this.players = []),
                        (this._triggers = new Map()),
                        (this._queue = []),
                        (this._elementListeners = new Map()),
                        (this._hostClassName = 'ng-tns-' + n),
                        la(e, this._hostClassName);
                }
                listen(n, e, i, r) {
                    if (!this._triggers.has(e))
                        throw (function SY(t, n) {
                            return new Me(3302, !1);
                        })();
                    if (null == i || 0 == i.length)
                        throw (function TY(t) {
                            return new Me(3303, !1);
                        })();
                    if (
                        !(function Dj(t) {
                            return 'start' == t || 'done' == t;
                        })(i)
                    )
                        throw (function DY(t, n) {
                            return new Me(3400, !1);
                        })();
                    const s = Yo(this._elementListeners, n, []),
                        o = { name: e, phase: i, callback: r };
                    s.push(o);
                    const a = Yo(this._engine.statesByElement, n, new Map());
                    return (
                        a.has(e) || (la(n, lf), la(n, lf + '-' + e), a.set(e, qp)),
                        () => {
                            this._engine.afterFlush(() => {
                                const l = s.indexOf(o);
                                l >= 0 && s.splice(l, 1), this._triggers.has(e) || a.delete(e);
                            });
                        }
                    );
                }
                register(n, e) {
                    return !this._triggers.has(n) && (this._triggers.set(n, e), !0);
                }
                _getTrigger(n) {
                    const e = this._triggers.get(n);
                    if (!e)
                        throw (function xY(t) {
                            return new Me(3401, !1);
                        })();
                    return e;
                }
                trigger(n, e, i, r = !0) {
                    const s = this._getTrigger(e),
                        o = new Yp(this.id, e, n);
                    let a = this._engine.statesByElement.get(n);
                    a || (la(n, lf), la(n, lf + '-' + e), this._engine.statesByElement.set(n, (a = new Map())));
                    let l = a.get(e);
                    const c = new Bp(i, this.id);
                    if (
                        (!(i && i.hasOwnProperty('value')) && l && c.absorbOptions(l.options),
                        a.set(e, c),
                        l || (l = qp),
                        c.value !== oh && l.value === c.value)
                    ) {
                        if (
                            !(function Ej(t, n) {
                                const e = Object.keys(t),
                                    i = Object.keys(n);
                                if (e.length != i.length) return !1;
                                for (let r = 0; r < e.length; r++) {
                                    const s = e[r];
                                    if (!n.hasOwnProperty(s) || t[s] !== n[s]) return !1;
                                }
                                return !0;
                            })(l.params, c.params)
                        ) {
                            const W = [],
                                ie = s.matchStyles(l.value, l.params, W),
                                he = s.matchStyles(c.value, c.params, W);
                            W.length
                                ? this._engine.reportError(W)
                                : this._engine.afterFlush(() => {
                                      Tu(n, ie), ll(n, he);
                                  });
                        }
                        return;
                    }
                    const E = Yo(this._engine.playersByElement, n, []);
                    E.forEach(W => {
                        W.namespaceId == this.id && W.triggerName == e && W.queued && W.destroy();
                    });
                    let P = s.matchTransition(l.value, c.value, n, c.params),
                        V = !1;
                    if (!P) {
                        if (!r) return;
                        (P = s.fallbackTransition), (V = !0);
                    }
                    return (
                        this._engine.totalQueuedPlayers++,
                        this._queue.push({
                            element: n,
                            triggerName: e,
                            transition: P,
                            fromState: l,
                            toState: c,
                            player: o,
                            isFallbackTransition: V,
                        }),
                        V ||
                            (la(n, DS),
                            o.onStart(() => {
                                X1(n, DS);
                            })),
                        o.onDone(() => {
                            let W = this.players.indexOf(o);
                            W >= 0 && this.players.splice(W, 1);
                            const ie = this._engine.playersByElement.get(n);
                            if (ie) {
                                let he = ie.indexOf(o);
                                he >= 0 && ie.splice(he, 1);
                            }
                        }),
                        this.players.push(o),
                        E.push(o),
                        o
                    );
                }
                deregister(n) {
                    this._triggers.delete(n),
                        this._engine.statesByElement.forEach(e => e.delete(n)),
                        this._elementListeners.forEach((e, i) => {
                            this._elementListeners.set(
                                i,
                                e.filter(r => r.name != n),
                            );
                        });
                }
                clearElementCache(n) {
                    this._engine.statesByElement.delete(n), this._elementListeners.delete(n);
                    const e = this._engine.playersByElement.get(n);
                    e && (e.forEach(i => i.destroy()), this._engine.playersByElement.delete(n));
                }
                _signalRemovalForInnerTriggers(n, e) {
                    const i = this._engine.driver.query(n, cf, !0);
                    i.forEach(r => {
                        if (r[ka]) return;
                        const s = this._engine.fetchNamespacesByElement(r);
                        s.size ? s.forEach(o => o.triggerLeaveAnimation(r, e, !1, !0)) : this.clearElementCache(r);
                    }),
                        this._engine.afterFlushAnimationsDone(() => i.forEach(r => this.clearElementCache(r)));
                }
                triggerLeaveAnimation(n, e, i, r) {
                    const s = this._engine.statesByElement.get(n),
                        o = new Map();
                    if (s) {
                        const a = [];
                        if (
                            (s.forEach((l, c) => {
                                if ((o.set(c, l.value), this._triggers.has(c))) {
                                    const f = this.trigger(n, c, oh, r);
                                    f && a.push(f);
                                }
                            }),
                            a.length)
                        )
                            return (
                                this._engine.markElementAsRemoved(this.id, n, !0, e, o),
                                i && Mc(a).onDone(() => this._engine.processLeaveNode(n)),
                                !0
                            );
                    }
                    return !1;
                }
                prepareLeaveAnimationListeners(n) {
                    const e = this._elementListeners.get(n),
                        i = this._engine.statesByElement.get(n);
                    if (e && i) {
                        const r = new Set();
                        e.forEach(s => {
                            const o = s.name;
                            if (r.has(o)) return;
                            r.add(o);
                            const l = this._triggers.get(o).fallbackTransition,
                                c = i.get(o) || qp,
                                f = new Bp(oh),
                                g = new Yp(this.id, o, n);
                            this._engine.totalQueuedPlayers++,
                                this._queue.push({
                                    element: n,
                                    triggerName: o,
                                    transition: l,
                                    fromState: c,
                                    toState: f,
                                    player: g,
                                    isFallbackTransition: !0,
                                });
                        });
                    }
                }
                removeNode(n, e) {
                    const i = this._engine;
                    if (
                        (n.childElementCount && this._signalRemovalForInnerTriggers(n, e),
                        this.triggerLeaveAnimation(n, e, !0))
                    )
                        return;
                    let r = !1;
                    if (i.totalAnimations) {
                        const s = i.players.length ? i.playersByQueriedElement.get(n) : [];
                        if (s && s.length) r = !0;
                        else {
                            let o = n;
                            for (; (o = o.parentNode); )
                                if (i.statesByElement.get(o)) {
                                    r = !0;
                                    break;
                                }
                        }
                    }
                    if ((this.prepareLeaveAnimationListeners(n), r)) i.markElementAsRemoved(this.id, n, !1, e);
                    else {
                        const s = n[ka];
                        (!s || s === xS) &&
                            (i.afterFlush(() => this.clearElementCache(n)),
                            i.destroyInnerAnimations(n),
                            i._onRemovalComplete(n, e));
                    }
                }
                insertNode(n, e) {
                    la(n, this._hostClassName);
                }
                drainQueuedTransitions(n) {
                    const e = [];
                    return (
                        this._queue.forEach(i => {
                            const r = i.player;
                            if (r.destroyed) return;
                            const s = i.element,
                                o = this._elementListeners.get(s);
                            o &&
                                o.forEach(a => {
                                    if (a.name == i.triggerName) {
                                        const l = Sp(s, i.triggerName, i.fromState.value, i.toState.value);
                                        (l._data = n), wp(i.player, a.phase, l, a.callback);
                                    }
                                }),
                                r.markedForDestroy
                                    ? this._engine.afterFlush(() => {
                                          r.destroy();
                                      })
                                    : e.push(i);
                        }),
                        (this._queue = []),
                        e.sort((i, r) => {
                            const s = i.transition.ast.depCount,
                                o = r.transition.ast.depCount;
                            return 0 == s || 0 == o
                                ? s - o
                                : this._engine.driver.containsElement(i.element, r.element)
                                ? 1
                                : -1;
                        })
                    );
                }
                destroy(n) {
                    this.players.forEach(e => e.destroy()), this._signalRemovalForInnerTriggers(this.hostElement, n);
                }
            }
            class Mj {
                _onRemovalComplete(n, e) {
                    this.onRemovalComplete(n, e);
                }
                constructor(n, e, i, r) {
                    (this.bodyNode = n),
                        (this.driver = e),
                        (this._normalizer = i),
                        (this.scheduler = r),
                        (this.players = []),
                        (this.newHostElements = new Map()),
                        (this.playersByElement = new Map()),
                        (this.playersByQueriedElement = new Map()),
                        (this.statesByElement = new Map()),
                        (this.disabledNodes = new Set()),
                        (this.totalAnimations = 0),
                        (this.totalQueuedPlayers = 0),
                        (this._namespaceLookup = {}),
                        (this._namespaceList = []),
                        (this._flushFns = []),
                        (this._whenQuietFns = []),
                        (this.namespacesByHostElement = new Map()),
                        (this.collectedEnterElements = []),
                        (this.collectedLeaveElements = []),
                        (this.onRemovalComplete = (s, o) => {});
                }
                get queuedPlayers() {
                    const n = [];
                    return (
                        this._namespaceList.forEach(e => {
                            e.players.forEach(i => {
                                i.queued && n.push(i);
                            });
                        }),
                        n
                    );
                }
                createNamespace(n, e) {
                    const i = new wj(n, e, this);
                    return (
                        this.bodyNode && this.driver.containsElement(this.bodyNode, e)
                            ? this._balanceNamespaceList(i, e)
                            : (this.newHostElements.set(e, i), this.collectEnterElement(e)),
                        (this._namespaceLookup[n] = i)
                    );
                }
                _balanceNamespaceList(n, e) {
                    const i = this._namespaceList,
                        r = this.namespacesByHostElement;
                    if (i.length - 1 >= 0) {
                        let o = !1,
                            a = this.driver.getParentElement(e);
                        for (; a; ) {
                            const l = r.get(a);
                            if (l) {
                                const c = i.indexOf(l);
                                i.splice(c + 1, 0, n), (o = !0);
                                break;
                            }
                            a = this.driver.getParentElement(a);
                        }
                        o || i.unshift(n);
                    } else i.push(n);
                    return r.set(e, n), n;
                }
                register(n, e) {
                    let i = this._namespaceLookup[n];
                    return i || (i = this.createNamespace(n, e)), i;
                }
                registerTrigger(n, e, i) {
                    let r = this._namespaceLookup[n];
                    r && r.register(e, i) && this.totalAnimations++;
                }
                destroy(n, e) {
                    n &&
                        (this.afterFlush(() => {}),
                        this.afterFlushAnimationsDone(() => {
                            const i = this._fetchNamespace(n);
                            this.namespacesByHostElement.delete(i.hostElement);
                            const r = this._namespaceList.indexOf(i);
                            r >= 0 && this._namespaceList.splice(r, 1), i.destroy(e), delete this._namespaceLookup[n];
                        }));
                }
                _fetchNamespace(n) {
                    return this._namespaceLookup[n];
                }
                fetchNamespacesByElement(n) {
                    const e = new Set(),
                        i = this.statesByElement.get(n);
                    if (i)
                        for (let r of i.values())
                            if (r.namespaceId) {
                                const s = this._fetchNamespace(r.namespaceId);
                                s && e.add(s);
                            }
                    return e;
                }
                trigger(n, e, i, r) {
                    if (vf(e)) {
                        const s = this._fetchNamespace(n);
                        if (s) return s.trigger(e, i, r), !0;
                    }
                    return !1;
                }
                insertNode(n, e, i, r) {
                    if (!vf(e)) return;
                    const s = e[ka];
                    if (s && s.setForRemoval) {
                        (s.setForRemoval = !1), (s.setForMove = !0);
                        const o = this.collectedLeaveElements.indexOf(e);
                        o >= 0 && this.collectedLeaveElements.splice(o, 1);
                    }
                    if (n) {
                        const o = this._fetchNamespace(n);
                        o && o.insertNode(e, i);
                    }
                    r && this.collectEnterElement(e);
                }
                collectEnterElement(n) {
                    this.collectedEnterElements.push(n);
                }
                markElementAsDisabled(n, e) {
                    e
                        ? this.disabledNodes.has(n) || (this.disabledNodes.add(n), la(n, Up))
                        : this.disabledNodes.has(n) && (this.disabledNodes.delete(n), X1(n, Up));
                }
                removeNode(n, e, i) {
                    if (vf(e)) {
                        this.scheduler?.notify();
                        const r = n ? this._fetchNamespace(n) : null;
                        r ? r.removeNode(e, i) : this.markElementAsRemoved(n, e, !1, i);
                        const s = this.namespacesByHostElement.get(e);
                        s && s.id !== n && s.removeNode(e, i);
                    } else this._onRemovalComplete(e, i);
                }
                markElementAsRemoved(n, e, i, r, s) {
                    this.collectedLeaveElements.push(e),
                        (e[ka] = {
                            namespaceId: n,
                            setForRemoval: r,
                            hasAnimation: i,
                            removedBeforeQueried: !1,
                            previousTriggersValues: s,
                        });
                }
                listen(n, e, i, r, s) {
                    return vf(e) ? this._fetchNamespace(n).listen(e, i, r, s) : () => {};
                }
                _buildInstruction(n, e, i, r, s) {
                    return n.transition.build(
                        this.driver,
                        n.element,
                        n.fromState.value,
                        n.toState.value,
                        i,
                        r,
                        n.fromState.options,
                        n.toState.options,
                        e,
                        s,
                    );
                }
                destroyInnerAnimations(n) {
                    let e = this.driver.query(n, cf, !0);
                    e.forEach(i => this.destroyActiveAnimationsForElement(i)),
                        0 != this.playersByQueriedElement.size &&
                            ((e = this.driver.query(n, Ip, !0)),
                            e.forEach(i => this.finishActiveQueriedAnimationOnElement(i)));
                }
                destroyActiveAnimationsForElement(n) {
                    const e = this.playersByElement.get(n);
                    e &&
                        e.forEach(i => {
                            i.queued ? (i.markedForDestroy = !0) : i.destroy();
                        });
                }
                finishActiveQueriedAnimationOnElement(n) {
                    const e = this.playersByQueriedElement.get(n);
                    e && e.forEach(i => i.finish());
                }
                whenRenderingDone() {
                    return new Promise(n => {
                        if (this.players.length) return Mc(this.players).onDone(() => n());
                        n();
                    });
                }
                processLeaveNode(n) {
                    const e = n[ka];
                    if (e && e.setForRemoval) {
                        if (((n[ka] = xS), e.namespaceId)) {
                            this.destroyInnerAnimations(n);
                            const i = this._fetchNamespace(e.namespaceId);
                            i && i.clearElementCache(n);
                        }
                        this._onRemovalComplete(n, e.setForRemoval);
                    }
                    n.classList?.contains(Up) && this.markElementAsDisabled(n, !1),
                        this.driver.query(n, '.ng-animate-disabled', !0).forEach(i => {
                            this.markElementAsDisabled(i, !1);
                        });
                }
                flush(n = -1) {
                    let e = [];
                    if (
                        (this.newHostElements.size &&
                            (this.newHostElements.forEach((i, r) => this._balanceNamespaceList(i, r)),
                            this.newHostElements.clear()),
                        this.totalAnimations && this.collectedEnterElements.length)
                    )
                        for (let i = 0; i < this.collectedEnterElements.length; i++)
                            la(this.collectedEnterElements[i], 'ng-star-inserted');
                    if (this._namespaceList.length && (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
                        const i = [];
                        try {
                            e = this._flushAnimations(i, n);
                        } finally {
                            for (let r = 0; r < i.length; r++) i[r]();
                        }
                    } else
                        for (let i = 0; i < this.collectedLeaveElements.length; i++)
                            this.processLeaveNode(this.collectedLeaveElements[i]);
                    if (
                        ((this.totalQueuedPlayers = 0),
                        (this.collectedEnterElements.length = 0),
                        (this.collectedLeaveElements.length = 0),
                        this._flushFns.forEach(i => i()),
                        (this._flushFns = []),
                        this._whenQuietFns.length)
                    ) {
                        const i = this._whenQuietFns;
                        (this._whenQuietFns = []),
                            e.length
                                ? Mc(e).onDone(() => {
                                      i.forEach(r => r());
                                  })
                                : i.forEach(r => r());
                    }
                }
                reportError(n) {
                    throw (function kY(t) {
                        return new Me(3402, !1);
                    })();
                }
                _flushAnimations(n, e) {
                    const i = new mf(),
                        r = [],
                        s = new Map(),
                        o = [],
                        a = new Map(),
                        l = new Map(),
                        c = new Map(),
                        f = new Set();
                    this.disabledNodes.forEach(tt => {
                        f.add(tt);
                        const yt = this.driver.query(tt, '.ng-animate-queued', !0);
                        for (let jt = 0; jt < yt.length; jt++) f.add(yt[jt]);
                    });
                    const g = this.bodyNode,
                        E = Array.from(this.statesByElement.keys()),
                        P = IS(E, this.collectedEnterElements),
                        V = new Map();
                    let W = 0;
                    P.forEach((tt, yt) => {
                        const jt = Ep + W++;
                        V.set(yt, jt), tt.forEach(Fn => la(Fn, jt));
                    });
                    const ie = [],
                        he = new Set(),
                        fe = new Set();
                    for (let tt = 0; tt < this.collectedLeaveElements.length; tt++) {
                        const yt = this.collectedLeaveElements[tt],
                            jt = yt[ka];
                        jt &&
                            jt.setForRemoval &&
                            (ie.push(yt),
                            he.add(yt),
                            jt.hasAnimation
                                ? this.driver.query(yt, '.ng-star-inserted', !0).forEach(Fn => he.add(Fn))
                                : fe.add(yt));
                    }
                    const ze = new Map(),
                        nt = IS(E, Array.from(he));
                    nt.forEach((tt, yt) => {
                        const jt = af + W++;
                        ze.set(yt, jt), tt.forEach(Fn => la(Fn, jt));
                    }),
                        n.push(() => {
                            P.forEach((tt, yt) => {
                                const jt = V.get(yt);
                                tt.forEach(Fn => X1(Fn, jt));
                            }),
                                nt.forEach((tt, yt) => {
                                    const jt = ze.get(yt);
                                    tt.forEach(Fn => X1(Fn, jt));
                                }),
                                ie.forEach(tt => {
                                    this.processLeaveNode(tt);
                                });
                        });
                    const kt = [],
                        Tt = [];
                    for (let tt = this._namespaceList.length - 1; tt >= 0; tt--)
                        this._namespaceList[tt].drainQueuedTransitions(e).forEach(jt => {
                            const Fn = jt.player,
                                Ur = jt.element;
                            if ((kt.push(Fn), this.collectedEnterElements.length)) {
                                const Or = Ur[ka];
                                if (Or && Or.setForMove) {
                                    if (Or.previousTriggersValues && Or.previousTriggersValues.has(jt.triggerName)) {
                                        const Wi = Or.previousTriggersValues.get(jt.triggerName),
                                            Dn = this.statesByElement.get(jt.element);
                                        if (Dn && Dn.has(jt.triggerName)) {
                                            const ks = Dn.get(jt.triggerName);
                                            (ks.value = Wi), Dn.set(jt.triggerName, ks);
                                        }
                                    }
                                    return void Fn.destroy();
                                }
                            }
                            const Mo = !g || !this.driver.containsElement(g, Ur),
                                is = ze.get(Ur),
                                Oa = V.get(Ur),
                                Li = this._buildInstruction(jt, i, Oa, is, Mo);
                            if (Li.errors && Li.errors.length) return void Tt.push(Li);
                            if (Mo)
                                return (
                                    Fn.onStart(() => Tu(Ur, Li.fromStyles)),
                                    Fn.onDestroy(() => ll(Ur, Li.toStyles)),
                                    void r.push(Fn)
                                );
                            if (jt.isFallbackTransition)
                                return (
                                    Fn.onStart(() => Tu(Ur, Li.fromStyles)),
                                    Fn.onDestroy(() => ll(Ur, Li.toStyles)),
                                    void r.push(Fn)
                                );
                            const Eh = [];
                            Li.timelines.forEach(Or => {
                                (Or.stretchStartingKeyframe = !0), this.disabledNodes.has(Or.element) || Eh.push(Or);
                            }),
                                (Li.timelines = Eh),
                                i.append(Ur, Li.timelines),
                                o.push({ instruction: Li, player: Fn, element: Ur }),
                                Li.queriedElements.forEach(Or => Yo(a, Or, []).push(Fn)),
                                Li.preStyleProps.forEach((Or, Wi) => {
                                    if (Or.size) {
                                        let Dn = l.get(Wi);
                                        Dn || l.set(Wi, (Dn = new Set())), Or.forEach((ks, Oc) => Dn.add(Oc));
                                    }
                                }),
                                Li.postStyleProps.forEach((Or, Wi) => {
                                    let Dn = c.get(Wi);
                                    Dn || c.set(Wi, (Dn = new Set())), Or.forEach((ks, Oc) => Dn.add(Oc));
                                });
                        });
                    if (Tt.length) {
                        const tt = [];
                        Tt.forEach(yt => {
                            tt.push(
                                (function EY(t, n) {
                                    return new Me(3505, !1);
                                })(),
                            );
                        }),
                            kt.forEach(yt => yt.destroy()),
                            this.reportError(tt);
                    }
                    const rn = new Map(),
                        Nn = new Map();
                    o.forEach(tt => {
                        const yt = tt.element;
                        i.has(yt) &&
                            (Nn.set(yt, yt), this._beforeAnimationBuild(tt.player.namespaceId, tt.instruction, rn));
                    }),
                        r.forEach(tt => {
                            const yt = tt.element;
                            this._getPreviousPlayers(yt, !1, tt.namespaceId, tt.triggerName, null).forEach(Fn => {
                                Yo(rn, yt, []).push(Fn), Fn.destroy();
                            });
                        });
                    const vn = ie.filter(tt => LS(tt, l, c)),
                        Si = new Map();
                    ES(Si, this.driver, fe, c, Ol).forEach(tt => {
                        LS(tt, l, c) && vn.push(tt);
                    });
                    const ir = new Map();
                    P.forEach((tt, yt) => {
                        ES(ir, this.driver, new Set(tt), l, '!');
                    }),
                        vn.forEach(tt => {
                            const yt = Si.get(tt),
                                jt = ir.get(tt);
                            Si.set(tt, new Map([...(yt?.entries() ?? []), ...(jt?.entries() ?? [])]));
                        });
                    const wo = [],
                        La = [],
                        Zi = {};
                    o.forEach(tt => {
                        const { element: yt, player: jt, instruction: Fn } = tt;
                        if (i.has(yt)) {
                            if (f.has(yt))
                                return (
                                    jt.onDestroy(() => ll(yt, Fn.toStyles)),
                                    (jt.disabled = !0),
                                    jt.overrideTotalTime(Fn.totalTime),
                                    void r.push(jt)
                                );
                            let Ur = Zi;
                            if (Nn.size > 1) {
                                let is = yt;
                                const Oa = [];
                                for (; (is = is.parentNode); ) {
                                    const Li = Nn.get(is);
                                    if (Li) {
                                        Ur = Li;
                                        break;
                                    }
                                    Oa.push(is);
                                }
                                Oa.forEach(Li => Nn.set(Li, Ur));
                            }
                            const Mo = this._buildAnimation(jt.namespaceId, Fn, rn, s, ir, Si);
                            if ((jt.setRealPlayer(Mo), Ur === Zi)) wo.push(jt);
                            else {
                                const is = this.playersByElement.get(Ur);
                                is && is.length && (jt.parentPlayer = Mc(is)), r.push(jt);
                            }
                        } else
                            Tu(yt, Fn.fromStyles),
                                jt.onDestroy(() => ll(yt, Fn.toStyles)),
                                La.push(jt),
                                f.has(yt) && r.push(jt);
                    }),
                        La.forEach(tt => {
                            const yt = s.get(tt.element);
                            if (yt && yt.length) {
                                const jt = Mc(yt);
                                tt.setRealPlayer(jt);
                            }
                        }),
                        r.forEach(tt => {
                            tt.parentPlayer ? tt.syncPlayerEvents(tt.parentPlayer) : tt.destroy();
                        });
                    for (let tt = 0; tt < ie.length; tt++) {
                        const yt = ie[tt],
                            jt = yt[ka];
                        if ((X1(yt, af), jt && jt.hasAnimation)) continue;
                        let Fn = [];
                        if (a.size) {
                            let Mo = a.get(yt);
                            Mo && Mo.length && Fn.push(...Mo);
                            let is = this.driver.query(yt, Ip, !0);
                            for (let Oa = 0; Oa < is.length; Oa++) {
                                let Li = a.get(is[Oa]);
                                Li && Li.length && Fn.push(...Li);
                            }
                        }
                        const Ur = Fn.filter(Mo => !Mo.destroyed);
                        Ur.length ? xj(this, yt, Ur) : this.processLeaveNode(yt);
                    }
                    return (
                        (ie.length = 0),
                        wo.forEach(tt => {
                            this.players.push(tt),
                                tt.onDone(() => {
                                    tt.destroy();
                                    const yt = this.players.indexOf(tt);
                                    this.players.splice(yt, 1);
                                }),
                                tt.play();
                        }),
                        wo
                    );
                }
                afterFlush(n) {
                    this._flushFns.push(n);
                }
                afterFlushAnimationsDone(n) {
                    this._whenQuietFns.push(n);
                }
                _getPreviousPlayers(n, e, i, r, s) {
                    let o = [];
                    if (e) {
                        const a = this.playersByQueriedElement.get(n);
                        a && (o = a);
                    } else {
                        const a = this.playersByElement.get(n);
                        if (a) {
                            const l = !s || s == oh;
                            a.forEach(c => {
                                c.queued || (!l && c.triggerName != r) || o.push(c);
                            });
                        }
                    }
                    return (
                        (i || r) && (o = o.filter(a => !((i && i != a.namespaceId) || (r && r != a.triggerName)))), o
                    );
                }
                _beforeAnimationBuild(n, e, i) {
                    const s = e.element,
                        o = e.isRemovalTransition ? void 0 : n,
                        a = e.isRemovalTransition ? void 0 : e.triggerName;
                    for (const l of e.timelines) {
                        const c = l.element,
                            f = c !== s,
                            g = Yo(i, c, []);
                        this._getPreviousPlayers(c, f, o, a, e.toState).forEach(P => {
                            const V = P.getRealPlayer();
                            V.beforeDestroy && V.beforeDestroy(), P.destroy(), g.push(P);
                        });
                    }
                    Tu(s, e.fromStyles);
                }
                _buildAnimation(n, e, i, r, s, o) {
                    const a = e.triggerName,
                        l = e.element,
                        c = [],
                        f = new Set(),
                        g = new Set(),
                        E = e.timelines.map(V => {
                            const W = V.element;
                            f.add(W);
                            const ie = W[ka];
                            if (ie && ie.removedBeforeQueried) return new ih(V.duration, V.delay);
                            const he = W !== l,
                                fe = (function kj(t) {
                                    const n = [];
                                    return AS(t, n), n;
                                })((i.get(W) || bj).map(rn => rn.getRealPlayer())).filter(
                                    rn => !!rn.element && rn.element === W,
                                ),
                                ze = s.get(W),
                                nt = o.get(W),
                                kt = lS(this._normalizer, V.keyframes, ze, nt),
                                Tt = this._buildPlayer(V, kt, fe);
                            if ((V.subTimeline && r && g.add(W), he)) {
                                const rn = new Yp(n, a, W);
                                rn.setRealPlayer(Tt), c.push(rn);
                            }
                            return Tt;
                        });
                    c.forEach(V => {
                        Yo(this.playersByQueriedElement, V.element, []).push(V),
                            V.onDone(() =>
                                (function Sj(t, n, e) {
                                    let i = t.get(n);
                                    if (i) {
                                        if (i.length) {
                                            const r = i.indexOf(e);
                                            i.splice(r, 1);
                                        }
                                        0 == i.length && t.delete(n);
                                    }
                                    return i;
                                })(this.playersByQueriedElement, V.element, V),
                            );
                    }),
                        f.forEach(V => la(V, mS));
                    const P = Mc(E);
                    return (
                        P.onDestroy(() => {
                            f.forEach(V => X1(V, mS)), ll(l, e.toStyles);
                        }),
                        g.forEach(V => {
                            Yo(r, V, []).push(P);
                        }),
                        P
                    );
                }
                _buildPlayer(n, e, i) {
                    return e.length > 0
                        ? this.driver.animate(n.element, e, n.duration, n.delay, n.easing, i)
                        : new ih(n.duration, n.delay);
                }
            }
            class Yp {
                constructor(n, e, i) {
                    (this.namespaceId = n),
                        (this.triggerName = e),
                        (this.element = i),
                        (this._player = new ih()),
                        (this._containsRealPlayer = !1),
                        (this._queuedCallbacks = new Map()),
                        (this.destroyed = !1),
                        (this.parentPlayer = null),
                        (this.markedForDestroy = !1),
                        (this.disabled = !1),
                        (this.queued = !0),
                        (this.totalTime = 0);
                }
                setRealPlayer(n) {
                    this._containsRealPlayer ||
                        ((this._player = n),
                        this._queuedCallbacks.forEach((e, i) => {
                            e.forEach(r => wp(n, i, void 0, r));
                        }),
                        this._queuedCallbacks.clear(),
                        (this._containsRealPlayer = !0),
                        this.overrideTotalTime(n.totalTime),
                        (this.queued = !1));
                }
                getRealPlayer() {
                    return this._player;
                }
                overrideTotalTime(n) {
                    this.totalTime = n;
                }
                syncPlayerEvents(n) {
                    const e = this._player;
                    e.triggerCallback && n.onStart(() => e.triggerCallback('start')),
                        n.onDone(() => this.finish()),
                        n.onDestroy(() => this.destroy());
                }
                _queueEvent(n, e) {
                    Yo(this._queuedCallbacks, n, []).push(e);
                }
                onDone(n) {
                    this.queued && this._queueEvent('done', n), this._player.onDone(n);
                }
                onStart(n) {
                    this.queued && this._queueEvent('start', n), this._player.onStart(n);
                }
                onDestroy(n) {
                    this.queued && this._queueEvent('destroy', n), this._player.onDestroy(n);
                }
                init() {
                    this._player.init();
                }
                hasStarted() {
                    return !this.queued && this._player.hasStarted();
                }
                play() {
                    !this.queued && this._player.play();
                }
                pause() {
                    !this.queued && this._player.pause();
                }
                restart() {
                    !this.queued && this._player.restart();
                }
                finish() {
                    this._player.finish();
                }
                destroy() {
                    (this.destroyed = !0), this._player.destroy();
                }
                reset() {
                    !this.queued && this._player.reset();
                }
                setPosition(n) {
                    this.queued || this._player.setPosition(n);
                }
                getPosition() {
                    return this.queued ? 0 : this._player.getPosition();
                }
                triggerCallback(n) {
                    const e = this._player;
                    e.triggerCallback && e.triggerCallback(n);
                }
            }
            function vf(t) {
                return t && 1 === t.nodeType;
            }
            function kS(t, n) {
                const e = t.style.display;
                return (t.style.display = n ?? 'none'), e;
            }
            function ES(t, n, e, i, r) {
                const s = [];
                e.forEach(l => s.push(kS(l)));
                const o = [];
                i.forEach((l, c) => {
                    const f = new Map();
                    l.forEach(g => {
                        const E = n.computeStyle(c, g, r);
                        f.set(g, E), (!E || 0 == E.length) && ((c[ka] = Cj), o.push(c));
                    }),
                        t.set(c, f);
                });
                let a = 0;
                return e.forEach(l => kS(l, s[a++])), o;
            }
            function IS(t, n) {
                const e = new Map();
                if ((t.forEach(a => e.set(a, [])), 0 == n.length)) return e;
                const r = new Set(n),
                    s = new Map();
                function o(a) {
                    if (!a) return 1;
                    let l = s.get(a);
                    if (l) return l;
                    const c = a.parentNode;
                    return (l = e.has(c) ? c : r.has(c) ? 1 : o(c)), s.set(a, l), l;
                }
                return (
                    n.forEach(a => {
                        const l = o(a);
                        1 !== l && e.get(l).push(a);
                    }),
                    e
                );
            }
            function la(t, n) {
                t.classList?.add(n);
            }
            function X1(t, n) {
                t.classList?.remove(n);
            }
            function xj(t, n, e) {
                Mc(e).onDone(() => t.processLeaveNode(n));
            }
            function AS(t, n) {
                for (let e = 0; e < t.length; e++) {
                    const i = t[e];
                    i instanceof oS ? AS(i.players, n) : n.push(i);
                }
            }
            function LS(t, n, e) {
                const i = e.get(t);
                if (!i) return !1;
                let r = n.get(t);
                return r ? i.forEach(s => r.add(s)) : n.set(t, i), e.delete(t), !0;
            }
            class ah {
                constructor(n, e, i, r) {
                    (this._driver = e),
                        (this._normalizer = i),
                        (this._triggerCache = {}),
                        (this.onRemovalComplete = (s, o) => {}),
                        (this._transitionEngine = new Mj(n.body, e, i, r)),
                        (this._timelineEngine = new pj(n.body, e, i)),
                        (this._transitionEngine.onRemovalComplete = (s, o) => this.onRemovalComplete(s, o));
                }
                registerTrigger(n, e, i, r, s) {
                    const o = n + '-' + r;
                    let a = this._triggerCache[o];
                    if (!a) {
                        const l = [],
                            f = Pp(this._driver, s, l, []);
                        if (l.length)
                            throw (function _Y(t, n) {
                                return new Me(3404, !1);
                            })();
                        (a = (function dj(t, n, e) {
                            return new hj(t, n, e);
                        })(r, f, this._normalizer)),
                            (this._triggerCache[o] = a);
                    }
                    this._transitionEngine.registerTrigger(e, r, a);
                }
                register(n, e) {
                    this._transitionEngine.register(n, e);
                }
                destroy(n, e) {
                    this._transitionEngine.destroy(n, e);
                }
                onInsert(n, e, i, r) {
                    this._transitionEngine.insertNode(n, e, i, r);
                }
                onRemove(n, e, i) {
                    this._transitionEngine.removeNode(n, e, i);
                }
                disableAnimations(n, e) {
                    this._transitionEngine.markElementAsDisabled(n, e);
                }
                process(n, e, i, r) {
                    if ('@' == i.charAt(0)) {
                        const [s, o] = cS(i);
                        this._timelineEngine.command(s, e, o, r);
                    } else this._transitionEngine.trigger(n, e, i, r);
                }
                listen(n, e, i, r, s) {
                    if ('@' == i.charAt(0)) {
                        const [o, a] = cS(i);
                        return this._timelineEngine.listen(o, e, a, s);
                    }
                    return this._transitionEngine.listen(n, e, i, r, s);
                }
                flush(n = -1) {
                    this._transitionEngine.flush(n);
                }
                get players() {
                    return [...this._transitionEngine.players, ...this._timelineEngine.players];
                }
                whenRenderingDone() {
                    return this._transitionEngine.whenRenderingDone();
                }
                afterFlushAnimationsDone(n) {
                    this._transitionEngine.afterFlushAnimationsDone(n);
                }
            }
            class lh {
                static #e = (this.initialStylesByElement = new WeakMap());
                constructor(n, e, i) {
                    (this._element = n), (this._startStyles = e), (this._endStyles = i), (this._state = 0);
                    let r = lh.initialStylesByElement.get(n);
                    r || lh.initialStylesByElement.set(n, (r = new Map())), (this._initialStyles = r);
                }
                start() {
                    this._state < 1 &&
                        (this._startStyles && ll(this._element, this._startStyles, this._initialStyles),
                        (this._state = 1));
                }
                finish() {
                    this.start(),
                        this._state < 2 &&
                            (ll(this._element, this._initialStyles),
                            this._endStyles && (ll(this._element, this._endStyles), (this._endStyles = null)),
                            (this._state = 1));
                }
                destroy() {
                    this.finish(),
                        this._state < 3 &&
                            (lh.initialStylesByElement.delete(this._element),
                            this._startStyles && (Tu(this._element, this._startStyles), (this._endStyles = null)),
                            this._endStyles && (Tu(this._element, this._endStyles), (this._endStyles = null)),
                            ll(this._element, this._initialStyles),
                            (this._state = 3));
                }
            }
            function jp(t) {
                let n = null;
                return (
                    t.forEach((e, i) => {
                        (function Aj(t) {
                            return 'display' === t || 'position' === t;
                        })(i) && ((n = n || new Map()), n.set(i, e));
                    }),
                    n
                );
            }
            class OS {
                constructor(n, e, i, r) {
                    (this.element = n),
                        (this.keyframes = e),
                        (this.options = i),
                        (this._specialStyles = r),
                        (this._onDoneFns = []),
                        (this._onStartFns = []),
                        (this._onDestroyFns = []),
                        (this._initialized = !1),
                        (this._finished = !1),
                        (this._started = !1),
                        (this._destroyed = !1),
                        (this._originalOnDoneFns = []),
                        (this._originalOnStartFns = []),
                        (this.time = 0),
                        (this.parentPlayer = null),
                        (this.currentSnapshot = new Map()),
                        (this._duration = i.duration),
                        (this._delay = i.delay || 0),
                        (this.time = this._duration + this._delay);
                }
                _onFinish() {
                    this._finished ||
                        ((this._finished = !0), this._onDoneFns.forEach(n => n()), (this._onDoneFns = []));
                }
                init() {
                    this._buildPlayer(), this._preparePlayerBeforeStart();
                }
                _buildPlayer() {
                    if (this._initialized) return;
                    this._initialized = !0;
                    const n = this.keyframes;
                    (this.domPlayer = this._triggerWebAnimation(this.element, n, this.options)),
                        (this._finalKeyframe = n.length ? n[n.length - 1] : new Map());
                    const e = () => this._onFinish();
                    this.domPlayer.addEventListener('finish', e),
                        this.onDestroy(() => {
                            this.domPlayer.removeEventListener('finish', e);
                        });
                }
                _preparePlayerBeforeStart() {
                    this._delay ? this._resetDomPlayerState() : this.domPlayer.pause();
                }
                _convertKeyframesToObject(n) {
                    const e = [];
                    return (
                        n.forEach(i => {
                            e.push(Object.fromEntries(i));
                        }),
                        e
                    );
                }
                _triggerWebAnimation(n, e, i) {
                    return n.animate(this._convertKeyframesToObject(e), i);
                }
                onStart(n) {
                    this._originalOnStartFns.push(n), this._onStartFns.push(n);
                }
                onDone(n) {
                    this._originalOnDoneFns.push(n), this._onDoneFns.push(n);
                }
                onDestroy(n) {
                    this._onDestroyFns.push(n);
                }
                play() {
                    this._buildPlayer(),
                        this.hasStarted() ||
                            (this._onStartFns.forEach(n => n()),
                            (this._onStartFns = []),
                            (this._started = !0),
                            this._specialStyles && this._specialStyles.start()),
                        this.domPlayer.play();
                }
                pause() {
                    this.init(), this.domPlayer.pause();
                }
                finish() {
                    this.init(),
                        this._specialStyles && this._specialStyles.finish(),
                        this._onFinish(),
                        this.domPlayer.finish();
                }
                reset() {
                    this._resetDomPlayerState(),
                        (this._destroyed = !1),
                        (this._finished = !1),
                        (this._started = !1),
                        (this._onStartFns = this._originalOnStartFns),
                        (this._onDoneFns = this._originalOnDoneFns);
                }
                _resetDomPlayerState() {
                    this.domPlayer && this.domPlayer.cancel();
                }
                restart() {
                    this.reset(), this.play();
                }
                hasStarted() {
                    return this._started;
                }
                destroy() {
                    this._destroyed ||
                        ((this._destroyed = !0),
                        this._resetDomPlayerState(),
                        this._onFinish(),
                        this._specialStyles && this._specialStyles.destroy(),
                        this._onDestroyFns.forEach(n => n()),
                        (this._onDestroyFns = []));
                }
                setPosition(n) {
                    void 0 === this.domPlayer && this.init(), (this.domPlayer.currentTime = n * this.time);
                }
                getPosition() {
                    return +(this.domPlayer.currentTime ?? 0) / this.time;
                }
                get totalTime() {
                    return this._delay + this._duration;
                }
                beforeDestroy() {
                    const n = new Map();
                    this.hasStarted() &&
                        this._finalKeyframe.forEach((i, r) => {
                            'offset' !== r && n.set(r, this._finished ? i : zp(this.element, r));
                        }),
                        (this.currentSnapshot = n);
                }
                triggerCallback(n) {
                    const e = 'start' === n ? this._onStartFns : this._onDoneFns;
                    e.forEach(i => i()), (e.length = 0);
                }
            }
            class zS {
                validateStyleProperty(n) {
                    return !0;
                }
                validateAnimatableStyleProperty(n) {
                    return !0;
                }
                matchesElement(n, e) {
                    return !1;
                }
                containsElement(n, e) {
                    return dS(n, e);
                }
                getParentElement(n) {
                    return Tp(n);
                }
                query(n, e, i) {
                    return hS(n, e, i);
                }
                computeStyle(n, e, i) {
                    return zp(n, e);
                }
                animate(n, e, i, r, s, o = []) {
                    const l = { duration: i, delay: r, fill: 0 == r ? 'both' : 'forwards' };
                    s && (l.easing = s);
                    const c = new Map(),
                        f = o.filter(P => P instanceof OS);
                    (function BY(t, n) {
                        return 0 === t || 0 === n;
                    })(i, r) &&
                        f.forEach(P => {
                            P.currentSnapshot.forEach((V, W) => c.set(W, V));
                        });
                    let g = (function VY(t) {
                        return t.length ? (t[0] instanceof Map ? t : t.map(n => new Map(Object.entries(n)))) : [];
                    })(e).map(P => new Map(P));
                    g = (function qY(t, n, e) {
                        if (e.size && n.length) {
                            let i = n[0],
                                r = [];
                            if (
                                (e.forEach((s, o) => {
                                    i.has(o) || r.push(o), i.set(o, s);
                                }),
                                r.length)
                            )
                                for (let s = 1; s < n.length; s++) {
                                    let o = n[s];
                                    r.forEach(a => o.set(a, zp(t, a)));
                                }
                        }
                        return n;
                    })(n, g, c);
                    const E = (function Ij(t, n) {
                        let e = null,
                            i = null;
                        return (
                            Array.isArray(n) && n.length
                                ? ((e = jp(n[0])), n.length > 1 && (i = jp(n[n.length - 1])))
                                : n instanceof Map && (e = jp(n)),
                            e || i ? new lh(t, e, i) : null
                        );
                    })(n, g);
                    return new OS(n, g, l, E);
                }
            }
            const PS = '@.disabled';
            class NS {
                constructor(n, e, i, r) {
                    (this.namespaceId = n),
                        (this.delegate = e),
                        (this.engine = i),
                        (this._onDestroy = r),
                        (this.ɵtype = 0);
                }
                get data() {
                    return this.delegate.data;
                }
                destroyNode(n) {
                    this.delegate.destroyNode?.(n);
                }
                destroy() {
                    this.engine.destroy(this.namespaceId, this.delegate),
                        this.engine.afterFlushAnimationsDone(() => {
                            queueMicrotask(() => {
                                this.delegate.destroy();
                            });
                        }),
                        this._onDestroy?.();
                }
                createElement(n, e) {
                    return this.delegate.createElement(n, e);
                }
                createComment(n) {
                    return this.delegate.createComment(n);
                }
                createText(n) {
                    return this.delegate.createText(n);
                }
                appendChild(n, e) {
                    this.delegate.appendChild(n, e), this.engine.onInsert(this.namespaceId, e, n, !1);
                }
                insertBefore(n, e, i, r = !0) {
                    this.delegate.insertBefore(n, e, i), this.engine.onInsert(this.namespaceId, e, n, r);
                }
                removeChild(n, e, i) {
                    this.engine.onRemove(this.namespaceId, e, this.delegate);
                }
                selectRootElement(n, e) {
                    return this.delegate.selectRootElement(n, e);
                }
                parentNode(n) {
                    return this.delegate.parentNode(n);
                }
                nextSibling(n) {
                    return this.delegate.nextSibling(n);
                }
                setAttribute(n, e, i, r) {
                    this.delegate.setAttribute(n, e, i, r);
                }
                removeAttribute(n, e, i) {
                    this.delegate.removeAttribute(n, e, i);
                }
                addClass(n, e) {
                    this.delegate.addClass(n, e);
                }
                removeClass(n, e) {
                    this.delegate.removeClass(n, e);
                }
                setStyle(n, e, i, r) {
                    this.delegate.setStyle(n, e, i, r);
                }
                removeStyle(n, e, i) {
                    this.delegate.removeStyle(n, e, i);
                }
                setProperty(n, e, i) {
                    '@' == e.charAt(0) && e == PS ? this.disableAnimations(n, !!i) : this.delegate.setProperty(n, e, i);
                }
                setValue(n, e) {
                    this.delegate.setValue(n, e);
                }
                listen(n, e, i) {
                    return this.delegate.listen(n, e, i);
                }
                disableAnimations(n, e) {
                    this.engine.disableAnimations(n, e);
                }
            }
            class Lj extends NS {
                constructor(n, e, i, r, s) {
                    super(e, i, r, s), (this.factory = n), (this.namespaceId = e);
                }
                setProperty(n, e, i) {
                    '@' == e.charAt(0)
                        ? '.' == e.charAt(1) && e == PS
                            ? this.disableAnimations(n, (i = void 0 === i || !!i))
                            : this.engine.process(this.namespaceId, n, e.slice(1), i)
                        : this.delegate.setProperty(n, e, i);
                }
                listen(n, e, i) {
                    if ('@' == e.charAt(0)) {
                        const r = (function Oj(t) {
                            switch (t) {
                                case 'body':
                                    return document.body;
                                case 'document':
                                    return document;
                                case 'window':
                                    return window;
                                default:
                                    return t;
                            }
                        })(n);
                        let s = e.slice(1),
                            o = '';
                        return (
                            '@' != s.charAt(0) &&
                                ([s, o] = (function zj(t) {
                                    const n = t.indexOf('.');
                                    return [t.substring(0, n), t.slice(n + 1)];
                                })(s)),
                            this.engine.listen(this.namespaceId, r, s, o, a => {
                                this.factory.scheduleListenerCallback(a._data || -1, i, a);
                            })
                        );
                    }
                    return this.delegate.listen(n, e, i);
                }
            }
            class Pj {
                constructor(n, e, i) {
                    (this.delegate = n),
                        (this.engine = e),
                        (this._zone = i),
                        (this._currentId = 0),
                        (this._microtaskId = 1),
                        (this._animationCallbacksBuffer = []),
                        (this._rendererCache = new Map()),
                        (this._cdRecurDepth = 0),
                        (e.onRemovalComplete = (r, s) => {
                            const o = s?.parentNode(r);
                            o && s.removeChild(o, r);
                        });
                }
                createRenderer(n, e) {
                    const r = this.delegate.createRenderer(n, e);
                    if (!n || !e?.data?.animation) {
                        const c = this._rendererCache;
                        let f = c.get(r);
                        return f || ((f = new NS('', r, this.engine, () => c.delete(r))), c.set(r, f)), f;
                    }
                    const s = e.id,
                        o = e.id + '-' + this._currentId;
                    this._currentId++, this.engine.register(o, n);
                    const a = c => {
                        Array.isArray(c) ? c.forEach(a) : this.engine.registerTrigger(s, o, n, c.name, c);
                    };
                    return e.data.animation.forEach(a), new Lj(this, o, r, this.engine);
                }
                begin() {
                    this._cdRecurDepth++, this.delegate.begin && this.delegate.begin();
                }
                _scheduleCountTask() {
                    queueMicrotask(() => {
                        this._microtaskId++;
                    });
                }
                scheduleListenerCallback(n, e, i) {
                    if (n >= 0 && n < this._microtaskId) return void this._zone.run(() => e(i));
                    const r = this._animationCallbacksBuffer;
                    0 == r.length &&
                        queueMicrotask(() => {
                            this._zone.run(() => {
                                r.forEach(s => {
                                    const [o, a] = s;
                                    o(a);
                                }),
                                    (this._animationCallbacksBuffer = []);
                            });
                        }),
                        r.push([e, i]);
                }
                end() {
                    this._cdRecurDepth--,
                        0 == this._cdRecurDepth &&
                            this._zone.runOutsideAngular(() => {
                                this._scheduleCountTask(), this.engine.flush(this._microtaskId);
                            }),
                        this.delegate.end && this.delegate.end();
                }
                whenRenderingDone() {
                    return this.engine.whenRenderingDone();
                }
            }
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */ const FS = [
                    {
                        provide: kp,
                        useFactory: function Fj() {
                            return new vS();
                        },
                    },
                    {
                        provide: ah,
                        useClass: (() => {
                            class t extends ah {
                                constructor(e, i, r) {
                                    super(e, i, r, Ue(H2, { optional: !0 }));
                                }
                                ngOnDestroy() {
                                    this.flush();
                                }
                                static #e = (this.ɵfac = function (i) {
                                    return new (i || t)(Se(Ni), Se(xp), Se(kp));
                                });
                                static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                            }
                            return t;
                        })(),
                    },
                    {
                        provide: y1,
                        useFactory: function Rj(t, n, e) {
                            return new Pj(t, n, e);
                        },
                        deps: [zm, ah, en],
                    },
                ],
                $p = [
                    { provide: xp, useFactory: () => new zS() },
                    { provide: W0, useValue: 'BrowserAnimations' },
                    ...FS,
                ],
                RS = [{ provide: xp, useClass: Dp }, { provide: W0, useValue: 'NoopAnimations' }, ...FS];
            let Vj = (() => {
                class t {
                    static withConfig(e) {
                        return { ngModule: t, providers: e.disableAnimations ? RS : $p };
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵmod = Zn({ type: t }));
                    static #n = (this.ɵinj = zn({ providers: $p, imports: [dw] }));
                }
                return t;
            })();
            const VS = {
                name: 'star',
                theme: 'fill',
                icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" /></svg>',
            };
            function Z1(t) {
                return t <= 0
                    ? () => j4
                    : mi((n, e) => {
                          let i = 0;
                          n.subscribe(
                              ln(e, r => {
                                  ++i <= t && (e.next(r), t <= i && e.complete());
                              }),
                          );
                      });
            }
            class L$ extends ii {
                constructor(n, e) {
                    super();
                }
                schedule(n, e = 0) {
                    return this;
                }
            }
            const yf = {
                setInterval(t, n, ...e) {
                    const { delegate: i } = yf;
                    return i?.setInterval ? i.setInterval(t, n, ...e) : setInterval(t, n, ...e);
                },
                clearInterval(t) {
                    const { delegate: n } = yf;
                    return (n?.clearInterval || clearInterval)(t);
                },
                delegate: void 0,
            };
            class Gp extends L$ {
                constructor(n, e) {
                    super(n, e), (this.scheduler = n), (this.work = e), (this.pending = !1);
                }
                schedule(n, e = 0) {
                    var i;
                    if (this.closed) return this;
                    this.state = n;
                    const r = this.id,
                        s = this.scheduler;
                    return (
                        null != r && (this.id = this.recycleAsyncId(s, r, e)),
                        (this.pending = !0),
                        (this.delay = e),
                        (this.id = null !== (i = this.id) && void 0 !== i ? i : this.requestAsyncId(s, this.id, e)),
                        this
                    );
                }
                requestAsyncId(n, e, i = 0) {
                    return yf.setInterval(n.flush.bind(n, this), i);
                }
                recycleAsyncId(n, e, i = 0) {
                    if (null != i && this.delay === i && !1 === this.pending) return e;
                    null != e && yf.clearInterval(e);
                }
                execute(n, e) {
                    if (this.closed) return new Error('executing a cancelled action');
                    this.pending = !1;
                    const i = this._execute(n, e);
                    if (i) return i;
                    !1 === this.pending &&
                        null != this.id &&
                        (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
                }
                _execute(n, e) {
                    let r,
                        i = !1;
                    try {
                        this.work(n);
                    } catch (s) {
                        (i = !0), (r = s || new Error('Scheduled action threw falsy error'));
                    }
                    if (i) return this.unsubscribe(), r;
                }
                unsubscribe() {
                    if (!this.closed) {
                        const { id: n, scheduler: e } = this,
                            { actions: i } = e;
                        (this.work = this.state = this.scheduler = null),
                            (this.pending = !1),
                            Ti(i, this),
                            null != n && (this.id = this.recycleAsyncId(e, n, null)),
                            (this.delay = null),
                            super.unsubscribe();
                    }
                }
            }
            class ch {
                constructor(n, e = ch.now) {
                    (this.schedulerActionCtor = n), (this.now = e);
                }
                schedule(n, e = 0, i) {
                    return new this.schedulerActionCtor(this, n).schedule(i, e);
                }
            }
            ch.now = Qm.now;
            class Wp extends ch {
                constructor(n, e = ch.now) {
                    super(n, e), (this.actions = []), (this._active = !1);
                }
                flush(n) {
                    const { actions: e } = this;
                    if (this._active) return void e.push(n);
                    let i;
                    this._active = !0;
                    do {
                        if ((i = n.execute(n.state, n.delay))) break;
                    } while ((n = e.shift()));
                    if (((this._active = !1), i)) {
                        for (; (n = e.shift()); ) n.unsubscribe();
                        throw i;
                    }
                }
            }
            const bf = new Wp(Gp),
                O$ = bf;
            function Kp(t = 0, n, e = O$) {
                let i = -1;
                return (
                    null != n && (pw(n) ? (e = n) : (i = n)),
                    new Tn(r => {
                        let s = (function z$(t) {
                            return t instanceof Date && !isNaN(t);
                        })(t)
                            ? +t - e.now()
                            : t;
                        s < 0 && (s = 0);
                        let o = 0;
                        return e.schedule(function () {
                            r.closed || (r.next(o++), 0 <= i ? this.schedule(void 0, i) : r.complete());
                        }, s);
                    })
                );
            }
            function Qp(t, n, e) {
                const i = et(t) || n || e ? { next: t, error: n, complete: e } : t;
                return i
                    ? mi((r, s) => {
                          var o;
                          null === (o = i.subscribe) || void 0 === o || o.call(i);
                          let a = !0;
                          r.subscribe(
                              ln(
                                  s,
                                  l => {
                                      var c;
                                      null === (c = i.next) || void 0 === c || c.call(i, l), s.next(l);
                                  },
                                  () => {
                                      var l;
                                      (a = !1), null === (l = i.complete) || void 0 === l || l.call(i), s.complete();
                                  },
                                  l => {
                                      var c;
                                      (a = !1), null === (c = i.error) || void 0 === c || c.call(i, l), s.error(l);
                                  },
                                  () => {
                                      var l, c;
                                      a && (null === (l = i.unsubscribe) || void 0 === l || l.call(i)),
                                          null === (c = i.finalize) || void 0 === c || c.call(i);
                                  },
                              ),
                          );
                      })
                    : Yn;
            }
            function Xp(t) {
                return mi((n, e) => {
                    let s,
                        i = null,
                        r = !1;
                    (i = n.subscribe(
                        ln(e, void 0, void 0, o => {
                            (s = bs(t(o, Xp(t)(n)))), i ? (i.unsubscribe(), (i = null), s.subscribe(e)) : (r = !0);
                        }),
                    )),
                        r && (i.unsubscribe(), (i = null), s.subscribe(e));
                });
            }
            function HS(t = {}) {
                const {
                    connector: n = () => new vt(),
                    resetOnError: e = !0,
                    resetOnComplete: i = !0,
                    resetOnRefCountZero: r = !0,
                } = t;
                return s => {
                    let o,
                        a,
                        l,
                        c = 0,
                        f = !1,
                        g = !1;
                    const E = () => {
                            a?.unsubscribe(), (a = void 0);
                        },
                        P = () => {
                            E(), (o = l = void 0), (f = g = !1);
                        },
                        V = () => {
                            const W = o;
                            P(), W?.unsubscribe();
                        };
                    return mi((W, ie) => {
                        c++, !g && !f && E();
                        const he = (l = l ?? n());
                        ie.add(() => {
                            c--, 0 === c && !g && !f && (a = Zp(V, r));
                        }),
                            he.subscribe(ie),
                            !o &&
                                c > 0 &&
                                ((o = new on({
                                    next: fe => he.next(fe),
                                    error: fe => {
                                        (g = !0), E(), (a = Zp(P, e, fe)), he.error(fe);
                                    },
                                    complete: () => {
                                        (f = !0), E(), (a = Zp(P, i)), he.complete();
                                    },
                                })),
                                bs(W).subscribe(o));
                    })(s);
                };
            }
            function Zp(t, n, ...e) {
                if (!0 === n) return void t();
                if (!1 === n) return;
                const i = new on({
                    next: () => {
                        i.unsubscribe(), t();
                    },
                });
                return bs(n(...e)).subscribe(i);
            }
            function US(t, n, e) {
                t ? Ll(e, t, n) : n();
            }
            function nn(t) {
                return mi((n, e) => {
                    bs(t).subscribe(ln(e, () => e.complete(), Kn)), !e.closed && n.subscribe(e);
                });
            }
            /**
             * @license Angular v17.3.11
             * (c) 2010-2024 Google LLC. https://angular.io/
             * License: MIT
             */ function Cf(t) {
                t ||
                    ((function Kc(t) {
                        if (!jh()) throw new Me(-203, !1);
                    })(),
                    (t = Ue(oc)));
                const n = new Tn(e => t.onDestroy(e.next.bind(e)));
                return e => e.pipe(nn(n));
            }
            function BS(t) {
                return t && t.constructor && 'function' == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
            }
            function qS(t) {
                return t;
            }
            function YS(t, n) {
                const e = (n = n || {}).delimiter || '.',
                    i = n.maxDepth,
                    r = n.transformKey || qS,
                    s = {};
                return (
                    (function o(a, l, c) {
                        (c = c || 1),
                            Object.keys(a).forEach(function (f) {
                                const g = a[f],
                                    E = n.safe && Array.isArray(g),
                                    P = Object.prototype.toString.call(g),
                                    V = BS(g),
                                    W = '[object Object]' === P || '[object Array]' === P,
                                    ie = l ? l + e + r(f) : r(f);
                                if (!E && !V && W && Object.keys(g).length && (!n.maxDepth || c < i))
                                    return o(g, ie, c + 1);
                                s[ie] = g;
                            });
                    })(t),
                    s
                );
            }
            function jS(t, n) {
                const e = (n = n || {}).delimiter || '.',
                    i = n.overwrite || !1,
                    r = n.transformKey || qS,
                    s = {};
                if (BS(t) || '[object Object]' !== Object.prototype.toString.call(t)) return t;
                function a(f) {
                    const g = Number(f);
                    return isNaN(g) || -1 !== f.indexOf('.') || n.object ? f : g;
                }
                return (
                    (t = Object.keys(t).reduce(function (f, g) {
                        const E = Object.prototype.toString.call(t[g]);
                        return ('[object Object]' !== E && '[object Array]' !== E) ||
                            (function c(f) {
                                const g = Object.prototype.toString.call(f);
                                return (
                                    !f ||
                                    ('[object Array]' === g
                                        ? !f.length
                                        : '[object Object]' === g
                                        ? !Object.keys(f).length
                                        : void 0)
                                );
                            })(t[g])
                            ? ((f[g] = t[g]), f)
                            : (function l(f, g, E) {
                                  return Object.keys(E).reduce(function (P, V) {
                                      return (P[f + e + V] = E[V]), P;
                                  }, g);
                              })(g, f, YS(t[g], n));
                    }, {})),
                    Object.keys(t).forEach(function (f) {
                        const g = f.split(e).map(r);
                        let E = a(g.shift()),
                            P = a(g[0]),
                            V = s;
                        for (; void 0 !== P; ) {
                            if ('__proto__' === E) return;
                            const W = Object.prototype.toString.call(V[E]),
                                ie = '[object Object]' === W || '[object Array]' === W;
                            if (!i && !ie && typeof V[E] < 'u') return;
                            ((i && !ie) || (!i && null == V[E])) && (V[E] = 'number' != typeof P || n.object ? {} : []),
                                (V = V[E]),
                                g.length > 0 && ((E = a(g.shift())), (P = a(g[0])));
                        }
                        V[E] = jS(t[f], n);
                    }),
                    s
                );
            }
            class B$ {
                translations;
                constructor(n) {
                    this.translations = n;
                }
                getTranslation(n) {
                    return Uo(this.translations.get(n) || {});
                }
            }
            const $S = new $e('TRANSLOCO_LOADER');
            function Jp(t, n) {
                return (
                    t && (Object.prototype.hasOwnProperty.call(t, n) ? t[n] : n.split('.').reduce((e, i) => e?.[i], t))
                );
            }
            function GS(t) {
                return t ? (Array.isArray(t) ? t.length : eg(t) ? Object.keys(t).length : t ? t.length : 0) : 0;
            }
            function xu(t) {
                return 'string' == typeof t;
            }
            function eg(t) {
                return !!t && 'object' == typeof t && !Array.isArray(t);
            }
            function WS(t) {
                return t
                    .replace(/(?:^\w|[A-Z]|\b\w)/g, (n, e) => (0 == e ? n.toLowerCase() : n.toUpperCase()))
                    .replace(/\s+|_|-|\//g, '');
            }
            function tg(t) {
                return null == t;
            }
            function QS(t) {
                return !1 === tg(t);
            }
            function XS(t) {
                return t && 'string' == typeof t.scope;
            }
            function ZS(t) {
                return YS(t, { safe: !0 });
            }
            const J1 = new $e('TRANSLOCO_CONFIG', { providedIn: 'root', factory: () => e0 }),
                e0 = {
                    defaultLang: 'en',
                    reRenderOnLangChange: !1,
                    prodMode: !1,
                    failedRetries: 2,
                    fallbackLang: [],
                    availableLangs: [],
                    missingHandler: { logMissingKey: !0, useFallbackTranslation: !1, allowEmpty: !1 },
                    flatten: { aot: !1 },
                    interpolation: ['{{', '}}'],
                    scopes: { keepCasing: !1 },
                };
            function K$(t = {}) {
                return {
                    ...e0,
                    ...t,
                    missingHandler: { ...e0.missingHandler, ...t.missingHandler },
                    flatten: { ...e0.flatten, ...t.flatten },
                    scopes: { ...e0.scopes, ...t.scopes },
                };
            }
            const JS = new $e('TRANSLOCO_TRANSPILER');
            let Q$ = (() => {
                class t {
                    config = Ue(J1, { optional: !0 }) ?? e0;
                    get interpolationMatcher() {
                        return (function X$(t) {
                            const [n, e] = t.interpolation;
                            return new RegExp(`${n}([^${n}${e}]*?)${e}`, 'g');
                        })(this.config);
                    }
                    transpile({ value: e, params: i = {}, translation: r, key: s }) {
                        if (xu(e)) {
                            let o,
                                a = e;
                            for (; null !== (o = this.interpolationMatcher.exec(a)); ) {
                                const [l, c] = o;
                                a = a.replace(l, () => {
                                    const f = c.trim(),
                                        g = Jp(i, f);
                                    return QS(g)
                                        ? g
                                        : QS(r[f])
                                        ? this.transpile({ params: i, translation: r, key: s, value: r[f] })
                                        : '';
                                });
                            }
                            return a;
                        }
                        return (
                            i &&
                                (eg(e)
                                    ? (e = this.handleObject({ value: e, params: i, translation: r, key: s }))
                                    : Array.isArray(e) &&
                                      (e = this.handleArray({ value: e, params: i, translation: r, key: s }))),
                            e
                        );
                    }
                    handleObject({ value: e, params: i = {}, translation: r, key: s }) {
                        let o = e;
                        return (
                            Object.keys(i).forEach(a => {
                                const l = this.transpile({ value: Jp(o, a), params: Jp(i, a), translation: r, key: s });
                                o = (function q$(t, n, e) {
                                    t = { ...t };
                                    const i = n.split('.'),
                                        r = i.length - 1;
                                    return (
                                        i.reduce(
                                            (s, o, a) => (
                                                (s[o] = a === r ? e : Array.isArray(s[o]) ? s[o].slice() : { ...s[o] }),
                                                s && s[o]
                                            ),
                                            t,
                                        ),
                                        t
                                    );
                                })(o, a, l);
                            }),
                            o
                        );
                    }
                    handleArray({ value: e, ...i }) {
                        return e.map(r => this.transpile({ value: r, ...i }));
                    }
                    static ɵfac = function (i) {
                        return new (i || t)();
                    };
                    static ɵprov = We({ token: t, factory: t.ɵfac });
                }
                return t;
            })();
            const eT = new $e('TRANSLOCO_MISSING_HANDLER');
            let Z$ = (() => {
                class t {
                    handle(e, i) {
                        return (
                            i.missingHandler.logMissingKey &&
                                !i.prodMode &&
                                console.warn(`%c Missing translation for '${e}'`, 'font-size: 12px; color: red'),
                            e
                        );
                    }
                    static ɵfac = function (i) {
                        return new (i || t)();
                    };
                    static ɵprov = We({ token: t, factory: t.ɵfac });
                }
                return t;
            })();
            const tT = new $e('TRANSLOCO_INTERCEPTOR');
            let J$ = (() => {
                class t {
                    preSaveTranslation(e) {
                        return e;
                    }
                    preSaveTranslationKey(e, i) {
                        return i;
                    }
                    static ɵfac = function (i) {
                        return new (i || t)();
                    };
                    static ɵprov = We({ token: t, factory: t.ɵfac });
                }
                return t;
            })();
            const nT = new $e('TRANSLOCO_FALLBACK_STRATEGY');
            let sg,
                eG = (() => {
                    class t {
                        userConfig;
                        constructor(e) {
                            this.userConfig = e;
                        }
                        getNextLangs() {
                            const e = this.userConfig.fallbackLang;
                            if (!e)
                                throw new Error(
                                    'When using the default fallback, a fallback language must be provided in the config!',
                                );
                            return Array.isArray(e) ? e : [e];
                        }
                        static ɵfac = function (i) {
                            return new (i || t)(Se(J1));
                        };
                        static ɵprov = We({ token: t, factory: t.ɵfac });
                    }
                    return t;
                })();
            function uh(t) {
                if (!t) return '';
                const n = t.split('/');
                return n.pop(), n.join('/');
            }
            function Sc(t) {
                return t ? t.split('/').pop() : '';
            }
            function ng(t, n, e = '|') {
                if (xu(t)) {
                    const i = t.split(e),
                        r = i.pop();
                    return r === n ? [!0, i.toString()] : [!1, r];
                }
                return [!1, ''];
            }
            function ig(t, n) {
                return (function G$(t) {
                    return t && eg(t.loader);
                })(t)
                    ? (function tG(t, n) {
                          return Object.keys(t).reduce((e, i) => ((e[`${n}/${i}`] = t[i]), e), {});
                      })(t.loader, n)
                    : void 0;
            }
            function rg(t) {
                return { scope: uh(t) || null, langName: Sc(t) };
            }
            function sT(t) {
                const { path: n, inlineLoader: e, mainLoader: i, data: r } = t;
                if (e) {
                    if (
                        !1 ===
                        (function j$(t) {
                            return 'function' == typeof t;
                        })(e[n])
                    )
                        throw `You're using an inline loader but didn't provide a loader for ${n}`;
                    return e[n]().then(o => (o.default ? o.default : o));
                }
                return i.getTranslation(n, r);
            }
            let og = (() => {
                class t {
                    loader;
                    parser;
                    missingHandler;
                    interceptor;
                    fallbackStrategy;
                    langChanges$;
                    translations = new Map();
                    cache = new Map();
                    firstFallbackLang;
                    defaultLang = '';
                    availableLangs = [];
                    isResolvedMissingOnce = !1;
                    lang;
                    failedLangs = new Set();
                    events = new vt();
                    events$ = this.events.asObservable();
                    config;
                    constructor(e, i, r, s, o, a) {
                        (this.loader = e),
                            (this.parser = i),
                            (this.missingHandler = r),
                            (this.interceptor = s),
                            (this.fallbackStrategy = a),
                            this.loader || (this.loader = new B$(this.translations)),
                            (sg = this),
                            (this.config = JSON.parse(JSON.stringify(o))),
                            this.setAvailableLangs(this.config.availableLangs || []),
                            this.setFallbackLangForMissingTranslation(this.config),
                            this.setDefaultLang(this.config.defaultLang),
                            (this.lang = new Ke(this.getDefaultLang())),
                            (this.langChanges$ = this.lang.asObservable()),
                            this.events$.pipe(Cf()).subscribe(l => {
                                'translationLoadSuccess' === l.type &&
                                    l.wasFailure &&
                                    this.setActiveLang(l.payload.langName);
                            });
                    }
                    getDefaultLang() {
                        return this.defaultLang;
                    }
                    setDefaultLang(e) {
                        this.defaultLang = e;
                    }
                    getActiveLang() {
                        return this.lang.getValue();
                    }
                    setActiveLang(e) {
                        return (
                            this.parser.onLangChanged?.(e),
                            this.lang.next(e),
                            this.events.next({ type: 'langChanged', payload: rg(e) }),
                            this
                        );
                    }
                    setAvailableLangs(e) {
                        this.availableLangs = e;
                    }
                    getAvailableLangs() {
                        return this.availableLangs;
                    }
                    load(e, i = {}) {
                        const r = this.cache.get(e);
                        if (r) return r;
                        let s;
                        const o = this._isLangScoped(e);
                        let a;
                        o && (a = uh(e));
                        const l = {
                            path: e,
                            mainLoader: this.loader,
                            inlineLoader: i.inlineLoader,
                            data: o ? { scope: a } : void 0,
                        };
                        if (this.useFallbackTranslation(e)) {
                            const f = o ? `${a}/${this.firstFallbackLang}` : this.firstFallbackLang,
                                g = (function nG({
                                    mainLoader: t,
                                    path: n,
                                    data: e,
                                    fallbackPath: i,
                                    inlineLoader: r,
                                }) {
                                    return (i ? [n, i] : [n]).map(o =>
                                        ol(sT({ path: o, mainLoader: t, inlineLoader: r, data: e })).pipe(
                                            Ct(l => ({ translation: l, lang: o })),
                                        ),
                                    );
                                })({ ...l, fallbackPath: f });
                            s = G4(g);
                        } else s = ol(sT(l));
                        const c = s.pipe(
                            (function P$(t = 1 / 0) {
                                let n;
                                n = t && 'object' == typeof t ? t : { count: t };
                                const { count: e = 1 / 0, delay: i, resetOnSuccess: r = !1 } = n;
                                return e <= 0
                                    ? Yn
                                    : mi((s, o) => {
                                          let l,
                                              a = 0;
                                          const c = () => {
                                              let f = !1;
                                              (l = s.subscribe(
                                                  ln(
                                                      o,
                                                      g => {
                                                          r && (a = 0), o.next(g);
                                                      },
                                                      void 0,
                                                      g => {
                                                          if (a++ < e) {
                                                              const E = () => {
                                                                  l ? (l.unsubscribe(), (l = null), c()) : (f = !0);
                                                              };
                                                              if (null != i) {
                                                                  const P = 'number' == typeof i ? Kp(i) : bs(i(g, a)),
                                                                      V = ln(
                                                                          o,
                                                                          () => {
                                                                              V.unsubscribe(), E();
                                                                          },
                                                                          () => {
                                                                              o.complete();
                                                                          },
                                                                      );
                                                                  P.subscribe(V);
                                                              } else E();
                                                          } else o.error(g);
                                                      },
                                                  ),
                                              )),
                                                  f && (l.unsubscribe(), (l = null), c());
                                          };
                                          c();
                                      });
                            })(this.config.failedRetries),
                            Qp(f => {
                                Array.isArray(f)
                                    ? f.forEach(g => {
                                          this.handleSuccess(g.lang, g.translation),
                                              g.lang !== e && this.cache.set(g.lang, Uo({}));
                                      })
                                    : this.handleSuccess(e, f);
                            }),
                            Xp(
                                f => (
                                    this.config.prodMode || console.error(`Error while trying to load "${e}"`, f),
                                    this.handleFailure(e, i)
                                ),
                            ),
                            (function N$(t, n, e) {
                                let i,
                                    r = !1;
                                return (
                                    t && 'object' == typeof t
                                        ? ({
                                              bufferSize: i = 1 / 0,
                                              windowTime: n = 1 / 0,
                                              refCount: r = !1,
                                              scheduler: e,
                                          } = t)
                                        : (i = t ?? 1 / 0),
                                    HS({
                                        connector: () => new yc(i, n, e),
                                        resetOnError: !0,
                                        resetOnComplete: !1,
                                        resetOnRefCountZero: r,
                                    })
                                );
                            })(1),
                        );
                        return this.cache.set(e, c), c;
                    }
                    translate(e, i = {}, r = this.getActiveLang()) {
                        if (!e) return e;
                        const { scope: s, resolveLang: o } = this.resolveLangAndScope(r);
                        if (Array.isArray(e)) return e.map(c => this.translate(s ? `${s}.${c}` : c, i, o));
                        e = s ? `${s}.${e}` : e;
                        const a = this.getTranslation(o),
                            l = a[e];
                        return l
                            ? this.parser.transpile({ value: l, params: i, translation: a, key: e })
                            : this._handleMissingKey(e, l, i);
                    }
                    selectTranslate(e, i, r, s = !1) {
                        let o;
                        const a = (c, f) =>
                            this.load(c, f).pipe(
                                Ct(() => (s ? this.translateObject(e, i, c) : this.translate(e, i, c))),
                            );
                        if (tg(r)) return this.langChanges$.pipe(vu(c => a(c)));
                        if (XS((r = Array.isArray(r) ? r[0] : r))) {
                            const c = r;
                            (r = c.scope), (o = ig(c, c.scope));
                        }
                        if (this.isLang(r) || this.isScopeWithLang(r)) return a(r);
                        const l = r;
                        return this.langChanges$.pipe(vu(c => a(`${l}/${c}`, { inlineLoader: o })));
                    }
                    isScopeWithLang(e) {
                        return this.isLang(Sc(e));
                    }
                    translateObject(e, i = {}, r = this.getActiveLang()) {
                        if (xu(e) || Array.isArray(e)) {
                            const { resolveLang: o, scope: a } = this.resolveLangAndScope(r);
                            if (Array.isArray(e)) return e.map(f => this.translateObject(a ? `${a}.${f}` : f, i, o));
                            const l = this.getTranslation(o),
                                c = (function W$(t) {
                                    return jS(t);
                                })(this.getObjectByKey(l, (e = a ? `${a}.${e}` : e)));
                            return (function Y$(t) {
                                return 0 === GS(t);
                            })(c)
                                ? this.translate(e, i, r)
                                : this.parser.transpile({ value: c, params: i, translation: l, key: e });
                        }
                        const s = [];
                        for (const [o, a] of this.getEntries(e)) s.push(this.translateObject(o, a, r));
                        return s;
                    }
                    selectTranslateObject(e, i, r) {
                        if (xu(e) || Array.isArray(e)) return this.selectTranslate(e, i, r, !0);
                        const [[s, o], ...a] = this.getEntries(e);
                        return this.selectTranslateObject(s, o, r).pipe(
                            Ct(l => {
                                const c = [l];
                                for (const [f, g] of a) c.push(this.translateObject(f, g, r));
                                return c;
                            }),
                        );
                    }
                    getTranslation(e) {
                        if (e) {
                            if (this.isLang(e)) return this.translations.get(e) || {};
                            {
                                const { scope: i, resolveLang: r } = this.resolveLangAndScope(e),
                                    s = this.translations.get(r) || {};
                                return this.getObjectByKey(s, i);
                            }
                        }
                        return this.translations;
                    }
                    selectTranslation(e) {
                        let i = this.langChanges$;
                        if (e) {
                            const r = Sc(e) !== e;
                            i = this.isLang(e) || r ? Uo(e) : this.langChanges$.pipe(Ct(s => `${e}/${s}`));
                        }
                        return i.pipe(vu(r => this.load(r).pipe(Ct(() => this.getTranslation(r)))));
                    }
                    setTranslation(e, i = this.getActiveLang(), r = {}) {
                        const o = { merge: !0, emitChange: !0, ...r },
                            a = uh(i);
                        let l = e;
                        a && (l = ZS({ [this.getMappedScope(a)]: e }));
                        const c = a ? Sc(i) : i,
                            f = { ...(o.merge && this.getTranslation(c)), ...l },
                            g = this.config.flatten.aot ? f : ZS(f),
                            E = this.interceptor.preSaveTranslation(g, c);
                        this.translations.set(c, E), o.emitChange && this.setActiveLang(this.getActiveLang());
                    }
                    setTranslationKey(e, i, r = {}) {
                        const s = r.lang || this.getActiveLang(),
                            o = this.interceptor.preSaveTranslationKey(e, i, s);
                        this.setTranslation({ [e]: o }, s, { ...r, merge: !0 });
                    }
                    setFallbackLangForMissingTranslation({ fallbackLang: e }) {
                        const i = Array.isArray(e) ? e[0] : e;
                        e && this.useFallbackTranslation(i) && (this.firstFallbackLang = i);
                    }
                    _handleMissingKey(e, i, r) {
                        if (this.config.missingHandler.allowEmpty && '' === i) return '';
                        if (!this.isResolvedMissingOnce && this.useFallbackTranslation()) {
                            this.isResolvedMissingOnce = !0;
                            const s = this.translate(e, r, this.firstFallbackLang);
                            return (this.isResolvedMissingOnce = !1), s;
                        }
                        return this.missingHandler.handle(e, this.getMissingHandlerData(), r);
                    }
                    _isLangScoped(e) {
                        return -1 === this.getAvailableLangsIds().indexOf(e);
                    }
                    isLang(e) {
                        return -1 !== this.getAvailableLangsIds().indexOf(e);
                    }
                    _loadDependencies(e, i) {
                        const r = Sc(e);
                        return this._isLangScoped(e) && !this.isLoadedTranslation(r)
                            ? (function F$(...t) {
                                  const n = Gd(t),
                                      e = Rm(t),
                                      { args: i, keys: r } = tM(t);
                                  if (0 === i.length) return ol([], n);
                                  const s = new Tn(
                                      (function R$(t, n, e = Yn) {
                                          return i => {
                                              US(
                                                  n,
                                                  () => {
                                                      const { length: r } = t,
                                                          s = new Array(r);
                                                      let o = r,
                                                          a = r;
                                                      for (let l = 0; l < r; l++)
                                                          US(
                                                              n,
                                                              () => {
                                                                  const c = ol(t[l], n);
                                                                  let f = !1;
                                                                  c.subscribe(
                                                                      ln(
                                                                          i,
                                                                          g => {
                                                                              (s[l] = g),
                                                                                  f || ((f = !0), a--),
                                                                                  a || i.next(e(s.slice()));
                                                                          },
                                                                          () => {
                                                                              --o || i.complete();
                                                                          },
                                                                      ),
                                                                  );
                                                              },
                                                              i,
                                                          );
                                                  },
                                                  i,
                                              );
                                          };
                                      })(i, n, r ? o => nM(r, o) : Yn),
                                  );
                                  return e ? s.pipe(Jm(e)) : s;
                              })([this.load(r), this.load(e, { inlineLoader: i })])
                            : this.load(e, { inlineLoader: i });
                    }
                    _completeScopeWithLang(e) {
                        return this._isLangScoped(e) && !this.isLang(Sc(e)) ? `${e}/${this.getActiveLang()}` : e;
                    }
                    _setScopeAlias(e, i) {
                        this.config.scopeMapping || (this.config.scopeMapping = {}), (this.config.scopeMapping[e] = i);
                    }
                    ngOnDestroy() {
                        this.cache.clear();
                    }
                    isLoadedTranslation(e) {
                        return GS(this.getTranslation(e));
                    }
                    getAvailableLangsIds() {
                        return xu(this.getAvailableLangs()[0])
                            ? this.getAvailableLangs()
                            : this.getAvailableLangs().map(i => i.id);
                    }
                    getMissingHandlerData() {
                        return {
                            ...this.config,
                            activeLang: this.getActiveLang(),
                            availableLangs: this.availableLangs,
                            defaultLang: this.defaultLang,
                        };
                    }
                    useFallbackTranslation(e) {
                        return this.config.missingHandler.useFallbackTranslation && e !== this.firstFallbackLang;
                    }
                    handleSuccess(e, i) {
                        this.setTranslation(i, e, { emitChange: !1 }),
                            this.events.next({
                                wasFailure: !!this.failedLangs.size,
                                type: 'translationLoadSuccess',
                                payload: rg(e),
                            }),
                            this.failedLangs.forEach(r => this.cache.delete(r)),
                            this.failedLangs.clear();
                    }
                    handleFailure(e, i) {
                        tg(i.failedCounter) &&
                            ((i.failedCounter = 0),
                            i.fallbackLangs || (i.fallbackLangs = this.fallbackStrategy.getNextLangs(e)));
                        const r = e.split('/'),
                            o = i.fallbackLangs[i.failedCounter];
                        if ((this.failedLangs.add(e), this.cache.has(o)))
                            return this.handleSuccess(o, this.getTranslation(o)), j4;
                        if (!o || o === r[r.length - 1]) {
                            let c = 'Unable to load translation and all the fallback languages';
                            throw (r.length > 1 && (c += ', did you misspelled the scope name?'), new Error(c));
                        }
                        let l = o;
                        return (
                            r.length > 1 && ((r[r.length - 1] = o), (l = r.join('/'))),
                            i.failedCounter++,
                            this.events.next({ type: 'translationLoadFailure', payload: rg(e) }),
                            this.load(l, i)
                        );
                    }
                    getMappedScope(e) {
                        const { scopeMapping: i = {}, scopes: r = { keepCasing: !1 } } = this.config;
                        return i[e] || (r.keepCasing ? e : WS(e));
                    }
                    resolveLangAndScope(e) {
                        let r,
                            i = e;
                        if (this._isLangScoped(e)) {
                            const s = Sc(e),
                                o = this.isLang(s);
                            (i = o ? s : this.getActiveLang()), (r = this.getMappedScope(o ? uh(e) : e));
                        }
                        return { scope: r, resolveLang: i };
                    }
                    getObjectByKey(e, i) {
                        const r = {},
                            s = `${i}.`;
                        for (const o in e) o.startsWith(s) && (r[o.replace(s, '')] = e[o]);
                        return r;
                    }
                    getEntries(e) {
                        return e instanceof Map ? e.entries() : Object.entries(e);
                    }
                    static ɵfac = function (i) {
                        return new (i || t)(Se($S, 8), Se(JS), Se(eT), Se(tT), Se(J1), Se(nT));
                    };
                    static ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' });
                }
                return t;
            })();
            const ag = new $e('TRANSLOCO_LANG'),
                lg = (new $e('TRANSLOCO_LOADING_TEMPLATE'), new $e('TRANSLOCO_SCOPE'));
            class aT {
                initialized = !1;
                resolve({ inline: n, provider: e, active: i }) {
                    let r = i;
                    if (this.initialized) return (r = i), r;
                    if (e) {
                        const [, s] = ng(e, 'static');
                        r = s;
                    }
                    if (n) {
                        const [, s] = ng(n, 'static');
                        r = s;
                    }
                    return (this.initialized = !0), r;
                }
                resolveLangBasedOnScope(n) {
                    return uh(n) ? Sc(n) : n;
                }
                resolveLangPath(n, e) {
                    return e ? `${e}/${n}` : n;
                }
            }
            class lT {
                service;
                constructor(n) {
                    this.service = n;
                }
                resolve(n) {
                    const { inline: e, provider: i } = n;
                    if (e) return e;
                    if (i) {
                        if (XS(i)) {
                            const { scope: r, alias: s = this.service.config.scopes.keepCasing ? r : WS(r) } = i;
                            return this.service._setScopeAlias(r, s), r;
                        }
                        return i;
                    }
                }
            }
            let $o = (() => {
                class t {
                    service;
                    providerScope;
                    providerLang;
                    cdr;
                    subscription = null;
                    lastValue = '';
                    lastKey;
                    path;
                    langResolver = new aT();
                    scopeResolver;
                    constructor(e, i, r, s) {
                        (this.service = e),
                            (this.providerScope = i),
                            (this.providerLang = r),
                            (this.cdr = s),
                            (this.scopeResolver = new lT(this.service));
                    }
                    transform(e, i, r) {
                        if (!e) return e;
                        const s = i ? `${e}${JSON.stringify(i)}` : e;
                        if (s === this.lastKey) return this.lastValue;
                        (this.lastKey = s), this.subscription?.unsubscribe();
                        const o = (function iT(t, n) {
                            const [e] = ng(n, 'static');
                            return !e && !!t.config.reRenderOnLangChange;
                        })(this.service, this.providerLang || r);
                        return (
                            (this.subscription = this.service.langChanges$
                                .pipe(
                                    vu(a => {
                                        const l = this.langResolver.resolve({
                                            inline: r,
                                            provider: this.providerLang,
                                            active: a,
                                        });
                                        return Array.isArray(this.providerScope)
                                            ? G4(this.providerScope.map(c => this.resolveScope(l, c)))
                                            : this.resolveScope(l, this.providerScope);
                                    }),
                                    (function rT(t) {
                                        return t ? n => n : Z1(1);
                                    })(o),
                                )
                                .subscribe(() => this.updateValue(e, i))),
                            this.lastValue
                        );
                    }
                    ngOnDestroy() {
                        this.subscription?.unsubscribe(), (this.subscription = null);
                    }
                    updateValue(e, i) {
                        const r = this.langResolver.resolveLangBasedOnScope(this.path);
                        (this.lastValue = this.service.translate(e, i, r)), this.cdr.markForCheck();
                    }
                    resolveScope(e, i) {
                        const r = this.scopeResolver.resolve({ inline: void 0, provider: i });
                        this.path = this.langResolver.resolveLangPath(e, r);
                        const s = ig(i, r);
                        return this.service._loadDependencies(this.path, s);
                    }
                    static ɵfac = function (i) {
                        return new (i || t)(te(og, 16), te(lg, 24), te(ag, 24), te(kr, 16));
                    };
                    static ɵpipe = jr({ name: 'transloco', type: t, pure: !1, standalone: !0 });
                }
                return t;
            })();
            function oG(t) {
                const n = [cG(Q$), dG(Z$), hG(J$), uG(eG)];
                return (
                    t.config &&
                        n.push(
                            (function aG(t) {
                                return _s([{ provide: J1, useValue: K$(t) }]);
                            })(t.config),
                        ),
                    t.loader &&
                        n.push(
                            (function lG(t) {
                                return _s([{ provide: $S, useClass: t }]);
                            })(t.loader),
                        ),
                    n
                );
            }
            function cG(t) {
                return _s([{ provide: JS, useClass: t, deps: [J1] }]);
            }
            function uG(t) {
                return _s([{ provide: nT, useClass: t, deps: [J1] }]);
            }
            function dG(t) {
                return _s([{ provide: eT, useClass: t }]);
            }
            function hG(t) {
                return _s([{ provide: tT, useClass: t }]);
            }
            new $e('TRANSLOCO_TEST_LANGS - Available testing languages'),
                new $e('TRANSLOCO_TEST_OPTIONS - Testing options');
            const mG = ['addListener', 'removeListener'],
                pG = ['addEventListener', 'removeEventListener'],
                gG = ['on', 'off'];
            function ca(t, n, e, i) {
                if ((et(e) && ((i = e), (e = void 0)), i)) return ca(t, n, e).pipe(Jm(i));
                const [r, s] = (function yG(t) {
                    return et(t.addEventListener) && et(t.removeEventListener);
                })(t)
                    ? pG.map(o => a => t[o](n, a, e))
                    : (function vG(t) {
                          return et(t.addListener) && et(t.removeListener);
                      })(t)
                    ? mG.map(cT(t, n))
                    : (function _G(t) {
                          return et(t.on) && et(t.off);
                      })(t)
                    ? gG.map(cT(t, n))
                    : [];
                if (!r && qm(t)) return G1(o => ca(o, n, e))(bs(t));
                if (!r) throw new TypeError('Invalid event target');
                return new Tn(o => {
                    const a = (...l) => o.next(1 < l.length ? l : l[0]);
                    return r(a), () => s(a);
                });
            }
            function cT(t, n) {
                return e => i => t[e](n, i);
            }
            function uT(t) {
                return Array.isArray(t) ? t : [t];
            }
            function Hr(t) {
                return null == t ? '' : 'string' == typeof t ? t : `${t}px`;
            }
            function dh(t) {
                return t instanceof Pn ? t.nativeElement : t;
            }
            const ku = (...t) => {};
            function Fi(t) {
                return typeof t < 'u' && null !== t;
            }
            function fT(t) {
                return typeof t > 'u' || null === t;
            }
            function ug(t) {
                return 'string' == typeof t && '' !== t;
            }
            function dg(t) {
                return t instanceof Qr;
            }
            function hg(t) {
                return (function bG(t) {
                    return null != t && 'false' != `${t}`;
                })(t);
            }
            function Eu(t, ...n) {
                return 'function' == typeof t ? t(...n) : t;
            }
            function En() {
                return (function fg(t, n) {
                    return function e(i, r, s) {
                        const o = `$$__zorroPropDecorator__${r}`;
                        return (
                            Object.prototype.hasOwnProperty.call(i, o) &&
                                ku(`The prop "${o}" is already exist, it will be overrided by ${t} decorator.`),
                            Object.defineProperty(i, o, { configurable: !0, writable: !0 }),
                            {
                                get() {
                                    return s && s.get ? s.get.bind(this)() : this[o];
                                },
                                set(a) {
                                    s && s.set && s.set.bind(this)(n(a)), (this[o] = n(a));
                                },
                            }
                        );
                    };
                })('InputBoolean', hg);
            }
            function vT() {
                return !!(typeof window < 'u' && window.document && window.document.createElement);
            }
            typeof window < 'u' && window;
            const NG = 'rc-util-key';
            function _T({ mark: t } = {}) {
                return t ? (t.startsWith('data-') ? t : `data-${t}`) : NG;
            }
            function yg(t) {
                return t.attachTo ? t.attachTo : document.querySelector('head') || document.body;
            }
            function yT(t, n = {}) {
                if (!vT()) return null;
                const e = document.createElement('style');
                n.cspNonce && (e.nonce = n.cspNonce), (e.innerHTML = t);
                const i = yg(n),
                    { firstChild: r } = i;
                return (
                    n.prepend && i.prepend ? i.prepend(e) : n.prepend && r ? i.insertBefore(e, r) : i.appendChild(e), e
                );
            }
            const bg = new Map();
            function CT(t, n, e) {
                return {
                    [`${t}-status-success`]: 'success' === n,
                    [`${t}-status-warning`]: 'warning' === n,
                    [`${t}-status-error`]: 'error' === n,
                    [`${t}-status-validating`]: 'validating' === n,
                    [`${t}-has-feedback`]: e,
                };
            }
            let Cg;
            try {
                Cg = typeof Intl < 'u' && Intl.v8BreakIterator;
            } catch {
                Cg = !1;
            }
            let hh,
                Iu,
                wg,
                Go = (() => {
                    class t {
                        constructor(e) {
                            (this._platformId = e),
                                (this.isBrowser = this._platformId
                                    ? BC(this._platformId)
                                    : 'object' == typeof document && !!document),
                                (this.EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent)),
                                (this.TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent)),
                                (this.BLINK =
                                    this.isBrowser &&
                                    !(!window.chrome && !Cg) &&
                                    typeof CSS < 'u' &&
                                    !this.EDGE &&
                                    !this.TRIDENT),
                                (this.WEBKIT =
                                    this.isBrowser &&
                                    /AppleWebKit/i.test(navigator.userAgent) &&
                                    !this.BLINK &&
                                    !this.EDGE &&
                                    !this.TRIDENT),
                                (this.IOS =
                                    this.isBrowser &&
                                    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                                    !('MSStream' in window)),
                                (this.FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent)),
                                (this.ANDROID =
                                    this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT),
                                (this.SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Za));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })();
            function MT(t) {
                return (function RG() {
                    if (null == hh && typeof window < 'u')
                        try {
                            window.addEventListener(
                                'test',
                                null,
                                Object.defineProperty({}, 'passive', { get: () => (hh = !0) }),
                            );
                        } finally {
                            hh = hh || !1;
                        }
                    return hh;
                })()
                    ? t
                    : !!t.capture;
            }
            function VG() {
                if (null == Iu) {
                    if ('object' != typeof document || !document || 'function' != typeof Element || !Element)
                        return (Iu = !1), Iu;
                    if ('scrollBehavior' in document.documentElement.style) Iu = !0;
                    else {
                        const t = Element.prototype.scrollTo;
                        Iu = !!t && !/\{\s*\[native code\]\s*\}/.test(t.toString());
                    }
                }
                return Iu;
            }
            function Tc(t) {
                return t.composedPath ? t.composedPath()[0] : t.target;
            }
            function ST() {
                return (
                    (typeof __karma__ < 'u' && !!__karma__) ||
                    (typeof jasmine < 'u' && !!jasmine) ||
                    (typeof jest < 'u' && !!jest) ||
                    (typeof Mocha < 'u' && !!Mocha)
                );
            }
            function n0(t, n = Yn) {
                return (
                    (t = t ?? sW),
                    mi((e, i) => {
                        let r,
                            s = !0;
                        e.subscribe(
                            ln(i, o => {
                                const a = n(o);
                                (s || !t(r, a)) && ((s = !1), (r = a), i.next(o));
                            }),
                        );
                    })
                );
            }
            function sW(t, n) {
                return t === n;
            }
            const vW = new $e('cdk-input-modality-detector-options'),
                _W = { ignoreKeys: [18, 17, 224, 91, 16] },
                r0 = MT({ passive: !0, capture: !0 });
            let yW = (() => {
                class t {
                    get mostRecentModality() {
                        return this._modality.value;
                    }
                    constructor(e, i, r, s) {
                        (this._platform = e),
                            (this._mostRecentTarget = null),
                            (this._modality = new Ke(null)),
                            (this._lastTouchMs = 0),
                            (this._onKeydown = o => {
                                this._options?.ignoreKeys?.some(a => a === o.keyCode) ||
                                    (this._modality.next('keyboard'), (this._mostRecentTarget = Tc(o)));
                            }),
                            (this._onMousedown = o => {
                                Date.now() - this._lastTouchMs < 650 ||
                                    (this._modality.next(
                                        (function pW(t) {
                                            return 0 === t.buttons || 0 === t.detail;
                                        })(o)
                                            ? 'keyboard'
                                            : 'mouse',
                                    ),
                                    (this._mostRecentTarget = Tc(o)));
                            }),
                            (this._onTouchstart = o => {
                                !(function gW(t) {
                                    const n = (t.touches && t.touches[0]) || (t.changedTouches && t.changedTouches[0]);
                                    return !(
                                        !n ||
                                        -1 !== n.identifier ||
                                        (null != n.radiusX && 1 !== n.radiusX) ||
                                        (null != n.radiusY && 1 !== n.radiusY)
                                    );
                                })(o)
                                    ? ((this._lastTouchMs = Date.now()),
                                      this._modality.next('touch'),
                                      (this._mostRecentTarget = Tc(o)))
                                    : this._modality.next('keyboard');
                            }),
                            (this._options = { ..._W, ...s }),
                            (this.modalityDetected = this._modality.pipe(
                                (function rW(t) {
                                    return al((n, e) => t <= e);
                                })(1),
                            )),
                            (this.modalityChanged = this.modalityDetected.pipe(n0())),
                            e.isBrowser &&
                                i.runOutsideAngular(() => {
                                    r.addEventListener('keydown', this._onKeydown, r0),
                                        r.addEventListener('mousedown', this._onMousedown, r0),
                                        r.addEventListener('touchstart', this._onTouchstart, r0);
                                });
                    }
                    ngOnDestroy() {
                        this._modality.complete(),
                            this._platform.isBrowser &&
                                (document.removeEventListener('keydown', this._onKeydown, r0),
                                document.removeEventListener('mousedown', this._onMousedown, r0),
                                document.removeEventListener('touchstart', this._onTouchstart, r0));
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(Go), Se(en), Se(Ni), Se(vW, 8));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            var Sf = (function (t) {
                return (t[(t.IMMEDIATE = 0)] = 'IMMEDIATE'), (t[(t.EVENTUAL = 1)] = 'EVENTUAL'), t;
            })(Sf || {});
            const CW = new $e('cdk-focus-monitor-default-options'),
                Tf = MT({ passive: !0, capture: !0 });
            let Df = (() => {
                class t {
                    constructor(e, i, r, s, o) {
                        (this._ngZone = e),
                            (this._platform = i),
                            (this._inputModalityDetector = r),
                            (this._origin = null),
                            (this._windowFocused = !1),
                            (this._originFromTouchInteraction = !1),
                            (this._elementInfo = new Map()),
                            (this._monitoredElementCount = 0),
                            (this._rootNodeFocusListenerCount = new Map()),
                            (this._windowFocusListener = () => {
                                (this._windowFocused = !0),
                                    (this._windowFocusTimeoutId = window.setTimeout(() => (this._windowFocused = !1)));
                            }),
                            (this._stopInputModalityDetector = new vt()),
                            (this._rootNodeFocusAndBlurListener = a => {
                                for (let c = Tc(a); c; c = c.parentElement)
                                    'focus' === a.type ? this._onFocus(a, c) : this._onBlur(a, c);
                            }),
                            (this._document = s),
                            (this._detectionMode = o?.detectionMode || Sf.IMMEDIATE);
                    }
                    monitor(e, i = !1) {
                        const r = dh(e);
                        if (!this._platform.isBrowser || 1 !== r.nodeType) return Uo();
                        const s =
                                (function UG(t) {
                                    if (
                                        (function HG() {
                                            if (null == wg) {
                                                const t = typeof document < 'u' ? document.head : null;
                                                wg = !(!t || (!t.createShadowRoot && !t.attachShadow));
                                            }
                                            return wg;
                                        })()
                                    ) {
                                        const n = t.getRootNode ? t.getRootNode() : null;
                                        if (typeof ShadowRoot < 'u' && ShadowRoot && n instanceof ShadowRoot) return n;
                                    }
                                    return null;
                                })(r) || this._getDocument(),
                            o = this._elementInfo.get(r);
                        if (o) return i && (o.checkChildren = !0), o.subject;
                        const a = { checkChildren: i, subject: new vt(), rootNode: s };
                        return this._elementInfo.set(r, a), this._registerGlobalListeners(a), a.subject;
                    }
                    stopMonitoring(e) {
                        const i = dh(e),
                            r = this._elementInfo.get(i);
                        r &&
                            (r.subject.complete(),
                            this._setClasses(i),
                            this._elementInfo.delete(i),
                            this._removeGlobalListeners(r));
                    }
                    focusVia(e, i, r) {
                        const s = dh(e);
                        s === this._getDocument().activeElement
                            ? this._getClosestElementsInfo(s).forEach(([a, l]) => this._originChanged(a, i, l))
                            : (this._setOrigin(i), 'function' == typeof s.focus && s.focus(r));
                    }
                    ngOnDestroy() {
                        this._elementInfo.forEach((e, i) => this.stopMonitoring(i));
                    }
                    _getDocument() {
                        return this._document || document;
                    }
                    _getWindow() {
                        return this._getDocument().defaultView || window;
                    }
                    _getFocusOrigin(e) {
                        return this._origin
                            ? this._originFromTouchInteraction
                                ? this._shouldBeAttributedToTouch(e)
                                    ? 'touch'
                                    : 'program'
                                : this._origin
                            : this._windowFocused && this._lastFocusOrigin
                            ? this._lastFocusOrigin
                            : e && this._isLastInteractionFromInputLabel(e)
                            ? 'mouse'
                            : 'program';
                    }
                    _shouldBeAttributedToTouch(e) {
                        return (
                            this._detectionMode === Sf.EVENTUAL ||
                            !!e?.contains(this._inputModalityDetector._mostRecentTarget)
                        );
                    }
                    _setClasses(e, i) {
                        e.classList.toggle('cdk-focused', !!i),
                            e.classList.toggle('cdk-touch-focused', 'touch' === i),
                            e.classList.toggle('cdk-keyboard-focused', 'keyboard' === i),
                            e.classList.toggle('cdk-mouse-focused', 'mouse' === i),
                            e.classList.toggle('cdk-program-focused', 'program' === i);
                    }
                    _setOrigin(e, i = !1) {
                        this._ngZone.runOutsideAngular(() => {
                            (this._origin = e),
                                (this._originFromTouchInteraction = 'touch' === e && i),
                                this._detectionMode === Sf.IMMEDIATE &&
                                    (clearTimeout(this._originTimeoutId),
                                    (this._originTimeoutId = setTimeout(
                                        () => (this._origin = null),
                                        this._originFromTouchInteraction ? 650 : 1,
                                    )));
                        });
                    }
                    _onFocus(e, i) {
                        const r = this._elementInfo.get(i),
                            s = Tc(e);
                        !r || (!r.checkChildren && i !== s) || this._originChanged(i, this._getFocusOrigin(s), r);
                    }
                    _onBlur(e, i) {
                        const r = this._elementInfo.get(i);
                        !r ||
                            (r.checkChildren && e.relatedTarget instanceof Node && i.contains(e.relatedTarget)) ||
                            (this._setClasses(i), this._emitOrigin(r, null));
                    }
                    _emitOrigin(e, i) {
                        e.subject.observers.length && this._ngZone.run(() => e.subject.next(i));
                    }
                    _registerGlobalListeners(e) {
                        if (!this._platform.isBrowser) return;
                        const i = e.rootNode,
                            r = this._rootNodeFocusListenerCount.get(i) || 0;
                        r ||
                            this._ngZone.runOutsideAngular(() => {
                                i.addEventListener('focus', this._rootNodeFocusAndBlurListener, Tf),
                                    i.addEventListener('blur', this._rootNodeFocusAndBlurListener, Tf);
                            }),
                            this._rootNodeFocusListenerCount.set(i, r + 1),
                            1 == ++this._monitoredElementCount &&
                                (this._ngZone.runOutsideAngular(() => {
                                    this._getWindow().addEventListener('focus', this._windowFocusListener);
                                }),
                                this._inputModalityDetector.modalityDetected
                                    .pipe(nn(this._stopInputModalityDetector))
                                    .subscribe(s => {
                                        this._setOrigin(s, !0);
                                    }));
                    }
                    _removeGlobalListeners(e) {
                        const i = e.rootNode;
                        if (this._rootNodeFocusListenerCount.has(i)) {
                            const r = this._rootNodeFocusListenerCount.get(i);
                            r > 1
                                ? this._rootNodeFocusListenerCount.set(i, r - 1)
                                : (i.removeEventListener('focus', this._rootNodeFocusAndBlurListener, Tf),
                                  i.removeEventListener('blur', this._rootNodeFocusAndBlurListener, Tf),
                                  this._rootNodeFocusListenerCount.delete(i));
                        }
                        --this._monitoredElementCount ||
                            (this._getWindow().removeEventListener('focus', this._windowFocusListener),
                            this._stopInputModalityDetector.next(),
                            clearTimeout(this._windowFocusTimeoutId),
                            clearTimeout(this._originTimeoutId));
                    }
                    _originChanged(e, i, r) {
                        this._setClasses(e, i), this._emitOrigin(r, i), (this._lastFocusOrigin = i);
                    }
                    _getClosestElementsInfo(e) {
                        const i = [];
                        return (
                            this._elementInfo.forEach((r, s) => {
                                (s === e || (r.checkChildren && s.contains(e))) && i.push([s, r]);
                            }),
                            i
                        );
                    }
                    _isLastInteractionFromInputLabel(e) {
                        const { _mostRecentTarget: i, mostRecentModality: r } = this._inputModalityDetector;
                        if (
                            'mouse' !== r ||
                            !i ||
                            i === e ||
                            ('INPUT' !== e.nodeName && 'TEXTAREA' !== e.nodeName) ||
                            e.disabled
                        )
                            return !1;
                        const s = e.labels;
                        if (s) for (let o = 0; o < s.length; o++) if (s[o].contains(i)) return !0;
                        return !1;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(en), Se(Go), Se(yW), Se(Ni, 8), Se(CW, 8));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            const MW = new $e('cdk-dir-doc', {
                    providedIn: 'root',
                    factory: function SW() {
                        return Ue(Ni);
                    },
                }),
                TW =
                    /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
            let yo = (() => {
                    class t {
                        constructor(e) {
                            (this.value = 'ltr'),
                                (this.change = new Ft()),
                                e &&
                                    (this.value = (function DW(t) {
                                        const n = t?.toLowerCase() || '';
                                        return 'auto' === n && typeof navigator < 'u' && navigator?.language
                                            ? TW.test(navigator.language)
                                                ? 'rtl'
                                                : 'ltr'
                                            : 'rtl' === n
                                            ? 'rtl'
                                            : 'ltr';
                                    })(
                                        (e.body ? e.body.dir : null) ||
                                            (e.documentElement ? e.documentElement.dir : null) ||
                                            'ltr',
                                    ));
                        }
                        ngOnDestroy() {
                            this.change.complete();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(MW, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                Tg = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })();
            function Cs(t, n) {
                (function xW(t) {
                    return 'string' == typeof t && -1 !== t.indexOf('.') && 1 === parseFloat(t);
                })(t) && (t = '100%');
                var e = (function kW(t) {
                    return 'string' == typeof t && -1 !== t.indexOf('%');
                })(t);
                return (
                    (t = 360 === n ? t : Math.min(n, Math.max(0, parseFloat(t)))),
                    e && (t = parseInt(String(t * n), 10) / 100),
                    Math.abs(t - n) < 1e-6
                        ? 1
                        : (t =
                              360 === n
                                  ? (t < 0 ? (t % n) + n : t % n) / parseFloat(String(n))
                                  : (t % n) / parseFloat(String(n)))
                );
            }
            function xf(t) {
                return Math.min(1, Math.max(0, t));
            }
            function zT(t) {
                return (t = parseFloat(t)), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
            }
            function kf(t) {
                return t <= 1 ? ''.concat(100 * Number(t), '%') : t;
            }
            function Au(t) {
                return 1 === t.length ? '0' + t : String(t);
            }
            function PT(t, n, e) {
                (t = Cs(t, 255)), (n = Cs(n, 255)), (e = Cs(e, 255));
                var i = Math.max(t, n, e),
                    r = Math.min(t, n, e),
                    s = 0,
                    o = 0,
                    a = (i + r) / 2;
                if (i === r) (o = 0), (s = 0);
                else {
                    var l = i - r;
                    switch (((o = a > 0.5 ? l / (2 - i - r) : l / (i + r)), i)) {
                        case t:
                            s = (n - e) / l + (n < e ? 6 : 0);
                            break;
                        case n:
                            s = (e - t) / l + 2;
                            break;
                        case e:
                            s = (t - n) / l + 4;
                    }
                    s /= 6;
                }
                return { h: s, s: o, l: a };
            }
            function Dg(t, n, e) {
                return (
                    e < 0 && (e += 1),
                    e > 1 && (e -= 1),
                    e < 1 / 6 ? t + 6 * e * (n - t) : e < 0.5 ? n : e < 2 / 3 ? t + (n - t) * (2 / 3 - e) * 6 : t
                );
            }
            function Ef(t, n, e) {
                (t = Cs(t, 255)), (n = Cs(n, 255)), (e = Cs(e, 255));
                var i = Math.max(t, n, e),
                    r = Math.min(t, n, e),
                    s = 0,
                    o = i,
                    a = i - r,
                    l = 0 === i ? 0 : a / i;
                if (i === r) s = 0;
                else {
                    switch (i) {
                        case t:
                            s = (n - e) / a + (n < e ? 6 : 0);
                            break;
                        case n:
                            s = (e - t) / a + 2;
                            break;
                        case e:
                            s = (t - n) / a + 4;
                    }
                    s /= 6;
                }
                return { h: s, s: l, v: o };
            }
            function If(t, n, e, i) {
                var r = [
                    Au(Math.round(t).toString(16)),
                    Au(Math.round(n).toString(16)),
                    Au(Math.round(e).toString(16)),
                ];
                return i &&
                    r[0].startsWith(r[0].charAt(1)) &&
                    r[1].startsWith(r[1].charAt(1)) &&
                    r[2].startsWith(r[2].charAt(1))
                    ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0)
                    : r.join('');
            }
            function NT(t) {
                return Math.round(255 * parseFloat(t)).toString(16);
            }
            function FT(t) {
                return Wo(t) / 255;
            }
            function Wo(t) {
                return parseInt(t, 16);
            }
            var xg = {
                aliceblue: '#f0f8ff',
                antiquewhite: '#faebd7',
                aqua: '#00ffff',
                aquamarine: '#7fffd4',
                azure: '#f0ffff',
                beige: '#f5f5dc',
                bisque: '#ffe4c4',
                black: '#000000',
                blanchedalmond: '#ffebcd',
                blue: '#0000ff',
                blueviolet: '#8a2be2',
                brown: '#a52a2a',
                burlywood: '#deb887',
                cadetblue: '#5f9ea0',
                chartreuse: '#7fff00',
                chocolate: '#d2691e',
                coral: '#ff7f50',
                cornflowerblue: '#6495ed',
                cornsilk: '#fff8dc',
                crimson: '#dc143c',
                cyan: '#00ffff',
                darkblue: '#00008b',
                darkcyan: '#008b8b',
                darkgoldenrod: '#b8860b',
                darkgray: '#a9a9a9',
                darkgreen: '#006400',
                darkgrey: '#a9a9a9',
                darkkhaki: '#bdb76b',
                darkmagenta: '#8b008b',
                darkolivegreen: '#556b2f',
                darkorange: '#ff8c00',
                darkorchid: '#9932cc',
                darkred: '#8b0000',
                darksalmon: '#e9967a',
                darkseagreen: '#8fbc8f',
                darkslateblue: '#483d8b',
                darkslategray: '#2f4f4f',
                darkslategrey: '#2f4f4f',
                darkturquoise: '#00ced1',
                darkviolet: '#9400d3',
                deeppink: '#ff1493',
                deepskyblue: '#00bfff',
                dimgray: '#696969',
                dimgrey: '#696969',
                dodgerblue: '#1e90ff',
                firebrick: '#b22222',
                floralwhite: '#fffaf0',
                forestgreen: '#228b22',
                fuchsia: '#ff00ff',
                gainsboro: '#dcdcdc',
                ghostwhite: '#f8f8ff',
                goldenrod: '#daa520',
                gold: '#ffd700',
                gray: '#808080',
                green: '#008000',
                greenyellow: '#adff2f',
                grey: '#808080',
                honeydew: '#f0fff0',
                hotpink: '#ff69b4',
                indianred: '#cd5c5c',
                indigo: '#4b0082',
                ivory: '#fffff0',
                khaki: '#f0e68c',
                lavenderblush: '#fff0f5',
                lavender: '#e6e6fa',
                lawngreen: '#7cfc00',
                lemonchiffon: '#fffacd',
                lightblue: '#add8e6',
                lightcoral: '#f08080',
                lightcyan: '#e0ffff',
                lightgoldenrodyellow: '#fafad2',
                lightgray: '#d3d3d3',
                lightgreen: '#90ee90',
                lightgrey: '#d3d3d3',
                lightpink: '#ffb6c1',
                lightsalmon: '#ffa07a',
                lightseagreen: '#20b2aa',
                lightskyblue: '#87cefa',
                lightslategray: '#778899',
                lightslategrey: '#778899',
                lightsteelblue: '#b0c4de',
                lightyellow: '#ffffe0',
                lime: '#00ff00',
                limegreen: '#32cd32',
                linen: '#faf0e6',
                magenta: '#ff00ff',
                maroon: '#800000',
                mediumaquamarine: '#66cdaa',
                mediumblue: '#0000cd',
                mediumorchid: '#ba55d3',
                mediumpurple: '#9370db',
                mediumseagreen: '#3cb371',
                mediumslateblue: '#7b68ee',
                mediumspringgreen: '#00fa9a',
                mediumturquoise: '#48d1cc',
                mediumvioletred: '#c71585',
                midnightblue: '#191970',
                mintcream: '#f5fffa',
                mistyrose: '#ffe4e1',
                moccasin: '#ffe4b5',
                navajowhite: '#ffdead',
                navy: '#000080',
                oldlace: '#fdf5e6',
                olive: '#808000',
                olivedrab: '#6b8e23',
                orange: '#ffa500',
                orangered: '#ff4500',
                orchid: '#da70d6',
                palegoldenrod: '#eee8aa',
                palegreen: '#98fb98',
                paleturquoise: '#afeeee',
                palevioletred: '#db7093',
                papayawhip: '#ffefd5',
                peachpuff: '#ffdab9',
                peru: '#cd853f',
                pink: '#ffc0cb',
                plum: '#dda0dd',
                powderblue: '#b0e0e6',
                purple: '#800080',
                rebeccapurple: '#663399',
                red: '#ff0000',
                rosybrown: '#bc8f8f',
                royalblue: '#4169e1',
                saddlebrown: '#8b4513',
                salmon: '#fa8072',
                sandybrown: '#f4a460',
                seagreen: '#2e8b57',
                seashell: '#fff5ee',
                sienna: '#a0522d',
                silver: '#c0c0c0',
                skyblue: '#87ceeb',
                slateblue: '#6a5acd',
                slategray: '#708090',
                slategrey: '#708090',
                snow: '#fffafa',
                springgreen: '#00ff7f',
                steelblue: '#4682b4',
                tan: '#d2b48c',
                teal: '#008080',
                thistle: '#d8bfd8',
                tomato: '#ff6347',
                turquoise: '#40e0d0',
                violet: '#ee82ee',
                wheat: '#f5deb3',
                white: '#ffffff',
                whitesmoke: '#f5f5f5',
                yellow: '#ffff00',
                yellowgreen: '#9acd32',
            };
            function Ea(t) {
                var n = { r: 0, g: 0, b: 0 },
                    e = 1,
                    i = null,
                    r = null,
                    s = null,
                    o = !1,
                    a = !1;
                return (
                    'string' == typeof t &&
                        (t = (function NW(t) {
                            if (0 === (t = t.trim().toLowerCase()).length) return !1;
                            var n = !1;
                            if (xg[t]) (t = xg[t]), (n = !0);
                            else if ('transparent' === t) return { r: 0, g: 0, b: 0, a: 0, format: 'name' };
                            var e = Ia.rgb.exec(t);
                            return e
                                ? { r: e[1], g: e[2], b: e[3] }
                                : (e = Ia.rgba.exec(t))
                                ? { r: e[1], g: e[2], b: e[3], a: e[4] }
                                : (e = Ia.hsl.exec(t))
                                ? { h: e[1], s: e[2], l: e[3] }
                                : (e = Ia.hsla.exec(t))
                                ? { h: e[1], s: e[2], l: e[3], a: e[4] }
                                : (e = Ia.hsv.exec(t))
                                ? { h: e[1], s: e[2], v: e[3] }
                                : (e = Ia.hsva.exec(t))
                                ? { h: e[1], s: e[2], v: e[3], a: e[4] }
                                : (e = Ia.hex8.exec(t))
                                ? { r: Wo(e[1]), g: Wo(e[2]), b: Wo(e[3]), a: FT(e[4]), format: n ? 'name' : 'hex8' }
                                : (e = Ia.hex6.exec(t))
                                ? { r: Wo(e[1]), g: Wo(e[2]), b: Wo(e[3]), format: n ? 'name' : 'hex' }
                                : (e = Ia.hex4.exec(t))
                                ? {
                                      r: Wo(e[1] + e[1]),
                                      g: Wo(e[2] + e[2]),
                                      b: Wo(e[3] + e[3]),
                                      a: FT(e[4] + e[4]),
                                      format: n ? 'name' : 'hex8',
                                  }
                                : !!(e = Ia.hex3.exec(t)) && {
                                      r: Wo(e[1] + e[1]),
                                      g: Wo(e[2] + e[2]),
                                      b: Wo(e[3] + e[3]),
                                      format: n ? 'name' : 'hex',
                                  };
                        })(t)),
                    'object' == typeof t &&
                        (Pl(t.r) && Pl(t.g) && Pl(t.b)
                            ? ((n = (function EW(t, n, e) {
                                  return { r: 255 * Cs(t, 255), g: 255 * Cs(n, 255), b: 255 * Cs(e, 255) };
                              })(t.r, t.g, t.b)),
                              (o = !0),
                              (a = '%' === String(t.r).substr(-1) ? 'prgb' : 'rgb'))
                            : Pl(t.h) && Pl(t.s) && Pl(t.v)
                            ? ((i = kf(t.s)),
                              (r = kf(t.v)),
                              (n = (function AW(t, n, e) {
                                  (t = 6 * Cs(t, 360)), (n = Cs(n, 100)), (e = Cs(e, 100));
                                  var i = Math.floor(t),
                                      r = t - i,
                                      s = e * (1 - n),
                                      o = e * (1 - r * n),
                                      a = e * (1 - (1 - r) * n),
                                      l = i % 6;
                                  return {
                                      r: 255 * [e, o, s, s, a, e][l],
                                      g: 255 * [a, e, e, o, s, s][l],
                                      b: 255 * [s, s, a, e, e, o][l],
                                  };
                              })(t.h, i, r)),
                              (o = !0),
                              (a = 'hsv'))
                            : Pl(t.h) &&
                              Pl(t.s) &&
                              Pl(t.l) &&
                              ((i = kf(t.s)),
                              (s = kf(t.l)),
                              (n = (function IW(t, n, e) {
                                  var i, r, s;
                                  if (((t = Cs(t, 360)), (n = Cs(n, 100)), (e = Cs(e, 100)), 0 === n))
                                      (r = e), (s = e), (i = e);
                                  else {
                                      var o = e < 0.5 ? e * (1 + n) : e + n - e * n,
                                          a = 2 * e - o;
                                      (i = Dg(a, o, t + 1 / 3)), (r = Dg(a, o, t)), (s = Dg(a, o, t - 1 / 3));
                                  }
                                  return { r: 255 * i, g: 255 * r, b: 255 * s };
                              })(t.h, i, s)),
                              (o = !0),
                              (a = 'hsl')),
                        Object.prototype.hasOwnProperty.call(t, 'a') && (e = t.a)),
                    (e = zT(e)),
                    {
                        ok: o,
                        format: t.format || a,
                        r: Math.min(255, Math.max(n.r, 0)),
                        g: Math.min(255, Math.max(n.g, 0)),
                        b: Math.min(255, Math.max(n.b, 0)),
                        a: e,
                    }
                );
            }
            var Dc = '(?:'.concat('[-\\+]?\\d*\\.\\d+%?', ')|(?:').concat('[-\\+]?\\d+%?', ')'),
                kg = '[\\s|\\(]+('.concat(Dc, ')[,|\\s]+(').concat(Dc, ')[,|\\s]+(').concat(Dc, ')\\s*\\)?'),
                Eg = '[\\s|\\(]+('
                    .concat(Dc, ')[,|\\s]+(')
                    .concat(Dc, ')[,|\\s]+(')
                    .concat(Dc, ')[,|\\s]+(')
                    .concat(Dc, ')\\s*\\)?'),
                Ia = {
                    CSS_UNIT: new RegExp(Dc),
                    rgb: new RegExp('rgb' + kg),
                    rgba: new RegExp('rgba' + Eg),
                    hsl: new RegExp('hsl' + kg),
                    hsla: new RegExp('hsla' + Eg),
                    hsv: new RegExp('hsv' + kg),
                    hsva: new RegExp('hsva' + Eg),
                    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                };
            function Pl(t) {
                return !!Ia.CSS_UNIT.exec(String(t));
            }
            var Af = 2,
                RT = 0.16,
                FW = 0.05,
                RW = 0.05,
                VW = 0.15,
                VT = 5,
                HT = 4,
                HW = [
                    { index: 7, opacity: 0.15 },
                    { index: 6, opacity: 0.25 },
                    { index: 5, opacity: 0.3 },
                    { index: 5, opacity: 0.45 },
                    { index: 5, opacity: 0.65 },
                    { index: 5, opacity: 0.85 },
                    { index: 4, opacity: 0.9 },
                    { index: 3, opacity: 0.95 },
                    { index: 2, opacity: 0.97 },
                    { index: 1, opacity: 0.98 },
                ];
            function UT(t) {
                var r = Ef(t.r, t.g, t.b);
                return { h: 360 * r.h, s: r.s, v: r.v };
            }
            function Lf(t) {
                return '#'.concat(If(t.r, t.g, t.b, !1));
            }
            function BT(t, n, e) {
                var i;
                return (
                    (i =
                        Math.round(t.h) >= 60 && Math.round(t.h) <= 240
                            ? e
                                ? Math.round(t.h) - Af * n
                                : Math.round(t.h) + Af * n
                            : e
                            ? Math.round(t.h) + Af * n
                            : Math.round(t.h) - Af * n) < 0
                        ? (i += 360)
                        : i >= 360 && (i -= 360),
                    i
                );
            }
            function qT(t, n, e) {
                return 0 === t.h && 0 === t.s
                    ? t.s
                    : ((i = e ? t.s - RT * n : n === HT ? t.s + RT : t.s + FW * n) > 1 && (i = 1),
                      e && n === VT && i > 0.1 && (i = 0.1),
                      i < 0.06 && (i = 0.06),
                      Number(i.toFixed(2)));
                var i;
            }
            function YT(t, n, e) {
                var i;
                return (i = e ? t.v + RW * n : t.v - VW * n) > 1 && (i = 1), Number(i.toFixed(2));
            }
            function Ig(t) {
                for (
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        e = [],
                        i = Ea(t),
                        r = VT;
                    r > 0;
                    r -= 1
                ) {
                    var s = UT(i),
                        o = Lf(Ea({ h: BT(s, r, !0), s: qT(s, r, !0), v: YT(s, r, !0) }));
                    e.push(o);
                }
                e.push(Lf(i));
                for (var a = 1; a <= HT; a += 1) {
                    var l = UT(i),
                        c = Lf(Ea({ h: BT(l, a), s: qT(l, a), v: YT(l, a) }));
                    e.push(c);
                }
                return 'dark' === n.theme
                    ? HW.map(function (f) {
                          var g = f.index,
                              E = f.opacity,
                              P = Lf(
                                  (function UW(t, n, e) {
                                      var i = e / 100;
                                      return {
                                          r: (n.r - t.r) * i + t.r,
                                          g: (n.g - t.g) * i + t.g,
                                          b: (n.b - t.b) * i + t.b,
                                      };
                                  })(Ea(n.backgroundColor || '#141414'), Ea(e[g]), 100 * E),
                              );
                          return P;
                      })
                    : e;
            }
            var Ag = {
                    red: '#F5222D',
                    volcano: '#FA541C',
                    orange: '#FA8C16',
                    gold: '#FAAD14',
                    yellow: '#FADB14',
                    lime: '#A0D911',
                    green: '#52C41A',
                    cyan: '#13C2C2',
                    blue: '#1677FF',
                    geekblue: '#2F54EB',
                    purple: '#722ED1',
                    magenta: '#EB2F96',
                    grey: '#666666',
                },
                ws = {},
                Lg = {};
            Object.keys(Ag).forEach(function (t) {
                (ws[t] = Ig(Ag[t])),
                    (ws[t].primary = ws[t][5]),
                    (Lg[t] = Ig(Ag[t], { theme: 'dark', backgroundColor: '#141414' })),
                    (Lg[t].primary = Lg[t][5]);
            });
            const Nl = '[@ant-design/icons-angular]:';
            function $T(t) {
                return Ig(t)[0];
            }
            function Of(t, n) {
                switch (n) {
                    case 'fill':
                        return `${t}-fill`;
                    case 'outline':
                        return `${t}-o`;
                    case 'twotone':
                        return `${t}-twotone`;
                    case void 0:
                        return t;
                    default:
                        throw new Error(`${Nl}Theme "${n}" is not a recognized theme!`);
                }
            }
            function GT(t) {
                return (
                    'object' == typeof t &&
                    'string' == typeof t.name &&
                    ('string' == typeof t.theme || void 0 === t.theme) &&
                    'string' == typeof t.icon
                );
            }
            function zf(t) {
                const n = t.split(':');
                switch (n.length) {
                    case 1:
                        return [t, ''];
                    case 2:
                        return [n[1], n[0]];
                    default:
                        throw new Error(`${Nl}The icon type ${t} is not valid!`);
                }
            }
            function WT(t) {
                return new Error(`${Nl}the icon ${t} does not exist or is not registered.`);
            }
            function JW() {
                return new Error(`${Nl}<svg> tag not found.`);
            }
            const nK = new $e('ant_icons');
            let KT = (() => {
                    class t {
                        set twoToneColor({ primaryColor: e, secondaryColor: i }) {
                            (this._twoToneColorPalette.primaryColor = e),
                                (this._twoToneColorPalette.secondaryColor = i || $T(e));
                        }
                        get twoToneColor() {
                            return { ...this._twoToneColorPalette };
                        }
                        get _disableDynamicLoading() {
                            return !1;
                        }
                        constructor(e, i, r, s, o) {
                            (this._rendererFactory = e),
                                (this._handler = i),
                                (this._document = r),
                                (this.sanitizer = s),
                                (this._antIcons = o),
                                (this.defaultTheme = 'outline'),
                                (this._svgDefinitions = new Map()),
                                (this._svgRenderedDefinitions = new Map()),
                                (this._inProgressFetches = new Map()),
                                (this._assetsUrlRoot = ''),
                                (this._twoToneColorPalette = { primaryColor: '#333333', secondaryColor: '#E6E6E6' }),
                                (this._enableJsonpLoading = !1),
                                (this._jsonpIconLoad$ = new vt()),
                                (this._renderer = this._rendererFactory.createRenderer(null, null)),
                                this._handler && (this._http = new $m(this._handler)),
                                this._antIcons && this.addIcon(...this._antIcons);
                        }
                        useJsonpLoading() {
                            this._enableJsonpLoading ||
                                ((this._enableJsonpLoading = !0),
                                (window.__ant_icon_load = e => {
                                    this._jsonpIconLoad$.next(e);
                                }));
                        }
                        changeAssetsSource(e) {
                            this._assetsUrlRoot = e.endsWith('/') ? e : e + '/';
                        }
                        addIcon(...e) {
                            e.forEach(i => {
                                this._svgDefinitions.set(Of(i.name, i.theme), i);
                            });
                        }
                        addIconLiteral(e, i) {
                            const [r, s] = zf(e);
                            if (!s)
                                throw (function QW() {
                                    return new Error(`${Nl}Type should have a namespace. Try "namespace:${name}".`);
                                })();
                            this.addIcon({ name: e, icon: i });
                        }
                        clear() {
                            this._svgDefinitions.clear(), this._svgRenderedDefinitions.clear();
                        }
                        getRenderedContent(e, i) {
                            const r = GT(e) ? e : this._svgDefinitions.get(e) || null;
                            if (!r && this._disableDynamicLoading) throw WT(e);
                            return (r ? Uo(r) : this._loadIconDynamically(e)).pipe(
                                Ct(o => {
                                    if (!o) throw WT(e);
                                    return this._loadSVGFromCacheOrCreateNew(o, i);
                                }),
                            );
                        }
                        getCachedIcons() {
                            return this._svgDefinitions;
                        }
                        _loadIconDynamically(e) {
                            if (!this._http && !this._enableJsonpLoading)
                                return Uo(
                                    (function XW() {
                                        return (
                                            (function BW(t) {
                                                console.error(`${Nl} ${t}.`);
                                            })('you need to import "HttpClientModule" to use dynamic importing.'),
                                            null
                                        );
                                    })(),
                                );
                            let i = this._inProgressFetches.get(e);
                            if (!i) {
                                const [r, s] = zf(e),
                                    o = s
                                        ? { name: e, icon: '' }
                                        : (function $W(t) {
                                              const n = t.split('-'),
                                                  e = (function YW(t) {
                                                      return 'o' === t ? 'outline' : t;
                                                  })(n.splice(n.length - 1, 1)[0]);
                                              return { name: n.join('-'), theme: e, icon: '' };
                                          })(r),
                                    l =
                                        (s
                                            ? `${this._assetsUrlRoot}assets/${s}/${r}`
                                            : `${this._assetsUrlRoot}assets/${o.theme}/${o.name}`) +
                                        (this._enableJsonpLoading ? '.js' : '.svg'),
                                    c = this.sanitizer.sanitize(Po.URL, l);
                                if (!c)
                                    throw (function ZW(t) {
                                        return new Error(`${Nl}The url "${t}" is unsafe.`);
                                    })(l);
                                (i = (
                                    this._enableJsonpLoading
                                        ? this._loadIconDynamicallyWithJsonp(o, c)
                                        : this._http.get(c, { responseType: 'text' }).pipe(Ct(g => ({ ...o, icon: g })))
                                ).pipe(
                                    Qp(g => this.addIcon(g)),
                                    H4(() => this._inProgressFetches.delete(e)),
                                    Xp(() => Uo(null)),
                                    HS(),
                                )),
                                    this._inProgressFetches.set(e, i);
                            }
                            return i;
                        }
                        _loadIconDynamicallyWithJsonp(e, i) {
                            return new Tn(r => {
                                const s = this._document.createElement('script'),
                                    o = setTimeout(() => {
                                        a(),
                                            r.error(
                                                (function eK() {
                                                    return new Error(`${Nl}Importing timeout error.`);
                                                })(),
                                            );
                                    }, 6e3);
                                function a() {
                                    s.parentNode.removeChild(s), clearTimeout(o);
                                }
                                (s.src = i),
                                    this._document.body.appendChild(s),
                                    this._jsonpIconLoad$
                                        .pipe(
                                            al(l => l.name === e.name && l.theme === e.theme),
                                            Z1(1),
                                        )
                                        .subscribe(l => {
                                            r.next(l), a();
                                        });
                            });
                        }
                        _loadSVGFromCacheOrCreateNew(e, i) {
                            let r;
                            const s = i || this._twoToneColorPalette.primaryColor,
                                o = $T(s) || this._twoToneColorPalette.secondaryColor,
                                a =
                                    'twotone' === e.theme
                                        ? (function qW(t, n, e, i) {
                                              return `${Of(t, n)}-${e}-${i}`;
                                          })(e.name, e.theme, s, o)
                                        : void 0 === e.theme
                                        ? e.name
                                        : Of(e.name, e.theme),
                                l = this._svgRenderedDefinitions.get(a);
                            return (
                                l
                                    ? (r = l.icon)
                                    : ((r = this._setSVGAttribute(
                                          this._colorizeSVGIcon(
                                              this._createSVGElementFromString(
                                                  (function KW(t) {
                                                      return '' !== zf(t)[1];
                                                  })(e.name)
                                                      ? e.icon
                                                      : (function WW(t) {
                                                            return t
                                                                .replace(/['"]#333['"]/g, '"primaryColor"')
                                                                .replace(/['"]#E6E6E6['"]/g, '"secondaryColor"')
                                                                .replace(/['"]#D9D9D9['"]/g, '"secondaryColor"')
                                                                .replace(/['"]#D8D8D8['"]/g, '"secondaryColor"');
                                                        })(e.icon),
                                              ),
                                              'twotone' === e.theme,
                                              s,
                                              o,
                                          ),
                                      )),
                                      this._svgRenderedDefinitions.set(a, { ...e, icon: r })),
                                (function GW(t) {
                                    return t.cloneNode(!0);
                                })(r)
                            );
                        }
                        _createSVGElementFromString(e) {
                            const i = this._document.createElement('div');
                            i.innerHTML = e;
                            const r = i.querySelector('svg');
                            if (!r) throw JW;
                            return r;
                        }
                        _setSVGAttribute(e) {
                            return (
                                this._renderer.setAttribute(e, 'width', '1em'),
                                this._renderer.setAttribute(e, 'height', '1em'),
                                e
                            );
                        }
                        _colorizeSVGIcon(e, i, r, s) {
                            if (i) {
                                const o = e.childNodes,
                                    a = o.length;
                                for (let l = 0; l < a; l++) {
                                    const c = o[l];
                                    'secondaryColor' === c.getAttribute('fill')
                                        ? this._renderer.setAttribute(c, 'fill', s)
                                        : this._renderer.setAttribute(c, 'fill', r);
                                }
                            }
                            return this._renderer.setAttribute(e, 'fill', 'currentColor'), e;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(y1), Se(W1, 8), Se(Ni, 8), Se(V4), Se(nK, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })(),
                rK = (() => {
                    class t {
                        constructor(e, i, r) {
                            (this._iconService = e), (this._elementRef = i), (this._renderer = r);
                        }
                        ngOnChanges(e) {
                            (e.type || e.theme || e.twoToneColor) && this._changeIcon();
                        }
                        _changeIcon() {
                            return new Promise(e => {
                                if (!this.type) return this._clearSVGElement(), void e(null);
                                const i = this._getSelfRenderMeta();
                                this._iconService
                                    .getRenderedContent(this._parseIconType(this.type, this.theme), this.twoToneColor)
                                    .subscribe(r => {
                                        const s = this._getSelfRenderMeta();
                                        !(function iK(t, n) {
                                            return (
                                                t.type === n.type &&
                                                t.theme === n.theme &&
                                                t.twoToneColor === n.twoToneColor
                                            );
                                        })(i, s)
                                            ? e(null)
                                            : (this._setSVGElement(r), e(r));
                                    });
                            });
                        }
                        _getSelfRenderMeta() {
                            return { type: this.type, theme: this.theme, twoToneColor: this.twoToneColor };
                        }
                        _parseIconType(e, i) {
                            if (GT(e)) return e;
                            {
                                const [r, s] = zf(e);
                                return s
                                    ? e
                                    : (function jW(t) {
                                          return t.endsWith('-fill') || t.endsWith('-o') || t.endsWith('-twotone');
                                      })(r)
                                    ? r
                                    : Of(r, i || this._iconService.defaultTheme);
                            }
                        }
                        _setSVGElement(e) {
                            this._clearSVGElement(), this._renderer.appendChild(this._elementRef.nativeElement, e);
                        }
                        _clearSVGElement() {
                            const e = this._elementRef.nativeElement,
                                i = e.childNodes;
                            for (let s = i.length - 1; s >= 0; s--) {
                                const o = i[s];
                                'svg' === o.tagName?.toLowerCase() && this._renderer.removeChild(e, o);
                            }
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(KT), te(Pn), te(Ps));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'antIcon', '']],
                            inputs: { type: 'type', theme: 'theme', twoToneColor: 'twoToneColor' },
                            features: [D],
                        }));
                    }
                    return t;
                })();
            function QT(t) {
                return Ct(() => t);
            }
            var Pf = (function () {
                function t(n, e) {
                    var i;
                    if ((void 0 === n && (n = ''), void 0 === e && (e = {}), n instanceof t)) return n;
                    'number' == typeof n &&
                        (n = (function OW(t) {
                            return { r: t >> 16, g: (65280 & t) >> 8, b: 255 & t };
                        })(n)),
                        (this.originalInput = n);
                    var r = Ea(n);
                    (this.originalInput = n),
                        (this.r = r.r),
                        (this.g = r.g),
                        (this.b = r.b),
                        (this.a = r.a),
                        (this.roundA = Math.round(100 * this.a) / 100),
                        (this.format = null !== (i = e.format) && void 0 !== i ? i : r.format),
                        (this.gradientType = e.gradientType),
                        this.r < 1 && (this.r = Math.round(this.r)),
                        this.g < 1 && (this.g = Math.round(this.g)),
                        this.b < 1 && (this.b = Math.round(this.b)),
                        (this.isValid = r.ok);
                }
                return (
                    (t.prototype.isDark = function () {
                        return this.getBrightness() < 128;
                    }),
                    (t.prototype.isLight = function () {
                        return !this.isDark();
                    }),
                    (t.prototype.getBrightness = function () {
                        var n = this.toRgb();
                        return (299 * n.r + 587 * n.g + 114 * n.b) / 1e3;
                    }),
                    (t.prototype.getLuminance = function () {
                        var n = this.toRgb(),
                            s = n.r / 255,
                            o = n.g / 255,
                            a = n.b / 255;
                        return (
                            0.2126 * (s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4)) +
                            0.7152 * (o <= 0.03928 ? o / 12.92 : Math.pow((o + 0.055) / 1.055, 2.4)) +
                            0.0722 * (a <= 0.03928 ? a / 12.92 : Math.pow((a + 0.055) / 1.055, 2.4))
                        );
                    }),
                    (t.prototype.getAlpha = function () {
                        return this.a;
                    }),
                    (t.prototype.setAlpha = function (n) {
                        return (this.a = zT(n)), (this.roundA = Math.round(100 * this.a) / 100), this;
                    }),
                    (t.prototype.isMonochrome = function () {
                        return 0 === this.toHsl().s;
                    }),
                    (t.prototype.toHsv = function () {
                        var n = Ef(this.r, this.g, this.b);
                        return { h: 360 * n.h, s: n.s, v: n.v, a: this.a };
                    }),
                    (t.prototype.toHsvString = function () {
                        var n = Ef(this.r, this.g, this.b),
                            e = Math.round(360 * n.h),
                            i = Math.round(100 * n.s),
                            r = Math.round(100 * n.v);
                        return 1 === this.a
                            ? 'hsv('.concat(e, ', ').concat(i, '%, ').concat(r, '%)')
                            : 'hsva('.concat(e, ', ').concat(i, '%, ').concat(r, '%, ').concat(this.roundA, ')');
                    }),
                    (t.prototype.toHsl = function () {
                        var n = PT(this.r, this.g, this.b);
                        return { h: 360 * n.h, s: n.s, l: n.l, a: this.a };
                    }),
                    (t.prototype.toHslString = function () {
                        var n = PT(this.r, this.g, this.b),
                            e = Math.round(360 * n.h),
                            i = Math.round(100 * n.s),
                            r = Math.round(100 * n.l);
                        return 1 === this.a
                            ? 'hsl('.concat(e, ', ').concat(i, '%, ').concat(r, '%)')
                            : 'hsla('.concat(e, ', ').concat(i, '%, ').concat(r, '%, ').concat(this.roundA, ')');
                    }),
                    (t.prototype.toHex = function (n) {
                        return void 0 === n && (n = !1), If(this.r, this.g, this.b, n);
                    }),
                    (t.prototype.toHexString = function (n) {
                        return void 0 === n && (n = !1), '#' + this.toHex(n);
                    }),
                    (t.prototype.toHex8 = function (n) {
                        return (
                            void 0 === n && (n = !1),
                            (function LW(t, n, e, i, r) {
                                var s = [
                                    Au(Math.round(t).toString(16)),
                                    Au(Math.round(n).toString(16)),
                                    Au(Math.round(e).toString(16)),
                                    Au(NT(i)),
                                ];
                                return r &&
                                    s[0].startsWith(s[0].charAt(1)) &&
                                    s[1].startsWith(s[1].charAt(1)) &&
                                    s[2].startsWith(s[2].charAt(1)) &&
                                    s[3].startsWith(s[3].charAt(1))
                                    ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) + s[3].charAt(0)
                                    : s.join('');
                            })(this.r, this.g, this.b, this.a, n)
                        );
                    }),
                    (t.prototype.toHex8String = function (n) {
                        return void 0 === n && (n = !1), '#' + this.toHex8(n);
                    }),
                    (t.prototype.toHexShortString = function (n) {
                        return void 0 === n && (n = !1), 1 === this.a ? this.toHexString(n) : this.toHex8String(n);
                    }),
                    (t.prototype.toRgb = function () {
                        return { r: Math.round(this.r), g: Math.round(this.g), b: Math.round(this.b), a: this.a };
                    }),
                    (t.prototype.toRgbString = function () {
                        var n = Math.round(this.r),
                            e = Math.round(this.g),
                            i = Math.round(this.b);
                        return 1 === this.a
                            ? 'rgb('.concat(n, ', ').concat(e, ', ').concat(i, ')')
                            : 'rgba('.concat(n, ', ').concat(e, ', ').concat(i, ', ').concat(this.roundA, ')');
                    }),
                    (t.prototype.toPercentageRgb = function () {
                        var n = function (e) {
                            return ''.concat(Math.round(100 * Cs(e, 255)), '%');
                        };
                        return { r: n(this.r), g: n(this.g), b: n(this.b), a: this.a };
                    }),
                    (t.prototype.toPercentageRgbString = function () {
                        var n = function (e) {
                            return Math.round(100 * Cs(e, 255));
                        };
                        return 1 === this.a
                            ? 'rgb('.concat(n(this.r), '%, ').concat(n(this.g), '%, ').concat(n(this.b), '%)')
                            : 'rgba('
                                  .concat(n(this.r), '%, ')
                                  .concat(n(this.g), '%, ')
                                  .concat(n(this.b), '%, ')
                                  .concat(this.roundA, ')');
                    }),
                    (t.prototype.toName = function () {
                        if (0 === this.a) return 'transparent';
                        if (this.a < 1) return !1;
                        for (
                            var n = '#' + If(this.r, this.g, this.b, !1), e = 0, i = Object.entries(xg);
                            e < i.length;
                            e++
                        ) {
                            var r = i[e];
                            if (n === r[1]) return r[0];
                        }
                        return !1;
                    }),
                    (t.prototype.toString = function (n) {
                        var e = !!n;
                        n = n ?? this.format;
                        var i = !1;
                        return !e && this.a < 1 && this.a >= 0 && (n.startsWith('hex') || 'name' === n)
                            ? 'name' === n && 0 === this.a
                                ? this.toName()
                                : this.toRgbString()
                            : ('rgb' === n && (i = this.toRgbString()),
                              'prgb' === n && (i = this.toPercentageRgbString()),
                              ('hex' === n || 'hex6' === n) && (i = this.toHexString()),
                              'hex3' === n && (i = this.toHexString(!0)),
                              'hex4' === n && (i = this.toHex8String(!0)),
                              'hex8' === n && (i = this.toHex8String()),
                              'name' === n && (i = this.toName()),
                              'hsl' === n && (i = this.toHslString()),
                              'hsv' === n && (i = this.toHsvString()),
                              i || this.toHexString());
                    }),
                    (t.prototype.toNumber = function () {
                        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
                    }),
                    (t.prototype.clone = function () {
                        return new t(this.toString());
                    }),
                    (t.prototype.lighten = function (n) {
                        void 0 === n && (n = 10);
                        var e = this.toHsl();
                        return (e.l += n / 100), (e.l = xf(e.l)), new t(e);
                    }),
                    (t.prototype.brighten = function (n) {
                        void 0 === n && (n = 10);
                        var e = this.toRgb();
                        return (
                            (e.r = Math.max(0, Math.min(255, e.r - Math.round((-n / 100) * 255)))),
                            (e.g = Math.max(0, Math.min(255, e.g - Math.round((-n / 100) * 255)))),
                            (e.b = Math.max(0, Math.min(255, e.b - Math.round((-n / 100) * 255)))),
                            new t(e)
                        );
                    }),
                    (t.prototype.darken = function (n) {
                        void 0 === n && (n = 10);
                        var e = this.toHsl();
                        return (e.l -= n / 100), (e.l = xf(e.l)), new t(e);
                    }),
                    (t.prototype.tint = function (n) {
                        return void 0 === n && (n = 10), this.mix('white', n);
                    }),
                    (t.prototype.shade = function (n) {
                        return void 0 === n && (n = 10), this.mix('black', n);
                    }),
                    (t.prototype.desaturate = function (n) {
                        void 0 === n && (n = 10);
                        var e = this.toHsl();
                        return (e.s -= n / 100), (e.s = xf(e.s)), new t(e);
                    }),
                    (t.prototype.saturate = function (n) {
                        void 0 === n && (n = 10);
                        var e = this.toHsl();
                        return (e.s += n / 100), (e.s = xf(e.s)), new t(e);
                    }),
                    (t.prototype.greyscale = function () {
                        return this.desaturate(100);
                    }),
                    (t.prototype.spin = function (n) {
                        var e = this.toHsl(),
                            i = (e.h + n) % 360;
                        return (e.h = i < 0 ? 360 + i : i), new t(e);
                    }),
                    (t.prototype.mix = function (n, e) {
                        void 0 === e && (e = 50);
                        var i = this.toRgb(),
                            r = new t(n).toRgb(),
                            s = e / 100;
                        return new t({
                            r: (r.r - i.r) * s + i.r,
                            g: (r.g - i.g) * s + i.g,
                            b: (r.b - i.b) * s + i.b,
                            a: (r.a - i.a) * s + i.a,
                        });
                    }),
                    (t.prototype.analogous = function (n, e) {
                        void 0 === n && (n = 6), void 0 === e && (e = 30);
                        var i = this.toHsl(),
                            r = 360 / e,
                            s = [this];
                        for (i.h = (i.h - ((r * n) >> 1) + 720) % 360; --n; ) (i.h = (i.h + r) % 360), s.push(new t(i));
                        return s;
                    }),
                    (t.prototype.complement = function () {
                        var n = this.toHsl();
                        return (n.h = (n.h + 180) % 360), new t(n);
                    }),
                    (t.prototype.monochromatic = function (n) {
                        void 0 === n && (n = 6);
                        for (var e = this.toHsv(), i = e.h, r = e.s, s = e.v, o = [], a = 1 / n; n--; )
                            o.push(new t({ h: i, s: r, v: s })), (s = (s + a) % 1);
                        return o;
                    }),
                    (t.prototype.splitcomplement = function () {
                        var n = this.toHsl(),
                            e = n.h;
                        return [
                            this,
                            new t({ h: (e + 72) % 360, s: n.s, l: n.l }),
                            new t({ h: (e + 216) % 360, s: n.s, l: n.l }),
                        ];
                    }),
                    (t.prototype.onBackground = function (n) {
                        var e = this.toRgb(),
                            i = new t(n).toRgb(),
                            r = e.a + i.a * (1 - e.a);
                        return new t({
                            r: (e.r * e.a + i.r * i.a * (1 - e.a)) / r,
                            g: (e.g * e.a + i.g * i.a * (1 - e.a)) / r,
                            b: (e.b * e.a + i.b * i.a * (1 - e.a)) / r,
                            a: r,
                        });
                    }),
                    (t.prototype.triad = function () {
                        return this.polyad(3);
                    }),
                    (t.prototype.tetrad = function () {
                        return this.polyad(4);
                    }),
                    (t.prototype.polyad = function (n) {
                        for (var e = this.toHsl(), i = e.h, r = [this], s = 360 / n, o = 1; o < n; o++)
                            r.push(new t({ h: (i + o * s) % 360, s: e.s, l: e.l }));
                        return r;
                    }),
                    (t.prototype.equals = function (n) {
                        return this.toRgbString() === new t(n).toRgbString();
                    }),
                    t
                );
            })();
            const oK = [
                    'pink',
                    'red',
                    'yellow',
                    'orange',
                    'cyan',
                    'green',
                    'blue',
                    'purple',
                    'geekblue',
                    'magenta',
                    'volcano',
                    'gold',
                    'lime',
                ],
                Nf = 2,
                XT = 0.16,
                lK = 0.05,
                cK = 0.05,
                uK = 0.15,
                ZT = 5,
                JT = 4,
                dK = [
                    { index: 7, opacity: 0.15 },
                    { index: 6, opacity: 0.25 },
                    { index: 5, opacity: 0.3 },
                    { index: 5, opacity: 0.45 },
                    { index: 5, opacity: 0.65 },
                    { index: 5, opacity: 0.85 },
                    { index: 4, opacity: 0.9 },
                    { index: 3, opacity: 0.95 },
                    { index: 2, opacity: 0.97 },
                    { index: 1, opacity: 0.98 },
                ];
            function eD({ r: t, g: n, b: e }) {
                const i = Ef(t, n, e);
                return { h: 360 * i.h, s: i.s, v: i.v };
            }
            function Ff({ r: t, g: n, b: e }) {
                return `#${If(t, n, e, !1)}`;
            }
            function tD(t, n, e) {
                let i;
                return (
                    (i =
                        Math.round(t.h) >= 60 && Math.round(t.h) <= 240
                            ? e
                                ? Math.round(t.h) - Nf * n
                                : Math.round(t.h) + Nf * n
                            : e
                            ? Math.round(t.h) + Nf * n
                            : Math.round(t.h) - Nf * n),
                    i < 0 ? (i += 360) : i >= 360 && (i -= 360),
                    i
                );
            }
            function nD(t, n, e) {
                if (0 === t.h && 0 === t.s) return t.s;
                let i;
                return (
                    (i = e ? t.s - XT * n : n === JT ? t.s + XT : t.s + lK * n),
                    i > 1 && (i = 1),
                    e && n === ZT && i > 0.1 && (i = 0.1),
                    i < 0.06 && (i = 0.06),
                    Number(i.toFixed(2))
                );
            }
            function iD(t, n, e) {
                let i;
                return (i = e ? t.v + cK * n : t.v - uK * n), i > 1 && (i = 1), Number(i.toFixed(2));
            }
            function rD(t, n = {}) {
                const e = [],
                    i = Ea(t);
                for (let r = ZT; r > 0; r -= 1) {
                    const s = eD(i),
                        o = Ff(Ea({ h: tD(s, r, !0), s: nD(s, r, !0), v: iD(s, r, !0) }));
                    e.push(o);
                }
                e.push(Ff(i));
                for (let r = 1; r <= JT; r += 1) {
                    const s = eD(i),
                        o = Ff(Ea({ h: tD(s, r), s: nD(s, r), v: iD(s, r) }));
                    e.push(o);
                }
                return 'dark' === n.theme
                    ? dK.map(({ index: r, opacity: s }) =>
                          Ff(
                              (function hK(t, n, e) {
                                  const i = e / 100;
                                  return {
                                      r: (n.r - t.r) * i + t.r,
                                      g: (n.g - t.g) * i + t.g,
                                      b: (n.b - t.b) * i + t.b,
                                  };
                              })(Ea(n.backgroundColor || '#141414'), Ea(e[r]), 100 * s),
                          ),
                      )
                    : e;
            }
            const sD = new $e('nz-config'),
                fK = `-ant-${Date.now()}-${Math.random()}`;
            function oD(t, n, e) {
                const i = (function mK(t, n) {
                    const e = {},
                        i = (o, a) => {
                            let l = o.clone();
                            return (l = a?.(l) || l), l.toRgbString();
                        },
                        r = (o, a) => {
                            const l = new Pf(o),
                                c = rD(l.toRgbString());
                            (e[`${a}-color`] = i(l)),
                                (e[`${a}-color-disabled`] = c[1]),
                                (e[`${a}-color-hover`] = c[4]),
                                (e[`${a}-color-active`] = c[7]),
                                (e[`${a}-color-outline`] = l.clone().setAlpha(0.2).toRgbString()),
                                (e[`${a}-color-deprecated-bg`] = c[1]),
                                (e[`${a}-color-deprecated-border`] = c[3]);
                        };
                    if (n.primaryColor) {
                        r(n.primaryColor, 'primary');
                        const o = new Pf(n.primaryColor),
                            a = rD(o.toRgbString());
                        a.forEach((c, f) => {
                            e[`primary-${f + 1}`] = c;
                        }),
                            (e['primary-color-deprecated-l-35'] = i(o, c => c.lighten(35))),
                            (e['primary-color-deprecated-l-20'] = i(o, c => c.lighten(20))),
                            (e['primary-color-deprecated-t-20'] = i(o, c => c.tint(20))),
                            (e['primary-color-deprecated-t-50'] = i(o, c => c.tint(50))),
                            (e['primary-color-deprecated-f-12'] = i(o, c => c.setAlpha(0.12 * c.getAlpha())));
                        const l = new Pf(a[0]);
                        (e['primary-color-active-deprecated-f-30'] = i(l, c => c.setAlpha(0.3 * c.getAlpha()))),
                            (e['primary-color-active-deprecated-d-02'] = i(l, c => c.darken(2)));
                    }
                    return (
                        n.successColor && r(n.successColor, 'success'),
                        n.warningColor && r(n.warningColor, 'warning'),
                        n.errorColor && r(n.errorColor, 'error'),
                        n.infoColor && r(n.infoColor, 'info'),
                        `\n  :root {\n    ${Object.keys(e)
                            .map(o => `--${t}-${o}: ${e[o]};`)
                            .join('\n')}\n  }\n  `.trim()
                    );
                })(t, n);
                vT()
                    ? (function FG(t, n, e = {}) {
                          const i = yg(e);
                          if (!bg.has(i)) {
                              const o = yT('', e),
                                  { parentNode: a } = o;
                              bg.set(i, a), a.removeChild(o);
                          }
                          const r = (function bT(t, n = {}) {
                              const e = yg(n);
                              return Array.from(bg.get(e)?.children || []).find(
                                  i => 'STYLE' === i.tagName && i.getAttribute(_T(n)) === t,
                              );
                          })(n, e);
                          if (r)
                              return (
                                  e.cspNonce && r.nonce !== e.cspNonce && (r.nonce = e.cspNonce),
                                  r.innerHTML !== t && (r.innerHTML = t),
                                  r
                              );
                          const s = yT(t, e);
                          s?.setAttribute(_T(e), n);
                      })(i, `${fK}-dynamic-theme`, { cspNonce: e })
                    : ku('NzConfigService: SSR do not support dynamic theme with css variables.');
            }
            const aD = function (t) {
                return void 0 !== t;
            };
            let s0 = (() => {
                class t {
                    constructor(e, i) {
                        (this.configUpdated$ = new vt()),
                            (this.config = e || {}),
                            (this.cspNonce = i),
                            this.config.theme &&
                                oD(this.getConfig().prefixCls?.prefixCls || 'ant', this.config.theme, i);
                    }
                    getConfig() {
                        return this.config;
                    }
                    getConfigForComponent(e) {
                        return this.config[e];
                    }
                    getConfigChangeEventForComponent(e) {
                        return this.configUpdated$.pipe(
                            al(i => i === e),
                            QT(void 0),
                        );
                    }
                    set(e, i) {
                        (this.config[e] = { ...this.config[e], ...i }),
                            'theme' === e &&
                                this.config.theme &&
                                oD(this.getConfig().prefixCls?.prefixCls || 'ant', this.config.theme, this.cspNonce),
                            this.configUpdated$.next(e);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(sD, 8), Se(K0, 8));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            function fs() {
                return function (n, e, i) {
                    const r = `$$__zorroConfigDecorator__${e}`;
                    return (
                        Object.defineProperty(n, r, { configurable: !0, writable: !0, enumerable: !1 }),
                        {
                            get() {
                                const s = i?.get ? i.get.bind(this)() : this[r],
                                    o = (this.propertyAssignCounter?.[e] || 0) > 1,
                                    a = this.nzConfigService.getConfigForComponent(this._nzModuleName)?.[e];
                                return o && aD(s) ? s : aD(a) ? a : s;
                            },
                            set(s) {
                                (this.propertyAssignCounter = this.propertyAssignCounter || {}),
                                    (this.propertyAssignCounter[e] = (this.propertyAssignCounter[e] || 0) + 1),
                                    i?.set ? i.set.bind(this)(s) : (this[r] = s);
                            },
                            configurable: !0,
                            enumerable: !0,
                        }
                    );
                };
            }
            const pK = [
                    {
                        name: 'bars',
                        theme: 'outline',
                        icon: '<svg viewBox="0 0 1024 1024" focusable="false"><path d="M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" /></svg>',
                    },
                    {
                        name: 'calendar',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" /></svg>',
                    },
                    {
                        name: 'caret-up',
                        theme: 'fill',
                        icon: '<svg viewBox="0 0 1024 1024" focusable="false"><path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" /></svg>',
                    },
                    {
                        name: 'caret-up',
                        theme: 'outline',
                        icon: '<svg viewBox="0 0 1024 1024" focusable="false"><path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" /></svg>',
                    },
                    {
                        name: 'caret-down',
                        theme: 'fill',
                        icon: '<svg viewBox="0 0 1024 1024" focusable="false"><path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" /></svg>',
                    },
                    {
                        name: 'caret-down',
                        theme: 'outline',
                        icon: '<svg viewBox="0 0 1024 1024" focusable="false"><path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" /></svg>',
                    },
                    {
                        name: 'check-circle',
                        theme: 'fill',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" /></svg>',
                    },
                    {
                        name: 'check-circle',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" /><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" /></svg>',
                    },
                    {
                        name: 'check',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" /></svg>',
                    },
                    {
                        name: 'clock-circle',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" /><path d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" /></svg>',
                    },
                    {
                        name: 'close-circle',
                        theme: 'outline',
                        icon: '<svg fill-rule="evenodd" viewBox="64 64 896 896" focusable="false"><path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z" /></svg>',
                    },
                    {
                        name: 'close-circle',
                        theme: 'fill',
                        icon: '<svg fill-rule="evenodd" viewBox="64 64 896 896" focusable="false"><path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" /></svg>',
                    },
                    {
                        name: 'close',
                        theme: 'outline',
                        icon: '<svg fill-rule="evenodd" viewBox="64 64 896 896" focusable="false"><path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" /></svg>',
                    },
                    {
                        name: 'copy',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" /></svg>',
                    },
                    {
                        name: 'delete',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" /></svg>',
                    },
                    {
                        name: 'double-left',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" /></svg>',
                    },
                    {
                        name: 'double-right',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" /></svg>',
                    },
                    {
                        name: 'down',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" /></svg>',
                    },
                    {
                        name: 'edit',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" /></svg>',
                    },
                    {
                        name: 'ellipsis',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" /></svg>',
                    },
                    {
                        name: 'exclamation-circle',
                        theme: 'fill',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" /></svg>',
                    },
                    {
                        name: 'exclamation-circle',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" /><path d="M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" /></svg>',
                    },
                    {
                        name: 'eye',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" /></svg>',
                    },
                    {
                        name: 'file',
                        theme: 'fill',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" /></svg>',
                    },
                    {
                        name: 'file',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" /></svg>',
                    },
                    {
                        name: 'filter',
                        theme: 'fill',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" /></svg>',
                    },
                    {
                        name: 'info-circle',
                        theme: 'fill',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" /></svg>',
                    },
                    {
                        name: 'info-circle',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" /><path d="M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" /></svg>',
                    },
                    {
                        name: 'left',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" /></svg>',
                    },
                    {
                        name: 'loading',
                        theme: 'outline',
                        icon: '<svg viewBox="0 0 1024 1024" focusable="false"><path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" /></svg>',
                    },
                    {
                        name: 'paper-clip',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" /></svg>',
                    },
                    {
                        name: 'question-circle',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" /><path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" /></svg>',
                    },
                    {
                        name: 'right',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" /></svg>',
                    },
                    {
                        name: 'rotate-right',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><defs><style /></defs><path d="M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" /><path d="M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" /></svg>',
                    },
                    {
                        name: 'rotate-left',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><defs><style /></defs><path d="M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" /><path d="M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" /></svg>',
                    },
                    VS,
                    {
                        name: 'search',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" /></svg>',
                    },
                    VS,
                    {
                        name: 'upload',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" /></svg>',
                    },
                    {
                        name: 'vertical-align-top',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z" /></svg>',
                    },
                    {
                        name: 'up',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" /></svg>',
                    },
                    {
                        name: 'swap',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" /></svg>',
                    },
                    {
                        name: 'swap-right',
                        theme: 'outline',
                        icon: '<svg viewBox="0 0 1024 1024" focusable="false"><path d="M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" /></svg>',
                    },
                    {
                        name: 'zoom-in',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" /></svg>',
                    },
                    {
                        name: 'zoom-out',
                        theme: 'outline',
                        icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" /></svg>',
                    },
                ],
                cD = new $e('nz_icons'),
                uD = (new $e('nz_icon_default_twotone_color'), '#1890ff');
            let dD = (() => {
                class t extends KT {
                    get _disableDynamicLoading() {
                        return !this.platform.isBrowser;
                    }
                    ngOnDestroy() {
                        this.subscription && (this.subscription.unsubscribe(), (this.subscription = null));
                    }
                    normalizeSvgElement(e) {
                        e.getAttribute('viewBox') || this._renderer.setAttribute(e, 'viewBox', '0 0 1024 1024'),
                            (!e.getAttribute('width') || !e.getAttribute('height')) &&
                                (this._renderer.setAttribute(e, 'width', '1em'),
                                this._renderer.setAttribute(e, 'height', '1em')),
                            e.getAttribute('fill') || this._renderer.setAttribute(e, 'fill', 'currentColor');
                    }
                    fetchFromIconfont(e) {
                        const { scriptUrl: i } = e;
                        if (this._document && !this.iconfontCache.has(i)) {
                            const r = this._renderer.createElement('script');
                            this._renderer.setAttribute(r, 'src', i),
                                this._renderer.setAttribute(r, 'data-namespace', i.replace(/^(https?|http):/g, '')),
                                this._renderer.appendChild(this._document.body, r),
                                this.iconfontCache.add(i);
                        }
                    }
                    createIconfontIcon(e) {
                        return this._createSVGElementFromString(`<svg><use xlink:href="${e}"></svg>`);
                    }
                    constructor(e, i, r, s, o, a, l) {
                        super(e, o, a, i, [...pK, ...(l || [])]),
                            (this.nzConfigService = r),
                            (this.platform = s),
                            (this.configUpdated$ = new vt()),
                            (this.iconfontCache = new Set()),
                            (this.subscription = null),
                            this.onConfigChange(),
                            this.configDefaultTwotoneColor(),
                            this.configDefaultTheme();
                    }
                    onConfigChange() {
                        this.subscription = this.nzConfigService
                            .getConfigChangeEventForComponent('icon')
                            .subscribe(() => {
                                this.configDefaultTwotoneColor(), this.configDefaultTheme(), this.configUpdated$.next();
                            });
                    }
                    configDefaultTheme() {
                        const e = this.getConfig();
                        this.defaultTheme = e.nzTheme || 'outline';
                    }
                    configDefaultTwotoneColor() {
                        const i = this.getConfig().nzTwotoneColor || uD;
                        let r = uD;
                        i && (i.startsWith('#') ? (r = i) : ku('Twotone color must be a hex color!')),
                            (this.twoToneColor = { primaryColor: r });
                    }
                    getConfig() {
                        return this.nzConfigService.getConfigForComponent('icon') || {};
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(y1), Se(V4), Se(s0), Se(Go), Se(W1, 8), Se(Ni, 8), Se(cD, 8));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            const hD = new $e('nz_icons_patch');
            let fD = (() => {
                    class t {
                        constructor(e, i) {
                            (this.extraIcons = e), (this.rootIconService = i), (this.patched = !1);
                        }
                        doPatch() {
                            this.patched ||
                                (this.extraIcons.forEach(e => this.rootIconService.addIcon(e)), (this.patched = !0));
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(hD, 2), Se(dD));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })(),
                xc = (() => {
                    class t extends rK {
                        set nzSpin(e) {
                            this.spin = e;
                        }
                        set nzType(e) {
                            this.type = e;
                        }
                        set nzTheme(e) {
                            this.theme = e;
                        }
                        set nzTwotoneColor(e) {
                            this.twoToneColor = e;
                        }
                        set nzIconfont(e) {
                            this.iconfont = e;
                        }
                        constructor(e, i, r, s, o, a) {
                            super(s, r, o),
                                (this.ngZone = e),
                                (this.changeDetectorRef = i),
                                (this.iconService = s),
                                (this.renderer = o),
                                (this.cacheClassName = null),
                                (this.nzRotate = 0),
                                (this.spin = !1),
                                (this.destroy$ = new vt()),
                                a && a.doPatch(),
                                (this.el = r.nativeElement);
                        }
                        ngOnChanges(e) {
                            const { nzType: i, nzTwotoneColor: r, nzSpin: s, nzTheme: o, nzRotate: a } = e;
                            i || r || s || o
                                ? this.changeIcon2()
                                : a
                                ? this.handleRotate(this.el.firstChild)
                                : this._setSVGElement(this.iconService.createIconfontIcon(`#${this.iconfont}`));
                        }
                        ngOnInit() {
                            this.renderer.setAttribute(this.el, 'class', `anticon ${this.el.className}`.trim());
                        }
                        ngAfterContentChecked() {
                            if (!this.type) {
                                const e = this.el.children;
                                let i = e.length;
                                if (!this.type && e.length)
                                    for (; i--; ) {
                                        const r = e[i];
                                        'svg' === r.tagName.toLowerCase() && this.iconService.normalizeSvgElement(r);
                                    }
                            }
                        }
                        ngOnDestroy() {
                            this.destroy$.next();
                        }
                        changeIcon2() {
                            this.setClassName(),
                                this.ngZone.runOutsideAngular(() => {
                                    ol(this._changeIcon())
                                        .pipe(nn(this.destroy$))
                                        .subscribe({
                                            next: e => {
                                                this.ngZone.run(() => {
                                                    this.changeDetectorRef.detectChanges(),
                                                        e &&
                                                            (this.setSVGData(e),
                                                            this.handleSpin(e),
                                                            this.handleRotate(e));
                                                });
                                            },
                                            error: ku,
                                        });
                                });
                        }
                        handleSpin(e) {
                            this.spin || 'loading' === this.type
                                ? this.renderer.addClass(e, 'anticon-spin')
                                : this.renderer.removeClass(e, 'anticon-spin');
                        }
                        handleRotate(e) {
                            this.nzRotate
                                ? this.renderer.setAttribute(e, 'style', `transform: rotate(${this.nzRotate}deg)`)
                                : this.renderer.removeAttribute(e, 'style');
                        }
                        setClassName() {
                            this.cacheClassName && this.renderer.removeClass(this.el, this.cacheClassName),
                                (this.cacheClassName = `anticon-${this.type}`),
                                this.renderer.addClass(this.el, this.cacheClassName);
                        }
                        setSVGData(e) {
                            this.renderer.setAttribute(e, 'data-icon', this.type),
                                this.renderer.setAttribute(e, 'aria-hidden', 'true');
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(en), te(kr), te(Pn), te(dD), te(Ps), te(fD, 8));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'nz-icon', '']],
                            hostVars: 2,
                            hostBindings: function (i, r) {
                                2 & i && On('anticon', !0);
                            },
                            inputs: {
                                nzSpin: 'nzSpin',
                                nzRotate: 'nzRotate',
                                nzType: 'nzType',
                                nzTheme: 'nzTheme',
                                nzTwotoneColor: 'nzTwotoneColor',
                                nzIconfont: 'nzIconfont',
                            },
                            exportAs: ['nzIcon'],
                            standalone: !0,
                            features: [Cn, D],
                        }));
                    }
                    return Lt([En()], t.prototype, 'nzSpin', null), t;
                })(),
                o0 = (() => {
                    class t {
                        static forRoot(e) {
                            return { ngModule: t, providers: [{ provide: cD, useValue: e }] };
                        }
                        static forChild(e) {
                            return { ngModule: t, providers: [fD, { provide: hD, useValue: e }] };
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })();
            function gK(t, n) {
                1 & t && Oe(0, 'span', 1), 2 & t && H('nzType', L().iconType);
            }
            let Rf = (() => {
                    class t {
                        constructor() {
                            this.formStatusChanges = new yc(1);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })(),
                mD = (() => {
                    class t {
                        constructor() {
                            this.noFormStatus = new Ke(!1);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })();
            const vK = {
                error: 'close-circle-fill',
                validating: 'loading',
                success: 'check-circle-fill',
                warning: 'exclamation-circle-fill',
            };
            let pD = (() => {
                    class t {
                        constructor(e) {
                            (this.cdr = e), (this.status = ''), (this.iconType = null);
                        }
                        ngOnChanges(e) {
                            this.updateIcon();
                        }
                        updateIcon() {
                            (this.iconType = this.status ? vK[this.status] : null), this.cdr.markForCheck();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(kr));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['nz-form-item-feedback-icon']],
                            hostAttrs: [1, 'ant-form-item-feedback-icon'],
                            hostVars: 8,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('ant-form-item-feedback-icon-error', 'error' === r.status)(
                                        'ant-form-item-feedback-icon-warning',
                                        'warning' === r.status,
                                    )('ant-form-item-feedback-icon-success', 'success' === r.status)(
                                        'ant-form-item-feedback-icon-validating',
                                        'validating' === r.status,
                                    );
                            },
                            inputs: { status: 'status' },
                            exportAs: ['nzFormFeedbackIcon'],
                            features: [D],
                            decls: 1,
                            vars: 1,
                            consts: [
                                ['nz-icon', '', 3, 'nzType', 4, 'ngIf'],
                                ['nz-icon', '', 3, 'nzType'],
                            ],
                            template: function (i, r) {
                                1 & i && ue(0, gK, 1, 1, 'span', 0), 2 & i && H('ngIf', r.iconType);
                            },
                            dependencies: [hi, xc],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                gD = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [HC, o0] }));
                    }
                    return t;
                })();
            const vD = ['*'],
                _K = ['inputElement'],
                yK = ['nz-checkbox', ''],
                bK = (t, n) => n.value;
            function CK(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'label', 1),
                        Le('nzCheckedChange', function (r) {
                            const s = me(e).$implicit;
                            return pe(L().onCheckedChange(s, r));
                        }),
                        Z(1, 'span'),
                        Je(2),
                        ee()();
                }
                if (2 & t) {
                    const e = n.$implicit,
                        i = L();
                    H('nzDisabled', e.disabled || i.nzDisabled)('nzChecked', e.checked), z(2), hn(e.label);
                }
            }
            let _D = (() => {
                    class t {
                        constructor() {
                            (this.nzOnChange = new Ft()), (this.checkboxList = []);
                        }
                        addCheckbox(e) {
                            this.checkboxList.push(e);
                        }
                        removeCheckbox(e) {
                            this.checkboxList.splice(this.checkboxList.indexOf(e), 1);
                        }
                        onChange() {
                            const e = this.checkboxList.filter(i => i.nzChecked).map(i => i.nzValue);
                            this.nzOnChange.emit(e);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['nz-checkbox-wrapper']],
                            hostAttrs: [1, 'ant-checkbox-group'],
                            outputs: { nzOnChange: 'nzOnChange' },
                            exportAs: ['nzCheckboxWrapper'],
                            standalone: !0,
                            features: [Qi],
                            ngContentSelectors: vD,
                            decls: 1,
                            vars: 0,
                            template: function (i, r) {
                                1 & i && (H1(), U1(0));
                            },
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                Og = (() => {
                    class t {
                        innerCheckedChange(e) {
                            this.nzDisabled ||
                                ((this.nzChecked = e),
                                this.onChange(this.nzChecked),
                                this.nzCheckedChange.emit(this.nzChecked),
                                this.nzCheckboxWrapperComponent && this.nzCheckboxWrapperComponent.onChange());
                        }
                        writeValue(e) {
                            (this.nzChecked = e), this.cdr.markForCheck();
                        }
                        registerOnChange(e) {
                            this.onChange = e;
                        }
                        registerOnTouched(e) {
                            this.onTouched = e;
                        }
                        setDisabledState(e) {
                            (this.nzDisabled = (this.isNzDisableFirstChange && this.nzDisabled) || e),
                                (this.isNzDisableFirstChange = !1),
                                this.cdr.markForCheck();
                        }
                        focus() {
                            this.focusMonitor.focusVia(this.inputElement, 'keyboard');
                        }
                        blur() {
                            this.inputElement.nativeElement.blur();
                        }
                        constructor(e, i, r, s, o, a, l) {
                            (this.ngZone = e),
                                (this.elementRef = i),
                                (this.nzCheckboxWrapperComponent = r),
                                (this.cdr = s),
                                (this.focusMonitor = o),
                                (this.directionality = a),
                                (this.nzFormStatusService = l),
                                (this.dir = 'ltr'),
                                (this.destroy$ = new vt()),
                                (this.isNzDisableFirstChange = !0),
                                (this.onChange = () => {}),
                                (this.onTouched = () => {}),
                                (this.nzCheckedChange = new Ft()),
                                (this.nzValue = null),
                                (this.nzAutoFocus = !1),
                                (this.nzDisabled = !1),
                                (this.nzIndeterminate = !1),
                                (this.nzChecked = !1),
                                (this.nzId = null);
                        }
                        ngOnInit() {
                            this.focusMonitor
                                .monitor(this.elementRef, !0)
                                .pipe(nn(this.destroy$))
                                .subscribe(e => {
                                    e || Promise.resolve().then(() => this.onTouched());
                                }),
                                this.nzCheckboxWrapperComponent && this.nzCheckboxWrapperComponent.addCheckbox(this),
                                this.directionality.change.pipe(nn(this.destroy$)).subscribe(e => {
                                    (this.dir = e), this.cdr.detectChanges();
                                }),
                                (this.dir = this.directionality.value),
                                this.ngZone.runOutsideAngular(() => {
                                    ca(this.elementRef.nativeElement, 'click')
                                        .pipe(nn(this.destroy$))
                                        .subscribe(e => {
                                            e.preventDefault(),
                                                this.focus(),
                                                !this.nzDisabled &&
                                                    this.ngZone.run(() => {
                                                        this.innerCheckedChange(!this.nzChecked),
                                                            this.cdr.markForCheck();
                                                    });
                                        }),
                                        ca(this.inputElement.nativeElement, 'click')
                                            .pipe(nn(this.destroy$))
                                            .subscribe(e => e.stopPropagation());
                                });
                        }
                        ngAfterViewInit() {
                            this.nzAutoFocus && this.focus();
                        }
                        ngOnDestroy() {
                            this.focusMonitor.stopMonitoring(this.elementRef),
                                this.nzCheckboxWrapperComponent && this.nzCheckboxWrapperComponent.removeCheckbox(this),
                                this.destroy$.next(),
                                this.destroy$.complete();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(en), te(Pn), te(_D, 8), te(kr), te(Df), te(yo, 8), te(Rf, 8));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['', 'nz-checkbox', '']],
                            viewQuery: function (i, r) {
                                if ((1 & i && Fr(_K, 7), 2 & i)) {
                                    let s;
                                    Dr((s = xr())) && (r.inputElement = s.first);
                                }
                            },
                            hostAttrs: [1, 'ant-checkbox-wrapper'],
                            hostVars: 6,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('ant-checkbox-wrapper-in-form-item', !!r.nzFormStatusService)(
                                        'ant-checkbox-wrapper-checked',
                                        r.nzChecked,
                                    )('ant-checkbox-rtl', 'rtl' === r.dir);
                            },
                            inputs: {
                                nzValue: 'nzValue',
                                nzAutoFocus: 'nzAutoFocus',
                                nzDisabled: 'nzDisabled',
                                nzIndeterminate: 'nzIndeterminate',
                                nzChecked: 'nzChecked',
                                nzId: 'nzId',
                            },
                            outputs: { nzCheckedChange: 'nzCheckedChange' },
                            exportAs: ['nzCheckbox'],
                            standalone: !0,
                            features: [$n([{ provide: hs, useExisting: Wt(() => t), multi: !0 }]), Qi],
                            attrs: yK,
                            ngContentSelectors: vD,
                            decls: 6,
                            vars: 11,
                            consts: [
                                ['inputElement', ''],
                                [1, 'ant-checkbox'],
                                [
                                    'type',
                                    'checkbox',
                                    1,
                                    'ant-checkbox-input',
                                    3,
                                    'ngModelChange',
                                    'checked',
                                    'ngModel',
                                    'disabled',
                                ],
                                [1, 'ant-checkbox-inner'],
                            ],
                            template: function (i, r) {
                                if (1 & i) {
                                    const s = st();
                                    H1(),
                                        Z(0, 'span', 1)(1, 'input', 2, 0),
                                        Le('ngModelChange', function (a) {
                                            return me(s), pe(r.innerCheckedChange(a));
                                        }),
                                        ee(),
                                        Oe(3, 'span', 3),
                                        ee(),
                                        Z(4, 'span'),
                                        U1(5),
                                        ee();
                                }
                                2 & i &&
                                    (On('ant-checkbox-checked', r.nzChecked && !r.nzIndeterminate)(
                                        'ant-checkbox-disabled',
                                        r.nzDisabled,
                                    )('ant-checkbox-indeterminate', r.nzIndeterminate),
                                    z(),
                                    H('checked', r.nzChecked)('ngModel', r.nzChecked)('disabled', r.nzDisabled),
                                    zi('autofocus', r.nzAutoFocus ? 'autofocus' : null)('id', r.nzId));
                            },
                            dependencies: [nh, W4, eo, Fs],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return (
                        Lt([En()], t.prototype, 'nzAutoFocus', void 0),
                        Lt([En()], t.prototype, 'nzDisabled', void 0),
                        Lt([En()], t.prototype, 'nzIndeterminate', void 0),
                        Lt([En()], t.prototype, 'nzChecked', void 0),
                        t
                    );
                })(),
                wK = (() => {
                    class t {
                        onCheckedChange(e, i) {
                            (e.checked = i), this.onChange(this.options);
                        }
                        constructor(e, i, r, s) {
                            (this.elementRef = e),
                                (this.focusMonitor = i),
                                (this.cdr = r),
                                (this.directionality = s),
                                (this.onChange = () => {}),
                                (this.onTouched = () => {}),
                                (this.options = []),
                                (this.nzDisabled = !1),
                                (this.dir = 'ltr'),
                                (this.destroy$ = new vt()),
                                (this.isNzDisableFirstChange = !0);
                        }
                        ngOnInit() {
                            this.focusMonitor
                                .monitor(this.elementRef, !0)
                                .pipe(nn(this.destroy$))
                                .subscribe(e => {
                                    e || Promise.resolve().then(() => this.onTouched());
                                }),
                                this.directionality.change?.pipe(nn(this.destroy$)).subscribe(e => {
                                    (this.dir = e), this.cdr.detectChanges();
                                }),
                                (this.dir = this.directionality.value);
                        }
                        ngOnDestroy() {
                            this.focusMonitor.stopMonitoring(this.elementRef),
                                this.destroy$.next(),
                                this.destroy$.complete();
                        }
                        writeValue(e) {
                            (this.options = e), this.cdr.markForCheck();
                        }
                        registerOnChange(e) {
                            this.onChange = e;
                        }
                        registerOnTouched(e) {
                            this.onTouched = e;
                        }
                        setDisabledState(e) {
                            (this.nzDisabled = (this.isNzDisableFirstChange && this.nzDisabled) || e),
                                (this.isNzDisableFirstChange = !1),
                                this.cdr.markForCheck();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Pn), te(Df), te(kr), te(yo, 8));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['nz-checkbox-group']],
                            hostAttrs: [1, 'ant-checkbox-group'],
                            hostVars: 2,
                            hostBindings: function (i, r) {
                                2 & i && On('ant-checkbox-group-rtl', 'rtl' === r.dir);
                            },
                            inputs: { nzDisabled: 'nzDisabled' },
                            exportAs: ['nzCheckboxGroup'],
                            standalone: !0,
                            features: [$n([{ provide: hs, useExisting: Wt(() => t), multi: !0 }]), Qi],
                            decls: 2,
                            vars: 0,
                            consts: [
                                ['nz-checkbox', '', 1, 'ant-checkbox-group-item', 3, 'nzDisabled', 'nzChecked'],
                                [
                                    'nz-checkbox',
                                    '',
                                    1,
                                    'ant-checkbox-group-item',
                                    3,
                                    'nzCheckedChange',
                                    'nzDisabled',
                                    'nzChecked',
                                ],
                            ],
                            template: function (i, r) {
                                1 & i && Jr(0, CK, 3, 3, 'label', 0, bK), 2 & i && es(r.options);
                            },
                            dependencies: [Og],
                            encapsulation: 2,
                        }));
                    }
                    return Lt([En()], t.prototype, 'nzDisabled', void 0), t;
                })(),
                MK = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [Og, wK] }));
                    }
                    return t;
                })();
            function zg(...t) {
                return (function SK() {
                    return eM(1);
                })()(ol(t, Gd(t)));
            }
            function Pg(...t) {
                const n = Gd(t);
                return mi((e, i) => {
                    (n ? zg(t, e, n) : zg(t, e)).subscribe(i);
                });
            }
            let yD = (() => {
                    class t {
                        setHiddenAttribute() {
                            this.hidden
                                ? this.renderer.setAttribute(
                                      this.elementRef.nativeElement,
                                      'hidden',
                                      'string' == typeof this.hidden ? this.hidden : '',
                                  )
                                : this.renderer.removeAttribute(this.elementRef.nativeElement, 'hidden');
                        }
                        constructor(e, i) {
                            (this.elementRef = e),
                                (this.renderer = i),
                                (this.hidden = null),
                                this.renderer.setAttribute(this.elementRef.nativeElement, 'hidden', '');
                        }
                        ngOnChanges() {
                            this.setHiddenAttribute();
                        }
                        ngAfterViewInit() {
                            this.setHiddenAttribute();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Pn), te(Ps));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [
                                ['', 'nz-button', ''],
                                ['nz-button-group'],
                                ['', 'nz-icon', ''],
                                ['', 'nz-menu-item', ''],
                                ['', 'nz-submenu', ''],
                                ['nz-select-top-control'],
                                ['nz-select-placeholder'],
                                ['nz-input-group'],
                            ],
                            inputs: { hidden: 'hidden' },
                            standalone: !0,
                            features: [D],
                        }));
                    }
                    return t;
                })(),
                TK = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })();
            class DK {
                get waveAttributeName() {
                    return this.insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
                }
                constructor(n, e, i, r, s) {
                    (this.triggerElement = n),
                        (this.ngZone = e),
                        (this.insertExtraNode = i),
                        (this.platformId = r),
                        (this.cspNonce = s),
                        (this.waveTransitionDuration = 400),
                        (this.styleForPseudo = null),
                        (this.extraNode = null),
                        (this.lastTime = 0),
                        (this.onClick = o => {
                            !this.triggerElement ||
                                !this.triggerElement.getAttribute ||
                                this.triggerElement.getAttribute('disabled') ||
                                'INPUT' === o.target.tagName ||
                                this.triggerElement.className.indexOf('disabled') >= 0 ||
                                this.fadeOutWave();
                        }),
                        (this.platform = new Go(this.platformId)),
                        (this.clickHandler = this.onClick.bind(this)),
                        this.bindTriggerEvent();
                }
                bindTriggerEvent() {
                    this.platform.isBrowser &&
                        this.ngZone.runOutsideAngular(() => {
                            this.removeTriggerEvent(),
                                this.triggerElement &&
                                    this.triggerElement.addEventListener('click', this.clickHandler, !0);
                        });
                }
                removeTriggerEvent() {
                    this.triggerElement && this.triggerElement.removeEventListener('click', this.clickHandler, !0);
                }
                removeStyleAndExtraNode() {
                    this.styleForPseudo &&
                        document.body.contains(this.styleForPseudo) &&
                        (document.body.removeChild(this.styleForPseudo), (this.styleForPseudo = null)),
                        this.insertExtraNode &&
                            this.triggerElement.contains(this.extraNode) &&
                            this.triggerElement.removeChild(this.extraNode);
                }
                destroy() {
                    this.removeTriggerEvent(), this.removeStyleAndExtraNode();
                }
                fadeOutWave() {
                    const n = this.triggerElement,
                        e = this.getWaveColor(n);
                    n.setAttribute(this.waveAttributeName, 'true'),
                        !(Date.now() < this.lastTime + this.waveTransitionDuration) &&
                            (this.isValidColor(e) &&
                                (this.styleForPseudo ||
                                    ((this.styleForPseudo = document.createElement('style')),
                                    this.cspNonce && (this.styleForPseudo.nonce = this.cspNonce)),
                                (this.styleForPseudo.innerHTML = `\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ${e};\n      }`),
                                document.body.appendChild(this.styleForPseudo)),
                            this.insertExtraNode &&
                                (this.extraNode || (this.extraNode = document.createElement('div')),
                                (this.extraNode.className = 'ant-click-animating-node'),
                                n.appendChild(this.extraNode)),
                            (this.lastTime = Date.now()),
                            this.runTimeoutOutsideZone(() => {
                                n.removeAttribute(this.waveAttributeName), this.removeStyleAndExtraNode();
                            }, this.waveTransitionDuration));
                }
                isValidColor(n) {
                    return (
                        !!n &&
                        '#ffffff' !== n &&
                        'rgb(255, 255, 255)' !== n &&
                        this.isNotGrey(n) &&
                        !/rgba\(\d*, \d*, \d*, 0\)/.test(n) &&
                        'transparent' !== n
                    );
                }
                isNotGrey(n) {
                    const e = n.match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
                    return !(e && e[1] && e[2] && e[3] && e[1] === e[2] && e[2] === e[3]);
                }
                getWaveColor(n) {
                    const e = getComputedStyle(n);
                    return (
                        e.getPropertyValue('border-top-color') ||
                        e.getPropertyValue('border-color') ||
                        e.getPropertyValue('background-color')
                    );
                }
                runTimeoutOutsideZone(n, e) {
                    this.ngZone.runOutsideAngular(() => setTimeout(n, e));
                }
            }
            const xK = { disabled: !1 },
                bD = new $e('nz-wave-global-options');
            function kK(t) {
                return _s([{ provide: bD, useValue: t }]);
            }
            let Ng = (() => {
                    class t {
                        get disabled() {
                            return this.waveDisabled;
                        }
                        get rendererRef() {
                            return this.waveRenderer;
                        }
                        constructor(e, i, r, s, o, a) {
                            (this.ngZone = e),
                                (this.elementRef = i),
                                (this.config = r),
                                (this.animationType = s),
                                (this.platformId = o),
                                (this.cspNonce = a),
                                (this.nzWaveExtraNode = !1),
                                (this.waveDisabled = !1),
                                (this.waveDisabled = this.isConfigDisabled());
                        }
                        isConfigDisabled() {
                            let e = !1;
                            return (
                                this.config && 'boolean' == typeof this.config.disabled && (e = this.config.disabled),
                                'NoopAnimations' === this.animationType && (e = !0),
                                e
                            );
                        }
                        ngOnDestroy() {
                            this.waveRenderer && this.waveRenderer.destroy();
                        }
                        ngOnInit() {
                            this.renderWaveIfEnabled();
                        }
                        renderWaveIfEnabled() {
                            !this.waveDisabled &&
                                this.elementRef.nativeElement &&
                                (this.waveRenderer = new DK(
                                    this.elementRef.nativeElement,
                                    this.ngZone,
                                    this.nzWaveExtraNode,
                                    this.platformId,
                                    this.cspNonce,
                                ));
                        }
                        disable() {
                            (this.waveDisabled = !0),
                                this.waveRenderer &&
                                    (this.waveRenderer.removeTriggerEvent(),
                                    this.waveRenderer.removeStyleAndExtraNode());
                        }
                        enable() {
                            (this.waveDisabled = this.isConfigDisabled() || !1),
                                this.waveRenderer && this.waveRenderer.bindTriggerEvent();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(en), te(Pn), te(bD, 8), te(W0, 8), te(Za), te(K0, 8));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [
                                ['', 'nz-wave', ''],
                                ['button', 'nz-button', '', 3, 'nzType', 'link', 3, 'nzType', 'text'],
                            ],
                            inputs: { nzWaveExtraNode: 'nzWaveExtraNode' },
                            exportAs: ['nzWave'],
                            standalone: !0,
                        }));
                    }
                    return t;
                })(),
                CD = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ providers: [kK(xK)] }));
                    }
                    return t;
                })();
            const EK = ['nz-button', ''],
                IK = ['*'];
            function AK(t, n) {
                1 & t && Oe(0, 'span', 0);
            }
            let Fg = (() => {
                    class t {
                        insertSpan(e, i) {
                            e.forEach(r => {
                                if ('#text' === r.nodeName) {
                                    const s = i.createElement('span'),
                                        o = i.parentNode(r);
                                    i.insertBefore(o, s, r), i.appendChild(s, r);
                                }
                            });
                        }
                        get iconOnly() {
                            const e = Array.from(this.elementRef?.nativeElement?.childNodes || []),
                                i = e.every(s => '#text' !== s.nodeName),
                                r =
                                    0 ==
                                    e.filter(
                                        s => !('#comment' === s.nodeName || s?.attributes?.getNamedItem('nz-icon')),
                                    ).length;
                            return !!this.nzIconDirectiveElement && r && i;
                        }
                        constructor(e, i, r, s, o, a) {
                            (this.ngZone = e),
                                (this.elementRef = i),
                                (this.cdr = r),
                                (this.renderer = s),
                                (this.nzConfigService = o),
                                (this.directionality = a),
                                (this._nzModuleName = 'button'),
                                (this.nzBlock = !1),
                                (this.nzGhost = !1),
                                (this.nzSearch = !1),
                                (this.nzLoading = !1),
                                (this.nzDanger = !1),
                                (this.disabled = !1),
                                (this.tabIndex = null),
                                (this.nzType = null),
                                (this.nzShape = null),
                                (this.nzSize = 'default'),
                                (this.dir = 'ltr'),
                                (this.destroy$ = new vt()),
                                (this.loading$ = new vt()),
                                this.nzConfigService
                                    .getConfigChangeEventForComponent('button')
                                    .pipe(nn(this.destroy$))
                                    .subscribe(() => {
                                        this.cdr.markForCheck();
                                    });
                        }
                        ngOnInit() {
                            this.directionality.change?.pipe(nn(this.destroy$)).subscribe(e => {
                                (this.dir = e), this.cdr.detectChanges();
                            }),
                                (this.dir = this.directionality.value),
                                this.ngZone.runOutsideAngular(() => {
                                    ca(this.elementRef.nativeElement, 'click', { capture: !0 })
                                        .pipe(nn(this.destroy$))
                                        .subscribe(e => {
                                            ((this.disabled && 'A' === e.target?.tagName) || this.nzLoading) &&
                                                (e.preventDefault(), e.stopImmediatePropagation());
                                        });
                                });
                        }
                        ngOnChanges(e) {
                            const { nzLoading: i } = e;
                            i && this.loading$.next(this.nzLoading);
                        }
                        ngAfterViewInit() {
                            this.insertSpan(this.elementRef.nativeElement.childNodes, this.renderer);
                        }
                        ngAfterContentInit() {
                            this.loading$
                                .pipe(
                                    Pg(this.nzLoading),
                                    al(() => !!this.nzIconDirectiveElement),
                                    nn(this.destroy$),
                                )
                                .subscribe(e => {
                                    const i = this.nzIconDirectiveElement.nativeElement;
                                    e
                                        ? this.renderer.setStyle(i, 'display', 'none')
                                        : this.renderer.removeStyle(i, 'display');
                                });
                        }
                        ngOnDestroy() {
                            this.destroy$.next(), this.destroy$.complete();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(en), te(Pn), te(kr), te(Ps), te(s0), te(yo, 8));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [
                                ['button', 'nz-button', ''],
                                ['a', 'nz-button', ''],
                            ],
                            contentQueries: function (i, r, s) {
                                if ((1 & i && Iy(s, xc, 5, Pn), 2 & i)) {
                                    let o;
                                    Dr((o = xr())) && (r.nzIconDirectiveElement = o.first);
                                }
                            },
                            hostAttrs: [1, 'ant-btn'],
                            hostVars: 34,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    (zi('tabindex', r.disabled ? -1 : null === r.tabIndex ? null : r.tabIndex)(
                                        'disabled',
                                        r.disabled || null,
                                    ),
                                    On('ant-btn-default', 'default' === r.nzType)(
                                        'ant-btn-primary',
                                        'primary' === r.nzType,
                                    )('ant-btn-dashed', 'dashed' === r.nzType)('ant-btn-link', 'link' === r.nzType)(
                                        'ant-btn-text',
                                        'text' === r.nzType,
                                    )('ant-btn-circle', 'circle' === r.nzShape)('ant-btn-round', 'round' === r.nzShape)(
                                        'ant-btn-lg',
                                        'large' === r.nzSize,
                                    )('ant-btn-sm', 'small' === r.nzSize)('ant-btn-dangerous', r.nzDanger)(
                                        'ant-btn-loading',
                                        r.nzLoading,
                                    )('ant-btn-background-ghost', r.nzGhost)('ant-btn-block', r.nzBlock)(
                                        'ant-input-search-button',
                                        r.nzSearch,
                                    )('ant-btn-rtl', 'rtl' === r.dir)('ant-btn-icon-only', r.iconOnly));
                            },
                            inputs: {
                                nzBlock: 'nzBlock',
                                nzGhost: 'nzGhost',
                                nzSearch: 'nzSearch',
                                nzLoading: 'nzLoading',
                                nzDanger: 'nzDanger',
                                disabled: 'disabled',
                                tabIndex: 'tabIndex',
                                nzType: 'nzType',
                                nzShape: 'nzShape',
                                nzSize: 'nzSize',
                            },
                            exportAs: ['nzButton'],
                            standalone: !0,
                            features: [D, Qi],
                            attrs: EK,
                            ngContentSelectors: IK,
                            decls: 2,
                            vars: 1,
                            consts: [['nz-icon', '', 'nzType', 'loading']],
                            template: function (i, r) {
                                1 & i && (H1(), ue(0, AK, 1, 0, 'span', 0), U1(1)),
                                    2 & i && dn(0, r.nzLoading ? 0 : -1);
                            },
                            dependencies: [o0, xc],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return (
                        Lt([En()], t.prototype, 'nzBlock', void 0),
                        Lt([En()], t.prototype, 'nzGhost', void 0),
                        Lt([En()], t.prototype, 'nzSearch', void 0),
                        Lt([En()], t.prototype, 'nzLoading', void 0),
                        Lt([En()], t.prototype, 'nzDanger', void 0),
                        Lt([En()], t.prototype, 'disabled', void 0),
                        Lt([fs()], t.prototype, 'nzSize', void 0),
                        t
                    );
                })(),
                MD = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [Fg, TK, CD] }));
                    }
                    return t;
                })();
            function Fl(t) {
                return (Fl =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (n) {
                              return typeof n;
                          }
                        : function (n) {
                              return n &&
                                  'function' == typeof Symbol &&
                                  n.constructor === Symbol &&
                                  n !== Symbol.prototype
                                  ? 'symbol'
                                  : typeof n;
                          })(t);
            }
            function Ot(t, n) {
                if (n.length < t)
                    throw new TypeError(
                        t + ' argument' + (t > 1 ? 's' : '') + ' required, but only ' + n.length + ' present',
                    );
            }
            function fn(t) {
                Ot(1, arguments);
                var n = Object.prototype.toString.call(t);
                return t instanceof Date || ('object' === Fl(t) && '[object Date]' === n)
                    ? new Date(t.getTime())
                    : 'number' == typeof t || '[object Number]' === n
                    ? new Date(t)
                    : (('string' == typeof t || '[object String]' === n) &&
                          typeof console < 'u' &&
                          (console.warn(
                              "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments",
                          ),
                          console.warn(new Error().stack)),
                      new Date(NaN));
            }
            function fr(t) {
                if (null === t || !0 === t || !1 === t) return NaN;
                var n = Number(t);
                return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
            }
            var SD = {};
            function kc() {
                return SD;
            }
            function TD(t, n) {
                var e, i, r, s, o, a, l, c;
                Ot(1, arguments);
                var f = kc(),
                    g = fr(
                        null !==
                            (e =
                                null !==
                                    (i =
                                        null !==
                                            (r =
                                                null !== (s = n?.weekStartsOn) && void 0 !== s
                                                    ? s
                                                    : null == n ||
                                                      null === (o = n.locale) ||
                                                      void 0 === o ||
                                                      null === (a = o.options) ||
                                                      void 0 === a
                                                    ? void 0
                                                    : a.weekStartsOn) && void 0 !== r
                                            ? r
                                            : f.weekStartsOn) && void 0 !== i
                                    ? i
                                    : null === (l = f.locale) ||
                                      void 0 === l ||
                                      null === (c = l.options) ||
                                      void 0 === c
                                    ? void 0
                                    : c.weekStartsOn) && void 0 !== e
                            ? e
                            : 0,
                    );
                if (!(g >= 0 && g <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                var E = fn(t),
                    P = E.getDay(),
                    V = (P < g ? 7 : 0) + P - g;
                return E.setDate(E.getDate() - V), E.setHours(0, 0, 0, 0), E;
            }
            function DD(t, n) {
                Ot(2, arguments);
                var e = fn(t),
                    i = fr(n);
                if (isNaN(i)) return new Date(NaN);
                if (!i) return e;
                var r = e.getDate(),
                    s = new Date(e.getTime());
                return (
                    s.setMonth(e.getMonth() + i + 1, 0),
                    r >= s.getDate() ? s : (e.setFullYear(s.getFullYear(), s.getMonth(), r), e)
                );
            }
            function VK(t, n) {
                Ot(2, arguments);
                var e = fn(t),
                    i = fn(n);
                return e.getFullYear() === i.getFullYear();
            }
            function HK(t, n) {
                Ot(2, arguments);
                var e = fn(t),
                    i = fn(n);
                return e.getFullYear() === i.getFullYear() && e.getMonth() === i.getMonth();
            }
            function Vf(t) {
                Ot(1, arguments);
                var n = fn(t);
                return n.setHours(0, 0, 0, 0), n;
            }
            function Rg(t, n) {
                Ot(2, arguments);
                var e = Vf(t),
                    i = Vf(n);
                return e.getTime() === i.getTime();
            }
            function xD(t) {
                Ot(1, arguments);
                var n = fn(t);
                return n.setMinutes(0, 0, 0), n;
            }
            function UK(t, n) {
                Ot(2, arguments);
                var e = xD(t),
                    i = xD(n);
                return e.getTime() === i.getTime();
            }
            function kD(t) {
                Ot(1, arguments);
                var n = fn(t);
                return n.setSeconds(0, 0), n;
            }
            function BK(t, n) {
                Ot(2, arguments);
                var e = kD(t),
                    i = kD(n);
                return e.getTime() === i.getTime();
            }
            function ED(t) {
                Ot(1, arguments);
                var n = fn(t);
                return n.setMilliseconds(0), n;
            }
            function qK(t, n) {
                Ot(2, arguments);
                var e = ED(t),
                    i = ED(n);
                return e.getTime() === i.getTime();
            }
            function YK(t, n) {
                Ot(2, arguments);
                var e = fn(t),
                    i = fn(n);
                return e.getFullYear() - i.getFullYear();
            }
            function jK(t, n) {
                Ot(2, arguments);
                var e = fn(t),
                    i = fn(n);
                return 12 * (e.getFullYear() - i.getFullYear()) + (e.getMonth() - i.getMonth());
            }
            function Hf(t) {
                var n = new Date(
                    Date.UTC(
                        t.getFullYear(),
                        t.getMonth(),
                        t.getDate(),
                        t.getHours(),
                        t.getMinutes(),
                        t.getSeconds(),
                        t.getMilliseconds(),
                    ),
                );
                return n.setUTCFullYear(t.getFullYear()), t.getTime() - n.getTime();
            }
            function ID(t, n) {
                Ot(2, arguments);
                var e = Vf(t),
                    i = Vf(n),
                    r = e.getTime() - Hf(e),
                    s = i.getTime() - Hf(i);
                return Math.round((r - s) / 864e5);
            }
            function Vg(t, n) {
                return Ot(2, arguments), fn(t).getTime() - fn(n).getTime();
            }
            Math.pow(10, 8);
            var zD = {
                    ceil: Math.ceil,
                    round: Math.round,
                    floor: Math.floor,
                    trunc: function (n) {
                        return n < 0 ? Math.ceil(n) : Math.floor(n);
                    },
                },
                JK = 'trunc';
            function Hg(t) {
                return t ? zD[t] : zD[JK];
            }
            function eQ(t, n, e) {
                Ot(2, arguments);
                var i = Vg(t, n) / 36e5;
                return Hg(e?.roundingMethod)(i);
            }
            function tQ(t, n, e) {
                Ot(2, arguments);
                var i = Vg(t, n) / 6e4;
                return Hg(e?.roundingMethod)(i);
            }
            function nQ(t, n, e) {
                Ot(2, arguments);
                var i = Vg(t, n) / 1e3;
                return Hg(e?.roundingMethod)(i);
            }
            function a0(t) {
                if (
                    (Ot(1, arguments),
                    !(function rQ(t) {
                        return (
                            Ot(1, arguments),
                            t instanceof Date ||
                                ('object' === Fl(t) && '[object Date]' === Object.prototype.toString.call(t))
                        );
                    })(t) && 'number' != typeof t)
                )
                    return !1;
                var n = fn(t);
                return !isNaN(Number(n));
            }
            function PD(t) {
                const [n, e] = t;
                return !!n && !!e && e.isBeforeDay(n);
            }
            function mh(t) {
                return Array.isArray(t)
                    ? t.map(n => (n instanceof Wn ? n.clone() : null))
                    : t instanceof Wn
                    ? t.clone()
                    : null;
            }
            class Wn {
                constructor(n) {
                    if (n)
                        if (n instanceof Date) this.nativeDate = n;
                        else {
                            if ('string' != typeof n && 'number' != typeof n)
                                throw new Error('The input date type is not supported ("Date" is now recommended)');
                            ku('The string type is not recommended for date-picker, use "Date" type'),
                                (this.nativeDate = new Date(n));
                        }
                    else this.nativeDate = new Date();
                }
                calendarStart(n) {
                    return new Wn(
                        TD(
                            (function LK(t) {
                                Ot(1, arguments);
                                var n = fn(t);
                                return n.setDate(1), n.setHours(0, 0, 0, 0), n;
                            })(this.nativeDate),
                            n,
                        ),
                    );
                }
                getYear() {
                    return this.nativeDate.getFullYear();
                }
                getMonth() {
                    return this.nativeDate.getMonth();
                }
                getDay() {
                    return this.nativeDate.getDay();
                }
                getTime() {
                    return this.nativeDate.getTime();
                }
                getDate() {
                    return this.nativeDate.getDate();
                }
                getHours() {
                    return this.nativeDate.getHours();
                }
                getMinutes() {
                    return this.nativeDate.getMinutes();
                }
                getSeconds() {
                    return this.nativeDate.getSeconds();
                }
                getMilliseconds() {
                    return this.nativeDate.getMilliseconds();
                }
                clone() {
                    return new Wn(new Date(this.nativeDate));
                }
                setHms(n, e, i) {
                    const r = new Date(this.nativeDate.setHours(n, e, i));
                    return new Wn(r);
                }
                setYear(n) {
                    return new Wn(
                        (function OK(t, n) {
                            Ot(2, arguments);
                            var e = fn(t),
                                i = fr(n);
                            return isNaN(e.getTime()) ? new Date(NaN) : (e.setFullYear(i), e);
                        })(this.nativeDate, n),
                    );
                }
                addYears(n) {
                    return new Wn(
                        (function zK(t, n) {
                            return Ot(2, arguments), DD(t, 12 * fr(n));
                        })(this.nativeDate, n),
                    );
                }
                setMonth(n) {
                    return new Wn(
                        (function NK(t, n) {
                            Ot(2, arguments);
                            var e = fn(t),
                                i = fr(n),
                                r = e.getFullYear(),
                                s = e.getDate(),
                                o = new Date(0);
                            o.setFullYear(r, i, 15), o.setHours(0, 0, 0, 0);
                            var a = (function PK(t) {
                                Ot(1, arguments);
                                var n = fn(t),
                                    e = n.getFullYear(),
                                    i = n.getMonth(),
                                    r = new Date(0);
                                return r.setFullYear(e, i + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
                            })(o);
                            return e.setMonth(i, Math.min(s, a)), e;
                        })(this.nativeDate, n),
                    );
                }
                addMonths(n) {
                    return new Wn(DD(this.nativeDate, n));
                }
                setDay(n, e) {
                    return new Wn(
                        (function RK(t, n, e) {
                            var i, r, s, o, a, l, c, f;
                            Ot(2, arguments);
                            var g = kc(),
                                E = fr(
                                    null !==
                                        (i =
                                            null !==
                                                (r =
                                                    null !==
                                                        (s =
                                                            null !== (o = e?.weekStartsOn) && void 0 !== o
                                                                ? o
                                                                : null == e ||
                                                                  null === (a = e.locale) ||
                                                                  void 0 === a ||
                                                                  null === (l = a.options) ||
                                                                  void 0 === l
                                                                ? void 0
                                                                : l.weekStartsOn) && void 0 !== s
                                                        ? s
                                                        : g.weekStartsOn) && void 0 !== r
                                                ? r
                                                : null === (c = g.locale) ||
                                                  void 0 === c ||
                                                  null === (f = c.options) ||
                                                  void 0 === f
                                                ? void 0
                                                : f.weekStartsOn) && void 0 !== i
                                        ? i
                                        : 0,
                                );
                            if (!(E >= 0 && E <= 6))
                                throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                            var P = fn(t),
                                V = fr(n),
                                W = P.getDay(),
                                fe = 7 - E;
                            return (function FK(t, n) {
                                Ot(2, arguments);
                                var e = fn(t),
                                    i = fr(n);
                                return isNaN(i) ? new Date(NaN) : (i && e.setDate(e.getDate() + i), e);
                            })(
                                P,
                                V < 0 || V > 6 ? V - ((W + fe) % 7) : (((((V % 7) + 7) % 7) + fe) % 7) - ((W + fe) % 7),
                            );
                        })(this.nativeDate, n, e),
                    );
                }
                setDate(n) {
                    const e = new Date(this.nativeDate);
                    return e.setDate(n), new Wn(e);
                }
                addDays(n) {
                    return this.setDate(this.getDate() + n);
                }
                add(n, e) {
                    switch (e) {
                        case 'decade':
                            return this.addYears(10 * n);
                        case 'year':
                            return this.addYears(n);
                        default:
                            return this.addMonths(n);
                    }
                }
                isSame(n, e = 'day') {
                    let i;
                    switch (e) {
                        case 'decade':
                            i = (r, s) => Math.abs(r.getFullYear() - s.getFullYear()) < 11;
                            break;
                        case 'year':
                            i = VK;
                            break;
                        case 'month':
                            i = HK;
                            break;
                        case 'day':
                        default:
                            i = Rg;
                            break;
                        case 'hour':
                            i = UK;
                            break;
                        case 'minute':
                            i = BK;
                            break;
                        case 'second':
                            i = qK;
                    }
                    return i(this.nativeDate, this.toNativeDate(n));
                }
                isSameYear(n) {
                    return this.isSame(n, 'year');
                }
                isSameMonth(n) {
                    return this.isSame(n, 'month');
                }
                isSameDay(n) {
                    return this.isSame(n, 'day');
                }
                isSameHour(n) {
                    return this.isSame(n, 'hour');
                }
                isSameMinute(n) {
                    return this.isSame(n, 'minute');
                }
                isSameSecond(n) {
                    return this.isSame(n, 'second');
                }
                isBefore(n, e = 'day') {
                    if (null === n) return !1;
                    let i;
                    switch (e) {
                        case 'year':
                            i = YK;
                            break;
                        case 'month':
                            i = jK;
                            break;
                        case 'day':
                        default:
                            i = ID;
                            break;
                        case 'hour':
                            i = eQ;
                            break;
                        case 'minute':
                            i = tQ;
                            break;
                        case 'second':
                            i = nQ;
                    }
                    return i(this.nativeDate, this.toNativeDate(n)) < 0;
                }
                isBeforeYear(n) {
                    return this.isBefore(n, 'year');
                }
                isBeforeMonth(n) {
                    return this.isBefore(n, 'month');
                }
                isBeforeDay(n) {
                    return this.isBefore(n, 'day');
                }
                isToday() {
                    return (function iQ(t) {
                        return Ot(1, arguments), Rg(t, Date.now());
                    })(this.nativeDate);
                }
                isValid() {
                    return a0(this.nativeDate);
                }
                isFirstDayOfMonth() {
                    return (function sQ(t) {
                        return Ot(1, arguments), 1 === fn(t).getDate();
                    })(this.nativeDate);
                }
                isLastDayOfMonth() {
                    return (function lQ(t) {
                        Ot(1, arguments);
                        var n = fn(t);
                        return (
                            (function oQ(t) {
                                Ot(1, arguments);
                                var n = fn(t);
                                return n.setHours(23, 59, 59, 999), n;
                            })(n).getTime() ===
                            (function aQ(t) {
                                Ot(1, arguments);
                                var n = fn(t),
                                    e = n.getMonth();
                                return n.setFullYear(n.getFullYear(), e + 1, 0), n.setHours(23, 59, 59, 999), n;
                            })(n).getTime()
                        );
                    })(this.nativeDate);
                }
                toNativeDate(n) {
                    return n instanceof Wn ? n.nativeDate : n;
                }
            }
            class uQ {
                constructor(n, e) {
                    (this.format = n),
                        (this.localeId = e),
                        (this.regex = null),
                        (this.matchMap = {
                            hour: null,
                            minute: null,
                            second: null,
                            periodNarrow: null,
                            periodWide: null,
                            periodAbbreviated: null,
                        }),
                        this.genRegexp();
                }
                toDate(n) {
                    const e = this.getTimeResult(n),
                        i = new Date();
                    return (
                        Fi(e?.hour) && i.setHours(e.hour),
                        Fi(e?.minute) && i.setMinutes(e.minute),
                        Fi(e?.second) && i.setSeconds(e.second),
                        1 === e?.period && i.getHours() < 12 && i.setHours(i.getHours() + 12),
                        i
                    );
                }
                getTimeResult(n) {
                    const e = this.regex.exec(n);
                    let i = null;
                    return e
                        ? (Fi(this.matchMap.periodNarrow) &&
                              (i = gu(this.localeId, Er.Format, Jn.Narrow).indexOf(e[this.matchMap.periodNarrow + 1])),
                          Fi(this.matchMap.periodWide) &&
                              (i = gu(this.localeId, Er.Format, Jn.Wide).indexOf(e[this.matchMap.periodWide + 1])),
                          Fi(this.matchMap.periodAbbreviated) &&
                              (i = gu(this.localeId, Er.Format, Jn.Abbreviated).indexOf(
                                  e[this.matchMap.periodAbbreviated + 1],
                              )),
                          {
                              hour: Fi(this.matchMap.hour) ? Number.parseInt(e[this.matchMap.hour + 1], 10) : null,
                              minute: Fi(this.matchMap.minute)
                                  ? Number.parseInt(e[this.matchMap.minute + 1], 10)
                                  : null,
                              second: Fi(this.matchMap.second)
                                  ? Number.parseInt(e[this.matchMap.second + 1], 10)
                                  : null,
                              period: i,
                          })
                        : null;
                }
                genRegexp() {
                    let n = this.format.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$&');
                    const e = /h{1,2}/i,
                        i = /m{1,2}/,
                        r = /s{1,2}/,
                        s = /aaaaa/,
                        o = /aaaa/,
                        a = /a{1,3}/,
                        l = e.exec(this.format),
                        c = i.exec(this.format),
                        f = r.exec(this.format),
                        g = s.exec(this.format);
                    let E = null,
                        P = null;
                    g || (E = o.exec(this.format)),
                        !E && !g && (P = a.exec(this.format)),
                        [l, c, f, g, E, P]
                            .filter(W => !!W)
                            .sort((W, ie) => W.index - ie.index)
                            .forEach((W, ie) => {
                                switch (W) {
                                    case l:
                                        (this.matchMap.hour = ie), (n = n.replace(e, '(\\d{1,2})'));
                                        break;
                                    case c:
                                        (this.matchMap.minute = ie), (n = n.replace(i, '(\\d{1,2})'));
                                        break;
                                    case f:
                                        (this.matchMap.second = ie), (n = n.replace(r, '(\\d{1,2})'));
                                        break;
                                    case g:
                                        this.matchMap.periodNarrow = ie;
                                        const he = gu(this.localeId, Er.Format, Jn.Narrow).join('|');
                                        n = n.replace(s, `(${he})`);
                                        break;
                                    case E:
                                        this.matchMap.periodWide = ie;
                                        const fe = gu(this.localeId, Er.Format, Jn.Wide).join('|');
                                        n = n.replace(o, `(${fe})`);
                                        break;
                                    case P:
                                        this.matchMap.periodAbbreviated = ie;
                                        const ze = gu(this.localeId, Er.Format, Jn.Abbreviated).join('|');
                                        n = n.replace(a, `(${ze})`);
                                }
                            }),
                        (this.regex = new RegExp(n));
                }
            }
            function Uf(t) {
                return Ot(1, arguments), TD(t, { weekStartsOn: 1 });
            }
            function ND(t, n) {
                return (
                    Ot(2, arguments),
                    (function pQ(t, n) {
                        Ot(2, arguments);
                        var e = fn(t).getTime(),
                            i = fr(n);
                        return new Date(e + i);
                    })(t, -fr(n))
                );
            }
            function l0(t) {
                Ot(1, arguments);
                var e = fn(t),
                    i = e.getUTCDay(),
                    r = (i < 1 ? 7 : 0) + i - 1;
                return e.setUTCDate(e.getUTCDate() - r), e.setUTCHours(0, 0, 0, 0), e;
            }
            function FD(t) {
                Ot(1, arguments);
                var n = fn(t),
                    e = n.getUTCFullYear(),
                    i = new Date(0);
                i.setUTCFullYear(e + 1, 0, 4), i.setUTCHours(0, 0, 0, 0);
                var r = l0(i),
                    s = new Date(0);
                s.setUTCFullYear(e, 0, 4), s.setUTCHours(0, 0, 0, 0);
                var o = l0(s);
                return n.getTime() >= r.getTime() ? e + 1 : n.getTime() >= o.getTime() ? e : e - 1;
            }
            function RD(t) {
                Ot(1, arguments);
                var n = fn(t),
                    e =
                        l0(n).getTime() -
                        (function _Q(t) {
                            Ot(1, arguments);
                            var n = FD(t),
                                e = new Date(0);
                            return e.setUTCFullYear(n, 0, 4), e.setUTCHours(0, 0, 0, 0), l0(e);
                        })(n).getTime();
                return Math.round(e / 6048e5) + 1;
            }
            function Lu(t, n) {
                var e, i, r, s, o, a, l, c;
                Ot(1, arguments);
                var f = kc(),
                    g = fr(
                        null !==
                            (e =
                                null !==
                                    (i =
                                        null !==
                                            (r =
                                                null !== (s = n?.weekStartsOn) && void 0 !== s
                                                    ? s
                                                    : null == n ||
                                                      null === (o = n.locale) ||
                                                      void 0 === o ||
                                                      null === (a = o.options) ||
                                                      void 0 === a
                                                    ? void 0
                                                    : a.weekStartsOn) && void 0 !== r
                                            ? r
                                            : f.weekStartsOn) && void 0 !== i
                                    ? i
                                    : null === (l = f.locale) ||
                                      void 0 === l ||
                                      null === (c = l.options) ||
                                      void 0 === c
                                    ? void 0
                                    : c.weekStartsOn) && void 0 !== e
                            ? e
                            : 0,
                    );
                if (!(g >= 0 && g <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                var E = fn(t),
                    P = E.getUTCDay(),
                    V = (P < g ? 7 : 0) + P - g;
                return E.setUTCDate(E.getUTCDate() - V), E.setUTCHours(0, 0, 0, 0), E;
            }
            function Ug(t, n) {
                var e, i, r, s, o, a, l, c;
                Ot(1, arguments);
                var f = fn(t),
                    g = f.getUTCFullYear(),
                    E = kc(),
                    P = fr(
                        null !==
                            (e =
                                null !==
                                    (i =
                                        null !==
                                            (r =
                                                null !== (s = n?.firstWeekContainsDate) && void 0 !== s
                                                    ? s
                                                    : null == n ||
                                                      null === (o = n.locale) ||
                                                      void 0 === o ||
                                                      null === (a = o.options) ||
                                                      void 0 === a
                                                    ? void 0
                                                    : a.firstWeekContainsDate) && void 0 !== r
                                            ? r
                                            : E.firstWeekContainsDate) && void 0 !== i
                                    ? i
                                    : null === (l = E.locale) ||
                                      void 0 === l ||
                                      null === (c = l.options) ||
                                      void 0 === c
                                    ? void 0
                                    : c.firstWeekContainsDate) && void 0 !== e
                            ? e
                            : 1,
                    );
                if (!(P >= 1 && P <= 7))
                    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
                var V = new Date(0);
                V.setUTCFullYear(g + 1, 0, P), V.setUTCHours(0, 0, 0, 0);
                var W = Lu(V, n),
                    ie = new Date(0);
                ie.setUTCFullYear(g, 0, P), ie.setUTCHours(0, 0, 0, 0);
                var he = Lu(ie, n);
                return f.getTime() >= W.getTime() ? g + 1 : f.getTime() >= he.getTime() ? g : g - 1;
            }
            function VD(t, n) {
                Ot(1, arguments);
                var e = fn(t),
                    i =
                        Lu(e, n).getTime() -
                        (function bQ(t, n) {
                            var e, i, r, s, o, a, l, c;
                            Ot(1, arguments);
                            var f = kc(),
                                g = fr(
                                    null !==
                                        (e =
                                            null !==
                                                (i =
                                                    null !==
                                                        (r =
                                                            null !== (s = n?.firstWeekContainsDate) && void 0 !== s
                                                                ? s
                                                                : null == n ||
                                                                  null === (o = n.locale) ||
                                                                  void 0 === o ||
                                                                  null === (a = o.options) ||
                                                                  void 0 === a
                                                                ? void 0
                                                                : a.firstWeekContainsDate) && void 0 !== r
                                                        ? r
                                                        : f.firstWeekContainsDate) && void 0 !== i
                                                ? i
                                                : null === (l = f.locale) ||
                                                  void 0 === l ||
                                                  null === (c = l.options) ||
                                                  void 0 === c
                                                ? void 0
                                                : c.firstWeekContainsDate) && void 0 !== e
                                        ? e
                                        : 1,
                                ),
                                E = Ug(t, n),
                                P = new Date(0);
                            return P.setUTCFullYear(E, 0, g), P.setUTCHours(0, 0, 0, 0), Lu(P, n);
                        })(e, n).getTime();
                return Math.round(i / 6048e5) + 1;
            }
            function Mi(t, n) {
                for (var e = t < 0 ? '-' : '', i = Math.abs(t).toString(); i.length < n; ) i = '0' + i;
                return e + i;
            }
            const Ec_y = function (n, e) {
                    var i = n.getUTCFullYear(),
                        r = i > 0 ? i : 1 - i;
                    return Mi('yy' === e ? r % 100 : r, e.length);
                },
                Ec_M = function (n, e) {
                    var i = n.getUTCMonth();
                    return 'M' === e ? String(i + 1) : Mi(i + 1, 2);
                },
                Ec_d = function (n, e) {
                    return Mi(n.getUTCDate(), e.length);
                },
                Ec_h = function (n, e) {
                    return Mi(n.getUTCHours() % 12 || 12, e.length);
                },
                Ec_H = function (n, e) {
                    return Mi(n.getUTCHours(), e.length);
                },
                Ec_m = function (n, e) {
                    return Mi(n.getUTCMinutes(), e.length);
                },
                Ec_s = function (n, e) {
                    return Mi(n.getUTCSeconds(), e.length);
                },
                Ec_S = function (n, e) {
                    var i = e.length,
                        r = n.getUTCMilliseconds();
                    return Mi(Math.floor(r * Math.pow(10, i - 3)), e.length);
                };
            function HD(t, n) {
                var e = t > 0 ? '-' : '+',
                    i = Math.abs(t),
                    r = Math.floor(i / 60),
                    s = i % 60;
                if (0 === s) return e + String(r);
                var o = n || '';
                return e + String(r) + o + Mi(s, 2);
            }
            function UD(t, n) {
                return t % 60 == 0 ? (t > 0 ? '-' : '+') + Mi(Math.abs(t) / 60, 2) : Ou(t, n);
            }
            function Ou(t, n) {
                var e = n || '',
                    i = t > 0 ? '-' : '+',
                    r = Math.abs(t);
                return i + Mi(Math.floor(r / 60), 2) + e + Mi(r % 60, 2);
            }
            const SQ = {
                G: function (n, e, i) {
                    var r = n.getUTCFullYear() > 0 ? 1 : 0;
                    switch (e) {
                        case 'G':
                        case 'GG':
                        case 'GGG':
                            return i.era(r, { width: 'abbreviated' });
                        case 'GGGGG':
                            return i.era(r, { width: 'narrow' });
                        default:
                            return i.era(r, { width: 'wide' });
                    }
                },
                y: function (n, e, i) {
                    if ('yo' === e) {
                        var r = n.getUTCFullYear();
                        return i.ordinalNumber(r > 0 ? r : 1 - r, { unit: 'year' });
                    }
                    return Ec_y(n, e);
                },
                Y: function (n, e, i, r) {
                    var s = Ug(n, r),
                        o = s > 0 ? s : 1 - s;
                    return 'YY' === e
                        ? Mi(o % 100, 2)
                        : 'Yo' === e
                        ? i.ordinalNumber(o, { unit: 'year' })
                        : Mi(o, e.length);
                },
                R: function (n, e) {
                    return Mi(FD(n), e.length);
                },
                u: function (n, e) {
                    return Mi(n.getUTCFullYear(), e.length);
                },
                Q: function (n, e, i) {
                    var r = Math.ceil((n.getUTCMonth() + 1) / 3);
                    switch (e) {
                        case 'Q':
                            return String(r);
                        case 'QQ':
                            return Mi(r, 2);
                        case 'Qo':
                            return i.ordinalNumber(r, { unit: 'quarter' });
                        case 'QQQ':
                            return i.quarter(r, { width: 'abbreviated', context: 'formatting' });
                        case 'QQQQQ':
                            return i.quarter(r, { width: 'narrow', context: 'formatting' });
                        default:
                            return i.quarter(r, { width: 'wide', context: 'formatting' });
                    }
                },
                q: function (n, e, i) {
                    var r = Math.ceil((n.getUTCMonth() + 1) / 3);
                    switch (e) {
                        case 'q':
                            return String(r);
                        case 'qq':
                            return Mi(r, 2);
                        case 'qo':
                            return i.ordinalNumber(r, { unit: 'quarter' });
                        case 'qqq':
                            return i.quarter(r, { width: 'abbreviated', context: 'standalone' });
                        case 'qqqqq':
                            return i.quarter(r, { width: 'narrow', context: 'standalone' });
                        default:
                            return i.quarter(r, { width: 'wide', context: 'standalone' });
                    }
                },
                M: function (n, e, i) {
                    var r = n.getUTCMonth();
                    switch (e) {
                        case 'M':
                        case 'MM':
                            return Ec_M(n, e);
                        case 'Mo':
                            return i.ordinalNumber(r + 1, { unit: 'month' });
                        case 'MMM':
                            return i.month(r, { width: 'abbreviated', context: 'formatting' });
                        case 'MMMMM':
                            return i.month(r, { width: 'narrow', context: 'formatting' });
                        default:
                            return i.month(r, { width: 'wide', context: 'formatting' });
                    }
                },
                L: function (n, e, i) {
                    var r = n.getUTCMonth();
                    switch (e) {
                        case 'L':
                            return String(r + 1);
                        case 'LL':
                            return Mi(r + 1, 2);
                        case 'Lo':
                            return i.ordinalNumber(r + 1, { unit: 'month' });
                        case 'LLL':
                            return i.month(r, { width: 'abbreviated', context: 'standalone' });
                        case 'LLLLL':
                            return i.month(r, { width: 'narrow', context: 'standalone' });
                        default:
                            return i.month(r, { width: 'wide', context: 'standalone' });
                    }
                },
                w: function (n, e, i, r) {
                    var s = VD(n, r);
                    return 'wo' === e ? i.ordinalNumber(s, { unit: 'week' }) : Mi(s, e.length);
                },
                I: function (n, e, i) {
                    var r = RD(n);
                    return 'Io' === e ? i.ordinalNumber(r, { unit: 'week' }) : Mi(r, e.length);
                },
                d: function (n, e, i) {
                    return 'do' === e ? i.ordinalNumber(n.getUTCDate(), { unit: 'date' }) : Ec_d(n, e);
                },
                D: function (n, e, i) {
                    var r = (function vQ(t) {
                        Ot(1, arguments);
                        var n = fn(t),
                            e = n.getTime();
                        n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
                        var i = n.getTime();
                        return Math.floor((e - i) / 864e5) + 1;
                    })(n);
                    return 'Do' === e ? i.ordinalNumber(r, { unit: 'dayOfYear' }) : Mi(r, e.length);
                },
                E: function (n, e, i) {
                    var r = n.getUTCDay();
                    switch (e) {
                        case 'E':
                        case 'EE':
                        case 'EEE':
                            return i.day(r, { width: 'abbreviated', context: 'formatting' });
                        case 'EEEEE':
                            return i.day(r, { width: 'narrow', context: 'formatting' });
                        case 'EEEEEE':
                            return i.day(r, { width: 'short', context: 'formatting' });
                        default:
                            return i.day(r, { width: 'wide', context: 'formatting' });
                    }
                },
                e: function (n, e, i, r) {
                    var s = n.getUTCDay(),
                        o = (s - r.weekStartsOn + 8) % 7 || 7;
                    switch (e) {
                        case 'e':
                            return String(o);
                        case 'ee':
                            return Mi(o, 2);
                        case 'eo':
                            return i.ordinalNumber(o, { unit: 'day' });
                        case 'eee':
                            return i.day(s, { width: 'abbreviated', context: 'formatting' });
                        case 'eeeee':
                            return i.day(s, { width: 'narrow', context: 'formatting' });
                        case 'eeeeee':
                            return i.day(s, { width: 'short', context: 'formatting' });
                        default:
                            return i.day(s, { width: 'wide', context: 'formatting' });
                    }
                },
                c: function (n, e, i, r) {
                    var s = n.getUTCDay(),
                        o = (s - r.weekStartsOn + 8) % 7 || 7;
                    switch (e) {
                        case 'c':
                            return String(o);
                        case 'cc':
                            return Mi(o, e.length);
                        case 'co':
                            return i.ordinalNumber(o, { unit: 'day' });
                        case 'ccc':
                            return i.day(s, { width: 'abbreviated', context: 'standalone' });
                        case 'ccccc':
                            return i.day(s, { width: 'narrow', context: 'standalone' });
                        case 'cccccc':
                            return i.day(s, { width: 'short', context: 'standalone' });
                        default:
                            return i.day(s, { width: 'wide', context: 'standalone' });
                    }
                },
                i: function (n, e, i) {
                    var r = n.getUTCDay(),
                        s = 0 === r ? 7 : r;
                    switch (e) {
                        case 'i':
                            return String(s);
                        case 'ii':
                            return Mi(s, e.length);
                        case 'io':
                            return i.ordinalNumber(s, { unit: 'day' });
                        case 'iii':
                            return i.day(r, { width: 'abbreviated', context: 'formatting' });
                        case 'iiiii':
                            return i.day(r, { width: 'narrow', context: 'formatting' });
                        case 'iiiiii':
                            return i.day(r, { width: 'short', context: 'formatting' });
                        default:
                            return i.day(r, { width: 'wide', context: 'formatting' });
                    }
                },
                a: function (n, e, i) {
                    var s = n.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
                    switch (e) {
                        case 'a':
                        case 'aa':
                            return i.dayPeriod(s, { width: 'abbreviated', context: 'formatting' });
                        case 'aaa':
                            return i.dayPeriod(s, { width: 'abbreviated', context: 'formatting' }).toLowerCase();
                        case 'aaaaa':
                            return i.dayPeriod(s, { width: 'narrow', context: 'formatting' });
                        default:
                            return i.dayPeriod(s, { width: 'wide', context: 'formatting' });
                    }
                },
                b: function (n, e, i) {
                    var s,
                        r = n.getUTCHours();
                    switch (((s = 12 === r ? 'noon' : 0 === r ? 'midnight' : r / 12 >= 1 ? 'pm' : 'am'), e)) {
                        case 'b':
                        case 'bb':
                            return i.dayPeriod(s, { width: 'abbreviated', context: 'formatting' });
                        case 'bbb':
                            return i.dayPeriod(s, { width: 'abbreviated', context: 'formatting' }).toLowerCase();
                        case 'bbbbb':
                            return i.dayPeriod(s, { width: 'narrow', context: 'formatting' });
                        default:
                            return i.dayPeriod(s, { width: 'wide', context: 'formatting' });
                    }
                },
                B: function (n, e, i) {
                    var s,
                        r = n.getUTCHours();
                    switch (((s = r >= 17 ? 'evening' : r >= 12 ? 'afternoon' : r >= 4 ? 'morning' : 'night'), e)) {
                        case 'B':
                        case 'BB':
                        case 'BBB':
                            return i.dayPeriod(s, { width: 'abbreviated', context: 'formatting' });
                        case 'BBBBB':
                            return i.dayPeriod(s, { width: 'narrow', context: 'formatting' });
                        default:
                            return i.dayPeriod(s, { width: 'wide', context: 'formatting' });
                    }
                },
                h: function (n, e, i) {
                    if ('ho' === e) {
                        var r = n.getUTCHours() % 12;
                        return 0 === r && (r = 12), i.ordinalNumber(r, { unit: 'hour' });
                    }
                    return Ec_h(n, e);
                },
                H: function (n, e, i) {
                    return 'Ho' === e ? i.ordinalNumber(n.getUTCHours(), { unit: 'hour' }) : Ec_H(n, e);
                },
                K: function (n, e, i) {
                    var r = n.getUTCHours() % 12;
                    return 'Ko' === e ? i.ordinalNumber(r, { unit: 'hour' }) : Mi(r, e.length);
                },
                k: function (n, e, i) {
                    var r = n.getUTCHours();
                    return 0 === r && (r = 24), 'ko' === e ? i.ordinalNumber(r, { unit: 'hour' }) : Mi(r, e.length);
                },
                m: function (n, e, i) {
                    return 'mo' === e ? i.ordinalNumber(n.getUTCMinutes(), { unit: 'minute' }) : Ec_m(n, e);
                },
                s: function (n, e, i) {
                    return 'so' === e ? i.ordinalNumber(n.getUTCSeconds(), { unit: 'second' }) : Ec_s(n, e);
                },
                S: function (n, e) {
                    return Ec_S(n, e);
                },
                X: function (n, e, i, r) {
                    var o = (r._originalDate || n).getTimezoneOffset();
                    if (0 === o) return 'Z';
                    switch (e) {
                        case 'X':
                            return UD(o);
                        case 'XXXX':
                        case 'XX':
                            return Ou(o);
                        default:
                            return Ou(o, ':');
                    }
                },
                x: function (n, e, i, r) {
                    var o = (r._originalDate || n).getTimezoneOffset();
                    switch (e) {
                        case 'x':
                            return UD(o);
                        case 'xxxx':
                        case 'xx':
                            return Ou(o);
                        default:
                            return Ou(o, ':');
                    }
                },
                O: function (n, e, i, r) {
                    var o = (r._originalDate || n).getTimezoneOffset();
                    switch (e) {
                        case 'O':
                        case 'OO':
                        case 'OOO':
                            return 'GMT' + HD(o, ':');
                        default:
                            return 'GMT' + Ou(o, ':');
                    }
                },
                z: function (n, e, i, r) {
                    var o = (r._originalDate || n).getTimezoneOffset();
                    switch (e) {
                        case 'z':
                        case 'zz':
                        case 'zzz':
                            return 'GMT' + HD(o, ':');
                        default:
                            return 'GMT' + Ou(o, ':');
                    }
                },
                t: function (n, e, i, r) {
                    return Mi(Math.floor((r._originalDate || n).getTime() / 1e3), e.length);
                },
                T: function (n, e, i, r) {
                    return Mi((r._originalDate || n).getTime(), e.length);
                },
            };
            var BD = function (n, e) {
                    switch (n) {
                        case 'P':
                            return e.date({ width: 'short' });
                        case 'PP':
                            return e.date({ width: 'medium' });
                        case 'PPP':
                            return e.date({ width: 'long' });
                        default:
                            return e.date({ width: 'full' });
                    }
                },
                qD = function (n, e) {
                    switch (n) {
                        case 'p':
                            return e.time({ width: 'short' });
                        case 'pp':
                            return e.time({ width: 'medium' });
                        case 'ppp':
                            return e.time({ width: 'long' });
                        default:
                            return e.time({ width: 'full' });
                    }
                };
            const Bg = {
                p: qD,
                P: function (n, e) {
                    var o,
                        i = n.match(/(P+)(p+)?/) || [],
                        r = i[1],
                        s = i[2];
                    if (!s) return BD(n, e);
                    switch (r) {
                        case 'P':
                            o = e.dateTime({ width: 'short' });
                            break;
                        case 'PP':
                            o = e.dateTime({ width: 'medium' });
                            break;
                        case 'PPP':
                            o = e.dateTime({ width: 'long' });
                            break;
                        default:
                            o = e.dateTime({ width: 'full' });
                    }
                    return o.replace('{{date}}', BD(r, e)).replace('{{time}}', qD(s, e));
                },
            };
            var xQ = ['D', 'DD'],
                kQ = ['YY', 'YYYY'];
            function YD(t) {
                return -1 !== xQ.indexOf(t);
            }
            function jD(t) {
                return -1 !== kQ.indexOf(t);
            }
            function Bf(t, n, e) {
                if ('YYYY' === t)
                    throw new RangeError(
                        'Use `yyyy` instead of `YYYY` (in `'
                            .concat(n, '`) for formatting years to the input `')
                            .concat(
                                e,
                                '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md',
                            ),
                    );
                if ('YY' === t)
                    throw new RangeError(
                        'Use `yy` instead of `YY` (in `'
                            .concat(n, '`) for formatting years to the input `')
                            .concat(
                                e,
                                '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md',
                            ),
                    );
                if ('D' === t)
                    throw new RangeError(
                        'Use `d` instead of `D` (in `'
                            .concat(n, '`) for formatting days of the month to the input `')
                            .concat(
                                e,
                                '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md',
                            ),
                    );
                if ('DD' === t)
                    throw new RangeError(
                        'Use `dd` instead of `DD` (in `'
                            .concat(n, '`) for formatting days of the month to the input `')
                            .concat(
                                e,
                                '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md',
                            ),
                    );
            }
            var EQ = {
                lessThanXSeconds: { one: 'less than a second', other: 'less than {{count}} seconds' },
                xSeconds: { one: '1 second', other: '{{count}} seconds' },
                halfAMinute: 'half a minute',
                lessThanXMinutes: { one: 'less than a minute', other: 'less than {{count}} minutes' },
                xMinutes: { one: '1 minute', other: '{{count}} minutes' },
                aboutXHours: { one: 'about 1 hour', other: 'about {{count}} hours' },
                xHours: { one: '1 hour', other: '{{count}} hours' },
                xDays: { one: '1 day', other: '{{count}} days' },
                aboutXWeeks: { one: 'about 1 week', other: 'about {{count}} weeks' },
                xWeeks: { one: '1 week', other: '{{count}} weeks' },
                aboutXMonths: { one: 'about 1 month', other: 'about {{count}} months' },
                xMonths: { one: '1 month', other: '{{count}} months' },
                aboutXYears: { one: 'about 1 year', other: 'about {{count}} years' },
                xYears: { one: '1 year', other: '{{count}} years' },
                overXYears: { one: 'over 1 year', other: 'over {{count}} years' },
                almostXYears: { one: 'almost 1 year', other: 'almost {{count}} years' },
            };
            function qg(t) {
                return function () {
                    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                        e = n.width ? String(n.width) : t.defaultWidth;
                    return t.formats[e] || t.formats[t.defaultWidth];
                };
            }
            var PQ = {
                    date: qg({
                        formats: {
                            full: 'EEEE, MMMM do, y',
                            long: 'MMMM do, y',
                            medium: 'MMM d, y',
                            short: 'MM/dd/yyyy',
                        },
                        defaultWidth: 'full',
                    }),
                    time: qg({
                        formats: { full: 'h:mm:ss a zzzz', long: 'h:mm:ss a z', medium: 'h:mm:ss a', short: 'h:mm a' },
                        defaultWidth: 'full',
                    }),
                    dateTime: qg({
                        formats: {
                            full: "{{date}} 'at' {{time}}",
                            long: "{{date}} 'at' {{time}}",
                            medium: '{{date}}, {{time}}',
                            short: '{{date}}, {{time}}',
                        },
                        defaultWidth: 'full',
                    }),
                },
                FQ = {
                    lastWeek: "'last' eeee 'at' p",
                    yesterday: "'yesterday at' p",
                    today: "'today at' p",
                    tomorrow: "'tomorrow at' p",
                    nextWeek: "eeee 'at' p",
                    other: 'P',
                };
            function ph(t) {
                return function (n, e) {
                    var r;
                    if (
                        'formatting' === (null != e && e.context ? String(e.context) : 'standalone') &&
                        t.formattingValues
                    ) {
                        var s = t.defaultFormattingWidth || t.defaultWidth,
                            o = null != e && e.width ? String(e.width) : s;
                        r = t.formattingValues[o] || t.formattingValues[s];
                    } else {
                        var a = t.defaultWidth,
                            l = null != e && e.width ? String(e.width) : t.defaultWidth;
                        r = t.values[l] || t.values[a];
                    }
                    return r[t.argumentCallback ? t.argumentCallback(n) : n];
                };
            }
            function gh(t) {
                return function (n) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        i = e.width,
                        s = n.match((i && t.matchPatterns[i]) || t.matchPatterns[t.defaultMatchWidth]);
                    if (!s) return null;
                    var c,
                        o = s[0],
                        a = (i && t.parsePatterns[i]) || t.parsePatterns[t.defaultParseWidth],
                        l = Array.isArray(a)
                            ? (function QQ(t, n) {
                                  for (var e = 0; e < t.length; e++) if (n(t[e])) return e;
                              })(a, function (g) {
                                  return g.test(o);
                              })
                            : (function KQ(t, n) {
                                  for (var e in t) if (t.hasOwnProperty(e) && n(t[e])) return e;
                              })(a, function (g) {
                                  return g.test(o);
                              });
                    return (
                        (c = t.valueCallback ? t.valueCallback(l) : l),
                        { value: (c = e.valueCallback ? e.valueCallback(c) : c), rest: n.slice(o.length) }
                    );
                };
            }
            const $D = {
                code: 'en-US',
                formatDistance: function (n, e, i) {
                    var r,
                        s = EQ[n];
                    return (
                        (r = 'string' == typeof s ? s : 1 === e ? s.one : s.other.replace('{{count}}', e.toString())),
                        null != i && i.addSuffix ? (i.comparison && i.comparison > 0 ? 'in ' + r : r + ' ago') : r
                    );
                },
                formatLong: PQ,
                formatRelative: function (n, e, i, r) {
                    return FQ[n];
                },
                localize: {
                    ordinalNumber: function (n, e) {
                        var i = Number(n),
                            r = i % 100;
                        if (r > 20 || r < 10)
                            switch (r % 10) {
                                case 1:
                                    return i + 'st';
                                case 2:
                                    return i + 'nd';
                                case 3:
                                    return i + 'rd';
                            }
                        return i + 'th';
                    },
                    era: ph({
                        values: {
                            narrow: ['B', 'A'],
                            abbreviated: ['BC', 'AD'],
                            wide: ['Before Christ', 'Anno Domini'],
                        },
                        defaultWidth: 'wide',
                    }),
                    quarter: ph({
                        values: {
                            narrow: ['1', '2', '3', '4'],
                            abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
                            wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'],
                        },
                        defaultWidth: 'wide',
                        argumentCallback: function (n) {
                            return n - 1;
                        },
                    }),
                    month: ph({
                        values: {
                            narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
                            abbreviated: [
                                'Jan',
                                'Feb',
                                'Mar',
                                'Apr',
                                'May',
                                'Jun',
                                'Jul',
                                'Aug',
                                'Sep',
                                'Oct',
                                'Nov',
                                'Dec',
                            ],
                            wide: [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                            ],
                        },
                        defaultWidth: 'wide',
                    }),
                    day: ph({
                        values: {
                            narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                            short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                            abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                            wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                        },
                        defaultWidth: 'wide',
                    }),
                    dayPeriod: ph({
                        values: {
                            narrow: {
                                am: 'a',
                                pm: 'p',
                                midnight: 'mi',
                                noon: 'n',
                                morning: 'morning',
                                afternoon: 'afternoon',
                                evening: 'evening',
                                night: 'night',
                            },
                            abbreviated: {
                                am: 'AM',
                                pm: 'PM',
                                midnight: 'midnight',
                                noon: 'noon',
                                morning: 'morning',
                                afternoon: 'afternoon',
                                evening: 'evening',
                                night: 'night',
                            },
                            wide: {
                                am: 'a.m.',
                                pm: 'p.m.',
                                midnight: 'midnight',
                                noon: 'noon',
                                morning: 'morning',
                                afternoon: 'afternoon',
                                evening: 'evening',
                                night: 'night',
                            },
                        },
                        defaultWidth: 'wide',
                        formattingValues: {
                            narrow: {
                                am: 'a',
                                pm: 'p',
                                midnight: 'mi',
                                noon: 'n',
                                morning: 'in the morning',
                                afternoon: 'in the afternoon',
                                evening: 'in the evening',
                                night: 'at night',
                            },
                            abbreviated: {
                                am: 'AM',
                                pm: 'PM',
                                midnight: 'midnight',
                                noon: 'noon',
                                morning: 'in the morning',
                                afternoon: 'in the afternoon',
                                evening: 'in the evening',
                                night: 'at night',
                            },
                            wide: {
                                am: 'a.m.',
                                pm: 'p.m.',
                                midnight: 'midnight',
                                noon: 'noon',
                                morning: 'in the morning',
                                afternoon: 'in the afternoon',
                                evening: 'in the evening',
                                night: 'at night',
                            },
                        },
                        defaultFormattingWidth: 'wide',
                    }),
                },
                match: {
                    ordinalNumber: (function XQ(t) {
                        return function (n) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                                i = n.match(t.matchPattern);
                            if (!i) return null;
                            var r = i[0],
                                s = n.match(t.parsePattern);
                            if (!s) return null;
                            var o = t.valueCallback ? t.valueCallback(s[0]) : s[0];
                            return { value: (o = e.valueCallback ? e.valueCallback(o) : o), rest: n.slice(r.length) };
                        };
                    })({
                        matchPattern: /^(\d+)(th|st|nd|rd)?/i,
                        parsePattern: /\d+/i,
                        valueCallback: function (n) {
                            return parseInt(n, 10);
                        },
                    }),
                    era: gh({
                        matchPatterns: {
                            narrow: /^(b|a)/i,
                            abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                            wide: /^(before christ|before common era|anno domini|common era)/i,
                        },
                        defaultMatchWidth: 'wide',
                        parsePatterns: { any: [/^b/i, /^(a|c)/i] },
                        defaultParseWidth: 'any',
                    }),
                    quarter: gh({
                        matchPatterns: {
                            narrow: /^[1234]/i,
                            abbreviated: /^q[1234]/i,
                            wide: /^[1234](th|st|nd|rd)? quarter/i,
                        },
                        defaultMatchWidth: 'wide',
                        parsePatterns: { any: [/1/i, /2/i, /3/i, /4/i] },
                        defaultParseWidth: 'any',
                        valueCallback: function (n) {
                            return n + 1;
                        },
                    }),
                    month: gh({
                        matchPatterns: {
                            narrow: /^[jfmasond]/i,
                            abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                            wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
                        },
                        defaultMatchWidth: 'wide',
                        parsePatterns: {
                            narrow: [
                                /^j/i,
                                /^f/i,
                                /^m/i,
                                /^a/i,
                                /^m/i,
                                /^j/i,
                                /^j/i,
                                /^a/i,
                                /^s/i,
                                /^o/i,
                                /^n/i,
                                /^d/i,
                            ],
                            any: [
                                /^ja/i,
                                /^f/i,
                                /^mar/i,
                                /^ap/i,
                                /^may/i,
                                /^jun/i,
                                /^jul/i,
                                /^au/i,
                                /^s/i,
                                /^o/i,
                                /^n/i,
                                /^d/i,
                            ],
                        },
                        defaultParseWidth: 'any',
                    }),
                    day: gh({
                        matchPatterns: {
                            narrow: /^[smtwf]/i,
                            short: /^(su|mo|tu|we|th|fr|sa)/i,
                            abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                            wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
                        },
                        defaultMatchWidth: 'wide',
                        parsePatterns: {
                            narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
                            any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
                        },
                        defaultParseWidth: 'any',
                    }),
                    dayPeriod: gh({
                        matchPatterns: {
                            narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                            any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
                        },
                        defaultMatchWidth: 'any',
                        parsePatterns: {
                            any: {
                                am: /^a/i,
                                pm: /^p/i,
                                midnight: /^mi/i,
                                noon: /^no/i,
                                morning: /morning/i,
                                afternoon: /afternoon/i,
                                evening: /evening/i,
                                night: /night/i,
                            },
                        },
                        defaultParseWidth: 'any',
                    }),
                },
                options: { weekStartsOn: 0, firstWeekContainsDate: 1 },
            };
            var hX = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
                fX = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
                mX = /^'([^]*?)'?$/,
                pX = /''/g,
                gX = /[a-zA-Z]/;
            function GD(t, n) {
                (null == n || n > t.length) && (n = t.length);
                for (var e = 0, i = new Array(n); e < n; e++) i[e] = t[e];
                return i;
            }
            function WD(t, n) {
                var e = (typeof Symbol < 'u' && t[Symbol.iterator]) || t['@@iterator'];
                if (!e) {
                    if (
                        Array.isArray(t) ||
                        (e = (function yX(t, n) {
                            if (t) {
                                if ('string' == typeof t) return GD(t, n);
                                var e = Object.prototype.toString.call(t).slice(8, -1);
                                if (
                                    ('Object' === e && t.constructor && (e = t.constructor.name),
                                    'Map' === e || 'Set' === e)
                                )
                                    return Array.from(t);
                                if ('Arguments' === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
                                    return GD(t, n);
                            }
                        })(t)) ||
                        (n && t && 'number' == typeof t.length)
                    ) {
                        e && (t = e);
                        var i = 0,
                            r = function () {};
                        return {
                            s: r,
                            n: function () {
                                return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                            },
                            e: function (c) {
                                throw c;
                            },
                            f: r,
                        };
                    }
                    throw new TypeError(
                        'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                    );
                }
                var a,
                    s = !0,
                    o = !1;
                return {
                    s: function () {
                        e = e.call(t);
                    },
                    n: function () {
                        var c = e.next();
                        return (s = c.done), c;
                    },
                    e: function (c) {
                        (o = !0), (a = c);
                    },
                    f: function () {
                        try {
                            !s && null != e.return && e.return();
                        } finally {
                            if (o) throw a;
                        }
                    },
                };
            }
            function bX(t, n) {
                if (null == t) throw new TypeError('assign requires that input parameter not be null or undefined');
                for (var e in n) Object.prototype.hasOwnProperty.call(n, e) && (t[e] = n[e]);
                return t;
            }
            function mt(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function Yg(t, n) {
                return (Yg = Object.setPrototypeOf
                    ? Object.setPrototypeOf.bind()
                    : function (i, r) {
                          return (i.__proto__ = r), i;
                      })(t, n);
            }
            function ei(t, n) {
                if ('function' != typeof n && null !== n)
                    throw new TypeError('Super expression must either be null or a function');
                (t.prototype = Object.create(n && n.prototype, {
                    constructor: { value: t, writable: !0, configurable: !0 },
                })),
                    Object.defineProperty(t, 'prototype', { writable: !1 }),
                    n && Yg(t, n);
            }
            function qf(t) {
                return (qf = Object.setPrototypeOf
                    ? Object.getPrototypeOf.bind()
                    : function (e) {
                          return e.__proto__ || Object.getPrototypeOf(e);
                      })(t);
            }
            function KD() {
                try {
                    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
                } catch {}
                return (KD = function () {
                    return !!t;
                })();
            }
            function ti(t) {
                var n = KD();
                return function () {
                    var r,
                        i = qf(t);
                    if (n) {
                        var s = qf(this).constructor;
                        r = Reflect.construct(i, arguments, s);
                    } else r = i.apply(this, arguments);
                    return (function CX(t, n) {
                        if (n && ('object' === Fl(n) || 'function' == typeof n)) return n;
                        if (void 0 !== n)
                            throw new TypeError('Derived constructors may only return object or undefined');
                        return mt(t);
                    })(this, r);
                };
            }
            function Un(t, n) {
                if (!(t instanceof n)) throw new TypeError('Cannot call a class as a function');
            }
            function QD(t) {
                var n = (function wX(t, n) {
                    if ('object' != Fl(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, n || 'default');
                        if ('object' != Fl(i)) return i;
                        throw new TypeError('@@toPrimitive must return a primitive value.');
                    }
                    return ('string' === n ? String : Number)(t);
                })(t, 'string');
                return 'symbol' == Fl(n) ? n : String(n);
            }
            function XD(t, n) {
                for (var e = 0; e < n.length; e++) {
                    var i = n[e];
                    (i.enumerable = i.enumerable || !1),
                        (i.configurable = !0),
                        'value' in i && (i.writable = !0),
                        Object.defineProperty(t, QD(i.key), i);
                }
            }
            function Bn(t, n, e) {
                return (
                    n && XD(t.prototype, n), e && XD(t, e), Object.defineProperty(t, 'prototype', { writable: !1 }), t
                );
            }
            function ut(t, n, e) {
                return (
                    (n = QD(n)) in t
                        ? Object.defineProperty(t, n, { value: e, enumerable: !0, configurable: !0, writable: !0 })
                        : (t[n] = e),
                    t
                );
            }
            var ZD = (function () {
                    function t() {
                        Un(this, t), ut(this, 'priority', void 0), ut(this, 'subPriority', 0);
                    }
                    return (
                        Bn(t, [
                            {
                                key: 'validate',
                                value: function (e, i) {
                                    return !0;
                                },
                            },
                        ]),
                        t
                    );
                })(),
                SX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e(i, r, s, o, a) {
                        var l;
                        return (
                            Un(this, e),
                            ((l = n.call(this)).value = i),
                            (l.validateValue = r),
                            (l.setValue = s),
                            (l.priority = o),
                            a && (l.subPriority = a),
                            l
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return this.validateValue(r, this.value, s);
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return this.setValue(r, s, this.value, o);
                                },
                            },
                        ]),
                        e
                    );
                })(ZD),
                TX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 10),
                            ut(mt(i), 'subPriority', -1),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'set',
                                value: function (r, s) {
                                    if (s.timestampIsSet) return r;
                                    var o = new Date(0);
                                    return (
                                        o.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()),
                                        o.setHours(
                                            r.getUTCHours(),
                                            r.getUTCMinutes(),
                                            r.getUTCSeconds(),
                                            r.getUTCMilliseconds(),
                                        ),
                                        o
                                    );
                                },
                            },
                        ]),
                        e
                    );
                })(ZD),
                fi = (function () {
                    function t() {
                        Un(this, t),
                            ut(this, 'incompatibleTokens', void 0),
                            ut(this, 'priority', void 0),
                            ut(this, 'subPriority', void 0);
                    }
                    return (
                        Bn(t, [
                            {
                                key: 'run',
                                value: function (e, i, r, s) {
                                    var o = this.parse(e, i, r, s);
                                    return o
                                        ? {
                                              setter: new SX(
                                                  o.value,
                                                  this.validate,
                                                  this.set,
                                                  this.priority,
                                                  this.subPriority,
                                              ),
                                              rest: o.rest,
                                          }
                                        : null;
                                },
                            },
                            {
                                key: 'validate',
                                value: function (e, i, r) {
                                    return !0;
                                },
                            },
                        ]),
                        t
                    );
                })(),
                DX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 140),
                            ut(mt(i), 'incompatibleTokens', ['R', 'u', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'G':
                                        case 'GG':
                                        case 'GGG':
                                            return o.era(r, { width: 'abbreviated' }) || o.era(r, { width: 'narrow' });
                                        case 'GGGGG':
                                            return o.era(r, { width: 'narrow' });
                                        default:
                                            return (
                                                o.era(r, { width: 'wide' }) ||
                                                o.era(r, { width: 'abbreviated' }) ||
                                                o.era(r, { width: 'narrow' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return (s.era = o), r.setUTCFullYear(o, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                Ir_month = /^(1[0-2]|0?\d)/,
                Ir_date = /^(3[0-1]|[0-2]?\d)/,
                Ir_dayOfYear = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
                Ir_week = /^(5[0-3]|[0-4]?\d)/,
                Ir_hour23h = /^(2[0-3]|[0-1]?\d)/,
                Ir_hour24h = /^(2[0-4]|[0-1]?\d)/,
                Ir_hour11h = /^(1[0-1]|0?\d)/,
                Ir_hour12h = /^(1[0-2]|0?\d)/,
                Ir_minute = /^[0-5]?\d/,
                Ir_second = /^[0-5]?\d/,
                Ir_singleDigit = /^\d/,
                Ir_twoDigits = /^\d{1,2}/,
                Ir_threeDigits = /^\d{1,3}/,
                Ir_fourDigits = /^\d{1,4}/,
                Ir_anyDigitsSigned = /^-?\d+/,
                Ir_singleDigitSigned = /^-?\d/,
                Ir_twoDigitsSigned = /^-?\d{1,2}/,
                Ir_threeDigitsSigned = /^-?\d{1,3}/,
                Ir_fourDigitsSigned = /^-?\d{1,4}/,
                cl_basicOptionalMinutes = /^([+-])(\d{2})(\d{2})?|Z/,
                cl_basic = /^([+-])(\d{2})(\d{2})|Z/,
                cl_basicOptionalSeconds = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
                cl_extended = /^([+-])(\d{2}):(\d{2})|Z/,
                cl_extendedOptionalSeconds = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
            function Ar(t, n) {
                return t && { value: n(t.value), rest: t.rest };
            }
            function cr(t, n) {
                var e = n.match(t);
                return e ? { value: parseInt(e[0], 10), rest: n.slice(e[0].length) } : null;
            }
            function ul(t, n) {
                var e = n.match(t);
                return e
                    ? 'Z' === e[0]
                        ? { value: 0, rest: n.slice(1) }
                        : {
                              value:
                                  ('+' === e[1] ? 1 : -1) *
                                  (36e5 * (e[2] ? parseInt(e[2], 10) : 0) +
                                      6e4 * (e[3] ? parseInt(e[3], 10) : 0) +
                                      1e3 * (e[5] ? parseInt(e[5], 10) : 0)),
                              rest: n.slice(e[0].length),
                          }
                    : null;
            }
            function JD(t) {
                return cr(Ir_anyDigitsSigned, t);
            }
            function mr(t, n) {
                switch (t) {
                    case 1:
                        return cr(Ir_singleDigit, n);
                    case 2:
                        return cr(Ir_twoDigits, n);
                    case 3:
                        return cr(Ir_threeDigits, n);
                    case 4:
                        return cr(Ir_fourDigits, n);
                    default:
                        return cr(new RegExp('^\\d{1,' + t + '}'), n);
                }
            }
            function Yf(t, n) {
                switch (t) {
                    case 1:
                        return cr(Ir_singleDigitSigned, n);
                    case 2:
                        return cr(Ir_twoDigitsSigned, n);
                    case 3:
                        return cr(Ir_threeDigitsSigned, n);
                    case 4:
                        return cr(Ir_fourDigitsSigned, n);
                    default:
                        return cr(new RegExp('^-?\\d{1,' + t + '}'), n);
                }
            }
            function jg(t) {
                switch (t) {
                    case 'morning':
                        return 4;
                    case 'evening':
                        return 17;
                    case 'pm':
                    case 'noon':
                    case 'afternoon':
                        return 12;
                    default:
                        return 0;
                }
            }
            function ex(t, n) {
                var r,
                    e = n > 0,
                    i = e ? n : 1 - n;
                if (i <= 50) r = t || 100;
                else {
                    var s = i + 50;
                    r = t + 100 * Math.floor(s / 100) - (t >= s % 100 ? 100 : 0);
                }
                return e ? r : 1 - r;
            }
            function tx(t) {
                return t % 400 == 0 || (t % 4 == 0 && t % 100 != 0);
            }
            var xX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 130),
                            ut(mt(i), 'incompatibleTokens', ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    var a = function (c) {
                                        return { year: c, isTwoDigitYear: 'yy' === s };
                                    };
                                    switch (s) {
                                        case 'y':
                                            return Ar(mr(4, r), a);
                                        case 'yo':
                                            return Ar(o.ordinalNumber(r, { unit: 'year' }), a);
                                        default:
                                            return Ar(mr(s.length, r), a);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s.isTwoDigitYear || s.year > 0;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    var a = r.getUTCFullYear();
                                    if (o.isTwoDigitYear) {
                                        var l = ex(o.year, a);
                                        return r.setUTCFullYear(l, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
                                    }
                                    return (
                                        r.setUTCFullYear('era' in s && 1 !== s.era ? 1 - o.year : o.year, 0, 1),
                                        r.setUTCHours(0, 0, 0, 0),
                                        r
                                    );
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                kX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 130),
                            ut(mt(i), 'incompatibleTokens', [
                                'y',
                                'R',
                                'u',
                                'Q',
                                'q',
                                'M',
                                'L',
                                'I',
                                'd',
                                'D',
                                'i',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    var a = function (c) {
                                        return { year: c, isTwoDigitYear: 'YY' === s };
                                    };
                                    switch (s) {
                                        case 'Y':
                                            return Ar(mr(4, r), a);
                                        case 'Yo':
                                            return Ar(o.ordinalNumber(r, { unit: 'year' }), a);
                                        default:
                                            return Ar(mr(s.length, r), a);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s.isTwoDigitYear || s.year > 0;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o, a) {
                                    var l = Ug(r, a);
                                    if (o.isTwoDigitYear) {
                                        var c = ex(o.year, l);
                                        return (
                                            r.setUTCFullYear(c, 0, a.firstWeekContainsDate),
                                            r.setUTCHours(0, 0, 0, 0),
                                            Lu(r, a)
                                        );
                                    }
                                    return (
                                        r.setUTCFullYear(
                                            'era' in s && 1 !== s.era ? 1 - o.year : o.year,
                                            0,
                                            a.firstWeekContainsDate,
                                        ),
                                        r.setUTCHours(0, 0, 0, 0),
                                        Lu(r, a)
                                    );
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                EX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 130),
                            ut(mt(i), 'incompatibleTokens', [
                                'G',
                                'y',
                                'Y',
                                'u',
                                'Q',
                                'q',
                                'M',
                                'L',
                                'w',
                                'd',
                                'D',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s) {
                                    return Yf('R' === s ? 4 : s.length, r);
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    var a = new Date(0);
                                    return a.setUTCFullYear(o, 0, 4), a.setUTCHours(0, 0, 0, 0), l0(a);
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                IX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 130),
                            ut(mt(i), 'incompatibleTokens', ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s) {
                                    return Yf('u' === s ? 4 : s.length, r);
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCFullYear(o, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                AX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 120),
                            ut(mt(i), 'incompatibleTokens', [
                                'Y',
                                'R',
                                'q',
                                'M',
                                'L',
                                'w',
                                'I',
                                'd',
                                'D',
                                'i',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'Q':
                                        case 'QQ':
                                            return mr(s.length, r);
                                        case 'Qo':
                                            return o.ordinalNumber(r, { unit: 'quarter' });
                                        case 'QQQ':
                                            return (
                                                o.quarter(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.quarter(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        case 'QQQQQ':
                                            return o.quarter(r, { width: 'narrow', context: 'formatting' });
                                        default:
                                            return (
                                                o.quarter(r, { width: 'wide', context: 'formatting' }) ||
                                                o.quarter(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.quarter(r, { width: 'narrow', context: 'formatting' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 1 && s <= 4;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCMonth(3 * (o - 1), 1), r.setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                LX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 120),
                            ut(mt(i), 'incompatibleTokens', [
                                'Y',
                                'R',
                                'Q',
                                'M',
                                'L',
                                'w',
                                'I',
                                'd',
                                'D',
                                'i',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'q':
                                        case 'qq':
                                            return mr(s.length, r);
                                        case 'qo':
                                            return o.ordinalNumber(r, { unit: 'quarter' });
                                        case 'qqq':
                                            return (
                                                o.quarter(r, { width: 'abbreviated', context: 'standalone' }) ||
                                                o.quarter(r, { width: 'narrow', context: 'standalone' })
                                            );
                                        case 'qqqqq':
                                            return o.quarter(r, { width: 'narrow', context: 'standalone' });
                                        default:
                                            return (
                                                o.quarter(r, { width: 'wide', context: 'standalone' }) ||
                                                o.quarter(r, { width: 'abbreviated', context: 'standalone' }) ||
                                                o.quarter(r, { width: 'narrow', context: 'standalone' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 1 && s <= 4;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCMonth(3 * (o - 1), 1), r.setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                OX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'incompatibleTokens', [
                                'Y',
                                'R',
                                'q',
                                'Q',
                                'L',
                                'w',
                                'I',
                                'D',
                                'i',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            ut(mt(i), 'priority', 110),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    var a = function (c) {
                                        return c - 1;
                                    };
                                    switch (s) {
                                        case 'M':
                                            return Ar(cr(Ir_month, r), a);
                                        case 'MM':
                                            return Ar(mr(2, r), a);
                                        case 'Mo':
                                            return Ar(o.ordinalNumber(r, { unit: 'month' }), a);
                                        case 'MMM':
                                            return (
                                                o.month(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.month(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        case 'MMMMM':
                                            return o.month(r, { width: 'narrow', context: 'formatting' });
                                        default:
                                            return (
                                                o.month(r, { width: 'wide', context: 'formatting' }) ||
                                                o.month(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.month(r, { width: 'narrow', context: 'formatting' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 11;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCMonth(o, 1), r.setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                zX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 110),
                            ut(mt(i), 'incompatibleTokens', [
                                'Y',
                                'R',
                                'q',
                                'Q',
                                'M',
                                'w',
                                'I',
                                'D',
                                'i',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    var a = function (c) {
                                        return c - 1;
                                    };
                                    switch (s) {
                                        case 'L':
                                            return Ar(cr(Ir_month, r), a);
                                        case 'LL':
                                            return Ar(mr(2, r), a);
                                        case 'Lo':
                                            return Ar(o.ordinalNumber(r, { unit: 'month' }), a);
                                        case 'LLL':
                                            return (
                                                o.month(r, { width: 'abbreviated', context: 'standalone' }) ||
                                                o.month(r, { width: 'narrow', context: 'standalone' })
                                            );
                                        case 'LLLLL':
                                            return o.month(r, { width: 'narrow', context: 'standalone' });
                                        default:
                                            return (
                                                o.month(r, { width: 'wide', context: 'standalone' }) ||
                                                o.month(r, { width: 'abbreviated', context: 'standalone' }) ||
                                                o.month(r, { width: 'narrow', context: 'standalone' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 11;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCMonth(o, 1), r.setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                NX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 100),
                            ut(mt(i), 'incompatibleTokens', [
                                'y',
                                'R',
                                'u',
                                'q',
                                'Q',
                                'M',
                                'L',
                                'I',
                                'd',
                                'D',
                                'i',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'w':
                                            return cr(Ir_week, r);
                                        case 'wo':
                                            return o.ordinalNumber(r, { unit: 'week' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 1 && s <= 53;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o, a) {
                                    return Lu(
                                        (function PX(t, n, e) {
                                            Ot(2, arguments);
                                            var i = fn(t),
                                                r = fr(n),
                                                s = VD(i, e) - r;
                                            return i.setUTCDate(i.getUTCDate() - 7 * s), i;
                                        })(r, o, a),
                                        a,
                                    );
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                RX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 100),
                            ut(mt(i), 'incompatibleTokens', [
                                'y',
                                'Y',
                                'u',
                                'q',
                                'Q',
                                'M',
                                'L',
                                'w',
                                'd',
                                'D',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'I':
                                            return cr(Ir_week, r);
                                        case 'Io':
                                            return o.ordinalNumber(r, { unit: 'week' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 1 && s <= 53;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return l0(
                                        (function FX(t, n) {
                                            Ot(2, arguments);
                                            var e = fn(t),
                                                i = fr(n),
                                                r = RD(e) - i;
                                            return e.setUTCDate(e.getUTCDate() - 7 * r), e;
                                        })(r, o),
                                    );
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                VX = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                HX = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                UX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 90),
                            ut(mt(i), 'subPriority', 1),
                            ut(mt(i), 'incompatibleTokens', [
                                'Y',
                                'R',
                                'q',
                                'Q',
                                'w',
                                'I',
                                'D',
                                'i',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'd':
                                            return cr(Ir_date, r);
                                        case 'do':
                                            return o.ordinalNumber(r, { unit: 'date' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    var a = tx(r.getUTCFullYear()),
                                        l = r.getUTCMonth();
                                    return a ? s >= 1 && s <= HX[l] : s >= 1 && s <= VX[l];
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCDate(o), r.setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                BX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 90),
                            ut(mt(i), 'subpriority', 1),
                            ut(mt(i), 'incompatibleTokens', [
                                'Y',
                                'R',
                                'q',
                                'Q',
                                'M',
                                'L',
                                'w',
                                'I',
                                'd',
                                'E',
                                'i',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'D':
                                        case 'DD':
                                            return cr(Ir_dayOfYear, r);
                                        case 'Do':
                                            return o.ordinalNumber(r, { unit: 'date' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return tx(r.getUTCFullYear()) ? s >= 1 && s <= 366 : s >= 1 && s <= 365;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCMonth(0, o), r.setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi);
            function $g(t, n, e) {
                var i, r, s, o, a, l, c, f;
                Ot(2, arguments);
                var g = kc(),
                    E = fr(
                        null !==
                            (i =
                                null !==
                                    (r =
                                        null !==
                                            (s =
                                                null !== (o = e?.weekStartsOn) && void 0 !== o
                                                    ? o
                                                    : null == e ||
                                                      null === (a = e.locale) ||
                                                      void 0 === a ||
                                                      null === (l = a.options) ||
                                                      void 0 === l
                                                    ? void 0
                                                    : l.weekStartsOn) && void 0 !== s
                                            ? s
                                            : g.weekStartsOn) && void 0 !== r
                                    ? r
                                    : null === (c = g.locale) ||
                                      void 0 === c ||
                                      null === (f = c.options) ||
                                      void 0 === f
                                    ? void 0
                                    : f.weekStartsOn) && void 0 !== i
                            ? i
                            : 0,
                    );
                if (!(E >= 0 && E <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                var P = fn(t),
                    V = fr(n),
                    fe = (((V % 7) + 7) % 7 < E ? 7 : 0) + V - P.getUTCDay();
                return P.setUTCDate(P.getUTCDate() + fe), P;
            }
            var qX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 90),
                            ut(mt(i), 'incompatibleTokens', ['D', 'i', 'e', 'c', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'E':
                                        case 'EE':
                                        case 'EEE':
                                            return (
                                                o.day(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.day(r, { width: 'short', context: 'formatting' }) ||
                                                o.day(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        case 'EEEEE':
                                            return o.day(r, { width: 'narrow', context: 'formatting' });
                                        case 'EEEEEE':
                                            return (
                                                o.day(r, { width: 'short', context: 'formatting' }) ||
                                                o.day(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        default:
                                            return (
                                                o.day(r, { width: 'wide', context: 'formatting' }) ||
                                                o.day(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.day(r, { width: 'short', context: 'formatting' }) ||
                                                o.day(r, { width: 'narrow', context: 'formatting' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 6;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o, a) {
                                    return (r = $g(r, o, a)).setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                YX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 90),
                            ut(mt(i), 'incompatibleTokens', [
                                'y',
                                'R',
                                'u',
                                'q',
                                'Q',
                                'M',
                                'L',
                                'I',
                                'd',
                                'D',
                                'E',
                                'i',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o, a) {
                                    var l = function (f) {
                                        var g = 7 * Math.floor((f - 1) / 7);
                                        return ((f + a.weekStartsOn + 6) % 7) + g;
                                    };
                                    switch (s) {
                                        case 'e':
                                        case 'ee':
                                            return Ar(mr(s.length, r), l);
                                        case 'eo':
                                            return Ar(o.ordinalNumber(r, { unit: 'day' }), l);
                                        case 'eee':
                                            return (
                                                o.day(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.day(r, { width: 'short', context: 'formatting' }) ||
                                                o.day(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        case 'eeeee':
                                            return o.day(r, { width: 'narrow', context: 'formatting' });
                                        case 'eeeeee':
                                            return (
                                                o.day(r, { width: 'short', context: 'formatting' }) ||
                                                o.day(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        default:
                                            return (
                                                o.day(r, { width: 'wide', context: 'formatting' }) ||
                                                o.day(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.day(r, { width: 'short', context: 'formatting' }) ||
                                                o.day(r, { width: 'narrow', context: 'formatting' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 6;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o, a) {
                                    return (r = $g(r, o, a)).setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                jX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 90),
                            ut(mt(i), 'incompatibleTokens', [
                                'y',
                                'R',
                                'u',
                                'q',
                                'Q',
                                'M',
                                'L',
                                'I',
                                'd',
                                'D',
                                'E',
                                'i',
                                'e',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o, a) {
                                    var l = function (f) {
                                        var g = 7 * Math.floor((f - 1) / 7);
                                        return ((f + a.weekStartsOn + 6) % 7) + g;
                                    };
                                    switch (s) {
                                        case 'c':
                                        case 'cc':
                                            return Ar(mr(s.length, r), l);
                                        case 'co':
                                            return Ar(o.ordinalNumber(r, { unit: 'day' }), l);
                                        case 'ccc':
                                            return (
                                                o.day(r, { width: 'abbreviated', context: 'standalone' }) ||
                                                o.day(r, { width: 'short', context: 'standalone' }) ||
                                                o.day(r, { width: 'narrow', context: 'standalone' })
                                            );
                                        case 'ccccc':
                                            return o.day(r, { width: 'narrow', context: 'standalone' });
                                        case 'cccccc':
                                            return (
                                                o.day(r, { width: 'short', context: 'standalone' }) ||
                                                o.day(r, { width: 'narrow', context: 'standalone' })
                                            );
                                        default:
                                            return (
                                                o.day(r, { width: 'wide', context: 'standalone' }) ||
                                                o.day(r, { width: 'abbreviated', context: 'standalone' }) ||
                                                o.day(r, { width: 'short', context: 'standalone' }) ||
                                                o.day(r, { width: 'narrow', context: 'standalone' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 6;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o, a) {
                                    return (r = $g(r, o, a)).setUTCHours(0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                GX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 90),
                            ut(mt(i), 'incompatibleTokens', [
                                'y',
                                'Y',
                                'u',
                                'q',
                                'Q',
                                'M',
                                'L',
                                'w',
                                'd',
                                'D',
                                'E',
                                'e',
                                'c',
                                't',
                                'T',
                            ]),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    var a = function (c) {
                                        return 0 === c ? 7 : c;
                                    };
                                    switch (s) {
                                        case 'i':
                                        case 'ii':
                                            return mr(s.length, r);
                                        case 'io':
                                            return o.ordinalNumber(r, { unit: 'day' });
                                        case 'iii':
                                            return Ar(
                                                o.day(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                    o.day(r, { width: 'short', context: 'formatting' }) ||
                                                    o.day(r, { width: 'narrow', context: 'formatting' }),
                                                a,
                                            );
                                        case 'iiiii':
                                            return Ar(o.day(r, { width: 'narrow', context: 'formatting' }), a);
                                        case 'iiiiii':
                                            return Ar(
                                                o.day(r, { width: 'short', context: 'formatting' }) ||
                                                    o.day(r, { width: 'narrow', context: 'formatting' }),
                                                a,
                                            );
                                        default:
                                            return Ar(
                                                o.day(r, { width: 'wide', context: 'formatting' }) ||
                                                    o.day(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                    o.day(r, { width: 'short', context: 'formatting' }) ||
                                                    o.day(r, { width: 'narrow', context: 'formatting' }),
                                                a,
                                            );
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 1 && s <= 7;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return (
                                        (r = (function $X(t, n) {
                                            Ot(2, arguments);
                                            var e = fr(n);
                                            e % 7 == 0 && (e -= 7);
                                            var r = fn(t),
                                                l = (((e % 7) + 7) % 7 < 1 ? 7 : 0) + e - r.getUTCDay();
                                            return r.setUTCDate(r.getUTCDate() + l), r;
                                        })(r, o)),
                                        r.setUTCHours(0, 0, 0, 0),
                                        r
                                    );
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                WX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 80),
                            ut(mt(i), 'incompatibleTokens', ['b', 'B', 'H', 'k', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'a':
                                        case 'aa':
                                        case 'aaa':
                                            return (
                                                o.dayPeriod(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        case 'aaaaa':
                                            return o.dayPeriod(r, { width: 'narrow', context: 'formatting' });
                                        default:
                                            return (
                                                o.dayPeriod(r, { width: 'wide', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'narrow', context: 'formatting' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCHours(jg(o), 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                KX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 80),
                            ut(mt(i), 'incompatibleTokens', ['a', 'B', 'H', 'k', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'b':
                                        case 'bb':
                                        case 'bbb':
                                            return (
                                                o.dayPeriod(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        case 'bbbbb':
                                            return o.dayPeriod(r, { width: 'narrow', context: 'formatting' });
                                        default:
                                            return (
                                                o.dayPeriod(r, { width: 'wide', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'narrow', context: 'formatting' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCHours(jg(o), 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                QX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 80),
                            ut(mt(i), 'incompatibleTokens', ['a', 'b', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'B':
                                        case 'BB':
                                        case 'BBB':
                                            return (
                                                o.dayPeriod(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'narrow', context: 'formatting' })
                                            );
                                        case 'BBBBB':
                                            return o.dayPeriod(r, { width: 'narrow', context: 'formatting' });
                                        default:
                                            return (
                                                o.dayPeriod(r, { width: 'wide', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'abbreviated', context: 'formatting' }) ||
                                                o.dayPeriod(r, { width: 'narrow', context: 'formatting' })
                                            );
                                    }
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCHours(jg(o), 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                XX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 70),
                            ut(mt(i), 'incompatibleTokens', ['H', 'K', 'k', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'h':
                                            return cr(Ir_hour12h, r);
                                        case 'ho':
                                            return o.ordinalNumber(r, { unit: 'hour' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 1 && s <= 12;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    var a = r.getUTCHours() >= 12;
                                    return r.setUTCHours(a && o < 12 ? o + 12 : a || 12 !== o ? o : 0, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                ZX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 70),
                            ut(mt(i), 'incompatibleTokens', ['a', 'b', 'h', 'K', 'k', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'H':
                                            return cr(Ir_hour23h, r);
                                        case 'Ho':
                                            return o.ordinalNumber(r, { unit: 'hour' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 23;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCHours(o, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                JX = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 70),
                            ut(mt(i), 'incompatibleTokens', ['h', 'H', 'k', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'K':
                                            return cr(Ir_hour11h, r);
                                        case 'Ko':
                                            return o.ordinalNumber(r, { unit: 'hour' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 11;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    var a = r.getUTCHours() >= 12;
                                    return r.setUTCHours(a && o < 12 ? o + 12 : o, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                eZ = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 70),
                            ut(mt(i), 'incompatibleTokens', ['a', 'b', 'h', 'H', 'K', 't', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'k':
                                            return cr(Ir_hour24h, r);
                                        case 'ko':
                                            return o.ordinalNumber(r, { unit: 'hour' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 1 && s <= 24;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCHours(o <= 24 ? o % 24 : o, 0, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                tZ = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 60),
                            ut(mt(i), 'incompatibleTokens', ['t', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 'm':
                                            return cr(Ir_minute, r);
                                        case 'mo':
                                            return o.ordinalNumber(r, { unit: 'minute' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 59;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCMinutes(o, 0, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                nZ = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 50),
                            ut(mt(i), 'incompatibleTokens', ['t', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s, o) {
                                    switch (s) {
                                        case 's':
                                            return cr(Ir_second, r);
                                        case 'so':
                                            return o.ordinalNumber(r, { unit: 'second' });
                                        default:
                                            return mr(s.length, r);
                                    }
                                },
                            },
                            {
                                key: 'validate',
                                value: function (r, s) {
                                    return s >= 0 && s <= 59;
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCSeconds(o, 0), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                iZ = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 30),
                            ut(mt(i), 'incompatibleTokens', ['t', 'T']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s) {
                                    return Ar(mr(s.length, r), function (l) {
                                        return Math.floor(l * Math.pow(10, 3 - s.length));
                                    });
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return r.setUTCMilliseconds(o), r;
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                rZ = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 10),
                            ut(mt(i), 'incompatibleTokens', ['t', 'T', 'x']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s) {
                                    switch (s) {
                                        case 'X':
                                            return ul(cl_basicOptionalMinutes, r);
                                        case 'XX':
                                            return ul(cl_basic, r);
                                        case 'XXXX':
                                            return ul(cl_basicOptionalSeconds, r);
                                        case 'XXXXX':
                                            return ul(cl_extendedOptionalSeconds, r);
                                        default:
                                            return ul(cl_extended, r);
                                    }
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return s.timestampIsSet ? r : new Date(r.getTime() - o);
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                sZ = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 10),
                            ut(mt(i), 'incompatibleTokens', ['t', 'T', 'X']),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r, s) {
                                    switch (s) {
                                        case 'x':
                                            return ul(cl_basicOptionalMinutes, r);
                                        case 'xx':
                                            return ul(cl_basic, r);
                                        case 'xxxx':
                                            return ul(cl_basicOptionalSeconds, r);
                                        case 'xxxxx':
                                            return ul(cl_extendedOptionalSeconds, r);
                                        default:
                                            return ul(cl_extended, r);
                                    }
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return s.timestampIsSet ? r : new Date(r.getTime() - o);
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                oZ = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 40),
                            ut(mt(i), 'incompatibleTokens', '*'),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r) {
                                    return JD(r);
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return [new Date(1e3 * o), { timestampIsSet: !0 }];
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                aZ = (function (t) {
                    ei(e, t);
                    var n = ti(e);
                    function e() {
                        var i;
                        Un(this, e);
                        for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++) s[o] = arguments[o];
                        return (
                            ut(mt((i = n.call.apply(n, [this].concat(s)))), 'priority', 20),
                            ut(mt(i), 'incompatibleTokens', '*'),
                            i
                        );
                    }
                    return (
                        Bn(e, [
                            {
                                key: 'parse',
                                value: function (r) {
                                    return JD(r);
                                },
                            },
                            {
                                key: 'set',
                                value: function (r, s, o) {
                                    return [new Date(o), { timestampIsSet: !0 }];
                                },
                            },
                        ]),
                        e
                    );
                })(fi),
                lZ = {
                    G: new DX(),
                    y: new xX(),
                    Y: new kX(),
                    R: new EX(),
                    u: new IX(),
                    Q: new AX(),
                    q: new LX(),
                    M: new OX(),
                    L: new zX(),
                    w: new NX(),
                    I: new RX(),
                    d: new UX(),
                    D: new BX(),
                    E: new qX(),
                    e: new YX(),
                    c: new jX(),
                    i: new GX(),
                    a: new WX(),
                    b: new KX(),
                    B: new QX(),
                    h: new XX(),
                    H: new ZX(),
                    K: new JX(),
                    k: new eZ(),
                    m: new tZ(),
                    s: new nZ(),
                    S: new iZ(),
                    X: new rZ(),
                    x: new sZ(),
                    t: new oZ(),
                    T: new aZ(),
                },
                cZ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
                uZ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
                dZ = /^'([^]*?)'?$/,
                hZ = /''/g,
                fZ = /\S/,
                mZ = /[a-zA-Z]/;
            var nx = {
                    locale: 'en',
                    Pagination: {
                        items_per_page: '/ page',
                        jump_to: 'Go to',
                        jump_to_confirm: 'confirm',
                        page: 'Page',
                        prev_page: 'Previous Page',
                        next_page: 'Next Page',
                        prev_5: 'Previous 5 Pages',
                        next_5: 'Next 5 Pages',
                        prev_3: 'Previous 3 Pages',
                        next_3: 'Next 3 Pages',
                        page_size: 'Page Size',
                    },
                    DatePicker: {
                        lang: {
                            placeholder: 'Select date',
                            yearPlaceholder: 'Select year',
                            quarterPlaceholder: 'Select quarter',
                            monthPlaceholder: 'Select month',
                            weekPlaceholder: 'Select week',
                            rangePlaceholder: ['Start date', 'End date'],
                            rangeYearPlaceholder: ['Start year', 'End year'],
                            rangeMonthPlaceholder: ['Start month', 'End month'],
                            rangeWeekPlaceholder: ['Start week', 'End week'],
                            locale: 'en_US',
                            today: 'Today',
                            now: 'Now',
                            backToToday: 'Back to today',
                            ok: 'Ok',
                            clear: 'Clear',
                            month: 'Month',
                            year: 'Year',
                            timeSelect: 'select time',
                            dateSelect: 'select date',
                            weekSelect: 'Choose a week',
                            monthSelect: 'Choose a month',
                            yearSelect: 'Choose a year',
                            decadeSelect: 'Choose a decade',
                            yearFormat: 'YYYY',
                            dateFormat: 'M/D/YYYY',
                            dayFormat: 'D',
                            dateTimeFormat: 'M/D/YYYY HH:mm:ss',
                            monthBeforeYear: !0,
                            previousMonth: 'Previous month (PageUp)',
                            nextMonth: 'Next month (PageDown)',
                            previousYear: 'Last year (Control + left)',
                            nextYear: 'Next year (Control + right)',
                            previousDecade: 'Last decade',
                            nextDecade: 'Next decade',
                            previousCentury: 'Last century',
                            nextCentury: 'Next century',
                        },
                        timePickerLocale: { placeholder: 'Select time', rangePlaceholder: ['Start time', 'End time'] },
                    },
                    TimePicker: { placeholder: 'Select time', rangePlaceholder: ['Start time', 'End time'] },
                    Calendar: {
                        lang: {
                            placeholder: 'Select date',
                            yearPlaceholder: 'Select year',
                            quarterPlaceholder: 'Select quarter',
                            monthPlaceholder: 'Select month',
                            weekPlaceholder: 'Select week',
                            rangePlaceholder: ['Start date', 'End date'],
                            rangeYearPlaceholder: ['Start year', 'End year'],
                            rangeMonthPlaceholder: ['Start month', 'End month'],
                            rangeWeekPlaceholder: ['Start week', 'End week'],
                            locale: 'en_US',
                            today: 'Today',
                            now: 'Now',
                            backToToday: 'Back to today',
                            ok: 'Ok',
                            clear: 'Clear',
                            month: 'Month',
                            year: 'Year',
                            timeSelect: 'select time',
                            dateSelect: 'select date',
                            weekSelect: 'Choose a week',
                            monthSelect: 'Choose a month',
                            yearSelect: 'Choose a year',
                            decadeSelect: 'Choose a decade',
                            yearFormat: 'YYYY',
                            dateFormat: 'M/D/YYYY',
                            dayFormat: 'D',
                            dateTimeFormat: 'M/D/YYYY HH:mm:ss',
                            monthBeforeYear: !0,
                            previousMonth: 'Previous month (PageUp)',
                            nextMonth: 'Next month (PageDown)',
                            previousYear: 'Last year (Control + left)',
                            nextYear: 'Next year (Control + right)',
                            previousDecade: 'Last decade',
                            nextDecade: 'Next decade',
                            previousCentury: 'Last century',
                            nextCentury: 'Next century',
                        },
                        timePickerLocale: { placeholder: 'Select time', rangePlaceholder: ['Start time', 'End time'] },
                    },
                    global: { placeholder: 'Please select' },
                    Table: {
                        filterTitle: 'Filter menu',
                        filterConfirm: 'OK',
                        filterReset: 'Reset',
                        filterEmptyText: 'No filters',
                        emptyText: 'No data',
                        selectAll: 'Select current page',
                        selectInvert: 'Invert current page',
                        selectionAll: 'Select all data',
                        sortTitle: 'Sort',
                        expand: 'Expand row',
                        collapse: 'Collapse row',
                        triggerDesc: 'Click to sort descending',
                        triggerAsc: 'Click to sort ascending',
                        cancelSort: 'Click to cancel sorting',
                        filterCheckall: 'Select all items',
                        filterSearchPlaceholder: 'Search in filters',
                        selectNone: 'Clear all data',
                    },
                    Modal: { okText: 'OK', cancelText: 'Cancel', justOkText: 'OK' },
                    Popconfirm: { okText: 'OK', cancelText: 'Cancel' },
                    Transfer: {
                        titles: ['', ''],
                        searchPlaceholder: 'Search here',
                        itemUnit: 'item',
                        itemsUnit: 'items',
                        remove: 'Remove',
                        selectCurrent: 'Select current page',
                        removeCurrent: 'Remove current page',
                        selectAll: 'Select all data',
                        removeAll: 'Remove all data',
                        selectInvert: 'Invert current page',
                    },
                    Upload: {
                        uploading: 'Uploading...',
                        removeFile: 'Remove file',
                        uploadError: 'Upload error',
                        previewFile: 'Preview file',
                        downloadFile: 'Download file',
                    },
                    Empty: { description: 'No Data' },
                    Icon: { icon: 'icon' },
                    Text: { edit: 'Edit', copy: 'Copy', copied: 'Copied', expand: 'Expand' },
                    PageHeader: { back: 'Back' },
                    Image: { preview: 'Preview' },
                    CronExpression: {
                        cronError: 'Invalid cron expression',
                        second: 'second',
                        minute: 'minute',
                        hour: 'hour',
                        day: 'day',
                        month: 'month',
                        week: 'week',
                    },
                    QRCode: { expired: 'QR code expired', refresh: 'Refresh' },
                },
                vZ = {
                    locale: 'zh-cn',
                    Pagination: {
                        items_per_page: '\u6761/\u9875',
                        jump_to: '\u8df3\u81f3',
                        jump_to_confirm: '\u786e\u5b9a',
                        page: '\u9875',
                        prev_page: '\u4e0a\u4e00\u9875',
                        next_page: '\u4e0b\u4e00\u9875',
                        prev_5: '\u5411\u524d 5 \u9875',
                        next_5: '\u5411\u540e 5 \u9875',
                        prev_3: '\u5411\u524d 3 \u9875',
                        next_3: '\u5411\u540e 3 \u9875',
                        page_size: '\u9875\u7801',
                    },
                    DatePicker: {
                        lang: {
                            placeholder: '\u8bf7\u9009\u62e9\u65e5\u671f',
                            yearPlaceholder: '\u8bf7\u9009\u62e9\u5e74\u4efd',
                            quarterPlaceholder: '\u8bf7\u9009\u62e9\u5b63\u5ea6',
                            monthPlaceholder: '\u8bf7\u9009\u62e9\u6708\u4efd',
                            weekPlaceholder: '\u8bf7\u9009\u62e9\u5468',
                            rangePlaceholder: ['\u5f00\u59cb\u65e5\u671f', '\u7ed3\u675f\u65e5\u671f'],
                            rangeYearPlaceholder: ['\u5f00\u59cb\u5e74\u4efd', '\u7ed3\u675f\u5e74\u4efd'],
                            rangeMonthPlaceholder: ['\u5f00\u59cb\u6708\u4efd', '\u7ed3\u675f\u6708\u4efd'],
                            rangeWeekPlaceholder: ['\u5f00\u59cb\u5468', '\u7ed3\u675f\u5468'],
                            locale: 'zh_CN',
                            today: '\u4eca\u5929',
                            now: '\u6b64\u523b',
                            backToToday: '\u8fd4\u56de\u4eca\u5929',
                            ok: '\u786e\u5b9a',
                            timeSelect: '\u9009\u62e9\u65f6\u95f4',
                            dateSelect: '\u9009\u62e9\u65e5\u671f',
                            weekSelect: '\u9009\u62e9\u5468',
                            clear: '\u6e05\u9664',
                            month: '\u6708',
                            year: '\u5e74',
                            previousMonth: '\u4e0a\u4e2a\u6708 (\u7ffb\u9875\u4e0a\u952e)',
                            nextMonth: '\u4e0b\u4e2a\u6708 (\u7ffb\u9875\u4e0b\u952e)',
                            monthSelect: '\u9009\u62e9\u6708\u4efd',
                            yearSelect: '\u9009\u62e9\u5e74\u4efd',
                            decadeSelect: '\u9009\u62e9\u5e74\u4ee3',
                            yearFormat: 'YYYY\u5e74',
                            dayFormat: 'D\u65e5',
                            dateFormat: 'YYYY\u5e74M\u6708D\u65e5',
                            dateTimeFormat: 'YYYY\u5e74M\u6708D\u65e5 HH\u65f6mm\u5206ss\u79d2',
                            previousYear: '\u4e0a\u4e00\u5e74 (Control\u952e\u52a0\u5de6\u65b9\u5411\u952e)',
                            nextYear: '\u4e0b\u4e00\u5e74 (Control\u952e\u52a0\u53f3\u65b9\u5411\u952e)',
                            previousDecade: '\u4e0a\u4e00\u5e74\u4ee3',
                            nextDecade: '\u4e0b\u4e00\u5e74\u4ee3',
                            previousCentury: '\u4e0a\u4e00\u4e16\u7eaa',
                            nextCentury: '\u4e0b\u4e00\u4e16\u7eaa',
                        },
                        timePickerLocale: {
                            placeholder: '\u8bf7\u9009\u62e9\u65f6\u95f4',
                            rangePlaceholder: ['\u5f00\u59cb\u65f6\u95f4', '\u7ed3\u675f\u65f6\u95f4'],
                        },
                    },
                    TimePicker: {
                        placeholder: '\u8bf7\u9009\u62e9\u65f6\u95f4',
                        rangePlaceholder: ['\u5f00\u59cb\u65f6\u95f4', '\u7ed3\u675f\u65f6\u95f4'],
                    },
                    Calendar: {
                        lang: {
                            placeholder: '\u8bf7\u9009\u62e9\u65e5\u671f',
                            yearPlaceholder: '\u8bf7\u9009\u62e9\u5e74\u4efd',
                            quarterPlaceholder: '\u8bf7\u9009\u62e9\u5b63\u5ea6',
                            monthPlaceholder: '\u8bf7\u9009\u62e9\u6708\u4efd',
                            weekPlaceholder: '\u8bf7\u9009\u62e9\u5468',
                            rangePlaceholder: ['\u5f00\u59cb\u65e5\u671f', '\u7ed3\u675f\u65e5\u671f'],
                            rangeYearPlaceholder: ['\u5f00\u59cb\u5e74\u4efd', '\u7ed3\u675f\u5e74\u4efd'],
                            rangeMonthPlaceholder: ['\u5f00\u59cb\u6708\u4efd', '\u7ed3\u675f\u6708\u4efd'],
                            rangeWeekPlaceholder: ['\u5f00\u59cb\u5468', '\u7ed3\u675f\u5468'],
                            locale: 'zh_CN',
                            today: '\u4eca\u5929',
                            now: '\u6b64\u523b',
                            backToToday: '\u8fd4\u56de\u4eca\u5929',
                            ok: '\u786e\u5b9a',
                            timeSelect: '\u9009\u62e9\u65f6\u95f4',
                            dateSelect: '\u9009\u62e9\u65e5\u671f',
                            weekSelect: '\u9009\u62e9\u5468',
                            clear: '\u6e05\u9664',
                            month: '\u6708',
                            year: '\u5e74',
                            previousMonth: '\u4e0a\u4e2a\u6708 (\u7ffb\u9875\u4e0a\u952e)',
                            nextMonth: '\u4e0b\u4e2a\u6708 (\u7ffb\u9875\u4e0b\u952e)',
                            monthSelect: '\u9009\u62e9\u6708\u4efd',
                            yearSelect: '\u9009\u62e9\u5e74\u4efd',
                            decadeSelect: '\u9009\u62e9\u5e74\u4ee3',
                            yearFormat: 'YYYY\u5e74',
                            dayFormat: 'D\u65e5',
                            dateFormat: 'YYYY\u5e74M\u6708D\u65e5',
                            dateTimeFormat: 'YYYY\u5e74M\u6708D\u65e5 HH\u65f6mm\u5206ss\u79d2',
                            previousYear: '\u4e0a\u4e00\u5e74 (Control\u952e\u52a0\u5de6\u65b9\u5411\u952e)',
                            nextYear: '\u4e0b\u4e00\u5e74 (Control\u952e\u52a0\u53f3\u65b9\u5411\u952e)',
                            previousDecade: '\u4e0a\u4e00\u5e74\u4ee3',
                            nextDecade: '\u4e0b\u4e00\u5e74\u4ee3',
                            previousCentury: '\u4e0a\u4e00\u4e16\u7eaa',
                            nextCentury: '\u4e0b\u4e00\u4e16\u7eaa',
                        },
                        timePickerLocale: {
                            placeholder: '\u8bf7\u9009\u62e9\u65f6\u95f4',
                            rangePlaceholder: ['\u5f00\u59cb\u65f6\u95f4', '\u7ed3\u675f\u65f6\u95f4'],
                        },
                    },
                    global: { placeholder: '\u8bf7\u9009\u62e9' },
                    Table: {
                        filterTitle: '\u7b5b\u9009',
                        filterConfirm: '\u786e\u5b9a',
                        filterReset: '\u91cd\u7f6e',
                        filterEmptyText: '\u65e0\u7b5b\u9009\u9879',
                        selectAll: '\u5168\u9009\u5f53\u9875',
                        selectInvert: '\u53cd\u9009\u5f53\u9875',
                        selectionAll: '\u5168\u9009\u6240\u6709',
                        sortTitle: '\u6392\u5e8f',
                        expand: '\u5c55\u5f00\u884c',
                        collapse: '\u5173\u95ed\u884c',
                        triggerDesc: '\u70b9\u51fb\u964d\u5e8f',
                        triggerAsc: '\u70b9\u51fb\u5347\u5e8f',
                        cancelSort: '\u53d6\u6d88\u6392\u5e8f',
                        filterCheckall: '\u5168\u9009',
                        filterSearchPlaceholder: '\u5728\u7b5b\u9009\u9879\u4e2d\u641c\u7d22',
                        selectNone: '\u6e05\u7a7a\u6240\u6709',
                    },
                    Modal: { okText: '\u786e\u5b9a', cancelText: '\u53d6\u6d88', justOkText: '\u77e5\u9053\u4e86' },
                    Popconfirm: { cancelText: '\u53d6\u6d88', okText: '\u786e\u5b9a' },
                    Transfer: {
                        searchPlaceholder: '\u8bf7\u8f93\u5165\u641c\u7d22\u5185\u5bb9',
                        itemUnit: '\u9879',
                        itemsUnit: '\u9879',
                        remove: '\u5220\u9664',
                        selectCurrent: '\u5168\u9009\u5f53\u9875',
                        removeCurrent: '\u5220\u9664\u5f53\u9875',
                        selectAll: '\u5168\u9009\u6240\u6709',
                        removeAll: '\u5220\u9664\u5168\u90e8',
                        selectInvert: '\u53cd\u9009\u5f53\u9875',
                    },
                    Upload: {
                        uploading: '\u6587\u4ef6\u4e0a\u4f20\u4e2d',
                        removeFile: '\u5220\u9664\u6587\u4ef6',
                        uploadError: '\u4e0a\u4f20\u9519\u8bef',
                        previewFile: '\u9884\u89c8\u6587\u4ef6',
                        downloadFile: '\u4e0b\u8f7d\u6587\u4ef6',
                    },
                    Empty: { description: '\u6682\u65e0\u6570\u636e' },
                    Icon: { icon: '\u56fe\u6807' },
                    Text: {
                        edit: '\u7f16\u8f91',
                        copy: '\u590d\u5236',
                        copied: '\u590d\u5236\u6210\u529f',
                        expand: '\u5c55\u5f00',
                    },
                    PageHeader: { back: '\u8fd4\u56de' },
                    Image: { preview: '\u9884\u89c8' },
                    CronExpression: {
                        cronError: 'cron \u8868\u8fbe\u5f0f\u4e0d\u5408\u6cd5',
                        second: '\u79d2',
                        minute: '\u5206\u949f',
                        hour: '\u5c0f\u65f6',
                        day: '\u65e5',
                        month: '\u6708',
                        week: '\u5468',
                    },
                    QRCode: { expired: '\u4e8c\u7ef4\u7801\u8fc7\u671f', refresh: '\u70b9\u51fb\u5237\u65b0' },
                };
            const Gg = new $e('nz-i18n'),
                _Z = new $e('nz-date-locale');
            let zu = (() => {
                    class t {
                        get localeChange() {
                            return this._change.asObservable();
                        }
                        constructor(e, i) {
                            (this._change = new Ke(this._locale)),
                                this.setLocale(e || vZ),
                                this.setDateLocale(i || null);
                        }
                        translate(e, i) {
                            let r = this._getObjectPath(this._locale, e);
                            return 'string' == typeof r
                                ? (i && Object.keys(i).forEach(s => (r = r.replace(new RegExp(`%${s}%`, 'g'), i[s]))),
                                  r)
                                : e;
                        }
                        setLocale(e) {
                            (this._locale && this._locale.locale === e.locale) ||
                                ((this._locale = e), this._change.next(e));
                        }
                        getLocale() {
                            return this._locale;
                        }
                        getLocaleId() {
                            return this._locale ? this._locale.locale : '';
                        }
                        setDateLocale(e) {
                            this.dateLocale = e;
                        }
                        getDateLocale() {
                            return this.dateLocale;
                        }
                        getLocaleData(e, i) {
                            const r = e ? this._getObjectPath(this._locale, e) : this._locale;
                            return (
                                !r &&
                                    !i &&
                                    ku(
                                        `Missing translations for "${e}" in language "${this._locale.locale}".\nYou can use "NzI18nService.setLocale" as a temporary fix.\nWelcome to submit a pull request to help us optimize the translations!\nhttps://github.com/NG-ZORRO/ng-zorro-antd/blob/master/CONTRIBUTING.md`,
                                    ),
                                r || i || this._getObjectPath(nx, e) || {}
                            );
                        }
                        _getObjectPath(e, i) {
                            let r = e;
                            const s = i.split('.'),
                                o = s.length;
                            let a = 0;
                            for (; r && a < o; ) r = r[s[a++]];
                            return a === o ? r : null;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Gg, 8), Se(_Z, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                yZ = (() => {
                    class t {
                        constructor(e) {
                            this._locale = e;
                        }
                        transform(e, i) {
                            return this._locale.translate(e, i);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(zu, 16));
                        });
                        static #t = (this.ɵpipe = jr({ name: 'nzI18n', type: t, pure: !0, standalone: !0 }));
                    }
                    return t;
                })(),
                bZ = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })();
            const ix = new $e('date-config'),
                CZ = { firstDayOfWeek: void 0 };
            let Aa = (() => {
                class t {
                    constructor(e, i) {
                        (this.i18n = e),
                            (this.config = (function wZ(t) {
                                return { ...CZ, ...t };
                            })(i));
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(zu), Se(ix, 8));
                    });
                    static #t = (this.ɵprov = We({
                        token: t,
                        factory: () =>
                            (function MZ() {
                                const t = Ue(zu),
                                    n = Ue(ix, { optional: !0 });
                                return t.getDateLocale() ? new SZ(t, n) : new TZ(t, n);
                            })(),
                        providedIn: 'root',
                    }));
                }
                return t;
            })();
            class SZ extends Aa {
                getISOWeek(n) {
                    return (function mQ(t) {
                        Ot(1, arguments);
                        var n = fn(t),
                            e =
                                Uf(n).getTime() -
                                (function hQ(t) {
                                    Ot(1, arguments);
                                    var n = (function dQ(t) {
                                            Ot(1, arguments);
                                            var n = fn(t),
                                                e = n.getFullYear(),
                                                i = new Date(0);
                                            i.setFullYear(e + 1, 0, 4), i.setHours(0, 0, 0, 0);
                                            var r = Uf(i),
                                                s = new Date(0);
                                            s.setFullYear(e, 0, 4), s.setHours(0, 0, 0, 0);
                                            var o = Uf(s);
                                            return n.getTime() >= r.getTime()
                                                ? e + 1
                                                : n.getTime() >= o.getTime()
                                                ? e
                                                : e - 1;
                                        })(t),
                                        e = new Date(0);
                                    return e.setFullYear(n, 0, 4), e.setHours(0, 0, 0, 0), Uf(e);
                                })(n).getTime();
                        return Math.round(e / 6048e5) + 1;
                    })(n);
                }
                getFirstDayOfWeek() {
                    let n;
                    try {
                        n = this.i18n.getDateLocale().options.weekStartsOn;
                    } catch {
                        n = 1;
                    }
                    return null == this.config.firstDayOfWeek ? n : this.config.firstDayOfWeek;
                }
                format(n, e) {
                    return n
                        ? (function vX(t, n, e) {
                              var i, r, s, o, a, l, c, f, g, E, P, V, W, ie, he, fe, ze, nt;
                              Ot(2, arguments);
                              var kt = String(n),
                                  Tt = kc(),
                                  rn =
                                      null !== (i = null !== (r = e?.locale) && void 0 !== r ? r : Tt.locale) &&
                                      void 0 !== i
                                          ? i
                                          : $D,
                                  Nn = fr(
                                      null !==
                                          (s =
                                              null !==
                                                  (o =
                                                      null !==
                                                          (a =
                                                              null !== (l = e?.firstWeekContainsDate) && void 0 !== l
                                                                  ? l
                                                                  : null == e ||
                                                                    null === (c = e.locale) ||
                                                                    void 0 === c ||
                                                                    null === (f = c.options) ||
                                                                    void 0 === f
                                                                  ? void 0
                                                                  : f.firstWeekContainsDate) && void 0 !== a
                                                          ? a
                                                          : Tt.firstWeekContainsDate) && void 0 !== o
                                                  ? o
                                                  : null === (g = Tt.locale) ||
                                                    void 0 === g ||
                                                    null === (E = g.options) ||
                                                    void 0 === E
                                                  ? void 0
                                                  : E.firstWeekContainsDate) && void 0 !== s
                                          ? s
                                          : 1,
                                  );
                              if (!(Nn >= 1 && Nn <= 7))
                                  throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
                              var vn = fr(
                                  null !==
                                      (P =
                                          null !==
                                              (V =
                                                  null !==
                                                      (W =
                                                          null !== (ie = e?.weekStartsOn) && void 0 !== ie
                                                              ? ie
                                                              : null == e ||
                                                                null === (he = e.locale) ||
                                                                void 0 === he ||
                                                                null === (fe = he.options) ||
                                                                void 0 === fe
                                                              ? void 0
                                                              : fe.weekStartsOn) && void 0 !== W
                                                      ? W
                                                      : Tt.weekStartsOn) && void 0 !== V
                                              ? V
                                              : null === (ze = Tt.locale) ||
                                                void 0 === ze ||
                                                null === (nt = ze.options) ||
                                                void 0 === nt
                                              ? void 0
                                              : nt.weekStartsOn) && void 0 !== P
                                      ? P
                                      : 0,
                              );
                              if (!(vn >= 0 && vn <= 6))
                                  throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                              if (!rn.localize) throw new RangeError('locale must contain localize property');
                              if (!rn.formatLong) throw new RangeError('locale must contain formatLong property');
                              var Si = fn(t);
                              if (!a0(Si)) throw new RangeError('Invalid time value');
                              var ir = ND(Si, Hf(Si)),
                                  wo = { firstWeekContainsDate: Nn, weekStartsOn: vn, locale: rn, _originalDate: Si },
                                  La = kt
                                      .match(fX)
                                      .map(function (Zi) {
                                          var tt = Zi[0];
                                          return 'p' === tt || 'P' === tt ? (0, Bg[tt])(Zi, rn.formatLong) : Zi;
                                      })
                                      .join('')
                                      .match(hX)
                                      .map(function (Zi) {
                                          if ("''" === Zi) return "'";
                                          var tt = Zi[0];
                                          if ("'" === tt)
                                              return (function _X(t) {
                                                  var n = t.match(mX);
                                                  return n ? n[1].replace(pX, "'") : t;
                                              })(Zi);
                                          var yt = SQ[tt];
                                          if (yt)
                                              return (
                                                  !(null != e && e.useAdditionalWeekYearTokens) &&
                                                      jD(Zi) &&
                                                      Bf(Zi, n, String(t)),
                                                  !(null != e && e.useAdditionalDayOfYearTokens) &&
                                                      YD(Zi) &&
                                                      Bf(Zi, n, String(t)),
                                                  yt(ir, Zi, rn.localize, wo)
                                              );
                                          if (tt.match(gX))
                                              throw new RangeError(
                                                  'Format string contains an unescaped latin alphabet character `' +
                                                      tt +
                                                      '`',
                                              );
                                          return Zi;
                                      })
                                      .join('');
                              return La;
                          })(n, e, { locale: this.i18n.getDateLocale() })
                        : '';
                }
                parseDate(n, e) {
                    return (function pZ(t, n, e, i) {
                        var r, s, o, a, l, c, f, g, E, P, V, W, ie, he, fe, ze, nt, kt;
                        Ot(3, arguments);
                        var Tt = String(t),
                            rn = String(n),
                            Nn = kc(),
                            vn =
                                null !== (r = null !== (s = i?.locale) && void 0 !== s ? s : Nn.locale) && void 0 !== r
                                    ? r
                                    : $D;
                        if (!vn.match) throw new RangeError('locale must contain match property');
                        var Si = fr(
                            null !==
                                (o =
                                    null !==
                                        (a =
                                            null !==
                                                (l =
                                                    null !== (c = i?.firstWeekContainsDate) && void 0 !== c
                                                        ? c
                                                        : null == i ||
                                                          null === (f = i.locale) ||
                                                          void 0 === f ||
                                                          null === (g = f.options) ||
                                                          void 0 === g
                                                        ? void 0
                                                        : g.firstWeekContainsDate) && void 0 !== l
                                                ? l
                                                : Nn.firstWeekContainsDate) && void 0 !== a
                                        ? a
                                        : null === (E = Nn.locale) ||
                                          void 0 === E ||
                                          null === (P = E.options) ||
                                          void 0 === P
                                        ? void 0
                                        : P.firstWeekContainsDate) && void 0 !== o
                                ? o
                                : 1,
                        );
                        if (!(Si >= 1 && Si <= 7))
                            throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
                        var ms = fr(
                            null !==
                                (V =
                                    null !==
                                        (W =
                                            null !==
                                                (ie =
                                                    null !== (he = i?.weekStartsOn) && void 0 !== he
                                                        ? he
                                                        : null == i ||
                                                          null === (fe = i.locale) ||
                                                          void 0 === fe ||
                                                          null === (ze = fe.options) ||
                                                          void 0 === ze
                                                        ? void 0
                                                        : ze.weekStartsOn) && void 0 !== ie
                                                ? ie
                                                : Nn.weekStartsOn) && void 0 !== W
                                        ? W
                                        : null === (nt = Nn.locale) ||
                                          void 0 === nt ||
                                          null === (kt = nt.options) ||
                                          void 0 === kt
                                        ? void 0
                                        : kt.weekStartsOn) && void 0 !== V
                                ? V
                                : 0,
                        );
                        if (!(ms >= 0 && ms <= 6))
                            throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
                        if ('' === rn) return '' === Tt ? fn(e) : new Date(NaN);
                        var yt,
                            ir = { firstWeekContainsDate: Si, weekStartsOn: ms, locale: vn },
                            wo = [new TX()],
                            La = rn
                                .match(uZ)
                                .map(function (Wi) {
                                    var Dn = Wi[0];
                                    return Dn in Bg ? (0, Bg[Dn])(Wi, vn.formatLong) : Wi;
                                })
                                .join('')
                                .match(cZ),
                            Zi = [],
                            tt = WD(La);
                        try {
                            var jt = function () {
                                var Dn = yt.value;
                                !(null != i && i.useAdditionalWeekYearTokens) && jD(Dn) && Bf(Dn, rn, t),
                                    (null == i || !i.useAdditionalDayOfYearTokens) && YD(Dn) && Bf(Dn, rn, t);
                                var ks = Dn[0],
                                    Oc = lZ[ks];
                                if (Oc) {
                                    var Fk = Oc.incompatibleTokens;
                                    if (Array.isArray(Fk)) {
                                        var Rk = Zi.find(function (Vk) {
                                            return Fk.includes(Vk.token) || Vk.token === ks;
                                        });
                                        if (Rk)
                                            throw new RangeError(
                                                "The format string mustn't contain `"
                                                    .concat(Rk.fullToken, '` and `')
                                                    .concat(Dn, '` at the same time'),
                                            );
                                    } else if ('*' === Oc.incompatibleTokens && Zi.length > 0)
                                        throw new RangeError(
                                            "The format string mustn't contain `".concat(
                                                Dn,
                                                '` and any other token at the same time',
                                            ),
                                        );
                                    Zi.push({ token: ks, fullToken: Dn });
                                    var S5 = Oc.run(Tt, Dn, vn.match, ir);
                                    if (!S5) return { v: new Date(NaN) };
                                    wo.push(S5.setter), (Tt = S5.rest);
                                } else {
                                    if (ks.match(mZ))
                                        throw new RangeError(
                                            'Format string contains an unescaped latin alphabet character `' + ks + '`',
                                        );
                                    if (
                                        ("''" === Dn
                                            ? (Dn = "'")
                                            : "'" === ks &&
                                              (Dn = (function gZ(t) {
                                                  return t.match(dZ)[1].replace(hZ, "'");
                                              })(Dn)),
                                        0 !== Tt.indexOf(Dn))
                                    )
                                        return { v: new Date(NaN) };
                                    Tt = Tt.slice(Dn.length);
                                }
                            };
                            for (tt.s(); !(yt = tt.n()).done; ) {
                                var Fn = jt();
                                if ('object' === Fl(Fn)) return Fn.v;
                            }
                        } catch (Wi) {
                            tt.e(Wi);
                        } finally {
                            tt.f();
                        }
                        if (Tt.length > 0 && fZ.test(Tt)) return new Date(NaN);
                        var Ur = wo
                                .map(function (Wi) {
                                    return Wi.priority;
                                })
                                .sort(function (Wi, Dn) {
                                    return Dn - Wi;
                                })
                                .filter(function (Wi, Dn, ks) {
                                    return ks.indexOf(Wi) === Dn;
                                })
                                .map(function (Wi) {
                                    return wo
                                        .filter(function (Dn) {
                                            return Dn.priority === Wi;
                                        })
                                        .sort(function (Dn, ks) {
                                            return ks.subPriority - Dn.subPriority;
                                        });
                                })
                                .map(function (Wi) {
                                    return Wi[0];
                                }),
                            Mo = fn(e);
                        if (isNaN(Mo.getTime())) return new Date(NaN);
                        var Eh,
                            is = ND(Mo, Hf(Mo)),
                            Oa = {},
                            Li = WD(Ur);
                        try {
                            for (Li.s(); !(Eh = Li.n()).done; ) {
                                var p3 = Eh.value;
                                if (!p3.validate(is, ir)) return new Date(NaN);
                                var Or = p3.set(is, Oa, ir);
                                Array.isArray(Or) ? ((is = Or[0]), bX(Oa, Or[1])) : (is = Or);
                            }
                        } catch (Wi) {
                            Li.e(Wi);
                        } finally {
                            Li.f();
                        }
                        return is;
                    })(n, e, new Date(), { locale: this.i18n.getDateLocale(), weekStartsOn: this.getFirstDayOfWeek() });
                }
                parseTime(n, e) {
                    return this.parseDate(n, e);
                }
            }
            class TZ extends Aa {
                getISOWeek(n) {
                    return +this.format(n, 'w');
                }
                getFirstDayOfWeek() {
                    if (void 0 === this.config.firstDayOfWeek) {
                        const n = this.i18n.getLocaleId();
                        return n && ['zh-cn', 'zh-tw'].indexOf(n.toLowerCase()) > -1 ? 1 : 0;
                    }
                    return this.config.firstDayOfWeek;
                }
                format(n, e) {
                    return n ? MC(n, e, this.i18n.getLocaleId()) : '';
                }
                parseDate(n) {
                    return new Date(n);
                }
                parseTime(n, e) {
                    return new uQ(e, this.i18n.getLocaleId()).toDate(n);
                }
            }
            var DZ = {
                    locale: 'de',
                    Pagination: {
                        items_per_page: '/ Seite',
                        jump_to: 'Gehe zu',
                        jump_to_confirm: 'best\xe4tigen',
                        page: 'Seite',
                        prev_page: 'Vorherige Seite',
                        next_page: 'N\xe4chste Seite',
                        prev_5: '5 Seiten zur\xfcck',
                        next_5: '5 Seiten vor',
                        prev_3: '3 Seiten zur\xfcck',
                        next_3: '3 Seiten vor',
                        page_size: 'Page Size',
                    },
                    DatePicker: {
                        lang: {
                            placeholder: 'Datum ausw\xe4hlen',
                            yearPlaceholder: 'Jahr ausw\xe4hlen',
                            quarterPlaceholder: 'Quartal ausw\xe4hlen',
                            monthPlaceholder: 'Monat ausw\xe4hlen',
                            weekPlaceholder: 'Woche ausw\xe4hlen',
                            rangePlaceholder: ['Startdatum', 'Enddatum'],
                            rangeYearPlaceholder: ['Startjahr', 'Endjahr'],
                            rangeMonthPlaceholder: ['Startmonat', 'Endmonat'],
                            rangeWeekPlaceholder: ['Startwoche', 'Endwoche'],
                            locale: 'de_DE',
                            today: 'Heute',
                            now: 'Jetzt',
                            backToToday: 'Zur\xfcck zu Heute',
                            ok: 'OK',
                            clear: 'Zur\xfccksetzen',
                            month: 'Monat',
                            year: 'Jahr',
                            timeSelect: 'Zeit w\xe4hlen',
                            dateSelect: 'Datum w\xe4hlen',
                            weekSelect: 'Woche w\xe4hlen',
                            monthSelect: 'W\xe4hle einen Monat',
                            yearSelect: 'W\xe4hle ein Jahr',
                            decadeSelect: 'W\xe4hle ein Jahrzehnt',
                            yearFormat: 'YYYY',
                            dateFormat: 'D.M.YYYY',
                            dayFormat: 'D',
                            dateTimeFormat: 'D.M.YYYY HH:mm:ss',
                            monthBeforeYear: !0,
                            previousMonth: 'Vorheriger Monat (PageUp)',
                            nextMonth: 'N\xe4chster Monat (PageDown)',
                            previousYear: 'Vorheriges Jahr (Ctrl + left)',
                            nextYear: 'N\xe4chstes Jahr (Ctrl + right)',
                            previousDecade: 'Vorheriges Jahrzehnt',
                            nextDecade: 'N\xe4chstes Jahrzehnt',
                            previousCentury: 'Vorheriges Jahrhundert',
                            nextCentury: 'N\xe4chstes Jahrhundert',
                        },
                        timePickerLocale: {
                            placeholder: 'Zeit ausw\xe4hlen',
                            rangePlaceholder: ['Startzeit', 'Endzeit'],
                        },
                    },
                    TimePicker: { placeholder: 'Zeit ausw\xe4hlen' },
                    Calendar: {
                        lang: {
                            placeholder: 'Datum ausw\xe4hlen',
                            yearPlaceholder: 'Jahr ausw\xe4hlen',
                            quarterPlaceholder: 'Quartal ausw\xe4hlen',
                            monthPlaceholder: 'Monat ausw\xe4hlen',
                            weekPlaceholder: 'Woche ausw\xe4hlen',
                            rangePlaceholder: ['Startdatum', 'Enddatum'],
                            rangeYearPlaceholder: ['Startjahr', 'Endjahr'],
                            rangeMonthPlaceholder: ['Startmonat', 'Endmonat'],
                            rangeWeekPlaceholder: ['Startwoche', 'Endwoche'],
                            locale: 'de_DE',
                            today: 'Heute',
                            now: 'Jetzt',
                            backToToday: 'Zur\xfcck zu Heute',
                            ok: 'OK',
                            clear: 'Zur\xfccksetzen',
                            month: 'Monat',
                            year: 'Jahr',
                            timeSelect: 'Zeit w\xe4hlen',
                            dateSelect: 'Datum w\xe4hlen',
                            weekSelect: 'Woche w\xe4hlen',
                            monthSelect: 'W\xe4hle einen Monat',
                            yearSelect: 'W\xe4hle ein Jahr',
                            decadeSelect: 'W\xe4hle ein Jahrzehnt',
                            yearFormat: 'YYYY',
                            dateFormat: 'D.M.YYYY',
                            dayFormat: 'D',
                            dateTimeFormat: 'D.M.YYYY HH:mm:ss',
                            monthBeforeYear: !0,
                            previousMonth: 'Vorheriger Monat (PageUp)',
                            nextMonth: 'N\xe4chster Monat (PageDown)',
                            previousYear: 'Vorheriges Jahr (Ctrl + left)',
                            nextYear: 'N\xe4chstes Jahr (Ctrl + right)',
                            previousDecade: 'Vorheriges Jahrzehnt',
                            nextDecade: 'N\xe4chstes Jahrzehnt',
                            previousCentury: 'Vorheriges Jahrhundert',
                            nextCentury: 'N\xe4chstes Jahrhundert',
                        },
                        timePickerLocale: {
                            placeholder: 'Zeit ausw\xe4hlen',
                            rangePlaceholder: ['Startzeit', 'Endzeit'],
                        },
                    },
                    global: { placeholder: 'Bitte ausw\xe4hlen' },
                    Table: {
                        filterTitle: 'Filter-Men\xfc',
                        filterConfirm: 'OK',
                        filterReset: 'Zur\xfccksetzen',
                        filterEmptyText: 'Keine Filter',
                        emptyText: 'Keine Daten',
                        selectAll: 'Selektiere Alle',
                        selectInvert: 'Selektion Invertieren',
                        selectionAll: 'W\xe4hlen Sie alle Daten aus',
                        sortTitle: 'Sortieren',
                        expand: 'Zeile erweitern',
                        collapse: 'Zeile reduzieren',
                        triggerDesc: 'Klicken zur absteigenden  Sortierung',
                        triggerAsc: 'Klicken zur aufsteigenden Sortierung',
                        cancelSort: 'Klicken zum Abbrechen der Sortierung',
                    },
                    Modal: { okText: 'OK', cancelText: 'Abbrechen', justOkText: 'OK' },
                    Popconfirm: { okText: 'OK', cancelText: 'Abbrechen' },
                    Transfer: {
                        titles: ['', ''],
                        searchPlaceholder: 'Suchen',
                        itemUnit: 'Eintrag',
                        itemsUnit: 'Eintr\xe4ge',
                        remove: 'Entfernen',
                        selectCurrent: 'Alle auf aktueller Seite ausw\xe4hlen',
                        removeCurrent: 'Auswahl auf aktueller Seite aufheben',
                        selectAll: 'Alle ausw\xe4hlen',
                        removeAll: 'Auswahl aufheben',
                        selectInvert: 'Auswahl umkehren',
                    },
                    Upload: {
                        uploading: 'Hochladen...',
                        removeFile: 'Datei entfernen',
                        uploadError: 'Fehler beim Hochladen',
                        previewFile: 'Dateivorschau',
                        downloadFile: 'Download-Datei',
                    },
                    Empty: { description: 'Keine Daten' },
                    Text: { edit: 'Bearbeiten', copy: 'Kopieren', copied: 'Kopiert', expand: 'Erweitern' },
                    PageHeader: { back: 'Zur\xfcck' },
                    Image: { preview: 'Vorschau' },
                },
                rx = {
                    locale: 'en-gb',
                    Pagination: {
                        items_per_page: '/ page',
                        jump_to: 'Go to',
                        jump_to_confirm: 'confirm',
                        page: 'Page',
                        prev_page: 'Previous Page',
                        next_page: 'Next Page',
                        prev_5: 'Previous 5 Pages',
                        next_5: 'Next 5 Pages',
                        prev_3: 'Previous 3 Pages',
                        next_3: 'Next 3 Pages',
                        page_size: 'Page Size',
                    },
                    DatePicker: {
                        lang: {
                            placeholder: 'Select date',
                            yearPlaceholder: 'Select year',
                            quarterPlaceholder: 'Select quarter',
                            monthPlaceholder: 'Select month',
                            weekPlaceholder: 'Select week',
                            rangePlaceholder: ['Start date', 'End date'],
                            rangeYearPlaceholder: ['Start year', 'End year'],
                            rangeMonthPlaceholder: ['Start month', 'End month'],
                            rangeWeekPlaceholder: ['Start week', 'End week'],
                            locale: 'en_GB',
                            today: 'Today',
                            now: 'Now',
                            backToToday: 'Back to today',
                            ok: 'Ok',
                            clear: 'Clear',
                            month: 'Month',
                            year: 'Year',
                            timeSelect: 'Select time',
                            dateSelect: 'Select date',
                            weekSelect: 'Choose a week',
                            monthSelect: 'Choose a month',
                            yearSelect: 'Choose a year',
                            decadeSelect: 'Choose a decade',
                            yearFormat: 'YYYY',
                            dateFormat: 'D/M/YYYY',
                            dayFormat: 'D',
                            dateTimeFormat: 'D/M/YYYY HH:mm:ss',
                            monthBeforeYear: !0,
                            previousMonth: 'Previous month (PageUp)',
                            nextMonth: 'Next month (PageDown)',
                            previousYear: 'Last year (Control + left)',
                            nextYear: 'Next year (Control + right)',
                            previousDecade: 'Last decade',
                            nextDecade: 'Next decade',
                            previousCentury: 'Last century',
                            nextCentury: 'Next century',
                        },
                        timePickerLocale: { placeholder: 'Select time', rangePlaceholder: ['Start time', 'End time'] },
                    },
                    TimePicker: { placeholder: 'Select time', rangePlaceholder: ['Start time', 'End time'] },
                    Calendar: {
                        lang: {
                            placeholder: 'Select date',
                            yearPlaceholder: 'Select year',
                            quarterPlaceholder: 'Select quarter',
                            monthPlaceholder: 'Select month',
                            weekPlaceholder: 'Select week',
                            rangePlaceholder: ['Start date', 'End date'],
                            rangeYearPlaceholder: ['Start year', 'End year'],
                            rangeMonthPlaceholder: ['Start month', 'End month'],
                            rangeWeekPlaceholder: ['Start week', 'End week'],
                            locale: 'en_GB',
                            today: 'Today',
                            now: 'Now',
                            backToToday: 'Back to today',
                            ok: 'Ok',
                            clear: 'Clear',
                            month: 'Month',
                            year: 'Year',
                            timeSelect: 'Select time',
                            dateSelect: 'Select date',
                            weekSelect: 'Choose a week',
                            monthSelect: 'Choose a month',
                            yearSelect: 'Choose a year',
                            decadeSelect: 'Choose a decade',
                            yearFormat: 'YYYY',
                            dateFormat: 'D/M/YYYY',
                            dayFormat: 'D',
                            dateTimeFormat: 'D/M/YYYY HH:mm:ss',
                            monthBeforeYear: !0,
                            previousMonth: 'Previous month (PageUp)',
                            nextMonth: 'Next month (PageDown)',
                            previousYear: 'Last year (Control + left)',
                            nextYear: 'Next year (Control + right)',
                            previousDecade: 'Last decade',
                            nextDecade: 'Next decade',
                            previousCentury: 'Last century',
                            nextCentury: 'Next century',
                        },
                        timePickerLocale: { placeholder: 'Select time', rangePlaceholder: ['Start time', 'End time'] },
                    },
                    global: { placeholder: 'Please select' },
                    Table: {
                        filterTitle: 'Filter menu',
                        filterConfirm: 'OK',
                        filterReset: 'Reset',
                        filterEmptyText: 'No filters',
                        emptyText: 'No data',
                        selectAll: 'Select current page',
                        selectInvert: 'Invert current page',
                        selectionAll: 'Select all data',
                        sortTitle: 'Sort',
                        expand: 'Expand row',
                        collapse: 'Collapse row',
                        triggerDesc: 'Click to sort descending',
                        triggerAsc: 'Click to sort ascending',
                        cancelSort: 'Click to cancel sorting',
                        selectNone: 'Clear all data',
                    },
                    Modal: { okText: 'OK', cancelText: 'Cancel', justOkText: 'OK' },
                    Popconfirm: { okText: 'OK', cancelText: 'Cancel' },
                    Transfer: {
                        titles: ['', ''],
                        searchPlaceholder: 'Search here',
                        itemUnit: 'item',
                        itemsUnit: 'items',
                        remove: 'Remove',
                        selectCurrent: 'Select current page',
                        removeCurrent: 'Remove current page',
                        selectAll: 'Select all data',
                        removeAll: 'Remove all data',
                        selectInvert: 'Invert current page',
                    },
                    Upload: {
                        uploading: 'Uploading...',
                        removeFile: 'Remove file',
                        uploadError: 'Upload error',
                        previewFile: 'Preview file',
                        downloadFile: 'Download file',
                    },
                    Empty: { description: 'No data' },
                    Icon: { icon: 'icon' },
                    Text: { edit: 'Edit', copy: 'Copy', copied: 'Copied', expand: 'Expand' },
                    PageHeader: { back: 'Back' },
                },
                xZ = {
                    locale: 'ro',
                    Pagination: {
                        items_per_page: '/ pagin\u0103',
                        jump_to: 'Mergi la',
                        jump_to_confirm: 'confirm',
                        page: '',
                        prev_page: 'Pagina Anterioar\u0103',
                        next_page: 'Pagina Urm\u0103toare',
                        prev_5: '5 Pagini Anterioare',
                        next_5: '5 Pagini Urm\u0103toare',
                        prev_3: '3 Pagini Anterioare',
                        next_3: '3 Pagini Urm\u0103toare',
                        page_size: 'Page Size',
                    },
                    DatePicker: {
                        lang: {
                            placeholder: 'Selecteaz\u0103 data',
                            rangePlaceholder: ['Data start', 'Data sf\xe2r\u0219it'],
                            locale: 'ro_RO',
                            today: 'Azi',
                            now: 'Acum',
                            backToToday: '\xcenapoi la azi',
                            ok: 'Ok',
                            clear: '\u0218terge',
                            month: 'Lun\u0103',
                            year: 'An',
                            timeSelect: 'selecteaz\u0103 timpul',
                            dateSelect: 'selecteaz\u0103 data',
                            weekSelect: 'Alege o s\u0103pt\u0103m\xe2n\u0103',
                            monthSelect: 'Alege o lun\u0103',
                            yearSelect: 'Alege un an',
                            decadeSelect: 'Alege un deceniu',
                            yearFormat: 'YYYY',
                            dateFormat: 'D/M/YYYY',
                            dayFormat: 'D',
                            dateTimeFormat: 'D/M/YYYY HH:mm:ss',
                            monthBeforeYear: !0,
                            previousMonth: 'Luna anterioar\u0103 (PageUp)',
                            nextMonth: 'Luna urm\u0103toare (PageDown)',
                            previousYear: 'Anul anterior (Control + st\xe2nga)',
                            nextYear: 'Anul urm\u0103tor (Control + dreapta)',
                            previousDecade: 'Deceniul anterior',
                            nextDecade: 'Deceniul urm\u0103tor',
                            previousCentury: 'Secolul anterior',
                            nextCentury: 'Secolul urm\u0103tor',
                        },
                        timePickerLocale: { placeholder: 'Selecteaz\u0103 ora' },
                    },
                    TimePicker: { placeholder: 'Selecteaz\u0103 ora' },
                    Calendar: {
                        lang: {
                            placeholder: 'Selecteaz\u0103 data',
                            rangePlaceholder: ['Data start', 'Data sf\xe2r\u0219it'],
                            locale: 'ro_RO',
                            today: 'Azi',
                            now: 'Acum',
                            backToToday: '\xcenapoi la azi',
                            ok: 'Ok',
                            clear: '\u0218terge',
                            month: 'Lun\u0103',
                            year: 'An',
                            timeSelect: 'selecteaz\u0103 timpul',
                            dateSelect: 'selecteaz\u0103 data',
                            weekSelect: 'Alege o s\u0103pt\u0103m\xe2n\u0103',
                            monthSelect: 'Alege o lun\u0103',
                            yearSelect: 'Alege un an',
                            decadeSelect: 'Alege un deceniu',
                            yearFormat: 'YYYY',
                            dateFormat: 'D/M/YYYY',
                            dayFormat: 'D',
                            dateTimeFormat: 'D/M/YYYY HH:mm:ss',
                            monthBeforeYear: !0,
                            previousMonth: 'Luna anterioar\u0103 (PageUp)',
                            nextMonth: 'Luna urm\u0103toare (PageDown)',
                            previousYear: 'Anul anterior (Control + st\xe2nga)',
                            nextYear: 'Anul urm\u0103tor (Control + dreapta)',
                            previousDecade: 'Deceniul anterior',
                            nextDecade: 'Deceniul urm\u0103tor',
                            previousCentury: 'Secolul anterior',
                            nextCentury: 'Secolul urm\u0103tor',
                        },
                        timePickerLocale: { placeholder: 'Selecteaz\u0103 ora' },
                    },
                    global: { placeholder: 'Selecteaz\u0103' },
                    Table: {
                        filterTitle: 'Filtreaz\u0103',
                        filterConfirm: 'OK',
                        filterReset: 'Reseteaz\u0103',
                        selectAll: 'Selecteaz\u0103 pagina curent\u0103',
                        selectInvert: 'Inverseaz\u0103 pagina curent\u0103',
                        sortTitle: 'Ordoneaz\u0103',
                        expand: 'Extinde r\xe2ndul',
                        collapse: 'Mic\u0219oreaz\u0103 r\xe2ndul',
                        filterEmptyText: 'F\u0103r\u0103 filtre',
                        emptyText: 'Nu exist\u0103 date',
                        selectNone: '\u0218terge selec\u021bia',
                        selectionAll: 'Selecteaz\u0103 toate datele',
                        triggerDesc: 'Apas\u0103 pentru ordonare descresc\u0103toare',
                        triggerAsc: 'Apas\u0103 pentru ordonare cresc\u0103toare',
                        cancelSort: 'Apas\u0103 pentru a anula ordonarea',
                    },
                    Modal: { okText: 'OK', cancelText: 'Anulare', justOkText: 'OK' },
                    Popconfirm: { okText: 'OK', cancelText: 'Anulare' },
                    Transfer: {
                        titles: ['', ''],
                        searchPlaceholder: 'C\u0103utare',
                        itemUnit: 'element',
                        itemsUnit: 'elemente',
                        remove: '\u0218terge',
                        selectCurrent: 'Selecteaz\u0103 pagina curent\u0103',
                        removeCurrent: '\u0218terge pagina curent\u0103',
                        selectAll: 'Selecteaz\u0103 toate datele',
                        removeAll: '\u0218terge toate datele',
                        selectInvert: 'Inverseaz\u0103 pagina curent\u0103',
                    },
                    Upload: {
                        uploading: 'Se transfer\u0103...',
                        removeFile: '\xcenl\u0103tur\u0103 fi\u0219ierul',
                        uploadError: 'Eroare la upload',
                        previewFile: 'Previzualizare fi\u0219ier',
                        downloadFile: 'Desc\u0103rcare fi\u0219ier',
                    },
                    Empty: { description: 'F\u0103r\u0103 date' },
                    Icon: { icon: 'icon' },
                    Text: { edit: 'editeaz\u0103', copy: 'copiaz\u0103', copied: 'copiat', expand: 'extinde' },
                    PageHeader: { back: '\xeenapoi' },
                    Image: { preview: 'Preview' },
                };
            const vh = {
                schedule(t) {
                    let n = requestAnimationFrame,
                        e = cancelAnimationFrame;
                    const { delegate: i } = vh;
                    i && ((n = i.requestAnimationFrame), (e = i.cancelAnimationFrame));
                    const r = n(s => {
                        (e = void 0), t(s);
                    });
                    return new ii(() => e?.(r));
                },
                requestAnimationFrame(...t) {
                    const { delegate: n } = vh;
                    return (n?.requestAnimationFrame || requestAnimationFrame)(...t);
                },
                cancelAnimationFrame(...t) {
                    const { delegate: n } = vh;
                    return (n?.cancelAnimationFrame || cancelAnimationFrame)(...t);
                },
                delegate: void 0,
            };
            new (class EZ extends Wp {
                flush(n) {
                    this._active = !0;
                    const e = this._scheduled;
                    this._scheduled = void 0;
                    const { actions: i } = this;
                    let r;
                    n = n || i.shift();
                    do {
                        if ((r = n.execute(n.state, n.delay))) break;
                    } while ((n = i[0]) && n.id === e && i.shift());
                    if (((this._active = !1), r)) {
                        for (; (n = i[0]) && n.id === e && i.shift(); ) n.unsubscribe();
                        throw r;
                    }
                }
            })(
                class kZ extends Gp {
                    constructor(n, e) {
                        super(n, e), (this.scheduler = n), (this.work = e);
                    }
                    requestAsyncId(n, e, i = 0) {
                        return null !== i && i > 0
                            ? super.requestAsyncId(n, e, i)
                            : (n.actions.push(this),
                              n._scheduled || (n._scheduled = vh.requestAnimationFrame(() => n.flush(void 0))));
                    }
                    recycleAsyncId(n, e, i = 0) {
                        var r;
                        if (null != i ? i > 0 : this.delay > 0) return super.recycleAsyncId(n, e, i);
                        const { actions: s } = n;
                        null != e &&
                            (null === (r = s[s.length - 1]) || void 0 === r ? void 0 : r.id) !== e &&
                            (vh.cancelAnimationFrame(e), (n._scheduled = void 0));
                    }
                },
            );
            let Wg,
                AZ = 1;
            const jf = {};
            function sx(t) {
                return t in jf && (delete jf[t], !0);
            }
            const LZ = {
                    setImmediate(t) {
                        const n = AZ++;
                        return (jf[n] = !0), Wg || (Wg = Promise.resolve()), Wg.then(() => sx(n) && t()), n;
                    },
                    clearImmediate(t) {
                        sx(t);
                    },
                },
                { setImmediate: OZ, clearImmediate: zZ } = LZ,
                $f = {
                    setImmediate(...t) {
                        const { delegate: n } = $f;
                        return (n?.setImmediate || OZ)(...t);
                    },
                    clearImmediate(t) {
                        const { delegate: n } = $f;
                        return (n?.clearImmediate || zZ)(t);
                    },
                    delegate: void 0,
                },
                ox = new (class NZ extends Wp {
                    flush(n) {
                        this._active = !0;
                        const e = this._scheduled;
                        this._scheduled = void 0;
                        const { actions: i } = this;
                        let r;
                        n = n || i.shift();
                        do {
                            if ((r = n.execute(n.state, n.delay))) break;
                        } while ((n = i[0]) && n.id === e && i.shift());
                        if (((this._active = !1), r)) {
                            for (; (n = i[0]) && n.id === e && i.shift(); ) n.unsubscribe();
                            throw r;
                        }
                    }
                })(
                    class PZ extends Gp {
                        constructor(n, e) {
                            super(n, e), (this.scheduler = n), (this.work = e);
                        }
                        requestAsyncId(n, e, i = 0) {
                            return null !== i && i > 0
                                ? super.requestAsyncId(n, e, i)
                                : (n.actions.push(this),
                                  n._scheduled || (n._scheduled = $f.setImmediate(n.flush.bind(n, void 0))));
                        }
                        recycleAsyncId(n, e, i = 0) {
                            var r;
                            if (null != i ? i > 0 : this.delay > 0) return super.recycleAsyncId(n, e, i);
                            const { actions: s } = n;
                            null != e &&
                                (null === (r = s[s.length - 1]) || void 0 === r ? void 0 : r.id) !== e &&
                                ($f.clearImmediate(e), n._scheduled === e && (n._scheduled = void 0));
                        }
                    },
                );
            function Kg(t, n = bf) {
                return (function FZ(t) {
                    return mi((n, e) => {
                        let i = !1,
                            r = null,
                            s = null,
                            o = !1;
                        const a = () => {
                                if ((s?.unsubscribe(), (s = null), i)) {
                                    i = !1;
                                    const c = r;
                                    (r = null), e.next(c);
                                }
                                o && e.complete();
                            },
                            l = () => {
                                (s = null), o && e.complete();
                            };
                        n.subscribe(
                            ln(
                                e,
                                c => {
                                    (i = !0), (r = c), s || bs(t(c)).subscribe((s = ln(e, a, l)));
                                },
                                () => {
                                    (o = !0), (!i || !s || s.closed) && e.complete();
                                },
                            ),
                        );
                    });
                })(() => Kp(t, n));
            }
            let VZ = (() => {
                    class t {
                        constructor(e, i, r) {
                            (this._ngZone = e),
                                (this._platform = i),
                                (this._scrolled = new vt()),
                                (this._globalSubscription = null),
                                (this._scrolledCount = 0),
                                (this.scrollContainers = new Map()),
                                (this._document = r);
                        }
                        register(e) {
                            this.scrollContainers.has(e) ||
                                this.scrollContainers.set(
                                    e,
                                    e.elementScrolled().subscribe(() => this._scrolled.next(e)),
                                );
                        }
                        deregister(e) {
                            const i = this.scrollContainers.get(e);
                            i && (i.unsubscribe(), this.scrollContainers.delete(e));
                        }
                        scrolled(e = 20) {
                            return this._platform.isBrowser
                                ? new Tn(i => {
                                      this._globalSubscription || this._addGlobalListener();
                                      const r =
                                          e > 0 ? this._scrolled.pipe(Kg(e)).subscribe(i) : this._scrolled.subscribe(i);
                                      return (
                                          this._scrolledCount++,
                                          () => {
                                              r.unsubscribe(),
                                                  this._scrolledCount--,
                                                  this._scrolledCount || this._removeGlobalListener();
                                          }
                                      );
                                  })
                                : Uo();
                        }
                        ngOnDestroy() {
                            this._removeGlobalListener(),
                                this.scrollContainers.forEach((e, i) => this.deregister(i)),
                                this._scrolled.complete();
                        }
                        ancestorScrolled(e, i) {
                            const r = this.getAncestorScrollContainers(e);
                            return this.scrolled(i).pipe(al(s => !s || r.indexOf(s) > -1));
                        }
                        getAncestorScrollContainers(e) {
                            const i = [];
                            return (
                                this.scrollContainers.forEach((r, s) => {
                                    this._scrollableContainsElement(s, e) && i.push(s);
                                }),
                                i
                            );
                        }
                        _getWindow() {
                            return this._document.defaultView || window;
                        }
                        _scrollableContainsElement(e, i) {
                            let r = dh(i),
                                s = e.getElementRef().nativeElement;
                            do {
                                if (r == s) return !0;
                            } while ((r = r.parentElement));
                            return !1;
                        }
                        _addGlobalListener() {
                            this._globalSubscription = this._ngZone.runOutsideAngular(() =>
                                ca(this._getWindow().document, 'scroll').subscribe(() => this._scrolled.next()),
                            );
                        }
                        _removeGlobalListener() {
                            this._globalSubscription &&
                                (this._globalSubscription.unsubscribe(), (this._globalSubscription = null));
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(en), Se(Go), Se(Ni, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                ax = (() => {
                    class t {
                        constructor(e, i, r) {
                            (this._platform = e),
                                (this._change = new vt()),
                                (this._changeListener = s => {
                                    this._change.next(s);
                                }),
                                (this._document = r),
                                i.runOutsideAngular(() => {
                                    if (e.isBrowser) {
                                        const s = this._getWindow();
                                        s.addEventListener('resize', this._changeListener),
                                            s.addEventListener('orientationchange', this._changeListener);
                                    }
                                    this.change().subscribe(() => (this._viewportSize = null));
                                });
                        }
                        ngOnDestroy() {
                            if (this._platform.isBrowser) {
                                const e = this._getWindow();
                                e.removeEventListener('resize', this._changeListener),
                                    e.removeEventListener('orientationchange', this._changeListener);
                            }
                            this._change.complete();
                        }
                        getViewportSize() {
                            this._viewportSize || this._updateViewportSize();
                            const e = { width: this._viewportSize.width, height: this._viewportSize.height };
                            return this._platform.isBrowser || (this._viewportSize = null), e;
                        }
                        getViewportRect() {
                            const e = this.getViewportScrollPosition(),
                                { width: i, height: r } = this.getViewportSize();
                            return {
                                top: e.top,
                                left: e.left,
                                bottom: e.top + r,
                                right: e.left + i,
                                height: r,
                                width: i,
                            };
                        }
                        getViewportScrollPosition() {
                            if (!this._platform.isBrowser) return { top: 0, left: 0 };
                            const e = this._document,
                                i = this._getWindow(),
                                r = e.documentElement,
                                s = r.getBoundingClientRect();
                            return {
                                top: -s.top || e.body.scrollTop || i.scrollY || r.scrollTop || 0,
                                left: -s.left || e.body.scrollLeft || i.scrollX || r.scrollLeft || 0,
                            };
                        }
                        change(e = 20) {
                            return e > 0 ? this._change.pipe(Kg(e)) : this._change;
                        }
                        _getWindow() {
                            return this._document.defaultView || window;
                        }
                        _updateViewportSize() {
                            const e = this._getWindow();
                            this._viewportSize = this._platform.isBrowser
                                ? { width: e.innerWidth, height: e.innerHeight }
                                : { width: 0, height: 0 };
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Go), Se(en), Se(Ni, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                lx = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })(),
                cx = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [Tg, lx, Tg, lx] }));
                    }
                    return t;
                })();
            class Qg {
                attach(n) {
                    return (this._attachedHost = n), n.attach(this);
                }
                detach() {
                    let n = this._attachedHost;
                    null != n && ((this._attachedHost = null), n.detach());
                }
                get isAttached() {
                    return null != this._attachedHost;
                }
                setAttachedHost(n) {
                    this._attachedHost = n;
                }
            }
            class BZ extends Qg {
                constructor(n, e, i, r, s) {
                    super(),
                        (this.component = n),
                        (this.viewContainerRef = e),
                        (this.injector = i),
                        (this.componentFactoryResolver = r),
                        (this.projectableNodes = s);
                }
            }
            class ux extends Qg {
                constructor(n, e, i, r) {
                    super(),
                        (this.templateRef = n),
                        (this.viewContainerRef = e),
                        (this.context = i),
                        (this.injector = r);
                }
                get origin() {
                    return this.templateRef.elementRef;
                }
                attach(n, e = this.context) {
                    return (this.context = e), super.attach(n);
                }
                detach() {
                    return (this.context = void 0), super.detach();
                }
            }
            class qZ extends Qg {
                constructor(n) {
                    super(), (this.element = n instanceof Pn ? n.nativeElement : n);
                }
            }
            class YZ {
                constructor() {
                    (this._isDisposed = !1), (this.attachDomPortal = null);
                }
                hasAttached() {
                    return !!this._attachedPortal;
                }
                attach(n) {
                    return n instanceof BZ
                        ? ((this._attachedPortal = n), this.attachComponentPortal(n))
                        : n instanceof ux
                        ? ((this._attachedPortal = n), this.attachTemplatePortal(n))
                        : this.attachDomPortal && n instanceof qZ
                        ? ((this._attachedPortal = n), this.attachDomPortal(n))
                        : void 0;
                }
                detach() {
                    this._attachedPortal && (this._attachedPortal.setAttachedHost(null), (this._attachedPortal = null)),
                        this._invokeDisposeFn();
                }
                dispose() {
                    this.hasAttached() && this.detach(), this._invokeDisposeFn(), (this._isDisposed = !0);
                }
                setDisposeFn(n) {
                    this._disposeFn = n;
                }
                _invokeDisposeFn() {
                    this._disposeFn && (this._disposeFn(), (this._disposeFn = null));
                }
            }
            class jZ extends YZ {
                constructor(n, e, i, r, s) {
                    super(),
                        (this.outletElement = n),
                        (this._componentFactoryResolver = e),
                        (this._appRef = i),
                        (this._defaultInjector = r),
                        (this.attachDomPortal = o => {
                            const a = o.element,
                                l = this._document.createComment('dom-portal');
                            a.parentNode.insertBefore(l, a),
                                this.outletElement.appendChild(a),
                                (this._attachedPortal = o),
                                super.setDisposeFn(() => {
                                    l.parentNode && l.parentNode.replaceChild(a, l);
                                });
                        }),
                        (this._document = s);
                }
                attachComponentPortal(n) {
                    const i = (n.componentFactoryResolver || this._componentFactoryResolver).resolveComponentFactory(
                        n.component,
                    );
                    let r;
                    return (
                        n.viewContainerRef
                            ? ((r = n.viewContainerRef.createComponent(
                                  i,
                                  n.viewContainerRef.length,
                                  n.injector || n.viewContainerRef.injector,
                                  n.projectableNodes || void 0,
                              )),
                              this.setDisposeFn(() => r.destroy()))
                            : ((r = i.create(n.injector || this._defaultInjector || ys.NULL)),
                              this._appRef.attachView(r.hostView),
                              this.setDisposeFn(() => {
                                  this._appRef.viewCount > 0 && this._appRef.detachView(r.hostView), r.destroy();
                              })),
                        this.outletElement.appendChild(this._getComponentRootNode(r)),
                        (this._attachedPortal = n),
                        r
                    );
                }
                attachTemplatePortal(n) {
                    let e = n.viewContainerRef,
                        i = e.createEmbeddedView(n.templateRef, n.context, { injector: n.injector });
                    return (
                        i.rootNodes.forEach(r => this.outletElement.appendChild(r)),
                        i.detectChanges(),
                        this.setDisposeFn(() => {
                            let r = e.indexOf(i);
                            -1 !== r && e.remove(r);
                        }),
                        (this._attachedPortal = n),
                        i
                    );
                }
                dispose() {
                    super.dispose(), this.outletElement.remove();
                }
                _getComponentRootNode(n) {
                    return n.hostView.rootNodes[0];
                }
            }
            let $Z = (() => {
                class t {
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵmod = Zn({ type: t }));
                    static #n = (this.ɵinj = zn({}));
                }
                return t;
            })();
            const dx = VG();
            class GZ {
                constructor(n, e) {
                    (this._viewportRuler = n),
                        (this._previousHTMLStyles = { top: '', left: '' }),
                        (this._isEnabled = !1),
                        (this._document = e);
                }
                attach() {}
                enable() {
                    if (this._canBeEnabled()) {
                        const n = this._document.documentElement;
                        (this._previousScrollPosition = this._viewportRuler.getViewportScrollPosition()),
                            (this._previousHTMLStyles.left = n.style.left || ''),
                            (this._previousHTMLStyles.top = n.style.top || ''),
                            (n.style.left = Hr(-this._previousScrollPosition.left)),
                            (n.style.top = Hr(-this._previousScrollPosition.top)),
                            n.classList.add('cdk-global-scrollblock'),
                            (this._isEnabled = !0);
                    }
                }
                disable() {
                    if (this._isEnabled) {
                        const n = this._document.documentElement,
                            i = n.style,
                            r = this._document.body.style,
                            s = i.scrollBehavior || '',
                            o = r.scrollBehavior || '';
                        (this._isEnabled = !1),
                            (i.left = this._previousHTMLStyles.left),
                            (i.top = this._previousHTMLStyles.top),
                            n.classList.remove('cdk-global-scrollblock'),
                            dx && (i.scrollBehavior = r.scrollBehavior = 'auto'),
                            window.scroll(this._previousScrollPosition.left, this._previousScrollPosition.top),
                            dx && ((i.scrollBehavior = s), (r.scrollBehavior = o));
                    }
                }
                _canBeEnabled() {
                    if (this._document.documentElement.classList.contains('cdk-global-scrollblock') || this._isEnabled)
                        return !1;
                    const e = this._document.body,
                        i = this._viewportRuler.getViewportSize();
                    return e.scrollHeight > i.height || e.scrollWidth > i.width;
                }
            }
            class WZ {
                constructor(n, e, i, r) {
                    (this._scrollDispatcher = n),
                        (this._ngZone = e),
                        (this._viewportRuler = i),
                        (this._config = r),
                        (this._scrollSubscription = null),
                        (this._detach = () => {
                            this.disable(),
                                this._overlayRef.hasAttached() && this._ngZone.run(() => this._overlayRef.detach());
                        });
                }
                attach(n) {
                    this._overlayRef = n;
                }
                enable() {
                    if (this._scrollSubscription) return;
                    const n = this._scrollDispatcher
                        .scrolled(0)
                        .pipe(
                            al(e => !e || !this._overlayRef.overlayElement.contains(e.getElementRef().nativeElement)),
                        );
                    this._config && this._config.threshold && this._config.threshold > 1
                        ? ((this._initialScrollPosition = this._viewportRuler.getViewportScrollPosition().top),
                          (this._scrollSubscription = n.subscribe(() => {
                              const e = this._viewportRuler.getViewportScrollPosition().top;
                              Math.abs(e - this._initialScrollPosition) > this._config.threshold
                                  ? this._detach()
                                  : this._overlayRef.updatePosition();
                          })))
                        : (this._scrollSubscription = n.subscribe(this._detach));
                }
                disable() {
                    this._scrollSubscription &&
                        (this._scrollSubscription.unsubscribe(), (this._scrollSubscription = null));
                }
                detach() {
                    this.disable(), (this._overlayRef = null);
                }
            }
            class hx {
                enable() {}
                disable() {}
                attach() {}
            }
            function Xg(t, n) {
                return n.some(e => t.bottom < e.top || t.top > e.bottom || t.right < e.left || t.left > e.right);
            }
            function fx(t, n) {
                return n.some(e => t.top < e.top || t.bottom > e.bottom || t.left < e.left || t.right > e.right);
            }
            class KZ {
                constructor(n, e, i, r) {
                    (this._scrollDispatcher = n),
                        (this._viewportRuler = e),
                        (this._ngZone = i),
                        (this._config = r),
                        (this._scrollSubscription = null);
                }
                attach(n) {
                    this._overlayRef = n;
                }
                enable() {
                    this._scrollSubscription ||
                        (this._scrollSubscription = this._scrollDispatcher
                            .scrolled(this._config ? this._config.scrollThrottle : 0)
                            .subscribe(() => {
                                if ((this._overlayRef.updatePosition(), this._config && this._config.autoClose)) {
                                    const e = this._overlayRef.overlayElement.getBoundingClientRect(),
                                        { width: i, height: r } = this._viewportRuler.getViewportSize();
                                    Xg(e, [{ width: i, height: r, bottom: r, right: i, top: 0, left: 0 }]) &&
                                        (this.disable(), this._ngZone.run(() => this._overlayRef.detach()));
                                }
                            }));
                }
                disable() {
                    this._scrollSubscription &&
                        (this._scrollSubscription.unsubscribe(), (this._scrollSubscription = null));
                }
                detach() {
                    this.disable(), (this._overlayRef = null);
                }
            }
            let QZ = (() => {
                class t {
                    constructor(e, i, r, s) {
                        (this._scrollDispatcher = e),
                            (this._viewportRuler = i),
                            (this._ngZone = r),
                            (this.noop = () => new hx()),
                            (this.close = o => new WZ(this._scrollDispatcher, this._ngZone, this._viewportRuler, o)),
                            (this.block = () => new GZ(this._viewportRuler, this._document)),
                            (this.reposition = o =>
                                new KZ(this._scrollDispatcher, this._viewportRuler, this._ngZone, o)),
                            (this._document = s);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(VZ), Se(ax), Se(en), Se(Ni));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            class mx {
                constructor(n) {
                    if (
                        ((this.scrollStrategy = new hx()),
                        (this.panelClass = ''),
                        (this.hasBackdrop = !1),
                        (this.backdropClass = 'cdk-overlay-dark-backdrop'),
                        (this.disposeOnNavigation = !1),
                        n)
                    ) {
                        const e = Object.keys(n);
                        for (const i of e) void 0 !== n[i] && (this[i] = n[i]);
                    }
                }
            }
            class Lr {
                constructor(n, e, i, r, s) {
                    (this.offsetX = i),
                        (this.offsetY = r),
                        (this.panelClass = s),
                        (this.originX = n.originX),
                        (this.originY = n.originY),
                        (this.overlayX = e.overlayX),
                        (this.overlayY = e.overlayY);
                }
            }
            class XZ {
                constructor(n, e) {
                    (this.connectionPair = n), (this.scrollableViewProperties = e);
                }
            }
            let px = (() => {
                    class t {
                        constructor(e) {
                            (this._attachedOverlays = []), (this._document = e);
                        }
                        ngOnDestroy() {
                            this.detach();
                        }
                        add(e) {
                            this.remove(e), this._attachedOverlays.push(e);
                        }
                        remove(e) {
                            const i = this._attachedOverlays.indexOf(e);
                            i > -1 && this._attachedOverlays.splice(i, 1),
                                0 === this._attachedOverlays.length && this.detach();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Ni));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                ZZ = (() => {
                    class t extends px {
                        constructor(e, i) {
                            super(e),
                                (this._ngZone = i),
                                (this._keydownListener = r => {
                                    const s = this._attachedOverlays;
                                    for (let o = s.length - 1; o > -1; o--)
                                        if (s[o]._keydownEvents.observers.length > 0) {
                                            const a = s[o]._keydownEvents;
                                            this._ngZone ? this._ngZone.run(() => a.next(r)) : a.next(r);
                                            break;
                                        }
                                });
                        }
                        add(e) {
                            super.add(e),
                                this._isAttached ||
                                    (this._ngZone
                                        ? this._ngZone.runOutsideAngular(() =>
                                              this._document.body.addEventListener('keydown', this._keydownListener),
                                          )
                                        : this._document.body.addEventListener('keydown', this._keydownListener),
                                    (this._isAttached = !0));
                        }
                        detach() {
                            this._isAttached &&
                                (this._document.body.removeEventListener('keydown', this._keydownListener),
                                (this._isAttached = !1));
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Ni), Se(en, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                JZ = (() => {
                    class t extends px {
                        constructor(e, i, r) {
                            super(e),
                                (this._platform = i),
                                (this._ngZone = r),
                                (this._cursorStyleIsSet = !1),
                                (this._pointerDownListener = s => {
                                    this._pointerDownEventTarget = Tc(s);
                                }),
                                (this._clickListener = s => {
                                    const o = Tc(s),
                                        a =
                                            'click' === s.type && this._pointerDownEventTarget
                                                ? this._pointerDownEventTarget
                                                : o;
                                    this._pointerDownEventTarget = null;
                                    const l = this._attachedOverlays.slice();
                                    for (let c = l.length - 1; c > -1; c--) {
                                        const f = l[c];
                                        if (f._outsidePointerEvents.observers.length < 1 || !f.hasAttached()) continue;
                                        if (f.overlayElement.contains(o) || f.overlayElement.contains(a)) break;
                                        const g = f._outsidePointerEvents;
                                        this._ngZone ? this._ngZone.run(() => g.next(s)) : g.next(s);
                                    }
                                });
                        }
                        add(e) {
                            if ((super.add(e), !this._isAttached)) {
                                const i = this._document.body;
                                this._ngZone
                                    ? this._ngZone.runOutsideAngular(() => this._addEventListeners(i))
                                    : this._addEventListeners(i),
                                    this._platform.IOS &&
                                        !this._cursorStyleIsSet &&
                                        ((this._cursorOriginalValue = i.style.cursor),
                                        (i.style.cursor = 'pointer'),
                                        (this._cursorStyleIsSet = !0)),
                                    (this._isAttached = !0);
                            }
                        }
                        detach() {
                            if (this._isAttached) {
                                const e = this._document.body;
                                e.removeEventListener('pointerdown', this._pointerDownListener, !0),
                                    e.removeEventListener('click', this._clickListener, !0),
                                    e.removeEventListener('auxclick', this._clickListener, !0),
                                    e.removeEventListener('contextmenu', this._clickListener, !0),
                                    this._platform.IOS &&
                                        this._cursorStyleIsSet &&
                                        ((e.style.cursor = this._cursorOriginalValue), (this._cursorStyleIsSet = !1)),
                                    (this._isAttached = !1);
                            }
                        }
                        _addEventListeners(e) {
                            e.addEventListener('pointerdown', this._pointerDownListener, !0),
                                e.addEventListener('click', this._clickListener, !0),
                                e.addEventListener('auxclick', this._clickListener, !0),
                                e.addEventListener('contextmenu', this._clickListener, !0);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Ni), Se(Go), Se(en, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                gx = (() => {
                    class t {
                        constructor(e, i) {
                            (this._platform = i), (this._document = e);
                        }
                        ngOnDestroy() {
                            this._containerElement?.remove();
                        }
                        getContainerElement() {
                            return this._containerElement || this._createContainer(), this._containerElement;
                        }
                        _createContainer() {
                            const e = 'cdk-overlay-container';
                            if (this._platform.isBrowser || ST()) {
                                const r = this._document.querySelectorAll(
                                    `.${e}[platform="server"], .${e}[platform="test"]`,
                                );
                                for (let s = 0; s < r.length; s++) r[s].remove();
                            }
                            const i = this._document.createElement('div');
                            i.classList.add(e),
                                ST()
                                    ? i.setAttribute('platform', 'test')
                                    : this._platform.isBrowser || i.setAttribute('platform', 'server'),
                                this._document.body.appendChild(i),
                                (this._containerElement = i);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Ni), Se(Go));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })();
            class eJ {
                constructor(n, e, i, r, s, o, a, l, c, f = !1) {
                    (this._portalOutlet = n),
                        (this._host = e),
                        (this._pane = i),
                        (this._config = r),
                        (this._ngZone = s),
                        (this._keyboardDispatcher = o),
                        (this._document = a),
                        (this._location = l),
                        (this._outsideClickDispatcher = c),
                        (this._animationsDisabled = f),
                        (this._backdropElement = null),
                        (this._backdropClick = new vt()),
                        (this._attachments = new vt()),
                        (this._detachments = new vt()),
                        (this._locationChanges = ii.EMPTY),
                        (this._backdropClickHandler = g => this._backdropClick.next(g)),
                        (this._backdropTransitionendHandler = g => {
                            this._disposeBackdrop(g.target);
                        }),
                        (this._keydownEvents = new vt()),
                        (this._outsidePointerEvents = new vt()),
                        r.scrollStrategy &&
                            ((this._scrollStrategy = r.scrollStrategy), this._scrollStrategy.attach(this)),
                        (this._positionStrategy = r.positionStrategy);
                }
                get overlayElement() {
                    return this._pane;
                }
                get backdropElement() {
                    return this._backdropElement;
                }
                get hostElement() {
                    return this._host;
                }
                attach(n) {
                    !this._host.parentElement &&
                        this._previousHostParent &&
                        this._previousHostParent.appendChild(this._host);
                    const e = this._portalOutlet.attach(n);
                    return (
                        this._positionStrategy && this._positionStrategy.attach(this),
                        this._updateStackingOrder(),
                        this._updateElementSize(),
                        this._updateElementDirection(),
                        this._scrollStrategy && this._scrollStrategy.enable(),
                        this._ngZone.onStable.pipe(Z1(1)).subscribe(() => {
                            this.hasAttached() && this.updatePosition();
                        }),
                        this._togglePointerEvents(!0),
                        this._config.hasBackdrop && this._attachBackdrop(),
                        this._config.panelClass && this._toggleClasses(this._pane, this._config.panelClass, !0),
                        this._attachments.next(),
                        this._keyboardDispatcher.add(this),
                        this._config.disposeOnNavigation &&
                            (this._locationChanges = this._location.subscribe(() => this.dispose())),
                        this._outsideClickDispatcher.add(this),
                        'function' == typeof e?.onDestroy &&
                            e.onDestroy(() => {
                                this.hasAttached() &&
                                    this._ngZone.runOutsideAngular(() => Promise.resolve().then(() => this.detach()));
                            }),
                        e
                    );
                }
                detach() {
                    if (!this.hasAttached()) return;
                    this.detachBackdrop(),
                        this._togglePointerEvents(!1),
                        this._positionStrategy && this._positionStrategy.detach && this._positionStrategy.detach(),
                        this._scrollStrategy && this._scrollStrategy.disable();
                    const n = this._portalOutlet.detach();
                    return (
                        this._detachments.next(),
                        this._keyboardDispatcher.remove(this),
                        this._detachContentWhenStable(),
                        this._locationChanges.unsubscribe(),
                        this._outsideClickDispatcher.remove(this),
                        n
                    );
                }
                dispose() {
                    const n = this.hasAttached();
                    this._positionStrategy && this._positionStrategy.dispose(),
                        this._disposeScrollStrategy(),
                        this._disposeBackdrop(this._backdropElement),
                        this._locationChanges.unsubscribe(),
                        this._keyboardDispatcher.remove(this),
                        this._portalOutlet.dispose(),
                        this._attachments.complete(),
                        this._backdropClick.complete(),
                        this._keydownEvents.complete(),
                        this._outsidePointerEvents.complete(),
                        this._outsideClickDispatcher.remove(this),
                        this._host?.remove(),
                        (this._previousHostParent = this._pane = this._host = null),
                        n && this._detachments.next(),
                        this._detachments.complete();
                }
                hasAttached() {
                    return this._portalOutlet.hasAttached();
                }
                backdropClick() {
                    return this._backdropClick;
                }
                attachments() {
                    return this._attachments;
                }
                detachments() {
                    return this._detachments;
                }
                keydownEvents() {
                    return this._keydownEvents;
                }
                outsidePointerEvents() {
                    return this._outsidePointerEvents;
                }
                getConfig() {
                    return this._config;
                }
                updatePosition() {
                    this._positionStrategy && this._positionStrategy.apply();
                }
                updatePositionStrategy(n) {
                    n !== this._positionStrategy &&
                        (this._positionStrategy && this._positionStrategy.dispose(),
                        (this._positionStrategy = n),
                        this.hasAttached() && (n.attach(this), this.updatePosition()));
                }
                updateSize(n) {
                    (this._config = { ...this._config, ...n }), this._updateElementSize();
                }
                setDirection(n) {
                    (this._config = { ...this._config, direction: n }), this._updateElementDirection();
                }
                addPanelClass(n) {
                    this._pane && this._toggleClasses(this._pane, n, !0);
                }
                removePanelClass(n) {
                    this._pane && this._toggleClasses(this._pane, n, !1);
                }
                getDirection() {
                    const n = this._config.direction;
                    return n ? ('string' == typeof n ? n : n.value) : 'ltr';
                }
                updateScrollStrategy(n) {
                    n !== this._scrollStrategy &&
                        (this._disposeScrollStrategy(),
                        (this._scrollStrategy = n),
                        this.hasAttached() && (n.attach(this), n.enable()));
                }
                _updateElementDirection() {
                    this._host.setAttribute('dir', this.getDirection());
                }
                _updateElementSize() {
                    if (!this._pane) return;
                    const n = this._pane.style;
                    (n.width = Hr(this._config.width)),
                        (n.height = Hr(this._config.height)),
                        (n.minWidth = Hr(this._config.minWidth)),
                        (n.minHeight = Hr(this._config.minHeight)),
                        (n.maxWidth = Hr(this._config.maxWidth)),
                        (n.maxHeight = Hr(this._config.maxHeight));
                }
                _togglePointerEvents(n) {
                    this._pane.style.pointerEvents = n ? '' : 'none';
                }
                _attachBackdrop() {
                    const n = 'cdk-overlay-backdrop-showing';
                    (this._backdropElement = this._document.createElement('div')),
                        this._backdropElement.classList.add('cdk-overlay-backdrop'),
                        this._animationsDisabled &&
                            this._backdropElement.classList.add('cdk-overlay-backdrop-noop-animation'),
                        this._config.backdropClass &&
                            this._toggleClasses(this._backdropElement, this._config.backdropClass, !0),
                        this._host.parentElement.insertBefore(this._backdropElement, this._host),
                        this._backdropElement.addEventListener('click', this._backdropClickHandler),
                        !this._animationsDisabled && typeof requestAnimationFrame < 'u'
                            ? this._ngZone.runOutsideAngular(() => {
                                  requestAnimationFrame(() => {
                                      this._backdropElement && this._backdropElement.classList.add(n);
                                  });
                              })
                            : this._backdropElement.classList.add(n);
                }
                _updateStackingOrder() {
                    this._host.nextSibling && this._host.parentNode.appendChild(this._host);
                }
                detachBackdrop() {
                    const n = this._backdropElement;
                    if (n) {
                        if (this._animationsDisabled) return void this._disposeBackdrop(n);
                        n.classList.remove('cdk-overlay-backdrop-showing'),
                            this._ngZone.runOutsideAngular(() => {
                                n.addEventListener('transitionend', this._backdropTransitionendHandler);
                            }),
                            (n.style.pointerEvents = 'none'),
                            (this._backdropTimeout = this._ngZone.runOutsideAngular(() =>
                                setTimeout(() => {
                                    this._disposeBackdrop(n);
                                }, 500),
                            ));
                    }
                }
                _toggleClasses(n, e, i) {
                    const r = uT(e || []).filter(s => !!s);
                    r.length && (i ? n.classList.add(...r) : n.classList.remove(...r));
                }
                _detachContentWhenStable() {
                    this._ngZone.runOutsideAngular(() => {
                        const n = this._ngZone.onStable
                            .pipe(nn(Xm(this._attachments, this._detachments)))
                            .subscribe(() => {
                                (!this._pane || !this._host || 0 === this._pane.children.length) &&
                                    (this._pane &&
                                        this._config.panelClass &&
                                        this._toggleClasses(this._pane, this._config.panelClass, !1),
                                    this._host &&
                                        this._host.parentElement &&
                                        ((this._previousHostParent = this._host.parentElement), this._host.remove()),
                                    n.unsubscribe());
                            });
                    });
                }
                _disposeScrollStrategy() {
                    const n = this._scrollStrategy;
                    n && (n.disable(), n.detach && n.detach());
                }
                _disposeBackdrop(n) {
                    n &&
                        (n.removeEventListener('click', this._backdropClickHandler),
                        n.removeEventListener('transitionend', this._backdropTransitionendHandler),
                        n.remove(),
                        this._backdropElement === n && (this._backdropElement = null)),
                        this._backdropTimeout &&
                            (clearTimeout(this._backdropTimeout), (this._backdropTimeout = void 0));
                }
            }
            const vx = 'cdk-overlay-connected-position-bounding-box',
                tJ = /([A-Za-z%]+)$/;
            class nJ {
                get positions() {
                    return this._preferredPositions;
                }
                constructor(n, e, i, r, s) {
                    (this._viewportRuler = e),
                        (this._document = i),
                        (this._platform = r),
                        (this._overlayContainer = s),
                        (this._lastBoundingBoxSize = { width: 0, height: 0 }),
                        (this._isPushed = !1),
                        (this._canPush = !0),
                        (this._growAfterOpen = !1),
                        (this._hasFlexibleDimensions = !0),
                        (this._positionLocked = !1),
                        (this._viewportMargin = 0),
                        (this._scrollables = []),
                        (this._preferredPositions = []),
                        (this._positionChanges = new vt()),
                        (this._resizeSubscription = ii.EMPTY),
                        (this._offsetX = 0),
                        (this._offsetY = 0),
                        (this._appliedPanelClasses = []),
                        (this.positionChanges = this._positionChanges),
                        this.setOrigin(n);
                }
                attach(n) {
                    this._validatePositions(),
                        n.hostElement.classList.add(vx),
                        (this._overlayRef = n),
                        (this._boundingBox = n.hostElement),
                        (this._pane = n.overlayElement),
                        (this._isDisposed = !1),
                        (this._isInitialRender = !0),
                        (this._lastPosition = null),
                        this._resizeSubscription.unsubscribe(),
                        (this._resizeSubscription = this._viewportRuler.change().subscribe(() => {
                            (this._isInitialRender = !0), this.apply();
                        }));
                }
                apply() {
                    if (this._isDisposed || !this._platform.isBrowser) return;
                    if (!this._isInitialRender && this._positionLocked && this._lastPosition)
                        return void this.reapplyLastPosition();
                    this._clearPanelClasses(),
                        this._resetOverlayElementStyles(),
                        this._resetBoundingBoxStyles(),
                        (this._viewportRect = this._getNarrowedViewportRect()),
                        (this._originRect = this._getOriginRect()),
                        (this._overlayRect = this._pane.getBoundingClientRect()),
                        (this._containerRect = this._overlayContainer.getContainerElement().getBoundingClientRect());
                    const n = this._originRect,
                        e = this._overlayRect,
                        i = this._viewportRect,
                        r = this._containerRect,
                        s = [];
                    let o;
                    for (let a of this._preferredPositions) {
                        let l = this._getOriginPoint(n, r, a),
                            c = this._getOverlayPoint(l, e, a),
                            f = this._getOverlayFit(c, e, i, a);
                        if (f.isCompletelyWithinViewport) return (this._isPushed = !1), void this._applyPosition(a, l);
                        this._canFitWithFlexibleDimensions(f, c, i)
                            ? s.push({
                                  position: a,
                                  origin: l,
                                  overlayRect: e,
                                  boundingBoxRect: this._calculateBoundingBoxRect(l, a),
                              })
                            : (!o || o.overlayFit.visibleArea < f.visibleArea) &&
                              (o = { overlayFit: f, overlayPoint: c, originPoint: l, position: a, overlayRect: e });
                    }
                    if (s.length) {
                        let a = null,
                            l = -1;
                        for (const c of s) {
                            const f = c.boundingBoxRect.width * c.boundingBoxRect.height * (c.position.weight || 1);
                            f > l && ((l = f), (a = c));
                        }
                        return (this._isPushed = !1), void this._applyPosition(a.position, a.origin);
                    }
                    if (this._canPush)
                        return (this._isPushed = !0), void this._applyPosition(o.position, o.originPoint);
                    this._applyPosition(o.position, o.originPoint);
                }
                detach() {
                    this._clearPanelClasses(),
                        (this._lastPosition = null),
                        (this._previousPushAmount = null),
                        this._resizeSubscription.unsubscribe();
                }
                dispose() {
                    this._isDisposed ||
                        (this._boundingBox &&
                            Pu(this._boundingBox.style, {
                                top: '',
                                left: '',
                                right: '',
                                bottom: '',
                                height: '',
                                width: '',
                                alignItems: '',
                                justifyContent: '',
                            }),
                        this._pane && this._resetOverlayElementStyles(),
                        this._overlayRef && this._overlayRef.hostElement.classList.remove(vx),
                        this.detach(),
                        this._positionChanges.complete(),
                        (this._overlayRef = this._boundingBox = null),
                        (this._isDisposed = !0));
                }
                reapplyLastPosition() {
                    if (this._isDisposed || !this._platform.isBrowser) return;
                    const n = this._lastPosition;
                    if (n) {
                        (this._originRect = this._getOriginRect()),
                            (this._overlayRect = this._pane.getBoundingClientRect()),
                            (this._viewportRect = this._getNarrowedViewportRect()),
                            (this._containerRect = this._overlayContainer
                                .getContainerElement()
                                .getBoundingClientRect());
                        const e = this._getOriginPoint(this._originRect, this._containerRect, n);
                        this._applyPosition(n, e);
                    } else this.apply();
                }
                withScrollableContainers(n) {
                    return (this._scrollables = n), this;
                }
                withPositions(n) {
                    return (
                        (this._preferredPositions = n),
                        -1 === n.indexOf(this._lastPosition) && (this._lastPosition = null),
                        this._validatePositions(),
                        this
                    );
                }
                withViewportMargin(n) {
                    return (this._viewportMargin = n), this;
                }
                withFlexibleDimensions(n = !0) {
                    return (this._hasFlexibleDimensions = n), this;
                }
                withGrowAfterOpen(n = !0) {
                    return (this._growAfterOpen = n), this;
                }
                withPush(n = !0) {
                    return (this._canPush = n), this;
                }
                withLockedPosition(n = !0) {
                    return (this._positionLocked = n), this;
                }
                setOrigin(n) {
                    return (this._origin = n), this;
                }
                withDefaultOffsetX(n) {
                    return (this._offsetX = n), this;
                }
                withDefaultOffsetY(n) {
                    return (this._offsetY = n), this;
                }
                withTransformOriginOn(n) {
                    return (this._transformOriginSelector = n), this;
                }
                _getOriginPoint(n, e, i) {
                    let r, s;
                    if ('center' == i.originX) r = n.left + n.width / 2;
                    else {
                        const o = this._isRtl() ? n.right : n.left,
                            a = this._isRtl() ? n.left : n.right;
                        r = 'start' == i.originX ? o : a;
                    }
                    return (
                        e.left < 0 && (r -= e.left),
                        (s = 'center' == i.originY ? n.top + n.height / 2 : 'top' == i.originY ? n.top : n.bottom),
                        e.top < 0 && (s -= e.top),
                        { x: r, y: s }
                    );
                }
                _getOverlayPoint(n, e, i) {
                    let r, s;
                    return (
                        (r =
                            'center' == i.overlayX
                                ? -e.width / 2
                                : 'start' === i.overlayX
                                ? this._isRtl()
                                    ? -e.width
                                    : 0
                                : this._isRtl()
                                ? 0
                                : -e.width),
                        (s = 'center' == i.overlayY ? -e.height / 2 : 'top' == i.overlayY ? 0 : -e.height),
                        { x: n.x + r, y: n.y + s }
                    );
                }
                _getOverlayFit(n, e, i, r) {
                    const s = yx(e);
                    let { x: o, y: a } = n,
                        l = this._getOffset(r, 'x'),
                        c = this._getOffset(r, 'y');
                    l && (o += l), c && (a += c);
                    let E = 0 - a,
                        P = a + s.height - i.height,
                        V = this._subtractOverflows(s.width, 0 - o, o + s.width - i.width),
                        W = this._subtractOverflows(s.height, E, P),
                        ie = V * W;
                    return {
                        visibleArea: ie,
                        isCompletelyWithinViewport: s.width * s.height === ie,
                        fitsInViewportVertically: W === s.height,
                        fitsInViewportHorizontally: V == s.width,
                    };
                }
                _canFitWithFlexibleDimensions(n, e, i) {
                    if (this._hasFlexibleDimensions) {
                        const r = i.bottom - e.y,
                            s = i.right - e.x,
                            o = _x(this._overlayRef.getConfig().minHeight),
                            a = _x(this._overlayRef.getConfig().minWidth);
                        return (
                            (n.fitsInViewportVertically || (null != o && o <= r)) &&
                            (n.fitsInViewportHorizontally || (null != a && a <= s))
                        );
                    }
                    return !1;
                }
                _pushOverlayOnScreen(n, e, i) {
                    if (this._previousPushAmount && this._positionLocked)
                        return { x: n.x + this._previousPushAmount.x, y: n.y + this._previousPushAmount.y };
                    const r = yx(e),
                        s = this._viewportRect,
                        o = Math.max(n.x + r.width - s.width, 0),
                        a = Math.max(n.y + r.height - s.height, 0),
                        l = Math.max(s.top - i.top - n.y, 0),
                        c = Math.max(s.left - i.left - n.x, 0);
                    let f = 0,
                        g = 0;
                    return (
                        (f = r.width <= s.width ? c || -o : n.x < this._viewportMargin ? s.left - i.left - n.x : 0),
                        (g = r.height <= s.height ? l || -a : n.y < this._viewportMargin ? s.top - i.top - n.y : 0),
                        (this._previousPushAmount = { x: f, y: g }),
                        { x: n.x + f, y: n.y + g }
                    );
                }
                _applyPosition(n, e) {
                    if (
                        (this._setTransformOrigin(n),
                        this._setOverlayElementStyles(e, n),
                        this._setBoundingBoxStyles(e, n),
                        n.panelClass && this._addPanelClasses(n.panelClass),
                        this._positionChanges.observers.length)
                    ) {
                        const i = this._getScrollVisibility();
                        if (
                            n !== this._lastPosition ||
                            !this._lastScrollVisibility ||
                            !(function iJ(t, n) {
                                return (
                                    t === n ||
                                    (t.isOriginClipped === n.isOriginClipped &&
                                        t.isOriginOutsideView === n.isOriginOutsideView &&
                                        t.isOverlayClipped === n.isOverlayClipped &&
                                        t.isOverlayOutsideView === n.isOverlayOutsideView)
                                );
                            })(this._lastScrollVisibility, i)
                        ) {
                            const r = new XZ(n, i);
                            this._positionChanges.next(r);
                        }
                        this._lastScrollVisibility = i;
                    }
                    (this._lastPosition = n), (this._isInitialRender = !1);
                }
                _setTransformOrigin(n) {
                    if (!this._transformOriginSelector) return;
                    const e = this._boundingBox.querySelectorAll(this._transformOriginSelector);
                    let i,
                        r = n.overlayY;
                    i =
                        'center' === n.overlayX
                            ? 'center'
                            : this._isRtl()
                            ? 'start' === n.overlayX
                                ? 'right'
                                : 'left'
                            : 'start' === n.overlayX
                            ? 'left'
                            : 'right';
                    for (let s = 0; s < e.length; s++) e[s].style.transformOrigin = `${i} ${r}`;
                }
                _calculateBoundingBoxRect(n, e) {
                    const i = this._viewportRect,
                        r = this._isRtl();
                    let s, o, a, f, g, E;
                    if ('top' === e.overlayY) (o = n.y), (s = i.height - o + this._viewportMargin);
                    else if ('bottom' === e.overlayY)
                        (a = i.height - n.y + 2 * this._viewportMargin), (s = i.height - a + this._viewportMargin);
                    else {
                        const P = Math.min(i.bottom - n.y + i.top, n.y),
                            V = this._lastBoundingBoxSize.height;
                        (s = 2 * P),
                            (o = n.y - P),
                            s > V && !this._isInitialRender && !this._growAfterOpen && (o = n.y - V / 2);
                    }
                    if (('end' === e.overlayX && !r) || ('start' === e.overlayX && r))
                        (E = i.width - n.x + 2 * this._viewportMargin), (f = n.x - this._viewportMargin);
                    else if (('start' === e.overlayX && !r) || ('end' === e.overlayX && r))
                        (g = n.x), (f = i.right - n.x);
                    else {
                        const P = Math.min(i.right - n.x + i.left, n.x),
                            V = this._lastBoundingBoxSize.width;
                        (f = 2 * P),
                            (g = n.x - P),
                            f > V && !this._isInitialRender && !this._growAfterOpen && (g = n.x - V / 2);
                    }
                    return { top: o, left: g, bottom: a, right: E, width: f, height: s };
                }
                _setBoundingBoxStyles(n, e) {
                    const i = this._calculateBoundingBoxRect(n, e);
                    !this._isInitialRender &&
                        !this._growAfterOpen &&
                        ((i.height = Math.min(i.height, this._lastBoundingBoxSize.height)),
                        (i.width = Math.min(i.width, this._lastBoundingBoxSize.width)));
                    const r = {};
                    if (this._hasExactPosition())
                        (r.top = r.left = '0'),
                            (r.bottom = r.right = r.maxHeight = r.maxWidth = ''),
                            (r.width = r.height = '100%');
                    else {
                        const s = this._overlayRef.getConfig().maxHeight,
                            o = this._overlayRef.getConfig().maxWidth;
                        (r.height = Hr(i.height)),
                            (r.top = Hr(i.top)),
                            (r.bottom = Hr(i.bottom)),
                            (r.width = Hr(i.width)),
                            (r.left = Hr(i.left)),
                            (r.right = Hr(i.right)),
                            (r.alignItems =
                                'center' === e.overlayX ? 'center' : 'end' === e.overlayX ? 'flex-end' : 'flex-start'),
                            (r.justifyContent =
                                'center' === e.overlayY
                                    ? 'center'
                                    : 'bottom' === e.overlayY
                                    ? 'flex-end'
                                    : 'flex-start'),
                            s && (r.maxHeight = Hr(s)),
                            o && (r.maxWidth = Hr(o));
                    }
                    (this._lastBoundingBoxSize = i), Pu(this._boundingBox.style, r);
                }
                _resetBoundingBoxStyles() {
                    Pu(this._boundingBox.style, {
                        top: '0',
                        left: '0',
                        right: '0',
                        bottom: '0',
                        height: '',
                        width: '',
                        alignItems: '',
                        justifyContent: '',
                    });
                }
                _resetOverlayElementStyles() {
                    Pu(this._pane.style, { top: '', left: '', bottom: '', right: '', position: '', transform: '' });
                }
                _setOverlayElementStyles(n, e) {
                    const i = {},
                        r = this._hasExactPosition(),
                        s = this._hasFlexibleDimensions,
                        o = this._overlayRef.getConfig();
                    if (r) {
                        const f = this._viewportRuler.getViewportScrollPosition();
                        Pu(i, this._getExactOverlayY(e, n, f)), Pu(i, this._getExactOverlayX(e, n, f));
                    } else i.position = 'static';
                    let a = '',
                        l = this._getOffset(e, 'x'),
                        c = this._getOffset(e, 'y');
                    l && (a += `translateX(${l}px) `),
                        c && (a += `translateY(${c}px)`),
                        (i.transform = a.trim()),
                        o.maxHeight && (r ? (i.maxHeight = Hr(o.maxHeight)) : s && (i.maxHeight = '')),
                        o.maxWidth && (r ? (i.maxWidth = Hr(o.maxWidth)) : s && (i.maxWidth = '')),
                        Pu(this._pane.style, i);
                }
                _getExactOverlayY(n, e, i) {
                    let r = { top: '', bottom: '' },
                        s = this._getOverlayPoint(e, this._overlayRect, n);
                    return (
                        this._isPushed && (s = this._pushOverlayOnScreen(s, this._overlayRect, i)),
                        'bottom' === n.overlayY
                            ? (r.bottom =
                                  this._document.documentElement.clientHeight - (s.y + this._overlayRect.height) + 'px')
                            : (r.top = Hr(s.y)),
                        r
                    );
                }
                _getExactOverlayX(n, e, i) {
                    let o,
                        r = { left: '', right: '' },
                        s = this._getOverlayPoint(e, this._overlayRect, n);
                    return (
                        this._isPushed && (s = this._pushOverlayOnScreen(s, this._overlayRect, i)),
                        (o = this._isRtl()
                            ? 'end' === n.overlayX
                                ? 'left'
                                : 'right'
                            : 'end' === n.overlayX
                            ? 'right'
                            : 'left'),
                        'right' === o
                            ? (r.right =
                                  this._document.documentElement.clientWidth - (s.x + this._overlayRect.width) + 'px')
                            : (r.left = Hr(s.x)),
                        r
                    );
                }
                _getScrollVisibility() {
                    const n = this._getOriginRect(),
                        e = this._pane.getBoundingClientRect(),
                        i = this._scrollables.map(r => r.getElementRef().nativeElement.getBoundingClientRect());
                    return {
                        isOriginClipped: fx(n, i),
                        isOriginOutsideView: Xg(n, i),
                        isOverlayClipped: fx(e, i),
                        isOverlayOutsideView: Xg(e, i),
                    };
                }
                _subtractOverflows(n, ...e) {
                    return e.reduce((i, r) => i - Math.max(r, 0), n);
                }
                _getNarrowedViewportRect() {
                    const n = this._document.documentElement.clientWidth,
                        e = this._document.documentElement.clientHeight,
                        i = this._viewportRuler.getViewportScrollPosition();
                    return {
                        top: i.top + this._viewportMargin,
                        left: i.left + this._viewportMargin,
                        right: i.left + n - this._viewportMargin,
                        bottom: i.top + e - this._viewportMargin,
                        width: n - 2 * this._viewportMargin,
                        height: e - 2 * this._viewportMargin,
                    };
                }
                _isRtl() {
                    return 'rtl' === this._overlayRef.getDirection();
                }
                _hasExactPosition() {
                    return !this._hasFlexibleDimensions || this._isPushed;
                }
                _getOffset(n, e) {
                    return 'x' === e
                        ? null == n.offsetX
                            ? this._offsetX
                            : n.offsetX
                        : null == n.offsetY
                        ? this._offsetY
                        : n.offsetY;
                }
                _validatePositions() {}
                _addPanelClasses(n) {
                    this._pane &&
                        uT(n).forEach(e => {
                            '' !== e &&
                                -1 === this._appliedPanelClasses.indexOf(e) &&
                                (this._appliedPanelClasses.push(e), this._pane.classList.add(e));
                        });
                }
                _clearPanelClasses() {
                    this._pane &&
                        (this._appliedPanelClasses.forEach(n => {
                            this._pane.classList.remove(n);
                        }),
                        (this._appliedPanelClasses = []));
                }
                _getOriginRect() {
                    const n = this._origin;
                    if (n instanceof Pn) return n.nativeElement.getBoundingClientRect();
                    if (n instanceof Element) return n.getBoundingClientRect();
                    const e = n.width || 0,
                        i = n.height || 0;
                    return { top: n.y, bottom: n.y + i, left: n.x, right: n.x + e, height: i, width: e };
                }
            }
            function Pu(t, n) {
                for (let e in n) n.hasOwnProperty(e) && (t[e] = n[e]);
                return t;
            }
            function _x(t) {
                if ('number' != typeof t && null != t) {
                    const [n, e] = t.split(tJ);
                    return e && 'px' !== e ? null : parseFloat(n);
                }
                return t || null;
            }
            function yx(t) {
                return {
                    top: Math.floor(t.top),
                    right: Math.floor(t.right),
                    bottom: Math.floor(t.bottom),
                    left: Math.floor(t.left),
                    width: Math.floor(t.width),
                    height: Math.floor(t.height),
                };
            }
            const bx = 'cdk-global-overlay-wrapper';
            class rJ {
                constructor() {
                    (this._cssPosition = 'static'),
                        (this._topOffset = ''),
                        (this._bottomOffset = ''),
                        (this._alignItems = ''),
                        (this._xPosition = ''),
                        (this._xOffset = ''),
                        (this._width = ''),
                        (this._height = ''),
                        (this._isDisposed = !1);
                }
                attach(n) {
                    const e = n.getConfig();
                    (this._overlayRef = n),
                        this._width && !e.width && n.updateSize({ width: this._width }),
                        this._height && !e.height && n.updateSize({ height: this._height }),
                        n.hostElement.classList.add(bx),
                        (this._isDisposed = !1);
                }
                top(n = '') {
                    return (this._bottomOffset = ''), (this._topOffset = n), (this._alignItems = 'flex-start'), this;
                }
                left(n = '') {
                    return (this._xOffset = n), (this._xPosition = 'left'), this;
                }
                bottom(n = '') {
                    return (this._topOffset = ''), (this._bottomOffset = n), (this._alignItems = 'flex-end'), this;
                }
                right(n = '') {
                    return (this._xOffset = n), (this._xPosition = 'right'), this;
                }
                start(n = '') {
                    return (this._xOffset = n), (this._xPosition = 'start'), this;
                }
                end(n = '') {
                    return (this._xOffset = n), (this._xPosition = 'end'), this;
                }
                width(n = '') {
                    return this._overlayRef ? this._overlayRef.updateSize({ width: n }) : (this._width = n), this;
                }
                height(n = '') {
                    return this._overlayRef ? this._overlayRef.updateSize({ height: n }) : (this._height = n), this;
                }
                centerHorizontally(n = '') {
                    return this.left(n), (this._xPosition = 'center'), this;
                }
                centerVertically(n = '') {
                    return this.top(n), (this._alignItems = 'center'), this;
                }
                apply() {
                    if (!this._overlayRef || !this._overlayRef.hasAttached()) return;
                    const n = this._overlayRef.overlayElement.style,
                        e = this._overlayRef.hostElement.style,
                        i = this._overlayRef.getConfig(),
                        { width: r, height: s, maxWidth: o, maxHeight: a } = i,
                        l = !(('100%' !== r && '100vw' !== r) || (o && '100%' !== o && '100vw' !== o)),
                        c = !(('100%' !== s && '100vh' !== s) || (a && '100%' !== a && '100vh' !== a)),
                        f = this._xPosition,
                        g = this._xOffset,
                        E = 'rtl' === this._overlayRef.getConfig().direction;
                    let P = '',
                        V = '',
                        W = '';
                    l
                        ? (W = 'flex-start')
                        : 'center' === f
                        ? ((W = 'center'), E ? (V = g) : (P = g))
                        : E
                        ? 'left' === f || 'end' === f
                            ? ((W = 'flex-end'), (P = g))
                            : ('right' === f || 'start' === f) && ((W = 'flex-start'), (V = g))
                        : 'left' === f || 'start' === f
                        ? ((W = 'flex-start'), (P = g))
                        : ('right' === f || 'end' === f) && ((W = 'flex-end'), (V = g)),
                        (n.position = this._cssPosition),
                        (n.marginLeft = l ? '0' : P),
                        (n.marginTop = c ? '0' : this._topOffset),
                        (n.marginBottom = this._bottomOffset),
                        (n.marginRight = l ? '0' : V),
                        (e.justifyContent = W),
                        (e.alignItems = c ? 'flex-start' : this._alignItems);
                }
                dispose() {
                    if (this._isDisposed || !this._overlayRef) return;
                    const n = this._overlayRef.overlayElement.style,
                        e = this._overlayRef.hostElement,
                        i = e.style;
                    e.classList.remove(bx),
                        (i.justifyContent =
                            i.alignItems =
                            n.marginTop =
                            n.marginBottom =
                            n.marginLeft =
                            n.marginRight =
                            n.position =
                                ''),
                        (this._overlayRef = null),
                        (this._isDisposed = !0);
                }
            }
            let sJ = (() => {
                    class t {
                        constructor(e, i, r, s) {
                            (this._viewportRuler = e),
                                (this._document = i),
                                (this._platform = r),
                                (this._overlayContainer = s);
                        }
                        global() {
                            return new rJ();
                        }
                        flexibleConnectedTo(e) {
                            return new nJ(
                                e,
                                this._viewportRuler,
                                this._document,
                                this._platform,
                                this._overlayContainer,
                            );
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(ax), Se(Ni), Se(Go), Se(gx));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                oJ = 0,
                Gf = (() => {
                    class t {
                        constructor(e, i, r, s, o, a, l, c, f, g, E, P) {
                            (this.scrollStrategies = e),
                                (this._overlayContainer = i),
                                (this._componentFactoryResolver = r),
                                (this._positionBuilder = s),
                                (this._keyboardDispatcher = o),
                                (this._injector = a),
                                (this._ngZone = l),
                                (this._document = c),
                                (this._directionality = f),
                                (this._location = g),
                                (this._outsideClickDispatcher = E),
                                (this._animationsModuleType = P);
                        }
                        create(e) {
                            const i = this._createHostElement(),
                                r = this._createPaneElement(i),
                                s = this._createPortalOutlet(r),
                                o = new mx(e);
                            return (
                                (o.direction = o.direction || this._directionality.value),
                                new eJ(
                                    s,
                                    i,
                                    r,
                                    o,
                                    this._ngZone,
                                    this._keyboardDispatcher,
                                    this._document,
                                    this._location,
                                    this._outsideClickDispatcher,
                                    'NoopAnimations' === this._animationsModuleType,
                                )
                            );
                        }
                        position() {
                            return this._positionBuilder;
                        }
                        _createPaneElement(e) {
                            const i = this._document.createElement('div');
                            return (
                                (i.id = 'cdk-overlay-' + oJ++), i.classList.add('cdk-overlay-pane'), e.appendChild(i), i
                            );
                        }
                        _createHostElement() {
                            const e = this._document.createElement('div');
                            return this._overlayContainer.getContainerElement().appendChild(e), e;
                        }
                        _createPortalOutlet(e) {
                            return (
                                this._appRef || (this._appRef = this._injector.get(xl)),
                                new jZ(e, this._componentFactoryResolver, this._appRef, this._injector, this._document)
                            );
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(
                                Se(QZ),
                                Se(gx),
                                Se(su),
                                Se(sJ),
                                Se(ZZ),
                                Se(ys),
                                Se(en),
                                Se(Ni),
                                Se(yo),
                                Se(yC),
                                Se(JZ),
                                Se(W0, 8),
                            );
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })();
            const aJ = [
                    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
                    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
                    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
                    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
                ],
                Cx = new $e('cdk-connected-overlay-scroll-strategy', {
                    providedIn: 'root',
                    factory: () => {
                        const t = Ue(Gf);
                        return () => t.scrollStrategies.reposition();
                    },
                });
            let _h = (() => {
                    class t {
                        constructor(e) {
                            this.elementRef = e;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Pn));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [
                                ['', 'cdk-overlay-origin', ''],
                                ['', 'overlay-origin', ''],
                                ['', 'cdkOverlayOrigin', ''],
                            ],
                            exportAs: ['cdkOverlayOrigin'],
                            standalone: !0,
                        }));
                    }
                    return t;
                })(),
                u0 = (() => {
                    class t {
                        get offsetX() {
                            return this._offsetX;
                        }
                        set offsetX(e) {
                            (this._offsetX = e), this._position && this._updatePositionStrategy(this._position);
                        }
                        get offsetY() {
                            return this._offsetY;
                        }
                        set offsetY(e) {
                            (this._offsetY = e), this._position && this._updatePositionStrategy(this._position);
                        }
                        get disposeOnNavigation() {
                            return this._disposeOnNavigation;
                        }
                        set disposeOnNavigation(e) {
                            this._disposeOnNavigation = e;
                        }
                        constructor(e, i, r, s, o) {
                            (this._overlay = e),
                                (this._dir = o),
                                (this._backdropSubscription = ii.EMPTY),
                                (this._attachSubscription = ii.EMPTY),
                                (this._detachSubscription = ii.EMPTY),
                                (this._positionSubscription = ii.EMPTY),
                                (this._disposeOnNavigation = !1),
                                (this._ngZone = Ue(en)),
                                (this.viewportMargin = 0),
                                (this.open = !1),
                                (this.disableClose = !1),
                                (this.hasBackdrop = !1),
                                (this.lockPosition = !1),
                                (this.flexibleDimensions = !1),
                                (this.growAfterOpen = !1),
                                (this.push = !1),
                                (this.backdropClick = new Ft()),
                                (this.positionChange = new Ft()),
                                (this.attach = new Ft()),
                                (this.detach = new Ft()),
                                (this.overlayKeydown = new Ft()),
                                (this.overlayOutsideClick = new Ft()),
                                (this._templatePortal = new ux(i, r)),
                                (this._scrollStrategyFactory = s),
                                (this.scrollStrategy = this._scrollStrategyFactory());
                        }
                        get overlayRef() {
                            return this._overlayRef;
                        }
                        get dir() {
                            return this._dir ? this._dir.value : 'ltr';
                        }
                        ngOnDestroy() {
                            this._attachSubscription.unsubscribe(),
                                this._detachSubscription.unsubscribe(),
                                this._backdropSubscription.unsubscribe(),
                                this._positionSubscription.unsubscribe(),
                                this._overlayRef && this._overlayRef.dispose();
                        }
                        ngOnChanges(e) {
                            this._position &&
                                (this._updatePositionStrategy(this._position),
                                this._overlayRef.updateSize({
                                    width: this.width,
                                    minWidth: this.minWidth,
                                    height: this.height,
                                    minHeight: this.minHeight,
                                }),
                                e.origin && this.open && this._position.apply()),
                                e.open && (this.open ? this._attachOverlay() : this._detachOverlay());
                        }
                        _createOverlay() {
                            (!this.positions || !this.positions.length) && (this.positions = aJ);
                            const e = (this._overlayRef = this._overlay.create(this._buildConfig()));
                            (this._attachSubscription = e.attachments().subscribe(() => this.attach.emit())),
                                (this._detachSubscription = e.detachments().subscribe(() => this.detach.emit())),
                                e.keydownEvents().subscribe(i => {
                                    this.overlayKeydown.next(i),
                                        27 === i.keyCode &&
                                            !this.disableClose &&
                                            !(function kT(t, ...n) {
                                                return n.length
                                                    ? n.some(e => t[e])
                                                    : t.altKey || t.shiftKey || t.ctrlKey || t.metaKey;
                                            })(i) &&
                                            (i.preventDefault(), this._detachOverlay());
                                }),
                                this._overlayRef.outsidePointerEvents().subscribe(i => {
                                    const r = this._getOriginElement(),
                                        s = Tc(i);
                                    (!r || (r !== s && !r.contains(s))) && this.overlayOutsideClick.next(i);
                                });
                        }
                        _buildConfig() {
                            const e = (this._position = this.positionStrategy || this._createPositionStrategy()),
                                i = new mx({
                                    direction: this._dir,
                                    positionStrategy: e,
                                    scrollStrategy: this.scrollStrategy,
                                    hasBackdrop: this.hasBackdrop,
                                    disposeOnNavigation: this.disposeOnNavigation,
                                });
                            return (
                                (this.width || 0 === this.width) && (i.width = this.width),
                                (this.height || 0 === this.height) && (i.height = this.height),
                                (this.minWidth || 0 === this.minWidth) && (i.minWidth = this.minWidth),
                                (this.minHeight || 0 === this.minHeight) && (i.minHeight = this.minHeight),
                                this.backdropClass && (i.backdropClass = this.backdropClass),
                                this.panelClass && (i.panelClass = this.panelClass),
                                i
                            );
                        }
                        _updatePositionStrategy(e) {
                            const i = this.positions.map(r => ({
                                originX: r.originX,
                                originY: r.originY,
                                overlayX: r.overlayX,
                                overlayY: r.overlayY,
                                offsetX: r.offsetX || this.offsetX,
                                offsetY: r.offsetY || this.offsetY,
                                panelClass: r.panelClass || void 0,
                            }));
                            return e
                                .setOrigin(this._getOrigin())
                                .withPositions(i)
                                .withFlexibleDimensions(this.flexibleDimensions)
                                .withPush(this.push)
                                .withGrowAfterOpen(this.growAfterOpen)
                                .withViewportMargin(this.viewportMargin)
                                .withLockedPosition(this.lockPosition)
                                .withTransformOriginOn(this.transformOriginSelector);
                        }
                        _createPositionStrategy() {
                            const e = this._overlay.position().flexibleConnectedTo(this._getOrigin());
                            return this._updatePositionStrategy(e), e;
                        }
                        _getOrigin() {
                            return this.origin instanceof _h ? this.origin.elementRef : this.origin;
                        }
                        _getOriginElement() {
                            return this.origin instanceof _h
                                ? this.origin.elementRef.nativeElement
                                : this.origin instanceof Pn
                                ? this.origin.nativeElement
                                : typeof Element < 'u' && this.origin instanceof Element
                                ? this.origin
                                : null;
                        }
                        _attachOverlay() {
                            this._overlayRef
                                ? (this._overlayRef.getConfig().hasBackdrop = this.hasBackdrop)
                                : this._createOverlay(),
                                this._overlayRef.hasAttached() || this._overlayRef.attach(this._templatePortal),
                                this.hasBackdrop
                                    ? (this._backdropSubscription = this._overlayRef.backdropClick().subscribe(e => {
                                          this.backdropClick.emit(e);
                                      }))
                                    : this._backdropSubscription.unsubscribe(),
                                this._positionSubscription.unsubscribe(),
                                this.positionChange.observers.length > 0 &&
                                    (this._positionSubscription = this._position.positionChanges
                                        .pipe(
                                            (function UZ(t, n = !1) {
                                                return mi((e, i) => {
                                                    let r = 0;
                                                    e.subscribe(
                                                        ln(i, s => {
                                                            const o = t(s, r++);
                                                            (o || n) && i.next(s), !o && i.complete();
                                                        }),
                                                    );
                                                });
                                            })(() => this.positionChange.observers.length > 0),
                                        )
                                        .subscribe(e => {
                                            this._ngZone.run(() => this.positionChange.emit(e)),
                                                0 === this.positionChange.observers.length &&
                                                    this._positionSubscription.unsubscribe();
                                        }));
                        }
                        _detachOverlay() {
                            this._overlayRef && this._overlayRef.detach(),
                                this._backdropSubscription.unsubscribe(),
                                this._positionSubscription.unsubscribe();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Gf), te(Qr), te(go), te(Cx), te(yo, 8));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [
                                ['', 'cdk-connected-overlay', ''],
                                ['', 'connected-overlay', ''],
                                ['', 'cdkConnectedOverlay', ''],
                            ],
                            inputs: {
                                origin: [de.None, 'cdkConnectedOverlayOrigin', 'origin'],
                                positions: [de.None, 'cdkConnectedOverlayPositions', 'positions'],
                                positionStrategy: [de.None, 'cdkConnectedOverlayPositionStrategy', 'positionStrategy'],
                                offsetX: [de.None, 'cdkConnectedOverlayOffsetX', 'offsetX'],
                                offsetY: [de.None, 'cdkConnectedOverlayOffsetY', 'offsetY'],
                                width: [de.None, 'cdkConnectedOverlayWidth', 'width'],
                                height: [de.None, 'cdkConnectedOverlayHeight', 'height'],
                                minWidth: [de.None, 'cdkConnectedOverlayMinWidth', 'minWidth'],
                                minHeight: [de.None, 'cdkConnectedOverlayMinHeight', 'minHeight'],
                                backdropClass: [de.None, 'cdkConnectedOverlayBackdropClass', 'backdropClass'],
                                panelClass: [de.None, 'cdkConnectedOverlayPanelClass', 'panelClass'],
                                viewportMargin: [de.None, 'cdkConnectedOverlayViewportMargin', 'viewportMargin'],
                                scrollStrategy: [de.None, 'cdkConnectedOverlayScrollStrategy', 'scrollStrategy'],
                                open: [de.None, 'cdkConnectedOverlayOpen', 'open'],
                                disableClose: [de.None, 'cdkConnectedOverlayDisableClose', 'disableClose'],
                                transformOriginSelector: [
                                    de.None,
                                    'cdkConnectedOverlayTransformOriginOn',
                                    'transformOriginSelector',
                                ],
                                hasBackdrop: [
                                    de.HasDecoratorInputTransform,
                                    'cdkConnectedOverlayHasBackdrop',
                                    'hasBackdrop',
                                    Ma,
                                ],
                                lockPosition: [
                                    de.HasDecoratorInputTransform,
                                    'cdkConnectedOverlayLockPosition',
                                    'lockPosition',
                                    Ma,
                                ],
                                flexibleDimensions: [
                                    de.HasDecoratorInputTransform,
                                    'cdkConnectedOverlayFlexibleDimensions',
                                    'flexibleDimensions',
                                    Ma,
                                ],
                                growAfterOpen: [
                                    de.HasDecoratorInputTransform,
                                    'cdkConnectedOverlayGrowAfterOpen',
                                    'growAfterOpen',
                                    Ma,
                                ],
                                push: [de.HasDecoratorInputTransform, 'cdkConnectedOverlayPush', 'push', Ma],
                                disposeOnNavigation: [
                                    de.HasDecoratorInputTransform,
                                    'cdkConnectedOverlayDisposeOnNavigation',
                                    'disposeOnNavigation',
                                    Ma,
                                ],
                            },
                            outputs: {
                                backdropClick: 'backdropClick',
                                positionChange: 'positionChange',
                                attach: 'attach',
                                detach: 'detach',
                                overlayKeydown: 'overlayKeydown',
                                overlayOutsideClick: 'overlayOutsideClick',
                            },
                            exportAs: ['cdkConnectedOverlay'],
                            standalone: !0,
                            features: [G2, D],
                        }));
                    }
                    return t;
                })();
            const cJ = {
                provide: Cx,
                deps: [Gf],
                useFactory: function lJ(t) {
                    return () => t.scrollStrategies.reposition();
                },
            };
            let Zg = (() => {
                class t {
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵmod = Zn({ type: t }));
                    static #n = (this.ɵinj = zn({ providers: [Gf, cJ], imports: [Tg, $Z, cx, cx] }));
                }
                return t;
            })();
            function wx(...t) {
                const n = Rm(t);
                return mi((e, i) => {
                    const r = t.length,
                        s = new Array(r);
                    let o = t.map(() => !1),
                        a = !1;
                    for (let l = 0; l < r; l++)
                        bs(t[l]).subscribe(
                            ln(
                                i,
                                c => {
                                    (s[l] = c), !a && !o[l] && ((o[l] = !0), (a = o.every(Yn)) && (o = null));
                                },
                                Kn,
                            ),
                        );
                    e.subscribe(
                        ln(i, l => {
                            if (a) {
                                const c = [l, ...s];
                                i.next(n ? n(...c) : c);
                            }
                        }),
                    );
                });
            }
            let Ms = (() => {
                    class t {
                        static #e = (this.SLOW = '0.3s');
                        static #t = (this.BASE = '0.2s');
                        static #n = (this.FAST = '0.1s');
                    }
                    return t;
                })(),
                Rs = (() => {
                    class t {
                        static #e = (this.EASE_BASE_OUT = 'cubic-bezier(0.7, 0.3, 0.1, 1)');
                        static #t = (this.EASE_BASE_IN = 'cubic-bezier(0.9, 0, 0.3, 0.7)');
                        static #n = (this.EASE_OUT = 'cubic-bezier(0.215, 0.61, 0.355, 1)');
                        static #i = (this.EASE_IN = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)');
                        static #r = (this.EASE_IN_OUT = 'cubic-bezier(0.645, 0.045, 0.355, 1)');
                        static #s = (this.EASE_OUT_BACK = 'cubic-bezier(0.12, 0.4, 0.29, 1.46)');
                        static #o = (this.EASE_IN_BACK = 'cubic-bezier(0.71, -0.46, 0.88, 0.6)');
                        static #a = (this.EASE_IN_OUT_BACK = 'cubic-bezier(0.71, -0.46, 0.29, 1.46)');
                        static #l = (this.EASE_OUT_CIRC = 'cubic-bezier(0.08, 0.82, 0.17, 1)');
                        static #c = (this.EASE_IN_CIRC = 'cubic-bezier(0.6, 0.04, 0.98, 0.34)');
                        static #u = (this.EASE_IN_OUT_CIRC = 'cubic-bezier(0.78, 0.14, 0.15, 0.86)');
                        static #d = (this.EASE_OUT_QUINT = 'cubic-bezier(0.23, 1, 0.32, 1)');
                        static #h = (this.EASE_IN_QUINT = 'cubic-bezier(0.755, 0.05, 0.855, 0.06)');
                        static #f = (this.EASE_IN_OUT_QUINT = 'cubic-bezier(0.86, 0, 0.07, 1)');
                    }
                    return t;
                })();
            Bo('collapseMotion', [
                qo('expanded', zt({ height: '*' })),
                qo('collapsed', zt({ height: 0, overflow: 'hidden' })),
                qo('hidden', zt({ height: 0, overflow: 'hidden', borderTopWidth: '0' })),
                Ii('expanded => collapsed', Ci(`150ms ${Rs.EASE_IN_OUT}`)),
                Ii('expanded => hidden', Ci(`150ms ${Rs.EASE_IN_OUT}`)),
                Ii('collapsed => expanded', Ci(`150ms ${Rs.EASE_IN_OUT}`)),
                Ii('hidden => expanded', Ci(`150ms ${Rs.EASE_IN_OUT}`)),
            ]),
                Bo('treeCollapseMotion', [
                    Ii('* => *', [
                        rS(
                            'nz-tree-node:leave,nz-tree-builtin-node:leave',
                            [
                                zt({ overflow: 'hidden' }),
                                sS(0, [
                                    Ci(`150ms ${Rs.EASE_IN_OUT}`, zt({ height: 0, opacity: 0, 'padding-bottom': 0 })),
                                ]),
                            ],
                            { optional: !0 },
                        ),
                        rS(
                            'nz-tree-node:enter,nz-tree-builtin-node:enter',
                            [
                                zt({ overflow: 'hidden', height: 0, opacity: 0, 'padding-bottom': 0 }),
                                sS(0, [
                                    Ci(
                                        `150ms ${Rs.EASE_IN_OUT}`,
                                        zt({ overflow: 'hidden', height: '*', opacity: '*', 'padding-bottom': '*' }),
                                    ),
                                ]),
                            ],
                            { optional: !0 },
                        ),
                    ]),
                ]),
                Bo('drawerMaskMotion', [
                    Ii(':enter', [zt({ opacity: 0 }), Ci(`${Ms.SLOW}`, zt({ opacity: 1 }))]),
                    Ii(':leave', [zt({ opacity: 1 }), Ci(`${Ms.SLOW}`, zt({ opacity: 0 }))]),
                ]),
                Bo('fadeMotion', [
                    Ii('* => enter', [zt({ opacity: 0 }), Ci(`${Ms.BASE}`, zt({ opacity: 1 }))]),
                    Ii('* => leave, :leave', [zt({ opacity: 1 }), Ci(`${Ms.BASE}`, zt({ opacity: 0 }))]),
                ]),
                Bo('helpMotion', [
                    Ii(':enter', [
                        zt({ opacity: 0, transform: 'translateY(-5px)' }),
                        Ci(`${Ms.SLOW} ${Rs.EASE_IN_OUT}`, zt({ opacity: 1, transform: 'translateY(0)' })),
                    ]),
                    Ii(':leave', [
                        zt({ opacity: 1, transform: 'translateY(0)' }),
                        Ci(`${Ms.SLOW} ${Rs.EASE_IN_OUT}`, zt({ opacity: 0, transform: 'translateY(-5px)' })),
                    ]),
                ]),
                Bo('moveUpMotion', [
                    Ii('* => enter', [
                        zt({ transformOrigin: '0 0', transform: 'translateY(-100%)', opacity: 0 }),
                        Ci(`${Ms.BASE}`, zt({ transformOrigin: '0 0', transform: 'translateY(0%)', opacity: 1 })),
                    ]),
                    Ii('* => leave', [
                        zt({ transformOrigin: '0 0', transform: 'translateY(0%)', opacity: 1 }),
                        Ci(`${Ms.BASE}`, zt({ transformOrigin: '0 0', transform: 'translateY(-100%)', opacity: 0 })),
                    ]),
                ]),
                Bo('notificationMotion', [
                    qo('enterRight', zt({ opacity: 1, transform: 'translateX(0)' })),
                    Ii('* => enterRight', [zt({ opacity: 0, transform: 'translateX(5%)' }), Ci('100ms linear')]),
                    qo('enterLeft', zt({ opacity: 1, transform: 'translateX(0)' })),
                    Ii('* => enterLeft', [zt({ opacity: 0, transform: 'translateX(-5%)' }), Ci('100ms linear')]),
                    qo('enterTop', zt({ opacity: 1, transform: 'translateY(0)' })),
                    Ii('* => enterTop', [zt({ opacity: 0, transform: 'translateY(-5%)' }), Ci('100ms linear')]),
                    qo('enterBottom', zt({ opacity: 1, transform: 'translateY(0)' })),
                    Ii('* => enterBottom', [zt({ opacity: 0, transform: 'translateY(5%)' }), Ci('100ms linear')]),
                    qo('leave', zt({ opacity: 0, transform: 'scaleY(0.8)', transformOrigin: '0% 0%' })),
                    Ii('* => leave', [
                        zt({ opacity: 1, transform: 'scaleY(1)', transformOrigin: '0% 0%' }),
                        Ci('100ms linear'),
                    ]),
                ]);
            const uJ = `${Ms.BASE} ${Rs.EASE_OUT_QUINT}`,
                dJ = `${Ms.BASE} ${Rs.EASE_IN_QUINT}`,
                Mx = Bo('slideMotion', [
                    qo('void', zt({ opacity: 0, transform: 'scaleY(0.8)' })),
                    qo('enter', zt({ opacity: 1, transform: 'scaleY(1)' })),
                    Ii('void => *', [Ci(uJ)]),
                    Ii('* => void', [Ci(dJ)]),
                ]),
                Sx =
                    (Bo('slideAlertMotion', [
                        Ii(':leave', [
                            zt({ opacity: 1, transform: 'scaleY(1)', transformOrigin: '0% 0%' }),
                            Ci(
                                `${Ms.SLOW} ${Rs.EASE_IN_OUT_CIRC}`,
                                zt({ opacity: 0, transform: 'scaleY(0)', transformOrigin: '0% 0%' }),
                            ),
                        ]),
                    ]),
                    Bo('tabSwitchMotion', [
                        qo('leave', zt({ display: 'none' })),
                        Ii('* => enter', [zt({ display: 'block', opacity: 0 }), Ci(Ms.SLOW)]),
                        Ii('* => leave, :leave', [
                            zt({ position: 'absolute', top: 0, left: 0, width: '100%' }),
                            Ci(Ms.SLOW, zt({ opacity: 0 })),
                            zt({ display: 'none' }),
                        ]),
                    ]),
                    Bo('thumbMotion', [
                        qo('from', zt({ transform: 'translateX({{ transform }}px)', width: '{{ width }}px' }), {
                            params: { transform: 0, width: 0 },
                        }),
                        qo('to', zt({ transform: 'translateX({{ transform }}px)', width: '{{ width }}px' }), {
                            params: { transform: 100, width: 0 },
                        }),
                        Ii('from => to', Ci(`300ms ${Rs.EASE_IN_OUT}`)),
                    ]),
                    Bo('zoomBigMotion', [
                        Ii('void => active', [
                            zt({ opacity: 0, transform: 'scale(0.8)' }),
                            Ci(`${Ms.BASE} ${Rs.EASE_OUT_CIRC}`, zt({ opacity: 1, transform: 'scale(1)' })),
                        ]),
                        Ii('active => void', [
                            zt({ opacity: 1, transform: 'scale(1)' }),
                            Ci(`${Ms.BASE} ${Rs.EASE_IN_OUT_CIRC}`, zt({ opacity: 0, transform: 'scale(0.8)' })),
                        ]),
                    ]));
            Bo('zoomBadgeMotion', [
                Ii(':enter', [
                    zt({ opacity: 0, transform: 'scale(0) translate(50%, -50%)' }),
                    Ci(
                        `${Ms.SLOW} ${Rs.EASE_OUT_BACK}`,
                        zt({ opacity: 1, transform: 'scale(1) translate(50%, -50%)' }),
                    ),
                ]),
                Ii(':leave', [
                    zt({ opacity: 1, transform: 'scale(1) translate(50%, -50%)' }),
                    Ci(`${Ms.SLOW} ${Rs.EASE_IN_BACK}`, zt({ opacity: 0, transform: 'scale(0) translate(50%, -50%)' })),
                ]),
            ]);
            let Ic = (() => {
                    class t {
                        constructor() {
                            (this.animationType = Ue(W0, { optional: !0 })), (this.nzNoAnimation = !1);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'nzNoAnimation', '']],
                            hostVars: 2,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('nz-animate-disabled', r.nzNoAnimation || 'NoopAnimations' === r.animationType);
                            },
                            inputs: {
                                nzNoAnimation: [de.HasDecoratorInputTransform, 'nzNoAnimation', 'nzNoAnimation', Ma],
                            },
                            exportAs: ['nzNoAnimation'],
                            standalone: !0,
                            features: [G2],
                        }));
                    }
                    return t;
                })(),
                yh = (() => {
                    class t {
                        static ngTemplateContextGuard(e, i) {
                            return !0;
                        }
                        recreateView() {
                            this.viewContainer.clear();
                            const e = this.nzStringTemplateOutlet instanceof Qr;
                            this.embeddedViewRef = this.viewContainer.createEmbeddedView(
                                e ? this.nzStringTemplateOutlet : this.templateRef,
                                e ? this.nzStringTemplateOutletContext : this.context,
                            );
                        }
                        updateContext() {
                            const i =
                                    this.nzStringTemplateOutlet instanceof Qr
                                        ? this.nzStringTemplateOutletContext
                                        : this.context,
                                r = this.embeddedViewRef.context;
                            if (i) for (const s of Object.keys(i)) r[s] = i[s];
                        }
                        constructor(e, i) {
                            (this.viewContainer = e),
                                (this.templateRef = i),
                                (this.embeddedViewRef = null),
                                (this.context = new hJ()),
                                (this.nzStringTemplateOutletContext = null),
                                (this.nzStringTemplateOutlet = null);
                        }
                        ngOnChanges(e) {
                            const { nzStringTemplateOutletContext: i, nzStringTemplateOutlet: r } = e;
                            r && (this.context.$implicit = r.currentValue),
                                (() => {
                                    let a = !1;
                                    return (
                                        r &&
                                            (a =
                                                !!r.firstChange ||
                                                r.previousValue instanceof Qr ||
                                                r.currentValue instanceof Qr),
                                        (i &&
                                            (f => {
                                                const g = Object.keys(f.previousValue || {}),
                                                    E = Object.keys(f.currentValue || {});
                                                if (g.length === E.length) {
                                                    for (const P of E) if (-1 === g.indexOf(P)) return !0;
                                                    return !1;
                                                }
                                                return !0;
                                            })(i)) ||
                                            a
                                    );
                                })()
                                    ? this.recreateView()
                                    : this.updateContext();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(go), te(Qr));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'nzStringTemplateOutlet', '']],
                            inputs: {
                                nzStringTemplateOutletContext: 'nzStringTemplateOutletContext',
                                nzStringTemplateOutlet: 'nzStringTemplateOutlet',
                            },
                            exportAs: ['nzStringTemplateOutlet'],
                            standalone: !0,
                            features: [D],
                        }));
                    }
                    return t;
                })();
            class hJ {}
            let bh = (() => {
                class t {
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵmod = Zn({ type: t }));
                    static #n = (this.ɵinj = zn({}));
                }
                return t;
            })();
            const Tx = new Set();
            let Nu,
                Dx = (() => {
                    class t {
                        constructor(e, i) {
                            (this._platform = e),
                                (this._nonce = i),
                                (this._matchMedia =
                                    this._platform.isBrowser && window.matchMedia
                                        ? window.matchMedia.bind(window)
                                        : mJ);
                        }
                        matchMedia(e) {
                            return (
                                (this._platform.WEBKIT || this._platform.BLINK) &&
                                    (function fJ(t, n) {
                                        if (!Tx.has(t))
                                            try {
                                                Nu ||
                                                    ((Nu = document.createElement('style')),
                                                    n && Nu.setAttribute('nonce', n),
                                                    Nu.setAttribute('type', 'text/css'),
                                                    document.head.appendChild(Nu)),
                                                    Nu.sheet &&
                                                        (Nu.sheet.insertRule(`@media ${t} {body{ }}`, 0), Tx.add(t));
                                            } catch (e) {
                                                console.error(e);
                                            }
                                    })(e, this._nonce),
                                this._matchMedia(e)
                            );
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(Go), Se(K0, 8));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })();
            function mJ(t) {
                return { matches: 'all' === t || '' === t, media: t, addListener: () => {}, removeListener: () => {} };
            }
            const Jg = () => {};
            let pJ = (() => {
                class t {
                    constructor(e, i) {
                        (this.ngZone = e),
                            (this.rendererFactory2 = i),
                            (this.resizeSource$ = new vt()),
                            (this.listeners = 0),
                            (this.disposeHandle = Jg),
                            (this.handler = () => {
                                this.ngZone.run(() => {
                                    this.resizeSource$.next();
                                });
                            }),
                            (this.renderer = this.rendererFactory2.createRenderer(null, null));
                    }
                    ngOnDestroy() {
                        this.handler = Jg;
                    }
                    subscribe() {
                        return (
                            this.registerListener(),
                            this.resizeSource$.pipe(
                                Kg(16),
                                H4(() => this.unregisterListener()),
                            )
                        );
                    }
                    unsubscribe() {
                        this.unregisterListener();
                    }
                    registerListener() {
                        0 === this.listeners &&
                            this.ngZone.runOutsideAngular(() => {
                                this.disposeHandle = this.renderer.listen('window', 'resize', this.handler);
                            }),
                            (this.listeners += 1);
                    }
                    unregisterListener() {
                        (this.listeners -= 1),
                            0 === this.listeners && (this.disposeHandle(), (this.disposeHandle = Jg));
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(en), Se(y1));
                    });
                    static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                }
                return t;
            })();
            var xx = (function (t) {
                return (t.xxl = 'xxl'), (t.xl = 'xl'), (t.lg = 'lg'), (t.md = 'md'), (t.sm = 'sm'), (t.xs = 'xs'), t;
            })(xx || {});
            const Wf = {
                xs: '(max-width: 575px)',
                sm: '(min-width: 576px)',
                md: '(min-width: 768px)',
                lg: '(min-width: 992px)',
                xl: '(min-width: 1200px)',
                xxl: '(min-width: 1600px)',
            };
            let gJ = (() => {
                    class t {
                        constructor(e, i) {
                            (this.resizeService = e),
                                (this.mediaMatcher = i),
                                (this.destroy$ = new vt()),
                                this.resizeService
                                    .subscribe()
                                    .pipe(nn(this.destroy$))
                                    .subscribe(() => {});
                        }
                        ngOnDestroy() {
                            this.destroy$.next();
                        }
                        subscribe(e, i) {
                            if (i) {
                                const r = () => this.matchMedia(e, !0);
                                return this.resizeService.subscribe().pipe(
                                    Ct(r),
                                    Pg(r()),
                                    n0((s, o) => s[0] === o[0]),
                                    Ct(s => s[1]),
                                );
                            }
                            {
                                const r = () => this.matchMedia(e);
                                return this.resizeService.subscribe().pipe(Ct(r), Pg(r()), n0());
                            }
                        }
                        matchMedia(e, i) {
                            let r = xx.md;
                            const s = {};
                            return (
                                Object.keys(e).map(o => {
                                    const a = o,
                                        l = this.mediaMatcher.matchMedia(Wf[a]).matches;
                                    (s[o] = l), l && (r = a);
                                }),
                                i ? [r, s] : r
                            );
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se(pJ), Se(Dx));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                Kf = (() => {
                    class t extends vt {
                        ngOnDestroy() {
                            this.next(), this.complete();
                        }
                        static #e = (this.ɵfac = (() => {
                            let e;
                            return function (r) {
                                return (e || (e = Nr(t)))(r || t);
                            };
                        })());
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })();
            const Ss = {
                    top: new Lr({ originX: 'center', originY: 'top' }, { overlayX: 'center', overlayY: 'bottom' }),
                    topCenter: new Lr(
                        { originX: 'center', originY: 'top' },
                        { overlayX: 'center', overlayY: 'bottom' },
                    ),
                    topLeft: new Lr({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' }),
                    topRight: new Lr({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' }),
                    right: new Lr({ originX: 'end', originY: 'center' }, { overlayX: 'start', overlayY: 'center' }),
                    rightTop: new Lr({ originX: 'end', originY: 'top' }, { overlayX: 'start', overlayY: 'top' }),
                    rightBottom: new Lr(
                        { originX: 'end', originY: 'bottom' },
                        { overlayX: 'start', overlayY: 'bottom' },
                    ),
                    bottom: new Lr({ originX: 'center', originY: 'bottom' }, { overlayX: 'center', overlayY: 'top' }),
                    bottomCenter: new Lr(
                        { originX: 'center', originY: 'bottom' },
                        { overlayX: 'center', overlayY: 'top' },
                    ),
                    bottomLeft: new Lr({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
                    bottomRight: new Lr({ originX: 'end', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' }),
                    left: new Lr({ originX: 'start', originY: 'center' }, { overlayX: 'end', overlayY: 'center' }),
                    leftTop: new Lr({ originX: 'start', originY: 'top' }, { overlayX: 'end', overlayY: 'top' }),
                    leftBottom: new Lr(
                        { originX: 'start', originY: 'bottom' },
                        { overlayX: 'end', overlayY: 'bottom' },
                    ),
                },
                kx = [Ss.top, Ss.right, Ss.bottom, Ss.left];
            function Ex(t) {
                for (const n in Ss)
                    if (
                        t.connectionPair.originX === Ss[n].originX &&
                        t.connectionPair.originY === Ss[n].originY &&
                        t.connectionPair.overlayX === Ss[n].overlayX &&
                        t.connectionPair.overlayY === Ss[n].overlayY
                    )
                        return n;
            }
            new Lr({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'bottom' }),
                new Lr({ originX: 'start', originY: 'bottom' }, { overlayX: 'end', overlayY: 'bottom' }),
                new Lr({ originX: 'start', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' });
            const Ch = {
                    bottomLeft: new Lr(
                        { originX: 'start', originY: 'bottom' },
                        { overlayX: 'start', overlayY: 'top' },
                        void 0,
                        2,
                    ),
                    topLeft: new Lr(
                        { originX: 'start', originY: 'top' },
                        { overlayX: 'start', overlayY: 'bottom' },
                        void 0,
                        -2,
                    ),
                    bottomRight: new Lr(
                        { originX: 'end', originY: 'bottom' },
                        { overlayX: 'end', overlayY: 'top' },
                        void 0,
                        2,
                    ),
                    topRight: new Lr(
                        { originX: 'end', originY: 'top' },
                        { overlayX: 'end', overlayY: 'bottom' },
                        void 0,
                        -2,
                    ),
                },
                Ix = [Ch.bottomLeft, Ch.topLeft, Ch.bottomRight, Ch.topRight];
            let Qf = (() => {
                    class t {
                        constructor(e, i) {
                            (this.cdkConnectedOverlay = e),
                                (this.nzDestroyService = i),
                                (this.nzArrowPointAtCenter = !1),
                                (this.cdkConnectedOverlay.backdropClass = 'nz-overlay-transparent-backdrop'),
                                this.cdkConnectedOverlay.positionChange.pipe(nn(this.nzDestroyService)).subscribe(r => {
                                    this.nzArrowPointAtCenter && this.updateArrowPosition(r);
                                });
                        }
                        updateArrowPosition(e) {
                            const i = this.getOriginRect(),
                                r = Ex(e);
                            let s = 0,
                                o = 0;
                            'topLeft' === r || 'bottomLeft' === r
                                ? (s = i.width / 2 - 14)
                                : 'topRight' === r || 'bottomRight' === r
                                ? (s = -(i.width / 2 - 14))
                                : 'leftTop' === r || 'rightTop' === r
                                ? (o = i.height / 2 - 10)
                                : ('leftBottom' === r || 'rightBottom' === r) && (o = -(i.height / 2 - 10)),
                                (this.cdkConnectedOverlay.offsetX !== s || this.cdkConnectedOverlay.offsetY !== o) &&
                                    ((this.cdkConnectedOverlay.offsetY = o),
                                    (this.cdkConnectedOverlay.offsetX = s),
                                    this.cdkConnectedOverlay.overlayRef.updatePosition());
                        }
                        getFlexibleConnectedPositionStrategyOrigin() {
                            return this.cdkConnectedOverlay.origin instanceof _h
                                ? this.cdkConnectedOverlay.origin.elementRef
                                : this.cdkConnectedOverlay.origin;
                        }
                        getOriginRect() {
                            const e = this.getFlexibleConnectedPositionStrategyOrigin();
                            if (e instanceof Pn) return e.nativeElement.getBoundingClientRect();
                            if (e instanceof Element) return e.getBoundingClientRect();
                            const i = e.width || 0,
                                r = e.height || 0;
                            return { top: e.y, bottom: e.y + r, left: e.x, right: e.x + i, height: r, width: i };
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(u0), te(Kf));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'cdkConnectedOverlay', '', 'nzConnectedOverlay', '']],
                            inputs: { nzArrowPointAtCenter: 'nzArrowPointAtCenter' },
                            exportAs: ['nzConnectedOverlay'],
                            features: [$n([Kf])],
                        }));
                    }
                    return Lt([En()], t.prototype, 'nzArrowPointAtCenter', void 0), t;
                })(),
                Xf = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })();
            const Ax = ['moz', 'ms', 'webkit'],
                yJ = (function _J() {
                    if (typeof window > 'u') return () => 0;
                    if (window.requestAnimationFrame) return window.requestAnimationFrame.bind(window);
                    const t = Ax.filter(n => `${n}RequestAnimationFrame` in window)[0];
                    return t
                        ? window[`${t}RequestAnimationFrame`]
                        : (function vJ() {
                              let t = 0;
                              return function (n) {
                                  const e = new Date().getTime(),
                                      i = Math.max(0, 16 - (e - t)),
                                      r = window.setTimeout(() => {
                                          n(e + i);
                                      }, i);
                                  return (t = e + i), r;
                              };
                          })();
                })(),
                bJ = ['hourListElement'],
                CJ = ['minuteListElement'],
                wJ = ['secondListElement'],
                MJ = ['use12HoursListElement'];
            function SJ(t, n) {
                if ((1 & t && (Z(0, 'div', 8)(1, 'div', 9), Je(2), ee()()), 2 & t)) {
                    const e = L();
                    z(2), hn(e.dateHelper.format(null == e.time ? null : e.time.value, e.format) || '\xa0');
                }
            }
            function TJ(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'li', 13),
                        Le('click', function () {
                            me(e);
                            const r = L().$implicit;
                            return pe(L(2).selectHour(r));
                        }),
                        Z(1, 'div', 14),
                        Je(2),
                        Gn(3, 'number'),
                        ee()();
                }
                if (2 & t) {
                    const e = L().$implicit;
                    On('ant-picker-time-panel-cell-selected', L(2).isSelectedHour(e))(
                        'ant-picker-time-panel-cell-disabled',
                        e.disabled,
                    ),
                        z(2),
                        hn(u4(3, 5, e.index, '2.0-0'));
                }
            }
            function DJ(t, n) {
                if ((1 & t && (Xe(0), ue(1, TJ, 4, 8, 'li', 12), Ze()), 2 & t)) {
                    const e = n.$implicit,
                        i = L(2);
                    z(), H('ngIf', !(i.nzHideDisabledOptions && e.disabled));
                }
            }
            function xJ(t, n) {
                if ((1 & t && (Z(0, 'ul', 10, 0), ue(2, DJ, 2, 1, 'ng-container', 11), ee()), 2 & t)) {
                    const e = L();
                    z(2), H('ngForOf', e.hourRange)('ngForTrackBy', e.trackByFn);
                }
            }
            function kJ(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'li', 13),
                        Le('click', function () {
                            me(e);
                            const r = L().$implicit;
                            return pe(L(2).selectMinute(r));
                        }),
                        Z(1, 'div', 14),
                        Je(2),
                        Gn(3, 'number'),
                        ee()();
                }
                if (2 & t) {
                    const e = L().$implicit;
                    On('ant-picker-time-panel-cell-selected', L(2).isSelectedMinute(e))(
                        'ant-picker-time-panel-cell-disabled',
                        e.disabled,
                    ),
                        z(2),
                        hn(u4(3, 5, e.index, '2.0-0'));
                }
            }
            function EJ(t, n) {
                if ((1 & t && (Xe(0), ue(1, kJ, 4, 8, 'li', 12), Ze()), 2 & t)) {
                    const e = n.$implicit,
                        i = L(2);
                    z(), H('ngIf', !(i.nzHideDisabledOptions && e.disabled));
                }
            }
            function IJ(t, n) {
                if ((1 & t && (Z(0, 'ul', 10, 1), ue(2, EJ, 2, 1, 'ng-container', 11), ee()), 2 & t)) {
                    const e = L();
                    z(2), H('ngForOf', e.minuteRange)('ngForTrackBy', e.trackByFn);
                }
            }
            function AJ(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'li', 13),
                        Le('click', function () {
                            me(e);
                            const r = L().$implicit;
                            return pe(L(2).selectSecond(r));
                        }),
                        Z(1, 'div', 14),
                        Je(2),
                        Gn(3, 'number'),
                        ee()();
                }
                if (2 & t) {
                    const e = L().$implicit;
                    On('ant-picker-time-panel-cell-selected', L(2).isSelectedSecond(e))(
                        'ant-picker-time-panel-cell-disabled',
                        e.disabled,
                    ),
                        z(2),
                        hn(u4(3, 5, e.index, '2.0-0'));
                }
            }
            function LJ(t, n) {
                if ((1 & t && (Xe(0), ue(1, AJ, 4, 8, 'li', 12), Ze()), 2 & t)) {
                    const e = n.$implicit,
                        i = L(2);
                    z(), H('ngIf', !(i.nzHideDisabledOptions && e.disabled));
                }
            }
            function OJ(t, n) {
                if ((1 & t && (Z(0, 'ul', 10, 2), ue(2, LJ, 2, 1, 'ng-container', 11), ee()), 2 & t)) {
                    const e = L();
                    z(2), H('ngForOf', e.secondRange)('ngForTrackBy', e.trackByFn);
                }
            }
            function zJ(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'li', 13),
                        Le('click', function () {
                            const r = me(e).$implicit;
                            return pe(L(2).select12Hours(r));
                        }),
                        Z(2, 'div', 14),
                        Je(3),
                        ee()(),
                        Ze();
                }
                if (2 & t) {
                    const e = n.$implicit,
                        i = L(2);
                    z(), On('ant-picker-time-panel-cell-selected', i.isSelected12Hours(e)), z(2), hn(e.value);
                }
            }
            function PJ(t, n) {
                if ((1 & t && (Z(0, 'ul', 10, 3), ue(2, zJ, 4, 3, 'ng-container', 15), ee()), 2 & t)) {
                    const e = L();
                    z(2), H('ngForOf', e.use12HoursRange);
                }
            }
            function NJ(t, n) {}
            function FJ(t, n) {
                if ((1 & t && (Z(0, 'div', 23), ue(1, NJ, 0, 0, 'ng-template', 24), ee()), 2 & t)) {
                    const e = L(2);
                    z(), H('ngTemplateOutlet', e.nzAddOn);
                }
            }
            function RJ(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div', 16),
                        ue(1, FJ, 2, 1, 'div', 17),
                        Z(2, 'ul', 18)(3, 'li', 19)(4, 'a', 20),
                        Le('click', function () {
                            return me(e), pe(L().onClickNow());
                        }),
                        Je(5),
                        Gn(6, 'nzI18n'),
                        ee()(),
                        Z(7, 'li', 21)(8, 'button', 22),
                        Le('click', function () {
                            return me(e), pe(L().onClickOk());
                        }),
                        Je(9),
                        Gn(10, 'nzI18n'),
                        ee()()()();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        H('ngIf', e.nzAddOn),
                        z(4),
                        jn(' ', e.nzNowText || ci(6, 3, 'Calendar.lang.now'), ' '),
                        z(4),
                        jn(' ', e.nzOkText || ci(10, 5, 'Calendar.lang.ok'), ' ');
                }
            }
            const VJ = ['inputElement'];
            function HJ(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'span', 8), Ze()), 2 & t)) {
                    const e = n.$implicit;
                    z(), H('nzType', e);
                }
            }
            function UJ(t, n) {
                1 & t && Oe(0, 'nz-form-item-feedback-icon', 9), 2 & t && H('status', L().status);
            }
            function BJ(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'span', 10),
                        Le('click', function (r) {
                            return me(e), pe(L().onClickClearBtn(r));
                        }),
                        Oe(1, 'span', 11),
                        ee();
                }
                if (2 & t) {
                    const e = L();
                    z(), zi('aria-label', e.nzClearText)('title', e.nzClearText);
                }
            }
            function qJ(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div', 12)(1, 'div', 13)(2, 'div', 14)(3, 'nz-time-picker-panel', 15),
                        Gn(4, 'async'),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.value, r) || (s.value = r), pe(r);
                        }),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onPanelValueChange(r));
                        })('closePanel', function () {
                            return me(e), pe(L().closePanel());
                        }),
                        ee()()()();
                }
                if (2 & t) {
                    const e = L();
                    H('@slideMotion', 'enter'),
                        z(3),
                        H('ngClass', e.nzPopupClassName)('format', e.nzFormat)('nzHourStep', e.nzHourStep)(
                            'nzMinuteStep',
                            e.nzMinuteStep,
                        )('nzSecondStep', e.nzSecondStep)('nzDisabledHours', e.nzDisabledHours)(
                            'nzDisabledMinutes',
                            e.nzDisabledMinutes,
                        )('nzDisabledSeconds', e.nzDisabledSeconds)(
                            'nzPlaceHolder',
                            e.nzPlaceHolder || ci(4, 19, e.i18nPlaceHolder$),
                        )('nzHideDisabledOptions', e.nzHideDisabledOptions)('nzUse12Hours', e.nzUse12Hours)(
                            'nzDefaultOpenValue',
                            e.nzDefaultOpenValue,
                        )('nzAddOn', e.nzAddOn)('nzClearText', e.nzClearText)('nzNowText', e.nzNowText)(
                            'nzOkText',
                            e.nzOkText,
                        )('nzAllowEmpty', e.nzAllowEmpty),
                        yi('ngModel', e.value);
                }
            }
            class YJ {
                setMinutes(n, e) {
                    return e || (this.initValue(), this.value.setMinutes(n), this.update()), this;
                }
                setHours(n, e) {
                    return (
                        e ||
                            (this.initValue(),
                            this.value.setHours(
                                this._use12Hours
                                    ? 'PM' === this.selected12Hours && 12 !== n
                                        ? n + 12
                                        : 'AM' === this.selected12Hours && 12 === n
                                        ? 0
                                        : n
                                    : n,
                            ),
                            this.update()),
                        this
                    );
                }
                setSeconds(n, e) {
                    return e || (this.initValue(), this.value.setSeconds(n), this.update()), this;
                }
                setUse12Hours(n) {
                    return (this._use12Hours = n), this;
                }
                get changes() {
                    return this._changes.asObservable();
                }
                setValue(n, e) {
                    return (
                        Fi(e) && (this._use12Hours = e),
                        n !== this.value &&
                            ((this._value = n),
                            Fi(this.value)
                                ? this._use12Hours &&
                                  Fi(this.hours) &&
                                  (this.selected12Hours = this.hours >= 12 ? 'PM' : 'AM')
                                : this._clear()),
                        this
                    );
                }
                initValue() {
                    fT(this.value) && this.setValue(new Date(), this._use12Hours);
                }
                clear() {
                    this._clear(), this.update();
                }
                get isEmpty() {
                    return !(Fi(this.hours) || Fi(this.minutes) || Fi(this.seconds));
                }
                _clear() {
                    (this._value = void 0), (this.selected12Hours = void 0);
                }
                update() {
                    this.isEmpty
                        ? (this._value = void 0)
                        : (Fi(this.hours) && this.value.setHours(this.hours),
                          Fi(this.minutes) && this.value.setMinutes(this.minutes),
                          Fi(this.seconds) && this.value.setSeconds(this.seconds),
                          this._use12Hours &&
                              ('PM' === this.selected12Hours && this.hours < 12 && this.value.setHours(this.hours + 12),
                              'AM' === this.selected12Hours &&
                                  this.hours >= 12 &&
                                  this.value.setHours(this.hours - 12))),
                        this.changed();
                }
                changed() {
                    this._changes.next(this.value);
                }
                get viewHours() {
                    return this._use12Hours && Fi(this.hours) ? this.calculateViewHour(this.hours) : this.hours;
                }
                setSelected12Hours(n) {
                    n.toUpperCase() !== this.selected12Hours &&
                        ((this.selected12Hours = n.toUpperCase()), this.update());
                }
                get value() {
                    return this._value || this._defaultOpenValue;
                }
                get hours() {
                    return this.value?.getHours();
                }
                get minutes() {
                    return this.value?.getMinutes();
                }
                get seconds() {
                    return this.value?.getSeconds();
                }
                setDefaultOpenValue(n) {
                    return (this._defaultOpenValue = n), this;
                }
                constructor() {
                    (this.selected12Hours = void 0), (this._use12Hours = !1), (this._changes = new vt());
                }
                calculateViewHour(n) {
                    const e = this.selected12Hours;
                    return 'PM' === e && n > 12 ? n - 12 : 'AM' === e && 0 === n ? 12 : n;
                }
            }
            function e5(t, n = 1, e = 0) {
                return new Array(Math.ceil(t / n)).fill(0).map((i, r) => (r + e) * n);
            }
            let t5 = (() => {
                    class t {
                        set nzAllowEmpty(e) {
                            Fi(e) && (this._allowEmpty = e);
                        }
                        get nzAllowEmpty() {
                            return this._allowEmpty;
                        }
                        set nzDisabledHours(e) {
                            (this._disabledHours = e), this._disabledHours && this.buildHours();
                        }
                        get nzDisabledHours() {
                            return this._disabledHours;
                        }
                        set nzDisabledMinutes(e) {
                            Fi(e) && ((this._disabledMinutes = e), this.buildMinutes());
                        }
                        get nzDisabledMinutes() {
                            return this._disabledMinutes;
                        }
                        set nzDisabledSeconds(e) {
                            Fi(e) && ((this._disabledSeconds = e), this.buildSeconds());
                        }
                        get nzDisabledSeconds() {
                            return this._disabledSeconds;
                        }
                        set format(e) {
                            if (Fi(e)) {
                                (this._format = e), (this.enabledColumns = 0);
                                const i = new Set(e);
                                (this.hourEnabled = i.has('H') || i.has('h')),
                                    (this.minuteEnabled = i.has('m')),
                                    (this.secondEnabled = i.has('s')),
                                    this.hourEnabled && this.enabledColumns++,
                                    this.minuteEnabled && this.enabledColumns++,
                                    this.secondEnabled && this.enabledColumns++,
                                    this.nzUse12Hours && this.build12Hours();
                            }
                        }
                        get format() {
                            return this._format;
                        }
                        set nzHourStep(e) {
                            Fi(e) && ((this._nzHourStep = e), this.buildHours());
                        }
                        get nzHourStep() {
                            return this._nzHourStep;
                        }
                        set nzMinuteStep(e) {
                            Fi(e) && ((this._nzMinuteStep = e), this.buildMinutes());
                        }
                        get nzMinuteStep() {
                            return this._nzMinuteStep;
                        }
                        set nzSecondStep(e) {
                            Fi(e) && ((this._nzSecondStep = e), this.buildSeconds());
                        }
                        get nzSecondStep() {
                            return this._nzSecondStep;
                        }
                        trackByFn(e) {
                            return e;
                        }
                        buildHours() {
                            let e = 24,
                                i = this.nzDisabledHours?.(),
                                r = 0;
                            if (
                                (this.nzUse12Hours &&
                                    ((e = 12),
                                    i &&
                                        (i =
                                            'PM' === this.time.selected12Hours
                                                ? i.filter(s => s >= 12).map(s => (s > 12 ? s - 12 : s))
                                                : i
                                                      .filter(s => s < 12 || 24 === s)
                                                      .map(s => (24 === s || 0 === s ? 12 : s))),
                                    (r = 1)),
                                (this.hourRange = e5(e, this.nzHourStep, r).map(s => ({
                                    index: s,
                                    disabled: !!i && -1 !== i.indexOf(s),
                                }))),
                                this.nzUse12Hours && 12 === this.hourRange[this.hourRange.length - 1].index)
                            ) {
                                const s = [...this.hourRange];
                                s.unshift(s[s.length - 1]), s.splice(s.length - 1, 1), (this.hourRange = s);
                            }
                        }
                        buildMinutes() {
                            this.minuteRange = e5(60, this.nzMinuteStep).map(e => ({
                                index: e,
                                disabled:
                                    !!this.nzDisabledMinutes &&
                                    -1 !== this.nzDisabledMinutes(this.time.hours).indexOf(e),
                            }));
                        }
                        buildSeconds() {
                            this.secondRange = e5(60, this.nzSecondStep).map(e => ({
                                index: e,
                                disabled:
                                    !!this.nzDisabledSeconds &&
                                    -1 !== this.nzDisabledSeconds(this.time.hours, this.time.minutes).indexOf(e),
                            }));
                        }
                        build12Hours() {
                            const e = this._format.includes('A');
                            this.use12HoursRange = [
                                { index: 0, value: e ? 'AM' : 'am' },
                                { index: 1, value: e ? 'PM' : 'pm' },
                            ];
                        }
                        buildTimes() {
                            this.buildHours(), this.buildMinutes(), this.buildSeconds(), this.build12Hours();
                        }
                        scrollToTime(e = 0) {
                            this.hourEnabled &&
                                this.hourListElement &&
                                this.scrollToSelected(
                                    this.hourListElement.nativeElement,
                                    this.time.viewHours,
                                    e,
                                    'hour',
                                ),
                                this.minuteEnabled &&
                                    this.minuteListElement &&
                                    this.scrollToSelected(
                                        this.minuteListElement.nativeElement,
                                        this.time.minutes,
                                        e,
                                        'minute',
                                    ),
                                this.secondEnabled &&
                                    this.secondListElement &&
                                    this.scrollToSelected(
                                        this.secondListElement.nativeElement,
                                        this.time.seconds,
                                        e,
                                        'second',
                                    ),
                                this.nzUse12Hours &&
                                    this.use12HoursListElement &&
                                    this.scrollToSelected(
                                        this.use12HoursListElement.nativeElement,
                                        'AM' === this.time.selected12Hours ? 0 : 1,
                                        e,
                                        '12-hour',
                                    );
                        }
                        selectHour(e) {
                            this.time.setHours(e.index, e.disabled),
                                this._disabledMinutes && this.buildMinutes(),
                                (this._disabledSeconds || this._disabledMinutes) && this.buildSeconds();
                        }
                        selectMinute(e) {
                            this.time.setMinutes(e.index, e.disabled), this._disabledSeconds && this.buildSeconds();
                        }
                        selectSecond(e) {
                            this.time.setSeconds(e.index, e.disabled);
                        }
                        select12Hours(e) {
                            this.time.setSelected12Hours(e.value),
                                this._disabledHours && this.buildHours(),
                                this._disabledMinutes && this.buildMinutes(),
                                this._disabledSeconds && this.buildSeconds();
                        }
                        scrollToSelected(e, i, r = 0, s) {
                            if (!e) return;
                            const o = this.translateIndex(i, s);
                            this.scrollTo(e, (e.children[o] || e.children[0]).offsetTop, r);
                        }
                        translateIndex(e, i) {
                            return 'hour' === i
                                ? this.calcIndex(this.nzDisabledHours?.(), this.hourRange.map(r => r.index).indexOf(e))
                                : 'minute' === i
                                ? this.calcIndex(
                                      this.nzDisabledMinutes?.(this.time.hours),
                                      this.minuteRange.map(r => r.index).indexOf(e),
                                  )
                                : 'second' === i
                                ? this.calcIndex(
                                      this.nzDisabledSeconds?.(this.time.hours, this.time.minutes),
                                      this.secondRange.map(r => r.index).indexOf(e),
                                  )
                                : this.calcIndex([], this.use12HoursRange.map(r => r.index).indexOf(e));
                        }
                        scrollTo(e, i, r) {
                            if (r <= 0) return void (e.scrollTop = i);
                            const o = ((i - e.scrollTop) / r) * 10;
                            this.ngZone.runOutsideAngular(() => {
                                yJ(() => {
                                    (e.scrollTop = e.scrollTop + o), e.scrollTop !== i && this.scrollTo(e, i, r - 10);
                                });
                            });
                        }
                        calcIndex(e, i) {
                            return e?.length && this.nzHideDisabledOptions
                                ? i - e.reduce((r, s) => r + (s < i ? 1 : 0), 0)
                                : i;
                        }
                        changed() {
                            this.onChange && this.onChange(this.time.value);
                        }
                        touched() {
                            this.onTouch && this.onTouch();
                        }
                        timeDisabled(e) {
                            const i = e.getHours(),
                                r = e.getMinutes(),
                                s = e.getSeconds();
                            return (
                                (this.nzDisabledHours?.().indexOf(i) ?? -1) > -1 ||
                                (this.nzDisabledMinutes?.(i).indexOf(r) ?? -1) > -1 ||
                                (this.nzDisabledSeconds?.(i, r).indexOf(s) ?? -1) > -1
                            );
                        }
                        onClickNow() {
                            const e = new Date();
                            this.timeDisabled(e) || (this.time.setValue(e), this.changed(), this.closePanel.emit());
                        }
                        onClickOk() {
                            this.time.setValue(this.time.value, this.nzUse12Hours),
                                this.changed(),
                                this.closePanel.emit();
                        }
                        isSelectedHour(e) {
                            return e.index === this.time.viewHours;
                        }
                        isSelectedMinute(e) {
                            return e.index === this.time.minutes;
                        }
                        isSelectedSecond(e) {
                            return e.index === this.time.seconds;
                        }
                        isSelected12Hours(e) {
                            return e.value.toUpperCase() === this.time.selected12Hours;
                        }
                        constructor(e, i, r, s) {
                            (this.ngZone = e),
                                (this.cdr = i),
                                (this.dateHelper = r),
                                (this.elementRef = s),
                                (this._nzHourStep = 1),
                                (this._nzMinuteStep = 1),
                                (this._nzSecondStep = 1),
                                (this.unsubscribe$ = new vt()),
                                (this._format = 'HH:mm:ss'),
                                (this._disabledHours = () => []),
                                (this._disabledMinutes = () => []),
                                (this._disabledSeconds = () => []),
                                (this._allowEmpty = !0),
                                (this.time = new YJ()),
                                (this.hourEnabled = !0),
                                (this.minuteEnabled = !0),
                                (this.secondEnabled = !0),
                                (this.firstScrolled = !1),
                                (this.enabledColumns = 3),
                                (this.nzInDatePicker = !1),
                                (this.nzHideDisabledOptions = !1),
                                (this.nzUse12Hours = !1),
                                (this.closePanel = new Ft());
                        }
                        ngOnInit() {
                            this.time.changes.pipe(nn(this.unsubscribe$)).subscribe(() => {
                                this.changed(), this.touched(), this.scrollToTime(120);
                            }),
                                this.buildTimes(),
                                this.ngZone.runOutsideAngular(() => {
                                    setTimeout(() => {
                                        this.scrollToTime(), (this.firstScrolled = !0);
                                    }),
                                        ca(this.elementRef.nativeElement, 'mousedown')
                                            .pipe(nn(this.unsubscribe$))
                                            .subscribe(e => {
                                                e.preventDefault();
                                            });
                                });
                        }
                        ngOnDestroy() {
                            this.unsubscribe$.next(), this.unsubscribe$.complete();
                        }
                        ngOnChanges(e) {
                            const { nzUse12Hours: i, nzDefaultOpenValue: r } = e;
                            !i?.previousValue && i?.currentValue && (this.build12Hours(), this.enabledColumns++),
                                r?.currentValue && this.time.setDefaultOpenValue(this.nzDefaultOpenValue || new Date());
                        }
                        writeValue(e) {
                            this.time.setValue(e, this.nzUse12Hours),
                                this.buildTimes(),
                                e && this.firstScrolled && this.scrollToTime(120),
                                this.cdr.markForCheck();
                        }
                        registerOnChange(e) {
                            this.onChange = e;
                        }
                        registerOnTouched(e) {
                            this.onTouch = e;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(en), te(kr), te(Aa), te(Pn));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['nz-time-picker-panel']],
                            viewQuery: function (i, r) {
                                if ((1 & i && (Fr(bJ, 5), Fr(CJ, 5), Fr(wJ, 5), Fr(MJ, 5)), 2 & i)) {
                                    let s;
                                    Dr((s = xr())) && (r.hourListElement = s.first),
                                        Dr((s = xr())) && (r.minuteListElement = s.first),
                                        Dr((s = xr())) && (r.secondListElement = s.first),
                                        Dr((s = xr())) && (r.use12HoursListElement = s.first);
                                }
                            },
                            hostAttrs: [1, 'ant-picker-time-panel'],
                            hostVars: 12,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('ant-picker-time-panel-column-0', 0 === r.enabledColumns && !r.nzInDatePicker)(
                                        'ant-picker-time-panel-column-1',
                                        1 === r.enabledColumns && !r.nzInDatePicker,
                                    )('ant-picker-time-panel-column-2', 2 === r.enabledColumns && !r.nzInDatePicker)(
                                        'ant-picker-time-panel-column-3',
                                        3 === r.enabledColumns && !r.nzInDatePicker,
                                    )('ant-picker-time-panel-narrow', r.enabledColumns < 3)(
                                        'ant-picker-time-panel-placement-bottomLeft',
                                        !r.nzInDatePicker,
                                    );
                            },
                            inputs: {
                                nzInDatePicker: 'nzInDatePicker',
                                nzAddOn: 'nzAddOn',
                                nzHideDisabledOptions: 'nzHideDisabledOptions',
                                nzClearText: 'nzClearText',
                                nzNowText: 'nzNowText',
                                nzOkText: 'nzOkText',
                                nzPlaceHolder: 'nzPlaceHolder',
                                nzUse12Hours: 'nzUse12Hours',
                                nzDefaultOpenValue: 'nzDefaultOpenValue',
                                nzAllowEmpty: 'nzAllowEmpty',
                                nzDisabledHours: 'nzDisabledHours',
                                nzDisabledMinutes: 'nzDisabledMinutes',
                                nzDisabledSeconds: 'nzDisabledSeconds',
                                format: 'format',
                                nzHourStep: 'nzHourStep',
                                nzMinuteStep: 'nzMinuteStep',
                                nzSecondStep: 'nzSecondStep',
                            },
                            outputs: { closePanel: 'closePanel' },
                            exportAs: ['nzTimePickerPanel'],
                            standalone: !0,
                            features: [$n([{ provide: hs, useExisting: t, multi: !0 }]), D, Qi],
                            decls: 7,
                            vars: 6,
                            consts: [
                                ['hourListElement', ''],
                                ['minuteListElement', ''],
                                ['secondListElement', ''],
                                ['use12HoursListElement', ''],
                                ['class', 'ant-picker-header', 4, 'ngIf'],
                                [1, 'ant-picker-content'],
                                ['class', 'ant-picker-time-panel-column', 'style', 'position: relative;', 4, 'ngIf'],
                                ['class', 'ant-picker-footer', 4, 'ngIf'],
                                [1, 'ant-picker-header'],
                                [1, 'ant-picker-header-view'],
                                [1, 'ant-picker-time-panel-column', 2, 'position', 'relative'],
                                [4, 'ngFor', 'ngForOf', 'ngForTrackBy'],
                                [
                                    'class',
                                    'ant-picker-time-panel-cell',
                                    3,
                                    'ant-picker-time-panel-cell-selected',
                                    'ant-picker-time-panel-cell-disabled',
                                    'click',
                                    4,
                                    'ngIf',
                                ],
                                [1, 'ant-picker-time-panel-cell', 3, 'click'],
                                [1, 'ant-picker-time-panel-cell-inner'],
                                [4, 'ngFor', 'ngForOf'],
                                [1, 'ant-picker-footer'],
                                ['class', 'ant-picker-footer-extra', 4, 'ngIf'],
                                [1, 'ant-picker-ranges'],
                                [1, 'ant-picker-now'],
                                [3, 'click'],
                                [1, 'ant-picker-ok'],
                                ['nz-button', '', 'type', 'button', 'nzSize', 'small', 'nzType', 'primary', 3, 'click'],
                                [1, 'ant-picker-footer-extra'],
                                [3, 'ngTemplateOutlet'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (ue(0, SJ, 3, 1, 'div', 4),
                                    Z(1, 'div', 5),
                                    ue(2, xJ, 3, 2, 'ul', 6)(3, IJ, 3, 2, 'ul', 6)(4, OJ, 3, 2, 'ul', 6)(
                                        5,
                                        PJ,
                                        3,
                                        1,
                                        'ul',
                                        6,
                                    ),
                                    ee(),
                                    ue(6, RJ, 11, 7, 'div', 7)),
                                    2 & i &&
                                        (H('ngIf', r.nzInDatePicker),
                                        z(2),
                                        H('ngIf', r.hourEnabled),
                                        z(),
                                        H('ngIf', r.minuteEnabled),
                                        z(),
                                        H('ngIf', r.secondEnabled),
                                        z(),
                                        H('ngIf', r.nzUse12Hours),
                                        z(),
                                        H('ngIf', !r.nzInDatePicker));
                            },
                            dependencies: [hi, oa, VC, Al, bZ, yZ, MD, Fg, yD, Ng],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return Lt([En()], t.prototype, 'nzUse12Hours', void 0), t;
                })(),
                Lx = (() => {
                    class t {
                        emitValue(e) {
                            this.setValue(e, !0),
                                this._onChange && this._onChange(this.value),
                                this._onTouched && this._onTouched();
                        }
                        setValue(e, i = !1) {
                            i && (this.preValue = a0(e) ? new Date(e) : null),
                                (this.value = a0(e) ? new Date(e) : null),
                                (this.inputValue = this.dateHelper.format(e, this.nzFormat)),
                                this.cdr.markForCheck();
                        }
                        open() {
                            this.nzDisabled ||
                                this.nzOpen ||
                                (this.focus(), (this.nzOpen = !0), this.nzOpenChange.emit(this.nzOpen));
                        }
                        close() {
                            (this.nzOpen = !1), this.cdr.markForCheck(), this.nzOpenChange.emit(this.nzOpen);
                        }
                        updateAutoFocus() {
                            this.isInit &&
                                !this.nzDisabled &&
                                (this.nzAutoFocus
                                    ? this.renderer.setAttribute(this.inputRef.nativeElement, 'autofocus', 'autofocus')
                                    : this.renderer.removeAttribute(this.inputRef.nativeElement, 'autofocus'));
                        }
                        onClickClearBtn(e) {
                            e.stopPropagation(), this.emitValue(null);
                        }
                        onClickOutside(e) {
                            this.element.nativeElement.contains(e.target) || this.setCurrentValueAndClose();
                        }
                        onFocus(e) {
                            (this.focused = e),
                                e ||
                                    (this.checkTimeValid(this.value)
                                        ? this.setCurrentValueAndClose()
                                        : (this.setValue(this.preValue), this.close()));
                        }
                        focus() {
                            this.inputRef.nativeElement && this.inputRef.nativeElement.focus();
                        }
                        blur() {
                            this.inputRef.nativeElement && this.inputRef.nativeElement.blur();
                        }
                        onKeyupEsc() {
                            this.setValue(this.preValue);
                        }
                        onKeyupEnter() {
                            this.nzOpen && a0(this.value) ? this.setCurrentValueAndClose() : this.nzOpen || this.open();
                        }
                        onInputChange(e) {
                            !this.platform.TRIDENT &&
                                document.activeElement === this.inputRef.nativeElement &&
                                (this.open(), this.parseTimeString(e));
                        }
                        onPanelValueChange(e) {
                            this.setValue(e), this.focus();
                        }
                        closePanel() {
                            this.inputRef.nativeElement.blur();
                        }
                        setCurrentValueAndClose() {
                            this.emitValue(this.value), this.close();
                        }
                        constructor(e, i, r, s, o, a, l, c, f, g) {
                            (this.nzConfigService = e),
                                (this.i18n = i),
                                (this.element = r),
                                (this.renderer = s),
                                (this.cdr = o),
                                (this.dateHelper = a),
                                (this.platform = l),
                                (this.directionality = c),
                                (this.nzFormStatusService = f),
                                (this.nzFormNoStatusService = g),
                                (this._nzModuleName = 'timePicker'),
                                (this.destroy$ = new vt()),
                                (this.isNzDisableFirstChange = !0),
                                (this.isInit = !1),
                                (this.focused = !1),
                                (this.inputValue = ''),
                                (this.value = null),
                                (this.preValue = null),
                                (this.i18nPlaceHolder$ = Uo(void 0)),
                                (this.overlayPositions = [
                                    {
                                        offsetY: 3,
                                        originX: 'start',
                                        originY: 'bottom',
                                        overlayX: 'start',
                                        overlayY: 'top',
                                    },
                                    {
                                        offsetY: -3,
                                        originX: 'start',
                                        originY: 'top',
                                        overlayX: 'start',
                                        overlayY: 'bottom',
                                    },
                                    { offsetY: 3, originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
                                    {
                                        offsetY: -3,
                                        originX: 'end',
                                        originY: 'top',
                                        overlayX: 'end',
                                        overlayY: 'bottom',
                                    },
                                ]),
                                (this.dir = 'ltr'),
                                (this.prefixCls = 'ant-picker'),
                                (this.statusCls = {}),
                                (this.status = ''),
                                (this.hasFeedback = !1),
                                (this.nzId = null),
                                (this.nzSize = null),
                                (this.nzStatus = ''),
                                (this.nzHourStep = 1),
                                (this.nzMinuteStep = 1),
                                (this.nzSecondStep = 1),
                                (this.nzClearText = 'löschen'),
                                (this.nzNowText = ''),
                                (this.nzOkText = ''),
                                (this.nzPopupClassName = ''),
                                (this.nzPlaceHolder = ''),
                                (this.nzFormat = 'HH:mm:ss'),
                                (this.nzOpen = !1),
                                (this.nzUse12Hours = !1),
                                (this.nzSuffixIcon = 'clock-circle'),
                                (this.nzOpenChange = new Ft()),
                                (this.nzHideDisabledOptions = !1),
                                (this.nzAllowEmpty = !0),
                                (this.nzDisabled = !1),
                                (this.nzAutoFocus = !1),
                                (this.nzBackdrop = !1),
                                (this.nzBorderless = !1),
                                (this.nzInputReadOnly = !1);
                        }
                        ngOnInit() {
                            this.nzFormStatusService?.formStatusChanges
                                .pipe(
                                    n0((e, i) => e.status === i.status && e.hasFeedback === i.hasFeedback),
                                    wx(this.nzFormNoStatusService ? this.nzFormNoStatusService.noFormStatus : Uo(!1)),
                                    Ct(([{ status: e, hasFeedback: i }, r]) => ({
                                        status: r ? '' : e,
                                        hasFeedback: i,
                                    })),
                                    nn(this.destroy$),
                                )
                                .subscribe(({ status: e, hasFeedback: i }) => {
                                    this.setStatusStyles(e, i);
                                }),
                                (this.inputSize = Math.max(8, this.nzFormat.length) + 2),
                                (this.origin = new _h(this.element)),
                                (this.i18nPlaceHolder$ = this.i18n.localeChange.pipe(
                                    Ct(e => e.TimePicker.placeholder),
                                )),
                                (this.dir = this.directionality.value),
                                this.directionality.change?.pipe(nn(this.destroy$)).subscribe(e => {
                                    this.dir = e;
                                });
                        }
                        ngOnDestroy() {
                            this.destroy$.next(), this.destroy$.complete();
                        }
                        ngOnChanges(e) {
                            const { nzUse12Hours: i, nzFormat: r, nzDisabled: s, nzAutoFocus: o, nzStatus: a } = e;
                            if ((i && !i.previousValue && i.currentValue && !r && (this.nzFormat = 'h:mm:ss a'), s)) {
                                const c = this.inputRef.nativeElement;
                                s.currentValue
                                    ? this.renderer.setAttribute(c, 'disabled', '')
                                    : this.renderer.removeAttribute(c, 'disabled');
                            }
                            o && this.updateAutoFocus(), a && this.setStatusStyles(this.nzStatus, this.hasFeedback);
                        }
                        parseTimeString(e) {
                            const i = this.dateHelper.parseTime(e, this.nzFormat) || null;
                            a0(i) && ((this.value = i), this.cdr.markForCheck());
                        }
                        ngAfterViewInit() {
                            (this.isInit = !0), this.updateAutoFocus();
                        }
                        writeValue(e) {
                            let i;
                            e instanceof Date
                                ? (i = e)
                                : fT(e)
                                ? (i = null)
                                : (ku('Non-Date type is not recommended for time-picker, use "Date" type.'),
                                  (i = new Date(e))),
                                this.setValue(i, !0);
                        }
                        registerOnChange(e) {
                            this._onChange = e;
                        }
                        registerOnTouched(e) {
                            this._onTouched = e;
                        }
                        setDisabledState(e) {
                            (this.nzDisabled = (this.isNzDisableFirstChange && this.nzDisabled) || e),
                                (this.isNzDisableFirstChange = !1),
                                this.cdr.markForCheck();
                        }
                        checkTimeValid(e) {
                            if (!e) return !0;
                            const i = this.nzDisabledHours?.(),
                                r = this.nzDisabledMinutes?.(e.getHours()),
                                s = this.nzDisabledSeconds?.(e.getHours(), e.getMinutes());
                            return !(
                                i?.includes(e.getHours()) ||
                                r?.includes(e.getMinutes()) ||
                                s?.includes(e.getSeconds())
                            );
                        }
                        setStatusStyles(e, i) {
                            (this.status = e),
                                (this.hasFeedback = i),
                                this.cdr.markForCheck(),
                                (this.statusCls = CT(this.prefixCls, e, i)),
                                Object.keys(this.statusCls).forEach(r => {
                                    this.statusCls[r]
                                        ? this.renderer.addClass(this.element.nativeElement, r)
                                        : this.renderer.removeClass(this.element.nativeElement, r);
                                });
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(
                                te(s0),
                                te(zu),
                                te(Pn),
                                te(Ps),
                                te(kr),
                                te(Aa),
                                te(Go),
                                te(yo, 8),
                                te(Rf, 8),
                                te(mD, 8),
                            );
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['nz-time-picker']],
                            viewQuery: function (i, r) {
                                if ((1 & i && Fr(VJ, 7), 2 & i)) {
                                    let s;
                                    Dr((s = xr())) && (r.inputRef = s.first);
                                }
                            },
                            hostAttrs: [1, 'ant-picker'],
                            hostVars: 12,
                            hostBindings: function (i, r) {
                                1 & i &&
                                    Le('click', function () {
                                        return r.open();
                                    }),
                                    2 & i &&
                                        On('ant-picker-large', 'large' === r.nzSize)(
                                            'ant-picker-small',
                                            'small' === r.nzSize,
                                        )('ant-picker-disabled', r.nzDisabled)('ant-picker-focused', r.focused)(
                                            'ant-picker-rtl',
                                            'rtl' === r.dir,
                                        )('ant-picker-borderless', r.nzBorderless);
                            },
                            inputs: {
                                nzId: 'nzId',
                                nzSize: 'nzSize',
                                nzStatus: 'nzStatus',
                                nzHourStep: 'nzHourStep',
                                nzMinuteStep: 'nzMinuteStep',
                                nzSecondStep: 'nzSecondStep',
                                nzClearText: 'nzClearText',
                                nzNowText: 'nzNowText',
                                nzOkText: 'nzOkText',
                                nzPopupClassName: 'nzPopupClassName',
                                nzPlaceHolder: 'nzPlaceHolder',
                                nzAddOn: 'nzAddOn',
                                nzDefaultOpenValue: 'nzDefaultOpenValue',
                                nzDisabledHours: 'nzDisabledHours',
                                nzDisabledMinutes: 'nzDisabledMinutes',
                                nzDisabledSeconds: 'nzDisabledSeconds',
                                nzFormat: 'nzFormat',
                                nzOpen: 'nzOpen',
                                nzUse12Hours: 'nzUse12Hours',
                                nzSuffixIcon: 'nzSuffixIcon',
                                nzHideDisabledOptions: 'nzHideDisabledOptions',
                                nzAllowEmpty: 'nzAllowEmpty',
                                nzDisabled: 'nzDisabled',
                                nzAutoFocus: 'nzAutoFocus',
                                nzBackdrop: 'nzBackdrop',
                                nzBorderless: 'nzBorderless',
                                nzInputReadOnly: 'nzInputReadOnly',
                            },
                            outputs: { nzOpenChange: 'nzOpenChange' },
                            exportAs: ['nzTimePicker'],
                            standalone: !0,
                            features: [$n([{ provide: hs, useExisting: t, multi: !0 }]), D, Qi],
                            decls: 9,
                            vars: 16,
                            consts: [
                                ['inputElement', ''],
                                [1, 'ant-picker-input'],
                                [
                                    'type',
                                    'text',
                                    'autocomplete',
                                    'off',
                                    3,
                                    'ngModelChange',
                                    'focus',
                                    'blur',
                                    'keyup.enter',
                                    'keyup.escape',
                                    'size',
                                    'placeholder',
                                    'ngModel',
                                    'disabled',
                                    'readOnly',
                                ],
                                [1, 'ant-picker-suffix'],
                                [4, 'nzStringTemplateOutlet'],
                                [3, 'status', 4, 'ngIf'],
                                ['class', 'ant-picker-clear', 3, 'click', 4, 'ngIf'],
                                [
                                    'cdkConnectedOverlay',
                                    '',
                                    'nzConnectedOverlay',
                                    '',
                                    3,
                                    'detach',
                                    'overlayOutsideClick',
                                    'cdkConnectedOverlayHasBackdrop',
                                    'cdkConnectedOverlayPositions',
                                    'cdkConnectedOverlayOrigin',
                                    'cdkConnectedOverlayOpen',
                                    'cdkConnectedOverlayTransformOriginOn',
                                ],
                                ['nz-icon', '', 3, 'nzType'],
                                [3, 'status'],
                                [1, 'ant-picker-clear', 3, 'click'],
                                ['nz-icon', '', 'nzType', 'close-circle', 'nzTheme', 'fill'],
                                [1, 'ant-picker-dropdown', 2, 'position', 'relative'],
                                [1, 'ant-picker-panel-container'],
                                ['tabindex', '-1', 1, 'ant-picker-panel'],
                                [
                                    3,
                                    'ngModelChange',
                                    'closePanel',
                                    'ngClass',
                                    'format',
                                    'nzHourStep',
                                    'nzMinuteStep',
                                    'nzSecondStep',
                                    'nzDisabledHours',
                                    'nzDisabledMinutes',
                                    'nzDisabledSeconds',
                                    'nzPlaceHolder',
                                    'nzHideDisabledOptions',
                                    'nzUse12Hours',
                                    'nzDefaultOpenValue',
                                    'nzAddOn',
                                    'nzClearText',
                                    'nzNowText',
                                    'nzOkText',
                                    'nzAllowEmpty',
                                    'ngModel',
                                ],
                            ],
                            template: function (i, r) {
                                if (1 & i) {
                                    const s = st();
                                    Z(0, 'div', 1)(1, 'input', 2, 0),
                                        Gn(3, 'async'),
                                        bi('ngModelChange', function (a) {
                                            return me(s), ki(r.inputValue, a) || (r.inputValue = a), pe(a);
                                        }),
                                        Le('focus', function () {
                                            return me(s), pe(r.onFocus(!0));
                                        })('blur', function () {
                                            return me(s), pe(r.onFocus(!1));
                                        })('keyup.enter', function () {
                                            return me(s), pe(r.onKeyupEnter());
                                        })('keyup.escape', function () {
                                            return me(s), pe(r.onKeyupEsc());
                                        })('ngModelChange', function (a) {
                                            return me(s), pe(r.onInputChange(a));
                                        }),
                                        ee(),
                                        Z(4, 'span', 3),
                                        ue(5, HJ, 2, 1, 'ng-container', 4)(
                                            6,
                                            UJ,
                                            1,
                                            1,
                                            'nz-form-item-feedback-icon',
                                            5,
                                        ),
                                        ee(),
                                        ue(7, BJ, 2, 2, 'span', 6),
                                        ee(),
                                        ue(8, qJ, 5, 21, 'ng-template', 7),
                                        Le('detach', function () {
                                            return me(s), pe(r.close());
                                        })('overlayOutsideClick', function (a) {
                                            return me(s), pe(r.onClickOutside(a));
                                        });
                                }
                                2 & i &&
                                    (z(),
                                    H('size', r.inputSize)(
                                        'placeholder',
                                        r.nzPlaceHolder || ci(3, 14, r.i18nPlaceHolder$),
                                    ),
                                    yi('ngModel', r.inputValue),
                                    H('disabled', r.nzDisabled)('readOnly', r.nzInputReadOnly),
                                    zi('id', r.nzId),
                                    z(4),
                                    H('nzStringTemplateOutlet', r.nzSuffixIcon),
                                    z(),
                                    H('ngIf', r.hasFeedback && !!r.status),
                                    z(),
                                    H('ngIf', r.nzAllowEmpty && !r.nzDisabled && r.value),
                                    z(),
                                    H('cdkConnectedOverlayHasBackdrop', r.nzBackdrop)(
                                        'cdkConnectedOverlayPositions',
                                        r.overlayPositions,
                                    )('cdkConnectedOverlayOrigin', r.origin)('cdkConnectedOverlayOpen', r.nzOpen)(
                                        'cdkConnectedOverlayTransformOriginOn',
                                        '.ant-picker-dropdown',
                                    ));
                            },
                            dependencies: [NC, nh, xa, eo, Fs, bh, yh, o0, xc, gD, pD, hi, t5, sl, Xf, Qf, Zg, u0],
                            encapsulation: 2,
                            data: { animation: [Mx] },
                            changeDetection: 0,
                        }));
                    }
                    return (
                        Lt([fs()], t.prototype, 'nzHourStep', void 0),
                        Lt([fs()], t.prototype, 'nzMinuteStep', void 0),
                        Lt([fs()], t.prototype, 'nzSecondStep', void 0),
                        Lt([fs()], t.prototype, 'nzClearText', void 0),
                        Lt([fs()], t.prototype, 'nzNowText', void 0),
                        Lt([fs()], t.prototype, 'nzOkText', void 0),
                        Lt([fs()], t.prototype, 'nzPopupClassName', void 0),
                        Lt([fs()], t.prototype, 'nzFormat', void 0),
                        Lt([fs(), En()], t.prototype, 'nzUse12Hours', void 0),
                        Lt([fs()], t.prototype, 'nzSuffixIcon', void 0),
                        Lt([En()], t.prototype, 'nzHideDisabledOptions', void 0),
                        Lt([fs(), En()], t.prototype, 'nzAllowEmpty', void 0),
                        Lt([En()], t.prototype, 'nzDisabled', void 0),
                        Lt([En()], t.prototype, 'nzAutoFocus', void 0),
                        Lt([fs()], t.prototype, 'nzBackdrop', void 0),
                        Lt([En()], t.prototype, 'nzBorderless', void 0),
                        Lt([En()], t.prototype, 'nzInputReadOnly', void 0),
                        t
                    );
                })(),
                Ox = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [Lx, t5] }));
                    }
                    return t;
                })(),
                $J = (() => {
                    class t {
                        create(e) {
                            return typeof ResizeObserver > 'u' ? null : new ResizeObserver(e);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })(),
                GJ = (() => {
                    class t {
                        constructor(e) {
                            (this.nzResizeObserverFactory = e), (this.observedElements = new Map());
                        }
                        ngOnDestroy() {
                            this.observedElements.forEach((e, i) => this.cleanupObserver(i));
                        }
                        observe(e) {
                            const i = dh(e);
                            return new Tn(r => {
                                const o = this.observeElement(i).subscribe(r);
                                return () => {
                                    o.unsubscribe(), this.unobserveElement(i);
                                };
                            });
                        }
                        observeElement(e) {
                            if (this.observedElements.has(e)) this.observedElements.get(e).count++;
                            else {
                                const i = new vt(),
                                    r = this.nzResizeObserverFactory.create(s => i.next(s));
                                r && r.observe(e), this.observedElements.set(e, { observer: r, stream: i, count: 1 });
                            }
                            return this.observedElements.get(e).stream;
                        }
                        unobserveElement(e) {
                            this.observedElements.has(e) &&
                                (this.observedElements.get(e).count--,
                                this.observedElements.get(e).count || this.cleanupObserver(e));
                        }
                        cleanupObserver(e) {
                            if (this.observedElements.has(e)) {
                                const { observer: i, stream: r } = this.observedElements.get(e);
                                i && i.disconnect(), r.complete(), this.observedElements.delete(e);
                            }
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(Se($J));
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })();
            function WJ(t, n) {
                1 & t && Pi(0);
            }
            function KJ(t, n) {
                1 & t && ue(0, WJ, 1, 0, 'ng-container', 3), 2 & t && H('ngTemplateOutlet', L(2).extraFooter);
            }
            function QJ(t, n) {
                1 & t && Oe(0, 'span', 2), 2 & t && H('innerHTML', L(2).extraFooter, No);
            }
            function XJ(t, n) {
                if ((1 & t && (Z(0, 'div'), ue(1, KJ, 1, 1, 'ng-container')(2, QJ, 1, 1, 'span', 2), ee()), 2 & t)) {
                    const e = L();
                    dt('', e.prefixCls, '-footer-extra'),
                        z(),
                        dn(1, e.isExtraFooterTemplateRef ? 1 : -1),
                        z(),
                        dn(2, e.isExtraFooterNonEmptyString ? 2 : -1);
                }
            }
            function ZJ(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'a', 4),
                        Le('click', function () {
                            me(e);
                            const r = L();
                            return pe(r.isTodayDisabled ? null : r.onClickToday());
                        }),
                        Je(1),
                        ee();
                }
                if (2 & t) {
                    const e = L();
                    F1(
                        '',
                        e.prefixCls,
                        '-today-btn ',
                        e.isTodayDisabled ? e.prefixCls + '-today-btn-disabled' : '',
                        '',
                    ),
                        ct('title', e.todayTitle),
                        z(),
                        jn(' ', e.locale.today, ' ');
                }
            }
            function JJ(t, n) {
                1 & t && Pi(0);
            }
            function eee(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'li')(1, 'a', 5),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.isTodayDisabled ? null : r.onClickToday());
                        }),
                        Je(2),
                        ee()();
                }
                if (2 & t) {
                    const e = L(2);
                    dt('', e.prefixCls, '-now'), z(), dt('', e.prefixCls, '-now-btn'), z(), jn(' ', e.locale.now, ' ');
                }
            }
            function tee(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'li')(1, 'button', 6),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.okDisabled ? null : r.clickOk.emit());
                        }),
                        Je(2),
                        ee()();
                }
                if (2 & t) {
                    const e = L(2);
                    dt('', e.prefixCls, '-ok'), z(), H('disabled', e.okDisabled), z(), jn(' ', e.locale.ok, ' ');
                }
            }
            function nee(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'ul'),
                        ue(1, JJ, 1, 0, 'ng-container', 3)(2, eee, 3, 7, 'li', 0)(3, tee, 3, 5, 'li', 0),
                        ee()),
                    2 & t)
                ) {
                    const e = L();
                    dt('', e.prefixCls, '-ranges'),
                        z(),
                        H('ngTemplateOutlet', e.rangeQuickSelector),
                        z(),
                        dn(2, e.showNow ? 2 : -1),
                        z(),
                        dn(3, e.hasTimePicker ? 3 : -1);
                }
            }
            function iee(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 6),
                        Le('click', function () {
                            return pe(me(e).$implicit.onClick());
                        }),
                        Je(1),
                        ee();
                }
                if (2 & t) {
                    const e = n.$implicit;
                    vo(e.className), ct('title', e.title || null), z(), jn(' ', e.label, ' ');
                }
            }
            const Ac = (t, n) => n.trackByIndex,
                ua = t => ({ $implicit: t });
            function ree(t, n) {
                1 & t && Oe(0, 'th', 3);
            }
            function see(t, n) {
                if ((1 & t && (Z(0, 'th', 4), Je(1), ee()), 2 & t)) {
                    const e = n.$implicit;
                    ct('title', e.title), z(), jn(' ', e.content, ' ');
                }
            }
            function oee(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'thead')(1, 'tr', 2), ue(2, ree, 1, 0, 'th', 3), Jr(3, see, 2, 2, 'th', 4, rl), ee()()),
                    2 & t)
                ) {
                    const e = L();
                    z(2), dn(2, e.showWeek ? 2 : -1), z(), es(e.headRow);
                }
            }
            function aee(t, n) {
                if ((1 & t && (Z(0, 'td', 7), Je(1), ee()), 2 & t)) {
                    const e = L().$implicit;
                    dt('', L().prefixCls, '-cell-week'), z(), jn(' ', e.weekNum, ' ');
                }
            }
            function lee(t, n) {
                1 & t && Pi(0);
            }
            function cee(t, n) {
                if ((1 & t && ue(0, lee, 1, 0, 'ng-container', 9), 2 & t)) {
                    const e = L(2).$implicit;
                    H('ngTemplateOutlet', e.cellRender)('ngTemplateOutletContext', us(2, ua, e.value));
                }
            }
            function uee(t, n) {
                1 & t && Oe(0, 'span', 10), 2 & t && H('innerHTML', L(2).$implicit.cellRender, No);
            }
            function dee(t, n) {
                if ((1 & t && (Z(0, 'div'), Je(1), ee()), 2 & t)) {
                    const e = L(2).$implicit;
                    dt('', L(2).prefixCls, '-cell-inner'),
                        zi('aria-selected', e.isSelected)('aria-disabled', e.isDisabled),
                        z(),
                        jn(' ', e.content, ' ');
                }
            }
            function hee(t, n) {
                if ((1 & t && ue(0, cee, 1, 4, 'ng-container')(1, uee, 1, 1)(2, dee, 2, 6), 2 & t)) {
                    const e = L().$implicit;
                    dn(0, e.isTemplateRef ? 0 : e.isNonEmptyString ? 1 : 2);
                }
            }
            function fee(t, n) {
                1 & t && Pi(0);
            }
            function mee(t, n) {
                if ((1 & t && ue(0, fee, 1, 0, 'ng-container', 9), 2 & t)) {
                    const e = L(2).$implicit;
                    H('ngTemplateOutlet', e.fullCellRender)('ngTemplateOutletContext', us(2, ua, e.value));
                }
            }
            function pee(t, n) {
                1 & t && Pi(0);
            }
            function gee(t, n) {
                if (
                    (1 & t && (Z(0, 'div'), Je(1), ee(), Z(2, 'div'), ue(3, pee, 1, 0, 'ng-container', 9), ee()), 2 & t)
                ) {
                    const e = L(2).$implicit,
                        i = L(2);
                    dt('', i.prefixCls, '-date-value'),
                        z(),
                        hn(e.content),
                        z(),
                        dt('', i.prefixCls, '-date-content'),
                        z(),
                        H('ngTemplateOutlet', e.cellRender)('ngTemplateOutletContext', us(9, ua, e.value));
                }
            }
            function vee(t, n) {
                if ((1 & t && (Z(0, 'div'), ue(1, mee, 1, 4, 'ng-container')(2, gee, 4, 11), ee()), 2 & t)) {
                    const e = L().$implicit;
                    dt('', L(2).prefixCls, '-date ant-picker-cell-inner'),
                        On('ant-picker-calendar-date-today', e.isToday),
                        z(),
                        dn(1, e.fullCellRender ? 1 : 2);
                }
            }
            function _ee(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'td', 8),
                        Le('click', function () {
                            const r = me(e).$implicit;
                            return pe(r.isDisabled ? null : r.onClick());
                        })('mouseenter', function () {
                            return pe(me(e).$implicit.onMouseEnter());
                        }),
                        ue(1, hee, 3, 1)(2, vee, 3, 6),
                        ee();
                }
                if (2 & t) {
                    let e;
                    const i = n.$implicit,
                        r = L(2);
                    ct('title', i.title),
                        H('ngClass', i.classMap),
                        z(),
                        dn(1, 'ant-picker' === (e = r.prefixCls) ? 1 : 'ant-picker-calendar' === e ? 2 : -1);
                }
            }
            function yee(t, n) {
                if ((1 & t && (Z(0, 'tr', 1), ue(1, aee, 2, 4, 'td', 5), Jr(2, _ee, 3, 3, 'td', 6, Ac), ee()), 2 & t)) {
                    const e = n.$implicit;
                    H('ngClass', e.classMap), z(), dn(1, e.weekNum ? 1 : -1), z(), es(e.dateCells);
                }
            }
            function bee(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 6),
                        Le('click', function () {
                            return pe(me(e).$implicit.onClick());
                        }),
                        Je(1),
                        ee();
                }
                if (2 & t) {
                    const e = n.$implicit;
                    vo(e.className), ct('title', e.title || null), z(), jn(' ', e.label, ' ');
                }
            }
            function Cee(t, n) {
                1 & t && Oe(0, 'th', 3);
            }
            function wee(t, n) {
                if ((1 & t && (Z(0, 'th', 4), Je(1), ee()), 2 & t)) {
                    const e = n.$implicit;
                    ct('title', e.title), z(), jn(' ', e.content, ' ');
                }
            }
            function Mee(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'thead')(1, 'tr', 2), ue(2, Cee, 1, 0, 'th', 3), Jr(3, wee, 2, 2, 'th', 4, rl), ee()()),
                    2 & t)
                ) {
                    const e = L();
                    z(2), dn(2, e.showWeek ? 2 : -1), z(), es(e.headRow);
                }
            }
            function See(t, n) {
                if ((1 & t && (Z(0, 'td', 7), Je(1), ee()), 2 & t)) {
                    const e = L().$implicit;
                    dt('', L().prefixCls, '-cell-week'), z(), jn(' ', e.weekNum, ' ');
                }
            }
            function Tee(t, n) {
                1 & t && Pi(0);
            }
            function Dee(t, n) {
                if ((1 & t && ue(0, Tee, 1, 0, 'ng-container', 9), 2 & t)) {
                    const e = L(2).$implicit;
                    H('ngTemplateOutlet', e.cellRender)('ngTemplateOutletContext', us(2, ua, e.value));
                }
            }
            function xee(t, n) {
                1 & t && Oe(0, 'span', 10), 2 & t && H('innerHTML', L(2).$implicit.cellRender, No);
            }
            function kee(t, n) {
                if ((1 & t && (Z(0, 'div'), Je(1), ee()), 2 & t)) {
                    const e = L(2).$implicit;
                    dt('', L(2).prefixCls, '-cell-inner'),
                        zi('aria-selected', e.isSelected)('aria-disabled', e.isDisabled),
                        z(),
                        jn(' ', e.content, ' ');
                }
            }
            function Eee(t, n) {
                if ((1 & t && ue(0, Dee, 1, 4, 'ng-container')(1, xee, 1, 1)(2, kee, 2, 6), 2 & t)) {
                    const e = L().$implicit;
                    dn(0, e.isTemplateRef ? 0 : e.isNonEmptyString ? 1 : 2);
                }
            }
            function Iee(t, n) {
                1 & t && Pi(0);
            }
            function Aee(t, n) {
                if ((1 & t && ue(0, Iee, 1, 0, 'ng-container', 9), 2 & t)) {
                    const e = L(2).$implicit;
                    H('ngTemplateOutlet', e.fullCellRender)('ngTemplateOutletContext', us(2, ua, e.value));
                }
            }
            function Lee(t, n) {
                1 & t && Pi(0);
            }
            function Oee(t, n) {
                if (
                    (1 & t && (Z(0, 'div'), Je(1), ee(), Z(2, 'div'), ue(3, Lee, 1, 0, 'ng-container', 9), ee()), 2 & t)
                ) {
                    const e = L(2).$implicit,
                        i = L(2);
                    dt('', i.prefixCls, '-date-value'),
                        z(),
                        hn(e.content),
                        z(),
                        dt('', i.prefixCls, '-date-content'),
                        z(),
                        H('ngTemplateOutlet', e.cellRender)('ngTemplateOutletContext', us(9, ua, e.value));
                }
            }
            function zee(t, n) {
                if ((1 & t && (Z(0, 'div'), ue(1, Aee, 1, 4, 'ng-container')(2, Oee, 4, 11), ee()), 2 & t)) {
                    const e = L().$implicit;
                    dt('', L(2).prefixCls, '-date ant-picker-cell-inner'),
                        On('ant-picker-calendar-date-today', e.isToday),
                        z(),
                        dn(1, e.fullCellRender ? 1 : 2);
                }
            }
            function Pee(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'td', 8),
                        Le('click', function () {
                            const r = me(e).$implicit;
                            return pe(r.isDisabled ? null : r.onClick());
                        })('mouseenter', function () {
                            return pe(me(e).$implicit.onMouseEnter());
                        }),
                        ue(1, Eee, 3, 1)(2, zee, 3, 6),
                        ee();
                }
                if (2 & t) {
                    let e;
                    const i = n.$implicit,
                        r = L(2);
                    ct('title', i.title),
                        H('ngClass', i.classMap),
                        z(),
                        dn(1, 'ant-picker' === (e = r.prefixCls) ? 1 : 'ant-picker-calendar' === e ? 2 : -1);
                }
            }
            function Nee(t, n) {
                if ((1 & t && (Z(0, 'tr', 1), ue(1, See, 2, 4, 'td', 5), Jr(2, Pee, 3, 3, 'td', 6, Ac), ee()), 2 & t)) {
                    const e = n.$implicit;
                    H('ngClass', e.classMap), z(), dn(1, e.weekNum ? 1 : -1), z(), es(e.dateCells);
                }
            }
            function Fee(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 6),
                        Le('click', function () {
                            return pe(me(e).$implicit.onClick());
                        }),
                        Je(1),
                        ee();
                }
                if (2 & t) {
                    const e = n.$implicit;
                    vo(e.className), ct('title', e.title || null), z(), jn(' ', e.label, ' ');
                }
            }
            function Ree(t, n) {
                1 & t && Oe(0, 'th', 3);
            }
            function Vee(t, n) {
                if ((1 & t && (Z(0, 'th', 4), Je(1), ee()), 2 & t)) {
                    const e = n.$implicit;
                    ct('title', e.title), z(), jn(' ', e.content, ' ');
                }
            }
            function Hee(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'thead')(1, 'tr', 2), ue(2, Ree, 1, 0, 'th', 3), Jr(3, Vee, 2, 2, 'th', 4, rl), ee()()),
                    2 & t)
                ) {
                    const e = L();
                    z(2), dn(2, e.showWeek ? 2 : -1), z(), es(e.headRow);
                }
            }
            function Uee(t, n) {
                if ((1 & t && (Z(0, 'td', 7), Je(1), ee()), 2 & t)) {
                    const e = L().$implicit;
                    dt('', L().prefixCls, '-cell-week'), z(), jn(' ', e.weekNum, ' ');
                }
            }
            function Bee(t, n) {
                1 & t && Pi(0);
            }
            function qee(t, n) {
                if ((1 & t && ue(0, Bee, 1, 0, 'ng-container', 9), 2 & t)) {
                    const e = L(2).$implicit;
                    H('ngTemplateOutlet', e.cellRender)('ngTemplateOutletContext', us(2, ua, e.value));
                }
            }
            function Yee(t, n) {
                1 & t && Oe(0, 'span', 10), 2 & t && H('innerHTML', L(2).$implicit.cellRender, No);
            }
            function jee(t, n) {
                if ((1 & t && (Z(0, 'div'), Je(1), ee()), 2 & t)) {
                    const e = L(2).$implicit;
                    dt('', L(2).prefixCls, '-cell-inner'),
                        zi('aria-selected', e.isSelected)('aria-disabled', e.isDisabled),
                        z(),
                        jn(' ', e.content, ' ');
                }
            }
            function $ee(t, n) {
                if ((1 & t && ue(0, qee, 1, 4, 'ng-container')(1, Yee, 1, 1)(2, jee, 2, 6), 2 & t)) {
                    const e = L().$implicit;
                    dn(0, e.isTemplateRef ? 0 : e.isNonEmptyString ? 1 : 2);
                }
            }
            function Gee(t, n) {
                1 & t && Pi(0);
            }
            function Wee(t, n) {
                if ((1 & t && ue(0, Gee, 1, 0, 'ng-container', 9), 2 & t)) {
                    const e = L(2).$implicit;
                    H('ngTemplateOutlet', e.fullCellRender)('ngTemplateOutletContext', us(2, ua, e.value));
                }
            }
            function Kee(t, n) {
                1 & t && Pi(0);
            }
            function Qee(t, n) {
                if (
                    (1 & t && (Z(0, 'div'), Je(1), ee(), Z(2, 'div'), ue(3, Kee, 1, 0, 'ng-container', 9), ee()), 2 & t)
                ) {
                    const e = L(2).$implicit,
                        i = L(2);
                    dt('', i.prefixCls, '-date-value'),
                        z(),
                        hn(e.content),
                        z(),
                        dt('', i.prefixCls, '-date-content'),
                        z(),
                        H('ngTemplateOutlet', e.cellRender)('ngTemplateOutletContext', us(9, ua, e.value));
                }
            }
            function Xee(t, n) {
                if ((1 & t && (Z(0, 'div'), ue(1, Wee, 1, 4, 'ng-container')(2, Qee, 4, 11), ee()), 2 & t)) {
                    const e = L().$implicit;
                    dt('', L(2).prefixCls, '-date ant-picker-cell-inner'),
                        On('ant-picker-calendar-date-today', e.isToday),
                        z(),
                        dn(1, e.fullCellRender ? 1 : 2);
                }
            }
            function Zee(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'td', 8),
                        Le('click', function () {
                            const r = me(e).$implicit;
                            return pe(r.isDisabled ? null : r.onClick());
                        })('mouseenter', function () {
                            return pe(me(e).$implicit.onMouseEnter());
                        }),
                        ue(1, $ee, 3, 1)(2, Xee, 3, 6),
                        ee();
                }
                if (2 & t) {
                    let e;
                    const i = n.$implicit,
                        r = L(2);
                    ct('title', i.title),
                        H('ngClass', i.classMap),
                        z(),
                        dn(1, 'ant-picker' === (e = r.prefixCls) ? 1 : 'ant-picker-calendar' === e ? 2 : -1);
                }
            }
            function Jee(t, n) {
                if ((1 & t && (Z(0, 'tr', 1), ue(1, Uee, 2, 4, 'td', 5), Jr(2, Zee, 3, 3, 'td', 6, Ac), ee()), 2 & t)) {
                    const e = n.$implicit;
                    H('ngClass', e.classMap), z(), dn(1, e.weekNum ? 1 : -1), z(), es(e.dateCells);
                }
            }
            function ete(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 6),
                        Le('click', function () {
                            return pe(me(e).$implicit.onClick());
                        }),
                        Je(1),
                        ee();
                }
                if (2 & t) {
                    const e = n.$implicit;
                    vo(e.className), ct('title', e.title || null), z(), jn(' ', e.label, ' ');
                }
            }
            function tte(t, n) {
                1 & t && Oe(0, 'th', 3);
            }
            function nte(t, n) {
                if ((1 & t && (Z(0, 'th', 4), Je(1), ee()), 2 & t)) {
                    const e = n.$implicit;
                    ct('title', e.title), z(), jn(' ', e.content, ' ');
                }
            }
            function ite(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'thead')(1, 'tr', 2), ue(2, tte, 1, 0, 'th', 3), Jr(3, nte, 2, 2, 'th', 4, rl), ee()()),
                    2 & t)
                ) {
                    const e = L();
                    z(2), dn(2, e.showWeek ? 2 : -1), z(), es(e.headRow);
                }
            }
            function rte(t, n) {
                if ((1 & t && (Z(0, 'td', 7), Je(1), ee()), 2 & t)) {
                    const e = L().$implicit;
                    dt('', L().prefixCls, '-cell-week'), z(), jn(' ', e.weekNum, ' ');
                }
            }
            function ste(t, n) {
                1 & t && Pi(0);
            }
            function ote(t, n) {
                if ((1 & t && ue(0, ste, 1, 0, 'ng-container', 9), 2 & t)) {
                    const e = L(2).$implicit;
                    H('ngTemplateOutlet', e.cellRender)('ngTemplateOutletContext', us(2, ua, e.value));
                }
            }
            function ate(t, n) {
                1 & t && Oe(0, 'span', 10), 2 & t && H('innerHTML', L(2).$implicit.cellRender, No);
            }
            function lte(t, n) {
                if ((1 & t && (Z(0, 'div'), Je(1), ee()), 2 & t)) {
                    const e = L(2).$implicit;
                    dt('', L(2).prefixCls, '-cell-inner'),
                        zi('aria-selected', e.isSelected)('aria-disabled', e.isDisabled),
                        z(),
                        jn(' ', e.content, ' ');
                }
            }
            function cte(t, n) {
                if ((1 & t && ue(0, ote, 1, 4, 'ng-container')(1, ate, 1, 1)(2, lte, 2, 6), 2 & t)) {
                    const e = L().$implicit;
                    dn(0, e.isTemplateRef ? 0 : e.isNonEmptyString ? 1 : 2);
                }
            }
            function ute(t, n) {
                1 & t && Pi(0);
            }
            function dte(t, n) {
                if ((1 & t && ue(0, ute, 1, 0, 'ng-container', 9), 2 & t)) {
                    const e = L(2).$implicit;
                    H('ngTemplateOutlet', e.fullCellRender)('ngTemplateOutletContext', us(2, ua, e.value));
                }
            }
            function hte(t, n) {
                1 & t && Pi(0);
            }
            function fte(t, n) {
                if (
                    (1 & t && (Z(0, 'div'), Je(1), ee(), Z(2, 'div'), ue(3, hte, 1, 0, 'ng-container', 9), ee()), 2 & t)
                ) {
                    const e = L(2).$implicit,
                        i = L(2);
                    dt('', i.prefixCls, '-date-value'),
                        z(),
                        hn(e.content),
                        z(),
                        dt('', i.prefixCls, '-date-content'),
                        z(),
                        H('ngTemplateOutlet', e.cellRender)('ngTemplateOutletContext', us(9, ua, e.value));
                }
            }
            function mte(t, n) {
                if ((1 & t && (Z(0, 'div'), ue(1, dte, 1, 4, 'ng-container')(2, fte, 4, 11), ee()), 2 & t)) {
                    const e = L().$implicit;
                    dt('', L(2).prefixCls, '-date ant-picker-cell-inner'),
                        On('ant-picker-calendar-date-today', e.isToday),
                        z(),
                        dn(1, e.fullCellRender ? 1 : 2);
                }
            }
            function pte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'td', 8),
                        Le('click', function () {
                            const r = me(e).$implicit;
                            return pe(r.isDisabled ? null : r.onClick());
                        })('mouseenter', function () {
                            return pe(me(e).$implicit.onMouseEnter());
                        }),
                        ue(1, cte, 3, 1)(2, mte, 3, 6),
                        ee();
                }
                if (2 & t) {
                    let e;
                    const i = n.$implicit,
                        r = L(2);
                    ct('title', i.title),
                        H('ngClass', i.classMap),
                        z(),
                        dn(1, 'ant-picker' === (e = r.prefixCls) ? 1 : 'ant-picker-calendar' === e ? 2 : -1);
                }
            }
            function gte(t, n) {
                if ((1 & t && (Z(0, 'tr', 1), ue(1, rte, 2, 4, 'td', 5), Jr(2, pte, 3, 3, 'td', 6, Ac), ee()), 2 & t)) {
                    const e = n.$implicit;
                    H('ngClass', e.classMap), z(), dn(1, e.weekNum ? 1 : -1), z(), es(e.dateCells);
                }
            }
            function vte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'decade-header', 1),
                        bi('valueChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.activeDate, r) || (s.activeDate = r), pe(r);
                        }),
                        Le('panelModeChange', function (r) {
                            return me(e), pe(L().panelModeChange.emit(r));
                        })('valueChange', function (r) {
                            return me(e), pe(L().headerChange.emit(r));
                        }),
                        ee(),
                        Z(1, 'div')(2, 'decade-table', 2),
                        Le('valueChange', function (r) {
                            return me(e), pe(L().onChooseDecade(r));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    yi('value', e.activeDate),
                        H('locale', e.locale)('showSuperPreBtn', e.enablePrevNext('prev', 'decade'))(
                            'showSuperNextBtn',
                            e.enablePrevNext('next', 'decade'),
                        )('showNextBtn', !1)('showPreBtn', !1),
                        z(),
                        dt('', e.prefixCls, '-body'),
                        z(),
                        H('activeDate', e.activeDate)('value', e.value)('locale', e.locale)(
                            'disabledDate',
                            e.disabledDate,
                        );
                }
            }
            function _te(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'year-header', 1),
                        bi('valueChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.activeDate, r) || (s.activeDate = r), pe(r);
                        }),
                        Le('panelModeChange', function (r) {
                            return me(e), pe(L().panelModeChange.emit(r));
                        })('valueChange', function (r) {
                            return me(e), pe(L().headerChange.emit(r));
                        }),
                        ee(),
                        Z(1, 'div')(2, 'year-table', 3),
                        Le('valueChange', function (r) {
                            return me(e), pe(L().onChooseYear(r));
                        })('cellHover', function (r) {
                            return me(e), pe(L().cellHover.emit(r));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    yi('value', e.activeDate),
                        H('locale', e.locale)('showSuperPreBtn', e.enablePrevNext('prev', 'year'))(
                            'showSuperNextBtn',
                            e.enablePrevNext('next', 'year'),
                        )('showNextBtn', !1)('showPreBtn', !1),
                        z(),
                        dt('', e.prefixCls, '-body'),
                        z(),
                        H('activeDate', e.activeDate)('value', e.value)('locale', e.locale)(
                            'disabledDate',
                            e.disabledDate,
                        )('selectedValue', e.selectedValue)('hoverValue', e.hoverValue);
                }
            }
            function yte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'month-header', 1),
                        bi('valueChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.activeDate, r) || (s.activeDate = r), pe(r);
                        }),
                        Le('panelModeChange', function (r) {
                            return me(e), pe(L().panelModeChange.emit(r));
                        })('valueChange', function (r) {
                            return me(e), pe(L().headerChange.emit(r));
                        }),
                        ee(),
                        Z(1, 'div')(2, 'month-table', 4),
                        Le('valueChange', function (r) {
                            return me(e), pe(L().onChooseMonth(r));
                        })('cellHover', function (r) {
                            return me(e), pe(L().cellHover.emit(r));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    yi('value', e.activeDate),
                        H('locale', e.locale)('showSuperPreBtn', e.enablePrevNext('prev', 'month'))(
                            'showSuperNextBtn',
                            e.enablePrevNext('next', 'month'),
                        )('showNextBtn', !1)('showPreBtn', !1),
                        z(),
                        dt('', e.prefixCls, '-body'),
                        z(),
                        H('value', e.value)('activeDate', e.activeDate)('locale', e.locale)(
                            'disabledDate',
                            e.disabledDate,
                        )('selectedValue', e.selectedValue)('hoverValue', e.hoverValue);
                }
            }
            function bte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'date-header', 5),
                        bi('valueChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.activeDate, r) || (s.activeDate = r), pe(r);
                        }),
                        Le('panelModeChange', function (r) {
                            return me(e), pe(L().panelModeChange.emit(r));
                        })('valueChange', function (r) {
                            return me(e), pe(L().headerChange.emit(r));
                        }),
                        ee(),
                        Z(1, 'div')(2, 'date-table', 6),
                        Le('valueChange', function (r) {
                            return me(e), pe(L().onSelectDate(r));
                        })('cellHover', function (r) {
                            return me(e), pe(L().cellHover.emit(r));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    yi('value', e.activeDate),
                        H('locale', e.locale)(
                            'showSuperPreBtn',
                            e.enablePrevNext('prev', 'week' === e.panelMode ? 'week' : 'date'),
                        )('showSuperNextBtn', e.enablePrevNext('next', 'week' === e.panelMode ? 'week' : 'date'))(
                            'showPreBtn',
                            e.enablePrevNext('prev', 'week' === e.panelMode ? 'week' : 'date'),
                        )('showNextBtn', e.enablePrevNext('next', 'week' === e.panelMode ? 'week' : 'date')),
                        z(),
                        dt('', e.prefixCls, '-body'),
                        z(),
                        H('locale', e.locale)('showWeek', e.showWeek)('value', e.value)('activeDate', e.activeDate)(
                            'disabledDate',
                            e.disabledDate,
                        )('cellRender', e.dateRender)('selectedValue', e.selectedValue)('hoverValue', e.hoverValue)(
                            'canSelectWeek',
                            'week' === e.panelMode,
                        );
                }
            }
            function Cte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'nz-time-picker-panel', 7),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onSelectTime(r));
                        }),
                        ee();
                }
                if (2 & t) {
                    const e = L();
                    H('nzInDatePicker', !0)('ngModel', null == e.value ? null : e.value.nativeDate)(
                        'format',
                        e.timeOptions.nzFormat,
                    )('nzHourStep', e.timeOptions.nzHourStep)('nzMinuteStep', e.timeOptions.nzMinuteStep)(
                        'nzSecondStep',
                        e.timeOptions.nzSecondStep,
                    )('nzDisabledHours', e.timeOptions.nzDisabledHours)(
                        'nzDisabledMinutes',
                        e.timeOptions.nzDisabledMinutes,
                    )('nzDisabledSeconds', e.timeOptions.nzDisabledSeconds)(
                        'nzHideDisabledOptions',
                        !!e.timeOptions.nzHideDisabledOptions,
                    )('nzDefaultOpenValue', e.timeOptions.nzDefaultOpenValue)(
                        'nzUse12Hours',
                        !!e.timeOptions.nzUse12Hours,
                    )('nzAddOn', e.timeOptions.nzAddOn);
                }
            }
            const wte = t => ({ partType: t }),
                zx = () => ({ partType: 'left' }),
                Px = () => ({ partType: 'right' });
            function Mte(t, n) {
                1 & t && Pi(0);
            }
            function Ste(t, n) {
                if ((1 & t && ue(0, Mte, 1, 0, 'ng-container', 6), 2 & t)) {
                    const e = L(2);
                    H('ngTemplateOutlet', ts(3))(
                        'ngTemplateOutletContext',
                        us(2, wte, e.datePickerService.activeInput),
                    );
                }
            }
            function Tte(t, n) {
                1 & t && Pi(0);
            }
            function Dte(t, n) {
                1 & t && Pi(0);
            }
            function xte(t, n) {
                if ((1 & t && ue(0, Tte, 1, 0, 'ng-container', 6)(1, Dte, 1, 0, 'ng-container', 6), 2 & t)) {
                    L(2);
                    const e = ts(3);
                    H('ngTemplateOutlet', e)('ngTemplateOutletContext', B1(4, zx)),
                        z(),
                        H('ngTemplateOutlet', e)('ngTemplateOutletContext', B1(5, Px));
                }
            }
            function kte(t, n) {
                1 & t && Pi(0);
            }
            function Ete(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'div'),
                        Oe(1, 'div', 4),
                        Z(2, 'div')(3, 'div'),
                        ue(4, Ste, 1, 4, 'ng-container')(5, xte, 2, 6),
                        ee(),
                        ue(6, kte, 1, 0, 'ng-container', 5),
                        ee()()),
                    2 & t)
                ) {
                    const e = L(),
                        i = ts(5);
                    F1('', e.prefixCls, '-range-wrapper ', e.prefixCls, '-date-range-wrapper'),
                        z(),
                        dt('', e.prefixCls, '-range-arrow'),
                        H('ngStyle', e.arrowPosition),
                        z(),
                        F1('', e.prefixCls, '-panel-container ', e.showWeek ? e.prefixCls + '-week-number' : '', ''),
                        z(),
                        dt('', e.prefixCls, '-panels'),
                        z(),
                        dn(4, e.hasTimePicker ? 4 : 5),
                        z(2),
                        H('ngTemplateOutlet', i);
                }
            }
            function Ite(t, n) {
                1 & t && Pi(0);
            }
            function Ate(t, n) {
                1 & t && Pi(0);
            }
            function Lte(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'div')(1, 'div', 7),
                        ue(2, Ite, 1, 0, 'ng-container', 5)(3, Ate, 1, 0, 'ng-container', 5),
                        ee()()),
                    2 & t)
                ) {
                    const e = L(),
                        i = ts(3),
                        r = ts(5);
                    (function F_(t, n, e, i, r, s, o, a, l) {
                        wa(br, il, A1(Ie(), t, n, e, i, r, s, o, a, l), !0);
                    })(
                        '',
                        e.prefixCls,
                        '-panel-container ',
                        e.showWeek ? e.prefixCls + '-week-number' : '',
                        ' ',
                        e.hasTimePicker ? e.prefixCls + '-time' : '',
                        ' ',
                        e.isRange ? e.prefixCls + '-range' : '',
                        '',
                    ),
                        z(),
                        dt('', e.prefixCls, '-panel'),
                        On('ant-picker-panel-rtl', 'rtl' === e.dir),
                        z(),
                        H('ngTemplateOutlet', i),
                        z(),
                        H('ngTemplateOutlet', r);
                }
            }
            function Ote(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'inner-popup', 8),
                        Le('panelModeChange', function (r) {
                            const s = me(e).partType;
                            return pe(L().onPanelModeChange(r, s));
                        })('cellHover', function (r) {
                            return me(e), pe(L().onCellHover(r));
                        })('selectDate', function (r) {
                            me(e);
                            const s = L();
                            return pe(s.changeValueFromSelect(r, !s.showTime));
                        })('selectTime', function (r) {
                            const s = me(e).partType;
                            return pe(L().onSelectTime(r, s));
                        })('headerChange', function (r) {
                            const s = me(e).partType;
                            return pe(L().onActiveDateChange(r, s));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = n.partType,
                        i = L();
                    dt('', i.prefixCls, '-panel'),
                        On('ant-picker-panel-rtl', 'rtl' === i.dir),
                        z(),
                        H('showWeek', i.showWeek)('endPanelMode', i.getPanelMode(i.endPanelMode, e))('partType', e)(
                            'locale',
                            i.locale,
                        )('showTimePicker', i.hasTimePicker)('timeOptions', i.getTimeOptions(e))(
                            'panelMode',
                            i.getPanelMode(i.panelMode, e),
                        )('activeDate', i.getActiveDate(e))('value', i.getValue(e))('disabledDate', i.disabledDate)(
                            'dateRender',
                            i.dateRender,
                        )('selectedValue', null == i.datePickerService ? null : i.datePickerService.value)(
                            'hoverValue',
                            i.hoverValue,
                        );
                }
            }
            function zte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'calendar-footer', 10),
                        Le('clickOk', function () {
                            return me(e), pe(L(2).onClickOk());
                        })('clickToday', function (r) {
                            return me(e), pe(L(2).onClickToday(r));
                        }),
                        ee();
                }
                if (2 & t) {
                    const e = L(2),
                        i = ts(7);
                    H('locale', e.locale)('isRange', e.isRange)('showToday', e.showToday)('showNow', e.showNow)(
                        'hasTimePicker',
                        e.hasTimePicker,
                    )('okDisabled', !e.isAllowed(null == e.datePickerService ? null : e.datePickerService.value))(
                        'extraFooter',
                        e.extraFooter,
                    )('rangeQuickSelector', e.ranges ? i : null);
                }
            }
            function Pte(t, n) {
                1 & t && ue(0, zte, 1, 8, 'calendar-footer', 9), 2 & t && dn(0, L().hasFooter ? 0 : -1);
            }
            function Nte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'li', 11),
                        Le('click', function () {
                            const r = me(e).$implicit,
                                s = L(2);
                            return pe(s.onClickPresetRange(s.ranges[r]));
                        })('mouseenter', function () {
                            const r = me(e).$implicit,
                                s = L(2);
                            return pe(s.onHoverPresetRange(s.ranges[r]));
                        })('mouseleave', function () {
                            return me(e), pe(L(2).onPresetRangeMouseLeave());
                        }),
                        Z(1, 'span', 12),
                        Je(2),
                        ee()();
                }
                if (2 & t) {
                    const e = n.$implicit;
                    dt('', L(2).prefixCls, '-preset'), z(2), hn(e);
                }
            }
            function Fte(t, n) {
                if ((1 & t && Jr(0, Nte, 3, 4, 'li', 3, rl), 2 & t)) {
                    const e = L();
                    es(e.getObjectKeys(e.ranges));
                }
            }
            const Rte = ['separatorElement'],
                Vte = ['pickerInput'],
                Hte = ['rangePickerInput'];
            function Ute(t, n) {
                1 & t && Pi(0);
            }
            function Bte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'input', 8, 3),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(2);
                            return ki(s.inputValue, r) || (s.inputValue = r), pe(r);
                        }),
                        Le('focus', function (r) {
                            return me(e), pe(L(2).onFocus(r));
                        })('focusout', function (r) {
                            return me(e), pe(L(2).onFocusout(r));
                        })('ngModelChange', function (r) {
                            return me(e), pe(L(2).onInputChange(r));
                        })('keyup.enter', function (r) {
                            return me(e), pe(L(2).onKeyupEnter(r));
                        }),
                        ee(),
                        ue(3, Ute, 1, 0, 'ng-container', 9),
                        ee();
                }
                if (2 & t) {
                    const e = L(2),
                        i = ts(5);
                    dt('', e.prefixCls, '-input'),
                        z(),
                        On('ant-input-disabled', e.nzDisabled),
                        ct('placeholder', e.getPlaceholder()),
                        H('disabled', e.nzDisabled)('readOnly', e.nzInputReadOnly),
                        yi('ngModel', e.inputValue),
                        H('size', e.inputSize),
                        zi('id', e.nzId),
                        z(2),
                        H('ngTemplateOutlet', i);
                }
            }
            function qte(t, n) {
                1 & t && Pi(0);
            }
            function Yte(t, n) {
                1 & t && Je(0), 2 & t && jn(' ', L(4).nzSeparator, ' ');
            }
            function jte(t, n) {
                1 & t && Oe(0, 'span', 12);
            }
            function $te(t, n) {
                if ((1 & t && (Xe(0), ue(1, Yte, 1, 1)(2, jte, 1, 0), Ze()), 2 & t)) {
                    const e = L(3);
                    z(), dn(1, e.nzSeparator ? 1 : 2);
                }
            }
            function Gte(t, n) {
                1 & t && Pi(0);
            }
            function Wte(t, n) {
                1 & t && Pi(0);
            }
            function Kte(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'div'),
                        ue(1, qte, 1, 0, 'ng-container', 10),
                        ee(),
                        Z(2, 'div', null, 4)(4, 'span'),
                        ue(5, $te, 3, 1, 'ng-container', 11),
                        ee()(),
                        Z(6, 'div'),
                        ue(7, Gte, 1, 0, 'ng-container', 10),
                        ee(),
                        ue(8, Wte, 1, 0, 'ng-container', 9)),
                    2 & t)
                ) {
                    const e = L(2),
                        i = ts(3),
                        r = ts(5);
                    dt('', e.prefixCls, '-input'),
                        z(),
                        H('ngTemplateOutlet', i)('ngTemplateOutletContext', B1(18, zx)),
                        z(),
                        dt('', e.prefixCls, '-range-separator'),
                        z(2),
                        dt('', e.prefixCls, '-separator'),
                        z(),
                        H('nzStringTemplateOutlet', e.nzSeparator),
                        z(),
                        dt('', e.prefixCls, '-input'),
                        z(),
                        H('ngTemplateOutlet', i)('ngTemplateOutletContext', B1(19, Px)),
                        z(),
                        H('ngTemplateOutlet', r);
                }
            }
            function Qte(t, n) {
                1 & t && ue(0, Bte, 4, 12, 'div', 7)(1, Kte, 9, 20), 2 & t && dn(0, L().isRange ? 1 : 0);
            }
            function Xte(t, n) {}
            function Zte(t, n) {
                1 & t && ue(0, Xte, 0, 0, 'ng-template', 13), 2 & t && (L(), H('ngTemplateOutlet', ts(7)));
            }
            function Jte(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'input', 14, 5),
                        Le('click', function (r) {
                            return me(e), pe(L().onClickInputBox(r));
                        })('focusout', function (r) {
                            return me(e), pe(L().onFocusout(r));
                        })('focus', function (r) {
                            const s = me(e).partType;
                            return pe(L().onFocus(r, s));
                        })('keyup.enter', function (r) {
                            return me(e), pe(L().onKeyupEnter(r));
                        }),
                        bi('ngModelChange', function (r) {
                            const s = me(e).partType,
                                o = L();
                            return (
                                ki(o.inputValue[o.datePickerService.getActiveIndex(s)], r) ||
                                    (o.inputValue[o.datePickerService.getActiveIndex(s)] = r),
                                pe(r)
                            );
                        }),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onInputChange(r));
                        }),
                        ee();
                }
                if (2 & t) {
                    const e = n.partType,
                        i = L();
                    ct('placeholder', i.getPlaceholder(e)),
                        H('disabled', i.nzDisabled)('readOnly', i.nzInputReadOnly)('size', i.inputSize),
                        yi('ngModel', i.inputValue[i.datePickerService.getActiveIndex(e)]),
                        zi('id', i.nzId);
                }
            }
            function ene(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'span', 17),
                        Le('click', function (r) {
                            return me(e), pe(L(2).onClickClear(r));
                        }),
                        Oe(1, 'span', 18),
                        ee();
                }
                2 & t && dt('', L(2).prefixCls, '-clear');
            }
            function tne(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'span', 19), Ze()), 2 & t)) {
                    const e = n.$implicit;
                    z(), H('nzType', e);
                }
            }
            function nne(t, n) {
                1 & t && Oe(0, 'nz-form-item-feedback-icon', 16), 2 & t && H('status', L(2).status);
            }
            function ine(t, n) {
                if (
                    (1 & t &&
                        (Oe(0, 'div', 15),
                        ue(1, ene, 2, 3, 'span', 7),
                        Z(2, 'span'),
                        ue(3, tne, 2, 1, 'ng-container', 11)(4, nne, 1, 1, 'nz-form-item-feedback-icon', 16),
                        ee()),
                    2 & t)
                ) {
                    const e = L();
                    dt('', e.prefixCls, '-active-bar'),
                        H('ngStyle', e.activeBarStyle),
                        z(),
                        dn(1, e.showClear ? 1 : -1),
                        z(),
                        dt('', e.prefixCls, '-suffix'),
                        z(),
                        H('nzStringTemplateOutlet', e.nzSuffixIcon),
                        z(),
                        dn(4, e.hasFeedback && e.status ? 4 : -1);
                }
            }
            function rne(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div', 15)(1, 'date-range-popup', 20),
                        Le('panelModeChange', function (r) {
                            return me(e), pe(L().onPanelModeChange(r));
                        })('calendarChange', function (r) {
                            return me(e), pe(L().onCalendarChange(r));
                        })('resultOk', function () {
                            return me(e), pe(L().onResultOk());
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    F1('', e.prefixCls, '-dropdown ', e.nzDropdownClassName, ''),
                        On('ant-picker-dropdown-rtl', 'rtl' === e.dir)(
                            'ant-picker-dropdown-placement-bottomLeft',
                            'bottom' === e.currentPositionY && 'start' === e.currentPositionX,
                        )(
                            'ant-picker-dropdown-placement-topLeft',
                            'top' === e.currentPositionY && 'start' === e.currentPositionX,
                        )(
                            'ant-picker-dropdown-placement-bottomRight',
                            'bottom' === e.currentPositionY && 'end' === e.currentPositionX,
                        )(
                            'ant-picker-dropdown-placement-topRight',
                            'top' === e.currentPositionY && 'end' === e.currentPositionX,
                        )('ant-picker-dropdown-range', e.isRange)(
                            'ant-picker-active-left',
                            'left' === e.datePickerService.activeInput,
                        )('ant-picker-active-right', 'right' === e.datePickerService.activeInput),
                        H('ngStyle', e.nzPopupStyle),
                        z(),
                        H('isRange', e.isRange)('inline', e.nzInline)('defaultPickerValue', e.nzDefaultPickerValue)(
                            'showWeek',
                            e.nzShowWeekNumber || 'week' === e.nzMode,
                        )('panelMode', e.panelMode)('locale', null == e.nzLocale ? null : e.nzLocale.lang)(
                            'showToday',
                            'date' === e.nzMode && e.nzShowToday && !e.isRange && !e.nzShowTime,
                        )('showNow', 'date' === e.nzMode && e.nzShowNow && !e.isRange && !!e.nzShowTime)(
                            'showTime',
                            e.nzShowTime,
                        )('dateRender', e.nzDateRender)('disabledDate', e.nzDisabledDate)(
                            'disabledTime',
                            e.nzDisabledTime,
                        )('extraFooter', e.extraFooter)('ranges', e.nzRanges)('dir', e.dir);
                }
            }
            function sne(t, n) {
                1 & t && Pi(0);
            }
            function one(t, n) {
                if ((1 & t && (Z(0, 'div', 21), ue(1, sne, 1, 0, 'ng-container', 9), ee()), 2 & t)) {
                    const e = L(),
                        i = ts(7);
                    Zr('position', 'relative'),
                        H('nzNoAnimation', !(null == e.noAnimation || !e.noAnimation.nzNoAnimation))(
                            '@slideMotion',
                            'enter',
                        ),
                        z(),
                        H('ngTemplateOutlet', i);
                }
            }
            const Zf = 'ant-picker',
                ane = { nzDisabledHours: () => [], nzDisabledMinutes: () => [], nzDisabledSeconds: () => [] };
            function Nx(t, n) {
                let e = n ? n(t && t.nativeDate) : {};
                return (e = { ...ane, ...e }), e;
            }
            function Jf(t, n, e) {
                return !(
                    !t ||
                    (n && n(t.nativeDate)) ||
                    (e &&
                        !(function cne(t, n) {
                            return (function lne(t, n) {
                                let e = !1;
                                if (t) {
                                    const i = t.getHours(),
                                        r = t.getMinutes(),
                                        s = t.getSeconds();
                                    e =
                                        -1 !== n.nzDisabledHours().indexOf(i) ||
                                        -1 !== n.nzDisabledMinutes(i).indexOf(r) ||
                                        -1 !== n.nzDisabledSeconds(i, r).indexOf(s);
                                }
                                return !e;
                            })(t, Nx(t, n));
                        })(t, e))
                );
            }
            function e3(t) {
                return t && t.replace(/Y/g, 'y').replace(/D/g, 'd');
            }
            let Fx = (() => {
                    class t {
                        constructor(e) {
                            (this.dateHelper = e),
                                (this.showToday = !1),
                                (this.showNow = !1),
                                (this.hasTimePicker = !1),
                                (this.isRange = !1),
                                (this.okDisabled = !1),
                                (this.rangeQuickSelector = null),
                                (this.clickOk = new Ft()),
                                (this.clickToday = new Ft()),
                                (this.prefixCls = Zf),
                                (this.isTemplateRef = dg),
                                (this.isNonEmptyString = ug),
                                (this.isTodayDisabled = !1),
                                (this.todayTitle = '');
                        }
                        ngOnChanges(e) {
                            const i = new Date();
                            if (
                                (e.disabledDate &&
                                    (this.isTodayDisabled = !(!this.disabledDate || !this.disabledDate(i))),
                                e.locale)
                            ) {
                                const r = e3(this.locale.dateFormat);
                                this.todayTitle = this.dateHelper.format(i, r);
                            }
                        }
                        onClickToday() {
                            const e = new Wn();
                            this.clickToday.emit(e.clone());
                        }
                        get isExtraFooterTemplateRef() {
                            return dg(this.extraFooter);
                        }
                        get isExtraFooterNonEmptyString() {
                            return ug(this.extraFooter);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Aa));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['calendar-footer']],
                            inputs: {
                                locale: 'locale',
                                showToday: 'showToday',
                                showNow: 'showNow',
                                hasTimePicker: 'hasTimePicker',
                                isRange: 'isRange',
                                okDisabled: 'okDisabled',
                                disabledDate: 'disabledDate',
                                extraFooter: 'extraFooter',
                                rangeQuickSelector: 'rangeQuickSelector',
                            },
                            outputs: { clickOk: 'clickOk', clickToday: 'clickToday' },
                            exportAs: ['calendarFooter'],
                            standalone: !0,
                            features: [D, Qi],
                            decls: 4,
                            vars: 6,
                            consts: [
                                [3, 'class'],
                                ['role', 'button', 3, 'class', 'title'],
                                [3, 'innerHTML'],
                                [4, 'ngTemplateOutlet'],
                                ['role', 'button', 3, 'click', 'title'],
                                [3, 'click'],
                                [
                                    'nz-button',
                                    '',
                                    'type',
                                    'button',
                                    'nzType',
                                    'primary',
                                    'nzSize',
                                    'small',
                                    3,
                                    'click',
                                    'disabled',
                                ],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'div'),
                                    ue(1, XJ, 3, 5, 'div', 0)(2, ZJ, 2, 6, 'a', 1)(3, nee, 4, 6, 'ul', 0),
                                    ee()),
                                    2 & i &&
                                        (dt('', r.prefixCls, '-footer'),
                                        z(),
                                        dn(1, r.extraFooter ? 1 : -1),
                                        z(),
                                        dn(2, r.showToday ? 2 : -1),
                                        z(),
                                        dn(3, r.hasTimePicker || r.rangeQuickSelector ? 3 : -1));
                            },
                            dependencies: [Al, MD, Fg, yD, Ng],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                n5 = (() => {
                    class t {
                        constructor() {
                            (this.activeInput = 'left'),
                                (this.arrowLeft = 0),
                                (this.isRange = !1),
                                (this.valueChange$ = new yc(1)),
                                (this.emitValue$ = new vt()),
                                (this.inputPartChange$ = new vt());
                        }
                        initValue(e = !1) {
                            e && (this.initialValue = this.isRange ? [] : null), this.setValue(this.initialValue);
                        }
                        hasValue(e = this.value) {
                            return Array.isArray(e) ? !!e[0] || !!e[1] : !!e;
                        }
                        makeValue(e) {
                            return this.isRange ? (e ? e.map(i => new Wn(i)) : []) : e ? new Wn(e) : null;
                        }
                        setActiveDate(e, i = !1, r = 'month') {
                            this.activeDate = this.isRange
                                ? (function cQ(t, n, e = 'month', i = 'left') {
                                      const [r, s] = t;
                                      let o = r || new Wn(),
                                          a = s || (n ? o : o.add(1, e));
                                      return (
                                          r && !s
                                              ? ((o = r), (a = n ? r : r.add(1, e)))
                                              : !r && s
                                              ? ((o = n ? s : s.add(-1, e)), (a = s))
                                              : r &&
                                                s &&
                                                !n &&
                                                (r.isSame(s, e) || 'left' === i
                                                    ? (a = o.add(1, e))
                                                    : (o = a.add(-1, e))),
                                          [o, a]
                                      );
                                  })(e, i, { date: 'month', month: 'year', year: 'decade' }[r], this.activeInput)
                                : mh(e);
                        }
                        setValue(e) {
                            (this.value = e), this.valueChange$.next(this.value);
                        }
                        getActiveIndex(e = this.activeInput) {
                            return { left: 0, right: 1 }[e];
                        }
                        ngOnDestroy() {
                            this.valueChange$.complete(), this.emitValue$.complete(), this.inputPartChange$.complete();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })(),
                t3 = (() => {
                    class t {
                        constructor() {
                            (this.prefixCls = 'ant-picker-header'),
                                (this.selectors = []),
                                (this.showSuperPreBtn = !0),
                                (this.showSuperNextBtn = !0),
                                (this.showPreBtn = !0),
                                (this.showNextBtn = !0),
                                (this.panelModeChange = new Ft()),
                                (this.valueChange = new Ft());
                        }
                        superPreviousTitle() {
                            return this.locale.previousYear;
                        }
                        previousTitle() {
                            return this.locale.previousMonth;
                        }
                        superNextTitle() {
                            return this.locale.nextYear;
                        }
                        nextTitle() {
                            return this.locale.nextMonth;
                        }
                        superPrevious() {
                            this.changeValue(this.value.addYears(-1));
                        }
                        superNext() {
                            this.changeValue(this.value.addYears(1));
                        }
                        previous() {
                            this.changeValue(this.value.addMonths(-1));
                        }
                        next() {
                            this.changeValue(this.value.addMonths(1));
                        }
                        changeValue(e) {
                            this.value !== e && ((this.value = e), this.valueChange.emit(this.value), this.render());
                        }
                        changeMode(e) {
                            this.panelModeChange.emit(e);
                        }
                        render() {
                            this.value && (this.selectors = this.getSelectors());
                        }
                        ngOnInit() {
                            this.value || (this.value = new Wn()), (this.selectors = this.getSelectors());
                        }
                        ngOnChanges(e) {
                            (e.value || e.locale) && this.render();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            inputs: {
                                value: 'value',
                                locale: 'locale',
                                showSuperPreBtn: 'showSuperPreBtn',
                                showSuperNextBtn: 'showSuperNextBtn',
                                showPreBtn: 'showPreBtn',
                                showNextBtn: 'showNextBtn',
                            },
                            outputs: { panelModeChange: 'panelModeChange', valueChange: 'valueChange' },
                            features: [D],
                        }));
                    }
                    return t;
                })(),
                une = (() => {
                    class t extends t3 {
                        previous() {}
                        next() {}
                        get startYear() {
                            return 100 * parseInt('' + this.value.getYear() / 100, 10);
                        }
                        get endYear() {
                            return this.startYear + 99;
                        }
                        superPrevious() {
                            this.changeValue(this.value.addYears(-100));
                        }
                        superNext() {
                            this.changeValue(this.value.addYears(100));
                        }
                        getSelectors() {
                            return [
                                {
                                    className: `${this.prefixCls}-decade-btn`,
                                    title: '',
                                    onClick: () => {},
                                    label: `${this.startYear}-${this.endYear}`,
                                },
                            ];
                        }
                        static #e = (this.ɵfac = (() => {
                            let e;
                            return function (r) {
                                return (e || (e = Nr(t)))(r || t);
                            };
                        })());
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['decade-header']],
                            exportAs: ['decadeHeader'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 12,
                            vars: 30,
                            consts: [
                                ['role', 'button', 'type', 'button', 'tabindex', '-1', 3, 'click', 'title'],
                                [1, 'ant-picker-super-prev-icon'],
                                [1, 'ant-picker-prev-icon'],
                                ['role', 'button', 'type', 'button', 3, 'class', 'title'],
                                [1, 'ant-picker-next-icon'],
                                [1, 'ant-picker-super-next-icon'],
                                ['role', 'button', 'type', 'button', 3, 'click', 'title'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'div')(1, 'button', 0),
                                    Le('click', function () {
                                        return r.superPrevious();
                                    }),
                                    Oe(2, 'span', 1),
                                    ee(),
                                    Z(3, 'button', 0),
                                    Le('click', function () {
                                        return r.previous();
                                    }),
                                    Oe(4, 'span', 2),
                                    ee(),
                                    Z(5, 'div'),
                                    Jr(6, iee, 2, 5, 'button', 3, rl),
                                    ee(),
                                    Z(8, 'button', 0),
                                    Le('click', function () {
                                        return r.next();
                                    }),
                                    Oe(9, 'span', 4),
                                    ee(),
                                    Z(10, 'button', 0),
                                    Le('click', function () {
                                        return r.superNext();
                                    }),
                                    Oe(11, 'span', 5),
                                    ee()()),
                                    2 & i &&
                                        (vo(r.prefixCls),
                                        z(),
                                        dt('', r.prefixCls, '-super-prev-btn'),
                                        Zr('visibility', r.showSuperPreBtn ? 'visible' : 'hidden'),
                                        ct('title', r.superPreviousTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-prev-btn'),
                                        Zr('visibility', r.showPreBtn ? 'visible' : 'hidden'),
                                        ct('title', r.previousTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-view'),
                                        z(),
                                        es(r.selectors),
                                        z(2),
                                        dt('', r.prefixCls, '-next-btn'),
                                        Zr('visibility', r.showNextBtn ? 'visible' : 'hidden'),
                                        ct('title', r.nextTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-super-next-btn'),
                                        Zr('visibility', r.showSuperNextBtn ? 'visible' : 'hidden'),
                                        ct('title', r.superNextTitle()));
                            },
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                n3 = (() => {
                    class t {
                        constructor() {
                            (this.headRow = []),
                                (this.bodyRows = []),
                                (this.MAX_ROW = 6),
                                (this.MAX_COL = 7),
                                (this.prefixCls = 'ant-picker'),
                                (this.activeDate = new Wn()),
                                (this.showWeek = !1),
                                (this.selectedValue = []),
                                (this.hoverValue = []),
                                (this.canSelectWeek = !1),
                                (this.valueChange = new Ft()),
                                (this.cellHover = new Ft());
                        }
                        render() {
                            this.activeDate &&
                                ((this.headRow = this.makeHeadRow()), (this.bodyRows = this.makeBodyRows()));
                        }
                        hasRangeValue() {
                            return this.selectedValue?.length > 0 || this.hoverValue?.length > 0;
                        }
                        getClassMap(e) {
                            return {
                                'ant-picker-cell': !0,
                                'ant-picker-cell-in-view': !0,
                                'ant-picker-cell-selected': e.isSelected,
                                'ant-picker-cell-disabled': e.isDisabled,
                                'ant-picker-cell-in-range': !!e.isInSelectedRange,
                                'ant-picker-cell-range-start': !!e.isSelectedStart,
                                'ant-picker-cell-range-end': !!e.isSelectedEnd,
                                'ant-picker-cell-range-start-single': !!e.isStartSingle,
                                'ant-picker-cell-range-end-single': !!e.isEndSingle,
                                'ant-picker-cell-range-hover': !!e.isInHoverRange,
                                'ant-picker-cell-range-hover-start': !!e.isHoverStart,
                                'ant-picker-cell-range-hover-end': !!e.isHoverEnd,
                                'ant-picker-cell-range-hover-edge-start': !!e.isFirstCellInPanel,
                                'ant-picker-cell-range-hover-edge-end': !!e.isLastCellInPanel,
                                'ant-picker-cell-range-start-near-hover': !!e.isRangeStartNearHover,
                                'ant-picker-cell-range-end-near-hover': !!e.isRangeEndNearHover,
                            };
                        }
                        ngOnInit() {
                            this.render();
                        }
                        ngOnChanges(e) {
                            e.activeDate && !e.activeDate.currentValue && (this.activeDate = new Wn()),
                                (e.disabledDate ||
                                    e.locale ||
                                    e.showWeek ||
                                    e.selectWeek ||
                                    this.isDateRealChange(e.activeDate) ||
                                    this.isDateRealChange(e.value) ||
                                    this.isDateRealChange(e.selectedValue) ||
                                    this.isDateRealChange(e.hoverValue)) &&
                                    this.render();
                        }
                        isDateRealChange(e) {
                            if (e) {
                                const i = e.previousValue,
                                    r = e.currentValue;
                                return Array.isArray(r)
                                    ? !Array.isArray(i) ||
                                          r.length !== i.length ||
                                          r.some((s, o) => {
                                              const a = i[o];
                                              return a instanceof Wn ? a.isSameDay(s) : a !== s;
                                          })
                                    : !this.isSameDate(i, r);
                            }
                            return !1;
                        }
                        isSameDate(e, i) {
                            return (!e && !i) || (e && i && i.isSameDay(e));
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            inputs: {
                                prefixCls: 'prefixCls',
                                value: 'value',
                                locale: 'locale',
                                activeDate: 'activeDate',
                                showWeek: 'showWeek',
                                selectedValue: 'selectedValue',
                                hoverValue: 'hoverValue',
                                disabledDate: 'disabledDate',
                                cellRender: 'cellRender',
                                fullCellRender: 'fullCellRender',
                                canSelectWeek: 'canSelectWeek',
                            },
                            outputs: { valueChange: 'valueChange', cellHover: 'cellHover' },
                            features: [D],
                        }));
                    }
                    return t;
                })(),
                fne = (() => {
                    class t extends n3 {
                        get startYear() {
                            return 100 * parseInt('' + this.activeDate.getYear() / 100, 10);
                        }
                        get endYear() {
                            return this.startYear + 99;
                        }
                        makeHeadRow() {
                            return [];
                        }
                        makeBodyRows() {
                            const e = [],
                                i = this.value && this.value.getYear(),
                                r = this.startYear,
                                s = this.endYear,
                                o = r - 10;
                            let a = 0;
                            for (let l = 0; l < 4; l++) {
                                const c = { dateCells: [], trackByIndex: l };
                                for (let f = 0; f < 3; f++) {
                                    const g = o + 10 * a,
                                        E = o + 10 * a + 9,
                                        P = `${g}-${E}`,
                                        V = {
                                            trackByIndex: f,
                                            value: this.activeDate.setYear(g).nativeDate,
                                            content: P,
                                            title: P,
                                            isDisabled: !1,
                                            isSelected: i >= g && i <= E,
                                            isLowerThanStart: E < r,
                                            isBiggerThanEnd: g > s,
                                            classMap: {},
                                            onClick() {},
                                            onMouseEnter() {},
                                        };
                                    (V.classMap = this.getClassMap(V)),
                                        (V.onClick = () => this.chooseDecade(g)),
                                        a++,
                                        c.dateCells.push(V);
                                }
                                e.push(c);
                            }
                            return e;
                        }
                        getClassMap(e) {
                            return {
                                [`${this.prefixCls}-cell`]: !0,
                                [`${this.prefixCls}-cell-in-view`]: !e.isBiggerThanEnd && !e.isLowerThanStart,
                                [`${this.prefixCls}-cell-selected`]: e.isSelected,
                                [`${this.prefixCls}-cell-disabled`]: e.isDisabled,
                            };
                        }
                        chooseDecade(e) {
                            (this.value = this.activeDate.setYear(e)), this.valueChange.emit(this.value);
                        }
                        static #e = (this.ɵfac = (() => {
                            let e;
                            return function (r) {
                                return (e || (e = Nr(t)))(r || t);
                            };
                        })());
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['decade-table']],
                            exportAs: ['decadeTable'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 5,
                            vars: 1,
                            consts: [
                                ['cellspacing', '0', 'role', 'grid', 1, 'ant-picker-content'],
                                ['role', 'row', 3, 'ngClass'],
                                ['role', 'row'],
                                ['role', 'columnheader'],
                                ['role', 'columnheader', 3, 'title'],
                                ['role', 'gridcell', 3, 'class'],
                                ['role', 'gridcell', 3, 'title', 'ngClass'],
                                ['role', 'gridcell'],
                                ['role', 'gridcell', 3, 'click', 'mouseenter', 'title', 'ngClass'],
                                [4, 'ngTemplateOutlet', 'ngTemplateOutletContext'],
                                [3, 'innerHTML'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'table', 0),
                                    ue(1, oee, 5, 1, 'thead'),
                                    Z(2, 'tbody'),
                                    Jr(3, yee, 4, 2, 'tr', 1, Ac),
                                    ee()()),
                                    2 & i &&
                                        (z(), dn(1, r.headRow && r.headRow.length > 0 ? 1 : -1), z(2), es(r.bodyRows));
                            },
                            dependencies: [sl, Al],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                mne = (() => {
                    class t extends t3 {
                        get startYear() {
                            return 10 * parseInt('' + this.value.getYear() / 10, 10);
                        }
                        get endYear() {
                            return this.startYear + 9;
                        }
                        superPrevious() {
                            this.changeValue(this.value.addYears(-10));
                        }
                        superNext() {
                            this.changeValue(this.value.addYears(10));
                        }
                        getSelectors() {
                            return [
                                {
                                    className: `${this.prefixCls}-year-btn`,
                                    title: '',
                                    onClick: () => this.changeMode('decade'),
                                    label: `${this.startYear}-${this.endYear}`,
                                },
                            ];
                        }
                        static #e = (this.ɵfac = (() => {
                            let e;
                            return function (r) {
                                return (e || (e = Nr(t)))(r || t);
                            };
                        })());
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['year-header']],
                            exportAs: ['yearHeader'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 12,
                            vars: 30,
                            consts: [
                                ['role', 'button', 'type', 'button', 'tabindex', '-1', 3, 'click', 'title'],
                                [1, 'ant-picker-super-prev-icon'],
                                [1, 'ant-picker-prev-icon'],
                                ['role', 'button', 'type', 'button', 3, 'class', 'title'],
                                [1, 'ant-picker-next-icon'],
                                [1, 'ant-picker-super-next-icon'],
                                ['role', 'button', 'type', 'button', 3, 'click', 'title'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'div')(1, 'button', 0),
                                    Le('click', function () {
                                        return r.superPrevious();
                                    }),
                                    Oe(2, 'span', 1),
                                    ee(),
                                    Z(3, 'button', 0),
                                    Le('click', function () {
                                        return r.previous();
                                    }),
                                    Oe(4, 'span', 2),
                                    ee(),
                                    Z(5, 'div'),
                                    Jr(6, bee, 2, 5, 'button', 3, rl),
                                    ee(),
                                    Z(8, 'button', 0),
                                    Le('click', function () {
                                        return r.next();
                                    }),
                                    Oe(9, 'span', 4),
                                    ee(),
                                    Z(10, 'button', 0),
                                    Le('click', function () {
                                        return r.superNext();
                                    }),
                                    Oe(11, 'span', 5),
                                    ee()()),
                                    2 & i &&
                                        (vo(r.prefixCls),
                                        z(),
                                        dt('', r.prefixCls, '-super-prev-btn'),
                                        Zr('visibility', r.showSuperPreBtn ? 'visible' : 'hidden'),
                                        ct('title', r.superPreviousTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-prev-btn'),
                                        Zr('visibility', r.showPreBtn ? 'visible' : 'hidden'),
                                        ct('title', r.previousTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-view'),
                                        z(),
                                        es(r.selectors),
                                        z(2),
                                        dt('', r.prefixCls, '-next-btn'),
                                        Zr('visibility', r.showNextBtn ? 'visible' : 'hidden'),
                                        ct('title', r.nextTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-super-next-btn'),
                                        Zr('visibility', r.showSuperNextBtn ? 'visible' : 'hidden'),
                                        ct('title', r.superNextTitle()));
                            },
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                pne = (() => {
                    class t extends n3 {
                        constructor(e) {
                            super(), (this.dateHelper = e), (this.MAX_ROW = 4), (this.MAX_COL = 3);
                        }
                        makeHeadRow() {
                            return [];
                        }
                        makeBodyRows() {
                            const e = this.activeDate && this.activeDate.getYear(),
                                i = 10 * parseInt('' + e / 10, 10),
                                r = i + 9,
                                s = i - 1,
                                o = [];
                            let a = 0;
                            for (let l = 0; l < this.MAX_ROW; l++) {
                                const c = { dateCells: [], trackByIndex: l };
                                for (let f = 0; f < this.MAX_COL; f++) {
                                    const g = s + a,
                                        E = this.activeDate.setYear(g),
                                        P = this.dateHelper.format(E.nativeDate, 'yyyy'),
                                        V = this.isDisabledYear(E),
                                        W = {
                                            trackByIndex: f,
                                            value: E.nativeDate,
                                            isDisabled: V,
                                            isSameDecade: g >= i && g <= r,
                                            isSelected: g === (this.value && this.value.getYear()),
                                            content: P,
                                            title: P,
                                            classMap: {},
                                            isLastCellInPanel: E.getYear() === r,
                                            isFirstCellInPanel: E.getYear() === i,
                                            cellRender: Eu(this.cellRender, E),
                                            fullCellRender: Eu(this.fullCellRender, E),
                                            onClick: () => this.chooseYear(W.value.getFullYear()),
                                            onMouseEnter: () => this.cellHover.emit(E),
                                        };
                                    this.addCellProperty(W, E), c.dateCells.push(W), a++;
                                }
                                o.push(c);
                            }
                            return o;
                        }
                        getClassMap(e) {
                            return { ...super.getClassMap(e), 'ant-picker-cell-in-view': !!e.isSameDecade };
                        }
                        isDisabledYear(e) {
                            if (!this.disabledDate) return !1;
                            for (let r = e.setMonth(0).setDate(1); r.getYear() === e.getYear(); r = r.addDays(1))
                                if (!this.disabledDate(r.nativeDate)) return !1;
                            return !0;
                        }
                        addCellProperty(e, i) {
                            if (this.hasRangeValue()) {
                                const [r, s] = this.hoverValue,
                                    [o, a] = this.selectedValue;
                                o?.isSameYear(i) && ((e.isSelectedStart = !0), (e.isSelected = !0)),
                                    a?.isSameYear(i) && ((e.isSelectedEnd = !0), (e.isSelected = !0)),
                                    r &&
                                        s &&
                                        ((e.isHoverStart = r.isSameYear(i)),
                                        (e.isHoverEnd = s.isSameYear(i)),
                                        (e.isInHoverRange = r.isBeforeYear(i) && i.isBeforeYear(s))),
                                    (e.isStartSingle = o && !a),
                                    (e.isEndSingle = !o && a),
                                    (e.isInSelectedRange = o?.isBeforeYear(i) && i?.isBeforeYear(a)),
                                    (e.isRangeStartNearHover = o && e.isInHoverRange),
                                    (e.isRangeEndNearHover = a && e.isInHoverRange);
                            } else i.isSameYear(this.value) && (e.isSelected = !0);
                            e.classMap = this.getClassMap(e);
                        }
                        chooseYear(e) {
                            (this.value = this.activeDate.setYear(e)), this.valueChange.emit(this.value), this.render();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Aa));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['year-table']],
                            exportAs: ['yearTable'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 5,
                            vars: 1,
                            consts: [
                                ['cellspacing', '0', 'role', 'grid', 1, 'ant-picker-content'],
                                ['role', 'row', 3, 'ngClass'],
                                ['role', 'row'],
                                ['role', 'columnheader'],
                                ['role', 'columnheader', 3, 'title'],
                                ['role', 'gridcell', 3, 'class'],
                                ['role', 'gridcell', 3, 'title', 'ngClass'],
                                ['role', 'gridcell'],
                                ['role', 'gridcell', 3, 'click', 'mouseenter', 'title', 'ngClass'],
                                [4, 'ngTemplateOutlet', 'ngTemplateOutletContext'],
                                [3, 'innerHTML'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'table', 0),
                                    ue(1, Mee, 5, 1, 'thead'),
                                    Z(2, 'tbody'),
                                    Jr(3, Nee, 4, 2, 'tr', 1, Ac),
                                    ee()()),
                                    2 & i &&
                                        (z(), dn(1, r.headRow && r.headRow.length > 0 ? 1 : -1), z(2), es(r.bodyRows));
                            },
                            dependencies: [sl, Al],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                gne = (() => {
                    class t extends t3 {
                        constructor(e) {
                            super(), (this.dateHelper = e);
                        }
                        getSelectors() {
                            return [
                                {
                                    className: `${this.prefixCls}-month-btn`,
                                    title: this.locale.yearSelect,
                                    onClick: () => this.changeMode('year'),
                                    label: this.dateHelper.format(this.value.nativeDate, e3(this.locale.yearFormat)),
                                },
                            ];
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Aa));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['month-header']],
                            exportAs: ['monthHeader'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 12,
                            vars: 30,
                            consts: [
                                ['role', 'button', 'type', 'button', 'tabindex', '-1', 3, 'click', 'title'],
                                [1, 'ant-picker-super-prev-icon'],
                                [1, 'ant-picker-prev-icon'],
                                ['role', 'button', 'type', 'button', 3, 'class', 'title'],
                                [1, 'ant-picker-next-icon'],
                                [1, 'ant-picker-super-next-icon'],
                                ['role', 'button', 'type', 'button', 3, 'click', 'title'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'div')(1, 'button', 0),
                                    Le('click', function () {
                                        return r.superPrevious();
                                    }),
                                    Oe(2, 'span', 1),
                                    ee(),
                                    Z(3, 'button', 0),
                                    Le('click', function () {
                                        return r.previous();
                                    }),
                                    Oe(4, 'span', 2),
                                    ee(),
                                    Z(5, 'div'),
                                    Jr(6, Fee, 2, 5, 'button', 3, rl),
                                    ee(),
                                    Z(8, 'button', 0),
                                    Le('click', function () {
                                        return r.next();
                                    }),
                                    Oe(9, 'span', 4),
                                    ee(),
                                    Z(10, 'button', 0),
                                    Le('click', function () {
                                        return r.superNext();
                                    }),
                                    Oe(11, 'span', 5),
                                    ee()()),
                                    2 & i &&
                                        (vo(r.prefixCls),
                                        z(),
                                        dt('', r.prefixCls, '-super-prev-btn'),
                                        Zr('visibility', r.showSuperPreBtn ? 'visible' : 'hidden'),
                                        ct('title', r.superPreviousTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-prev-btn'),
                                        Zr('visibility', r.showPreBtn ? 'visible' : 'hidden'),
                                        ct('title', r.previousTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-view'),
                                        z(),
                                        es(r.selectors),
                                        z(2),
                                        dt('', r.prefixCls, '-next-btn'),
                                        Zr('visibility', r.showNextBtn ? 'visible' : 'hidden'),
                                        ct('title', r.nextTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-super-next-btn'),
                                        Zr('visibility', r.showSuperNextBtn ? 'visible' : 'hidden'),
                                        ct('title', r.superNextTitle()));
                            },
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                vne = (() => {
                    class t extends n3 {
                        constructor(e) {
                            super(), (this.dateHelper = e), (this.MAX_ROW = 4), (this.MAX_COL = 3);
                        }
                        makeHeadRow() {
                            return [];
                        }
                        makeBodyRows() {
                            const e = [];
                            let i = 0;
                            for (let r = 0; r < this.MAX_ROW; r++) {
                                const s = { dateCells: [], trackByIndex: r };
                                for (let o = 0; o < this.MAX_COL; o++) {
                                    const a = this.activeDate.setMonth(i),
                                        l = this.isDisabledMonth(a),
                                        c = this.dateHelper.format(a.nativeDate, 'MMM'),
                                        f = {
                                            trackByIndex: o,
                                            value: a.nativeDate,
                                            isDisabled: l,
                                            isSelected: a.isSameMonth(this.value),
                                            content: c,
                                            title: c,
                                            classMap: {},
                                            cellRender: Eu(this.cellRender, a),
                                            fullCellRender: Eu(this.fullCellRender, a),
                                            onClick: () => this.chooseMonth(f.value.getMonth()),
                                            onMouseEnter: () => this.cellHover.emit(a),
                                        };
                                    this.addCellProperty(f, a), s.dateCells.push(f), i++;
                                }
                                e.push(s);
                            }
                            return e;
                        }
                        isDisabledMonth(e) {
                            if (!this.disabledDate) return !1;
                            for (let r = e.setDate(1); r.getMonth() === e.getMonth(); r = r.addDays(1))
                                if (!this.disabledDate(r.nativeDate)) return !1;
                            return !0;
                        }
                        addCellProperty(e, i) {
                            if (this.hasRangeValue()) {
                                const [r, s] = this.hoverValue,
                                    [o, a] = this.selectedValue;
                                o?.isSameMonth(i) && ((e.isSelectedStart = !0), (e.isSelected = !0)),
                                    a?.isSameMonth(i) && ((e.isSelectedEnd = !0), (e.isSelected = !0)),
                                    r &&
                                        s &&
                                        ((e.isHoverStart = r.isSameMonth(i)),
                                        (e.isHoverEnd = s.isSameMonth(i)),
                                        (e.isLastCellInPanel = 11 === i.getMonth()),
                                        (e.isFirstCellInPanel = 0 === i.getMonth()),
                                        (e.isInHoverRange = r.isBeforeMonth(i) && i.isBeforeMonth(s))),
                                    (e.isStartSingle = o && !a),
                                    (e.isEndSingle = !o && a),
                                    (e.isInSelectedRange = o?.isBeforeMonth(i) && i?.isBeforeMonth(a)),
                                    (e.isRangeStartNearHover = o && e.isInHoverRange),
                                    (e.isRangeEndNearHover = a && e.isInHoverRange);
                            } else i.isSameMonth(this.value) && (e.isSelected = !0);
                            e.classMap = this.getClassMap(e);
                        }
                        chooseMonth(e) {
                            (this.value = this.activeDate.setMonth(e)), this.valueChange.emit(this.value);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Aa));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['month-table']],
                            exportAs: ['monthTable'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 5,
                            vars: 1,
                            consts: [
                                ['cellspacing', '0', 'role', 'grid', 1, 'ant-picker-content'],
                                ['role', 'row', 3, 'ngClass'],
                                ['role', 'row'],
                                ['role', 'columnheader'],
                                ['role', 'columnheader', 3, 'title'],
                                ['role', 'gridcell', 3, 'class'],
                                ['role', 'gridcell', 3, 'title', 'ngClass'],
                                ['role', 'gridcell'],
                                ['role', 'gridcell', 3, 'click', 'mouseenter', 'title', 'ngClass'],
                                [4, 'ngTemplateOutlet', 'ngTemplateOutletContext'],
                                [3, 'innerHTML'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'table', 0),
                                    ue(1, Hee, 5, 1, 'thead'),
                                    Z(2, 'tbody'),
                                    Jr(3, Jee, 4, 2, 'tr', 1, Ac),
                                    ee()()),
                                    2 & i &&
                                        (z(), dn(1, r.headRow && r.headRow.length > 0 ? 1 : -1), z(2), es(r.bodyRows));
                            },
                            dependencies: [sl, Al],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                _ne = (() => {
                    class t extends t3 {
                        constructor(e) {
                            super(), (this.dateHelper = e);
                        }
                        getSelectors() {
                            return [
                                {
                                    className: `${this.prefixCls}-year-btn`,
                                    title: this.locale.yearSelect,
                                    onClick: () => this.changeMode('year'),
                                    label: this.dateHelper.format(this.value.nativeDate, e3(this.locale.yearFormat)),
                                },
                                {
                                    className: `${this.prefixCls}-month-btn`,
                                    title: this.locale.monthSelect,
                                    onClick: () => this.changeMode('month'),
                                    label: this.dateHelper.format(
                                        this.value.nativeDate,
                                        this.locale.monthFormat || 'MMM',
                                    ),
                                },
                            ];
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Aa));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['date-header']],
                            exportAs: ['dateHeader'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 12,
                            vars: 30,
                            consts: [
                                ['role', 'button', 'type', 'button', 'tabindex', '-1', 3, 'click', 'title'],
                                [1, 'ant-picker-super-prev-icon'],
                                [1, 'ant-picker-prev-icon'],
                                ['role', 'button', 'type', 'button', 3, 'class', 'title'],
                                [1, 'ant-picker-next-icon'],
                                [1, 'ant-picker-super-next-icon'],
                                ['role', 'button', 'type', 'button', 3, 'click', 'title'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'div')(1, 'button', 0),
                                    Le('click', function () {
                                        return r.superPrevious();
                                    }),
                                    Oe(2, 'span', 1),
                                    ee(),
                                    Z(3, 'button', 0),
                                    Le('click', function () {
                                        return r.previous();
                                    }),
                                    Oe(4, 'span', 2),
                                    ee(),
                                    Z(5, 'div'),
                                    Jr(6, ete, 2, 5, 'button', 3, rl),
                                    ee(),
                                    Z(8, 'button', 0),
                                    Le('click', function () {
                                        return r.next();
                                    }),
                                    Oe(9, 'span', 4),
                                    ee(),
                                    Z(10, 'button', 0),
                                    Le('click', function () {
                                        return r.superNext();
                                    }),
                                    Oe(11, 'span', 5),
                                    ee()()),
                                    2 & i &&
                                        (vo(r.prefixCls),
                                        z(),
                                        dt('', r.prefixCls, '-super-prev-btn'),
                                        Zr('visibility', r.showSuperPreBtn ? 'visible' : 'hidden'),
                                        ct('title', r.superPreviousTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-prev-btn'),
                                        Zr('visibility', r.showPreBtn ? 'visible' : 'hidden'),
                                        ct('title', r.previousTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-view'),
                                        z(),
                                        es(r.selectors),
                                        z(2),
                                        dt('', r.prefixCls, '-next-btn'),
                                        Zr('visibility', r.showNextBtn ? 'visible' : 'hidden'),
                                        ct('title', r.nextTitle()),
                                        z(2),
                                        dt('', r.prefixCls, '-super-next-btn'),
                                        Zr('visibility', r.showSuperNextBtn ? 'visible' : 'hidden'),
                                        ct('title', r.superNextTitle()));
                            },
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                yne = (() => {
                    class t extends n3 {
                        constructor(e, i) {
                            super(), (this.i18n = e), (this.dateHelper = i);
                        }
                        changeValueFromInside(e) {
                            (this.activeDate = this.activeDate
                                .setYear(e.getYear())
                                .setMonth(e.getMonth())
                                .setDate(e.getDate())),
                                this.valueChange.emit(this.activeDate),
                                this.activeDate.isSameMonth(this.value) || this.render();
                        }
                        makeHeadRow() {
                            const e = [],
                                i = this.activeDate.calendarStart({
                                    weekStartsOn: this.dateHelper.getFirstDayOfWeek(),
                                });
                            for (let r = 0; r < this.MAX_COL; r++) {
                                const s = i.addDays(r);
                                e.push({
                                    trackByIndex: null,
                                    value: s.nativeDate,
                                    title: this.dateHelper.format(s.nativeDate, 'E'),
                                    content: this.dateHelper.format(s.nativeDate, this.getVeryShortWeekFormat()),
                                    isSelected: !1,
                                    isDisabled: !1,
                                    onClick() {},
                                    onMouseEnter() {},
                                });
                            }
                            return e;
                        }
                        getVeryShortWeekFormat() {
                            return 0 === this.i18n.getLocaleId().toLowerCase().indexOf('zh') ? 'EEEEE' : 'EEEEEE';
                        }
                        makeBodyRows() {
                            const e = [],
                                i = this.activeDate.calendarStart({
                                    weekStartsOn: this.dateHelper.getFirstDayOfWeek(),
                                });
                            for (let r = 0; r < this.MAX_ROW; r++) {
                                const s = i.addDays(7 * r),
                                    o = { isActive: !1, dateCells: [], trackByIndex: r };
                                for (let a = 0; a < 7; a++) {
                                    const l = s.addDays(a),
                                        c = e3(this.i18n.getLocaleData('DatePicker.lang.dateFormat', 'YYYY-MM-DD')),
                                        f = this.dateHelper.format(l.nativeDate, c),
                                        g = this.dateHelper.format(l.nativeDate, 'dd'),
                                        E = {
                                            trackByIndex: a,
                                            value: l.nativeDate,
                                            label: g,
                                            isSelected: !1,
                                            isDisabled: !1,
                                            isToday: !1,
                                            title: f,
                                            cellRender: Eu(this.cellRender, l),
                                            fullCellRender: Eu(this.fullCellRender, l),
                                            content: `${l.getDate()}`,
                                            onClick: () => this.changeValueFromInside(l),
                                            onMouseEnter: () => this.cellHover.emit(l),
                                        };
                                    this.addCellProperty(E, l),
                                        this.showWeek &&
                                            !o.weekNum &&
                                            (o.weekNum = this.dateHelper.getISOWeek(l.nativeDate)),
                                        l.isSameDay(this.value) && (o.isActive = l.isSameDay(this.value)),
                                        o.dateCells.push(E);
                                }
                                (o.classMap = {
                                    'ant-picker-week-panel-row': this.canSelectWeek,
                                    'ant-picker-week-panel-row-selected': this.canSelectWeek && o.isActive,
                                }),
                                    e.push(o);
                            }
                            return e;
                        }
                        addCellProperty(e, i) {
                            if (
                                ((e.isTemplateRef = dg(e.cellRender)),
                                (e.isNonEmptyString = ug(e.cellRender)),
                                this.hasRangeValue() && !this.canSelectWeek)
                            ) {
                                const [r, s] = this.hoverValue,
                                    [o, a] = this.selectedValue;
                                o?.isSameDay(i) && ((e.isSelectedStart = !0), (e.isSelected = !0)),
                                    a?.isSameDay(i) && ((e.isSelectedEnd = !0), (e.isSelected = !0)),
                                    r &&
                                        s &&
                                        ((e.isHoverStart = r.isSameDay(i)),
                                        (e.isHoverEnd = s.isSameDay(i)),
                                        (e.isLastCellInPanel = i.isLastDayOfMonth()),
                                        (e.isFirstCellInPanel = i.isFirstDayOfMonth()),
                                        (e.isInHoverRange = r.isBeforeDay(i) && i.isBeforeDay(s))),
                                    (e.isStartSingle = o && !a),
                                    (e.isEndSingle = !o && a),
                                    (e.isInSelectedRange = o?.isBeforeDay(i) && i.isBeforeDay(a)),
                                    (e.isRangeStartNearHover = o && e.isInHoverRange),
                                    (e.isRangeEndNearHover = a && e.isInHoverRange);
                            }
                            (e.isToday = i.isToday()),
                                (e.isSelected = i.isSameDay(this.value)),
                                (e.isDisabled = !!this.disabledDate?.(i.nativeDate)),
                                (e.classMap = this.getClassMap(e));
                        }
                        getClassMap(e) {
                            const i = new Wn(e.value);
                            return {
                                ...super.getClassMap(e),
                                'ant-picker-cell-today': !!e.isToday,
                                'ant-picker-cell-in-view': i.isSameMonth(this.activeDate),
                            };
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(zu), te(Aa));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['date-table']],
                            inputs: { locale: 'locale' },
                            exportAs: ['dateTable'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 5,
                            vars: 1,
                            consts: [
                                ['cellspacing', '0', 'role', 'grid', 1, 'ant-picker-content'],
                                ['role', 'row', 3, 'ngClass'],
                                ['role', 'row'],
                                ['role', 'columnheader'],
                                ['role', 'columnheader', 3, 'title'],
                                ['role', 'gridcell', 3, 'class'],
                                ['role', 'gridcell', 3, 'title', 'ngClass'],
                                ['role', 'gridcell'],
                                ['role', 'gridcell', 3, 'click', 'mouseenter', 'title', 'ngClass'],
                                [4, 'ngTemplateOutlet', 'ngTemplateOutletContext'],
                                [3, 'innerHTML'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (Z(0, 'table', 0),
                                    ue(1, ite, 5, 1, 'thead'),
                                    Z(2, 'tbody'),
                                    Jr(3, gte, 4, 2, 'tr', 1, Ac),
                                    ee()()),
                                    2 & i &&
                                        (z(), dn(1, r.headRow && r.headRow.length > 0 ? 1 : -1), z(2), es(r.bodyRows));
                            },
                            dependencies: [sl, Al],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                bne = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })(),
                Rx = (() => {
                    class t {
                        constructor() {
                            (this.panelModeChange = new Ft()),
                                (this.headerChange = new Ft()),
                                (this.selectDate = new Ft()),
                                (this.selectTime = new Ft()),
                                (this.cellHover = new Ft()),
                                (this.prefixCls = Zf);
                        }
                        enablePrevNext(e, i) {
                            return !(
                                !this.showTimePicker &&
                                i === this.endPanelMode &&
                                (('left' === this.partType && 'next' === e) ||
                                    ('right' === this.partType && 'prev' === e))
                            );
                        }
                        onSelectTime(e) {
                            this.selectTime.emit(new Wn(e));
                        }
                        onSelectDate(e) {
                            const i = e instanceof Wn ? e : new Wn(e),
                                r = this.timeOptions && this.timeOptions.nzDefaultOpenValue;
                            !this.value && r && i.setHms(r.getHours(), r.getMinutes(), r.getSeconds()),
                                this.selectDate.emit(i);
                        }
                        onChooseMonth(e) {
                            (this.activeDate = this.activeDate.setMonth(e.getMonth())),
                                'month' === this.endPanelMode
                                    ? ((this.value = e), this.selectDate.emit(e))
                                    : (this.headerChange.emit(e), this.panelModeChange.emit(this.endPanelMode));
                        }
                        onChooseYear(e) {
                            (this.activeDate = this.activeDate.setYear(e.getYear())),
                                'year' === this.endPanelMode
                                    ? ((this.value = e), this.selectDate.emit(e))
                                    : (this.headerChange.emit(e), this.panelModeChange.emit(this.endPanelMode));
                        }
                        onChooseDecade(e) {
                            (this.activeDate = this.activeDate.setYear(e.getYear())),
                                'decade' === this.endPanelMode
                                    ? ((this.value = e), this.selectDate.emit(e))
                                    : (this.headerChange.emit(e), this.panelModeChange.emit('year'));
                        }
                        ngOnChanges(e) {
                            e.activeDate && !e.activeDate.currentValue && (this.activeDate = new Wn()),
                                e.panelMode && 'time' === e.panelMode.currentValue && (this.panelMode = 'date');
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['inner-popup']],
                            inputs: {
                                activeDate: 'activeDate',
                                endPanelMode: 'endPanelMode',
                                panelMode: 'panelMode',
                                showWeek: 'showWeek',
                                locale: 'locale',
                                showTimePicker: 'showTimePicker',
                                timeOptions: 'timeOptions',
                                disabledDate: 'disabledDate',
                                dateRender: 'dateRender',
                                selectedValue: 'selectedValue',
                                hoverValue: 'hoverValue',
                                value: 'value',
                                partType: 'partType',
                            },
                            outputs: {
                                panelModeChange: 'panelModeChange',
                                headerChange: 'headerChange',
                                selectDate: 'selectDate',
                                selectTime: 'selectTime',
                                cellHover: 'cellHover',
                            },
                            exportAs: ['innerPopup'],
                            standalone: !0,
                            features: [D, Qi],
                            decls: 7,
                            vars: 8,
                            consts: [
                                [
                                    3,
                                    'nzInDatePicker',
                                    'ngModel',
                                    'format',
                                    'nzHourStep',
                                    'nzMinuteStep',
                                    'nzSecondStep',
                                    'nzDisabledHours',
                                    'nzDisabledMinutes',
                                    'nzDisabledSeconds',
                                    'nzHideDisabledOptions',
                                    'nzDefaultOpenValue',
                                    'nzUse12Hours',
                                    'nzAddOn',
                                ],
                                [
                                    3,
                                    'valueChange',
                                    'panelModeChange',
                                    'value',
                                    'locale',
                                    'showSuperPreBtn',
                                    'showSuperNextBtn',
                                    'showNextBtn',
                                    'showPreBtn',
                                ],
                                [3, 'valueChange', 'activeDate', 'value', 'locale', 'disabledDate'],
                                [
                                    3,
                                    'valueChange',
                                    'cellHover',
                                    'activeDate',
                                    'value',
                                    'locale',
                                    'disabledDate',
                                    'selectedValue',
                                    'hoverValue',
                                ],
                                [
                                    3,
                                    'valueChange',
                                    'cellHover',
                                    'value',
                                    'activeDate',
                                    'locale',
                                    'disabledDate',
                                    'selectedValue',
                                    'hoverValue',
                                ],
                                [
                                    3,
                                    'valueChange',
                                    'panelModeChange',
                                    'value',
                                    'locale',
                                    'showSuperPreBtn',
                                    'showSuperNextBtn',
                                    'showPreBtn',
                                    'showNextBtn',
                                ],
                                [
                                    3,
                                    'valueChange',
                                    'cellHover',
                                    'locale',
                                    'showWeek',
                                    'value',
                                    'activeDate',
                                    'disabledDate',
                                    'cellRender',
                                    'selectedValue',
                                    'hoverValue',
                                    'canSelectWeek',
                                ],
                                [
                                    3,
                                    'ngModelChange',
                                    'nzInDatePicker',
                                    'ngModel',
                                    'format',
                                    'nzHourStep',
                                    'nzMinuteStep',
                                    'nzSecondStep',
                                    'nzDisabledHours',
                                    'nzDisabledMinutes',
                                    'nzDisabledSeconds',
                                    'nzHideDisabledOptions',
                                    'nzDefaultOpenValue',
                                    'nzUse12Hours',
                                    'nzAddOn',
                                ],
                            ],
                            template: function (i, r) {
                                if (
                                    (1 & i &&
                                        (Z(0, 'div')(1, 'div'),
                                        ue(2, vte, 3, 13)(3, _te, 3, 15)(4, yte, 3, 15)(5, bte, 3, 18),
                                        ee(),
                                        ue(6, Cte, 1, 13, 'nz-time-picker-panel', 0),
                                        ee()),
                                    2 & i)
                                ) {
                                    let s;
                                    On('ant-picker-datetime-panel', r.showTimePicker),
                                        z(),
                                        F1('', r.prefixCls, '-', r.panelMode, '-panel'),
                                        z(),
                                        dn(
                                            2,
                                            'decade' === (s = r.panelMode)
                                                ? 2
                                                : 'year' === s
                                                ? 3
                                                : 'month' === s
                                                ? 4
                                                : 5,
                                        ),
                                        z(4),
                                        dn(6, r.showTimePicker && r.timeOptions ? 6 : -1);
                                }
                            },
                            dependencies: [bne, _ne, yne, une, fne, gne, vne, mne, pne, Ox, t5, nh, eo, Fs],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                i5 = (() => {
                    class t {
                        get hasTimePicker() {
                            return !!this.showTime;
                        }
                        get hasFooter() {
                            return this.showToday || this.hasTimePicker || !!this.extraFooter || !!this.ranges;
                        }
                        get arrowPosition() {
                            return 'rtl' === this.dir
                                ? { right: `${this.datePickerService?.arrowLeft}px` }
                                : { left: `${this.datePickerService?.arrowLeft}px` };
                        }
                        constructor(e, i, r, s) {
                            (this.datePickerService = e),
                                (this.cdr = i),
                                (this.ngZone = r),
                                (this.host = s),
                                (this.inline = !1),
                                (this.dir = 'ltr'),
                                (this.panelModeChange = new Ft()),
                                (this.calendarChange = new Ft()),
                                (this.resultOk = new Ft()),
                                (this.prefixCls = Zf),
                                (this.endPanelMode = 'date'),
                                (this.timeOptions = null),
                                (this.hoverValue = []),
                                (this.checkedPartArr = [!1, !1]),
                                (this.destroy$ = new vt()),
                                (this.disabledStartTime = o => this.disabledTime && this.disabledTime(o, 'start')),
                                (this.disabledEndTime = o => this.disabledTime && this.disabledTime(o, 'end'));
                        }
                        ngOnInit() {
                            Xm(this.datePickerService.valueChange$, this.datePickerService.inputPartChange$)
                                .pipe(nn(this.destroy$))
                                .subscribe(() => {
                                    this.updateActiveDate(), this.cdr.markForCheck();
                                }),
                                this.ngZone.runOutsideAngular(() => {
                                    ca(this.host.nativeElement, 'mousedown')
                                        .pipe(nn(this.destroy$))
                                        .subscribe(e => e.preventDefault());
                                });
                        }
                        ngOnChanges(e) {
                            (e.showTime || e.disabledTime) && this.showTime && this.buildTimeOptions(),
                                e.panelMode && (this.endPanelMode = this.panelMode),
                                e.defaultPickerValue && this.updateActiveDate();
                        }
                        ngOnDestroy() {
                            this.destroy$.next(!0), this.destroy$.complete();
                        }
                        updateActiveDate() {
                            const e = this.datePickerService.hasValue()
                                ? this.datePickerService.value
                                : this.datePickerService.makeValue(this.defaultPickerValue);
                            this.datePickerService.setActiveDate(
                                e,
                                this.hasTimePicker,
                                this.getPanelMode(this.endPanelMode),
                            );
                        }
                        onClickOk() {
                            this.changeValueFromSelect(
                                this.isRange
                                    ? this.datePickerService.value[
                                          { left: 0, right: 1 }[this.datePickerService.activeInput]
                                      ]
                                    : this.datePickerService.value,
                            ),
                                this.resultOk.emit();
                        }
                        onClickToday(e) {
                            this.changeValueFromSelect(e, !this.showTime);
                        }
                        onCellHover(e) {
                            if (!this.isRange) return;
                            const r =
                                this.datePickerService.value[{ left: 1, right: 0 }[this.datePickerService.activeInput]];
                            r && (this.hoverValue = r.isBeforeDay(e) ? [r, e] : [e, r]);
                        }
                        onPanelModeChange(e, i) {
                            (this.panelMode = this.isRange
                                ? 0 === this.datePickerService.getActiveIndex(i)
                                    ? [e, this.panelMode[1]]
                                    : [this.panelMode[0], e]
                                : e),
                                this.panelModeChange.emit(this.panelMode);
                        }
                        onActiveDateChange(e, i) {
                            if (this.isRange) {
                                const r = [];
                                (r[this.datePickerService.getActiveIndex(i)] = e),
                                    this.datePickerService.setActiveDate(
                                        r,
                                        this.hasTimePicker,
                                        this.getPanelMode(this.endPanelMode, i),
                                    );
                            } else this.datePickerService.setActiveDate(e);
                        }
                        onSelectTime(e, i) {
                            if (this.isRange) {
                                const r = mh(this.datePickerService.value),
                                    s = this.datePickerService.getActiveIndex(i);
                                (r[s] = this.overrideHms(e, r[s])), this.datePickerService.setValue(r);
                            } else {
                                const r = this.overrideHms(e, this.datePickerService.value);
                                this.datePickerService.setValue(r);
                            }
                            this.datePickerService.inputPartChange$.next(null), this.buildTimeOptions();
                        }
                        changeValueFromSelect(e, i = !0) {
                            if (this.isRange) {
                                const r = mh(this.datePickerService.value),
                                    s = this.datePickerService.activeInput;
                                let o = s;
                                (r[this.datePickerService.getActiveIndex(s)] = e),
                                    (this.checkedPartArr[this.datePickerService.getActiveIndex(s)] = !0),
                                    (this.hoverValue = r),
                                    i
                                        ? this.inline
                                            ? ((o = this.reversedPart(s)),
                                              'right' === o &&
                                                  ((r[this.datePickerService.getActiveIndex(o)] = null),
                                                  (this.checkedPartArr[this.datePickerService.getActiveIndex(o)] = !1)),
                                              this.datePickerService.setValue(r),
                                              this.calendarChange.emit(r),
                                              this.isBothAllowed(r) &&
                                                  this.checkedPartArr[0] &&
                                                  this.checkedPartArr[1] &&
                                                  (this.clearHoverValue(), this.datePickerService.emitValue$.next()))
                                            : (PD(r) &&
                                                  ((o = this.reversedPart(s)),
                                                  (r[this.datePickerService.getActiveIndex(o)] = null),
                                                  (this.checkedPartArr[this.datePickerService.getActiveIndex(o)] = !1)),
                                              this.datePickerService.setValue(r),
                                              this.isBothAllowed(r) && this.checkedPartArr[0] && this.checkedPartArr[1]
                                                  ? (this.calendarChange.emit(r),
                                                    this.clearHoverValue(),
                                                    this.datePickerService.emitValue$.next())
                                                  : this.isAllowed(r) &&
                                                    ((o = this.reversedPart(s)), this.calendarChange.emit([e.clone()])))
                                        : this.datePickerService.setValue(r),
                                    this.datePickerService.inputPartChange$.next(o);
                            } else
                                this.datePickerService.setValue(e),
                                    this.datePickerService.inputPartChange$.next(null),
                                    i && this.isAllowed(e) && this.datePickerService.emitValue$.next();
                            this.buildTimeOptions();
                        }
                        reversedPart(e) {
                            return 'left' === e ? 'right' : 'left';
                        }
                        getPanelMode(e, i) {
                            return this.isRange ? e[this.datePickerService.getActiveIndex(i)] : e;
                        }
                        getValue(e) {
                            return this.isRange
                                ? (this.datePickerService.value || [])[this.datePickerService.getActiveIndex(e)]
                                : this.datePickerService.value;
                        }
                        getActiveDate(e) {
                            return this.isRange
                                ? this.datePickerService.activeDate[this.datePickerService.getActiveIndex(e)]
                                : this.datePickerService.activeDate;
                        }
                        isOneAllowed(e) {
                            const i = this.datePickerService.getActiveIndex();
                            return Jf(e[i], this.disabledDate, [this.disabledStartTime, this.disabledEndTime][i]);
                        }
                        isBothAllowed(e) {
                            return (
                                Jf(e[0], this.disabledDate, this.disabledStartTime) &&
                                Jf(e[1], this.disabledDate, this.disabledEndTime)
                            );
                        }
                        isAllowed(e, i = !1) {
                            return this.isRange
                                ? i
                                    ? this.isBothAllowed(e)
                                    : this.isOneAllowed(e)
                                : Jf(e, this.disabledDate, this.disabledTime);
                        }
                        getTimeOptions(e) {
                            return this.showTime && this.timeOptions
                                ? this.timeOptions instanceof Array
                                    ? this.timeOptions[this.datePickerService.getActiveIndex(e)]
                                    : this.timeOptions
                                : null;
                        }
                        onClickPresetRange(e) {
                            const i = 'function' == typeof e ? e() : e;
                            i &&
                                (this.datePickerService.setValue([new Wn(i[0]), new Wn(i[1])]),
                                this.datePickerService.emitValue$.next());
                        }
                        onPresetRangeMouseLeave() {
                            this.clearHoverValue();
                        }
                        onHoverPresetRange(e) {
                            'function' != typeof e && (this.hoverValue = [new Wn(e[0]), new Wn(e[1])]);
                        }
                        getObjectKeys(e) {
                            return e ? Object.keys(e) : [];
                        }
                        show(e) {
                            return !(this.showTime && this.isRange && this.datePickerService.activeInput !== e);
                        }
                        clearHoverValue() {
                            this.hoverValue = [];
                        }
                        buildTimeOptions() {
                            if (this.showTime) {
                                const e = 'object' == typeof this.showTime ? this.showTime : {};
                                if (this.isRange) {
                                    const i = this.datePickerService.value;
                                    this.timeOptions = [
                                        this.overrideTimeOptions(e, i[0], 'start'),
                                        this.overrideTimeOptions(e, i[1], 'end'),
                                    ];
                                } else this.timeOptions = this.overrideTimeOptions(e, this.datePickerService.value);
                            } else this.timeOptions = null;
                        }
                        overrideTimeOptions(e, i, r) {
                            let s;
                            return (
                                (s = r
                                    ? 'start' === r
                                        ? this.disabledStartTime
                                        : this.disabledEndTime
                                    : this.disabledTime),
                                { ...e, ...Nx(i, s) }
                            );
                        }
                        overrideHms(e, i) {
                            return (
                                (e = e || new Wn()),
                                (i = i || new Wn()).setHms(e.getHours(), e.getMinutes(), e.getSeconds())
                            );
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(n5), te(kr), te(en), te(Pn));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['date-range-popup']],
                            inputs: {
                                isRange: 'isRange',
                                inline: 'inline',
                                showWeek: 'showWeek',
                                locale: 'locale',
                                disabledDate: 'disabledDate',
                                disabledTime: 'disabledTime',
                                showToday: 'showToday',
                                showNow: 'showNow',
                                showTime: 'showTime',
                                extraFooter: 'extraFooter',
                                ranges: 'ranges',
                                dateRender: 'dateRender',
                                panelMode: 'panelMode',
                                defaultPickerValue: 'defaultPickerValue',
                                dir: 'dir',
                            },
                            outputs: {
                                panelModeChange: 'panelModeChange',
                                calendarChange: 'calendarChange',
                                resultOk: 'resultOk',
                            },
                            exportAs: ['dateRangePopup'],
                            standalone: !0,
                            features: [D, Qi],
                            decls: 8,
                            vars: 1,
                            consts: [
                                ['tplInnerPopup', ''],
                                ['tplFooter', ''],
                                ['tplRangeQuickSelector', ''],
                                [3, 'class'],
                                [3, 'ngStyle'],
                                [4, 'ngTemplateOutlet'],
                                [4, 'ngTemplateOutlet', 'ngTemplateOutletContext'],
                                ['tabindex', '-1'],
                                [
                                    3,
                                    'panelModeChange',
                                    'cellHover',
                                    'selectDate',
                                    'selectTime',
                                    'headerChange',
                                    'showWeek',
                                    'endPanelMode',
                                    'partType',
                                    'locale',
                                    'showTimePicker',
                                    'timeOptions',
                                    'panelMode',
                                    'activeDate',
                                    'value',
                                    'disabledDate',
                                    'dateRender',
                                    'selectedValue',
                                    'hoverValue',
                                ],
                                [
                                    3,
                                    'locale',
                                    'isRange',
                                    'showToday',
                                    'showNow',
                                    'hasTimePicker',
                                    'okDisabled',
                                    'extraFooter',
                                    'rangeQuickSelector',
                                ],
                                [
                                    3,
                                    'clickOk',
                                    'clickToday',
                                    'locale',
                                    'isRange',
                                    'showToday',
                                    'showNow',
                                    'hasTimePicker',
                                    'okDisabled',
                                    'extraFooter',
                                    'rangeQuickSelector',
                                ],
                                [3, 'click', 'mouseenter', 'mouseleave'],
                                [1, 'ant-tag', 'ant-tag-blue'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    ue(0, Ete, 7, 17, 'div', 3)(1, Lte, 4, 13)(
                                        2,
                                        Ote,
                                        2,
                                        18,
                                        'ng-template',
                                        null,
                                        0,
                                        Xs,
                                    )(4, Pte, 1, 1, 'ng-template', null, 1, Xs)(
                                        6,
                                        Fte,
                                        2,
                                        0,
                                        'ng-template',
                                        null,
                                        2,
                                        Xs,
                                    ),
                                    2 & i && dn(0, r.isRange ? 0 : 1);
                            },
                            dependencies: [Rx, Al, Fx, mc],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })();
            const r5 = { position: 'relative' };
            let s5 = (() => {
                    class t {
                        get nzShowTime() {
                            return this.showTime;
                        }
                        set nzShowTime(e) {
                            this.showTime = 'object' == typeof e ? e : hg(e);
                        }
                        get realOpenState() {
                            return this.isOpenHandledByUser() ? !!this.nzOpen : this.overlayOpen;
                        }
                        ngAfterViewInit() {
                            this.nzAutoFocus && this.focus(),
                                this.isRange &&
                                    this.platform.isBrowser &&
                                    this.nzResizeObserver
                                        .observe(this.elementRef)
                                        .pipe(nn(this.destroy$))
                                        .subscribe(() => {
                                            this.updateInputWidthAndArrowLeft();
                                        }),
                                this.datePickerService.inputPartChange$.pipe(nn(this.destroy$)).subscribe(e => {
                                    e && (this.datePickerService.activeInput = e),
                                        this.focus(),
                                        this.updateInputWidthAndArrowLeft();
                                }),
                                this.platform.isBrowser &&
                                    this.ngZone.runOutsideAngular(() =>
                                        ca(this.elementRef.nativeElement, 'mousedown')
                                            .pipe(nn(this.destroy$))
                                            .subscribe(e => {
                                                'input' !== e.target.tagName.toLowerCase() && e.preventDefault();
                                            }),
                                    );
                        }
                        updateInputWidthAndArrowLeft() {
                            this.inputWidth = this.rangePickerInputs?.first?.nativeElement.offsetWidth || 0;
                            const e = { position: 'absolute', width: `${this.inputWidth}px` };
                            (this.datePickerService.arrowLeft =
                                'left' === this.datePickerService.activeInput
                                    ? 0
                                    : this.inputWidth + this.separatorElement?.nativeElement.offsetWidth || 0),
                                (this.activeBarStyle =
                                    'rtl' === this.dir
                                        ? { ...e, right: `${this.datePickerService.arrowLeft}px` }
                                        : { ...e, left: `${this.datePickerService.arrowLeft}px` }),
                                this.cdr.markForCheck();
                        }
                        getInput(e) {
                            if (!this.nzInline)
                                return this.isRange
                                    ? 'left' === e
                                        ? this.rangePickerInputs?.first.nativeElement
                                        : this.rangePickerInputs?.last.nativeElement
                                    : this.pickerInput.nativeElement;
                        }
                        focus() {
                            const e = this.getInput(this.datePickerService.activeInput);
                            this.document.activeElement !== e && e?.focus();
                        }
                        onFocus(e, i) {
                            e.preventDefault(),
                                i && this.datePickerService.inputPartChange$.next(i),
                                this.renderClass(!0);
                        }
                        onFocusout(e) {
                            e.preventDefault(),
                                this.onTouchedFn(),
                                this.elementRef.nativeElement.contains(e.relatedTarget) || this.checkAndClose(),
                                this.renderClass(!1);
                        }
                        open() {
                            this.nzInline ||
                                (!this.realOpenState &&
                                    !this.nzDisabled &&
                                    (this.updateInputWidthAndArrowLeft(),
                                    (this.overlayOpen = !0),
                                    this.nzOnOpenChange.emit(!0),
                                    this.focus(),
                                    this.cdr.markForCheck()));
                        }
                        close() {
                            this.nzInline ||
                                (this.realOpenState && ((this.overlayOpen = !1), this.nzOnOpenChange.emit(!1)));
                        }
                        get showClear() {
                            return (
                                !this.nzDisabled &&
                                !this.isEmptyValue(this.datePickerService.value) &&
                                this.nzAllowClear
                            );
                        }
                        checkAndClose() {
                            if (this.realOpenState)
                                if (this.panel.isAllowed(this.datePickerService.value, !0)) {
                                    if (
                                        Array.isArray(this.datePickerService.value) &&
                                        PD(this.datePickerService.value)
                                    ) {
                                        const e = this.datePickerService.getActiveIndex();
                                        return void this.panel.changeValueFromSelect(
                                            this.datePickerService.value[e],
                                            !0,
                                        );
                                    }
                                    this.updateInputValue(), this.datePickerService.emitValue$.next();
                                } else
                                    this.datePickerService.setValue(this.datePickerService.initialValue), this.close();
                        }
                        onClickInputBox(e) {
                            e.stopPropagation(), this.focus(), this.isOpenHandledByUser() || this.open();
                        }
                        onOverlayKeydown(e) {
                            27 === e.keyCode && this.datePickerService.initValue();
                        }
                        onPositionChange(e) {
                            (this.currentPositionX = e.connectionPair.originX),
                                (this.currentPositionY = e.connectionPair.originY),
                                this.cdr.detectChanges();
                        }
                        onClickClear(e) {
                            e.preventDefault(),
                                e.stopPropagation(),
                                this.datePickerService.initValue(!0),
                                this.datePickerService.emitValue$.next();
                        }
                        updateInputValue() {
                            const e = this.datePickerService.value;
                            (this.inputValue = this.isRange
                                ? e
                                    ? e.map(i => this.formatValue(i))
                                    : ['', '']
                                : this.formatValue(e)),
                                this.cdr.markForCheck();
                        }
                        formatValue(e) {
                            return this.dateHelper.format(e && e.nativeDate, this.nzFormat);
                        }
                        onInputChange(e, i = !1) {
                            if (
                                !this.platform.TRIDENT &&
                                this.document.activeElement === this.getInput(this.datePickerService.activeInput) &&
                                !this.realOpenState
                            )
                                return void this.open();
                            const r = this.checkValidDate(e);
                            r && this.realOpenState && this.panel.changeValueFromSelect(r, i);
                        }
                        onKeyupEnter(e) {
                            this.onInputChange(e.target.value, !0);
                        }
                        checkValidDate(e) {
                            const i = new Wn(this.dateHelper.parseDate(e, this.nzFormat));
                            return i.isValid() && e === this.dateHelper.format(i.nativeDate, this.nzFormat) ? i : null;
                        }
                        getPlaceholder(e) {
                            return this.isRange
                                ? this.nzPlaceHolder[this.datePickerService.getActiveIndex(e)]
                                : this.nzPlaceHolder;
                        }
                        isEmptyValue(e) {
                            return null === e || (this.isRange ? !e || !Array.isArray(e) || e.every(i => !i) : !e);
                        }
                        isOpenHandledByUser() {
                            return void 0 !== this.nzOpen;
                        }
                        constructor(e, i, r, s, o, a, l, c, f, g, E, P, V, W, ie, he) {
                            (this.nzConfigService = e),
                                (this.datePickerService = i),
                                (this.i18n = r),
                                (this.cdr = s),
                                (this.renderer = o),
                                (this.ngZone = a),
                                (this.elementRef = l),
                                (this.dateHelper = c),
                                (this.nzResizeObserver = f),
                                (this.platform = g),
                                (this.destroy$ = E),
                                (this.directionality = V),
                                (this.noAnimation = W),
                                (this.nzFormStatusService = ie),
                                (this.nzFormNoStatusService = he),
                                (this._nzModuleName = 'datePicker'),
                                (this.isRange = !1),
                                (this.dir = 'ltr'),
                                (this.statusCls = {}),
                                (this.status = ''),
                                (this.hasFeedback = !1),
                                (this.panelMode = 'date'),
                                (this.isCustomPlaceHolder = !1),
                                (this.isCustomFormat = !1),
                                (this.showTime = !1),
                                (this.isNzDisableFirstChange = !0),
                                (this.nzAllowClear = !0),
                                (this.nzAutoFocus = !1),
                                (this.nzDisabled = !1),
                                (this.nzBorderless = !1),
                                (this.nzInputReadOnly = !1),
                                (this.nzInline = !1),
                                (this.nzPlaceHolder = ''),
                                (this.nzPopupStyle = r5),
                                (this.nzSize = 'default'),
                                (this.nzStatus = ''),
                                (this.nzShowToday = !0),
                                (this.nzMode = 'date'),
                                (this.nzShowNow = !0),
                                (this.nzDefaultPickerValue = null),
                                (this.nzSeparator = void 0),
                                (this.nzSuffixIcon = 'calendar'),
                                (this.nzBackdrop = !1),
                                (this.nzId = null),
                                (this.nzPlacement = 'bottomLeft'),
                                (this.nzShowWeekNumber = !1),
                                (this.nzOnPanelChange = new Ft()),
                                (this.nzOnCalendarChange = new Ft()),
                                (this.nzOnOk = new Ft()),
                                (this.nzOnOpenChange = new Ft()),
                                (this.inputSize = 12),
                                (this.prefixCls = Zf),
                                (this.activeBarStyle = {}),
                                (this.overlayOpen = !1),
                                (this.overlayPositions = [...Ix]),
                                (this.currentPositionX = 'start'),
                                (this.currentPositionY = 'bottom'),
                                (this.onChangeFn = () => {}),
                                (this.onTouchedFn = () => {}),
                                (this.document = P),
                                (this.origin = new _h(this.elementRef));
                        }
                        ngOnInit() {
                            this.nzFormStatusService?.formStatusChanges
                                .pipe(
                                    n0((e, i) => e.status === i.status && e.hasFeedback === i.hasFeedback),
                                    wx(this.nzFormNoStatusService ? this.nzFormNoStatusService.noFormStatus : Uo(!1)),
                                    Ct(([{ status: e, hasFeedback: i }, r]) => ({
                                        status: r ? '' : e,
                                        hasFeedback: i,
                                    })),
                                    nn(this.destroy$),
                                )
                                .subscribe(({ status: e, hasFeedback: i }) => {
                                    this.setStatusStyles(e, i);
                                }),
                                this.nzLocale ||
                                    this.i18n.localeChange.pipe(nn(this.destroy$)).subscribe(() => this.setLocale()),
                                (this.datePickerService.isRange = this.isRange),
                                this.datePickerService.initValue(!0),
                                this.datePickerService.emitValue$.pipe(nn(this.destroy$)).subscribe(() => {
                                    const e = this.showTime ? 'second' : 'day',
                                        i = this.datePickerService.value,
                                        r = this.datePickerService.initialValue;
                                    if (!this.isRange && i?.isSame(r?.nativeDate, e))
                                        return this.onTouchedFn(), this.close();
                                    if (this.isRange) {
                                        const [s, o] = r,
                                            [a, l] = i;
                                        if (s?.isSame(a?.nativeDate, e) && o?.isSame(l?.nativeDate, e))
                                            return this.onTouchedFn(), this.close();
                                    }
                                    if (((this.datePickerService.initialValue = mh(i)), this.isRange)) {
                                        const s = i;
                                        this.onChangeFn(
                                            s.length ? [s[0]?.nativeDate ?? null, s[1]?.nativeDate ?? null] : [],
                                        );
                                    } else this.onChangeFn(i ? i.nativeDate : null);
                                    this.onTouchedFn(), this.close();
                                }),
                                this.directionality.change?.pipe(nn(this.destroy$)).subscribe(e => {
                                    (this.dir = e), this.cdr.detectChanges();
                                }),
                                (this.dir = this.directionality.value),
                                (this.inputValue = this.isRange ? ['', ''] : ''),
                                this.setModeAndFormat(),
                                this.datePickerService.valueChange$.pipe(nn(this.destroy$)).subscribe(() => {
                                    this.updateInputValue();
                                });
                        }
                        ngOnChanges(e) {
                            const { nzStatus: i, nzPlacement: r } = e;
                            e.nzPopupStyle &&
                                (this.nzPopupStyle = this.nzPopupStyle ? { ...this.nzPopupStyle, ...r5 } : r5),
                                e.nzPlaceHolder?.currentValue && (this.isCustomPlaceHolder = !0),
                                e.nzFormat?.currentValue && (this.isCustomFormat = !0),
                                e.nzLocale && this.setDefaultPlaceHolder(),
                                e.nzRenderExtraFooter && (this.extraFooter = Eu(this.nzRenderExtraFooter)),
                                e.nzMode && (this.setDefaultPlaceHolder(), this.setModeAndFormat()),
                                i && this.setStatusStyles(this.nzStatus, this.hasFeedback),
                                r && this.setPlacement(this.nzPlacement);
                        }
                        setModeAndFormat() {
                            const e = {
                                year: 'yyyy',
                                month: 'yyyy-MM',
                                week: 'YYYY-ww',
                                date: this.nzShowTime ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd',
                            };
                            this.nzMode || (this.nzMode = 'date'),
                                (this.panelMode = this.isRange ? [this.nzMode, this.nzMode] : this.nzMode),
                                this.isCustomFormat || (this.nzFormat = e[this.nzMode]),
                                (this.inputSize = Math.max(10, this.nzFormat.length) + 2),
                                this.updateInputValue();
                        }
                        onOpenChange(e) {
                            this.nzOnOpenChange.emit(e);
                        }
                        writeValue(e) {
                            this.setValue(e), this.cdr.markForCheck();
                        }
                        registerOnChange(e) {
                            this.onChangeFn = e;
                        }
                        registerOnTouched(e) {
                            this.onTouchedFn = e;
                        }
                        setDisabledState(e) {
                            (this.nzDisabled = (this.isNzDisableFirstChange && this.nzDisabled) || e),
                                this.cdr.markForCheck(),
                                (this.isNzDisableFirstChange = !1);
                        }
                        setLocale() {
                            (this.nzLocale = this.i18n.getLocaleData('DatePicker', {})),
                                this.setDefaultPlaceHolder(),
                                this.cdr.markForCheck();
                        }
                        setDefaultPlaceHolder() {
                            if (!this.isCustomPlaceHolder && this.nzLocale) {
                                const e = {
                                        year: this.getPropertyOfLocale('yearPlaceholder'),
                                        month: this.getPropertyOfLocale('monthPlaceholder'),
                                        week: this.getPropertyOfLocale('weekPlaceholder'),
                                        date: this.getPropertyOfLocale('placeholder'),
                                    },
                                    i = {
                                        year: this.getPropertyOfLocale('rangeYearPlaceholder'),
                                        month: this.getPropertyOfLocale('rangeMonthPlaceholder'),
                                        week: this.getPropertyOfLocale('rangeWeekPlaceholder'),
                                        date: this.getPropertyOfLocale('rangePlaceholder'),
                                    };
                                this.nzPlaceHolder = this.isRange ? i[this.nzMode] : e[this.nzMode];
                            }
                        }
                        getPropertyOfLocale(e) {
                            return this.nzLocale.lang[e] || this.i18n.getLocaleData(`DatePicker.lang.${e}`);
                        }
                        setValue(e) {
                            const i = this.datePickerService.makeValue(e);
                            this.datePickerService.setValue(i),
                                (this.datePickerService.initialValue = mh(i)),
                                this.cdr.detectChanges();
                        }
                        renderClass(e) {
                            e
                                ? this.renderer.addClass(this.elementRef.nativeElement, 'ant-picker-focused')
                                : this.renderer.removeClass(this.elementRef.nativeElement, 'ant-picker-focused');
                        }
                        onPanelModeChange(e) {
                            this.nzOnPanelChange.emit(e);
                        }
                        onCalendarChange(e) {
                            if (this.isRange && Array.isArray(e)) {
                                const i = e.filter(r => r instanceof Wn).map(r => r.nativeDate);
                                this.nzOnCalendarChange.emit(i);
                            }
                        }
                        onResultOk() {
                            if (this.isRange) {
                                const e = this.datePickerService.value;
                                this.nzOnOk.emit(e.length ? [e[0]?.nativeDate || null, e[1]?.nativeDate || null] : []);
                            } else
                                this.nzOnOk.emit(
                                    this.datePickerService.value ? this.datePickerService.value.nativeDate : null,
                                );
                        }
                        setStatusStyles(e, i) {
                            (this.status = e),
                                (this.hasFeedback = i),
                                this.cdr.markForCheck(),
                                (this.statusCls = CT(this.prefixCls, e, i)),
                                Object.keys(this.statusCls).forEach(r => {
                                    this.statusCls[r]
                                        ? this.renderer.addClass(this.elementRef.nativeElement, r)
                                        : this.renderer.removeClass(this.elementRef.nativeElement, r);
                                });
                        }
                        setPlacement(e) {
                            const i = Ch[e];
                            (this.overlayPositions = [i, ...Ix]),
                                (this.currentPositionX = i.originX),
                                (this.currentPositionY = i.originY);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(
                                te(s0),
                                te(n5),
                                te(zu),
                                te(kr),
                                te(Ps),
                                te(en),
                                te(Pn),
                                te(Aa),
                                te(GJ),
                                te(Go),
                                te(Kf),
                                te(Ni),
                                te(yo, 8),
                                te(Ic, 9),
                                te(Rf, 8),
                                te(mD, 8),
                            );
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [
                                ['nz-date-picker'],
                                ['nz-week-picker'],
                                ['nz-month-picker'],
                                ['nz-year-picker'],
                                ['nz-range-picker'],
                            ],
                            viewQuery: function (i, r) {
                                if ((1 & i && (Fr(u0, 5), Fr(i5, 5), Fr(Rte, 5), Fr(Vte, 5), Fr(Hte, 5)), 2 & i)) {
                                    let s;
                                    Dr((s = xr())) && (r.cdkConnectedOverlay = s.first),
                                        Dr((s = xr())) && (r.panel = s.first),
                                        Dr((s = xr())) && (r.separatorElement = s.first),
                                        Dr((s = xr())) && (r.pickerInput = s.first),
                                        Dr((s = xr())) && (r.rangePickerInputs = s);
                                }
                            },
                            hostVars: 16,
                            hostBindings: function (i, r) {
                                1 & i &&
                                    Le('click', function (o) {
                                        return r.onClickInputBox(o);
                                    }),
                                    2 & i &&
                                        On('ant-picker', !0)('ant-picker-range', r.isRange)(
                                            'ant-picker-large',
                                            'large' === r.nzSize,
                                        )('ant-picker-small', 'small' === r.nzSize)(
                                            'ant-picker-disabled',
                                            r.nzDisabled,
                                        )('ant-picker-rtl', 'rtl' === r.dir)('ant-picker-borderless', r.nzBorderless)(
                                            'ant-picker-inline',
                                            r.nzInline,
                                        );
                            },
                            inputs: {
                                nzAllowClear: 'nzAllowClear',
                                nzAutoFocus: 'nzAutoFocus',
                                nzDisabled: 'nzDisabled',
                                nzBorderless: 'nzBorderless',
                                nzInputReadOnly: 'nzInputReadOnly',
                                nzInline: 'nzInline',
                                nzOpen: 'nzOpen',
                                nzDisabledDate: 'nzDisabledDate',
                                nzLocale: 'nzLocale',
                                nzPlaceHolder: 'nzPlaceHolder',
                                nzPopupStyle: 'nzPopupStyle',
                                nzDropdownClassName: 'nzDropdownClassName',
                                nzSize: 'nzSize',
                                nzStatus: 'nzStatus',
                                nzFormat: 'nzFormat',
                                nzDateRender: 'nzDateRender',
                                nzDisabledTime: 'nzDisabledTime',
                                nzRenderExtraFooter: 'nzRenderExtraFooter',
                                nzShowToday: 'nzShowToday',
                                nzMode: 'nzMode',
                                nzShowNow: 'nzShowNow',
                                nzRanges: 'nzRanges',
                                nzDefaultPickerValue: 'nzDefaultPickerValue',
                                nzSeparator: 'nzSeparator',
                                nzSuffixIcon: 'nzSuffixIcon',
                                nzBackdrop: 'nzBackdrop',
                                nzId: 'nzId',
                                nzPlacement: 'nzPlacement',
                                nzShowWeekNumber: 'nzShowWeekNumber',
                                nzShowTime: 'nzShowTime',
                            },
                            outputs: {
                                nzOnPanelChange: 'nzOnPanelChange',
                                nzOnCalendarChange: 'nzOnCalendarChange',
                                nzOnOk: 'nzOnOk',
                                nzOnOpenChange: 'nzOnOpenChange',
                            },
                            exportAs: ['nzDatePicker'],
                            standalone: !0,
                            features: [$n([Kf, n5, { provide: hs, multi: !0, useExisting: Wt(() => t) }]), D, Qi],
                            decls: 9,
                            vars: 6,
                            consts: [
                                ['tplRangeInput', ''],
                                ['tplRightRest', ''],
                                ['inlineMode', ''],
                                ['pickerInput', ''],
                                ['separatorElement', ''],
                                ['rangePickerInput', ''],
                                [
                                    'cdkConnectedOverlay',
                                    '',
                                    'nzConnectedOverlay',
                                    '',
                                    3,
                                    'positionChange',
                                    'detach',
                                    'overlayKeydown',
                                    'cdkConnectedOverlayHasBackdrop',
                                    'cdkConnectedOverlayOrigin',
                                    'cdkConnectedOverlayOpen',
                                    'cdkConnectedOverlayPositions',
                                    'cdkConnectedOverlayTransformOriginOn',
                                ],
                                [3, 'class'],
                                [
                                    'autocomplete',
                                    'off',
                                    3,
                                    'ngModelChange',
                                    'focus',
                                    'focusout',
                                    'keyup.enter',
                                    'disabled',
                                    'readOnly',
                                    'ngModel',
                                    'placeholder',
                                    'size',
                                ],
                                [4, 'ngTemplateOutlet'],
                                [4, 'ngTemplateOutlet', 'ngTemplateOutletContext'],
                                [4, 'nzStringTemplateOutlet'],
                                ['nz-icon', '', 'nzType', 'swap-right', 'nzTheme', 'outline'],
                                [3, 'ngTemplateOutlet'],
                                [
                                    'autocomplete',
                                    'off',
                                    3,
                                    'click',
                                    'focusout',
                                    'focus',
                                    'keyup.enter',
                                    'ngModelChange',
                                    'disabled',
                                    'readOnly',
                                    'size',
                                    'ngModel',
                                    'placeholder',
                                ],
                                [3, 'ngStyle'],
                                [3, 'status'],
                                [3, 'click'],
                                ['nz-icon', '', 'nzType', 'close-circle', 'nzTheme', 'fill'],
                                ['nz-icon', '', 3, 'nzType'],
                                [
                                    3,
                                    'panelModeChange',
                                    'calendarChange',
                                    'resultOk',
                                    'isRange',
                                    'inline',
                                    'defaultPickerValue',
                                    'showWeek',
                                    'panelMode',
                                    'locale',
                                    'showToday',
                                    'showNow',
                                    'showTime',
                                    'dateRender',
                                    'disabledDate',
                                    'disabledTime',
                                    'extraFooter',
                                    'ranges',
                                    'dir',
                                ],
                                [1, 'ant-picker-wrapper', 3, 'nzNoAnimation'],
                            ],
                            template: function (i, r) {
                                if (1 & i) {
                                    const s = st();
                                    ue(0, Qte, 2, 1)(1, Zte, 1, 1)(2, Jte, 2, 6, 'ng-template', null, 0, Xs)(
                                        4,
                                        ine,
                                        5,
                                        10,
                                        'ng-template',
                                        null,
                                        1,
                                        Xs,
                                    )(
                                        6,
                                        rne,
                                        2,
                                        36,
                                        'ng-template',
                                        null,
                                        2,
                                        Xs,
                                    )(8, one, 2, 5, 'ng-template', 6),
                                        Le('positionChange', function (a) {
                                            return me(s), pe(r.onPositionChange(a));
                                        })('detach', function () {
                                            return me(s), pe(r.close());
                                        })('overlayKeydown', function (a) {
                                            return me(s), pe(r.onOverlayKeydown(a));
                                        });
                                }
                                2 & i &&
                                    (dn(0, r.nzInline ? 1 : 0),
                                    z(8),
                                    H('cdkConnectedOverlayHasBackdrop', r.nzBackdrop)(
                                        'cdkConnectedOverlayOrigin',
                                        r.origin,
                                    )('cdkConnectedOverlayOpen', r.realOpenState)(
                                        'cdkConnectedOverlayPositions',
                                        r.overlayPositions,
                                    )('cdkConnectedOverlayTransformOriginOn', '.ant-picker-wrapper'));
                            },
                            dependencies: [nh, xa, eo, Fs, Al, bh, yh, o0, xc, mc, gD, pD, i5, u0, Xf, Qf, Ic],
                            encapsulation: 2,
                            data: { animation: [Mx] },
                            changeDetection: 0,
                        }));
                    }
                    return (
                        Lt([En()], t.prototype, 'nzAllowClear', void 0),
                        Lt([En()], t.prototype, 'nzAutoFocus', void 0),
                        Lt([En()], t.prototype, 'nzDisabled', void 0),
                        Lt([En()], t.prototype, 'nzBorderless', void 0),
                        Lt([En()], t.prototype, 'nzInputReadOnly', void 0),
                        Lt([En()], t.prototype, 'nzInline', void 0),
                        Lt([En()], t.prototype, 'nzOpen', void 0),
                        Lt([En()], t.prototype, 'nzShowToday', void 0),
                        Lt([En()], t.prototype, 'nzShowNow', void 0),
                        Lt([fs()], t.prototype, 'nzSeparator', void 0),
                        Lt([fs()], t.prototype, 'nzSuffixIcon', void 0),
                        Lt([fs()], t.prototype, 'nzBackdrop', void 0),
                        Lt([En()], t.prototype, 'nzShowWeekNumber', void 0),
                        t
                    );
                })(),
                wne = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [s5, Fx, Rx, i5] }));
                    }
                    return t;
                })(),
                Vx = (() => {
                    class t {
                        getGutter() {
                            const e = [null, null],
                                i = this.nzGutter || 0;
                            return (
                                (Array.isArray(i) ? i : [i, null]).forEach((s, o) => {
                                    'object' == typeof s && null !== s
                                        ? ((e[o] = null),
                                          Object.keys(Wf).map(a => {
                                              const l = a;
                                              this.mediaMatcher.matchMedia(Wf[l]).matches && s[l] && (e[o] = s[l]);
                                          }))
                                        : (e[o] = Number(s) || null);
                                }),
                                e
                            );
                        }
                        setGutterStyle() {
                            const [e, i] = this.getGutter();
                            this.actualGutter$.next([e, i]);
                            const r = (s, o) => {
                                null !== o && this.renderer.setStyle(this.elementRef.nativeElement, s, `-${o / 2}px`);
                            };
                            r('margin-left', e), r('margin-right', e), r('margin-top', i), r('margin-bottom', i);
                        }
                        constructor(e, i, r, s, o, a, l) {
                            (this.elementRef = e),
                                (this.renderer = i),
                                (this.mediaMatcher = r),
                                (this.ngZone = s),
                                (this.platform = o),
                                (this.breakpointService = a),
                                (this.directionality = l),
                                (this.nzAlign = null),
                                (this.nzJustify = null),
                                (this.nzGutter = null),
                                (this.actualGutter$ = new yc(1)),
                                (this.dir = 'ltr'),
                                (this.destroy$ = new vt());
                        }
                        ngOnInit() {
                            (this.dir = this.directionality.value),
                                this.directionality.change?.pipe(nn(this.destroy$)).subscribe(e => {
                                    this.dir = e;
                                }),
                                this.setGutterStyle();
                        }
                        ngOnChanges(e) {
                            e.nzGutter && this.setGutterStyle();
                        }
                        ngAfterViewInit() {
                            this.platform.isBrowser &&
                                this.breakpointService
                                    .subscribe(Wf)
                                    .pipe(nn(this.destroy$))
                                    .subscribe(() => {
                                        this.setGutterStyle();
                                    });
                        }
                        ngOnDestroy() {
                            this.destroy$.next(!0), this.destroy$.complete();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Pn), te(Ps), te(Dx), te(en), te(Go), te(gJ), te(yo, 8));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'nz-row', ''], ['nz-row'], ['nz-form-item']],
                            hostAttrs: [1, 'ant-row'],
                            hostVars: 20,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('ant-row-top', 'top' === r.nzAlign)('ant-row-middle', 'middle' === r.nzAlign)(
                                        'ant-row-bottom',
                                        'bottom' === r.nzAlign,
                                    )('ant-row-start', 'start' === r.nzJustify)('ant-row-end', 'end' === r.nzJustify)(
                                        'ant-row-center',
                                        'center' === r.nzJustify,
                                    )('ant-row-space-around', 'space-around' === r.nzJustify)(
                                        'ant-row-space-between',
                                        'space-between' === r.nzJustify,
                                    )('ant-row-space-evenly', 'space-evenly' === r.nzJustify)(
                                        'ant-row-rtl',
                                        'rtl' === r.dir,
                                    );
                            },
                            inputs: { nzAlign: 'nzAlign', nzJustify: 'nzJustify', nzGutter: 'nzGutter' },
                            exportAs: ['nzRow'],
                            standalone: !0,
                            features: [D],
                        }));
                    }
                    return t;
                })(),
                Mne = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })();
            function Hx(t, n) {
                return n
                    ? e =>
                          zg(
                              n.pipe(
                                  Z1(1),
                                  (function Sne() {
                                      return mi((t, n) => {
                                          t.subscribe(ln(n, Kn));
                                      });
                                  })(),
                              ),
                              e.pipe(Hx(t)),
                          )
                    : G1((e, i) => bs(t(e, i)).pipe(Z1(1), QT(e)));
            }
            const Dne = ['overlay'];
            function xne(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), hn(e.nzTitle);
                }
            }
            function kne(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'div', 2)(1, 'div', 3)(2, 'div', 4),
                        Oe(3, 'span', 5),
                        ee(),
                        Z(4, 'div', 6),
                        ue(5, xne, 2, 1, 'ng-container', 7),
                        ee()()()),
                    2 & t)
                ) {
                    const e = L();
                    On('ant-tooltip-rtl', 'rtl' === e.dir),
                        H('ngClass', e._classMap)('ngStyle', e.nzOverlayStyle)(
                            '@.disabled',
                            !(null == e.noAnimation || !e.noAnimation.nzNoAnimation),
                        )('nzNoAnimation', null == e.noAnimation ? null : e.noAnimation.nzNoAnimation)(
                            '@zoomBigMotion',
                            'active',
                        ),
                        z(3),
                        H('ngStyle', e._contentStyleMap),
                        z(),
                        H('ngStyle', e._contentStyleMap),
                        z(),
                        H('nzStringTemplateOutlet', e.nzTitle)('nzStringTemplateOutletContext', e.nzTitleContext);
                }
            }
            let Ene = (() => {
                    class t {
                        get _title() {
                            return this.title || this.directiveTitle || null;
                        }
                        get _content() {
                            return this.content || this.directiveContent || null;
                        }
                        get _trigger() {
                            return typeof this.trigger < 'u' ? this.trigger : 'hover';
                        }
                        get _placement() {
                            const e = this.placement;
                            return Array.isArray(e) && e.length > 0 ? e : 'string' == typeof e && e ? [e] : ['top'];
                        }
                        get _visible() {
                            return (typeof this.visible < 'u' ? this.visible : this.internalVisible) || !1;
                        }
                        get _mouseEnterDelay() {
                            return this.mouseEnterDelay || 0.15;
                        }
                        get _mouseLeaveDelay() {
                            return this.mouseLeaveDelay || 0.1;
                        }
                        get _overlayClassName() {
                            return this.overlayClassName || null;
                        }
                        get _overlayStyle() {
                            return this.overlayStyle || null;
                        }
                        getProxyPropertyMap() {
                            return { noAnimation: ['noAnimation', () => !!this.noAnimation] };
                        }
                        constructor(e) {
                            (this.componentType = e),
                                (this.visibleChange = new Ft()),
                                (this.internalVisible = !1),
                                (this.destroy$ = new vt()),
                                (this.triggerDisposables = []),
                                (this.elementRef = Ue(Pn)),
                                (this.hostView = Ue(go)),
                                (this.renderer = Ue(Ps)),
                                (this.noAnimation = Ue(Ic, { host: !0, optional: !0 })),
                                (this.nzConfigService = Ue(s0)),
                                (this.platformId = Ue(Za));
                        }
                        ngAfterViewInit() {
                            BC(this.platformId) && (this.createComponent(), this.registerTriggers());
                        }
                        ngOnChanges(e) {
                            const { trigger: i } = e;
                            i && !i.isFirstChange() && this.registerTriggers(),
                                this.component && this.updatePropertiesByChanges(e);
                        }
                        ngOnDestroy() {
                            this.destroy$.next(),
                                this.destroy$.complete(),
                                this.clearTogglingTimer(),
                                this.removeTriggerListeners();
                        }
                        show() {
                            this.component?.show();
                        }
                        hide() {
                            this.component?.hide();
                        }
                        updatePosition() {
                            this.component && this.component.updatePosition();
                        }
                        createComponent() {
                            const e = this.hostView.createComponent(this.componentType);
                            (this.component = e.instance),
                                this.renderer.removeChild(
                                    this.renderer.parentNode(this.elementRef.nativeElement),
                                    e.location.nativeElement,
                                ),
                                this.component.setOverlayOrigin(this.origin || this.elementRef),
                                this.initProperties();
                            const i = this.component.nzVisibleChange.pipe(n0());
                            i.pipe(nn(this.destroy$)).subscribe(r => {
                                (this.internalVisible = r), this.visibleChange.emit(r);
                            }),
                                i
                                    .pipe(
                                        al(r => r),
                                        (function Tne(t, n = bf) {
                                            const e = Kp(t, n);
                                            return Hx(() => e);
                                        })(0, ox),
                                        al(() => !!this.component?.overlay?.overlayRef),
                                        nn(this.destroy$),
                                    )
                                    .subscribe(() => {
                                        this.component?.updatePosition();
                                    });
                        }
                        registerTriggers() {
                            const e = this.elementRef.nativeElement,
                                i = this.trigger;
                            if ((this.removeTriggerListeners(), 'hover' === i)) {
                                let r;
                                this.triggerDisposables.push(
                                    this.renderer.listen(e, 'mouseenter', () => {
                                        this.delayEnterLeave(!0, !0, this._mouseEnterDelay);
                                    }),
                                ),
                                    this.triggerDisposables.push(
                                        this.renderer.listen(e, 'mouseleave', () => {
                                            this.delayEnterLeave(!0, !1, this._mouseLeaveDelay),
                                                this.component?.overlay.overlayRef &&
                                                    !r &&
                                                    ((r = this.component.overlay.overlayRef.overlayElement),
                                                    this.triggerDisposables.push(
                                                        this.renderer.listen(r, 'mouseenter', () => {
                                                            this.delayEnterLeave(!1, !0, this._mouseEnterDelay);
                                                        }),
                                                    ),
                                                    this.triggerDisposables.push(
                                                        this.renderer.listen(r, 'mouseleave', () => {
                                                            this.delayEnterLeave(!1, !1, this._mouseLeaveDelay);
                                                        }),
                                                    ));
                                        }),
                                    );
                            } else
                                'focus' === i
                                    ? (this.triggerDisposables.push(
                                          this.renderer.listen(e, 'focusin', () => this.show()),
                                      ),
                                      this.triggerDisposables.push(
                                          this.renderer.listen(e, 'focusout', () => this.hide()),
                                      ))
                                    : 'click' === i &&
                                      this.triggerDisposables.push(
                                          this.renderer.listen(e, 'click', r => {
                                              r.preventDefault(), this.show();
                                          }),
                                      );
                        }
                        updatePropertiesByChanges(e) {
                            this.updatePropertiesByKeys(Object.keys(e));
                        }
                        updatePropertiesByKeys(e) {
                            const i = {
                                title: ['nzTitle', () => this._title],
                                directiveTitle: ['nzTitle', () => this._title],
                                content: ['nzContent', () => this._content],
                                directiveContent: ['nzContent', () => this._content],
                                trigger: ['nzTrigger', () => this._trigger],
                                placement: ['nzPlacement', () => this._placement],
                                visible: ['nzVisible', () => this._visible],
                                mouseEnterDelay: ['nzMouseEnterDelay', () => this._mouseEnterDelay],
                                mouseLeaveDelay: ['nzMouseLeaveDelay', () => this._mouseLeaveDelay],
                                overlayClassName: ['nzOverlayClassName', () => this._overlayClassName],
                                overlayStyle: ['nzOverlayStyle', () => this._overlayStyle],
                                arrowPointAtCenter: ['nzArrowPointAtCenter', () => this.arrowPointAtCenter],
                                cdkConnectedOverlayPush: [
                                    'cdkConnectedOverlayPush',
                                    () => this.cdkConnectedOverlayPush,
                                ],
                                ...this.getProxyPropertyMap(),
                            };
                            (e || Object.keys(i).filter(r => !r.startsWith('directive'))).forEach(r => {
                                if (i[r]) {
                                    const [s, o] = i[r];
                                    this.updateComponentValue(s, o());
                                }
                            }),
                                this.component?.updateByDirective();
                        }
                        initProperties() {
                            this.updatePropertiesByKeys();
                        }
                        updateComponentValue(e, i) {
                            typeof i < 'u' && (this.component[e] = i);
                        }
                        delayEnterLeave(e, i, r = -1) {
                            this.delayTimer
                                ? this.clearTogglingTimer()
                                : r > 0
                                ? (this.delayTimer = setTimeout(() => {
                                      (this.delayTimer = void 0), i ? this.show() : this.hide();
                                  }, 1e3 * r))
                                : i && e
                                ? this.show()
                                : this.hide();
                        }
                        removeTriggerListeners() {
                            this.triggerDisposables.forEach(e => e()), (this.triggerDisposables.length = 0);
                        }
                        clearTogglingTimer() {
                            this.delayTimer && (clearTimeout(this.delayTimer), (this.delayTimer = void 0));
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Gh));
                        });
                        static #t = (this.ɵdir = gt({ type: t, features: [D] }));
                    }
                    return t;
                })(),
                Ine = (() => {
                    class t {
                        set nzVisible(e) {
                            const i = hg(e);
                            this._visible !== i && ((this._visible = i), this.nzVisibleChange.next(i));
                        }
                        get nzVisible() {
                            return this._visible;
                        }
                        set nzTrigger(e) {
                            this._trigger = e;
                        }
                        get nzTrigger() {
                            return this._trigger;
                        }
                        set nzPlacement(e) {
                            const i = e.map(r => Ss[r]);
                            this._positions = [...i, ...kx];
                        }
                        constructor(e, i, r) {
                            (this.cdr = e),
                                (this.directionality = i),
                                (this.noAnimation = r),
                                (this.nzTitle = null),
                                (this.nzContent = null),
                                (this.nzArrowPointAtCenter = !1),
                                (this.nzOverlayStyle = {}),
                                (this.nzBackdrop = !1),
                                (this.cdkConnectedOverlayPush = !0),
                                (this.nzVisibleChange = new vt()),
                                (this._visible = !1),
                                (this._trigger = 'hover'),
                                (this.preferredPlacement = 'top'),
                                (this.dir = 'ltr'),
                                (this._classMap = {}),
                                (this._prefix = 'ant-tooltip'),
                                (this._positions = [...kx]),
                                (this.destroy$ = new vt());
                        }
                        ngOnInit() {
                            this.directionality.change?.pipe(nn(this.destroy$)).subscribe(e => {
                                (this.dir = e), this.cdr.detectChanges();
                            }),
                                (this.dir = this.directionality.value);
                        }
                        ngOnDestroy() {
                            this.nzVisibleChange.complete(), this.destroy$.next(), this.destroy$.complete();
                        }
                        show() {
                            this.nzVisible ||
                                (this.isEmpty() ||
                                    ((this.nzVisible = !0), this.nzVisibleChange.next(!0), this.cdr.detectChanges()),
                                this.origin &&
                                    this.overlay &&
                                    this.overlay.overlayRef &&
                                    'rtl' === this.overlay.overlayRef.getDirection() &&
                                    this.overlay.overlayRef.setDirection('ltr'));
                        }
                        hide() {
                            this.nzVisible &&
                                ((this.nzVisible = !1), this.nzVisibleChange.next(!1), this.cdr.detectChanges());
                        }
                        updateByDirective() {
                            this.updateStyles(),
                                this.cdr.detectChanges(),
                                Promise.resolve().then(() => {
                                    this.updatePosition(), this.updateVisibilityByTitle();
                                });
                        }
                        updatePosition() {
                            this.origin &&
                                this.overlay &&
                                this.overlay.overlayRef &&
                                this.overlay.overlayRef.updatePosition();
                        }
                        onPositionChange(e) {
                            (this.preferredPlacement = Ex(e)), this.updateStyles(), this.cdr.detectChanges();
                        }
                        setOverlayOrigin(e) {
                            (this.origin = e), this.cdr.markForCheck();
                        }
                        onClickOutside(e) {
                            !this.origin.nativeElement.contains(e.target) && null !== this.nzTrigger && this.hide();
                        }
                        updateVisibilityByTitle() {
                            this.isEmpty() && this.hide();
                        }
                        updateStyles() {
                            this._classMap = {
                                [this.nzOverlayClassName]: !0,
                                [`${this._prefix}-placement-${this.preferredPlacement}`]: !0,
                            };
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(kr), te(yo, 8), te(Ic));
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            viewQuery: function (i, r) {
                                if ((1 & i && Fr(Dne, 5), 2 & i)) {
                                    let s;
                                    Dr((s = xr())) && (r.overlay = s.first);
                                }
                            },
                        }));
                    }
                    return t;
                })();
            function o5(t) {
                return !(t instanceof Qr || ('' !== t && Fi(t)));
            }
            let Ane = (() => {
                class t extends Ine {
                    constructor(e, i, r) {
                        super(e, i, r),
                            (this.nzTitle = null),
                            (this.nzTitleContext = null),
                            (this._contentStyleMap = {});
                    }
                    isEmpty() {
                        return o5(this.nzTitle);
                    }
                    updateStyles() {
                        const e =
                            this.nzColor &&
                            (function aK(t) {
                                return -1 !== oK.indexOf(t);
                            })(this.nzColor);
                        (this._classMap = {
                            [this.nzOverlayClassName]: !0,
                            [`${this._prefix}-placement-${this.preferredPlacement}`]: !0,
                            [`${this._prefix}-${this.nzColor}`]: e,
                        }),
                            (this._contentStyleMap = {
                                backgroundColor: this.nzColor && !e ? this.nzColor : null,
                                '--color': this.nzColor,
                            });
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(kr), te(yo, 8), te(Ic, 9));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['nz-tooltip']],
                        exportAs: ['nzTooltipComponent'],
                        standalone: !0,
                        features: [Cn, Qi],
                        decls: 2,
                        vars: 5,
                        consts: [
                            ['overlay', 'cdkConnectedOverlay'],
                            [
                                'cdkConnectedOverlay',
                                '',
                                'nzConnectedOverlay',
                                '',
                                3,
                                'overlayOutsideClick',
                                'detach',
                                'positionChange',
                                'cdkConnectedOverlayOrigin',
                                'cdkConnectedOverlayOpen',
                                'cdkConnectedOverlayPositions',
                                'cdkConnectedOverlayPush',
                                'nzArrowPointAtCenter',
                            ],
                            [1, 'ant-tooltip', 3, 'ngClass', 'ngStyle', 'nzNoAnimation'],
                            [1, 'ant-tooltip-content'],
                            [1, 'ant-tooltip-arrow'],
                            [1, 'ant-tooltip-arrow-content', 3, 'ngStyle'],
                            [1, 'ant-tooltip-inner', 3, 'ngStyle'],
                            [4, 'nzStringTemplateOutlet', 'nzStringTemplateOutletContext'],
                        ],
                        template: function (i, r) {
                            if (1 & i) {
                                const s = st();
                                ue(0, kne, 6, 11, 'ng-template', 1, 0, Xs),
                                    Le('overlayOutsideClick', function (a) {
                                        return me(s), pe(r.onClickOutside(a));
                                    })('detach', function () {
                                        return me(s), pe(r.hide());
                                    })('positionChange', function (a) {
                                        return me(s), pe(r.onPositionChange(a));
                                    });
                            }
                            2 & i &&
                                H('cdkConnectedOverlayOrigin', r.origin)('cdkConnectedOverlayOpen', r._visible)(
                                    'cdkConnectedOverlayPositions',
                                    r._positions,
                                )('cdkConnectedOverlayPush', r.cdkConnectedOverlayPush)(
                                    'nzArrowPointAtCenter',
                                    r.nzArrowPointAtCenter,
                                );
                        },
                        dependencies: [Zg, u0, sl, mc, Ic, bh, yh, Xf, Qf],
                        encapsulation: 2,
                        data: { animation: [Sx] },
                        changeDetection: 0,
                    }));
                }
                return t;
            })();
            function Lne(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L(3);
                    z(), hn(e.nzTitle);
                }
            }
            function One(t, n) {
                if ((1 & t && (Z(0, 'div', 7), ue(1, Lne, 2, 1, 'ng-container', 9), ee()), 2 & t)) {
                    const e = L(2);
                    z(), H('nzStringTemplateOutlet', e.nzTitle);
                }
            }
            function zne(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), hn(e.nzContent);
                }
            }
            function Pne(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'div', 2)(1, 'div', 3)(2, 'div', 4),
                        Oe(3, 'span', 5),
                        ee(),
                        Z(4, 'div', 6)(5, 'div'),
                        ue(6, One, 2, 1, 'div', 7),
                        Z(7, 'div', 8),
                        ue(8, zne, 2, 1, 'ng-container', 9),
                        ee()()()()()),
                    2 & t)
                ) {
                    const e = L();
                    On('ant-popover-rtl', 'rtl' === e.dir),
                        H('ngClass', e._classMap)('ngStyle', e.nzOverlayStyle)(
                            '@.disabled',
                            !(null == e.noAnimation || !e.noAnimation.nzNoAnimation),
                        )('nzNoAnimation', null == e.noAnimation ? null : e.noAnimation.nzNoAnimation)(
                            '@zoomBigMotion',
                            'active',
                        ),
                        z(6),
                        dn(6, e.nzTitle ? 6 : -1),
                        z(2),
                        H('nzStringTemplateOutlet', e.nzContent);
                }
            }
            let Fne = (() => {
                    class t extends Ene {
                        getProxyPropertyMap() {
                            return {
                                nzPopoverBackdrop: ['nzBackdrop', () => this.nzPopoverBackdrop],
                                ...super.getProxyPropertyMap(),
                            };
                        }
                        constructor() {
                            super(Ux),
                                (this._nzModuleName = 'popover'),
                                (this.trigger = 'hover'),
                                (this.placement = 'top'),
                                (this.nzPopoverBackdrop = !1),
                                (this.visibleChange = new Ft());
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵdir = gt({
                            type: t,
                            selectors: [['', 'nz-popover', '']],
                            hostVars: 2,
                            hostBindings: function (i, r) {
                                2 & i && On('ant-popover-open', r.visible);
                            },
                            inputs: {
                                arrowPointAtCenter: [de.None, 'nzPopoverArrowPointAtCenter', 'arrowPointAtCenter'],
                                title: [de.None, 'nzPopoverTitle', 'title'],
                                content: [de.None, 'nzPopoverContent', 'content'],
                                directiveTitle: [de.None, 'nz-popover', 'directiveTitle'],
                                trigger: [de.None, 'nzPopoverTrigger', 'trigger'],
                                placement: [de.None, 'nzPopoverPlacement', 'placement'],
                                origin: [de.None, 'nzPopoverOrigin', 'origin'],
                                visible: [de.None, 'nzPopoverVisible', 'visible'],
                                mouseEnterDelay: [de.None, 'nzPopoverMouseEnterDelay', 'mouseEnterDelay'],
                                mouseLeaveDelay: [de.None, 'nzPopoverMouseLeaveDelay', 'mouseLeaveDelay'],
                                overlayClassName: [de.None, 'nzPopoverOverlayClassName', 'overlayClassName'],
                                overlayStyle: [de.None, 'nzPopoverOverlayStyle', 'overlayStyle'],
                                nzPopoverBackdrop: 'nzPopoverBackdrop',
                            },
                            outputs: { visibleChange: 'nzPopoverVisibleChange' },
                            exportAs: ['nzPopover'],
                            standalone: !0,
                            features: [Cn],
                        }));
                    }
                    return (
                        Lt([En()], t.prototype, 'arrowPointAtCenter', void 0),
                        Lt([fs()], t.prototype, 'nzPopoverBackdrop', void 0),
                        t
                    );
                })(),
                Ux = (() => {
                    class t extends Ane {
                        constructor(e, i, r) {
                            super(e, i, r), (this._prefix = 'ant-popover');
                        }
                        get hasBackdrop() {
                            return 'click' === this.nzTrigger && this.nzBackdrop;
                        }
                        isEmpty() {
                            return o5(this.nzTitle) && o5(this.nzContent);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(kr), te(yo, 8), te(Ic, 9));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['nz-popover']],
                            exportAs: ['nzPopoverComponent'],
                            standalone: !0,
                            features: [Cn, Qi],
                            decls: 2,
                            vars: 6,
                            consts: [
                                ['overlay', 'cdkConnectedOverlay'],
                                [
                                    'cdkConnectedOverlay',
                                    '',
                                    'nzConnectedOverlay',
                                    '',
                                    3,
                                    'overlayOutsideClick',
                                    'detach',
                                    'positionChange',
                                    'cdkConnectedOverlayHasBackdrop',
                                    'cdkConnectedOverlayOrigin',
                                    'cdkConnectedOverlayPositions',
                                    'cdkConnectedOverlayOpen',
                                    'cdkConnectedOverlayPush',
                                    'nzArrowPointAtCenter',
                                ],
                                [1, 'ant-popover', 3, 'ngClass', 'ngStyle', 'nzNoAnimation'],
                                [1, 'ant-popover-content'],
                                [1, 'ant-popover-arrow'],
                                [1, 'ant-popover-arrow-content'],
                                ['role', 'tooltip', 1, 'ant-popover-inner'],
                                [1, 'ant-popover-title'],
                                [1, 'ant-popover-inner-content'],
                                [4, 'nzStringTemplateOutlet'],
                            ],
                            template: function (i, r) {
                                if (1 & i) {
                                    const s = st();
                                    ue(0, Pne, 9, 9, 'ng-template', 1, 0, Xs),
                                        Le('overlayOutsideClick', function (a) {
                                            return me(s), pe(r.onClickOutside(a));
                                        })('detach', function () {
                                            return me(s), pe(r.hide());
                                        })('positionChange', function (a) {
                                            return me(s), pe(r.onPositionChange(a));
                                        });
                                }
                                2 & i &&
                                    H('cdkConnectedOverlayHasBackdrop', r.hasBackdrop)(
                                        'cdkConnectedOverlayOrigin',
                                        r.origin,
                                    )('cdkConnectedOverlayPositions', r._positions)(
                                        'cdkConnectedOverlayOpen',
                                        r._visible,
                                    )('cdkConnectedOverlayPush', r.cdkConnectedOverlayPush)(
                                        'nzArrowPointAtCenter',
                                        r.nzArrowPointAtCenter,
                                    );
                            },
                            dependencies: [Zg, u0, Xf, Qf, sl, mc, Ic, bh, yh],
                            encapsulation: 2,
                            data: { animation: [Sx] },
                            changeDetection: 0,
                        }));
                    }
                    return t;
                })(),
                Rne = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [Ux] }));
                    }
                    return t;
                })();
            const Bx = ['*'],
                Vne = ['inputElement'],
                Hne = ['nz-radio', ''];
            let a5 = (() => {
                    class t {
                        constructor() {
                            (this.selected$ = new yc(1)),
                                (this.touched$ = new vt()),
                                (this.disabled$ = new yc(1)),
                                (this.name$ = new yc(1));
                        }
                        touch() {
                            this.touched$.next();
                        }
                        select(e) {
                            this.selected$.next(e);
                        }
                        setDisabled(e) {
                            this.disabled$.next(e);
                        }
                        setName(e) {
                            this.name$.next(e);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac }));
                    }
                    return t;
                })(),
                qx = (() => {
                    class t {
                        constructor(e, i, r) {
                            (this.cdr = e),
                                (this.nzRadioService = i),
                                (this.directionality = r),
                                (this.value = null),
                                (this.destroy$ = new vt()),
                                (this.isNzDisableFirstChange = !0),
                                (this.onChange = () => {}),
                                (this.onTouched = () => {}),
                                (this.nzDisabled = !1),
                                (this.nzButtonStyle = 'outline'),
                                (this.nzSize = 'default'),
                                (this.nzName = null),
                                (this.dir = 'ltr');
                        }
                        ngOnInit() {
                            this.nzRadioService.selected$.pipe(nn(this.destroy$)).subscribe(e => {
                                this.value !== e && ((this.value = e), this.onChange(this.value));
                            }),
                                this.nzRadioService.touched$.pipe(nn(this.destroy$)).subscribe(() => {
                                    Promise.resolve().then(() => this.onTouched());
                                }),
                                this.directionality.change?.pipe(nn(this.destroy$)).subscribe(e => {
                                    (this.dir = e), this.cdr.detectChanges();
                                }),
                                (this.dir = this.directionality.value);
                        }
                        ngOnChanges(e) {
                            const { nzDisabled: i, nzName: r } = e;
                            i && this.nzRadioService.setDisabled(this.nzDisabled),
                                r && this.nzRadioService.setName(this.nzName);
                        }
                        ngOnDestroy() {
                            this.destroy$.next(!0), this.destroy$.complete();
                        }
                        writeValue(e) {
                            (this.value = e), this.nzRadioService.select(e), this.cdr.markForCheck();
                        }
                        registerOnChange(e) {
                            this.onChange = e;
                        }
                        registerOnTouched(e) {
                            this.onTouched = e;
                        }
                        setDisabledState(e) {
                            (this.nzDisabled = (this.isNzDisableFirstChange && this.nzDisabled) || e),
                                (this.isNzDisableFirstChange = !1),
                                this.nzRadioService.setDisabled(this.nzDisabled),
                                this.cdr.markForCheck();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(kr), te(a5), te(yo, 8));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['nz-radio-group']],
                            hostAttrs: [1, 'ant-radio-group'],
                            hostVars: 8,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('ant-radio-group-large', 'large' === r.nzSize)(
                                        'ant-radio-group-small',
                                        'small' === r.nzSize,
                                    )('ant-radio-group-solid', 'solid' === r.nzButtonStyle)(
                                        'ant-radio-group-rtl',
                                        'rtl' === r.dir,
                                    );
                            },
                            inputs: {
                                nzDisabled: 'nzDisabled',
                                nzButtonStyle: 'nzButtonStyle',
                                nzSize: 'nzSize',
                                nzName: 'nzName',
                            },
                            exportAs: ['nzRadioGroup'],
                            standalone: !0,
                            features: [$n([a5, { provide: hs, useExisting: Wt(() => t), multi: !0 }]), D, Qi],
                            ngContentSelectors: Bx,
                            decls: 1,
                            vars: 0,
                            template: function (i, r) {
                                1 & i && (H1(), U1(0));
                            },
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return Lt([En()], t.prototype, 'nzDisabled', void 0), t;
                })(),
                Yx = (() => {
                    class t {
                        focus() {
                            this.focusMonitor.focusVia(this.inputElement, 'keyboard');
                        }
                        blur() {
                            this.inputElement.nativeElement.blur();
                        }
                        constructor(e, i, r, s, o, a, l) {
                            (this.ngZone = e),
                                (this.elementRef = i),
                                (this.cdr = r),
                                (this.focusMonitor = s),
                                (this.directionality = o),
                                (this.nzRadioService = a),
                                (this.nzFormStatusService = l),
                                (this.isNgModel = !1),
                                (this.destroy$ = new vt()),
                                (this.isNzDisableFirstChange = !0),
                                (this.isChecked = !1),
                                (this.name = null),
                                (this.onChange = () => {}),
                                (this.onTouched = () => {}),
                                (this.nzValue = null),
                                (this.nzDisabled = !1),
                                (this.nzAutoFocus = !1),
                                (this.isRadioButton = !1),
                                (this.dir = 'ltr');
                        }
                        setDisabledState(e) {
                            (this.nzDisabled = (this.isNzDisableFirstChange && this.nzDisabled) || e),
                                (this.isNzDisableFirstChange = !1),
                                this.cdr.markForCheck();
                        }
                        writeValue(e) {
                            (this.isChecked = e), this.cdr.markForCheck();
                        }
                        registerOnChange(e) {
                            (this.isNgModel = !0), (this.onChange = e);
                        }
                        registerOnTouched(e) {
                            this.onTouched = e;
                        }
                        ngOnInit() {
                            this.nzRadioService &&
                                (this.nzRadioService.name$.pipe(nn(this.destroy$)).subscribe(e => {
                                    (this.name = e), this.cdr.markForCheck();
                                }),
                                this.nzRadioService.disabled$.pipe(nn(this.destroy$)).subscribe(e => {
                                    (this.nzDisabled = (this.isNzDisableFirstChange && this.nzDisabled) || e),
                                        (this.isNzDisableFirstChange = !1),
                                        this.cdr.markForCheck();
                                }),
                                this.nzRadioService.selected$.pipe(nn(this.destroy$)).subscribe(e => {
                                    const i = this.isChecked;
                                    (this.isChecked = this.nzValue === e),
                                        this.isNgModel &&
                                            i !== this.isChecked &&
                                            !1 === this.isChecked &&
                                            this.onChange(!1),
                                        this.cdr.markForCheck();
                                })),
                                this.focusMonitor
                                    .monitor(this.elementRef, !0)
                                    .pipe(nn(this.destroy$))
                                    .subscribe(e => {
                                        e ||
                                            (Promise.resolve().then(() => this.onTouched()),
                                            this.nzRadioService && this.nzRadioService.touch());
                                    }),
                                this.directionality.change.pipe(nn(this.destroy$)).subscribe(e => {
                                    (this.dir = e), this.cdr.detectChanges();
                                }),
                                (this.dir = this.directionality.value),
                                this.setupClickListener();
                        }
                        ngAfterViewInit() {
                            this.nzAutoFocus && this.focus();
                        }
                        ngOnDestroy() {
                            this.destroy$.next(),
                                this.destroy$.complete(),
                                this.focusMonitor.stopMonitoring(this.elementRef);
                        }
                        setupClickListener() {
                            this.ngZone.runOutsideAngular(() => {
                                ca(this.elementRef.nativeElement, 'click')
                                    .pipe(nn(this.destroy$))
                                    .subscribe(e => {
                                        e.stopPropagation(),
                                            e.preventDefault(),
                                            !this.nzDisabled &&
                                                !this.isChecked &&
                                                this.ngZone.run(() => {
                                                    this.focus(),
                                                        this.nzRadioService?.select(this.nzValue),
                                                        this.isNgModel && ((this.isChecked = !0), this.onChange(!0)),
                                                        this.cdr.markForCheck();
                                                });
                                    });
                            });
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(en), te(Pn), te(kr), te(Df), te(yo, 8), te(a5, 8), te(Rf, 8));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [
                                ['', 'nz-radio', ''],
                                ['', 'nz-radio-button', ''],
                            ],
                            viewQuery: function (i, r) {
                                if ((1 & i && Fr(Vne, 7), 2 & i)) {
                                    let s;
                                    Dr((s = xr())) && (r.inputElement = s.first);
                                }
                            },
                            hostVars: 18,
                            hostBindings: function (i, r) {
                                2 & i &&
                                    On('ant-radio-wrapper-in-form-item', !!r.nzFormStatusService)(
                                        'ant-radio-wrapper',
                                        !r.isRadioButton,
                                    )('ant-radio-button-wrapper', r.isRadioButton)(
                                        'ant-radio-wrapper-checked',
                                        r.isChecked && !r.isRadioButton,
                                    )('ant-radio-button-wrapper-checked', r.isChecked && r.isRadioButton)(
                                        'ant-radio-wrapper-disabled',
                                        r.nzDisabled && !r.isRadioButton,
                                    )('ant-radio-button-wrapper-disabled', r.nzDisabled && r.isRadioButton)(
                                        'ant-radio-wrapper-rtl',
                                        !r.isRadioButton && 'rtl' === r.dir,
                                    )('ant-radio-button-wrapper-rtl', r.isRadioButton && 'rtl' === r.dir);
                            },
                            inputs: {
                                nzValue: 'nzValue',
                                nzDisabled: 'nzDisabled',
                                nzAutoFocus: 'nzAutoFocus',
                                isRadioButton: [de.HasDecoratorInputTransform, 'nz-radio-button', 'isRadioButton', Ma],
                            },
                            exportAs: ['nzRadio'],
                            standalone: !0,
                            features: [$n([{ provide: hs, useExisting: Wt(() => t), multi: !0 }]), G2, Qi],
                            attrs: Hne,
                            ngContentSelectors: Bx,
                            decls: 6,
                            vars: 24,
                            consts: [
                                ['inputElement', ''],
                                ['type', 'radio', 3, 'disabled', 'checked'],
                            ],
                            template: function (i, r) {
                                1 & i &&
                                    (H1(),
                                    Z(0, 'span'),
                                    Oe(1, 'input', 1, 0)(3, 'span'),
                                    ee(),
                                    Z(4, 'span'),
                                    U1(5),
                                    ee()),
                                    2 & i &&
                                        (On('ant-radio', !r.isRadioButton)(
                                            'ant-radio-checked',
                                            r.isChecked && !r.isRadioButton,
                                        )('ant-radio-disabled', r.nzDisabled && !r.isRadioButton)(
                                            'ant-radio-button',
                                            r.isRadioButton,
                                        )('ant-radio-button-checked', r.isChecked && r.isRadioButton)(
                                            'ant-radio-button-disabled',
                                            r.nzDisabled && r.isRadioButton,
                                        ),
                                        z(),
                                        On('ant-radio-input', !r.isRadioButton)(
                                            'ant-radio-button-input',
                                            r.isRadioButton,
                                        ),
                                        H('disabled', r.nzDisabled)('checked', r.isChecked),
                                        zi('autofocus', r.nzAutoFocus ? 'autofocus' : null)('name', r.name),
                                        z(2),
                                        On('ant-radio-inner', !r.isRadioButton)(
                                            'ant-radio-button-inner',
                                            r.isRadioButton,
                                        ));
                            },
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return (
                        Lt([En()], t.prototype, 'nzDisabled', void 0), Lt([En()], t.prototype, 'nzAutoFocus', void 0), t
                    );
                })(),
                Une = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({}));
                    }
                    return t;
                })();
            const Bne = ['switchElement'];
            function qne(t, n) {
                1 & t && Oe(0, 'span', 8);
            }
            function Yne(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), hn(e.nzCheckedChildren);
                }
            }
            function jne(t, n) {
                if ((1 & t && (Xe(0), ue(1, Yne, 2, 1, 'ng-container', 9), Ze()), 2 & t)) {
                    const e = L();
                    z(), H('nzStringTemplateOutlet', e.nzCheckedChildren);
                }
            }
            function $ne(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), hn(e.nzUnCheckedChildren);
                }
            }
            function Gne(t, n) {
                1 & t && ue(0, $ne, 2, 1, 'ng-container', 9),
                    2 & t && H('nzStringTemplateOutlet', L().nzUnCheckedChildren);
            }
            let Kne = (() => {
                    class t {
                        updateValue(e) {
                            this.isChecked !== e && ((this.isChecked = e), this.onChange(this.isChecked));
                        }
                        focus() {
                            this.focusMonitor.focusVia(this.switchElement.nativeElement, 'keyboard');
                        }
                        blur() {
                            this.switchElement.nativeElement.blur();
                        }
                        constructor(e, i, r, s, o, a) {
                            (this.nzConfigService = e),
                                (this.host = i),
                                (this.ngZone = r),
                                (this.cdr = s),
                                (this.focusMonitor = o),
                                (this.directionality = a),
                                (this._nzModuleName = 'switch'),
                                (this.isChecked = !1),
                                (this.onChange = () => {}),
                                (this.onTouched = () => {}),
                                (this.nzLoading = !1),
                                (this.nzDisabled = !1),
                                (this.nzControl = !1),
                                (this.nzCheckedChildren = null),
                                (this.nzUnCheckedChildren = null),
                                (this.nzSize = 'default'),
                                (this.nzId = null),
                                (this.dir = 'ltr'),
                                (this.destroy$ = new vt()),
                                (this.isNzDisableFirstChange = !0);
                        }
                        ngOnInit() {
                            this.directionality.change.pipe(nn(this.destroy$)).subscribe(e => {
                                (this.dir = e), this.cdr.detectChanges();
                            }),
                                (this.dir = this.directionality.value),
                                this.ngZone.runOutsideAngular(() => {
                                    ca(this.host.nativeElement, 'click')
                                        .pipe(nn(this.destroy$))
                                        .subscribe(e => {
                                            e.preventDefault(),
                                                !(this.nzControl || this.nzDisabled || this.nzLoading) &&
                                                    this.ngZone.run(() => {
                                                        this.updateValue(!this.isChecked), this.cdr.markForCheck();
                                                    });
                                        }),
                                        ca(this.switchElement.nativeElement, 'keydown')
                                            .pipe(nn(this.destroy$))
                                            .subscribe(e => {
                                                if (this.nzControl || this.nzDisabled || this.nzLoading) return;
                                                const { keyCode: i } = e;
                                                (37 !== i && 39 !== i && 32 !== i && 13 !== i) ||
                                                    (e.preventDefault(),
                                                    this.ngZone.run(() => {
                                                        37 === i
                                                            ? this.updateValue(!1)
                                                            : 39 === i
                                                            ? this.updateValue(!0)
                                                            : (32 === i || 13 === i) &&
                                                              this.updateValue(!this.isChecked),
                                                            this.cdr.markForCheck();
                                                    }));
                                            });
                                });
                        }
                        ngAfterViewInit() {
                            this.focusMonitor
                                .monitor(this.switchElement.nativeElement, !0)
                                .pipe(nn(this.destroy$))
                                .subscribe(e => {
                                    e || Promise.resolve().then(() => this.onTouched());
                                });
                        }
                        ngOnDestroy() {
                            this.focusMonitor.stopMonitoring(this.switchElement.nativeElement),
                                this.destroy$.next(),
                                this.destroy$.complete();
                        }
                        writeValue(e) {
                            (this.isChecked = e), this.cdr.markForCheck();
                        }
                        registerOnChange(e) {
                            this.onChange = e;
                        }
                        registerOnTouched(e) {
                            this.onTouched = e;
                        }
                        setDisabledState(e) {
                            (this.nzDisabled = (this.isNzDisableFirstChange && this.nzDisabled) || e),
                                (this.isNzDisableFirstChange = !1),
                                this.cdr.markForCheck();
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(s0), te(Pn), te(en), te(kr), te(Df), te(yo, 8));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['nz-switch']],
                            viewQuery: function (i, r) {
                                if ((1 & i && Fr(Bne, 7), 2 & i)) {
                                    let s;
                                    Dr((s = xr())) && (r.switchElement = s.first);
                                }
                            },
                            inputs: {
                                nzLoading: 'nzLoading',
                                nzDisabled: 'nzDisabled',
                                nzControl: 'nzControl',
                                nzCheckedChildren: 'nzCheckedChildren',
                                nzUnCheckedChildren: 'nzUnCheckedChildren',
                                nzSize: 'nzSize',
                                nzId: 'nzId',
                            },
                            exportAs: ['nzSwitch'],
                            standalone: !0,
                            features: [$n([{ provide: hs, useExisting: Wt(() => t), multi: !0 }]), Qi],
                            decls: 9,
                            vars: 16,
                            consts: [
                                ['switchElement', ''],
                                ['uncheckTemplate', ''],
                                ['nz-wave', '', 'type', 'button', 1, 'ant-switch', 3, 'disabled', 'nzWaveExtraNode'],
                                [1, 'ant-switch-handle'],
                                ['nz-icon', '', 'nzType', 'loading', 'class', 'ant-switch-loading-icon', 4, 'ngIf'],
                                [1, 'ant-switch-inner'],
                                [4, 'ngIf', 'ngIfElse'],
                                [1, 'ant-click-animating-node'],
                                ['nz-icon', '', 'nzType', 'loading', 1, 'ant-switch-loading-icon'],
                                [4, 'nzStringTemplateOutlet'],
                            ],
                            template: function (i, r) {
                                if (
                                    (1 & i &&
                                        (Z(0, 'button', 2, 0)(2, 'span', 3),
                                        ue(3, qne, 1, 0, 'span', 4),
                                        ee(),
                                        Z(4, 'span', 5),
                                        ue(5, jne, 2, 1, 'ng-container', 6)(6, Gne, 1, 1, 'ng-template', null, 1, Xs),
                                        ee(),
                                        Oe(8, 'div', 7),
                                        ee()),
                                    2 & i)
                                ) {
                                    const s = ts(7);
                                    On('ant-switch-checked', r.isChecked)('ant-switch-loading', r.nzLoading)(
                                        'ant-switch-disabled',
                                        r.nzDisabled,
                                    )('ant-switch-small', 'small' === r.nzSize)('ant-switch-rtl', 'rtl' === r.dir),
                                        H('disabled', r.nzDisabled)('nzWaveExtraNode', !0),
                                        zi('id', r.nzId),
                                        z(3),
                                        H('ngIf', r.nzLoading),
                                        z(2),
                                        H('ngIf', r.isChecked)('ngIfElse', s);
                                }
                            },
                            dependencies: [CD, Ng, o0, xc, hi, bh, yh],
                            encapsulation: 2,
                            changeDetection: 0,
                        }));
                    }
                    return (
                        Lt([En()], t.prototype, 'nzLoading', void 0),
                        Lt([En()], t.prototype, 'nzDisabled', void 0),
                        Lt([En()], t.prototype, 'nzControl', void 0),
                        Lt([fs()], t.prototype, 'nzSize', void 0),
                        t
                    );
                })(),
                Qne = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵmod = Zn({ type: t }));
                        static #n = (this.ɵinj = zn({ imports: [Kne] }));
                    }
                    return t;
                })();
            var Xne = U(5801),
                Zne = U(9545),
                i3 = U.n(Zne),
                Jne = Function.prototype.toString,
                l5 = Object.create,
                eie = Object.prototype.toString,
                tie = (function () {
                    function t() {
                        (this._keys = []), (this._values = []);
                    }
                    return (
                        (t.prototype.has = function (n) {
                            return !!~this._keys.indexOf(n);
                        }),
                        (t.prototype.get = function (n) {
                            return this._values[this._keys.indexOf(n)];
                        }),
                        (t.prototype.set = function (n, e) {
                            this._keys.push(n), this._values.push(e);
                        }),
                        t
                    );
                })(),
                rie =
                    typeof WeakMap < 'u'
                        ? function iie() {
                              return new WeakMap();
                          }
                        : function nie() {
                              return new tie();
                          };
            function c5(t) {
                if (!t) return l5(null);
                var n = t.constructor;
                if (n === Object) return t === Object.prototype ? {} : l5(t);
                if (n && ~Jne.call(n).indexOf('[native code]'))
                    try {
                        return new n();
                    } catch {}
                return l5(t);
            }
            var aie =
                'g' === /test/g.flags
                    ? function oie(t) {
                          return t.flags;
                      }
                    : function sie(t) {
                          var n = '';
                          return (
                              t.global && (n += 'g'),
                              t.ignoreCase && (n += 'i'),
                              t.multiline && (n += 'm'),
                              t.unicode && (n += 'u'),
                              t.sticky && (n += 'y'),
                              n
                          );
                      };
            function jx(t) {
                var n = eie.call(t);
                return n.substring(8, n.length - 1);
            }
            var cie =
                    typeof Symbol < 'u'
                        ? function lie(t) {
                              return t[Symbol.toStringTag] || jx(t);
                          }
                        : jx,
                uie = Object.defineProperty,
                die = Object.getOwnPropertyDescriptor,
                $x = Object.getOwnPropertyNames,
                u5 = Object.getOwnPropertySymbols,
                Gx = Object.prototype,
                Wx = Gx.hasOwnProperty,
                hie = Gx.propertyIsEnumerable,
                Kx = 'function' == typeof u5,
                mie = Kx
                    ? function fie(t) {
                          return $x(t).concat(u5(t));
                      }
                    : $x;
            function r3(t, n, e) {
                for (var i = mie(t), r = 0, s = i.length, o = void 0, a = void 0; r < s; ++r)
                    if ('callee' !== (o = i[r]) && 'caller' !== o) {
                        if (!(a = die(t, o))) {
                            n[o] = e.copier(t[o], e);
                            continue;
                        }
                        !a.get && !a.set && (a.value = e.copier(a.value, e));
                        try {
                            uie(n, o, a);
                        } catch {
                            n[o] = a.value;
                        }
                    }
                return n;
            }
            function Qx(t, n) {
                return t.slice(0);
            }
            function Xx(t, n) {
                var e = new n.Constructor();
                return (
                    n.cache.set(t, e),
                    t.forEach(function (i, r) {
                        e.set(r, n.copier(i, n));
                    }),
                    e
                );
            }
            function d5(t, n) {
                return new n.Constructor(t.valueOf());
            }
            function s3(t, n) {
                return t;
            }
            function Zx(t, n) {
                var e = new n.Constructor();
                return (
                    n.cache.set(t, e),
                    t.forEach(function (i) {
                        e.add(n.copier(i, n));
                    }),
                    e
                );
            }
            var xie = Array.isArray,
                h5 = Object.assign,
                kie =
                    Object.getPrototypeOf ||
                    function (t) {
                        return t.__proto__;
                    },
                Jx = {
                    array: function pie(t, n) {
                        var e = new n.Constructor();
                        n.cache.set(t, e);
                        for (var i = 0, r = t.length; i < r; ++i) e[i] = n.copier(t[i], n);
                        return e;
                    },
                    arrayBuffer: Qx,
                    blob: function vie(t, n) {
                        return t.slice(0, t.size, t.type);
                    },
                    dataView: function _ie(t, n) {
                        return new n.Constructor(Qx(t.buffer));
                    },
                    date: function yie(t, n) {
                        return new n.Constructor(t.getTime());
                    },
                    error: s3,
                    map: Xx,
                    object: Kx
                        ? function wie(t, n) {
                              var e = c5(n.prototype);
                              for (var i in (n.cache.set(t, e), t)) Wx.call(t, i) && (e[i] = n.copier(t[i], n));
                              for (var r = u5(t), s = 0, o = r.length, a = void 0; s < o; ++s)
                                  hie.call(t, (a = r[s])) && (e[a] = n.copier(t[a], n));
                              return e;
                          }
                        : function Cie(t, n) {
                              var e = c5(n.prototype);
                              for (var i in (n.cache.set(t, e), t)) Wx.call(t, i) && (e[i] = n.copier(t[i], n));
                              return e;
                          },
                    regExp: function Tie(t, n) {
                        var e = new n.Constructor(t.source, aie(t));
                        return (e.lastIndex = t.lastIndex), e;
                    },
                    set: Zx,
                },
                Eie = h5({}, Jx, {
                    array: function gie(t, n) {
                        var e = new n.Constructor();
                        return n.cache.set(t, e), r3(t, e, n);
                    },
                    map: function bie(t, n) {
                        return r3(t, Xx(t, n), n);
                    },
                    object: function Sie(t, n) {
                        var e = c5(n.prototype);
                        return n.cache.set(t, e), r3(t, e, n);
                    },
                    set: function Die(t, n) {
                        return r3(t, Zx(t, n), n);
                    },
                });
            function ek(t) {
                var e = (function Iie(t) {
                        return {
                            Arguments: t.object,
                            Array: t.array,
                            ArrayBuffer: t.arrayBuffer,
                            Blob: t.blob,
                            Boolean: d5,
                            DataView: t.dataView,
                            Date: t.date,
                            Error: t.error,
                            Float32Array: t.arrayBuffer,
                            Float64Array: t.arrayBuffer,
                            Int8Array: t.arrayBuffer,
                            Int16Array: t.arrayBuffer,
                            Int32Array: t.arrayBuffer,
                            Map: t.map,
                            Number: d5,
                            Object: t.object,
                            Promise: s3,
                            RegExp: t.regExp,
                            Set: t.set,
                            String: d5,
                            WeakMap: s3,
                            WeakSet: s3,
                            Uint8Array: t.arrayBuffer,
                            Uint8ClampedArray: t.arrayBuffer,
                            Uint16Array: t.arrayBuffer,
                            Uint32Array: t.arrayBuffer,
                            Uint64Array: t.arrayBuffer,
                        };
                    })(h5({}, Jx, t)),
                    i = e.Array,
                    r = e.Object;
                function s(o, a) {
                    if (((a.prototype = a.Constructor = void 0), !o || 'object' != typeof o)) return o;
                    if (a.cache.has(o)) return a.cache.get(o);
                    if (
                        ((a.prototype = kie(o)),
                        (a.Constructor = a.prototype && a.prototype.constructor),
                        !a.Constructor || a.Constructor === Object)
                    )
                        return r(o, a);
                    if (xie(o)) return i(o, a);
                    var l = e[cie(o)];
                    return l ? l(o, a) : 'function' == typeof o.then ? o : r(o, a);
                }
                return function (a) {
                    return s(a, { Constructor: void 0, cache: rie(), copier: s, prototype: void 0 });
                };
            }
            !(function Aie(t) {
                ek(h5({}, Eie, t));
            })({});
            var wh = ek({}),
                Lie = U(9250),
                f5 = U.n(Lie);
            const Rt = {
                    parseDateFormats: [
                        'M/D/YYYY',
                        'M/D/YY',
                        'M/D',
                        'M-D-YYYY',
                        'M-D-YY',
                        'M-D',
                        'YYYY',
                        'YYYY-M-D',
                        'YYYY/M/D',
                        i3().ISO_8601,
                        'M/D/YYYY HH:mm',
                        'M/D/YY HH:mm',
                        'M/D HH:mm',
                        'M-D-YYYY HH:mm',
                        'M-D-YY HH:mm',
                        'M-D HH:mm',
                    ],
                    intRegex: /^\s*(\+|-)?\d+\s*$/,
                    decRegex: /^\s*[\+-]?([\+-]?\d+\.?\d*([eE]?[\+|-]?\d+)?|[\+-]?\d*\.?\d+[eE]?([\+|-]?\d+)?)\s*$/,
                    areTwoAnswersSame: function (t, n, e) {
                        let i = ['label', 'code', 'text', 'score', 'other'];
                        if ('object' != typeof t) return !1;
                        let s = !1;
                        if ((!t.system && !n.system) || t.system === (n.system ? n.system : e.answerCodeSystem)) {
                            s = !0;
                            let l = Object.keys(t);
                            for (var o = 0, a = l.length; o < a; o++)
                                if (i.indexOf(l[o]) >= 0 && t[l[o]] !== n[l[o]]) {
                                    s = !1;
                                    break;
                                }
                        }
                        return s;
                    },
                    dateToDTStringISO: function (t) {
                        return t && t instanceof Date && !isNaN(t.getTime())
                            ? [
                                  (1e4 + t.getFullYear()).toString().substr(1),
                                  (101 + t.getMonth()).toString().substr(1),
                                  (100 + t.getDate()).toString().substr(1),
                              ].join('-')
                            : void 0;
                    },
                    stringToDTDateISO: function (t) {
                        var n = new Date(t);
                        return isNaN(n.getTime())
                            ? void 0
                            : new Date(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate());
                    },
                    dateToDTMString: function (t) {
                        return 'string' == typeof t && (t = this.stringToDate(t, !0)), t.toISOString();
                    },
                    stringToDate: function (t, n) {
                        if (!t || 'string' != typeof t) return t;
                        if ('t' === t.trim()) return new Date();
                        let e = i3()(t, this.parseDateFormats, !0);
                        return n && !e.isValid() && (e = i3()(t)), e.isValid() ? e.toDate() : null;
                    },
                    isValidDate: function (t) {
                        return !!this.stringToDate(t);
                    },
                    formatDate: function (t, n) {
                        return i3()(t).format(n);
                    },
                    getNextLetter: function (t) {
                        for (var e = [], i = t; i > 0; ) {
                            var r = i % 26;
                            e.push((r = 0 === r ? 25 : r - 1)), (i = Math.floor((i - 1) / 26));
                        }
                        for (var s = '', o = e.length - 1; o >= 0; o--) s += 'abcdefghijklmnopqrstuvqxyz'.charAt(e[o]);
                        return s;
                    },
                    findObjectInArray: function (t, n, e, i, r) {
                        var s = r ? [] : null;
                        if (Array.isArray(t)) {
                            var o = 0;
                            i && Math.abs(i) < t.length && (o = i < 0 ? t.length + i : i);
                            for (var a = t.length, l = o; l < a; l++)
                                if (t[l][n] === e) {
                                    var c = t[l];
                                    if (!r) {
                                        s = c;
                                        break;
                                    }
                                    s.push(c);
                                }
                        }
                        return s;
                    },
                    _pruneObject: function (t, n, e) {
                        if ('object' == typeof n)
                            for (var i in n)
                                if (i.match(t)) delete n[i];
                                else if (e && i === e) {
                                    var r = n[i];
                                    if (Array.isArray(r))
                                        for (var s = r.length, o = 0; o < s; o++) this._pruneObject(t, r[o], e);
                                    else this._pruneObject(t, r, e);
                                }
                    },
                    pruneNulls: function (t) {
                        if (Array.isArray(t))
                            for (var n = t.length - 1; n >= 0; n--)
                                null == t[n] ? t.splice(n, 1) : 'object' == typeof t[n] && this.pruneNulls(t[n]);
                        else
                            t &&
                                'object' == typeof t &&
                                Object.keys(t).forEach(function (i) {
                                    null == t[i] ? delete t[i] : 'object' == typeof t[i] && this.pruneNulls(t[i]);
                                }, this);
                    },
                    deepCopy: function (t) {
                        return wh(t);
                    },
                    deepEqual: function (t, n) {
                        return f5()(t, n);
                    },
                    shallowEqual: function (t, n) {
                        var e = !0;
                        if (typeof t != typeof n) e = !1;
                        else if ('object' != typeof t) t !== n && (e = !1);
                        else {
                            var i = Object.keys(t),
                                r = Object.keys(n);
                            if (i.length !== r.length) e = !1;
                            else
                                for (var s = 0, o = i.length; s < o; s++)
                                    if (t[i[s]] !== n[i[s]]) {
                                        e = !1;
                                        break;
                                    }
                        }
                        return e;
                    },
                    showWarning: function (t, n) {
                        n && (t = 'The question "' + n.text + '" produced the following warning:  ' + t),
                            console.log(t);
                    },
                    isInteger(t) {
                        return !!Number.isInteger(t) || ('number' != typeof t && this.intRegex.test(t));
                    },
                    isDecimal(t) {
                        return 'number' == typeof t || this.decRegex.test(t);
                    },
                },
                tk = {
                    messages: {
                        comparatorInQuantity: { en: 'This item cannot accept a quantity with a comparator' },
                        nonMatchingQuantityUnit: {
                            en: 'An attempt was made to assign a quantity with a non-matching unit.',
                        },
                        MultipleValuesForNonRepeat: {
                            en: 'An attempt was made to assign multiple values to a non-repeating item.',
                        },
                        invalidTagInHelpHTMLContent: { en: 'Invalid HTML tags/attributes found in the help text.' },
                        invalidTagInHTMLContent: { en: 'Invalid HTML tags/attributes found in item text.' },
                    },
                    getMsg: function (t) {
                        const n = this.messages[t];
                        if (!n) throw new Error('Unknown message ID "' + t + '"');
                        const e = n[this.language];
                        if (!e)
                            throw new Error('Unknown language code "' + this.language + '" for message ID "' + t + '"');
                        return e;
                    },
                    addMsg: function (t, n) {
                        t[n] = this.getMsg(n);
                    },
                    setLanguage: function (t) {
                        this.language = t;
                    },
                },
                Ge_DATA_CONTROL_CONSTRUCTION_ARRAY = 'ARRAY',
                Ge_DATA_CONTROL_CONSTRUCTION_OBJECT = 'OBJECT',
                Ge_DATA_CONTROL_CONSTRUCTION_SIMPLE = 'SIMPLE',
                Ge_DATA_CONTROL_SOURCE_INTERNAL = 'INTERNAL',
                Ge_SKIP_LOGIC_ACTION_ENABLE = 'show',
                Ge_SKIP_LOGIC_ACTION_DISABLE = 'hide',
                Ge_SKIP_LOGIC_STATUS_ENABLED = 'target-enabled',
                Ge_SKIP_LOGIC_STATUS_DISABLED = 'target-disabled',
                Ge_CALCULATION_METHOD_TOTALSCORE = 'TOTALSCORE',
                Ge_DATA_TYPE_INT = 'INT',
                Ge_DATA_TYPE_REAL = 'REAL',
                Ge_DATA_TYPE_ST = 'ST',
                Ge_DATA_TYPE_TX = 'TX',
                Ge_DATA_TYPE_DT = 'DT',
                Ge_DATA_TYPE_DTM = 'DTM',
                Ge_DATA_TYPE_TM = 'TM',
                Ge_DATA_TYPE_CNE = 'CNE',
                Ge_DATA_TYPE_CWE = 'CWE',
                Ge_DATA_TYPE_SECTION = 'SECTION',
                Ge_DATA_TYPE_TITLE = 'TITLE',
                Ge_DATA_TYPE_QTY = 'QTY',
                Ge_DATA_TYPE_BL = 'BL',
                Ge_DATA_TYPE_CODING = 'CODING',
                $i = {
                    assignValueToItem: function (t, n, e) {
                        var i = !1;
                        if (((e = e || (n && n._type)), n && 'Quantity' === e)) {
                            t.value !== n.value && ((t.value = n.value), (i = !0));
                            var r = { name: n.name };
                            n.code && ((r.code = n.code), n.system && (r.system = n.system)),
                                Rt.deepEqual(t.unit, r) || ((t.unit = r), (i = !0));
                        } else Rt.deepEqual(t.value, n) || ((t.value = n), (i = !0));
                        return i;
                    },
                    modelForOffListUnit: function (t) {
                        return t ? { name: t, _displayUnit: t } : void 0;
                    },
                    printInvalidHtmlToConsole: function (t) {
                        console.log('Possible invalid HTML tags/attributes:'),
                            t.forEach(n => {
                                n.attributeValue
                                    ? console.log(
                                          '  - Attribute value: ' +
                                              n.attributeValue +
                                              ' of ' +
                                              n.attribute +
                                              ' in ' +
                                              n.tag,
                                      )
                                    : n.attribute
                                    ? console.log('  - Attribute: ' + n.attribute + ' in ' + n.tag)
                                    : n.tag && console.log('  - Element: ' + n.tag);
                            });
                    },
                    setItemMessagesArray: function (t, n, e) {
                        let i, r;
                        for (let s of n)
                            if (s) {
                                i || ((i = { errors: {}, warnings: {}, info: {} }), (r = Object.keys(i)));
                                for (let o of r) s[o] && Object.assign(i[o], s[o]);
                            }
                        this.setItemMessages(t, i, e);
                    },
                    setItemMessages: function (t, n, e) {
                        n
                            ? (t.messages || (t.messages = {}), (t.messages[e] = n))
                            : t.messages && (delete t.messages[e], Object.keys(t.messages).length || delete t.messages);
                    },
                    addItemWarning: function (t, n, e) {
                        e || (e = 'Other message source');
                        let i = t.messages;
                        i || (i = t.messages = {});
                        let r = i[e];
                        r || (r = i[e] = {});
                        let s = r.warnings;
                        s || (s = r.warnings = {}), (s[n] = tk.getMsg(n)), console.log(JSON.stringify(t.messages));
                    },
                    removeItemWarning: function (t, n, e) {
                        let i, r, s;
                        e || (e = 'Other message source'),
                            (i = t.messages) && (r = i[e]) && (s = r.warnings) && delete s[n];
                    },
                    hasAnswerList: function (t) {
                        return (
                            'CODING' === t.dataType ||
                            (t.answers &&
                                ('ST' === t.dataType ||
                                    'INT' === t.dataType ||
                                    'DT' === t.dataType ||
                                    'TM' === t.dataType))
                        );
                    },
                    _getHtmlStringWithContainedImages: function (t, n) {
                        if (t) {
                            let i = new DOMParser().parseFromString(n, 'text/html'),
                                r = i.getElementsByTagName('img');
                            for (let s = 0; s < r.length; s++) {
                                let o = r[s].getAttribute('src');
                                if (o && o.match(/^#/)) {
                                    let l = t[o.substring(1)];
                                    l && r[s].setAttribute('src', l);
                                }
                            }
                            return i.body.innerHTML;
                        }
                        return '';
                    },
                    targetEnabled: function (t) {
                        return !1 !== t._enableWhenExpVal && t._skipLogicStatus !== Ge_SKIP_LOGIC_STATUS_DISABLED;
                    },
                    targetDisabledAndProtected: function (t) {
                        return 'protected' === t._disabledDisplayStatus && !this.targetEnabled(t);
                    },
                    targetShown: function (t) {
                        return 'protected' === t._disabledDisplayStatus || this.targetEnabled(t);
                    },
                };
            ($i.errorMessages = tk), $i.errorMessages.setLanguage('en');
            const nk = new Uint16Array(
                    '\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\u{1d504}rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\u{1d538}plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\u{1d49c}ign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\u{1d505}pf;\uc000\u{1d539}eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\u{1d49e}p\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\u{1d507}\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\u{1d53b}\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\u{1d49f}rok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\u{1d508}rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\u{1d53c}silon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\u{1d509}lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\u{1d53d}All;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\u{1d50a};\u62d9pf;\uc000\u{1d53e}eater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\u{1d4a2};\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\u{1d540}a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\u{1d50d}pf;\uc000\u{1d541}\u01e3\u07c7\0\u07ccr;\uc000\u{1d4a5}rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\u{1d50e}pf;\uc000\u{1d542}cr;\uc000\u{1d4a6}\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\u{1d50f}\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\u{1d543}er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\u{1d510}nusPlus;\u6213pf;\uc000\u{1d544}c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\u{1d511}\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\u{1d4a9}ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\u{1d512}rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\u{1d546}enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\u{1d4aa}ash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\u{1d513}i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\u{1d4ab};\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b"\u4022r;\uc000\u{1d514}pf;\u611acr;\uc000\u{1d4ac}\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\u{1d516}ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\u{1d54a}\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\u{1d4ae}ar;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\u{1d517}\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\u{1d54b}ipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\u{1d4af}rok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\u{1d518}rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\u{1d54c}\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\u{1d4b0}ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\u{1d519}pf;\uc000\u{1d54d}cr;\uc000\u{1d4b1}dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\u{1d51a}pf;\uc000\u{1d54e}cr;\uc000\u{1d4b2}\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\u{1d51b};\u439epf;\uc000\u{1d54f}cr;\uc000\u{1d4b3}\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\u{1d51c}pf;\uc000\u{1d550}cr;\uc000\u{1d4b4}ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\u{1d4b5}\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\u{1d51e}rave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\u{1d552}\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\u{1d4b6};\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\u{1d51f}g\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\u{1d553}\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\u{1d4b7}mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\u{1d520}\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\u{1d554}o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\u{1d4b8}\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\u{1d521}ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\u{1d555}\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\u{1d4b9};\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\u{1d522}\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\u{1d556}\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\u{1d523}lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\u{1d557}\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\u{1d4bb}\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\u{1d524}\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\u{1d558}\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\u{1d525}s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\u{1d559}bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\u{1d4bd}as\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\u{1d526}rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\u{1d55a}a;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\u{1d4be}n\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\u{1d527}ath;\u4237pf;\uc000\u{1d55b}\u01e3\u23ec\0\u23f1r;\uc000\u{1d4bf}rcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\u{1d528}reen;\u4138cy;\u4445cy;\u445cpf;\uc000\u{1d55c}cr;\uc000\u{1d4c0}\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\u{1d529}\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\u{1d55d}us;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\u{1d4c1}m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\u{1d52a}o;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\u{1d55e}\u0100ct\u28f8\u28fdr;\uc000\u{1d4c2}pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\u{1d52b}\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\u{1d55f}\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\u{1d4c3}ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\u{1d52c}\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\u{1d560}\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\u{1d52d}\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\u{1d561}nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\u{1d4c5};\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\u{1d52e}pf;\uc000\u{1d562}rime;\u6057cr;\uc000\u{1d4c6}\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\u{1d52f}\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\u{1d563}us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\u{1d4c7}\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\u{1d530}\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\u{1d564}a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\u{1d4c8}tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\u{1d531}\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\u{1d565}rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\u{1d4c9};\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\u{1d532}rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\u{1d566}\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\u{1d4ca}\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\u{1d533}tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\u{1d567}ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\u{1d4cb}\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\u{1d534}pf;\uc000\u{1d568}\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\u{1d4cc}\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\u{1d535}\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\u{1d569}im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\u{1d4cd}\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\u{1d536}cy;\u4457pf;\uc000\u{1d56a}cr;\uc000\u{1d4ce}\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\u{1d537}cy;\u4436grarr;\u61ddpf;\uc000\u{1d56b}cr;\uc000\u{1d4cf}\u0100jn\u3b85\u3b87;\u600dj;\u600c'
                        .split('')
                        .map(t => t.charCodeAt(0)),
                ),
                ik = new Uint16Array(
                    '\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022'
                        .split('')
                        .map(t => t.charCodeAt(0)),
                );
            var m5;
            const Oie = new Map([
                    [0, 65533],
                    [128, 8364],
                    [130, 8218],
                    [131, 402],
                    [132, 8222],
                    [133, 8230],
                    [134, 8224],
                    [135, 8225],
                    [136, 710],
                    [137, 8240],
                    [138, 352],
                    [139, 8249],
                    [140, 338],
                    [142, 381],
                    [145, 8216],
                    [146, 8217],
                    [147, 8220],
                    [148, 8221],
                    [149, 8226],
                    [150, 8211],
                    [151, 8212],
                    [152, 732],
                    [153, 8482],
                    [154, 353],
                    [155, 8250],
                    [156, 339],
                    [158, 382],
                    [159, 376],
                ]),
                o3 =
                    null !== (m5 = String.fromCodePoint) && void 0 !== m5
                        ? m5
                        : function (t) {
                              let n = '';
                              return (
                                  t > 65535 &&
                                      ((t -= 65536),
                                      (n += String.fromCharCode(((t >>> 10) & 1023) | 55296)),
                                      (t = 56320 | (1023 & t))),
                                  (n += String.fromCharCode(t)),
                                  n
                              );
                          };
            var Ts = (function (t) {
                    return (
                        (t[(t.NUM = 35)] = 'NUM'),
                        (t[(t.SEMI = 59)] = 'SEMI'),
                        (t[(t.EQUALS = 61)] = 'EQUALS'),
                        (t[(t.ZERO = 48)] = 'ZERO'),
                        (t[(t.NINE = 57)] = 'NINE'),
                        (t[(t.LOWER_A = 97)] = 'LOWER_A'),
                        (t[(t.LOWER_F = 102)] = 'LOWER_F'),
                        (t[(t.LOWER_X = 120)] = 'LOWER_X'),
                        (t[(t.LOWER_Z = 122)] = 'LOWER_Z'),
                        (t[(t.UPPER_A = 65)] = 'UPPER_A'),
                        (t[(t.UPPER_F = 70)] = 'UPPER_F'),
                        (t[(t.UPPER_Z = 90)] = 'UPPER_Z'),
                        t
                    );
                })(Ts || {}),
                Fu = (function (t) {
                    return (
                        (t[(t.VALUE_LENGTH = 49152)] = 'VALUE_LENGTH'),
                        (t[(t.BRANCH_LENGTH = 16256)] = 'BRANCH_LENGTH'),
                        (t[(t.JUMP_TABLE = 127)] = 'JUMP_TABLE'),
                        t
                    );
                })(Fu || {});
            function p5(t) {
                return t >= Ts.ZERO && t <= Ts.NINE;
            }
            var Ds = (function (t) {
                    return (
                        (t[(t.EntityStart = 0)] = 'EntityStart'),
                        (t[(t.NumericStart = 1)] = 'NumericStart'),
                        (t[(t.NumericDecimal = 2)] = 'NumericDecimal'),
                        (t[(t.NumericHex = 3)] = 'NumericHex'),
                        (t[(t.NamedEntity = 4)] = 'NamedEntity'),
                        t
                    );
                })(Ds || {}),
                Ko = (function (t) {
                    return (
                        (t[(t.Legacy = 0)] = 'Legacy'),
                        (t[(t.Strict = 1)] = 'Strict'),
                        (t[(t.Attribute = 2)] = 'Attribute'),
                        t
                    );
                })(Ko || {});
            class sk {
                constructor(n, e, i) {
                    (this.decodeTree = n),
                        (this.emitCodePoint = e),
                        (this.errors = i),
                        (this.state = Ds.EntityStart),
                        (this.consumed = 1),
                        (this.result = 0),
                        (this.treeIndex = 0),
                        (this.excess = 1),
                        (this.decodeMode = Ko.Strict);
                }
                startEntity(n) {
                    (this.decodeMode = n),
                        (this.state = Ds.EntityStart),
                        (this.result = 0),
                        (this.treeIndex = 0),
                        (this.excess = 1),
                        (this.consumed = 1);
                }
                write(n, e) {
                    switch (this.state) {
                        case Ds.EntityStart:
                            return n.charCodeAt(e) === Ts.NUM
                                ? ((this.state = Ds.NumericStart),
                                  (this.consumed += 1),
                                  this.stateNumericStart(n, e + 1))
                                : ((this.state = Ds.NamedEntity), this.stateNamedEntity(n, e));
                        case Ds.NumericStart:
                            return this.stateNumericStart(n, e);
                        case Ds.NumericDecimal:
                            return this.stateNumericDecimal(n, e);
                        case Ds.NumericHex:
                            return this.stateNumericHex(n, e);
                        case Ds.NamedEntity:
                            return this.stateNamedEntity(n, e);
                    }
                }
                stateNumericStart(n, e) {
                    return e >= n.length
                        ? -1
                        : (32 | n.charCodeAt(e)) === Ts.LOWER_X
                        ? ((this.state = Ds.NumericHex), (this.consumed += 1), this.stateNumericHex(n, e + 1))
                        : ((this.state = Ds.NumericDecimal), this.stateNumericDecimal(n, e));
                }
                addToNumericResult(n, e, i, r) {
                    if (e !== i) {
                        const s = i - e;
                        (this.result = this.result * Math.pow(r, s) + parseInt(n.substr(e, s), r)),
                            (this.consumed += s);
                    }
                }
                stateNumericHex(n, e) {
                    const i = e;
                    for (; e < n.length; ) {
                        const r = n.charCodeAt(e);
                        if (
                            !(
                                p5(r) ||
                                ((t = r), (t >= Ts.UPPER_A && t <= Ts.UPPER_F) || (t >= Ts.LOWER_A && t <= Ts.LOWER_F))
                            )
                        )
                            return this.addToNumericResult(n, i, e, 16), this.emitNumericEntity(r, 3);
                        e += 1;
                    }
                    var t;
                    return this.addToNumericResult(n, i, e, 16), -1;
                }
                stateNumericDecimal(n, e) {
                    const i = e;
                    for (; e < n.length; ) {
                        const r = n.charCodeAt(e);
                        if (!p5(r)) return this.addToNumericResult(n, i, e, 10), this.emitNumericEntity(r, 2);
                        e += 1;
                    }
                    return this.addToNumericResult(n, i, e, 10), -1;
                }
                emitNumericEntity(n, e) {
                    var i;
                    if (this.consumed <= e)
                        return (
                            null === (i = this.errors) ||
                                void 0 === i ||
                                i.absenceOfDigitsInNumericCharacterReference(this.consumed),
                            0
                        );
                    if (n === Ts.SEMI) this.consumed += 1;
                    else if (this.decodeMode === Ko.Strict) return 0;
                    return (
                        this.emitCodePoint(
                            (function rk(t) {
                                var n;
                                return (t >= 55296 && t <= 57343) || t > 1114111
                                    ? 65533
                                    : null !== (n = Oie.get(t)) && void 0 !== n
                                    ? n
                                    : t;
                            })(this.result),
                            this.consumed,
                        ),
                        this.errors &&
                            (n !== Ts.SEMI && this.errors.missingSemicolonAfterCharacterReference(),
                            this.errors.validateNumericCharacterReference(this.result)),
                        this.consumed
                    );
                }
                stateNamedEntity(n, e) {
                    const { decodeTree: i } = this;
                    let r = i[this.treeIndex],
                        s = (r & Fu.VALUE_LENGTH) >> 14;
                    for (; e < n.length; e++, this.excess++) {
                        const o = n.charCodeAt(e);
                        if (((this.treeIndex = Rie(i, r, this.treeIndex + Math.max(1, s), o)), this.treeIndex < 0))
                            return 0 === this.result ||
                                (this.decodeMode === Ko.Attribute &&
                                    (0 === s ||
                                        (t = o) === Ts.EQUALS ||
                                        (function Nie(t) {
                                            return (
                                                (t >= Ts.UPPER_A && t <= Ts.UPPER_Z) ||
                                                (t >= Ts.LOWER_A && t <= Ts.LOWER_Z) ||
                                                p5(t)
                                            );
                                        })(t)))
                                ? 0
                                : this.emitNotTerminatedNamedEntity();
                        if (((r = i[this.treeIndex]), (s = (r & Fu.VALUE_LENGTH) >> 14), 0 !== s)) {
                            if (o === Ts.SEMI)
                                return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
                            this.decodeMode !== Ko.Strict &&
                                ((this.result = this.treeIndex), (this.consumed += this.excess), (this.excess = 0));
                        }
                    }
                    var t;
                    return -1;
                }
                emitNotTerminatedNamedEntity() {
                    var n;
                    const { result: e, decodeTree: i } = this;
                    return (
                        this.emitNamedEntityData(e, (i[e] & Fu.VALUE_LENGTH) >> 14, this.consumed),
                        null === (n = this.errors) || void 0 === n || n.missingSemicolonAfterCharacterReference(),
                        this.consumed
                    );
                }
                emitNamedEntityData(n, e, i) {
                    const { decodeTree: r } = this;
                    return (
                        this.emitCodePoint(1 === e ? r[n] & ~Fu.VALUE_LENGTH : r[n + 1], i),
                        3 === e && this.emitCodePoint(r[n + 2], i),
                        i
                    );
                }
                end() {
                    var n;
                    switch (this.state) {
                        case Ds.NamedEntity:
                            return 0 === this.result ||
                                (this.decodeMode === Ko.Attribute && this.result !== this.treeIndex)
                                ? 0
                                : this.emitNotTerminatedNamedEntity();
                        case Ds.NumericDecimal:
                            return this.emitNumericEntity(0, 2);
                        case Ds.NumericHex:
                            return this.emitNumericEntity(0, 3);
                        case Ds.NumericStart:
                            return (
                                null === (n = this.errors) ||
                                    void 0 === n ||
                                    n.absenceOfDigitsInNumericCharacterReference(this.consumed),
                                0
                            );
                        case Ds.EntityStart:
                            return 0;
                    }
                }
            }
            function ok(t) {
                let n = '';
                const e = new sk(t, i => (n += o3(i)));
                return function (r, s) {
                    let o = 0,
                        a = 0;
                    for (; (a = r.indexOf('&', a)) >= 0; ) {
                        (n += r.slice(o, a)), e.startEntity(s);
                        const c = e.write(r, a + 1);
                        if (c < 0) {
                            o = a + e.end();
                            break;
                        }
                        (o = a + c), (a = 0 === c ? o + 1 : o);
                    }
                    const l = n + r.slice(o);
                    return (n = ''), l;
                };
            }
            function Rie(t, n, e, i) {
                const r = (n & Fu.BRANCH_LENGTH) >> 7,
                    s = n & Fu.JUMP_TABLE;
                if (0 === r) return 0 !== s && i === s ? e : -1;
                if (s) {
                    const l = i - s;
                    return l < 0 || l >= r ? -1 : t[e + l] - 1;
                }
                let o = e,
                    a = o + r - 1;
                for (; o <= a; ) {
                    const l = (o + a) >>> 1,
                        c = t[l];
                    if (c < i) o = l + 1;
                    else {
                        if (!(c > i)) return t[l + r];
                        a = l - 1;
                    }
                }
                return -1;
            }
            ok(nk), ok(ik);
            var $t = (function (t) {
                    return (
                        (t[(t.Tab = 9)] = 'Tab'),
                        (t[(t.NewLine = 10)] = 'NewLine'),
                        (t[(t.FormFeed = 12)] = 'FormFeed'),
                        (t[(t.CarriageReturn = 13)] = 'CarriageReturn'),
                        (t[(t.Space = 32)] = 'Space'),
                        (t[(t.ExclamationMark = 33)] = 'ExclamationMark'),
                        (t[(t.Number = 35)] = 'Number'),
                        (t[(t.Amp = 38)] = 'Amp'),
                        (t[(t.SingleQuote = 39)] = 'SingleQuote'),
                        (t[(t.DoubleQuote = 34)] = 'DoubleQuote'),
                        (t[(t.Dash = 45)] = 'Dash'),
                        (t[(t.Slash = 47)] = 'Slash'),
                        (t[(t.Zero = 48)] = 'Zero'),
                        (t[(t.Nine = 57)] = 'Nine'),
                        (t[(t.Semi = 59)] = 'Semi'),
                        (t[(t.Lt = 60)] = 'Lt'),
                        (t[(t.Eq = 61)] = 'Eq'),
                        (t[(t.Gt = 62)] = 'Gt'),
                        (t[(t.Questionmark = 63)] = 'Questionmark'),
                        (t[(t.UpperA = 65)] = 'UpperA'),
                        (t[(t.LowerA = 97)] = 'LowerA'),
                        (t[(t.UpperF = 70)] = 'UpperF'),
                        (t[(t.LowerF = 102)] = 'LowerF'),
                        (t[(t.UpperZ = 90)] = 'UpperZ'),
                        (t[(t.LowerZ = 122)] = 'LowerZ'),
                        (t[(t.LowerX = 120)] = 'LowerX'),
                        (t[(t.OpeningSquareBracket = 91)] = 'OpeningSquareBracket'),
                        t
                    );
                })($t || {}),
                Ye = (function (t) {
                    return (
                        (t[(t.Text = 1)] = 'Text'),
                        (t[(t.BeforeTagName = 2)] = 'BeforeTagName'),
                        (t[(t.InTagName = 3)] = 'InTagName'),
                        (t[(t.InSelfClosingTag = 4)] = 'InSelfClosingTag'),
                        (t[(t.BeforeClosingTagName = 5)] = 'BeforeClosingTagName'),
                        (t[(t.InClosingTagName = 6)] = 'InClosingTagName'),
                        (t[(t.AfterClosingTagName = 7)] = 'AfterClosingTagName'),
                        (t[(t.BeforeAttributeName = 8)] = 'BeforeAttributeName'),
                        (t[(t.InAttributeName = 9)] = 'InAttributeName'),
                        (t[(t.AfterAttributeName = 10)] = 'AfterAttributeName'),
                        (t[(t.BeforeAttributeValue = 11)] = 'BeforeAttributeValue'),
                        (t[(t.InAttributeValueDq = 12)] = 'InAttributeValueDq'),
                        (t[(t.InAttributeValueSq = 13)] = 'InAttributeValueSq'),
                        (t[(t.InAttributeValueNq = 14)] = 'InAttributeValueNq'),
                        (t[(t.BeforeDeclaration = 15)] = 'BeforeDeclaration'),
                        (t[(t.InDeclaration = 16)] = 'InDeclaration'),
                        (t[(t.InProcessingInstruction = 17)] = 'InProcessingInstruction'),
                        (t[(t.BeforeComment = 18)] = 'BeforeComment'),
                        (t[(t.CDATASequence = 19)] = 'CDATASequence'),
                        (t[(t.InSpecialComment = 20)] = 'InSpecialComment'),
                        (t[(t.InCommentLike = 21)] = 'InCommentLike'),
                        (t[(t.BeforeSpecialS = 22)] = 'BeforeSpecialS'),
                        (t[(t.BeforeSpecialT = 23)] = 'BeforeSpecialT'),
                        (t[(t.SpecialStartSequence = 24)] = 'SpecialStartSequence'),
                        (t[(t.InSpecialTag = 25)] = 'InSpecialTag'),
                        (t[(t.InEntity = 26)] = 'InEntity'),
                        t
                    );
                })(Ye || {});
            function Rl(t) {
                return (
                    t === $t.Space || t === $t.NewLine || t === $t.Tab || t === $t.FormFeed || t === $t.CarriageReturn
                );
            }
            function a3(t) {
                return t === $t.Slash || t === $t.Gt || Rl(t);
            }
            var Vl = (function (t) {
                return (
                    (t[(t.NoValue = 0)] = 'NoValue'),
                    (t[(t.Unquoted = 1)] = 'Unquoted'),
                    (t[(t.Single = 2)] = 'Single'),
                    (t[(t.Double = 3)] = 'Double'),
                    t
                );
            })(Vl || {});
            const xs = {
                Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
                CdataEnd: new Uint8Array([93, 93, 62]),
                CommentEnd: new Uint8Array([45, 45, 62]),
                ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
                StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
                TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
                TextareaEnd: new Uint8Array([60, 47, 116, 101, 120, 116, 97, 114, 101, 97]),
            };
            class Uie {
                constructor({ xmlMode: n = !1, decodeEntities: e = !0 }, i) {
                    (this.cbs = i),
                        (this.state = Ye.Text),
                        (this.buffer = ''),
                        (this.sectionStart = 0),
                        (this.index = 0),
                        (this.entityStart = 0),
                        (this.baseState = Ye.Text),
                        (this.isSpecial = !1),
                        (this.running = !0),
                        (this.offset = 0),
                        (this.currentSequence = void 0),
                        (this.sequenceIndex = 0),
                        (this.xmlMode = n),
                        (this.decodeEntities = e),
                        (this.entityDecoder = new sk(n ? ik : nk, (r, s) => this.emitCodePoint(r, s)));
                }
                reset() {
                    (this.state = Ye.Text),
                        (this.buffer = ''),
                        (this.sectionStart = 0),
                        (this.index = 0),
                        (this.baseState = Ye.Text),
                        (this.currentSequence = void 0),
                        (this.running = !0),
                        (this.offset = 0);
                }
                write(n) {
                    (this.offset += this.buffer.length), (this.buffer = n), this.parse();
                }
                end() {
                    this.running && this.finish();
                }
                pause() {
                    this.running = !1;
                }
                resume() {
                    (this.running = !0), this.index < this.buffer.length + this.offset && this.parse();
                }
                stateText(n) {
                    n === $t.Lt || (!this.decodeEntities && this.fastForwardTo($t.Lt))
                        ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index),
                          (this.state = Ye.BeforeTagName),
                          (this.sectionStart = this.index))
                        : this.decodeEntities && n === $t.Amp && this.startEntity();
                }
                stateSpecialStartSequence(n) {
                    const e = this.sequenceIndex === this.currentSequence.length;
                    if (e ? a3(n) : (32 | n) === this.currentSequence[this.sequenceIndex]) {
                        if (!e) return void this.sequenceIndex++;
                    } else this.isSpecial = !1;
                    (this.sequenceIndex = 0), (this.state = Ye.InTagName), this.stateInTagName(n);
                }
                stateInSpecialTag(n) {
                    if (this.sequenceIndex === this.currentSequence.length) {
                        if (n === $t.Gt || Rl(n)) {
                            const e = this.index - this.currentSequence.length;
                            if (this.sectionStart < e) {
                                const i = this.index;
                                (this.index = e), this.cbs.ontext(this.sectionStart, e), (this.index = i);
                            }
                            return (
                                (this.isSpecial = !1), (this.sectionStart = e + 2), void this.stateInClosingTagName(n)
                            );
                        }
                        this.sequenceIndex = 0;
                    }
                    (32 | n) === this.currentSequence[this.sequenceIndex]
                        ? (this.sequenceIndex += 1)
                        : 0 === this.sequenceIndex
                        ? this.currentSequence === xs.TitleEnd
                            ? this.decodeEntities && n === $t.Amp && this.startEntity()
                            : this.fastForwardTo($t.Lt) && (this.sequenceIndex = 1)
                        : (this.sequenceIndex = +(n === $t.Lt));
                }
                stateCDATASequence(n) {
                    n === xs.Cdata[this.sequenceIndex]
                        ? ++this.sequenceIndex === xs.Cdata.length &&
                          ((this.state = Ye.InCommentLike),
                          (this.currentSequence = xs.CdataEnd),
                          (this.sequenceIndex = 0),
                          (this.sectionStart = this.index + 1))
                        : ((this.sequenceIndex = 0), (this.state = Ye.InDeclaration), this.stateInDeclaration(n));
                }
                fastForwardTo(n) {
                    for (; ++this.index < this.buffer.length + this.offset; )
                        if (this.buffer.charCodeAt(this.index - this.offset) === n) return !0;
                    return (this.index = this.buffer.length + this.offset - 1), !1;
                }
                stateInCommentLike(n) {
                    n === this.currentSequence[this.sequenceIndex]
                        ? ++this.sequenceIndex === this.currentSequence.length &&
                          (this.currentSequence === xs.CdataEnd
                              ? this.cbs.oncdata(this.sectionStart, this.index, 2)
                              : this.cbs.oncomment(this.sectionStart, this.index, 2),
                          (this.sequenceIndex = 0),
                          (this.sectionStart = this.index + 1),
                          (this.state = Ye.Text))
                        : 0 === this.sequenceIndex
                        ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1)
                        : n !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
                }
                isTagStartChar(n) {
                    return this.xmlMode
                        ? !a3(n)
                        : (function Hie(t) {
                              return (t >= $t.LowerA && t <= $t.LowerZ) || (t >= $t.UpperA && t <= $t.UpperZ);
                          })(n);
                }
                startSpecial(n, e) {
                    (this.isSpecial = !0),
                        (this.currentSequence = n),
                        (this.sequenceIndex = e),
                        (this.state = Ye.SpecialStartSequence);
                }
                stateBeforeTagName(n) {
                    if (n === $t.ExclamationMark)
                        (this.state = Ye.BeforeDeclaration), (this.sectionStart = this.index + 1);
                    else if (n === $t.Questionmark)
                        (this.state = Ye.InProcessingInstruction), (this.sectionStart = this.index + 1);
                    else if (this.isTagStartChar(n)) {
                        const e = 32 | n;
                        (this.sectionStart = this.index),
                            (this.state = this.xmlMode
                                ? Ye.InTagName
                                : e === xs.ScriptEnd[2]
                                ? Ye.BeforeSpecialS
                                : e === xs.TitleEnd[2]
                                ? Ye.BeforeSpecialT
                                : Ye.InTagName);
                    } else
                        n === $t.Slash
                            ? (this.state = Ye.BeforeClosingTagName)
                            : ((this.state = Ye.Text), this.stateText(n));
                }
                stateInTagName(n) {
                    a3(n) &&
                        (this.cbs.onopentagname(this.sectionStart, this.index),
                        (this.sectionStart = -1),
                        (this.state = Ye.BeforeAttributeName),
                        this.stateBeforeAttributeName(n));
                }
                stateBeforeClosingTagName(n) {
                    Rl(n) ||
                        (n === $t.Gt
                            ? (this.state = Ye.Text)
                            : ((this.state = this.isTagStartChar(n) ? Ye.InClosingTagName : Ye.InSpecialComment),
                              (this.sectionStart = this.index)));
                }
                stateInClosingTagName(n) {
                    (n === $t.Gt || Rl(n)) &&
                        (this.cbs.onclosetag(this.sectionStart, this.index),
                        (this.sectionStart = -1),
                        (this.state = Ye.AfterClosingTagName),
                        this.stateAfterClosingTagName(n));
                }
                stateAfterClosingTagName(n) {
                    (n === $t.Gt || this.fastForwardTo($t.Gt)) &&
                        ((this.state = Ye.Text), (this.sectionStart = this.index + 1));
                }
                stateBeforeAttributeName(n) {
                    n === $t.Gt
                        ? (this.cbs.onopentagend(this.index),
                          this.isSpecial
                              ? ((this.state = Ye.InSpecialTag), (this.sequenceIndex = 0))
                              : (this.state = Ye.Text),
                          (this.sectionStart = this.index + 1))
                        : n === $t.Slash
                        ? (this.state = Ye.InSelfClosingTag)
                        : Rl(n) || ((this.state = Ye.InAttributeName), (this.sectionStart = this.index));
                }
                stateInSelfClosingTag(n) {
                    n === $t.Gt
                        ? (this.cbs.onselfclosingtag(this.index),
                          (this.state = Ye.Text),
                          (this.sectionStart = this.index + 1),
                          (this.isSpecial = !1))
                        : Rl(n) || ((this.state = Ye.BeforeAttributeName), this.stateBeforeAttributeName(n));
                }
                stateInAttributeName(n) {
                    (n === $t.Eq || a3(n)) &&
                        (this.cbs.onattribname(this.sectionStart, this.index),
                        (this.sectionStart = this.index),
                        (this.state = Ye.AfterAttributeName),
                        this.stateAfterAttributeName(n));
                }
                stateAfterAttributeName(n) {
                    n === $t.Eq
                        ? (this.state = Ye.BeforeAttributeValue)
                        : n === $t.Slash || n === $t.Gt
                        ? (this.cbs.onattribend(Vl.NoValue, this.sectionStart),
                          (this.sectionStart = -1),
                          (this.state = Ye.BeforeAttributeName),
                          this.stateBeforeAttributeName(n))
                        : Rl(n) ||
                          (this.cbs.onattribend(Vl.NoValue, this.sectionStart),
                          (this.state = Ye.InAttributeName),
                          (this.sectionStart = this.index));
                }
                stateBeforeAttributeValue(n) {
                    n === $t.DoubleQuote
                        ? ((this.state = Ye.InAttributeValueDq), (this.sectionStart = this.index + 1))
                        : n === $t.SingleQuote
                        ? ((this.state = Ye.InAttributeValueSq), (this.sectionStart = this.index + 1))
                        : Rl(n) ||
                          ((this.sectionStart = this.index),
                          (this.state = Ye.InAttributeValueNq),
                          this.stateInAttributeValueNoQuotes(n));
                }
                handleInAttributeValue(n, e) {
                    n === e || (!this.decodeEntities && this.fastForwardTo(e))
                        ? (this.cbs.onattribdata(this.sectionStart, this.index),
                          (this.sectionStart = -1),
                          this.cbs.onattribend(e === $t.DoubleQuote ? Vl.Double : Vl.Single, this.index + 1),
                          (this.state = Ye.BeforeAttributeName))
                        : this.decodeEntities && n === $t.Amp && this.startEntity();
                }
                stateInAttributeValueDoubleQuotes(n) {
                    this.handleInAttributeValue(n, $t.DoubleQuote);
                }
                stateInAttributeValueSingleQuotes(n) {
                    this.handleInAttributeValue(n, $t.SingleQuote);
                }
                stateInAttributeValueNoQuotes(n) {
                    Rl(n) || n === $t.Gt
                        ? (this.cbs.onattribdata(this.sectionStart, this.index),
                          (this.sectionStart = -1),
                          this.cbs.onattribend(Vl.Unquoted, this.index),
                          (this.state = Ye.BeforeAttributeName),
                          this.stateBeforeAttributeName(n))
                        : this.decodeEntities && n === $t.Amp && this.startEntity();
                }
                stateBeforeDeclaration(n) {
                    n === $t.OpeningSquareBracket
                        ? ((this.state = Ye.CDATASequence), (this.sequenceIndex = 0))
                        : (this.state = n === $t.Dash ? Ye.BeforeComment : Ye.InDeclaration);
                }
                stateInDeclaration(n) {
                    (n === $t.Gt || this.fastForwardTo($t.Gt)) &&
                        (this.cbs.ondeclaration(this.sectionStart, this.index),
                        (this.state = Ye.Text),
                        (this.sectionStart = this.index + 1));
                }
                stateInProcessingInstruction(n) {
                    (n === $t.Gt || this.fastForwardTo($t.Gt)) &&
                        (this.cbs.onprocessinginstruction(this.sectionStart, this.index),
                        (this.state = Ye.Text),
                        (this.sectionStart = this.index + 1));
                }
                stateBeforeComment(n) {
                    n === $t.Dash
                        ? ((this.state = Ye.InCommentLike),
                          (this.currentSequence = xs.CommentEnd),
                          (this.sequenceIndex = 2),
                          (this.sectionStart = this.index + 1))
                        : (this.state = Ye.InDeclaration);
                }
                stateInSpecialComment(n) {
                    (n === $t.Gt || this.fastForwardTo($t.Gt)) &&
                        (this.cbs.oncomment(this.sectionStart, this.index, 0),
                        (this.state = Ye.Text),
                        (this.sectionStart = this.index + 1));
                }
                stateBeforeSpecialS(n) {
                    const e = 32 | n;
                    e === xs.ScriptEnd[3]
                        ? this.startSpecial(xs.ScriptEnd, 4)
                        : e === xs.StyleEnd[3]
                        ? this.startSpecial(xs.StyleEnd, 4)
                        : ((this.state = Ye.InTagName), this.stateInTagName(n));
                }
                stateBeforeSpecialT(n) {
                    const e = 32 | n;
                    e === xs.TitleEnd[3]
                        ? this.startSpecial(xs.TitleEnd, 4)
                        : e === xs.TextareaEnd[3]
                        ? this.startSpecial(xs.TextareaEnd, 4)
                        : ((this.state = Ye.InTagName), this.stateInTagName(n));
                }
                startEntity() {
                    (this.baseState = this.state),
                        (this.state = Ye.InEntity),
                        (this.entityStart = this.index),
                        this.entityDecoder.startEntity(
                            this.xmlMode
                                ? Ko.Strict
                                : this.baseState === Ye.Text || this.baseState === Ye.InSpecialTag
                                ? Ko.Legacy
                                : Ko.Attribute,
                        );
                }
                stateInEntity() {
                    const n = this.entityDecoder.write(this.buffer, this.index - this.offset);
                    n >= 0
                        ? ((this.state = this.baseState), 0 === n && (this.index = this.entityStart))
                        : (this.index = this.offset + this.buffer.length - 1);
                }
                cleanup() {
                    this.running &&
                        this.sectionStart !== this.index &&
                        (this.state === Ye.Text || (this.state === Ye.InSpecialTag && 0 === this.sequenceIndex)
                            ? (this.cbs.ontext(this.sectionStart, this.index), (this.sectionStart = this.index))
                            : (this.state === Ye.InAttributeValueDq ||
                                  this.state === Ye.InAttributeValueSq ||
                                  this.state === Ye.InAttributeValueNq) &&
                              (this.cbs.onattribdata(this.sectionStart, this.index), (this.sectionStart = this.index)));
                }
                shouldContinue() {
                    return this.index < this.buffer.length + this.offset && this.running;
                }
                parse() {
                    for (; this.shouldContinue(); ) {
                        const n = this.buffer.charCodeAt(this.index - this.offset);
                        switch (this.state) {
                            case Ye.Text:
                                this.stateText(n);
                                break;
                            case Ye.SpecialStartSequence:
                                this.stateSpecialStartSequence(n);
                                break;
                            case Ye.InSpecialTag:
                                this.stateInSpecialTag(n);
                                break;
                            case Ye.CDATASequence:
                                this.stateCDATASequence(n);
                                break;
                            case Ye.InAttributeValueDq:
                                this.stateInAttributeValueDoubleQuotes(n);
                                break;
                            case Ye.InAttributeName:
                                this.stateInAttributeName(n);
                                break;
                            case Ye.InCommentLike:
                                this.stateInCommentLike(n);
                                break;
                            case Ye.InSpecialComment:
                                this.stateInSpecialComment(n);
                                break;
                            case Ye.BeforeAttributeName:
                                this.stateBeforeAttributeName(n);
                                break;
                            case Ye.InTagName:
                                this.stateInTagName(n);
                                break;
                            case Ye.InClosingTagName:
                                this.stateInClosingTagName(n);
                                break;
                            case Ye.BeforeTagName:
                                this.stateBeforeTagName(n);
                                break;
                            case Ye.AfterAttributeName:
                                this.stateAfterAttributeName(n);
                                break;
                            case Ye.InAttributeValueSq:
                                this.stateInAttributeValueSingleQuotes(n);
                                break;
                            case Ye.BeforeAttributeValue:
                                this.stateBeforeAttributeValue(n);
                                break;
                            case Ye.BeforeClosingTagName:
                                this.stateBeforeClosingTagName(n);
                                break;
                            case Ye.AfterClosingTagName:
                                this.stateAfterClosingTagName(n);
                                break;
                            case Ye.BeforeSpecialS:
                                this.stateBeforeSpecialS(n);
                                break;
                            case Ye.BeforeSpecialT:
                                this.stateBeforeSpecialT(n);
                                break;
                            case Ye.InAttributeValueNq:
                                this.stateInAttributeValueNoQuotes(n);
                                break;
                            case Ye.InSelfClosingTag:
                                this.stateInSelfClosingTag(n);
                                break;
                            case Ye.InDeclaration:
                                this.stateInDeclaration(n);
                                break;
                            case Ye.BeforeDeclaration:
                                this.stateBeforeDeclaration(n);
                                break;
                            case Ye.BeforeComment:
                                this.stateBeforeComment(n);
                                break;
                            case Ye.InProcessingInstruction:
                                this.stateInProcessingInstruction(n);
                                break;
                            case Ye.InEntity:
                                this.stateInEntity();
                        }
                        this.index++;
                    }
                    this.cleanup();
                }
                finish() {
                    this.state === Ye.InEntity && (this.entityDecoder.end(), (this.state = this.baseState)),
                        this.handleTrailingData(),
                        this.cbs.onend();
                }
                handleTrailingData() {
                    const n = this.buffer.length + this.offset;
                    this.sectionStart >= n ||
                        (this.state === Ye.InCommentLike
                            ? this.currentSequence === xs.CdataEnd
                                ? this.cbs.oncdata(this.sectionStart, n, 0)
                                : this.cbs.oncomment(this.sectionStart, n, 0)
                            : this.state === Ye.InTagName ||
                              this.state === Ye.BeforeAttributeName ||
                              this.state === Ye.BeforeAttributeValue ||
                              this.state === Ye.AfterAttributeName ||
                              this.state === Ye.InAttributeName ||
                              this.state === Ye.InAttributeValueSq ||
                              this.state === Ye.InAttributeValueDq ||
                              this.state === Ye.InAttributeValueNq ||
                              this.state === Ye.InClosingTagName ||
                              this.cbs.ontext(this.sectionStart, n));
                }
                emitCodePoint(n, e) {
                    this.baseState !== Ye.Text && this.baseState !== Ye.InSpecialTag
                        ? (this.sectionStart < this.entityStart &&
                              this.cbs.onattribdata(this.sectionStart, this.entityStart),
                          (this.sectionStart = this.entityStart + e),
                          (this.index = this.sectionStart - 1),
                          this.cbs.onattribentity(n))
                        : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart),
                          (this.sectionStart = this.entityStart + e),
                          (this.index = this.sectionStart - 1),
                          this.cbs.ontextentity(n, this.sectionStart));
                }
            }
            const d0 = new Set(['input', 'option', 'optgroup', 'select', 'button', 'datalist', 'textarea']),
                Ai = new Set(['p']),
                ak = new Set(['thead', 'tbody']),
                lk = new Set(['dd', 'dt']),
                ck = new Set(['rt', 'rp']),
                Bie = new Map([
                    ['tr', new Set(['tr', 'th', 'td'])],
                    ['th', new Set(['th'])],
                    ['td', new Set(['thead', 'th', 'td'])],
                    ['body', new Set(['head', 'link', 'script'])],
                    ['li', new Set(['li'])],
                    ['p', Ai],
                    ['h1', Ai],
                    ['h2', Ai],
                    ['h3', Ai],
                    ['h4', Ai],
                    ['h5', Ai],
                    ['h6', Ai],
                    ['select', d0],
                    ['input', d0],
                    ['output', d0],
                    ['button', d0],
                    ['datalist', d0],
                    ['textarea', d0],
                    ['option', new Set(['option'])],
                    ['optgroup', new Set(['optgroup', 'option'])],
                    ['dd', lk],
                    ['dt', lk],
                    ['address', Ai],
                    ['article', Ai],
                    ['aside', Ai],
                    ['blockquote', Ai],
                    ['details', Ai],
                    ['div', Ai],
                    ['dl', Ai],
                    ['fieldset', Ai],
                    ['figcaption', Ai],
                    ['figure', Ai],
                    ['footer', Ai],
                    ['form', Ai],
                    ['header', Ai],
                    ['hr', Ai],
                    ['main', Ai],
                    ['nav', Ai],
                    ['ol', Ai],
                    ['pre', Ai],
                    ['section', Ai],
                    ['table', Ai],
                    ['ul', Ai],
                    ['rt', ck],
                    ['rp', ck],
                    ['tbody', ak],
                    ['tfoot', ak],
                ]),
                qie = new Set([
                    'area',
                    'base',
                    'basefont',
                    'br',
                    'col',
                    'command',
                    'embed',
                    'frame',
                    'hr',
                    'img',
                    'input',
                    'isindex',
                    'keygen',
                    'link',
                    'meta',
                    'param',
                    'source',
                    'track',
                    'wbr',
                ]),
                uk = new Set(['math', 'svg']),
                dk = new Set(['mi', 'mo', 'mn', 'ms', 'mtext', 'annotation-xml', 'foreignobject', 'desc', 'title']),
                Yie = /\s|\//;
            class jie {
                constructor(n, e = {}) {
                    var i, r, s, o, a, l;
                    (this.options = e),
                        (this.startIndex = 0),
                        (this.endIndex = 0),
                        (this.openTagStart = 0),
                        (this.tagname = ''),
                        (this.attribname = ''),
                        (this.attribvalue = ''),
                        (this.attribs = null),
                        (this.stack = []),
                        (this.buffers = []),
                        (this.bufferOffset = 0),
                        (this.writeIndex = 0),
                        (this.ended = !1),
                        (this.cbs = n ?? {}),
                        (this.htmlMode = !this.options.xmlMode),
                        (this.lowerCaseTagNames = null !== (i = e.lowerCaseTags) && void 0 !== i ? i : this.htmlMode),
                        (this.lowerCaseAttributeNames =
                            null !== (r = e.lowerCaseAttributeNames) && void 0 !== r ? r : this.htmlMode),
                        (this.recognizeSelfClosing =
                            null !== (s = e.recognizeSelfClosing) && void 0 !== s ? s : !this.htmlMode),
                        (this.tokenizer = new (null !== (o = e.Tokenizer) && void 0 !== o ? o : Uie)(
                            this.options,
                            this,
                        )),
                        (this.foreignContext = [!this.htmlMode]),
                        null === (l = (a = this.cbs).onparserinit) || void 0 === l || l.call(a, this);
                }
                ontext(n, e) {
                    var i, r;
                    const s = this.getSlice(n, e);
                    (this.endIndex = e - 1),
                        null === (r = (i = this.cbs).ontext) || void 0 === r || r.call(i, s),
                        (this.startIndex = e);
                }
                ontextentity(n, e) {
                    var i, r;
                    (this.endIndex = e - 1),
                        null === (r = (i = this.cbs).ontext) || void 0 === r || r.call(i, o3(n)),
                        (this.startIndex = e);
                }
                isVoidElement(n) {
                    return this.htmlMode && qie.has(n);
                }
                onopentagname(n, e) {
                    this.endIndex = e;
                    let i = this.getSlice(n, e);
                    this.lowerCaseTagNames && (i = i.toLowerCase()), this.emitOpenTag(i);
                }
                emitOpenTag(n) {
                    var e, i, r, s;
                    (this.openTagStart = this.startIndex), (this.tagname = n);
                    const o = this.htmlMode && Bie.get(n);
                    if (o)
                        for (; this.stack.length > 0 && o.has(this.stack[0]); ) {
                            const a = this.stack.shift();
                            null === (i = (e = this.cbs).onclosetag) || void 0 === i || i.call(e, a, !0);
                        }
                    this.isVoidElement(n) ||
                        (this.stack.unshift(n),
                        this.htmlMode &&
                            (uk.has(n)
                                ? this.foreignContext.unshift(!0)
                                : dk.has(n) && this.foreignContext.unshift(!1))),
                        null === (s = (r = this.cbs).onopentagname) || void 0 === s || s.call(r, n),
                        this.cbs.onopentag && (this.attribs = {});
                }
                endOpenTag(n) {
                    var e, i;
                    (this.startIndex = this.openTagStart),
                        this.attribs &&
                            (null === (i = (e = this.cbs).onopentag) ||
                                void 0 === i ||
                                i.call(e, this.tagname, this.attribs, n),
                            (this.attribs = null)),
                        this.cbs.onclosetag &&
                            this.isVoidElement(this.tagname) &&
                            this.cbs.onclosetag(this.tagname, !0),
                        (this.tagname = '');
                }
                onopentagend(n) {
                    (this.endIndex = n), this.endOpenTag(!1), (this.startIndex = n + 1);
                }
                onclosetag(n, e) {
                    var i, r, s, o, a, l, c, f;
                    this.endIndex = e;
                    let g = this.getSlice(n, e);
                    if (
                        (this.lowerCaseTagNames && (g = g.toLowerCase()),
                        this.htmlMode && (uk.has(g) || dk.has(g)) && this.foreignContext.shift(),
                        this.isVoidElement(g))
                    )
                        this.htmlMode &&
                            'br' === g &&
                            (null === (o = (s = this.cbs).onopentagname) || void 0 === o || o.call(s, 'br'),
                            null === (l = (a = this.cbs).onopentag) || void 0 === l || l.call(a, 'br', {}, !0),
                            null === (f = (c = this.cbs).onclosetag) || void 0 === f || f.call(c, 'br', !1));
                    else {
                        const E = this.stack.indexOf(g);
                        if (-1 !== E)
                            for (let P = 0; P <= E; P++) {
                                const V = this.stack.shift();
                                null === (r = (i = this.cbs).onclosetag) || void 0 === r || r.call(i, V, P !== E);
                            }
                        else this.htmlMode && 'p' === g && (this.emitOpenTag('p'), this.closeCurrentTag(!0));
                    }
                    this.startIndex = e + 1;
                }
                onselfclosingtag(n) {
                    (this.endIndex = n),
                        this.recognizeSelfClosing || this.foreignContext[0]
                            ? (this.closeCurrentTag(!1), (this.startIndex = n + 1))
                            : this.onopentagend(n);
                }
                closeCurrentTag(n) {
                    var e, i;
                    const r = this.tagname;
                    this.endOpenTag(n),
                        this.stack[0] === r &&
                            (null === (i = (e = this.cbs).onclosetag) || void 0 === i || i.call(e, r, !n),
                            this.stack.shift());
                }
                onattribname(n, e) {
                    this.startIndex = n;
                    const i = this.getSlice(n, e);
                    this.attribname = this.lowerCaseAttributeNames ? i.toLowerCase() : i;
                }
                onattribdata(n, e) {
                    this.attribvalue += this.getSlice(n, e);
                }
                onattribentity(n) {
                    this.attribvalue += o3(n);
                }
                onattribend(n, e) {
                    var i, r;
                    (this.endIndex = e),
                        null === (r = (i = this.cbs).onattribute) ||
                            void 0 === r ||
                            r.call(
                                i,
                                this.attribname,
                                this.attribvalue,
                                n === Vl.Double ? '"' : n === Vl.Single ? "'" : n === Vl.NoValue ? void 0 : null,
                            ),
                        this.attribs &&
                            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) &&
                            (this.attribs[this.attribname] = this.attribvalue),
                        (this.attribvalue = '');
                }
                getInstructionName(n) {
                    const e = n.search(Yie);
                    let i = e < 0 ? n : n.substr(0, e);
                    return this.lowerCaseTagNames && (i = i.toLowerCase()), i;
                }
                ondeclaration(n, e) {
                    this.endIndex = e;
                    const i = this.getSlice(n, e);
                    if (this.cbs.onprocessinginstruction) {
                        const r = this.getInstructionName(i);
                        this.cbs.onprocessinginstruction(`!${r}`, `!${i}`);
                    }
                    this.startIndex = e + 1;
                }
                onprocessinginstruction(n, e) {
                    this.endIndex = e;
                    const i = this.getSlice(n, e);
                    if (this.cbs.onprocessinginstruction) {
                        const r = this.getInstructionName(i);
                        this.cbs.onprocessinginstruction(`?${r}`, `?${i}`);
                    }
                    this.startIndex = e + 1;
                }
                oncomment(n, e, i) {
                    var r, s, o, a;
                    (this.endIndex = e),
                        null === (s = (r = this.cbs).oncomment) || void 0 === s || s.call(r, this.getSlice(n, e - i)),
                        null === (a = (o = this.cbs).oncommentend) || void 0 === a || a.call(o),
                        (this.startIndex = e + 1);
                }
                oncdata(n, e, i) {
                    var r, s, o, a, l, c, f, g, E, P;
                    this.endIndex = e;
                    const V = this.getSlice(n, e - i);
                    !this.htmlMode || this.options.recognizeCDATA
                        ? (null === (s = (r = this.cbs).oncdatastart) || void 0 === s || s.call(r),
                          null === (a = (o = this.cbs).ontext) || void 0 === a || a.call(o, V),
                          null === (c = (l = this.cbs).oncdataend) || void 0 === c || c.call(l))
                        : (null === (g = (f = this.cbs).oncomment) || void 0 === g || g.call(f, `[CDATA[${V}]]`),
                          null === (P = (E = this.cbs).oncommentend) || void 0 === P || P.call(E)),
                        (this.startIndex = e + 1);
                }
                onend() {
                    var n, e;
                    if (this.cbs.onclosetag) {
                        this.endIndex = this.startIndex;
                        for (let i = 0; i < this.stack.length; i++) this.cbs.onclosetag(this.stack[i], !0);
                    }
                    null === (e = (n = this.cbs).onend) || void 0 === e || e.call(n);
                }
                reset() {
                    var n, e, i, r;
                    null === (e = (n = this.cbs).onreset) || void 0 === e || e.call(n),
                        this.tokenizer.reset(),
                        (this.tagname = ''),
                        (this.attribname = ''),
                        (this.attribs = null),
                        (this.stack.length = 0),
                        (this.startIndex = 0),
                        (this.endIndex = 0),
                        null === (r = (i = this.cbs).onparserinit) || void 0 === r || r.call(i, this),
                        (this.buffers.length = 0),
                        (this.foreignContext.length = 0),
                        this.foreignContext.unshift(!this.htmlMode),
                        (this.bufferOffset = 0),
                        (this.writeIndex = 0),
                        (this.ended = !1);
                }
                parseComplete(n) {
                    this.reset(), this.end(n);
                }
                getSlice(n, e) {
                    for (; n - this.bufferOffset >= this.buffers[0].length; ) this.shiftBuffer();
                    let i = this.buffers[0].slice(n - this.bufferOffset, e - this.bufferOffset);
                    for (; e - this.bufferOffset > this.buffers[0].length; )
                        this.shiftBuffer(), (i += this.buffers[0].slice(0, e - this.bufferOffset));
                    return i;
                }
                shiftBuffer() {
                    (this.bufferOffset += this.buffers[0].length), this.writeIndex--, this.buffers.shift();
                }
                write(n) {
                    var e, i;
                    this.ended
                        ? null === (i = (e = this.cbs).onerror) ||
                          void 0 === i ||
                          i.call(e, new Error('.write() after done!'))
                        : (this.buffers.push(n),
                          this.tokenizer.running && (this.tokenizer.write(n), this.writeIndex++));
                }
                end(n) {
                    var e, i;
                    this.ended
                        ? null === (i = (e = this.cbs).onerror) ||
                          void 0 === i ||
                          i.call(e, new Error('.end() after done!'))
                        : (n && this.write(n), (this.ended = !0), this.tokenizer.end());
                }
                pause() {
                    this.tokenizer.pause();
                }
                resume() {
                    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
                        this.tokenizer.write(this.buffers[this.writeIndex++]);
                    this.ended && this.tokenizer.end();
                }
                parseChunk(n) {
                    this.write(n);
                }
                done(n) {
                    this.end(n);
                }
            }
            function c3(t) {
                for (let n = 1; n < t.length; n++) t[n][0] += t[n - 1][0] + 1;
                return t;
            }
            new Map(
                c3([
                    [9, '&Tab;'],
                    [0, '&NewLine;'],
                    [22, '&excl;'],
                    [0, '&quot;'],
                    [0, '&num;'],
                    [0, '&dollar;'],
                    [0, '&percnt;'],
                    [0, '&amp;'],
                    [0, '&apos;'],
                    [0, '&lpar;'],
                    [0, '&rpar;'],
                    [0, '&ast;'],
                    [0, '&plus;'],
                    [0, '&comma;'],
                    [1, '&period;'],
                    [0, '&sol;'],
                    [10, '&colon;'],
                    [0, '&semi;'],
                    [0, { v: '&lt;', n: 8402, o: '&nvlt;' }],
                    [0, { v: '&equals;', n: 8421, o: '&bne;' }],
                    [0, { v: '&gt;', n: 8402, o: '&nvgt;' }],
                    [0, '&quest;'],
                    [0, '&commat;'],
                    [26, '&lbrack;'],
                    [0, '&bsol;'],
                    [0, '&rbrack;'],
                    [0, '&Hat;'],
                    [0, '&lowbar;'],
                    [0, '&DiacriticalGrave;'],
                    [5, { n: 106, o: '&fjlig;' }],
                    [20, '&lbrace;'],
                    [0, '&verbar;'],
                    [0, '&rbrace;'],
                    [34, '&nbsp;'],
                    [0, '&iexcl;'],
                    [0, '&cent;'],
                    [0, '&pound;'],
                    [0, '&curren;'],
                    [0, '&yen;'],
                    [0, '&brvbar;'],
                    [0, '&sect;'],
                    [0, '&die;'],
                    [0, '&copy;'],
                    [0, '&ordf;'],
                    [0, '&laquo;'],
                    [0, '&not;'],
                    [0, '&shy;'],
                    [0, '&circledR;'],
                    [0, '&macr;'],
                    [0, '&deg;'],
                    [0, '&PlusMinus;'],
                    [0, '&sup2;'],
                    [0, '&sup3;'],
                    [0, '&acute;'],
                    [0, '&micro;'],
                    [0, '&para;'],
                    [0, '&centerdot;'],
                    [0, '&cedil;'],
                    [0, '&sup1;'],
                    [0, '&ordm;'],
                    [0, '&raquo;'],
                    [0, '&frac14;'],
                    [0, '&frac12;'],
                    [0, '&frac34;'],
                    [0, '&iquest;'],
                    [0, '&Agrave;'],
                    [0, '&Aacute;'],
                    [0, '&Acirc;'],
                    [0, '&Atilde;'],
                    [0, '&Auml;'],
                    [0, '&angst;'],
                    [0, '&AElig;'],
                    [0, '&Ccedil;'],
                    [0, '&Egrave;'],
                    [0, '&Eacute;'],
                    [0, '&Ecirc;'],
                    [0, '&Euml;'],
                    [0, '&Igrave;'],
                    [0, '&Iacute;'],
                    [0, '&Icirc;'],
                    [0, '&Iuml;'],
                    [0, '&ETH;'],
                    [0, '&Ntilde;'],
                    [0, '&Ograve;'],
                    [0, '&Oacute;'],
                    [0, '&Ocirc;'],
                    [0, '&Otilde;'],
                    [0, '&Ouml;'],
                    [0, '&times;'],
                    [0, '&Oslash;'],
                    [0, '&Ugrave;'],
                    [0, '&Uacute;'],
                    [0, '&Ucirc;'],
                    [0, '&Uuml;'],
                    [0, '&Yacute;'],
                    [0, '&THORN;'],
                    [0, '&szlig;'],
                    [0, '&agrave;'],
                    [0, '&aacute;'],
                    [0, '&acirc;'],
                    [0, '&atilde;'],
                    [0, '&auml;'],
                    [0, '&aring;'],
                    [0, '&aelig;'],
                    [0, '&ccedil;'],
                    [0, '&egrave;'],
                    [0, '&eacute;'],
                    [0, '&ecirc;'],
                    [0, '&euml;'],
                    [0, '&igrave;'],
                    [0, '&iacute;'],
                    [0, '&icirc;'],
                    [0, '&iuml;'],
                    [0, '&eth;'],
                    [0, '&ntilde;'],
                    [0, '&ograve;'],
                    [0, '&oacute;'],
                    [0, '&ocirc;'],
                    [0, '&otilde;'],
                    [0, '&ouml;'],
                    [0, '&div;'],
                    [0, '&oslash;'],
                    [0, '&ugrave;'],
                    [0, '&uacute;'],
                    [0, '&ucirc;'],
                    [0, '&uuml;'],
                    [0, '&yacute;'],
                    [0, '&thorn;'],
                    [0, '&yuml;'],
                    [0, '&Amacr;'],
                    [0, '&amacr;'],
                    [0, '&Abreve;'],
                    [0, '&abreve;'],
                    [0, '&Aogon;'],
                    [0, '&aogon;'],
                    [0, '&Cacute;'],
                    [0, '&cacute;'],
                    [0, '&Ccirc;'],
                    [0, '&ccirc;'],
                    [0, '&Cdot;'],
                    [0, '&cdot;'],
                    [0, '&Ccaron;'],
                    [0, '&ccaron;'],
                    [0, '&Dcaron;'],
                    [0, '&dcaron;'],
                    [0, '&Dstrok;'],
                    [0, '&dstrok;'],
                    [0, '&Emacr;'],
                    [0, '&emacr;'],
                    [2, '&Edot;'],
                    [0, '&edot;'],
                    [0, '&Eogon;'],
                    [0, '&eogon;'],
                    [0, '&Ecaron;'],
                    [0, '&ecaron;'],
                    [0, '&Gcirc;'],
                    [0, '&gcirc;'],
                    [0, '&Gbreve;'],
                    [0, '&gbreve;'],
                    [0, '&Gdot;'],
                    [0, '&gdot;'],
                    [0, '&Gcedil;'],
                    [1, '&Hcirc;'],
                    [0, '&hcirc;'],
                    [0, '&Hstrok;'],
                    [0, '&hstrok;'],
                    [0, '&Itilde;'],
                    [0, '&itilde;'],
                    [0, '&Imacr;'],
                    [0, '&imacr;'],
                    [2, '&Iogon;'],
                    [0, '&iogon;'],
                    [0, '&Idot;'],
                    [0, '&imath;'],
                    [0, '&IJlig;'],
                    [0, '&ijlig;'],
                    [0, '&Jcirc;'],
                    [0, '&jcirc;'],
                    [0, '&Kcedil;'],
                    [0, '&kcedil;'],
                    [0, '&kgreen;'],
                    [0, '&Lacute;'],
                    [0, '&lacute;'],
                    [0, '&Lcedil;'],
                    [0, '&lcedil;'],
                    [0, '&Lcaron;'],
                    [0, '&lcaron;'],
                    [0, '&Lmidot;'],
                    [0, '&lmidot;'],
                    [0, '&Lstrok;'],
                    [0, '&lstrok;'],
                    [0, '&Nacute;'],
                    [0, '&nacute;'],
                    [0, '&Ncedil;'],
                    [0, '&ncedil;'],
                    [0, '&Ncaron;'],
                    [0, '&ncaron;'],
                    [0, '&napos;'],
                    [0, '&ENG;'],
                    [0, '&eng;'],
                    [0, '&Omacr;'],
                    [0, '&omacr;'],
                    [2, '&Odblac;'],
                    [0, '&odblac;'],
                    [0, '&OElig;'],
                    [0, '&oelig;'],
                    [0, '&Racute;'],
                    [0, '&racute;'],
                    [0, '&Rcedil;'],
                    [0, '&rcedil;'],
                    [0, '&Rcaron;'],
                    [0, '&rcaron;'],
                    [0, '&Sacute;'],
                    [0, '&sacute;'],
                    [0, '&Scirc;'],
                    [0, '&scirc;'],
                    [0, '&Scedil;'],
                    [0, '&scedil;'],
                    [0, '&Scaron;'],
                    [0, '&scaron;'],
                    [0, '&Tcedil;'],
                    [0, '&tcedil;'],
                    [0, '&Tcaron;'],
                    [0, '&tcaron;'],
                    [0, '&Tstrok;'],
                    [0, '&tstrok;'],
                    [0, '&Utilde;'],
                    [0, '&utilde;'],
                    [0, '&Umacr;'],
                    [0, '&umacr;'],
                    [0, '&Ubreve;'],
                    [0, '&ubreve;'],
                    [0, '&Uring;'],
                    [0, '&uring;'],
                    [0, '&Udblac;'],
                    [0, '&udblac;'],
                    [0, '&Uogon;'],
                    [0, '&uogon;'],
                    [0, '&Wcirc;'],
                    [0, '&wcirc;'],
                    [0, '&Ycirc;'],
                    [0, '&ycirc;'],
                    [0, '&Yuml;'],
                    [0, '&Zacute;'],
                    [0, '&zacute;'],
                    [0, '&Zdot;'],
                    [0, '&zdot;'],
                    [0, '&Zcaron;'],
                    [0, '&zcaron;'],
                    [19, '&fnof;'],
                    [34, '&imped;'],
                    [63, '&gacute;'],
                    [65, '&jmath;'],
                    [142, '&circ;'],
                    [0, '&caron;'],
                    [16, '&breve;'],
                    [0, '&DiacriticalDot;'],
                    [0, '&ring;'],
                    [0, '&ogon;'],
                    [0, '&DiacriticalTilde;'],
                    [0, '&dblac;'],
                    [51, '&DownBreve;'],
                    [127, '&Alpha;'],
                    [0, '&Beta;'],
                    [0, '&Gamma;'],
                    [0, '&Delta;'],
                    [0, '&Epsilon;'],
                    [0, '&Zeta;'],
                    [0, '&Eta;'],
                    [0, '&Theta;'],
                    [0, '&Iota;'],
                    [0, '&Kappa;'],
                    [0, '&Lambda;'],
                    [0, '&Mu;'],
                    [0, '&Nu;'],
                    [0, '&Xi;'],
                    [0, '&Omicron;'],
                    [0, '&Pi;'],
                    [0, '&Rho;'],
                    [1, '&Sigma;'],
                    [0, '&Tau;'],
                    [0, '&Upsilon;'],
                    [0, '&Phi;'],
                    [0, '&Chi;'],
                    [0, '&Psi;'],
                    [0, '&ohm;'],
                    [7, '&alpha;'],
                    [0, '&beta;'],
                    [0, '&gamma;'],
                    [0, '&delta;'],
                    [0, '&epsi;'],
                    [0, '&zeta;'],
                    [0, '&eta;'],
                    [0, '&theta;'],
                    [0, '&iota;'],
                    [0, '&kappa;'],
                    [0, '&lambda;'],
                    [0, '&mu;'],
                    [0, '&nu;'],
                    [0, '&xi;'],
                    [0, '&omicron;'],
                    [0, '&pi;'],
                    [0, '&rho;'],
                    [0, '&sigmaf;'],
                    [0, '&sigma;'],
                    [0, '&tau;'],
                    [0, '&upsi;'],
                    [0, '&phi;'],
                    [0, '&chi;'],
                    [0, '&psi;'],
                    [0, '&omega;'],
                    [7, '&thetasym;'],
                    [0, '&Upsi;'],
                    [2, '&phiv;'],
                    [0, '&piv;'],
                    [5, '&Gammad;'],
                    [0, '&digamma;'],
                    [18, '&kappav;'],
                    [0, '&rhov;'],
                    [3, '&epsiv;'],
                    [0, '&backepsilon;'],
                    [10, '&IOcy;'],
                    [0, '&DJcy;'],
                    [0, '&GJcy;'],
                    [0, '&Jukcy;'],
                    [0, '&DScy;'],
                    [0, '&Iukcy;'],
                    [0, '&YIcy;'],
                    [0, '&Jsercy;'],
                    [0, '&LJcy;'],
                    [0, '&NJcy;'],
                    [0, '&TSHcy;'],
                    [0, '&KJcy;'],
                    [1, '&Ubrcy;'],
                    [0, '&DZcy;'],
                    [0, '&Acy;'],
                    [0, '&Bcy;'],
                    [0, '&Vcy;'],
                    [0, '&Gcy;'],
                    [0, '&Dcy;'],
                    [0, '&IEcy;'],
                    [0, '&ZHcy;'],
                    [0, '&Zcy;'],
                    [0, '&Icy;'],
                    [0, '&Jcy;'],
                    [0, '&Kcy;'],
                    [0, '&Lcy;'],
                    [0, '&Mcy;'],
                    [0, '&Ncy;'],
                    [0, '&Ocy;'],
                    [0, '&Pcy;'],
                    [0, '&Rcy;'],
                    [0, '&Scy;'],
                    [0, '&Tcy;'],
                    [0, '&Ucy;'],
                    [0, '&Fcy;'],
                    [0, '&KHcy;'],
                    [0, '&TScy;'],
                    [0, '&CHcy;'],
                    [0, '&SHcy;'],
                    [0, '&SHCHcy;'],
                    [0, '&HARDcy;'],
                    [0, '&Ycy;'],
                    [0, '&SOFTcy;'],
                    [0, '&Ecy;'],
                    [0, '&YUcy;'],
                    [0, '&YAcy;'],
                    [0, '&acy;'],
                    [0, '&bcy;'],
                    [0, '&vcy;'],
                    [0, '&gcy;'],
                    [0, '&dcy;'],
                    [0, '&iecy;'],
                    [0, '&zhcy;'],
                    [0, '&zcy;'],
                    [0, '&icy;'],
                    [0, '&jcy;'],
                    [0, '&kcy;'],
                    [0, '&lcy;'],
                    [0, '&mcy;'],
                    [0, '&ncy;'],
                    [0, '&ocy;'],
                    [0, '&pcy;'],
                    [0, '&rcy;'],
                    [0, '&scy;'],
                    [0, '&tcy;'],
                    [0, '&ucy;'],
                    [0, '&fcy;'],
                    [0, '&khcy;'],
                    [0, '&tscy;'],
                    [0, '&chcy;'],
                    [0, '&shcy;'],
                    [0, '&shchcy;'],
                    [0, '&hardcy;'],
                    [0, '&ycy;'],
                    [0, '&softcy;'],
                    [0, '&ecy;'],
                    [0, '&yucy;'],
                    [0, '&yacy;'],
                    [1, '&iocy;'],
                    [0, '&djcy;'],
                    [0, '&gjcy;'],
                    [0, '&jukcy;'],
                    [0, '&dscy;'],
                    [0, '&iukcy;'],
                    [0, '&yicy;'],
                    [0, '&jsercy;'],
                    [0, '&ljcy;'],
                    [0, '&njcy;'],
                    [0, '&tshcy;'],
                    [0, '&kjcy;'],
                    [1, '&ubrcy;'],
                    [0, '&dzcy;'],
                    [7074, '&ensp;'],
                    [0, '&emsp;'],
                    [0, '&emsp13;'],
                    [0, '&emsp14;'],
                    [1, '&numsp;'],
                    [0, '&puncsp;'],
                    [0, '&ThinSpace;'],
                    [0, '&hairsp;'],
                    [0, '&NegativeMediumSpace;'],
                    [0, '&zwnj;'],
                    [0, '&zwj;'],
                    [0, '&lrm;'],
                    [0, '&rlm;'],
                    [0, '&dash;'],
                    [2, '&ndash;'],
                    [0, '&mdash;'],
                    [0, '&horbar;'],
                    [0, '&Verbar;'],
                    [1, '&lsquo;'],
                    [0, '&CloseCurlyQuote;'],
                    [0, '&lsquor;'],
                    [1, '&ldquo;'],
                    [0, '&CloseCurlyDoubleQuote;'],
                    [0, '&bdquo;'],
                    [1, '&dagger;'],
                    [0, '&Dagger;'],
                    [0, '&bull;'],
                    [2, '&nldr;'],
                    [0, '&hellip;'],
                    [9, '&permil;'],
                    [0, '&pertenk;'],
                    [0, '&prime;'],
                    [0, '&Prime;'],
                    [0, '&tprime;'],
                    [0, '&backprime;'],
                    [3, '&lsaquo;'],
                    [0, '&rsaquo;'],
                    [3, '&oline;'],
                    [2, '&caret;'],
                    [1, '&hybull;'],
                    [0, '&frasl;'],
                    [10, '&bsemi;'],
                    [7, '&qprime;'],
                    [7, { v: '&MediumSpace;', n: 8202, o: '&ThickSpace;' }],
                    [0, '&NoBreak;'],
                    [0, '&af;'],
                    [0, '&InvisibleTimes;'],
                    [0, '&ic;'],
                    [72, '&euro;'],
                    [46, '&tdot;'],
                    [0, '&DotDot;'],
                    [37, '&complexes;'],
                    [2, '&incare;'],
                    [4, '&gscr;'],
                    [0, '&hamilt;'],
                    [0, '&Hfr;'],
                    [0, '&Hopf;'],
                    [0, '&planckh;'],
                    [0, '&hbar;'],
                    [0, '&imagline;'],
                    [0, '&Ifr;'],
                    [0, '&lagran;'],
                    [0, '&ell;'],
                    [1, '&naturals;'],
                    [0, '&numero;'],
                    [0, '&copysr;'],
                    [0, '&weierp;'],
                    [0, '&Popf;'],
                    [0, '&Qopf;'],
                    [0, '&realine;'],
                    [0, '&real;'],
                    [0, '&reals;'],
                    [0, '&rx;'],
                    [3, '&trade;'],
                    [1, '&integers;'],
                    [2, '&mho;'],
                    [0, '&zeetrf;'],
                    [0, '&iiota;'],
                    [2, '&bernou;'],
                    [0, '&Cayleys;'],
                    [1, '&escr;'],
                    [0, '&Escr;'],
                    [0, '&Fouriertrf;'],
                    [1, '&Mellintrf;'],
                    [0, '&order;'],
                    [0, '&alefsym;'],
                    [0, '&beth;'],
                    [0, '&gimel;'],
                    [0, '&daleth;'],
                    [12, '&CapitalDifferentialD;'],
                    [0, '&dd;'],
                    [0, '&ee;'],
                    [0, '&ii;'],
                    [10, '&frac13;'],
                    [0, '&frac23;'],
                    [0, '&frac15;'],
                    [0, '&frac25;'],
                    [0, '&frac35;'],
                    [0, '&frac45;'],
                    [0, '&frac16;'],
                    [0, '&frac56;'],
                    [0, '&frac18;'],
                    [0, '&frac38;'],
                    [0, '&frac58;'],
                    [0, '&frac78;'],
                    [49, '&larr;'],
                    [0, '&ShortUpArrow;'],
                    [0, '&rarr;'],
                    [0, '&darr;'],
                    [0, '&harr;'],
                    [0, '&updownarrow;'],
                    [0, '&nwarr;'],
                    [0, '&nearr;'],
                    [0, '&LowerRightArrow;'],
                    [0, '&LowerLeftArrow;'],
                    [0, '&nlarr;'],
                    [0, '&nrarr;'],
                    [1, { v: '&rarrw;', n: 824, o: '&nrarrw;' }],
                    [0, '&Larr;'],
                    [0, '&Uarr;'],
                    [0, '&Rarr;'],
                    [0, '&Darr;'],
                    [0, '&larrtl;'],
                    [0, '&rarrtl;'],
                    [0, '&LeftTeeArrow;'],
                    [0, '&mapstoup;'],
                    [0, '&map;'],
                    [0, '&DownTeeArrow;'],
                    [1, '&hookleftarrow;'],
                    [0, '&hookrightarrow;'],
                    [0, '&larrlp;'],
                    [0, '&looparrowright;'],
                    [0, '&harrw;'],
                    [0, '&nharr;'],
                    [1, '&lsh;'],
                    [0, '&rsh;'],
                    [0, '&ldsh;'],
                    [0, '&rdsh;'],
                    [1, '&crarr;'],
                    [0, '&cularr;'],
                    [0, '&curarr;'],
                    [2, '&circlearrowleft;'],
                    [0, '&circlearrowright;'],
                    [0, '&leftharpoonup;'],
                    [0, '&DownLeftVector;'],
                    [0, '&RightUpVector;'],
                    [0, '&LeftUpVector;'],
                    [0, '&rharu;'],
                    [0, '&DownRightVector;'],
                    [0, '&dharr;'],
                    [0, '&dharl;'],
                    [0, '&RightArrowLeftArrow;'],
                    [0, '&udarr;'],
                    [0, '&LeftArrowRightArrow;'],
                    [0, '&leftleftarrows;'],
                    [0, '&upuparrows;'],
                    [0, '&rightrightarrows;'],
                    [0, '&ddarr;'],
                    [0, '&leftrightharpoons;'],
                    [0, '&Equilibrium;'],
                    [0, '&nlArr;'],
                    [0, '&nhArr;'],
                    [0, '&nrArr;'],
                    [0, '&DoubleLeftArrow;'],
                    [0, '&DoubleUpArrow;'],
                    [0, '&DoubleRightArrow;'],
                    [0, '&dArr;'],
                    [0, '&DoubleLeftRightArrow;'],
                    [0, '&DoubleUpDownArrow;'],
                    [0, '&nwArr;'],
                    [0, '&neArr;'],
                    [0, '&seArr;'],
                    [0, '&swArr;'],
                    [0, '&lAarr;'],
                    [0, '&rAarr;'],
                    [1, '&zigrarr;'],
                    [6, '&larrb;'],
                    [0, '&rarrb;'],
                    [15, '&DownArrowUpArrow;'],
                    [7, '&loarr;'],
                    [0, '&roarr;'],
                    [0, '&hoarr;'],
                    [0, '&forall;'],
                    [0, '&comp;'],
                    [0, { v: '&part;', n: 824, o: '&npart;' }],
                    [0, '&exist;'],
                    [0, '&nexist;'],
                    [0, '&empty;'],
                    [1, '&Del;'],
                    [0, '&Element;'],
                    [0, '&NotElement;'],
                    [1, '&ni;'],
                    [0, '&notni;'],
                    [2, '&prod;'],
                    [0, '&coprod;'],
                    [0, '&sum;'],
                    [0, '&minus;'],
                    [0, '&MinusPlus;'],
                    [0, '&dotplus;'],
                    [1, '&Backslash;'],
                    [0, '&lowast;'],
                    [0, '&compfn;'],
                    [1, '&radic;'],
                    [2, '&prop;'],
                    [0, '&infin;'],
                    [0, '&angrt;'],
                    [0, { v: '&ang;', n: 8402, o: '&nang;' }],
                    [0, '&angmsd;'],
                    [0, '&angsph;'],
                    [0, '&mid;'],
                    [0, '&nmid;'],
                    [0, '&DoubleVerticalBar;'],
                    [0, '&NotDoubleVerticalBar;'],
                    [0, '&and;'],
                    [0, '&or;'],
                    [0, { v: '&cap;', n: 65024, o: '&caps;' }],
                    [0, { v: '&cup;', n: 65024, o: '&cups;' }],
                    [0, '&int;'],
                    [0, '&Int;'],
                    [0, '&iiint;'],
                    [0, '&conint;'],
                    [0, '&Conint;'],
                    [0, '&Cconint;'],
                    [0, '&cwint;'],
                    [0, '&ClockwiseContourIntegral;'],
                    [0, '&awconint;'],
                    [0, '&there4;'],
                    [0, '&becaus;'],
                    [0, '&ratio;'],
                    [0, '&Colon;'],
                    [0, '&dotminus;'],
                    [1, '&mDDot;'],
                    [0, '&homtht;'],
                    [0, { v: '&sim;', n: 8402, o: '&nvsim;' }],
                    [0, { v: '&backsim;', n: 817, o: '&race;' }],
                    [0, { v: '&ac;', n: 819, o: '&acE;' }],
                    [0, '&acd;'],
                    [0, '&VerticalTilde;'],
                    [0, '&NotTilde;'],
                    [0, { v: '&eqsim;', n: 824, o: '&nesim;' }],
                    [0, '&sime;'],
                    [0, '&NotTildeEqual;'],
                    [0, '&cong;'],
                    [0, '&simne;'],
                    [0, '&ncong;'],
                    [0, '&ap;'],
                    [0, '&nap;'],
                    [0, '&ape;'],
                    [0, { v: '&apid;', n: 824, o: '&napid;' }],
                    [0, '&backcong;'],
                    [0, { v: '&asympeq;', n: 8402, o: '&nvap;' }],
                    [0, { v: '&bump;', n: 824, o: '&nbump;' }],
                    [0, { v: '&bumpe;', n: 824, o: '&nbumpe;' }],
                    [0, { v: '&doteq;', n: 824, o: '&nedot;' }],
                    [0, '&doteqdot;'],
                    [0, '&efDot;'],
                    [0, '&erDot;'],
                    [0, '&Assign;'],
                    [0, '&ecolon;'],
                    [0, '&ecir;'],
                    [0, '&circeq;'],
                    [1, '&wedgeq;'],
                    [0, '&veeeq;'],
                    [1, '&triangleq;'],
                    [2, '&equest;'],
                    [0, '&ne;'],
                    [0, { v: '&Congruent;', n: 8421, o: '&bnequiv;' }],
                    [0, '&nequiv;'],
                    [1, { v: '&le;', n: 8402, o: '&nvle;' }],
                    [0, { v: '&ge;', n: 8402, o: '&nvge;' }],
                    [0, { v: '&lE;', n: 824, o: '&nlE;' }],
                    [0, { v: '&gE;', n: 824, o: '&ngE;' }],
                    [0, { v: '&lnE;', n: 65024, o: '&lvertneqq;' }],
                    [0, { v: '&gnE;', n: 65024, o: '&gvertneqq;' }],
                    [
                        0,
                        {
                            v: '&ll;',
                            n: new Map(
                                c3([
                                    [824, '&nLtv;'],
                                    [7577, '&nLt;'],
                                ]),
                            ),
                        },
                    ],
                    [
                        0,
                        {
                            v: '&gg;',
                            n: new Map(
                                c3([
                                    [824, '&nGtv;'],
                                    [7577, '&nGt;'],
                                ]),
                            ),
                        },
                    ],
                    [0, '&between;'],
                    [0, '&NotCupCap;'],
                    [0, '&nless;'],
                    [0, '&ngt;'],
                    [0, '&nle;'],
                    [0, '&nge;'],
                    [0, '&lesssim;'],
                    [0, '&GreaterTilde;'],
                    [0, '&nlsim;'],
                    [0, '&ngsim;'],
                    [0, '&LessGreater;'],
                    [0, '&gl;'],
                    [0, '&NotLessGreater;'],
                    [0, '&NotGreaterLess;'],
                    [0, '&pr;'],
                    [0, '&sc;'],
                    [0, '&prcue;'],
                    [0, '&sccue;'],
                    [0, '&PrecedesTilde;'],
                    [0, { v: '&scsim;', n: 824, o: '&NotSucceedsTilde;' }],
                    [0, '&NotPrecedes;'],
                    [0, '&NotSucceeds;'],
                    [0, { v: '&sub;', n: 8402, o: '&NotSubset;' }],
                    [0, { v: '&sup;', n: 8402, o: '&NotSuperset;' }],
                    [0, '&nsub;'],
                    [0, '&nsup;'],
                    [0, '&sube;'],
                    [0, '&supe;'],
                    [0, '&NotSubsetEqual;'],
                    [0, '&NotSupersetEqual;'],
                    [0, { v: '&subne;', n: 65024, o: '&varsubsetneq;' }],
                    [0, { v: '&supne;', n: 65024, o: '&varsupsetneq;' }],
                    [1, '&cupdot;'],
                    [0, '&UnionPlus;'],
                    [0, { v: '&sqsub;', n: 824, o: '&NotSquareSubset;' }],
                    [0, { v: '&sqsup;', n: 824, o: '&NotSquareSuperset;' }],
                    [0, '&sqsube;'],
                    [0, '&sqsupe;'],
                    [0, { v: '&sqcap;', n: 65024, o: '&sqcaps;' }],
                    [0, { v: '&sqcup;', n: 65024, o: '&sqcups;' }],
                    [0, '&CirclePlus;'],
                    [0, '&CircleMinus;'],
                    [0, '&CircleTimes;'],
                    [0, '&osol;'],
                    [0, '&CircleDot;'],
                    [0, '&circledcirc;'],
                    [0, '&circledast;'],
                    [1, '&circleddash;'],
                    [0, '&boxplus;'],
                    [0, '&boxminus;'],
                    [0, '&boxtimes;'],
                    [0, '&dotsquare;'],
                    [0, '&RightTee;'],
                    [0, '&dashv;'],
                    [0, '&DownTee;'],
                    [0, '&bot;'],
                    [1, '&models;'],
                    [0, '&DoubleRightTee;'],
                    [0, '&Vdash;'],
                    [0, '&Vvdash;'],
                    [0, '&VDash;'],
                    [0, '&nvdash;'],
                    [0, '&nvDash;'],
                    [0, '&nVdash;'],
                    [0, '&nVDash;'],
                    [0, '&prurel;'],
                    [1, '&LeftTriangle;'],
                    [0, '&RightTriangle;'],
                    [0, { v: '&LeftTriangleEqual;', n: 8402, o: '&nvltrie;' }],
                    [0, { v: '&RightTriangleEqual;', n: 8402, o: '&nvrtrie;' }],
                    [0, '&origof;'],
                    [0, '&imof;'],
                    [0, '&multimap;'],
                    [0, '&hercon;'],
                    [0, '&intcal;'],
                    [0, '&veebar;'],
                    [1, '&barvee;'],
                    [0, '&angrtvb;'],
                    [0, '&lrtri;'],
                    [0, '&bigwedge;'],
                    [0, '&bigvee;'],
                    [0, '&bigcap;'],
                    [0, '&bigcup;'],
                    [0, '&diam;'],
                    [0, '&sdot;'],
                    [0, '&sstarf;'],
                    [0, '&divideontimes;'],
                    [0, '&bowtie;'],
                    [0, '&ltimes;'],
                    [0, '&rtimes;'],
                    [0, '&leftthreetimes;'],
                    [0, '&rightthreetimes;'],
                    [0, '&backsimeq;'],
                    [0, '&curlyvee;'],
                    [0, '&curlywedge;'],
                    [0, '&Sub;'],
                    [0, '&Sup;'],
                    [0, '&Cap;'],
                    [0, '&Cup;'],
                    [0, '&fork;'],
                    [0, '&epar;'],
                    [0, '&lessdot;'],
                    [0, '&gtdot;'],
                    [0, { v: '&Ll;', n: 824, o: '&nLl;' }],
                    [0, { v: '&Gg;', n: 824, o: '&nGg;' }],
                    [0, { v: '&leg;', n: 65024, o: '&lesg;' }],
                    [0, { v: '&gel;', n: 65024, o: '&gesl;' }],
                    [2, '&cuepr;'],
                    [0, '&cuesc;'],
                    [0, '&NotPrecedesSlantEqual;'],
                    [0, '&NotSucceedsSlantEqual;'],
                    [0, '&NotSquareSubsetEqual;'],
                    [0, '&NotSquareSupersetEqual;'],
                    [2, '&lnsim;'],
                    [0, '&gnsim;'],
                    [0, '&precnsim;'],
                    [0, '&scnsim;'],
                    [0, '&nltri;'],
                    [0, '&NotRightTriangle;'],
                    [0, '&nltrie;'],
                    [0, '&NotRightTriangleEqual;'],
                    [0, '&vellip;'],
                    [0, '&ctdot;'],
                    [0, '&utdot;'],
                    [0, '&dtdot;'],
                    [0, '&disin;'],
                    [0, '&isinsv;'],
                    [0, '&isins;'],
                    [0, { v: '&isindot;', n: 824, o: '&notindot;' }],
                    [0, '&notinvc;'],
                    [0, '&notinvb;'],
                    [1, { v: '&isinE;', n: 824, o: '&notinE;' }],
                    [0, '&nisd;'],
                    [0, '&xnis;'],
                    [0, '&nis;'],
                    [0, '&notnivc;'],
                    [0, '&notnivb;'],
                    [6, '&barwed;'],
                    [0, '&Barwed;'],
                    [1, '&lceil;'],
                    [0, '&rceil;'],
                    [0, '&LeftFloor;'],
                    [0, '&rfloor;'],
                    [0, '&drcrop;'],
                    [0, '&dlcrop;'],
                    [0, '&urcrop;'],
                    [0, '&ulcrop;'],
                    [0, '&bnot;'],
                    [1, '&profline;'],
                    [0, '&profsurf;'],
                    [1, '&telrec;'],
                    [0, '&target;'],
                    [5, '&ulcorn;'],
                    [0, '&urcorn;'],
                    [0, '&dlcorn;'],
                    [0, '&drcorn;'],
                    [2, '&frown;'],
                    [0, '&smile;'],
                    [9, '&cylcty;'],
                    [0, '&profalar;'],
                    [7, '&topbot;'],
                    [6, '&ovbar;'],
                    [1, '&solbar;'],
                    [60, '&angzarr;'],
                    [51, '&lmoustache;'],
                    [0, '&rmoustache;'],
                    [2, '&OverBracket;'],
                    [0, '&bbrk;'],
                    [0, '&bbrktbrk;'],
                    [37, '&OverParenthesis;'],
                    [0, '&UnderParenthesis;'],
                    [0, '&OverBrace;'],
                    [0, '&UnderBrace;'],
                    [2, '&trpezium;'],
                    [4, '&elinters;'],
                    [59, '&blank;'],
                    [164, '&circledS;'],
                    [55, '&boxh;'],
                    [1, '&boxv;'],
                    [9, '&boxdr;'],
                    [3, '&boxdl;'],
                    [3, '&boxur;'],
                    [3, '&boxul;'],
                    [3, '&boxvr;'],
                    [7, '&boxvl;'],
                    [7, '&boxhd;'],
                    [7, '&boxhu;'],
                    [7, '&boxvh;'],
                    [19, '&boxH;'],
                    [0, '&boxV;'],
                    [0, '&boxdR;'],
                    [0, '&boxDr;'],
                    [0, '&boxDR;'],
                    [0, '&boxdL;'],
                    [0, '&boxDl;'],
                    [0, '&boxDL;'],
                    [0, '&boxuR;'],
                    [0, '&boxUr;'],
                    [0, '&boxUR;'],
                    [0, '&boxuL;'],
                    [0, '&boxUl;'],
                    [0, '&boxUL;'],
                    [0, '&boxvR;'],
                    [0, '&boxVr;'],
                    [0, '&boxVR;'],
                    [0, '&boxvL;'],
                    [0, '&boxVl;'],
                    [0, '&boxVL;'],
                    [0, '&boxHd;'],
                    [0, '&boxhD;'],
                    [0, '&boxHD;'],
                    [0, '&boxHu;'],
                    [0, '&boxhU;'],
                    [0, '&boxHU;'],
                    [0, '&boxvH;'],
                    [0, '&boxVh;'],
                    [0, '&boxVH;'],
                    [19, '&uhblk;'],
                    [3, '&lhblk;'],
                    [3, '&block;'],
                    [8, '&blk14;'],
                    [0, '&blk12;'],
                    [0, '&blk34;'],
                    [13, '&square;'],
                    [8, '&blacksquare;'],
                    [0, '&EmptyVerySmallSquare;'],
                    [1, '&rect;'],
                    [0, '&marker;'],
                    [2, '&fltns;'],
                    [1, '&bigtriangleup;'],
                    [0, '&blacktriangle;'],
                    [0, '&triangle;'],
                    [2, '&blacktriangleright;'],
                    [0, '&rtri;'],
                    [3, '&bigtriangledown;'],
                    [0, '&blacktriangledown;'],
                    [0, '&dtri;'],
                    [2, '&blacktriangleleft;'],
                    [0, '&ltri;'],
                    [6, '&loz;'],
                    [0, '&cir;'],
                    [32, '&tridot;'],
                    [2, '&bigcirc;'],
                    [8, '&ultri;'],
                    [0, '&urtri;'],
                    [0, '&lltri;'],
                    [0, '&EmptySmallSquare;'],
                    [0, '&FilledSmallSquare;'],
                    [8, '&bigstar;'],
                    [0, '&star;'],
                    [7, '&phone;'],
                    [49, '&female;'],
                    [1, '&male;'],
                    [29, '&spades;'],
                    [2, '&clubs;'],
                    [1, '&hearts;'],
                    [0, '&diamondsuit;'],
                    [3, '&sung;'],
                    [2, '&flat;'],
                    [0, '&natural;'],
                    [0, '&sharp;'],
                    [163, '&check;'],
                    [3, '&cross;'],
                    [8, '&malt;'],
                    [21, '&sext;'],
                    [33, '&VerticalSeparator;'],
                    [25, '&lbbrk;'],
                    [0, '&rbbrk;'],
                    [84, '&bsolhsub;'],
                    [0, '&suphsol;'],
                    [28, '&LeftDoubleBracket;'],
                    [0, '&RightDoubleBracket;'],
                    [0, '&lang;'],
                    [0, '&rang;'],
                    [0, '&Lang;'],
                    [0, '&Rang;'],
                    [0, '&loang;'],
                    [0, '&roang;'],
                    [7, '&longleftarrow;'],
                    [0, '&longrightarrow;'],
                    [0, '&longleftrightarrow;'],
                    [0, '&DoubleLongLeftArrow;'],
                    [0, '&DoubleLongRightArrow;'],
                    [0, '&DoubleLongLeftRightArrow;'],
                    [1, '&longmapsto;'],
                    [2, '&dzigrarr;'],
                    [258, '&nvlArr;'],
                    [0, '&nvrArr;'],
                    [0, '&nvHarr;'],
                    [0, '&Map;'],
                    [6, '&lbarr;'],
                    [0, '&bkarow;'],
                    [0, '&lBarr;'],
                    [0, '&dbkarow;'],
                    [0, '&drbkarow;'],
                    [0, '&DDotrahd;'],
                    [0, '&UpArrowBar;'],
                    [0, '&DownArrowBar;'],
                    [2, '&Rarrtl;'],
                    [2, '&latail;'],
                    [0, '&ratail;'],
                    [0, '&lAtail;'],
                    [0, '&rAtail;'],
                    [0, '&larrfs;'],
                    [0, '&rarrfs;'],
                    [0, '&larrbfs;'],
                    [0, '&rarrbfs;'],
                    [2, '&nwarhk;'],
                    [0, '&nearhk;'],
                    [0, '&hksearow;'],
                    [0, '&hkswarow;'],
                    [0, '&nwnear;'],
                    [0, '&nesear;'],
                    [0, '&seswar;'],
                    [0, '&swnwar;'],
                    [8, { v: '&rarrc;', n: 824, o: '&nrarrc;' }],
                    [1, '&cudarrr;'],
                    [0, '&ldca;'],
                    [0, '&rdca;'],
                    [0, '&cudarrl;'],
                    [0, '&larrpl;'],
                    [2, '&curarrm;'],
                    [0, '&cularrp;'],
                    [7, '&rarrpl;'],
                    [2, '&harrcir;'],
                    [0, '&Uarrocir;'],
                    [0, '&lurdshar;'],
                    [0, '&ldrushar;'],
                    [2, '&LeftRightVector;'],
                    [0, '&RightUpDownVector;'],
                    [0, '&DownLeftRightVector;'],
                    [0, '&LeftUpDownVector;'],
                    [0, '&LeftVectorBar;'],
                    [0, '&RightVectorBar;'],
                    [0, '&RightUpVectorBar;'],
                    [0, '&RightDownVectorBar;'],
                    [0, '&DownLeftVectorBar;'],
                    [0, '&DownRightVectorBar;'],
                    [0, '&LeftUpVectorBar;'],
                    [0, '&LeftDownVectorBar;'],
                    [0, '&LeftTeeVector;'],
                    [0, '&RightTeeVector;'],
                    [0, '&RightUpTeeVector;'],
                    [0, '&RightDownTeeVector;'],
                    [0, '&DownLeftTeeVector;'],
                    [0, '&DownRightTeeVector;'],
                    [0, '&LeftUpTeeVector;'],
                    [0, '&LeftDownTeeVector;'],
                    [0, '&lHar;'],
                    [0, '&uHar;'],
                    [0, '&rHar;'],
                    [0, '&dHar;'],
                    [0, '&luruhar;'],
                    [0, '&ldrdhar;'],
                    [0, '&ruluhar;'],
                    [0, '&rdldhar;'],
                    [0, '&lharul;'],
                    [0, '&llhard;'],
                    [0, '&rharul;'],
                    [0, '&lrhard;'],
                    [0, '&udhar;'],
                    [0, '&duhar;'],
                    [0, '&RoundImplies;'],
                    [0, '&erarr;'],
                    [0, '&simrarr;'],
                    [0, '&larrsim;'],
                    [0, '&rarrsim;'],
                    [0, '&rarrap;'],
                    [0, '&ltlarr;'],
                    [1, '&gtrarr;'],
                    [0, '&subrarr;'],
                    [1, '&suplarr;'],
                    [0, '&lfisht;'],
                    [0, '&rfisht;'],
                    [0, '&ufisht;'],
                    [0, '&dfisht;'],
                    [5, '&lopar;'],
                    [0, '&ropar;'],
                    [4, '&lbrke;'],
                    [0, '&rbrke;'],
                    [0, '&lbrkslu;'],
                    [0, '&rbrksld;'],
                    [0, '&lbrksld;'],
                    [0, '&rbrkslu;'],
                    [0, '&langd;'],
                    [0, '&rangd;'],
                    [0, '&lparlt;'],
                    [0, '&rpargt;'],
                    [0, '&gtlPar;'],
                    [0, '&ltrPar;'],
                    [3, '&vzigzag;'],
                    [1, '&vangrt;'],
                    [0, '&angrtvbd;'],
                    [6, '&ange;'],
                    [0, '&range;'],
                    [0, '&dwangle;'],
                    [0, '&uwangle;'],
                    [0, '&angmsdaa;'],
                    [0, '&angmsdab;'],
                    [0, '&angmsdac;'],
                    [0, '&angmsdad;'],
                    [0, '&angmsdae;'],
                    [0, '&angmsdaf;'],
                    [0, '&angmsdag;'],
                    [0, '&angmsdah;'],
                    [0, '&bemptyv;'],
                    [0, '&demptyv;'],
                    [0, '&cemptyv;'],
                    [0, '&raemptyv;'],
                    [0, '&laemptyv;'],
                    [0, '&ohbar;'],
                    [0, '&omid;'],
                    [0, '&opar;'],
                    [1, '&operp;'],
                    [1, '&olcross;'],
                    [0, '&odsold;'],
                    [1, '&olcir;'],
                    [0, '&ofcir;'],
                    [0, '&olt;'],
                    [0, '&ogt;'],
                    [0, '&cirscir;'],
                    [0, '&cirE;'],
                    [0, '&solb;'],
                    [0, '&bsolb;'],
                    [3, '&boxbox;'],
                    [3, '&trisb;'],
                    [0, '&rtriltri;'],
                    [0, { v: '&LeftTriangleBar;', n: 824, o: '&NotLeftTriangleBar;' }],
                    [0, { v: '&RightTriangleBar;', n: 824, o: '&NotRightTriangleBar;' }],
                    [11, '&iinfin;'],
                    [0, '&infintie;'],
                    [0, '&nvinfin;'],
                    [4, '&eparsl;'],
                    [0, '&smeparsl;'],
                    [0, '&eqvparsl;'],
                    [5, '&blacklozenge;'],
                    [8, '&RuleDelayed;'],
                    [1, '&dsol;'],
                    [9, '&bigodot;'],
                    [0, '&bigoplus;'],
                    [0, '&bigotimes;'],
                    [1, '&biguplus;'],
                    [1, '&bigsqcup;'],
                    [5, '&iiiint;'],
                    [0, '&fpartint;'],
                    [2, '&cirfnint;'],
                    [0, '&awint;'],
                    [0, '&rppolint;'],
                    [0, '&scpolint;'],
                    [0, '&npolint;'],
                    [0, '&pointint;'],
                    [0, '&quatint;'],
                    [0, '&intlarhk;'],
                    [10, '&pluscir;'],
                    [0, '&plusacir;'],
                    [0, '&simplus;'],
                    [0, '&plusdu;'],
                    [0, '&plussim;'],
                    [0, '&plustwo;'],
                    [1, '&mcomma;'],
                    [0, '&minusdu;'],
                    [2, '&loplus;'],
                    [0, '&roplus;'],
                    [0, '&Cross;'],
                    [0, '&timesd;'],
                    [0, '&timesbar;'],
                    [1, '&smashp;'],
                    [0, '&lotimes;'],
                    [0, '&rotimes;'],
                    [0, '&otimesas;'],
                    [0, '&Otimes;'],
                    [0, '&odiv;'],
                    [0, '&triplus;'],
                    [0, '&triminus;'],
                    [0, '&tritime;'],
                    [0, '&intprod;'],
                    [2, '&amalg;'],
                    [0, '&capdot;'],
                    [1, '&ncup;'],
                    [0, '&ncap;'],
                    [0, '&capand;'],
                    [0, '&cupor;'],
                    [0, '&cupcap;'],
                    [0, '&capcup;'],
                    [0, '&cupbrcap;'],
                    [0, '&capbrcup;'],
                    [0, '&cupcup;'],
                    [0, '&capcap;'],
                    [0, '&ccups;'],
                    [0, '&ccaps;'],
                    [2, '&ccupssm;'],
                    [2, '&And;'],
                    [0, '&Or;'],
                    [0, '&andand;'],
                    [0, '&oror;'],
                    [0, '&orslope;'],
                    [0, '&andslope;'],
                    [1, '&andv;'],
                    [0, '&orv;'],
                    [0, '&andd;'],
                    [0, '&ord;'],
                    [1, '&wedbar;'],
                    [6, '&sdote;'],
                    [3, '&simdot;'],
                    [2, { v: '&congdot;', n: 824, o: '&ncongdot;' }],
                    [0, '&easter;'],
                    [0, '&apacir;'],
                    [0, { v: '&apE;', n: 824, o: '&napE;' }],
                    [0, '&eplus;'],
                    [0, '&pluse;'],
                    [0, '&Esim;'],
                    [0, '&Colone;'],
                    [0, '&Equal;'],
                    [1, '&ddotseq;'],
                    [0, '&equivDD;'],
                    [0, '&ltcir;'],
                    [0, '&gtcir;'],
                    [0, '&ltquest;'],
                    [0, '&gtquest;'],
                    [0, { v: '&leqslant;', n: 824, o: '&nleqslant;' }],
                    [0, { v: '&geqslant;', n: 824, o: '&ngeqslant;' }],
                    [0, '&lesdot;'],
                    [0, '&gesdot;'],
                    [0, '&lesdoto;'],
                    [0, '&gesdoto;'],
                    [0, '&lesdotor;'],
                    [0, '&gesdotol;'],
                    [0, '&lap;'],
                    [0, '&gap;'],
                    [0, '&lne;'],
                    [0, '&gne;'],
                    [0, '&lnap;'],
                    [0, '&gnap;'],
                    [0, '&lEg;'],
                    [0, '&gEl;'],
                    [0, '&lsime;'],
                    [0, '&gsime;'],
                    [0, '&lsimg;'],
                    [0, '&gsiml;'],
                    [0, '&lgE;'],
                    [0, '&glE;'],
                    [0, '&lesges;'],
                    [0, '&gesles;'],
                    [0, '&els;'],
                    [0, '&egs;'],
                    [0, '&elsdot;'],
                    [0, '&egsdot;'],
                    [0, '&el;'],
                    [0, '&eg;'],
                    [2, '&siml;'],
                    [0, '&simg;'],
                    [0, '&simlE;'],
                    [0, '&simgE;'],
                    [0, { v: '&LessLess;', n: 824, o: '&NotNestedLessLess;' }],
                    [0, { v: '&GreaterGreater;', n: 824, o: '&NotNestedGreaterGreater;' }],
                    [1, '&glj;'],
                    [0, '&gla;'],
                    [0, '&ltcc;'],
                    [0, '&gtcc;'],
                    [0, '&lescc;'],
                    [0, '&gescc;'],
                    [0, '&smt;'],
                    [0, '&lat;'],
                    [0, { v: '&smte;', n: 65024, o: '&smtes;' }],
                    [0, { v: '&late;', n: 65024, o: '&lates;' }],
                    [0, '&bumpE;'],
                    [0, { v: '&PrecedesEqual;', n: 824, o: '&NotPrecedesEqual;' }],
                    [0, { v: '&sce;', n: 824, o: '&NotSucceedsEqual;' }],
                    [2, '&prE;'],
                    [0, '&scE;'],
                    [0, '&precneqq;'],
                    [0, '&scnE;'],
                    [0, '&prap;'],
                    [0, '&scap;'],
                    [0, '&precnapprox;'],
                    [0, '&scnap;'],
                    [0, '&Pr;'],
                    [0, '&Sc;'],
                    [0, '&subdot;'],
                    [0, '&supdot;'],
                    [0, '&subplus;'],
                    [0, '&supplus;'],
                    [0, '&submult;'],
                    [0, '&supmult;'],
                    [0, '&subedot;'],
                    [0, '&supedot;'],
                    [0, { v: '&subE;', n: 824, o: '&nsubE;' }],
                    [0, { v: '&supE;', n: 824, o: '&nsupE;' }],
                    [0, '&subsim;'],
                    [0, '&supsim;'],
                    [2, { v: '&subnE;', n: 65024, o: '&varsubsetneqq;' }],
                    [0, { v: '&supnE;', n: 65024, o: '&varsupsetneqq;' }],
                    [2, '&csub;'],
                    [0, '&csup;'],
                    [0, '&csube;'],
                    [0, '&csupe;'],
                    [0, '&subsup;'],
                    [0, '&supsub;'],
                    [0, '&subsub;'],
                    [0, '&supsup;'],
                    [0, '&suphsub;'],
                    [0, '&supdsub;'],
                    [0, '&forkv;'],
                    [0, '&topfork;'],
                    [0, '&mlcp;'],
                    [8, '&Dashv;'],
                    [1, '&Vdashl;'],
                    [0, '&Barv;'],
                    [0, '&vBar;'],
                    [0, '&vBarv;'],
                    [1, '&Vbar;'],
                    [0, '&Not;'],
                    [0, '&bNot;'],
                    [0, '&rnmid;'],
                    [0, '&cirmid;'],
                    [0, '&midcir;'],
                    [0, '&topcir;'],
                    [0, '&nhpar;'],
                    [0, '&parsim;'],
                    [9, { v: '&parsl;', n: 8421, o: '&nparsl;' }],
                    [
                        44343,
                        {
                            n: new Map(
                                c3([
                                    [56476, '&Ascr;'],
                                    [1, '&Cscr;'],
                                    [0, '&Dscr;'],
                                    [2, '&Gscr;'],
                                    [2, '&Jscr;'],
                                    [0, '&Kscr;'],
                                    [2, '&Nscr;'],
                                    [0, '&Oscr;'],
                                    [0, '&Pscr;'],
                                    [0, '&Qscr;'],
                                    [1, '&Sscr;'],
                                    [0, '&Tscr;'],
                                    [0, '&Uscr;'],
                                    [0, '&Vscr;'],
                                    [0, '&Wscr;'],
                                    [0, '&Xscr;'],
                                    [0, '&Yscr;'],
                                    [0, '&Zscr;'],
                                    [0, '&ascr;'],
                                    [0, '&bscr;'],
                                    [0, '&cscr;'],
                                    [0, '&dscr;'],
                                    [1, '&fscr;'],
                                    [1, '&hscr;'],
                                    [0, '&iscr;'],
                                    [0, '&jscr;'],
                                    [0, '&kscr;'],
                                    [0, '&lscr;'],
                                    [0, '&mscr;'],
                                    [0, '&nscr;'],
                                    [1, '&pscr;'],
                                    [0, '&qscr;'],
                                    [0, '&rscr;'],
                                    [0, '&sscr;'],
                                    [0, '&tscr;'],
                                    [0, '&uscr;'],
                                    [0, '&vscr;'],
                                    [0, '&wscr;'],
                                    [0, '&xscr;'],
                                    [0, '&yscr;'],
                                    [0, '&zscr;'],
                                    [52, '&Afr;'],
                                    [0, '&Bfr;'],
                                    [1, '&Dfr;'],
                                    [0, '&Efr;'],
                                    [0, '&Ffr;'],
                                    [0, '&Gfr;'],
                                    [2, '&Jfr;'],
                                    [0, '&Kfr;'],
                                    [0, '&Lfr;'],
                                    [0, '&Mfr;'],
                                    [0, '&Nfr;'],
                                    [0, '&Ofr;'],
                                    [0, '&Pfr;'],
                                    [0, '&Qfr;'],
                                    [1, '&Sfr;'],
                                    [0, '&Tfr;'],
                                    [0, '&Ufr;'],
                                    [0, '&Vfr;'],
                                    [0, '&Wfr;'],
                                    [0, '&Xfr;'],
                                    [0, '&Yfr;'],
                                    [1, '&afr;'],
                                    [0, '&bfr;'],
                                    [0, '&cfr;'],
                                    [0, '&dfr;'],
                                    [0, '&efr;'],
                                    [0, '&ffr;'],
                                    [0, '&gfr;'],
                                    [0, '&hfr;'],
                                    [0, '&ifr;'],
                                    [0, '&jfr;'],
                                    [0, '&kfr;'],
                                    [0, '&lfr;'],
                                    [0, '&mfr;'],
                                    [0, '&nfr;'],
                                    [0, '&ofr;'],
                                    [0, '&pfr;'],
                                    [0, '&qfr;'],
                                    [0, '&rfr;'],
                                    [0, '&sfr;'],
                                    [0, '&tfr;'],
                                    [0, '&ufr;'],
                                    [0, '&vfr;'],
                                    [0, '&wfr;'],
                                    [0, '&xfr;'],
                                    [0, '&yfr;'],
                                    [0, '&zfr;'],
                                    [0, '&Aopf;'],
                                    [0, '&Bopf;'],
                                    [1, '&Dopf;'],
                                    [0, '&Eopf;'],
                                    [0, '&Fopf;'],
                                    [0, '&Gopf;'],
                                    [1, '&Iopf;'],
                                    [0, '&Jopf;'],
                                    [0, '&Kopf;'],
                                    [0, '&Lopf;'],
                                    [0, '&Mopf;'],
                                    [1, '&Oopf;'],
                                    [3, '&Sopf;'],
                                    [0, '&Topf;'],
                                    [0, '&Uopf;'],
                                    [0, '&Vopf;'],
                                    [0, '&Wopf;'],
                                    [0, '&Xopf;'],
                                    [0, '&Yopf;'],
                                    [1, '&aopf;'],
                                    [0, '&bopf;'],
                                    [0, '&copf;'],
                                    [0, '&dopf;'],
                                    [0, '&eopf;'],
                                    [0, '&fopf;'],
                                    [0, '&gopf;'],
                                    [0, '&hopf;'],
                                    [0, '&iopf;'],
                                    [0, '&jopf;'],
                                    [0, '&kopf;'],
                                    [0, '&lopf;'],
                                    [0, '&mopf;'],
                                    [0, '&nopf;'],
                                    [0, '&oopf;'],
                                    [0, '&popf;'],
                                    [0, '&qopf;'],
                                    [0, '&ropf;'],
                                    [0, '&sopf;'],
                                    [0, '&topf;'],
                                    [0, '&uopf;'],
                                    [0, '&vopf;'],
                                    [0, '&wopf;'],
                                    [0, '&xopf;'],
                                    [0, '&yopf;'],
                                    [0, '&zopf;'],
                                ]),
                            ),
                        },
                    ],
                    [8906, '&fflig;'],
                    [0, '&filig;'],
                    [0, '&fllig;'],
                    [0, '&ffilig;'],
                    [0, '&ffllig;'],
                ]),
            );
            function C5(t, n) {
                return function (i) {
                    let r,
                        s = 0,
                        o = '';
                    for (; (r = t.exec(i)); )
                        s !== r.index && (o += i.substring(s, r.index)),
                            (o += n.get(r[0].charCodeAt(0))),
                            (s = r.index + 1);
                    return o + i.substring(s);
                };
            }
            C5(
                /[&<>'"]/g,
                new Map([
                    [34, '&quot;'],
                    [38, '&amp;'],
                    [39, '&apos;'],
                    [60, '&lt;'],
                    [62, '&gt;'],
                ]),
            ),
                C5(
                    /["&\u00A0]/g,
                    new Map([
                        [34, '&quot;'],
                        [38, '&amp;'],
                        [160, '&nbsp;'],
                    ]),
                ),
                C5(
                    /[&<>\u00A0]/g,
                    new Map([
                        [38, '&amp;'],
                        [60, '&lt;'],
                        [62, '&gt;'],
                        [160, '&nbsp;'],
                    ]),
                ),
                new Map(
                    [
                        'altGlyph',
                        'altGlyphDef',
                        'altGlyphItem',
                        'animateColor',
                        'animateMotion',
                        'animateTransform',
                        'clipPath',
                        'feBlend',
                        'feColorMatrix',
                        'feComponentTransfer',
                        'feComposite',
                        'feConvolveMatrix',
                        'feDiffuseLighting',
                        'feDisplacementMap',
                        'feDistantLight',
                        'feDropShadow',
                        'feFlood',
                        'feFuncA',
                        'feFuncB',
                        'feFuncG',
                        'feFuncR',
                        'feGaussianBlur',
                        'feImage',
                        'feMerge',
                        'feMergeNode',
                        'feMorphology',
                        'feOffset',
                        'fePointLight',
                        'feSpecularLighting',
                        'feSpotLight',
                        'feTile',
                        'feTurbulence',
                        'foreignObject',
                        'glyphRef',
                        'linearGradient',
                        'radialGradient',
                        'textPath',
                    ].map(t => [t.toLowerCase(), t]),
                ),
                new Map(
                    [
                        'definitionURL',
                        'attributeName',
                        'attributeType',
                        'baseFrequency',
                        'baseProfile',
                        'calcMode',
                        'clipPathUnits',
                        'diffuseConstant',
                        'edgeMode',
                        'filterUnits',
                        'glyphRef',
                        'gradientTransform',
                        'gradientUnits',
                        'kernelMatrix',
                        'kernelUnitLength',
                        'keyPoints',
                        'keySplines',
                        'keyTimes',
                        'lengthAdjust',
                        'limitingConeAngle',
                        'markerHeight',
                        'markerUnits',
                        'markerWidth',
                        'maskContentUnits',
                        'maskUnits',
                        'numOctaves',
                        'pathLength',
                        'patternContentUnits',
                        'patternTransform',
                        'patternUnits',
                        'pointsAtX',
                        'pointsAtY',
                        'pointsAtZ',
                        'preserveAlpha',
                        'preserveAspectRatio',
                        'primitiveUnits',
                        'refX',
                        'refY',
                        'repeatCount',
                        'repeatDur',
                        'requiredExtensions',
                        'requiredFeatures',
                        'specularConstant',
                        'specularExponent',
                        'spreadMethod',
                        'startOffset',
                        'stdDeviation',
                        'stitchTiles',
                        'surfaceScale',
                        'systemLanguage',
                        'tableValues',
                        'targetX',
                        'targetY',
                        'textLength',
                        'viewBox',
                        'viewTarget',
                        'xChannelSelector',
                        'yChannelSelector',
                        'zoomAndPan',
                    ].map(t => [t.toLowerCase(), t]),
                );
            var Tk = U(561);
            const Ore = Tk.default || Tk,
                zre = JSON.parse(
                    '{"itemControl":["list","table","gtable","inline","autocomplete","drop-down","check-box","lookup","radio-button"]}',
                ),
                Pre = new RegExp('http://hl7.org/fhir/(\\d+.\\d+)([.\\d]+)?/StructureDefinition/Questionnaire'),
                Nre = new RegExp(
                    'http://hl7.org/fhir/u./sdc/StructureDefinition/sdc-questionnaire\\|(\\d+.\\d+)(.\\d+)?',
                ),
                Dk = { STU3: 1, R4: 2, R4B: 3, R5: 4 },
                xk = {
                    addFormToPage: function (t, i, e) {
                        (i = 'string' == typeof i ? document.getElementById(i) : i),
                            'string' == typeof t && (t = t.indexOf('{') >= 0 ? JSON.parse(t) : window[t]);
                        var r = t.resourceType,
                            s = e && e.fhirVersion;
                        if (r && 'Questionnaire' !== r)
                            throw new Error('Only Questionnaire FHIR content is supported in addFormToPage.');
                        this.pageFormID_ || (this.pageFormID_ = 0),
                            LForms.addedFormDefs || (LForms.addedFormDefs = []),
                            LForms.addedFormDefs.push(t);
                        for (var o = e && !0 === e.prepopulate; i.firstChild; ) i.removeChild(i.lastChild);
                        const a = document.createElement('wc-lhc-form');
                        return (
                            i.appendChild(a),
                            new Promise(function (c, f) {
                                try {
                                    (a.questionnaire = t),
                                        (a.options = e),
                                        (a.prepop = o),
                                        (a.fhirVersion = s),
                                        a.addEventListener('onFormReady', function (g) {
                                            c();
                                        }),
                                        a.addEventListener('onError', function (g) {
                                            f(g.detail);
                                        });
                                } catch (g) {
                                    f(g);
                                }
                            })
                        );
                    },
                    removeFormsFromPage: function (n) {
                        for (n = 'string' == typeof n ? document.getElementById(n) : n; n.firstChild; )
                            n.removeChild(n.lastChild);
                    },
                    getUserData: function (t, n, e, i) {
                        var r = this._getFormObjectInScope(t);
                        return r ? r.getUserData(n, e, i) : null;
                    },
                    getFormData: function (t, n, e) {
                        var i = this._getFormObjectInScope(t);
                        return i ? i.getFormData(n, e) : null;
                    },
                    getFormHL7Data: function (t) {
                        var n = this._getFormObjectInScope(t);
                        return n ? LForms.HL7.toHL7Segments(n) : null;
                    },
                    getFormFHIRData: function (t, n, e, i) {
                        return (
                            (!e || e instanceof HTMLElement || 'string' == typeof e) &&
                                (e = this._getFormObjectInScope(e)),
                            this._convertLFormsToFHIRData(t, n, e, i)
                        );
                    },
                    checkValidity: function (t) {
                        var n = this._getFormObjectInScope(t);
                        return n ? n.checkValidity() : null;
                    },
                    _convertLFormsToFHIRData: function (t, n, e, i) {
                        i || (i = {}), e instanceof LForms.LFormsData || (e = new LForms.LFormsData(e));
                        var r = this.validateFHIRVersion(n),
                            s = LForms.FHIR[r],
                            o = null;
                        if (e)
                            switch (t) {
                                case 'DiagnosticReport':
                                    var a = i ? i.bundleType : void 0;
                                    o = s.DiagnosticReport.createDiagnosticReport(e, i.subject, null != a, a);
                                    break;
                                case 'Questionnaire':
                                    o = s.SDC.convertLFormsToQuestionnaire(e, i.noExtensions);
                                    break;
                                case 'QuestionnaireResponse':
                                    o = i.extract
                                        ? s.SDC.convertLFormsToQRAndExtractFHIRData(e, i.noExtensions, i.subject)
                                        : s.SDC.convertLFormsToQuestionnaireResponse(e, i.noExtensions, i.subject);
                            }
                        return o;
                    },
                    convertFHIRQuestionnaireToLForms: function (t, n) {
                        var e = null;
                        return (
                            t &&
                                ((n = this._requireValidFHIRVersion(n, t)),
                                (e = LForms.FHIR[n].SDC.convertQuestionnaireToLForms(t))),
                            e
                        );
                    },
                    mergeFHIRDataIntoLForms: function (t, n, e) {
                        if (('string' == typeof t && ((t = n), (n = e), (e = arguments[3])), t)) {
                            let r = wh(t);
                            e = this._requireValidFHIRVersion(e, r);
                            var i = LForms.FHIR[e];
                            switch (r.resourceType) {
                                case 'DiagnosticReport':
                                    (n = i.DiagnosticReport.mergeDiagnosticReportToLForms(n, r)).hasSavedData = !0;
                                    break;
                                case 'Bundle':
                                    'searchset' === r.type &&
                                        r.entry.find(s => 'DiagnosticReport' === s.resource.resourceType) &&
                                        ((n = i.DiagnosticReport.mergeDiagnosticReportToLForms(n, r)).hasSavedData =
                                            !0);
                                    break;
                                case 'QuestionnaireResponse':
                                    (n = i.SDC.mergeQuestionnaireResponseToLForms(n, r)).hasSavedData = !0;
                            }
                        }
                        return n;
                    },
                    _requireValidFHIRVersion: function (t, n) {
                        if ((t || (t = this.detectFHIRVersion(n) || this.guessFHIRVersion(n)), !t))
                            throw new Error(
                                'Could not determine the FHIR version for this resource.  Please make sure it is specified via meta.profile (see http://build.fhir.org/versioning.html#mp-version and https://www.hl7.org/fhir/references.html#canonical).  Example 1:  http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire (for Questionnaire version 4.0, a.k.a. R4).Example 2:  http://hl7.org/fhir/3.0/StructureDefinition/Questionnaire (for Questionnaire version 3.0, a.k.a. STU3).Example 3:  http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire|2.7  (for SDC Questionnaire version 2.7).',
                            );
                        return this.validateFHIRVersion(t);
                    },
                    setFHIRContext: function (t, n) {
                        if (!LForms.FHIR)
                            throw new Error(
                                'LHC-Forms FHIR support files have not been loaded.See http://lhncbc.github.io/lforms/#fhirScripts',
                            );
                        (LForms.fhirContext = { client: t, vars: n }),
                            (LForms.fhirCapabilities = {}),
                            delete LForms._serverFHIRReleaseID;
                    },
                    _fhirVersionToRelease: function (t) {
                        let n = t,
                            e = t.match(/^\d+(\.\d+)/);
                        if (e) {
                            const i = parseFloat(e[0]);
                            n =
                                (i >= 5 && i < 6) || 4.2 == i || (i >= 4.4) & (i <= 4.6)
                                    ? 'R5'
                                    : 4.1 == i || 4.3 == i
                                    ? 'R4B'
                                    : i > 3 && i <= 4
                                    ? 'R4'
                                    : i >= 1.1 && i <= 3
                                    ? 'STU3'
                                    : t;
                        }
                        return n;
                    },
                    getServerFHIRReleaseID: function (t) {
                        if (!LForms.fhirContext)
                            throw new Error('setFHIRContext needs to be called before getFHIRReleaseID');
                        if (!LForms.fhirContext.client)
                            throw new Error('setFHIRContext was called, but no server connection was provided');
                        if (LForms._serverFHIRReleaseID)
                            setTimeout(function () {
                                t(LForms._serverFHIRReleaseID);
                            });
                        else
                            try {
                                LForms.fhirContext.client.getFhirVersion().then(
                                    function (e) {
                                        (LForms._serverFHIRReleaseID = LForms.Util._fhirVersionToRelease(e)),
                                            console.log(
                                                'Server FHIR version is ' +
                                                    LForms._serverFHIRReleaseID +
                                                    ' (' +
                                                    e +
                                                    ')',
                                            ),
                                            t(LForms._serverFHIRReleaseID);
                                    },
                                    function (e) {
                                        console.log("Error retrieving server's CompatibilityStatement:"),
                                            console.log(e),
                                            t();
                                    },
                                );
                            } catch (e) {
                                throw (
                                    (setTimeout(function () {
                                        t();
                                    }),
                                    e)
                                );
                            }
                    },
                    validateFHIRVersion: function (t) {
                        if (!LForms.Util.FHIRSupport[t]) throw new Error('Version ' + t + ' of FHIR is not supported.');
                        if (!LForms.FHIR)
                            throw new Error(
                                'The FHIR support files for LHC-Forms do not appear to have been loaded.  Please consult the documentation at http://lhncbc.github.io/lforms/#fhirSupport.',
                            );
                        if (!LForms.FHIR[t])
                            throw new Error(
                                'Version ' + t + ' of FHIR is supported, but the supporting code was not loaded.',
                            );
                        return t;
                    },
                    detectFHIRVersion: function (t) {
                        let n = null;
                        return t.meta && t.meta.profile && (n = this.detectFHIRVersionFromProfiles(t.meta.profile)), n;
                    },
                    detectFHIRVersionFromProfiles(t) {
                        if (!t || !t.length) return null;
                        let n = null;
                        for (let i = 0; i < t.length; i++) {
                            var e = t[i].match(Pre);
                            let r;
                            if (
                                (e
                                    ? (r = e[1])
                                    : (e = t[i].match(Nre)) &&
                                      ((r = e[1]), '2.0' === r ? (r = '3.0') : parseFloat(r) >= 2.1 && (r = '4.0')),
                                r)
                            ) {
                                const s = this._fhirVersionToRelease(r);
                                (!n || Dk[s] > Dk[n]) && (n = s);
                            }
                        }
                        return n;
                    },
                    guessFHIRVersion: function (t) {
                        var n = null;
                        return (
                            'Questionnaire' == t.resourceType
                                ? (n = this._testValues(t, 'item', function (s) {
                                      let o = !!(
                                          s.option ||
                                          s.options ||
                                          s.initialBoolean ||
                                          s.initialDecimal ||
                                          s.initialInteger ||
                                          s.initialDate ||
                                          s.initialDateTime ||
                                          s.initialTime ||
                                          s.initialString ||
                                          s.initialUri ||
                                          s.initialAttachment ||
                                          s.initialQuantity ||
                                          s.initialReference
                                      );
                                      return (
                                          !o && s.enableWhen?.length && (o = s.enableWhen.some(a => 'hasAnswer' in a)),
                                          o
                                      );
                                  })
                                      ? 'STU3'
                                      : this._testValues(t, 'item', function (s) {
                                            return !(!s.disabledDisplay && !s.answerConstraint && 'coding' !== s.type);
                                        })
                                      ? 'R5'
                                      : 'R4')
                                : 'QuestionnaireResponse' == t.resourceType &&
                                  (n =
                                      t.parent ||
                                      this._testValues(t, 'item', function (o) {
                                          return !!o.subject;
                                      })
                                          ? 'STU3'
                                          : 'R4'),
                            n
                        );
                    },
                    _testValues: function (t, n, e) {
                        var i = !1;
                        if (t instanceof Array)
                            for (var r = 0, s = t.length; !i && r < s; ++r) i = this._testValues(t[r], n, e);
                        else if ('object' == typeof t)
                            for (var o = Object.keys(t), a = 0, l = o.length; !i && a < l; ++a) {
                                var c = o[a],
                                    f = t[c];
                                if (c === n)
                                    if (f instanceof Array) for (var g = 0, E = f.length; !i && g < E; ++g) i = e(f[g]);
                                    else i = e(f);
                                i || (i = this._testValues(f, n, e));
                            }
                        return i;
                    },
                    _getFormObjectInScope: function (t) {
                        var n, e;
                        if (('string' == typeof t && (t = document.querySelector(t)), t))
                            e = t.getElementsByTagName('wc-lhc-form');
                        else {
                            var i = document.getElementsByTagName('body');
                            e =
                                i && i.length > 0
                                    ? (t = i[0]).getElementsByTagName('wc-lhc-form')
                                    : document.getElementsByTagName('wc-lhc-form');
                        }
                        for (let r of e) {
                            n = r.lhcFormData;
                            break;
                        }
                        return n;
                    },
                    isItemValueEmpty: function (t) {
                        var n = !0;
                        if (null != t && '' !== t && 'function' != typeof t)
                            if ('string' == typeof t || t instanceof String) n = '' === t.trim();
                            else if (Array.isArray(t)) {
                                for (var e = 0; e < t.length; ++e)
                                    if (!this.isItemValueEmpty(t[e])) {
                                        n = !1;
                                        break;
                                    }
                            } else if ('object' == typeof t) {
                                var i = Object.keys(t);
                                if (i.length > 0) {
                                    e = 0;
                                    for (var r = i.length; e < r; e++)
                                        if (!this.isItemValueEmpty(t[i[e]])) {
                                            n = !1;
                                            break;
                                        }
                                } else t.constructor !== Object && (n = !1);
                            } else n = !1;
                        return n;
                    },
                    findItem: function (t, n, e) {
                        var i = null;
                        if (t)
                            for (var r = 0; !i && r < t.length; ++r) {
                                var s = t[r];
                                s[n] === e ? (i = s) : Array.isArray(s.items) && (i = this.findItem(s.items, n, e));
                            }
                        return i;
                    },
                    initializeCodes: function (t) {
                        var n = t.question || t.questionCode,
                            e = n ? t.questionCode : t.code,
                            r = n ? t.question : t.name,
                            s = this.getCodeSystem(n ? t.questionCodeSystem : t.codeSystem);
                        if (e) {
                            t.codeList || (t.codeList = []);
                            for (var o = t.codeList, a = !1, l = 0; l < o.length; l++)
                                if (e === o[l].code && ((!s && !o[l].system) || s === o[l].system)) {
                                    a = !0;
                                    break;
                                }
                            a || 'LinkId' === s || ((e = { code: e, display: r }), s && (e.system = s), o.unshift(e));
                        } else
                            t.codeList &&
                                t.codeList.length > 0 &&
                                (n
                                    ? ((t.questionCode = t.codeList[0].code),
                                      (t.questionCodeSystem = t.codeList[0].system))
                                    : ((t.code = t.codeList[0].code), (t.codeSystem = t.codeList[0].system)));
                        return t;
                    },
                    createLocalFHIRReference: function (t) {
                        var n = { reference: t.resourceType + '/' + t.id };
                        if ('Patient' === t.resourceType && t.name && t.name.length > 0) {
                            var e = t.name[0];
                            e.text
                                ? (n.display = e.text)
                                : (e.given && e.given.length > 0 && (n.display = e.given[0]),
                                  e.family && (n.display = n.display ? n.display + ' ' + e.family : e.family));
                        }
                        return n;
                    },
                    getCodeSystem: function (t) {
                        return 'LOINC' === t ? 'http://loinc.org' : t;
                    },
                    removeObjectsFromArray: function (t, n, e, i, r) {
                        var s = r ? [] : null,
                            o = r ? [] : null;
                        if (Array.isArray(t)) {
                            var a = 0;
                            i && Math.abs(i) < t.length && (a = i < 0 ? t.length + i : i);
                            for (var l = t.length, c = a; c < l; c++)
                                if (t[c][n] === e) {
                                    var f = t[c];
                                    if (!r) {
                                        (s = c), (o = f);
                                        break;
                                    }
                                    s.push(c), o.push(f);
                                }
                            if (Array.isArray(s)) for (c = s.length - 1; c >= 0; c--) t.splice(s[c], 1);
                            else null !== s && t.splice(s, 1);
                        }
                        return o;
                    },
                    baseFormDef: function () {
                        return { lformsVersion: LForms.lformsVersion };
                    },
                    getAnswersResourceStatus: function (t) {
                        return (
                            (!t || t instanceof HTMLElement || 'string' == typeof t) &&
                                (t = this._getFormObjectInScope(t)),
                            t.checkAnswersResourceStatus()
                        );
                    },
                    loadScript: function (t) {
                        return new Promise(function (n, e) {
                            var i = document.createElement('script');
                            (i.onreadystatechange = n),
                                (i.onload = n),
                                (i.onerror = e),
                                (i.src = t),
                                document.body.appendChild(i);
                        });
                    },
                    loadFHIRLibs: function (t, n) {
                        return Promise.all([this.loadScript(t), this.loadScript(n)]);
                    },
                    _hasMultipleAnswers: function (t) {
                        return (
                            t.answerCardinality &&
                            t.answerCardinality.max &&
                            ('*' === t.answerCardinality.max || parseInt(t.answerCardinality.max) > 1)
                        );
                    },
                    _hasForbiddenCssUrl: function (t) {
                        let n = [],
                            i = t.match(/url\(\s*["']?(.*?)["']?\s*\)/g);
                        const r = /^url\(\s*[\\"']?[A-Za-z0-9]*\:\/\//;
                        if (i)
                            for (let s = 0; s < i.length; s++) {
                                let o = i[s];
                                o.match(r) && n.push(o);
                            }
                        return n;
                    },
                    checkForInvalidHtmlTags: function (t) {
                        let n = [];
                        const r = [
                                'html',
                                'head',
                                'body',
                                'ref',
                                'script',
                                'form',
                                'base',
                                'link',
                                'xlink',
                                'iframe',
                                'object',
                            ].concat([
                                'applet',
                                'basefont',
                                'blink',
                                'center',
                                'dir',
                                'embed',
                                'font',
                                'frame',
                                'frameset',
                                'isindex',
                                'noframes',
                                'marquee',
                                'menu',
                                'plaintext',
                                's',
                                'strike',
                                'u',
                            ]),
                            s = /^(?:data:|#|\/)/i,
                            a = [
                                'background',
                                'background-image',
                                'border',
                                'border-image',
                                'border-image-source',
                                'content',
                                'cursor',
                                'filter',
                                'list-style',
                                'list-style-image',
                                'mask',
                                'mask-image',
                                'offset-path',
                                'clip-path',
                            ],
                            l = {
                                a: ['href'],
                                area: ['href'],
                                blockquote: ['cite'],
                                del: ['cite'],
                                img: ['langdesc', 'src', 'usemap'],
                                input: ['src', 'usemap'],
                                ins: ['cite'],
                                q: ['cite'],
                                audio: ['src'],
                                button: ['formaction'],
                                input: ['formaction'],
                                source: ['src'],
                                tract: ['src'],
                                video: ['poster', 'src'],
                            },
                            c = { img: 'srcset', source: 'srcset' };
                        let f = this;
                        const g = new jie({
                            onopentag(E, P) {
                                r.forEach(V => {
                                    E.toLocaleLowerCase() === V && n.push({ tag: V });
                                });
                                for (const [V, W] of Object.entries(l))
                                    if (E.toLocaleLowerCase() === V)
                                        for (const [ie, he] of Object.entries(P))
                                            W.forEach(fe => {
                                                ie === fe && !he.match(s) && n.push({ tag: V, attribute: fe });
                                            });
                                for (const [V, W] of Object.entries(c))
                                    if (E.toLocaleLowerCase() === V)
                                        for (const [ie, he] of Object.entries(P))
                                            ie === W &&
                                                he.split(',').forEach(ze => {
                                                    ze.trim().match(s) || n.push({ tag: V, attribute: W });
                                                });
                                for (const [V, W] of Object.entries(P))
                                    if ('style' === V) {
                                        let ie = Ore(W);
                                        for (const [he, fe] of Object.entries(ie))
                                            a.forEach(ze => {
                                                he.toLocaleLowerCase() === ze &&
                                                    f._hasForbiddenCssUrl(fe).forEach(kt => {
                                                        n.push({
                                                            tag: E.toLocaleLowerCase(),
                                                            attribute: 'style',
                                                            cssPropertyValue: ze + ' : ' + kt,
                                                        });
                                                    });
                                            });
                                    }
                            },
                        });
                        return g.write(t), g.end(), n;
                    },
                    escapeAttribute: function (t) {
                        return t
                            .replace(/&/g, '&amp;')
                            .replace(/"/g, '&quot;')
                            .replace(/'/g, '&#39;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;');
                    },
                    getSupportedFeatures: function () {
                        return zre;
                    },
                };
            xk._internalUtil = $i;
            const Co = { ...Rt, ...xk },
                h3 = {
                    _timeout: 1500,
                    _restrictionKeys: [
                        'minExclusive',
                        'minInclusive',
                        'maxExclusive',
                        'maxInclusive',
                        'totalDigits',
                        'fractionDigits',
                        'length',
                        'minLength',
                        'maxLength',
                        'enumeration',
                        'whiteSpace',
                        'pattern',
                    ],
                    _dataTypes: [
                        'BL',
                        'INT',
                        'REAL',
                        'ST',
                        'TX',
                        'BIN',
                        'DT',
                        'DTM',
                        'TM',
                        'CODING',
                        'RTO',
                        'QTY',
                        'NR',
                        'YEAR',
                        'MONTH',
                        'DAY',
                        'URL',
                        'EMAIL',
                        'PHONE',
                        '',
                    ],
                    _errorMessages: {
                        BL: 'BL',
                        INT: 'INT',
                        REAL: 'REAL',
                        ST: 'ST',
                        TX: 'TX',
                        BIN: 'BIN',
                        DT: 'DT',
                        DTM: 'DTM',
                        TM: 'TM',
                        RTO: 'RTO',
                        QTY: 'QTY',
                        NR: 'NR',
                        YEAR: 'YEAR',
                        MONTH: 'MONTH',
                        DAY: 'DAY',
                        URL: 'URL',
                        EMAIL: 'EMAIL',
                        PHONE: 'PHONE',
                    },
                    checkRequired: function (t, n, e) {
                        var i = !0;
                        return (
                            t &&
                                (null == n || '' === n || (Array.isArray(n) && 0 === n.length)) &&
                                ((i = !1), e.push(window.lhcTranslationsFn('required'))),
                            i
                        );
                    },
                    checkDataType: function (t, n, e) {
                        var i = !0;
                        if (null != n && '' !== n)
                            switch (t) {
                                case 'BL':
                                    !0 !== n && !1 !== n && (i = !1);
                                    break;
                                case 'INT':
                                    i = Rt.isInteger(n);
                                    break;
                                case 'REAL':
                                case 'QTY':
                                    i = Rt.isDecimal(n);
                                    break;
                                case 'PHONE':
                                    i =
                                        /(((^\s*(\d\d){0,1}\s*(-?|\.)\s*(\(?\d\d\d\)?\s*(-?|\.?)){0,1}\s*\d\d\d\s*(-?|\.?)\s*\d{4}\b)|(^\s*\+\(?(\d{1,4}\)?(-?|\.?))(\s*\(?\d{2,}\)?\s*(-?|\.?)\s*\d{2,}\s*(-?|\.?)(\s*\d*\s*(-|\.?)){0,3})))(\s*(x|ext|X)\s*\d+){0,1}$)/.test(
                                            n,
                                        );
                                    break;
                                case 'EMAIL':
                                    i = /^\s*((\w+)(\.\w+)*)@((\w+)(\.\w+)+)$/.test(n);
                                    break;
                                case 'URL':
                                    i =
                                        /^(https?|ftp):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?$/.test(
                                            n,
                                        );
                                    break;
                                case 'TM':
                                    i =
                                        /^\s*(((\d|[0-1]\d|2[0-4]):([0-5]\d))|(\d|0\d|1[0-2]):([0-5]\d)\s*([aApP][mM]))\s*$/.test(
                                            n,
                                        );
                                    break;
                                case 'YEAR':
                                    i = /^\d{1,4}$/.test(n);
                                    break;
                                case 'MONTH':
                                    i = /^(0?[1-9]|1[012])$/.test(n);
                                    break;
                                case 'DAY':
                                    i = /^(0?[1-9]|[12]\d|3[01])$/.test(n);
                                    break;
                                case 'NR':
                                    i = /^(\-?\d+(\.\d*)?)?\s*\^\s*(\-?\d+(\.\d*)?)?$/.test(n);
                                    break;
                                case 'DT':
                                    i = Rt.isValidDate(n);
                                    break;
                                default:
                                    i = !0;
                            }
                        if (Array.isArray(e) && !i) {
                            var translatedMessage = window.lhcTranslationsFn(this._errorMessages[t]);
                            e.push(translatedMessage);
                        }
                        return i;
                    },
                    checkRestrictions: function (t, n, e) {
                        var i = !0;
                        if (null != n && '' !== n)
                            for (var r in t) {
                                var s = !0,
                                    o = t[r];
                                switch (r) {
                                    case 'minExclusive':
                                        parseFloat(n) > parseFloat(o)
                                            ? (s = !0)
                                            : ((s = !1), e.push(window.lhcTranslationsFn('minExclusive', [o])));
                                        break;
                                    case 'minInclusive':
                                        parseFloat(n) >= parseFloat(o)
                                            ? (s = !0)
                                            : ((s = !1), e.push(window.lhcTranslationsFn('minInclusive', [o])));
                                        break;
                                    case 'maxExclusive':
                                        parseFloat(n) < parseFloat(o)
                                            ? (s = !0)
                                            : ((s = !1), e.push(window.lhcTranslationsFn('maxExclusive', [o])));
                                        break;
                                    case 'maxInclusive':
                                        parseFloat(n) <= parseFloat(o)
                                            ? (s = !0)
                                            : ((s = !1), e.push(window.lhcTranslationsFn('maxInclusive', [o])));
                                        break;
                                    case 'totalDigits':
                                    case 'fractionDigits':
                                        break;
                                    case 'length':
                                        n.length == parseInt(o)
                                            ? (s = !0)
                                            : ((s = !1), e.push(window.lhcTranslationsFn('length', [o])));
                                        break;
                                    case 'maxLength':
                                        n.length <= parseInt(o)
                                            ? (s = !0)
                                            : ((s = !1), e.push(window.lhcTranslationsFn('maxLength', [o])));
                                        break;
                                    case 'minLength':
                                        n.length >= parseInt(o)
                                            ? (s = !0)
                                            : ((s = !1), e.push(window.lhcTranslationsFn('minLength', [o])));
                                        break;
                                    case 'pattern':
                                        var c,
                                            f,
                                            a = o.indexOf('/'),
                                            l = o.lastIndexOf('/');
                                        0 === a && l > 0 ? ((c = o.slice(a + 1, l)), (f = o.slice(l + 1))) : (c = o),
                                            new RegExp(c, f).test(n)
                                                ? (s = !0)
                                                : ((s = !1), e.push(window.lhcTranslationsFn('pattern', [o])));
                                        break;
                                    case 'maxDecimalPlaces':
                                        const E = n.toString().split(/[eE]/),
                                            P = parseInt(E[1]) || 0;
                                        (E[0].split('.')[1]?.length || 0) - P <= o
                                            ? (s = !0)
                                            : ((s = !1), e.push(window.lhcTranslationsFn('maxDecimalPlaces', [o])));
                                        break;
                                    default:
                                        s = !0;
                                }
                                i = i && s;
                            }
                        return i;
                    },
                    getTranslationForDynamicErrors: function (key, params) {
                        var currentLang = window.uiLanguage || 'en-GB';

                        // Define translations
                        var translations = {
                            'en-GB': {
                                required: 'requires a value',
                                minExclusive: 'must be a value greater than {0}.',
                                minInclusive: 'must be a value greater than or equal to {0}.',
                                maxExclusive: 'must be a value less than {0}.',
                                maxInclusive: 'must be a value less than or equal to {0}.',
                                length: 'must have a total length of {0}.',
                                maxLength: 'must have a total length less than or equal to {0}.',
                                minLength: 'must have a total length greater than or equal to {0}.',
                                pattern: 'must match a RegExp pattern of {0}.',
                                maxDecimalPlaces: 'must not have more than {0} decimal places.',
                                removeThis: 'Remove this "',
                                other: ' Other ',
                                BL: 'must be a boolean (true/false).',
                                INT: 'must be an integer number.',
                                REAL: 'must be a decimal number.',
                                ST: 'must be a string value.',
                                TX: 'must be a text value.',
                                BIN: 'must be a binary value.',
                                DT: 'must be a date value.',
                                DTM: 'must be a date and time value.',
                                TM: 'must be a time value.',
                                RTO: 'must be a ratio value.',
                                QTY: 'must be a decimal number.',
                                NR: 'must be two numeric values separated by a ^. One value can be omitted, but not the ^.',
                                YEAR: 'must be a numeric value of year.',
                                MONTH: 'must be a numeric value of month.',
                                DAY: 'must be a numeric value of day.',
                                URL: 'must be a valid URL.',
                                EMAIL: 'must be a valid email address.',
                                PHONE: 'must be a valid phone number.',
                            },
                            'de-DE': {
                                required: 'erfordert einen Wert',
                                minExclusive: 'muss größer als {0} sein.',
                                minInclusive: 'muss größer oder gleich {0} sein.',
                                maxExclusive: 'muss kleiner als {0} sein.',
                                maxInclusive: 'muss kleiner oder gleich {0} sein.',
                                length: 'muss eine Gesamtlänge von {0} haben.',
                                maxLength: 'darf eine Gesamtlänge von {0} nicht überschreiten.',
                                minLength: 'muss eine Mindestlänge von {0} haben.',
                                pattern: 'muss dem Muster {0} entsprechen',
                                maxDecimalPlaces: 'darf nicht mehr als {0} Dezimalstellen haben.',
                                removeThis: 'Entfernen Sie dieses "',
                                other: 'Andere',
                                BL: 'muss ein Boolean-Wert sein (true/false).',
                                INT: 'muss eine ganze Zahl sein.',
                                REAL: 'muss eine Dezimalzahl sein.',
                                ST: 'muss ein String-Wert sein.',
                                TX: 'muss ein Text-Wert sein.',
                                BIN: 'muss ein Binärwert sein.',
                                DT: 'muss ein Datumswert sein.',
                                DTM: 'muss ein Datums- und Zeitwert sein.',
                                TM: 'muss ein Zeitwert sein.',
                                RTO: 'muss ein Verhältniswert sein.',
                                QTY: 'muss eine Dezimalzahl sein.',
                                NR: 'muss zwei durch ^ getrennte numerische Werte enthalten. Ein Wert kann weggelassen werden, aber nicht das ^.',
                                YEAR: 'muss ein numerischer Jahreswert sein.',
                                MONTH: 'muss ein numerischer Monatswert sein.',
                                DAY: 'muss ein numerischer Tageswert sein.',
                                URL: 'muss eine gültige URL sein.',
                                EMAIL: 'muss eine gültige E-Mail-Adresse sein.',
                                PHONE: 'muss eine gültige Telefonnummer sein.',
                            },
                            // Add more languages as needed
                        };

                        // Get the translation for the current language or fall back to English
                        var message =
                            (translations[currentLang] && translations[currentLang][key]) ||
                            translations['en-GB'][key] ||
                            key;

                        // Replace parameters
                        if (params) {
                            for (var i = 0; i < params.length; i++) {
                                message = message.replace('{' + i + '}', params[i]);
                            }
                        }

                        return message;
                    },
                };
            let Fre = {
                    getValueInStandardUnit: function (t, n) {
                        return (t * this.units_[n]).toFixed(this.precision_);
                    },
                    getStandardUnit: function () {},
                    precision_: 4,
                    units_: {
                        kg: 1,
                        kgs: 1,
                        kilograms: 1,
                        pounds: 0.453592,
                        lbs: 0.453592,
                        cm: 1,
                        cms: 1,
                        centimeters: 1,
                        feet: 30.48,
                        ft: 30.48,
                        inches: 2.54,
                        '[in_i]': 2.54,
                        meters: 100,
                        'ft-inches': 2.54,
                    },
                },
                Rre = {
                    calculations_: {
                        precision_: 2,
                        TOTALSCORE: function (t) {
                            for (var n = 0, e = 0, i = t.length; e < i; e++) n += parseFloat(t[e]);
                            return n;
                        },
                        BMI: function (t) {
                            var n = '',
                                e = parseFloat(t[0]),
                                i = parseFloat(t[1]);
                            return (
                                e &&
                                    '' != e &&
                                    i &&
                                    '' != i &&
                                    '0' != i &&
                                    (n = (n = e / Math.pow(i / 100, 2)).toFixed(this.precision_)),
                                n
                            );
                        },
                        BSA: function (t) {
                            var n = '',
                                e = parseFloat(t[0]),
                                i = parseFloat(t[1]);
                            return (
                                e &&
                                    '' != e &&
                                    i &&
                                    '' != i &&
                                    (n = (n = Math.sqrt((i * e) / 3600)).toFixed(this.precision_)),
                                n
                            );
                        },
                    },
                };
            var Ek = $i.errorMessages;
            class Ik {
                constructor(n, e = null) {
                    if (
                        ((this.code = null),
                        (this.codeList = null),
                        (this.identifier = null),
                        (this.name = null),
                        (this.templateOptions = {}),
                        (this.items = []),
                        (this.PATH_DELIMITER = '/'),
                        (this.hasSavedData = !1),
                        (this._invalidData = !1),
                        (this._repeatableItems = {}),
                        (this._opt = {}),
                        (this._actionLogs = []),
                        (this._activeItem = null),
                        (this._defaultTemplateOptions = {
                            showQuestionCode: !1,
                            showCodingInstruction: !1,
                            allowMultipleEmptyRepeatingItems: !1,
                            allowHTML: !1,
                            displayControl: { questionLayout: 'vertical' },
                            viewMode: 'auto',
                            defaultAnswerLayout: { answerLayout: { type: 'COMBO_BOX', columns: '0' } },
                            hideTreeLine: !1,
                            hideIndentation: !1,
                            hideRepetitionNumber: !1,
                            displayScoreWithAnswerText: !0,
                            displayInvalidHTML: !1,
                            messageLevel: 'error',
                        }),
                        (this.lformsVersion = '36.7.2'),
                        (this._packageStore = null),
                        (this._variableExt = null),
                        (this._codePath = ''),
                        (this._idPath = ''),
                        (this._displayLevel = 0),
                        (this._horizontalTableInfo = {}),
                        (this._containedImageHtmlMap = new Map()),
                        e && (this._packageStore = e),
                        n && n._initializeInternalData)
                    ) {
                        for (var i = Object.getOwnPropertyNames(n), r = 0; r < i.length; r++)
                            i[r] && !i[r].startsWith('_') && 'function' != typeof n[i[r]] && (this[i[r]] = n[i[r]]);
                        n._variableExt && (this._variableExt = n._variableExt);
                    } else
                        Object.assign(this, n),
                            (this.templateOptions = n.templateOptions || {}),
                            (this.PATH_DELIMITER = n.PATH_DELIMITER || '/');
                    LForms.FHIR && n.fhirVersion && this._initializeFormFHIRData(n),
                        n.contained && (this._containedImages = this._fhir.SDC.buildContainedImageMap(n.contained)),
                        this._initializeInternalData();
                }
                setMessageLevel(n) {
                    (this._showInfo = 'info' == n),
                        (this._showWarnings = this._showInfo || 'warning' == n),
                        (this._showErrors = this._showWarnings || 'error' == n);
                }
                _getResourcesFromPackageStore(n, e) {
                    var i = null;
                    if (this._packageStore && e && n)
                        for (
                            var r = e.split('|'), s = r[0], o = r[1], a = 0, l = this._packageStore.length;
                            a < l;
                            a++
                        ) {
                            var c = this._packageStore[a];
                            if (c.resourceType === n && c.url === s && ((o && c.version === o) || !o)) {
                                i = JSON.parse(JSON.stringify(c));
                                break;
                            }
                        }
                    return i;
                }
                checkAnswersResourceStatus() {
                    for (var n = [], e = 0, i = this.itemList.length; e < i; e++) {
                        var r = this.itemList[e];
                        r.answerValueSet && !r.answers && n.push('Resource not loaded: ' + r.answerValueSet);
                    }
                    return n;
                }
                addAsyncChangeListener(n) {
                    this._asyncChangeListeners || (this._asyncChangeListeners = []), this._asyncChangeListeners.push(n);
                }
                _notifyAsyncChangeListeners() {
                    if (this._asyncChangeListeners)
                        for (var n = 0, e = this._asyncChangeListeners.length; n < e; ++n)
                            this._asyncChangeListeners[n]();
                }
                _initializeFormFHIRData(n) {
                    (this.fhirVersion = n.fhirVersion),
                        (this._fhir = LForms.FHIR[this.fhirVersion]),
                        (this._expressionProcessor = new this._fhir.SDC.ExpressionProcessor(this)),
                        (this._fhirVariables = {}),
                        (this.extension = n.extension ? n.extension.slice(0) : null),
                        n.extension &&
                            (this._fhir.SDC.buildExtensionMap(this),
                            (this._hasResponsiveExpr =
                                this._hasResponsiveExpr || this._fhir.SDC.hasResponsiveExpression(this)),
                            (this._hasInitialExpr = this._hasInitialExpr || this._fhir.SDC.hasInitialExpression(this))),
                        this._fhir.SDC.processExtensions(this, 'obj_title');
                }
                _getFHIRSupport() {
                    var n = this._fhir;
                    if (!n) {
                        var e = Object.keys(LForms.FHIR);
                        if ((e.length > 0 && (n = LForms.FHIR[e[0]]), !n))
                            throw new Error('The LHC-Forms FHIR support file was not loaded.');
                        this._fhir = n;
                    }
                    return n;
                }
                loadFHIRResources(n) {
                    var e = this,
                        i = this._fhir.SDC;
                    const r = i._getTerminologyServer(this);
                    !LForms.fhirContext &&
                        !r &&
                        console.log(
                            'Warning: FHIR resources might not be loaded, because loadFHIRResources() was called before LForms.Util.setFHIRContext()',
                        );
                    var s = LForms.fhirContext ? i.loadLaunchContext(this) : [];
                    return (
                        (s = s.concat(i.loadAnswerValueSets(this))),
                        n && s.push(i.requestLinkedObs(this)),
                        Promise.all(s)
                            .then(function () {
                                e._notifyAsyncChangeListeners();
                            })
                            .catch(function (a) {
                                throw a;
                            })
                    );
                }
                _buildURL(n, e) {
                    let i = n.map(r => encodeURIComponent(r)).join('/');
                    return (
                        e &&
                            (i +=
                                '?' +
                                Object.keys(e)
                                    .map(r => r + '=' + encodeURIComponent(e[r]))
                                    .join('&')),
                        i
                    );
                }
                _loadAnswerValueSetsFromPackage(n) {
                    if (n.answerValueSet) {
                        var e = this._getResourcesFromPackageStore('ValueSet', n.answerValueSet);
                        if (e && this._fhir) {
                            var i = this._fhir.SDC.answersFromVS(e.fileContent);
                            i && (n.answers = i);
                        }
                    }
                }
                _checkFHIRVarName(n) {
                    if (this._fhir.reservedVarNames[n])
                        throw 'The "' + n + '" variable name is reserved; Questionnaires may not assign a value to it.';
                }
                _initializeInternalData() {
                    this._setDefaultValues(),
                        Co.initializeCodes(this),
                        (this._repeatableItems = {}),
                        this._setTreeNodes(this.items, this),
                        this._updateLastRepeatingItemsStatus(this.items),
                        this._updateItemDisabledDisplayStatus(this.items),
                        (this.itemList = []),
                        (this.itemHash = {}),
                        this._updateItemReferenceList(this.items),
                        this._standardizeScoreRule(this.itemList),
                        this._resetHorizontalTableInfo(),
                        this._adjustLastSiblingListForHorizontalLayout(),
                        this._setUpAnswerAndUnitAutoComp(this.itemList),
                        this._setupSourceToTargetMap(),
                        this._checkFormControls();
                }
                _resetInternalData() {
                    this._updateTreeNodes(this.items, this),
                        this._updateLastRepeatingItemsStatus(this.items),
                        this._updateItemDisabledDisplayStatus(this.items),
                        (this.itemList = []),
                        (this.itemHash = {}),
                        this._updateItemReferenceList(this.items),
                        this._standardizeScoreRule(this.itemList),
                        this._resetHorizontalTableInfo(),
                        this._adjustLastSiblingListForHorizontalLayout(),
                        this._setUpAnswerAndUnitAutoComp(this.itemList),
                        this._setupSourceToTargetMap(),
                        this._checkFormControls();
                }
                updateSkipLogicControlledItems(n, e) {
                    var i = !1;
                    if (n._skipLogicTargets)
                        for (var r = 0, s = n._skipLogicTargets.length; r < s; r++) {
                            var o = n._skipLogicTargets[r];
                            (i = this._updateItemSkipLogicStatus(o, null) || i) &&
                                this.updateSkipLogicControlledItems(o, e);
                        }
                    return e(n) || i;
                }
                updateOnSourceItemChange(n) {
                    for (var e = this, i = !0; i; )
                        i = this.updateSkipLogicControlledItems(n, function (r) {
                            var s = !1;
                            if (r._formulaTargets)
                                for (var o = 0, a = r._formulaTargets.length; o < a; o++)
                                    s = e._processItemFormula(r._formulaTargets[o]) || s;
                            if (r._dataControlTargets)
                                for (o = 0, a = r._dataControlTargets.length; o < a; o++)
                                    s = e._processItemDataControl(r._dataControlTargets[o]) || s;
                            return s;
                        });
                    if (
                        (this._updateTreeNodes(this.items, this),
                        this._updateLastRepeatingItemsStatus(this.items),
                        this._resetHorizontalTableInfo(),
                        this._adjustLastSiblingListForHorizontalLayout(),
                        this._checkFormControls(),
                        LForms.FHIR && this._hasResponsiveExpr)
                    ) {
                        let r = this;
                        setTimeout(function () {
                            r._expressionProcessor.runCalculations(!1).then(() => {
                                r._checkFormControls();
                            });
                        });
                    }
                }
                _checkValidations(n) {
                    if (n._hasValidation) {
                        var e = [];
                        h3.checkRequired(n._answerRequired, n.value, e),
                            h3.checkDataType(n.dataType, n.value, e),
                            h3.checkRestrictions(n.restrictions, n.value, e),
                            (n._validationErrors = e);
                    }
                }
                _checkFormControls() {
                    for (var n = !0; n; ) {
                        n = !1;
                        for (var e = 0, i = this.itemList.length; e < i; e++) {
                            var r = this.itemList[e];
                            r.calculationMethod && (n = this._processItemFormula(r) || n),
                                r.dataControl && (n = this._processItemDataControl(r) || n),
                                r.skipLogic && (n = this._updateItemSkipLogicStatus(r, null) || n);
                        }
                    }
                    this._updateSubItemsHiddenFromView(this, !1),
                        this._updateTreeNodes(this.items, this),
                        this._updateLastRepeatingItemsStatus(this.items),
                        this._resetHorizontalTableInfo(),
                        this._adjustLastSiblingListForHorizontalLayout();
                }
                _updateSubItemsHiddenFromView(n, e) {
                    if (n.items && n.items.length > 0)
                        for (var i = 0, r = n.items.length; i < r; i++) {
                            var s = n.items[i];
                            let o = e || this.isItemHidden(s);
                            (s._isHiddenFromView = o), this._updateSubItemsHiddenFromView(s, o);
                        }
                }
                _setupSourceToTargetMap() {
                    for (var n = 0, e = this.itemList.length; n < e; n++) {
                        var i = this.itemList[n];
                        if (i.calculationMethod && i.calculationMethod.name)
                            for (
                                var r = this._getFormulaSourceItems(i, i.calculationMethod.value), s = 0, o = r.length;
                                s < o;
                                s++
                            )
                                r[s]._formulaTargets ? r[s]._formulaTargets.push(i) : (r[s]._formulaTargets = [i]);
                        if (i.dataControl && Array.isArray(i.dataControl))
                            for (s = 0, o = i.dataControl.length; s < o; s++) {
                                var a = i.dataControl[s].source;
                                if (
                                    a &&
                                    (!a.sourceType || a.sourceType === Ge_DATA_CONTROL_SOURCE_INTERNAL) &&
                                    a.sourceLinkId
                                ) {
                                    if (!(l = this._findItemByLinkId(i, a.sourceLinkId)))
                                        throw new Error(
                                            "Data control for item '" +
                                                i.question +
                                                "' refers to source item '" +
                                                a.sourceLinkId +
                                                "' which was not found as a sibling, ancestor, or ancestor sibling.",
                                        );
                                    l._dataControlTargets
                                        ? l._dataControlTargets.push(i)
                                        : (l._dataControlTargets = [i]);
                                }
                            }
                        if (i.skipLogic)
                            for (s = 0, o = i.skipLogic.conditions.length; s < o; s++) {
                                var l;
                                (l = this._getSkipLogicSourceItem(i, i.skipLogic.conditions[s].source))
                                    ._skipLogicTargets
                                    ? l._skipLogicTargets.push(i)
                                    : (l._skipLogicTargets = [i]);
                            }
                    }
                }
                _updateItemSkipLogicStatus(n, e) {
                    var r,
                        i = !1;
                    if (e) (i = this._setSkipLogicStatusValue(n, Ge_SKIP_LOGIC_STATUS_DISABLED) || i), (r = !0);
                    else {
                        if (n.skipLogic) {
                            var s = this._checkSkipLogic(n);
                            n.skipLogic.action && n.skipLogic.action !== Ge_SKIP_LOGIC_ACTION_ENABLE
                                ? n.skipLogic.action === Ge_SKIP_LOGIC_ACTION_DISABLE &&
                                  (i =
                                      this._setSkipLogicStatusValue(
                                          n,
                                          s ? Ge_SKIP_LOGIC_STATUS_DISABLED : Ge_SKIP_LOGIC_STATUS_ENABLED,
                                      ) || i)
                                : (i =
                                      this._setSkipLogicStatusValue(
                                          n,
                                          s ? Ge_SKIP_LOGIC_STATUS_ENABLED : Ge_SKIP_LOGIC_STATUS_DISABLED,
                                      ) || i);
                        } else
                            n._skipLogicStatus === Ge_SKIP_LOGIC_STATUS_DISABLED &&
                                (i = this._setSkipLogicStatusValue(n, Ge_SKIP_LOGIC_STATUS_ENABLED) || i);
                        r = n._skipLogicStatus === Ge_SKIP_LOGIC_STATUS_DISABLED;
                    }
                    if (n.items && n.items.length > 0)
                        for (var a = 0, l = n.items.length; a < l; a++)
                            i = this._updateItemSkipLogicStatus(n.items[a], r) || i;
                    return i;
                }
                _presetSkipLogicStatus(n, e) {
                    if (
                        (n.skipLogic || e) &&
                        (this._setSkipLogicStatusValue(n, Ge_SKIP_LOGIC_STATUS_DISABLED, !0), n.items)
                    )
                        for (var r = 0, s = n.items.length; r < s; r++) this._presetSkipLogicStatus(n.items[r], !0);
                }
                _setSkipLogicStatusValue(n, e, i = !1) {
                    var r = !1;
                    return (
                        n._skipLogicStatus !== e &&
                            (n._skipLogicStatus &&
                                (i ||
                                    this._actionLogs.push(
                                        e === Ge_SKIP_LOGIC_STATUS_DISABLED
                                            ? 'Hiding ' + n._text
                                            : 'Showing ' + n._text,
                                    )),
                            (n._skipLogicStatus = e),
                            (r = !0)),
                        r
                    );
                }
                _updateItemReferenceList(n) {
                    for (var e = 0, i = n.length; e < i; e++) {
                        var r = n[e];
                        this.itemList.push(r),
                            (this.itemHash[r._elementId] = r),
                            r.items && r.items.length > 0 && this._updateItemReferenceList(r.items);
                    }
                }
                _updateItemDisabledDisplayStatus(n, e = null) {
                    for (let i = 0, r = n.length; i < r; i++) {
                        let s = n[i],
                            o = s.disabledDisplay || e;
                        o &&
                            ((s._disabledDisplayStatus = o),
                            s.items && s.items.length > 0 && this._updateItemDisabledDisplayStatus(s.items, o));
                    }
                }
                _findItemsWithScore() {
                    for (var n = {}, e = 0, i = this.itemList.length; e < i; e++) {
                        var r = this.itemList[e];
                        if (
                            r.dataType === Ge_DATA_TYPE_CODING &&
                            r.answers &&
                            Array.isArray(r.answers) &&
                            r.answers.length > 0
                        )
                            for (var s = 0, o = r.answers.length; s < o; s++) {
                                var a = r.answers[s];
                                if (a && a.hasOwnProperty('score') && !isNaN(a.score)) {
                                    n[r.linkId] = r;
                                    break;
                                }
                            }
                    }
                    return Object.keys(n);
                }
                _standardizeScoreRule(n) {
                    for (var e = 0, i = n.length; e < i; e++) {
                        var r = n[e];
                        if (
                            r.calculationMethod &&
                            (r.calculationMethod.name === Ge_CALCULATION_METHOD_TOTALSCORE ||
                                r.calculationMethod === Ge_CALCULATION_METHOD_TOTALSCORE)
                        ) {
                            r.calculationMethod = { name: Ge_CALCULATION_METHOD_TOTALSCORE, value: [] };
                            var s = this._findItemsWithScore();
                            r.calculationMethod.value = s;
                        }
                    }
                }
                _setDefaultValues() {
                    (this._codePath = ''),
                        (this._idPath = ''),
                        (this._displayLevel = 0),
                        (this._activeItem = null),
                        (!this.template ||
                            0 == this.template.length ||
                            'form-view-a' === this.template ||
                            'form-view-b' === this.template) &&
                            (this.template = 'table');
                    var n = Rt.deepCopy(this.templateOptions),
                        e = Rt.deepCopy(this._defaultTemplateOptions);
                    this.setTemplateOptions(n, e);
                }
                _mergeTwoArrays(n, e) {
                    for (var i = 0, r = e.length; i < r; i++)
                        if (e[i])
                            for (var s = Object.keys(e[i]), o = 0, a = s.length; o < a; o++)
                                (null !== e[i][s[o]] || void 0 !== e[i][s[o]]) && (n[i][s[o]] = e[i][s[o]]);
                }
                setTemplateOptions(n, e = null) {
                    if (
                        (n &&
                            n.hasOwnProperty('allowHTMLInInstructions') &&
                            !n.hasOwnProperty('allowHTML') &&
                            ((n.allowHTML = n.allowHTMLInInstructions), delete n.allowHTMLInInstructions),
                        n)
                    ) {
                        e || (e = Rt.deepCopy(this.templateOptions));
                        let i =
                                void 0 !== n.displayScoreWithAnswerText &&
                                n.displayScoreWithAnswerText !== e.displayScoreWithAnswerText,
                            r = void 0 !== n.allowHTML && n.allowHTML !== e.allowHTML,
                            s = void 0 !== n.displayInvalidHTML && n.displayInvalidHTML !== e.displayInvalidHTML;
                        if (((this.templateOptions = Object.assign({}, e, n)), (i || r || s) && this.itemList))
                            for (let o = 0, a = this.itemList.length; o < a; o++) {
                                let l = this.itemList[o];
                                l._hasAnswerList && (!i || l._hasScoreInAnswer) && this._updateAutocompOptions(l);
                            }
                        if (this.templateOptions.allowHTML && this.itemList)
                            for (let o = 0, a = this.itemList.length; o < a; o++) {
                                let l = this.itemList[o];
                                if (l._displayTextHTML) {
                                    this._containedImages &&
                                        l._displayTextHTML.match(/img/) &&
                                        l._displayTextHTML.match(/src/) &&
                                        (this._containedImageHtmlMap.has(l._displayTextHTMLOriginal)
                                            ? (l._displayTextHTML = this._containedImageHtmlMap.get(
                                                  l._displayTextHTMLOriginal,
                                              ))
                                            : ((l._displayTextHTMLOriginal = l._displayTextHTML),
                                              (l._displayTextHTML = $i._getHtmlStringWithContainedImages(
                                                  this._containedImages,
                                                  l._displayTextHTMLOriginal,
                                              )),
                                              this._containedImageHtmlMap.set(
                                                  l._displayTextHTMLOriginal,
                                                  l._displayTextHTML,
                                              )));
                                    let c,
                                        f,
                                        g = LForms.Util.checkForInvalidHtmlTags(l._displayTextHTML);
                                    g &&
                                        g.length > 0 &&
                                        ((l._hasInvalidHtmlTag = !0),
                                        (c = {}),
                                        Ek.addMsg(c, 'invalidTagInHTMLContent'),
                                        (f = [{ errors: c }]),
                                        $i.printInvalidHtmlToConsole(g),
                                        $i.setItemMessagesArray(l, f, 'setTemplateOptions'));
                                }
                                if (
                                    l.codingInstructions &&
                                    l.codingInstructions.length > 0 &&
                                    'html' === l.codingInstructionsFormat
                                ) {
                                    this._containedImages &&
                                        l.codingInstructions.match(/img/) &&
                                        l.codingInstructions.match(/src/) &&
                                        (l._codingInstructionsWithContainedImages =
                                            $i._getHtmlStringWithContainedImages(
                                                this._containedImages,
                                                l.codingInstructions,
                                            ));
                                    let c,
                                        f,
                                        E = LForms.Util.checkForInvalidHtmlTags(
                                            l._codingInstructionsWithContainedImages || l.codingInstructions,
                                        );
                                    E &&
                                        E.length > 0 &&
                                        ((l.codingInstructionsHasInvalidHtmlTag = !0),
                                        (c = {}),
                                        Ek.addMsg(c, 'invalidTagInHelpHTMLContent'),
                                        (f = [{ errors: c }]),
                                        $i.printInvalidHtmlToConsole(E),
                                        $i.setItemMessagesArray(l, f, '_processCodingInstructions'));
                                }
                            }
                        this.setMessageLevel(this.templateOptions.messageLevel);
                    }
                }
                _lfItemValueFromDefaultAnswer(n) {
                    var e = n.defaultAnswer;
                    if (null == e || '' === e) return !1;
                    !n._hasAnswerList &&
                        (n.dataType === Ge_DATA_TYPE_DTM || n.dataType === Ge_DATA_TYPE_DT) &&
                        'string' == typeof e &&
                        ((e = Rt.stringToDate(e)) ||
                            console.error(
                                n.defaultAnswer +
                                    ': Invalid date/datetime string as defaultAnswer for ' +
                                    n.questionCode,
                            )),
                        $i.assignValueToItem(n, e);
                }
                _setTreeNodes(n, e) {
                    for (var i = n.length, r = i - 1, s = null, o = 1, a = 0; a < i; a++) {
                        var l = n[a];
                        if (
                            (l.dataType === Ge_DATA_TYPE_CNE
                                ? (l.dataType = Ge_DATA_TYPE_CODING)
                                : l.dataType === Ge_DATA_TYPE_CWE &&
                                  ((l.dataType = Ge_DATA_TYPE_CODING), (l.answerConstraint = 'optionsOrString')),
                            Co.initializeCodes(l),
                            (l._text = l.prefix ? l.prefix + ' ' + l.question : l.question),
                            l.header
                                ? l.dataType !== Ge_DATA_TYPE_TITLE && (l.dataType = Ge_DATA_TYPE_SECTION)
                                : l.units && !l.dataType
                                ? (l.dataType = Ge_DATA_TYPE_REAL)
                                : l.dataType || (l.dataType = Ge_DATA_TYPE_ST),
                            ('string' == typeof l.answers || 'number' == typeof l.answers) &&
                                this.answerLists &&
                                Array.isArray(this.answerLists[l.answers]) &&
                                (l.answers = this.answerLists[l.answers]),
                            this._packageStore && this._loadAnswerValueSetsFromPackage(l),
                            (l._hasAnswerList = $i.hasAnswerList(l)),
                            'SECTION' === l.dataType
                                ? l.displayControl
                                    ? l.displayControl.questionLayout || (l.displayControl.questionLayout = 'vertical')
                                    : ((l.displayControl = { questionLayout: 'vertical' }),
                                      l.layout && ((l.displayControl.questionLayout = l.layout), delete l.layout))
                                : l._hasAnswerList &&
                                  (l.displayControl
                                      ? l.displayControl.answerLayout ||
                                        (l.displayControl.answerLayout = Rt.deepCopy(
                                            this.templateOptions.defaultAnswerLayout.answerLayout,
                                        ))
                                      : (l.displayControl = Rt.deepCopy(this.templateOptions.defaultAnswerLayout))),
                            l.extension &&
                                this._fhir &&
                                (this._fhir.SDC.buildExtensionMap(l),
                                (this._hasResponsiveExpr =
                                    this._hasResponsiveExpr || this._fhir.SDC.hasResponsiveExpression(l)),
                                (this._hasInitialExpr = this._hasInitialExpr || this._fhir.SDC.hasInitialExpression(l)),
                                (l._hasListExpr = this._fhir.SDC.hasListExpression(l))),
                            this._updateItemAttrs(l),
                            l._hasAnswerList
                                ? this._resetItemValueWithAnswers(l)
                                : !this.hasSavedData &&
                                  null != l.defaultAnswer &&
                                  null == l.value &&
                                  this._lfItemValueFromDefaultAnswer(l),
                            l._questionRepeatable && s && s.linkId === l.linkId ? (o += 1) : (o = 1),
                            (l._id = o),
                            (l._idPath = e._idPath + this.PATH_DELIMITER + l._id),
                            (l._elementId = l.linkId + l._idPath),
                            (l._displayLevel = e._displayLevel + 1),
                            (l._lastSibling = a === r),
                            (l._firstSibling = 0 === a),
                            this._setupInFieldPlaceholders(l),
                            l.value &&
                                !l._hasAnswerList &&
                                (l.dataType === Ge_DATA_TYPE_DT || l.dataType === Ge_DATA_TYPE_DTM) &&
                                (l.value = Rt.stringToDate(l.value)),
                            !l._hasAnswerList &&
                                (l.dataType === Ge_DATA_TYPE_INT ||
                                    l.dataType === Ge_DATA_TYPE_REAL ||
                                    l.dataType === Ge_DATA_TYPE_QTY) &&
                                'number' == typeof l.value &&
                                (l.value = l.value + ''),
                            (l._answerRequired ||
                                l.restrictions ||
                                (l.dataType !== Ge_DATA_TYPE_ST &&
                                    l.dataType !== Ge_DATA_TYPE_TX &&
                                    l.dataType !== Ge_DATA_TYPE_DTM &&
                                    l.dataType !== Ge_DATA_TYPE_DT &&
                                    l.dataType !== Ge_DATA_TYPE_TM &&
                                    !l._hasAnswerList)) &&
                                (l._hasValidation = !0),
                            l.items && l.items.length > 0 && this._setTreeNodes(l.items, l),
                            l._questionRepeatable && 1 === l._id)
                        ) {
                            delete l._parentItem;
                            var c = Rt.deepCopy(l);
                            this._removeUserDataAndRepeatingSubItems(c), (this._repeatableItems[l.linkId] = c);
                        }
                        (l._parentItem = e), (s = l);
                    }
                }
                _setupInFieldPlaceholders(n) {
                    if (!n._readOnly)
                        if (n._entryFormat) n._placeholder = n._entryFormat;
                        else if (n._hasAnswerList)
                            n._placeholder =
                                'optionsOrString' === n.answerConstraint
                                    ? n.externallyDefined
                                        ? n._multipleAnswers
                                            ? 'Search for or type values'
                                            : 'Search for or type a value'
                                        : n._multipleAnswers
                                        ? 'Select one or more or type a value'
                                        : 'Select one or type a value'
                                    : n.externallyDefined
                                    ? n._multipleAnswers
                                        ? 'Search for values'
                                        : 'Search for value'
                                    : n._multipleAnswers
                                    ? 'Select one or more'
                                    : 'Select one';
                        else
                            switch (n.dataType) {
                                case Ge_DATA_TYPE_DT:
                                    n._placeholder = 'MM/DD/YYYY';
                                    break;
                                case Ge_DATA_TYPE_DTM:
                                    n._placeholder = 'MM/DD/YYYY HH:MM:SS';
                                    break;
                                case Ge_DATA_TYPE_TM:
                                    n._placeholder = 'HH:MM:SS';
                                    break;
                                case Ge_DATA_TYPE_CODING:
                                    n.answerConstaint && 'optionsOnly' !== n.answerConstraint
                                        ? 'optionsOrString' === n.answerConstraint &&
                                          (n._placeholder = n.externallyDefined
                                              ? n._multipleAnswers
                                                  ? 'Search for or type values'
                                                  : 'Search for or type a value'
                                              : n._multipleAnswers
                                              ? 'Select one or more or type a value'
                                              : 'Select one or type a value')
                                        : (n._placeholder = n.externallyDefined
                                              ? n._multipleAnswers
                                                  ? 'Search for values'
                                                  : 'Search for value'
                                              : n._multipleAnswers
                                              ? 'Select one or more'
                                              : 'Select one');
                                    break;
                                case 'SECTION':
                                case 'TITLE':
                                case '':
                                    n._placeholder = '';
                                    break;
                                case Ge_DATA_TYPE_INT:
                                case Ge_DATA_TYPE_REAL:
                                case Ge_DATA_TYPE_QTY:
                                    n._placeholder = 'Type a number';
                                    break;
                                default:
                                    n._placeholder = 'Type a value';
                            }
                }
                _removeUserDataAndRepeatingSubItems(n) {
                    if (((n.value = null), (n.unit = null), n.items && n.items.length > 0))
                        for (var e = 0; e < n.items.length; e++) {
                            var i = n.items[e];
                            i._questionRepeatable && 1 != i._id
                                ? (n.items.splice(e, 1), e--)
                                : this._removeUserDataAndRepeatingSubItems(i);
                        }
                }
                _updateItemAttrs(n) {
                    if (
                        (n.questionCardinality || (n.questionCardinality = { min: '1', max: '1' }),
                        n.answerCardinality || (n.answerCardinality = { min: '0', max: '1' }),
                        !Array.isArray(n.answers) &&
                            '' !== n.answers &&
                            this.answerLists &&
                            (n.answers = this.answerLists[n.answers]),
                        this._containedImages &&
                            n.codingInstructions &&
                            n.codingInstructions.length > 0 &&
                            this.templateOptions.allowHTML &&
                            'html' === n.codingInstructionsFormat &&
                            n.codingInstructions.match(/img/) &&
                            n.codingInstructions.match(/src/) &&
                            (n._codingInstructionsWithContainedImages = $i._getHtmlStringWithContainedImages(
                                this._containedImages,
                                n.codingInstructions,
                            )),
                        Array.isArray(n.answers) && n.dataType === Ge_DATA_TYPE_CODING)
                    )
                        for (
                            var e = n.answerCodeSystem ? Co.getCodeSystem(n.answerCodeSystem) : null,
                                i = 0,
                                r = n.answers.length;
                            i < r;
                            i++
                        ) {
                            var s = n.answers[i];
                            s.system
                                ? (s.system = Co.getCodeSystem(s.system))
                                : s.codeSystem
                                ? ((s.system = Co.getCodeSystem(s.codeSystem)), delete s.codeSystem)
                                : e && (s.system = e);
                        }
                    (n._questionRepeatable =
                        n.questionCardinality.max &&
                        ('*' === n.questionCardinality.max || parseInt(n.questionCardinality.max) > 1)),
                        (n._answerRequired =
                            n.answerCardinality.min &&
                            n.answerCardinality.min &&
                            parseInt(n.answerCardinality.min) >= 1),
                        (n._multipleAnswers = Co._hasMultipleAnswers(n)),
                        (n._readOnly = '0' === n.editable || !!n.calculationMethod || $i.targetDisabledAndProtected(n)),
                        this._fhir &&
                            (this._fhir.SDC.processExtensions(n, 'obj_text'),
                            this._fhir.SDC.processExtensions(n, 'obj_prefix'));
                }
                isItemHidden(n) {
                    return (
                        ((n._skipLogicStatus === Ge_SKIP_LOGIC_STATUS_DISABLED || !1 === n._enableWhenExpVal) &&
                            'protected' !== n._disabledDisplayStatus) ||
                        n.isHiddenInDef
                    );
                }
                _updateTreeNodes(n, e) {
                    for (var i = n.length, r = i - 1, s = !1, o = i - 1; o >= 0; o--) {
                        if (
                            ((a = n[o])._id || (a._id = 1),
                            (a._idPath = e._idPath + this.PATH_DELIMITER + a._id),
                            (a._elementId = a.linkId + a._idPath),
                            (a._displayLevel = e._displayLevel + 1),
                            (a._parentItem = e),
                            (a._repeatingSectionList = null),
                            this._updateItemAttrs(a),
                            (a._lastSibling = o === r),
                            s ||
                                (this.isItemHidden(a)
                                    ? ((a._lastSibling = !1), (r -= 1))
                                    : ((a._lastSibling = !0), (s = !0))),
                            a._questionRepeatable && 1 === a._id && !this._repeatableItems[a.linkId])
                        ) {
                            delete a._parentItem;
                            var l = Rt.deepCopy(a);
                            this._removeUserDataAndRepeatingSubItems(l), (this._repeatableItems[a.linkId] = l);
                        }
                        (a._parentItem = e), a.items && a.items.length > 0 && this._updateTreeNodes(a.items, a);
                    }
                    var c = !1,
                        f = 0;
                    for (o = 0; o < i; o++) {
                        var a;
                        ((a = n[o])._firstSibling = o === f),
                            c ||
                                (a._skipLogicStatus === Ge_SKIP_LOGIC_STATUS_DISABLED
                                    ? ((a._firstSibling = !1), (f += 1))
                                    : ((a._firstSibling = !0), (c = !0)));
                    }
                }
                getFormData(n, e, i) {
                    for (var r = this.getUserData(!1, n, e, i), s = !1, o = 0, a = this.itemList.length; o < a; o++)
                        if (!Co.isItemValueEmpty(this.itemList[o].value)) {
                            s = !0;
                            break;
                        }
                    var c = {
                        lformsVersion: this.lformsVersion,
                        PATH_DELIMITER: this.PATH_DELIMITER,
                        code: this.code,
                        codeList: this.codeList,
                        identifier: this.identifier,
                        codeSystem: this.codeSystem,
                        name: this.name,
                        type: this.type,
                        template: this.template,
                        copyrightNotice: this.copyrightNotice,
                        url: this.url,
                        version: this.version,
                        items: r.itemsData,
                        templateOptions: Rt.deepCopy(this.templateOptions),
                    };
                    return (
                        this.extension && this.extension.length > 0 && (c.extension = this.extension),
                        s && (c.hasSavedData = !0),
                        this.fhirVersion && (c.fhirVersion = this.fhirVersion),
                        c
                    );
                }
                getUserData(n, e, i, r) {
                    var s = {};
                    return (
                        (this._invalidData = !1),
                        this._checkSubTreeValues(this.items),
                        (s.itemsData = this._processDataInItems(this.items, n, e, i, r)),
                        Rt.deepCopy(s)
                    );
                }
                checkValidity() {
                    const n = [],
                        e = this.itemList.length;
                    for (let i = 0; i < e; i++) {
                        const r = this.itemList[i];
                        if (
                            r._skipLogicStatus !== Ge_SKIP_LOGIC_STATUS_DISABLED &&
                            (this._checkValidations(r), void 0 !== r._validationErrors && r._validationErrors.length)
                        ) {
                            const s = r._validationErrors.map(o => `${r.question} ${o}`);
                            Array.prototype.push.apply(n, s);
                        }
                    }
                    return n.length ? n : null;
                }
                _checkSubTreeValues(n) {
                    for (var e = 0, i = n.length; e < i; e++) this._setSubTreeHasValue(n[e]);
                }
                _setSubTreeHasValue(n) {
                    var e = !1;
                    if ((Co.isItemValueEmpty(n.value) || (e = !0), n.items && n.items.length > 0))
                        for (var i = 0, r = n.items.length; i < r; i++)
                            this._setSubTreeHasValue(n.items[i]) && (e = !0);
                    return (n._itemOrSubtreeHasValue = e), e;
                }
                _processDataInItems(n, e, i, r, s) {
                    for (var o = [], a = 0, l = n.length; a < l; a++) {
                        var c = n[a],
                            f = {};
                        if (
                            !(
                                (r && c._skipLogicStatus === Ge_SKIP_LOGIC_STATUS_DISABLED) ||
                                (i &&
                                    !c._itemOrSubtreeHasValue &&
                                    c.dataType !== Ge_DATA_TYPE_SECTION &&
                                    c.dataType !== Ge_DATA_TYPE_TITLE)
                            )
                        ) {
                            if (e)
                                (f.questionCode = c.questionCode),
                                    c.dataType !== Ge_DATA_TYPE_SECTION &&
                                        c.dataType !== Ge_DATA_TYPE_TITLE &&
                                        (void 0 !== c.value &&
                                            (f.value = this._getOriginalValue(
                                                c,
                                                c.value,
                                                c.dataType,
                                                c._hasAnswerList,
                                            )),
                                        c.unit && (f.unit = this._getOriginalValue(c, c.unit)));
                            else
                                for (var g in (c.extension && c.extension.length > 0 && (f.extension = c.extension), c))
                                    'value' === g
                                        ? (f[g] = this._getOriginalValue(c, c[g], c.dataType, c._hasAnswerList))
                                        : 'unit' === g
                                        ? (f[g] = this._getOriginalValue(c, c[g]))
                                        : !g.match(/^[_\$]/) && 'extension' !== g && (f[g] = c[g]),
                                        s && (f._id = c._id);
                            c.items && c.items.length > 0 && (f.items = this._processDataInItems(c.items, e, i, r, s)),
                                (!i || (f.items && 0 !== f.items.length) || c._itemOrSubtreeHasValue) && o.push(f);
                        }
                    }
                    return o;
                }
                _filterInternalData(n, e) {
                    var i = {};
                    if (e && n._notOnList && !n.code && !n.system) i = n.text;
                    else for (var r in n) r.match(/^[_\$]/) || (i[r] = n[r]);
                    return i;
                }
                getItemValues(n) {
                    var e;
                    if (n._questionRepeatable) {
                        e = [];
                        for (var r = n._parentItem.items, s = n.linkId, o = !1, a = 0, l = r.length; a < l; ++a) {
                            var c = r[a];
                            if (c.linkId === s) Co.isItemValueEmpty(c.value) || e.push(c.value), (o = !0);
                            else if (o) break;
                        }
                    } else {
                        var i = n.value;
                        e = Co.isItemValueEmpty(i) ? [] : n._multipleAnswers ? i : [i];
                    }
                    return e;
                }
                _getObjectValue(n, e = !1) {
                    var i = null;
                    if (n)
                        if (Array.isArray(n)) {
                            for (var r = [], s = 0, o = n.length; s < o; s++)
                                r.push('object' == typeof n[s] ? this._filterInternalData(n[s], e) : n[s]);
                            i = r;
                        } else 'object' == typeof n && (i = this._filterInternalData(n, e));
                    return i;
                }
                _getOriginalValue(n, e, i = null, r = !1) {
                    var s;
                    if (null != e)
                        if (i)
                            switch (i) {
                                case Ge_DATA_TYPE_INT:
                                    r
                                        ? n.answerConstraint && 'optionsOnly' !== n.answerConstraint
                                            ? 'optionsOrString' === n.answerConstraint &&
                                              (s = this._getObjectValue(e, !0))
                                            : (s = this._getObjectValue(e))
                                        : Array.isArray(e)
                                        ? (s = e.map(o => (Rt.isInteger(o) || (this._invalidData = !0), parseInt(o))))
                                        : (Rt.isInteger(e) || (this._invalidData = !0), (s = parseInt(e)));
                                    break;
                                case Ge_DATA_TYPE_REAL:
                                case Ge_DATA_TYPE_QTY:
                                    Rt.isDecimal(e) || (this._invalidData = !0), (s = parseFloat(e));
                                    break;
                                case Ge_DATA_TYPE_DT:
                                    r
                                        ? n.answerConstraint && 'optionsOnly' !== n.answerConstraint
                                            ? 'optionsOrString' === n.answerConstraint &&
                                              (s = this._getObjectValue(e, !0))
                                            : (s = this._getObjectValue(e))
                                        : (s = Array.isArray(e)
                                              ? e.map(o => Rt.dateToDTStringISO(o))
                                              : Rt.dateToDTStringISO(e));
                                    break;
                                case Ge_DATA_TYPE_DTM:
                                    s = Rt.dateToDTMString(e);
                                    break;
                                case Ge_DATA_TYPE_CODING:
                                    n.answerConstraint && 'optionsOnly' !== n.answerConstraint
                                        ? 'optionsOrString' === n.answerConstraint && (s = this._getObjectValue(e, !0))
                                        : (s = this._getObjectValue(e));
                                    break;
                                case Ge_DATA_TYPE_BL:
                                    s = !!e;
                                    break;
                                case Ge_DATA_TYPE_ST:
                                case Ge_DATA_TYPE_TM:
                                    r
                                        ? n.answerConstraint && 'optionsOnly' !== n.answerConstraint
                                            ? 'optionsOrString' === n.answerConstraint &&
                                              (s = this._getObjectValue(e, !0))
                                            : (s = this._getObjectValue(e))
                                        : (s = e);
                                    break;
                                default:
                                    s = e;
                            }
                        else s = this._getObjectValue(e);
                    return s;
                }
                getRepeatingItemMaxId(n) {
                    var e = n._id;
                    if (n._parentItem && Array.isArray(n._parentItem.items))
                        for (var i = 0, r = n._parentItem.items.length; i < r; i++)
                            n._parentItem.items[i].linkId === n.linkId &&
                                n._parentItem.items[i]._id > e &&
                                (e = n._parentItem.items[i]._id);
                    return e;
                }
                getRepeatingItemCount(n) {
                    var e = 0;
                    if (n._parentItem && Array.isArray(n._parentItem.items))
                        for (var i = 0, r = n._parentItem.items.length; i < r; i++)
                            n._parentItem.items[i].linkId === n.linkId && e++;
                    return e;
                }
                _updateLastRepeatingItemsStatus(n) {
                    if (n && 0 !== n.length) {
                        for (var e = n.length, i = '', r = 0; r < e; r++) {
                            var s = n[r];
                            '' !== i &&
                                (n[r - 1]._lastRepeatingItem = !(i === s.linkId || !n[r - 1]._questionRepeatable)),
                                (i = s.linkId),
                                s.items && s.items.length > 0 && this._updateLastRepeatingItemsStatus(s.items);
                        }
                        (n[e - 1]._lastRepeatingItem = !!n[e - 1]._questionRepeatable),
                            n[e - 1].items &&
                                n[e - 1].items.length > 0 &&
                                this._updateLastRepeatingItemsStatus(n[e - 1].items);
                    }
                }
                _getLastSubItem(n) {
                    var e = n;
                    if (n && Array.isArray(n.items) && n.items.length > 0) {
                        var i,
                            r = n.items.length,
                            s = !1;
                        do {
                            (i = n.items[--r])._skipLogicStatus !== Ge_SKIP_LOGIC_STATUS_DISABLED && (s = !0);
                        } while (!s);
                        s && (e = this._getLastSubItem(i));
                    }
                    return e;
                }
                _resetHorizontalTableInfo() {
                    this._horizontalTableInfo = {};
                    for (var n = null, e = null, i = 0, r = this.itemList.length; i < r; i++) {
                        var s = this.itemList[i];
                        if (
                            s.dataType === Ge_DATA_TYPE_SECTION &&
                            s.displayControl &&
                            'horizontal' == s.displayControl.questionLayout
                        ) {
                            var o = [],
                                a = [];
                            s._inHorizontalTable = !0;
                            var l = s.linkId + s._parentItem._idPath;
                            if (((e = s._elementId), null === n || n !== l)) {
                                (n = l), (s._horizontalTableHeader = !0), (s._horizontalTableId = n);
                                for (var c = 0, f = (o = s.items).length; c < f; c++) {
                                    var g = o[c];
                                    a.push({ item: g, id: 'col' + g._elementId, displayControl: g.displayControl }),
                                        (o[c]._inHorizontalTable = !0);
                                }
                                (this._horizontalTableInfo[n] = {
                                    tableStartIndex: i,
                                    tableEndIndex: i + o.length,
                                    columnHeaders: a,
                                    tableRows: [{ header: s, cells: o }],
                                    tableHeaders: [s],
                                }),
                                    (this._horizontalTableInfo[n].lastHeaderId = e);
                            } else if (n === l) {
                                for (s._horizontalTableHeader = !1, c = 0, f = (o = s.items).length; c < f; c++)
                                    o[c]._inHorizontalTable = !0;
                                this._horizontalTableInfo[n].tableRows.push({ header: s, cells: o }),
                                    this._horizontalTableInfo[n].tableHeaders.push(s),
                                    (this._horizontalTableInfo[n].tableEndIndex = i + o.length),
                                    (this._horizontalTableInfo[n].lastHeaderId = e);
                            }
                        }
                    }
                }
                _adjustLastSiblingListForHorizontalLayout() {
                    var n = this._horizontalTableInfo;
                    for (var e in n) {
                        var i = n[e].tableHeaders;
                        i.length > 1 && (i[0]._lastSibling = i[i.length - 1]._lastSibling);
                    }
                }
                addRepeatingItems(n) {
                    var e = this.getRepeatingItemMaxId(n),
                        i = this._repeatableItems[n.linkId];
                    this._fillAnswersInRepeatItem(i, n);
                    var r = Rt.deepCopy(i);
                    if (((r._id = e + 1), n._parentItem && Array.isArray(n._parentItem.items))) {
                        for (var s = 0, o = 0, a = n._parentItem.items.length; o < a; o++)
                            if (n._parentItem.items[o].linkId === n.linkId && n._parentItem.items[o]._id === n._id) {
                                s = o;
                                break;
                            }
                        n._parentItem.items.splice(s + 1, 0, r),
                            (r._parentItem = n._parentItem),
                            this._presetSkipLogicStatus(r, !1);
                    }
                    this._resetInternalData();
                    var l = 'Added ' + this.itemDescription(n);
                    return (
                        this._actionLogs.push(l),
                        LForms.FHIR &&
                            this._hasResponsiveExpr &&
                            this._expressionProcessor.runCalculations(!1).then(() => {}),
                        r
                    );
                }
                _fillAnswersInRepeatItem(n, e) {
                    n.items &&
                        Array.isArray(n.items) &&
                        n.items.length > 0 &&
                        n.items.forEach(i => {
                            var r = e.items.find(s => s.linkId === i.linkId);
                            r &&
                                (!i.answers && r.answers && (i.answers = r.answers),
                                this._fillAnswersInRepeatItem(i, r));
                        });
                }
                _findIndexForNewRepetition(n) {
                    for (var e = 0, i = !1, r = 0, s = n._parentItem.items.length; r < s; r++)
                        if (
                            (n._parentItem.items[r].linkId === n.linkId && (i = !0),
                            i && n._parentItem.items[r].linkId !== n.linkId)
                        ) {
                            e = r;
                            break;
                        }
                    return i && r === s && (e = r), e;
                }
                appendRepeatingItems(n) {
                    var e = this.getRepeatingItemMaxId(n),
                        i = Rt.deepCopy(this._repeatableItems[n.linkId]);
                    if (((i._id = e + 1), n._parentItem && Array.isArray(n._parentItem.items))) {
                        var r = this._findIndexForNewRepetition(n);
                        n._parentItem.items.splice(r, 0, i),
                            (i._parentItem = n._parentItem),
                            this._presetSkipLogicStatus(i, !1);
                    }
                    this._resetInternalData();
                    var s = 'Added ' + this.itemDescription(n);
                    return this._actionLogs.push(s), i;
                }
                areAnyRepeatingItemsEmpty(n) {
                    for (var e = !1, i = this._getRepeatingItems(n), r = 0, s = i.length; r < s; r++)
                        (i[r]._showUnusedItemWarning = !1), this._isRepeatingItemEmpty(i[r]) && (e = !0);
                    return e && (n._showUnusedItemWarning = !0), e;
                }
                _isRepeatingItemEmpty(n) {
                    var e = !0;
                    if (n.dataType !== Ge_DATA_TYPE_SECTION) {
                        if (null == n.value || '' === n.value) return e;
                        if (n._skipLogicStatus !== Ge_SKIP_LOGIC_STATUS_DISABLED)
                            if (Array.isArray(n.value) && n.value.length > 0) {
                                for (
                                    var i = !1, r = 0, s = n.value.length;
                                    r < s &&
                                    (n.value[r].text && (i = null != n.value[r].text && '' !== n.value[r].text), !i);
                                    r++
                                );
                                e = !i;
                            } else if ('object' == typeof n.value) {
                                const l = n.value;
                                e = !(null != l.data || l.url || l.text || l instanceof Date);
                            } else null != n.value && '' !== n.value && (e = !1);
                    }
                    if (e && n.items)
                        for (var o = 0, a = n.items.length; o < a && (e = this._isRepeatingItemEmpty(n.items[o])); o++);
                    return e;
                }
                _getRepeatingItems(n) {
                    var e = [];
                    if (n._questionRepeatable && n._parentItem && Array.isArray(n._parentItem.items))
                        for (var i = n._parentItem.items, r = 0, s = i.length; r < s; r++)
                            i[r].linkId === n.linkId && e.push(i[r]);
                    return e;
                }
                getPrevRepeatingItem(n) {
                    var e = this._getRepeatingItems(n),
                        r = e
                            .map(function (s) {
                                return s._elementId;
                            })
                            .indexOf(n._elementId);
                    return r > 0 ? e[r - 1] : null;
                }
                getNextRepeatingItem(n) {
                    var e = this._getRepeatingItems(n),
                        r = e
                            .map(function (s) {
                                return s._elementId;
                            })
                            .indexOf(n._elementId);
                    return r < e.length - 1 ? e[r + 1] : null;
                }
                getFirstRepeatingItem(n) {
                    return this._getRepeatingItems(n)[0];
                }
                getLastRepeatingItem(n) {
                    var e = this._getRepeatingItems(n);
                    return e[e.length - 1];
                }
                removeRepeatingItems(n) {
                    if (n._parentItem && Array.isArray(n._parentItem.items))
                        for (var e = 0, i = n._parentItem.items.length; e < i; e++)
                            if (n._parentItem.items[e].linkId == n.linkId && n._parentItem.items[e]._id == n._id) {
                                n._parentItem.items.splice(e, 1);
                                break;
                            }
                    this._resetInternalData();
                    var r = 'Removed ' + this.itemDescription(n);
                    this._actionLogs.push(r),
                        LForms.FHIR &&
                            this._hasResponsiveExpr &&
                            this._expressionProcessor.runCalculations(!1).then(() => {});
                }
                setRepeatingItems(n, e, i, r) {
                    var o,
                        s = !1;
                    let a = !1,
                        l = !1;
                    if (
                        (Rt.deepEqual(n._lastComputedMessages, i) || ((n._lastComputedRepeatingMessages = i), (a = !0)),
                        n._questionRepeatable)
                    ) {
                        if (n._parentItem && Array.isArray(n._parentItem.items)) {
                            o = this._getRepeatingItems(n);
                            var g,
                                E,
                                f = e.length - o.length;
                            if (
                                ((s = 0 !== f),
                                f < 0 &&
                                    ((E = this._findIndexForNewRepetition(n) + f),
                                    n._parentItem.items.splice(E, -f),
                                    o.splice(f),
                                    0 === e.length && ((f = 1), (g = 0))),
                                f > 0)
                            ) {
                                void 0 === E &&
                                    ((E = this._findIndexForNewRepetition(n)), (g = this.getRepeatingItemMaxId(n)));
                                for (
                                    var P = n._parentItem._skipLogicStatus === Ge_SKIP_LOGIC_STATUS_DISABLED, V = 0;
                                    V < f;
                                    ++V
                                ) {
                                    var W = Rt.deepCopy(this._repeatableItems[n.linkId]);
                                    (W._id = g + 1),
                                        n._parentItem.items.splice(E, 0, W),
                                        (W._parentItem = n._parentItem),
                                        o.push(W),
                                        this._presetSkipLogicStatus(W, P);
                                }
                            }
                            V = 0;
                            for (var ie = e.length; V < ie; ++V)
                                (l = $i.assignValueToItem(o[V], e[V]) || l), a && $i.setItemMessages(o[V], i[V], r);
                        }
                    } else
                        n._multipleAnswers
                            ? (n.value = e)
                            : ((l = $i.assignValueToItem(n, e[0]) || l),
                              e.length > 1
                                  ? ($i.addItemWarning(n, 'MultipleValuesForNonRepeat'), console.log(JSON.stringify(e)))
                                  : $i.removeItemWarning(n, 'MultipleValuesForNonRepeat')),
                            a && $i.setItemMessagesArray(n, i, r);
                    s && this._resetInternalData();
                    var he = 'Set values for ' + this.itemDescription(n);
                    return (
                        this._actionLogs.push(he), l && this.updateOnSourceItemChange(n), s ? o[o.length - 1] : void 0
                    );
                }
                setRepeatingItemMessages(n, e, i) {
                    if (!Rt.deepEqual(n._lastComputedMessages, e))
                        if (((n._lastComputedRepeatingMessages = e), n._questionRepeatable)) {
                            if (n._parentItem && Array.isArray(n._parentItem.items)) {
                                const o = this._getRepeatingItems(n);
                                for (var r = 0, s = o.length; r < s; ++r) $i.setItemMessages(o[r], e[r], i);
                            }
                        } else $i.setItemMessagesArray(n, e, i);
                }
                itemDescription(n) {
                    return n._inHorizontalTable ? 'row' : n.dataType === Ge_DATA_TYPE_SECTION ? 'section' : 'question';
                }
                _getScores(n, e) {
                    for (var i = [], r = this._getFormulaSourceItems(n, e.value), s = 0, o = r.length; s < o; s++) {
                        var a = 0;
                        (n = r[s]) &&
                            n.value &&
                            n.value.score &&
                            n._skipLogicStatus !== Ge_SKIP_LOGIC_STATUS_DISABLED &&
                            (a = n.value.score),
                            i.push(a);
                    }
                    return i;
                }
                _getFormulaSourceItems(n, e) {
                    for (var i = [], r = 0, s = e.length; r < s; r++) {
                        var a = this._findItemByLinkId(n, e[r]);
                        i.push(a);
                    }
                    return i;
                }
                _getValuesInStandardUnit(n, e) {
                    for (var i = [], r = this._getFormulaSourceItems(n, e.value), s = 0, o = r.length; s < o; s++) {
                        var a = null;
                        (n = r[s]).value &&
                            n._skipLogicStatus !== Ge_SKIP_LOGIC_STATUS_DISABLED &&
                            (a =
                                n.unit && n.unit.name
                                    ? Fre.getValueInStandardUnit(parseFloat(n.value), n.unit.name)
                                    : parseFloat(n.value)),
                            i.push(a);
                    }
                    return i;
                }
                getFormulaResult(n) {
                    var e = '',
                        i = [];
                    if (n.calculationMethod) {
                        var r = n.calculationMethod;
                        (i =
                            r.name === Ge_CALCULATION_METHOD_TOTALSCORE
                                ? this._getScores(n, r)
                                : this._getValuesInStandardUnit(n, r)),
                            (e = Rre.calculations_[r.name](i));
                    }
                    return e;
                }
                _processItemFormula(n) {
                    var e = !1;
                    if (n.calculationMethod && n.calculationMethod.name) {
                        let i = this.getFormulaResult(n);
                        Rt.deepEqual(i, n.value) || ((n.value = i), (e = !0));
                    }
                    return e;
                }
                _processItemDataControl(n) {
                    var e = !1;
                    return (
                        n.dataControl &&
                            Array.isArray(n.dataControl) &&
                            (e = this._updateDataByDataControl(n)) &&
                            (this._updateAutocompOptions(n), this._updateUnitAutocompOptions(n)),
                        e
                    );
                }
                _constructObjectByDataFormat(n, e) {
                    var i = {};
                    if ('object' == typeof n)
                        for (var r = Object.keys(n), s = 0, o = r.length; s < o; s++)
                            i[r[s]] = this._getDataFromNestedAttributes(n[r[s]], e);
                    return i;
                }
                _constructArrayByDataFormat(n, e) {
                    var i = [],
                        r = !1;
                    if ('object' == typeof n) {
                        for (var s = Object.keys(n), o = {}, a = s.length, l = -1, c = 0; c < a; c++) {
                            var f = (o[s[c]] = this._getDataFromNestedAttributes(n[s[c]], e));
                            if (!Array.isArray(f)) {
                                r = !0;
                                break;
                            }
                            if (-1 === l) l = f.length;
                            else if (l !== f.length) {
                                r = !0;
                                break;
                            }
                        }
                        if (!r)
                            for (var g = 0; g < l; g++) {
                                var E = {};
                                for (c = 0; c < a; c++) E[s[c]] = o[s[c]][g];
                                i.push(E);
                            }
                    }
                    return i;
                }
                _updateDataByDataControl(n) {
                    for (var e = !1, i = 0, r = n.dataControl.length; i < r; i++) {
                        var s = n.dataControl[i].source,
                            o = n.dataControl[i].onAttribute,
                            a = n.dataControl[i].construction,
                            l = n.dataControl[i].dataFormat;
                        if (
                            (o || (o = 'value'), a || (a = Ge_DATA_CONTROL_CONSTRUCTION_SIMPLE), l || (l = 'value'), s)
                        ) {
                            var c = s.sourceType;
                            if (
                                (c || (c = Ge_DATA_CONTROL_SOURCE_INTERNAL),
                                c === Ge_DATA_CONTROL_SOURCE_INTERNAL && s.sourceLinkId)
                            ) {
                                var f = this._findItemByLinkId(n, s.sourceLinkId);
                                if (f && f._skipLogicStatus !== Ge_SKIP_LOGIC_STATUS_DISABLED) {
                                    let g;
                                    a === Ge_DATA_CONTROL_CONSTRUCTION_ARRAY
                                        ? (g = this._constructArrayByDataFormat(l, f))
                                        : a === Ge_DATA_CONTROL_CONSTRUCTION_OBJECT
                                        ? (g = this._constructObjectByDataFormat(l, f))
                                        : a === Ge_DATA_CONTROL_CONSTRUCTION_SIMPLE &&
                                          (g = this._getDataFromNestedAttributes(l, f)),
                                        Rt.deepEqual(n[o], g) || ((n[o] = Rt.deepCopy(g)), (e = !0));
                                }
                            }
                        }
                    }
                    return e;
                }
                _getDataFromNestedAttributes(n, e) {
                    for (var i = n.trim().split('.'), r = e, s = i.length, o = 0; o < s && r; o++) {
                        var a = i[o];
                        if (!a) break;
                        var l = a.match(/^(.+)\[(\d+)\]$/);
                        if (l) {
                            r = r[l[1]];
                            var c = parseInt(l[2]);
                            if (!Number.isInteger(c)) break;
                            r = r[c];
                        } else r = r[a];
                    }
                    return o === s && r ? r : null;
                }
                _setUpAnswerAndUnitAutoComp(n) {
                    for (var e = 0, i = n.length; e < i; e++) {
                        var r = n[e];
                        r._hasAnswerList && this._updateAutocompOptions(r), this._updateUnitAutocompOptions(r);
                    }
                }
                _setUnitDisplay(n) {
                    n._displayUnit = n.name ? n.name : n.code ? n.code : null;
                }
                _updateUnitAutocompOptions(n) {
                    if (n.units && !n._hasAnswerList) {
                        n.unit && this._setUnitDisplay(n.unit), (n._unitAutocompOptions = null);
                        for (var r, e = [], i = n.units, s = 0, o = i.length; s < o; s++) {
                            var a = Rt.deepCopy(i[s]);
                            this._setUnitDisplay(a), i[s].default && (r = a), a._displayUnit && e.push(a);
                        }
                        if (
                            ((n.dataType === Ge_DATA_TYPE_INT || n.dataType === Ge_DATA_TYPE_REAL) &&
                                (n.units && n.units.length > 1
                                    ? (console.log(
                                          'Form definition warning: Data types of INT or REAL may only have one unit.  Question "' +
                                              n.question +
                                              '" has ' +
                                              n.units.length +
                                              ' units.  For multiple units, use type QTY instead.',
                                      ),
                                      (n.dataType = Ge_DATA_TYPE_QTY))
                                    : ((n._unitReadonly = !0), n.unit || (n.unit = e[0]))),
                            n.dataType === Ge_DATA_TYPE_QTY)
                        ) {
                            var l = {
                                listItems: e,
                                matchListValue:
                                    (n.units && (!n._unitOpen || 'optionsOrString' != n._unitOpen)) ||
                                    (!n.units && 'optionsOnly' == n._unitOpen),
                                autoFill: !0,
                                display: '_displayUnit',
                            };
                            void 0 !== r ? (l.defaultValue = r) : 1 === e.length && (l.defaultValue = e[0]),
                                Rt.deepEqual(n._unitAutocompOptions, l) || (n._unitAutocompOptions = l);
                        }
                    }
                }
                _resetItemValueWithAnswers(n) {
                    if (n._hasAnswerList) {
                        var e = null,
                            i = this.hasSavedData ? n.value : n.value || n.defaultAnswer;
                        if (i) {
                            e = [];
                            var r = n._multipleAnswers && Array.isArray(i) ? i : [i];
                            if ('optionsOrString' !== n.answerConstraint) e = r;
                            else
                                for (var s = 0, o = r.length; s < o; ++s)
                                    'string' == typeof r[s] || 'number' == typeof r[s]
                                        ? (e.push({ text: r[s], _notOnList: !0 }),
                                          (n._answerOther = r[s]),
                                          (n._answerOtherChecked = !0))
                                        : e.push(r[s]);
                        }
                        if (e) {
                            for (var a = [], l = 0, c = e.length; l < c; ++l) {
                                var f = e[l],
                                    g = !1;
                                if (n.externallyDefined) a = e;
                                else if (Array.isArray(n.answers)) {
                                    for (var E = 0, P = n.answers.length; !g && E < P; ++E)
                                        Rt.areTwoAnswersSame(f, n.answers[E], n) && (a.push(n.answers[E]), (g = !0));
                                    !g &&
                                        'optionsOrString' === n.answerConstraint &&
                                        f &&
                                        ((f._notOnList = !0), a.push(f));
                                } else a.push(f);
                            }
                            n.value = n._multipleAnswers ? a : a[0];
                        }
                    }
                }
                _fhirClientSearchByValueSetID(n, e, i) {
                    return LForms.fhirContext.client.request(
                        this._buildURL(['ValueSet', n, '$expand'], { count: i, filter: e }),
                    );
                }
                _findValueSetIDAndSearch(n, e, i) {
                    var r = 'Could not retrieve the ValueSet definition for ' + n.answerValueSet,
                        s = LForms.fhirContext.client;
                    LForms._valueSetUrlToID || (LForms._valueSetUrlToID = {});
                    var o = LForms._valueSetUrlToID[n.answerValueSet];
                    if (o) return this._fhirClientSearchByValueSetID(o, e, i);
                    {
                        const a = this;
                        return s
                            .request(this._buildURL(['ValueSet'], { url: n.answerValueSet, _total: 'accurate' }))
                            .then(
                                function (l) {
                                    if (1 === l.total) {
                                        var f = l.entry[0].resource.id;
                                        return (
                                            (LForms._valueSetUrlToID[n.answerValueSet] = f),
                                            a._fhirClientSearchByValueSetID(f, e, i)
                                        );
                                    }
                                    return console.log(r), Promise.reject(r);
                                },
                                function (l) {
                                    return console.log(r), Promise.reject(r);
                                },
                            );
                    }
                }
                _updateAutocompOptions(n) {
                    if (n._hasAnswerList) {
                        var e = n.answerCardinality ? n.answerCardinality.max : 1;
                        '*' !== e && 'string' == typeof e && (e = parseInt(e));
                        var i = {
                                matchListValue: 'optionsOrString' !== n.answerConstraint,
                                maxSelect: e,
                                autoFill: !1,
                            },
                            r = n.externallyDefined;
                        if (r) {
                            if (
                                ((i.url = r),
                                (i.autocomp = !0),
                                (i.nonMatchSuggestions = !1),
                                (i.tableFormat = !0),
                                (i.valueCols = [0]),
                                (i.colHeaders = n.displayControl.listColHeaders),
                                i.colHeaders)
                            )
                                for (var s = i.colHeaders, o = 0, a = s.length; o < a; ++o)
                                    s[o] = s[o].replace(/</g, '&lt;');
                        } else if (n.isSearchAutocomplete && n.answerValueSet) {
                            var c = this._getFHIRSupport().SDC._getExpansionURL(n);
                            if (c) (i.url = c), (i.fhir = !0);
                            else {
                                if (!LForms.fhirContext?.client)
                                    throw new Error(
                                        'Cannot properly initialize the list for field "' +
                                            n.question +
                                            '" because it requires either a terminology server to be specified or LForms.Util.setFHIRContext(...) to have been called to provide access to a FHIR server.',
                                    );
                                {
                                    const W = this;
                                    i.fhir = {
                                        search: function (ie, he) {
                                            return LForms.fhirCapabilities.urlExpandBroken
                                                ? W._findValueSetIDAndSearch(n, ie, he)
                                                : LForms.fhirContext.client
                                                      .request(
                                                          W._buildURL(['ValueSet', '$expand'], {
                                                              count: he,
                                                              filter: ie,
                                                              url: n.answerValueSet,
                                                          }),
                                                      )
                                                      .catch(
                                                          ze => (
                                                              (LForms.fhirCapabilities.urlExpandBroken = !0),
                                                              W._findValueSetIDAndSearch(n, ie, he)
                                                          ),
                                                      );
                                        },
                                    };
                                }
                            }
                        } else {
                            ([i.listItems, i.addSeqNum] = this._getAnswerDisplayTextWithLabelAndScore(
                                this.templateOptions.displayScoreWithAnswerText,
                                n,
                            )),
                                (i.display = '_displayText'),
                                (i.listItemsForModel = n.answers);
                            var f = i.listItems,
                                g = !0;
                            for (o = 0, a = f.length; o < a && g; ++o) g = !!f[o].parentAnswerCode;
                            if (!g) {
                                var E = [],
                                    P = {};
                                for (o = 0, a = f.length; o < a; ++o) {
                                    var V = f[o];
                                    E.push(V.code), V.parentAnswerCode && (P[V.code] = V.parentAnswerCode);
                                }
                                (i.codes = E), (i.itemToHeading = P);
                            }
                            if (
                                !n.displayControl ||
                                !n.displayControl.answerLayout ||
                                'RADIO_CHECKBOX' !== n.displayControl.answerLayout.type
                            ) {
                                i.isListHTML = f.some(W => 'html' === W._displayType);
                                for (let W = 0; W < f.length; ++W)
                                    'html' === f[W]._displayType
                                        ? (f[W]._displayText = f[W]._displayTextHTML)
                                        : 'escaped' === f[W]._displayType
                                        ? (f[W]._displayText = LForms.Util.escapeAttribute(f[W]._displayTextHTML))
                                        : i.isListHTML &&
                                          (f[W]._displayText = LForms.Util.escapeAttribute(f[W]._displayText));
                            }
                        }
                        Rt.deepEqual(i, n._autocompOptions) || (n._autocompOptions = i);
                    }
                }
                getTextDisplayType(n) {
                    var e = 'plain';
                    return (
                        n._displayTextHTML &&
                            n._displayTextHTML.length > 0 &&
                            this.templateOptions.allowHTML &&
                            (e = n._hasInvalidHtmlTag
                                ? this.templateOptions.displayInvalidHTML
                                    ? 'escaped'
                                    : 'plain'
                                : 'html'),
                        e
                    );
                }
                _getAnswerDisplayTextWithLabelAndScore(n, e) {
                    var i = [],
                        r = !1,
                        s = !1;
                    let o = e.answers;
                    if (o && Array.isArray(o))
                        for (var a = 0, l = o.length; a < l; a++) {
                            var c = Rt.deepCopy(o[a]),
                                f = c.text + '',
                                g = c.textHTML;
                            c.label
                                ? ((f = c.label + '. ' + f), (r = !0), g && (g = c.label + '. ' + g))
                                : !s && !isNaN(c.text) && (s = !0),
                                null != c.score &&
                                    ((e._hasScoreInAnswer = !0),
                                    n && ((f = f + ' - ' + c.score), g && (g = g + ' - ' + c.score))),
                                (c._displayText = f),
                                (c._displayTextHTML = g),
                                (c._displayType = this.getTextDisplayType(c)),
                                i.push(c);
                        }
                    return [i, !r && !s];
                }
                _inRange(n, e) {
                    var i = !1;
                    if (n && !isNaN(e)) {
                        var r = Object.keys(n);
                        if (1 == r.length)
                            switch (r[0]) {
                                case 'minInclusive':
                                    i = n.minInclusive <= e;
                                    break;
                                case 'minExclusive':
                                    i = n.minExclusive < e;
                                    break;
                                case 'maxInclusive':
                                    i = n.maxInclusive >= e;
                                    break;
                                case 'maxExclusive':
                                    i = n.maxExclusive > e;
                            }
                        else
                            2 == r.length &&
                                (n.hasOwnProperty('minInclusive')
                                    ? (i = n.minInclusive <= e)
                                    : n.hasOwnProperty('minExclusive') && (i = n.minExclusive < e),
                                i &&
                                    (n.hasOwnProperty('maxInclusive')
                                        ? (i = n.maxInclusive >= e)
                                        : n.hasOwnProperty('maxExclusive') && (i = n.maxExclusive > e)));
                    }
                    return i;
                }
                _objectEqual(n, e) {
                    return Rt.shallowEqual(n, e);
                }
                _findItemByLinkId(n, e) {
                    for (var i = null, r = n._parentItem, s = !1; !s && r; )
                        r.linkId === e && ((i = r), (s = !0)), (r = r._parentItem);
                    var o = null;
                    if (!i) {
                        for (var a = 0, l = this.itemList.length; a < l; a++)
                            if (n._elementId === this.itemList[a]._elementId) {
                                o = a;
                                break;
                            }
                        if (null !== o) {
                            for (var c = o - 1; c >= 0; c--)
                                if (this.itemList[c].linkId === e) {
                                    i = this.itemList[c];
                                    break;
                                }
                            if (!i)
                                for (var f = o + 1, g = this.itemList.length; f < g; f++)
                                    if (this.itemList[f].linkId === e) {
                                        i = this.itemList[f];
                                        break;
                                    }
                        }
                    }
                    return i;
                }
                _getSkipLogicSourceItem(n, e) {
                    return this._findItemByLinkId(n, e);
                }
                _codingsEqual(n, e) {
                    let i = !1,
                        r = s => null != s && '' !== s;
                    return (
                        (n.system === e.system || (!n.system && !e.system)) &&
                            (i = r(n.code) || r(e.code) ? n.code === e.code : n.text && e.text && n.text === e.text),
                        !!i
                    );
                }
                _checkSkipLogicCondition(n, e) {
                    var i = !1,
                        r =
                            n &&
                            null != n.value &&
                            '' !== n.value &&
                            n._skipLogicStatus !== Ge_SKIP_LOGIC_STATUS_DISABLED;
                    if (e.hasOwnProperty('exists')) i = (e.exists && r) || (!e.exists && !r);
                    else if (r) {
                        var s = n.value;
                        if (n._hasAnswerList)
                            switch (n.dataType) {
                                case Ge_DATA_TYPE_CODING:
                                case Ge_DATA_TYPE_INT:
                                case Ge_DATA_TYPE_ST:
                                case Ge_DATA_TYPE_DT:
                                case Ge_DATA_TYPE_TM:
                                    for (
                                        var o = e.hasOwnProperty('value')
                                                ? e.value
                                                : e.hasOwnProperty('notEqual')
                                                ? e.notEqual
                                                : null,
                                            a = Array.isArray(s) ? s : [s],
                                            l = !1,
                                            c = 0,
                                            f = a.length;
                                        c < f;
                                        c++
                                    ) {
                                        let E = a[c];
                                        if (n.dataType === Ge_DATA_TYPE_CODING) {
                                            if (
                                                (n.answerCodeSystem &&
                                                    (E = Object.assign({ system: n.answerCodeSystem }, E)),
                                                this._codingsEqual(o, E))
                                            ) {
                                                l = !0;
                                                break;
                                            }
                                        } else if (o === E.text) {
                                            l = !0;
                                            break;
                                        }
                                    }
                                    e.hasOwnProperty('value')
                                        ? l && (i = !0)
                                        : e.hasOwnProperty('notEqual') && (l || (i = !0));
                            }
                        else
                            switch (n.dataType) {
                                case Ge_DATA_TYPE_INT:
                                case Ge_DATA_TYPE_REAL:
                                case Ge_DATA_TYPE_QTY:
                                    var g = parseFloat(s);
                                    e.hasOwnProperty('value')
                                        ? e.value === g && (i = !0)
                                        : e.hasOwnProperty('notEqual')
                                        ? e.notEqual != g && (i = !0)
                                        : this._inRange(e, g) && (i = !0);
                                    break;
                                case Ge_DATA_TYPE_ST:
                                case Ge_DATA_TYPE_TX:
                                case Ge_DATA_TYPE_BL:
                                    e.hasOwnProperty('value')
                                        ? e.value === s && (i = !0)
                                        : e.hasOwnProperty('notEqual') && e.notEqual != s && (i = !0);
                            }
                    } else e.hasOwnProperty('notEqual') && null != e.notEqual && '' !== e.notEqual && (i = !0);
                    return i;
                }
                _checkSkipLogic(n) {
                    var e = !1;
                    if (n.skipLogic) {
                        var i = 'ALL' === n.skipLogic.logic,
                            r = !n.skipLogic.logic || 'ANY' === n.skipLogic.logic;
                        e = i;
                        for (var s = 0, o = n.skipLogic.conditions.length; s < o; s++) {
                            var a = n.skipLogic.conditions[s],
                                l = this._getSkipLogicSourceItem(n, a.source),
                                c = this._checkSkipLogicCondition(l, a.trigger);
                            if (i && !c) {
                                e = !1;
                                break;
                            }
                            if (r && c) {
                                e = !0;
                                break;
                            }
                        }
                    }
                    return e;
                }
                getSkipLogicClass(n) {
                    return n._skipLogicStatus;
                }
                needExtra(n) {
                    var e = !1;
                    return n && n.value && !Array.isArray(n.value) && n.value.other && (e = !0), e;
                }
                setActiveRow(n) {
                    this._activeItem = n;
                }
                getActiveRowClass(n) {
                    var e = '';
                    return (
                        this._activeItem && this._activeItem._elementId === n._elementId && (e = 'lhc-active-row'), e
                    );
                }
            }
            const Vre = {
                LOINC_URI: 'http://loinc.org',
                LOINC_CS: 'LN',
                obrFieldNum: 43,
                obxFieldNum: 17,
                DataType: {
                    ST: 'String',
                    TX: 'Text data',
                    FT: 'Formatted text',
                    CQ: 'Composite quantity with units',
                    MO: 'Money',
                    NM: 'Numeric',
                    SI: 'Sequence ID',
                    SN: 'Structured numeric',
                    ID: 'Coded values for HL7 tables',
                    IS: 'Coded values for user-defined tables',
                    HD: 'Hierarchic designator',
                    EI: 'Entity identifier',
                    RP: 'Reference pointer',
                    PL: 'Person location',
                    PT: 'Processing type',
                    DT: 'Date',
                    DTM: 'Date/Time',
                    TM: 'Time',
                    TS: 'Time stamp',
                    CE: 'Coded element',
                    CF: 'Coded element with formatted values',
                    CK: 'Composite ID with check digit',
                    CN: 'Composite ID number and name',
                    CX: 'Extended composite ID with check digit',
                    XCN: 'Extended composite ID number and name',
                    CM: 'Composite',
                    AD: 'Address',
                    PN: 'Person name',
                    TN: 'Telephone number',
                    XAD: 'Extended address',
                    XPN: 'Extended person name',
                    XON: 'Extended composite name and ID number for organizations',
                    XTN: 'Extended telecommunications number',
                    CD: 'Channel definition',
                    MA: 'Multiplexed array',
                    NA: 'Numeric array',
                    ED: 'Encapsulated data',
                    CP: 'Composite price',
                    FC: 'Financial class',
                    QSC: 'Query selection criteria',
                    QIP: 'Query input parameter list',
                    RCD: 'Row column definition',
                    DLN: 'Driver\u2019s license number',
                    JCC: 'Job code/class',
                    VH: 'Visiting hours',
                    PPN: 'Performing person time stamp',
                    DR: 'Date/time range',
                    RI: 'Repeat interval',
                    SCV: 'Scheduling class value pair',
                    TQ: 'Timing/quantity',
                },
                delimiters: {
                    segment: '\r',
                    field: '|',
                    component: '^',
                    subcomponent: '&',
                    repetition: '~',
                    escape: '\\',
                },
                OBX: [
                    { seq: 1, len: 4, dt: 'SI', opt: 'O', name: 'Set ID' },
                    { seq: 2, len: 2, dt: 'ID', opt: 'R', name: 'Value Type' },
                    { seq: 3, len: 590, dt: 'CE', opt: 'R', name: 'Observation Identifier' },
                    { seq: 4, len: 20, dt: 'ST', opt: 'O', name: 'Observation Sub-ID' },
                    { seq: 5, len: 65536, dt: 'ST', opt: 'O', name: 'Observation Value' },
                    { seq: 6, len: 60, dt: 'CE', opt: 'O', name: 'Units' },
                    { seq: 7, len: 10, dt: 'ST', opt: 'O', name: 'Reference Range' },
                    { seq: 8, len: 5, dt: 'ID', opt: 'O', name: 'Abnormal Flags' },
                    { seq: 9, len: 5, dt: 'NM', opt: 'O', name: 'Probability' },
                    { seq: 10, len: 2, dt: 'ID', opt: 'O', name: 'Nature of Abnormal Test' },
                    { seq: 11, len: 1, dt: 'ID', opt: 'R', name: 'Observation Result Status' },
                    { seq: 12, len: 26, dt: 'TS', opt: 'O', name: 'Date Last Obs Normal Values' },
                    { seq: 13, len: 20, dt: 'ST', opt: 'O', name: 'User Defined Access Checks' },
                    { seq: 14, len: 26, dt: 'TS', opt: 'O', name: 'Date/Time of the Observation' },
                    { seq: 15, len: 60, dt: 'CE', opt: 'O', name: "Producer's ID" },
                    { seq: 16, len: 80, dt: 'XCN', opt: 'O', name: 'Responsible Observer' },
                    { seq: 17, len: 80, dt: 'CE', opt: 'O', name: 'Observation Method' },
                ],
                OBR: [
                    { seq: 1, len: 4, dt: 'SI', opt: 'C', name: 'Set ID - OBR' },
                    { seq: 2, len: 75, dt: 'EI', opt: 'C', name: 'Placer Order Number' },
                    { seq: 3, len: 75, dt: 'EI', opt: 'C', name: 'Filler Order Number' },
                    { seq: 4, len: 200, dt: 'CE', opt: 'R', name: 'Universal Service ID' },
                    { seq: 5, len: 2, dt: 'ID', opt: 'B', name: 'Priority' },
                    { seq: 6, len: 26, dt: 'TS', opt: 'B', name: 'Requested Date/time' },
                    { seq: 7, len: 26, dt: 'TS', opt: 'C', name: 'Observation Date/Time' },
                    { seq: 8, len: 26, dt: 'TS', opt: 'O', name: 'Observation End Date/Time' },
                    { seq: 9, len: 20, dt: 'CQ', opt: 'O', name: 'Collection Volume' },
                    { seq: 10, len: 60, dt: 'XCN', opt: 'O', name: 'Collector Identifier' },
                    { seq: 11, len: 1, dt: 'ID', opt: 'O', name: 'Specimen Action Code' },
                    { seq: 12, len: 60, dt: 'CE', opt: 'O', name: 'Danger Code' },
                    { seq: 13, len: 300, dt: 'ST', opt: 'O', name: 'Relevant Clinical Info.' },
                    { seq: 14, len: 26, dt: 'TS', opt: 'C', name: 'Specimen Received Date/Time' },
                    { seq: 15, len: 300, dt: 'CM', opt: 'O', name: 'Specimen Source' },
                    { seq: 16, len: 80, dt: 'XCN', opt: 'O', name: 'Ordering Provider' },
                    { seq: 17, len: 40, dt: 'XTN', opt: 'O', name: 'Order Callback Phone Number' },
                    { seq: 18, len: 60, dt: 'ST', opt: 'O', name: 'Placer field 1' },
                    { seq: 19, len: 60, dt: 'ST', opt: 'O', name: 'Placer field 2' },
                    { seq: 20, len: 60, dt: 'ST', opt: 'O', name: 'Filler Field 1' },
                    { seq: 21, len: 60, dt: 'ST', opt: 'O', name: 'Filler Field 2' },
                    { seq: 22, len: 26, dt: 'TS', opt: 'C', name: 'Results Rpt/Status Chng - Date/Time' },
                    { seq: 23, len: 40, dt: 'CM', opt: 'O', name: 'Charge to Practice' },
                    { seq: 24, len: 10, dt: 'ID', opt: 'O', name: 'Diagnostic Serv Sect ID' },
                    { seq: 25, len: 1, dt: 'ID', opt: 'C', name: 'Result Status' },
                    { seq: 26, len: 400, dt: 'CM', opt: 'O', name: 'Parent Result' },
                    { seq: 27, len: 200, dt: 'TQ', opt: 'O', name: 'Quantity/Timing' },
                    { seq: 28, len: 150, dt: 'XCN', opt: 'O', name: 'Result Copies To' },
                    { seq: 29, len: 150, dt: 'CM', opt: 'O', name: 'Parent' },
                    { seq: 30, len: 20, dt: 'ID', opt: 'O', name: 'Transportation Mode' },
                    { seq: 31, len: 300, dt: 'CE', opt: 'O', name: 'Reason for Study' },
                    { seq: 32, len: 200, dt: 'CM', opt: 'O', name: 'Principal Result Interpreter' },
                    { seq: 33, len: 200, dt: 'CM', opt: 'O', name: 'Assistant Result Interpreter' },
                    { seq: 34, len: 200, dt: 'CM', opt: 'O', name: 'Technician' },
                    { seq: 35, len: 200, dt: 'CM', opt: 'O', name: 'Transcriptionist' },
                    { seq: 36, len: 26, dt: 'TS', opt: 'O', name: 'Scheduled Date/Time' },
                    { seq: 37, len: 4, dt: 'NM', opt: 'O', name: 'Number of Sample Containers' },
                    { seq: 38, len: 60, dt: 'CE', opt: 'O', name: 'Transport Logistics of Collected Sample' },
                    { seq: 39, len: 200, dt: 'CE', opt: 'O', name: 'Collector\u2019s Comment' },
                    { seq: 40, len: 60, dt: 'CE', opt: 'O', name: 'Transport Arrangement Responsibility' },
                    { seq: 41, len: 30, dt: 'ID', opt: 'O', name: 'Transport Arranged' },
                    { seq: 42, len: 1, dt: 'ID', opt: 'O', name: 'Escort Required' },
                    { seq: 43, len: 200, dt: 'CE', opt: 'O', name: 'Planned Patient Transport Comment' },
                ],
                getHL7V2DataType: function (t) {
                    var e,
                        n = t.dataType;
                    switch (n) {
                        case 'INT':
                        case 'REAL':
                        case 'QTY':
                            e = 'NM';
                            break;
                        case 'NR':
                        case 'TX':
                        case 'DT':
                        case 'DTM':
                        case 'TM':
                            e = n;
                            break;
                        case 'CODING':
                            t.answerConstraint && 'optionsOnly' !== t.answerConstraint
                                ? 'optionsOrString' === t.answerConstraint && (e = 'CWE')
                                : (e = 'CNE');
                            break;
                        default:
                            e = 'ST';
                    }
                    return e;
                },
                toHL7Segments: function (t) {
                    var n = '',
                        e = { obrIndex: 1, obxIndex: 1 },
                        i = t.getFormData(!1, !0);
                    this._generateOBX4(i);
                    var r = new Array(this.obrFieldNum);
                    (r[0] = 'OBR'),
                        (r[1] = '1'),
                        (r[4] =
                            i.code + this.delimiters.component + i.name + this.delimiters.component + this.LOINC_CS);
                    for (var o = this.obrFieldNum - 1; o >= 0; o--)
                        void 0 === r[o] ||
                            (void 0 !== r[o] ? (n = r[o] + this.delimiters.field + n) : (n += this.delimiters.field));
                    if (((n += this.delimiters.segment), i.items))
                        for (var l = 0, c = i.items.length; l < c; l++)
                            'TITLE' !== i.items[l].dataType && (n += this._itemToHL7v2(i.items[l], e));
                    return n;
                },
                _generateOBX4: function (t) {
                    t && t.items && this._precessOBX4AtOneLevel('', t.items);
                },
                _precessOBX4AtOneLevel: function (t, n) {
                    for (var e = 0, i = 1, r = null, s = 0, o = n.length; s < o; s++) {
                        var l,
                            a = n[s];
                        if ('SECTION' === a.dataType)
                            if ((l = a.questionCardinality.max) && ('*' === l || parseInt(l) > 1)) {
                                if (this._isSectionEmpty(a)) continue;
                                !r || (r && r.questionCode !== a.questionCode) ? ((i = 1), (e += 1)) : (i += 1);
                                var c = Rt.getNextLetter(i);
                                (a._obx4 = t ? t + '.' + e + c : e + c), this._precessOBX4AtOneLevel(a._obx4, a.items);
                            } else
                                (i = 1),
                                    (e += 1),
                                    (a._obx4 = t ? t + '.' + e : e),
                                    this._precessOBX4AtOneLevel(a._obx4, a.items);
                        else if ((l = a.questionCardinality.max) && ('*' === l || parseInt(l) > 1)) {
                            if (Co.isItemValueEmpty(a.value)) continue;
                            !r || (r && r.questionCode !== a.questionCode) ? (i = 1) : (i += 1),
                                (c = Rt.getNextLetter(i)),
                                (a._obx4 = t ? t + '.' + c : c);
                        } else (a._obx4 = t || ''), (i = 1);
                        r = a;
                    }
                },
                _generateOBX5: function (t, n, e) {
                    var r = t.code;
                    return 'CWE' !== n || r || 0 === r
                        ? r +
                              this.delimiters.component +
                              t.text +
                              this.delimiters.component +
                              (t.system
                                  ? 'LOINC' === t.system || t.system === this.LOINC_URI
                                      ? this.LOINC_CS
                                      : t.system
                                  : '')
                        : this.delimiters.component.repeat(8) + t.text;
                },
                _DT_FMT: 'YYYYMMDD',
                _DTM_FMT: 'YYYYMMDDHHmmss',
                _itemToHL7v2: function (t, n) {
                    var e = '',
                        i = this.LOINC_CS;
                    if ('TITLE' !== t.dataType) {
                        var r = new Array(this.obrFieldNum);
                        if (t.header) {
                            var s = '';
                            (r[0] = 'OBR'),
                                (r[1] = ++n.obrIndex),
                                (r[4] =
                                    t.questionCode +
                                    this.delimiters.component +
                                    t.question +
                                    this.delimiters.component +
                                    i);
                            for (var a = this.obrFieldNum - 1; a >= 0; a--)
                                void 0 === r[a] ||
                                    (void 0 !== r[a]
                                        ? (s = r[a] + this.delimiters.field + s)
                                        : (s += this.delimiters.field));
                            if (((s += this.delimiters.segment), t.items))
                                for (var c = 0, f = t.items.length; c < f; c++) e += this._itemToHL7v2(t.items[c], n);
                        } else if (!Co.isItemValueEmpty(t.value)) {
                            var g = Array.isArray(t.value),
                                E = g ? t.value : [t.value],
                                P = this.getHL7V2DataType(t),
                                V = [];
                            if (
                                ((V[0] = 'OBX'),
                                (V[1] = n.obxIndex++),
                                (V[2] = P),
                                (V[3] =
                                    t.questionCode +
                                    this.delimiters.component +
                                    t.question +
                                    this.delimiters.component +
                                    i),
                                t.unit)
                            ) {
                                var W = '';
                                void 0 !== t.unit.name && (W = t.unit.name),
                                    (V[6] =
                                        W + this.delimiters.component + W + this.delimiters.component + this.LOINC_CS);
                            }
                            a = 0;
                            for (var ie = E.length; a < ie; ++a) {
                                var he = E[a];
                                if (
                                    ((V[4] = t._obx4),
                                    g && ('' !== t._obx4 && (V[4] += '.'), (V[4] += Rt.getNextLetter(a + 1))),
                                    'CNE' === P || 'CWE' === P)
                                )
                                    V[5] = this._generateOBX5(he, P);
                                else if ('DT' === t.dataType || 'DTM' === t.dataType) {
                                    var fe = 'string' == typeof he ? Rt.stringToDate(he) : he;
                                    V[5] = Rt.formatDate(fe, 'DT' === t.dataType ? this._DT_FMT : this._DTM_FMT);
                                } else V[5] = he.toString();
                                e += V.join(this.delimiters.field) + this.delimiters.field + this.delimiters.segment;
                            }
                        }
                    }
                    return e;
                },
                _isSectionEmpty: function (t) {
                    var n = !0;
                    if (t.items)
                        for (var e = 0, i = t.items.length; e < i && n; e++) {
                            var r = t.items[e];
                            n =
                                'SECTION' === r.dataType
                                    ? !0 === r._emptySection || !1 === r._emptySection
                                        ? r._emptySection
                                        : this._isSectionEmpty(r)
                                    : Co.isItemValueEmpty(r.value);
                        }
                    return (t._emptySection = n), n;
                },
            };
            var Hre = U(3224),
                Ak = U.n(Hre);
            (window.LForms = { externalJQuery: window.jQuery, jQuery: Ak() }), (window.jQuery = Ak());
            var Ure = U(9339),
                f3 = U.n(Ure),
                Bre = U(4527);
            const da = window.LForms;
            (da.LFormsData = Ik),
                (da.HL7 = Vre),
                (da.ucumPkg = Xne),
                (da.Util = Co),
                (da.Def = f3()),
                (da.Validations = h3),
                (da.lformsVersion = '36.7.2'),
                (da.Util.FHIRSupport = Bre),
                da.externalJQuery ? (window.jQuery = da.externalJQuery) : delete window.jQuery,
                delete da.externalJQuery;
            class qre {
                constructor(n) {
                    if (((this.logID = n), void 0 === n)) {
                        n = 'reader_log';
                        let e = document.getElementById(n);
                        e
                            ? (this.logElement = e)
                            : ((this.logElement = document.createElement('div')),
                              this.logElement.setAttribute('id', n),
                              document.body.appendChild(this.logElement));
                    } else this.logElement = document.getElementById(n);
                    this.logElement.setAttribute('aria-live', 'assertive'),
                        this.logElement.setAttribute('aria-relevant', 'additions'),
                        this.logElement.setAttribute('role', 'log'),
                        this.logElement.setAttribute('class', 'screen_reader_only');
                }
                add(n) {
                    let e = document.createElement('p');
                    e.appendChild(document.createTextNode(n)), this.logElement.appendChild(e);
                }
            }
            class Xi {
                constructor() {
                    this.srLog = new qre();
                }
                getLhcFormData() {
                    return this.lhcFormData;
                }
                setLhcFormData(n) {
                    this.lhcFormData = n;
                }
                setActiveRow(n) {
                    this.lhcFormData &&
                        n &&
                        (this.lhcFormData.setActiveRow(n),
                        n._validationErrors &&
                            n._validationErrors.forEach(e => {
                                this.sendMsgToScreenReader(`${n.question} ${e}`);
                            }));
                }
                activeRowOnBlur(n) {
                    n._visitedBefore
                        ? (n._showValidation = !1)
                        : ((n._showValidation = !0),
                          setTimeout(() => {
                              (n._showValidation = !1), (n._visitedBefore = !0);
                          }, window.LForms.Validations._timeout));
                }
                getActiveRowClass(n) {
                    return this.lhcFormData.getActiveRowClass(n);
                }
                getSkipLogicClass(n) {
                    return this.lhcFormData.getSkipLogicClass(n);
                }
                getTableColumnStyle(n) {
                    var e = {};
                    if (n.displayControl && Array.isArray(n.displayControl.colCSS))
                        for (var i = n.displayControl.colCSS, r = 0, s = i.length; r < s; r++) {
                            var o = i[r];
                            e[o.name] = o.value;
                        }
                    return e;
                }
                getItemStyle(n) {
                    var e = {};
                    if (n.displayControl && Array.isArray(n.displayControl.css))
                        for (var i = 0, r = n.displayControl.css.length; i < r; i++) {
                            var s = n.displayControl.css[i];
                            e[s.name] = s.value;
                        }
                    return e;
                }
                hasOneRepeatingItem(n) {
                    return !(this.lhcFormData.getRepeatingItemCount(n) > 1);
                }
                hasOneRepeatingRow(n) {
                    var e = !1,
                        i = this.lhcFormData._horizontalTableInfo[n._codePath + n._parentIdPath_];
                    return i && i.tableRows && 1 === i.tableRows.length && (e = !0), e;
                }
                getTextDisplayType(n) {
                    return this.lhcFormData?.getTextDisplayType(n) || 'plain';
                }
                getCodingInstructionsDisplayType(n) {
                    var e = '';
                    if (n.codingInstructions && n.codingInstructions.length > 0) {
                        if (this.lhcFormData.templateOptions.allowHTML && 'html' === n.codingInstructionsFormat) {
                            var r = 'html';
                            n.codingInstructionsHasInvalidHtmlTag &&
                                (r = this.lhcFormData.templateOptions.displayInvalidHTML ? 'escaped' : 'plain');
                        } else r = 'escaped';
                        e = (this.lhcFormData.templateOptions.showCodingInstruction ? 'inline' : 'popover') + '-' + r;
                    }
                    return e;
                }
                checkUnits(n) {
                    return !!(n._unitAutocompOptions || (n._unitReadonly && n.unit && n.unit._displayUnit));
                }
                targetEnabled(n) {
                    return !!this.lhcFormData && $i.targetEnabled(n);
                }
                targetDisabledAndProtected(n) {
                    return !!this.lhcFormData && $i.targetDisabledAndProtected(n);
                }
                targetShown(n) {
                    return !!this.lhcFormData && $i.targetShown(n);
                }
                getRepeatingSN(n) {
                    var e = '';
                    return n._questionRepeatable && (e = n._idPath.slice(1).replace(/\//g, '.')), e;
                }
                getItemAnswerId(n, e) {
                    return (n._elementId + (e.code || e.text)).replace(/\s+/g, '');
                }
                getSiblingStatus(n) {
                    var e = '';
                    return n._lastSibling && (e += 'lhc-last-item'), n._firstSibling && (e += ' lhc-first-item'), e;
                }
                getTreeLineClass() {
                    const n = this.getLhcFormData().templateOptions;
                    return n.hideTreeLine || n.hideIndentation ? '' : 'lhc-tree-line';
                }
                getIndentationClass() {
                    return this.getLhcFormData().templateOptions.hideIndentation ? '' : 'lhc-indentation';
                }
                getItemClassList(n, e) {
                    return [
                        'lhc-item',
                        this.getItemViewModeClass(n, e),
                        this.getTreeLineClass(),
                        this.getIndentationClass(),
                        this.getSiblingStatus(n),
                        this.getRowClass(n),
                        this.getActiveRowClass(n),
                    ].join(' ');
                }
                isHideRepetitionNumber() {
                    return this.getLhcFormData().templateOptions.hideRepetitionNumber;
                }
                getRowClass(n) {
                    var e = ' lhc-datatype-' + n.dataType;
                    return (
                        n._answerRequired && (e += ' lf-answer-required'),
                        (e += n.header ? ' lhc-item-group' : ' lhc-item-question'),
                        (!n.question || 0 === n.question.length) && (e += ' lf-empty-question'),
                        n._visitedBefore && (e += ' lhc-visited-before'),
                        n._showValidation && (e += ' lhc-show-validation'),
                        n._isHiddenFromView && (e += ' lhc-hidden-from-view'),
                        this.targetDisabledAndProtected(n) && (e += ' lhc-item-disabled-protected'),
                        Array.isArray(n._validationErrors) && n._validationErrors.length > 0 && (e += ' lhc-invalid'),
                        e
                    );
                }
                getViewModeClass(n) {
                    let e,
                        i = this.lhcFormData?.templateOptions?.viewMode;
                    switch (((!i || 'auto' === i) && (i = n), i)) {
                        case 'lg':
                        default:
                            e = 'lhc-view-lg';
                            break;
                        case 'md':
                            e = 'lhc-view-md';
                            break;
                        case 'sm':
                            e = 'lhc-view-sm';
                    }
                    return e;
                }
                getItemViewModeClass(n, e) {
                    let i,
                        r = '';
                    if (n)
                        switch (
                            ((i =
                                n.displayControl && n.displayControl.viewMode
                                    ? n.displayControl.viewMode
                                    : this.lhcFormData.templateOptions.viewMode),
                            (!i || 'auto' === i) && (i = e),
                            i)
                        ) {
                            case 'lg':
                            default:
                                r = 'lhc-item-view-lg';
                                break;
                            case 'md':
                                r = 'lhc-item-view-md';
                                break;
                            case 'sm':
                                r = 'lhc-item-view-sm';
                        }
                    return r;
                }
                addOneRepeatingItem(n, e) {
                    var i = !1;
                    this.lhcFormData &&
                        !this.lhcFormData.templateOptions.allowMultipleEmptyRepeatingItems &&
                        (i = this.lhcFormData.areAnyRepeatingItemsEmpty(n)) &&
                        n._showUnusedItemWarning &&
                        (n._unusedItemWarning ||
                            (n._unusedItemWarning = window.lhcTranslationsFn('enterInfoBlank') + n._text + '"')),
                        i ||
                            (e ? this.lhcFormData.appendRepeatingItems(n) : this.lhcFormData.addRepeatingItems(n),
                            this.sendActionsToScreenReader());
                }
                removeOneRepeatingItem(n) {
                    var e = this.lhcFormData.getNextRepeatingItem(n),
                        i = '';
                    if (e)
                        i =
                            2 === this.lhcFormData.getRepeatingItemCount(n)
                                ? 'add-' + e._elementId
                                : 'del-' + e._elementId;
                    else {
                        var r = this.lhcFormData.getPrevRepeatingItem(n);
                        r && (i = 'add-' + r._elementId);
                    }
                    this.lhcFormData.removeRepeatingItems(n),
                        this.sendActionsToScreenReader(),
                        setTimeout(function () {
                            var s = document.getElementById(i);
                            s && s.focus();
                        }, 1);
                }
                hideUnusedItemWarning(n) {
                    this.lhcFormData &&
                        !this.lhcFormData.templateOptions.allowMultipleEmptyRepeatingItems &&
                        (n._showUnusedItemWarning = !1);
                }
                getHorizontalTableInfo() {
                    return this.lhcFormData._horizontalTableInfo;
                }
                trackByElementId(n, e) {
                    return e._elementId;
                }
                trackByRowHeaderElementId(n, e) {
                    return e.header._elementId;
                }
                trackByColumnHeaderId(n, e) {
                    return e.id;
                }
                isSubsequentHorizontalTableGroupItem(n) {
                    return (
                        n &&
                        n.displayControl &&
                        'horizontal' === n.displayControl.questionLayout &&
                        !n._horizontalTableHeader
                    );
                }
                sendMsgToScreenReader(n) {
                    this.srLog.add(n);
                }
                sendActionsToScreenReader() {
                    this.lhcFormData &&
                        this.lhcFormData._actionLogs.length > 0 &&
                        (this.lhcFormData._actionLogs.forEach(n => {
                            this.srLog.add(n);
                        }),
                        (this.lhcFormData._actionLogs = []));
                }
                isFormReady() {
                    return !!this.lhcFormData._formReady;
                }
                onItemValueChange(n, e, i, r = !1) {
                    this.lhcFormData &&
                        (r || (!r && !Rt.deepEqual(e, i))) &&
                        (this.lhcFormData.updateOnSourceItemChange(n), this.sendActionsToScreenReader());
                }
            }
            let Sh = (() => {
                class t {
                    constructor(e) {
                        this.sanitized = e;
                    }
                    transform(e, ...i) {
                        return this.sanitized.bypassSecurityTrustHtml(e);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(V4, 16));
                    });
                    static #t = (this.ɵpipe = jr({ name: 'safeHtml', type: t, pure: !0 }));
                }
                return t;
            })();
            function Yre(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 10),
                        bi('nzPopoverVisibleChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.item._showUnusedItemWarning, r) || (s.item._showUnusedItemWarning = r), pe(r);
                        }),
                        Le('click', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.addOneRepeatingItem(r.item, r.append));
                        })('blur', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.hideUnusedItemWarning(r.item));
                        }),
                        Je(1),
                        ee();
                }
                if (2 & t) {
                    const e = L(),
                        i = ts(7);
                    Bt('aria-controls', 'add-button-', e.item._elementId, ''),
                        Bt('aria-label', 'add button for ', e.item.question, ''),
                        Bt('aria-describedby', 'add-button-', e.item._elementId, ''),
                        Mn('id', 'add-', e.item._elementId, ''),
                        Mn(
                            'nzPopoverOverlayClassName',
                            'lhc-warning-class',
                            e.item._elementId.replaceAll('/', '-'),
                            '',
                        ),
                        H('disabled', e.item._readOnly),
                        yi('nzPopoverVisible', e.item._showUnusedItemWarning),
                        H('nzPopoverContent', i)('nzPopoverTrigger', e.click),
                        z(),
                        jn(' ', e.buttonLabel, ' ');
                }
            }
            function jre(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 11),
                        Gn(1, 'transloco'),
                        Le('click', function () {
                            me(e);
                            const r = L();
                            return pe(r.onShowingPopover(r.item));
                        }),
                        Oe(2, 'i', 12),
                        ee();
                }
                if (2 & t) {
                    const e = L(),
                        i = ts(13);
                    Bt('aria-controls', 'help-content-', e.item._elementId, ''),
                        Bt('aria-label', 'Help button for ', e.item.question, ''),
                        Bt('aria-describedby', 'help-button-', e.item._elementId, ''),
                        Mn('id', 'help-button-', e.item._elementId, ''),
                        Mn(
                            'nzPopoverOverlayClassName',
                            'lhc-popover-help lhc-help',
                            e.item._elementId.replaceAll('/', '-'),
                            '',
                        ),
                        H('nzPopoverContent', i)('nzPopoverTitle', ci(1, 12, 'Instruction'));
                }
            }
            function $re(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 13),
                        Le('click', function () {
                            me(e);
                            const r = L();
                            return pe(r.onShowingPopover(r.item));
                        }),
                        Oe(1, 'i', 12),
                        ee();
                }
                if (2 & t) {
                    const e = L(),
                        i = ts(9);
                    Bt('aria-controls', 'help-content-', e.item._elementId, ''),
                        Bt('aria-label', 'Help button for ', e.item.question, ''),
                        Bt('aria-describedby', 'help-button-', e.item._elementId, ''),
                        Mn('id', 'help-button-', e.item._elementId, ''),
                        Mn(
                            'nzPopoverOverlayClassName',
                            'lhc-popover-help lhc-help',
                            e.item._elementId.replaceAll('/', '-'),
                            '',
                        ),
                        H('nzPopoverContent', i);
                }
            }
            function Gre(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 13),
                        Le('click', function () {
                            me(e);
                            const r = L();
                            return pe(r.onShowingPopover(r.item));
                        }),
                        Oe(1, 'i', 12),
                        ee();
                }
                if (2 & t) {
                    const e = L(),
                        i = ts(11);
                    Bt('aria-controls', 'help-content-', e.item._elementId, ''),
                        Bt('aria-label', 'Help button for ', e.item.question, ''),
                        Bt('aria-describedby', 'help-button-', e.item._elementId, ''),
                        Mn('id', 'help-button-', e.item._elementId, ''),
                        Mn(
                            'nzPopoverOverlayClassName',
                            'lhc-popover-help lhc-help',
                            e.item._elementId.replaceAll('/', '-'),
                            '',
                        ),
                        H('nzPopoverContent', i);
                }
            }
            function Wre(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 15),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.onShowingPopover(r.item));
                        }),
                        Oe(1, 'i', 16),
                        ee();
                }
                if (2 & t) {
                    const e = L(2),
                        i = ts(15);
                    Bt('aria-controls', 'copyright-content-', e.item._elementId, ''),
                        Bt('aria-label', 'Copyright button for ', e.item.question, ''),
                        Bt('aria-describedby', 'copyright-button-', e.item._elementId, ''),
                        Mn('id', 'copyright-button-', e.item._elementId, ''),
                        Mn(
                            'nzPopoverOverlayClassName',
                            'lhc-popover-copyright lhc-copyright-class',
                            e.item._elementId.replaceAll('/', '-'),
                            '',
                        ),
                        H('nzPopoverContent', i);
                }
            }
            function Kre(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 15),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.onShowingPopover(r.item));
                        }),
                        Oe(1, 'i', 17),
                        ee();
                }
                if (2 & t) {
                    const e = L(2),
                        i = ts(15);
                    Bt('aria-controls', 'copyright-content-', e.popoverIdentifier, ''),
                        Bt('aria-label', 'Copyright button for ', e.item.name || e.item.shortName, ''),
                        Bt('aria-describedby', 'copyright-button-', e.popoverIdentifier, ''),
                        Mn('id', 'copyright-button-', e.popoverIdentifier, ''),
                        Mn(
                            'nzPopoverOverlayClassName',
                            'lhc-popover-copyright lhc-copyright-class',
                            e.popoverIdentifier,
                            '',
                        ),
                        H('nzPopoverContent', i);
                }
            }
            function Qre(t, n) {
                if ((1 & t && (Xe(0), ue(1, Wre, 2, 11, 'button', 14)(2, Kre, 2, 11, 'button', 14), Ze()), 2 & t)) {
                    const e = L();
                    z(), H('ngIf', !e.formLevel), z(), H('ngIf', e.formLevel);
                }
            }
            function Xre(t, n) {
                if ((1 & t && (Z(0, 'span', 18), Je(1), ee()), 2 & t)) {
                    const e = L();
                    Bt('aria-labelledby', 'add-button-', e.item._elementId, ''),
                        Bt('aria-describedby', 'add-content-', e.item._elementId, ''),
                        Mn('id', 'add-content-', e.item._elementId, ''),
                        zi('aria-label', e.item._unusedItemWarning),
                        z(),
                        hn(e.item._unusedItemWarning);
                }
            }
            function Zre(t, n) {
                if ((1 & t && (Oe(0, 'span', 19), Gn(1, 'safeHtml')), 2 & t)) {
                    const e = L();
                    Bt('aria-labelledby', 'help-button-', e.item._elementId, ''),
                        Bt('aria-label', 'Instruction for ', e.item.question, ''),
                        Bt('aria-describedby', 'help-content-', e.item._elementId, ''),
                        Mn('id', 'help-content-', e.item._elementId, ''),
                        H(
                            'innerHTML',
                            ci(1, 9, e.item._codingInstructionsWithContainedImages || e.item.codingInstructions),
                            No,
                        );
                }
            }
            function Jre(t, n) {
                if ((1 & t && (Z(0, 'span', 18), Je(1), ee()), 2 & t)) {
                    const e = L();
                    Bt('aria-labelledby', 'help-button-', e.item._elementId, ''),
                        Bt('aria-label', 'Instruction for ', e.item.question, ''),
                        Bt('aria-describedby', 'help-content-', e.item._elementId, ''),
                        Mn('id', 'help-content-', e.item._elementId, ''),
                        z(),
                        hn(e.item.codingInstructionsPlain);
                }
            }
            function ese(t, n) {
                if ((1 & t && (Z(0, 'span', 18), Je(1), ee()), 2 & t)) {
                    const e = L();
                    Bt('aria-labelledby', 'help-button-', e.item._elementId, ''),
                        Bt('aria-label', 'Instruction for ', e.item.question, ''),
                        Bt('aria-describedby', 'help-content-', e.item._elementId, ''),
                        Mn('id', 'help-content-', e.item._elementId, ''),
                        z(),
                        hn(e.item.codingInstructions);
                }
            }
            function tse(t, n) {
                if ((1 & t && (Z(0, 'span', 18), Je(1), ee()), 2 & t)) {
                    const e = L(2);
                    Bt('aria-labelledby', 'copyright-button-', e.item._elementId, ''),
                        Bt('aria-label', 'Copyright notice for ', e.item.question, ''),
                        Bt('aria-describedby', 'copyright-content-', e.item._elementId, ''),
                        Mn('id', 'copyright-content-', e.item._elementId, ''),
                        z(),
                        hn(e.item.copyrightNotice);
                }
            }
            function nse(t, n) {
                if ((1 & t && (Z(0, 'span', 18), Je(1), ee()), 2 & t)) {
                    const e = L(2);
                    Bt('aria-labelledby', 'copyright-button-', e.popoverIdentifier, ''),
                        Bt('aria-label', 'Copyright notice for ', e.item.name || e.item.shortName, ''),
                        Bt('aria-describedby', 'copyright-content-', e.popoverIdentifier, ''),
                        Mn('id', 'copyright-content-', e.popoverIdentifier, ''),
                        Mn('id', 'copyright-content-', e.popoverIdentifier, ''),
                        z(),
                        hn(e.item.copyrightNotice);
                }
            }
            function ise(t, n) {
                if ((1 & t && ue(0, tse, 2, 9, 'span', 20)(1, nse, 2, 11, 'span', 20), 2 & t)) {
                    const e = L();
                    H('ngIf', !e.formLevel), z(), H('ngIf', e.formLevel);
                }
            }
            let Th = (() => {
                class t {
                    constructor(e) {
                        (this.lhcDataService = e),
                            (this.formLevel = !1),
                            (this.buttonLabel = null),
                            (this.append = !1),
                            (this.popoverIdentifier = null);
                    }
                    ngOnInit() {
                        this.formLevel &&
                            this.item &&
                            (this.popoverIdentifier = (
                                this.item.code ||
                                this.item.name ||
                                this.item.shortName
                            ).replaceAll(/[\/\s]/g, '-'));
                    }
                    onShowingPopover() {
                        let r,
                            e = 'copyright-string' === this.popoverType ? 'Copyright notice:' : 'Instruction:';
                        'copyright-string' === this.popoverType
                            ? ((e = 'Copyright notice:'),
                              (r = 'copyright-content-' + (this.formLevel ? this.item.code : this.item._elementId)))
                            : ((e = 'Instruction:'),
                              (r = 'help-content-' + (this.formLevel ? this.item.code : this.item._elementId))),
                            setTimeout(() => {
                                let s = document.getElementById(r).textContent;
                                this.lhcDataService.sendMsgToScreenReader(`${e} ${s}`);
                            }, 10);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-button-popover']],
                        inputs: {
                            item: 'item',
                            popoverType: 'popoverType',
                            formLevel: 'formLevel',
                            buttonLabel: 'buttonLabel',
                            append: 'append',
                        },
                        decls: 16,
                        vars: 6,
                        consts: [
                            ['warningStrTemplate', ''],
                            ['helpHtmlTemplate', ''],
                            ['helpPlainTemplate', ''],
                            ['helpStrTemplate', ''],
                            ['copyrightStrTemplate', ''],
                            [3, 'ngSwitch'],
                            [
                                'type',
                                'button',
                                'class',
                                'lhc-float-button lhc-button',
                                'nz-popover',
                                '',
                                'nzPopoverPlacement',
                                'topLeft',
                                3,
                                'id',
                                'disabled',
                                'nzPopoverVisible',
                                'nzPopoverContent',
                                'nzPopoverTrigger',
                                'nzPopoverOverlayClassName',
                                'nzPopoverVisibleChange',
                                'click',
                                'blur',
                                4,
                                'ngSwitchCase',
                            ],
                            [
                                'type',
                                'button',
                                'class',
                                'lhc-help-button',
                                'nz-popover',
                                '',
                                'nzPopoverTrigger',
                                'click',
                                'nzPopoverPlacement',
                                'right',
                                3,
                                'id',
                                'nzPopoverContent',
                                'nzPopoverTitle',
                                'nzPopoverOverlayClassName',
                                'click',
                                4,
                                'ngSwitchCase',
                            ],
                            [
                                'type',
                                'button',
                                'class',
                                'lhc-help-button',
                                'nz-popover',
                                '',
                                'nzPopoverTrigger',
                                'click',
                                'nzPopoverPlacement',
                                'right',
                                'nzPopoverTitle',
                                'Instruction',
                                3,
                                'id',
                                'nzPopoverContent',
                                'nzPopoverOverlayClassName',
                                'click',
                                4,
                                'ngSwitchCase',
                            ],
                            [4, 'ngSwitchCase'],
                            [
                                'type',
                                'button',
                                'nz-popover',
                                '',
                                'nzPopoverPlacement',
                                'topLeft',
                                1,
                                'lhc-float-button',
                                'lhc-button',
                                3,
                                'nzPopoverVisibleChange',
                                'click',
                                'blur',
                                'id',
                                'disabled',
                                'nzPopoverVisible',
                                'nzPopoverContent',
                                'nzPopoverTrigger',
                                'nzPopoverOverlayClassName',
                            ],
                            [
                                'type',
                                'button',
                                'nz-popover',
                                '',
                                'nzPopoverTrigger',
                                'click',
                                'nzPopoverPlacement',
                                'right',
                                1,
                                'lhc-help-button',
                                3,
                                'click',
                                'id',
                                'nzPopoverContent',
                                'nzPopoverTitle',
                                'nzPopoverOverlayClassName',
                            ],
                            ['nz-icon', '', 'nzType', 'question-circle', 'nzTheme', 'fill'],
                            [
                                'type',
                                'button',
                                'nz-popover',
                                '',
                                'nzPopoverTrigger',
                                'click',
                                'nzPopoverPlacement',
                                'right',
                                'nzPopoverTitle',
                                'Instruction',
                                1,
                                'lhc-help-button',
                                3,
                                'click',
                                'id',
                                'nzPopoverContent',
                                'nzPopoverOverlayClassName',
                            ],
                            [
                                'type',
                                'button',
                                'class',
                                'lhc-copyright-button',
                                'nz-popover',
                                '',
                                'nzPopoverTrigger',
                                'click',
                                'nzPopoverPlacement',
                                'right',
                                'nzPopoverTitle',
                                'Copyright',
                                3,
                                'id',
                                'nzPopoverContent',
                                'nzPopoverOverlayClassName',
                                'click',
                                4,
                                'ngIf',
                            ],
                            [
                                'type',
                                'button',
                                'nz-popover',
                                '',
                                'nzPopoverTrigger',
                                'click',
                                'nzPopoverPlacement',
                                'right',
                                'nzPopoverTitle',
                                'Copyright',
                                1,
                                'lhc-copyright-button',
                                3,
                                'click',
                                'id',
                                'nzPopoverContent',
                                'nzPopoverOverlayClassName',
                            ],
                            ['nz-icon', '', 'nzType', 'copyright-circle', 'nzTheme', 'fill'],
                            ['nz-icon', '', 'nzType', 'copyright-circle', 'nzTheme', 'outline'],
                            ['role', 'region', 3, 'id'],
                            ['role', 'region', 3, 'id', 'innerHTML'],
                            ['role', 'region', 3, 'id', 4, 'ngIf'],
                        ],
                        template: function (i, r) {
                            1 & i &&
                                (Xe(0, 5),
                                ue(1, Yre, 2, 15, 'button', 6)(2, jre, 3, 14, 'button', 7)(3, $re, 2, 11, 'button', 8)(
                                    4,
                                    Gre,
                                    2,
                                    11,
                                    'button',
                                    8,
                                )(5, Qre, 3, 2, 'ng-container', 9),
                                Ze(),
                                ue(6, Xre, 2, 8, 'ng-template', null, 0, Xs)(8, Zre, 2, 11, 'ng-template', null, 1, Xs)(
                                    10,
                                    Jre,
                                    2,
                                    9,
                                    'ng-template',
                                    null,
                                    2,
                                    Xs,
                                )(12, ese, 2, 9, 'ng-template', null, 3, Xs)(
                                    14,
                                    ise,
                                    2,
                                    2,
                                    'ng-template',
                                    null,
                                    4,
                                    Xs,
                                )),
                                2 & i &&
                                    (H('ngSwitch', r.popoverType),
                                    z(),
                                    H('ngSwitchCase', 'repeating-item'),
                                    z(),
                                    H('ngSwitchCase', 'help-string'),
                                    z(),
                                    H('ngSwitchCase', 'help-html'),
                                    z(),
                                    H('ngSwitchCase', 'help-plain'),
                                    z(),
                                    H('ngSwitchCase', 'copyright-string'));
                        },
                        dependencies: [hi, Ho, Ta, Fne, xc, $o, Sh],
                    }));
                }
                return t;
            })();
            class Dh {
                constructor() {
                    (this._windowWidth$ = null),
                        (this._viewMode$ = null),
                        (this._windowWidth$ = new Ke(window.innerWidth)),
                        (this._viewMode$ = new Ke('lg'));
                }
                getWindowWidth() {
                    return this._windowWidth$.getValue();
                }
                getViewMode() {
                    return this._viewMode$.getValue();
                }
                setWindowWidth(n) {
                    let e;
                    this._windowWidth$.next(n), (e = n <= 400 ? 'sm' : n <= 600 ? 'md' : 'lg'), this._viewMode$.next(e);
                }
                get windowWidth() {
                    return this._windowWidth$.asObservable();
                }
                get viewMode() {
                    return this._viewMode$.asObservable();
                }
            }
            function rse(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-group', 4), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function sse(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-display', 4), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function ose(t, n) {
                if ((1 & t && Oe(0, 'lhc-item', 11), 2 & t)) {
                    const e = L().$implicit,
                        i = L(4);
                    vo(i.lhcDataService.getItemClassList(e, i.viewMode)),
                        Mn('id', 'item-', e._elementId, ''),
                        H('item', e);
                }
            }
            function ase(t, n) {
                if ((1 & t && (Xe(0), ue(1, ose, 1, 6, 'lhc-item', 10), Ze()), 2 & t)) {
                    const e = n.$implicit,
                        i = L(4);
                    z(), H('ngIf', e && !e._isHiddenFromView && i.lhcDataService.targetShown(e));
                }
            }
            function lse(t, n) {
                if ((1 & t && (Z(0, 'div', 8), ue(1, ase, 2, 1, 'ng-container', 9), ee()), 2 & t)) {
                    const e = L(3);
                    z(), H('ngForOf', e.item.items)('ngForTrackBy', e.lhcDataService.trackByElementId);
                }
            }
            function cse(t, n) {
                if ((1 & t && (Z(0, 'div')(1, 'div'), Oe(2, 'lhc-button-popover', 12), ee()()), 2 & t)) {
                    const e = L(3);
                    dt('lhc-button-padding ', e.lhcDataService.getSiblingStatus(e.item), ''),
                        z(),
                        vo(e.lhcDataService.getSkipLogicClass(e.item)),
                        z(),
                        Mn('buttonLabel', '+ ', e.item._text, ''),
                        H('item', e.item)('popoverType', 'repeating-item');
                }
            }
            function use(t, n) {
                if (
                    (1 & t &&
                        (Xe(0),
                        Oe(1, 'lhc-item-question', 5),
                        ue(2, lse, 2, 2, 'div', 6)(3, cse, 3, 10, 'div', 7),
                        Ze()),
                    2 & t)
                ) {
                    const e = L(2);
                    z(),
                        H('item', e.item)('ngStyle', e.lhcDataService.getItemStyle(e.item)),
                        z(),
                        H('ngIf', e.item.items),
                        z(),
                        H(
                            'ngIf',
                            e.item._lastRepeatingItem &&
                                !e.item._isHiddenFromView &&
                                e.lhcDataService.targetEnabled(e.item),
                        );
                }
            }
            function dse(t, n) {
                if (
                    (1 & t &&
                        (Xe(0)(1, 1),
                        ue(2, rse, 2, 1, 'ng-container', 2)(3, sse, 2, 1, 'ng-container', 2)(
                            4,
                            use,
                            4,
                            4,
                            'ng-container',
                            3,
                        ),
                        Ze()()),
                    2 & t)
                ) {
                    const e = L();
                    z(),
                        H('ngSwitch', e.item.dataType),
                        z(),
                        H('ngSwitchCase', 'SECTION'),
                        z(),
                        H('ngSwitchCase', 'TITLE');
                }
            }
            let m3 = (() => {
                class t {
                    constructor(e, i) {
                        (this.winService = e),
                            (this.lhcDataService = i),
                            (this.viewMode = ''),
                            e.windowWidth.subscribe(r => {
                                this.viewMode = e.getViewMode();
                            });
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Dh), te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item']],
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [3, 'ngSwitch'],
                            [4, 'ngSwitchCase'],
                            [4, 'ngSwitchDefault'],
                            [3, 'item'],
                            [1, 'lhc-de', 3, 'item', 'ngStyle'],
                            ['class', 'lhc-item-group-body', 4, 'ngIf'],
                            [3, 'class', 4, 'ngIf'],
                            [1, 'lhc-item-group-body'],
                            [4, 'ngFor', 'ngForOf', 'ngForTrackBy'],
                            [3, 'item', 'class', 'id', 4, 'ngIf'],
                            [3, 'item', 'id'],
                            [3, 'item', 'popoverType', 'buttonLabel'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, dse, 5, 3, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        styles: [
                            '[_nghost-%COMP%]{display:block}\n\n/*# sourceMappingURL=lhc-item.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            function hse(t, n) {
                if ((1 & t && (Z(0, 'span', 11), Je(1), ee()), 2 & t)) {
                    const e = L(2);
                    z(), hn(e.lhcDataService.getRepeatingSN(e.item));
                }
            }
            function fse(t, n) {
                if ((1 & t && (Z(0, 'span', 12), Je(1), ee()), 2 & t)) {
                    const e = L(2);
                    Ks(e.item._obj_prefixCSS), z(), hn(e.item.prefix);
                }
            }
            function mse(t, n) {
                if ((1 & t && (Z(0, 'span', 13), Je(1), ee()), 2 & t)) {
                    const e = L(2);
                    Ks(e.item._obj_textCSS), z(), hn(e.item._displayTextHTML);
                }
            }
            function pse(t, n) {
                if ((1 & t && (Oe(0, 'span', 14), Gn(1, 'safeHtml')), 2 & t)) {
                    const e = L(2);
                    Ks(e.item._obj_textCSS), H('innerHTML', ci(1, 3, e.item._displayTextHTML), No);
                }
            }
            function gse(t, n) {
                if ((1 & t && (Z(0, 'span', 13), Je(1), ee()), 2 & t)) {
                    const e = L(2);
                    Ks(e.item._obj_textCSS), z(), hn(e.item.question);
                }
            }
            function vse(t, n) {
                1 & t && (Z(0, 'span', 15), Je(1, ' *'), ee());
            }
            function _se(t, n) {
                if ((1 & t && (Z(0, 'a', 19), Je(1), ee()), 2 & t)) {
                    const e = L(2).$implicit;
                    ct('href', 'https://loinc.org/' + e.code, td), z(), jn(' [', e.code, '] ');
                }
            }
            function yse(t, n) {
                if ((1 & t && (Z(0, 'span', 20), Je(1), ee()), 2 & t)) {
                    const e = L(2).$implicit;
                    z(), jn('[', e.code, ']');
                }
            }
            function bse(t, n) {
                if ((1 & t && (Z(0, 'span'), ue(1, _se, 2, 2, 'a', 17)(2, yse, 2, 1, 'span', 18), ee()), 2 & t)) {
                    const e = L().$implicit;
                    z(), H('ngIf', 'http://loinc.org' == e.system), z(), H('ngIf', 'http://loinc.org' != e.system);
                }
            }
            function Cse(t, n) {
                if ((1 & t && (Z(0, 'span'), ue(1, bse, 3, 2, 'span', 0), ee()), 2 & t)) {
                    const e = n.$implicit;
                    z(), H('ngIf', e.code);
                }
            }
            function wse(t, n) {
                if ((1 & t && (Z(0, 'span'), ue(1, Cse, 2, 1, 'span', 16), ee()), 2 & t)) {
                    const e = L(2);
                    z(), H('ngForOf', e.item.codeList);
                }
            }
            function Mse(t, n) {
                if ((1 & t && (Z(0, 'div', 24), Je(1), ee()), 2 & t)) {
                    const e = L(3);
                    Bt('aria-label', 'Help for question ', e.item.question, ''),
                        Bt('aria-describedby', 'label-', e.item._elementId, ''),
                        Mn('id', 'help-', e.item._elementId, ''),
                        z(),
                        hn(e.item.codingInstructions);
                }
            }
            function Sse(t, n) {
                if ((1 & t && (Oe(0, 'div', 25), Gn(1, 'safeHtml')), 2 & t)) {
                    const e = L(3);
                    Bt('aria-label', 'Help for question ', e.item.question, ''),
                        Bt('aria-describedby', 'label-', e.item._elementId, ''),
                        Mn('id', 'help-', e.item._elementId, ''),
                        H(
                            'innerHTML',
                            ci(1, 7, e.item._codingInstructionsWithContainedImages || e.item.codingInstructions),
                            No,
                        );
                }
            }
            function Tse(t, n) {
                if ((1 & t && (Z(0, 'div', 24), Je(1), ee()), 2 & t)) {
                    const e = L(3);
                    Bt('aria-label', 'Help for question ', e.item.question, ''),
                        Bt('aria-describedby', 'label-', e.item._elementId, ''),
                        Mn('id', 'help-', e.item._elementId, ''),
                        z(),
                        hn(e.item.codingInstructionsPlain);
                }
            }
            function Dse(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-button-popover', 26), Ze()), 2 & t)) {
                    const e = L(3);
                    z(), H('item', e.item)('popoverType', 'help-string');
                }
            }
            function xse(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-button-popover', 26), Ze()), 2 & t)) {
                    const e = L(3);
                    z(), H('item', e.item)('popoverType', 'help-html');
                }
            }
            function kse(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-button-popover', 26), Ze()), 2 & t)) {
                    const e = L(3);
                    z(), H('item', e.item)('popoverType', 'help-plain');
                }
            }
            function Ese(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'span', 6),
                        ue(1, Mse, 2, 7, 'div', 21)(2, Sse, 2, 9, 'div', 22)(3, Tse, 2, 7, 'div', 21)(
                            4,
                            Dse,
                            2,
                            2,
                            'ng-container',
                            23,
                        )(5, xse, 2, 2, 'ng-container', 23)(6, kse, 2, 2, 'ng-container', 23),
                        ee()),
                    2 & t)
                ) {
                    const e = L(2);
                    H('ngSwitch', e.lhcDataService.getCodingInstructionsDisplayType(e.item)),
                        z(),
                        H('ngSwitchCase', 'inline-escaped'),
                        z(),
                        H('ngSwitchCase', 'inline-html'),
                        z(),
                        H('ngSwitchCase', 'inline-plain'),
                        z(),
                        H('ngSwitchCase', 'popover-escaped'),
                        z(),
                        H('ngSwitchCase', 'popover-html'),
                        z(),
                        H('ngSwitchCase', 'popover-plain');
                }
            }
            function Ise(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-button-popover', 26), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item)('popoverType', 'copyright-string');
                }
            }
            function Ase(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'div', 1),
                        Le('focus', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ue(2, hse, 2, 1, 'span', 2),
                        Z(3, 'span', 3)(4, 'label', 4),
                        ue(5, fse, 2, 3, 'span', 5),
                        Xe(6, 6),
                        ue(7, mse, 2, 3, 'span', 7)(8, pse, 2, 5, 'span', 8)(9, gse, 2, 3, 'span', 7),
                        Ze(),
                        ue(10, vse, 2, 0, 'span', 9),
                        ee()(),
                        ue(11, wse, 2, 1, 'span', 0)(12, Ese, 7, 7, 'span', 10)(13, Ise, 2, 2, 'ng-container', 0),
                        ee(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(2),
                        H(
                            'ngIf',
                            e.item._questionRepeatable &&
                                !e.item._horizontalTableHeader &&
                                !e.lhcDataService.isHideRepetitionNumber(),
                        ),
                        z(2),
                        Mn('id', 'label-', e.item._elementId, ''),
                        ct('for', e.item._elementId),
                        z(),
                        H('ngIf', e.item.prefix),
                        z(),
                        H('ngSwitch', e.lhcDataService.getTextDisplayType(e.item)),
                        z(),
                        H('ngSwitchCase', 'escaped'),
                        z(),
                        H('ngSwitchCase', 'html'),
                        z(),
                        H('ngSwitchCase', 'plain'),
                        z(),
                        H('ngIf', e.item._answerRequired),
                        z(),
                        H(
                            'ngIf',
                            e.lhcDataService.getLhcFormData().templateOptions.showQuestionCode &&
                                e.item.codeList &&
                                e.item.codeList.length > 0,
                        ),
                        z(),
                        H('ngIf', e.item.codingInstructions),
                        z(),
                        H('ngIf', e.item.copyrightNotice);
                }
            }
            let xh = (() => {
                    class t {
                        constructor(e) {
                            this.lhcDataService = e;
                        }
                        ngOnInit() {}
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Xi));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['lhc-item-question-text']],
                            inputs: { item: 'item' },
                            decls: 1,
                            vars: 1,
                            consts: [
                                [4, 'ngIf'],
                                [1, 'lhc-de-label', 3, 'focus'],
                                ['class', 'lf-sn', 4, 'ngIf'],
                                [1, 'lhc-question'],
                                [3, 'id', 'for'],
                                ['class', 'prefix', 3, 'style', 4, 'ngIf'],
                                [3, 'ngSwitch'],
                                ['class', 'question', 3, 'style', 4, 'ngSwitchCase'],
                                ['class', 'question', 3, 'style', 'innerHTML', 4, 'ngSwitchCase'],
                                ['class', 'lhc-required', 'text', '2', 4, 'ngIf'],
                                [3, 'ngSwitch', 4, 'ngIf'],
                                [1, 'lf-sn'],
                                [1, 'prefix'],
                                [1, 'question'],
                                [1, 'question', 3, 'innerHTML'],
                                ['text', '1', 1, 'lhc-required'],
                                [4, 'ngFor', 'ngForOf'],
                                [
                                    'class',
                                    'lhc-item-code',
                                    'target',
                                    '_blank',
                                    'rel',
                                    'noopener noreferrer',
                                    3,
                                    'href',
                                    4,
                                    'ngIf',
                                ],
                                ['class', 'lhc-item-code', 4, 'ngIf'],
                                ['target', '_blank', 'rel', 'noopener noreferrer', 1, 'lhc-item-code', 3, 'href'],
                                [1, 'lhc-item-code'],
                                ['class', 'lhc-inline-help', 3, 'id', 4, 'ngSwitchCase'],
                                ['class', 'lhc-inline-help', 3, 'id', 'innerHTML', 4, 'ngSwitchCase'],
                                [4, 'ngSwitchCase'],
                                [1, 'lhc-inline-help', 3, 'id'],
                                [1, 'lhc-inline-help', 3, 'id', 'innerHTML'],
                                [3, 'item', 'popoverType'],
                            ],
                            template: function (i, r) {
                                1 & i && ue(0, Ase, 14, 13, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                            },
                            dependencies: [oa, hi, Ho, Ta, Th, Sh],
                        }));
                    }
                    return t;
                })(),
                kh = (() => {
                    class t {
                        areTwoAnswersSame(e, i, r) {
                            return Rt.areTwoAnswersSame(e, i, r);
                        }
                        str2num(e, i) {
                            let r = null;
                            if ('integer' === i) {
                                let s = parseInt(e);
                                r = isNaN(s) ? null : s;
                            } else if ('decimal' === i) {
                                let s = parseFloat(e);
                                r = isNaN(s) ? null : s;
                            }
                            return r;
                        }
                        getDisplayControlIsVertical(e) {
                            return void 0 !== e?.answerLayout?.columns && '0' !== e.answerLayout.columns;
                        }
                        getAriaLabel(e) {
                            return e.prefix ? `${e.prefix} ${e.question}` : e.question;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })();
            const Lse = t => ({ 'lhc-vertical': t }),
                Ose = t => ({ text: t, _notOnList: !0 });
            function zse(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), hn(e._displayTextHTML);
                }
            }
            function Pse(t, n) {
                1 & t && (Oe(0, 'span', 9), Gn(1, 'safeHtml')),
                    2 & t && H('outerHTML', ci(1, 1, L().$implicit._displayTextHTML), No);
            }
            function Nse(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), hn(e._displayText);
                }
            }
            function Fse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'label', 5),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        bi('ngModelChange', function (r) {
                            const s = me(e).index,
                                o = L(2);
                            return ki(o.checkboxModels[s], r) || (o.checkboxModels[s] = r), pe(r);
                        }),
                        Xe(2, 6),
                        ue(3, zse, 2, 1, 'ng-container', 7)(4, Pse, 2, 3, 'span', 8)(5, Nse, 2, 1, 'ng-container', 7),
                        Ze(),
                        ee()();
                }
                if (2 & t) {
                    const e = n.$implicit,
                        i = n.index,
                        r = L(2);
                    z(),
                        Dd('aria-label', 'Checkbox ', e._displayText, ' for ', r.item.question, ''),
                        H('nzValue', r.item.answers[i]),
                        yi('ngModel', r.checkboxModels[i]),
                        H('nzDisabled', r.item._readOnly)('id', r.lhcDataService.getItemAnswerId(r.item, e)),
                        z(),
                        H('ngSwitch', r.lhcDataService.getTextDisplayType(e)),
                        z(),
                        H('ngSwitchCase', 'escaped'),
                        z(),
                        H('ngSwitchCase', 'html'),
                        z(),
                        H('ngSwitchCase', 'plain');
                }
            }
            function Rse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'input', 12),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L(3).onOtherValueChange(r));
                        })('focus', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee();
                }
                if (2 & t) {
                    const e = L(3);
                    H('ngModel', e.otherValue)('id', e.item._elementId + '_otherValue')('disabled', e.item._readOnly);
                }
            }
            function Vse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'label', 10),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(2);
                            return ki(s.otherCheckboxModel, r) || (s.otherCheckboxModel = r), pe(r);
                        }),
                        Je(2),
                        Gn(3, 'transloco'),
                        ee(),
                        ue(4, Rse, 1, 3, 'input', 11),
                        ee();
                }
                if (2 & t) {
                    const e = L(2);
                    z(),
                        Bt('aria-label', 'Checkbox Other for ', e.item.question, ''),
                        H('nzValue', us(10, Ose, e.otherValue))('nzDisabled', e.item._readOnly),
                        yi('ngModel', e.otherCheckboxModel),
                        H('id', e.item._elementId + '_other'),
                        z(),
                        jn(' ', ci(3, 8, 'Other'), ' '),
                        z(2),
                        H('ngIf', e.otherCheckboxModel);
                }
            }
            function Hse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'nz-checkbox-wrapper', 1),
                        Le('nzOnChange', function (r) {
                            return me(e), pe(L().onCheckboxModelChange(r));
                        }),
                        Z(1, 'div', 2),
                        ue(2, Fse, 6, 11, 'div', 3)(3, Vse, 5, 12, 'div', 4),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        H('ngClass', us(3, Lse, e.commonUtils.getDisplayControlIsVertical(e.item.displayControl))),
                        z(),
                        H('ngForOf', e.acOptions.listItems),
                        z(),
                        H('ngIf', 'optionsOrString' === e.item.answerConstraint);
                }
            }
            let Use = (() => {
                class t {
                    constructor(e, i) {
                        (this.commonUtils = e),
                            (this.lhcDataService = i),
                            (this.otherValue = null),
                            (this.checkboxModels = []),
                            (this.otherCheckboxModel = null),
                            (this.prevCheckBoxValue = null);
                    }
                    setInitialValue() {
                        if (
                            this.item &&
                            this.item.value &&
                            Array.isArray(this.item.value) &&
                            this.item.answers &&
                            Array.isArray(this.item.answers)
                        ) {
                            let e = this.item.answers.length;
                            this.checkboxModels = new Array(e);
                            for (let i = 0, r = this.item.value.length; i < r; i++) {
                                let s = this.item.value[i];
                                if (s._notOnList) (this.otherCheckboxModel = !0), (this.otherValue = s.text);
                                else
                                    for (let o = 0; o < e; o++)
                                        this.commonUtils.areTwoAnswersSame(s, this.item.answers[o], this.item) &&
                                            (this.checkboxModels[o] = !0);
                            }
                            this.prevCheckBoxValue = this.item.value;
                        }
                    }
                    ngOnInit() {}
                    ngOnChanges(e) {
                        this.setInitialValue();
                    }
                    onCheckboxModelChange(e) {
                        (this.item.value = e),
                            this.lhcDataService.onItemValueChange(this.item, this.item.value, this.prevCheckBoxValue),
                            (this.prevCheckBoxValue = this.item.value);
                    }
                    onOtherValueChange(e) {
                        this.otherCheckboxModel &&
                            ((this.item.value = Rt.deepCopy(this.prevCheckBoxValue).map(
                                i => (i._notOnList && (i.text = e), i),
                            )),
                            (this.otherValue = e),
                            this.lhcDataService.onItemValueChange(this.item, this.item.value, this.prevCheckBoxValue),
                            (this.prevCheckBoxValue = this.item.value));
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(kh), te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-choice-check-box']],
                        inputs: { item: 'item', acOptions: 'acOptions' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            ['style', 'width: 100%;', 3, 'nzOnChange', 4, 'ngIf'],
                            [2, 'width', '100%', 3, 'nzOnChange'],
                            ['nz-row', '', 3, 'ngClass'],
                            [4, 'ngFor', 'ngForOf'],
                            [4, 'ngIf'],
                            ['nz-checkbox', '', 3, 'click', 'ngModelChange', 'nzValue', 'ngModel', 'nzDisabled', 'id'],
                            [3, 'ngSwitch'],
                            [4, 'ngSwitchCase'],
                            [3, 'outerHTML', 4, 'ngSwitchCase'],
                            [3, 'outerHTML'],
                            ['nz-checkbox', '', 3, 'click', 'ngModelChange', 'nzValue', 'nzDisabled', 'ngModel', 'id'],
                            [
                                'type',
                                'text',
                                'class',
                                'lhc-answer-other-input',
                                'nz-input',
                                '',
                                3,
                                'ngModel',
                                'id',
                                'disabled',
                                'ngModelChange',
                                'focus',
                                4,
                                'ngIf',
                            ],
                            [
                                'type',
                                'text',
                                'nz-input',
                                '',
                                1,
                                'lhc-answer-other-input',
                                3,
                                'ngModelChange',
                                'focus',
                                'ngModel',
                                'id',
                                'disabled',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Hse, 4, 5, 'nz-checkbox-wrapper', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [sl, oa, hi, Ho, Ta, xa, eo, Fs, Og, _D, Vx, $o, Sh],
                        styles: [
                            '.lhc-answer-other-input[_ngcontent-%COMP%]{height:22px}.ant-checkbox-group[_ngcontent-%COMP%], .ant-checkbox-wrapper[_ngcontent-%COMP%]{color:#000000d9}.lhc-vertical[_ngcontent-%COMP%]{flex-direction:column}\n\n/*# sourceMappingURL=lhc-item-choice-check-box.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            const Bse = t => ({ 'lhc-vertical': t }),
                qse = t => ({ text: t, _notOnList: !0 });
            function Yse(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), hn(e._displayTextHTML);
                }
            }
            function jse(t, n) {
                1 & t && (Oe(0, 'span', 8), Gn(1, 'safeHtml')),
                    2 & t && H('outerHTML', ci(1, 1, L().$implicit._displayTextHTML), No);
            }
            function $se(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), hn(e._displayText);
                }
            }
            function Gse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'label', 4),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        bi('ngModelChange', function (r) {
                            const s = me(e).index,
                                o = L(2);
                            return ki(o.radioModels[s], r) || (o.radioModels[s] = r), pe(r);
                        }),
                        Xe(1, 5),
                        ue(2, Yse, 2, 1, 'ng-container', 6)(3, jse, 2, 3, 'span', 7)(4, $se, 2, 1, 'ng-container', 6),
                        Ze(),
                        ee();
                }
                if (2 & t) {
                    const e = n.$implicit,
                        i = n.index,
                        r = L(2);
                    H('nzDisabled', r.item._readOnly)('disabled', r.item._readOnly)('nzValue', r.item.answers[i]),
                        yi('ngModel', r.radioModels[i]),
                        H('id', r.lhcDataService.getItemAnswerId(r.item, e)),
                        z(),
                        H('ngSwitch', r.lhcDataService.getTextDisplayType(e)),
                        z(),
                        H('ngSwitchCase', 'escaped'),
                        z(),
                        H('ngSwitchCase', 'html'),
                        z(),
                        H('ngSwitchCase', 'plain');
                }
            }
            function Wse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'input', 10),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L(3).onOtherValueChange(r));
                        })('focus', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee();
                }
                if (2 & t) {
                    const e = L(3);
                    H('ngModel', e.otherValue)('id', e.item._elementId + '_otherValue')('disabled', e.item._readOnly);
                }
            }
            function Kse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'label', 4),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(2);
                            return ki(s.otherRadioModel, r) || (s.otherRadioModel = r), pe(r);
                        }),
                        Je(1, window.lhcTranslationsFn('other')),
                        ue(2, Wse, 1, 3, 'input', 9),
                        ee();
                }
                if (2 & t) {
                    const e = L(2);
                    H('nzDisabled', e.item._readOnly)('disabled', e.item._readOnly)(
                        'nzValue',
                        us(6, qse, e.otherValue),
                    ),
                        yi('ngModel', e.otherRadioModel),
                        H('id', e.item._elementId + '_other'),
                        z(2),
                        H('ngIf', e.radioValue && e.radioValue._notOnList);
                }
            }
            function Qse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'nz-radio-group', 1),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onRadioModelChange(r));
                        }),
                        ue(2, Gse, 5, 9, 'label', 2)(3, Kse, 3, 8, 'label', 3),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        Bt('aria-labelledby', 'label-', e.item._elementId, ''),
                        H('ngModel', e.radioValue)('nzDisabled', e.item._readOnly)(
                            'nzName',
                            'radiogroup_' + e.item._elementId,
                        )('ngClass', us(8, Bse, e.commonUtils.getDisplayControlIsVertical(e.item.displayControl))),
                        z(),
                        H('ngForOf', e.acOptions.listItems),
                        z(),
                        H('ngIf', 'optionsOrString' === e.item.answerConstraint);
                }
            }
            let Xse = (() => {
                class t {
                    constructor(e, i) {
                        (this.commonUtils = e),
                            (this.lhcDataService = i),
                            (this.radioValue = null),
                            (this.otherValue = null),
                            (this.radioModels = []),
                            (this.otherRadioModel = null);
                    }
                    setInitialValue() {
                        if (this.item && this.item.value && this.item.answers && Array.isArray(this.item.answers))
                            if (((this.radioValue = this.item.value), this.item.value._notOnList))
                                (this.otherValue = this.item.value.text), (this.otherRadioModel = !0);
                            else {
                                let e = this.item.answers.length;
                                this.radioModels = new Array(e);
                                for (let i = 0; i < e; i++)
                                    if (
                                        this.commonUtils.areTwoAnswersSame(
                                            this.item.value,
                                            this.item.answers[i],
                                            this.item,
                                        )
                                    ) {
                                        this.radioModels[i] = !0;
                                        break;
                                    }
                            }
                    }
                    ngOnChanges(e) {
                        this.setInitialValue();
                    }
                    onRadioModelChange(e) {
                        this.radioValue = e;
                        let i = this.item.value;
                        (this.item.value = e), this.lhcDataService.onItemValueChange(this.item, this.item.value, i);
                    }
                    onOtherValueChange(e) {
                        this.otherValue = e;
                        let i = this.item.value;
                        (this.item.value = { text: e, _notOnList: !0 }),
                            this.lhcDataService.onItemValueChange(this.item, this.item.value, i);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(kh), te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-choice-radio-button']],
                        inputs: { item: 'item', acOptions: 'acOptions' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [
                                'role',
                                'radiogroup',
                                'nz-row',
                                '',
                                1,
                                'lhc-radio-group',
                                3,
                                'ngModelChange',
                                'ngModel',
                                'nzDisabled',
                                'nzName',
                                'ngClass',
                            ],
                            [
                                'class',
                                'lhc-answer',
                                'nz-radio',
                                '',
                                3,
                                'nzDisabled',
                                'disabled',
                                'nzValue',
                                'ngModel',
                                'id',
                                'click',
                                'ngModelChange',
                                4,
                                'ngFor',
                                'ngForOf',
                            ],
                            [
                                'nz-radio',
                                '',
                                'class',
                                'lhc-answer',
                                3,
                                'nzDisabled',
                                'disabled',
                                'nzValue',
                                'ngModel',
                                'id',
                                'click',
                                'ngModelChange',
                                4,
                                'ngIf',
                            ],
                            [
                                'nz-radio',
                                '',
                                1,
                                'lhc-answer',
                                3,
                                'click',
                                'ngModelChange',
                                'nzDisabled',
                                'disabled',
                                'nzValue',
                                'ngModel',
                                'id',
                            ],
                            [3, 'ngSwitch'],
                            [4, 'ngSwitchCase'],
                            [3, 'outerHTML', 4, 'ngSwitchCase'],
                            [3, 'outerHTML'],
                            [
                                'type',
                                'text',
                                'class',
                                'lhc-answer-other-input',
                                'nz-input',
                                '',
                                3,
                                'ngModel',
                                'id',
                                'disabled',
                                'ngModelChange',
                                'focus',
                                4,
                                'ngIf',
                            ],
                            [
                                'type',
                                'text',
                                'nz-input',
                                '',
                                1,
                                'lhc-answer-other-input',
                                3,
                                'ngModelChange',
                                'focus',
                                'ngModel',
                                'id',
                                'disabled',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Qse, 4, 10, 'div', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [sl, oa, hi, Ho, Ta, xa, eo, Fs, Yx, qx, Vx, Sh],
                        styles: [
                            '.lhc-radio-group[_ngcontent-%COMP%]{display:flex}.lhc-answer[_ngcontent-%COMP%]{margin:0}.lhc-answer-other-input[_ngcontent-%COMP%]{height:22px}.ant-radio-group[_ngcontent-%COMP%], .ant-radio-wrapper[_ngcontent-%COMP%]{color:#000000d9}.lhc-vertical[_ngcontent-%COMP%]{flex-direction:column}\n\n/*# sourceMappingURL=lhc-item-choice-radio-button.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            const Zse = ['ac'];
            function Jse(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'input', 2, 0),
                        Gn(3, 'transloco'),
                        Le('blur', function () {
                            return me(e), pe(L().onInputBlur());
                        })('focus', function () {
                            return me(e), pe(L().onInputFocus());
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    vo(e.options.readOnly ? 'lhc-item-readyonly' : null),
                        z(),
                        ct('placeholder', ci(3, 6, e.options.placeholder)),
                        ct('id', e.options.elementId),
                        H('disabled', e.options.readOnly);
                }
            }
            let Lk = (() => {
                class t {
                    constructor(e) {
                        (this.lhcDataService = e),
                            (this.dataModelChange = new Ft()),
                            (this.onFocusFn = new Ft()),
                            (this.onBlurFn = new Ft()),
                            (this.selectedItems = []),
                            (this.multipleSelections = !1),
                            (this.allowNotOnList = !1),
                            (this.acType = null),
                            (this.acInstance = null),
                            (this.displayProp = ''),
                            (this.viewInitialized = !1);
                    }
                    ngOnChanges(e) {
                        if (this.viewInitialized) {
                            let i;
                            if (e.options && e.dataModel)
                                this.cleanupAutocomplete(!0),
                                    this.setupAutocomplete(),
                                    (i = e.dataModel && !Rt.deepEqual(this.dataModel, e.dataModel.previousValue));
                            else if (e.options) {
                                let { keep: r, dataModelChanged: s } = this.keepDataModel(e);
                                this.cleanupAutocomplete(r), this.setupAutocomplete(), (i = s || !r);
                            } else e.dataModel && (this.updateDisplayedValue(this.dataModel), (i = !0));
                            i &&
                                (this.dataModelChange.emit(this.dataModel),
                                this.lhcDataService.onItemValueChange(this.item, null, null, !0));
                        }
                    }
                    keepDataModel(e) {
                        let i, r;
                        if (void 0 !== e.isFormReady?.previousValue ? e.isFormReady.previousValue : this.isFormReady) {
                            var l,
                                c,
                                o = e?.options?.previousValue?.acOptions || {},
                                a = e?.options?.currentValue?.acOptions || {};
                            void 0 !== o.listItems || void 0 !== a.listItems
                                ? ((l = o.listItems), (c = a.listItems))
                                : void 0 !== o.url || void 0 !== a.url
                                ? ((l = o.url), (c = a.url))
                                : (void 0 !== o.fhir || void 0 !== a.fhir) && ((l = o.fhir), (c = a.fhir)),
                                (i = Rt.deepEqual(l, c)),
                                o.maxSelect !== a.maxSelect &&
                                    (('*' === o.maxSelect || parseInt(o.maxSelect) > 1) && 1 === parseInt(a.maxSelect)
                                        ? ((this.dataModel = this.dataModel[0]), (r = !0))
                                        : 1 === parseInt(o.maxSelect) &&
                                          ('*' === a.maxSelect || parseInt(a.maxSelect) > 1) &&
                                          ((this.dataModel = [this.dataModel]), (r = !0)),
                                    (i = !0));
                        } else i = !0;
                        return { keep: i, dataModelChanged: r };
                    }
                    updateDisplayedValue(e) {
                        if (this.multipleSelections) {
                            if ((this.acInstance.clearStoredSelection(), Array.isArray(e)))
                                for (let i of e) {
                                    let r = this.updateAutocompSelectionModel(i);
                                    this.acInstance.addToSelectedArea(r);
                                }
                        } else if (e) {
                            let i = this.updateAutocompSelectionModel(e);
                            if ('string' == typeof i) {
                                let r = 'prefetch' === this.acType ? i.trim() : i;
                                this.acInstance.setFieldVal(r, !1);
                            } else this.acInstance.setFieldVal('', !1);
                        } else this.acInstance.setFieldVal('', !1);
                    }
                    getDisplayValue(e) {
                        let i = null;
                        if ('string' == typeof e) i = e;
                        else if ('prefetch' === this.acType)
                            if (e._notOnList) e._notOnList && (i = e.text);
                            else if (this.options.acOptions.listItemsForModel) {
                                for (let r = 0, s = this.options.acOptions.listItemsForModel.length; r < s; r++)
                                    if (Rt.deepEqual(e, this.options.acOptions.listItemsForModel[r])) {
                                        i = this.options.acOptions.listItems[r][this.displayProp];
                                        break;
                                    }
                            } else i = e[this.displayProp] ? e[this.displayProp] : e.text;
                        else i = e[this.displayProp];
                        return i;
                    }
                    updateAutocompSelectionModel(e) {
                        let i = this.getDisplayValue(e);
                        return this.acInstance.storeSelectedItem(i, e.code), i;
                    }
                    ngAfterViewInit() {
                        let e = Rt.deepCopy(this.dataModel);
                        this.setupAutocomplete(),
                            Rt.deepEqual(e, this.dataModel) ||
                                (this.dataModelChange.emit(this.dataModel),
                                this.lhcDataService.onItemValueChange(this.item, null, null, !0)),
                            (this.viewInitialized = !0);
                    }
                    ngOnDestroy() {
                        this.cleanupAutocomplete();
                    }
                    onInputBlur() {
                        this.onBlurFn.emit();
                    }
                    onInputFocus() {
                        this.onFocusFn.emit();
                    }
                    cleanupAutocomplete(e = !1) {
                        this.acInstance &&
                            (this.acInstance.setFieldVal('', !1),
                            !e && void 0 !== this.dataModel && (this.dataModel = null),
                            this.acInstance.destroy());
                    }
                    setupAutocomplete() {
                        if (
                            ((this.selectedItems = []),
                            (this.multipleSelections = !1),
                            (this.acType = null),
                            (this.acInstance = !1),
                            (this.allowNotOnList = null),
                            (this.prefetchTextToItem = {}),
                            (this.displayProp = ''),
                            this.options && this.options.acOptions)
                        ) {
                            let e = this.options.acOptions;
                            if (
                                (e.maxSelect &&
                                    ('*' === e.maxSelect || parseInt(e.maxSelect) > 1) &&
                                    (this.multipleSelections = !0),
                                (this.allowNotOnList = !e.matchListValue),
                                (this.displayProp = e.display || 'text'),
                                e.hasOwnProperty('url') || (e.fhir && e.fhir.search))
                            )
                                (this.acType = 'search'),
                                    e.url?.startsWith('https://snowstorm.ihtsdotools.org/') &&
                                        (e.frequency = e.frequency || 0.5),
                                    (this.acInstance = new (f3().Autocompleter.Search)(
                                        this.ac.nativeElement,
                                        e.url,
                                        e,
                                    ));
                            else {
                                this.acType = 'prefetch';
                                let s = [];
                                e.listItems.forEach((o, a) => {
                                    s.push(o[this.displayProp]),
                                        (this.prefetchTextToItem[o[this.displayProp].trim()] = e.listItemsForModel
                                            ? e.listItemsForModel[a]
                                            : o);
                                }, this),
                                    (this.acInstance = new (f3().Autocompleter.Prefetch)(this.ac.nativeElement, s, e));
                            }
                            this.setItemInitValue(this.dataModel || e.defaultValue),
                                f3().Autocompleter.Event.observeListSelections(
                                    this.options.elementId,
                                    this.onSelectionHandler.bind(this),
                                );
                        }
                    }
                    setItemInitValue(e) {
                        if (e)
                            if (this.multipleSelections && Array.isArray(e)) {
                                for (var i = 0, r = e.length; i < r; ++i) {
                                    let s = e[i],
                                        o = this.getDisplayValue(s);
                                    this.acInstance.storeSelectedItem(o, s.code), this.acInstance.addToSelectedArea(o);
                                }
                                this.acInstance.setFieldVal('', !1), (this.selectedItems = e);
                            } else {
                                let s = this.getDisplayValue(e);
                                if ('string' == typeof s) {
                                    this.acInstance.storeSelectedItem(s, e.code);
                                    let o = 'prefetch' === this.acType ? s.trim() : s;
                                    this.acInstance.setFieldVal(o, !1);
                                } else this.acInstance.setFieldVal('', !1);
                                this.dataModel = e;
                            }
                    }
                    onSelectionHandler(e) {
                        let i = !1;
                        if ('prefetch' === this.acType) {
                            let r = this.acInstance.getSelectedItems();
                            i = this.setItemValueForPrefetchAC(r);
                        } else 'search' === this.acType && (i = this.setItemValueForSearchAC(e));
                        i &&
                            (this.dataModelChange.emit(this.dataModel),
                            this.lhcDataService.onItemValueChange(this.item, null, null, !0));
                    }
                    setItemValueForPrefetchAC(e) {
                        let i = wh(this.dataModel);
                        if (e)
                            if (0 === e.length) this.dataModel = null;
                            else {
                                let r = e.map(
                                    s =>
                                        this.prefetchTextToItem[s] ||
                                        (this.allowNotOnList
                                            ? this.options.modelForOffListItem
                                                ? this.options.modelForOffListItem(s)
                                                : { text: s, _notOnList: !0 }
                                            : void 0),
                                );
                                this.dataModel = this.multipleSelections ? r : r.length >= 0 && r[0] ? r[0] : null;
                            }
                        else this.dataModel = null;
                        return !Rt.deepEqual(i, this.dataModel);
                    }
                    getSearchItemModelData(e, i) {
                        var r = null;
                        if ('' !== e) {
                            let s = this.acInstance.getItemData(e);
                            i ? (r = s) : !i && this.allowNotOnList && ((r = s)._notOnList = !0),
                                r && r.code_system && !r.system && ((r.system = r.code_system), delete r.code_system);
                        }
                        return r;
                    }
                    setItemValueForSearchAC(e) {
                        var i = e.final_val,
                            r = e.on_list;
                        let s = wh(this.dataModel);
                        if ('search' === this.acType)
                            if (this.multipleSelections)
                                if (e.removed) this.selectedItems = this.selectedItems.filter(o => i !== o.text);
                                else {
                                    let o = this.getSearchItemModelData(i, r);
                                    o && (this.selectedItems = [...this.selectedItems, o]);
                                }
                            else this.selectedItems = this.getSearchItemModelData(i, r);
                        return (this.dataModel = this.selectedItems), !Rt.deepEqual(s, this.dataModel);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-autocomplete']],
                        viewQuery: function (i, r) {
                            if ((1 & i && Fr(Zse, 5), 2 & i)) {
                                let s;
                                Dr((s = xr())) && (r.ac = s.first);
                            }
                        },
                        inputs: {
                            options: 'options',
                            item: 'item',
                            dataModel: 'dataModel',
                            isFormReady: 'isFormReady',
                        },
                        outputs: { dataModelChange: 'dataModelChange', onFocusFn: 'onFocusFn', onBlurFn: 'onBlurFn' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            ['ac', ''],
                            [3, 'class', 4, 'ngIf'],
                            ['type', 'text', 3, 'blur', 'focus', 'disabled', 'placeholder', 'id'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Jse, 4, 8, 'div', 1), 2 & i && H('ngIf', r.options);
                        },
                        dependencies: [hi, $o],
                    }));
                }
                return t;
            })();
            function eoe(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'lhc-autocomplete', 1),
                        bi('dataModelChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.item.value, r) || (s.item.value = r), pe(r);
                        }),
                        Le('onBlurFn', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        })('onFocusFn', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        H('options', e.options)('item', e.item),
                        yi('dataModel', e.item.value),
                        H('isFormReady', e.lhcDataService.isFormReady());
                }
            }
            let toe = (() => {
                class t {
                    constructor(e) {
                        (this.lhcDataService = e), (this.options = {});
                    }
                    ngOnChanges(e) {
                        this.item &&
                            (e.acOptions || e.readOnly) &&
                            (this.options = {
                                elementId: this.item._elementId,
                                acOptions: this.item._autocompOptions,
                                placeholder: this.item._placeholder,
                                readOnly: this.readOnly,
                            });
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-choice-autocomplete']],
                        inputs: { item: 'item', acOptions: 'acOptions', readOnly: 'readOnly' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [
                                3,
                                'dataModelChange',
                                'onBlurFn',
                                'onFocusFn',
                                'options',
                                'item',
                                'dataModel',
                                'isFormReady',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, eoe, 2, 4, 'div', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, Lk],
                    }));
                }
                return t;
            })();
            function noe(t, n) {
                if ((1 & t && Oe(0, 'lhc-item-choice-radio-button', 5), 2 & t)) {
                    const e = L(3);
                    H('item', e.item)('acOptions', e.item._autocompOptions);
                }
            }
            function ioe(t, n) {
                if ((1 & t && Oe(0, 'lhc-item-choice-check-box', 5), 2 & t)) {
                    const e = L(3);
                    H('item', e.item)('acOptions', e.item._autocompOptions);
                }
            }
            function roe(t, n) {
                if (
                    (1 & t &&
                        (Xe(0),
                        ue(1, noe, 1, 2, 'lhc-item-choice-radio-button', 4)(
                            2,
                            ioe,
                            1,
                            2,
                            'lhc-item-choice-check-box',
                            4,
                        ),
                        Ze()),
                    2 & t)
                ) {
                    const e = L(2);
                    z(), H('ngIf', !e.item._multipleAnswers), z(), H('ngIf', e.item._multipleAnswers);
                }
            }
            function soe(t, n) {
                if ((1 & t && Oe(0, 'lhc-item-choice-autocomplete', 6), 2 & t)) {
                    const e = L(2);
                    H('item', e.item)('acOptions', e.item._autocompOptions)('readOnly', e.item._readOnly);
                }
            }
            function ooe(t, n) {
                if (
                    (1 & t &&
                        (Xe(0)(1, 1),
                        ue(2, roe, 3, 2, 'ng-container', 2)(3, soe, 1, 3, 'lhc-item-choice-autocomplete', 3),
                        Ze()()),
                    2 & t)
                ) {
                    const e = L();
                    z(),
                        H(
                            'ngSwitch',
                            e.item.displayControl &&
                                e.item.displayControl.answerLayout &&
                                e.item.displayControl.answerLayout.type,
                        ),
                        z(),
                        H('ngSwitchCase', 'RADIO_CHECKBOX');
                }
            }
            let aoe = (() => {
                class t {
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-choice']],
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [3, 'ngSwitch'],
                            [4, 'ngSwitchCase'],
                            [3, 'item', 'acOptions', 'readOnly', 4, 'ngSwitchDefault'],
                            [3, 'item', 'acOptions', 4, 'ngIf'],
                            [3, 'item', 'acOptions'],
                            [3, 'item', 'acOptions', 'readOnly'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, ooe, 4, 2, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, Ho, Ta, Bd, Use, Xse, toe],
                    }));
                }
                return t;
            })();
            function loe(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'input', 1),
                        Gn(2, 'transloco'),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onModelChange(r));
                        })('blur', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        })('focus', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        Bt('aria-labelledby', 'label-', e.item._elementId, ''),
                        ct('id', e.item._elementId),
                        ct('placeholder', ci(2, 7, e.item._placeholder)),
                        H('disabled', e.item._readOnly)('ngModel', e.item.value),
                        zi('aria-required', e.item._answerRequired);
                }
            }
            let M5 = (() => {
                class t {
                    constructor(e) {
                        this.lhcDataService = e;
                    }
                    onModelChange(e) {
                        let i = this.item.value;
                        (this.item.value = e), this.lhcDataService.onItemValueChange(this.item, this.item.value, i);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-input']],
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [
                                'type',
                                'text',
                                3,
                                'ngModelChange',
                                'blur',
                                'focus',
                                'id',
                                'disabled',
                                'ngModel',
                                'placeholder',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, loe, 3, 9, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, xa, eo, Fs, $o],
                    }));
                }
                return t;
            })();
            function coe(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div', 3)(1, 'input', 4),
                        Le('blur', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        })('focus', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L(2);
                    z(),
                        ct('id', e.unitElementId),
                        ct('value', e.item.unit.name || e.item.unit.code),
                        H('disabled', e.item._readOnly);
                }
            }
            function uoe(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-input', 1), ue(2, coe, 2, 3, 'div', 2), Ze()), 2 & t)) {
                    const e = L();
                    z(), H('item', e.item), z(), H('ngIf', e.hasSingleUnit);
                }
            }
            let doe = (() => {
                class t {
                    constructor(e) {
                        (this.lhcDataService = e),
                            (this.isSimpleType = !1),
                            (this.hasSingleUnit = !1),
                            (this.unitElementId = '');
                    }
                    ngOnChanges() {
                        this.item &&
                            ((this.isSimpleType =
                                'INT' === this.item.dataType ||
                                'REAL' === this.item.dataType ||
                                'ST' === this.item.dataType ||
                                !this.item.dataType),
                            (this.hasSingleUnit = this.item.unit && this.item._unitReadonly),
                            (this.unitElementId = 'unit_' + this.item._elementId));
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-simple-type']],
                        inputs: { item: 'item' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [3, 'item'],
                            ['class', 'lhc-de-unit', 4, 'ngIf'],
                            [1, 'lhc-de-unit'],
                            [
                                'type',
                                'text',
                                'aria-labelledby',
                                'th_Units',
                                'readonly',
                                '',
                                3,
                                'blur',
                                'focus',
                                'disabled',
                                'id',
                                'value',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, uoe, 3, 2, 'ng-container', 0), 2 & i && H('ngIf', r.item && r.isSimpleType);
                        },
                        dependencies: [hi, M5],
                    }));
                }
                return t;
            })();
            function hoe(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'lhc-autocomplete', 1),
                        bi('dataModelChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.item.unit, r) || (s.item.unit = r), pe(r);
                        }),
                        Le('onBlurFn', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        })('onFocusFn', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        H('options', e.options)('item', e.item),
                        yi('dataModel', e.item.unit),
                        H('isFormReady', e.lhcDataService.isFormReady());
                }
            }
            function foe(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'input', 2),
                        Gn(2, 'transloco'),
                        Le('blur', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        })('focus', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        })('change', function (r) {
                            return me(e), pe(L().updateModel(r));
                        }),
                        ee(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        ct('placeholder', ci(2, 4, e.options.toolTip)),
                        ct('id', e.options.elementId),
                        ct(
                            'value',
                            (null == e.item || null == e.item.unit ? null : e.item.unit.name) ||
                                (null == e.item || null == e.item.unit ? null : e.item.unit.code),
                        ),
                        H('readOnly', e.options.readOnly);
                }
            }
            let moe = (() => {
                class t {
                    constructor(e) {
                        (this.lhcDataService = e),
                            (this.options = {}),
                            (this.hasUnitAutocomplete = !1),
                            (this.hasUnitInputField = !1);
                    }
                    ngOnChanges(e) {
                        let i = this.item;
                        i &&
                            ((this.hasUnitAutocomplete = !!i._unitAutocompOptions),
                            (this.options.readOnly =
                                i._readOnly || (!i.units && i._unitOpen && 'optionsOrString' != i._unitOpen)),
                            (this.options.elementId = 'unit_' + i._elementId),
                            (this.options.acOptions = i._unitAutocompOptions),
                            (this.options.placeholder = i._placeholder),
                            (this.options.modelForOffListItem = $i.modelForOffListUnit));
                    }
                    updateModel(e) {
                        this.item.unit = { name: e.target.value };
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-unit']],
                        inputs: { item: 'item' },
                        features: [D],
                        decls: 2,
                        vars: 2,
                        consts: [
                            [4, 'ngIf'],
                            [
                                3,
                                'dataModelChange',
                                'onBlurFn',
                                'onFocusFn',
                                'options',
                                'item',
                                'dataModel',
                                'isFormReady',
                            ],
                            ['type', 'text', 3, 'blur', 'focus', 'change', 'readOnly', 'placeholder', 'id', 'value'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, hoe, 2, 4, 'ng-container', 0)(1, foe, 3, 6, 'ng-container', 0),
                                2 & i && (H('ngIf', r.hasUnitAutocomplete), z(), H('ngIf', !r.hasUnitAutocomplete));
                        },
                        dependencies: [hi, Lk, $o],
                    }));
                }
                return t;
            })();
            function poe(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-input', 1)(2, 'lhc-unit', 1), Ze()), 2 & t)) {
                    const e = L();
                    z(), H('item', e.item), z(), H('item', e.item);
                }
            }
            let goe = (() => {
                class t {
                    constructor() {
                        this.isQuantity = !1;
                    }
                    ngOnInit() {
                        this.isQuantity = this.item && 'QTY' === this.item.dataType;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)();
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-quantity']],
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [3, 'item'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, poe, 3, 2, 'ng-container', 0), 2 & i && H('ngIf', r.item && r.isQuantity);
                        },
                        dependencies: [hi, moe, M5],
                    }));
                }
                return t;
            })();
            function voe(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'div')(1, 'div', 5),
                        Oe(2, 'i', 6),
                        Z(3, 'span', 7),
                        Je(4),
                        ee(),
                        Z(5, 'span', 8),
                        Je(6),
                        Gn(7, 'transloco'),
                        ee()()()),
                    2 & t)
                ) {
                    const e = n.$implicit,
                        i = L(3);
                    z(4), hn(i.item.question), z(2), hn(ci(7, 2, e));
                }
            }
            function _oe(t, n) {
                if ((1 & t && (Z(0, 'div', 3), ue(1, voe, 8, 4, 'div', 4), ee()), 2 & t)) {
                    const e = L(2);
                    z(), H('ngForOf', e.item._validationErrors);
                }
            }
            function yoe(t, n) {
                if ((1 & t && (Xe(0), ue(1, _oe, 2, 1, 'div', 1), Z(2, 'div', 2), Je(3), ee(), Ze()), 2 & t)) {
                    const e = L();
                    z(), H('ngIf', e.item._hasValidation), z(2), hn(e.value);
                }
            }
            let boe = (() => {
                class t {
                    constructor(e) {
                        this.lhcDataService = e;
                    }
                    ngOnChanges(e) {
                        if (e.value && !e.value.firstChange) {
                            let i = this.lhcDataService.getLhcFormData();
                            setTimeout(() => {
                                i._checkValidations(this.item),
                                    this.item._validationErrors &&
                                        this.item._validationErrors.forEach(r => {
                                            this.lhcDataService.sendMsgToScreenReader(`${this.item.question} ${r}`);
                                        });
                            }, 1);
                        }
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-validate']],
                        inputs: { item: 'item', value: 'value' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            ['class', 'lhc-validation-popover', 4, 'ngIf'],
                            [1, 'lhc-watched-value'],
                            [1, 'lhc-validation-popover'],
                            [4, 'ngFor', 'ngForOf'],
                            [1, 'validation-error'],
                            ['nz-icon', '', 'nzType', 'close', 1, 'lhc-error-icon'],
                            [1, 'lhc-error-item'],
                            [1, 'lhc-error-msg'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, yoe, 4, 2, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [oa, hi, xc, $o],
                        styles: [
                            '.lhc-error-icon[_ngcontent-%COMP%]{color:red;font-weight:700}.lhc-error-msg[_ngcontent-%COMP%]{color:red}.lhc-error-msg[_ngcontent-%COMP%], .lhc-error-item[_ngcontent-%COMP%]{margin-left:.5em}.lhc-watched-value[_ngcontent-%COMP%]{display:none}\n\n/*# sourceMappingURL=lhc-validate.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            function Coe(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'nz-radio-group', 1),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onModelChange(r));
                        })('click', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        Z(2, 'label', 2),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.booleanModels[0], r) || (s.booleanModels[0] = r), pe(r);
                        }),
                        Je(3),
                        Gn(4, 'transloco'),
                        ee(),
                        Z(5, 'label', 2),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.booleanModels[1], r) || (s.booleanModels[1] = r), pe(r);
                        }),
                        Je(6),
                        Gn(7, 'transloco'),
                        ee(),
                        Z(8, 'label', 2),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.booleanModels[2], r) || (s.booleanModels[2] = r), pe(r);
                        }),
                        Je(9),
                        Gn(10, 'transloco'),
                        ee()(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        Bt('aria-labelledby', 'label-', e.item._elementId, ''),
                        H('ngModel', e.radioValue)('nzName', 'radiogroup_' + e.item._elementId),
                        z(),
                        H('nzDisabled', e.item._readOnly)('disabled', e.item._readOnly)('nzValue', !0),
                        yi('ngModel', e.booleanModels[0]),
                        H('id', e.item._elementId + 'true'),
                        z(),
                        hn(ci(4, 22, 'Yes')),
                        z(2),
                        H('nzDisabled', e.item._readOnly)('disabled', e.item._readOnly)('nzValue', !1),
                        yi('ngModel', e.booleanModels[1]),
                        H('id', e.item._elementId + 'false'),
                        z(),
                        hn(ci(7, 24, 'No')),
                        z(2),
                        H('nzDisabled', e.item._readOnly)('disabled', e.item._readOnly)('nzValue', null),
                        yi('ngModel', e.booleanModels[2]),
                        H('id', e.item._elementId + 'null'),
                        z(),
                        hn(ci(10, 26, 'Not Answered'));
                }
            }
            let woe = (() => {
                class t {
                    constructor(e) {
                        (this.lhcDataService = e), (this.booleanModels = new Array(3));
                    }
                    ngOnChanges(e) {
                        this.setInitialValue();
                    }
                    onModelChange(e) {
                        let i = this.item.value;
                        (this.item.value = e), this.lhcDataService.onItemValueChange(this.item, this.item.value, i);
                    }
                    setInitialValue() {
                        if (this.item) {
                            let e = this.item.value;
                            !0 === e
                                ? (this.booleanModels[0] = !0)
                                : !1 === e
                                ? (this.booleanModels[1] = !0)
                                : null == e && (this.booleanModels[2] = !0);
                        }
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-boolean']],
                        inputs: { item: 'item' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            ['role', 'radiogroup', 3, 'ngModelChange', 'click', 'ngModel', 'nzName'],
                            ['nz-radio', '', 3, 'ngModelChange', 'nzDisabled', 'disabled', 'nzValue', 'ngModel', 'id'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Coe, 11, 28, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, eo, Fs, Yx, qx, $o],
                        styles: [
                            '[_nghost-%COMP%]{display:block;padding:4.3125px 2px}\n\n/*# sourceMappingURL=lhc-item-boolean.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            const Moe = ['nzDatePickerComponent'];
            function Soe(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'nz-date-picker', 2, 0),
                        Gn(3, 'transloco'),
                        Gn(4, 'transloco'),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onModelChange(r));
                        }),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.item.value, r) || (s.item.value = r), pe(r);
                        }),
                        Le('focus', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        ct('id', e.item._elementId),
                        ct('nzPlaceHolder', ci(3, 6, e.item._placeholder)),
                        H('nzDisabled', e.item._readOnly)('nzFormat', ci(4, 8, 'MM/dd/yyyy')),
                        yi('ngModel', e.item.value),
                        zi('aria-required', e.item._answerRequired);
                }
            }
            let Toe = (() => {
                class t {
                    constructor(e, i) {
                        (this.lhcDataService = e), (this.commonUtilsService = i);
                    }
                    ngAfterViewInit() {
                        this.nzDatePickerComponent.pickerInput.nativeElement.setAttribute(
                            'aria-label',
                            this.commonUtilsService.getAriaLabel(this.item),
                        );
                    }
                    onModelChange(e) {
                        let i = this.item.value;
                        (this.item.value = e), this.lhcDataService.onItemValueChange(this.item, this.item.value, i);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi), te(kh));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-date']],
                        viewQuery: function (i, r) {
                            if ((1 & i && Fr(Moe, 5), 2 & i)) {
                                let s;
                                Dr((s = xr())) && (r.nzDatePickerComponent = s.first);
                            }
                        },
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            ['nzDatePickerComponent', ''],
                            [4, 'ngIf'],
                            [
                                'nzSize',
                                'small',
                                1,
                                'lhc-date-picker',
                                3,
                                'ngModelChange',
                                'focus',
                                'nzDisabled',
                                'id',
                                'nzFormat',
                                'nzPlaceHolder',
                                'ngModel',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Soe, 5, 10, 'ng-container', 1), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, eo, Fs, s5, $o],
                    }));
                }
                return t;
            })();
            function Doe(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'nz-time-picker', 1),
                        Gn(2, 'transloco'),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onModelChange(r));
                        })('focus', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        ct('id', e.item._elementId),
                        ct('nzPlaceHolder', ci(2, 5, e.item._placeholder)),
                        H('nzDisabled', e.item._readOnly)('ngModel', e.time),
                        zi('aria-required', e.item._answerRequired);
                }
            }
            let xoe = (() => {
                class t {
                    constructor(e, i, r) {
                        (this.lhcDataService = e), (this.elRef = i), (this.commonUtilsService = r), (this.time = null);
                    }
                    ngOnChanges() {
                        if (this.item.value) {
                            let e = new Date('1970-01-01 ' + this.item.value);
                            isNaN(e) || (this.time = e);
                        }
                    }
                    onModelChange(e) {
                        let i = this.item.value;
                        if (e) {
                            let r = e.toTimeString();
                            r &&
                                ((this.item.value = r.slice(0, 8)),
                                this.lhcDataService.onItemValueChange(this.item, this.item.value, i));
                        }
                    }
                    ngAfterViewInit() {
                        const e = this.elRef.nativeElement.querySelector('input');
                        e && e.setAttribute('aria-label', this.commonUtilsService.getAriaLabel(this.item));
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi), te(Pn), te(kh));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-time']],
                        inputs: { item: 'item' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [
                                'nzFormat',
                                'HH:mm:ss',
                                'nzSize',
                                'small',
                                1,
                                'lhc-time-picker',
                                3,
                                'ngModelChange',
                                'focus',
                                'nzDisabled',
                                'id',
                                'nzPlaceHolder',
                                'ngModel',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Doe, 3, 7, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, eo, Fs, Lx, $o],
                    }));
                }
                return t;
            })();
            const koe = ['nzDatePickerComponent'];
            function Eoe(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'nz-date-picker', 2, 0),
                        Gn(3, 'transloco'),
                        Gn(4, 'transloco'),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onModelChange(r));
                        }),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L();
                            return ki(s.item.value, r) || (s.item.value = r), pe(r);
                        }),
                        Le('nzOnOk', function (r) {
                            return me(e), pe(L().onOk(r));
                        })('focus', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        ee(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        ct('id', e.item._elementId),
                        ct('nzPlaceHolder', ci(3, 6, e.item._placeholder)),
                        H('nzDisabled', e.item._readOnly)('nzFormat', ci(4, 8, 'MM/dd/yyyy HH:mm:ss')),
                        yi('ngModel', e.item.value),
                        zi('aria-required', e.item._answerRequired);
                }
            }
            let Ioe = (() => {
                class t {
                    constructor(e, i) {
                        (this.lhcDataService = e), (this.commonUtilsService = i);
                    }
                    ngAfterViewInit() {
                        this.nzDatePickerComponent.pickerInput.nativeElement.setAttribute(
                            'aria-label',
                            this.commonUtilsService.getAriaLabel(this.item),
                        );
                    }
                    onOk(e) {}
                    onCalendarChange(e) {}
                    onModelChange(e) {
                        let i = this.item.value;
                        (this.item.value = e), this.lhcDataService.onItemValueChange(this.item, this.item.value, i, !0);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi), te(kh));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-datetime']],
                        viewQuery: function (i, r) {
                            if ((1 & i && Fr(koe, 5), 2 & i)) {
                                let s;
                                Dr((s = xr())) && (r.nzDatePickerComponent = s.first);
                            }
                        },
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            ['nzDatePickerComponent', ''],
                            [4, 'ngIf'],
                            [
                                'nzShowTime',
                                '',
                                'nzSize',
                                'small',
                                1,
                                'lhc-datetime-picker',
                                3,
                                'ngModelChange',
                                'nzOnOk',
                                'focus',
                                'nzDisabled',
                                'id',
                                'nzFormat',
                                'nzPlaceHolder',
                                'ngModel',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Eoe, 5, 10, 'ng-container', 1), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, eo, Fs, s5, $o],
                    }));
                }
                return t;
            })();
            function Aoe(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        Z(1, 'textarea', 1),
                        Gn(2, 'transloco'),
                        Le('ngModelChange', function (r) {
                            return me(e), pe(L().onModelChange(r));
                        })('blur', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        })('focus', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        Je(3, '  '),
                        ee(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        Bt('aria-labelledby', 'label-', e.item._elementId, ''),
                        ct('id', e.item._elementId),
                        ct('placeholder', ci(2, 7, e.item._placeholder)),
                        H('disabled', e.item._readOnly)('ngModel', e.item.value),
                        zi('aria-required', e.item._answerRequired);
                }
            }
            let Loe = (() => {
                class t {
                    constructor(e) {
                        this.lhcDataService = e;
                    }
                    onModelChange(e) {
                        let i = this.item.value;
                        (this.item.value = e), this.lhcDataService.onItemValueChange(this.item, this.item.value, i);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-text']],
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [3, 'ngModelChange', 'blur', 'focus', 'id', 'disabled', 'ngModel', 'placeholder'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Aoe, 4, 9, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, xa, eo, Fs, $o],
                    }));
                }
                return t;
            })();
            const Ooe = ['fileInput'];
            function zoe(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'label'),
                        Je(2, 'URL for file:'),
                        ee(),
                        Z(3, 'input', 5),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(3);
                            return ki(s.item._attachmentURL, r) || (s.item._attachmentURL = r), pe(r);
                        }),
                        Le('focus', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        })('blur', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        }),
                        ee(),
                        Z(4, 'input', 6),
                        Le('focus', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        })('blur', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        }),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(3);
                            return ki(s.item._attachmentName, r) || (s.item._attachmentName = r), pe(r);
                        }),
                        ee(),
                        Z(5, 'button', 7),
                        Le('click', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.createAttachment(r.item));
                        }),
                        Je(6),
                        ee(),
                        Oe(7, 'br'),
                        Je(
                            8,
                            ' Note: The URL you enter will not be downloaded or verified, but simply copied into your response. Please ensure that it works. ',
                        ),
                        ee();
                }
                if (2 & t) {
                    const e = L(3);
                    z(3),
                        H('disabled', e.item._readOnly),
                        yi('ngModel', e.item._attachmentURL),
                        z(),
                        H('disabled', e.item._readOnly),
                        yi('ngModel', e.item._attachmentName),
                        z(2),
                        jn(' Attach URL', e.item._fileInfo ? ' and file data' : '', '');
                }
            }
            function Poe(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div')(1, 'input', 3, 0),
                        Gn(3, 'transloco'),
                        Le('change', function (r) {
                            return me(e), pe(L(2).onChange(r));
                        })('focus', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        })('blur', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.activeRowOnBlur(r.item));
                        }),
                        ee(),
                        Z(4, 'button', 4),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe((r.item._useURL = !r.item._useURL));
                        }),
                        Je(5, '\u21af'),
                        ee(),
                        ue(6, zoe, 9, 5, 'div', 1),
                        ee();
                }
                if (2 & t) {
                    const e = L(2);
                    z(),
                        ct('placeholder', ci(3, 6, e.item._placeholder)),
                        ct('id', 'file-' + e.item._elementId),
                        H('name', e.item._text)('disabled', e.item._readOnly),
                        z(3),
                        ct('title', e.item._useURL ? 'Hide URL field' : 'Show URL field'),
                        z(2),
                        H('ngIf', e.item._useURL);
                }
            }
            function Noe(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'a', 10),
                        Le('click', function (r) {
                            me(e);
                            const s = L(3);
                            return pe(s.downloadAttachment(s.item.value, r));
                        }),
                        Je(1),
                        ee();
                }
                if (2 & t) {
                    const e = L(3);
                    ct('title', 'Download ' + e.item.value.title),
                        ct('download', e.item.title),
                        ct(
                            'href',
                            e.item.value.url && !e.item.value.data ? e.item.value.url : 'javascript:void(0)',
                            td,
                        ),
                        z(),
                        hn(e.item.value.title || e.item.value.url || 'Unknown filename');
                }
            }
            function Foe(t, n) {
                if (
                    (1 & t && (Z(0, 'span')(1, 'label'), Je(2, 'Download progress: '), Oe(3, 'progress', 11), ee()()),
                    2 & t)
                ) {
                    const e = L(3);
                    z(3), ct('value', e.item.value._progress);
                }
            }
            function Roe(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 12),
                        Le('click', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.removeAttachment(r.item));
                        }),
                        Je(1, '\u2716'),
                        ee();
                }
                2 & t && ct('title', 'Remove ' + L(3).item.value.title);
            }
            function Voe(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'span'),
                        ue(1, Noe, 2, 4, 'a', 8)(2, Foe, 4, 1, 'span', 1)(3, Roe, 2, 1, 'button', 9),
                        ee()),
                    2 & t)
                ) {
                    const e = L(2);
                    z(),
                        H('ngIf', !e.item.value._progress),
                        z(),
                        H('ngIf', e.item.value._progress),
                        z(),
                        H('ngIf', !e.item._readOnly);
                }
            }
            function Hoe(t, n) {
                if (
                    (1 & t && (Xe(0), Z(1, 'div', 2), ue(2, Poe, 7, 8, 'div', 1)(3, Voe, 4, 3, 'span', 1), ee(), Ze()),
                    2 & t)
                ) {
                    const e = L();
                    z(), ct('id', e.item._elementId), z(), H('ngIf', !e.item.value), z(), H('ngIf', e.item.value);
                }
            }
            let Uoe = (() => {
                class t {
                    constructor(e) {
                        this.lhcDataService = e;
                    }
                    onChange(e) {
                        const { files: i } = e.target;
                        if (i) {
                            let r = i[0];
                            const s = this.item;
                            if (r.type)
                                if (s.allowedAttachmentTypes && s.allowedAttachmentTypes.indexOf(r.type) < 0) {
                                    const o = s.allowedAttachmentTypes;
                                    alert(
                                        'The file ' +
                                            r.name +
                                            ' is not one of the mime types permitted by this questionnaire (' +
                                            o.slice(0, -1).join(', ') +
                                            ' and ' +
                                            o.slice(-1) +
                                            ').  Please make sure your file has an appropriate file extension for its type in its filename.',
                                    ),
                                        (r = null);
                                } else
                                    r.size > s.maxAttachmentSize
                                        ? (alert(
                                              'The file ' +
                                                  r.name +
                                                  ' exceeds the maximum attachment size of ' +
                                                  s.maxAttachmentSize +
                                                  ' bytes permitted by this questionnaire.  If you can specify the file with a URL, use the button to open the URL field and enter that instead.',
                                          ),
                                          (r = null))
                                        : r.size > 5e8 &&
                                          (confirm(
                                              'Adding a large file as an attachment might cause your computer to run low on memory.  There is a button to enter a URL instead of attaching the file data.  Are you sure you want to attach the file data?',
                                          ) ||
                                              (r = null));
                            else
                                alert('Unknown file type.  Please ensure the file has an appropriate extension'),
                                    (r = null);
                            r || (this.fileInput.nativeElement.value = ''),
                                (s._fileInfo = r),
                                r && !s._useURL && this.createAttachment(s);
                        }
                    }
                    removeAttachment(e) {
                        delete e.value,
                            delete e._attachmentName,
                            delete e._attachmentURL,
                            delete e._fileInfo,
                            delete e._useURL,
                            this.lhcDataService.onItemValueChange(this.item, null, null, !0);
                    }
                    createAttachment(e) {
                        if (e._fileInfo || e._attachmentURL) {
                            e.value = { title: e._attachmentName || e._fileInfo?.name };
                            const i = e.value;
                            if ((e._attachmentURL && (i.url = e._attachmentURL), e._fileInfo)) {
                                const r = e._fileInfo;
                                (i.contentType = r.type),
                                    r.lastModified
                                        ? (i.creation = new Date(r.lastModified).toISOString())
                                        : r.lastModifiedDate && (i.creation = r.lastModifiedDate.toISOString()),
                                    (e.value._progress = 0.001);
                                const s = new FileReader();
                                (s.onload = o => {
                                    const a = o.target.result,
                                        l = a.indexOf(',');
                                    if (0 !== a.indexOf('data:') || l < 0)
                                        throw (
                                            (alert('Unable to attach the file data.'),
                                            new Error(
                                                'data URL did not start with expected prefix, but with ' +
                                                    a.slice(0, 30),
                                            ))
                                        );
                                    delete i._progress,
                                        (i.data = a.slice(l + 1)),
                                        this.lhcDataService.onItemValueChange(this.item, null, null, !0);
                                }),
                                    (s.onprogress = o => {
                                        e._progress = o.loaded / o.total;
                                    }),
                                    s.readAsDataURL(r);
                            } else this.lhcDataService.onItemValueChange(this.item, null, null, !0);
                        } else alert('An attachment must have either a file or a URL (or both).');
                    }
                    downloadAttachment(e, i) {
                        if (e.data) {
                            const r = i.target,
                                s = r.href;
                            (r.href = 'data:' + (e.contentType ? e.contentType : '') + ';base64,' + e.data),
                                (r.download = e.title),
                                setTimeout(() => {
                                    r.href = s;
                                }, 0);
                        }
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-attachment']],
                        viewQuery: function (i, r) {
                            if ((1 & i && Fr(Ooe, 5), 2 & i)) {
                                let s;
                                Dr((s = xr())) && (r.fileInput = s.first);
                            }
                        },
                        inputs: { item: 'item', labelledBy: 'labelledBy' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            ['fileInput', ''],
                            [4, 'ngIf'],
                            [3, 'id'],
                            [
                                'type',
                                'file',
                                1,
                                'lhc-attachment-upload',
                                3,
                                'change',
                                'focus',
                                'blur',
                                'name',
                                'placeholder',
                                'disabled',
                                'id',
                            ],
                            [
                                'type',
                                'button',
                                1,
                                'lhc-attachment-button',
                                'toggle-attachment-fields',
                                3,
                                'click',
                                'title',
                            ],
                            [
                                'type',
                                'text',
                                'placeholder',
                                'URL for retrieving file',
                                1,
                                'lhc-attachment-url',
                                3,
                                'ngModelChange',
                                'focus',
                                'blur',
                                'disabled',
                                'ngModel',
                            ],
                            [
                                'type',
                                'text',
                                'placeholder',
                                'File name (optional)',
                                1,
                                'lhc-attachment-name',
                                3,
                                'focus',
                                'blur',
                                'ngModelChange',
                                'disabled',
                                'ngModel',
                            ],
                            ['type', 'button', 1, 'lf-float-button', 'attach-button', 3, 'click'],
                            [
                                'button',
                                '',
                                'target',
                                '_blank',
                                'rel',
                                'noreferrer',
                                'class',
                                'download-link',
                                3,
                                'title',
                                'download',
                                'href',
                                'click',
                                4,
                                'ngIf',
                            ],
                            [
                                'class',
                                'lhc-attachment-button lf-remove-attachment',
                                'type',
                                'button',
                                3,
                                'title',
                                'click',
                                4,
                                'ngIf',
                            ],
                            [
                                'button',
                                '',
                                'target',
                                '_blank',
                                'rel',
                                'noreferrer',
                                1,
                                'download-link',
                                3,
                                'click',
                                'title',
                                'download',
                                'href',
                            ],
                            [3, 'value'],
                            ['type', 'button', 1, 'lhc-attachment-button', 'lf-remove-attachment', 3, 'click', 'title'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Hoe, 4, 3, 'ng-container', 1), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [hi, xa, eo, Fs, $o],
                        styles: [
                            'input[type=file][_ngcontent-%COMP%]{border:1px solid gray;display:inline}.lhc-attachment-button[_ngcontent-%COMP%], .attach-button[_ngcontent-%COMP%]{padding-left:.25em;padding-right:.25em;border-radius:4px;margin-left:.5em;min-width:22px;color:#fff;border:none;background-color:#066aa0;vertical-align:top}.lhc-attachment-url[_ngcontent-%COMP%], .lhc-attachment-name[_ngcontent-%COMP%]{width:inherit!important}progress[_ngcontent-%COMP%]{vertical-align:text-bottom}.download-link[_ngcontent-%COMP%]{margin-left:5px}.lhc-button[_ngcontent-%COMP%]{border:0 none;cursor:pointer;overflow:visible;padding:0;position:relative;background-color:#066aa0}.lf-rm-attachment-button[_ngcontent-%COMP%]:hover{color:#0087fd}\n\n/*# sourceMappingURL=lhc-item-attachment.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            function Boe(t, n) {
                if ((1 & t && (Z(0, 'div', 5), Je(1), ee()), 2 & t)) {
                    const e = n.$implicit;
                    z(), jn('Error: ', e.value, '');
                }
            }
            function qoe(t, n) {
                if ((1 & t && (Xe(0), ue(1, Boe, 2, 1, 'div', 4), Gn(2, 'keyvalue'), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), H('ngForOf', ci(2, 1, e.value.errors));
                }
            }
            function Yoe(t, n) {
                if ((1 & t && (Z(0, 'div', 7), Je(1), ee()), 2 & t)) {
                    const e = n.$implicit;
                    z(), jn('Warning: ', e.value, '');
                }
            }
            function joe(t, n) {
                if ((1 & t && (Xe(0), ue(1, Yoe, 2, 1, 'div', 6), Gn(2, 'keyvalue'), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), H('ngForOf', ci(2, 1, e.value.warnings));
                }
            }
            function $oe(t, n) {
                if ((1 & t && (Z(0, 'div', 9), Je(1), ee()), 2 & t)) {
                    const e = n.$implicit;
                    z(), hn(e.value);
                }
            }
            function Goe(t, n) {
                if ((1 & t && (Xe(0), ue(1, $oe, 2, 1, 'div', 8), Gn(2, 'keyvalue'), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), H('ngForOf', ci(2, 1, e.value.info));
                }
            }
            function Woe(t, n) {
                if (
                    (1 & t &&
                        (Xe(0),
                        ue(1, qoe, 3, 3, 'ng-container', 3)(2, joe, 3, 3, 'ng-container', 3)(
                            3,
                            Goe,
                            3,
                            3,
                            'ng-container',
                            3,
                        ),
                        Ze()),
                    2 & t)
                ) {
                    const e = L(2);
                    z(), H('ngIf', e.showErrors()), z(), H('ngIf', e.showWarnings()), z(), H('ngIf', e.showInfo());
                }
            }
            function Koe(t, n) {
                if ((1 & t && (Z(0, 'div', 1), ue(1, Woe, 4, 3, 'ng-container', 2), Gn(2, 'keyvalue'), ee()), 2 & t)) {
                    const e = L();
                    z(), H('ngForOf', ci(2, 1, e.item.messages));
                }
            }
            let Ok = (() => {
                class t {
                    constructor(e) {
                        this.lhcDataService = e;
                    }
                    ngOnInit() {}
                    showErrors() {
                        return this.lhcDataService.getLhcFormData()._showErrors;
                    }
                    showWarnings() {
                        return this.lhcDataService.getLhcFormData()._showWarnings;
                    }
                    showInfo() {
                        return this.lhcDataService.getLhcFormData()._showInfo;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-messages']],
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            ['role', 'alert', 4, 'ngIf'],
                            ['role', 'alert'],
                            [4, 'ngFor', 'ngForOf'],
                            [4, 'ngIf'],
                            ['class', 'lhc-item-error', 'ng-container', '', 4, 'ngFor', 'ngForOf'],
                            ['ng-container', '', 1, 'lhc-item-error'],
                            ['class', 'lhc-item-warning', 'ng-container', '', 4, 'ngFor', 'ngForOf'],
                            ['ng-container', '', 1, 'lhc-item-warning'],
                            ['class', 'lhc-item-info', 'ng-container', '', 4, 'ngFor', 'ngForOf'],
                            ['ng-container', '', 1, 'lhc-item-info'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Koe, 3, 3, 'div', 0), 2 & i && H('ngIf', r.item.messages);
                        },
                        dependencies: [oa, hi, FC],
                        styles: [
                            '.lhc-item-error[_ngcontent-%COMP%]:before{content:"\\26a0";color:red;margin-left:3px;margin-right:6px;font-weight:700}.lhc-item-error[_ngcontent-%COMP%]{background-color:orange;margin:2px 0 2px 2px;border-radius:4px;padding:2px 4px}.lhc-item-warning[_ngcontent-%COMP%]{background-color:#ffffe0}.lhc-item-warning[_ngcontent-%COMP%]:before{content:"\\26a0";color:orange;margin-left:3px;margin-right:6px;font-weight:700}.lhc-item-info[_ngcontent-%COMP%]:before{content:"\\1f6c8";margin-right:6px}\n\n/*# sourceMappingURL=lhc-item-messages.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            const Qoe = ['deInput'];
            function Xoe(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 12),
                        Le('click', function () {
                            me(e);
                            const r = L(3);
                            return pe(r.lhcDataService.removeOneRepeatingItem(r.item));
                        }),
                        Je(1, '-'),
                        ee();
                }
                if (2 & t) {
                    const e = L(3);
                    Mn('id', 'del-', e.item._elementId, ''),
                        Mn('title', window.lhcTranslationsFn('removeThis'), e.item._text, '"'),
                        H('disabled', e.item._readOnly);
                }
            }
            function Zoe(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'div', 9),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        Oe(1, 'lhc-item-question-text', 8),
                        Z(2, 'div', 10),
                        ue(3, Xoe, 2, 5, 'button', 11),
                        ee()();
                }
                if (2 & t) {
                    const e = L(2);
                    z(), H('item', e.item), z(2), H('ngIf', !e.lhcDataService.hasOneRepeatingItem(e.item));
                }
            }
            function Joe(t, n) {
                1 & t && Oe(0, 'lhc-item-simple-type', 8), 2 & t && H('item', L(3).item);
            }
            function eae(t, n) {
                1 & t && Oe(0, 'lhc-item-choice', 8), 2 & t && H('item', L(3).item);
            }
            function tae(t, n) {
                if (
                    (1 & t &&
                        (Xe(0),
                        ue(1, Joe, 1, 1, 'lhc-item-simple-type', 13)(2, eae, 1, 1, 'lhc-item-choice', 13),
                        Ze()),
                    2 & t)
                ) {
                    const e = L(2);
                    z(), H('ngIf', !e.item._hasAnswerList), z(), H('ngIf', e.item._hasAnswerList);
                }
            }
            function nae(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-simple-type', 8), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function iae(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-quantity', 8), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function rae(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-choice', 8), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function sae(t, n) {
                1 & t && Oe(0, 'lhc-item-date', 8), 2 & t && H('item', L(3).item);
            }
            function oae(t, n) {
                1 & t && Oe(0, 'lhc-item-choice', 8), 2 & t && H('item', L(3).item);
            }
            function aae(t, n) {
                if (
                    (1 & t && (Xe(0), ue(1, sae, 1, 1, 'lhc-item-date', 13)(2, oae, 1, 1, 'lhc-item-choice', 13), Ze()),
                    2 & t)
                ) {
                    const e = L(2);
                    z(), H('ngIf', !e.item._hasAnswerList), z(), H('ngIf', e.item._hasAnswerList);
                }
            }
            function lae(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-datetime', 8), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function cae(t, n) {
                1 & t && Oe(0, 'lhc-item-time', 8), 2 & t && H('item', L(3).item);
            }
            function uae(t, n) {
                1 & t && Oe(0, 'lhc-item-choice', 8), 2 & t && H('item', L(3).item);
            }
            function dae(t, n) {
                if (
                    (1 & t && (Xe(0), ue(1, cae, 1, 1, 'lhc-item-time', 13)(2, uae, 1, 1, 'lhc-item-choice', 13), Ze()),
                    2 & t)
                ) {
                    const e = L(2);
                    z(), H('ngIf', !e.item._hasAnswerList), z(), H('ngIf', e.item._hasAnswerList);
                }
            }
            function hae(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-boolean', 8), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function fae(t, n) {
                1 & t && Oe(0, 'lhc-input', 8), 2 & t && H('item', L(3).item);
            }
            function mae(t, n) {
                1 & t && Oe(0, 'lhc-item-choice', 8), 2 & t && H('item', L(3).item);
            }
            function pae(t, n) {
                if (
                    (1 & t && (Xe(0), ue(1, fae, 1, 1, 'lhc-input', 13)(2, mae, 1, 1, 'lhc-item-choice', 13), Ze()),
                    2 & t)
                ) {
                    const e = L(2);
                    z(), H('ngIf', !e.item._hasAnswerList), z(), H('ngIf', e.item._hasAnswerList);
                }
            }
            function gae(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-text', 8), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function vae(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-item-attachment', 8), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function _ae(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-input', 8), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function yae(t, n) {
                if (1 & t) {
                    const e = st();
                    Xe(0),
                        ue(1, Zoe, 4, 2, 'div', 1),
                        Z(2, 'div', 2),
                        Le('click', function () {
                            me(e);
                            const r = L();
                            return pe(r.lhcDataService.setActiveRow(r.item));
                        }),
                        Z(3, 'div', 3),
                        Oe(4, 'lhc-validate', 4),
                        Xe(5, 5),
                        ue(6, tae, 3, 2, 'ng-container', 6)(7, nae, 2, 1, 'ng-container', 6)(
                            8,
                            iae,
                            2,
                            1,
                            'ng-container',
                            6,
                        )(9, rae, 2, 1, 'ng-container', 6)(10, aae, 3, 2, 'ng-container', 6)(
                            11,
                            lae,
                            2,
                            1,
                            'ng-container',
                            6,
                        )(12, dae, 3, 2, 'ng-container', 6)(13, hae, 2, 1, 'ng-container', 6)(
                            14,
                            pae,
                            3,
                            2,
                            'ng-container',
                            6,
                        )(15, gae, 2, 1, 'ng-container', 6)(16, vae, 2, 1, 'ng-container', 6)(
                            17,
                            _ae,
                            2,
                            1,
                            'ng-container',
                            7,
                        ),
                        Ze(),
                        Oe(18, 'lhc-item-messages', 8),
                        ee()(),
                        Ze();
                }
                if (2 & t) {
                    const e = L();
                    z(),
                        H('ngIf', !e.options || !e.options.hideQuestionText),
                        z(),
                        H('ngStyle', e.options && e.options.hideQuestionText ? null : e.eleStyle),
                        z(2),
                        H('item', e.item)('value', e.item.value),
                        z(),
                        H('ngSwitch', e.item.dataType),
                        z(),
                        H('ngSwitchCase', 'INT'),
                        z(),
                        H('ngSwitchCase', 'REAL'),
                        z(),
                        H('ngSwitchCase', 'QTY'),
                        z(),
                        H('ngSwitchCase', 'CODING'),
                        z(),
                        H('ngSwitchCase', 'DT'),
                        z(),
                        H('ngSwitchCase', 'DTM'),
                        z(),
                        H('ngSwitchCase', 'TM'),
                        z(),
                        H('ngSwitchCase', 'BL'),
                        z(),
                        H('ngSwitchCase', 'ST'),
                        z(),
                        H('ngSwitchCase', 'TX'),
                        z(),
                        H('ngSwitchCase', 'attachment'),
                        z(2),
                        H('item', e.item);
                }
            }
            let zk = (() => {
                class t {
                    constructor(e, i) {
                        (this.winService = e), (this.lhcDataService = i), (this.eleStyle = null);
                    }
                    ngOnInit() {
                        this.winService.windowWidth.subscribe(e => {
                            let i = this.winService.getViewMode(),
                                r = this.lhcDataService.getItemViewModeClass(this.item, i);
                            this.eleStyle = 'lhc-item-view-lg' === r ? { width: e / 2 + 'px' } : null;
                        });
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Dh), te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-item-question']],
                        viewQuery: function (i, r) {
                            if ((1 & i && Fr(Qoe, 5), 2 & i)) {
                                let s;
                                Dr((s = xr())) && (r.deInputElement = s.first);
                            }
                        },
                        inputs: { item: 'item', options: 'options' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            ['class', 'lhc-de-label-button', 3, 'click', 4, 'ngIf'],
                            [1, 'lhc-de-input-unit', 3, 'click', 'ngStyle'],
                            [1, 'lhc-de-input-unit-content'],
                            [3, 'item', 'value'],
                            [3, 'ngSwitch'],
                            [4, 'ngSwitchCase'],
                            [4, 'ngSwitchDefault'],
                            [3, 'item'],
                            [1, 'lhc-de-label-button', 3, 'click'],
                            [1, 'lhc-de-button'],
                            [
                                'class',
                                'lhc-float-button lhc-button',
                                'type',
                                'button',
                                3,
                                'id',
                                'title',
                                'disabled',
                                'click',
                                4,
                                'ngIf',
                            ],
                            [
                                'type',
                                'button',
                                1,
                                'lhc-float-button',
                                'lhc-button',
                                3,
                                'click',
                                'id',
                                'title',
                                'disabled',
                            ],
                            [3, 'item', 4, 'ngIf'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, yae, 19, 17, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [
                            hi,
                            mc,
                            Ho,
                            Ta,
                            Bd,
                            aoe,
                            doe,
                            M5,
                            goe,
                            boe,
                            woe,
                            Toe,
                            xoe,
                            Ioe,
                            Loe,
                            xh,
                            Uoe,
                            Ok,
                        ],
                        styles: [
                            '[_nghost-%COMP%]{border:solid;border-color:#ced5d9;border-width:1px 0 0 0;margin:0 4px 0 2px;padding-left:2px}.lhc-de-input-unit-content[_ngcontent-%COMP%]{width:100%}.lhc-error-icon[_ngcontent-%COMP%]{color:red;font-weight:700}.lhc-error-msg[_ngcontent-%COMP%]{color:red}.lhc-error-msg[_ngcontent-%COMP%], .lhc-error-item[_ngcontent-%COMP%]{margin-left:.5em}.lhc-validate-class[_ngcontent-%COMP%]{background-color:#fcf8e3}\n\n/*# sourceMappingURL=lhc-item-question.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            const bae = () => ({ hideQuestionText: !0 });
            function Cae(t, n) {
                if ((1 & t && (Z(0, 'div', 9), Oe(1, 'lhc-item-question-text', 10), ee()), 2 & t)) {
                    const e = L(3);
                    ct('ng-attr-role', e.item.header ? 'heading' : void 0),
                        ct('ng-attr-aria-level', e.item.header ? e.item._displayLevel + 1 : void 0),
                        z(),
                        H('item', e.item);
                }
            }
            function wae(t, n) {
                1 & t && Oe(0, 'col', 11);
            }
            function Mae(t, n) {
                if ((1 & t && Oe(0, 'col', 13), 2 & t)) {
                    const e = L().$implicit;
                    H('ngStyle', L(3).lhcDataService.getTableColumnStyle(e));
                }
            }
            function Sae(t, n) {
                if ((1 & t && (Xe(0), ue(1, Mae, 1, 1, 'col', 12), Ze()), 2 & t)) {
                    const e = n.$implicit;
                    z(), H('ngIf', !e.item._isHiddenFromView);
                }
            }
            function Tae(t, n) {
                1 & t && Oe(0, 'th', 14);
            }
            function Dae(t, n) {
                if ((1 & t && (Z(0, 'th', 16), Oe(1, 'lhc-item-question-text', 10), ee()), 2 & t)) {
                    const e = L().$implicit;
                    ct('id', e.id), z(), H('item', e.item);
                }
            }
            function xae(t, n) {
                if ((1 & t && (Xe(0), ue(1, Dae, 2, 2, 'th', 15), Ze()), 2 & t)) {
                    const e = n.$implicit;
                    z(), H('ngIf', !e.item._isHiddenFromView);
                }
            }
            function kae(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 19),
                        Le('click', function () {
                            me(e);
                            const r = L(2).$implicit;
                            return pe(L(3).lhcDataService.removeOneRepeatingItem(r.header));
                        }),
                        Je(1, '-'),
                        ee();
                }
                if (2 & t) {
                    const e = L(2).$implicit,
                        i = L(3);
                    Mn('id', 'del-', e.header._elementId, ''),
                        Mn('title', 'Remove this row of "', e.header.question, '"'),
                        H('disabled', i.item._readOnly);
                }
            }
            function Eae(t, n) {
                if ((1 & t && (Z(0, 'td', 11), ue(1, kae, 2, 5, 'button', 18), ee()), 2 & t)) {
                    const e = L(4);
                    z(), H('ngIf', !e.lhcDataService.hasOneRepeatingItem(e.item));
                }
            }
            function Iae(t, n) {
                if ((1 & t && (Z(0, 'td')(1, 'div', 20), Oe(2, 'lhc-item-question', 21), ee()()), 2 & t)) {
                    const e = L().$implicit,
                        i = L(4);
                    (function N_(t, n, e, i, r, s, o) {
                        wa(br, il, I1(Ie(), t, n, e, i, r, s, o), !0);
                    })(
                        '',
                        i.lhcDataService.getRowClass(e),
                        ' ',
                        i.lhcDataService.getSkipLogicClass(e),
                        ' ',
                        i.lhcDataService.getActiveRowClass(e),
                        '',
                    ),
                        z(2),
                        H('item', e)('options', B1(7, bae));
                }
            }
            function Aae(t, n) {
                if ((1 & t && (Xe(0), ue(1, Iae, 3, 8, 'td', 1), Ze()), 2 & t)) {
                    const e = n.$implicit;
                    z(), H('ngIf', !e._isHiddenFromView);
                }
            }
            function Lae(t, n) {
                if (
                    (1 & t && (Z(0, 'tr', 17), ue(1, Eae, 2, 1, 'td', 4)(2, Aae, 2, 1, 'ng-container', 5), ee()), 2 & t)
                ) {
                    const e = n.$implicit,
                        i = L(3);
                    z(),
                        H(
                            'ngIf',
                            i.item._questionRepeatable &&
                                i.lhcDataService.getHorizontalTableInfo()[i.item._horizontalTableId].tableRows.length >
                                    1,
                        ),
                        z(),
                        H('ngForOf', e.cells)('ngForTrackBy', i.lhcDataService.trackByElementId);
                }
            }
            function Oae(t, n) {
                if ((1 & t && (Z(0, 'div'), Oe(1, 'lhc-button-popover', 22), ee()), 2 & t)) {
                    const e = L(3);
                    dt('lhc-button-padding ', e.lhcDataService.getSkipLogicClass(e.item), ''),
                        z(),
                        Mn('buttonLabel', '+ ', e.item._text, ''),
                        H('item', e.item)('popoverType', 'repeating-item')('append', !0);
                }
            }
            function zae(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'div'),
                        ue(1, Cae, 2, 3, 'div', 2),
                        Z(2, 'table', 3)(3, 'colgroup'),
                        ue(4, wae, 1, 0, 'col', 4)(5, Sae, 2, 1, 'ng-container', 5),
                        ee(),
                        Z(6, 'thead')(7, 'tr'),
                        ue(8, Tae, 1, 0, 'th', 6)(9, xae, 2, 1, 'ng-container', 5),
                        ee()(),
                        Z(10, 'tbody', 7),
                        ue(11, Lae, 3, 3, 'tr', 8),
                        ee()(),
                        ue(12, Oae, 2, 8, 'div', 1),
                        ee()),
                    2 & t)
                ) {
                    const e = L(2);
                    dt('lhc-layout-horizontal ', e.lhcDataService.getSiblingStatus(e.item), ' '),
                        z(),
                        H('ngIf', !e.formLevel),
                        z(3),
                        H(
                            'ngIf',
                            e.item._questionRepeatable &&
                                e.lhcDataService.getHorizontalTableInfo()[e.item._horizontalTableId].tableRows.length >
                                    1,
                        ),
                        z(),
                        H(
                            'ngForOf',
                            e.lhcDataService.getHorizontalTableInfo()[e.item._horizontalTableId].columnHeaders,
                        )('ngForTrackBy', e.lhcDataService.trackByColumnHeaderId),
                        z(3),
                        H(
                            'ngIf',
                            e.item._questionRepeatable &&
                                e.lhcDataService.getHorizontalTableInfo()[e.item._horizontalTableId].tableRows.length >
                                    1,
                        ),
                        z(),
                        H(
                            'ngForOf',
                            e.lhcDataService.getHorizontalTableInfo()[e.item._horizontalTableId].columnHeaders,
                        )('ngForTrackBy', e.lhcDataService.trackByColumnHeaderId),
                        z(2),
                        H('ngForOf', e.lhcDataService.getHorizontalTableInfo()[e.item._horizontalTableId].tableRows)(
                            'ngForTrackBy',
                            e.lhcDataService.trackByRowHeaderElementId,
                        ),
                        z(),
                        H(
                            'ngIf',
                            e.item._questionRepeatable &&
                                e.lhcDataService.targetEnabled(e.item) &&
                                !e.item._isHiddenFromView,
                        );
                }
            }
            function Pae(t, n) {
                if ((1 & t && (Xe(0), ue(1, zae, 13, 13, 'div', 1), Ze()), 2 & t)) {
                    const e = L();
                    z(),
                        H(
                            'ngIf',
                            e.item._horizontalTableHeader &&
                                e.lhcDataService.getHorizontalTableInfo()[e.item._horizontalTableId],
                        );
                }
            }
            let Pk = (() => {
                class t {
                    constructor(e) {
                        (this.lhcDataService = e), (this.formLevel = !1);
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-group-horizontal']],
                        inputs: { item: 'item', formLevel: 'formLevel' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [3, 'class', 4, 'ngIf'],
                            [
                                'class',
                                'lhc-form-horizontal-table-title',
                                3,
                                'ng-attr-role',
                                'ng-attr-aria-level',
                                4,
                                'ngIf',
                            ],
                            [1, 'lhc-form-horizontal-table'],
                            ['class', 'lhc-de-button', 4, 'ngIf'],
                            [4, 'ngFor', 'ngForOf', 'ngForTrackBy'],
                            ['class', 'lhc-form-horizontal-table-header', 4, 'ngIf'],
                            ['id', '', 1, ''],
                            ['class', 'lhc-data-row has-ng-animate', 4, 'ngFor', 'ngForOf', 'ngForTrackBy'],
                            [1, 'lhc-form-horizontal-table-title', 3, 'ng-attr-role', 'ng-attr-aria-level'],
                            [3, 'item'],
                            [1, 'lhc-de-button'],
                            [3, 'ngStyle', 4, 'ngIf'],
                            [3, 'ngStyle'],
                            [1, 'lhc-form-horizontal-table-header'],
                            ['class', 'lhc-form-horizontal-table-header', 3, 'id', 4, 'ngIf'],
                            [1, 'lhc-form-horizontal-table-header', 3, 'id'],
                            [1, 'lhc-data-row', 'has-ng-animate'],
                            [
                                'type',
                                'button',
                                'class',
                                'lhc-float-button lhc-button',
                                3,
                                'id',
                                'disabled',
                                'title',
                                'click',
                                4,
                                'ngIf',
                            ],
                            [
                                'type',
                                'button',
                                1,
                                'lhc-float-button',
                                'lhc-button',
                                3,
                                'click',
                                'id',
                                'disabled',
                                'title',
                            ],
                            [1, 'lf-form-item-data', 'tooltipContainer'],
                            [1, 'lhc-de', 3, 'item', 'options'],
                            [3, 'item', 'popoverType', 'buttonLabel', 'append'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Pae, 2, 1, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [oa, hi, mc, xh, zk, Th],
                        styles: [
                            '.lhc-form-horizontal-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:top}\n\n/*# sourceMappingURL=lhc-group-horizontal.component.css.map*/',
                        ],
                    }));
                }
                return t;
            })();
            function Nae(t, n) {
                if ((1 & t && (Z(0, 'div', 10), Oe(1, 'lhc-item-question-text', 11), ee()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function Fae(t, n) {
                1 & t && Oe(0, 'col');
            }
            function Rae(t, n) {
                1 & t && Oe(0, 'col', 12);
            }
            function Vae(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), hn(e._displayTextHTML);
                }
            }
            function Hae(t, n) {
                1 & t && (Oe(0, 'span', 17), Gn(1, 'safeHtml')),
                    2 & t && H('outerHTML', ci(1, 1, L().$implicit._displayTextHTML), No);
            }
            function Uae(t, n) {
                if ((1 & t && (Xe(0), Je(1), Ze()), 2 & t)) {
                    const e = L().$implicit;
                    z(), hn(e._displayText);
                }
            }
            function Bae(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'th', 13),
                        Xe(1, 14),
                        ue(2, Vae, 2, 1, 'ng-container', 15)(3, Hae, 2, 3, 'span', 16)(
                            4,
                            Uae,
                            2,
                            1,
                            'ng-container',
                            15,
                        ),
                        Ze(),
                        ee()),
                    2 & t)
                ) {
                    const e = n.$implicit,
                        i = L(2);
                    Mn('id', 'answer-', i.index, ''),
                        z(),
                        H('ngSwitch', i.lhcDataService.getTextDisplayType(e)),
                        z(),
                        H('ngSwitchCase', 'escaped'),
                        z(),
                        H('ngSwitchCase', 'html'),
                        z(),
                        H('ngSwitchCase', 'plain');
                }
            }
            function qae(t, n) {
                1 & t && (Z(0, 'th', 18), Je(1, 'Other'), ee());
            }
            function Yae(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'label')(1, 'input', 26),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L().index,
                                o = L(2).$implicit;
                            return ki(o._checkboxModels[s], r) || (o._checkboxModels[s] = r), pe(r);
                        }),
                        Le('ngModelChange', function () {
                            me(e);
                            const r = L(3).$implicit;
                            return pe(L(2).updateCheckboxListValue(r));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L(),
                        i = e.$implicit,
                        r = e.index,
                        s = L(2).$implicit,
                        o = L(2);
                    z(),
                        Dd('aria-label', '', i.text, ' for ', s.question, ''),
                        H('disabled', o.item._readOnly)('id', o.lhcDataService.getItemAnswerId(s, i)),
                        yi('ngModel', s._checkboxModels[r]);
                }
            }
            function jae(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'label')(1, 'input', 27),
                        Le('change', function () {
                            me(e);
                            const r = L().$implicit,
                                s = L(2).$implicit;
                            return pe(L(2).updateRadioListValue(s, r));
                        }),
                        ee()();
                }
                if (2 & t) {
                    const e = L().$implicit,
                        i = L(2).$implicit,
                        r = L(2);
                    z(),
                        Dd('aria-label', '', e.text, ' for ', i.question, ''),
                        ct('name', i._elementId),
                        H('disabled', r.item._readOnly)('id', r.lhcDataService.getItemAnswerId(i, e))(
                            'ngModel',
                            i.value,
                        )('value', e);
                }
            }
            function $ae(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'td', 23)(1, 'span', 24),
                        ue(2, Yae, 2, 6, 'label', 25)(3, jae, 2, 8, 'label', 25),
                        ee()()),
                    2 & t)
                ) {
                    const e = L(4);
                    z(2), H('ngIf', e.isCheckbox), z(), H('ngIf', !e.isCheckbox);
                }
            }
            function Gae(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'span', 24)(1, 'label')(2, 'input', 26),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(3).$implicit;
                            return ki(s._answerOtherChecked, r) || (s._answerOtherChecked = r), pe(r);
                        }),
                        Le('ngModelChange', function () {
                            me(e);
                            const r = L(3).$implicit;
                            return pe(L(2).updateCheckboxListValue(r));
                        }),
                        ee()(),
                        Z(3, 'label')(4, 'input', 30),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(3).$implicit;
                            return ki(s._answerOther, r) || (s._answerOther = r), pe(r);
                        }),
                        Le('ngModelChange', function () {
                            me(e);
                            const r = L(3).$implicit;
                            return pe(L(2).updateCheckboxListValue(r));
                        }),
                        ee()()();
                }
                if (2 & t) {
                    const e = L(3).$implicit,
                        i = L(2);
                    z(2),
                        Bt('aria-label', 'Other values for ', e.question, ''),
                        ct('id', e._elementId + '_other'),
                        H('disabled', i.item._readOnly),
                        yi('ngModel', e._answerOtherChecked),
                        z(2),
                        Bt('aria-label', 'Other values for ', e.question, ''),
                        ct('id', e._elementId + '_otherValue'),
                        H('disabled', i.item._readOnly),
                        yi('ngModel', e._answerOther);
                }
            }
            function Wae(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'span', 24)(1, 'label')(2, 'input', 31),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(3).$implicit;
                            return ki(s._answerOtherChecked, r) || (s._answerOtherChecked = r), pe(r);
                        }),
                        Le('change', function () {
                            me(e);
                            const r = L(3).$implicit;
                            return pe(L(2).updateRadioListValueForOther(r, r._answerOther));
                        }),
                        ee()(),
                        Z(3, 'label')(4, 'input', 30),
                        bi('ngModelChange', function (r) {
                            me(e);
                            const s = L(3).$implicit;
                            return ki(s._answerOther, r) || (s._answerOther = r), pe(r);
                        }),
                        Le('ngModelChange', function () {
                            me(e);
                            const r = L(3).$implicit;
                            return pe(L(2).updateRadioListValueForOther(r, r._answerOther));
                        }),
                        ee()()();
                }
                if (2 & t) {
                    const e = L(3).$implicit,
                        i = L(2);
                    z(2),
                        Bt('aria-label', 'Other values for ', e.question, ''),
                        ct('id', e._elementId + '_other'),
                        ct('name', e._elementId),
                        H('disabled', i.item._readOnly),
                        yi('ngModel', e._answerOtherChecked),
                        H('value', !0),
                        z(2),
                        Bt('aria-label', 'Other values for ', e.question, ''),
                        ct('id', e._elementId + '_otherValue'),
                        H('disabled', i.item._readOnly),
                        yi('ngModel', e._answerOther);
                }
            }
            function Kae(t, n) {
                if (
                    (1 & t && (Z(0, 'td', 28), ue(1, Gae, 5, 10, 'span', 29)(2, Wae, 5, 12, 'span', 29), ee()), 2 & t)
                ) {
                    const e = L(4);
                    z(), H('ngIf', e.isCheckbox), z(), H('ngIf', !e.isCheckbox);
                }
            }
            function Qae(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'tr', 20)(1, 'td', 3),
                        Oe(2, 'lhc-item-question-text', 11)(3, 'lhc-item-messages', 11),
                        ee(),
                        ue(4, $ae, 4, 2, 'td', 21)(5, Kae, 3, 2, 'td', 22),
                        ee()),
                    2 & t)
                ) {
                    const e = L().$implicit,
                        i = L(2);
                    z(2),
                        H('item', e),
                        z(),
                        H('item', e),
                        z(),
                        H('ngForOf', i.item.items[0].answers),
                        z(),
                        H('ngIf', 'optionsOrString' === e.answerConstraint);
                }
            }
            function Xae(t, n) {
                if ((1 & t && (Xe(0), ue(1, Qae, 6, 4, 'tr', 19), Ze()), 2 & t)) {
                    const e = n.$implicit;
                    z(), H('ngIf', !e._isHiddenFromView);
                }
            }
            function Zae(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'div'),
                        ue(1, Nae, 2, 1, 'div', 1),
                        Z(2, 'table', 2)(3, 'colgroup'),
                        Oe(4, 'col', 3),
                        ue(5, Fae, 1, 0, 'col', 4)(6, Rae, 1, 0, 'col', 5),
                        ee(),
                        Z(7, 'thead')(8, 'tr', 6),
                        Oe(9, 'th', 3),
                        ue(10, Bae, 5, 6, 'th', 7)(11, qae, 2, 0, 'th', 8),
                        ee()(),
                        Z(12, 'tbody'),
                        ue(13, Xae, 2, 1, 'ng-container', 9),
                        ee()()()),
                    2 & t)
                ) {
                    const e = L();
                    dt('lhc-layout-matrix ', e.lhcDataService.getSiblingStatus(e.item), ''),
                        z(),
                        H('ngIf', !e.formLevel),
                        z(4),
                        H('ngForOf', e.item.items[0].answers),
                        z(),
                        H('ngIf', 'optionsOrString' === e.item.items[0].answerConstraint),
                        z(4),
                        H('ngForOf', e._autocompOptions.listItems),
                        z(),
                        H('ngIf', 'optionsOrString' === e.item.items[0].answerConstraint),
                        z(2),
                        H('ngForOf', e.item.items)('ngForTrackBy', e.lhcDataService.trackByElementId);
                }
            }
            let Nk = (() => {
                class t {
                    constructor(e) {
                        (this.lhcDataService = e),
                            (this.formLevel = !1),
                            (this.isCheckbox = !1),
                            (this._autocompOptions = { listItems: [] });
                    }
                    ngOnChanges(e) {
                        this.setInitialValue();
                        const i = this.lhcDataService.getLhcFormData();
                        if (i && this.item.items[0]) {
                            const r = i._getAnswerDisplayTextWithLabelAndScore(
                                i.templateOptions.displayScoreWithAnswerText,
                                this.item.items[0],
                            );
                            this._autocompOptions.listItems = r[0];
                        }
                    }
                    updateCheckboxListValue(e) {
                        let i = [];
                        for (let r = 0, s = e._checkboxModels.length; r < s; r++)
                            e._checkboxModels[r] && i.push(e.answers[r]);
                        e._answerOtherChecked && i.push({ text: e._answerOther, _notOnList: !0 }),
                            (e.value = i),
                            this.lhcDataService.onItemValueChange(e, null, null, !0);
                    }
                    updateRadioListValue(e, i) {
                        (e.value = i),
                            (e._answerOtherChecked = !1),
                            this.lhcDataService.onItemValueChange(e, null, null, !0);
                    }
                    updateRadioListValueForOther(e, i) {
                        e._answerOtherChecked &&
                            ((e.value = { text: i, _notOnList: !0 }),
                            this.lhcDataService.onItemValueChange(e, null, null, !0));
                    }
                    setInitialValue() {
                        (this.isCheckbox = this.item.items[0]?._multipleAnswers),
                            this.item.items.forEach(e => {
                                this.isCheckbox ? this.setCheckboxInitialValue(e) : this.setRadioInitialValue(e);
                            });
                    }
                    setRadioInitialValue(e) {
                        e.value && e.answers && Array.isArray(e.answers)
                            ? e.value._notOnList && ((e._answerOtherChecked = !0), (e._answerOther = e.value.text))
                            : ((e._answerOtherChecked = !1), delete e._answerOther);
                    }
                    _getCheckboxModels(e, i) {
                        let r = new Array(i.length).fill(!1);
                        for (let s = 0, o = e.length; s < o; s++)
                            for (let a = 0, l = i.length; a < l; a++)
                                if (f5()(e[s], i[a])) {
                                    r[a] = !0;
                                    break;
                                }
                        return r;
                    }
                    setCheckboxInitialValue(e) {
                        if (e.value && Array.isArray(e.value) && e.answers && Array.isArray(e.answers)) {
                            let i = new Array(e.answers.length).fill(!1);
                            for (let r = 0, s = e.value.length; r < s; r++)
                                if (e.value[r]._notOnList)
                                    (e._answerOtherChecked = !0), (e._answerOther = e.value[r].text);
                                else
                                    for (let o = 0, a = e.answers.length; o < a; o++)
                                        if (f5()(e.value[r], e.answers[o])) {
                                            i[o] = !0;
                                            break;
                                        }
                            e._checkboxModels = i;
                        } else
                            (e._checkboxModels = new Array(e.answers.length).fill(!1)),
                                (e._answerOtherChecked = !1),
                                delete e._answerOther;
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-group-matrix']],
                        inputs: { item: 'item', formLevel: 'formLevel' },
                        features: [D],
                        decls: 1,
                        vars: 1,
                        consts: [
                            [3, 'class', 4, 'ngIf'],
                            ['class', 'lhc-form-matrix-table-title', 4, 'ngIf'],
                            [1, 'lhc-form-matrix-table'],
                            [1, 'lhc-question'],
                            [4, 'ngFor', 'ngForOf'],
                            ['class', 'other-answer', 4, 'ngIf'],
                            [1, 'lhc-matrix-table-header-row'],
                            ['class', 'lhc-form-matrix-cell', 3, 'id', 4, 'ngFor', 'ngForOf'],
                            ['class', 'lhc-form-matrix-cell-other', 'id', 'otherAnswer', 4, 'ngIf'],
                            [4, 'ngFor', 'ngForOf', 'ngForTrackBy'],
                            [1, 'lhc-form-matrix-table-title'],
                            [3, 'item'],
                            [1, 'other-answer'],
                            [1, 'lhc-form-matrix-cell', 3, 'id'],
                            [3, 'ngSwitch'],
                            [4, 'ngSwitchCase'],
                            [3, 'outerHTML', 4, 'ngSwitchCase'],
                            [3, 'outerHTML'],
                            ['id', 'otherAnswer', 1, 'lhc-form-matrix-cell-other'],
                            ['role', 'radiogroup', 4, 'ngIf'],
                            ['role', 'radiogroup'],
                            ['class', 'lhc-form-matrix-cell', 4, 'ngFor', 'ngForOf'],
                            ['class', 'lhc-form-matrix-cell-other', 'aria-labeledby', 'otherAnswer', 4, 'ngIf'],
                            [1, 'lhc-form-matrix-cell'],
                            [1, 'lhc-form-matrix-answer'],
                            [4, 'ngIf'],
                            ['type', 'checkbox', 3, 'ngModelChange', 'disabled', 'id', 'ngModel'],
                            ['type', 'radio', 3, 'change', 'disabled', 'id', 'ngModel', 'value', 'name'],
                            ['aria-labeledby', 'otherAnswer', 1, 'lhc-form-matrix-cell-other'],
                            ['class', 'lhc-form-matrix-answer', 4, 'ngIf'],
                            ['type', 'text', 3, 'ngModelChange', 'disabled', 'id', 'ngModel'],
                            [
                                'type',
                                'radio',
                                3,
                                'ngModelChange',
                                'change',
                                'disabled',
                                'id',
                                'ngModel',
                                'value',
                                'name',
                            ],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, Zae, 14, 10, 'div', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [oa, hi, Ho, Ta, xa, W4, fp, eo, Fs, xh, Ok, Sh],
                    }));
                }
                return t;
            })();
            function Jae(t, n) {
                if ((1 & t && (Z(0, 'a', 12), Je(1), ee()), 2 & t)) {
                    const e = L(2).$implicit;
                    ct('href', 'https://loinc.org/' + e.code, td), z(), jn(' [', e.code, '] ');
                }
            }
            function ele(t, n) {
                if ((1 & t && (Z(0, 'span', 13), Je(1), ee()), 2 & t)) {
                    const e = L(2).$implicit;
                    z(), jn('[', e.code, ']');
                }
            }
            function tle(t, n) {
                if ((1 & t && (Z(0, 'span'), ue(1, Jae, 2, 2, 'a', 10)(2, ele, 2, 1, 'span', 11), ee()), 2 & t)) {
                    const e = L().$implicit;
                    z(), H('ngIf', 'http://loinc.org' == e.system), z(), H('ngIf', 'http://loinc.org' != e.system);
                }
            }
            function nle(t, n) {
                if ((1 & t && (Z(0, 'span'), ue(1, tle, 3, 2, 'span', 5), ee()), 2 & t)) {
                    const e = n.$implicit;
                    z(), H('ngIf', e.code);
                }
            }
            function ile(t, n) {
                if ((1 & t && (Z(0, 'span'), ue(1, nle, 2, 1, 'span', 9), ee()), 2 & t)) {
                    const e = L(2);
                    z(), H('ngForOf', e.lhcFormData.codeList);
                }
            }
            function rle(t, n) {
                1 & t && Oe(0, 'lhc-button-popover', 14),
                    2 & t && H('item', L(2).lhcFormData)('popoverType', 'copyright-string')('formLevel', !0);
            }
            function sle(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-group-horizontal', 18), Ze()), 2 & t)) {
                    const e = L(3);
                    z(), H('item', e.lhcFormData)('formLevel', !0);
                }
            }
            function ole(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-group-matrix', 18), Ze()), 2 & t)) {
                    const e = L(3);
                    z(), H('item', e.lhcFormData)('formLevel', !0);
                }
            }
            function ale(t, n) {
                if ((1 & t && Oe(0, 'lhc-item', 21), 2 & t)) {
                    const e = L().$implicit,
                        i = L(5);
                    vo(i.lhcDataService.getItemClassList(e, i.viewMode)),
                        Mn('id', 'item-', e._elementId, ''),
                        H('item', e);
                }
            }
            function lle(t, n) {
                if ((1 & t && (Xe(0), ue(1, ale, 1, 6, 'lhc-item', 20), Ze()), 2 & t)) {
                    const e = n.$implicit,
                        i = L(5);
                    z(),
                        H(
                            'ngIf',
                            e &&
                                i.lhcDataService.targetShown(e) &&
                                !e._isHiddenFromView &&
                                !i.lhcDataService.isSubsequentHorizontalTableGroupItem(e),
                        );
                }
            }
            function cle(t, n) {
                if ((1 & t && (Xe(0), ue(1, lle, 2, 1, 'ng-container', 19), Ze()), 2 & t)) {
                    const e = L(4);
                    z(), H('ngForOf', e.lhcFormData.items)('ngForTrackBy', e.lhcDataService.trackByElementId);
                }
            }
            function ule(t, n) {
                if ((1 & t && (Xe(0), ue(1, cle, 2, 2, 'ng-container', 5), Ze()), 2 & t)) {
                    const e = L(3);
                    z(), H('ngIf', e.lhcFormData.items);
                }
            }
            function dle(t, n) {
                1 & t &&
                    (Xe(0, 15),
                    ue(1, sle, 2, 2, 'ng-container', 16)(2, ole, 2, 2, 'ng-container', 16)(
                        3,
                        ule,
                        2,
                        1,
                        'ng-container',
                        17,
                    ),
                    Ze()),
                    2 & t &&
                        (H('ngSwitch', L(2).lhcFormData.templateOptions.displayControl.questionLayout),
                        z(),
                        H('ngSwitchCase', 'horizontal'),
                        z(),
                        H('ngSwitchCase', 'matrix'));
            }
            function hle(t, n) {
                if (
                    (1 & t &&
                        (Z(0, 'form', 2, 0)(2, 'div', 3)(3, 'span', 4),
                        Je(4),
                        ee(),
                        ue(5, ile, 2, 1, 'span', 5)(6, rle, 1, 3, 'lhc-button-popover', 6),
                        ee(),
                        Z(7, 'div', 7),
                        ue(8, dle, 4, 3, 'ng-container', 8),
                        ee()()),
                    2 & t)
                ) {
                    const e = L();
                    dt('lhc-form lf-template-table novalidate ', e.viewModeClass, ''),
                        z(3),
                        Ks(e.lhcFormData._obj_titleCSS),
                        Mn('id', 'label-', e.lhcFormData.code, ''),
                        z(),
                        hn(e.lhcFormData.name || e.lhcFormData.shortName),
                        z(),
                        H(
                            'ngIf',
                            e.lhcFormData.templateOptions.showQuestionCode &&
                                e.lhcFormData.codeList &&
                                e.lhcFormData.codeList.length > 0,
                        ),
                        z(),
                        H('ngIf', e.lhcFormData.copyrightNotice),
                        z(2),
                        H('ngIf', e.lhcFormData.templateOptions.displayControl);
                }
            }
            let fle = (() => {
                    class t {
                        constructor(e, i, r, s) {
                            (this.winService = e),
                                (this.lhcDataService = i),
                                (this.host = r),
                                (this.zone = s),
                                (this.prepop = !1),
                                (this.onFormReady = new Ft()),
                                (this.onError = new Ft()),
                                (this.viewModeClass = ''),
                                (this.viewMode = ''),
                                (this._inputFieldWidth = null),
                                (this.changeSize = new vt()),
                                this.changeSize
                                    .asObservable()
                                    .pipe(
                                        (function ET(t, n = bf) {
                                            return mi((e, i) => {
                                                let r = null,
                                                    s = null,
                                                    o = null;
                                                const a = () => {
                                                    if (r) {
                                                        r.unsubscribe(), (r = null);
                                                        const c = s;
                                                        (s = null), i.next(c);
                                                    }
                                                };
                                                function l() {
                                                    const c = o + t,
                                                        f = n.now();
                                                    if (f < c) return (r = this.schedule(void 0, c - f)), void i.add(r);
                                                    a();
                                                }
                                                e.subscribe(
                                                    ln(
                                                        i,
                                                        c => {
                                                            (s = c),
                                                                (o = n.now()),
                                                                r || ((r = n.schedule(l, t)), i.add(r));
                                                        },
                                                        () => {
                                                            a(), i.complete();
                                                        },
                                                        void 0,
                                                        () => {
                                                            s = r = null;
                                                        },
                                                    ),
                                                );
                                            });
                                        })(100),
                                    )
                                    .subscribe(o => {
                                        this.winService.setWindowWidth(o);
                                    }),
                                e.viewMode.subscribe(o => {
                                    (this.viewModeClass = this.lhcDataService.getViewModeClass(o)), (this.viewMode = o);
                                });
                        }
                        ngOnInit() {
                            (this.observer = new ResizeObserver(e => {
                                this.zone.run(() => {
                                    this.changeSize.next(e[0].contentRect.width);
                                });
                            })),
                                this.observer.observe(this.host.nativeElement);
                        }
                        ngOnDestroy() {
                            this.observer.unobserve(this.host.nativeElement);
                        }
                        formReady() {
                            (this.lhcFormData._formReady = !0), this.onFormReady.emit();
                        }
                        ngOnChanges(e) {
                            if (e.questionnaire)
                                if (
                                    ((this.lhcFormData = null),
                                    this.lhcDataService.setLhcFormData(null),
                                    this.questionnaire)
                                ) {
                                    const i = this;
                                    setTimeout(() => {
                                        try {
                                            let r = Rt.deepCopy(i.questionnaire);
                                            if ('Questionnaire' === r.resourceType) {
                                                let s = i.fhirVersion || LForms.Util.guessFHIRVersion(r) || 'R4';
                                                if (
                                                    LForms.FHIR[s] &&
                                                    LForms.FHIR[s].SDC &&
                                                    ((r = LForms.FHIR[s].SDC.convertQuestionnaireToLForms(
                                                        r,
                                                        i.options,
                                                    )),
                                                    i.options?.questionnaireResponse)
                                                ) {
                                                    let o = wh(i.options.questionnaireResponse);
                                                    r = LForms.FHIR[s].SDC.mergeQuestionnaireResponseToLForms(r, o);
                                                }
                                            }
                                            (i.lhcFormData = new Ik(r)),
                                                e.options && i.options && i.lhcFormData.setTemplateOptions(i.options),
                                                i.lhcDataService.setLhcFormData(i.lhcFormData),
                                                LForms.FHIR && i.lhcFormData.fhirVersion
                                                    ? i.lhcFormData
                                                          .loadFHIRResources(i.prepop)
                                                          .then(() => {
                                                              i.lhcFormData &&
                                                              (i.lhcFormData._hasResponsiveExpr ||
                                                                  i.lhcFormData._hasInitialExpr)
                                                                  ? i.lhcFormData._expressionProcessor
                                                                        .runCalculations(!i.lhcFormData.hasSavedData)
                                                                        .then(() => {
                                                                            i.lhcFormData._checkFormControls(),
                                                                                i.formReady();
                                                                        })
                                                                        .catch(s => {
                                                                            i.onError.emit(
                                                                                'string' == typeof s ? s : s.message,
                                                                            );
                                                                        })
                                                                  : i.formReady();
                                                          })
                                                          .catch(s => {
                                                              i.onError.emit('string' == typeof s ? s : s.message);
                                                          })
                                                    : i.formReady();
                                        } catch (r) {
                                            i.onError.emit('string' == typeof r ? r : r.message);
                                        }
                                    }, 1);
                                } else (this.lhcFormData = null), this.lhcDataService.setLhcFormData(null);
                            else if (e.options) {
                                let i = this.lhcDataService.getLhcFormData();
                                i && i.setTemplateOptions(this.options);
                            }
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Dh), te(Xi), te(Pn), te(en));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['lhc-form']],
                            inputs: {
                                questionnaire: 'questionnaire',
                                options: 'options',
                                prepop: 'prepop',
                                fhirVersion: 'fhirVersion',
                                lhcFormData: 'lhcFormData',
                            },
                            outputs: { onFormReady: 'onFormReady', onError: 'onError' },
                            features: [$n([Dh, Xi]), D],
                            decls: 1,
                            vars: 1,
                            consts: [
                                ['lhcFormContainer', ''],
                                ['autocomplete', 'off', 3, 'class', 4, 'ngIf'],
                                ['autocomplete', 'off'],
                                ['role', 'heading', 'aria-level', '1', 1, 'lhc-form-title'],
                                [1, 'lhc-question', 3, 'id'],
                                [4, 'ngIf'],
                                [3, 'item', 'popoverType', 'formLevel', 4, 'ngIf'],
                                [1, 'lhc-form-body'],
                                [3, 'ngSwitch', 4, 'ngIf'],
                                [4, 'ngFor', 'ngForOf'],
                                [
                                    'target',
                                    '_blank',
                                    'rel',
                                    'noopener noreferrer',
                                    'class',
                                    'lhc-item-code',
                                    3,
                                    'href',
                                    4,
                                    'ngIf',
                                ],
                                ['class', 'lhc-item-code', 4, 'ngIf'],
                                ['target', '_blank', 'rel', 'noopener noreferrer', 1, 'lhc-item-code', 3, 'href'],
                                [1, 'lhc-item-code'],
                                [3, 'item', 'popoverType', 'formLevel'],
                                [3, 'ngSwitch'],
                                [4, 'ngSwitchCase'],
                                [4, 'ngSwitchDefault'],
                                [3, 'item', 'formLevel'],
                                [4, 'ngFor', 'ngForOf', 'ngForTrackBy'],
                                [3, 'item', 'class', 'id', 4, 'ngIf'],
                                [3, 'item', 'id'],
                            ],
                            template: function (i, r) {
                                1 & i && ue(0, hle, 9, 11, 'form', 1), 2 & i && H('ngIf', r.lhcFormData);
                            },
                            dependencies: [oa, hi, Ho, Ta, Bd, HM, xM, sf, m3, Pk, Nk, Th],
                            styles: [
                                '[_nghost-%COMP%]{display:block;width:100%}\n\n/*# sourceMappingURL=lhc-form.component.css.map*/',
                            ],
                        }));
                    }
                    return t;
                })(),
                mle = (() => {
                    class t {
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['lhc-item-display']],
                            inputs: { item: 'item' },
                            decls: 2,
                            vars: 1,
                            consts: [
                                [1, 'lhc-item-display'],
                                [3, 'item'],
                            ],
                            template: function (i, r) {
                                1 & i && (Z(0, 'div', 0), Oe(1, 'lhc-item-question-text', 1), ee()),
                                    2 & i && (z(), H('item', r.item));
                            },
                            dependencies: [xh],
                        }));
                    }
                    return t;
                })();
            function ple(t, n) {
                if (1 & t) {
                    const e = st();
                    Z(0, 'button', 8),
                        Le('click', function () {
                            me(e);
                            const r = L(2);
                            return pe(r.lhcDataService.removeOneRepeatingItem(r.item));
                        }),
                        Je(1, '-'),
                        ee();
                }
                if (2 & t) {
                    const e = L(2);
                    Mn('id', 'del-', e.item._elementId, ''),
                        Mn('title', window.lhcTranslationsFn('removeThis'), e.item._text, '"'),
                        H('disabled', e.item._readOnly);
                }
            }
            function gle(t, n) {
                if ((1 & t && Oe(0, 'lhc-item', 12), 2 & t)) {
                    const e = L().$implicit,
                        i = L(3);
                    vo(i.lhcDataService.getItemClassList(e, i.viewMode)),
                        Mn('id', 'item-', e._elementId, ''),
                        H('item', e);
                }
            }
            function vle(t, n) {
                if ((1 & t && (Xe(0), ue(1, gle, 1, 6, 'lhc-item', 11), Ze()), 2 & t)) {
                    const e = n.$implicit,
                        i = L(3);
                    z(), H('ngIf', e && i.lhcDataService.targetShown(e) && !e._isHiddenFromView);
                }
            }
            function _le(t, n) {
                if ((1 & t && (Z(0, 'div', 9), ue(1, vle, 2, 1, 'ng-container', 10), ee()), 2 & t)) {
                    const e = L(2);
                    z(), H('ngForOf', e.item.items)('ngForTrackBy', e.lhcDataService.trackByElementId);
                }
            }
            function yle(t, n) {
                if ((1 & t && (Z(0, 'div'), Oe(1, 'lhc-button-popover', 13), ee()), 2 & t)) {
                    const e = L(2);
                    dt('lhc-button-padding ', e.lhcDataService.getSkipLogicClass(e.item), ''),
                        z(),
                        Mn('buttonLabel', '+ ', e.item._text, ''),
                        H('item', e.item)('popoverType', 'repeating-item');
                }
            }
            function ble(t, n) {
                if (
                    (1 & t &&
                        (Xe(0),
                        Z(1, 'div', 1)(2, 'div', 2),
                        Oe(3, 'lhc-item-question-text', 3),
                        ee(),
                        Z(4, 'div', 4),
                        ue(5, ple, 2, 5, 'button', 5),
                        ee()(),
                        ue(6, _le, 2, 2, 'div', 6)(7, yle, 2, 7, 'div', 7),
                        Ze()),
                    2 & t)
                ) {
                    const e = L();
                    z(3),
                        H('item', e.item),
                        z(2),
                        H('ngIf', !e.lhcDataService.hasOneRepeatingItem(e.item)),
                        z(),
                        H('ngIf', e.item.items),
                        z(),
                        H('ngIf', e.item._lastRepeatingItem);
                }
            }
            let Cle = (() => {
                class t {
                    constructor(e, i) {
                        (this.winService = e),
                            (this.lhcDataService = i),
                            (this.viewMode = ''),
                            e.windowWidth.subscribe(r => {
                                this.viewMode = e.getViewMode();
                            });
                    }
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(te(Dh), te(Xi));
                    });
                    static #t = (this.ɵcmp = At({
                        type: t,
                        selectors: [['lhc-group-vertical']],
                        inputs: { item: 'item' },
                        decls: 1,
                        vars: 1,
                        consts: [
                            [4, 'ngIf'],
                            [1, 'lhc-item-group-title', 'lhc-de-label-button'],
                            [1, 'lhc-de-label'],
                            [3, 'item'],
                            [1, 'lhc-de-button'],
                            [
                                'class',
                                'lhc-float-button lhc-button',
                                'type',
                                'button',
                                3,
                                'id',
                                'title',
                                'disabled',
                                'click',
                                4,
                                'ngIf',
                            ],
                            ['class', 'lhc-item-group-body', 4, 'ngIf'],
                            [3, 'class', 4, 'ngIf'],
                            [
                                'type',
                                'button',
                                1,
                                'lhc-float-button',
                                'lhc-button',
                                3,
                                'click',
                                'id',
                                'title',
                                'disabled',
                            ],
                            [1, 'lhc-item-group-body'],
                            [4, 'ngFor', 'ngForOf', 'ngForTrackBy'],
                            [3, 'item', 'class', 'id', 4, 'ngIf'],
                            [3, 'item', 'id'],
                            [3, 'item', 'popoverType', 'buttonLabel'],
                        ],
                        template: function (i, r) {
                            1 & i && ue(0, ble, 8, 4, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                        },
                        dependencies: [oa, hi, m3, xh, Th],
                    }));
                }
                return t;
            })();
            function wle(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-group-horizontal', 3), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function Mle(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-group-matrix', 3), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function Sle(t, n) {
                if ((1 & t && (Xe(0), Oe(1, 'lhc-group-vertical', 3), Ze()), 2 & t)) {
                    const e = L(2);
                    z(), H('item', e.item);
                }
            }
            function Tle(t, n) {
                1 & t &&
                    (Xe(0, 1),
                    ue(1, wle, 2, 1, 'ng-container', 2)(2, Mle, 2, 1, 'ng-container', 2)(
                        3,
                        Sle,
                        2,
                        1,
                        'ng-container',
                        2,
                    ),
                    Ze()),
                    2 & t &&
                        (H('ngSwitch', L().item.displayControl.questionLayout),
                        z(),
                        H('ngSwitchCase', 'horizontal'),
                        z(),
                        H('ngSwitchCase', 'matrix'),
                        z(),
                        H('ngSwitchCase', 'vertical'));
            }
            let Dle = (() => {
                    class t {
                        constructor(e) {
                            this.lhcDataService = e;
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)(te(Xi));
                        });
                        static #t = (this.ɵcmp = At({
                            type: t,
                            selectors: [['lhc-item-group']],
                            inputs: { item: 'item' },
                            decls: 1,
                            vars: 1,
                            consts: [
                                [3, 'ngSwitch', 4, 'ngIf'],
                                [3, 'ngSwitch'],
                                [4, 'ngSwitchCase'],
                                [3, 'item'],
                            ],
                            template: function (i, r) {
                                1 & i && ue(0, Tle, 4, 4, 'ng-container', 0), 2 & i && H('ngIf', r.item);
                            },
                            dependencies: [hi, Ho, Ta, Cle, Pk, Nk],
                        }));
                    }
                    return t;
                })(),
                xle = (() => {
                    class t {
                        constructor() {
                            this.http = Ue($m);
                        }
                        getTranslation(e) {
                            return this.http.get(`assets/i18n/lforms/${e}.json`);
                        }
                        static #e = (this.ɵfac = function (i) {
                            return new (i || t)();
                        });
                        static #t = (this.ɵprov = We({ token: t, factory: t.ɵfac, providedIn: 'root' }));
                    }
                    return t;
                })();
            const kle = [
                {
                    name: 'copyright-circle',
                    theme: 'fill',
                    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z" /></svg>',
                },
                {
                    name: 'question-circle',
                    theme: 'fill',
                    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z" /></svg>',
                },
                {
                    name: 'copyright-circle',
                    theme: 'outline',
                    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" /></svg>',
                },
            ];
            Mm(SB), Mm(DB), Mm(kB);
            let Ele = (() => {
                class t {
                    constructor(e, i, r) {
                        (this.injector = e),
                            (this.translocoService = i),
                            (this.i18n = r),
                            this.switchNzI18nLanguage(),
                            (window.LForms = da),
                            customElements.get('wc-lhc-form') ||
                                customElements.define(
                                    'wc-lhc-form',
                                    (function qB(t, n) {
                                        const e = (function NB(t, n) {
                                                return n.get(su).resolveComponentFactory(t).inputs;
                                            })(t, n.injector),
                                            i = n.strategyFactory || new HB(t, n.injector),
                                            r = (function PB(t) {
                                                const n = {};
                                                return (
                                                    t.forEach(({ propName: e, templateName: i, transform: r }) => {
                                                        n[
                                                            (function IB(t) {
                                                                return t.replace(/[A-Z]/g, n => `-${n.toLowerCase()}`);
                                                            })(i)
                                                        ] = [e, r];
                                                    }),
                                                    n
                                                );
                                            })(e);
                                        class s extends BB {
                                            static #e = (this.observedAttributes = Object.keys(r));
                                            get ngElementStrategy() {
                                                if (!this._ngElementStrategy) {
                                                    const a = (this._ngElementStrategy = i.create(
                                                        this.injector || n.injector,
                                                    ));
                                                    e.forEach(({ propName: l, transform: c }) => {
                                                        if (!this.hasOwnProperty(l)) return;
                                                        const f = this[l];
                                                        delete this[l], a.setInputValue(l, f, c);
                                                    });
                                                }
                                                return this._ngElementStrategy;
                                            }
                                            constructor(a) {
                                                super(), (this.injector = a);
                                            }
                                            attributeChangedCallback(a, l, c, f) {
                                                const [g, E] = r[a];
                                                this.ngElementStrategy.setInputValue(g, c, E);
                                            }
                                            connectedCallback() {
                                                let a = !1;
                                                this.ngElementStrategy.events && (this.subscribeToEvents(), (a = !0)),
                                                    this.ngElementStrategy.connect(this),
                                                    a || this.subscribeToEvents();
                                            }
                                            disconnectedCallback() {
                                                this._ngElementStrategy && this._ngElementStrategy.disconnect(),
                                                    this.ngElementEventsSubscription &&
                                                        (this.ngElementEventsSubscription.unsubscribe(),
                                                        (this.ngElementEventsSubscription = null));
                                            }
                                            subscribeToEvents() {
                                                this.ngElementEventsSubscription =
                                                    this.ngElementStrategy.events.subscribe(a => {
                                                        const l = new CustomEvent(a.name, { detail: a.value });
                                                        this.dispatchEvent(l);
                                                    });
                                            }
                                        }
                                        return (
                                            e.forEach(({ propName: o, transform: a }) => {
                                                Object.defineProperty(s.prototype, o, {
                                                    get() {
                                                        return this.ngElementStrategy.getInputValue(o);
                                                    },
                                                    set(l) {
                                                        this.ngElementStrategy.setInputValue(o, l, a);
                                                    },
                                                    configurable: !0,
                                                    enumerable: !0,
                                                });
                                            }),
                                            s
                                        );
                                    })(fle, { injector: this.injector }),
                                ),
                            document.addEventListener('mona:config:update', s => {
                                s.detail?.uiLanguage &&
                                    (this.translocoService.setActiveLang(s.detail.uiLanguage),
                                    this.switchNzI18nLanguage());
                            });
                    }
                    switchNzI18nLanguage() {
                        switch (this.translocoService.getActiveLang()) {
                            case 'de-DE':
                                this.i18n.setLocale(DZ);
                                break;
                            case 'en-GB':
                            default:
                                this.i18n.setLocale(rx);
                                break;
                            case 'ro-RO':
                                this.i18n.setLocale(xZ);
                        }
                    }
                    ngDoBootstrap() {}
                    static #e = (this.ɵfac = function (i) {
                        return new (i || t)(Se(ys), Se(og), Se(zu));
                    });
                    static #t = (this.ɵmod = Zn({ type: t }));
                    static #n = (this.ɵinj = zn({
                        providers: [
                            { provide: Gg, useValue: nx },
                            oG({
                                config: {
                                    availableLangs: ['en-GB', 'de-DE', 'ro-RO', 'pl-PL', 'bg-BG'],
                                    defaultLang: 'de-DE',
                                    fallbackLang: 'en-GB',
                                    reRenderOnLangChange: !0,
                                    prodMode: !0,
                                },
                                loader: xle,
                            }),
                        ],
                        imports: [dw, nh, jq, vB, Vj, Une, MK, wne, Ox, Mne, Rne, o0.forRoot(kle), Qne],
                    }));
                }
                return t;
            })();
            (function Qy(t, n, e) {
                const i = t.ɵcmp;
                (i.directiveDefs = Gc(n, !1)), (i.pipeDefs = Gc(e, !0));
            })(
                m3,
                function () {
                    return [oa, hi, mc, Ho, Ta, Bd, m3, Dle, zk, mle, Th];
                },
                [],
            ),
                nU()
                    .bootstrapModule(Ele)
                    .catch(t => console.error(t));
        },
        9935: (se, ae) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }),
                (ae.Ucum = void 0),
                (ae.Ucum = {
                    dimLen_: 7,
                    validOps_: ['.', '/'],
                    codeSep_: ': ',
                    valMsgStart_: 'Did you mean ',
                    valMsgEnd_: '?',
                    cnvMsgStart_: 'We assumed you meant ',
                    cnvMsgEnd_: '.',
                    openEmph_: ' ->',
                    closeEmph_: '<- ',
                    openEmphHTML_: ' <span class="emphSpan">',
                    closeEmphHTML_: '</span> ',
                    bracesMsg_:
                        'FYI - annotations (text in curly braces {}) are ignored, except that an annotation without a leading symbol implies the default unit 1 (the unity).',
                    needMoleWeightMsg_:
                        'Did you wish to convert between mass and moles?  The molecular weight of the substance represented by the units is required to perform the conversion.',
                    csvCols_: {
                        'case-sensitive code': 'csCode_',
                        'LOINC property': 'loincProperty_',
                        'name (display)': 'name_',
                        synonyms: 'synonyms_',
                        source: 'source_',
                        category: 'category_',
                        Guidance: 'guidance_',
                    },
                    inputKey_: 'case-sensitive code',
                    specUnits_: { 'B[10.nV]': 'specialUnitOne', '[m/s2/Hz^(1/2)]': 'specialUnitTwo' },
                });
        },
        2937: (se, ae, U) => {
            'use strict';
            ae.f = void 0;
            var M = U(9935),
                q = U(9962);
            class G {
                constructor(v) {
                    if (0 === M.Ucum.dimLen_)
                        throw new Error('Dimension.setDimensionLen must be called before Dimension constructor');
                    if (null == v) this.assignZero();
                    else if (v instanceof Array) {
                        if (v.length !== M.Ucum.dimLen_)
                            throw new Error(
                                `Parameter error, incorrect length of vector passed to Dimension constructor, vector = ${JSON.stringify(
                                    v,
                                )}`,
                            );
                        this.dimVec_ = [];
                        for (let p = 0; p < M.Ucum.dimLen_; p++) this.dimVec_.push(v[p]);
                    } else if (q(v)) {
                        if (v < 0 || v >= M.Ucum.dimLen_)
                            throw new Error(
                                'Parameter error, invalid element number specified for Dimension constructor',
                            );
                        this.assignZero(), (this.dimVec_[v] = 1);
                    }
                }
                setElementAt(v, p) {
                    if (!q(v) || v < 0 || v >= M.Ucum.dimLen_)
                        throw new Error(`Dimension.setElementAt called with an invalid index position (${v})`);
                    this.dimVec_ || this.assignZero(), null == p && (p = 1), (this.dimVec_[v] = p);
                }
                getElementAt(v) {
                    if (!q(v) || v < 0 || v >= M.Ucum.dimLen_)
                        throw new Error(`Dimension.getElementAt called with an invalid index position (${v})`);
                    let p = null;
                    return this.dimVec_ && (p = this.dimVec_[v]), p;
                }
                getProperty(v) {
                    return this['_' === v.charAt(v.length - 1) ? v : v + '_'];
                }
                toString() {
                    let v = null;
                    return this.dimVec_ && (v = '[' + this.dimVec_.join(', ') + ']'), v;
                }
                add(v) {
                    if (!v instanceof G)
                        throw new Error(
                            `Dimension.add called with an invalid parameter - ${typeof v} instead of a Dimension object`,
                        );
                    if (this.dimVec_ && v.dimVec_)
                        for (let p = 0; p < M.Ucum.dimLen_; p++) this.dimVec_[p] += v.dimVec_[p];
                    return this;
                }
                sub(v) {
                    if (!v instanceof G)
                        throw new Error(
                            `Dimension.sub called with an invalid parameter - ${typeof v} instead of a Dimension object`,
                        );
                    if (this.dimVec_ && v.dimVec_)
                        for (let p = 0; p < M.Ucum.dimLen_; p++) this.dimVec_[p] -= v.dimVec_[p];
                    return this;
                }
                minus() {
                    if (this.dimVec_) for (let v = 0; v < M.Ucum.dimLen_; v++) this.dimVec_[v] = -this.dimVec_[v];
                    return this;
                }
                mul(v) {
                    if (!q(v))
                        throw new Error(
                            `Dimension.sub called with an invalid parameter - ${typeof dim2} instead of a number`,
                        );
                    if (this.dimVec_) for (let p = 0; p < M.Ucum.dimLen_; p++) this.dimVec_[p] *= v;
                    return this;
                }
                equals(v) {
                    if (!v instanceof G)
                        throw new Error(
                            `Dimension.equals called with an invalid parameter - ${typeof v} instead of a Dimension object`,
                        );
                    let p = !0,
                        _ = v.dimVec_;
                    if (this.dimVec_ && _) for (let T = 0; p && T < M.Ucum.dimLen_; T++) p = this.dimVec_[T] === _[T];
                    else p = null === this.dimVec_ && null === _;
                    return p;
                }
                assignDim(v) {
                    if (!v instanceof G)
                        throw new Error(
                            `Dimension.assignDim called with an invalid parameter - ${typeof v} instead of a Dimension object`,
                        );
                    if (null === v.dimVec_) this.dimVec_ = null;
                    else {
                        null === this.dimVec_ && (this.dimVec_ = []);
                        for (let p = 0; p < M.Ucum.dimLen_; p++) this.dimVec_[p] = v.dimVec_[p];
                    }
                    return this;
                }
                assignZero() {
                    null == this.dimVec_ && (this.dimVec_ = []);
                    for (let v = 0; v < M.Ucum.dimLen_; v++) this.dimVec_.push(0);
                    return this;
                }
                isZero() {
                    let v = null !== this.dimVec_;
                    if (this.dimVec_) for (let p = 0; v && p < M.Ucum.dimLen_; p++) v = 0 === this.dimVec_[p];
                    return v;
                }
                isNull() {
                    return null === this.dimVec_;
                }
                clone() {
                    let v = new G();
                    return v.assignDim(this), v;
                }
            }
            ae.f = G;
        },
        2447: (se, ae) => {
            'use strict';
            ae.YH = function _(T) {
                const x = T && T.config;
                if (x) {
                    if (x.length && T.data) {
                        const F = G(x);
                        return T.data.map(v.bind(null, F));
                    }
                    return T.data;
                }
                return T;
            };
            function G(T) {
                return T.map(x => (Array.isArray(x) ? x : [x]));
            }
            function v(T, x) {
                let F = {};
                return (
                    T.forEach((C, k) => {
                        let R = F;
                        for (let j = 0; j < C.length - 1; j++) R = R[C[j]] = R[C[j]] || {};
                        R[C[C.length - 1]] = x[k];
                    }),
                    F
                );
            }
        },
        9261: (se, ae, U) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }),
                (ae.Prefix = void 0),
                U(9935),
                (ae.Prefix = class M {
                    constructor(G) {
                        if (null == G.code_ || null == G.name_ || null == G.value_ || void 0 === G.exp_)
                            throw new Error(
                                'Prefix constructor called missing one or more parameters.  Prefix codes (cs or ci), name, value and exponent must all be specified and all but the exponent must not be null.',
                            );
                        (this.code_ = G.code_),
                            (this.ciCode_ = G.ciCode_),
                            (this.name_ = G.name_),
                            (this.printSymbol_ = G.printSymbol_),
                            (this.value_ = 'string' == typeof G.value_ ? parseFloat(G.value_) : G.value_),
                            (this.exp_ = G.exp_);
                    }
                    getValue() {
                        return this.value_;
                    }
                    getCode() {
                        return this.code_;
                    }
                    getCiCode() {
                        return this.ciCode_;
                    }
                    getName() {
                        return this.name_;
                    }
                    getPrintSymbol() {
                        return this.printSymbol_;
                    }
                    getExp() {
                        return this.exp_;
                    }
                    equals(G) {
                        return (
                            this.code_ === G.code_ &&
                            this.ciCode_ === G.ciCode_ &&
                            this.name_ === G.name_ &&
                            this.printSymbol_ === G.printSymbol_ &&
                            this.value_ === G.value_ &&
                            this.exp_ === G.exp_
                        );
                    }
                });
        },
        5100: (se, ae) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }), (ae.PrefixTables = ae.PrefixTablesFactory = void 0);
            class U {
                constructor() {
                    (this.byCode_ = {}), (this.byValue_ = {});
                }
                prefixCount() {
                    return Object.keys(this.byCode_).length;
                }
                allPrefixesByValue() {
                    let G = '',
                        $ = Object.keys(this.byValue_),
                        v = $.length;
                    for (let p = 0; p < v; p++) {
                        let _ = this.getPrefixByValue($[p]);
                        G += _.code_ + ',' + _.name_ + ',,' + _.value_ + '\r\n';
                    }
                    return G;
                }
                allPrefixesByCode() {
                    let G = [],
                        $ = Object.keys(this.byCode_);
                    $.sort();
                    let v = $.length;
                    for (let p = 0; p < v; p++) G.push(this.getPrefixByCode($[p]));
                    return G;
                }
                add(G) {
                    (this.byCode_[G.getCode()] = G), (this.byValue_[G.getValue()] = G);
                }
                isDefined(G) {
                    return null != this.byCode_[G];
                }
                getPrefixByCode(G) {
                    return this.byCode_[G];
                }
                getPrefixByValue(G) {
                    return this.byValue_[G];
                }
            }
            ae.PrefixTablesFactory = U;
            var O = new U();
            ae.PrefixTables = {
                getInstance: function () {
                    return O;
                },
            };
        },
        6350: (se, ae) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }), (ae.default = void 0);
            var O = new (class U {
                constructor() {
                    (this.funcs = {}),
                        (this.funcs.cel = {
                            cnvTo: function (q) {
                                return q - 273.15;
                            },
                            cnvFrom: function (q) {
                                return q + 273.15;
                            },
                        }),
                        (this.funcs.degf = {
                            cnvTo: function (q) {
                                return q - 459.67;
                            },
                            cnvFrom: function (q) {
                                return q + 459.67;
                            },
                        }),
                        (this.funcs.degre = {
                            cnvTo: function (q) {
                                return q - 273.15;
                            },
                            cnvFrom: function (q) {
                                return q + 273.15;
                            },
                        }),
                        (this.funcs.ph = {
                            cnvTo: function (q) {
                                return -Math.log(q) / Math.LN10;
                            },
                            cnvFrom: function (q) {
                                return Math.pow(10, -q);
                            },
                        }),
                        (this.funcs.ln = {
                            cnvTo: function (q) {
                                return Math.log(q);
                            },
                            cnvFrom: function (q) {
                                return Math.exp(q);
                            },
                        }),
                        (this.funcs['2ln'] = {
                            cnvTo: function (q) {
                                return 2 * Math.log(q);
                            },
                            cnvFrom: function (q) {
                                return Math.exp(q / 2);
                            },
                        }),
                        (this.funcs.lg = {
                            cnvTo: function (q) {
                                return Math.log(q) / Math.LN10;
                            },
                            cnvFrom: function (q) {
                                return Math.pow(10, q);
                            },
                        }),
                        (this.funcs['10lg'] = {
                            cnvTo: function (q) {
                                return (10 * Math.log(q)) / Math.LN10;
                            },
                            cnvFrom: function (q) {
                                return Math.pow(10, q / 10);
                            },
                        }),
                        (this.funcs['20lg'] = {
                            cnvTo: function (q) {
                                return (20 * Math.log(q)) / Math.LN10;
                            },
                            cnvFrom: function (q) {
                                return Math.pow(10, q / 20);
                            },
                        }),
                        (this.funcs['2lg'] = {
                            cnvTo: function (q) {
                                return (2 * Math.log(q)) / Math.LN10;
                            },
                            cnvFrom: function (q) {
                                return Math.pow(10, q / 2);
                            },
                        }),
                        (this.funcs.lgtimes2 = this.funcs['2lg']),
                        (this.funcs.ld = {
                            cnvTo: function (q) {
                                return Math.log(q) / Math.LN2;
                            },
                            cnvFrom: function (q) {
                                return Math.pow(2, q);
                            },
                        }),
                        (this.funcs['100tan'] = {
                            cnvTo: function (q) {
                                return 100 * Math.tan(q);
                            },
                            cnvFrom: function (q) {
                                return Math.atan(q / 100);
                            },
                        }),
                        (this.funcs.tanTimes100 = this.funcs['100tan']),
                        (this.funcs.sqrt = {
                            cnvTo: function (q) {
                                return Math.sqrt(q);
                            },
                            cnvFrom: function (q) {
                                return q * q;
                            },
                        }),
                        (this.funcs.inv = {
                            cnvTo: function (q) {
                                return 1 / q;
                            },
                            cnvFrom: function (q) {
                                return 1 / q;
                            },
                        }),
                        (this.funcs.hpX = {
                            cnvTo: function (q) {
                                return -this.funcs.lg(q);
                            },
                            cnvFrom: function (q) {
                                return Math.pow(10, -q);
                            },
                        }),
                        (this.funcs.hpC = {
                            cnvTo: function (q) {
                                return -this.func.ln(q) / this.funcs.ln(100);
                            },
                            cnvFrom: function (q) {
                                return Math.pow(100, -q);
                            },
                        }),
                        (this.funcs.hpM = {
                            cnvTo: function (q) {
                                return -this.funcs.ln(q) / this.funcs.ln(1e3);
                            },
                            cnvFrom: function (q) {
                                return Math.pow(1e3, -q);
                            },
                        }),
                        (this.funcs.hpQ = {
                            cnvTo: function (q) {
                                return -this.funcs.ln(q) / this.funcs.ln(5e4);
                            },
                            cnvFrom: function (q) {
                                return Math.pow(5e4, -q);
                            },
                        });
                }
                forName(q) {
                    q = q.toLowerCase();
                    let G = this.funcs[q];
                    if (null === G) throw new Error(`Requested function ${q} is not defined`);
                    return G;
                }
                isDefined(q) {
                    return (q = q.toLowerCase()), null !== this.funcs[q];
                }
            })();
            ae.default = O;
        },
        3537: (se, ae, U) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }),
                (ae.isNumericString = function M($) {
                    let v = '' + $;
                    return !isNaN(v) && !isNaN(parseFloat(v));
                }),
                (ae.isIntegerUnit = function q($) {
                    return /^\d+$/.test($);
                }),
                (ae.getSynonyms = function G($) {
                    let v = {},
                        _ = {};
                    if (((_ = O.getInstance().getUnitBySynonym($)), _.units)) {
                        v.status = 'succeeded';
                        let T = _.units.length;
                        v.units = [];
                        for (let x = 0; x < T; x++) {
                            let F = _.units[x];
                            v.units[x] = { code: F.csCode_, name: F.name_, guidance: F.guidance_ };
                        }
                    } else (v.status = _.status), (v.msg = _.msg);
                    return v;
                });
            var O = U(4870).UnitTables;
        },
        6077: (se, ae, U) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }), (ae.ucumJsonDefs = ae.UcumJsonDefs = void 0);
            var O = U(9261),
                M = U(5100),
                q = U(7095),
                G = U(4870),
                $ = U(2447).YH;
            class v {
                loadJsonDefs() {
                    const T = U(3380);
                    if (
                        ((T.prefixes = $(T.prefixes)),
                        (T.units = $(T.units)),
                        0 === G.UnitTables.getInstance().unitsCount())
                    ) {
                        let x = M.PrefixTables.getInstance(),
                            F = T.prefixes,
                            C = F.length;
                        for (let N = 0; N < C; N++) {
                            let K = new O.Prefix(F[N]);
                            x.add(K);
                        }
                        let k = G.UnitTables.getInstance(),
                            R = T.units,
                            j = R.length;
                        for (let N = 0; N < j; N++) {
                            let K = new q.Unit(R[N]);
                            k.addUnit(K);
                        }
                    }
                }
            }
            ae.UcumJsonDefs = v;
            var p = new v();
            ae.ucumJsonDefs = p;
        },
        1181: (se, ae, U) => {
            'use strict';
            ae.l = void 0;
            var M = U(6077),
                q = (function $(x) {
                    if (x && x.__esModule) return x;
                    if (null === x || ('object' != typeof x && 'function' != typeof x)) return { default: x };
                    var F = G();
                    if (F && F.has(x)) return F.get(x);
                    var C = {},
                        k = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for (var R in x)
                        if (Object.prototype.hasOwnProperty.call(x, R)) {
                            var j = k ? Object.getOwnPropertyDescriptor(x, R) : null;
                            j && (j.get || j.set) ? Object.defineProperty(C, R, j) : (C[R] = x[R]);
                        }
                    return (C.default = x), F && F.set(x, C), C;
                })(U(3537));
            function G() {
                if ('function' != typeof WeakMap) return null;
                var x = new WeakMap();
                return (
                    (G = function () {
                        return x;
                    }),
                    x
                );
            }
            var v = U(9935).Ucum,
                p = U(4870).UnitTables,
                _ = U(6834).o;
            class T {
                constructor() {
                    0 === p.getInstance().unitsCount() && M.ucumJsonDefs.loadJsonDefs(),
                        (this.uStrParser_ = _.getInstance());
                }
                useHTMLInMessages(F) {
                    void 0 === F && (F = !0), this.uStrParser_.useHTMLInMessages(F);
                }
                useBraceMsgForEachString(F) {
                    void 0 === F && (F = !0), this.uStrParser_.useBraceMsgForEachString(F);
                }
                validateUnitString(F, C, k) {
                    void 0 === C && (C = !1), void 0 === k && (k = 'validate');
                    let R = this.getSpecifiedUnit(F, k, C),
                        j = R.unit,
                        N = j
                            ? {
                                  ucumCode: R.origString,
                                  unit: { code: j.csCode_, name: j.name_, guidance: j.guidance_ },
                              }
                            : { ucumCode: null };
                    return (
                        (N.status = R.status), R.suggestions && (N.suggestions = R.suggestions), (N.msg = R.retMsg), N
                    );
                }
                convertUnitTo(F, C, k, R, j) {
                    void 0 === R && (R = !1), void 0 === j && (j = null);
                    let N = { status: 'failed', toVal: null, msg: [] };
                    if (
                        (F && (F = F.trim()),
                        (!F || '' == F) && ((N.status = 'error'), N.msg.push('No "from" unit expression specified.')),
                        this._checkFromVal(C, N),
                        k && (k = k.trim()),
                        (!k || '' == k) && ((N.status = 'error'), N.msg.push('No "to" unit expression specified.')),
                        'error' !== N.status)
                    )
                        try {
                            let K = null,
                                Q = this.getSpecifiedUnit(F, 'convert', R);
                            (K = Q.unit),
                                Q.retMsg && (N.msg = N.msg.concat(Q.retMsg)),
                                Q.suggestions && ((N.suggestions = {}), (N.suggestions.from = Q.suggestions)),
                                K || N.msg.push(`Unable to find a unit for ${F}, so no conversion could be performed.`);
                            let ce = null;
                            if (
                                ((Q = this.getSpecifiedUnit(k, 'convert', R)),
                                (ce = Q.unit),
                                Q.retMsg && (N.msg = N.msg.concat(Q.retMsg)),
                                Q.suggestions &&
                                    (N.suggestions || (N.suggestions = {}), (N.suggestions.to = Q.suggestions)),
                                ce ||
                                    N.msg.push(`Unable to find a unit for ${k}, so no conversion could be performed.`),
                                K && ce)
                            )
                                try {
                                    if (j) {
                                        if (0 !== K.moleExp_ && 0 !== ce.moleExp_)
                                            throw new Error(
                                                'A molecular weight was specified but a mass <-> mole conversion cannot be executed for two mole-based units.  No conversion was attempted.',
                                            );
                                        if (0 === K.moleExp_ && 0 === ce.moleExp_)
                                            throw new Error(
                                                'A molecular weight was specified but a mass <-> mole conversion cannot be executed when neither unit is mole-based.  No conversion was attempted.',
                                            );
                                        if (!K.isMoleMassCommensurable(ce))
                                            throw new Error(`Sorry.  ${F} cannot be converted to ${k}.`);
                                        N.toVal =
                                            0 !== K.moleExp_
                                                ? K.convertMolToMass(C, ce, j)
                                                : K.convertMassToMol(C, ce, j);
                                    } else N.toVal = ce.convertFrom(C, K);
                                    (N.status = 'succeeded'), (N.fromUnit = K), (N.toUnit = ce);
                                } catch (ge) {
                                    (N.status = 'failed'), N.msg.push(ge.message);
                                }
                        } catch (K) {
                            (N.status = K.message == v.needMoleWeightMsg_ ? 'failed' : 'error'), N.msg.push(K.message);
                        }
                    return N;
                }
                convertToBaseUnits(F, C) {
                    let k = {};
                    if ((this._checkFromVal(C, k), !k.status)) {
                        let R = this.getSpecifiedUnit(F, 'validate');
                        k = { status: 'valid' == R.status ? 'succeeded' : R.status };
                        let j = R.unit;
                        if (((k.msg = R.retMsg || []), j)) {
                            if (j.isArbitrary_)
                                k.msg.push('Arbitrary units cannot be converted to base units or other units.'),
                                    (k.status = 'failed');
                            else if ('succeeded' == k.status) {
                                let N = {},
                                    K = j.dim_?.dimVec_,
                                    Q = '1';
                                if (K) {
                                    let De = p.getInstance().dimVecIndexToBaseUnit_;
                                    for (let xe = 0, Ve = K.length; xe < Ve; ++xe) {
                                        let b = K[xe];
                                        b && ((N[De[xe]] = b), (Q += '.' + De[xe] + b));
                                    }
                                }
                                let ce = this.getSpecifiedUnit(Q, 'validate'),
                                    ge = ce.unit;
                                if ('valid' !== ce.status)
                                    k.msg.push('Unable construct base unit string; tried ' + Q), (k.status = 'error');
                                else {
                                    try {
                                        k.magnitude = ge.convertFrom(C, j);
                                    } catch (De) {
                                        k.msg.push(De.toString()), (k.status = 'error');
                                    }
                                    'succeeded' == k.status &&
                                        ((k.unitToExp = N), (k.fromUnitIsSpecial = j.isSpecial_));
                                }
                            }
                        } else 0 == R.retMsg?.length && k.msg.push('Could not find unit information for ' + F);
                    }
                    return k;
                }
                _checkFromVal(F, C) {
                    (null === F || isNaN(F) || ('number' != typeof F && !q.isNumericString(F))) &&
                        ((C.status = 'error'),
                        C.msg || (C.msg = []),
                        C.msg.push('No "from" value, or an invalid "from" value, was specified.'));
                }
                checkSynonyms(F) {
                    let C = {};
                    return (
                        null == F
                            ? ((C.status = 'error'), (C.msg = 'No term specified for synonym search.'))
                            : (C = q.getSynonyms(F)),
                        C
                    );
                }
                getSpecifiedUnit(F, C, k) {
                    void 0 === k && (k = !1);
                    let R = { retMsg: [] };
                    if (F) {
                        let j = p.getInstance();
                        F = F.trim();
                        let N = j.getUnitByCode(F);
                        if (N) (R.unit = N), (R.origString = F);
                        else
                            try {
                                let K = this.uStrParser_.parseString(F, C, k);
                                (R.unit = K[0]),
                                    (R.origString = K[1]),
                                    K[2] && (R.retMsg = K[2]),
                                    (R.suggestions = K[3]);
                            } catch (K) {
                                console.log(
                                    `Unit requested for unit string ${F}.request unsuccessful; error thrown = ` +
                                        K.message,
                                ),
                                    R.retMsg.unshift(`${F} is not a valid unit.  ${K.message}`);
                            }
                    } else R.retMsg.push('No unit string specified.');
                    return (
                        (R.status = R.unit
                            ? R.origString === F
                                ? 'valid'
                                : 'invalid'
                            : R.origString
                            ? 'invalid'
                            : 'error'),
                        R
                    );
                }
                commensurablesList(F) {
                    let C = [],
                        k = null,
                        R = this.getSpecifiedUnit(F, 'validate', !1),
                        j = R.unit;
                    if ((R.retMsg.length > 0 && (C = R.retMsg), j)) {
                        let N = null,
                            K = j.getProperty('dim_');
                        if (K) {
                            try {
                                N = K.getProperty('dimVec_');
                            } catch (Q) {
                                C.push(Q.message),
                                    'Dimension does not have requested property(dimVec_)' === Q.message && (N = null);
                            }
                            N && (k = p.getInstance().getUnitsByDimension(N));
                        } else C.push('No commensurable units were found for ' + F);
                    } else C.push(`Could not find unit ${F}.`);
                    return [k, C];
                }
            }
            (ae.l = T),
                (T.getInstance = function () {
                    return new T();
                });
        },
        5801: (se, ae, U) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }),
                (ae.UnitTables = ae.UcumLhcUtils = ae.Ucum = void 0);
            var O = U(9935).Ucum;
            ae.Ucum = O;
            var M = U(1181).l;
            ae.UcumLhcUtils = M;
            var q = U(4870).UnitTables;
            ae.UnitTables = q;
        },
        7095: (se, ae, U) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }), (ae.Unit = void 0);
            var O = (function $(F) {
                    return F && F.__esModule ? F : { default: F };
                })(U(6350)),
                M = (function G(F) {
                    if (F && F.__esModule) return F;
                    if (null === F || ('object' != typeof F && 'function' != typeof F)) return { default: F };
                    var C = q();
                    if (C && C.has(F)) return C.get(F);
                    var k = {},
                        R = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for (var j in F)
                        if (Object.prototype.hasOwnProperty.call(F, j)) {
                            var N = R ? Object.getOwnPropertyDescriptor(F, j) : null;
                            N && (N.get || N.set) ? Object.defineProperty(k, j, N) : (k[j] = F[j]);
                        }
                    return (k.default = F), C && C.set(F, k), k;
                })(U(3537));
            function q() {
                if ('function' != typeof WeakMap) return null;
                var F = new WeakMap();
                return (
                    (q = function () {
                        return F;
                    }),
                    F
                );
            }
            var _,
                v = U(9935).Ucum,
                p = U(2937).f,
                T = U(9962);
            class x {
                constructor(C = {}) {
                    (this.isBase_ = C.isBase_ || !1),
                        (this.name_ = C.name_ || ''),
                        (this.csCode_ = C.csCode_ || ''),
                        (this.ciCode_ = C.ciCode_ || ''),
                        (this.property_ = C.property_ || ''),
                        (this.magnitude_ = C.magnitude_ || 1),
                        (this.dim_ =
                            null == C.dim_
                                ? new p()
                                : void 0 !== C.dim_.dimVec_
                                ? new p(C.dim_.dimVec_)
                                : C.dim_ instanceof p
                                ? C.dim_
                                : C.dim_ instanceof Array || T(C.dim_)
                                ? new p(C.dim_)
                                : new p()),
                        (this.printSymbol_ = C.printSymbol_ || null),
                        (this.class_ = C.class_ || null),
                        (this.isMetric_ = C.isMetric_ || !1),
                        (this.variable_ = C.variable_ || null),
                        (this.cnv_ = C.cnv_ || null),
                        (this.cnvPfx_ = C.cnvPfx_ || 1),
                        (this.isSpecial_ = C.isSpecial_ || !1),
                        (this.isArbitrary_ = C.isArbitrary_ || !1),
                        (this.moleExp_ = C.moleExp_ || 0),
                        (this.synonyms_ = C.synonyms_ || null),
                        (this.source_ = C.source_ || null),
                        (this.loincProperty_ = C.loincProperty_ || null),
                        (this.category_ = C.category_ || null),
                        (this.guidance_ = C.guidance_ || null),
                        (this.csUnitString_ = C.csUnitString_ || null),
                        (this.ciUnitString_ = C.ciUnitString_ || null),
                        (this.baseFactorStr_ = C.baseFactorStr_ || null),
                        (this.baseFactor_ = C.baseFactor_ || null),
                        (this.defError_ = C.defError_ || !1);
                }
                assignUnity() {
                    return (
                        (this.name_ = ''),
                        (this.magnitude_ = 1),
                        this.dim_ || (this.dim_ = new p()),
                        this.dim_.assignZero(),
                        (this.cnv_ = null),
                        (this.cnvPfx_ = 1),
                        this
                    );
                }
                assignVals(C) {
                    for (let k in C) {
                        let R = '_' === !k.charAt(k.length - 1) ? k + '_' : k;
                        if (!this.hasOwnProperty(R))
                            throw new Error(`Parameter error; ${k} is not a property of a Unit`);
                        this[R] = C[k];
                    }
                }
                clone() {
                    let C = new x();
                    return (
                        Object.getOwnPropertyNames(this).forEach(k => {
                            'dim_' === k ? (C.dim_ = this.dim_ ? this.dim_.clone() : null) : (C[k] = this[k]);
                        }),
                        C
                    );
                }
                assign(C) {
                    Object.getOwnPropertyNames(C).forEach(k => {
                        'dim_' === k ? (this.dim_ = C.dim_ ? C.dim_.clone() : null) : (this[k] = C[k]);
                    });
                }
                equals(C) {
                    return (
                        this.magnitude_ === C.magnitude_ &&
                        this.cnv_ === C.cnv_ &&
                        this.cnvPfx_ === C.cnvPfx_ &&
                        ((null === this.dim_ && null === C.dim_) || this.dim_.equals(C.dim_))
                    );
                }
                fullEquals(C) {
                    let k = Object.keys(this).sort(),
                        R = Object.keys(C).sort(),
                        j = k.length,
                        N = j === R.length;
                    for (let K = 0; K < j && N; K++)
                        N = k[K] === R[K] && ('dim_' === k[K] ? this.dim_.equals(C.dim_) : this[k[K]] === C[k[K]]);
                    return N;
                }
                getProperty(C) {
                    return this['_' === C.charAt(C.length - 1) ? C : C + '_'];
                }
                convertFrom(C, k) {
                    let R = 0;
                    if (this.isArbitrary_) throw new Error(`Attempt to convert to arbitrary unit "${this.csCode_}"`);
                    if (k.isArbitrary_) throw new Error(`Attempt to convert arbitrary unit "${k.csCode_}"`);
                    if (k.dim_ && this.dim_ && !k.dim_.equals(this.dim_))
                        throw this.isMoleMassCommensurable(k)
                            ? new Error(v.needMoleWeightMsg_)
                            : new Error(`Sorry.  ${k.csCode_} cannot be converted to ${this.csCode_}.`);
                    if (k.dim_ && (!this.dim_ || this.dim_.isNull()))
                        throw new Error(`Sorry.  ${k.csCode_} cannot be converted to ${this.csCode_}.`);
                    if (this.dim_ && (!k.dim_ || k.dim_.isNull()))
                        throw new Error(`Sorry.  ${k.csCode_} cannot be converted to ${this.csCode_}.`);
                    let K,
                        j = k.cnv_,
                        N = k.magnitude_;
                    return (
                        (K = null != j ? O.default.forName(j).cnvFrom(C * k.cnvPfx_) * N : C * N),
                        (R =
                            null != this.cnv_
                                ? O.default.forName(this.cnv_).cnvTo(K / this.magnitude_) / this.cnvPfx_
                                : K / this.magnitude_),
                        R
                    );
                }
                convertTo(C, k) {
                    return k.convertFrom(C, this);
                }
                convertCoherent(C) {
                    return null !== this.cnv_ && (C = this.cnv_.f_from(C / this.cnvPfx_) * this.magnitude_), C;
                }
                mutateCoherent(C) {
                    (C = this.convertCoherent(C)),
                        (this.magnitude_ = 1),
                        (this.cnv_ = null),
                        (this.cnvPfx_ = 1),
                        (this.name_ = '');
                    for (let k = 0, R = p.getMax(); k < R; k++) {
                        let j = this.dim_.getElementAt(k),
                            K = this._getUnitTables().getUnitsByDimension(new p(k));
                        if (null == K) throw new Error(`Can't find base unit for dimension ${k}`);
                        this.name_ = K.name + j;
                    }
                    return C;
                }
                convertMassToMol(C, k, R) {
                    let j = (this.magnitude_ * C) / R,
                        K = this._getUnitTables().getUnitByCode('mol').magnitude_;
                    return j / (k.magnitude_ / K);
                }
                convertMolToMass(C, k, R) {
                    let N = this._getUnitTables().getUnitByCode('mol').magnitude_;
                    return ((this.magnitude_ / N) * C * R) / k.magnitude_;
                }
                mutateRatio(C) {
                    return null == this.cnv_ ? this.mutateCoherent(C) : C;
                }
                multiplyThis(C) {
                    let k = this.clone();
                    null != k.cnv_ ? (k.cnvPfx_ *= C) : (k.magnitude_ *= C);
                    let R = C.toString();
                    return (
                        (k.name_ = this._concatStrs(R, '*', this.name_, '[', ']')),
                        (k.csCode_ = this._concatStrs(R, '.', this.csCode_, '(', ')')),
                        (k.ciCode_ = this._concatStrs(R, '.', this.ciCode_, '(', ')')),
                        (k.printSymbol_ = this._concatStrs(R, '.', this.printSymbol_, '(', ')')),
                        k
                    );
                }
                multiplyThese(C) {
                    var k = this.clone();
                    if (null != k.cnv_) {
                        if (null != C.cnv_ || (C.dim_ && !C.dim_.isZero()))
                            throw new Error(`Attempt to multiply non-ratio unit ${k.name_} failed.`);
                        k.cnvPfx_ *= C.magnitude_;
                    } else if (null != C.cnv_) {
                        if (k.dim_ && !k.dim_.isZero())
                            throw new Error(`Attempt to multiply non-ratio unit ${C.name_}`);
                        (k.cnvPfx_ = C.cnvPfx_ * k.magnitude_), (k.magnitude_ = C.magnitude_), (k.cnv_ = C.cnv_);
                    } else k.magnitude_ *= C.magnitude_;
                    return (
                        !k.dim_ || (k.dim_ && !k.dim_.dimVec_)
                            ? (k.dim_ = C.dim_ ? C.dim_.clone() : C.dim_)
                            : C.dim_ && C.dim_ instanceof p && k.dim_.add(C.dim_),
                        (k.name_ = this._concatStrs(k.name_, '*', C.name_, '[', ']')),
                        (k.csCode_ = this._concatStrs(k.csCode_, '.', C.csCode_, '(', ')')),
                        k.ciCode_ && C.ciCode_
                            ? (k.ciCode_ = this._concatStrs(k.ciCode_, '.', C.ciCode_, '(', ')'))
                            : C.ciCode_ && (k.ciCode_ = C.ciCode_),
                        k.resetFieldsForDerivedUnit(),
                        k.printSymbol_ && C.printSymbol_
                            ? (k.printSymbol_ = this._concatStrs(k.printSymbol_, '.', C.printSymbol_, '(', ')'))
                            : C.printSymbol_ && (k.printSymbol_ = C.printSymbol_),
                        (k.moleExp_ = k.moleExp_ + C.moleExp_),
                        k.isArbitrary_ || (k.isArbitrary_ = C.isArbitrary_),
                        k.isSpecial_ || (k.isSpecial_ = C.isSpecial_),
                        k
                    );
                }
                resetFieldsForDerivedUnit() {
                    (this.guidance_ = ''), (this.synonyms_ = null), (this.isBase_ = !1);
                }
                divide(C) {
                    var k = this.clone();
                    if (null != k.cnv_) throw new Error(`Attempt to divide non-ratio unit ${k.name_}`);
                    if (null != C.cnv_) throw new Error(`Attempt to divide by non-ratio unit ${C.name_}`);
                    return (
                        k.name_ && C.name_
                            ? (k.name_ = this._concatStrs(k.name_, '/', C.name_, '[', ']'))
                            : C.name_ && (k.name_ = C.invertString(C.name_)),
                        (k.csCode_ = this._concatStrs(k.csCode_, '/', C.csCode_, '(', ')')),
                        k.ciCode_ && C.ciCode_
                            ? (k.ciCode_ = this._concatStrs(k.ciCode_, '/', C.ciCode_, '(', ')'))
                            : C.ciCode_ && (k.ciCode_ = C.invertString(C.ciCode_)),
                        k.resetFieldsForDerivedUnit(),
                        (k.magnitude_ /= C.magnitude_),
                        k.printSymbol_ && C.printSymbol_
                            ? (k.printSymbol_ = this._concatStrs(k.printSymbol_, '/', C.printSymbol_, '(', ')'))
                            : C.printSymbol_ && (k.printSymbol_ = C.invertString(C.printSymbol_)),
                        C.dim_ &&
                            (k.dim_
                                ? (k.dim_.isNull() && k.dim_.assignZero(), (k.dim_ = k.dim_.sub(C.dim_)))
                                : (k.dim_ = C.dim_.clone().minus())),
                        (k.moleExp_ = k.moleExp_ - C.moleExp_),
                        k.isArbitrary_ || (k.isArbitrary_ = C.isArbitrary_),
                        k
                    );
                }
                invert() {
                    if (null != this.cnv_) throw new Error(`Attempt to invert a non-ratio unit - ${this.name_}`);
                    return (
                        (this.name_ = this.invertString(this.name_)),
                        (this.magnitude_ = 1 / this.magnitude_),
                        this.dim_.minus(),
                        this
                    );
                }
                invertString(C) {
                    if (C.length > 0) {
                        let k = C.replace('/', '!').replace('.', '/').replace('<!', '</').replace('!', '.');
                        switch (k.charAt(0)) {
                            case '.':
                                C = k.substr(1);
                                break;
                            case '/':
                                C = k;
                                break;
                            default:
                                C = '/' + k;
                        }
                    }
                    return C;
                }
                _concatStrs(C, k, R, j, N) {
                    return this._buildOneString(C, j, N) + k + this._buildOneString(R, j, N);
                }
                _buildOneString(C, k, R) {
                    let j = '';
                    return (
                        (j =
                            M.isNumericString(C) ||
                            ('(' === C.charAt(0) && C.endsWith(')')) ||
                            ('[' === C.charAt(0) && C.endsWith(']'))
                                ? C
                                : /[./* ]/.test(C)
                                ? k + C + R
                                : C),
                        j
                    );
                }
                power(C) {
                    if (null != this.cnv_)
                        throw new Error(`Attempt to raise a non-ratio unit, ${this.name_}, to a power.`);
                    let R = this.csCode_.match(/([./]|[^./]+)/g),
                        j = R.length;
                    for (let N = 0; N < j; N++) {
                        let K = R[N];
                        if ('/' !== K && '.' !== K) {
                            let Q = parseInt(K);
                            if (T(Q)) R[N] = Math.pow(Q, C).toString();
                            else {
                                let ce = K.length;
                                for (let ge = ce - 1; ge >= 0; ge--) {
                                    let De = parseInt(K[ge]);
                                    if (!T(De)) {
                                        if ((('-' === K[ge] || '+' === K[ge]) && ge--, ge < ce - 1)) {
                                            let xe = parseInt(K.substr(ge));
                                            (xe = Math.pow(xe, C)), (R[N] = K.substr(0, ge) + xe.toString()), (ge = -1);
                                        } else (R[N] += C.toString()), (ge = -1);
                                        ge = -1;
                                    }
                                }
                            }
                        }
                    }
                    return (
                        (this.csCode_ = R.join('')),
                        (this.magnitude_ = Math.pow(this.magnitude_, C)),
                        this.dim_ && this.dim_.mul(C),
                        this
                    );
                }
                isMoleMassCommensurable(C) {
                    let R = this._getUnitTables().getMassDimensionIndex(),
                        j = !1;
                    if (1 === this.moleExp_ && 0 === C.moleExp_) {
                        let N = this.dim_.clone(),
                            K = N.getElementAt(R);
                        N.setElementAt(R, K + this.moleExp_), (j = N.equals(C.dim_));
                    } else if (1 === C.moleExp_ && 0 === this.moleExp_) {
                        let N = C.dim_.clone(),
                            K = N.getElementAt(R);
                        N.setElementAt(R, K + C.moleExp_), (j = N.equals(this.dim_));
                    }
                    return j;
                }
                _getUnitTables() {
                    return _ || (_ = U(4870).UnitTables), _.getInstance();
                }
            }
            ae.Unit = x;
        },
        6834: (se, ae, U) => {
            'use strict';
            ae.o = void 0;
            var M = (function G(F) {
                if (F && F.__esModule) return F;
                if (null === F || ('object' != typeof F && 'function' != typeof F)) return { default: F };
                var C = q();
                if (C && C.has(F)) return C.get(F);
                var k = {},
                    R = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for (var j in F)
                    if (Object.prototype.hasOwnProperty.call(F, j)) {
                        var N = R ? Object.getOwnPropertyDescriptor(F, j) : null;
                        N && (N.get || N.set) ? Object.defineProperty(k, j, N) : (k[j] = F[j]);
                    }
                return (k.default = F), C && C.set(F, k), k;
            })(U(3537));
            function q() {
                if ('function' != typeof WeakMap) return null;
                var F = new WeakMap();
                return (
                    (q = function () {
                        return F;
                    }),
                    F
                );
            }
            function $(F, C, k) {
                return (
                    C in F
                        ? Object.defineProperty(F, C, { value: k, enumerable: !0, configurable: !0, writable: !0 })
                        : (F[C] = k),
                    F
                );
            }
            var v = U(9935).Ucum,
                p = U(7095).Unit,
                _ = U(4870).UnitTables,
                T = U(5100).PrefixTables;
            class x {
                constructor() {
                    (this.utabs_ = _.getInstance()),
                        (this.pfxTabs_ = T.getInstance()),
                        (this.openEmph_ = v.openEmph_),
                        (this.closeEmph_ = v.closeEmph_),
                        (this.bracesMsg_ = ''),
                        (this.parensFlag_ = 'parens_placeholder'),
                        (this.pFlagLen_ = this.parensFlag_.length),
                        (this.braceFlag_ = 'braces_placeholder'),
                        (this.bFlagLen_ = this.braceFlag_.length),
                        (this.vcMsgStart_ = null),
                        (this.vcMsgEnd_ = null),
                        (this.retMsg_ = []),
                        (this.parensUnits_ = []),
                        (this.annotations_ = []),
                        (this.suggestions = []);
                }
                useHTMLInMessages(C) {
                    void 0 === C || C
                        ? ((this.openEmph_ = v.openEmphHTML_), (this.closeEmph_ = v.closeEmphHTML_))
                        : ((this.openEmph_ = v.openEmph_), (this.closeEmph_ = v.closeEmph_));
                }
                useBraceMsgForEachString(C) {
                    this.bracesMsg_ = void 0 === C || C ? v.bracesMsg_ : '';
                }
                parseString(C, k, R) {
                    if ('' === (C = C.trim()) || null === C)
                        throw new Error('Please specify a unit expression to be validated.');
                    'validate' === k
                        ? ((this.vcMsgStart_ = v.valMsgStart_), (this.vcMsgEnd_ = v.valMsgEnd_))
                        : ((this.vcMsgStart_ = v.cnvMsgStart_), (this.vcMsgEnd_ = v.cnvMsgEnd_)),
                        (this.suggestions_ = void 0 === R || !1 === R ? null : []),
                        (this.retMsg_ = []),
                        (this.parensUnits_ = []),
                        (this.annotations_ = []);
                    let j = C,
                        N = [];
                    if (((C = this._getAnnotations(C)), this.retMsg_.length > 0)) (N[0] = null), (N[1] = null);
                    else {
                        let Q = null;
                        for (Q in v.specUnits_) for (; -1 !== C.indexOf(Q); ) C = C.replace(Q, v.specUnits_[Q]);
                        if (C.indexOf(' ') > -1) throw new Error('Blank spaces are not allowed in unit expressions.');
                        N = this._parseTheString(C, j);
                        let ce = N[0];
                        (M.isIntegerUnit(ce) || 'number' == typeof ce) &&
                            ((ce = new p({ csCode_: j, ciCode_: j, magnitude_: ce, name_: j })), (N[0] = ce));
                    }
                    return (
                        (N[2] = this.retMsg_),
                        this.suggestions_ && this.suggestions_.length > 0 && (N[3] = this.suggestions_),
                        N
                    );
                }
                _parseTheString(C, k) {
                    let R = null,
                        j = this.retMsg_.length > 0,
                        N = this._processParens(C, k);
                    j = N[2];
                    let K = [];
                    if (!j) {
                        let Q = this._makeUnitsArray((C = N[0]), (k = N[1]));
                        if (((j = Q[2]), !j)) {
                            (K = Q[0]), (k = Q[1]);
                            let ce = K.length;
                            for (let ge = 0; ge < ce; ge++) {
                                let De = K[ge].un;
                                if (M.isIntegerUnit(De)) K[ge].un = Number(De);
                                else if (De.indexOf(this.parensFlag_) >= 0) {
                                    let xe = this._getParensUnit(De, k);
                                    j || (j = xe[1]), j || (K[ge].un = xe[0]);
                                } else {
                                    let xe = this._makeUnit(De, k);
                                    null === xe[0] ? (j = !0) : ((K[ge].un = xe[0]), (k = xe[1]));
                                }
                            }
                        }
                    }
                    return (
                        j ||
                            ((null === K[0] || ' ' === K[0] || null == K[0].un) &&
                                0 === this.retMsg_.length &&
                                (this.retMsg_.push(
                                    `Unit string (${k}) did not contain anything that could be used to create a unit, or else something that is not handled yet by this package.  Sorry`,
                                ),
                                (j = !0))),
                        j || (R = this._performUnitArithmetic(K, k)),
                        [R, k]
                    );
                }
                _getAnnotations(C) {
                    let k = C.indexOf('{');
                    for (; k >= 0; ) {
                        let R = C.indexOf('}');
                        if (R < 0)
                            this.retMsg_.push(
                                'Missing closing brace for annotation starting at ' +
                                    this.openEmph_ +
                                    C.substr(k) +
                                    this.closeEmph_,
                            ),
                                (k = -1);
                        else {
                            let j = C.substring(k, R + 1);
                            if (x.VALID_ANNOTATION_REGEX.test(j)) {
                                let N = this.annotations_.length.toString();
                                (C = C.replace(j, this.braceFlag_ + N + this.braceFlag_)),
                                    this.annotations_.push(j),
                                    (k = C.indexOf('{'));
                            } else
                                this.retMsg_.push(x.INVALID_ANNOTATION_CHAR_MSG + this.openEmph_ + j + this.closeEmph_),
                                    (k = -1);
                        }
                    }
                    if (0 == this.retMsg_.length) {
                        let R = C.indexOf('}');
                        R >= 0 &&
                            this.retMsg_.push(
                                'Missing opening brace for closing brace found at ' +
                                    this.openEmph_ +
                                    C.substring(0, R + 1) +
                                    this.closeEmph_,
                            );
                    }
                    return C;
                }
                _processParens(C, k) {
                    let R = [],
                        j = 0,
                        N = !1,
                        K = this.parensUnits_.length,
                        Q = 0;
                    for (; '' !== C && !N; ) {
                        let ce = 0,
                            ge = 0,
                            De = C.indexOf('(');
                        if (De < 0) {
                            let xe = C.indexOf(')');
                            if (xe >= 0) {
                                let Ve = `Missing open parenthesis for close parenthesis at ${C.substring(0, xe + Q)}${
                                    this.openEmph_
                                }${C.substr(xe, 1)}${this.closeEmph_}`;
                                xe < C.length - 1 && (Ve += `${C.substr(xe + 1)}`),
                                    this.retMsg_.push(Ve),
                                    (R[j] = C),
                                    (N = !0);
                            } else (R[j] = C), (C = '');
                        } else {
                            ce += 1;
                            let xe = C.length;
                            De > 0 && (R[j++] = C.substr(0, De));
                            let Ve = 0,
                                b = De + 1;
                            for (; b < xe && ce != ge; b++) '(' === C[b] ? (ce += 1) : ')' === C[b] && (ge += 1);
                            if (ce === ge) {
                                (Ve = b), (R[j++] = this.parensFlag_ + K.toString() + this.parensFlag_);
                                let je = this._parseTheString(C.substring(De + 1, Ve - 1), k);
                                null === je[0]
                                    ? (N = !0)
                                    : '/' === C[De + 1]
                                    ? (this.retMsg_.push(
                                          "Unary operator '/' is only allowed at the beginning of the main term, not inside a parenthesis.",
                                      ),
                                      (N = !0))
                                    : ((k = je[1]), (this.parensUnits_[K++] = je[0]), (C = C.substr(Ve)), (Q = Ve));
                            } else
                                R.push(k.substr(De)),
                                    this.retMsg_.push(
                                        `Missing close parenthesis for open parenthesis at ${k.substring(0, De + Q)}${
                                            this.openEmph_
                                        }${k.substr(De, 1)}${this.closeEmph_}${k.substr(De + 1)}`,
                                    ),
                                    (N = !0);
                        }
                    }
                    return N && (this.parensUnits_ = []), [R.join(''), k, N];
                }
                _makeUnitsArray(C, k) {
                    let R = C.match(/([./]|[^./]+)/g),
                        j = !1,
                        N = [],
                        K = /(^[0-9]+)(\[?[a-zA-Z\_0-9a-zA-Z\_]+\]?$)/;
                    if (
                        ('/' === R[0]
                            ? R.unshift('1')
                            : '.' === R[0] &&
                              (this.retMsg_.push(
                                  `${k} is not a valid UCUM code. The multiplication operator at the beginning of the expression is not valid. A multiplication operator must appear only between two codes.`,
                              ),
                              (j = !0)),
                        !j)
                    ) {
                        if (!M.isNumericString(R[0])) {
                            let Q = R[0].match(K);
                            if (
                                Q &&
                                3 === Q.length &&
                                '' !== Q[1] &&
                                '' !== Q[2] &&
                                0 !== Q[2].indexOf(this.braceFlag_)
                            ) {
                                let ce = Q[2];
                                if (!j && -1 !== Q[2].indexOf(this.parensFlag_)) {
                                    let ge = this._getParensUnit(Q[2], k);
                                    (Q[2] = ge[0].csCode_), (ce = `(${Q[2]})`), (j = ge[1]);
                                }
                                j ||
                                    (this.retMsg_.push(
                                        `${Q[1]}${ce} is not a valid UCUM code.  ${this.vcMsgStart_}${Q[1]}.${ce}${this.vcMsgEnd_}`,
                                    ),
                                    (k = k.replace(`${Q[1]}${ce}`, `${Q[1]}.${ce}`)),
                                    (R[0] = Q[2]),
                                    R.unshift(Q[1], '.'));
                            }
                        }
                        if (!j) {
                            let Q = R.length;
                            N = [{ op: '', un: R[0] }];
                            for (let ce = 1; ce < Q; ce++) {
                                let ge = R[ce++];
                                if (R[ce])
                                    if (-1 !== v.validOps_.indexOf(R[ce]))
                                        this.retMsg_.push(
                                            `${k} is not a valid UCUM code. A unit code is missing between${this.openEmph_}${ge}${this.closeEmph_}and${this.openEmph_}${R[ce]}${this.closeEmph_}in${this.openEmph_}${ge}${R[ce]}${this.closeEmph_}.`,
                                        ),
                                            (ce = Q),
                                            (j = !0);
                                    else if (M.isNumericString(R[ce])) N.push({ op: ge, un: R[ce] });
                                    else {
                                        let De = R[ce].match(K);
                                        if (
                                            De &&
                                            3 === De.length &&
                                            '' !== De[1] &&
                                            '' !== De[2] &&
                                            0 !== De[2].indexOf(this.braceFlag_)
                                        ) {
                                            let xe = De[0];
                                            if (j || -1 === De[2].indexOf(this.parensFlag_)) {
                                                let Ve = '(' + De[1] + '.' + De[2] + ')',
                                                    b = this._processParens(Ve, k);
                                                b[2]
                                                    ? ((ce = Q), (j = !0))
                                                    : (this.retMsg_.push(
                                                          `${De[0]} is not a valid UCUM code.  ${this.vcMsgStart_}${De[1]}.${De[2]}${this.vcMsgEnd_}`,
                                                      ),
                                                      (k = k.replace(De[0], Ve)),
                                                      N.push({ op: ge, un: b[0] }));
                                            } else {
                                                let Ve = this._getParensUnit(De[2], k);
                                                if (((De[2] = Ve[0].csCode_), (xe = `(${De[2]})`), (j = Ve[1]), !j)) {
                                                    this.retMsg_.push(
                                                        `${De[1]}${xe} is not a valid UCUM code.  ${this.vcMsgStart_}${De[1]}.${xe}${this.vcMsgEnd_}`,
                                                    );
                                                    let b = `(${De[1]}.${xe})`;
                                                    k = k.replace(`${De[1]}${xe}`, b);
                                                    let je = this._processParens(b, k);
                                                    (j = je[2]), j || N.push({ op: ge, un: je[0] });
                                                }
                                            }
                                        } else N.push({ op: ge, un: R[ce] });
                                    }
                                else
                                    this.retMsg_.push(
                                        `${k} is not a valid UCUM code. It is terminated with the operator ${this.openEmph_}${ge}${this.closeEmph_}.`,
                                    ),
                                        (ce = Q),
                                        (j = !0);
                            }
                        }
                    }
                    return [N, k, j];
                }
                _getParensUnit(C, k) {
                    let R = !1,
                        N = null,
                        ce = C.indexOf(this.parensFlag_),
                        ge = null;
                    ce > 0 && (ge = C.substr(0, ce - 1));
                    let De = C.lastIndexOf(this.parensFlag_),
                        xe = null;
                    De + this.pFlagLen_ < C.length && (xe = C.substr(De + this.pFlagLen_));
                    let Ve = C.substring(ce + this.pFlagLen_, De);
                    if (!M.isNumericString(Ve))
                        throw new Error(`Processing error - invalid parens number ${Ve} found in ${C}.`);
                    if (((N = this.parensUnits_[Number(Ve)]), (C = M.isIntegerUnit(N) ? N : N.csCode_), ge))
                        if (M.isNumericString(ge)) {
                            let b = N.getProperty('magnitude_');
                            (b *= Number(ge)),
                                N.assignVals({ magnitude_: b }),
                                this.retMsg_.push(
                                    `${ge}${(C = `${ge}.${C}`)} is not a valid UCUM code.\n` +
                                        this.vcMsgStart_ +
                                        C +
                                        this.vcMsgEnd_,
                                );
                        } else if (ge.indexOf(this.braceFlag_) >= 0) {
                            let b = this._getAnnoText(ge, k);
                            if (b[1] || b[2])
                                throw new Error(
                                    `Text found before the parentheses (${ge}) included an annotation along with other text for parenthetical unit ${N.csCode_}`,
                                );
                            this.retMsg_.push(
                                `The annotation ${b[0]} before the unit code is invalid.\n` +
                                    this.vcMsgStart_ +
                                    (C += b[0]) +
                                    this.vcMsgEnd_,
                            );
                        } else
                            this.suggestions_
                                ? (R = 'succeeded' !== this._getSuggestions(ge))
                                : (this.retMsg_.push(
                                      `${ge} preceding the unit code ${C} is invalid.  Unable to make a substitution.`,
                                  ),
                                  (R = !0));
                    if (xe)
                        if (xe.indexOf(this.braceFlag_) >= 0) {
                            let b = this._getAnnoText(xe, k);
                            if (b[1] || b[2])
                                throw new Error(
                                    `Text found after the parentheses (${xe}) included an annotation along with other text for parenthetical unit ${N.csCode_}`,
                                );
                            C += b[0];
                        } else if (M.isNumericString(xe)) {
                            N = null;
                            let b = `An exponent (${xe}) following a parenthesis is invalid as of revision 1.9 of the UCUM Specification.`;
                            C.match(/\d$/) || (b += '\n  ' + this.vcMsgStart_ + (C += xe) + this.vcMsgEnd_),
                                this.retMsg_.push(b),
                                (R = !0);
                        } else
                            this.suggestions_
                                ? (R = 'succeeded' !== this._getSuggestions(ge))
                                : (this.retMsg_.push(
                                      `Text ${xe} following the unit code ${C} is invalid.  Unable to make a substitution.`,
                                  ),
                                  (R = !0));
                    return (
                        R ||
                            (N
                                ? M.isIntegerUnit(N)
                                    ? (N = new p({ csCode_: N, magnitude_: N, name_: N }))
                                    : (N.csCode_ = C)
                                : (N = new p({ csCode_: C, magnitude_: 1, name_: C }))),
                        [N, R]
                    );
                }
                _getAnnoText(C, k) {
                    let R = C.indexOf(this.braceFlag_),
                        j = R > 0 ? C.substring(0, R) : null;
                    0 !== R && (C = C.substr(R));
                    let N = C.indexOf(this.braceFlag_, 1),
                        K = N + this.bFlagLen_ < C.length ? C.substr(N + this.bFlagLen_) : null,
                        Q = C.substring(this.bFlagLen_, N),
                        ce = Number(Q);
                    if (!M.isNumericString(Q) || ce >= this.annotations_.length)
                        throw new Error(
                            `Processing Error - invalid annotation index ${Q} found in ${C} that was created from ${k}`,
                        );
                    return [(C = this.annotations_[ce]), j, K];
                }
                _getSuggestions(C) {
                    let k = M.getSynonyms(C);
                    if ('succeeded' === k.status) {
                        let R = {};
                        (R.msg = `${C} is not a valid UCUM code.  We found possible units that might be what was meant:`),
                            (R.invalidUnit = C);
                        let j = k.units.length;
                        R.units = [];
                        for (let N = 0; N < j; N++) {
                            let K = k.units[N];
                            R.units.push([K.code, K.name, K.guidance]);
                        }
                        this.suggestions_.push(R);
                    } else this.retMsg_.push(`${C} is not a valid UCUM code.  No alternatives were found.`);
                    return k.status;
                }
                _makeUnit(C, k) {
                    let R = this.utabs_.getUnitByCode(C);
                    if (R) R = R.clone();
                    else if (C.indexOf(this.braceFlag_) >= 0) {
                        let j = this._getUnitWithAnnotation(C, k);
                        (R = j[0]), R && (k = j[1]);
                    } else {
                        if (C.indexOf('^') > -1) {
                            let j = C.replace('^', '*');
                            (R = this.utabs_.getUnitByCode(j)),
                                R &&
                                    ((R = R.clone()),
                                    (R.csCode_ = R.csCode_.replace('*', '^')),
                                    (R.ciCode_ = R.ciCode_.replace('*', '^')));
                        }
                        if (!R) {
                            let j = '[' + C + ']';
                            (R = this.utabs_.getUnitByCode(j)),
                                R &&
                                    ((R = R.clone()),
                                    (k = k.replace(C, j)),
                                    this.retMsg_.push(
                                        `${C} is not a valid unit expression, but ${j} is.\n` +
                                            this.vcMsgStart_ +
                                            `${j} (${R.name_})${this.vcMsgEnd_}`,
                                    ));
                        }
                        if (!R) {
                            let j = this.utabs_.getUnitByName(C);
                            if (j && j.length > 0) {
                                R = j[0].clone();
                                let N =
                                        'The UCUM code for ' +
                                        C +
                                        ' is ' +
                                        R.csCode_ +
                                        '.\n' +
                                        this.vcMsgStart_ +
                                        R.csCode_ +
                                        this.vcMsgEnd_,
                                    K = !1;
                                for (let ge = 0; ge < this.retMsg_.length && !K; ge++) K = this.retMsg_[ge] === N;
                                K || this.retMsg_.push(N);
                                let Q = new RegExp('(^|[./({])(' + C + ')($|[./)}])'),
                                    ce = k.match(Q);
                                (k = k.replace(Q, ce[1] + R.csCode_ + ce[3])), (C = R.csCode_);
                            }
                        }
                        if (!R) {
                            let j = null;
                            for (j in v.specUnits_)
                                -1 !== C.indexOf(v.specUnits_[j]) && (C = C.replace(v.specUnits_[j], j));
                            (R = this.utabs_.getUnitByCode(C)), R && (R = R.clone());
                        }
                        if (!R) {
                            let j = C,
                                N = null,
                                K = null,
                                Q = null,
                                ce = null,
                                ge = null,
                                De = null,
                                xe = this._isCodeWithExponent(C);
                            if ((xe && ((K = xe[1]), (N = this.utabs_.getUnitByCode((C = xe[0])))), K && isNaN(K)))
                                (R = null), this.retMsg_.push(`${j} is not a valid UCUM code.`);
                            else if (
                                (!N &&
                                    ((Q = C.charAt(0)), (ce = this.pfxTabs_.getPrefixByCode(Q)), ce) &&
                                    ((ge = ce.getValue()),
                                    (De = ce.getExp()),
                                    (C = C.substr(Q.length)),
                                    (N = this.utabs_.getUnitByCode(C)),
                                    !N &&
                                        'd' == Q &&
                                        'a' == C.substr(0, 1) &&
                                        ((Q = 'da'),
                                        (ce = this.pfxTabs_.getPrefixByCode(Q)),
                                        (ge = ce.getValue()),
                                        (C = C.substr(1)),
                                        (N = this.utabs_.getUnitByCode(C))),
                                    N && 'LOINC' == N.source_ && (N = null)),
                                N)
                            ) {
                                (R = N.clone()), R.resetFieldsForDerivedUnit();
                                let Ve = R.getProperty('dim_'),
                                    b = R.getProperty('magnitude_'),
                                    je = R.getProperty('name_'),
                                    Ne = R.getProperty('ciCode_'),
                                    at = R.getProperty('printSymbol_');
                                if (K) {
                                    K = parseInt(K);
                                    let ht = K;
                                    Ve && (Ve = Ve.mul(K)),
                                        (b = Math.pow(b, K)),
                                        R.assignVals({ magnitude_: b }),
                                        ce && De && ((ht *= ce.getExp()), (ge = Math.pow(10, ht)));
                                }
                                ce &&
                                    (R.cnv_
                                        ? R.assignVals({ cnvPfx_: ge })
                                        : ((b *= ge), R.assignVals({ magnitude_: b })));
                                let Et = R.csCode_;
                                if (
                                    (ce &&
                                        ((je = ce.getName() + je),
                                        (Et = Q + Et),
                                        (Ne = ce.getCiCode() + Ne),
                                        (at = ce.getPrintSymbol() + at),
                                        R.assignVals({ name_: je, csCode_: Et, ciCode_: Ne, printSymbol_: at })),
                                    K)
                                ) {
                                    let ht = K.toString();
                                    R.assignVals({
                                        name_: je + '<sup>' + ht + '</sup>',
                                        csCode_: Et + ht,
                                        ciCode_: Ne + ht,
                                        printSymbol_: at + '<sup>' + ht + '</sup>',
                                    });
                                }
                            } else
                                (R = null),
                                    this.suggestions_
                                        ? this._getSuggestions(j)
                                        : this.retMsg_.push(`${j} is not a valid UCUM code.`);
                        }
                    }
                    return [R, k];
                }
                _getUnitWithAnnotation(C, k) {
                    let R = null,
                        j = this._getAnnoText(C, k),
                        N = j[0],
                        K = j[1],
                        Q = j[2];
                    this.bracesMsg_ &&
                        -1 === this.retMsg_.indexOf(this.bracesMsg_) &&
                        this.retMsg_.push(this.bracesMsg_);
                    let ce = this.retMsg_.length;
                    if (K || Q)
                        if (K && !Q)
                            if (M.isIntegerUnit(K)) R = K;
                            else {
                                let ge = this._makeUnit(K, k);
                                ge[0]
                                    ? ((R = ge[0]), (R.csCode_ += N), (k = ge[1]))
                                    : this.retMsg_.push(
                                          `Unable to find a unit for ${K} that precedes the annotation ${N}.`,
                                      );
                            }
                        else if (!K && Q)
                            if (M.isIntegerUnit(Q))
                                (R = Q + N),
                                    this.retMsg_.push(
                                        `The annotation ${N} before the ``${Q} is invalid.\n` +
                                            this.vcMsgStart_ +
                                            R +
                                            this.vcMsgEnd_,
                                    );
                            else {
                                let ge = this._makeUnit(Q, k);
                                ge[0]
                                    ? ((R = ge[0]),
                                      (R.csCode_ += N),
                                      (k = R.csCode_),
                                      this.retMsg_.push(
                                          `The annotation ${N} before the unit code is invalid.\n` +
                                              this.vcMsgStart_ +
                                              R.csCode_ +
                                              this.vcMsgEnd_,
                                      ))
                                    : this.retMsg_.push(
                                          `Unable to find a unit for ${K} that follows the annotation ${N}.`,
                                      );
                            }
                        else
                            this.retMsg_.push(
                                `Unable to find a unit for ${K}${N}${Q}.\nWe are not sure how to interpret text both before and after the annotation.  Sorry`,
                            );
                    else {
                        let ge = '[' + N.substring(1, N.length - 1) + ']',
                            De = this._makeUnit(ge, k);
                        De[0]
                            ? ((R = C),
                              this.retMsg_.push(
                                  `${N} is a valid unit expression, but did you mean ${ge} (${De[0].name_})?`,
                              ))
                            : this.retMsg_.length > ce && this.retMsg_.pop(),
                            (R = new p({ csCode_: N, ciCode_: N, magnitude_: 1, name_: N }));
                    }
                    return [R, k];
                }
                _performUnitArithmetic(C, k) {
                    let R = C[0].un;
                    M.isIntegerUnit(R) && (R = new p({ csCode_: R, ciCode_: R, magnitude_: Number(R), name_: R }));
                    let j = C.length,
                        N = !1;
                    for (let K = 1; K < j && !N; K++) {
                        let Q = C[K].un;
                        if (
                            (M.isIntegerUnit(Q) &&
                                (Q = new p({ csCode_: Q, ciCode_: Q, magnitude_: Number(Q), name_: Q })),
                            null === Q || ('number' != typeof Q && !Q.getProperty))
                        ) {
                            let ce = `Unit string (${k}) contains unrecognized element`;
                            Q && (ce += ` (${this.openEmph_}${Q.toString()}${this.closeEmph_})`),
                                (ce += '; could not parse full string.  Sorry'),
                                this.retMsg_.push(ce),
                                (N = !0);
                        } else
                            try {
                                R = '/' === C[K].op ? R.divide(Q) : R.multiplyThese(Q);
                            } catch (ce) {
                                this.retMsg_.unshift(ce.message), (N = !0), (R = null);
                            }
                    }
                    return R;
                }
                _isCodeWithExponent(C) {
                    let k = [],
                        R = C.match(/(^[^\-\+]+?)([\-\+\d]+)$/);
                    return R && R[2] && '' !== R[2] ? (k.push(R[1]), k.push(R[2])) : (k = null), k;
                }
            }
            (ae.o = x),
                $(x, 'INVALID_ANNOTATION_CHAR_MSG', 'An invalid character was found in the annotation '),
                $(x, 'VALID_ANNOTATION_REGEX', /^\{[!-z|~]*\}$/),
                (x.getInstance = function () {
                    return new x();
                });
        },
        4870: (se, ae, U) => {
            'use strict';
            Object.defineProperty(ae, '__esModule', { value: !0 }), (ae.UnitTables = void 0);
            var O = U(9935).Ucum,
                q = new (class M {
                    constructor() {
                        (this.unitNames_ = {}),
                            (this.unitCodes_ = {}),
                            (this.codeOrder_ = []),
                            (this.unitStrings_ = {}),
                            (this.unitDimensions_ = {}),
                            (this.unitSynonyms_ = {}),
                            (this.massDimIndex_ = 0),
                            (this.dimVecIndexToBaseUnit_ = {});
                    }
                    unitsCount() {
                        return Object.keys(this.unitCodes_).length;
                    }
                    addUnit(v) {
                        v.name_ && this.addUnitName(v), this.addUnitCode(v), this.addUnitString(v);
                        try {
                            v.dim_.getProperty('dimVec_') && this.addUnitDimension(v);
                        } catch {}
                        if (v.isBase_) {
                            const _ = v.dim_.dimVec_;
                            let T;
                            for (let x = 0, F = _.length; null == T && x < F; ++x) 0 != _[x] && (T = x);
                            this.dimVecIndexToBaseUnit_[T] = v.csCode_;
                        }
                    }
                    addUnitName(v) {
                        let p = v.name_;
                        if (!p)
                            throw new Error(
                                `UnitTables.addUnitName called for a unit with no name.  Unit code = ${v.csCode_}.`,
                            );
                        this.unitNames_[p] ? this.unitNames_[p].push(v) : (this.unitNames_[p] = [v]);
                    }
                    addUnitCode(v) {
                        let p = v.csCode_;
                        if (!p) throw new Error('UnitTables.addUnitCode called for unit that has no code.');
                        if (this.unitCodes_[p])
                            throw new Error(
                                `UnitTables.addUnitCode called, already contains entry for unit with code = ${p}`,
                            );
                        if (((this.unitCodes_[p] = v), this.codeOrder_.push(p), 'g' == p)) {
                            let _ = v.dim_.dimVec_,
                                T = 0;
                            for (; T < _.length && _[T] < 1; T++);
                            this.massDimIndex_ = T;
                        }
                    }
                    addUnitString(v) {
                        let p = null;
                        if (((p = 1 == O.caseSensitive_ ? v.csUnitString_ : v.ciUnitString_), p)) {
                            let _ = { mag: v.baseFactorStr_, unit: v };
                            this.unitStrings_[p] ? this.unitStrings_[p].push(_) : (this.unitStrings_[p] = [_]);
                        }
                    }
                    addUnitDimension(v) {
                        let p = v.dim_.getProperty('dimVec_');
                        if (!p)
                            throw new Error(
                                `UnitTables.addUnitDimension called for a unit with no dimension.  Unit code = ${v.csCode_}.`,
                            );
                        this.unitDimensions_[p] ? this.unitDimensions_[p].push(v) : (this.unitDimensions_[p] = [v]);
                    }
                    buildUnitSynonyms() {
                        for (let v in this.unitCodes_) {
                            let p = this.unitCodes_[v],
                                _ = p.synonyms_;
                            if (_) {
                                let T = _.split(';');
                                if ('' !== T[0]) {
                                    let x = T.length;
                                    for (let F = 0; F < x; F++) {
                                        let C = T[F].trim();
                                        this.addSynonymCodes(v, C);
                                    }
                                }
                            }
                            this.addSynonymCodes(v, p.name_);
                        }
                    }
                    addSynonymCodes(v, p) {
                        let _ = p.split(' '),
                            T = _.length;
                        for (let x = 0; x < T; x++) {
                            let F = _[x];
                            this.unitSynonyms_[F]
                                ? -1 === this.unitSynonyms_[F].indexOf(v) && this.unitSynonyms_[F].push(v)
                                : (this.unitSynonyms_[F] = [v]);
                        }
                    }
                    getUnitByCode(v) {
                        let p = null;
                        return v && (p = this.unitCodes_[v]), p;
                    }
                    getUnitByName(v) {
                        if (null == v) throw new Error('Unable to find unit by name because no name was provided.');
                        let p = v.indexOf(O.codeSep_),
                            _ = null;
                        p >= 1 && ((_ = v.substr(p + O.codeSep_.length)), (v = v.substr(0, p)));
                        let T = this.unitNames_[v];
                        if (T) {
                            let x = T.length;
                            if (_ && x > 1) {
                                let F = 0;
                                for (; T[F].csCode_ !== _ && F < x; F++);
                                T = F < x ? [T[F]] : null;
                            }
                        }
                        return T;
                    }
                    getUnitByString(v) {
                        let p = null;
                        return v && ((p = this.unitStrings_[v]), void 0 === p && (p = null)), p;
                    }
                    getUnitsByDimension(v) {
                        let p = null;
                        if (null == v)
                            throw new Error('Unable to find unit by because no dimension vector was provided.');
                        return (
                            (p = this.unitDimensions_[v]),
                            null == p && console.log(`Unable to find unit with dimension = ${v}`),
                            p
                        );
                    }
                    getUnitBySynonym(v) {
                        let p = {},
                            _ = [];
                        try {
                            if (null == v)
                                throw (
                                    ((p.status = 'error'),
                                    new Error('Unable to find unit by synonym because no synonym was provided.'))
                                );
                            0 === Object.keys(this.unitSynonyms_).length && this.buildUnitSynonyms();
                            let T = [];
                            if (((T = this.unitSynonyms_[v]), T)) {
                                p.status = 'succeeded';
                                let x = T.length;
                                for (let F = 0; F < x; F++) _.push(this.unitCodes_[T[F]]);
                                p.units = _;
                            }
                            0 === _.length &&
                                ((p.status = 'failed'), (p.msg = `Unable to find any units with synonym = ${v}`));
                        } catch (T) {
                            p.msg = T.message;
                        }
                        return p;
                    }
                    getAllUnitNames() {
                        return Object.keys(this.unitNames_);
                    }
                    getUnitNamesList() {
                        let v = [],
                            p = Object.keys(this.unitCodes_);
                        p.sort(this.compareCodes);
                        let _ = p.length;
                        for (let T = 0; T < _; T++) v[T] = p[T] + O.codeSep_ + this.unitCodes_[p[T]].name_;
                        return v;
                    }
                    getMassDimensionIndex() {
                        return this.massDimIndex_;
                    }
                    compareCodes(v, p) {
                        return (v = (v = v.replace(/[\[\]]/g, '')).toLowerCase()) <
                            (p = (p = p.replace(/[\[\]]/g, '')).toLowerCase())
                            ? -1
                            : 1;
                    }
                    getAllUnitCodes() {
                        return Object.keys(this.unitCodes_);
                    }
                    allUnitsByDef() {
                        let v = [],
                            p = this.codeOrder_.length;
                        for (let _ = 0; _ < p; _++) v.push(this.getUnitByCode(this.codeOrder_[_]));
                        return v;
                    }
                    allUnitsByName(v, p) {
                        null == p && (p = '|');
                        let _ = '',
                            T = this.getAllUnitNames(),
                            x = T.length,
                            F = v.length;
                        for (let C = 0; C < x; C++) {
                            let k = this.getUnitByName(T[C]);
                            for (let R = 0; R < k.length; R++) {
                                let j = k[R];
                                for (let N = 0; N < F; N++)
                                    if ((N > 0 && (_ += p), 'dim_' === v[N]))
                                        _ +=
                                            null != j.dim_ && j.dim_.dimVec_ instanceof Array
                                                ? '[' + j.dim_.dimVec_.join(',') + ']'
                                                : '';
                                    else {
                                        let K = j[v[N]];
                                        _ += 'string' == typeof K ? K.replace(/[\n\r]/g, ' ') : K;
                                    }
                                _ += '\r\n';
                            }
                        }
                        return _;
                    }
                    printUnits(v, p) {
                        void 0 === v && (v = !1), void 0 === p && (p = '|');
                        let _ = '',
                            T = this.codeOrder_.length,
                            x = 'csCode' + p;
                        v && (x += 'ciCode' + p),
                            (x += 'name' + p),
                            v && (x += 'isBase' + p),
                            (x +=
                                'magnitude' + p + 'dimension' + p + 'from unit(s)' + p + 'value' + p + 'function' + p),
                            v &&
                                (x +=
                                    'property' +
                                    p +
                                    'printSymbol' +
                                    p +
                                    'synonyms' +
                                    p +
                                    'source' +
                                    p +
                                    'class' +
                                    p +
                                    'isMetric' +
                                    p +
                                    'variable' +
                                    p +
                                    'isSpecial' +
                                    p +
                                    'isAbitrary' +
                                    p),
                            (x += 'comment'),
                            (_ = x + '\n');
                        for (let F = 0; F < T; F++) {
                            let C = this.getUnitByCode(this.codeOrder_[F]);
                            (x = this.codeOrder_[F] + p),
                                v && (x += C.getProperty('ciCode_') + p),
                                (x += C.getProperty('name_') + p),
                                v && (C.getProperty('isBase_') ? (x += 'true' + p) : (x += 'false' + p)),
                                (x += C.getProperty('magnitude_') + p);
                            let k = C.getProperty('dim_');
                            (x += k ? k.dimVec_ + p : 'null' + p),
                                (x += C.csUnitString_
                                    ? C.csUnitString_ + p + C.baseFactor_ + p
                                    : 'null' + p + 'null' + p),
                                (x += C.cnv_ ? C.cnv_ + p : 'null' + p),
                                v &&
                                    (x +=
                                        C.getProperty('property_') +
                                        p +
                                        C.getProperty('printSymbol_') +
                                        p +
                                        C.getProperty('synonyms_') +
                                        p +
                                        C.getProperty('source_') +
                                        p +
                                        C.getProperty('class_') +
                                        p +
                                        C.getProperty('isMetric_') +
                                        p +
                                        C.getProperty('variable_') +
                                        p +
                                        C.getProperty('isSpecial_') +
                                        p +
                                        C.getProperty('isArbitrary_') +
                                        p),
                                C.defError_ && (x += 'problem parsing this one, deferred to later.'),
                                (_ += x + '\n');
                        }
                        return _;
                    }
                })();
            ae.UnitTables = {
                getInstance: function () {
                    return q;
                },
            };
        },
        2219: (se, ae, U) => {
            'use strict';
            var M = U(3463)('ArrayBuffer.prototype.byteLength', !0),
                q = U(3066);
            se.exports = function ($) {
                return q($) ? (M ? M($) : $.byteLength) : NaN;
            };
        },
        1994: se => {
            se.exports = function ae(U) {
                U.FieldAlarms.soundData_ =
                    'data:audio/mp3;base64,/+OAxAAAAAAAAAAAAEluZm8AAAAPAAAABwAADQ4AJCQkJCQkJCQkJCQkJCRJSUlJSUlJSUlJSUlJSW1tbW1tbW1tbW1tbW1tkpKSkpKSkpKSkpKSkpKStra2tra2tra2tra2trbb29vb29vb29vb29vb2///////////////////AAAAWkxBTUUzLjkyIAHDAAAAAAAAAAACQCQF2SEAAAAAAA0OXWa08wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+OAxABa1IIMF5uwACCDBAGAB/86aEEGTrP/hZNdJTyqr/pn4OCRDARfjtIEHqAZfjEAZzj+AZkhOeMiITA2IE0A1rkeA6cdIA9GMcA66Ro+MmOYSZqT4G0RQAGcoYgGMcNoGAQPQGJ4KH4wyIEXNjUiYGUkgoGMMRYGEkBIGFkLYGG8P4GGMDv8tmpPn0J4DEOL0DGmI8AYFQGEkHIGDUHIGDEBYGD4F3/NicKiaCSJfLYGBoAQr4GFIIgGDoGwGCYAgGCsC4WhAFAQAw7hT//PE+ZmREB5IkLgGAO8ghUAwXgbAaAuUwMAIHQMFYDwMQAngMUwZgIAJAx5CmAwpAQFrAwcAs//6d97vTdngYJAPAFAkAGAeK2DlAGABluASAMDAaAsL3gYBwBgYAwDgNAHDU///////AwBgDDfxkBjxS4aoGQWIIF0nxWgYoFgJoAwBABwFBBQMiCAH//4GAUAIGAMA4DQBwAgDhc2MmBgWAgDY6AcA9UJAILy11W1dqwrXViy2OQCw1TFUqEku6WxLaggJZ4skWaLxKbQemiY/+OCxCha9IJFQ9jwABJw+YDYFRgagfGCiDUYQ4UhhvilGSSRkauQAZguA5mCgBuYC4DRgKgBBcBJxU5SzpgBADmAMAWYBQC5gFgGGAaAUYBIAxgDgBGAGAAWaQeV070dgBymHLDLDKmVMoEw1xZajTDtnsNKVBQAEwCgITBSAeMBcAgFABJFLucp3ozGYzLYzGcq0qpYzGYy5L+w67LszVqmv3dVYzLY1Gniac/0PRp/mlJiNeh6TyyNRqNQ1GYZf2GX9jLOXVgatTQ0/0PQWYEALbAkTlAVSs5a6zl/Xdh2My6mtayzq1aXKmlVymtU2WPa0n3n+tZY1X2TgjVNTU1al3j+5mUfg0WUQn9ZWvyxu473zH/5r/5jzHX/zHDn719rLLn3bO+5VuxaGm/ZbLbUqtU1rLP48+l/Hm5bD1NTUtLZpsfwxxuZU2SPPcqaaQAhh+FryH0uXjKpcoDewl+bSaWw/SLjbQLj8agKecVQYFATAIARMA0CgwBgSzAVCgMFAdkxD47Tt0DxMGgRAwHwVTAtAHBwVhgyiBBgOSTMH//jgsRRWgyCFULXtuQ5FkPVXXrENw3ZinyWZDgGE5YWqR/J+P0gNEVBZdGEjl1wlmZgAkb+ljIIyOMR2tdf7s3Fbzds47dprvwFI701C0yHDlMW5VhyelLWaO8MgTbROzjZc4MF3gn26qtiU/vstkOdu+6bR0TXks1pmVLtAosYDlE1+mY4CbaNMqlEbpb2oKk8kty2tauSKXyZusW+ih2GakYp2DVpRlRUUnmnjVAX3jVmJ87EpXEdSBuqVOMVFA1JhGCC4zBkqv3MotL5fRw1HpdnGpJD8odr56cgJyb0jm3ihiHJuIu9KqODsvkUzhS1uSqWx0EAa/YQ/N+jcF8ZqGIgoEJBNBSV5hbC9sZqDr8MqW/L6sVl2MM2pIYKQJncuwwqmR50hLvF3Zl0dUbAs7ViSSi7QSKIS6Hc9Z27ECMHRnIgBDAGAaMAkFEwJwFzEzJPMjjX89/l5TFqBeMCUC0wEQATAoA6MEcGZLtXk5SdWTA29vrU1POVTvBQwfEZbbtQ9KZRD4oA2JAExp9XBhyXxJK8wCALmttYq1rcamv/44LEfVscgggNWvAAViw7L6zk9Vh+eytw9KmttugmdZokWo5RJ9Yu1LMGBV5fOP9uEEwAMlpIJbWahqdmqlWgn6Wwy59WI3ZbHZA4bymB6BIDAFm5xtUiw1q/GXrsw5uVPLDVSnhFR+FtwKuxe0odCHpdTY3aTeFXka5L9KrAYBKV0UruS7KR3rlM6Rf7O8IgAXsQVijiSx5VrLCt86jEXVWbYclwoBj7IlH2ssGpJG6NiIPhGnLaWuZe7uxJ/YTMu03Z2WbQA3GSqbLqaS4sOupDcvf2rF4csW3Rrqyr2lcMUuT1ONYu3KGWwqgqOjCIy+2FuUhYAeBcoRTVBCSCRkof4QBfxYWZQMRCQAd1kQCzHgTXLwA6pYCCAFTAtBRMD8A8wOAcTBoAvMFUQ6GoZRCMKEQcwQJFzHkCyMMINwwiBNTHuK1MwwuswSAgVbn3Y0wIwvARi7Jg+AoAIDkwFwCzCwDVMKwEcwNAbzCAB1MDADCD4KhrN4jAwAOAoD5gNgDoCTAnAZDAMzA6BpMFYCcwBQVjAmA/MBIAQwMQUIat/+OCxKV/zGIABZrwAMBRK/NGBWBKQgDquMCEBtC9SwwGQATAMAVEIERgWgPBcAwwIwKgwCswCwJq1/H8pmqVAAAUATDQIAGFgCAAAIYBAACxTASAEMCUBQqgRmAiBIPARGAYBWYAYBRYALMBgB198JmryrV5vY8ABPGAMAAvFWNPARgImBAAOhPLVs3MAMAMwCAFwwCEEAHmAsAmCAADACAXAQEIhAUAgAqNhgFgJNdxrZbmq3a1butJ1v0YBIA8aZIgPTQXQ+4QAAtRUiDiXKNgNAIAwCyRxgBgCISwSAUBgEiAAkEgCK/AAB6gSMoCAFZj3HHUzVwmavKtXn+zR/ggAxmKQb8l91L0w3HTDLfoL0KAeLqELfTsYKAABU4AsACBgBUdAYAGmaFwBkEq+ACAFOoZJ9JpFtmHoCkNkdca2W61btat3Wu739XH6qokhHEYI6j8M4aRRKZP2lS1p8UxbTope7WqTEFNRTMuOTKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv/jgsQ6AAADSAHAAACqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqpMQU1FMy45Mqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqr/44LE/wAAA0gAAAAAqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqTEFNRTMuOTKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq';
            };
        },
        8898: se => {
            if (typeof ae > 'u') var ae = {};
            se.exports = function U(O, M) {
                'use strict';
                var q = M.PrototypeAPI.Browser,
                    G =
                        (!!window.attachEvent && !q.isOpera) ||
                        (typeof navigator < 'u' && navigator.userAgent.indexOf('Trident') >= 0),
                    $ = M.jqueryLite.ui.keyCode;
                (M.Autocompleter = {
                    isIE: G,
                    currentAutoCompField_: -1,
                    USE_STATISTICS: 2,
                    NO_COMPLETION_SUGGESTIONS: 0,
                    SUGGEST_SHORTEST: 1,
                    LIST_ITEM_FIELD_SEP: ' - ',
                    screenReaderLog_: new M.ScreenReaderLog(),
                    setOptions: function (p) {
                        Object.assign(this, p);
                    },
                    getFieldVal: function (p) {
                        return p.value;
                    },
                    setFieldVal: function (p, _, T) {
                        var x;
                        p.autocomp
                            ? p.autocomp.setFieldVal(_, T)
                            : (typeof T > 'u' && (T = !0),
                              T && (x = this.getFieldVal(p)),
                              (p.value = _),
                              T && x !== _ && M.Event.simulate(p, 'change'));
                    },
                    getFieldLookupKey: M.Observable.lookupKey,
                    lookupFields: function (p) {
                        for (var _ = [], T = 0, x = document.forms.length; T < x; ++T) {
                            var F = document.forms[T].elements[p];
                            void 0 !== F && _.push(F);
                        }
                        return _;
                    },
                    findRelatedFields: function (p, _) {
                        return this.lookupFields(_);
                    },
                    getFieldLabel: function (p) {
                        return null;
                    },
                    listItemElementContainer: function () {
                        var p = document.querySelector('#completionOptions').firstChild;
                        return p && 'TABLE' === p.tagName && (p = p.tBodies[0]), p;
                    },
                    listItemElements: function () {
                        var p = null,
                            _ = this.listItemElementContainer();
                        return _ && (p = _.childNodes), p;
                    },
                    setOffAlarm: function (p) {
                        M.FieldAlarms.setOffAlarm(p);
                    },
                    cancelAlarm: function (p) {
                        M.FieldAlarms.cancelAlarm(p);
                    },
                    stopEvent: function (p) {
                        p.stopImmediatePropagation(), p.preventDefault();
                    },
                    screenReaderLog: function (p) {
                        M.Autocompleter.screenReaderLog_.add(p);
                    },
                    createDOMCache: function (p, _) {
                        var T = {
                            data: {},
                            get: function (x) {
                                var F = this.data[x];
                                return void 0 === F && (F = this.data[x] = this.refresh[x].apply(this)), F;
                            },
                            set: function (x, F) {
                                this.data[x] = F;
                            },
                            invalidate: function (x) {
                                x ? delete this.data[x] : (this.data = {});
                            },
                            refresh: {},
                        };
                        return Object.assign(T, p), Object.assign(T.refresh, _), T;
                    },
                }),
                    (M.Autocompleter.Base = function () {}),
                    Object.assign(M.Autocompleter.Base, {
                        MAX_ITEMS_BELOW_FIELD: 7,
                        classInit_: !1,
                        classInit: function () {
                            this.classInit_ ||
                                (document.body.insertAdjacentHTML(
                                    'beforeend',
                                    '<div id="searchResults" class="form_auto_complete">              <div id="completionOptionsScroller">             <span class="auto_complete" id="completionOptions"></span>              </div>              <div id="moreResults">See more items (Ctl Ret)</div>              <div id="searchCount">Search Results\x3c!-- place holder for result count,               needed for height calculation--\x3e</div>              <div id="searchHint">Search Hint\x3c!--place holder--\x3e</div>              </div>',
                                ),
                                document.querySelector('#moreResults').addEventListener('mousedown', function (p) {
                                    var _ = O(M.Autocompleter.currentAutoCompField_);
                                    _.autocomp.handleSeeMoreItems(p),
                                        M.Autocompleter.Event.notifyObservers(_, 'LIST_EXP', {
                                            list_expansion_method: 'clicked',
                                        });
                                }),
                                document.querySelector('#completionOptionsScroller').addEventListener(
                                    'mousedown',
                                    function (p) {
                                        if (
                                            M.Autocompleter.isIE &&
                                            'completionOptionsScroller' === p.target.id &&
                                            (M.Autocompleter.stopEvent(p),
                                            (M.Autocompleter.completionOptionsScrollerClicked_ = !0),
                                            -1 != O(M.Autocompleter.currentAutoCompField_))
                                        ) {
                                            var _ = O(M.Autocompleter.currentAutoCompField_);
                                            setTimeout(function () {
                                                _.focus();
                                            });
                                        }
                                    }.bind(this),
                                ),
                                (this.classInit_ = !0));
                        },
                        noCaseSort: function (p, _) {
                            var T = p.toLowerCase(),
                                x = _.toLowerCase();
                            return T > x ? 1 : T < x ? -1 : 0;
                        },
                        escapeAttribute: M.PrototypeAPI.escapeAttribute,
                        unescapeAttribute: function (p) {
                            return p
                                .replace(/&amp;/g, '&')
                                .replace(/&quot;/g, '"')
                                .replace(/&#39;/g, "'")
                                .replace(/&lt;/g, '<')
                                .replace(/&gt;/g, '>');
                        },
                    }),
                    (M.Autocompleter.sharedDOMCache = M.Autocompleter.createDOMCache(
                        {},
                        {
                            spacerDiv: function () {
                                var p = O('spacer');
                                return (
                                    p ||
                                        ((p = document.createElement('div')).setAttribute('id', 'spacer'),
                                        document.body.appendChild(p)),
                                    p
                                );
                            },
                            listContainer: function () {
                                return O('searchResults');
                            },
                            firstEntryWidth: function () {
                                return M.Autocompleter.listItemElements()[0].offsetWidth;
                            },
                            listBoundingRect: function () {
                                return this.get('listContainer').getBoundingClientRect();
                            },
                            viewPortWidth: function () {
                                return document.documentElement.clientWidth;
                            },
                            spacerCoords: function () {
                                return this.get('spacerDiv').getBoundingClientRect();
                            },
                        },
                    ));
                var v = {
                    constructorOpts_: null,
                    scoreField_: null,
                    scoreFieldInitialized_: !1,
                    itemToDataIndex_: null,
                    selectedCodes_: null,
                    selectedItems_: null,
                    selectedItemData_: null,
                    matchListValue_: null,
                    invalidStatus_: !1,
                    matchStatus_: !0,
                    focusInProgress_: !1,
                    refocusInProgress_: !1,
                    listBelowField_: !0,
                    listContainer: null,
                    recDataRequester_: null,
                    enabled_: !0,
                    preFieldFillVal_: null,
                    fieldValIsListVal_: null,
                    indexToHeadingLevel_: {},
                    suggestionMode_: M.Autocompleter.SUGGEST_SHORTEST,
                    lastScrollEffect_: null,
                    multiSelect_: !1,
                    listExtraData_: null,
                    processedFieldVal_: null,
                    defAutocompleterBaseInit: function (p, _) {
                        _ || (_ = {}),
                            _.wordBoundaryChars && (_.tokens = _.wordBoundaryChars),
                            void 0 !== _.suggestionMode && (this.suggestionMode_ = _.suggestionMode),
                            (this.twoColumnFlow_ = _.twoColumnFlow),
                            void 0 === this.twoColumnFlow_ && (this.twoColumnFlow_ = !0),
                            (this.caseInsenstiveSelection_ = _.caseInsenstiveSelection),
                            void 0 === this.caseInsenstiveSelection_ && (this.caseInsenstiveSelection_ = !0),
                            _.tokens || void 0 === _.maxSelect
                                ? (_.maxSelect = 1)
                                : '*' === _.maxSelect && (_.maxSelect = 1 / 0),
                            (this.multiSelect_ = 1 !== _.maxSelect),
                            (this.scrolledContainer_ =
                                void 0 !== _.scrolledContainer ? _.scrolledContainer : document.documentElement),
                            void 0 === (this.nonMatchSuggestions_ = _.nonMatchSuggestions) &&
                                (this.nonMatchSuggestions_ = !1),
                            (this.constructorOpts_ = _),
                            this.initStoredSelectionData();
                        var T = _.dataRequester;
                        if (
                            (M.Autocompleter.Base.classInit_ || M.Autocompleter.Base.classInit(),
                            (this.matchListValue_ = _.matchListValue || !1),
                            (this.recDataRequester_ = T),
                            (this.update = O('completionOptions')),
                            (this.options = _),
                            (this.options.frequency = this.options.frequency || 0.01),
                            (this.options.minChars = this.options.minChars || 1),
                            (this.element = 'string' == typeof p ? O(p) : p),
                            !this.element)
                        )
                            throw 'string' == typeof p
                                ? new Error("Could not find the field with id '" + p + '"')
                                : new Error('The autocompleter constructor requires an field element or an ID');
                        if (
                            (this.ensureNeededAttrs(),
                            (this.hasFocus = !1),
                            (this.changed = !1),
                            (this.active = !1),
                            (this.index = 0),
                            (this.entryCount = 0),
                            (this.observer = null),
                            this.element.setAttribute('autocomplete', 'off'),
                            (this.update.style.display = 'none;'),
                            (this.elementEventListeners = {}),
                            this.addEventListenerToElement('blur', this.onBlur.bind(this)),
                            this.addEventListenerToElement('keydown', this.onKeyPress.bind(this)),
                            this.options.tokens &&
                                this.addEventListenerToElement(
                                    'click',
                                    function () {
                                        (this.tokenBounds = null), this.getTokenBounds(this.element.selectionStart);
                                    }.bind(this),
                                ),
                            _.maxSelect > 1)
                        ) {
                            var x = document.createElement('span');
                            x.classList.add('autocomp_selected'),
                                this.element.parentNode.replaceChild(x, this.element),
                                x.appendChild(document.createElement('ul')),
                                x.appendChild(this.element),
                                (this.selectedList = x.firstChild);
                        }
                        this.element.setAttribute('role', 'combobox'),
                            this.element.setAttribute('aria-expanded', 'false'),
                            (this.onMouseDownListener = this.onMouseDown.bind(this)),
                            this.addEventListenerToElement('change', this.onChange.bind(this)),
                            this.addEventListenerToElement('keypress', this.changeToFieldByKeys.bind(this));
                        var C = function () {
                            this.typedSinceLastFocus_ = !0;
                        }.bind(this);
                        this.addEventListenerToElement('paste', C),
                            this.addEventListenerToElement('cut', C),
                            (this.listContainer = M.Autocompleter.sharedDOMCache.get('listContainer')),
                            (this.options.showList = this.showList.bind(this)),
                            (this.options.hideList = this.hideList.bind(this)),
                            (this.options.posAnsList = this.posAnsList.bind(this)),
                            (this.update.style.display = 'block'),
                            (this.element.autocomp = this),
                            (this.index = -1),
                            this.initDOMCache(),
                            (this.oldElementValue = this.domCache.get('elemVal'));
                    },
                    setFieldVal: function (p, _) {
                        var T;
                        typeof _ > 'u' && (_ = !0),
                            _ && (T = this.domCache.get('elemVal')),
                            this.domCache.set('elemVal', (this.element.value = this.oldElementValue = p)),
                            (this.tokenBounds = null),
                            _ && T !== p && M.Event.simulate(this.element, 'change');
                    },
                    ensureNeededAttrs: function () {
                        var p = this.element;
                        '' === p.id &&
                            (M.Autocompleter.lastGeneratedID_ || (M.Autocompleter.lastGeneratedID_ = 0),
                            (p.id = 'ac' + ++M.Autocompleter.lastGeneratedID_));
                    },
                    initStoredSelectionData: function () {
                        (this.selectedCodes_ = {}), (this.selectedItems_ = {}), (this.selectedItemData_ = []);
                    },
                    clearStoredSelection: function () {
                        this.initStoredSelectionData(), this.multiSelect_ && (this.selectedList.innerHTML = '');
                    },
                    dupDataReqForField: function (p) {
                        var _ = null;
                        return this.recDataRequester_ && (_ = this.recDataRequester_.dupForField(p)), _;
                    },
                    getSelectedCodes: function () {
                        for (var p = this.getSelectedItems(), _ = [], T = 0, x = p.length; T < x; ++T)
                            _.push(this.selectedCodes_[p[T]]);
                        return _;
                    },
                    getSelectedItems: function () {
                        return Object.keys(this.selectedItems_);
                    },
                    getSelectedItemData: function () {
                        return this.selectedItemData_.length > 0 ? this.selectedItemData_ : null;
                    },
                    storeSelectedItem: function (p, _) {
                        if (
                            (void 0 === p && ((p = this.domCache.get('elemVal')), (_ = this.getItemCode(p))),
                            this.multiSelect_ || this.clearStoredSelection(),
                            p)
                        ) {
                            var x,
                                T = null != _;
                            T && (this.selectedCodes_[p] = _),
                                (this.selectedItems_[p] = 1),
                                this.getItemData ? (x = this.getItemData(p)) : ((x = { text: p }), T && (x.code = _)),
                                this.selectedItemData_.push(x);
                        }
                    },
                    getItemCode: function (p) {
                        this.itemToDataIndex_ || this.initItemToDataIndex();
                        var _ = this.itemToDataIndex_[p],
                            T = null;
                        return void 0 !== _ && this.itemCodes_ && (T = this.itemCodes_[_]), T;
                    },
                    addToSelectedArea: function (p) {
                        var _ = M.Autocompleter.Base.escapeAttribute(p);
                        return (
                            this.selectedList.insertAdjacentHTML(
                                'beforeend',
                                '<li><button type="button" aria-label="&quot;' +
                                    _ +
                                    '&quot; item remove"><span aria-hidden="true">&times;</span></button>' +
                                    _ +
                                    '</li>',
                            ),
                            this.selectedList.lastChild.childNodes[0].addEventListener(
                                'click',
                                this.removeSelection.bind(this),
                            ),
                            _
                        );
                    },
                    moveEntryToSelectedArea: function () {
                        var p = this.addToSelectedArea(this.domCache.get('elemVal'));
                        if (
                            (this.setFieldVal((this.processedFieldVal_ = ''), !1),
                            M.Autocompleter.screenReaderLog('Selected ' + p),
                            this.index >= 0)
                        ) {
                            var _ = M.Autocompleter.listItemElementContainer();
                            _.removeChild(this.getCurrentEntry()), --this.entryCount;
                            for (var T = _.childNodes, x = this.index, F = T.length; x < F; ++x)
                                T[x].autocompleteIndex = x;
                            if ((this.index == this.entryCount && --this.index, this.numHeadings_)) {
                                for (
                                    var C = this.index;
                                    this.index < this.entryCount && this.liIsHeading(this.getCurrentEntry());

                                )
                                    ++this.index;
                                if (this.index == this.entryCount)
                                    for (
                                        this.index = C - 1;
                                        this.index > 0 && this.liIsHeading(this.getCurrentEntry());

                                    )
                                        --this.index;
                            }
                            this.render();
                        }
                        (this.active = !0), (this.hasFocus = !0), this.posAnsList();
                    },
                    removeSelection: function (p) {
                        var _ = p.target.parentNode;
                        'SPAN' === p.target.tagName && (_ = _.parentNode), _.parentNode.removeChild(_);
                        var T = _.childNodes[1].textContent;
                        delete this.selectedCodes_[T], delete this.selectedItems_[T];
                        for (var x = 0, F = this.selectedItemData_.length; x < F; ++x)
                            if (this.selectedItemData_[x].text === T) {
                                this.selectedItemData_.splice(x, 1);
                                break;
                            }
                        this.listSelectionNotification(T, !0, !0), M.Autocompleter.screenReaderLog('Unselected ' + T);
                    },
                    isSelected: function (p) {
                        return this.selectedItems_ && void 0 !== this.selectedItems_[p];
                    },
                    getScoreField: function () {
                        return (
                            this.scoreFieldInitialized_ ||
                                ((this.scoreField_ = M.Autocompleter.getScoreField(this.element)),
                                this.scoreField_ && (this.scoreFieldInitialized_ = !0)),
                            this.scoreField_
                        );
                    },
                    changeToFieldByKeys: function (p) {
                        if (!this.typedSinceLastFocus_) {
                            var _ = !1;
                            typeof p.which > 'u'
                                ? (_ = !0)
                                : 'number' == typeof p.which &&
                                  p.which > 0 &&
                                  (_ = !p.ctrlKey && !p.metaKey && !p.altKey && 8 !== p.which),
                                (this.typedSinceLastFocus_ = _);
                        }
                    },
                    addObservers: function (p) {
                        p.addEventListener('mousedown', this.onMouseDownListener);
                    },
                    listItemValue: function (p) {
                        return this.options.tableFormat ? p.getAttribute('data-fieldval') : p.textContent;
                    },
                    markPrevious: function () {
                        null === this.preFieldFillVal_ && (this.preFieldFillVal_ = this.domCache.get('elemVal'));
                        var _,
                            p = this.index;
                        -1 === p && (p = this.entryCount - 1);
                        do {
                            this.index > 0 ? this.index-- : (this.index = this.entryCount - 1),
                                (_ = this.getCurrentEntry());
                            var T = this.listItemValue(_);
                            this.itemTextIsHeading(T) &&
                                (M.Autocompleter.screenReaderLog('Above list heading: ' + T), (_ = null));
                        } while (!_ && this.index !== p);
                        _ && (this.scrollToShow(_, this.update.parentNode), this.updateElementAfterMarking(_));
                    },
                    markNext: function () {
                        null === this.preFieldFillVal_ && (this.preFieldFillVal_ = this.domCache.get('elemVal'));
                        var _,
                            p = this.index;
                        -1 === p && (p = this.entryCount - 1);
                        do {
                            this.index < this.entryCount - 1 ? this.index++ : (this.index = 0),
                                (_ = this.getCurrentEntry());
                            var T = this.listItemValue(_);
                            this.itemTextIsHeading(T) &&
                                (M.Autocompleter.screenReaderLog('Under list heading: ' + T), (_ = null));
                        } while (!_ && this.index !== p);
                        _ && (this.scrollToShow(_, this.update.parentNode), this.updateElementAfterMarking(_));
                    },
                    updateElementAfterMarking: function (p) {
                        var _ = this.tokenBounds;
                        if (
                            (this.updateElement(p),
                            this.options.tokens
                                ? (this.getTokenBounds(_ && _[0]),
                                  this.element.setSelectionRange(this.tokenBounds[0], this.tokenBounds[1]))
                                : this.element.select(),
                            this.options.tableFormat)
                        ) {
                            var T = [],
                                x = p.querySelectorAll('td');
                            if (x.length > 1) {
                                for (var F = 0, C = x.length; F < C; ++F) T.push(x[F].innerText);
                                M.Autocompleter.screenReaderLog(T.join('; '));
                            }
                        }
                    },
                    hideList: function () {
                        M.Autocompleter.currentAutoCompField_ === this.element.id &&
                            ('visible' !== this.listContainer.style.visibility ||
                                ((this.listContainer.style.visibility = 'hidden'),
                                (this.listShowing = !1),
                                this.listContainer.setAttribute('aria-hidden', 'true'),
                                this.element.setAttribute('aria-expanded', 'false'),
                                window.removeEventListener('resize', this.windowResizeEventHandler)));
                    },
                    showList: function () {
                        var p = 'visible' !== this.listContainer.style.visibility;
                        (this.listContainer.style.visibility = 'visible'),
                            (this.listShowing = !0),
                            this.listContainer.setAttribute('aria-hidden', 'false'),
                            this.element.setAttribute('aria-expanded', 'true'),
                            p &&
                                !this.temporaryHide_ &&
                                this.entryCount > 0 &&
                                (M.Autocompleter.screenReaderLog(
                                    'A list has appeared below the ' + this.getFieldName() + '.',
                                ),
                                this.options.tableFormat &&
                                    this.options.colHeaders &&
                                    M.Autocompleter.screenReaderLog(
                                        'The column headers on the multi-column list are ' +
                                            this.options.colHeaders.join('; '),
                                    )),
                            (this.windowResizeEventHandler = this.posAnsList.bind(this)),
                            window.addEventListener('resize', this.windowResizeEventHandler);
                    },
                    getFieldName: function () {
                        if (void 0 === this.fieldName_) {
                            var p = M.Autocompleter.getFieldLabel(this.element.id);
                            this.fieldName_ = null === p ? 'field' : 'field "' + p + '"';
                        }
                        return this.fieldName_;
                    },
                    scrollToShow: function (p, _) {
                        if (p.offsetTop < _.scrollTop) _.scrollTop = p.offsetTop;
                        else {
                            var T = p.clientHeight,
                                x = _.clientHeight;
                            p.offsetTop + T - _.scrollTop > x && (_.scrollTop = p.offsetTop + T - x);
                        }
                    },
                    pageOptionsUpOrDown: function (p) {
                        var x,
                            _ = document.querySelector('#completionOptionsScroller'),
                            T = _.clientHeight;
                        if (p) _.scrollTop > 0 && ((x = _.scrollTop - T) < 0 && (x = 0), (_.scrollTop = x));
                        else {
                            var C = document.querySelector('#completionOptions').clientHeight - T;
                            C < 0 && (C = 0),
                                _.scrollTop < C && ((x = _.scrollTop + T) > C && (x = C), (_.scrollTop = x));
                        }
                    },
                    isSearchKey: function (p) {
                        return p.ctrlKey && p.keyCode === $.ENTER;
                    },
                    onKeyPress: function (p) {
                        if (this.enabled_) {
                            var _ = p.keyCode,
                                T = !0;
                            if (this.fieldEventIsBigList(p))
                                p.stopImmediatePropagation(),
                                    this.preFieldFillVal_ && this.setFieldVal(this.preFieldFillVal_, !1),
                                    this.handleSeeMoreItems(p),
                                    M.Autocompleter.Event.notifyObservers(this.element, 'LIST_EXP', {
                                        list_expansion_method: 'CtrlRet',
                                    });
                            else {
                                var x = $;
                                switch (_) {
                                    case x.ENTER:
                                        this.multiSelect_ && M.Autocompleter.stopEvent(p), this.handleDataEntry(p);
                                        break;
                                    case x.TAB:
                                        '' !== this.domCache.get('elemVal') && this.handleDataEntry(p);
                                        break;
                                    case x.ESCAPE:
                                        null !== this.preFieldFillVal_ &&
                                            (this.setFieldVal(this.preFieldFillVal_, !1),
                                            M.Autocompleter.Event.notifyObservers(this.element, 'CANCEL', {
                                                restored_value: this.preFieldFillVal_,
                                            })),
                                            this.active && ((this.index = -1), this.hide(), (this.active = !1));
                                        break;
                                    default:
                                        if (this.active)
                                            switch (_) {
                                                case x.PAGE_UP:
                                                    this.pageOptionsUpOrDown(!0);
                                                    break;
                                                case x.PAGE_DOWN:
                                                    this.pageOptionsUpOrDown(!1);
                                                    break;
                                                default:
                                                    if (p.ctrlKey) T = !1;
                                                    else
                                                        switch (_) {
                                                            case x.DOWN:
                                                            case x.UP:
                                                                _ === x.UP ? this.markPrevious() : this.markNext(),
                                                                    this.render(),
                                                                    M.Autocompleter.stopEvent(p);
                                                                break;
                                                            case x.LEFT:
                                                            case x.RIGHT:
                                                                this.options.tokens &&
                                                                    ((this.tokenBounds = null), this.getTokenBounds()),
                                                                    !p.ctrlKey &&
                                                                        this.index >= 0 &&
                                                                        this.update.classList.contains('multi_col') &&
                                                                        this.moveToOtherColumn(p);
                                                                break;
                                                            default:
                                                                T = !1;
                                                        }
                                            }
                                        else T = !1;
                                }
                            }
                            T ||
                                ((!p.ctrlKey || 86 === _) &&
                                    16 !== _ &&
                                    17 !== _ &&
                                    0 !== _ &&
                                    ((this.preFieldFillVal_ = null),
                                    (this.changed = !0),
                                    (this.hasFocus = !0),
                                    (this.matchListItemsToField_ = !0),
                                    this.observer && clearTimeout(this.observer),
                                    (this.observer = setTimeout(
                                        this.onObserverEvent.bind(this),
                                        1e3 * this.options.frequency,
                                    ))));
                        }
                    },
                    setMatchStatusIndicator: function (p) {
                        p !== this.matchStatus_ &&
                            (p
                                ? this.element.classList.contains('no_match') &&
                                  (this.element.classList.remove('no_match'),
                                  M.Autocompleter.screenReaderLog('The field no longer contains a non-matching value.'))
                                : (this.element.classList.add('no_match'),
                                  M.Autocompleter.screenReaderLog(
                                      "The field's value does not match any items in the list.",
                                  )),
                            (this.matchStatus_ = p));
                    },
                    setInvalidValIndicator: function (p) {
                        p
                            ? (M.Autocompleter.setOffAlarm(this.element),
                              this.invalidStatus_ ||
                                  (this.element.classList.add('invalid'), this.element.setAttribute('invalid', !0)))
                            : this.invalidStatus_ &&
                              (this.element.classList.remove('invalid'), this.element.setAttribute('invalid', !1)),
                            (this.invalidStatus_ = p);
                    },
                    cancelInvalidValIndicator: function () {
                        M.Autocompleter.cancelAlarm(this.element);
                    },
                    updateChoices: function (p, _) {
                        if (((this.index = -1), !this.changed && this.hasFocus)) {
                            this.update.innerHTML = p;
                            var T = this.update.firstChild;
                            T &&
                                T.tHead &&
                                T.tHead.addEventListener('mousedown', function (k) {
                                    M.Autocompleter.stopEvent(k);
                                });
                            var x = M.Autocompleter.listItemElements();
                            if (x) {
                                var F;
                                if (
                                    ((this.entryCount = x.length),
                                    this.suggestionMode_ !== M.Autocompleter.NO_COMPLETION_SUGGESTIONS &&
                                        this.entryCount > 0 &&
                                        !this.focusInProgress_ &&
                                        _)
                                ) {
                                    for (F = 0; this.liIsHeading(x[F]) && F < this.entryCount; ++F);
                                    this.index = F;
                                }
                                for (F = 0; F < this.entryCount; F++) {
                                    var C = this.getEntry(F);
                                    (C.autocompleteIndex = F), this.addObservers(C);
                                }
                            } else this.entryCount = 0;
                            1 === this.entryCount && this.options.autoSelect
                                ? (this.selectEntry(), this.hide())
                                : this.render(),
                                this.focusInProgress_ ||
                                    this.setMatchStatusIndicator(this.entryCount > 0 || '' === this.trimmedElemVal);
                        }
                    },
                    pickedByNumber: function () {
                        return this.add_seqnum && this.trimmedElemVal.match(/^\d+$/);
                    },
                    pickBestMatch: function (p) {
                        var _ = this.trimmedElemVal.toLowerCase(),
                            T = p.length,
                            x = -1;
                        if (_.length > 0 && T > 0) {
                            for (var F = -1, C = 1 / 0, k = -1, R = C, j = -1, N = C, K = 0; K < T; ++K) {
                                var Q = p[K];
                                if (!this.itemTextIsHeading(Q)) {
                                    var ce = Q.toLowerCase(),
                                        ge = (ce = ce.replace(/^\W+/, '')).indexOf(_),
                                        De = Q.length;
                                    0 === ge
                                        ? /(^\d+$)/.test(_)
                                            ? ((k = 0), (R = 0))
                                            : De < R && ((k = K), (R = De))
                                        : -1 === k &&
                                          (ge > 0
                                              ? De < N && ((j = K), (N = De))
                                              : -1 === j && De < C && ((C = De), (F = K)));
                                }
                            }
                            x = k > -1 ? k : j > -1 ? j : F;
                        }
                        return x;
                    },
                    posAnsList: function () {
                        this.posListBelowFieldInMultiCol(),
                            this.index > 0 && this.scrollToShow(this.getCurrentEntry(), O('completionOptionsScroller'));
                    },
                    posListBelowFieldInMultiCol: function () {
                        var p = M.Autocompleter.sharedDOMCache,
                            _ = this.domCache.element,
                            T = this.update;
                        this.domCache.invalidate('elemPos'),
                            p.invalidate('firstEntryWidth'),
                            p.invalidate('listBoundingRect'),
                            p.invalidate('viewPortWidth'),
                            T.style.height && (T.style.height = ''),
                            this.setListWrap(!1),
                            (T.style.width = 'auto'),
                            (O('completionOptionsScroller').style.height = ''),
                            (this.listContainer.style.width = ''),
                            (this.listHeight = void 0);
                        var x = this.listContainer;
                        x.style.display = 'none';
                        var F = this.domCache.get('elemPos');
                        x.style.display = '';
                        var C = 0,
                            k = document.documentElement.style;
                        /^-(\d+\.?\d*)px$/.test(k.top) && (C = Number(RegExp.$1)),
                            (x.style.top = F.top + C + _.offsetHeight + 'px');
                        var R = this.scrolledContainer_,
                            j = document.documentElement.clientHeight,
                            N = j,
                            Q = (K = p.get('listBoundingRect')).bottom;
                        if (Q <= N) this.setListLeft();
                        else {
                            var ce = this.twoColumnFlow_ && !this.options.tableFormat && this.entryCount > 4;
                            if (
                                (ce && (ce = this.setListWrap(!0)) && (Q = p.get('listBoundingRect').bottom),
                                ce && Q <= N)
                            )
                                this.setListLeft();
                            else {
                                var ge = _.getBoundingClientRect(),
                                    De = void 0;
                                if (!R || (R === document.documentElement && this.getFixedPositionedParent(_)))
                                    De = window.innerHeight - ge.bottom;
                                else {
                                    this.lastScrollEffect_ && this.lastScrollEffect_.cancel();
                                    var xe = Q - N,
                                        Ve = ge.top,
                                        b = 0,
                                        je = this.constructorOpts_.headerBar;
                                    if (je) {
                                        var Ne = document.getElementById(je);
                                        Ne && (b = Ne.offsetHeight);
                                    }
                                    var at,
                                        Et = R.getBoundingClientRect().top;
                                    xe > (at = Et > b ? Ve - Et : Ve - b) && ((xe = at), (De = j - ge.height - b)),
                                        (Q =
                                            void 0 === De
                                                ? p.get('listBoundingRect').bottom
                                                : p.get('listBoundingRect').top + De);
                                    var ht = p.get('spacerCoords');
                                    Q > ht.bottom &&
                                        ((p.get('spacerDiv').style.height = Q - ht.top + 'px'),
                                        p.invalidate('spacerCoords')),
                                        (this.lastScrollEffect_ = new M.Effect.Scroll(R, { y: xe, duration: 0.4 }));
                                }
                                if (void 0 !== De) {
                                    this.setListHeight(De);
                                    var Gt = p.get('viewPortWidth'),
                                        K = p.get('listBoundingRect');
                                    p.listWrap && K.width > Gt && this.setListWrap(!1);
                                }
                                this.setListLeft();
                            }
                        }
                    },
                    getFixedPositionedParent: function (p) {
                        const _ = p.offsetParent;
                        return _
                            ? 'fixed' === window.getComputedStyle(_).position
                                ? _
                                : this.getFixedPositionedParent(_)
                            : null;
                    },
                    initDOMCache: function () {
                        var p = this,
                            _ = M.Autocompleter;
                        this.domCache = _.createDOMCache(
                            { element: p.listPositioningElem() },
                            {
                                elemPos: function () {
                                    return M.jqueryLite.getElementOffset(this.element);
                                },
                                elemVal: function () {
                                    return _.getFieldVal(p.element);
                                },
                            },
                        );
                    },
                    listPositioningElem: function () {
                        return this.multiSelect_ ? this.element.parentNode : this.element;
                    },
                    setListWrap: function (p) {
                        var _ = M.Autocompleter.sharedDOMCache;
                        if (p !== _.listWrap) {
                            if (p) {
                                var T = 2 * _.get('firstEntryWidth') + 4;
                                T <= _.get('viewPortWidth') &&
                                    ((this.listContainer.style.width = T + 'px'),
                                    this.update.classList.add('multi_col'),
                                    (_.listWrap = !0));
                            } else
                                this.update.classList.remove('multi_col'),
                                    (this.listContainer.style.width = ''),
                                    (_.listWrap = !1),
                                    _.invalidate('viewPortWidth');
                            _.invalidate('listBoundingRect'), this.domCache.invalidate('elemPos');
                        }
                        return _.listWrap;
                    },
                    setListLeft: function () {
                        var p = this.listContainer,
                            _ = M.Autocompleter.sharedDOMCache,
                            T = _.get('viewPortWidth'),
                            x = _.get('listBoundingRect'),
                            F = this.domCache.get('elemPos'),
                            C = x.width - (T - F.left);
                        C < 0 && (C = 0);
                        var k = F.left - C;
                        k < 0 && (k = 0);
                        var R = M.Autocompleter.sharedDOMCache;
                        R.listPosLeft !== k && ((p.style.left = k + 'px'), (R.listPosLeft = k));
                    },
                    setListHeight: function (x) {
                        var _ = M.Autocompleter.sharedDOMCache,
                            T = _.get('listBoundingRect');
                        (x = x - T.height + this.update.offsetHeight),
                            (this.listContainer.style.width = T.width + 20 + 'px'),
                            x >= 20 &&
                                ((O('completionOptionsScroller').style.height = x + 'px'),
                                _.invalidate('listBoundingRect'));
                    },
                    getToken: function () {
                        var p = this.domCache.get('elemVal');
                        if (this.options.tokens) {
                            var _ = this.getTokenBounds();
                            p = p.substring(_[0], _[1]);
                        }
                        return p;
                    },
                    getTokenBounds: (function () {
                        return function (p) {
                            if (null != this.tokenBounds) return this.tokenBounds;
                            var _ = this.domCache.get('elemVal');
                            if ('' === _.trim()) return [-1, 0];
                            for (
                                var k,
                                    T = void 0 !== p ? p : this.element.selectionStart,
                                    x = T == this.oldElementValue.length ? 1 : 0,
                                    F = -1,
                                    C = _.length,
                                    R = 0,
                                    j = this.options.tokens.length;
                                R < j;
                                ++R
                            )
                                (k = _.lastIndexOf(this.options.tokens[R], T + x - 1)) > F && (F = k),
                                    -1 != (k = _.indexOf(this.options.tokens[R], T + x)) && k < C && (C = k);
                            return (this.tokenBounds = [F + 1, C]);
                        };
                    })(),
                    dupForField: function (p) {
                        throw 'dupForField must be overridden by autocompleter subclasses.';
                    },
                    initItemToDataIndex: function () {
                        throw 'initItemToDataIndex must be overridden by autocompleter classes that need it';
                    },
                    propagateFieldChanges: function (p) {
                        void 0 === p && (p = this.matchStatus_),
                            this.recDataRequester_ &&
                                (p && '' !== this.domCache.get('elemVal').trim()
                                    ? this.recDataRequester_.requestData()
                                    : this.recDataRequester_.clearDataOutputFields());
                    },
                    getValTyped: function () {
                        return null === this.preFieldFillVal_ ? this.domCache.get('elemVal') : this.preFieldFillVal_;
                    },
                    listSelectionNotification: function (p, _, T) {
                        var x;
                        void 0 === T ? (T = !1) : T && ((x = p), (p = '')),
                            void 0 === x && (x = this.domCache.get('elemVal'));
                        var F = this.clickSelectionInProgress_
                                ? 'clicked'
                                : null === this.preFieldFillVal_
                                ? 'typed'
                                : 'arrows',
                            C = 'typed' !== F && _,
                            k = this.getItemCode(x);
                        M.Autocompleter.Event.notifyObservers(this.element, 'LIST_SEL', {
                            input_method: F,
                            val_typed_in: p,
                            final_val: x,
                            used_list: C,
                            list: this.rawList_,
                            on_list: _,
                            item_code: k,
                            removed: T,
                        });
                    },
                    attemptSelection: function () {
                        var p = !1,
                            _ = this.getValTyped();
                        if (this.active) {
                            if (-1 === this.index) {
                                for (
                                    var T = this.domCache.get('elemVal').trim(),
                                        x = T.toLowerCase(),
                                        F = -1,
                                        C = -1,
                                        k = 0;
                                    k < this.entryCount && F < 0;
                                    ++k
                                ) {
                                    var R = this.getEntry(k),
                                        j = this.listItemValue(R);
                                    this.liIsHeading(R) ||
                                        (T === j
                                            ? (F = k)
                                            : this.caseInsenstiveSelection_ &&
                                              C < 0 &&
                                              x === j.toLowerCase() &&
                                              (C = k));
                                }
                                F >= 0 ? ((this.index = F), (p = !0)) : C >= 0 && ((this.index = C), (p = !0));
                            } else p = this.entryCount > 0 && !this.liIsHeading(this.getCurrentEntry());
                            (this.fieldValIsListVal_ = p),
                                p &&
                                    ((this.active = !1),
                                    this.updateElement(this.getCurrentEntry()),
                                    this.storeSelectedItem(),
                                    null !== M.Autocompleter.Event.callbacks_ && this.listSelectionNotification(_, !0),
                                    (this.processedFieldVal_ = M.Autocompleter.getFieldVal(this.element)),
                                    this.setMatchStatusIndicator(!0),
                                    this.setInvalidValIndicator(!1),
                                    this.propagateFieldChanges(),
                                    this.multiSelect_ && this.moveEntryToSelectedArea()),
                                this.multiSelect_ || ((this.active = !1), this.hide());
                        }
                        return p;
                    },
                    selectEntry: function () {
                        this.attemptSelection();
                    },
                    handleNonListEntry: function () {
                        this.propagateFieldChanges(!1), this.multiSelect_ || this.clearStoredSelection();
                        var p = M.Autocompleter.getFieldVal(this.element);
                        '' === M.Autocompleter.getFieldVal(this.element)
                            ? (this.setMatchStatusIndicator(!0),
                              this.setInvalidValIndicator(!1),
                              this.storeSelectedItem(''),
                              null !== M.Autocompleter.Event.callbacks_ && this.listSelectionNotification('', !1),
                              (this.processedFieldVal_ = p))
                            : (this.enabled_ && this.setMatchStatusIndicator(!1),
                              null !== M.Autocompleter.Event.callbacks_ &&
                                  this.listSelectionNotification(this.getValTyped(), !1),
                              this.matchListValue_
                                  ? (M.Autocompleter.screenReaderLog(
                                        'For this field your entry must match an item from the suggestion list.',
                                    ),
                                    this.setInvalidValIndicator(!0),
                                    (this.refocusInProgress_ = !0),
                                    (this.processedFieldVal_ = p),
                                    setTimeout(
                                        function () {
                                            this.element.focus(), this.element.select(), (this.refocusInProgress_ = !1);
                                        }.bind(this),
                                    ))
                                  : (this.storeSelectedItem(),
                                    this.multiSelect_ ? this.moveEntryToSelectedArea() : (this.processedFieldVal_ = p),
                                    this.findSuggestions &&
                                        this.nonMatchSuggestions_ &&
                                        !this.multiSelect_ &&
                                        setTimeout(
                                            function () {
                                                this.findSuggestions();
                                            }.bind(this),
                                        )));
                    },
                    onChange: function (p) {
                        this.domCache.invalidate('elemVal'),
                            M.Autocompleter.completionOptionsScrollerClicked_ || this.handleDataEntry(p);
                    },
                    onBlur: function (p) {
                        M.Autocompleter.completionOptionsScrollerClicked_ ||
                            (this.lastScrollEffect_ && this.lastScrollEffect_.cancel(),
                            M.Autocompleter.getFieldVal(this.element) !== this.processedFieldVal_ &&
                                M.Event.simulate(this.element, 'change'),
                            this.enabled_ &&
                                !this.refocusInProgress_ &&
                                (this.hide(),
                                document.activeElement === this.element && (this._disableListItemClick = !0),
                                (this.hasFocus = !1),
                                (this.active = !1),
                                this.invalidStatus_
                                    ? this.clearInvalidFieldVal()
                                    : '' === M.Autocompleter.getFieldVal(this.element)
                                    ? this.setMatchStatusIndicator(!0)
                                    : !1 === this.fieldValIsListVal_ && this.setMatchStatusIndicator(!1)));
                    },
                    clearInvalidFieldVal: function () {
                        this.setFieldVal('', !1),
                            this.setInvalidValIndicator(!1),
                            this.setMatchStatusIndicator(!0),
                            this.listSelectionNotification('', !1),
                            (this.processedFieldVal_ = '');
                    },
                    onFocus: function (p) {
                        if (
                            ((M.Autocompleter.currentAutoCompField_ = this.element.id),
                            this.refocusInProgress_ ||
                                (this.processedFieldVal_ = M.Autocompleter.getFieldVal(this.element)),
                            (this.refocusInProgress_ = !1),
                            (this.preFieldFillVal_ = null),
                            M.Autocompleter.Event.notifyObservers(this.element, 'FOCUS', {
                                start_val: this.processedFieldVal_,
                            }),
                            this.multiSelect_)
                        ) {
                            var _ = Object.getOwnPropertyNames(this.selectedItems_);
                            if (_.length > 0) {
                                var x =
                                    'Above this multi-select field are deselection buttons for each selected item.  Currently selected:' +
                                    _.join(', ');
                                M.Autocompleter.screenReaderLog(x);
                            }
                        }
                    },
                    onMouseDown: function (p) {
                        if (!this._disableListItemClick) {
                            M.Autocompleter.stopEvent(p);
                            for (var _ = p.target; _ && void 0 === _.autocompleteIndex; ) _ = _.parentNode;
                            _ &&
                                !this.liIsHeading(_) &&
                                ((this.clickSelectionInProgress_ = !0),
                                (this.index = _.autocompleteIndex),
                                this.selectEntry(),
                                this.hide(),
                                (this.clickSelectionInProgress_ = !1),
                                this.multiSelect_ && this.showList()),
                                (this.tokenBounds = null);
                        }
                    },
                    handleDataEntry: function (p) {
                        if (this.invalidStatus_ && this.processedFieldVal_ === this.domCache.get('elemVal'))
                            this.clearInvalidFieldVal();
                        else {
                            this.observer && clearTimeout(this.observer);
                            var _ = M.Autocompleter.getFieldVal(this.element),
                                T = !1;
                            ((this.processedFieldVal_ !== _ && '' !== _) ||
                                (this.multiSelect_ && '' === _ && this.index >= 0)) &&
                                (T = this.attemptSelection()),
                                this.processedFieldVal_ !== _ &&
                                    !T &&
                                    ('' === _ && (this.fieldValIsListVal_ = !1), this.handleNonListEntry()),
                                this.multiSelect_ || (this.hide(), (this.active = !1)),
                                !p.stopped &&
                                    this.matchListValue_ &&
                                    this.invalidStatus_ &&
                                    M.Autocompleter.stopEvent(p);
                        }
                    },
                    itemTextIsHeading: function (p) {
                        var _ = !!this.numHeadings_;
                        if (_) {
                            this.itemToDataIndex_ || this.initItemToDataIndex();
                            var T = this.itemToDataIndex_[p];
                            _ = void 0 !== T && !!this.indexToHeadingLevel_[T];
                        }
                        return _;
                    },
                    liIsHeading: function (p) {
                        var _ = !!this.numHeadings_;
                        return _ && (_ = this.itemTextIsHeading(this.listItemValue(p))), _;
                    },
                    onShow: function (p, _) {
                        p.autocomp.showList();
                    },
                    onHide: function (p, _) {
                        p.autocomp.hideList();
                    },
                    moveToOtherColumn: function (p) {
                        var _ = M.Autocompleter.listItemElements().length,
                            T = Math.floor(_ / 2),
                            x = Math.ceil(_ / 2),
                            F = this.index;
                        if (
                            (this.index < T ? (F = this.index + x) : this.index >= x && (F = this.index - x),
                            F !== this.index)
                        ) {
                            var C = this.getEntry(F);
                            this.liIsHeading(C) ||
                                ((this.index = F),
                                this.setFieldVal(this.listItemValue(C), !1),
                                this.element.select(),
                                this.render(),
                                M.Autocompleter.stopEvent(p));
                        }
                    },
                    handleSeeMoreItems: function (p) {},
                    readSearchCount: function () {
                        var p = !1;
                        return (
                            'none' !== O('searchCount').style.display &&
                                (M.Autocompleter.screenReaderLog('Showing ' + O('searchCount').innerHTML + '.'),
                                'none' !== O('moreResults').style.display &&
                                    M.Autocompleter.screenReaderLog('Pressing control+return will expand the list.'),
                                (p = !0)),
                            p
                        );
                    },
                    destroy: function () {
                        this.stopObservingEvents(), this.removeAutocompleteLhcClasses(), this.detachFromDOM();
                    },
                    addEventListenerToElement: function (p, _) {
                        this.element.addEventListener(p, _),
                            (this.elementEventListeners[p] ||= []),
                            this.elementEventListeners[p].push(_);
                    },
                    stopObservingEvents: function () {
                        for (const [p, _] of Object.entries(this.elementEventListeners))
                            _.forEach(T => {
                                this.element.removeEventListener(p, T);
                            }, this);
                        this.elementEventListeners = {};
                    },
                    removeAutocompleteLhcClasses: function () {
                        this.element.classList.remove('no_match', 'invalid', 'ansList', 'ac_multiple', 'search_field');
                    },
                    detachFromDOM: function () {
                        if (this.multiSelect_) {
                            var p = this.element.parentNode;
                            p.parentNode.replaceChild(this.element, p), (this.selectedList = null);
                        }
                        (this.element.autocomp = null),
                            (this.element = null),
                            (this.update = null),
                            (this.listContainer = null),
                            (this.recDataRequester_ = null);
                    },
                    updateElement: function (p) {
                        var _ = this.listItemValue(p),
                            T = _;
                        if (this.options.tokens) {
                            var x = this.getTokenBounds();
                            if (-1 != x[0]) {
                                var F = this.domCache.get('elemVal'),
                                    C = F.substr(0, x[0]),
                                    k = F.substr(x[0]).match(/^\s+/);
                                k && (C += k[0]), (T = C + _ + F.substr(x[1]));
                            }
                        }
                        this.setFieldVal(T, !1),
                            this.options.afterUpdateElement && this.options.afterUpdateElement(this.element, p);
                    },
                    show: function () {
                        'none' == getComputedStyle(this.update).display &&
                            this.options.onShow(this.element, this.update),
                            !this.iefix &&
                                q.IE &&
                                'absolute' == getComputedStyle(this.update).position &&
                                (new Insertion.After(
                                    this.update,
                                    '<iframe id="' +
                                        this.update.id +
                                        '_iefix" style="display:none;position:absolute;filter:progid:DXImageTransform.Microsoft.Alpha(opacity=0);" src="javascript:false;" frameborder="0" scrolling="no"></iframe>',
                                ),
                                (this.iefix = O(this.update.id + '_iefix'))),
                            this.iefix && setTimeout(this.fixIEOverlapping.bind(this), 50);
                    },
                    fixIEOverlapping: function () {
                        var p = M.jqueryLite.getElementOffset(this.update);
                        (this.iefix.style.left = p.left),
                            this.update.style.height || (this.update.style.top = p.top),
                            (this.iefix.style.zIndex = 1),
                            (this.update.style.zIndex = 2),
                            (this.iefix.style.display = '');
                    },
                    hide: function () {
                        'none' != getComputedStyle(this.update).display &&
                            this.options.onHide(this.element, this.update),
                            this.iefix && (this.iefix.style.display = 'none');
                    },
                    render: function () {
                        if (this.entryCount > 0) {
                            for (var p = 0; p < this.entryCount; p++)
                                this.index == p
                                    ? this.getEntry(p).classList.add('selected')
                                    : this.getEntry(p).classList.remove('selected');
                            this.hasFocus && (this.show(), (this.active = !0));
                        } else (this.active = !1), this.hide();
                    },
                    getEntry: function (p) {
                        return M.Autocompleter.listItemElements()[p];
                    },
                    getCurrentEntry: function () {
                        return this.getEntry(this.index);
                    },
                    onObserverEvent: function () {
                        this.domCache.invalidate('elemVal'),
                            (this.changed = !1),
                            (this.tokenBounds = null),
                            this.getToken().length >= this.options.minChars
                                ? this.getUpdatedChoices()
                                : ((this.active = !1), this.hide(), this.progressElement?.classList.remove('show')),
                            (this.oldElementValue = this.domCache.get('elemVal'));
                    },
                };
                Object.assign(M.Autocompleter.Base.prototype, v), (v = null);
            };
        },
        7606: se => {
            se.exports = function ae(U, O) {
                'use strict';
                (O.Autocompleter.Event = {
                    observeListExpansions: function (M, q) {
                        return this.storeCallback(M, 'LIST_EXP', q);
                    },
                    observeListSelections: function (M, q) {
                        return this.storeCallback(M, 'LIST_SEL', q);
                    },
                    observeFocusEvents: function (M, q) {
                        return this.storeCallback(M, 'FOCUS', q);
                    },
                    observeCancelList: function (M, q) {
                        return this.storeCallback(M, 'CANCEL', q);
                    },
                    observeSuggestions: function (M, q) {
                        return this.storeCallback(M, 'SUGGESTIONS', q);
                    },
                    observeSuggestionUsed: function (M, q) {
                        return this.storeCallback(M, 'SUGGESTION_USED', q);
                    },
                    observeListAssignments: function (M, q) {
                        return this.storeCallback(M, 'LIST_ASSIGNMENT', q);
                    },
                    observeRDRClearing: function (M) {
                        return this.storeCallback(null, 'RDR_CLEARING', M);
                    },
                    observeRDRAssignment: function (M) {
                        return this.storeCallback(null, 'RDR_ASSIGNMENT', M);
                    },
                }),
                    Object.assign(O.Autocompleter.Event, O.Observable);
            };
        },
        6400: se => {
            se.exports = function ae(U, O) {
                'use strict';
                var G = O.jqueryLite.ui.keyCode;
                (O.Autocompleter.Prefetch = O.PrototypeAPI.Class.create()),
                    (O.Autocompleter.Prefetch.constructor = O.Autocompleter.Prefetch),
                    Object.assign(O.Autocompleter.Prefetch.prototype, O.Autocompleter.Base.prototype),
                    (O.Autocompleter.Prefetch.prototype.className = 'Def.Autocompleter.Prefetch');
                var $ = {
                    SEQ_NUM_PREFIX: '<span class="listNum">',
                    SEQ_NUM_SEPARATOR: ':</span>&nbsp; ',
                    validationFailed_: !1,
                    listIsOriginal_: !0,
                    rawList_: null,
                    rawListWithoutTags_: null,
                    itemCodes_: null,
                    listLoadAttempted_: !1,
                    seeMoreItemsClicked_: !1,
                    matchListItemsToField_: !1,
                    defaultSelectionIndex_: null,
                    autoFill_: !0,
                    isListHTML_: !1,
                    initialize: function (v, p, _) {
                        var T = (_ = Object.assign(
                            {
                                ignoreCase: !0,
                                fullSearch: !1,
                                selector: this.selector,
                                getFormattedItemText: this.getFormattedItemText,
                                onShow: this.onShow,
                                onHide: this.onHide,
                            },
                            _ || {},
                        )).addSeqNum;
                        this.add_seqnum = void 0 === T || T;
                        var x = _.autoFill;
                        void 0 !== x && (this.autoFill_ = x);
                        var F = _.isListHTML;
                        void 0 !== F && (this.isListHTML_ = F),
                            O.Autocompleter.Base.classInit_ || O.Autocompleter.Base.classInit(),
                            this.initHeadings(_),
                            this.defAutocompleterBaseInit(v, _),
                            this.addEventListenerToElement('focus', this.onFocus.bind(this)),
                            this.addEventListenerToElement('click', this.onFieldClick.bind(this));
                        var C = _.codes;
                        this.setList(p, C),
                            (this.listIsOriginal_ = !0),
                            (this.originalCodes_ = C),
                            (this.options.minChars = 0),
                            (this.splitAutocomp_ = !1),
                            this.element.classList.add('ansList');
                    },
                    getUpdatedChoices: function () {
                        (this.trimmedElemVal = this.domCache.get('elemVal').trim()),
                            this.updateChoices(this.options.selector(this), this.pickedByNumber());
                    },
                    dupItemToDataIndex: function (v) {
                        this.listIsOriginal_ &&
                            (this.itemToDataIndex_ || this.initItemToDataIndex(),
                            (v.itemToDataIndex_ = this.itemToDataIndex_));
                    },
                    dupForField: function (v) {
                        var p = this.dupDataReqForField(v),
                            _ = {};
                        Object.assign(!0, _, this.constructorOpts_), (_.dataRequester = p);
                        var T = new O.Autocompleter.Prefetch(v, this.rawList_, _);
                        return this.dupItemToDataIndex(T), T;
                    },
                    initHeadings: function (v) {
                        var p = v.codes,
                            _ = v.itemToHeading;
                        if (_) {
                            v.itemToHeading = null;
                            for (var T = {}, x = {}, F = 0, C = p.length; F < C; ++F) {
                                var R = _[p[F]];
                                if (R) {
                                    var j = T[R];
                                    if (!j) {
                                        var N = _[R];
                                        T[R] = j = N ? T[N] + 1 : 1;
                                    }
                                }
                            }
                            for (F = 0, C = p.length; F < C; ++F) x[F] = (j = T[p[F]]) || 0;
                            (this.indexToHeadingLevel_ = x),
                                (v.indexToHeadingLevel = x),
                                (this.numHeadings_ = Object.keys(T).length),
                                (v.numHeadings = this.numHeadings_);
                        } else
                            v.indexToHeadingLevel &&
                                ((this.indexToHeadingLevel_ = v.indexToHeadingLevel),
                                (this.numHeadings_ = v.numHeadings));
                    },
                    initItemToDataIndex: function () {
                        if (((this.itemToDataIndex_ = {}), this.rawList_))
                            for (var v = 0, p = this.rawList_.length; v < p; ++v)
                                this.itemToDataIndex_[this.rawList_[v]] = v;
                    },
                    selector: function (v) {
                        var T = v.getToken(),
                            x = 0,
                            F = null,
                            C = !v.matchListItemsToField_ || '' === v.domCache.get('elemVal').trim(),
                            k = v.seeMoreItemsClicked_ ? 1 / 0 : 2 * O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD,
                            R = C && !v.seeMoreItemsClicked_ ? Math.floor(k / v.numHeadings_) : 1 / 0;
                        R < 1 && (R = 1);
                        var j = 0,
                            N = [],
                            K = [],
                            Q = {},
                            ce = null,
                            ge = !1,
                            De = 0,
                            xe = 0,
                            Ve = 0,
                            b = !0 === v.options.isListHTML,
                            je = b ? Pe => Pe : O.Autocompleter.Base.escapeAttribute;
                        v.options.ignoreCase && (T = T.toLowerCase());
                        for (var Ne = v.options.formattedListItems, at = 0, Et = v.rawList_.length; at < Et; ++at) {
                            var Re = !1;
                            if (v.indexToHeadingLevel_[at]) (ce = v.rawList_[at]), (ge = !1), ++De;
                            else {
                                var Pt = null,
                                    Gt = v.rawList_[at];
                                C && (++x, (Pt = je(Gt)), Ne && (Pt += Ne[at]));
                                var ur = null,
                                    Sn = !1,
                                    qt = !1;
                                if (
                                    (v.add_seqnum &&
                                        ((Re = (ur = at + 1 - De + '') === T),
                                        !C &&
                                            (Re || 0 === ur.indexOf(T)) &&
                                            (++x,
                                            (qt = !0),
                                            (Re || x <= k) &&
                                                ((ur =
                                                    '<strong>' +
                                                    ur.substr(0, T.length) +
                                                    '</strong>' +
                                                    ur.substr(T.length)),
                                                (Sn = !0),
                                                (Pt = v.SEQ_NUM_PREFIX + ur + v.SEQ_NUM_SEPARATOR + je(Gt)),
                                                Ne && (Pt += Ne[at])))),
                                    !qt && !C)
                                ) {
                                    var Vt = !1,
                                        an = b ? v.rawListWithoutTags_[at] : Gt;
                                    v.options.ignoreCase && (an = an.toLowerCase());
                                    for (var qe = an.indexOf(T); !Vt && -1 !== qe; ) {
                                        if (0 === qe)
                                            (Vt = !0),
                                                ++x <= k &&
                                                    ((Pt = b
                                                        ? Gt
                                                        : '<strong>' +
                                                          je(Gt.substr(0, T.length)) +
                                                          '</strong>' +
                                                          je(Gt.substr(T.length))),
                                                    Ne && (Pt += Ne[at]));
                                        else if (
                                            (v.options.fullSearch || /(.\b|_)./.test(an.substr(qe - 1, 2))) &&
                                            ((Vt = !0), ++x <= k)
                                        ) {
                                            var ot = je(Gt.substr(0, qe));
                                            (Pt = b
                                                ? Gt
                                                : ot +
                                                  '<strong>' +
                                                  je(Gt.substr(qe, T.length)) +
                                                  '</strong>' +
                                                  je(Gt.substr(qe + T.length))),
                                                Ne && (Pt += Ne[at]);
                                        }
                                        Vt || (qe = an.indexOf(T, qe + 1));
                                    }
                                }
                                var ke = !1;
                                v.multiSelect_ &&
                                    (ke = v.isSelected(v.isListHTML_ ? v.rawListWithoutTags_[at] : Gt)) &&
                                    ++Ve,
                                    !ke &&
                                        Pt &&
                                        (Re || x <= k || (v.numHeadings_ > 0 && C)) &&
                                        (ce &&
                                            !ge &&
                                            ((ge = !0),
                                            N.push(ce),
                                            K.push(at - 1),
                                            ++xe,
                                            (Q[ce] = [je(ce), 'heading']),
                                            (j = 0)),
                                        (!C || !v.numHeadings_ || j < R || Re) &&
                                            (!Sn &&
                                                v.add_seqnum &&
                                                (Pt = v.SEQ_NUM_PREFIX + ur + v.SEQ_NUM_SEPARATOR + Pt),
                                            N.push(Gt),
                                            K.push(at),
                                            Re && (F = N.length - 1),
                                            (Q[Gt] = [Pt]),
                                            C && ++j));
                            }
                        }
                        var Ce = N.length - xe;
                        return (
                            x > Ce + Ve
                                ? ((U('searchCount').innerHTML = Ce + ' of ' + x + ' items total'),
                                  (U('moreResults').style.display = 'block'),
                                  (U('searchCount').style.display = 'block'))
                                : ((U('moreResults').style.display = 'none'),
                                  (U('searchCount').style.display = 'none')),
                            v.buildHTML(N, K, Q, F)
                        );
                    },
                    buildHTML: function (v, p, _, T) {
                        var F,
                            x = -1,
                            k = null !== T;
                        if (
                            !this.numHeadings_ &&
                            this.matchListItemsToField_ &&
                            (k || this.suggestionMode_ === O.Autocompleter.SUGGEST_SHORTEST) &&
                            (x = k ? T : this.pickBestMatch(v)) >= 0
                        ) {
                            var C = v[x],
                                R = p[x];
                            for (F = x; F > 0; --F) (v[F] = v[F - 1]), (p[F] = p[F - 1]);
                            (v[0] = C), (p[0] = R);
                        }
                        var j = '<ul>';
                        (F = 0),
                            x >= 0 &&
                                ((j +=
                                    '<li class="suggestion" autocompRawListIndex="' + p[0] + '">' + _[C][0] + '</li>'),
                                ++F);
                        for (var N = v.length; F < N; ++F) {
                            var K = _[v[F]],
                                Q = K[1];
                            j += Q
                                ? '<li class="' + Q + '" autocompRawListIndex="' + p[F] + '">' + K[0] + '</li>'
                                : '<li autocompRawListIndex="' + p[F] + '">' + K[0] + '</li>';
                        }
                        return j + '</ul>';
                    },
                    setList: function (v, p) {
                        this.listIsOriginal_ = !1;
                        var _ = v.length;
                        (this.rawList_ = new Array(_)), this.isListHTML_ && (this.rawListWithoutTags_ = new Array(_));
                        for (var T = 0, x = v.length; T < x; ++T)
                            (this.rawList_[T] = v[T].trim()),
                                this.isListHTML_ &&
                                    (this.rawListWithoutTags_[T] = v[T].replace(/(<([^>]+)>)/gi, '').trim());
                        for (var F = new Array(_), C = O.Autocompleter.Base.escapeAttribute, k = 0; k < _; ++k)
                            (F[k] = C(this.rawList_[k])),
                                !0 === this.add_seqnum &&
                                    !this.indexToHeadingLevel_[k] &&
                                    (F[k] = this.SEQ_NUM_PREFIX + (k + 1) + this.SEQ_NUM_SEPARATOR + F[k]);
                        (this.options.array = F),
                            (this.itemCodes_ = p),
                            (this.itemToDataIndex_ = null),
                            (this.enabled_ = v.length > 0),
                            v.length > 1 || !this.autoFill_
                                ? this.element.classList.add('ac_multiple')
                                : this.element.classList.remove('ac_multiple'),
                            (this.hasFocus || document.activeElement === this.element) && this.onFocus();
                    },
                    setFieldToListValue: function (v) {
                        this.setFieldVal(v, !1),
                            (this.fieldValIsListVal_ = !0),
                            this.storeSelectedItem(),
                            (this.processedFieldVal_ = v),
                            this.listSelectionNotification('', !0),
                            this.setMatchStatusIndicator(!0),
                            this.setInvalidValIndicator(!1),
                            this.propagateFieldChanges();
                    },
                    setListAndField: function (v, p, _, T) {
                        void 0 === _ && (_ = !1),
                            void 0 === T && (T = !1),
                            this.setList(v, p),
                            O.Autocompleter.Event.notifyObservers(this.element, 'LIST_ASSIGNMENT', {});
                        var C,
                            x = this.domCache.get('elemVal'),
                            F = v.length;
                        !1 === _ && (C = this.autoFill_ && (1 === F || (F > 1 && T)) ? this.assembleValue(v[0]) : ''),
                            !_ && x !== C && this.setFieldToListValue(C),
                            this.setInvalidValIndicator(!1),
                            this.setMatchStatusIndicator(!0),
                            this.options.afterUpdateElement && this.options.afterUpdateElement();
                    },
                    assembleValue: function (v) {
                        return v.trim();
                    },
                    onObserverEvent: function () {
                        (this.temporaryHide_ = !0),
                            this.hideList(),
                            O.Autocompleter.Base.prototype.onObserverEvent.apply(this, []),
                            this.posAnsList(),
                            this.showList(),
                            (this.temporaryHide_ = !1);
                    },
                    loadList: function (v, p) {
                        void 0 === v && (v = this.element.id);
                        var _ = O.Autocompleter.getFieldLookupKey(this.element);
                        this.listLoadAttempted_ = !0;
                        var T = O.RecordDataRequester.getOutputFieldRDR(v);
                        if (T) {
                            var x = T.getFieldData(_);
                            if (
                                (x ? this.setListAndField(x[0], x[1], !0, !1) : T.assignListData(),
                                v !== this.element.id)
                            ) {
                                var F = U(p),
                                    C = [p, 'EQ', O.Autocompleter.getFieldVal(F)];
                                T.addFieldsToUpdateList(v, this, C);
                            }
                        }
                    },
                    listIsEmpty: function () {
                        return 0 === this.options.array.length;
                    },
                    getInitialSelectionIndex: function () {
                        var v = -1;
                        if ('' == this.domCache.get('elemVal'))
                            if (this.defaultSelectionIndex_) v = this.defaultSelectionIndex_;
                            else {
                                var p = this.constructorOpts_.defaultValue;
                                if (void 0 !== p) {
                                    if (this.itemCodes_)
                                        for (var _ = 0, T = this.itemCodes_.length; _ < T; ++_)
                                            this.itemCodes_[_] === p && (v = _);
                                    if (-1 === v)
                                        for (var x = 0, F = this.rawList_.length; x < F; ++x)
                                            this.rawList_[x] === p && (v = x);
                                }
                                v >= 2 * O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD && (v = -1),
                                    (this.defaultSelectionIndex_ = v);
                            }
                        return v;
                    },
                    onFocus: function () {
                        !0 === O.Autocompleter.completionOptionsScrollerClicked_
                            ? (O.Autocompleter.completionOptionsScrollerClicked_ = !1)
                            : ((this.matchListItemsToField_ = !1),
                              !this.listLoadAttempted_ &&
                                  this.listIsEmpty() &&
                                  !this.element.comboField &&
                                  this.loadList(),
                              O.Autocompleter.Base.prototype.onFocus.apply(this),
                              this.enabled_ &&
                                  ((this.listBelowField_ = !0),
                                  (this.focusInProgress_ = !0),
                                  this.hideList(),
                                  (this.element.shakeCanceled = !1),
                                  this.maybeShowList(),
                                  setTimeout(() => {
                                      this._disableListItemClick = !1;
                                  }, 10),
                                  (this.index = this.getInitialSelectionIndex()),
                                  this.index >= 0 &&
                                      (this.setFieldToListValue(this.listItemValue(this.getCurrentEntry())),
                                      this.element.select(),
                                      this.render()),
                                  (this.focusInProgress_ = !1)));
                    },
                    maybeShowList: function () {
                        this.activate(), this.render();
                        var v = !1;
                        this.preventListFromShowing
                            ? (v = !1)
                            : 0 == this.add_seqnum
                            ? (v = this.entryCount > 0)
                            : this.entryCount > 1 || !this.autoFill_
                            ? (v = !0)
                            : 1 == this.entryCount &&
                              (v =
                                  this.listItemValue(O.Autocompleter.listItemElements()[0]) != this.processedFieldVal_),
                            1 == v && (this.posAnsList(), this.showList(), this.readSearchCount());
                    },
                    onFieldClick: function () {
                        if (
                            this.enabled_ &&
                            this.element.id === O.Autocompleter.currentAutoCompField_ &&
                            (!this.listShowing || this.matchListItemsToField_)
                        ) {
                            this.matchListItemsToField_ = !1;
                            var v = this.suggestionMode_;
                            (this.suggestionMode_ = O.Autocompleter.NO_COMPLETION_SUGGESTIONS),
                                this.maybeShowList(),
                                (this.suggestionMode_ = v);
                        }
                    },
                    focusField: function () {
                        this.element.focus();
                    },
                    listItemValue: function (v) {
                        const p = v.getAttribute('autocompRawListIndex');
                        return this.isListHTML_ ? this.rawListWithoutTags_[p] : this.rawList_[p];
                    },
                    fieldEventIsBigList: function (v) {
                        return v.ctrlKey && v.keyCode === G.ENTER;
                    },
                    handleSeeMoreItems: function (v) {
                        (this.seeMoreItemsClicked_ = !0),
                            (U('searchHint').style.display = 'none'),
                            (this.listBelowField_ = !1),
                            this.getUpdatedChoices(),
                            this.posAnsList(),
                            (this.seeMoreItemsClicked_ = !1),
                            (this.splitAutocomp_ = !1),
                            O.Autocompleter.stopEvent(v);
                    },
                    findItemIndexByCode: function (v) {
                        for (var p = null, _ = 0, T = this.itemCodes_.length; _ < T && !p; ++_)
                            v == this.itemCodes_[_] && (p = _);
                        return p;
                    },
                    selectByCode: function (v) {
                        var p = this.findItemIndexByCode(v);
                        null != p && this.setFieldToListValue(this.rawList_[p]);
                    },
                    readSearchCount: function () {
                        var v = O.Autocompleter.Base.prototype.readSearchCount.apply(this);
                        return (
                            !v &&
                                this.entryCount > 0 &&
                                (O.Autocompleter.screenReaderLog(
                                    'Showing ' + this.entryCount + ' of ' + this.rawList_.length + ' items.',
                                ),
                                (v = !0)),
                            v
                        );
                    },
                    activate: function () {
                        (this.changed = !1), (this.hasFocus = !0), this.getUpdatedChoices();
                    },
                };
                Object.assign(O.Autocompleter.Prefetch.prototype, $), ($ = null);
            };
        },
        1615: se => {
            se.exports = function ae(U, O) {
                'use strict';
                var q = O.jqueryLite.ui.keyCode;
                O.Autocompleter.Search = O.PrototypeAPI.Class.create();
                var G = {
                    urlToCache_: {},
                    MAX_VALUE_SIZE_FOR_AUTOCOMP: 25,
                    EXPANDED_COUNT: 500,
                    constructor: O.Autocompleter.Search,
                    superclass: O.Autocompleter.Base.prototype,
                };
                Object.assign(O.Autocompleter.Search, G),
                    (G = null),
                    Object.assign(O.Autocompleter.Search.prototype, O.Autocompleter.Base.prototype),
                    (O.Autocompleter.Search.prototype.className = 'Def.Autocompleter.Search');
                var $ = {
                    lastAjaxRequest_: null,
                    resultCache_: null,
                    useResultCache_: !0,
                    suggestionList_: null,
                    showListOnFocusIfEmpty_: !1,
                    showLoadingIndicator_: !0,
                    initialize: function (v, p, _) {
                        if (
                            ((_ = Object.assign(
                                {
                                    partialChars: 2,
                                    onHide: function (k, R) {
                                        (U('searchCount').style.display = 'none'),
                                            (U('moreResults').style.display = 'none'),
                                            O.Autocompleter.Base.prototype.hideList.apply(this);
                                    }.bind(this),
                                    onShow: function (k, R) {
                                        (U('searchCount').style.display = 'block'),
                                            (U('moreResults').style.display = 'block'),
                                            O.Autocompleter.Base.prototype.showList.apply(this);
                                    }.bind(this),
                                    onComplete: this.onComplete.bind(this),
                                },
                                _ || {},
                            )),
                            O.Autocompleter.Base.classInit_ || O.Autocompleter.Base.classInit(),
                            (this.url = p),
                            (this.fhir = _.fhir),
                            (this.search = _.search || (this.fhir && this.fhir.search)),
                            this.defAutocompleterBaseInit(v, _),
                            (this.autocomp = _.autocomp),
                            void 0 === this.autocomp
                                ? (this.autocomp = !0)
                                : this.autocomp || (this.options.frequency = 31536e3),
                            void 0 === _.sort && (_.sort = !0),
                            null !== _.useResultCache && !1 === _.useResultCache && (this.useResultCache_ = !1),
                            (this.showListOnFocusIfEmpty_ = _.showListOnFocusIfEmpty || !1),
                            !1 === _.showLoadingIndicator && (this.showLoadingIndicator_ = !1),
                            this.showLoadingIndicator_)
                        ) {
                            var T = this.element.parentElement,
                                x = document.createElement('span');
                            x.classList.add('loading-indicator-container'),
                                T.replaceChild(x, this.element),
                                x.appendChild(this.element),
                                (this.progressElement = document.createElement('progress')),
                                x.appendChild(this.progressElement);
                        }
                        this.addEventListenerToElement('focus', this.onFocus.bind(this));
                        var F = _.buttonID;
                        if (((this.buttonID = F), F && 'null' !== F)) {
                            var C = document.getElementById(F);
                            C.addEventListener('mousedown', this.buttonClick.bind(this)),
                                C.addEventListener('keypress', this.buttonKeyPress.bind(this));
                        }
                        this.element.classList.add('search_field'),
                            _.colHeaders &&
                                (this.colHeaderHTML =
                                    '<table><thead><th>' + _.colHeaders.join('</th><th>') + '</th></thead><tbody>');
                    },
                    detachFromDOM: function () {
                        var v = this.element.parentElement;
                        v.classList.contains('loading-indicator-container') &&
                            v.parentElement.replaceChild(this.element, v),
                            O.Autocompleter.Search.superclass.detachFromDOM.apply(this);
                    },
                    initItemToDataIndex: function () {
                        this.itemToDataIndex_ = {};
                    },
                    dupForField: function (v) {
                        var p = this.dupDataReqForField(v),
                            _ = Object.clone(this.constructorOpts_);
                        return (_.dataRequester = p), new O.Autocompleter.Search(v, this.url, _);
                    },
                    getSearchStr: function (v) {
                        var p = O.Autocompleter;
                        return (
                            p.LIST_ITEM_FIELD_SEP_REGEX ||
                                (p.LIST_ITEM_FIELD_SEP_REGEX = new RegExp(p.LIST_ITEM_FIELD_SEP, 'g')),
                            v || (v = this.getToken()),
                            v.replace(p.LIST_ITEM_FIELD_SEP_REGEX, ' ').trimLeft()
                        );
                    },
                    runSearch: function () {
                        this.lastAjaxRequest_ && this.lastAjaxRequest_.abort();
                        var v = this.search;
                        if (this.url || v) {
                            (this.searchInProgress = !0), (this.searchStartTime = new Date().getTime());
                            var p = this.getSearchStr(),
                                _ = null;
                            this.useResultCache_ &&
                                (_ = this.getCachedResults(
                                    p,
                                    this.getLoadCount(O.Autocompleter.Search.EXPANDED_COUNT),
                                )) &&
                                this.onComplete(_, !0),
                                _ ||
                                    (this.showLoadingIndicator_ && this.showProgressBar(),
                                    v
                                        ? this.useSearchFn(p, O.Autocompleter.Search.EXPANDED_COUNT)
                                        : this.urlSearch(p, O.Autocompleter.Search.EXPANDED_COUNT),
                                    (this.changed = !1),
                                    (this.hasFocus = !0));
                        }
                    },
                    getLoadCount(v) {
                        return this.search || this.fhir
                            ? v +
                                  (this.multiSelect_ && O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD === v
                                      ? this.getSelectedItems().length
                                      : 0)
                            : this.multiSelect_ && v === O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD
                            ? v + this.getSelectedItems().length
                            : v !== O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD
                            ? v
                            : 0;
                    },
                    useSearchFn: function (v, p) {
                        var _ = this;
                        this.search(v, this.getLoadCount(p)).then(
                            function (T) {
                                _.onComplete({ results: T, requestedCount: p, searchStr: v });
                            },
                            function (T) {
                                console.log('FHIR search failed: ' + T);
                            },
                        );
                    },
                    urlSearch: function (v, p) {
                        var _ = {};
                        if (this.fhir)
                            (_.filter = v), (_._format = 'application/json'), (_.count = this.getLoadCount(p));
                        else {
                            _.terms = v;
                            var T = this.getLoadCount(p);
                            T && (_.maxList = T);
                        }
                        window._token && (params.authenticity_token = window._token),
                            (this.lastAjaxRequest_ = O.jqueryLite.ajax(this.url, {
                                data: _,
                                dataType: 'json',
                                complete: this.options.onComplete,
                            })),
                            (this.lastAjaxRequest_.requestParamData_ = _),
                            (this.lastAjaxRequest_.requestedCount = p);
                    },
                    initResultCache: function () {
                        (this.resultCache_ = this.url ? O.Autocompleter.Search.urlToCache_[this.url] : null),
                            this.resultCache_ ||
                                ((this.resultCache_ = []),
                                this.url && (O.Autocompleter.Search.urlToCache_[this.url] = this.resultCache_));
                    },
                    getCachedResults: function (v, p) {
                        return (
                            this.resultCache_ || this.initResultCache(), this.resultCache_[p] && this.resultCache_[p][v]
                        );
                    },
                    storeCachedResults: function (v, p, _) {
                        this.resultCache_ || this.initResultCache(),
                            this.resultCache_[p] || (this.resultCache_[p] = {}),
                            (this.resultCache_[p][v] = _);
                    },
                    clearCachedResults: function () {
                        (this.resultCache_ = [{}, {}]),
                            (O.Autocompleter.Search.urlToCache_[this.url] = this.resultCache_);
                    },
                    setURL: function (v) {
                        (this.url = v), this.initResultCache();
                    },
                    fieldEventIsBigList: function (v) {
                        return (
                            v.keyCode === q.ENTER &&
                            (v.ctrlKey ||
                                (!this.autocomp &&
                                    this.domCache.get('elemVal') !== this.processedFieldVal_ &&
                                    '' !== this.domCache.get('elemVal').trim()))
                        );
                    },
                    buttonKeyPress: function (v) {
                        v.keyCode === q.ENTER && this.runSearch();
                    },
                    processChoices: function (v, p) {
                        for (var _ = [], T = Object.keys(v), x = 0, F = T.length; x < F; ++x) {
                            var C = T[x];
                            (!this.multiSelect_ || !this.isSelected(C)) && _.push(C);
                        }
                        if (_.length > 0 && !this.numHeadings_) {
                            var R = null,
                                j = -1;
                            if (
                                (this.suggestionMode_ === O.Autocompleter.USE_STATISTICS
                                    ? (j = 0)
                                    : this.suggestionMode_ === O.Autocompleter.SUGGEST_SHORTEST &&
                                      (j = this.pickBestMatch(_)),
                                this.options.sort)
                            )
                                j > -1 && ((R = _[j]), (_[j] = '')),
                                    (_ = _.sort(O.Autocompleter.Base.noCaseSort)),
                                    j > -1 && (_[0] = R);
                            else if (j > 0) {
                                var N = _[0];
                                (_[0] = _[j]), (_[j] = N);
                            }
                            _.length > p && (_.length = p);
                        }
                        return [_, j > -1];
                    },
                    escapeHTML: function (v) {
                        return O.Autocompleter.Base.escapeAttribute(v).replace(/&lt;(\/)?span&gt;/g, '<$1span>');
                    },
                    buildUpdateHTML: function (v, p, _) {
                        var T,
                            x,
                            F,
                            C,
                            k,
                            R,
                            j,
                            N = this.options.tableFormat;
                        N
                            ? ((x = this.colHeaderHTML || '<table><tbody>'),
                              (F = '</tbody></table>'),
                              (C = '<tr'),
                              (k = '><td>'),
                              (R = '</td><td>'),
                              (j = '</td></tr>'))
                            : ((x = '<ul>'),
                              (F = '</ul>'),
                              (C = '<li'),
                              (k = '>'),
                              (R = O.Autocompleter.LIST_ITEM_FIELD_SEP),
                              (j = '</li>')),
                            (T = x);
                        for (var K = 0, Q = v.length; K < Q; ++K) {
                            for (var ce = v[K], ge = _[ce], De = [], xe = 0, Ve = ge.length; xe < Ve; ++xe)
                                De[xe] = this.escapeHTML(ge[xe]);
                            (T += C),
                                0 === K && p && (T += ' class="suggestion"'),
                                N && (T += ' data-fieldval="' + this.escapeHTML(ce) + '"'),
                                (T += k),
                                (T += De.join(R)),
                                (T += j);
                        }
                        return T + F;
                    },
                    setSearchCountDiv: function (v, p, _) {
                        var T = U('searchCount'),
                            x = '';
                        if (v > 0 || null === v) {
                            x = p + ' of ' + (null === v ? 'unknown' : v) + ' total';
                            var C = new Date().getTime() - this.searchStartTime + 1e3 * this.options.frequency + '',
                                k = _ + '';
                            k.length < 3 && (k += '&nbsp;');
                            var R = '; ';
                            void 0 !== _ && (R += k + ' bytes in '),
                                (R += C + ' ms'),
                                C.length < 3 && (R += '&nbsp;'),
                                (T.innerHTML = x += R),
                                (U('searchCount').style.display = 'block');
                        }
                    },
                    createFieldVals: function (v) {
                        var p = {},
                            _ = this.options.valueCols,
                            T = O.Autocompleter.LIST_ITEM_FIELD_SEP;
                        if (((this.itemToDataIndex_ = {}), _)) var x = _.length;
                        for (var F = 0, C = v.length; F < C; ++F) {
                            var R,
                                k = v[F];
                            if (_) {
                                R = [];
                                for (var j = 0; j < x; ++j) R[j] = k[_[j]];
                            } else R = k;
                            var N = R.join(T);
                            (N = N.replace(/<\/?span>/g, '')), (this.itemToDataIndex_[N] = F), (p[N] = k);
                        }
                        return p;
                    },
                    onComplete: function (v, p) {
                        const _ = v.requestedCount || this.lastAjaxRequest_.requestedCount;
                        var T = this.getToken();
                        (this.trimmedElemVal = T.trim()),
                            this.lastAjaxRequest_ === v && (this.lastAjaxRequest_ = null),
                            this.showLoadingIndicator_ &&
                                (this.progressElement?.classList.remove('show'),
                                clearTimeout(this.loadingAnnouncerTimeout));
                        const x = !!v.results;
                        if (200 === v.status || x) {
                            if (x)
                                var F = v.searchStr,
                                    C = v.requestedCount === O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD;
                            else {
                                var k = v.requestParamData_;
                                this.fhir
                                    ? ((F = k.filter),
                                      (C = k.count === this.getLoadCount(O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD)))
                                    : ((F = k.terms),
                                      (C =
                                          void 0 === k.maxList ||
                                          k.maxList === this.getLoadCount(O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD)));
                            }
                            var R = O.Autocompleter.Search;
                            !p && this.useResultCache_ && this.storeCachedResults(F, this.getLoadCount(_), v);
                            var j = this.getSearchStr(T);
                            if (
                                (C && (j = j.substr(0, R.MAX_VALUE_SIZE_FOR_AUTOCOMP)),
                                (this.hasFocus || this.refocusInProgress_) && j === F)
                            ) {
                                var N = x ? v.results : v.responseJSON || JSON.parse(v.responseText);
                                if (this.fhir) {
                                    (K = N.expansion.total),
                                        (this.listExtraData_ = null),
                                        (this.itemCodes_ = []),
                                        (this.itemCodeSystems_ = []),
                                        (this.rawList_ = []);
                                    var Q = N.expansion.contains;
                                    if (Q)
                                        for (var ce = 0, ge = Q.length; ce < ge; ++ce) {
                                            var De = Q[ce];
                                            (this.itemCodes_[ce] = De.code),
                                                (this.itemCodeSystems_[ce] = De.system),
                                                (this.rawList_[ce] = [De.display]);
                                        }
                                } else {
                                    var K = N[0];
                                    (this.itemCodes_ = N[1]),
                                        (this.listExtraData_ = N[2]),
                                        (this.itemCodeSystems_ = N[4]),
                                        (this.rawList_ = N[3]);
                                }
                                var xe = this.createFieldVals(this.rawList_),
                                    Ve = this.processChoices(xe, _),
                                    b = Ve[0],
                                    Ne = this.buildUpdateHTML(b, Ve[1], xe);
                                this.updateChoices(Ne, !1);
                                var at = b.length;
                                this.setSearchCountDiv(K, at, x ? void 0 : v.responseText.length),
                                    (U('moreResults').style.display = (at < K || null === K) && C ? 'block' : 'none'),
                                    this.showLoadingIndicator_ &&
                                        this.loadingAnnounced &&
                                        0 === K &&
                                        O.Autocompleter.screenReaderLog("No list items matched the field's value."),
                                    (this.searchInProgress = !1),
                                    (this.listBelowField_ =
                                        this.entryCount <= O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD),
                                    this.posAnsList();
                            }
                        }
                    },
                    getItemExtraData: function (v) {
                        var p = {};
                        if (this.listExtraData_) {
                            var _ = this.itemToDataIndex_[v];
                            if (null != _)
                                for (var T = Object.keys(this.listExtraData_), x = 0, F = T.length; x < F; ++x) {
                                    var C = T[x];
                                    p[C] = this.listExtraData_[C][_];
                                }
                        }
                        return p;
                    },
                    getItemData: function (v) {
                        v || (v = this.domCache.get('elemVal'));
                        var p = { text: v };
                        if ('' != v && this.itemToDataIndex_) {
                            var _ = this.getItemCode(v);
                            if (null != _ && ((p.code = _), this.itemCodeSystems_)) {
                                var x = this.itemCodeSystems_[this.itemToDataIndex_[v]];
                                x && (p.code_system = x);
                            }
                            var F = this.getItemExtraData(v);
                            Object.keys(F).length > 0 && (p.data = F);
                        }
                        return p;
                    },
                    show: function () {
                        ('hidden' === this.listContainer.style.visibility ||
                            '' === this.listContainer.style.visibility) &&
                            this.options.onShow(this.element, this.update);
                    },
                    hide: function () {
                        this.searchInProgress || O.Autocompleter.Search.superclass.hide.apply(this);
                    },
                    buttonClick: function (v) {
                        this.observer && clearTimeout(this.observer),
                            (this.searchInProgress = !0),
                            this.runSearch(),
                            O.Autocompleter.stopEvent(v);
                    },
                    handleSeeMoreItems: function (v) {
                        this.multiSelect_ &&
                            '' === this.domCache.get('elemVal') &&
                            this.preFieldFillVal_ &&
                            this.setFieldVal(this.preFieldFillVal_, !1),
                            this.buttonClick(v);
                    },
                    onFocus: function () {
                        !0 === O.Autocompleter.completionOptionsScrollerClicked_
                            ? (O.Autocompleter.completionOptionsScrollerClicked_ = !1)
                            : (this.refocusInProgress_ ||
                                  (O.Autocompleter.screenReaderLog('Type to show matching list values.'),
                                  this.hide(),
                                  (this.rawList_ = [])),
                              O.Autocompleter.Base.prototype.onFocus.apply(this),
                              (this.hasFocus = !0),
                              this.showListOnFocusIfEmpty_ && this.getUpdatedChoices(),
                              setTimeout(() => {
                                  this._disableListItemClick = !1;
                              }, 10));
                    },
                    onBlur: function (v) {
                        !this.refocusInProgress_ &&
                            !O.Autocompleter.completionOptionsScrollerClicked_ &&
                            (O.Autocompleter.Base.prototype.onBlur.apply(this, [v]),
                            this.searchInProgress || (this.active = !1));
                    },
                    getUpdatedChoices: function () {
                        if ((this.lastAjaxRequest_ && this.lastAjaxRequest_.abort(), this.url || this.search)) {
                            this.searchStartTime = new Date().getTime();
                            var v = null,
                                p = O.Autocompleter.Search,
                                _ = this.getSearchStr();
                            _.length > p.MAX_VALUE_SIZE_FOR_AUTOCOMP &&
                                (_ = _.substr(0, p.MAX_VALUE_SIZE_FOR_AUTOCOMP)),
                                this.useResultCache_ &&
                                    (v = this.getCachedResults(
                                        _,
                                        this.getLoadCount(O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD),
                                    )) &&
                                    this.onComplete(v, !0),
                                v ||
                                    (this.showLoadingIndicator_ && this.showProgressBar(),
                                    this.search
                                        ? this.useSearchFn(_, O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD)
                                        : this.urlSearch(_, O.Autocompleter.Base.MAX_ITEMS_BELOW_FIELD));
                        }
                    },
                    showProgressBar: function () {
                        this.progressElement?.classList.add('show'),
                            clearTimeout(this.loadingAnnouncerTimeout),
                            (this.loadingAnnounced = !1),
                            (this.loadingAnnouncerTimeout = setTimeout(() => {
                                O.Autocompleter.screenReaderLog('A list is being loaded for the field.'),
                                    (this.loadingAnnounced = !0);
                            }, 1500));
                    },
                    findSuggestions: function () {
                        if (this.url) {
                            var p = { field_val: this.getSearchStr(), suggest: 1 };
                            window._token && (params.authenticity_token = window._token);
                            var _ = { data: p, complete: this.onFindSuggestionComplete.bind(this) };
                            O.jqueryLite.ajax(this.url, _);
                        }
                    },
                    onFindSuggestionComplete: function (v) {
                        if (200 === v.status) {
                            var p = v.responseJSON || JSON.parse(v.responseText),
                                T = [],
                                x = !1;
                            if (p[0].length > 0) {
                                var F = p[1];
                                this.suggestionList_ = p;
                                for (
                                    var C = this.domCache.get('elemVal').trim().toLowerCase(),
                                        k = O.Autocompleter.LIST_ITEM_FIELD_SEP,
                                        R = 0,
                                        j = F.length;
                                    !x && R < j;
                                    ++R
                                )
                                    (F[R] = F[R].join(k)),
                                        F[R].toLowerCase() === C &&
                                            ((x = !0),
                                            this.observer && clearTimeout(this.observer),
                                            this.acceptSuggestion(R));
                                x || (T = F);
                            }
                            x ||
                                O.Autocompleter.Event.notifyObservers(this.element, 'SUGGESTIONS', {
                                    suggestion_list: T,
                                });
                        }
                    },
                    acceptSuggestion: function (v) {
                        var p = this.suggestionList_[0],
                            _ = this.suggestionList_[1],
                            T = _[v],
                            x = this.domCache.get('elemVal');
                        this.setFieldVal((this.processedFieldVal_ = T), !1),
                            this.setMatchStatusIndicator(!0),
                            (this.fieldValIsListVal_ = !0),
                            this.propagateFieldChanges(),
                            O.Autocompleter.Event.notifyObservers(this.element, 'SUGGESTION_USED', {
                                suggestion_used: T,
                            }),
                            (this.itemCodes_ = p),
                            (this.itemToDataIndex_ = {}),
                            (this.itemToDataIndex_[_[v]] = v),
                            (this.listExtraData_ = this.suggestionList_[2]),
                            (this.itemCodeSystems_ = this.suggestionList_[3]),
                            this.listSelectionNotification(x, !0),
                            this.element.focus();
                    },
                };
                Object.assign(O.Autocompleter.Search.prototype, $), ($ = null);
            };
        },
        5955: se => {
            se.exports = function ae(U) {
                'use strict';
                var O = U.PrototypeAPI.Class.create({
                    initialize: function (M, q, G, $) {
                        if (((this.displayedProp = M.display || 'text'), (this.scope = q), (this.acOptions = M), $)) {
                            this.pElem = G[0];
                            var v = this.pElem.autocomp;
                            v &&
                                (v.destroy(),
                                (q.modelData = null),
                                this.removeAutocompFunction($.$formatters),
                                this.removeAutocompFunction($.$parsers));
                            var p = M.hasOwnProperty('url') || (M.fhir && M.fhir.search);
                            this.ac = p ? this.searchList() : this.prefetchList();
                            var _ = q.modelData;
                            if (null != _)
                                if (this.ac.multiSelect_) {
                                    for (var x = 0, F = _.length; x < F; ++x)
                                        this.ac.storeSelectedItem((C = _[x][this.displayedProp]), _[x].code),
                                            this.ac.addToSelectedArea(C);
                                    this.ac.setFieldVal('', !1);
                                } else {
                                    var C;
                                    'string' == typeof (C = _[this.displayedProp])
                                        ? (this.ac.storeSelectedItem(C, _.code), this.ac.setFieldVal(C, !1))
                                        : this.ac.setFieldVal('', !1);
                                }
                            (this.parser = this.parser.bind(this)),
                                (this.parser.fromAutocomp = !0),
                                $.$parsers.push(this.parser),
                                (this.formatter = this.formatter.bind(this)),
                                (this.formatter.fromAutocomp = !0),
                                $.$formatters.push(this.formatter);
                        }
                    },
                    parser: function (M) {
                        var q = this.scope.modelData;
                        return void 0 === q && (q = null), q;
                    },
                    formatter: function (M) {
                        var q = '';
                        return (
                            this.ac.multiSelect_
                                ? (q = '')
                                : ('string' == typeof M
                                      ? (q = M)
                                      : null !== M &&
                                        'object' == typeof M &&
                                        'string' == typeof M[this.displayedProp] &&
                                        (q = M[this.displayedProp]),
                                  (q = q.trim())),
                            this.ac.setFieldVal(q, !1),
                            q
                        );
                    },
                    getPrefetchItemModelData: function (M, q) {
                        var G = q[M];
                        return G || ('' != M ? ((G = { _notOnList: !0 })[this.displayedProp] = M) : (G = null)), G;
                    },
                    prefetchListSelHandler: function (M, q) {
                        var G = M.final_val;
                        if (this.ac.multiSelect_) {
                            this.scope.modelData || (this.scope.modelData = []);
                            var $ = this.scope.modelData;
                            if (M.removed) {
                                for (var v = M.final_val, p = 0, _ = $.length; p < _; ++p)
                                    if (v === $[p][this.displayedProp]) {
                                        $.splice(p, 1);
                                        break;
                                    }
                            } else if (M.on_list || !this.acOptions.matchListValue) {
                                var T = this.getPrefetchItemModelData(G, q);
                                T && $.push(T);
                            }
                        } else this.scope.modelData = this.getPrefetchItemModelData(G, q);
                    },
                    prefetchList: function () {
                        var M = [],
                            q = {},
                            G = this.acOptions,
                            $ = null,
                            v = G.defaultValue,
                            p = null,
                            _ = this.displayedProp;
                        void 0 !== v &&
                            null == this.scope.modelData &&
                            ('string' == typeof v ? (($ = _), (p = v)) : (p = v[($ = Object.keys(v)[0])]));
                        for (var x, T = null, F = 0, C = G.listItems.length; F < C; ++F) {
                            var k = G.listItems[F];
                            M[F] = x = k[_];
                            var R = x.trim();
                            (q[R] = k), $ && k[$].trim() === p && (T = this.getPrefetchItemModelData(R, q));
                        }
                        var j = new U.Autocompleter.Prefetch(this.pElem, M, G);
                        this.addNameAttr();
                        var N = this;
                        return (
                            this.updateListSelectionHandler(function (K) {
                                N.scope.$apply(function () {
                                    N.prefetchListSelHandler(K, q);
                                });
                            }),
                            null !== T && !this.scope.modelData && (this.scope.modelData = j.multiSelect_ ? [T] : T),
                            j
                        );
                    },
                    getSearchItemModelData: function (M, q) {
                        var G;
                        return '' === M ? (G = null) : ((G = this.ac.getItemData(M)), q || (G._notOnList = !0)), G;
                    },
                    addNameAttr: function () {
                        '' === this.pElem.name && (this.pElem.name = this.pElem.id);
                    },
                    searchListSelHandler: function (M) {
                        var q = M.final_val,
                            G = M.on_list;
                        if (this.ac.multiSelect_) {
                            this.scope.modelData || (this.scope.modelData = []);
                            var $ = this.scope.modelData;
                            if (M.removed) {
                                for (var v = M.final_val, p = 0, _ = $.length; p < _; ++p)
                                    if (v === $[p].text) {
                                        $.splice(p, 1);
                                        break;
                                    }
                            } else if (M.on_list || !this.acOptions.matchListValue) {
                                var T = this.getSearchItemModelData(q, G);
                                T && $.push(T);
                            }
                        } else this.scope.modelData = this.getSearchItemModelData(q, G);
                    },
                    searchList: function () {
                        var M = new U.Autocompleter.Search(this.pElem, this.acOptions.url, this.acOptions);
                        this.addNameAttr();
                        var q = this;
                        return (
                            this.updateListSelectionHandler(function (G) {
                                q.scope.$apply(function () {
                                    q.searchListSelHandler(G);
                                });
                            }),
                            M
                        );
                    },
                    removeAutocompFunction: function (M) {
                        for (var q = 0, G = M.length; q < G; ++q)
                            if (M[q].fromAutocomp) {
                                M.splice(q, 1);
                                break;
                            }
                    },
                    updateListSelectionHandler: function (M) {
                        var q = this.pElem,
                            G = U.Observable.lookupKey(q),
                            $ = U.Autocompleter.directiveListEventHandlers,
                            v = $[q.id];
                        v && U.Autocompleter.Event.removeCallback(G, 'LIST_SEL', v),
                            U.Autocompleter.Event.observeListSelections(G, M),
                            ($[q.id] = M);
                    },
                });
                (U.Autocompleter.directiveListEventHandlers = {}),
                    typeof angular < 'u' &&
                        angular.module('autocompleteLhcMod', []).directive('autocompleteLhc', [
                            function () {
                                return {
                                    restrict: 'A',
                                    require: '?ngModel',
                                    scope: { modelData: '=ngModel', acOpts: '=autocompleteLhc' },
                                    link: function (M, q, G, $) {
                                        $.$options || ($.$options = {}),
                                            ($.$options.updateOn = 'none'),
                                            ($.$options.updateOnDefault = !1),
                                            M.$watch(
                                                'acOpts',
                                                function v(p) {
                                                    new O(p, M, q, $);
                                                },
                                                !0,
                                            );
                                    },
                                };
                            },
                        ]);
            };
        },
        3319: se => {
            se.exports = function ae(U, O) {
                'use strict';
                var q = U.$;
                function G(_, v, p) {
                    if (((_ = q(_)), 1 == arguments.length)) {
                        var T = _.cumulativeOffset();
                        window.scrollTo(T[0], T[1]);
                    } else (_.scrollLeft = v), (_.scrollTop = p);
                    return _;
                }
                (O.Scroll = U.Class.create()),
                    Object.assign(Object.assign(O.Scroll.prototype, O.Base.prototype), {
                        currentScrollPos: function ($) {
                            return this.element === window
                                ? document.viewport.getScrollOffsets()
                                : this.element === document.documentElement &&
                                  0 === document.documentElement.scrollTop &&
                                  0 === document.documentElement.scrollLeft
                                ? { left: document.body.scrollLeft, top: document.body.scrollTop }
                                : { left: this.element.scrollLeft, top: this.element.scrollTop };
                        },
                        initialize: function ($) {
                            if (((this.element = q($)), !this.element)) throw O._elementDoesNotExistError;
                            var v = this.currentScrollPos($),
                                p = Object.assign({ x: 0, y: 0 }, arguments[1] || {});
                            this.start({ x: v.left + p.x, y: v.top + p.y });
                        },
                        setup: function () {},
                        update: function ($) {
                            var v = this.currentScrollPos(this.element),
                                p = Math.round((this.options.x - v.left) * $ + v.left),
                                _ = Math.round((this.options.y - v.top) * $ + v.top);
                            G(this.element, p, _), this.element === document.documentElement && G(document.body, p, _);
                        },
                    });
            };
        },
        9769: se => {
            if (typeof ae > 'u') var ae = {};
            se.exports = function U(O, M) {
                'use strict';
                var q = M.PrototypeAPI.Class,
                    G = M.PrototypeAPI.Enumerable,
                    v = M.PrototypeAPI.isString,
                    p = {
                        _elementDoesNotExistError: {
                            name: 'ElementDoesNotExistError',
                            message:
                                'The specified DOM element does not exist, but is required for this effect to operate',
                        },
                        Transitions: {
                            linear: function (_) {
                                return _;
                            },
                            sinoidal: function (_) {
                                return -Math.cos(_ * Math.PI) / 2 + 0.5;
                            },
                            reverse: function (_) {
                                return 1 - _;
                            },
                            flicker: function (T) {
                                return (T = -Math.cos(T * Math.PI) / 4 + 0.75 + Math.random() / 4) > 1 ? 1 : T;
                            },
                            wobble: function (_) {
                                return -Math.cos(_ * Math.PI * (9 * _)) / 2 + 0.5;
                            },
                            pulse: function (_, T) {
                                return -Math.cos(_ * ((T || 5) - 0.5) * 2 * Math.PI) / 2 + 0.5;
                            },
                            spring: function (_) {
                                return 1 - Math.cos(4.5 * _ * Math.PI) * Math.exp(6 * -_);
                            },
                            none: function (_) {
                                return 0;
                            },
                            full: function (_) {
                                return 1;
                            },
                        },
                        DefaultOptions: {
                            duration: 1,
                            fps: 100,
                            sync: !1,
                            from: 0,
                            to: 1,
                            delay: 0,
                            queue: 'parallel',
                        },
                    };
                (p.DefaultOptions.transition = p.Transitions.sinoidal),
                    (p.ScopedQueue = q.create(G, {
                        initialize: function () {
                            (this.effects = []), (this.interval = null);
                        },
                        _each: function (_) {
                            this.effects._each(_);
                        },
                        add: function (_) {
                            var T = new Date().getTime();
                            switch (v(_.options.queue) ? _.options.queue : _.options.queue.position) {
                                case 'front':
                                    this.effects
                                        .findAll(function (F) {
                                            return 'idle' == F.state;
                                        })
                                        .each(function (F) {
                                            (F.startOn += _.finishOn), (F.finishOn += _.finishOn);
                                        });
                                    break;
                                case 'with-last':
                                    T = this.effects.pluck('startOn').max() || T;
                                    break;
                                case 'end':
                                    T = this.effects.pluck('finishOn').max() || T;
                            }
                            (_.startOn += T),
                                (_.finishOn += T),
                                (!_.options.queue.limit || this.effects.length < _.options.queue.limit) &&
                                    this.effects.push(_),
                                this.interval || (this.interval = setInterval(this.loop.bind(this), 15));
                        },
                        remove: function (_) {
                            for (var T; (T = this.effects.indexOf(_)) > -1; ) this.effects.splice(T, 1);
                            0 == this.effects.length && (clearInterval(this.interval), (this.interval = null));
                        },
                        loop: function () {
                            for (var _ = new Date().getTime(), T = 0, x = this.effects.length; T < x; T++)
                                this.effects[T] && this.effects[T].loop(_);
                        },
                    })),
                    (p.Queues = {
                        instances: {},
                        get: function (_) {
                            return v(_) ? this.instances[_] || (this.instances[_] = new p.ScopedQueue()) : _;
                        },
                    }),
                    (p.Queue = p.Queues.get('global')),
                    (p.Base = q.create({
                        position: null,
                        start: function (_) {
                            _ && !1 === _.transition && (_.transition = p.Transitions.linear),
                                (this.options = Object.assign(Object.assign({}, p.DefaultOptions), _ || {})),
                                (this.currentFrame = 0),
                                (this.state = 'idle'),
                                (this.startOn = 1e3 * this.options.delay),
                                (this.finishOn = this.startOn + 1e3 * this.options.duration),
                                (this.fromToDelta = this.options.to - this.options.from),
                                (this.totalTime = this.finishOn - this.startOn),
                                (this.totalFrames = this.options.fps * this.options.duration),
                                (this.render = (function () {
                                    function T(x, F) {
                                        x.options[F + 'Internal'] && x.options[F + 'Internal'](x),
                                            x.options[F] && x.options[F](x);
                                    }
                                    return function (x) {
                                        'idle' === this.state &&
                                            ((this.state = 'running'),
                                            T(this, 'beforeSetup'),
                                            this.setup && this.setup(),
                                            T(this, 'afterSetup')),
                                            'running' === this.state &&
                                                ((x =
                                                    this.options.transition(x) * this.fromToDelta + this.options.from),
                                                (this.position = x),
                                                T(this, 'beforeUpdate'),
                                                this.update && this.update(x),
                                                T(this, 'afterUpdate'));
                                    };
                                })()),
                                this.event('beforeStart'),
                                this.options.sync ||
                                    p.Queues.get(v(this.options.queue) ? 'global' : this.options.queue.scope).add(this);
                        },
                        loop: function (_) {
                            if (_ >= this.startOn) {
                                if (_ >= this.finishOn)
                                    return (
                                        this.render(1),
                                        this.cancel(),
                                        this.event('beforeFinish'),
                                        this.finish && this.finish(),
                                        void this.event('afterFinish')
                                    );
                                var T = (_ - this.startOn) / this.totalTime,
                                    x = Math.round(T * this.totalFrames);
                                x > this.currentFrame && (this.render(T), (this.currentFrame = x));
                            }
                        },
                        cancel: function () {
                            this.options.sync ||
                                p.Queues.get(v(this.options.queue) ? 'global' : this.options.queue.scope).remove(this),
                                (this.state = 'finished');
                        },
                        event: function (_) {
                            this.options[_ + 'Internal'] && this.options[_ + 'Internal'](this),
                                this.options[_] && this.options[_](this);
                        },
                        inspect: function () {
                            var _ = $H();
                            for (property in this) Object.isFunction(this[property]) || _.set(property, this[property]);
                            return '#<Effect:' + _.inspect() + ',options:' + $H(this.options).inspect() + '>';
                        },
                    })),
                    (p.Move = q.create(p.Base, {
                        initialize: function (_) {
                            if (((this.element = O(_)), !this.element)) throw p._elementDoesNotExistError;
                            var T = Object.assign({ x: 0, y: 0, mode: 'relative' }, arguments[1] || {});
                            this.start(T);
                        },
                        setup: function () {
                            M.PrototypeAPI.makePositioned(this.element);
                            var _ = M.PrototypeAPI;
                            (this.originalLeft = parseFloat(_.getStyle(this.element, 'left') || '0')),
                                (this.originalTop = parseFloat(_.getStyle(this.element, 'top') || '0')),
                                'absolute' == this.options.mode &&
                                    ((this.options.x = this.options.x - this.originalLeft),
                                    (this.options.y = this.options.y - this.originalTop));
                        },
                        update: function (_) {
                            M.PrototypeAPI.setStyle(this.element, {
                                left: Math.round(this.options.x * _ + this.originalLeft) + 'px',
                                top: Math.round(this.options.y * _ + this.originalTop) + 'px',
                            });
                        },
                    })),
                    (p.Shake = function (_) {
                        _ = O(_);
                        var T = Object.assign({ distance: 20, duration: 0.5 }, arguments[1] || {}),
                            x = parseFloat(T.distance),
                            F = parseFloat(T.duration) / 10,
                            C = M.jqueryLite.getElementOffset(_),
                            k = M.PrototypeAPI,
                            R = { top: C.top, left: C.left };
                        return new p.Move(_, {
                            x,
                            y: 0,
                            duration: F,
                            afterFinishInternal: function (j) {
                                new p.Move(j.element, {
                                    x: 2 * -x,
                                    y: 0,
                                    duration: 2 * F,
                                    afterFinishInternal: function (N) {
                                        new p.Move(N.element, {
                                            x: 2 * x,
                                            y: 0,
                                            duration: 2 * F,
                                            afterFinishInternal: function (K) {
                                                new p.Move(K.element, {
                                                    x: 2 * -x,
                                                    y: 0,
                                                    duration: 2 * F,
                                                    afterFinishInternal: function (Q) {
                                                        new p.Move(Q.element, {
                                                            x: 2 * x,
                                                            y: 0,
                                                            duration: 2 * F,
                                                            afterFinishInternal: function (ce) {
                                                                new p.Move(ce.element, {
                                                                    x: -x,
                                                                    y: 0,
                                                                    duration: F,
                                                                    afterFinishInternal: function (ge) {
                                                                        k.setStyle(k.undoPositioned(ge.element), R);
                                                                    },
                                                                });
                                                            },
                                                        });
                                                    },
                                                });
                                            },
                                        });
                                    },
                                });
                            },
                        });
                    }),
                    (M.Effect = p);
            };
        },
        3895: se => {
            se.exports = function ae(U, O) {
                'use strict';
                var M = {
                        HTMLEvents: /^(?:load|unload|abort|error|select|change|submit|reset|focus|blur|resize|scroll)$/,
                        MouseEvents: /^(?:click|mouse(?:down|up|over|move|out))$/,
                    },
                    q = {
                        pointerX: 0,
                        pointerY: 0,
                        button: 0,
                        ctrlKey: !1,
                        altKey: !1,
                        shiftKey: !1,
                        metaKey: !1,
                        bubbles: !0,
                        cancelable: !0,
                    };
                (O.Event = {}),
                    (O.Event.simulate = function (G, $) {
                        var p,
                            v = Object.assign(q, arguments[2] || {}),
                            _ = null;
                        for (var T in ((G = U(G)), M))
                            if (M[T].test($)) {
                                _ = T;
                                break;
                            }
                        if (!_) throw new SyntaxError('Only HTMLEvents and MouseEvents interfaces are supported');
                        return (
                            document.createEvent
                                ? ((p = document.createEvent(_)),
                                  'HTMLEvents' == _
                                      ? p.initEvent($, v.bubbles, v.cancelable)
                                      : p.initMouseEvent(
                                            $,
                                            v.bubbles,
                                            v.cancelable,
                                            document.defaultView,
                                            v.button,
                                            v.pointerX,
                                            v.pointerY,
                                            v.pointerX,
                                            v.pointerY,
                                            v.ctrlKey,
                                            v.altKey,
                                            v.shiftKey,
                                            v.metaKey,
                                            v.button,
                                            G,
                                        ),
                                  G.dispatchEvent(p))
                                : ((v.clientX = v.pointerX),
                                  (v.clientY = v.pointerY),
                                  (p = Object.assign(document.createEventObject(), v)),
                                  G.fireEvent('on' + $, p)),
                            G
                        );
                    });
            };
        },
        8033: se => {
            if (typeof ae > 'u') var ae = {};
            se.exports = function U(O, M) {
                'use strict';
                M.FieldAlarms = {
                    setOffAlarm: function (q) {
                        void 0 === this.bonk && (this.bonk = new Audio(this.soundData_)),
                            this.bonk.readyState >= 2 &&
                                ((this.bonk.currentTime = 0),
                                0 !== this.bonk.currentTime && (this.bonk.src = this.bonk.src)),
                            this.bonk.play(),
                            M.Effect.Shake(q.id, 5);
                    },
                    cancelAlarm: function (q) {
                        (q.shakeCanceled = !0), this.bonk.pause(), (this.bonk.currentTime = 0);
                    },
                };
            };
        },
        9339: (se, ae, U) => {
            var O = {};
            (O.PrototypeAPI = U(5922)),
                U(7144),
                U(6433)(O),
                U(9769)(O.PrototypeAPI.$, O),
                U(3319)(O.PrototypeAPI, O.Effect),
                U(3895)(O.PrototypeAPI.$, O),
                U(6426)(O),
                U(3620)(O),
                U(3510)(O.PrototypeAPI.$, O),
                U(8033)(O.PrototypeAPI.$, O),
                U(1994)(O),
                U(8898)(O.PrototypeAPI.$, O),
                U(6400)(O.PrototypeAPI.$, O),
                U(1615)(O.PrototypeAPI.$, O),
                U(7606)(O.PrototypeAPI.$, O),
                U(5955)(O),
                (se.exports = O);
        },
        6433: se => {
            se.exports = function ae(U) {
                U.jqueryLite = (function () {
                    'use strict';
                    return {
                        ui: {
                            keyCode: {
                                BACKSPACE: 8,
                                COMMA: 188,
                                DELETE: 46,
                                DOWN: 40,
                                END: 35,
                                ENTER: 13,
                                ESCAPE: 27,
                                HOME: 36,
                                LEFT: 37,
                                PAGE_DOWN: 34,
                                PAGE_UP: 33,
                                PERIOD: 190,
                                RIGHT: 39,
                                SPACE: 32,
                                TAB: 9,
                                UP: 38,
                            },
                        },
                        getElementOffset: function (O) {
                            const M = O.getBoundingClientRect(),
                                q = O.ownerDocument.defaultView;
                            return { top: M.top + q.pageYOffset, left: M.left + q.pageXOffset };
                        },
                        ajax: function (O, M) {
                            O.startsWith('/') && (O = window.location.origin + O);
                            const q = new URL(O);
                            if (M.data) for (const [$, v] of Object.entries(M.data)) q.searchParams.set($, v);
                            const G = new XMLHttpRequest();
                            return (
                                G.open('GET', q.toString(), !0),
                                (G.onreadystatechange = function () {
                                    4 === G.readyState && M.complete(G);
                                }),
                                G.send(),
                                G
                            );
                        },
                    };
                })();
            };
        },
        6426: se => {
            if (typeof ae > 'u') var ae = {};
            se.exports = function U(O) {
                'use strict';
                O.Observable = {
                    callbacks_: null,
                    notifyObservers: function (M, q, G) {
                        null !== this.callbacks_ &&
                            ((G.field_id = M ? M.id : null),
                            setTimeout(
                                function () {
                                    var $ = this.callbacks_[q];
                                    if (void 0 !== $) {
                                        if (null !== M) var p = $[this.lookupKey(M)];
                                        for (var T = [p, $.null], x = 0, F = T.length; x < F; ++x) {
                                            var C = T[x];
                                            if (void 0 !== C)
                                                for (var k = 0, R = C.length; k < R; ++k) C[k].call(this, G);
                                        }
                                    }
                                }.bind(this),
                            ));
                    },
                    lookupKey: function (M) {
                        return M.name || M.id;
                    },
                    storeCallback: function (M, q, G) {
                        null === this.callbacks_ && (this.callbacks_ = {});
                        var $ = this.callbacks_[q];
                        void 0 === $ && (this.callbacks_[q] = $ = {});
                        var v = $[M];
                        return (
                            void 0 === v && ($[M] = v = []),
                            v.push(G),
                            () => {
                                this.removeCallback(M, q, G);
                            }
                        );
                    },
                    removeCallback: function (M, q, G) {
                        if (null !== this.callbacks_) {
                            var $ = this.callbacks_[q];
                            if (void 0 !== $) {
                                var v = $[M];
                                if (void 0 !== v) {
                                    var p = v.indexOf(G);
                                    p > -1 && v.splice(p, 1);
                                }
                            }
                        }
                    },
                };
            };
        },
        7144: () => {
            'function' != typeof Object.assign &&
                (Object.assign = function (se) {
                    'use strict';
                    if (null == se) throw new TypeError('Cannot convert undefined or null to object');
                    for (var ae = Object(se), U = 1; U < arguments.length; U++) {
                        var O = arguments[U];
                        if (null != O) for (var M in O) O.hasOwnProperty(M) && (ae[M] = O[M]);
                    }
                    return ae;
                }),
                (String.prototype.trimLeft = function () {
                    for (var se = -1; this.charCodeAt(++se) < 33; );
                    return this.slice(se, this.length);
                });
        },
        5922: se => {
            if (typeof ae > 'u') var ae = {};
            (ae.PrototypeAPI = (function () {
                'use strict';
                var U = {};
                function O(N) {
                    if (!N) return [];
                    if ('toArray' in Object(N)) return N.toArray();
                    for (var K = N.length || 0, Q = new Array(K); K--; ) Q[K] = N[K];
                    return Q;
                }
                function M(N) {
                    var K = N;
                    return ae.PrototypeAPI.isString(N) && (K = document.getElementById(N)), K;
                }
                var N,
                    K,
                    q = Object.prototype.toString,
                    G =
                        ((N = typeof navigator < 'u' && navigator.userAgent),
                        (K = '[object Opera]' == Object.prototype.toString.call(window.opera)),
                        {
                            IE: !!window.attachEvent && !K,
                            Opera: K,
                            WebKit: N && N.indexOf('AppleWebKit/') > -1,
                            Gecko: N && N.indexOf('Gecko') > -1 && -1 === N.indexOf('KHTML'),
                            MobileSafari: N && /Apple.*Mobile/.test(N),
                        });
                function $(N) {
                    return '[object Function]' === q.call(N);
                }
                function _(N) {
                    var K = N.toString()
                        .match(/^[\s\(]*function[^(]*\(([^)]*)\)/)[1]
                        .replace(/\/\/.*?[\r\n]|\/\*(?:.|[\r\n])*?\*\//g, '')
                        .replace(/\s+/g, '')
                        .split(',');
                    return 1 != K.length || K[0] ? K : [];
                }
                function x(N) {
                    return N;
                }
                var F = (function () {
                        var N = (function () {
                            for (var ge in { toString: 1 }) if ('toString' === ge) return !1;
                            return !0;
                        })();
                        function K() {}
                        return {
                            create: function Q() {
                                var ge = null,
                                    De = O(arguments);
                                function xe() {
                                    this.initialize.apply(this, arguments);
                                }
                                $(De[0]) && (ge = De.shift()),
                                    (function T(N, K) {
                                        for (var Q in K) N[Q] = K[Q];
                                    })(xe, F.Methods),
                                    (xe.superclass = ge),
                                    (xe.subclasses = []),
                                    ge &&
                                        ((K.prototype = ge.prototype),
                                        (xe.prototype = new K()),
                                        ge.subclasses.push(xe));
                                for (var Ve = 0, b = De.length; Ve < b; Ve++) xe.addMethods(De[Ve]);
                                return (
                                    xe.prototype.initialize || (xe.prototype.initialize = function () {}),
                                    (xe.prototype.constructor = xe),
                                    xe
                                );
                            },
                            Methods: {
                                addMethods: function ce(ge) {
                                    var De = this.superclass && this.superclass.prototype,
                                        xe = Object.keys(ge);
                                    N &&
                                        (ge.toString != Object.prototype.toString && xe.push('toString'),
                                        ge.valueOf != Object.prototype.valueOf && xe.push('valueOf'));
                                    for (var Ve = 0, b = xe.length; Ve < b; Ve++) {
                                        var je = xe[Ve],
                                            Ne = ge[je];
                                        if (De && $(Ne) && '$super' == _(Ne)[0]) {
                                            var at = Ne;
                                            (Ne = (function (Et) {
                                                return function () {
                                                    return De[Et].apply(this, arguments);
                                                };
                                            })(je).wrap(at)),
                                                (Ne.valueOf = (function (Et) {
                                                    return function () {
                                                        return Et.valueOf.call(Et);
                                                    };
                                                })(at)),
                                                (Ne.toString = (function (Et) {
                                                    return function () {
                                                        return Et.toString.call(Et);
                                                    };
                                                })(at));
                                        }
                                        this.prototype[je] = Ne;
                                    }
                                    return this;
                                },
                            },
                        };
                    })(),
                    C = (function () {
                        function Q(qe, ot) {
                            qe = qe || x;
                            var ke = !0;
                            return (
                                this.each(function (Ce, Pe) {
                                    if (!(ke = ke && !!qe.call(ot, Ce, Pe, this))) throw U;
                                }, this),
                                ke
                            );
                        }
                        function ce(qe, ot) {
                            qe = qe || x;
                            var ke = !1;
                            return (
                                this.each(function (Ce, Pe) {
                                    if ((ke = !!qe.call(ot, Ce, Pe, this))) throw U;
                                }, this),
                                ke
                            );
                        }
                        function ge(qe, ot) {
                            qe = qe || x;
                            var ke = [];
                            return (
                                this.each(function (Ce, Pe) {
                                    ke.push(qe.call(ot, Ce, Pe, this));
                                }, this),
                                ke
                            );
                        }
                        function De(qe, ot) {
                            var ke;
                            return (
                                this.each(function (Ce, Pe) {
                                    if (qe.call(ot, Ce, Pe, this)) throw ((ke = Ce), U);
                                }, this),
                                ke
                            );
                        }
                        function xe(qe, ot) {
                            var ke = [];
                            return (
                                this.each(function (Ce, Pe) {
                                    qe.call(ot, Ce, Pe, this) && ke.push(Ce);
                                }, this),
                                ke
                            );
                        }
                        function b(qe) {
                            if ($(this.indexOf) && -1 != this.indexOf(qe)) return !0;
                            var ot = !1;
                            return (
                                this.each(function (ke) {
                                    if (ke == qe) throw ((ot = !0), U);
                                }),
                                ot
                            );
                        }
                        function Sn() {
                            return this.map();
                        }
                        return {
                            each: function N(qe, ot) {
                                try {
                                    this._each(qe, ot);
                                } catch (ke) {
                                    if (ke != U) throw ke;
                                }
                                return this;
                            },
                            eachSlice: function K(qe, ot, ke) {
                                var Ce = -qe,
                                    Pe = [],
                                    _t = this.toArray();
                                if (qe < 1) return _t;
                                for (; (Ce += qe) < _t.length; ) Pe.push(_t.slice(Ce, Ce + qe));
                                return Pe.collect(ot, ke);
                            },
                            all: Q,
                            every: Q,
                            any: ce,
                            some: ce,
                            collect: ge,
                            map: ge,
                            detect: De,
                            findAll: xe,
                            select: xe,
                            filter: xe,
                            grep: function Ve(qe, ot, ke) {
                                ot = ot || x;
                                var Ce = [];
                                return (
                                    ae.PrototypeAPI.isString(qe) && (qe = new RegExp(RegExp.escape(qe))),
                                    this.each(function (Pe, _t) {
                                        qe.match(Pe) && Ce.push(ot.call(ke, Pe, _t, this));
                                    }, this),
                                    Ce
                                );
                            },
                            include: b,
                            member: b,
                            inGroupsOf: function je(qe, ot) {
                                return (
                                    (ot = Object.isUndefined(ot) ? null : ot),
                                    this.eachSlice(qe, function (ke) {
                                        for (; ke.length < qe; ) ke.push(ot);
                                        return ke;
                                    })
                                );
                            },
                            inject: function Ne(qe, ot, ke) {
                                return (
                                    this.each(function (Ce, Pe) {
                                        qe = ot.call(ke, qe, Ce, Pe, this);
                                    }, this),
                                    qe
                                );
                            },
                            invoke: function at(qe) {
                                var ot = O(arguments).slice(1);
                                return this.map(function (ke) {
                                    return ke[qe].apply(ke, ot);
                                });
                            },
                            max: function Et(qe, ot) {
                                var ke;
                                return (
                                    (qe = qe || x),
                                    this.each(function (Ce, Pe) {
                                        (Ce = qe.call(ot, Ce, Pe, this)), (null == ke || Ce >= ke) && (ke = Ce);
                                    }, this),
                                    ke
                                );
                            },
                            min: function ht(qe, ot) {
                                var ke;
                                return (
                                    (qe = qe || x),
                                    this.each(function (Ce, Pe) {
                                        (Ce = qe.call(ot, Ce, Pe, this)), (null == ke || Ce < ke) && (ke = Ce);
                                    }, this),
                                    ke
                                );
                            },
                            partition: function Re(qe, ot) {
                                qe = qe || x;
                                var ke = [],
                                    Ce = [];
                                return (
                                    this.each(function (Pe, _t) {
                                        (qe.call(ot, Pe, _t, this) ? ke : Ce).push(Pe);
                                    }, this),
                                    [ke, Ce]
                                );
                            },
                            pluck: function Pt(qe) {
                                var ot = [];
                                return (
                                    this.each(function (ke) {
                                        ot.push(ke[qe]);
                                    }),
                                    ot
                                );
                            },
                            reject: function Gt(qe, ot) {
                                var ke = [];
                                return (
                                    this.each(function (Ce, Pe) {
                                        qe.call(ot, Ce, Pe, this) || ke.push(Ce);
                                    }, this),
                                    ke
                                );
                            },
                            sortBy: function ur(qe, ot) {
                                return this.map(function (ke, Ce) {
                                    return { value: ke, criteria: qe.call(ot, ke, Ce, this) };
                                }, this)
                                    .sort(function (ke, Ce) {
                                        var Pe = ke.criteria,
                                            _t = Ce.criteria;
                                        return Pe < _t ? -1 : Pe > _t ? 1 : 0;
                                    })
                                    .pluck('value');
                            },
                            toArray: Sn,
                            entries: Sn,
                            zip: function qt() {
                                var qe = O(arguments),
                                    ot = [this].concat(qe).map(O);
                                return this.map(function (ke, Ce) {
                                    for (var Pe = [], _t = 0, Ht = ot.length; _t < Ht; ++_t) Pe.push(ot[_t][Ce]);
                                    return Pe;
                                });
                            },
                            size: function Vt() {
                                return this.toArray().length;
                            },
                            inspect: function an() {
                                return '#<Enumerable:' + this.toArray().inspect() + '>';
                            },
                            find: De,
                        };
                    })();
                function R(N) {
                    return N.replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }
                var j = {
                    setOpacity: function (N, K) {
                        return 1 == K || '' === K ? (K = '') : K < 1e-5 && (K = 0), ((N = M(N)).style.opacity = K), N;
                    },
                    setStyle: function (N, K) {
                        var Q = (N = M(N)).style;
                        if (ae.PrototypeAPI.isString(K)) {
                            if (((Q.cssText += ';' + K), K.include('opacity'))) {
                                var ge = K.match(/opacity:\s*(\d?\.?\d*)/)[1];
                                ae.PrototypeAPI.setOpacity(N, ge);
                            }
                            return N;
                        }
                        for (var De in K)
                            if ('opacity' === De) ae.PrototypeAPI.setOpacity(N, K[De]);
                            else {
                                var xe = K[De];
                                ('float' === De || 'cssFloat' === De) &&
                                    (De = void 0 === Q.styleFloat ? 'cssFloat' : 'styleFloat'),
                                    (Q[De] = xe);
                            }
                        return N;
                    },
                    getStyle: function (N, K) {
                        var Q = (N = M(N)).style[K];
                        if (!Q || 'auto' === Q) {
                            var ce = document.defaultView.getComputedStyle(N, null);
                            Q = ce ? ce[K] : null;
                        }
                        return 'opacity' === K ? (Q ? parseFloat(Q) : 1) : 'auto' === Q ? null : Q;
                    },
                    makePositioned: function (N) {
                        N = M(N);
                        var K = ae.PrototypeAPI.getStyle(N, 'position'),
                            Q = {};
                        return (
                            ('static' === K || !K) &&
                                ((Q.position = 'relative'),
                                ae.PrototypeAPI.Browser.Opera && ((Q.top = 0), (Q.left = 0)),
                                ae.PrototypeAPI.setStyle(N, Q),
                                (N.dataset.prototypeMadePositioned = '')),
                            N
                        );
                    },
                    undoPositioned: function (N) {
                        return (
                            'prototypeMadePositioned' in (N = M(N)).dataset &&
                                (delete N.dataset.prototypeMadePositioned,
                                ae.PrototypeAPI.setStyle(N, {
                                    position: '',
                                    top: '',
                                    bottom: '',
                                    left: '',
                                    right: '',
                                })),
                            N
                        );
                    },
                };
                return {
                    $: M,
                    Class: F,
                    Enumerable: C,
                    isString: function v(N) {
                        return '[object String]' === q.call(N);
                    },
                    isArray: function p(N) {
                        return '[object Array]' === q.call(N);
                    },
                    Browser: G,
                    parseQuery: function k(N) {
                        var Q = N.trim().match(/([^?#]*)(#.*)?$/);
                        if (!Q) return {};
                        for (var ce = Q[1].split('&'), De = 0, xe = ce.length; De < xe; ++De) {
                            var Ve = ce[De];
                            if ((Ve = Ve.split('='))[0]) {
                                var b = decodeURIComponent(Ve.shift()),
                                    je = Ve.length > 1 ? Ve.join('=') : Ve[0];
                                null != je && ((je = je.gsub('+', ' ')), (je = decodeURIComponent(je))),
                                    b in hash
                                        ? (this.isArray(hash[b]) || (hash[b] = [hash[b]]), hash[b].push(je))
                                        : (hash[b] = je);
                            }
                        }
                        return {};
                    },
                    escapeHTML: R,
                    escapeAttribute: R,
                    getStyle: j.getStyle,
                    setStyle: j.setStyle,
                    makePositioned: j.makePositioned,
                    undoPositioned: j.undoPositioned,
                    $A: O,
                };
            })()),
                (se.exports = ae.PrototypeAPI);
        },
        3510: se => {
            if (typeof ae > 'u') var ae = {};
            se.exports = function U(O, M) {
                'use strict';
                M.RecordDataRequester = M.PrototypeAPI.Class.create();
                var G = {
                    formField_: null,
                    codeField_: null,
                    dataURL_: null,
                    dataReqInput_: null,
                    dataReqOutput_: null,
                    inputFieldsHash_: null,
                    outputFieldsHash_: null,
                    noPriorDataReq_: !0,
                    latestPendingAjaxRequest_: null,
                    lastFieldVal_: null,
                    lastDataHash_: null,
                    outputToSameGroup_: null,
                    autoCompUpdateList_: null,
                    initialize: function ($, v, p, _, T) {
                        (this.formField_ = $),
                            (this.dataURL_ = v),
                            (this.dataReqInput_ = p),
                            (this.dataReqOutput_ = _),
                            (this.outputToSameGroup_ = T),
                            this.setOutputNamesToRDRNames($, _);
                    },
                    setOutputNamesToRDRNames: function ($, v) {
                        for (
                            var p = M.Autocompleter.getFieldLookupKey($),
                                _ = M.RecordDataRequester.outputFieldNameToRDRFieldName_,
                                T = 0,
                                x = v.length;
                            T < x;
                            ++T
                        )
                            _[v[T]] = p;
                    },
                    dupForField: function ($) {
                        return new M.RecordDataRequester(
                            O($),
                            this.dataURL_,
                            this.dataReqInput_,
                            this.dataReqOutput_,
                            this.outputToSameGroup_,
                        );
                    },
                    requestData: function ($) {
                        (this.noPriorDataReq_ = !1),
                            this.inputFieldsHash_ || this.initFieldsHash(),
                            this.dataRequestOptions_ || (this.dataRequestOptions_ = {}),
                            $ || this.clearDataOutputFields(),
                            (this.dataRequestOptions_.complete = $
                                ? this.onDataReqCompleteForListData.bind(this)
                                : this.onDataReqComplete.bind(this)),
                            (this.dataRequestOptions_.data = this.buildParameters()),
                            (this.latestPendingAjaxRequest_ = M.jqueryLite.ajax(
                                this.dataURL_,
                                this.dataRequestOptions_,
                            )),
                            (this.lastFieldVal_ = M.Autocompleter.getFieldVal(this.formField_));
                    },
                    assignListData: function () {
                        this.noPriorDataReq_ &&
                            '' !== M.Autocompleter.getFieldVal(this.formField_) &&
                            this.requestData(!0);
                    },
                    getFieldData: function ($) {
                        var v = null;
                        return (
                            this.lastDataHash_ &&
                                M.Autocompleter.getFieldVal(this.formField_) === this.lastFieldVal_ &&
                                (v = this.lastDataHash_[$]),
                            v
                        );
                    },
                    onDataReqComplete: function ($) {
                        if (this.latestPendingAjaxRequest_ === $) {
                            this.lastFieldVal_ = M.Autocompleter.getFieldVal(this.formField_);
                            var v = $.responseJSON || JSON.parse($.responseText);
                            (this.lastDataHash_ = v),
                                this.assignDataToFields(v),
                                this.processUpdateList(v),
                                (this.latestPendingAjaxRequest_ = null);
                        }
                    },
                    onDataReqCompleteForListData: function ($) {
                        if (this.latestPendingAjaxRequest_ === $) {
                            var v = $.responseJSON || JSON.parse($.responseText);
                            (this.lastDataHash_ = v),
                                this.assignDataToFields(v, !0),
                                this.processUpdateList(v),
                                (this.latestPendingAjaxRequest_ = null);
                        }
                    },
                    clearDataOutputFields: function () {
                        this.inputFieldsHash_ || this.initFieldsHash();
                        for (
                            var $ = [], v = this.getOutputFieldsHash(), p = 0, _ = this.dataReqOutput_.length;
                            p < _;
                            ++p
                        ) {
                            var T = v[this.dataReqOutput_[p]];
                            if (void 0 !== T)
                                for (var x = 0, F = T.length; x < F; ++x) {
                                    var C = T[x];
                                    C.autocomp && C.autocomp.setListAndField
                                        ? C.autocomp.setListAndField([])
                                        : (M.Autocompleter.setFieldVal(C, '', !1), $.push(C));
                                }
                        }
                        M.Autocompleter.Event.notifyObservers(null, 'RDR_CLEARING', $);
                    },
                    addFieldsToUpdateList: function ($, v, p) {
                        null === this.autoCompUpdateList_ && (this.autoCompUpdateList_ = {}),
                            null === this.autoCompUpdateList_[$] && (this.autoCompUpdateList_[$] = {}),
                            null === this.autoCompUpdateList_[$][p]
                                ? (this.autoCompUpdateList_[$][p] = [v])
                                : this.autoCompUpdateList_[$][p].push(v);
                    },
                    processUpdateList: function ($) {
                        if (null !== this.autoCompUpdateList_)
                            for (var v in $) {
                                var p = $[v],
                                    _ = p instanceof Array && p.length > 0;
                                if (null !== this.autoCompUpdateList_[v])
                                    for (var T in this.autoCompUpdateList_[v]) {
                                        var x = T.split(','),
                                            F = O(x[0]),
                                            C = M.Autocompleter.getFieldVal(F);
                                        if (('EQ' === x[1] && C === x[2]) || ('NE' === x[1] && C !== x[2]))
                                            for (
                                                var k = this.autoCompUpdateList_[v][T], R = 0, j = k.length;
                                                R < j;
                                                R++
                                            )
                                                k[R].element &&
                                                    (_
                                                        ? p[0] instanceof Array
                                                            ? k[R].setListAndField(p[0], p[1])
                                                            : k[R].setListAndField(p)
                                                        : null === p && k[R].setListAndField([], []));
                                    }
                            }
                    },
                    initFieldsHash: function () {
                        this.inputFieldsHash_ = {};
                        var $ = M.Autocompleter;
                        if (this.dataReqInput_)
                            for (var v = this.dataReqInput_, p = 0, _ = v.length; p < _; ++p) {
                                var T = v[p],
                                    x = $.findRelatedFields(this.formField_, T);
                                1 === x.length && (this.inputFieldsHash_[T] = x[0]);
                            }
                        this.outputToSameGroup_ && (this.outputFieldsHash_ = this.constructOutputFieldsHash());
                    },
                    getOutputFieldsHash: function () {
                        return this.outputToSameGroup_ ? this.outputFieldsHash_ : this.constructOutputFieldsHash();
                    },
                    constructOutputFieldsHash: function () {
                        for (
                            var $ = {}, v = this.dataReqOutput_, p = M.Autocompleter, _ = 0, T = v.length;
                            _ < T;
                            ++_
                        ) {
                            var x = v[_],
                                F = p.findRelatedFields(this.formField_, x);
                            F.length > 0 && ($[x] = F);
                        }
                        return $;
                    },
                    assignDataToFields: function ($, v) {
                        this.inputFieldsHash_ || this.initFieldsHash();
                        var p = [],
                            _ = {},
                            T = this.getOutputFieldsHash(),
                            x = M.Autocompleter;
                        for (var F in $) {
                            var C = T[F];
                            if (void 0 !== C)
                                for (var k = 0, R = C.length; k < R; ++k) {
                                    var j = C[k],
                                        N = $[F];
                                    if (Array.isArray(N)) {
                                        if (null !== j.autocomp) {
                                            var K = x.getFieldLookupKey(j);
                                            if (
                                                (this.setOutputNamesToRDRNames(this.formField_, [K]),
                                                N.length > 0 && Array.isArray(N[0])
                                                    ? (N[2] && j.autocomp.initHeadings(N[2]),
                                                      v
                                                          ? j.autocomp.setList(N[0], N[1])
                                                          : j.autocomp.setListAndField(N[0], N[1]))
                                                    : v
                                                    ? j.autocomp.setList(N)
                                                    : j.autocomp.setListAndField(N),
                                                null !== this.autoCompUpdateList_ &&
                                                    null !== this.autoCompUpdateList_[K])
                                            ) {
                                                var Q = {};
                                                (Q[K] = N), this.processUpdateList(Q);
                                            }
                                        }
                                    } else
                                        v ||
                                            (void 0 !== j.comboField
                                                ? j.comboField.mimicField(N, this.formField_.id)
                                                : (M.Autocompleter.setFieldVal(j, N, !1), p.push(j), (_[j.id] = N)));
                                }
                        }
                        M.Autocompleter.Event.notifyObservers(null, 'RDR_ASSIGNMENT', {
                            updatedFields: p,
                            updatedFieldIDToVal: _,
                            listField: this.formField_,
                        });
                    },
                    buildParameters: function () {
                        var $ = {};
                        this.inputFieldsHash_ || this.initFieldsHash();
                        var v = this.formField_.autocomp.getSelectedCodes()[0];
                        if (
                            (null != v
                                ? ($.code_val = v)
                                : ($.field_val = M.Autocompleter.getFieldVal(this.formField_)),
                            this.dataReqInput_)
                        )
                            for (var p = 0, _ = this.dataReqInput_.length; p < _; ++p) {
                                var T = this.dataReqInput_[p],
                                    x = this.inputFieldsHash_[T];
                                if (null == x) throw 'Could not find field for ' + T;
                                $[T] = M.Autocompleter.getFieldVal(x);
                            }
                        return ($.authenticity_token = window._token || ''), $;
                    },
                };
                Object.assign(M.RecordDataRequester.prototype, G),
                    (G = null),
                    Object.assign(M.RecordDataRequester, {
                        outputFieldNameToRDRFieldName_: {},
                        getOutputFieldRDR: function ($) {
                            var v = null,
                                p = O($),
                                _ = M.Autocompleter.getFieldLookupKey(p),
                                x = M.Autocompleter.findRelatedFields(p, this.outputFieldNameToRDRFieldName_[_]);
                            if (1 === x.length) {
                                var C = x[0].autocomp;
                                C && (v = C.recDataRequester_);
                            }
                            return v;
                        },
                    });
            };
        },
        3620: se => {
            se.exports = function ae(U) {
                'use strict';
                (U.ScreenReaderLog = function (O) {
                    if (void 0 === O) {
                        for (var M = 'reader_log', q = ((O = M), 1); document.getElementById(O); ) O = M + ++q;
                        (this.logElement_ = document.createElement('div')),
                            this.logElement_.setAttribute('id', O),
                            document.body.appendChild(this.logElement_);
                    } else this.logElement_ = document.getElementById(O);
                    this.logElement_.setAttribute('aria-live', 'assertive'),
                        this.logElement_.setAttribute('aria-relevant', 'additions'),
                        this.logElement_.setAttribute('role', 'log'),
                        this.logElement_.setAttribute('class', 'screen_reader_only');
                }),
                    (U.ScreenReaderLog.prototype = {
                        add: function (O) {
                            var M = document.createElement('p');
                            M.appendChild(document.createTextNode(O)), this.logElement_.appendChild(M);
                        },
                    }),
                    (U.ScreenReaderLog.add = function (O) {
                        this.log_ || (this.log_ = new U.ScreenReaderLog('reader_log')), this.log_.add(O);
                    });
            };
        },
        3463: (se, ae, U) => {
            'use strict';
            var O = U(2521),
                M = U(6283),
                q = M(O('String.prototype.indexOf'));
            se.exports = function ($, v) {
                var p = O($, !!v);
                return 'function' == typeof p && q($, '.prototype.') > -1 ? M(p) : p;
            };
        },
        6283: (se, ae, U) => {
            'use strict';
            var O = U(7707),
                M = U(2521),
                q = U(5557),
                G = U(8519),
                $ = M('%Function.prototype.apply%'),
                v = M('%Function.prototype.call%'),
                p = M('%Reflect.apply%', !0) || O.call(v, $),
                _ = U(1963),
                T = M('%Math.max%');
            se.exports = function (C) {
                if ('function' != typeof C) throw new G('a function is required');
                var k = p(O, v, arguments);
                return q(k, 1 + T(0, C.length - (arguments.length - 1)), !0);
            };
            var x = function () {
                return p(O, $, arguments);
            };
            _ ? _(se.exports, 'apply', { value: x }) : (se.exports.apply = x);
        },
        9250: (se, ae, U) => {
            'use strict';
            var O = U(6969),
                M = U(3463),
                q = U(7057),
                G = U(2521),
                $ = U(158),
                v = U(5492),
                p = U(545),
                _ = U(8344),
                T = U(7638),
                x = U(3066),
                F = U(5500),
                C = U(5831),
                k = U(2090),
                R = U(9209),
                j = U(6959),
                N = U(5757),
                K = U(6547),
                Q = U(2219),
                ce = M('SharedArrayBuffer.prototype.byteLength', !0),
                ge = M('Date.prototype.getTime'),
                De = Object.getPrototypeOf,
                xe = M('Object.prototype.toString'),
                Ve = G('%Set%', !0),
                b = M('Map.prototype.has', !0),
                je = M('Map.prototype.get', !0),
                Ne = M('Map.prototype.size', !0),
                at = M('Set.prototype.add', !0),
                Et = M('Set.prototype.delete', !0),
                ht = M('Set.prototype.has', !0),
                Re = M('Set.prototype.size', !0);
            function Pt(Ce, Pe, _t, Ht) {
                for (var _n, Qt = $(Ce); (_n = Qt.next()) && !_n.done; )
                    if (Vt(Pe, _n.value, _t, Ht)) return Et(Ce, _n.value), !0;
                return !1;
            }
            function Gt(Ce) {
                return typeof Ce > 'u'
                    ? null
                    : 'object' != typeof Ce
                    ? 'symbol' != typeof Ce && (('string' != typeof Ce && 'number' != typeof Ce) || +Ce == +Ce)
                    : void 0;
            }
            function ur(Ce, Pe, _t, Ht, Qt, _n) {
                var sn = Gt(_t);
                if (null != sn) return sn;
                var xn = je(Pe, sn),
                    et = O({}, Qt, { strict: !1 });
                return !((typeof xn > 'u' && !b(Pe, sn)) || !Vt(Ht, xn, et, _n)) && !b(Ce, sn) && Vt(Ht, xn, et, _n);
            }
            function Sn(Ce, Pe, _t) {
                var Ht = Gt(_t);
                return Ht ?? (ht(Pe, Ht) && !ht(Ce, Ht));
            }
            function qt(Ce, Pe, _t, Ht, Qt, _n) {
                for (var xn, et, sn = $(Ce); (xn = sn.next()) && !xn.done; )
                    if (Vt(_t, (et = xn.value), Qt, _n) && Vt(Ht, je(Pe, et), Qt, _n)) return Et(Ce, et), !0;
                return !1;
            }
            function Vt(Ce, Pe, _t, Ht) {
                var Qt = _t || {};
                if (Qt.strict ? p(Ce, Pe) : Ce === Pe) return !0;
                if (j(Ce) !== j(Pe)) return !1;
                if (!Ce || !Pe || ('object' != typeof Ce && 'object' != typeof Pe))
                    return Qt.strict ? p(Ce, Pe) : Ce == Pe;
                var qn,
                    xn = Ht.has(Ce),
                    et = Ht.has(Pe);
                if (xn && et) {
                    if (Ht.get(Ce) === Ht.get(Pe)) return !0;
                } else qn = {};
                return (
                    xn || Ht.set(Ce, qn),
                    et || Ht.set(Pe, qn),
                    (function ke(Ce, Pe, _t, Ht) {
                        var Qt, _n;
                        if (typeof Ce != typeof Pe || null == Ce || null == Pe || xe(Ce) !== xe(Pe) || _(Ce) !== _(Pe))
                            return !1;
                        if (T(Ce) !== T(Pe)) return !1;
                        var et = Ce instanceof Error,
                            qn = Pe instanceof Error;
                        if (et !== qn || ((et || qn) && (Ce.name !== Pe.name || Ce.message !== Pe.message))) return !1;
                        var Ji = C(Ce),
                            Ti = C(Pe);
                        if (Ji !== Ti || ((Ji || Ti) && (Ce.source !== Pe.source || q(Ce) !== q(Pe)))) return !1;
                        var ii = F(Ce),
                            Vs = F(Pe);
                        if (ii !== Vs || ((ii || Vs) && ge(Ce) !== ge(Pe)) || (_t.strict && De && De(Ce) !== De(Pe)))
                            return !1;
                        var rr = K(Ce),
                            Ri = K(Pe);
                        if (rr !== Ri) return !1;
                        if (rr || Ri) {
                            if (Ce.length !== Pe.length) return !1;
                            for (Qt = 0; Qt < Ce.length; Qt++) if (Ce[Qt] !== Pe[Qt]) return !1;
                            return !0;
                        }
                        var Oi = an(Ce),
                            Hs = an(Pe);
                        if (Oi !== Hs) return !1;
                        if (Oi || Hs) {
                            if (Ce.length !== Pe.length) return !1;
                            for (Qt = 0; Qt < Ce.length; Qt++) if (Ce[Qt] !== Pe[Qt]) return !1;
                            return !0;
                        }
                        var pr = x(Ce),
                            Kn = x(Pe);
                        if (pr !== Kn) return !1;
                        if (pr || Kn)
                            return (
                                Q(Ce) === Q(Pe) &&
                                'function' == typeof Uint8Array &&
                                Vt(new Uint8Array(Ce), new Uint8Array(Pe), _t, Ht)
                            );
                        var Us = k(Ce),
                            ft = k(Pe);
                        if (Us !== ft) return !1;
                        if (Us || ft)
                            return (
                                ce(Ce) === ce(Pe) &&
                                'function' == typeof Uint8Array &&
                                Vt(new Uint8Array(Ce), new Uint8Array(Pe), _t, Ht)
                            );
                        if (typeof Ce != typeof Pe) return !1;
                        var gn = R(Ce),
                            Ut = R(Pe);
                        if (gn.length !== Ut.length) return !1;
                        for (gn.sort(), Ut.sort(), Qt = gn.length - 1; Qt >= 0; Qt--) if (gn[Qt] != Ut[Qt]) return !1;
                        for (Qt = gn.length - 1; Qt >= 0; Qt--) if (!Vt(Ce[(_n = gn[Qt])], Pe[_n], _t, Ht)) return !1;
                        var sr = N(Ce),
                            Es = N(Pe);
                        return (
                            sr === Es &&
                            ('Set' === sr || 'Set' === Es
                                ? (function qe(Ce, Pe, _t, Ht) {
                                      if (Re(Ce) !== Re(Pe)) return !1;
                                      for (var sn, xn, et, Qt = $(Ce), _n = $(Pe); (sn = Qt.next()) && !sn.done; )
                                          if (sn.value && 'object' == typeof sn.value)
                                              et || (et = new Ve()), at(et, sn.value);
                                          else if (!ht(Pe, sn.value)) {
                                              if (_t.strict || !Sn(Ce, Pe, sn.value)) return !1;
                                              et || (et = new Ve()), at(et, sn.value);
                                          }
                                      if (et) {
                                          for (; (xn = _n.next()) && !xn.done; )
                                              if (xn.value && 'object' == typeof xn.value) {
                                                  if (!Pt(et, xn.value, _t.strict, Ht)) return !1;
                                              } else if (
                                                  !_t.strict &&
                                                  !ht(Ce, xn.value) &&
                                                  !Pt(et, xn.value, _t.strict, Ht)
                                              )
                                                  return !1;
                                          return 0 === Re(et);
                                      }
                                      return !0;
                                  })(Ce, Pe, _t, Ht)
                                : 'Map' !== sr ||
                                  (function ot(Ce, Pe, _t, Ht) {
                                      if (Ne(Ce) !== Ne(Pe)) return !1;
                                      for (
                                          var sn, xn, et, qn, Ji, Ti, Qt = $(Ce), _n = $(Pe);
                                          (sn = Qt.next()) && !sn.done;

                                      )
                                          if (((Ji = sn.value[1]), (qn = sn.value[0]) && 'object' == typeof qn))
                                              et || (et = new Ve()), at(et, qn);
                                          else if (
                                              (typeof (Ti = je(Pe, qn)) > 'u' && !b(Pe, qn)) ||
                                              !Vt(Ji, Ti, _t, Ht)
                                          ) {
                                              if (_t.strict || !ur(Ce, Pe, qn, Ji, _t, Ht)) return !1;
                                              et || (et = new Ve()), at(et, qn);
                                          }
                                      if (et) {
                                          for (; (xn = _n.next()) && !xn.done; )
                                              if (((Ti = xn.value[1]), (qn = xn.value[0]) && 'object' == typeof qn)) {
                                                  if (!qt(et, Ce, qn, Ti, _t, Ht)) return !1;
                                              } else if (
                                                  !(
                                                      _t.strict ||
                                                      (Ce.has(qn) && Vt(je(Ce, qn), Ti, _t, Ht)) ||
                                                      qt(et, Ce, qn, Ti, O({}, _t, { strict: !1 }), Ht)
                                                  )
                                              )
                                                  return !1;
                                          return 0 === Re(et);
                                      }
                                      return !0;
                                  })(Ce, Pe, _t, Ht))
                        );
                    })(Ce, Pe, Qt, Ht)
                );
            }
            function an(Ce) {
                return !(
                    !Ce ||
                    'object' != typeof Ce ||
                    'number' != typeof Ce.length ||
                    'function' != typeof Ce.copy ||
                    'function' != typeof Ce.slice ||
                    (Ce.length > 0 && 'number' != typeof Ce[0]) ||
                    !(Ce.constructor && Ce.constructor.isBuffer && Ce.constructor.isBuffer(Ce))
                );
            }
            se.exports = function (Pe, _t, Ht) {
                return Vt(Pe, _t, Ht, v());
            };
        },
        1197: (se, ae, U) => {
            'use strict';
            var O = U(1963),
                M = U(4880),
                q = U(8519),
                G = U(9263);
            se.exports = function (v, p, _) {
                if (!v || ('object' != typeof v && 'function' != typeof v))
                    throw new q('`obj` must be an object or a function`');
                if ('string' != typeof p && 'symbol' != typeof p)
                    throw new q('`property` must be a string or a symbol`');
                if (arguments.length > 3 && 'boolean' != typeof arguments[3] && null !== arguments[3])
                    throw new q('`nonEnumerable`, if provided, must be a boolean or null');
                if (arguments.length > 4 && 'boolean' != typeof arguments[4] && null !== arguments[4])
                    throw new q('`nonWritable`, if provided, must be a boolean or null');
                if (arguments.length > 5 && 'boolean' != typeof arguments[5] && null !== arguments[5])
                    throw new q('`nonConfigurable`, if provided, must be a boolean or null');
                if (arguments.length > 6 && 'boolean' != typeof arguments[6])
                    throw new q('`loose`, if provided, must be a boolean');
                var T = arguments.length > 3 ? arguments[3] : null,
                    x = arguments.length > 4 ? arguments[4] : null,
                    F = arguments.length > 5 ? arguments[5] : null,
                    C = arguments.length > 6 && arguments[6],
                    k = !!G && G(v, p);
                if (O)
                    O(v, p, {
                        configurable: null === F && k ? k.configurable : !F,
                        enumerable: null === T && k ? k.enumerable : !T,
                        value: _,
                        writable: null === x && k ? k.writable : !x,
                    });
                else {
                    if (!C && (T || x || F))
                        throw new M(
                            'This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.',
                        );
                    v[p] = _;
                }
            };
        },
        592: (se, ae, U) => {
            'use strict';
            var O = U(9209),
                M = 'function' == typeof Symbol && 'symbol' == typeof Symbol('foo'),
                q = Object.prototype.toString,
                G = Array.prototype.concat,
                $ = U(1197),
                p = U(6652)(),
                _ = function (x, F, C, k) {
                    if (F in x)
                        if (!0 === k) {
                            if (x[F] === C) return;
                        } else if (
                            !(function (x) {
                                return 'function' == typeof x && '[object Function]' === q.call(x);
                            })(k) ||
                            !k()
                        )
                            return;
                    p ? $(x, F, C, !0) : $(x, F, C);
                },
                T = function (x, F) {
                    var C = arguments.length > 2 ? arguments[2] : {},
                        k = O(F);
                    M && (k = G.call(k, Object.getOwnPropertySymbols(F)));
                    for (var R = 0; R < k.length; R += 1) _(x, k[R], F[k[R]], C[k[R]]);
                };
            (T.supportsDescriptors = !!p), (se.exports = T);
        },
        1963: (se, ae, U) => {
            'use strict';
            var M = U(2521)('%Object.defineProperty%', !0) || !1;
            if (M)
                try {
                    M({}, 'a', { value: 1 });
                } catch {
                    M = !1;
                }
            se.exports = M;
        },
        2905: se => {
            'use strict';
            se.exports = EvalError;
        },
        1123: se => {
            'use strict';
            se.exports = Error;
        },
        7718: se => {
            'use strict';
            se.exports = RangeError;
        },
        3286: se => {
            'use strict';
            se.exports = ReferenceError;
        },
        4880: se => {
            'use strict';
            se.exports = SyntaxError;
        },
        8519: se => {
            'use strict';
            se.exports = TypeError;
        },
        2781: se => {
            'use strict';
            se.exports = URIError;
        },
        6062: (se, ae, U) => {
            'use strict';
            var O = U(7268),
                M = Object.prototype.toString,
                q = Object.prototype.hasOwnProperty;
            se.exports = function (T, x, F) {
                if (!O(x)) throw new TypeError('iterator must be a function');
                var C;
                arguments.length >= 3 && (C = F),
                    '[object Array]' === M.call(T)
                        ? (function (T, x, F) {
                              for (var C = 0, k = T.length; C < k; C++)
                                  q.call(T, C) && (null == F ? x(T[C], C, T) : x.call(F, T[C], C, T));
                          })(T, x, C)
                        : 'string' == typeof T
                        ? (function (T, x, F) {
                              for (var C = 0, k = T.length; C < k; C++)
                                  null == F ? x(T.charAt(C), C, T) : x.call(F, T.charAt(C), C, T);
                          })(T, x, C)
                        : (function (T, x, F) {
                              for (var C in T) q.call(T, C) && (null == F ? x(T[C], C, T) : x.call(F, T[C], C, T));
                          })(T, x, C);
            };
        },
        3933: se => {
            'use strict';
            var U = Object.prototype.toString,
                O = Math.max,
                q = function (p, _) {
                    for (var T = [], x = 0; x < p.length; x += 1) T[x] = p[x];
                    for (var F = 0; F < _.length; F += 1) T[F + p.length] = _[F];
                    return T;
                };
            se.exports = function (p) {
                var _ = this;
                if ('function' != typeof _ || '[object Function]' !== U.apply(_))
                    throw new TypeError('Function.prototype.bind called on incompatible ' + _);
                for (
                    var x,
                        T = (function (p, _) {
                            for (var T = [], x = 1, F = 0; x < p.length; x += 1, F += 1) T[F] = p[x];
                            return T;
                        })(arguments),
                        C = O(0, _.length - T.length),
                        k = [],
                        R = 0;
                    R < C;
                    R++
                )
                    k[R] = '$' + R;
                if (
                    ((x = Function(
                        'binder',
                        'return function (' +
                            (function (v, p) {
                                for (var _ = '', T = 0; T < v.length; T += 1)
                                    (_ += v[T]), T + 1 < v.length && (_ += ',');
                                return _;
                            })(k) +
                            '){ return binder.apply(this,arguments); }',
                    )(function () {
                        if (this instanceof x) {
                            var N = _.apply(this, q(T, arguments));
                            return Object(N) === N ? N : this;
                        }
                        return _.apply(p, q(T, arguments));
                    })),
                    _.prototype)
                ) {
                    var j = function () {};
                    (j.prototype = _.prototype), (x.prototype = new j()), (j.prototype = null);
                }
                return x;
            };
        },
        7707: (se, ae, U) => {
            'use strict';
            var O = U(3933);
            se.exports = Function.prototype.bind || O;
        },
        5370: se => {
            'use strict';
            var ae = function () {
                    return 'string' == typeof function () {}.name;
                },
                U = Object.getOwnPropertyDescriptor;
            if (U)
                try {
                    U([], 'length');
                } catch {
                    U = null;
                }
            ae.functionsHaveConfigurableNames = function () {
                if (!ae() || !U) return !1;
                var q = U(function () {}, 'name');
                return !!q && !!q.configurable;
            };
            var O = Function.prototype.bind;
            (ae.boundFunctionsHaveNames = function () {
                return ae() && 'function' == typeof O && '' !== function () {}.bind().name;
            }),
                (se.exports = ae);
        },
        2521: (se, ae, U) => {
            'use strict';
            var O,
                M = U(1123),
                q = U(2905),
                G = U(7718),
                $ = U(3286),
                v = U(4880),
                p = U(8519),
                _ = U(2781),
                T = Function,
                x = function (Sn) {
                    try {
                        return T('"use strict"; return (' + Sn + ').constructor;')();
                    } catch {}
                },
                F = Object.getOwnPropertyDescriptor;
            if (F)
                try {
                    F({}, '');
                } catch {
                    F = null;
                }
            var C = function () {
                    throw new p();
                },
                k = F
                    ? (function () {
                          try {
                              return C;
                          } catch {
                              try {
                                  return F(arguments, 'callee').get;
                              } catch {
                                  return C;
                              }
                          }
                      })()
                    : C,
                R = U(1459)(),
                j = U(5860)(),
                N =
                    Object.getPrototypeOf ||
                    (j
                        ? function (Sn) {
                              return Sn.__proto__;
                          }
                        : null),
                K = {},
                Q = typeof Uint8Array > 'u' || !N ? O : N(Uint8Array),
                ce = {
                    __proto__: null,
                    '%AggregateError%': typeof AggregateError > 'u' ? O : AggregateError,
                    '%Array%': Array,
                    '%ArrayBuffer%': typeof ArrayBuffer > 'u' ? O : ArrayBuffer,
                    '%ArrayIteratorPrototype%': R && N ? N([][Symbol.iterator]()) : O,
                    '%AsyncFromSyncIteratorPrototype%': O,
                    '%AsyncFunction%': K,
                    '%AsyncGenerator%': K,
                    '%AsyncGeneratorFunction%': K,
                    '%AsyncIteratorPrototype%': K,
                    '%Atomics%': typeof Atomics > 'u' ? O : Atomics,
                    '%BigInt%': typeof BigInt > 'u' ? O : BigInt,
                    '%BigInt64Array%': typeof BigInt64Array > 'u' ? O : BigInt64Array,
                    '%BigUint64Array%': typeof BigUint64Array > 'u' ? O : BigUint64Array,
                    '%Boolean%': Boolean,
                    '%DataView%': typeof DataView > 'u' ? O : DataView,
                    '%Date%': Date,
                    '%decodeURI%': decodeURI,
                    '%decodeURIComponent%': decodeURIComponent,
                    '%encodeURI%': encodeURI,
                    '%encodeURIComponent%': encodeURIComponent,
                    '%Error%': M,
                    '%eval%': eval,
                    '%EvalError%': q,
                    '%Float32Array%': typeof Float32Array > 'u' ? O : Float32Array,
                    '%Float64Array%': typeof Float64Array > 'u' ? O : Float64Array,
                    '%FinalizationRegistry%': typeof FinalizationRegistry > 'u' ? O : FinalizationRegistry,
                    '%Function%': T,
                    '%GeneratorFunction%': K,
                    '%Int8Array%': typeof Int8Array > 'u' ? O : Int8Array,
                    '%Int16Array%': typeof Int16Array > 'u' ? O : Int16Array,
                    '%Int32Array%': typeof Int32Array > 'u' ? O : Int32Array,
                    '%isFinite%': isFinite,
                    '%isNaN%': isNaN,
                    '%IteratorPrototype%': R && N ? N(N([][Symbol.iterator]())) : O,
                    '%JSON%': 'object' == typeof JSON ? JSON : O,
                    '%Map%': typeof Map > 'u' ? O : Map,
                    '%MapIteratorPrototype%': typeof Map > 'u' || !R || !N ? O : N(new Map()[Symbol.iterator]()),
                    '%Math%': Math,
                    '%Number%': Number,
                    '%Object%': Object,
                    '%parseFloat%': parseFloat,
                    '%parseInt%': parseInt,
                    '%Promise%': typeof Promise > 'u' ? O : Promise,
                    '%Proxy%': typeof Proxy > 'u' ? O : Proxy,
                    '%RangeError%': G,
                    '%ReferenceError%': $,
                    '%Reflect%': typeof Reflect > 'u' ? O : Reflect,
                    '%RegExp%': RegExp,
                    '%Set%': typeof Set > 'u' ? O : Set,
                    '%SetIteratorPrototype%': typeof Set > 'u' || !R || !N ? O : N(new Set()[Symbol.iterator]()),
                    '%SharedArrayBuffer%': typeof SharedArrayBuffer > 'u' ? O : SharedArrayBuffer,
                    '%String%': String,
                    '%StringIteratorPrototype%': R && N ? N(''[Symbol.iterator]()) : O,
                    '%Symbol%': R ? Symbol : O,
                    '%SyntaxError%': v,
                    '%ThrowTypeError%': k,
                    '%TypedArray%': Q,
                    '%TypeError%': p,
                    '%Uint8Array%': typeof Uint8Array > 'u' ? O : Uint8Array,
                    '%Uint8ClampedArray%': typeof Uint8ClampedArray > 'u' ? O : Uint8ClampedArray,
                    '%Uint16Array%': typeof Uint16Array > 'u' ? O : Uint16Array,
                    '%Uint32Array%': typeof Uint32Array > 'u' ? O : Uint32Array,
                    '%URIError%': _,
                    '%WeakMap%': typeof WeakMap > 'u' ? O : WeakMap,
                    '%WeakRef%': typeof WeakRef > 'u' ? O : WeakRef,
                    '%WeakSet%': typeof WeakSet > 'u' ? O : WeakSet,
                };
            if (N)
                try {
                    null.error;
                } catch (Sn) {
                    var ge = N(N(Sn));
                    ce['%Error.prototype%'] = ge;
                }
            var De = function Sn(qt) {
                    var Vt;
                    if ('%AsyncFunction%' === qt) Vt = x('async function () {}');
                    else if ('%GeneratorFunction%' === qt) Vt = x('function* () {}');
                    else if ('%AsyncGeneratorFunction%' === qt) Vt = x('async function* () {}');
                    else if ('%AsyncGenerator%' === qt) {
                        var an = Sn('%AsyncGeneratorFunction%');
                        an && (Vt = an.prototype);
                    } else if ('%AsyncIteratorPrototype%' === qt) {
                        var qe = Sn('%AsyncGenerator%');
                        qe && N && (Vt = N(qe.prototype));
                    }
                    return (ce[qt] = Vt), Vt;
                },
                xe = {
                    __proto__: null,
                    '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
                    '%ArrayPrototype%': ['Array', 'prototype'],
                    '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
                    '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
                    '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
                    '%ArrayProto_values%': ['Array', 'prototype', 'values'],
                    '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
                    '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
                    '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
                    '%BooleanPrototype%': ['Boolean', 'prototype'],
                    '%DataViewPrototype%': ['DataView', 'prototype'],
                    '%DatePrototype%': ['Date', 'prototype'],
                    '%ErrorPrototype%': ['Error', 'prototype'],
                    '%EvalErrorPrototype%': ['EvalError', 'prototype'],
                    '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
                    '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
                    '%FunctionPrototype%': ['Function', 'prototype'],
                    '%Generator%': ['GeneratorFunction', 'prototype'],
                    '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
                    '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
                    '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
                    '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
                    '%JSONParse%': ['JSON', 'parse'],
                    '%JSONStringify%': ['JSON', 'stringify'],
                    '%MapPrototype%': ['Map', 'prototype'],
                    '%NumberPrototype%': ['Number', 'prototype'],
                    '%ObjectPrototype%': ['Object', 'prototype'],
                    '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
                    '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
                    '%PromisePrototype%': ['Promise', 'prototype'],
                    '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
                    '%Promise_all%': ['Promise', 'all'],
                    '%Promise_reject%': ['Promise', 'reject'],
                    '%Promise_resolve%': ['Promise', 'resolve'],
                    '%RangeErrorPrototype%': ['RangeError', 'prototype'],
                    '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
                    '%RegExpPrototype%': ['RegExp', 'prototype'],
                    '%SetPrototype%': ['Set', 'prototype'],
                    '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
                    '%StringPrototype%': ['String', 'prototype'],
                    '%SymbolPrototype%': ['Symbol', 'prototype'],
                    '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
                    '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
                    '%TypeErrorPrototype%': ['TypeError', 'prototype'],
                    '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
                    '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
                    '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
                    '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
                    '%URIErrorPrototype%': ['URIError', 'prototype'],
                    '%WeakMapPrototype%': ['WeakMap', 'prototype'],
                    '%WeakSetPrototype%': ['WeakSet', 'prototype'],
                },
                Ve = U(7707),
                b = U(3889),
                je = Ve.call(Function.call, Array.prototype.concat),
                Ne = Ve.call(Function.apply, Array.prototype.splice),
                at = Ve.call(Function.call, String.prototype.replace),
                Et = Ve.call(Function.call, String.prototype.slice),
                ht = Ve.call(Function.call, RegExp.prototype.exec),
                Re =
                    /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
                Pt = /\\(\\)?/g,
                ur = function (qt, Vt) {
                    var qe,
                        an = qt;
                    if ((b(xe, an) && (an = '%' + (qe = xe[an])[0] + '%'), b(ce, an))) {
                        var ot = ce[an];
                        if ((ot === K && (ot = De(an)), typeof ot > 'u' && !Vt))
                            throw new p('intrinsic ' + qt + ' exists, but is not available. Please file an issue!');
                        return { alias: qe, name: an, value: ot };
                    }
                    throw new v('intrinsic ' + qt + ' does not exist!');
                };
            se.exports = function (qt, Vt) {
                if ('string' != typeof qt || 0 === qt.length) throw new p('intrinsic name must be a non-empty string');
                if (arguments.length > 1 && 'boolean' != typeof Vt)
                    throw new p('"allowMissing" argument must be a boolean');
                if (null === ht(/^%?[^%]*%?$/, qt))
                    throw new v('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
                var an = (function (qt) {
                        var Vt = Et(qt, 0, 1),
                            an = Et(qt, -1);
                        if ('%' === Vt && '%' !== an) throw new v('invalid intrinsic syntax, expected closing `%`');
                        if ('%' === an && '%' !== Vt) throw new v('invalid intrinsic syntax, expected opening `%`');
                        var qe = [];
                        return (
                            at(qt, Re, function (ot, ke, Ce, Pe) {
                                qe[qe.length] = Ce ? at(Pe, Pt, '$1') : ke || ot;
                            }),
                            qe
                        );
                    })(qt),
                    qe = an.length > 0 ? an[0] : '',
                    ot = ur('%' + qe + '%', Vt),
                    ke = ot.name,
                    Ce = ot.value,
                    Pe = !1,
                    _t = ot.alias;
                _t && ((qe = _t[0]), Ne(an, je([0, 1], _t)));
                for (var Ht = 1, Qt = !0; Ht < an.length; Ht += 1) {
                    var _n = an[Ht],
                        sn = Et(_n, 0, 1),
                        xn = Et(_n, -1);
                    if (('"' === sn || "'" === sn || '`' === sn || '"' === xn || "'" === xn || '`' === xn) && sn !== xn)
                        throw new v('property names with quotes must have matching quotes');
                    if ((('constructor' === _n || !Qt) && (Pe = !0), b(ce, (ke = '%' + (qe += '.' + _n) + '%'))))
                        Ce = ce[ke];
                    else if (null != Ce) {
                        if (!(_n in Ce)) {
                            if (!Vt)
                                throw new p('base intrinsic for ' + qt + ' exists, but the property is not available.');
                            return;
                        }
                        if (F && Ht + 1 >= an.length) {
                            var et = F(Ce, _n);
                            Ce = (Qt = !!et) && 'get' in et && !('originalValue' in et.get) ? et.get : Ce[_n];
                        } else (Qt = b(Ce, _n)), (Ce = Ce[_n]);
                        Qt && !Pe && (ce[ke] = Ce);
                    }
                }
                return Ce;
            };
        },
        9263: (se, ae, U) => {
            'use strict';
            var M = U(2521)('%Object.getOwnPropertyDescriptor%', !0);
            if (M)
                try {
                    M([], 'length');
                } catch {
                    M = null;
                }
            se.exports = M;
        },
        362: se => {
            'use strict';
            var ae = typeof BigInt < 'u' && BigInt;
            se.exports = function () {
                return (
                    'function' == typeof ae &&
                    'function' == typeof BigInt &&
                    'bigint' == typeof ae(42) &&
                    'bigint' == typeof BigInt(42)
                );
            };
        },
        6652: (se, ae, U) => {
            'use strict';
            var O = U(1963),
                M = function () {
                    return !!O;
                };
            (M.hasArrayLengthDefineBug = function () {
                if (!O) return null;
                try {
                    return 1 !== O([], 'length', { value: 1 }).length;
                } catch {
                    return !0;
                }
            }),
                (se.exports = M);
        },
        5860: se => {
            'use strict';
            var ae = { __proto__: null, foo: {} },
                U = Object;
            se.exports = function () {
                return { __proto__: ae }.foo === ae.foo && !(ae instanceof U);
            };
        },
        1459: (se, ae, U) => {
            'use strict';
            var O = typeof Symbol < 'u' && Symbol,
                M = U(6497);
            se.exports = function () {
                return (
                    'function' == typeof O &&
                    'function' == typeof Symbol &&
                    'symbol' == typeof O('foo') &&
                    'symbol' == typeof Symbol('bar') &&
                    M()
                );
            };
        },
        6497: se => {
            'use strict';
            se.exports = function () {
                if ('function' != typeof Symbol || 'function' != typeof Object.getOwnPropertySymbols) return !1;
                if ('symbol' == typeof Symbol.iterator) return !0;
                var U = {},
                    O = Symbol('test'),
                    M = Object(O);
                if (
                    'string' == typeof O ||
                    '[object Symbol]' !== Object.prototype.toString.call(O) ||
                    '[object Symbol]' !== Object.prototype.toString.call(M)
                )
                    return !1;
                for (O in ((U[O] = 42), U)) return !1;
                if (
                    ('function' == typeof Object.keys && 0 !== Object.keys(U).length) ||
                    ('function' == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(U).length)
                )
                    return !1;
                var G = Object.getOwnPropertySymbols(U);
                if (1 !== G.length || G[0] !== O || !Object.prototype.propertyIsEnumerable.call(U, O)) return !1;
                if ('function' == typeof Object.getOwnPropertyDescriptor) {
                    var $ = Object.getOwnPropertyDescriptor(U, O);
                    if (42 !== $.value || !0 !== $.enumerable) return !1;
                }
                return !0;
            };
        },
        5328: (se, ae, U) => {
            'use strict';
            var O = U(6497);
            se.exports = function () {
                return O() && !!Symbol.toStringTag;
            };
        },
        3889: (se, ae, U) => {
            'use strict';
            var O = Function.prototype.call,
                M = Object.prototype.hasOwnProperty,
                q = U(7707);
            se.exports = q.call(O, M);
        },
        4584: se => {
            var ae = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g,
                U = /\n/g,
                O = /^\s*/,
                M = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/,
                q = /^:\s*/,
                G = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/,
                $ = /^[;\s]*/,
                v = /^\s+|\s+$/g,
                x = '';
            function k(R) {
                return R ? R.replace(v, x) : x;
            }
            se.exports = function (R, j) {
                if ('string' != typeof R) throw new TypeError('First argument must be a string');
                if (!R) return [];
                j = j || {};
                var N = 1,
                    K = 1;
                function Q(ht) {
                    var Re = ht.match(U);
                    Re && (N += Re.length);
                    var Pt = ht.lastIndexOf('\n');
                    K = ~Pt ? ht.length - Pt : K + ht.length;
                }
                function ce() {
                    var ht = { line: N, column: K };
                    return function (Re) {
                        return (Re.position = new ge(ht)), b(), Re;
                    };
                }
                function ge(ht) {
                    (this.start = ht), (this.end = { line: N, column: K }), (this.source = j.source);
                }
                ge.prototype.content = R;
                var De = [];
                function xe(ht) {
                    var Re = new Error(j.source + ':' + N + ':' + K + ': ' + ht);
                    if (
                        ((Re.reason = ht),
                        (Re.filename = j.source),
                        (Re.line = N),
                        (Re.column = K),
                        (Re.source = R),
                        !j.silent)
                    )
                        throw Re;
                    De.push(Re);
                }
                function Ve(ht) {
                    var Re = ht.exec(R);
                    if (Re) {
                        var Pt = Re[0];
                        return Q(Pt), (R = R.slice(Pt.length)), Re;
                    }
                }
                function b() {
                    Ve(O);
                }
                function je(ht) {
                    var Re;
                    for (ht = ht || []; (Re = Ne()); ) !1 !== Re && ht.push(Re);
                    return ht;
                }
                function Ne() {
                    var ht = ce();
                    if ('/' == R.charAt(0) && '*' == R.charAt(1)) {
                        for (var Re = 2; x != R.charAt(Re) && ('*' != R.charAt(Re) || '/' != R.charAt(Re + 1)); ) ++Re;
                        if (x === R.charAt((Re += 2) - 1)) return xe('End of comment missing');
                        var Pt = R.slice(2, Re - 2);
                        return (K += 2), Q(Pt), (R = R.slice(Re)), (K += 2), ht({ type: 'comment', comment: Pt });
                    }
                }
                function at() {
                    var ht = ce(),
                        Re = Ve(M);
                    if (Re) {
                        if ((Ne(), !Ve(q))) return xe("property missing ':'");
                        var Pt = Ve(G),
                            Gt = ht({
                                type: 'declaration',
                                property: k(Re[0].replace(ae, x)),
                                value: Pt ? k(Pt[0].replace(ae, x)) : x,
                            });
                        return Ve($), Gt;
                    }
                }
                return (
                    b(),
                    (function Et() {
                        var Re,
                            ht = [];
                        for (je(ht); (Re = at()); ) !1 !== Re && (ht.push(Re), je(ht));
                        return ht;
                    })()
                );
            };
        },
        2179: (se, ae, U) => {
            'use strict';
            var O = U(3889),
                M = U(5492)(),
                q = U(8519),
                G = {
                    assert: function ($, v) {
                        if (!$ || ('object' != typeof $ && 'function' != typeof $)) throw new q('`O` is not an object');
                        if ('string' != typeof v) throw new q('`slot` must be a string');
                        if ((M.assert($), !G.has($, v))) throw new q('`' + v + '` is not present on `O`');
                    },
                    get: function ($, v) {
                        if (!$ || ('object' != typeof $ && 'function' != typeof $)) throw new q('`O` is not an object');
                        if ('string' != typeof v) throw new q('`slot` must be a string');
                        var p = M.get($);
                        return p && p['$' + v];
                    },
                    has: function ($, v) {
                        if (!$ || ('object' != typeof $ && 'function' != typeof $)) throw new q('`O` is not an object');
                        if ('string' != typeof v) throw new q('`slot` must be a string');
                        var p = M.get($);
                        return !!p && O(p, '$' + v);
                    },
                    set: function ($, v, p) {
                        if (!$ || ('object' != typeof $ && 'function' != typeof $)) throw new q('`O` is not an object');
                        if ('string' != typeof v) throw new q('`slot` must be a string');
                        var _ = M.get($);
                        _ || M.set($, (_ = {})), (_['$' + v] = p);
                    },
                };
            Object.freeze && Object.freeze(G), (se.exports = G);
        },
        8344: (se, ae, U) => {
            'use strict';
            var O = U(5328)(),
                q = U(3463)('Object.prototype.toString'),
                G = function (_) {
                    return (
                        !(O && _ && 'object' == typeof _ && Symbol.toStringTag in _) && '[object Arguments]' === q(_)
                    );
                },
                $ = function (_) {
                    return (
                        !!G(_) ||
                        (null !== _ &&
                            'object' == typeof _ &&
                            'number' == typeof _.length &&
                            _.length >= 0 &&
                            '[object Array]' !== q(_) &&
                            '[object Function]' === q(_.callee))
                    );
                },
                v = (function () {
                    return G(arguments);
                })();
            (G.isLegacyArguments = $), (se.exports = v ? G : $);
        },
        3066: (se, ae, U) => {
            'use strict';
            var O = U(6283),
                M = U(3463),
                G = U(2521)('%ArrayBuffer%', !0),
                $ = M('ArrayBuffer.prototype.byteLength', !0),
                v = M('Object.prototype.toString'),
                p = !!G && !$ && new G(0).slice,
                _ = !!p && O(p);
            se.exports =
                $ || _
                    ? function (x) {
                          if (!x || 'object' != typeof x) return !1;
                          try {
                              return $ ? $(x) : _(x, 0), !0;
                          } catch {
                              return !1;
                          }
                      }
                    : G
                    ? function (x) {
                          return '[object ArrayBuffer]' === v(x);
                      }
                    : function (x) {
                          return !1;
                      };
        },
        7671: (se, ae, U) => {
            'use strict';
            if (U(362)()) {
                var M = BigInt.prototype.valueOf;
                se.exports = function ($) {
                    return (
                        !(
                            null === $ ||
                            typeof $ > 'u' ||
                            'boolean' == typeof $ ||
                            'string' == typeof $ ||
                            'number' == typeof $ ||
                            'symbol' == typeof $ ||
                            'function' == typeof $
                        ) &&
                        ('bigint' == typeof $ ||
                            (function ($) {
                                try {
                                    return M.call($), !0;
                                } catch {}
                                return !1;
                            })($))
                    );
                };
            } else
                se.exports = function ($) {
                    return !1;
                };
        },
        6484: (se, ae, U) => {
            'use strict';
            var O = U(3463),
                M = O('Boolean.prototype.toString'),
                q = O('Object.prototype.toString'),
                v = U(5328)();
            se.exports = function (_) {
                return (
                    'boolean' == typeof _ ||
                    (null !== _ &&
                        'object' == typeof _ &&
                        (v && Symbol.toStringTag in _
                            ? (function (_) {
                                  try {
                                      return M(_), !0;
                                  } catch {
                                      return !1;
                                  }
                              })(_)
                            : '[object Boolean]' === q(_)))
                );
            };
        },
        7268: se => {
            'use strict';
            var O,
                M,
                ae = Function.prototype.toString,
                U = 'object' == typeof Reflect && null !== Reflect && Reflect.apply;
            if ('function' == typeof U && 'function' == typeof Object.defineProperty)
                try {
                    (O = Object.defineProperty({}, 'length', {
                        get: function () {
                            throw M;
                        },
                    })),
                        (M = {}),
                        U(
                            function () {
                                throw 42;
                            },
                            null,
                            O,
                        );
                } catch (K) {
                    K !== M && (U = null);
                }
            else U = null;
            var q = /^\s*class\b/,
                G = function (Q) {
                    try {
                        var ce = ae.call(Q);
                        return q.test(ce);
                    } catch {
                        return !1;
                    }
                },
                $ = function (Q) {
                    try {
                        return !G(Q) && (ae.call(Q), !0);
                    } catch {
                        return !1;
                    }
                },
                v = Object.prototype.toString,
                k = 'function' == typeof Symbol && !!Symbol.toStringTag,
                R = !(0 in [,]),
                j = function () {
                    return !1;
                };
            if ('object' == typeof document) {
                var N = document.all;
                v.call(N) === v.call(document.all) &&
                    (j = function (Q) {
                        if ((R || !Q) && (typeof Q > 'u' || 'object' == typeof Q))
                            try {
                                var ce = v.call(Q);
                                return (
                                    ('[object HTMLAllCollection]' === ce ||
                                        '[object HTML document.all class]' === ce ||
                                        '[object HTMLCollection]' === ce ||
                                        '[object Object]' === ce) &&
                                    null == Q('')
                                );
                            } catch {}
                        return !1;
                    });
            }
            se.exports = U
                ? function (Q) {
                      if (j(Q)) return !0;
                      if (!Q || ('function' != typeof Q && 'object' != typeof Q)) return !1;
                      try {
                          U(Q, null, O);
                      } catch (ce) {
                          if (ce !== M) return !1;
                      }
                      return !G(Q) && $(Q);
                  }
                : function (Q) {
                      if (j(Q)) return !0;
                      if (!Q || ('function' != typeof Q && 'object' != typeof Q)) return !1;
                      if (k) return $(Q);
                      if (G(Q)) return !1;
                      var ce = v.call(Q);
                      return (
                          !(
                              '[object Function]' !== ce &&
                              '[object GeneratorFunction]' !== ce &&
                              !/^\[object HTML/.test(ce)
                          ) && $(Q)
                      );
                  };
        },
        5500: (se, ae, U) => {
            'use strict';
            var O = Date.prototype.getDay,
                q = Object.prototype.toString,
                $ = U(5328)();
            se.exports = function (p) {
                return (
                    'object' == typeof p &&
                    null !== p &&
                    ($
                        ? (function (p) {
                              try {
                                  return O.call(p), !0;
                              } catch {
                                  return !1;
                              }
                          })(p)
                        : '[object Date]' === q.call(p))
                );
            };
        },
        3983: se => {
            'use strict';
            se.exports =
                Number.isFinite ||
                function (ae) {
                    return !('number' != typeof ae || ae != ae || ae === 1 / 0 || ae === -1 / 0);
                };
        },
        9962: (se, ae, U) => {
            var O = U(3983);
            se.exports =
                Number.isInteger ||
                function (M) {
                    return 'number' == typeof M && O(M) && Math.floor(M) === M;
                };
        },
        7598: se => {
            'use strict';
            var O,
                ae = 'function' == typeof Map && Map.prototype ? Map : null,
                U = 'function' == typeof Set && Set.prototype ? Set : null;
            ae ||
                (O = function ($) {
                    return !1;
                });
            var M = ae ? Map.prototype.has : null,
                q = U ? Set.prototype.has : null;
            !O &&
                !M &&
                (O = function ($) {
                    return !1;
                }),
                (se.exports =
                    O ||
                    function ($) {
                        if (!$ || 'object' != typeof $) return !1;
                        try {
                            if ((M.call($), q))
                                try {
                                    q.call($);
                                } catch {
                                    return !0;
                                }
                            return $ instanceof ae;
                        } catch {}
                        return !1;
                    });
        },
        8979: (se, ae, U) => {
            'use strict';
            var O = Number.prototype.toString,
                q = Object.prototype.toString,
                $ = U(5328)();
            se.exports = function (p) {
                return (
                    'number' == typeof p ||
                    ('object' == typeof p &&
                        ($
                            ? (function (p) {
                                  try {
                                      return O.call(p), !0;
                                  } catch {
                                      return !1;
                                  }
                              })(p)
                            : '[object Number]' === q.call(p)))
                );
            };
        },
        5831: (se, ae, U) => {
            'use strict';
            var q,
                G,
                $,
                v,
                O = U(3463),
                M = U(5328)();
            if (M) {
                (q = O('Object.prototype.hasOwnProperty')), (G = O('RegExp.prototype.exec')), ($ = {});
                var p = function () {
                    throw $;
                };
                (v = { toString: p, valueOf: p }), 'symbol' == typeof Symbol.toPrimitive && (v[Symbol.toPrimitive] = p);
            }
            var _ = O('Object.prototype.toString'),
                T = Object.getOwnPropertyDescriptor;
            se.exports = M
                ? function (C) {
                      if (!C || 'object' != typeof C) return !1;
                      var k = T(C, 'lastIndex');
                      if (!k || !q(k, 'value')) return !1;
                      try {
                          G(C, v);
                      } catch (j) {
                          return j === $;
                      }
                  }
                : function (C) {
                      return !(!C || ('object' != typeof C && 'function' != typeof C)) && '[object RegExp]' === _(C);
                  };
        },
        9116: se => {
            'use strict';
            var O,
                ae = 'function' == typeof Map && Map.prototype ? Map : null,
                U = 'function' == typeof Set && Set.prototype ? Set : null;
            U ||
                (O = function ($) {
                    return !1;
                });
            var M = ae ? Map.prototype.has : null,
                q = U ? Set.prototype.has : null;
            !O &&
                !q &&
                (O = function ($) {
                    return !1;
                }),
                (se.exports =
                    O ||
                    function ($) {
                        if (!$ || 'object' != typeof $) return !1;
                        try {
                            if ((q.call($), M))
                                try {
                                    M.call($);
                                } catch {
                                    return !0;
                                }
                            return $ instanceof U;
                        } catch {}
                        return !1;
                    });
        },
        2090: (se, ae, U) => {
            'use strict';
            var M = U(3463)('SharedArrayBuffer.prototype.byteLength', !0);
            se.exports = M
                ? function (G) {
                      if (!G || 'object' != typeof G) return !1;
                      try {
                          return M(G), !0;
                      } catch {
                          return !1;
                      }
                  }
                : function (G) {
                      return !1;
                  };
        },
        6837: (se, ae, U) => {
            'use strict';
            var O = String.prototype.valueOf,
                q = Object.prototype.toString,
                $ = U(5328)();
            se.exports = function (p) {
                return (
                    'string' == typeof p ||
                    ('object' == typeof p &&
                        ($
                            ? (function (p) {
                                  try {
                                      return O.call(p), !0;
                                  } catch {
                                      return !1;
                                  }
                              })(p)
                            : '[object String]' === q.call(p)))
                );
            };
        },
        3016: (se, ae, U) => {
            'use strict';
            var O = Object.prototype.toString;
            if (U(1459)()) {
                var q = Symbol.prototype.toString,
                    G = /^Symbol\(.*\)$/;
                se.exports = function (p) {
                    if ('symbol' == typeof p) return !0;
                    if ('[object Symbol]' !== O.call(p)) return !1;
                    try {
                        return (function (p) {
                            return 'symbol' == typeof p.valueOf() && G.test(q.call(p));
                        })(p);
                    } catch {
                        return !1;
                    }
                };
            } else
                se.exports = function (p) {
                    return !1;
                };
        },
        9462: se => {
            'use strict';
            var O,
                ae = 'function' == typeof WeakMap && WeakMap.prototype ? WeakMap : null,
                U = 'function' == typeof WeakSet && WeakSet.prototype ? WeakSet : null;
            ae ||
                (O = function ($) {
                    return !1;
                });
            var M = ae ? ae.prototype.has : null,
                q = U ? U.prototype.has : null;
            !O &&
                !M &&
                (O = function ($) {
                    return !1;
                }),
                (se.exports =
                    O ||
                    function ($) {
                        if (!$ || 'object' != typeof $) return !1;
                        try {
                            if ((M.call($, M), q))
                                try {
                                    q.call($, q);
                                } catch {
                                    return !0;
                                }
                            return $ instanceof ae;
                        } catch {}
                        return !1;
                    });
        },
        5028: (se, ae, U) => {
            'use strict';
            var O = U(2521),
                M = U(3463),
                q = O('%WeakSet%', !0),
                G = M('WeakSet.prototype.has', !0);
            if (G) {
                var $ = M('WeakMap.prototype.has', !0);
                se.exports = function (p) {
                    if (!p || 'object' != typeof p) return !1;
                    try {
                        if ((G(p, G), $))
                            try {
                                $(p, $);
                            } catch {
                                return !0;
                            }
                        return p instanceof q;
                    } catch {}
                    return !1;
                };
            } else
                se.exports = function (p) {
                    return !1;
                };
        },
        7638: se => {
            var ae = {}.toString;
            se.exports =
                Array.isArray ||
                function (U) {
                    return '[object Array]' == ae.call(U);
                };
        },
        3224: function (se, ae) {
            var O;
            /*!
             * jQuery JavaScript Library v3.7.1
             * https://jquery.com/
             *
             * Copyright OpenJS Foundation and other contributors
             * Released under the MIT license
             * https://jquery.org/license
             *
             * Date: 2023-08-28T13:37Z
             */ !(function (M, q) {
                'use strict';
                'object' == typeof se.exports
                    ? (se.exports = M.document
                          ? q(M, !0)
                          : function (G) {
                                if (!G.document) throw new Error('jQuery requires a window with a document');
                                return q(G);
                            })
                    : q(M);
            })(typeof window < 'u' ? window : this, function (M, q) {
                'use strict';
                var G = [],
                    $ = Object.getPrototypeOf,
                    v = G.slice,
                    p = G.flat
                        ? function (u) {
                              return G.flat.call(u);
                          }
                        : function (u) {
                              return G.concat.apply([], u);
                          },
                    _ = G.push,
                    T = G.indexOf,
                    x = {},
                    F = x.toString,
                    C = x.hasOwnProperty,
                    k = C.toString,
                    R = k.call(Object),
                    j = {},
                    N = function (h) {
                        return 'function' == typeof h && 'number' != typeof h.nodeType && 'function' != typeof h.item;
                    },
                    K = function (h) {
                        return null != h && h === h.window;
                    },
                    Q = M.document,
                    ce = { type: !0, src: !0, nonce: !0, noModule: !0 };
                function ge(u, h, y) {
                    var w,
                        I,
                        A = (y = y || Q).createElement('script');
                    if (((A.text = u), h))
                        for (w in ce) (I = h[w] || (h.getAttribute && h.getAttribute(w))) && A.setAttribute(w, I);
                    y.head.appendChild(A).parentNode.removeChild(A);
                }
                function De(u) {
                    return null == u
                        ? u + ''
                        : 'object' == typeof u || 'function' == typeof u
                        ? x[F.call(u)] || 'object'
                        : typeof u;
                }
                var Ve = /HTML$/i,
                    b = function (u, h) {
                        return new b.fn.init(u, h);
                    };
                function je(u) {
                    var h = !!u && 'length' in u && u.length,
                        y = De(u);
                    return (
                        !N(u) && !K(u) && ('array' === y || 0 === h || ('number' == typeof h && h > 0 && h - 1 in u))
                    );
                }
                function Ne(u, h) {
                    return u.nodeName && u.nodeName.toLowerCase() === h.toLowerCase();
                }
                (b.fn = b.prototype =
                    {
                        jquery: '3.7.1',
                        constructor: b,
                        length: 0,
                        toArray: function () {
                            return v.call(this);
                        },
                        get: function (u) {
                            return null == u ? v.call(this) : u < 0 ? this[u + this.length] : this[u];
                        },
                        pushStack: function (u) {
                            var h = b.merge(this.constructor(), u);
                            return (h.prevObject = this), h;
                        },
                        each: function (u) {
                            return b.each(this, u);
                        },
                        map: function (u) {
                            return this.pushStack(
                                b.map(this, function (h, y) {
                                    return u.call(h, y, h);
                                }),
                            );
                        },
                        slice: function () {
                            return this.pushStack(v.apply(this, arguments));
                        },
                        first: function () {
                            return this.eq(0);
                        },
                        last: function () {
                            return this.eq(-1);
                        },
                        even: function () {
                            return this.pushStack(
                                b.grep(this, function (u, h) {
                                    return (h + 1) % 2;
                                }),
                            );
                        },
                        odd: function () {
                            return this.pushStack(
                                b.grep(this, function (u, h) {
                                    return h % 2;
                                }),
                            );
                        },
                        eq: function (u) {
                            var h = this.length,
                                y = +u + (u < 0 ? h : 0);
                            return this.pushStack(y >= 0 && y < h ? [this[y]] : []);
                        },
                        end: function () {
                            return this.prevObject || this.constructor();
                        },
                        push: _,
                        sort: G.sort,
                        splice: G.splice,
                    }),
                    (b.extend = b.fn.extend =
                        function () {
                            var u,
                                h,
                                y,
                                w,
                                I,
                                A,
                                B = arguments[0] || {},
                                ne = 1,
                                J = arguments.length,
                                re = !1;
                            for (
                                'boolean' == typeof B && ((re = B), (B = arguments[ne] || {}), ne++),
                                    'object' != typeof B && !N(B) && (B = {}),
                                    ne === J && ((B = this), ne--);
                                ne < J;
                                ne++
                            )
                                if (null != (u = arguments[ne]))
                                    for (h in u)
                                        (w = u[h]),
                                            '__proto__' !== h &&
                                                B !== w &&
                                                (re && w && (b.isPlainObject(w) || (I = Array.isArray(w)))
                                                    ? ((y = B[h]),
                                                      (A =
                                                          I && !Array.isArray(y)
                                                              ? []
                                                              : I || b.isPlainObject(y)
                                                              ? y
                                                              : {}),
                                                      (I = !1),
                                                      (B[h] = b.extend(re, A, w)))
                                                    : void 0 !== w && (B[h] = w));
                            return B;
                        }),
                    b.extend({
                        expando: 'jQuery' + ('3.7.1' + Math.random()).replace(/\D/g, ''),
                        isReady: !0,
                        error: function (u) {
                            throw new Error(u);
                        },
                        noop: function () {},
                        isPlainObject: function (u) {
                            var h, y;
                            return !(
                                !u ||
                                '[object Object]' !== F.call(u) ||
                                ((h = $(u)) &&
                                    ('function' != typeof (y = C.call(h, 'constructor') && h.constructor) ||
                                        k.call(y) !== R))
                            );
                        },
                        isEmptyObject: function (u) {
                            var h;
                            for (h in u) return !1;
                            return !0;
                        },
                        globalEval: function (u, h, y) {
                            ge(u, { nonce: h && h.nonce }, y);
                        },
                        each: function (u, h) {
                            var y,
                                w = 0;
                            if (je(u)) for (y = u.length; w < y && !1 !== h.call(u[w], w, u[w]); w++);
                            else for (w in u) if (!1 === h.call(u[w], w, u[w])) break;
                            return u;
                        },
                        text: function (u) {
                            var h,
                                y = '',
                                w = 0,
                                I = u.nodeType;
                            if (!I) for (; (h = u[w++]); ) y += b.text(h);
                            return 1 === I || 11 === I
                                ? u.textContent
                                : 9 === I
                                ? u.documentElement.textContent
                                : 3 === I || 4 === I
                                ? u.nodeValue
                                : y;
                        },
                        makeArray: function (u, h) {
                            var y = h || [];
                            return (
                                null != u &&
                                    (je(Object(u)) ? b.merge(y, 'string' == typeof u ? [u] : u) : _.call(y, u)),
                                y
                            );
                        },
                        inArray: function (u, h, y) {
                            return null == h ? -1 : T.call(h, u, y);
                        },
                        isXMLDoc: function (u) {
                            var y = u && (u.ownerDocument || u).documentElement;
                            return !Ve.test((u && u.namespaceURI) || (y && y.nodeName) || 'HTML');
                        },
                        merge: function (u, h) {
                            for (var y = +h.length, w = 0, I = u.length; w < y; w++) u[I++] = h[w];
                            return (u.length = I), u;
                        },
                        grep: function (u, h, y) {
                            for (var I = [], A = 0, B = u.length, ne = !y; A < B; A++)
                                !h(u[A], A) !== ne && I.push(u[A]);
                            return I;
                        },
                        map: function (u, h, y) {
                            var w,
                                I,
                                A = 0,
                                B = [];
                            if (je(u)) for (w = u.length; A < w; A++) null != (I = h(u[A], A, y)) && B.push(I);
                            else for (A in u) null != (I = h(u[A], A, y)) && B.push(I);
                            return p(B);
                        },
                        guid: 1,
                        support: j,
                    }),
                    'function' == typeof Symbol && (b.fn[Symbol.iterator] = G[Symbol.iterator]),
                    b.each(
                        'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '),
                        function (u, h) {
                            x['[object ' + h + ']'] = h.toLowerCase();
                        },
                    );
                var at = G.pop,
                    Et = G.sort,
                    ht = G.splice,
                    Re = '[\\x20\\t\\r\\n\\f]',
                    Pt = new RegExp('^' + Re + '+|((?:^|[^\\\\])(?:\\\\.)*)' + Re + '+$', 'g');
                b.contains = function (u, h) {
                    var y = h && h.parentNode;
                    return (
                        u === y ||
                        !(
                            !y ||
                            1 !== y.nodeType ||
                            !(u.contains
                                ? u.contains(y)
                                : u.compareDocumentPosition && 16 & u.compareDocumentPosition(y))
                        )
                    );
                };
                var Gt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
                function ur(u, h) {
                    return h
                        ? '\0' === u
                            ? '\ufffd'
                            : u.slice(0, -1) + '\\' + u.charCodeAt(u.length - 1).toString(16) + ' '
                        : '\\' + u;
                }
                b.escapeSelector = function (u) {
                    return (u + '').replace(Gt, ur);
                };
                var Sn = Q,
                    qt = _;
                !(function () {
                    var u,
                        h,
                        y,
                        w,
                        I,
                        B,
                        ne,
                        J,
                        re,
                        Te,
                        A = qt,
                        Ae = b.expando,
                        ve = 0,
                        He = 0,
                        Kt = gl(),
                        In = gl(),
                        Xt = gl(),
                        nr = gl(),
                        Vi = function (X, le) {
                            return X === le && (I = !0), 0;
                        },
                        oo =
                            'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
                        ao = '(?:\\\\[\\da-fA-F]{1,6}' + Re + '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
                        wn =
                            '\\[' +
                            Re +
                            '*(' +
                            ao +
                            ')(?:' +
                            Re +
                            '*([*^$|!~]?=)' +
                            Re +
                            '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
                            ao +
                            '))|)' +
                            Re +
                            '*\\]',
                        Jo =
                            ':(' +
                            ao +
                            ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
                            wn +
                            ')*)|.*)\\)|)',
                        mn = new RegExp(Re + '+', 'g'),
                        Hi = new RegExp('^' + Re + '*,' + Re + '*'),
                        _r = new RegExp('^' + Re + '*([>+~]|' + Re + ')' + Re + '*'),
                        Bc = new RegExp(Re + '|>'),
                        Se = new RegExp(Jo),
                        Ha = new RegExp('^' + ao + '$'),
                        Ue = {
                            ID: new RegExp('^#(' + ao + ')'),
                            CLASS: new RegExp('^\\.(' + ao + ')'),
                            TAG: new RegExp('^(' + ao + '|[*])'),
                            ATTR: new RegExp('^' + wn),
                            PSEUDO: new RegExp('^' + Jo),
                            CHILD: new RegExp(
                                '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
                                    Re +
                                    '*(even|odd|(([+-]|)(\\d*)n|)' +
                                    Re +
                                    '*(?:([+-]|)' +
                                    Re +
                                    '*(\\d+)|))' +
                                    Re +
                                    '*\\)|)',
                                'i',
                            ),
                            bool: new RegExp('^(?:' + oo + ')$', 'i'),
                            needsContext: new RegExp(
                                '^' +
                                    Re +
                                    '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
                                    Re +
                                    '*((?:-\\d)?\\d*)' +
                                    Re +
                                    '*\\)|)(?=[^-]|$)',
                                'i',
                            ),
                        },
                        Ys = /^(?:input|select|textarea|button)$/i,
                        lo = /^h\d$/i,
                        Pr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                        qc = /[+~]/,
                        co = new RegExp('\\\\[\\da-fA-F]{1,6}' + Re + '?|\\\\([^\\r\\n\\f])', 'g'),
                        Eo = function (X, le) {
                            var be = '0x' + X.slice(1) - 65536;
                            return (
                                le ||
                                (be < 0
                                    ? String.fromCharCode(be + 65536)
                                    : String.fromCharCode((be >> 10) | 55296, (1023 & be) | 56320))
                            );
                        },
                        Gu = function () {
                            gs();
                        },
                        oi = br(
                            function (X) {
                                return !0 === X.disabled && Ne(X, 'fieldset');
                            },
                            { dir: 'parentNode', next: 'legend' },
                        );
                    try {
                        A.apply((G = v.call(Sn.childNodes)), Sn.childNodes);
                    } catch {
                        A = {
                            apply: function (le, be) {
                                qt.apply(le, v.call(be));
                            },
                            call: function (le) {
                                qt.apply(le, v.call(arguments, 1));
                            },
                        };
                    }
                    function Vn(X, le, be, we) {
                        var de,
                            Qe,
                            it,
                            pt,
                            rt,
                            It,
                            wt,
                            Yt = le && le.ownerDocument,
                            yn = le ? le.nodeType : 9;
                        if (((be = be || []), 'string' != typeof X || !X || (1 !== yn && 9 !== yn && 11 !== yn)))
                            return be;
                        if (!we && (gs(le), (le = le || B), J)) {
                            if (11 !== yn && (rt = Pr.exec(X)))
                                if ((de = rt[1])) {
                                    if (9 === yn) {
                                        if (!(it = le.getElementById(de))) return be;
                                        if (it.id === de) return A.call(be, it), be;
                                    } else if (
                                        Yt &&
                                        (it = Yt.getElementById(de)) &&
                                        Vn.contains(le, it) &&
                                        it.id === de
                                    )
                                        return A.call(be, it), be;
                                } else {
                                    if (rt[2]) return A.apply(be, le.getElementsByTagName(X)), be;
                                    if ((de = rt[3]) && le.getElementsByClassName)
                                        return A.apply(be, le.getElementsByClassName(de)), be;
                                }
                            if (!(nr[X + ' '] || (re && re.test(X)))) {
                                if (((wt = X), (Yt = le), 1 === yn && (Bc.test(X) || _r.test(X)))) {
                                    for (
                                        ((Yt = (qc.test(X) && Ba(le.parentNode)) || le) != le || !j.scope) &&
                                            ((pt = le.getAttribute('id'))
                                                ? (pt = b.escapeSelector(pt))
                                                : le.setAttribute('id', (pt = Ae))),
                                            Qe = (It = ea(X)).length;
                                        Qe--;

                                    )
                                        It[Qe] = (pt ? '#' + pt : ':scope') + ' ' + jc(It[Qe]);
                                    wt = It.join(',');
                                }
                                try {
                                    return A.apply(be, Yt.querySelectorAll(wt)), be;
                                } catch {
                                    nr(X, !0);
                                } finally {
                                    pt === Ae && le.removeAttribute('id');
                                }
                            }
                        }
                        return $c(X.replace(Pt, '$1'), le, be, we);
                    }
                    function gl() {
                        var X = [];
                        return function le(be, we) {
                            return X.push(be + ' ') > h.cacheLength && delete le[X.shift()], (le[be + ' '] = we);
                        };
                    }
                    function yr(X) {
                        return (X[Ae] = !0), X;
                    }
                    function Ua(X) {
                        var le = B.createElement('fieldset');
                        try {
                            return !!X(le);
                        } catch {
                            return !1;
                        } finally {
                            le.parentNode && le.parentNode.removeChild(le), (le = null);
                        }
                    }
                    function rs(X) {
                        return function (le) {
                            return Ne(le, 'input') && le.type === X;
                        };
                    }
                    function uo(X) {
                        return function (le) {
                            return (Ne(le, 'input') || Ne(le, 'button')) && le.type === X;
                        };
                    }
                    function Yc(X) {
                        return function (le) {
                            return 'form' in le
                                ? le.parentNode && !1 === le.disabled
                                    ? 'label' in le
                                        ? 'label' in le.parentNode
                                            ? le.parentNode.disabled === X
                                            : le.disabled === X
                                        : le.isDisabled === X || (le.isDisabled !== !X && oi(le) === X)
                                    : le.disabled === X
                                : 'label' in le && le.disabled === X;
                        };
                    }
                    function ho(X) {
                        return yr(function (le) {
                            return (
                                (le = +le),
                                yr(function (be, we) {
                                    for (var de, Qe = X([], be.length, le), it = Qe.length; it--; )
                                        be[(de = Qe[it])] && (be[de] = !(we[de] = be[de]));
                                })
                            );
                        });
                    }
                    function Ba(X) {
                        return X && typeof X.getElementsByTagName < 'u' && X;
                    }
                    function gs(X) {
                        var le,
                            be = X ? X.ownerDocument || X : Sn;
                        return (
                            be == B ||
                                9 !== be.nodeType ||
                                !be.documentElement ||
                                ((ne = (B = be).documentElement),
                                (J = !b.isXMLDoc(B)),
                                (Te = ne.matches || ne.webkitMatchesSelector || ne.msMatchesSelector),
                                ne.msMatchesSelector &&
                                    Sn != B &&
                                    (le = B.defaultView) &&
                                    le.top !== le &&
                                    le.addEventListener('unload', Gu),
                                (j.getById = Ua(function (we) {
                                    return (
                                        (ne.appendChild(we).id = b.expando),
                                        !B.getElementsByName || !B.getElementsByName(b.expando).length
                                    );
                                })),
                                (j.disconnectedMatch = Ua(function (we) {
                                    return Te.call(we, '*');
                                })),
                                (j.scope = Ua(function () {
                                    return B.querySelectorAll(':scope');
                                })),
                                (j.cssHas = Ua(function () {
                                    try {
                                        return B.querySelector(':has(*,:jqfake)'), !1;
                                    } catch {
                                        return !0;
                                    }
                                })),
                                j.getById
                                    ? ((h.filter.ID = function (we) {
                                          var de = we.replace(co, Eo);
                                          return function (Qe) {
                                              return Qe.getAttribute('id') === de;
                                          };
                                      }),
                                      (h.find.ID = function (we, de) {
                                          if (typeof de.getElementById < 'u' && J) {
                                              var Qe = de.getElementById(we);
                                              return Qe ? [Qe] : [];
                                          }
                                      }))
                                    : ((h.filter.ID = function (we) {
                                          var de = we.replace(co, Eo);
                                          return function (Qe) {
                                              var it = typeof Qe.getAttributeNode < 'u' && Qe.getAttributeNode('id');
                                              return it && it.value === de;
                                          };
                                      }),
                                      (h.find.ID = function (we, de) {
                                          if (typeof de.getElementById < 'u' && J) {
                                              var Qe,
                                                  it,
                                                  pt,
                                                  rt = de.getElementById(we);
                                              if (rt) {
                                                  if ((Qe = rt.getAttributeNode('id')) && Qe.value === we) return [rt];
                                                  for (pt = de.getElementsByName(we), it = 0; (rt = pt[it++]); )
                                                      if ((Qe = rt.getAttributeNode('id')) && Qe.value === we)
                                                          return [rt];
                                              }
                                              return [];
                                          }
                                      })),
                                (h.find.TAG = function (we, de) {
                                    return typeof de.getElementsByTagName < 'u'
                                        ? de.getElementsByTagName(we)
                                        : de.querySelectorAll(we);
                                }),
                                (h.find.CLASS = function (we, de) {
                                    if (typeof de.getElementsByClassName < 'u' && J)
                                        return de.getElementsByClassName(we);
                                }),
                                (re = []),
                                Ua(function (we) {
                                    var de;
                                    (ne.appendChild(we).innerHTML =
                                        "<a id='" +
                                        Ae +
                                        "' href='' disabled='disabled'></a><select id='" +
                                        Ae +
                                        "-\r\\' disabled='disabled'><option selected=''></option></select>"),
                                        we.querySelectorAll('[selected]').length ||
                                            re.push('\\[' + Re + '*(?:value|' + oo + ')'),
                                        we.querySelectorAll('[id~=' + Ae + '-]').length || re.push('~='),
                                        we.querySelectorAll('a#' + Ae + '+*').length || re.push('.#.+[+~]'),
                                        we.querySelectorAll(':checked').length || re.push(':checked'),
                                        (de = B.createElement('input')).setAttribute('type', 'hidden'),
                                        we.appendChild(de).setAttribute('name', 'D'),
                                        (ne.appendChild(we).disabled = !0),
                                        2 !== we.querySelectorAll(':disabled').length &&
                                            re.push(':enabled', ':disabled'),
                                        (de = B.createElement('input')).setAttribute('name', ''),
                                        we.appendChild(de),
                                        we.querySelectorAll("[name='']").length ||
                                            re.push('\\[' + Re + '*name' + Re + '*=' + Re + '*(?:\'\'|"")');
                                }),
                                j.cssHas || re.push(':has'),
                                (re = re.length && new RegExp(re.join('|'))),
                                (Vi = function (we, de) {
                                    if (we === de) return (I = !0), 0;
                                    var Qe = !we.compareDocumentPosition - !de.compareDocumentPosition;
                                    return (
                                        Qe ||
                                        (1 &
                                            (Qe =
                                                (we.ownerDocument || we) == (de.ownerDocument || de)
                                                    ? we.compareDocumentPosition(de)
                                                    : 1) ||
                                        (!j.sortDetached && de.compareDocumentPosition(we) === Qe)
                                            ? we === B || (we.ownerDocument == Sn && Vn.contains(Sn, we))
                                                ? -1
                                                : de === B || (de.ownerDocument == Sn && Vn.contains(Sn, de))
                                                ? 1
                                                : w
                                                ? T.call(w, we) - T.call(w, de)
                                                : 0
                                            : 4 & Qe
                                            ? -1
                                            : 1)
                                    );
                                })),
                            B
                        );
                    }
                    for (u in ((Vn.matches = function (X, le) {
                        return Vn(X, null, null, le);
                    }),
                    (Vn.matchesSelector = function (X, le) {
                        if ((gs(X), J && !nr[le + ' '] && (!re || !re.test(le))))
                            try {
                                var be = Te.call(X, le);
                                if (be || j.disconnectedMatch || (X.document && 11 !== X.document.nodeType)) return be;
                            } catch {
                                nr(le, !0);
                            }
                        return Vn(le, B, null, [X]).length > 0;
                    }),
                    (Vn.contains = function (X, le) {
                        return (X.ownerDocument || X) != B && gs(X), b.contains(X, le);
                    }),
                    (Vn.attr = function (X, le) {
                        (X.ownerDocument || X) != B && gs(X);
                        var be = h.attrHandle[le.toLowerCase()],
                            we = be && C.call(h.attrHandle, le.toLowerCase()) ? be(X, le, !J) : void 0;
                        return void 0 !== we ? we : X.getAttribute(le);
                    }),
                    (Vn.error = function (X) {
                        throw new Error('Syntax error, unrecognized expression: ' + X);
                    }),
                    (b.uniqueSort = function (X) {
                        var le,
                            be = [],
                            we = 0,
                            de = 0;
                        if (((I = !j.sortStable), (w = !j.sortStable && v.call(X, 0)), Et.call(X, Vi), I)) {
                            for (; (le = X[de++]); ) le === X[de] && (we = be.push(de));
                            for (; we--; ) ht.call(X, be[we], 1);
                        }
                        return (w = null), X;
                    }),
                    (b.fn.uniqueSort = function () {
                        return this.pushStack(b.uniqueSort(v.apply(this)));
                    }),
                    ((h = b.expr =
                        {
                            cacheLength: 50,
                            createPseudo: yr,
                            match: Ue,
                            attrHandle: {},
                            find: {},
                            relative: {
                                '>': { dir: 'parentNode', first: !0 },
                                ' ': { dir: 'parentNode' },
                                '+': { dir: 'previousSibling', first: !0 },
                                '~': { dir: 'previousSibling' },
                            },
                            preFilter: {
                                ATTR: function (X) {
                                    return (
                                        (X[1] = X[1].replace(co, Eo)),
                                        (X[3] = (X[3] || X[4] || X[5] || '').replace(co, Eo)),
                                        '~=' === X[2] && (X[3] = ' ' + X[3] + ' '),
                                        X.slice(0, 4)
                                    );
                                },
                                CHILD: function (X) {
                                    return (
                                        (X[1] = X[1].toLowerCase()),
                                        'nth' === X[1].slice(0, 3)
                                            ? (X[3] || Vn.error(X[0]),
                                              (X[4] = +(X[4]
                                                  ? X[5] + (X[6] || 1)
                                                  : 2 * ('even' === X[3] || 'odd' === X[3]))),
                                              (X[5] = +(X[7] + X[8] || 'odd' === X[3])))
                                            : X[3] && Vn.error(X[0]),
                                        X
                                    );
                                },
                                PSEUDO: function (X) {
                                    var le,
                                        be = !X[6] && X[2];
                                    return Ue.CHILD.test(X[0])
                                        ? null
                                        : (X[3]
                                              ? (X[2] = X[4] || X[5] || '')
                                              : be &&
                                                Se.test(be) &&
                                                (le = ea(be, !0)) &&
                                                (le = be.indexOf(')', be.length - le) - be.length) &&
                                                ((X[0] = X[0].slice(0, le)), (X[2] = be.slice(0, le))),
                                          X.slice(0, 3));
                                },
                            },
                            filter: {
                                TAG: function (X) {
                                    var le = X.replace(co, Eo).toLowerCase();
                                    return '*' === X
                                        ? function () {
                                              return !0;
                                          }
                                        : function (be) {
                                              return Ne(be, le);
                                          };
                                },
                                CLASS: function (X) {
                                    var le = Kt[X + ' '];
                                    return (
                                        le ||
                                        ((le = new RegExp('(^|' + Re + ')' + X + '(' + Re + '|$)')) &&
                                            Kt(X, function (be) {
                                                return le.test(
                                                    ('string' == typeof be.className && be.className) ||
                                                        (typeof be.getAttribute < 'u' && be.getAttribute('class')) ||
                                                        '',
                                                );
                                            }))
                                    );
                                },
                                ATTR: function (X, le, be) {
                                    return function (we) {
                                        var de = Vn.attr(we, X);
                                        return null == de
                                            ? '!=' === le
                                            : !le ||
                                                  ((de += ''),
                                                  '=' === le
                                                      ? de === be
                                                      : '!=' === le
                                                      ? de !== be
                                                      : '^=' === le
                                                      ? be && 0 === de.indexOf(be)
                                                      : '*=' === le
                                                      ? be && de.indexOf(be) > -1
                                                      : '$=' === le
                                                      ? be && de.slice(-be.length) === be
                                                      : '~=' === le
                                                      ? (' ' + de.replace(mn, ' ') + ' ').indexOf(be) > -1
                                                      : '|=' === le &&
                                                        (de === be || de.slice(0, be.length + 1) === be + '-'));
                                    };
                                },
                                CHILD: function (X, le, be, we, de) {
                                    var Qe = 'nth' !== X.slice(0, 3),
                                        it = 'last' !== X.slice(-4),
                                        pt = 'of-type' === le;
                                    return 1 === we && 0 === de
                                        ? function (rt) {
                                              return !!rt.parentNode;
                                          }
                                        : function (rt, It, wt) {
                                              var Yt,
                                                  yn,
                                                  Mt,
                                                  ai,
                                                  ss,
                                                  gi = Qe !== it ? 'nextSibling' : 'previousSibling',
                                                  vs = rt.parentNode,
                                                  js = pt && rt.nodeName.toLowerCase(),
                                                  Ya = !wt && !pt,
                                                  Yr = !1;
                                              if (vs) {
                                                  if (Qe) {
                                                      for (; gi; ) {
                                                          for (Mt = rt; (Mt = Mt[gi]); )
                                                              if (pt ? Ne(Mt, js) : 1 === Mt.nodeType) return !1;
                                                          ss = gi = 'only' === X && !ss && 'nextSibling';
                                                      }
                                                      return !0;
                                                  }
                                                  if (((ss = [it ? vs.firstChild : vs.lastChild]), it && Ya)) {
                                                      for (
                                                          Yr =
                                                              (ai =
                                                                  (Yt = (yn = vs[Ae] || (vs[Ae] = {}))[X] || [])[0] ===
                                                                      ve && Yt[1]) && Yt[2],
                                                              Mt = ai && vs.childNodes[ai];
                                                          (Mt = (++ai && Mt && Mt[gi]) || (Yr = ai = 0) || ss.pop());

                                                      )
                                                          if (1 === Mt.nodeType && ++Yr && Mt === rt) {
                                                              yn[X] = [ve, ai, Yr];
                                                              break;
                                                          }
                                                  } else if (
                                                      (Ya &&
                                                          (Yr = ai =
                                                              (Yt = (yn = rt[Ae] || (rt[Ae] = {}))[X] || [])[0] ===
                                                                  ve && Yt[1]),
                                                      !1 === Yr)
                                                  )
                                                      for (
                                                          ;
                                                          (Mt = (++ai && Mt && Mt[gi]) || (Yr = ai = 0) || ss.pop()) &&
                                                          (!(pt ? Ne(Mt, js) : 1 === Mt.nodeType) ||
                                                              !++Yr ||
                                                              (Ya && ((yn = Mt[Ae] || (Mt[Ae] = {}))[X] = [ve, Yr]),
                                                              Mt !== rt));

                                                      );
                                                  return (Yr -= de) === we || (Yr % we == 0 && Yr / we >= 0);
                                              }
                                          };
                                },
                                PSEUDO: function (X, le) {
                                    var be,
                                        we =
                                            h.pseudos[X] ||
                                            h.setFilters[X.toLowerCase()] ||
                                            Vn.error('unsupported pseudo: ' + X);
                                    return we[Ae]
                                        ? we(le)
                                        : we.length > 1
                                        ? ((be = [X, X, '', le]),
                                          h.setFilters.hasOwnProperty(X.toLowerCase())
                                              ? yr(function (de, Qe) {
                                                    for (var it, pt = we(de, le), rt = pt.length; rt--; )
                                                        de[(it = T.call(de, pt[rt]))] = !(Qe[it] = pt[rt]);
                                                })
                                              : function (de) {
                                                    return we(de, 0, be);
                                                })
                                        : we;
                                },
                            },
                            pseudos: {
                                not: yr(function (X) {
                                    var le = [],
                                        be = [],
                                        we = na(X.replace(Pt, '$1'));
                                    return we[Ae]
                                        ? yr(function (de, Qe, it, pt) {
                                              for (var rt, It = we(de, null, pt, []), wt = de.length; wt--; )
                                                  (rt = It[wt]) && (de[wt] = !(Qe[wt] = rt));
                                          })
                                        : function (de, Qe, it) {
                                              return (le[0] = de), we(le, null, it, be), (le[0] = null), !be.pop();
                                          };
                                }),
                                has: yr(function (X) {
                                    return function (le) {
                                        return Vn(X, le).length > 0;
                                    };
                                }),
                                contains: yr(function (X) {
                                    return (
                                        (X = X.replace(co, Eo)),
                                        function (le) {
                                            return (le.textContent || b.text(le)).indexOf(X) > -1;
                                        }
                                    );
                                }),
                                lang: yr(function (X) {
                                    return (
                                        Ha.test(X || '') || Vn.error('unsupported lang: ' + X),
                                        (X = X.replace(co, Eo).toLowerCase()),
                                        function (le) {
                                            var be;
                                            do {
                                                if (
                                                    (be = J
                                                        ? le.lang
                                                        : le.getAttribute('xml:lang') || le.getAttribute('lang'))
                                                )
                                                    return (be = be.toLowerCase()) === X || 0 === be.indexOf(X + '-');
                                            } while ((le = le.parentNode) && 1 === le.nodeType);
                                            return !1;
                                        }
                                    );
                                }),
                                target: function (X) {
                                    var le = M.location && M.location.hash;
                                    return le && le.slice(1) === X.id;
                                },
                                root: function (X) {
                                    return X === ne;
                                },
                                focus: function (X) {
                                    return (
                                        X ===
                                            (function C0() {
                                                try {
                                                    return B.activeElement;
                                                } catch {}
                                            })() &&
                                        B.hasFocus() &&
                                        !!(X.type || X.href || ~X.tabIndex)
                                    );
                                },
                                enabled: Yc(!1),
                                disabled: Yc(!0),
                                checked: function (X) {
                                    return (Ne(X, 'input') && !!X.checked) || (Ne(X, 'option') && !!X.selected);
                                },
                                selected: function (X) {
                                    return !0 === X.selected;
                                },
                                empty: function (X) {
                                    for (X = X.firstChild; X; X = X.nextSibling) if (X.nodeType < 6) return !1;
                                    return !0;
                                },
                                parent: function (X) {
                                    return !h.pseudos.empty(X);
                                },
                                header: function (X) {
                                    return lo.test(X.nodeName);
                                },
                                input: function (X) {
                                    return Ys.test(X.nodeName);
                                },
                                button: function (X) {
                                    return (Ne(X, 'input') && 'button' === X.type) || Ne(X, 'button');
                                },
                                text: function (X) {
                                    var le;
                                    return (
                                        Ne(X, 'input') &&
                                        'text' === X.type &&
                                        (null == (le = X.getAttribute('type')) || 'text' === le.toLowerCase())
                                    );
                                },
                                first: ho(function () {
                                    return [0];
                                }),
                                last: ho(function (X, le) {
                                    return [le - 1];
                                }),
                                eq: ho(function (X, le, be) {
                                    return [be < 0 ? be + le : be];
                                }),
                                even: ho(function (X, le) {
                                    for (var be = 0; be < le; be += 2) X.push(be);
                                    return X;
                                }),
                                odd: ho(function (X, le) {
                                    for (var be = 1; be < le; be += 2) X.push(be);
                                    return X;
                                }),
                                lt: ho(function (X, le, be) {
                                    var we;
                                    for (we = be < 0 ? be + le : be > le ? le : be; --we >= 0; ) X.push(we);
                                    return X;
                                }),
                                gt: ho(function (X, le, be) {
                                    for (var we = be < 0 ? be + le : be; ++we < le; ) X.push(we);
                                    return X;
                                }),
                            },
                        }).pseudos.nth = h.pseudos.eq),
                    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                        h.pseudos[u] = rs(u);
                    for (u in { submit: !0, reset: !0 }) h.pseudos[u] = uo(u);
                    function Wl() {}
                    function ea(X, le) {
                        var be,
                            we,
                            de,
                            Qe,
                            it,
                            pt,
                            rt,
                            It = In[X + ' '];
                        if (It) return le ? 0 : It.slice(0);
                        for (it = X, pt = [], rt = h.preFilter; it; ) {
                            for (Qe in ((!be || (we = Hi.exec(it))) &&
                                (we && (it = it.slice(we[0].length) || it), pt.push((de = []))),
                            (be = !1),
                            (we = _r.exec(it)) &&
                                ((be = we.shift()),
                                de.push({ value: be, type: we[0].replace(Pt, ' ') }),
                                (it = it.slice(be.length))),
                            h.filter))
                                (we = Ue[Qe].exec(it)) &&
                                    (!rt[Qe] || (we = rt[Qe](we))) &&
                                    ((be = we.shift()),
                                    de.push({ value: be, type: Qe, matches: we }),
                                    (it = it.slice(be.length)));
                            if (!be) break;
                        }
                        return le ? it.length : it ? Vn.error(X) : In(X, pt).slice(0);
                    }
                    function jc(X) {
                        for (var le = 0, be = X.length, we = ''; le < be; le++) we += X[le].value;
                        return we;
                    }
                    function br(X, le, be) {
                        var we = le.dir,
                            de = le.next,
                            Qe = de || we,
                            it = be && 'parentNode' === Qe,
                            pt = He++;
                        return le.first
                            ? function (rt, It, wt) {
                                  for (; (rt = rt[we]); ) if (1 === rt.nodeType || it) return X(rt, It, wt);
                                  return !1;
                              }
                            : function (rt, It, wt) {
                                  var Yt,
                                      yn,
                                      Mt = [ve, pt];
                                  if (wt) {
                                      for (; (rt = rt[we]); ) if ((1 === rt.nodeType || it) && X(rt, It, wt)) return !0;
                                  } else
                                      for (; (rt = rt[we]); )
                                          if (1 === rt.nodeType || it)
                                              if (((yn = rt[Ae] || (rt[Ae] = {})), de && Ne(rt, de))) rt = rt[we] || rt;
                                              else {
                                                  if ((Yt = yn[Qe]) && Yt[0] === ve && Yt[1] === pt)
                                                      return (Mt[2] = Yt[2]);
                                                  if (((yn[Qe] = Mt), (Mt[2] = X(rt, It, wt)))) return !0;
                                              }
                                  return !1;
                              };
                    }
                    function vl(X) {
                        return X.length > 1
                            ? function (le, be, we) {
                                  for (var de = X.length; de--; ) if (!X[de](le, be, we)) return !1;
                                  return !0;
                              }
                            : X[0];
                    }
                    function _l(X, le, be, we, de) {
                        for (var Qe, it = [], pt = 0, rt = X.length, It = null != le; pt < rt; pt++)
                            (Qe = X[pt]) && (!be || be(Qe, we, de)) && (it.push(Qe), It && le.push(pt));
                        return it;
                    }
                    function qa(X, le, be, we, de, Qe) {
                        return (
                            we && !we[Ae] && (we = qa(we)),
                            de && !de[Ae] && (de = qa(de, Qe)),
                            yr(function (it, pt, rt, It) {
                                var wt,
                                    Yt,
                                    yn,
                                    Mt,
                                    ai = [],
                                    ss = [],
                                    gi = pt.length,
                                    vs =
                                        it ||
                                        (function ta(X, le, be) {
                                            for (var we = 0, de = le.length; we < de; we++) Vn(X, le[we], be);
                                            return be;
                                        })(le || '*', rt.nodeType ? [rt] : rt, []),
                                    js = !X || (!it && le) ? vs : _l(vs, ai, X, rt, It);
                                if ((be ? be(js, (Mt = de || (it ? X : gi || we) ? [] : pt), rt, It) : (Mt = js), we))
                                    for (wt = _l(Mt, ss), we(wt, [], rt, It), Yt = wt.length; Yt--; )
                                        (yn = wt[Yt]) && (Mt[ss[Yt]] = !(js[ss[Yt]] = yn));
                                if (it) {
                                    if (de || X) {
                                        if (de) {
                                            for (wt = [], Yt = Mt.length; Yt--; )
                                                (yn = Mt[Yt]) && wt.push((js[Yt] = yn));
                                            de(null, (Mt = []), wt, It);
                                        }
                                        for (Yt = Mt.length; Yt--; )
                                            (yn = Mt[Yt]) &&
                                                (wt = de ? T.call(it, yn) : ai[Yt]) > -1 &&
                                                (it[wt] = !(pt[wt] = yn));
                                    }
                                } else (Mt = _l(Mt === pt ? Mt.splice(gi, Mt.length) : Mt)), de ? de(null, pt, Mt, It) : A.apply(pt, Mt);
                            })
                        );
                    }
                    function Ls(X) {
                        for (
                            var le,
                                be,
                                we,
                                de = X.length,
                                Qe = h.relative[X[0].type],
                                it = Qe || h.relative[' '],
                                pt = Qe ? 1 : 0,
                                rt = br(
                                    function (Yt) {
                                        return Yt === le;
                                    },
                                    it,
                                    !0,
                                ),
                                It = br(
                                    function (Yt) {
                                        return T.call(le, Yt) > -1;
                                    },
                                    it,
                                    !0,
                                ),
                                wt = [
                                    function (Yt, yn, Mt) {
                                        var ai =
                                            (!Qe && (Mt || yn != y)) ||
                                            ((le = yn).nodeType ? rt(Yt, yn, Mt) : It(Yt, yn, Mt));
                                        return (le = null), ai;
                                    },
                                ];
                            pt < de;
                            pt++
                        )
                            if ((be = h.relative[X[pt].type])) wt = [br(vl(wt), be)];
                            else {
                                if ((be = h.filter[X[pt].type].apply(null, X[pt].matches))[Ae]) {
                                    for (we = ++pt; we < de && !h.relative[X[we].type]; we++);
                                    return qa(
                                        pt > 1 && vl(wt),
                                        pt > 1 &&
                                            jc(
                                                X.slice(0, pt - 1).concat({ value: ' ' === X[pt - 2].type ? '*' : '' }),
                                            ).replace(Pt, '$1'),
                                        be,
                                        pt < we && Ls(X.slice(pt, we)),
                                        we < de && Ls((X = X.slice(we))),
                                        we < de && jc(X),
                                    );
                                }
                                wt.push(be);
                            }
                        return vl(wt);
                    }
                    function na(X, le) {
                        var be,
                            we = [],
                            de = [],
                            Qe = Xt[X + ' '];
                        if (!Qe) {
                            for (le || (le = ea(X)), be = le.length; be--; )
                                (Qe = Ls(le[be]))[Ae] ? we.push(Qe) : de.push(Qe);
                            (Qe = Xt(
                                X,
                                (function An(X, le) {
                                    var be = le.length > 0,
                                        we = X.length > 0,
                                        de = function (Qe, it, pt, rt, It) {
                                            var wt,
                                                Yt,
                                                yn,
                                                Mt = 0,
                                                ai = '0',
                                                ss = Qe && [],
                                                gi = [],
                                                vs = y,
                                                js = Qe || (we && h.find.TAG('*', It)),
                                                Ya = (ve += null == vs ? 1 : Math.random() || 0.1),
                                                Yr = js.length;
                                            for (
                                                It && (y = it == B || it || It);
                                                ai !== Yr && null != (wt = js[ai]);
                                                ai++
                                            ) {
                                                if (we && wt) {
                                                    for (
                                                        Yt = 0, !it && wt.ownerDocument != B && (gs(wt), (pt = !J));
                                                        (yn = X[Yt++]);

                                                    )
                                                        if (yn(wt, it || B, pt)) {
                                                            A.call(rt, wt);
                                                            break;
                                                        }
                                                    It && (ve = Ya);
                                                }
                                                be && ((wt = !yn && wt) && Mt--, Qe && ss.push(wt));
                                            }
                                            if (((Mt += ai), be && ai !== Mt)) {
                                                for (Yt = 0; (yn = le[Yt++]); ) yn(ss, gi, it, pt);
                                                if (Qe) {
                                                    if (Mt > 0)
                                                        for (; ai--; ) ss[ai] || gi[ai] || (gi[ai] = at.call(rt));
                                                    gi = _l(gi);
                                                }
                                                A.apply(rt, gi),
                                                    It &&
                                                        !Qe &&
                                                        gi.length > 0 &&
                                                        Mt + le.length > 1 &&
                                                        b.uniqueSort(rt);
                                            }
                                            return It && ((ve = Ya), (y = vs)), ss;
                                        };
                                    return be ? yr(de) : de;
                                })(de, we),
                            )),
                                (Qe.selector = X);
                        }
                        return Qe;
                    }
                    function $c(X, le, be, we) {
                        var de,
                            Qe,
                            it,
                            pt,
                            rt,
                            It = 'function' == typeof X && X,
                            wt = !we && ea((X = It.selector || X));
                        if (((be = be || []), 1 === wt.length)) {
                            if (
                                (Qe = wt[0] = wt[0].slice(0)).length > 2 &&
                                'ID' === (it = Qe[0]).type &&
                                9 === le.nodeType &&
                                J &&
                                h.relative[Qe[1].type]
                            ) {
                                if (!(le = (h.find.ID(it.matches[0].replace(co, Eo), le) || [])[0])) return be;
                                It && (le = le.parentNode), (X = X.slice(Qe.shift().value.length));
                            }
                            for (
                                de = Ue.needsContext.test(X) ? 0 : Qe.length;
                                de-- && !h.relative[(pt = (it = Qe[de]).type)];

                            )
                                if (
                                    (rt = h.find[pt]) &&
                                    (we = rt(
                                        it.matches[0].replace(co, Eo),
                                        (qc.test(Qe[0].type) && Ba(le.parentNode)) || le,
                                    ))
                                ) {
                                    if ((Qe.splice(de, 1), !(X = we.length && jc(Qe)))) return A.apply(be, we), be;
                                    break;
                                }
                        }
                        return (It || na(X, wt))(we, le, !J, be, !le || (qc.test(X) && Ba(le.parentNode)) || le), be;
                    }
                    (Wl.prototype = h.filters = h.pseudos),
                        (h.setFilters = new Wl()),
                        (j.sortStable = Ae.split('').sort(Vi).join('') === Ae),
                        gs(),
                        (j.sortDetached = Ua(function (X) {
                            return 1 & X.compareDocumentPosition(B.createElement('fieldset'));
                        })),
                        (b.find = Vn),
                        (b.expr[':'] = b.expr.pseudos),
                        (b.unique = b.uniqueSort),
                        (Vn.compile = na),
                        (Vn.select = $c),
                        (Vn.setDocument = gs),
                        (Vn.tokenize = ea),
                        (Vn.escape = b.escapeSelector),
                        (Vn.getText = b.text),
                        (Vn.isXML = b.isXMLDoc),
                        (Vn.selectors = b.expr),
                        (Vn.support = b.support),
                        (Vn.uniqueSort = b.uniqueSort);
                })();
                var Vt = function (u, h, y) {
                        for (var w = [], I = void 0 !== y; (u = u[h]) && 9 !== u.nodeType; )
                            if (1 === u.nodeType) {
                                if (I && b(u).is(y)) break;
                                w.push(u);
                            }
                        return w;
                    },
                    an = function (u, h) {
                        for (var y = []; u; u = u.nextSibling) 1 === u.nodeType && u !== h && y.push(u);
                        return y;
                    },
                    qe = b.expr.match.needsContext,
                    ot = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
                function ke(u, h, y) {
                    return N(h)
                        ? b.grep(u, function (w, I) {
                              return !!h.call(w, I, w) !== y;
                          })
                        : h.nodeType
                        ? b.grep(u, function (w) {
                              return (w === h) !== y;
                          })
                        : 'string' != typeof h
                        ? b.grep(u, function (w) {
                              return T.call(h, w) > -1 !== y;
                          })
                        : b.filter(h, u, y);
                }
                (b.filter = function (u, h, y) {
                    var w = h[0];
                    return (
                        y && (u = ':not(' + u + ')'),
                        1 === h.length && 1 === w.nodeType
                            ? b.find.matchesSelector(w, u)
                                ? [w]
                                : []
                            : b.find.matches(
                                  u,
                                  b.grep(h, function (I) {
                                      return 1 === I.nodeType;
                                  }),
                              )
                    );
                }),
                    b.fn.extend({
                        find: function (u) {
                            var h,
                                y,
                                w = this.length,
                                I = this;
                            if ('string' != typeof u)
                                return this.pushStack(
                                    b(u).filter(function () {
                                        for (h = 0; h < w; h++) if (b.contains(I[h], this)) return !0;
                                    }),
                                );
                            for (y = this.pushStack([]), h = 0; h < w; h++) b.find(u, I[h], y);
                            return w > 1 ? b.uniqueSort(y) : y;
                        },
                        filter: function (u) {
                            return this.pushStack(ke(this, u || [], !1));
                        },
                        not: function (u) {
                            return this.pushStack(ke(this, u || [], !0));
                        },
                        is: function (u) {
                            return !!ke(this, 'string' == typeof u && qe.test(u) ? b(u) : u || [], !1).length;
                        },
                    });
                var Ce,
                    Pe = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
                    _t = (b.fn.init = function (u, h, y) {
                        var w, I;
                        if (!u) return this;
                        if (((y = y || Ce), 'string' == typeof u)) {
                            if (
                                !(w =
                                    '<' === u[0] && '>' === u[u.length - 1] && u.length >= 3
                                        ? [null, u, null]
                                        : Pe.exec(u)) ||
                                (!w[1] && h)
                            )
                                return !h || h.jquery ? (h || y).find(u) : this.constructor(h).find(u);
                            if (w[1]) {
                                if (
                                    (b.merge(
                                        this,
                                        b.parseHTML(
                                            w[1],
                                            (h = h instanceof b ? h[0] : h) && h.nodeType ? h.ownerDocument || h : Q,
                                            !0,
                                        ),
                                    ),
                                    ot.test(w[1]) && b.isPlainObject(h))
                                )
                                    for (w in h) N(this[w]) ? this[w](h[w]) : this.attr(w, h[w]);
                                return this;
                            }
                            return (I = Q.getElementById(w[2])) && ((this[0] = I), (this.length = 1)), this;
                        }
                        return u.nodeType
                            ? ((this[0] = u), (this.length = 1), this)
                            : N(u)
                            ? void 0 !== y.ready
                                ? y.ready(u)
                                : u(b)
                            : b.makeArray(u, this);
                    });
                (_t.prototype = b.fn), (Ce = b(Q));
                var Ht = /^(?:parents|prev(?:Until|All))/,
                    Qt = { children: !0, contents: !0, next: !0, prev: !0 };
                function _n(u, h) {
                    for (; (u = u[h]) && 1 !== u.nodeType; );
                    return u;
                }
                b.fn.extend({
                    has: function (u) {
                        var h = b(u, this),
                            y = h.length;
                        return this.filter(function () {
                            for (var w = 0; w < y; w++) if (b.contains(this, h[w])) return !0;
                        });
                    },
                    closest: function (u, h) {
                        var y,
                            w = 0,
                            I = this.length,
                            A = [],
                            B = 'string' != typeof u && b(u);
                        if (!qe.test(u))
                            for (; w < I; w++)
                                for (y = this[w]; y && y !== h; y = y.parentNode)
                                    if (
                                        y.nodeType < 11 &&
                                        (B ? B.index(y) > -1 : 1 === y.nodeType && b.find.matchesSelector(y, u))
                                    ) {
                                        A.push(y);
                                        break;
                                    }
                        return this.pushStack(A.length > 1 ? b.uniqueSort(A) : A);
                    },
                    index: function (u) {
                        return u
                            ? 'string' == typeof u
                                ? T.call(b(u), this[0])
                                : T.call(this, u.jquery ? u[0] : u)
                            : this[0] && this[0].parentNode
                            ? this.first().prevAll().length
                            : -1;
                    },
                    add: function (u, h) {
                        return this.pushStack(b.uniqueSort(b.merge(this.get(), b(u, h))));
                    },
                    addBack: function (u) {
                        return this.add(null == u ? this.prevObject : this.prevObject.filter(u));
                    },
                }),
                    b.each(
                        {
                            parent: function (u) {
                                var h = u.parentNode;
                                return h && 11 !== h.nodeType ? h : null;
                            },
                            parents: function (u) {
                                return Vt(u, 'parentNode');
                            },
                            parentsUntil: function (u, h, y) {
                                return Vt(u, 'parentNode', y);
                            },
                            next: function (u) {
                                return _n(u, 'nextSibling');
                            },
                            prev: function (u) {
                                return _n(u, 'previousSibling');
                            },
                            nextAll: function (u) {
                                return Vt(u, 'nextSibling');
                            },
                            prevAll: function (u) {
                                return Vt(u, 'previousSibling');
                            },
                            nextUntil: function (u, h, y) {
                                return Vt(u, 'nextSibling', y);
                            },
                            prevUntil: function (u, h, y) {
                                return Vt(u, 'previousSibling', y);
                            },
                            siblings: function (u) {
                                return an((u.parentNode || {}).firstChild, u);
                            },
                            children: function (u) {
                                return an(u.firstChild);
                            },
                            contents: function (u) {
                                return null != u.contentDocument && $(u.contentDocument)
                                    ? u.contentDocument
                                    : (Ne(u, 'template') && (u = u.content || u), b.merge([], u.childNodes));
                            },
                        },
                        function (u, h) {
                            b.fn[u] = function (y, w) {
                                var I = b.map(this, h, y);
                                return (
                                    'Until' !== u.slice(-5) && (w = y),
                                    w && 'string' == typeof w && (I = b.filter(w, I)),
                                    this.length > 1 && (Qt[u] || b.uniqueSort(I), Ht.test(u) && I.reverse()),
                                    this.pushStack(I)
                                );
                            };
                        },
                    );
                var sn = /[^\x20\t\r\n\f]+/g;
                function et(u) {
                    return u;
                }
                function qn(u) {
                    throw u;
                }
                function Ji(u, h, y, w) {
                    var I;
                    try {
                        u && N((I = u.promise))
                            ? I.call(u).done(h).fail(y)
                            : u && N((I = u.then))
                            ? I.call(u, h, y)
                            : h.apply(void 0, [u].slice(w));
                    } catch (A) {
                        y.apply(void 0, [A]);
                    }
                }
                (b.Callbacks = function (u) {
                    u =
                        'string' == typeof u
                            ? (function xn(u) {
                                  var h = {};
                                  return (
                                      b.each(u.match(sn) || [], function (y, w) {
                                          h[w] = !0;
                                      }),
                                      h
                                  );
                              })(u)
                            : b.extend({}, u);
                    var h,
                        y,
                        w,
                        I,
                        A = [],
                        B = [],
                        ne = -1,
                        J = function () {
                            for (I = I || u.once, w = h = !0; B.length; ne = -1)
                                for (y = B.shift(); ++ne < A.length; )
                                    !1 === A[ne].apply(y[0], y[1]) && u.stopOnFalse && ((ne = A.length), (y = !1));
                            u.memory || (y = !1), (h = !1), I && (A = y ? [] : '');
                        },
                        re = {
                            add: function () {
                                return (
                                    A &&
                                        (y && !h && ((ne = A.length - 1), B.push(y)),
                                        (function Te(Ae) {
                                            b.each(Ae, function (ve, He) {
                                                N(He)
                                                    ? (!u.unique || !re.has(He)) && A.push(He)
                                                    : He && He.length && 'string' !== De(He) && Te(He);
                                            });
                                        })(arguments),
                                        y && !h && J()),
                                    this
                                );
                            },
                            remove: function () {
                                return (
                                    b.each(arguments, function (Te, Ae) {
                                        for (var ve; (ve = b.inArray(Ae, A, ve)) > -1; )
                                            A.splice(ve, 1), ve <= ne && ne--;
                                    }),
                                    this
                                );
                            },
                            has: function (Te) {
                                return Te ? b.inArray(Te, A) > -1 : A.length > 0;
                            },
                            empty: function () {
                                return A && (A = []), this;
                            },
                            disable: function () {
                                return (I = B = []), (A = y = ''), this;
                            },
                            disabled: function () {
                                return !A;
                            },
                            lock: function () {
                                return (I = B = []), !y && !h && (A = y = ''), this;
                            },
                            locked: function () {
                                return !!I;
                            },
                            fireWith: function (Te, Ae) {
                                return (
                                    I || ((Ae = [Te, (Ae = Ae || []).slice ? Ae.slice() : Ae]), B.push(Ae), h || J()),
                                    this
                                );
                            },
                            fire: function () {
                                return re.fireWith(this, arguments), this;
                            },
                            fired: function () {
                                return !!w;
                            },
                        };
                    return re;
                }),
                    b.extend({
                        Deferred: function (u) {
                            var h = [
                                    ['notify', 'progress', b.Callbacks('memory'), b.Callbacks('memory'), 2],
                                    [
                                        'resolve',
                                        'done',
                                        b.Callbacks('once memory'),
                                        b.Callbacks('once memory'),
                                        0,
                                        'resolved',
                                    ],
                                    [
                                        'reject',
                                        'fail',
                                        b.Callbacks('once memory'),
                                        b.Callbacks('once memory'),
                                        1,
                                        'rejected',
                                    ],
                                ],
                                y = 'pending',
                                w = {
                                    state: function () {
                                        return y;
                                    },
                                    always: function () {
                                        return I.done(arguments).fail(arguments), this;
                                    },
                                    catch: function (A) {
                                        return w.then(null, A);
                                    },
                                    pipe: function () {
                                        var A = arguments;
                                        return b
                                            .Deferred(function (B) {
                                                b.each(h, function (ne, J) {
                                                    var re = N(A[J[4]]) && A[J[4]];
                                                    I[J[1]](function () {
                                                        var Te = re && re.apply(this, arguments);
                                                        Te && N(Te.promise)
                                                            ? Te.promise()
                                                                  .progress(B.notify)
                                                                  .done(B.resolve)
                                                                  .fail(B.reject)
                                                            : B[J[0] + 'With'](this, re ? [Te] : arguments);
                                                    });
                                                }),
                                                    (A = null);
                                            })
                                            .promise();
                                    },
                                    then: function (A, B, ne) {
                                        var J = 0;
                                        function re(Te, Ae, ve, He) {
                                            return function () {
                                                var Kt = this,
                                                    In = arguments,
                                                    Xt = function () {
                                                        var Vi, oo;
                                                        if (!(Te < J)) {
                                                            if ((Vi = ve.apply(Kt, In)) === Ae.promise())
                                                                throw new TypeError('Thenable self-resolution');
                                                            N(
                                                                (oo =
                                                                    Vi &&
                                                                    ('object' == typeof Vi ||
                                                                        'function' == typeof Vi) &&
                                                                    Vi.then),
                                                            )
                                                                ? He
                                                                    ? oo.call(Vi, re(J, Ae, et, He), re(J, Ae, qn, He))
                                                                    : (J++,
                                                                      oo.call(
                                                                          Vi,
                                                                          re(J, Ae, et, He),
                                                                          re(J, Ae, qn, He),
                                                                          re(J, Ae, et, Ae.notifyWith),
                                                                      ))
                                                                : (ve !== et && ((Kt = void 0), (In = [Vi])),
                                                                  (He || Ae.resolveWith)(Kt, In));
                                                        }
                                                    },
                                                    nr = He
                                                        ? Xt
                                                        : function () {
                                                              try {
                                                                  Xt();
                                                              } catch (Vi) {
                                                                  b.Deferred.exceptionHook &&
                                                                      b.Deferred.exceptionHook(Vi, nr.error),
                                                                      Te + 1 >= J &&
                                                                          (ve !== qn && ((Kt = void 0), (In = [Vi])),
                                                                          Ae.rejectWith(Kt, In));
                                                              }
                                                          };
                                                Te
                                                    ? nr()
                                                    : (b.Deferred.getErrorHook
                                                          ? (nr.error = b.Deferred.getErrorHook())
                                                          : b.Deferred.getStackHook &&
                                                            (nr.error = b.Deferred.getStackHook()),
                                                      M.setTimeout(nr));
                                            };
                                        }
                                        return b
                                            .Deferred(function (Te) {
                                                h[0][3].add(re(0, Te, N(ne) ? ne : et, Te.notifyWith)),
                                                    h[1][3].add(re(0, Te, N(A) ? A : et)),
                                                    h[2][3].add(re(0, Te, N(B) ? B : qn));
                                            })
                                            .promise();
                                    },
                                    promise: function (A) {
                                        return null != A ? b.extend(A, w) : w;
                                    },
                                },
                                I = {};
                            return (
                                b.each(h, function (A, B) {
                                    var ne = B[2],
                                        J = B[5];
                                    (w[B[1]] = ne.add),
                                        J &&
                                            ne.add(
                                                function () {
                                                    y = J;
                                                },
                                                h[3 - A][2].disable,
                                                h[3 - A][3].disable,
                                                h[0][2].lock,
                                                h[0][3].lock,
                                            ),
                                        ne.add(B[3].fire),
                                        (I[B[0]] = function () {
                                            return I[B[0] + 'With'](this === I ? void 0 : this, arguments), this;
                                        }),
                                        (I[B[0] + 'With'] = ne.fireWith);
                                }),
                                w.promise(I),
                                u && u.call(I, I),
                                I
                            );
                        },
                        when: function (u) {
                            var h = arguments.length,
                                y = h,
                                w = Array(y),
                                I = v.call(arguments),
                                A = b.Deferred(),
                                B = function (ne) {
                                    return function (J) {
                                        (w[ne] = this),
                                            (I[ne] = arguments.length > 1 ? v.call(arguments) : J),
                                            --h || A.resolveWith(w, I);
                                    };
                                };
                            if (
                                h <= 1 &&
                                (Ji(u, A.done(B(y)).resolve, A.reject, !h),
                                'pending' === A.state() || N(I[y] && I[y].then))
                            )
                                return A.then();
                            for (; y--; ) Ji(I[y], B(y), A.reject);
                            return A.promise();
                        },
                    });
                var Ti = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
                (b.Deferred.exceptionHook = function (u, h) {
                    M.console &&
                        M.console.warn &&
                        u &&
                        Ti.test(u.name) &&
                        M.console.warn('jQuery.Deferred exception: ' + u.message, u.stack, h);
                }),
                    (b.readyException = function (u) {
                        M.setTimeout(function () {
                            throw u;
                        });
                    });
                var ii = b.Deferred();
                function Vs() {
                    Q.removeEventListener('DOMContentLoaded', Vs), M.removeEventListener('load', Vs), b.ready();
                }
                (b.fn.ready = function (u) {
                    return (
                        ii.then(u).catch(function (h) {
                            b.readyException(h);
                        }),
                        this
                    );
                }),
                    b.extend({
                        isReady: !1,
                        readyWait: 1,
                        ready: function (u) {
                            (!0 === u ? --b.readyWait : b.isReady) ||
                                ((b.isReady = !0), !(!0 !== u && --b.readyWait > 0) && ii.resolveWith(Q, [b]));
                        },
                    }),
                    (b.ready.then = ii.then),
                    'complete' === Q.readyState || ('loading' !== Q.readyState && !Q.documentElement.doScroll)
                        ? M.setTimeout(b.ready)
                        : (Q.addEventListener('DOMContentLoaded', Vs), M.addEventListener('load', Vs));
                var rr = function (u, h, y, w, I, A, B) {
                        var ne = 0,
                            J = u.length,
                            re = null == y;
                        if ('object' === De(y)) for (ne in ((I = !0), y)) rr(u, h, ne, y[ne], !0, A, B);
                        else if (
                            void 0 !== w &&
                            ((I = !0),
                            N(w) || (B = !0),
                            re &&
                                (B
                                    ? (h.call(u, w), (h = null))
                                    : ((re = h),
                                      (h = function (Te, Ae, ve) {
                                          return re.call(b(Te), ve);
                                      }))),
                            h)
                        )
                            for (; ne < J; ne++) h(u[ne], y, B ? w : w.call(u[ne], ne, h(u[ne], y)));
                        return I ? u : re ? h.call(u) : J ? h(u[0], y) : A;
                    },
                    Ri = /^-ms-/,
                    Oi = /-([a-z])/g;
                function Hs(u, h) {
                    return h.toUpperCase();
                }
                function pr(u) {
                    return u.replace(Ri, 'ms-').replace(Oi, Hs);
                }
                var Kn = function (u) {
                    return 1 === u.nodeType || 9 === u.nodeType || !+u.nodeType;
                };
                function Us() {
                    this.expando = b.expando + Us.uid++;
                }
                (Us.uid = 1),
                    (Us.prototype = {
                        cache: function (u) {
                            var h = u[this.expando];
                            return (
                                h ||
                                    ((h = {}),
                                    Kn(u) &&
                                        (u.nodeType
                                            ? (u[this.expando] = h)
                                            : Object.defineProperty(u, this.expando, { value: h, configurable: !0 }))),
                                h
                            );
                        },
                        set: function (u, h, y) {
                            var w,
                                I = this.cache(u);
                            if ('string' == typeof h) I[pr(h)] = y;
                            else for (w in h) I[pr(w)] = h[w];
                            return I;
                        },
                        get: function (u, h) {
                            return void 0 === h ? this.cache(u) : u[this.expando] && u[this.expando][pr(h)];
                        },
                        access: function (u, h, y) {
                            return void 0 === h || (h && 'string' == typeof h && void 0 === y)
                                ? this.get(u, h)
                                : (this.set(u, h, y), void 0 !== y ? y : h);
                        },
                        remove: function (u, h) {
                            var y,
                                w = u[this.expando];
                            if (void 0 !== w) {
                                if (void 0 !== h)
                                    for (
                                        y = (h = Array.isArray(h)
                                            ? h.map(pr)
                                            : ((h = pr(h)) in w)
                                            ? [h]
                                            : h.match(sn) || []).length;
                                        y--;

                                    )
                                        delete w[h[y]];
                                (void 0 === h || b.isEmptyObject(w)) &&
                                    (u.nodeType ? (u[this.expando] = void 0) : delete u[this.expando]);
                            }
                        },
                        hasData: function (u) {
                            var h = u[this.expando];
                            return void 0 !== h && !b.isEmptyObject(h);
                        },
                    });
                var ft = new Us(),
                    gn = new Us(),
                    Ut = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                    sr = /[A-Z]/g;
                function hl(u, h, y) {
                    var w;
                    if (void 0 === y && 1 === u.nodeType)
                        if (
                            ((w = 'data-' + h.replace(sr, '-$&').toLowerCase()),
                            'string' == typeof (y = u.getAttribute(w)))
                        ) {
                            try {
                                y = (function Es(u) {
                                    return (
                                        'true' === u ||
                                        ('false' !== u &&
                                            ('null' === u ? null : u === +u + '' ? +u : Ut.test(u) ? JSON.parse(u) : u))
                                    );
                                })(y);
                            } catch {}
                            gn.set(u, h, y);
                        } else y = void 0;
                    return y;
                }
                b.extend({
                    hasData: function (u) {
                        return gn.hasData(u) || ft.hasData(u);
                    },
                    data: function (u, h, y) {
                        return gn.access(u, h, y);
                    },
                    removeData: function (u, h) {
                        gn.remove(u, h);
                    },
                    _data: function (u, h, y) {
                        return ft.access(u, h, y);
                    },
                    _removeData: function (u, h) {
                        ft.remove(u, h);
                    },
                }),
                    b.fn.extend({
                        data: function (u, h) {
                            var y,
                                w,
                                I,
                                A = this[0],
                                B = A && A.attributes;
                            if (void 0 === u) {
                                if (this.length && ((I = gn.get(A)), 1 === A.nodeType && !ft.get(A, 'hasDataAttrs'))) {
                                    for (y = B.length; y--; )
                                        B[y] &&
                                            0 === (w = B[y].name).indexOf('data-') &&
                                            ((w = pr(w.slice(5))), hl(A, w, I[w]));
                                    ft.set(A, 'hasDataAttrs', !0);
                                }
                                return I;
                            }
                            return 'object' == typeof u
                                ? this.each(function () {
                                      gn.set(this, u);
                                  })
                                : rr(
                                      this,
                                      function (ne) {
                                          var J;
                                          if (A && void 0 === ne)
                                              return void 0 !== (J = gn.get(A, u)) || void 0 !== (J = hl(A, u))
                                                  ? J
                                                  : void 0;
                                          this.each(function () {
                                              gn.set(this, u, ne);
                                          });
                                      },
                                      null,
                                      h,
                                      arguments.length > 1,
                                      null,
                                      !0,
                                  );
                        },
                        removeData: function (u) {
                            return this.each(function () {
                                gn.remove(this, u);
                            });
                        },
                    }),
                    b.extend({
                        queue: function (u, h, y) {
                            var w;
                            if (u)
                                return (
                                    (w = ft.get(u, (h = (h || 'fx') + 'queue'))),
                                    y && (!w || Array.isArray(y) ? (w = ft.access(u, h, b.makeArray(y))) : w.push(y)),
                                    w || []
                                );
                        },
                        dequeue: function (u, h) {
                            var y = b.queue(u, (h = h || 'fx')),
                                w = y.length,
                                I = y.shift(),
                                A = b._queueHooks(u, h);
                            'inprogress' === I && ((I = y.shift()), w--),
                                I &&
                                    ('fx' === h && y.unshift('inprogress'),
                                    delete A.stop,
                                    I.call(
                                        u,
                                        function () {
                                            b.dequeue(u, h);
                                        },
                                        A,
                                    )),
                                !w && A && A.empty.fire();
                        },
                        _queueHooks: function (u, h) {
                            var y = h + 'queueHooks';
                            return (
                                ft.get(u, y) ||
                                ft.access(u, y, {
                                    empty: b.Callbacks('once memory').add(function () {
                                        ft.remove(u, [h + 'queue', y]);
                                    }),
                                })
                            );
                        },
                    }),
                    b.fn.extend({
                        queue: function (u, h) {
                            var y = 2;
                            return (
                                'string' != typeof u && ((h = u), (u = 'fx'), y--),
                                arguments.length < y
                                    ? b.queue(this[0], u)
                                    : void 0 === h
                                    ? this
                                    : this.each(function () {
                                          var w = b.queue(this, u, h);
                                          b._queueHooks(this, u),
                                              'fx' === u && 'inprogress' !== w[0] && b.dequeue(this, u);
                                      })
                            );
                        },
                        dequeue: function (u) {
                            return this.each(function () {
                                b.dequeue(this, u);
                            });
                        },
                        clearQueue: function (u) {
                            return this.queue(u || 'fx', []);
                        },
                        promise: function (u, h) {
                            var y,
                                w = 1,
                                I = b.Deferred(),
                                A = this,
                                B = this.length,
                                ne = function () {
                                    --w || I.resolveWith(A, [A]);
                                };
                            for ('string' != typeof u && ((h = u), (u = void 0)), u = u || 'fx'; B--; )
                                (y = ft.get(A[B], u + 'queueHooks')) && y.empty && (w++, y.empty.add(ne));
                            return ne(), I.promise(h);
                        },
                    });
                var Qo = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                    to = new RegExp('^(?:([+-])=|)(' + Qo + ')([a-z%]*)$', 'i'),
                    _e = ['Top', 'Right', 'Bottom', 'Left'],
                    ye = Q.documentElement,
                    on = function (u) {
                        return b.contains(u.ownerDocument, u);
                    },
                    kn = { composed: !0 };
                ye.getRootNode &&
                    (on = function (u) {
                        return b.contains(u.ownerDocument, u) || u.getRootNode(kn) === u.ownerDocument;
                    });
                var Qn = function (u, h) {
                    return (
                        'none' === (u = h || u).style.display ||
                        ('' === u.style.display && on(u) && 'none' === b.css(u, 'display'))
                    );
                };
                function lt(u, h, y, w) {
                    var I,
                        A,
                        B = 20,
                        ne = w
                            ? function () {
                                  return w.cur();
                              }
                            : function () {
                                  return b.css(u, h, '');
                              },
                        J = ne(),
                        re = (y && y[3]) || (b.cssNumber[h] ? '' : 'px'),
                        Te = u.nodeType && (b.cssNumber[h] || ('px' !== re && +J)) && to.exec(b.css(u, h));
                    if (Te && Te[3] !== re) {
                        for (re = re || Te[3], Te = +(J /= 2) || 1; B--; )
                            b.style(u, h, Te + re), (1 - A) * (1 - (A = ne() / J || 0.5)) <= 0 && (B = 0), (Te /= A);
                        b.style(u, h, (Te *= 2) + re), (y = y || []);
                    }
                    return (
                        y &&
                            ((Te = +Te || +J || 0),
                            (I = y[1] ? Te + (y[1] + 1) * y[2] : +y[2]),
                            w && ((w.unit = re), (w.start = Te), (w.end = I))),
                        I
                    );
                }
                var Is = {};
                function As(u) {
                    var h,
                        y = u.ownerDocument,
                        w = u.nodeName,
                        I = Is[w];
                    return (
                        I ||
                        ((h = y.body.appendChild(y.createElement(w))),
                        (I = b.css(h, 'display')),
                        h.parentNode.removeChild(h),
                        'none' === I && (I = 'block'),
                        (Is[w] = I),
                        I)
                    );
                }
                function Yn(u, h) {
                    for (var y, w, I = [], A = 0, B = u.length; A < B; A++)
                        (w = u[A]).style &&
                            ((y = w.style.display),
                            h
                                ? ('none' === y &&
                                      ((I[A] = ft.get(w, 'display') || null), I[A] || (w.style.display = '')),
                                  '' === w.style.display && Qn(w) && (I[A] = As(w)))
                                : 'none' !== y && ((I[A] = 'none'), ft.set(w, 'display', y)));
                    for (A = 0; A < B; A++) null != I[A] && (u[A].style.display = I[A]);
                    return u;
                }
                b.fn.extend({
                    show: function () {
                        return Yn(this, !0);
                    },
                    hide: function () {
                        return Yn(this);
                    },
                    toggle: function (u) {
                        return 'boolean' == typeof u
                            ? u
                                ? this.show()
                                : this.hide()
                            : this.each(function () {
                                  Qn(this) ? b(this).show() : b(this).hide();
                              });
                    },
                });
                var h,
                    y,
                    Br = /^(?:checkbox|radio)$/i,
                    no = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
                    Tn = /^$|^module$|\/(?:java|ecma)script/i;
                (h = Q.createDocumentFragment().appendChild(Q.createElement('div'))),
                    (y = Q.createElement('input')).setAttribute('type', 'radio'),
                    y.setAttribute('checked', 'checked'),
                    y.setAttribute('name', 't'),
                    h.appendChild(y),
                    (j.checkClone = h.cloneNode(!0).cloneNode(!0).lastChild.checked),
                    (h.innerHTML = '<textarea>x</textarea>'),
                    (j.noCloneChecked = !!h.cloneNode(!0).lastChild.defaultValue),
                    (h.innerHTML = '<option></option>'),
                    (j.option = !!h.lastChild);
                var ni = {
                    thead: [1, '<table>', '</table>'],
                    col: [2, '<table><colgroup>', '</colgroup></table>'],
                    tr: [2, '<table><tbody>', '</tbody></table>'],
                    td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
                    _default: [0, '', ''],
                };
                function gr(u, h) {
                    var y;
                    return (
                        (y =
                            typeof u.getElementsByTagName < 'u'
                                ? u.getElementsByTagName(h || '*')
                                : typeof u.querySelectorAll < 'u'
                                ? u.querySelectorAll(h || '*')
                                : []),
                        void 0 === h || (h && Ne(u, h)) ? b.merge([u], y) : y
                    );
                }
                function So(u, h) {
                    for (var y = 0, w = u.length; y < w; y++)
                        ft.set(u[y], 'globalEval', !h || ft.get(h[y], 'globalEval'));
                }
                (ni.tbody = ni.tfoot = ni.colgroup = ni.caption = ni.thead),
                    (ni.th = ni.td),
                    j.option || (ni.optgroup = ni.option = [1, "<select multiple='multiple'>", '</select>']);
                var Hl = /<|&#?\w+;/;
                function vt(u, h, y, w, I) {
                    for (
                        var A, B, ne, J, re, Te, Ae = h.createDocumentFragment(), ve = [], He = 0, Kt = u.length;
                        He < Kt;
                        He++
                    )
                        if ((A = u[He]) || 0 === A)
                            if ('object' === De(A)) b.merge(ve, A.nodeType ? [A] : A);
                            else if (Hl.test(A)) {
                                for (
                                    B = B || Ae.appendChild(h.createElement('div')),
                                        ne = (no.exec(A) || ['', ''])[1].toLowerCase(),
                                        B.innerHTML = (J = ni[ne] || ni._default)[1] + b.htmlPrefilter(A) + J[2],
                                        Te = J[0];
                                    Te--;

                                )
                                    B = B.lastChild;
                                b.merge(ve, B.childNodes), ((B = Ae.firstChild).textContent = '');
                            } else ve.push(h.createTextNode(A));
                    for (Ae.textContent = '', He = 0; (A = ve[He++]); )
                        if (w && b.inArray(A, w) > -1) I && I.push(A);
                        else if (((re = on(A)), (B = gr(Ae.appendChild(A), 'script')), re && So(B), y))
                            for (Te = 0; (A = B[Te++]); ) Tn.test(A.type || '') && y.push(A);
                    return Ae;
                }
                var io = /^([^.]*)(?:\.(.+)|)/;
                function Ke() {
                    return !0;
                }
                function ro() {
                    return !1;
                }
                function mi(u, h, y, w, I, A) {
                    var B, ne;
                    if ('object' == typeof h) {
                        for (ne in ('string' != typeof y && ((w = w || y), (y = void 0)), h)) mi(u, ne, y, w, h[ne], A);
                        return u;
                    }
                    if (
                        (null == w && null == I
                            ? ((I = y), (w = y = void 0))
                            : null == I &&
                              ('string' == typeof y ? ((I = w), (w = void 0)) : ((I = w), (w = y), (y = void 0))),
                        !1 === I)
                    )
                        I = ro;
                    else if (!I) return u;
                    return (
                        1 === A &&
                            ((B = I),
                            (I = function (J) {
                                return b().off(J), B.apply(this, arguments);
                            }),
                            (I.guid = B.guid || (B.guid = b.guid++))),
                        u.each(function () {
                            b.event.add(this, h, I, w, y);
                        })
                    );
                }
                function ln(u, h, y) {
                    y
                        ? (ft.set(u, h, !1),
                          b.event.add(u, h, {
                              namespace: !1,
                              handler: function (w) {
                                  var I,
                                      A = ft.get(this, h);
                                  if (1 & w.isTrigger && this[h]) {
                                      if (A) (b.event.special[h] || {}).delegateType && w.stopPropagation();
                                      else if (
                                          ((A = v.call(arguments)),
                                          ft.set(this, h, A),
                                          this[h](),
                                          (I = ft.get(this, h)),
                                          ft.set(this, h, !1),
                                          A !== I)
                                      )
                                          return w.stopImmediatePropagation(), w.preventDefault(), I;
                                  } else
                                      A &&
                                          (ft.set(this, h, b.event.trigger(A[0], A.slice(1), this)),
                                          w.stopPropagation(),
                                          (w.isImmediatePropagationStopped = Ke));
                              },
                          }))
                        : void 0 === ft.get(u, h) && b.event.add(u, h, Ke);
                }
                (b.event = {
                    global: {},
                    add: function (u, h, y, w, I) {
                        var A,
                            B,
                            ne,
                            J,
                            re,
                            Te,
                            Ae,
                            ve,
                            He,
                            Kt,
                            In,
                            Xt = ft.get(u);
                        if (Kn(u))
                            for (
                                y.handler && ((y = (A = y).handler), (I = A.selector)),
                                    I && b.find.matchesSelector(ye, I),
                                    y.guid || (y.guid = b.guid++),
                                    (J = Xt.events) || (J = Xt.events = Object.create(null)),
                                    (B = Xt.handle) ||
                                        (B = Xt.handle =
                                            function (nr) {
                                                return typeof b < 'u' && b.event.triggered !== nr.type
                                                    ? b.event.dispatch.apply(u, arguments)
                                                    : void 0;
                                            }),
                                    re = (h = (h || '').match(sn) || ['']).length;
                                re--;

                            )
                                (He = In = (ne = io.exec(h[re]) || [])[1]),
                                    (Kt = (ne[2] || '').split('.').sort()),
                                    He &&
                                        ((Ae = b.event.special[He] || {}),
                                        (Ae = b.event.special[(He = (I ? Ae.delegateType : Ae.bindType) || He)] || {}),
                                        (Te = b.extend(
                                            {
                                                type: He,
                                                origType: In,
                                                data: w,
                                                handler: y,
                                                guid: y.guid,
                                                selector: I,
                                                needsContext: I && b.expr.match.needsContext.test(I),
                                                namespace: Kt.join('.'),
                                            },
                                            A,
                                        )),
                                        (ve = J[He]) ||
                                            (((ve = J[He] = []).delegateCount = 0),
                                            (!Ae.setup || !1 === Ae.setup.call(u, w, Kt, B)) &&
                                                u.addEventListener &&
                                                u.addEventListener(He, B)),
                                        Ae.add && (Ae.add.call(u, Te), Te.handler.guid || (Te.handler.guid = y.guid)),
                                        I ? ve.splice(ve.delegateCount++, 0, Te) : ve.push(Te),
                                        (b.event.global[He] = !0));
                    },
                    remove: function (u, h, y, w, I) {
                        var A,
                            B,
                            ne,
                            J,
                            re,
                            Te,
                            Ae,
                            ve,
                            He,
                            Kt,
                            In,
                            Xt = ft.hasData(u) && ft.get(u);
                        if (Xt && (J = Xt.events)) {
                            for (re = (h = (h || '').match(sn) || ['']).length; re--; )
                                if (
                                    ((He = In = (ne = io.exec(h[re]) || [])[1]),
                                    (Kt = (ne[2] || '').split('.').sort()),
                                    He)
                                ) {
                                    for (
                                        Ae = b.event.special[He] || {},
                                            ve = J[(He = (w ? Ae.delegateType : Ae.bindType) || He)] || [],
                                            ne = ne[2] && new RegExp('(^|\\.)' + Kt.join('\\.(?:.*\\.|)') + '(\\.|$)'),
                                            B = A = ve.length;
                                        A--;

                                    )
                                        (Te = ve[A]),
                                            (I || In === Te.origType) &&
                                                (!y || y.guid === Te.guid) &&
                                                (!ne || ne.test(Te.namespace)) &&
                                                (!w || w === Te.selector || ('**' === w && Te.selector)) &&
                                                (ve.splice(A, 1),
                                                Te.selector && ve.delegateCount--,
                                                Ae.remove && Ae.remove.call(u, Te));
                                    B &&
                                        !ve.length &&
                                        ((!Ae.teardown || !1 === Ae.teardown.call(u, Kt, Xt.handle)) &&
                                            b.removeEvent(u, He, Xt.handle),
                                        delete J[He]);
                                } else for (He in J) b.event.remove(u, He + h[re], y, w, !0);
                            b.isEmptyObject(J) && ft.remove(u, 'handle events');
                        }
                    },
                    dispatch: function (u) {
                        var h,
                            y,
                            w,
                            I,
                            A,
                            B,
                            ne = new Array(arguments.length),
                            J = b.event.fix(u),
                            re = (ft.get(this, 'events') || Object.create(null))[J.type] || [],
                            Te = b.event.special[J.type] || {};
                        for (ne[0] = J, h = 1; h < arguments.length; h++) ne[h] = arguments[h];
                        if (((J.delegateTarget = this), !Te.preDispatch || !1 !== Te.preDispatch.call(this, J))) {
                            for (
                                B = b.event.handlers.call(this, J, re), h = 0;
                                (I = B[h++]) && !J.isPropagationStopped();

                            )
                                for (
                                    J.currentTarget = I.elem, y = 0;
                                    (A = I.handlers[y++]) && !J.isImmediatePropagationStopped();

                                )
                                    (!J.rnamespace || !1 === A.namespace || J.rnamespace.test(A.namespace)) &&
                                        ((J.handleObj = A),
                                        (J.data = A.data),
                                        void 0 !==
                                            (w = ((b.event.special[A.origType] || {}).handle || A.handler).apply(
                                                I.elem,
                                                ne,
                                            )) &&
                                            !1 === (J.result = w) &&
                                            (J.preventDefault(), J.stopPropagation()));
                            return Te.postDispatch && Te.postDispatch.call(this, J), J.result;
                        }
                    },
                    handlers: function (u, h) {
                        var y,
                            w,
                            I,
                            A,
                            B,
                            ne = [],
                            J = h.delegateCount,
                            re = u.target;
                        if (J && re.nodeType && !('click' === u.type && u.button >= 1))
                            for (; re !== this; re = re.parentNode || this)
                                if (1 === re.nodeType && ('click' !== u.type || !0 !== re.disabled)) {
                                    for (A = [], B = {}, y = 0; y < J; y++)
                                        void 0 === B[(I = (w = h[y]).selector + ' ')] &&
                                            (B[I] = w.needsContext
                                                ? b(I, this).index(re) > -1
                                                : b.find(I, this, null, [re]).length),
                                            B[I] && A.push(w);
                                    A.length && ne.push({ elem: re, handlers: A });
                                }
                        return (re = this), J < h.length && ne.push({ elem: re, handlers: h.slice(J) }), ne;
                    },
                    addProp: function (u, h) {
                        Object.defineProperty(b.Event.prototype, u, {
                            enumerable: !0,
                            configurable: !0,
                            get: N(h)
                                ? function () {
                                      if (this.originalEvent) return h(this.originalEvent);
                                  }
                                : function () {
                                      if (this.originalEvent) return this.originalEvent[u];
                                  },
                            set: function (y) {
                                Object.defineProperty(this, u, {
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0,
                                    value: y,
                                });
                            },
                        });
                    },
                    fix: function (u) {
                        return u[b.expando] ? u : new b.Event(u);
                    },
                    special: {
                        load: { noBubble: !0 },
                        click: {
                            setup: function (u) {
                                var h = this || u;
                                return Br.test(h.type) && h.click && Ne(h, 'input') && ln(h, 'click', !0), !1;
                            },
                            trigger: function (u) {
                                var h = this || u;
                                return Br.test(h.type) && h.click && Ne(h, 'input') && ln(h, 'click'), !0;
                            },
                            _default: function (u) {
                                var h = u.target;
                                return (
                                    (Br.test(h.type) && h.click && Ne(h, 'input') && ft.get(h, 'click')) || Ne(h, 'a')
                                );
                            },
                        },
                        beforeunload: {
                            postDispatch: function (u) {
                                void 0 !== u.result && u.originalEvent && (u.originalEvent.returnValue = u.result);
                            },
                        },
                    },
                }),
                    (b.removeEvent = function (u, h, y) {
                        u.removeEventListener && u.removeEventListener(h, y);
                    }),
                    (b.Event = function (u, h) {
                        if (!(this instanceof b.Event)) return new b.Event(u, h);
                        u && u.type
                            ? ((this.originalEvent = u),
                              (this.type = u.type),
                              (this.isDefaultPrevented =
                                  u.defaultPrevented || (void 0 === u.defaultPrevented && !1 === u.returnValue)
                                      ? Ke
                                      : ro),
                              (this.target = u.target && 3 === u.target.nodeType ? u.target.parentNode : u.target),
                              (this.currentTarget = u.currentTarget),
                              (this.relatedTarget = u.relatedTarget))
                            : (this.type = u),
                            h && b.extend(this, h),
                            (this.timeStamp = (u && u.timeStamp) || Date.now()),
                            (this[b.expando] = !0);
                    }),
                    (b.Event.prototype = {
                        constructor: b.Event,
                        isDefaultPrevented: ro,
                        isPropagationStopped: ro,
                        isImmediatePropagationStopped: ro,
                        isSimulated: !1,
                        preventDefault: function () {
                            var u = this.originalEvent;
                            (this.isDefaultPrevented = Ke), u && !this.isSimulated && u.preventDefault();
                        },
                        stopPropagation: function () {
                            var u = this.originalEvent;
                            (this.isPropagationStopped = Ke), u && !this.isSimulated && u.stopPropagation();
                        },
                        stopImmediatePropagation: function () {
                            var u = this.originalEvent;
                            (this.isImmediatePropagationStopped = Ke),
                                u && !this.isSimulated && u.stopImmediatePropagation(),
                                this.stopPropagation();
                        },
                    }),
                    b.each(
                        {
                            altKey: !0,
                            bubbles: !0,
                            cancelable: !0,
                            changedTouches: !0,
                            ctrlKey: !0,
                            detail: !0,
                            eventPhase: !0,
                            metaKey: !0,
                            pageX: !0,
                            pageY: !0,
                            shiftKey: !0,
                            view: !0,
                            char: !0,
                            code: !0,
                            charCode: !0,
                            key: !0,
                            keyCode: !0,
                            button: !0,
                            buttons: !0,
                            clientX: !0,
                            clientY: !0,
                            offsetX: !0,
                            offsetY: !0,
                            pointerId: !0,
                            pointerType: !0,
                            screenX: !0,
                            screenY: !0,
                            targetTouches: !0,
                            toElement: !0,
                            touches: !0,
                            which: !0,
                        },
                        b.event.addProp,
                    ),
                    b.each({ focus: 'focusin', blur: 'focusout' }, function (u, h) {
                        function y(w) {
                            if (Q.documentMode) {
                                var I = ft.get(this, 'handle'),
                                    A = b.event.fix(w);
                                (A.type = 'focusin' === w.type ? 'focus' : 'blur'),
                                    (A.isSimulated = !0),
                                    I(w),
                                    A.target === A.currentTarget && I(A);
                            } else b.event.simulate(h, w.target, b.event.fix(w));
                        }
                        (b.event.special[u] = {
                            setup: function () {
                                var w;
                                if ((ln(this, u, !0), !Q.documentMode)) return !1;
                                (w = ft.get(this, h)) || this.addEventListener(h, y), ft.set(this, h, (w || 0) + 1);
                            },
                            trigger: function () {
                                return ln(this, u), !0;
                            },
                            teardown: function () {
                                var w;
                                if (!Q.documentMode) return !1;
                                (w = ft.get(this, h) - 1)
                                    ? ft.set(this, h, w)
                                    : (this.removeEventListener(h, y), ft.remove(this, h));
                            },
                            _default: function (w) {
                                return ft.get(w.target, u);
                            },
                            delegateType: h,
                        }),
                            (b.event.special[h] = {
                                setup: function () {
                                    var w = this.ownerDocument || this.document || this,
                                        I = Q.documentMode ? this : w,
                                        A = ft.get(I, h);
                                    A || (Q.documentMode ? this.addEventListener(h, y) : w.addEventListener(u, y, !0)),
                                        ft.set(I, h, (A || 0) + 1);
                                },
                                teardown: function () {
                                    var w = this.ownerDocument || this.document || this,
                                        I = Q.documentMode ? this : w,
                                        A = ft.get(I, h) - 1;
                                    A
                                        ? ft.set(I, h, A)
                                        : (Q.documentMode
                                              ? this.removeEventListener(h, y)
                                              : w.removeEventListener(u, y, !0),
                                          ft.remove(I, h));
                                },
                            });
                    }),
                    b.each(
                        {
                            mouseenter: 'mouseover',
                            mouseleave: 'mouseout',
                            pointerenter: 'pointerover',
                            pointerleave: 'pointerout',
                        },
                        function (u, h) {
                            b.event.special[u] = {
                                delegateType: h,
                                bindType: h,
                                handle: function (y) {
                                    var w,
                                        A = y.relatedTarget,
                                        B = y.handleObj;
                                    return (
                                        (!A || (A !== this && !b.contains(this, A))) &&
                                            ((y.type = B.origType),
                                            (w = B.handler.apply(this, arguments)),
                                            (y.type = h)),
                                        w
                                    );
                                },
                            };
                        },
                    ),
                    b.fn.extend({
                        on: function (u, h, y, w) {
                            return mi(this, u, h, y, w);
                        },
                        one: function (u, h, y, w) {
                            return mi(this, u, h, y, w, 1);
                        },
                        off: function (u, h, y) {
                            var w, I;
                            if (u && u.preventDefault && u.handleObj)
                                return (
                                    (w = u.handleObj),
                                    b(u.delegateTarget).off(
                                        w.namespace ? w.origType + '.' + w.namespace : w.origType,
                                        w.selector,
                                        w.handler,
                                    ),
                                    this
                                );
                            if ('object' == typeof u) {
                                for (I in u) this.off(I, h, u[I]);
                                return this;
                            }
                            return (
                                (!1 === h || 'function' == typeof h) && ((y = h), (h = void 0)),
                                !1 === y && (y = ro),
                                this.each(function () {
                                    b.event.remove(this, u, y, h);
                                })
                            );
                        },
                    });
                var za = /<script|<style|<link/i,
                    Ct = /checked\s*(?:[^=]|=\s*.checked.)/i,
                    ha = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
                function fa(u, h) {
                    return (
                        (Ne(u, 'table') &&
                            Ne(11 !== h.nodeType ? h : h.firstChild, 'tr') &&
                            b(u).children('tbody')[0]) ||
                        u
                    );
                }
                function Me(u) {
                    return (u.type = (null !== u.getAttribute('type')) + '/' + u.type), u;
                }
                function zr(u) {
                    return (
                        'true/' === (u.type || '').slice(0, 5) ? (u.type = u.type.slice(5)) : u.removeAttribute('type'),
                        u
                    );
                }
                function dr(u, h) {
                    var y, w, I, B, ne, J;
                    if (1 === h.nodeType) {
                        if (ft.hasData(u) && (J = ft.get(u).events))
                            for (I in (ft.remove(h, 'handle events'), J))
                                for (y = 0, w = J[I].length; y < w; y++) b.event.add(h, I, J[I][y]);
                        gn.hasData(u) && ((B = gn.access(u)), (ne = b.extend({}, B)), gn.set(h, ne));
                    }
                }
                function ri(u, h) {
                    var y = h.nodeName.toLowerCase();
                    'input' === y && Br.test(u.type)
                        ? (h.checked = u.checked)
                        : ('input' === y || 'textarea' === y) && (h.defaultValue = u.defaultValue);
                }
                function er(u, h, y, w) {
                    h = p(h);
                    var I,
                        A,
                        B,
                        ne,
                        J,
                        re,
                        Te = 0,
                        Ae = u.length,
                        ve = Ae - 1,
                        He = h[0],
                        Kt = N(He);
                    if (Kt || (Ae > 1 && 'string' == typeof He && !j.checkClone && Ct.test(He)))
                        return u.each(function (In) {
                            var Xt = u.eq(In);
                            Kt && (h[0] = He.call(this, In, Xt.html())), er(Xt, h, y, w);
                        });
                    if (
                        Ae &&
                        ((A = (I = vt(h, u[0].ownerDocument, !1, u, w)).firstChild),
                        1 === I.childNodes.length && (I = A),
                        A || w)
                    ) {
                        for (ne = (B = b.map(gr(I, 'script'), Me)).length; Te < Ae; Te++)
                            (J = I),
                                Te !== ve && ((J = b.clone(J, !0, !0)), ne && b.merge(B, gr(J, 'script'))),
                                y.call(u[Te], J, Te);
                        if (ne)
                            for (re = B[B.length - 1].ownerDocument, b.map(B, zr), Te = 0; Te < ne; Te++)
                                Tn.test((J = B[Te]).type || '') &&
                                    !ft.access(J, 'globalEval') &&
                                    b.contains(re, J) &&
                                    (J.src && 'module' !== (J.type || '').toLowerCase()
                                        ? b._evalUrl &&
                                          !J.noModule &&
                                          b._evalUrl(J.src, { nonce: J.nonce || J.getAttribute('nonce') }, re)
                                        : ge(J.textContent.replace(ha, ''), J, re));
                    }
                    return u;
                }
                function Bs(u, h, y) {
                    for (var w, I = h ? b.filter(h, u) : u, A = 0; null != (w = I[A]); A++)
                        !y && 1 === w.nodeType && b.cleanData(gr(w)),
                            w.parentNode && (y && on(w) && So(gr(w, 'script')), w.parentNode.removeChild(w));
                    return u;
                }
                b.extend({
                    htmlPrefilter: function (u) {
                        return u;
                    },
                    clone: function (u, h, y) {
                        var w,
                            I,
                            A,
                            B,
                            ne = u.cloneNode(!0),
                            J = on(u);
                        if (!(j.noCloneChecked || (1 !== u.nodeType && 11 !== u.nodeType) || b.isXMLDoc(u)))
                            for (B = gr(ne), w = 0, I = (A = gr(u)).length; w < I; w++) ri(A[w], B[w]);
                        if (h)
                            if (y)
                                for (A = A || gr(u), B = B || gr(ne), w = 0, I = A.length; w < I; w++) dr(A[w], B[w]);
                            else dr(u, ne);
                        return (B = gr(ne, 'script')).length > 0 && So(B, !J && gr(u, 'script')), ne;
                    },
                    cleanData: function (u) {
                        for (var h, y, w, I = b.event.special, A = 0; void 0 !== (y = u[A]); A++)
                            if (Kn(y)) {
                                if ((h = y[ft.expando])) {
                                    if (h.events)
                                        for (w in h.events) I[w] ? b.event.remove(y, w) : b.removeEvent(y, w, h.handle);
                                    y[ft.expando] = void 0;
                                }
                                y[gn.expando] && (y[gn.expando] = void 0);
                            }
                    },
                }),
                    b.fn.extend({
                        detach: function (u) {
                            return Bs(this, u, !0);
                        },
                        remove: function (u) {
                            return Bs(this, u);
                        },
                        text: function (u) {
                            return rr(
                                this,
                                function (h) {
                                    return void 0 === h
                                        ? b.text(this)
                                        : this.empty().each(function () {
                                              (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) &&
                                                  (this.textContent = h);
                                          });
                                },
                                null,
                                u,
                                arguments.length,
                            );
                        },
                        append: function () {
                            return er(this, arguments, function (u) {
                                (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                                    fa(this, u).appendChild(u);
                            });
                        },
                        prepend: function () {
                            return er(this, arguments, function (u) {
                                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                    var h = fa(this, u);
                                    h.insertBefore(u, h.firstChild);
                                }
                            });
                        },
                        before: function () {
                            return er(this, arguments, function (u) {
                                this.parentNode && this.parentNode.insertBefore(u, this);
                            });
                        },
                        after: function () {
                            return er(this, arguments, function (u) {
                                this.parentNode && this.parentNode.insertBefore(u, this.nextSibling);
                            });
                        },
                        empty: function () {
                            for (var u, h = 0; null != (u = this[h]); h++)
                                1 === u.nodeType && (b.cleanData(gr(u, !1)), (u.textContent = ''));
                            return this;
                        },
                        clone: function (u, h) {
                            return (
                                (u = u ?? !1),
                                (h = h ?? u),
                                this.map(function () {
                                    return b.clone(this, u, h);
                                })
                            );
                        },
                        html: function (u) {
                            return rr(
                                this,
                                function (h) {
                                    var y = this[0] || {},
                                        w = 0,
                                        I = this.length;
                                    if (void 0 === h && 1 === y.nodeType) return y.innerHTML;
                                    if (
                                        'string' == typeof h &&
                                        !za.test(h) &&
                                        !ni[(no.exec(h) || ['', ''])[1].toLowerCase()]
                                    ) {
                                        h = b.htmlPrefilter(h);
                                        try {
                                            for (; w < I; w++)
                                                1 === (y = this[w] || {}).nodeType &&
                                                    (b.cleanData(gr(y, !1)), (y.innerHTML = h));
                                            y = 0;
                                        } catch {}
                                    }
                                    y && this.empty().append(h);
                                },
                                null,
                                u,
                                arguments.length,
                            );
                        },
                        replaceWith: function () {
                            var u = [];
                            return er(
                                this,
                                arguments,
                                function (h) {
                                    var y = this.parentNode;
                                    b.inArray(this, u) < 0 && (b.cleanData(gr(this)), y && y.replaceChild(h, this));
                                },
                                u,
                            );
                        },
                    }),
                    b.each(
                        {
                            appendTo: 'append',
                            prependTo: 'prepend',
                            insertBefore: 'before',
                            insertAfter: 'after',
                            replaceAll: 'replaceWith',
                        },
                        function (u, h) {
                            b.fn[u] = function (y) {
                                for (var w, I = [], A = b(y), B = A.length - 1, ne = 0; ne <= B; ne++)
                                    (w = ne === B ? this : this.clone(!0)), b(A[ne])[h](w), _.apply(I, w.get());
                                return this.pushStack(I);
                            };
                        },
                    );
                var ps = new RegExp('^(' + Qo + ')(?!px)[a-z%]+$', 'i'),
                    qs = /^--/,
                    To = function (u) {
                        var h = u.ownerDocument.defaultView;
                        return (!h || !h.opener) && (h = M), h.getComputedStyle(u);
                    },
                    ma = function (u, h, y) {
                        var w,
                            I,
                            A = {};
                        for (I in h) (A[I] = u.style[I]), (u.style[I] = h[I]);
                        for (I in ((w = y.call(u)), h)) u.style[I] = A[I];
                        return w;
                    },
                    pi = new RegExp(_e.join('|'), 'i');
                function Do(u, h, y) {
                    var w,
                        I,
                        A,
                        B,
                        ne = qs.test(h),
                        J = u.style;
                    return (
                        (y = y || To(u)) &&
                            ((B = y.getPropertyValue(h) || y[h]),
                            ne && B && (B = B.replace(Pt, '$1') || void 0),
                            '' === B && !on(u) && (B = b.style(u, h)),
                            !j.pixelBoxStyles() &&
                                ps.test(B) &&
                                pi.test(h) &&
                                ((w = J.width),
                                (I = J.minWidth),
                                (A = J.maxWidth),
                                (J.minWidth = J.maxWidth = J.width = B),
                                (B = y.width),
                                (J.width = w),
                                (J.minWidth = I),
                                (J.maxWidth = A))),
                        void 0 !== B ? B + '' : B
                    );
                }
                function Ul(u, h) {
                    return {
                        get: function () {
                            if (!u()) return (this.get = h).apply(this, arguments);
                            delete this.get;
                        },
                    };
                }
                !(function () {
                    function u() {
                        if (re) {
                            (J.style.cssText =
                                'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
                                (re.style.cssText =
                                    'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
                                ye.appendChild(J).appendChild(re);
                            var Te = M.getComputedStyle(re);
                            (y = '1%' !== Te.top),
                                (ne = 12 === h(Te.marginLeft)),
                                (re.style.right = '60%'),
                                (A = 36 === h(Te.right)),
                                (w = 36 === h(Te.width)),
                                (re.style.position = 'absolute'),
                                (I = 12 === h(re.offsetWidth / 3)),
                                ye.removeChild(J),
                                (re = null);
                        }
                    }
                    function h(Te) {
                        return Math.round(parseFloat(Te));
                    }
                    var y,
                        w,
                        I,
                        A,
                        B,
                        ne,
                        J = Q.createElement('div'),
                        re = Q.createElement('div');
                    re.style &&
                        ((re.style.backgroundClip = 'content-box'),
                        (re.cloneNode(!0).style.backgroundClip = ''),
                        (j.clearCloneStyle = 'content-box' === re.style.backgroundClip),
                        b.extend(j, {
                            boxSizingReliable: function () {
                                return u(), w;
                            },
                            pixelBoxStyles: function () {
                                return u(), A;
                            },
                            pixelPosition: function () {
                                return u(), y;
                            },
                            reliableMarginLeft: function () {
                                return u(), ne;
                            },
                            scrollboxSize: function () {
                                return u(), I;
                            },
                            reliableTrDimensions: function () {
                                var Te, Ae, ve, He;
                                return (
                                    null == B &&
                                        ((Te = Q.createElement('table')),
                                        (Ae = Q.createElement('tr')),
                                        (ve = Q.createElement('div')),
                                        (Te.style.cssText = 'position:absolute;left:-11111px;border-collapse:separate'),
                                        (Ae.style.cssText = 'box-sizing:content-box;border:1px solid'),
                                        (Ae.style.height = '1px'),
                                        (ve.style.height = '9px'),
                                        (ve.style.display = 'block'),
                                        ye.appendChild(Te).appendChild(Ae).appendChild(ve),
                                        (He = M.getComputedStyle(Ae)),
                                        (B =
                                            parseInt(He.height, 10) +
                                                parseInt(He.borderTopWidth, 10) +
                                                parseInt(He.borderBottomWidth, 10) ===
                                            Ae.offsetHeight),
                                        ye.removeChild(Te)),
                                    B
                                );
                            },
                        }));
                })();
                var Xo = ['Webkit', 'Moz', 'ms'],
                    Ru = Q.createElement('div').style,
                    Rn = {};
                function Vu(u) {
                    return (
                        b.cssProps[u] ||
                        Rn[u] ||
                        (u in Ru
                            ? u
                            : (Rn[u] =
                                  (function Ih(u) {
                                      for (var h = u[0].toUpperCase() + u.slice(1), y = Xo.length; y--; )
                                          if ((u = Xo[y] + h) in Ru) return u;
                                  })(u) || u))
                    );
                }
                var Xn = /^(none|table(?!-c[ea]).+)/,
                    f0 = { position: 'absolute', visibility: 'hidden', display: 'block' },
                    tr = { letterSpacing: '0', fontWeight: '400' };
                function fl(u, h, y) {
                    var w = to.exec(h);
                    return w ? Math.max(0, w[2] - (y || 0)) + (w[3] || 'px') : h;
                }
                function zc(u, h, y, w, I, A) {
                    var B = 'width' === h ? 1 : 0,
                        ne = 0,
                        J = 0,
                        re = 0;
                    if (y === (w ? 'border' : 'content')) return 0;
                    for (; B < 4; B += 2)
                        'margin' === y && (re += b.css(u, y + _e[B], !0, I)),
                            w
                                ? ('content' === y && (J -= b.css(u, 'padding' + _e[B], !0, I)),
                                  'margin' !== y && (J -= b.css(u, 'border' + _e[B] + 'Width', !0, I)))
                                : ((J += b.css(u, 'padding' + _e[B], !0, I)),
                                  'padding' !== y
                                      ? (J += b.css(u, 'border' + _e[B] + 'Width', !0, I))
                                      : (ne += b.css(u, 'border' + _e[B] + 'Width', !0, I)));
                    return (
                        !w &&
                            A >= 0 &&
                            (J +=
                                Math.max(
                                    0,
                                    Math.ceil(u['offset' + h[0].toUpperCase() + h.slice(1)] - A - J - ne - 0.5),
                                ) || 0),
                        J + re
                    );
                }
                function Hu(u, h, y) {
                    var w = To(u),
                        A = (!j.boxSizingReliable() || y) && 'border-box' === b.css(u, 'boxSizing', !1, w),
                        B = A,
                        ne = Do(u, h, w),
                        J = 'offset' + h[0].toUpperCase() + h.slice(1);
                    if (ps.test(ne)) {
                        if (!y) return ne;
                        ne = 'auto';
                    }
                    return (
                        ((!j.boxSizingReliable() && A) ||
                            (!j.reliableTrDimensions() && Ne(u, 'tr')) ||
                            'auto' === ne ||
                            (!parseFloat(ne) && 'inline' === b.css(u, 'display', !1, w))) &&
                            u.getClientRects().length &&
                            ((A = 'border-box' === b.css(u, 'boxSizing', !1, w)), (B = J in u) && (ne = u[J])),
                        (ne = parseFloat(ne) || 0) + zc(u, h, y || (A ? 'border' : 'content'), B, w, ne) + 'px'
                    );
                }
                function Wt(u, h, y, w, I) {
                    return new Wt.prototype.init(u, h, y, w, I);
                }
                b.extend({
                    cssHooks: {
                        opacity: {
                            get: function (u, h) {
                                if (h) {
                                    var y = Do(u, 'opacity');
                                    return '' === y ? '1' : y;
                                }
                            },
                        },
                    },
                    cssNumber: {
                        animationIterationCount: !0,
                        aspectRatio: !0,
                        borderImageSlice: !0,
                        columnCount: !0,
                        flexGrow: !0,
                        flexShrink: !0,
                        fontWeight: !0,
                        gridArea: !0,
                        gridColumn: !0,
                        gridColumnEnd: !0,
                        gridColumnStart: !0,
                        gridRow: !0,
                        gridRowEnd: !0,
                        gridRowStart: !0,
                        lineHeight: !0,
                        opacity: !0,
                        order: !0,
                        orphans: !0,
                        scale: !0,
                        widows: !0,
                        zIndex: !0,
                        zoom: !0,
                        fillOpacity: !0,
                        floodOpacity: !0,
                        stopOpacity: !0,
                        strokeMiterlimit: !0,
                        strokeOpacity: !0,
                    },
                    cssProps: {},
                    style: function (u, h, y, w) {
                        if (u && 3 !== u.nodeType && 8 !== u.nodeType && u.style) {
                            var I,
                                A,
                                B,
                                ne = pr(h),
                                J = qs.test(h),
                                re = u.style;
                            if ((J || (h = Vu(ne)), (B = b.cssHooks[h] || b.cssHooks[ne]), void 0 === y))
                                return B && 'get' in B && void 0 !== (I = B.get(u, !1, w)) ? I : re[h];
                            if (
                                ('string' == (A = typeof y) &&
                                    (I = to.exec(y)) &&
                                    I[1] &&
                                    ((y = lt(u, h, I)), (A = 'number')),
                                null == y || y != y)
                            )
                                return;
                            'number' === A && !J && (y += (I && I[3]) || (b.cssNumber[ne] ? '' : 'px')),
                                !j.clearCloneStyle && '' === y && 0 === h.indexOf('background') && (re[h] = 'inherit'),
                                (!B || !('set' in B) || void 0 !== (y = B.set(u, y, w))) &&
                                    (J ? re.setProperty(h, y) : (re[h] = y));
                        }
                    },
                    css: function (u, h, y, w) {
                        var I,
                            A,
                            B,
                            ne = pr(h);
                        return (
                            qs.test(h) || (h = Vu(ne)),
                            (B = b.cssHooks[h] || b.cssHooks[ne]) && 'get' in B && (I = B.get(u, !0, y)),
                            void 0 === I && (I = Do(u, h, w)),
                            'normal' === I && h in tr && (I = tr[h]),
                            '' === y || y ? ((A = parseFloat(I)), !0 === y || isFinite(A) ? A || 0 : I) : I
                        );
                    },
                }),
                    b.each(['height', 'width'], function (u, h) {
                        b.cssHooks[h] = {
                            get: function (y, w, I) {
                                if (w)
                                    return !Xn.test(b.css(y, 'display')) ||
                                        (y.getClientRects().length && y.getBoundingClientRect().width)
                                        ? Hu(y, h, I)
                                        : ma(y, f0, function () {
                                              return Hu(y, h, I);
                                          });
                            },
                            set: function (y, w, I) {
                                var A,
                                    B = To(y),
                                    ne = !j.scrollboxSize() && 'absolute' === B.position,
                                    re = (ne || I) && 'border-box' === b.css(y, 'boxSizing', !1, B),
                                    Te = I ? zc(y, h, I, re, B) : 0;
                                return (
                                    re &&
                                        ne &&
                                        (Te -= Math.ceil(
                                            y['offset' + h[0].toUpperCase() + h.slice(1)] -
                                                parseFloat(B[h]) -
                                                zc(y, h, 'border', !1, B) -
                                                0.5,
                                        )),
                                    Te &&
                                        (A = to.exec(w)) &&
                                        'px' !== (A[3] || 'px') &&
                                        ((y.style[h] = w), (w = b.css(y, h))),
                                    fl(0, w, Te)
                                );
                            },
                        };
                    }),
                    (b.cssHooks.marginLeft = Ul(j.reliableMarginLeft, function (u, h) {
                        if (h)
                            return (
                                (parseFloat(Do(u, 'marginLeft')) ||
                                    u.getBoundingClientRect().left -
                                        ma(u, { marginLeft: 0 }, function () {
                                            return u.getBoundingClientRect().left;
                                        })) + 'px'
                            );
                    })),
                    b.each({ margin: '', padding: '', border: 'Width' }, function (u, h) {
                        (b.cssHooks[u + h] = {
                            expand: function (y) {
                                for (var w = 0, I = {}, A = 'string' == typeof y ? y.split(' ') : [y]; w < 4; w++)
                                    I[u + _e[w] + h] = A[w] || A[w - 2] || A[0];
                                return I;
                            },
                        }),
                            'margin' !== u && (b.cssHooks[u + h].set = fl);
                    }),
                    b.fn.extend({
                        css: function (u, h) {
                            return rr(
                                this,
                                function (y, w, I) {
                                    var A,
                                        B,
                                        ne = {},
                                        J = 0;
                                    if (Array.isArray(w)) {
                                        for (A = To(y), B = w.length; J < B; J++) ne[w[J]] = b.css(y, w[J], !1, A);
                                        return ne;
                                    }
                                    return void 0 !== I ? b.style(y, w, I) : b.css(y, w);
                                },
                                u,
                                h,
                                arguments.length > 1,
                            );
                        },
                    }),
                    (b.Tween = Wt),
                    (Wt.prototype = {
                        constructor: Wt,
                        init: function (u, h, y, w, I, A) {
                            (this.elem = u),
                                (this.prop = y),
                                (this.easing = I || b.easing._default),
                                (this.options = h),
                                (this.start = this.now = this.cur()),
                                (this.end = w),
                                (this.unit = A || (b.cssNumber[y] ? '' : 'px'));
                        },
                        cur: function () {
                            var u = Wt.propHooks[this.prop];
                            return u && u.get ? u.get(this) : Wt.propHooks._default.get(this);
                        },
                        run: function (u) {
                            var h,
                                y = Wt.propHooks[this.prop];
                            return (
                                (this.pos = h =
                                    this.options.duration
                                        ? b.easing[this.easing](
                                              u,
                                              this.options.duration * u,
                                              0,
                                              1,
                                              this.options.duration,
                                          )
                                        : u),
                                (this.now = (this.end - this.start) * h + this.start),
                                this.options.step && this.options.step.call(this.elem, this.now, this),
                                y && y.set ? y.set(this) : Wt.propHooks._default.set(this),
                                this
                            );
                        },
                    }),
                    (Wt.prototype.init.prototype = Wt.prototype),
                    (Wt.propHooks = {
                        _default: {
                            get: function (u) {
                                var h;
                                return 1 !== u.elem.nodeType || (null != u.elem[u.prop] && null == u.elem.style[u.prop])
                                    ? u.elem[u.prop]
                                    : (h = b.css(u.elem, u.prop, '')) && 'auto' !== h
                                    ? h
                                    : 0;
                            },
                            set: function (u) {
                                b.fx.step[u.prop]
                                    ? b.fx.step[u.prop](u)
                                    : 1 !== u.elem.nodeType || (!b.cssHooks[u.prop] && null == u.elem.style[Vu(u.prop)])
                                    ? (u.elem[u.prop] = u.now)
                                    : b.style(u.elem, u.prop, u.now + u.unit);
                            },
                        },
                    }),
                    (Wt.propHooks.scrollTop = Wt.propHooks.scrollLeft =
                        {
                            set: function (u) {
                                u.elem.nodeType && u.elem.parentNode && (u.elem[u.prop] = u.now);
                            },
                        }),
                    (b.easing = {
                        linear: function (u) {
                            return u;
                        },
                        swing: function (u) {
                            return 0.5 - Math.cos(u * Math.PI) / 2;
                        },
                        _default: 'swing',
                    }),
                    (b.fx = Wt.prototype.init),
                    (b.fx.step = {});
                var Dt,
                    Zo,
                    vr = /^(?:toggle|show|hide)$/,
                    m0 = /queueHooks$/;
                function Pc() {
                    Zo &&
                        (!1 === Q.hidden && M.requestAnimationFrame
                            ? M.requestAnimationFrame(Pc)
                            : M.setTimeout(Pc, b.fx.interval),
                        b.fx.tick());
                }
                function p0() {
                    return (
                        M.setTimeout(function () {
                            Dt = void 0;
                        }),
                        (Dt = Date.now())
                    );
                }
                function qr(u, h) {
                    var y,
                        w = 0,
                        I = { height: u };
                    for (h = h ? 1 : 0; w < 4; w += 2 - h) I['margin' + (y = _e[w])] = I['padding' + y] = u;
                    return h && (I.opacity = I.width = u), I;
                }
                function Bl(u, h, y) {
                    for (var w, I = (hr.tweeners[h] || []).concat(hr.tweeners['*']), A = 0, B = I.length; A < B; A++)
                        if ((w = I[A].call(y, h, u))) return w;
                }
                function hr(u, h, y) {
                    var w,
                        I,
                        A = 0,
                        B = hr.prefilters.length,
                        ne = b.Deferred().always(function () {
                            delete J.elem;
                        }),
                        J = function () {
                            if (I) return !1;
                            for (
                                var Ae = Dt || p0(),
                                    ve = Math.max(0, re.startTime + re.duration - Ae),
                                    Kt = 1 - (ve / re.duration || 0),
                                    In = 0,
                                    Xt = re.tweens.length;
                                In < Xt;
                                In++
                            )
                                re.tweens[In].run(Kt);
                            return (
                                ne.notifyWith(u, [re, Kt, ve]),
                                Kt < 1 && Xt ? ve : (Xt || ne.notifyWith(u, [re, 1, 0]), ne.resolveWith(u, [re]), !1)
                            );
                        },
                        re = ne.promise({
                            elem: u,
                            props: b.extend({}, h),
                            opts: b.extend(!0, { specialEasing: {}, easing: b.easing._default }, y),
                            originalProperties: h,
                            originalOptions: y,
                            startTime: Dt || p0(),
                            duration: y.duration,
                            tweens: [],
                            createTween: function (Ae, ve) {
                                var He = b.Tween(u, re.opts, Ae, ve, re.opts.specialEasing[Ae] || re.opts.easing);
                                return re.tweens.push(He), He;
                            },
                            stop: function (Ae) {
                                var ve = 0,
                                    He = Ae ? re.tweens.length : 0;
                                if (I) return this;
                                for (I = !0; ve < He; ve++) re.tweens[ve].run(1);
                                return (
                                    Ae
                                        ? (ne.notifyWith(u, [re, 1, 0]), ne.resolveWith(u, [re, Ae]))
                                        : ne.rejectWith(u, [re, Ae]),
                                    this
                                );
                            },
                        }),
                        Te = re.props;
                    for (
                        (function ql(u, h) {
                            var y, w, I, A, B;
                            for (y in u)
                                if (
                                    ((I = h[(w = pr(y))]),
                                    (A = u[y]),
                                    Array.isArray(A) && ((I = A[1]), (A = u[y] = A[0])),
                                    y !== w && ((u[w] = A), delete u[y]),
                                    (B = b.cssHooks[w]) && ('expand' in B))
                                )
                                    for (y in ((A = B.expand(A)), delete u[w], A))
                                        (y in u) || ((u[y] = A[y]), (h[y] = I));
                                else h[w] = I;
                        })(Te, re.opts.specialEasing);
                        A < B;
                        A++
                    )
                        if ((w = hr.prefilters[A].call(re, u, Te, re.opts)))
                            return N(w.stop) && (b._queueHooks(re.elem, re.opts.queue).stop = w.stop.bind(w)), w;
                    return (
                        b.map(Te, Bl, re),
                        N(re.opts.start) && re.opts.start.call(u, re),
                        re
                            .progress(re.opts.progress)
                            .done(re.opts.done, re.opts.complete)
                            .fail(re.opts.fail)
                            .always(re.opts.always),
                        b.fx.timer(b.extend(J, { elem: u, anim: re, queue: re.opts.queue })),
                        re
                    );
                }
                (b.Animation = b.extend(hr, {
                    tweeners: {
                        '*': [
                            function (u, h) {
                                var y = this.createTween(u, h);
                                return lt(y.elem, u, to.exec(h), y), y;
                            },
                        ],
                    },
                    tweener: function (u, h) {
                        N(u) ? ((h = u), (u = ['*'])) : (u = u.match(sn));
                        for (var y, w = 0, I = u.length; w < I; w++)
                            (hr.tweeners[(y = u[w])] = hr.tweeners[y] || []).unshift(h);
                    },
                    prefilters: [
                        function g0(u, h, y) {
                            var w,
                                I,
                                A,
                                B,
                                ne,
                                J,
                                re,
                                Te,
                                Ae = 'width' in h || 'height' in h,
                                ve = this,
                                He = {},
                                Kt = u.style,
                                In = u.nodeType && Qn(u),
                                Xt = ft.get(u, 'fxshow');
                            for (w in (y.queue ||
                                (null == (B = b._queueHooks(u, 'fx')).unqueued &&
                                    ((B.unqueued = 0),
                                    (ne = B.empty.fire),
                                    (B.empty.fire = function () {
                                        B.unqueued || ne();
                                    })),
                                B.unqueued++,
                                ve.always(function () {
                                    ve.always(function () {
                                        B.unqueued--, b.queue(u, 'fx').length || B.empty.fire();
                                    });
                                })),
                            h))
                                if (vr.test((I = h[w]))) {
                                    if ((delete h[w], (A = A || 'toggle' === I), I === (In ? 'hide' : 'show'))) {
                                        if ('show' !== I || !Xt || void 0 === Xt[w]) continue;
                                        In = !0;
                                    }
                                    He[w] = (Xt && Xt[w]) || b.style(u, w);
                                }
                            if ((J = !b.isEmptyObject(h)) || !b.isEmptyObject(He))
                                for (w in (Ae &&
                                    1 === u.nodeType &&
                                    ((y.overflow = [Kt.overflow, Kt.overflowX, Kt.overflowY]),
                                    null == (re = Xt && Xt.display) && (re = ft.get(u, 'display')),
                                    'none' === (Te = b.css(u, 'display')) &&
                                        (re
                                            ? (Te = re)
                                            : (Yn([u], !0),
                                              (re = u.style.display || re),
                                              (Te = b.css(u, 'display')),
                                              Yn([u]))),
                                    ('inline' === Te || ('inline-block' === Te && null != re)) &&
                                        'none' === b.css(u, 'float') &&
                                        (J ||
                                            (ve.done(function () {
                                                Kt.display = re;
                                            }),
                                            null == re && (re = 'none' === (Te = Kt.display) ? '' : Te)),
                                        (Kt.display = 'inline-block'))),
                                y.overflow &&
                                    ((Kt.overflow = 'hidden'),
                                    ve.always(function () {
                                        (Kt.overflow = y.overflow[0]),
                                            (Kt.overflowX = y.overflow[1]),
                                            (Kt.overflowY = y.overflow[2]);
                                    })),
                                (J = !1),
                                He))
                                    J ||
                                        (Xt
                                            ? 'hidden' in Xt && (In = Xt.hidden)
                                            : (Xt = ft.access(u, 'fxshow', { display: re })),
                                        A && (Xt.hidden = !In),
                                        In && Yn([u], !0),
                                        ve.done(function () {
                                            for (w in (In || Yn([u]), ft.remove(u, 'fxshow'), He)) b.style(u, w, He[w]);
                                        })),
                                        (J = Bl(In ? Xt[w] : 0, w, ve)),
                                        w in Xt || ((Xt[w] = J.start), In && ((J.end = J.start), (J.start = 0)));
                        },
                    ],
                    prefilter: function (u, h) {
                        h ? hr.prefilters.unshift(u) : hr.prefilters.push(u);
                    },
                })),
                    (b.speed = function (u, h, y) {
                        var w =
                            u && 'object' == typeof u
                                ? b.extend({}, u)
                                : {
                                      complete: y || (!y && h) || (N(u) && u),
                                      duration: u,
                                      easing: (y && h) || (h && !N(h) && h),
                                  };
                        return (
                            b.fx.off
                                ? (w.duration = 0)
                                : 'number' != typeof w.duration &&
                                  (w.duration =
                                      w.duration in b.fx.speeds ? b.fx.speeds[w.duration] : b.fx.speeds._default),
                            (null == w.queue || !0 === w.queue) && (w.queue = 'fx'),
                            (w.old = w.complete),
                            (w.complete = function () {
                                N(w.old) && w.old.call(this), w.queue && b.dequeue(this, w.queue);
                            }),
                            w
                        );
                    }),
                    b.fn.extend({
                        fadeTo: function (u, h, y, w) {
                            return this.filter(Qn).css('opacity', 0).show().end().animate({ opacity: h }, u, y, w);
                        },
                        animate: function (u, h, y, w) {
                            var I = b.isEmptyObject(u),
                                A = b.speed(h, y, w),
                                B = function () {
                                    var ne = hr(this, b.extend({}, u), A);
                                    (I || ft.get(this, 'finish')) && ne.stop(!0);
                                };
                            return (B.finish = B), I || !1 === A.queue ? this.each(B) : this.queue(A.queue, B);
                        },
                        stop: function (u, h, y) {
                            var w = function (I) {
                                var A = I.stop;
                                delete I.stop, A(y);
                            };
                            return (
                                'string' != typeof u && ((y = h), (h = u), (u = void 0)),
                                h && this.queue(u || 'fx', []),
                                this.each(function () {
                                    var I = !0,
                                        A = null != u && u + 'queueHooks',
                                        B = b.timers,
                                        ne = ft.get(this);
                                    if (A) ne[A] && ne[A].stop && w(ne[A]);
                                    else for (A in ne) ne[A] && ne[A].stop && m0.test(A) && w(ne[A]);
                                    for (A = B.length; A--; )
                                        B[A].elem === this &&
                                            (null == u || B[A].queue === u) &&
                                            (B[A].anim.stop(y), (I = !1), B.splice(A, 1));
                                    (I || !y) && b.dequeue(this, u);
                                })
                            );
                        },
                        finish: function (u) {
                            return (
                                !1 !== u && (u = u || 'fx'),
                                this.each(function () {
                                    var h,
                                        y = ft.get(this),
                                        w = y[u + 'queue'],
                                        I = y[u + 'queueHooks'],
                                        A = b.timers,
                                        B = w ? w.length : 0;
                                    for (
                                        y.finish = !0,
                                            b.queue(this, u, []),
                                            I && I.stop && I.stop.call(this, !0),
                                            h = A.length;
                                        h--;

                                    )
                                        A[h].elem === this && A[h].queue === u && (A[h].anim.stop(!0), A.splice(h, 1));
                                    for (h = 0; h < B; h++) w[h] && w[h].finish && w[h].finish.call(this);
                                    delete y.finish;
                                })
                            );
                        },
                    }),
                    b.each(['toggle', 'show', 'hide'], function (u, h) {
                        var y = b.fn[h];
                        b.fn[h] = function (w, I, A) {
                            return null == w || 'boolean' == typeof w
                                ? y.apply(this, arguments)
                                : this.animate(qr(h, !0), w, I, A);
                        };
                    }),
                    b.each(
                        {
                            slideDown: qr('show'),
                            slideUp: qr('hide'),
                            slideToggle: qr('toggle'),
                            fadeIn: { opacity: 'show' },
                            fadeOut: { opacity: 'hide' },
                            fadeToggle: { opacity: 'toggle' },
                        },
                        function (u, h) {
                            b.fn[u] = function (y, w, I) {
                                return this.animate(h, y, w, I);
                            };
                        },
                    ),
                    (b.timers = []),
                    (b.fx.tick = function () {
                        var u,
                            h = 0,
                            y = b.timers;
                        for (Dt = Date.now(); h < y.length; h++) !(u = y[h])() && y[h] === u && y.splice(h--, 1);
                        y.length || b.fx.stop(), (Dt = void 0);
                    }),
                    (b.fx.timer = function (u) {
                        b.timers.push(u), b.fx.start();
                    }),
                    (b.fx.interval = 13),
                    (b.fx.start = function () {
                        Zo || ((Zo = !0), Pc());
                    }),
                    (b.fx.stop = function () {
                        Zo = null;
                    }),
                    (b.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
                    (b.fn.delay = function (u, h) {
                        return (
                            (u = (b.fx && b.fx.speeds[u]) || u),
                            this.queue((h = h || 'fx'), function (y, w) {
                                var I = M.setTimeout(y, u);
                                w.stop = function () {
                                    M.clearTimeout(I);
                                };
                            })
                        );
                    }),
                    (function () {
                        var u = Q.createElement('input'),
                            y = Q.createElement('select').appendChild(Q.createElement('option'));
                        (u.type = 'checkbox'),
                            (j.checkOn = '' !== u.value),
                            (j.optSelected = y.selected),
                            ((u = Q.createElement('input')).value = 't'),
                            (u.type = 'radio'),
                            (j.radioValue = 't' === u.value);
                    })();
                var Uu,
                    Yl = b.expr.attrHandle;
                b.fn.extend({
                    attr: function (u, h) {
                        return rr(this, b.attr, u, h, arguments.length > 1);
                    },
                    removeAttr: function (u) {
                        return this.each(function () {
                            b.removeAttr(this, u);
                        });
                    },
                }),
                    b.extend({
                        attr: function (u, h, y) {
                            var w,
                                I,
                                A = u.nodeType;
                            if (3 !== A && 8 !== A && 2 !== A)
                                return typeof u.getAttribute > 'u'
                                    ? b.prop(u, h, y)
                                    : ((1 !== A || !b.isXMLDoc(u)) &&
                                          (I =
                                              b.attrHooks[h.toLowerCase()] ||
                                              (b.expr.match.bool.test(h) ? Uu : void 0)),
                                      void 0 !== y
                                          ? null === y
                                              ? void b.removeAttr(u, h)
                                              : I && 'set' in I && void 0 !== (w = I.set(u, y, h))
                                              ? w
                                              : (u.setAttribute(h, y + ''), y)
                                          : I && 'get' in I && null !== (w = I.get(u, h))
                                          ? w
                                          : (w = b.find.attr(u, h)) ?? void 0);
                        },
                        attrHooks: {
                            type: {
                                set: function (u, h) {
                                    if (!j.radioValue && 'radio' === h && Ne(u, 'input')) {
                                        var y = u.value;
                                        return u.setAttribute('type', h), y && (u.value = y), h;
                                    }
                                },
                            },
                        },
                        removeAttr: function (u, h) {
                            var y,
                                w = 0,
                                I = h && h.match(sn);
                            if (I && 1 === u.nodeType) for (; (y = I[w++]); ) u.removeAttribute(y);
                        },
                    }),
                    (Uu = {
                        set: function (u, h, y) {
                            return !1 === h ? b.removeAttr(u, y) : u.setAttribute(y, y), y;
                        },
                    }),
                    b.each(b.expr.match.bool.source.match(/\w+/g), function (u, h) {
                        var y = Yl[h] || b.find.attr;
                        Yl[h] = function (w, I, A) {
                            var B,
                                ne,
                                J = I.toLowerCase();
                            return (
                                A || ((ne = Yl[J]), (Yl[J] = B), (B = null != y(w, I, A) ? J : null), (Yl[J] = ne)), B
                            );
                        };
                    });
                var v0 = /^(?:input|select|textarea|button)$/i,
                    Ah = /^(?:a|area)$/i;
                function or(u) {
                    return (u.match(sn) || []).join(' ');
                }
                function bt(u) {
                    return (u.getAttribute && u.getAttribute('class')) || '';
                }
                function Bu(u) {
                    return Array.isArray(u) ? u : ('string' == typeof u && u.match(sn)) || [];
                }
                b.fn.extend({
                    prop: function (u, h) {
                        return rr(this, b.prop, u, h, arguments.length > 1);
                    },
                    removeProp: function (u) {
                        return this.each(function () {
                            delete this[b.propFix[u] || u];
                        });
                    },
                }),
                    b.extend({
                        prop: function (u, h, y) {
                            var w,
                                I,
                                A = u.nodeType;
                            if (3 !== A && 8 !== A && 2 !== A)
                                return (
                                    (1 !== A || !b.isXMLDoc(u)) && (I = b.propHooks[(h = b.propFix[h] || h)]),
                                    void 0 !== y
                                        ? I && 'set' in I && void 0 !== (w = I.set(u, y, h))
                                            ? w
                                            : (u[h] = y)
                                        : I && 'get' in I && null !== (w = I.get(u, h))
                                        ? w
                                        : u[h]
                                );
                        },
                        propHooks: {
                            tabIndex: {
                                get: function (u) {
                                    var h = b.find.attr(u, 'tabindex');
                                    return h
                                        ? parseInt(h, 10)
                                        : v0.test(u.nodeName) || (Ah.test(u.nodeName) && u.href)
                                        ? 0
                                        : -1;
                                },
                            },
                        },
                        propFix: { for: 'htmlFor', class: 'className' },
                    }),
                    j.optSelected ||
                        (b.propHooks.selected = {
                            get: function (u) {
                                return null;
                            },
                            set: function (u) {},
                        }),
                    b.each(
                        [
                            'tabIndex',
                            'readOnly',
                            'maxLength',
                            'cellSpacing',
                            'cellPadding',
                            'rowSpan',
                            'colSpan',
                            'useMap',
                            'frameBorder',
                            'contentEditable',
                        ],
                        function () {
                            b.propFix[this.toLowerCase()] = this;
                        },
                    ),
                    b.fn.extend({
                        addClass: function (u) {
                            var h, y, w, I, A, B;
                            return N(u)
                                ? this.each(function (ne) {
                                      b(this).addClass(u.call(this, ne, bt(this)));
                                  })
                                : (h = Bu(u)).length
                                ? this.each(function () {
                                      if (((w = bt(this)), (y = 1 === this.nodeType && ' ' + or(w) + ' '))) {
                                          for (A = 0; A < h.length; A++)
                                              y.indexOf(' ' + (I = h[A]) + ' ') < 0 && (y += I + ' ');
                                          (B = or(y)), w !== B && this.setAttribute('class', B);
                                      }
                                  })
                                : this;
                        },
                        removeClass: function (u) {
                            var h, y, w, I, A, B;
                            return N(u)
                                ? this.each(function (ne) {
                                      b(this).removeClass(u.call(this, ne, bt(this)));
                                  })
                                : arguments.length
                                ? (h = Bu(u)).length
                                    ? this.each(function () {
                                          if (((w = bt(this)), (y = 1 === this.nodeType && ' ' + or(w) + ' '))) {
                                              for (A = 0; A < h.length; A++)
                                                  for (I = h[A]; y.indexOf(' ' + I + ' ') > -1; )
                                                      y = y.replace(' ' + I + ' ', ' ');
                                              (B = or(y)), w !== B && this.setAttribute('class', B);
                                          }
                                      })
                                    : this
                                : this.attr('class', '');
                        },
                        toggleClass: function (u, h) {
                            var y,
                                w,
                                I,
                                A,
                                B = typeof u,
                                ne = 'string' === B || Array.isArray(u);
                            return N(u)
                                ? this.each(function (J) {
                                      b(this).toggleClass(u.call(this, J, bt(this), h), h);
                                  })
                                : 'boolean' == typeof h && ne
                                ? h
                                    ? this.addClass(u)
                                    : this.removeClass(u)
                                : ((y = Bu(u)),
                                  this.each(function () {
                                      if (ne)
                                          for (A = b(this), I = 0; I < y.length; I++)
                                              A.hasClass((w = y[I])) ? A.removeClass(w) : A.addClass(w);
                                      else
                                          (void 0 === u || 'boolean' === B) &&
                                              ((w = bt(this)) && ft.set(this, '__className__', w),
                                              this.setAttribute &&
                                                  this.setAttribute(
                                                      'class',
                                                      w || !1 === u ? '' : ft.get(this, '__className__') || '',
                                                  ));
                                  }));
                        },
                        hasClass: function (u) {
                            var h,
                                y,
                                w = 0;
                            for (h = ' ' + u + ' '; (y = this[w++]); )
                                if (1 === y.nodeType && (' ' + or(bt(y)) + ' ').indexOf(h) > -1) return !0;
                            return !1;
                        },
                    });
                var Lh = /\r/g;
                b.fn.extend({
                    val: function (u) {
                        var h,
                            y,
                            w,
                            I = this[0];
                        return arguments.length
                            ? ((w = N(u)),
                              this.each(function (A) {
                                  var B;
                                  1 === this.nodeType &&
                                      (null == (B = w ? u.call(this, A, b(this).val()) : u)
                                          ? (B = '')
                                          : 'number' == typeof B
                                          ? (B += '')
                                          : Array.isArray(B) &&
                                            (B = b.map(B, function (ne) {
                                                return null == ne ? '' : ne + '';
                                            })),
                                      (!(h = b.valHooks[this.type] || b.valHooks[this.nodeName.toLowerCase()]) ||
                                          !('set' in h) ||
                                          void 0 === h.set(this, B, 'value')) &&
                                          (this.value = B));
                              }))
                            : I
                            ? (h = b.valHooks[I.type] || b.valHooks[I.nodeName.toLowerCase()]) &&
                              'get' in h &&
                              void 0 !== (y = h.get(I, 'value'))
                                ? y
                                : 'string' == typeof (y = I.value)
                                ? y.replace(Lh, '')
                                : y ?? ''
                            : void 0;
                    },
                }),
                    b.extend({
                        valHooks: {
                            option: {
                                get: function (u) {
                                    return b.find.attr(u, 'value') ?? or(b.text(u));
                                },
                            },
                            select: {
                                get: function (u) {
                                    var h,
                                        y,
                                        w,
                                        I = u.options,
                                        A = u.selectedIndex,
                                        B = 'select-one' === u.type,
                                        ne = B ? null : [],
                                        J = B ? A + 1 : I.length;
                                    for (w = A < 0 ? J : B ? A : 0; w < J; w++)
                                        if (
                                            ((y = I[w]).selected || w === A) &&
                                            !y.disabled &&
                                            (!y.parentNode.disabled || !Ne(y.parentNode, 'optgroup'))
                                        ) {
                                            if (((h = b(y).val()), B)) return h;
                                            ne.push(h);
                                        }
                                    return ne;
                                },
                                set: function (u, h) {
                                    for (var y, w, I = u.options, A = b.makeArray(h), B = I.length; B--; )
                                        ((w = I[B]).selected = b.inArray(b.valHooks.option.get(w), A) > -1) && (y = !0);
                                    return y || (u.selectedIndex = -1), A;
                                },
                            },
                        },
                    }),
                    b.each(['radio', 'checkbox'], function () {
                        (b.valHooks[this] = {
                            set: function (u, h) {
                                if (Array.isArray(h)) return (u.checked = b.inArray(b(u).val(), h) > -1);
                            },
                        }),
                            j.checkOn ||
                                (b.valHooks[this].get = function (u) {
                                    return null === u.getAttribute('value') ? 'on' : u.value;
                                });
                    });
                var Pa = M.location,
                    _0 = { guid: Date.now() },
                    Nc = /\?/;
                b.parseXML = function (u) {
                    var h, y;
                    if (!u || 'string' != typeof u) return null;
                    try {
                        h = new M.DOMParser().parseFromString(u, 'text/xml');
                    } catch {}
                    return (
                        (y = h && h.getElementsByTagName('parsererror')[0]),
                        (!h || y) &&
                            b.error(
                                'Invalid XML: ' +
                                    (y
                                        ? b
                                              .map(y.childNodes, function (w) {
                                                  return w.textContent;
                                              })
                                              .join('\n')
                                        : u),
                            ),
                        h
                    );
                };
                var We = /^(?:focusinfocus|focusoutblur)$/,
                    y0 = function (u) {
                        u.stopPropagation();
                    };
                b.extend(b.event, {
                    trigger: function (u, h, y, w) {
                        var I,
                            A,
                            B,
                            ne,
                            J,
                            re,
                            Te,
                            Ae,
                            ve = [y || Q],
                            He = C.call(u, 'type') ? u.type : u,
                            Kt = C.call(u, 'namespace') ? u.namespace.split('.') : [];
                        if (
                            ((A = Ae = B = y = y || Q),
                            3 !== y.nodeType &&
                                8 !== y.nodeType &&
                                !We.test(He + b.event.triggered) &&
                                (He.indexOf('.') > -1 && ((Kt = He.split('.')), (He = Kt.shift()), Kt.sort()),
                                (J = He.indexOf(':') < 0 && 'on' + He),
                                ((u = u[b.expando] ? u : new b.Event(He, 'object' == typeof u && u)).isTrigger = w
                                    ? 2
                                    : 3),
                                (u.namespace = Kt.join('.')),
                                (u.rnamespace = u.namespace
                                    ? new RegExp('(^|\\.)' + Kt.join('\\.(?:.*\\.|)') + '(\\.|$)')
                                    : null),
                                (u.result = void 0),
                                u.target || (u.target = y),
                                (h = null == h ? [u] : b.makeArray(h, [u])),
                                (Te = b.event.special[He] || {}),
                                w || !Te.trigger || !1 !== Te.trigger.apply(y, h)))
                        ) {
                            if (!w && !Te.noBubble && !K(y)) {
                                for (
                                    We.test((ne = Te.delegateType || He) + He) || (A = A.parentNode);
                                    A;
                                    A = A.parentNode
                                )
                                    ve.push(A), (B = A);
                                B === (y.ownerDocument || Q) && ve.push(B.defaultView || B.parentWindow || M);
                            }
                            for (I = 0; (A = ve[I++]) && !u.isPropagationStopped(); )
                                (Ae = A),
                                    (u.type = I > 1 ? ne : Te.bindType || He),
                                    (re =
                                        (ft.get(A, 'events') || Object.create(null))[u.type] && ft.get(A, 'handle')) &&
                                        re.apply(A, h),
                                    (re = J && A[J]) &&
                                        re.apply &&
                                        Kn(A) &&
                                        ((u.result = re.apply(A, h)), !1 === u.result && u.preventDefault());
                            return (
                                (u.type = He),
                                !w &&
                                    !u.isDefaultPrevented() &&
                                    (!Te._default || !1 === Te._default.apply(ve.pop(), h)) &&
                                    Kn(y) &&
                                    J &&
                                    N(y[He]) &&
                                    !K(y) &&
                                    ((B = y[J]) && (y[J] = null),
                                    (b.event.triggered = He),
                                    u.isPropagationStopped() && Ae.addEventListener(He, y0),
                                    y[He](),
                                    u.isPropagationStopped() && Ae.removeEventListener(He, y0),
                                    (b.event.triggered = void 0),
                                    B && (y[J] = B)),
                                u.result
                            );
                        }
                    },
                    simulate: function (u, h, y) {
                        var w = b.extend(new b.Event(), y, { type: u, isSimulated: !0 });
                        b.event.trigger(w, null, h);
                    },
                }),
                    b.fn.extend({
                        trigger: function (u, h) {
                            return this.each(function () {
                                b.event.trigger(u, h, this);
                            });
                        },
                        triggerHandler: function (u, h) {
                            var y = this[0];
                            if (y) return b.event.trigger(u, h, y, !0);
                        },
                    });
                var zn = /\[\]$/,
                    ml = /\r?\n/g,
                    Oh = /^(?:submit|button|image|reset|file)$/i,
                    qu = /^(?:input|select|textarea|keygen)/i;
                function Fc(u, h, y, w) {
                    var I;
                    if (Array.isArray(h))
                        b.each(h, function (A, B) {
                            y || zn.test(u)
                                ? w(u, B)
                                : Fc(u + '[' + ('object' == typeof B && null != B ? A : '') + ']', B, y, w);
                        });
                    else if (y || 'object' !== De(h)) w(u, h);
                    else for (I in h) Fc(u + '[' + I + ']', h[I], y, w);
                }
                (b.param = function (u, h) {
                    var y,
                        w = [],
                        I = function (A, B) {
                            var ne = N(B) ? B() : B;
                            w[w.length] = encodeURIComponent(A) + '=' + encodeURIComponent(ne ?? '');
                        };
                    if (null == u) return '';
                    if (Array.isArray(u) || (u.jquery && !b.isPlainObject(u)))
                        b.each(u, function () {
                            I(this.name, this.value);
                        });
                    else for (y in u) Fc(y, u[y], h, I);
                    return w.join('&');
                }),
                    b.fn.extend({
                        serialize: function () {
                            return b.param(this.serializeArray());
                        },
                        serializeArray: function () {
                            return this.map(function () {
                                var u = b.prop(this, 'elements');
                                return u ? b.makeArray(u) : this;
                            })
                                .filter(function () {
                                    var u = this.type;
                                    return (
                                        this.name &&
                                        !b(this).is(':disabled') &&
                                        qu.test(this.nodeName) &&
                                        !Oh.test(u) &&
                                        (this.checked || !Br.test(u))
                                    );
                                })
                                .map(function (u, h) {
                                    var y = b(this).val();
                                    return null == y
                                        ? null
                                        : Array.isArray(y)
                                        ? b.map(y, function (w) {
                                              return { name: h.name, value: w.replace(ml, '\r\n') };
                                          })
                                        : { name: h.name, value: y.replace(ml, '\r\n') };
                                })
                                .get();
                        },
                    });
                var jl = /%20/g,
                    $l = /#.*$/,
                    Rc = /([?&])_=[^&]*/,
                    Yu = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                    $e = /^(?:GET|HEAD)$/,
                    Vc = /^\/\//,
                    Gl = {},
                    Na = {},
                    Fa = '*/'.concat('*'),
                    Hc = Q.createElement('a');
                function pl(u) {
                    return function (h, y) {
                        'string' != typeof h && ((y = h), (h = '*'));
                        var w,
                            I = 0,
                            A = h.toLowerCase().match(sn) || [];
                        if (N(y))
                            for (; (w = A[I++]); )
                                '+' === w[0]
                                    ? ((w = w.slice(1) || '*'), (u[w] = u[w] || []).unshift(y))
                                    : (u[w] = u[w] || []).push(y);
                    };
                }
                function ju(u, h, y, w) {
                    var I = {},
                        A = u === Na;
                    function B(ne) {
                        var J;
                        return (
                            (I[ne] = !0),
                            b.each(u[ne] || [], function (re, Te) {
                                var Ae = Te(h, y, w);
                                return 'string' != typeof Ae || A || I[Ae]
                                    ? A
                                        ? !(J = Ae)
                                        : void 0
                                    : (h.dataTypes.unshift(Ae), B(Ae), !1);
                            }),
                            J
                        );
                    }
                    return B(h.dataTypes[0]) || (!I['*'] && B('*'));
                }
                function $u(u, h) {
                    var y,
                        w,
                        I = b.ajaxSettings.flatOptions || {};
                    for (y in h) void 0 !== h[y] && ((I[y] ? u : w || (w = {}))[y] = h[y]);
                    return w && b.extend(!0, u, w), u;
                }
                (Hc.href = Pa.href),
                    b.extend({
                        active: 0,
                        lastModified: {},
                        etag: {},
                        ajaxSettings: {
                            url: Pa.href,
                            type: 'GET',
                            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Pa.protocol),
                            global: !0,
                            processData: !0,
                            async: !0,
                            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                            accepts: {
                                '*': Fa,
                                text: 'text/plain',
                                html: 'text/html',
                                xml: 'application/xml, text/xml',
                                json: 'application/json, text/javascript',
                            },
                            contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                            responseFields: { xml: 'responseXML', text: 'responseText', json: 'responseJSON' },
                            converters: {
                                '* text': String,
                                'text html': !0,
                                'text json': JSON.parse,
                                'text xml': b.parseXML,
                            },
                            flatOptions: { url: !0, context: !0 },
                        },
                        ajaxSetup: function (u, h) {
                            return h ? $u($u(u, b.ajaxSettings), h) : $u(b.ajaxSettings, u);
                        },
                        ajaxPrefilter: pl(Gl),
                        ajaxTransport: pl(Na),
                        ajax: function (u, h) {
                            'object' == typeof u && ((h = u), (u = void 0));
                            var y,
                                w,
                                I,
                                A,
                                B,
                                ne,
                                J,
                                re,
                                Te,
                                Ae,
                                ve = b.ajaxSetup({}, (h = h || {})),
                                He = ve.context || ve,
                                Kt = ve.context && (He.nodeType || He.jquery) ? b(He) : b.event,
                                In = b.Deferred(),
                                Xt = b.Callbacks('once memory'),
                                nr = ve.statusCode || {},
                                Vi = {},
                                oo = {},
                                ao = 'canceled',
                                wn = {
                                    readyState: 0,
                                    getResponseHeader: function (mn) {
                                        var Hi;
                                        if (J) {
                                            if (!A)
                                                for (A = {}; (Hi = Yu.exec(I)); )
                                                    A[Hi[1].toLowerCase() + ' '] = (
                                                        A[Hi[1].toLowerCase() + ' '] || []
                                                    ).concat(Hi[2]);
                                            Hi = A[mn.toLowerCase() + ' '];
                                        }
                                        return null == Hi ? null : Hi.join(', ');
                                    },
                                    getAllResponseHeaders: function () {
                                        return J ? I : null;
                                    },
                                    setRequestHeader: function (mn, Hi) {
                                        return (
                                            null == J &&
                                                ((mn = oo[mn.toLowerCase()] = oo[mn.toLowerCase()] || mn),
                                                (Vi[mn] = Hi)),
                                            this
                                        );
                                    },
                                    overrideMimeType: function (mn) {
                                        return null == J && (ve.mimeType = mn), this;
                                    },
                                    statusCode: function (mn) {
                                        var Hi;
                                        if (mn)
                                            if (J) wn.always(mn[wn.status]);
                                            else for (Hi in mn) nr[Hi] = [nr[Hi], mn[Hi]];
                                        return this;
                                    },
                                    abort: function (mn) {
                                        var Hi = mn || ao;
                                        return y && y.abort(Hi), Jo(0, Hi), this;
                                    },
                                };
                            if (
                                (In.promise(wn),
                                (ve.url = ((u || ve.url || Pa.href) + '').replace(Vc, Pa.protocol + '//')),
                                (ve.type = h.method || h.type || ve.method || ve.type),
                                (ve.dataTypes = (ve.dataType || '*').toLowerCase().match(sn) || ['']),
                                null == ve.crossDomain)
                            ) {
                                ne = Q.createElement('a');
                                try {
                                    (ne.href = ve.url),
                                        (ne.href = ne.href),
                                        (ve.crossDomain = Hc.protocol + '//' + Hc.host != ne.protocol + '//' + ne.host);
                                } catch {
                                    ve.crossDomain = !0;
                                }
                            }
                            if (
                                (ve.data &&
                                    ve.processData &&
                                    'string' != typeof ve.data &&
                                    (ve.data = b.param(ve.data, ve.traditional)),
                                ju(Gl, ve, h, wn),
                                J)
                            )
                                return wn;
                            for (Te in ((re = b.event && ve.global) && 0 == b.active++ && b.event.trigger('ajaxStart'),
                            (ve.type = ve.type.toUpperCase()),
                            (ve.hasContent = !$e.test(ve.type)),
                            (w = ve.url.replace($l, '')),
                            ve.hasContent
                                ? ve.data &&
                                  ve.processData &&
                                  0 === (ve.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                                  (ve.data = ve.data.replace(jl, '+'))
                                : ((Ae = ve.url.slice(w.length)),
                                  ve.data &&
                                      (ve.processData || 'string' == typeof ve.data) &&
                                      ((w += (Nc.test(w) ? '&' : '?') + ve.data), delete ve.data),
                                  !1 === ve.cache &&
                                      ((w = w.replace(Rc, '$1')),
                                      (Ae = (Nc.test(w) ? '&' : '?') + '_=' + _0.guid++ + Ae)),
                                  (ve.url = w + Ae)),
                            ve.ifModified &&
                                (b.lastModified[w] && wn.setRequestHeader('If-Modified-Since', b.lastModified[w]),
                                b.etag[w] && wn.setRequestHeader('If-None-Match', b.etag[w])),
                            ((ve.data && ve.hasContent && !1 !== ve.contentType) || h.contentType) &&
                                wn.setRequestHeader('Content-Type', ve.contentType),
                            wn.setRequestHeader(
                                'Accept',
                                ve.dataTypes[0] && ve.accepts[ve.dataTypes[0]]
                                    ? ve.accepts[ve.dataTypes[0]] +
                                          ('*' !== ve.dataTypes[0] ? ', ' + Fa + '; q=0.01' : '')
                                    : ve.accepts['*'],
                            ),
                            ve.headers))
                                wn.setRequestHeader(Te, ve.headers[Te]);
                            if (ve.beforeSend && (!1 === ve.beforeSend.call(He, wn, ve) || J)) return wn.abort();
                            if (
                                ((ao = 'abort'),
                                Xt.add(ve.complete),
                                wn.done(ve.success),
                                wn.fail(ve.error),
                                (y = ju(Na, ve, h, wn)))
                            ) {
                                if (((wn.readyState = 1), re && Kt.trigger('ajaxSend', [wn, ve]), J)) return wn;
                                ve.async &&
                                    ve.timeout > 0 &&
                                    (B = M.setTimeout(function () {
                                        wn.abort('timeout');
                                    }, ve.timeout));
                                try {
                                    (J = !1), y.send(Vi, Jo);
                                } catch (mn) {
                                    if (J) throw mn;
                                    Jo(-1, mn);
                                }
                            } else Jo(-1, 'No Transport');
                            function Jo(mn, Hi, _r, Bc) {
                                var Se,
                                    Ha,
                                    Ue,
                                    Ys,
                                    lo,
                                    Pr = Hi;
                                J ||
                                    ((J = !0),
                                    B && M.clearTimeout(B),
                                    (y = void 0),
                                    (I = Bc || ''),
                                    (wn.readyState = mn > 0 ? 4 : 0),
                                    (Se = (mn >= 200 && mn < 300) || 304 === mn),
                                    _r &&
                                        (Ys = (function zh(u, h, y) {
                                            for (var w, I, A, B, ne = u.contents, J = u.dataTypes; '*' === J[0]; )
                                                J.shift(),
                                                    void 0 === w &&
                                                        (w = u.mimeType || h.getResponseHeader('Content-Type'));
                                            if (w)
                                                for (I in ne)
                                                    if (ne[I] && ne[I].test(w)) {
                                                        J.unshift(I);
                                                        break;
                                                    }
                                            if (J[0] in y) A = J[0];
                                            else {
                                                for (I in y) {
                                                    if (!J[0] || u.converters[I + ' ' + J[0]]) {
                                                        A = I;
                                                        break;
                                                    }
                                                    B || (B = I);
                                                }
                                                A = A || B;
                                            }
                                            if (A) return A !== J[0] && J.unshift(A), y[A];
                                        })(ve, wn, _r)),
                                    !Se &&
                                        b.inArray('script', ve.dataTypes) > -1 &&
                                        b.inArray('json', ve.dataTypes) < 0 &&
                                        (ve.converters['text script'] = function () {}),
                                    (Ys = (function Ph(u, h, y, w) {
                                        var I,
                                            A,
                                            B,
                                            ne,
                                            J,
                                            re = {},
                                            Te = u.dataTypes.slice();
                                        if (Te[1]) for (B in u.converters) re[B.toLowerCase()] = u.converters[B];
                                        for (A = Te.shift(); A; )
                                            if (
                                                (u.responseFields[A] && (y[u.responseFields[A]] = h),
                                                !J && w && u.dataFilter && (h = u.dataFilter(h, u.dataType)),
                                                (J = A),
                                                (A = Te.shift()))
                                            )
                                                if ('*' === A) A = J;
                                                else if ('*' !== J && J !== A) {
                                                    if (!(B = re[J + ' ' + A] || re['* ' + A]))
                                                        for (I in re)
                                                            if (
                                                                (ne = I.split(' '))[1] === A &&
                                                                (B = re[J + ' ' + ne[0]] || re['* ' + ne[0]])
                                                            ) {
                                                                !0 === B
                                                                    ? (B = re[I])
                                                                    : !0 !== re[I] && ((A = ne[0]), Te.unshift(ne[1]));
                                                                break;
                                                            }
                                                    if (!0 !== B)
                                                        if (B && u.throws) h = B(h);
                                                        else
                                                            try {
                                                                h = B(h);
                                                            } catch (Ae) {
                                                                return {
                                                                    state: 'parsererror',
                                                                    error: B
                                                                        ? Ae
                                                                        : 'No conversion from ' + J + ' to ' + A,
                                                                };
                                                            }
                                                }
                                        return { state: 'success', data: h };
                                    })(ve, Ys, wn, Se)),
                                    Se
                                        ? (ve.ifModified &&
                                              ((lo = wn.getResponseHeader('Last-Modified')) && (b.lastModified[w] = lo),
                                              (lo = wn.getResponseHeader('etag')) && (b.etag[w] = lo)),
                                          204 === mn || 'HEAD' === ve.type
                                              ? (Pr = 'nocontent')
                                              : 304 === mn
                                              ? (Pr = 'notmodified')
                                              : ((Pr = Ys.state), (Ha = Ys.data), (Se = !(Ue = Ys.error))))
                                        : ((Ue = Pr), (mn || !Pr) && ((Pr = 'error'), mn < 0 && (mn = 0))),
                                    (wn.status = mn),
                                    (wn.statusText = (Hi || Pr) + ''),
                                    Se ? In.resolveWith(He, [Ha, Pr, wn]) : In.rejectWith(He, [wn, Pr, Ue]),
                                    wn.statusCode(nr),
                                    (nr = void 0),
                                    re && Kt.trigger(Se ? 'ajaxSuccess' : 'ajaxError', [wn, ve, Se ? Ha : Ue]),
                                    Xt.fireWith(He, [wn, Pr]),
                                    re &&
                                        (Kt.trigger('ajaxComplete', [wn, ve]),
                                        --b.active || b.event.trigger('ajaxStop')));
                            }
                            return wn;
                        },
                        getJSON: function (u, h, y) {
                            return b.get(u, h, y, 'json');
                        },
                        getScript: function (u, h) {
                            return b.get(u, void 0, h, 'script');
                        },
                    }),
                    b.each(['get', 'post'], function (u, h) {
                        b[h] = function (y, w, I, A) {
                            return (
                                N(w) && ((A = A || I), (I = w), (w = void 0)),
                                b.ajax(
                                    b.extend(
                                        { url: y, type: h, dataType: A, data: w, success: I },
                                        b.isPlainObject(y) && y,
                                    ),
                                )
                            );
                        };
                    }),
                    b.ajaxPrefilter(function (u) {
                        var h;
                        for (h in u.headers) 'content-type' === h.toLowerCase() && (u.contentType = u.headers[h] || '');
                    }),
                    (b._evalUrl = function (u, h, y) {
                        return b.ajax({
                            url: u,
                            type: 'GET',
                            dataType: 'script',
                            cache: !0,
                            async: !1,
                            global: !1,
                            converters: { 'text script': function () {} },
                            dataFilter: function (w) {
                                b.globalEval(w, h, y);
                            },
                        });
                    }),
                    b.fn.extend({
                        wrapAll: function (u) {
                            var h;
                            return (
                                this[0] &&
                                    (N(u) && (u = u.call(this[0])),
                                    (h = b(u, this[0].ownerDocument).eq(0).clone(!0)),
                                    this[0].parentNode && h.insertBefore(this[0]),
                                    h
                                        .map(function () {
                                            for (var y = this; y.firstElementChild; ) y = y.firstElementChild;
                                            return y;
                                        })
                                        .append(this)),
                                this
                            );
                        },
                        wrapInner: function (u) {
                            return N(u)
                                ? this.each(function (h) {
                                      b(this).wrapInner(u.call(this, h));
                                  })
                                : this.each(function () {
                                      var h = b(this),
                                          y = h.contents();
                                      y.length ? y.wrapAll(u) : h.append(u);
                                  });
                        },
                        wrap: function (u) {
                            var h = N(u);
                            return this.each(function (y) {
                                b(this).wrapAll(h ? u.call(this, y) : u);
                            });
                        },
                        unwrap: function (u) {
                            return (
                                this.parent(u)
                                    .not('body')
                                    .each(function () {
                                        b(this).replaceWith(this.childNodes);
                                    }),
                                this
                            );
                        },
                    }),
                    (b.expr.pseudos.hidden = function (u) {
                        return !b.expr.pseudos.visible(u);
                    }),
                    (b.expr.pseudos.visible = function (u) {
                        return !!(u.offsetWidth || u.offsetHeight || u.getClientRects().length);
                    }),
                    (b.ajaxSettings.xhr = function () {
                        try {
                            return new M.XMLHttpRequest();
                        } catch {}
                    });
                var Uc = { 0: 200, 1223: 204 },
                    so = b.ajaxSettings.xhr();
                (j.cors = !!so && 'withCredentials' in so),
                    (j.ajax = so = !!so),
                    b.ajaxTransport(function (u) {
                        var h, y;
                        if (j.cors || (so && !u.crossDomain))
                            return {
                                send: function (w, I) {
                                    var A,
                                        B = u.xhr();
                                    if ((B.open(u.type, u.url, u.async, u.username, u.password), u.xhrFields))
                                        for (A in u.xhrFields) B[A] = u.xhrFields[A];
                                    for (A in (u.mimeType && B.overrideMimeType && B.overrideMimeType(u.mimeType),
                                    !u.crossDomain &&
                                        !w['X-Requested-With'] &&
                                        (w['X-Requested-With'] = 'XMLHttpRequest'),
                                    w))
                                        B.setRequestHeader(A, w[A]);
                                    (h = function (ne) {
                                        return function () {
                                            h &&
                                                ((h =
                                                    y =
                                                    B.onload =
                                                    B.onerror =
                                                    B.onabort =
                                                    B.ontimeout =
                                                    B.onreadystatechange =
                                                        null),
                                                'abort' === ne
                                                    ? B.abort()
                                                    : 'error' === ne
                                                    ? 'number' != typeof B.status
                                                        ? I(0, 'error')
                                                        : I(B.status, B.statusText)
                                                    : I(
                                                          Uc[B.status] || B.status,
                                                          B.statusText,
                                                          'text' !== (B.responseType || 'text') ||
                                                              'string' != typeof B.responseText
                                                              ? { binary: B.response }
                                                              : { text: B.responseText },
                                                          B.getAllResponseHeaders(),
                                                      ));
                                        };
                                    }),
                                        (B.onload = h()),
                                        (y = B.onerror = B.ontimeout = h('error')),
                                        void 0 !== B.onabort
                                            ? (B.onabort = y)
                                            : (B.onreadystatechange = function () {
                                                  4 === B.readyState &&
                                                      M.setTimeout(function () {
                                                          h && y();
                                                      });
                                              }),
                                        (h = h('abort'));
                                    try {
                                        B.send((u.hasContent && u.data) || null);
                                    } catch (ne) {
                                        if (h) throw ne;
                                    }
                                },
                                abort: function () {
                                    h && h();
                                },
                            };
                    }),
                    b.ajaxPrefilter(function (u) {
                        u.crossDomain && (u.contents.script = !1);
                    }),
                    b.ajaxSetup({
                        accepts: {
                            script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
                        },
                        contents: { script: /\b(?:java|ecma)script\b/ },
                        converters: {
                            'text script': function (u) {
                                return b.globalEval(u), u;
                            },
                        },
                    }),
                    b.ajaxPrefilter('script', function (u) {
                        void 0 === u.cache && (u.cache = !1), u.crossDomain && (u.type = 'GET');
                    }),
                    b.ajaxTransport('script', function (u) {
                        var h, y;
                        if (u.crossDomain || u.scriptAttrs)
                            return {
                                send: function (w, I) {
                                    (h = b('<script>')
                                        .attr(u.scriptAttrs || {})
                                        .prop({ charset: u.scriptCharset, src: u.url })
                                        .on(
                                            'load error',
                                            (y = function (A) {
                                                h.remove(), (y = null), A && I('error' === A.type ? 404 : 200, A.type);
                                            }),
                                        )),
                                        Q.head.appendChild(h[0]);
                                },
                                abort: function () {
                                    y && y();
                                },
                            };
                    });
                var u,
                    si = [],
                    xo = /(=)\?(?=&|$)|\?\?/;
                b.ajaxSetup({
                    jsonp: 'callback',
                    jsonpCallback: function () {
                        var u = si.pop() || b.expando + '_' + _0.guid++;
                        return (this[u] = !0), u;
                    },
                }),
                    b.ajaxPrefilter('json jsonp', function (u, h, y) {
                        var w,
                            I,
                            A,
                            B =
                                !1 !== u.jsonp &&
                                (xo.test(u.url)
                                    ? 'url'
                                    : 'string' == typeof u.data &&
                                      0 === (u.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                                      xo.test(u.data) &&
                                      'data');
                        if (B || 'jsonp' === u.dataTypes[0])
                            return (
                                (w = u.jsonpCallback = N(u.jsonpCallback) ? u.jsonpCallback() : u.jsonpCallback),
                                B
                                    ? (u[B] = u[B].replace(xo, '$1' + w))
                                    : !1 !== u.jsonp && (u.url += (Nc.test(u.url) ? '&' : '?') + u.jsonp + '=' + w),
                                (u.converters['script json'] = function () {
                                    return A || b.error(w + ' was not called'), A[0];
                                }),
                                (u.dataTypes[0] = 'json'),
                                (I = M[w]),
                                (M[w] = function () {
                                    A = arguments;
                                }),
                                y.always(function () {
                                    void 0 === I ? b(M).removeProp(w) : (M[w] = I),
                                        u[w] && ((u.jsonpCallback = h.jsonpCallback), si.push(w)),
                                        A && N(I) && I(A[0]),
                                        (A = I = void 0);
                                }),
                                'script'
                            );
                    }),
                    (j.createHTMLDocument =
                        (((u = Q.implementation.createHTMLDocument('').body).innerHTML = '<form></form><form></form>'),
                        2 === u.childNodes.length)),
                    (b.parseHTML = function (u, h, y) {
                        return 'string' != typeof u
                            ? []
                            : ('boolean' == typeof h && ((y = h), (h = !1)),
                              h ||
                                  (j.createHTMLDocument
                                      ? (((w = (h = Q.implementation.createHTMLDocument('')).createElement(
                                            'base',
                                        )).href = Q.location.href),
                                        h.head.appendChild(w))
                                      : (h = Q)),
                              (A = !y && []),
                              (I = ot.exec(u))
                                  ? [h.createElement(I[1])]
                                  : ((I = vt([u], h, A)), A && A.length && b(A).remove(), b.merge([], I.childNodes)));
                        var w, I, A;
                    }),
                    (b.fn.load = function (u, h, y) {
                        var w,
                            I,
                            A,
                            B = this,
                            ne = u.indexOf(' ');
                        return (
                            ne > -1 && ((w = or(u.slice(ne))), (u = u.slice(0, ne))),
                            N(h) ? ((y = h), (h = void 0)) : h && 'object' == typeof h && (I = 'POST'),
                            B.length > 0 &&
                                b
                                    .ajax({ url: u, type: I || 'GET', dataType: 'html', data: h })
                                    .done(function (J) {
                                        (A = arguments), B.html(w ? b('<div>').append(b.parseHTML(J)).find(w) : J);
                                    })
                                    .always(
                                        y &&
                                            function (J, re) {
                                                B.each(function () {
                                                    y.apply(this, A || [J.responseText, re, J]);
                                                });
                                            },
                                    ),
                            this
                        );
                    }),
                    (b.expr.pseudos.animated = function (u) {
                        return b.grep(b.timers, function (h) {
                            return u === h.elem;
                        }).length;
                    }),
                    (b.offset = {
                        setOffset: function (u, h, y) {
                            var w,
                                I,
                                A,
                                B,
                                ne,
                                J,
                                Te = b.css(u, 'position'),
                                Ae = b(u),
                                ve = {};
                            'static' === Te && (u.style.position = 'relative'),
                                (ne = Ae.offset()),
                                (A = b.css(u, 'top')),
                                (J = b.css(u, 'left')),
                                ('absolute' === Te || 'fixed' === Te) && (A + J).indexOf('auto') > -1
                                    ? ((B = (w = Ae.position()).top), (I = w.left))
                                    : ((B = parseFloat(A) || 0), (I = parseFloat(J) || 0)),
                                N(h) && (h = h.call(u, y, b.extend({}, ne))),
                                null != h.top && (ve.top = h.top - ne.top + B),
                                null != h.left && (ve.left = h.left - ne.left + I),
                                'using' in h ? h.using.call(u, ve) : Ae.css(ve);
                        },
                    }),
                    b.fn.extend({
                        offset: function (u) {
                            if (arguments.length)
                                return void 0 === u
                                    ? this
                                    : this.each(function (I) {
                                          b.offset.setOffset(this, u, I);
                                      });
                            var h,
                                y,
                                w = this[0];
                            return w
                                ? w.getClientRects().length
                                    ? {
                                          top:
                                              (h = w.getBoundingClientRect()).top +
                                              (y = w.ownerDocument.defaultView).pageYOffset,
                                          left: h.left + y.pageXOffset,
                                      }
                                    : { top: 0, left: 0 }
                                : void 0;
                        },
                        position: function () {
                            if (this[0]) {
                                var u,
                                    h,
                                    y,
                                    w = this[0],
                                    I = { top: 0, left: 0 };
                                if ('fixed' === b.css(w, 'position')) h = w.getBoundingClientRect();
                                else {
                                    for (
                                        h = this.offset(), y = w.ownerDocument, u = w.offsetParent || y.documentElement;
                                        u &&
                                        (u === y.body || u === y.documentElement) &&
                                        'static' === b.css(u, 'position');

                                    )
                                        u = u.parentNode;
                                    u &&
                                        u !== w &&
                                        1 === u.nodeType &&
                                        (((I = b(u).offset()).top += b.css(u, 'borderTopWidth', !0)),
                                        (I.left += b.css(u, 'borderLeftWidth', !0)));
                                }
                                return {
                                    top: h.top - I.top - b.css(w, 'marginTop', !0),
                                    left: h.left - I.left - b.css(w, 'marginLeft', !0),
                                };
                            }
                        },
                        offsetParent: function () {
                            return this.map(function () {
                                for (var u = this.offsetParent; u && 'static' === b.css(u, 'position'); )
                                    u = u.offsetParent;
                                return u || ye;
                            });
                        },
                    }),
                    b.each({ scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' }, function (u, h) {
                        var y = 'pageYOffset' === h;
                        b.fn[u] = function (w) {
                            return rr(
                                this,
                                function (I, A, B) {
                                    var ne;
                                    if ((K(I) ? (ne = I) : 9 === I.nodeType && (ne = I.defaultView), void 0 === B))
                                        return ne ? ne[h] : I[A];
                                    ne ? ne.scrollTo(y ? ne.pageXOffset : B, y ? B : ne.pageYOffset) : (I[A] = B);
                                },
                                u,
                                w,
                                arguments.length,
                            );
                        };
                    }),
                    b.each(['top', 'left'], function (u, h) {
                        b.cssHooks[h] = Ul(j.pixelPosition, function (y, w) {
                            if (w) return (w = Do(y, h)), ps.test(w) ? b(y).position()[h] + 'px' : w;
                        });
                    }),
                    b.each({ Height: 'height', Width: 'width' }, function (u, h) {
                        b.each({ padding: 'inner' + u, content: h, '': 'outer' + u }, function (y, w) {
                            b.fn[w] = function (I, A) {
                                var B = arguments.length && (y || 'boolean' != typeof I),
                                    ne = y || (!0 === I || !0 === A ? 'margin' : 'border');
                                return rr(
                                    this,
                                    function (J, re, Te) {
                                        var Ae;
                                        return K(J)
                                            ? 0 === w.indexOf('outer')
                                                ? J['inner' + u]
                                                : J.document.documentElement['client' + u]
                                            : 9 === J.nodeType
                                            ? ((Ae = J.documentElement),
                                              Math.max(
                                                  J.body['scroll' + u],
                                                  Ae['scroll' + u],
                                                  J.body['offset' + u],
                                                  Ae['offset' + u],
                                                  Ae['client' + u],
                                              ))
                                            : void 0 === Te
                                            ? b.css(J, re, ne)
                                            : b.style(J, re, Te, ne);
                                    },
                                    h,
                                    B ? I : void 0,
                                    B,
                                );
                            };
                        });
                    }),
                    b.each(
                        ['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'],
                        function (u, h) {
                            b.fn[h] = function (y) {
                                return this.on(h, y);
                            };
                        },
                    ),
                    b.fn.extend({
                        bind: function (u, h, y) {
                            return this.on(u, null, h, y);
                        },
                        unbind: function (u, h) {
                            return this.off(u, null, h);
                        },
                        delegate: function (u, h, y, w) {
                            return this.on(h, u, y, w);
                        },
                        undelegate: function (u, h, y) {
                            return 1 === arguments.length ? this.off(u, '**') : this.off(h, u || '**', y);
                        },
                        hover: function (u, h) {
                            return this.on('mouseenter', u).on('mouseleave', h || u);
                        },
                    }),
                    b.each(
                        'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
                            ' ',
                        ),
                        function (u, h) {
                            b.fn[h] = function (y, w) {
                                return arguments.length > 0 ? this.on(h, null, y, w) : this.trigger(h);
                            };
                        },
                    );
                var Ra = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
                (b.proxy = function (u, h) {
                    var y, w, I;
                    if (('string' == typeof h && ((y = u[h]), (h = u), (u = y)), N(u)))
                        return (
                            (w = v.call(arguments, 2)),
                            (I = function () {
                                return u.apply(h || this, w.concat(v.call(arguments)));
                            }),
                            (I.guid = u.guid = u.guid || b.guid++),
                            I
                        );
                }),
                    (b.holdReady = function (u) {
                        u ? b.readyWait++ : b.ready(!0);
                    }),
                    (b.isArray = Array.isArray),
                    (b.parseJSON = JSON.parse),
                    (b.nodeName = Ne),
                    (b.isFunction = N),
                    (b.isWindow = K),
                    (b.camelCase = pr),
                    (b.type = De),
                    (b.now = Date.now),
                    (b.isNumeric = function (u) {
                        var h = b.type(u);
                        return ('number' === h || 'string' === h) && !isNaN(u - parseFloat(u));
                    }),
                    (b.trim = function (u) {
                        return null == u ? '' : (u + '').replace(Ra, '$1');
                    }),
                    void 0 !==
                        (O = function () {
                            return b;
                        }.apply(ae, [])) && (se.exports = O);
                var ko = M.jQuery,
                    Va = M.$;
                return (
                    (b.noConflict = function (u) {
                        return M.$ === b && (M.$ = Va), u && M.jQuery === b && (M.jQuery = ko), b;
                    }),
                    typeof q > 'u' && (M.jQuery = M.$ = b),
                    b
                );
            });
        },
        9545: function (se, ae, U) {
            (se = U.nmd(se)).exports = (function () {
                'use strict';
                var O, N;
                function M() {
                    return O.apply(null, arguments);
                }
                function G(d) {
                    return d instanceof Array || '[object Array]' === Object.prototype.toString.call(d);
                }
                function $(d) {
                    return null != d && '[object Object]' === Object.prototype.toString.call(d);
                }
                function v(d, m) {
                    return Object.prototype.hasOwnProperty.call(d, m);
                }
                function p(d) {
                    if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(d).length;
                    var m;
                    for (m in d) if (v(d, m)) return !1;
                    return !0;
                }
                function _(d) {
                    return void 0 === d;
                }
                function T(d) {
                    return 'number' == typeof d || '[object Number]' === Object.prototype.toString.call(d);
                }
                function x(d) {
                    return d instanceof Date || '[object Date]' === Object.prototype.toString.call(d);
                }
                function F(d, m) {
                    var D,
                        S = [],
                        Y = d.length;
                    for (D = 0; D < Y; ++D) S.push(m(d[D], D));
                    return S;
                }
                function C(d, m) {
                    for (var S in m) v(m, S) && (d[S] = m[S]);
                    return v(m, 'toString') && (d.toString = m.toString), v(m, 'valueOf') && (d.valueOf = m.valueOf), d;
                }
                function k(d, m, S, D) {
                    return Gu(d, m, S, D, !0).utc();
                }
                function j(d) {
                    return (
                        null == d._pf &&
                            (d._pf = {
                                empty: !1,
                                unusedTokens: [],
                                unusedInput: [],
                                overflow: -2,
                                charsLeftOver: 0,
                                nullInput: !1,
                                invalidEra: null,
                                invalidMonth: null,
                                invalidFormat: !1,
                                userInvalidated: !1,
                                iso: !1,
                                parsedDateParts: [],
                                era: null,
                                meridiem: null,
                                rfc2822: !1,
                                weekdayMismatch: !1,
                            }),
                        d._pf
                    );
                }
                function K(d) {
                    if (null == d._isValid) {
                        var m = j(d),
                            S = N.call(m.parsedDateParts, function (Y) {
                                return null != Y;
                            }),
                            D =
                                !isNaN(d._d.getTime()) &&
                                m.overflow < 0 &&
                                !m.empty &&
                                !m.invalidEra &&
                                !m.invalidMonth &&
                                !m.invalidWeekday &&
                                !m.weekdayMismatch &&
                                !m.nullInput &&
                                !m.invalidFormat &&
                                !m.userInvalidated &&
                                (!m.meridiem || (m.meridiem && S));
                        if (
                            (d._strict &&
                                (D = D && 0 === m.charsLeftOver && 0 === m.unusedTokens.length && void 0 === m.bigHour),
                            null != Object.isFrozen && Object.isFrozen(d))
                        )
                            return D;
                        d._isValid = D;
                    }
                    return d._isValid;
                }
                function Q(d) {
                    var m = k(NaN);
                    return null != d ? C(j(m), d) : (j(m).userInvalidated = !0), m;
                }
                N = Array.prototype.some
                    ? Array.prototype.some
                    : function (d) {
                          var D,
                              m = Object(this),
                              S = m.length >>> 0;
                          for (D = 0; D < S; D++) if (D in m && d.call(this, m[D], D, m)) return !0;
                          return !1;
                      };
                var ce = (M.momentProperties = []),
                    ge = !1;
                function De(d, m) {
                    var S,
                        D,
                        Y,
                        oe = ce.length;
                    if (
                        (_(m._isAMomentObject) || (d._isAMomentObject = m._isAMomentObject),
                        _(m._i) || (d._i = m._i),
                        _(m._f) || (d._f = m._f),
                        _(m._l) || (d._l = m._l),
                        _(m._strict) || (d._strict = m._strict),
                        _(m._tzm) || (d._tzm = m._tzm),
                        _(m._isUTC) || (d._isUTC = m._isUTC),
                        _(m._offset) || (d._offset = m._offset),
                        _(m._pf) || (d._pf = j(m)),
                        _(m._locale) || (d._locale = m._locale),
                        oe > 0)
                    )
                        for (S = 0; S < oe; S++) _((Y = m[(D = ce[S])])) || (d[D] = Y);
                    return d;
                }
                function xe(d) {
                    De(this, d),
                        (this._d = new Date(null != d._d ? d._d.getTime() : NaN)),
                        this.isValid() || (this._d = new Date(NaN)),
                        !1 === ge && ((ge = !0), M.updateOffset(this), (ge = !1));
                }
                function Ve(d) {
                    return d instanceof xe || (null != d && null != d._isAMomentObject);
                }
                function b(d) {
                    !1 === M.suppressDeprecationWarnings &&
                        typeof console < 'u' &&
                        console.warn &&
                        console.warn('Deprecation warning: ' + d);
                }
                function je(d, m) {
                    var S = !0;
                    return C(function () {
                        if ((null != M.deprecationHandler && M.deprecationHandler(null, d), S)) {
                            var Y,
                                oe,
                                Ee,
                                D = [],
                                xt = arguments.length;
                            for (oe = 0; oe < xt; oe++) {
                                if (((Y = ''), 'object' == typeof arguments[oe])) {
                                    for (Ee in ((Y += '\n[' + oe + '] '), arguments[0]))
                                        v(arguments[0], Ee) && (Y += Ee + ': ' + arguments[0][Ee] + ', ');
                                    Y = Y.slice(0, -2);
                                } else Y = arguments[oe];
                                D.push(Y);
                            }
                            b(d + '\nArguments: ' + Array.prototype.slice.call(D).join('') + '\n' + new Error().stack),
                                (S = !1);
                        }
                        return m.apply(this, arguments);
                    }, m);
                }
                var Gt,
                    Ne = {};
                function at(d, m) {
                    null != M.deprecationHandler && M.deprecationHandler(d, m), Ne[d] || (b(m), (Ne[d] = !0));
                }
                function Et(d) {
                    return (
                        (typeof Function < 'u' && d instanceof Function) ||
                        '[object Function]' === Object.prototype.toString.call(d)
                    );
                }
                function Re(d, m) {
                    var D,
                        S = C({}, d);
                    for (D in m)
                        v(m, D) &&
                            ($(d[D]) && $(m[D])
                                ? ((S[D] = {}), C(S[D], d[D]), C(S[D], m[D]))
                                : null != m[D]
                                ? (S[D] = m[D])
                                : delete S[D]);
                    for (D in d) v(d, D) && !v(m, D) && $(d[D]) && (S[D] = C({}, S[D]));
                    return S;
                }
                function Pt(d) {
                    null != d && this.set(d);
                }
                (M.suppressDeprecationWarnings = !1),
                    (M.deprecationHandler = null),
                    (Gt = Object.keys
                        ? Object.keys
                        : function (d) {
                              var m,
                                  S = [];
                              for (m in d) v(d, m) && S.push(m);
                              return S;
                          });
                function qt(d, m, S) {
                    var D = '' + Math.abs(d);
                    return (
                        (d >= 0 ? (S ? '+' : '') : '-') +
                        Math.pow(10, Math.max(0, m - D.length))
                            .toString()
                            .substr(1) +
                        D
                    );
                }
                var Vt =
                        /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
                    an = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
                    qe = {},
                    ot = {};
                function ke(d, m, S, D) {
                    var Y = D;
                    'string' == typeof D &&
                        (Y = function () {
                            return this[D]();
                        }),
                        d && (ot[d] = Y),
                        m &&
                            (ot[m[0]] = function () {
                                return qt(Y.apply(this, arguments), m[1], m[2]);
                            }),
                        S &&
                            (ot[S] = function () {
                                return this.localeData().ordinal(Y.apply(this, arguments), d);
                            });
                }
                function Ce(d) {
                    return d.match(/\[[\s\S]/) ? d.replace(/^\[|\]$/g, '') : d.replace(/\\/g, '');
                }
                function _t(d, m) {
                    return d.isValid()
                        ? ((m = Ht(m, d.localeData())),
                          (qe[m] =
                              qe[m] ||
                              (function Pe(d) {
                                  var S,
                                      D,
                                      m = d.match(Vt);
                                  for (S = 0, D = m.length; S < D; S++) m[S] = ot[m[S]] ? ot[m[S]] : Ce(m[S]);
                                  return function (Y) {
                                      var Ee,
                                          oe = '';
                                      for (Ee = 0; Ee < D; Ee++) oe += Et(m[Ee]) ? m[Ee].call(Y, d) : m[Ee];
                                      return oe;
                                  };
                              })(m)),
                          qe[m](d))
                        : d.localeData().invalidDate();
                }
                function Ht(d, m) {
                    var S = 5;
                    function D(Y) {
                        return m.longDateFormat(Y) || Y;
                    }
                    for (an.lastIndex = 0; S >= 0 && an.test(d); ) (d = d.replace(an, D)), (an.lastIndex = 0), (S -= 1);
                    return d;
                }
                var rr = {};
                function Ri(d, m) {
                    var S = d.toLowerCase();
                    rr[S] = rr[S + 's'] = rr[m] = d;
                }
                function Oi(d) {
                    return 'string' == typeof d ? rr[d] || rr[d.toLowerCase()] : void 0;
                }
                function Hs(d) {
                    var S,
                        D,
                        m = {};
                    for (D in d) v(d, D) && (S = Oi(D)) && (m[S] = d[D]);
                    return m;
                }
                var pr = {};
                function Kn(d, m) {
                    pr[d] = m;
                }
                function ft(d) {
                    return (d % 4 == 0 && d % 100 != 0) || d % 400 == 0;
                }
                function gn(d) {
                    return d < 0 ? Math.ceil(d) || 0 : Math.floor(d);
                }
                function Ut(d) {
                    var m = +d,
                        S = 0;
                    return 0 !== m && isFinite(m) && (S = gn(m)), S;
                }
                function sr(d, m) {
                    return function (S) {
                        return null != S ? (hl(this, d, S), M.updateOffset(this, m), this) : Es(this, d);
                    };
                }
                function Es(d, m) {
                    return d.isValid() ? d._d['get' + (d._isUTC ? 'UTC' : '') + m]() : NaN;
                }
                function hl(d, m, S) {
                    d.isValid() &&
                        !isNaN(S) &&
                        ('FullYear' === m && ft(d.year()) && 1 === d.month() && 29 === d.date()
                            ? ((S = Ut(S)), d._d['set' + (d._isUTC ? 'UTC' : '') + m](S, d.month(), Do(S, d.month())))
                            : d._d['set' + (d._isUTC ? 'UTC' : '') + m](S));
                }
                var io,
                    _e = /\d/,
                    ye = /\d\d/,
                    on = /\d{3}/,
                    kn = /\d{4}/,
                    Qn = /[+-]?\d{6}/,
                    lt = /\d\d?/,
                    Is = /\d\d\d\d?/,
                    As = /\d\d\d\d\d\d?/,
                    Yn = /\d{1,3}/,
                    Br = /\d{1,4}/,
                    no = /[+-]?\d{1,6}/,
                    Tn = /\d+/,
                    ni = /[+-]?\d+/,
                    gr = /Z|[+-]\d\d:?\d\d/gi,
                    So = /Z|[+-]\d\d(?::?\d\d)?/gi,
                    vt =
                        /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
                function Ke(d, m, S) {
                    io[d] = Et(m)
                        ? m
                        : function (D, Y) {
                              return D && S ? S : m;
                          };
                }
                function ro(d, m) {
                    return v(io, d)
                        ? io[d](m._strict, m._locale)
                        : new RegExp(
                              (function mi(d) {
                                  return ln(
                                      d
                                          .replace('\\', '')
                                          .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (m, S, D, Y, oe) {
                                              return S || D || Y || oe;
                                          }),
                                  );
                              })(d),
                          );
                }
                function ln(d) {
                    return d.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                }
                io = {};
                var za = {};
                function Ct(d, m) {
                    var S,
                        Y,
                        D = m;
                    for (
                        'string' == typeof d && (d = [d]),
                            T(m) &&
                                (D = function (oe, Ee) {
                                    Ee[m] = Ut(oe);
                                }),
                            Y = d.length,
                            S = 0;
                        S < Y;
                        S++
                    )
                        za[d[S]] = D;
                }
                function ha(d, m) {
                    Ct(d, function (S, D, Y, oe) {
                        (Y._w = Y._w || {}), m(S, Y._w, Y, oe);
                    });
                }
                function fa(d, m, S) {
                    null != m && v(za, d) && za[d](m, S._a, S, d);
                }
                var pi,
                    Me = 0,
                    zr = 1,
                    dr = 2,
                    ri = 3,
                    er = 4,
                    Bs = 5,
                    ps = 6,
                    qs = 7,
                    To = 8;
                function Do(d, m) {
                    if (isNaN(d) || isNaN(m)) return NaN;
                    var S = (function ma(d, m) {
                        return ((d % m) + m) % m;
                    })(m, 12);
                    return (d += (m - S) / 12), 1 === S ? (ft(d) ? 29 : 28) : 31 - ((S % 7) % 2);
                }
                (pi = Array.prototype.indexOf
                    ? Array.prototype.indexOf
                    : function (d) {
                          var m;
                          for (m = 0; m < this.length; ++m) if (this[m] === d) return m;
                          return -1;
                      }),
                    ke('M', ['MM', 2], 'Mo', function () {
                        return this.month() + 1;
                    }),
                    ke('MMM', 0, 0, function (d) {
                        return this.localeData().monthsShort(this, d);
                    }),
                    ke('MMMM', 0, 0, function (d) {
                        return this.localeData().months(this, d);
                    }),
                    Ri('month', 'M'),
                    Kn('month', 8),
                    Ke('M', lt),
                    Ke('MM', lt, ye),
                    Ke('MMM', function (d, m) {
                        return m.monthsShortRegex(d);
                    }),
                    Ke('MMMM', function (d, m) {
                        return m.monthsRegex(d);
                    }),
                    Ct(['M', 'MM'], function (d, m) {
                        m[zr] = Ut(d) - 1;
                    }),
                    Ct(['MMM', 'MMMM'], function (d, m, S, D) {
                        var Y = S._locale.monthsParse(d, D, S._strict);
                        null != Y ? (m[zr] = Y) : (j(S).invalidMonth = d);
                    });
                var Ul = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                        '_',
                    ),
                    Xo = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                    Ru = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
                    Rn = vt,
                    Ih = vt;
                function f0(d, m, S) {
                    var D,
                        Y,
                        oe,
                        Ee = d.toLocaleLowerCase();
                    if (!this._monthsParse)
                        for (
                            this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], D = 0;
                            D < 12;
                            ++D
                        )
                            (oe = k([2e3, D])),
                                (this._shortMonthsParse[D] = this.monthsShort(oe, '').toLocaleLowerCase()),
                                (this._longMonthsParse[D] = this.months(oe, '').toLocaleLowerCase());
                    return S
                        ? 'MMM' === m
                            ? -1 !== (Y = pi.call(this._shortMonthsParse, Ee))
                                ? Y
                                : null
                            : -1 !== (Y = pi.call(this._longMonthsParse, Ee))
                            ? Y
                            : null
                        : 'MMM' === m
                        ? -1 !== (Y = pi.call(this._shortMonthsParse, Ee)) ||
                          -1 !== (Y = pi.call(this._longMonthsParse, Ee))
                            ? Y
                            : null
                        : -1 !== (Y = pi.call(this._longMonthsParse, Ee)) ||
                          -1 !== (Y = pi.call(this._shortMonthsParse, Ee))
                        ? Y
                        : null;
                }
                function fl(d, m) {
                    var S;
                    if (!d.isValid()) return d;
                    if ('string' == typeof m)
                        if (/^\d+$/.test(m)) m = Ut(m);
                        else if (!T((m = d.localeData().monthsParse(m)))) return d;
                    return (
                        (S = Math.min(d.date(), Do(d.year(), m))),
                        d._d['set' + (d._isUTC ? 'UTC' : '') + 'Month'](m, S),
                        d
                    );
                }
                function zc(d) {
                    return null != d ? (fl(this, d), M.updateOffset(this, !0), this) : Es(this, 'Month');
                }
                function Zo() {
                    function d(Ee, xt) {
                        return xt.length - Ee.length;
                    }
                    var Y,
                        oe,
                        m = [],
                        S = [],
                        D = [];
                    for (Y = 0; Y < 12; Y++)
                        (oe = k([2e3, Y])),
                            m.push(this.monthsShort(oe, '')),
                            S.push(this.months(oe, '')),
                            D.push(this.months(oe, '')),
                            D.push(this.monthsShort(oe, ''));
                    for (m.sort(d), S.sort(d), D.sort(d), Y = 0; Y < 12; Y++) (m[Y] = ln(m[Y])), (S[Y] = ln(S[Y]));
                    for (Y = 0; Y < 24; Y++) D[Y] = ln(D[Y]);
                    (this._monthsRegex = new RegExp('^(' + D.join('|') + ')', 'i')),
                        (this._monthsShortRegex = this._monthsRegex),
                        (this._monthsStrictRegex = new RegExp('^(' + S.join('|') + ')', 'i')),
                        (this._monthsShortStrictRegex = new RegExp('^(' + m.join('|') + ')', 'i'));
                }
                function vr(d) {
                    return ft(d) ? 366 : 365;
                }
                ke('Y', 0, 0, function () {
                    var d = this.year();
                    return d <= 9999 ? qt(d, 4) : '+' + d;
                }),
                    ke(0, ['YY', 2], 0, function () {
                        return this.year() % 100;
                    }),
                    ke(0, ['YYYY', 4], 0, 'year'),
                    ke(0, ['YYYYY', 5], 0, 'year'),
                    ke(0, ['YYYYYY', 6, !0], 0, 'year'),
                    Ri('year', 'y'),
                    Kn('year', 1),
                    Ke('Y', ni),
                    Ke('YY', lt, ye),
                    Ke('YYYY', Br, kn),
                    Ke('YYYYY', no, Qn),
                    Ke('YYYYYY', no, Qn),
                    Ct(['YYYYY', 'YYYYYY'], Me),
                    Ct('YYYY', function (d, m) {
                        m[Me] = 2 === d.length ? M.parseTwoDigitYear(d) : Ut(d);
                    }),
                    Ct('YY', function (d, m) {
                        m[Me] = M.parseTwoDigitYear(d);
                    }),
                    Ct('Y', function (d, m) {
                        m[Me] = parseInt(d, 10);
                    }),
                    (M.parseTwoDigitYear = function (d) {
                        return Ut(d) + (Ut(d) > 68 ? 1900 : 2e3);
                    });
                var m0 = sr('FullYear', !0);
                function p0(d, m, S, D, Y, oe, Ee) {
                    var xt;
                    return (
                        d < 100 && d >= 0
                            ? ((xt = new Date(d + 400, m, S, D, Y, oe, Ee)),
                              isFinite(xt.getFullYear()) && xt.setFullYear(d))
                            : (xt = new Date(d, m, S, D, Y, oe, Ee)),
                        xt
                    );
                }
                function qr(d) {
                    var m, S;
                    return (
                        d < 100 && d >= 0
                            ? (((S = Array.prototype.slice.call(arguments))[0] = d + 400),
                              (m = new Date(Date.UTC.apply(null, S))),
                              isFinite(m.getUTCFullYear()) && m.setUTCFullYear(d))
                            : (m = new Date(Date.UTC.apply(null, arguments))),
                        m
                    );
                }
                function Bl(d, m, S) {
                    var D = 7 + m - S;
                    return (-(7 + qr(d, 0, D).getUTCDay() - m) % 7) + D - 1;
                }
                function g0(d, m, S, D, Y) {
                    var pn,
                        vi,
                        xt = 1 + 7 * (m - 1) + ((7 + S - D) % 7) + Bl(d, D, Y);
                    return (
                        xt <= 0
                            ? (vi = vr((pn = d - 1)) + xt)
                            : xt > vr(d)
                            ? ((pn = d + 1), (vi = xt - vr(d)))
                            : ((pn = d), (vi = xt)),
                        { year: pn, dayOfYear: vi }
                    );
                }
                function ql(d, m, S) {
                    var oe,
                        Ee,
                        D = Bl(d.year(), m, S),
                        Y = Math.floor((d.dayOfYear() - D - 1) / 7) + 1;
                    return (
                        Y < 1
                            ? (oe = Y + hr((Ee = d.year() - 1), m, S))
                            : Y > hr(d.year(), m, S)
                            ? ((oe = Y - hr(d.year(), m, S)), (Ee = d.year() + 1))
                            : ((Ee = d.year()), (oe = Y)),
                        { week: oe, year: Ee }
                    );
                }
                function hr(d, m, S) {
                    var D = Bl(d, m, S),
                        Y = Bl(d + 1, m, S);
                    return (vr(d) - D + Y) / 7;
                }
                ke('w', ['ww', 2], 'wo', 'week'),
                    ke('W', ['WW', 2], 'Wo', 'isoWeek'),
                    Ri('week', 'w'),
                    Ri('isoWeek', 'W'),
                    Kn('week', 5),
                    Kn('isoWeek', 5),
                    Ke('w', lt),
                    Ke('ww', lt, ye),
                    Ke('W', lt),
                    Ke('WW', lt, ye),
                    ha(['w', 'ww', 'W', 'WW'], function (d, m, S, D) {
                        m[D.substr(0, 1)] = Ut(d);
                    });
                function Pa(d, m) {
                    return d.slice(m, 7).concat(d.slice(0, m));
                }
                ke('d', 0, 'do', 'day'),
                    ke('dd', 0, 0, function (d) {
                        return this.localeData().weekdaysMin(this, d);
                    }),
                    ke('ddd', 0, 0, function (d) {
                        return this.localeData().weekdaysShort(this, d);
                    }),
                    ke('dddd', 0, 0, function (d) {
                        return this.localeData().weekdays(this, d);
                    }),
                    ke('e', 0, 0, 'weekday'),
                    ke('E', 0, 0, 'isoWeekday'),
                    Ri('day', 'd'),
                    Ri('weekday', 'e'),
                    Ri('isoWeekday', 'E'),
                    Kn('day', 11),
                    Kn('weekday', 11),
                    Kn('isoWeekday', 11),
                    Ke('d', lt),
                    Ke('e', lt),
                    Ke('E', lt),
                    Ke('dd', function (d, m) {
                        return m.weekdaysMinRegex(d);
                    }),
                    Ke('ddd', function (d, m) {
                        return m.weekdaysShortRegex(d);
                    }),
                    Ke('dddd', function (d, m) {
                        return m.weekdaysRegex(d);
                    }),
                    ha(['dd', 'ddd', 'dddd'], function (d, m, S, D) {
                        var Y = S._locale.weekdaysParse(d, D, S._strict);
                        null != Y ? (m.d = Y) : (j(S).invalidWeekday = d);
                    }),
                    ha(['d', 'e', 'E'], function (d, m, S, D) {
                        m[D] = Ut(d);
                    });
                var _0 = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                    Nc = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                    We = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                    y0 = vt,
                    zn = vt,
                    ml = vt;
                function jl(d, m, S) {
                    var D,
                        Y,
                        oe,
                        Ee = d.toLocaleLowerCase();
                    if (!this._weekdaysParse)
                        for (
                            this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], D = 0;
                            D < 7;
                            ++D
                        )
                            (oe = k([2e3, 1]).day(D)),
                                (this._minWeekdaysParse[D] = this.weekdaysMin(oe, '').toLocaleLowerCase()),
                                (this._shortWeekdaysParse[D] = this.weekdaysShort(oe, '').toLocaleLowerCase()),
                                (this._weekdaysParse[D] = this.weekdays(oe, '').toLocaleLowerCase());
                    return S
                        ? 'dddd' === m
                            ? -1 !== (Y = pi.call(this._weekdaysParse, Ee))
                                ? Y
                                : null
                            : 'ddd' === m
                            ? -1 !== (Y = pi.call(this._shortWeekdaysParse, Ee))
                                ? Y
                                : null
                            : -1 !== (Y = pi.call(this._minWeekdaysParse, Ee))
                            ? Y
                            : null
                        : 'dddd' === m
                        ? -1 !== (Y = pi.call(this._weekdaysParse, Ee)) ||
                          -1 !== (Y = pi.call(this._shortWeekdaysParse, Ee)) ||
                          -1 !== (Y = pi.call(this._minWeekdaysParse, Ee))
                            ? Y
                            : null
                        : 'ddd' === m
                        ? -1 !== (Y = pi.call(this._shortWeekdaysParse, Ee)) ||
                          -1 !== (Y = pi.call(this._weekdaysParse, Ee)) ||
                          -1 !== (Y = pi.call(this._minWeekdaysParse, Ee))
                            ? Y
                            : null
                        : -1 !== (Y = pi.call(this._minWeekdaysParse, Ee)) ||
                          -1 !== (Y = pi.call(this._weekdaysParse, Ee)) ||
                          -1 !== (Y = pi.call(this._shortWeekdaysParse, Ee))
                        ? Y
                        : null;
                }
                function Na() {
                    function d(Gr, _a) {
                        return _a.length - Gr.length;
                    }
                    var oe,
                        Ee,
                        xt,
                        pn,
                        vi,
                        m = [],
                        S = [],
                        D = [],
                        Y = [];
                    for (oe = 0; oe < 7; oe++)
                        (Ee = k([2e3, 1]).day(oe)),
                            (xt = ln(this.weekdaysMin(Ee, ''))),
                            (pn = ln(this.weekdaysShort(Ee, ''))),
                            (vi = ln(this.weekdays(Ee, ''))),
                            m.push(xt),
                            S.push(pn),
                            D.push(vi),
                            Y.push(xt),
                            Y.push(pn),
                            Y.push(vi);
                    m.sort(d),
                        S.sort(d),
                        D.sort(d),
                        Y.sort(d),
                        (this._weekdaysRegex = new RegExp('^(' + Y.join('|') + ')', 'i')),
                        (this._weekdaysShortRegex = this._weekdaysRegex),
                        (this._weekdaysMinRegex = this._weekdaysRegex),
                        (this._weekdaysStrictRegex = new RegExp('^(' + D.join('|') + ')', 'i')),
                        (this._weekdaysShortStrictRegex = new RegExp('^(' + S.join('|') + ')', 'i')),
                        (this._weekdaysMinStrictRegex = new RegExp('^(' + m.join('|') + ')', 'i'));
                }
                function Fa() {
                    return this.hours() % 12 || 12;
                }
                function pl(d, m) {
                    ke(d, 0, 0, function () {
                        return this.localeData().meridiem(this.hours(), this.minutes(), m);
                    });
                }
                function ju(d, m) {
                    return m._meridiemParse;
                }
                ke('H', ['HH', 2], 0, 'hour'),
                    ke('h', ['hh', 2], 0, Fa),
                    ke('k', ['kk', 2], 0, function Hc() {
                        return this.hours() || 24;
                    }),
                    ke('hmm', 0, 0, function () {
                        return '' + Fa.apply(this) + qt(this.minutes(), 2);
                    }),
                    ke('hmmss', 0, 0, function () {
                        return '' + Fa.apply(this) + qt(this.minutes(), 2) + qt(this.seconds(), 2);
                    }),
                    ke('Hmm', 0, 0, function () {
                        return '' + this.hours() + qt(this.minutes(), 2);
                    }),
                    ke('Hmmss', 0, 0, function () {
                        return '' + this.hours() + qt(this.minutes(), 2) + qt(this.seconds(), 2);
                    }),
                    pl('a', !0),
                    pl('A', !1),
                    Ri('hour', 'h'),
                    Kn('hour', 13),
                    Ke('a', ju),
                    Ke('A', ju),
                    Ke('H', lt),
                    Ke('h', lt),
                    Ke('k', lt),
                    Ke('HH', lt, ye),
                    Ke('hh', lt, ye),
                    Ke('kk', lt, ye),
                    Ke('hmm', Is),
                    Ke('hmmss', As),
                    Ke('Hmm', Is),
                    Ke('Hmmss', As),
                    Ct(['H', 'HH'], ri),
                    Ct(['k', 'kk'], function (d, m, S) {
                        var D = Ut(d);
                        m[ri] = 24 === D ? 0 : D;
                    }),
                    Ct(['a', 'A'], function (d, m, S) {
                        (S._isPm = S._locale.isPM(d)), (S._meridiem = d);
                    }),
                    Ct(['h', 'hh'], function (d, m, S) {
                        (m[ri] = Ut(d)), (j(S).bigHour = !0);
                    }),
                    Ct('hmm', function (d, m, S) {
                        var D = d.length - 2;
                        (m[ri] = Ut(d.substr(0, D))), (m[er] = Ut(d.substr(D))), (j(S).bigHour = !0);
                    }),
                    Ct('hmmss', function (d, m, S) {
                        var D = d.length - 4,
                            Y = d.length - 2;
                        (m[ri] = Ut(d.substr(0, D))),
                            (m[er] = Ut(d.substr(D, 2))),
                            (m[Bs] = Ut(d.substr(Y))),
                            (j(S).bigHour = !0);
                    }),
                    Ct('Hmm', function (d, m, S) {
                        var D = d.length - 2;
                        (m[ri] = Ut(d.substr(0, D))), (m[er] = Ut(d.substr(D)));
                    }),
                    Ct('Hmmss', function (d, m, S) {
                        var D = d.length - 4,
                            Y = d.length - 2;
                        (m[ri] = Ut(d.substr(0, D))), (m[er] = Ut(d.substr(D, 2))), (m[Bs] = Ut(d.substr(Y)));
                    });
                var Ph = sr('Hours', !0);
                var Ra,
                    so = {
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        longDateFormat: {
                            LTS: 'h:mm:ss A',
                            LT: 'h:mm A',
                            L: 'MM/DD/YYYY',
                            LL: 'MMMM D, YYYY',
                            LLL: 'MMMM D, YYYY h:mm A',
                            LLLL: 'dddd, MMMM D, YYYY h:mm A',
                        },
                        invalidDate: 'Invalid date',
                        ordinal: '%d',
                        dayOfMonthOrdinalParse: /\d{1,2}/,
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            w: 'a week',
                            ww: '%d weeks',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        months: Ul,
                        monthsShort: Xo,
                        week: { dow: 0, doy: 6 },
                        weekdays: _0,
                        weekdaysMin: We,
                        weekdaysShort: Nc,
                        meridiemParse: /[ap]\.?m?\.?/i,
                    },
                    si = {},
                    xo = {};
                function ko(d, m) {
                    var S,
                        D = Math.min(d.length, m.length);
                    for (S = 0; S < D; S += 1) if (d[S] !== m[S]) return S;
                    return D;
                }
                function Va(d) {
                    return d && d.toLowerCase().replace('_', '-');
                }
                function y(d) {
                    var m = null;
                    if (
                        void 0 === si[d] &&
                        se &&
                        se.exports &&
                        (function h(d) {
                            return null != d.match('^[^/\\\\]*$');
                        })(d)
                    )
                        try {
                            (m = Ra._abbr),
                                Object(
                                    (function () {
                                        var Y = new Error("Cannot find module 'undefined'");
                                        throw ((Y.code = 'MODULE_NOT_FOUND'), Y);
                                    })(),
                                ),
                                w(m);
                        } catch {
                            si[d] = null;
                        }
                    return si[d];
                }
                function w(d, m) {
                    var S;
                    return (
                        d &&
                            ((S = _(m) ? B(d) : I(d, m))
                                ? (Ra = S)
                                : typeof console < 'u' &&
                                  console.warn &&
                                  console.warn('Locale ' + d + ' not found. Did you forget to load it?')),
                        Ra._abbr
                    );
                }
                function I(d, m) {
                    if (null !== m) {
                        var S,
                            D = so;
                        if (((m.abbr = d), null != si[d]))
                            at(
                                'defineLocaleOverride',
                                'use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.',
                            ),
                                (D = si[d]._config);
                        else if (null != m.parentLocale)
                            if (null != si[m.parentLocale]) D = si[m.parentLocale]._config;
                            else {
                                if (null == (S = y(m.parentLocale)))
                                    return (
                                        xo[m.parentLocale] || (xo[m.parentLocale] = []),
                                        xo[m.parentLocale].push({ name: d, config: m }),
                                        null
                                    );
                                D = S._config;
                            }
                        return (
                            (si[d] = new Pt(Re(D, m))),
                            xo[d] &&
                                xo[d].forEach(function (Y) {
                                    I(Y.name, Y.config);
                                }),
                            w(d),
                            si[d]
                        );
                    }
                    return delete si[d], null;
                }
                function B(d) {
                    var m;
                    if ((d && d._locale && d._locale._abbr && (d = d._locale._abbr), !d)) return Ra;
                    if (!G(d)) {
                        if ((m = y(d))) return m;
                        d = [d];
                    }
                    return (function u(d) {
                        for (var S, D, Y, oe, m = 0; m < d.length; ) {
                            for (
                                S = (oe = Va(d[m]).split('-')).length, D = (D = Va(d[m + 1])) ? D.split('-') : null;
                                S > 0;

                            ) {
                                if ((Y = y(oe.slice(0, S).join('-')))) return Y;
                                if (D && D.length >= S && ko(oe, D) >= S - 1) break;
                                S--;
                            }
                            m++;
                        }
                        return Ra;
                    })(d);
                }
                function J(d) {
                    var m,
                        S = d._a;
                    return (
                        S &&
                            -2 === j(d).overflow &&
                            ((m =
                                S[zr] < 0 || S[zr] > 11
                                    ? zr
                                    : S[dr] < 1 || S[dr] > Do(S[Me], S[zr])
                                    ? dr
                                    : S[ri] < 0 ||
                                      S[ri] > 24 ||
                                      (24 === S[ri] && (0 !== S[er] || 0 !== S[Bs] || 0 !== S[ps]))
                                    ? ri
                                    : S[er] < 0 || S[er] > 59
                                    ? er
                                    : S[Bs] < 0 || S[Bs] > 59
                                    ? Bs
                                    : S[ps] < 0 || S[ps] > 999
                                    ? ps
                                    : -1),
                            j(d)._overflowDayOfYear && (m < Me || m > dr) && (m = dr),
                            j(d)._overflowWeeks && -1 === m && (m = qs),
                            j(d)._overflowWeekday && -1 === m && (m = To),
                            (j(d).overflow = m)),
                        d
                    );
                }
                var re =
                        /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                    Te =
                        /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                    Ae = /Z|[+-]\d\d(?::?\d\d)?/,
                    ve = [
                        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
                        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
                        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
                        ['GGGG-[W]WW', /\d{4}-W\d\d/, !1],
                        ['YYYY-DDD', /\d{4}-\d{3}/],
                        ['YYYY-MM', /\d{4}-\d\d/, !1],
                        ['YYYYYYMMDD', /[+-]\d{10}/],
                        ['YYYYMMDD', /\d{8}/],
                        ['GGGG[W]WWE', /\d{4}W\d{3}/],
                        ['GGGG[W]WW', /\d{4}W\d{2}/, !1],
                        ['YYYYDDD', /\d{7}/],
                        ['YYYYMM', /\d{6}/, !1],
                        ['YYYY', /\d{4}/, !1],
                    ],
                    He = [
                        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
                        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
                        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
                        ['HH:mm', /\d\d:\d\d/],
                        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
                        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
                        ['HHmmss', /\d\d\d\d\d\d/],
                        ['HHmm', /\d\d\d\d/],
                        ['HH', /\d\d/],
                    ],
                    Kt = /^\/?Date\((-?\d+)/i,
                    In =
                        /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
                    Xt = {
                        UT: 0,
                        GMT: 0,
                        EDT: -240,
                        EST: -300,
                        CDT: -300,
                        CST: -360,
                        MDT: -360,
                        MST: -420,
                        PDT: -420,
                        PST: -480,
                    };
                function nr(d) {
                    var m,
                        S,
                        oe,
                        Ee,
                        xt,
                        pn,
                        D = d._i,
                        Y = re.exec(D) || Te.exec(D),
                        vi = ve.length,
                        Gr = He.length;
                    if (Y) {
                        for (j(d).iso = !0, m = 0, S = vi; m < S; m++)
                            if (ve[m][1].exec(Y[1])) {
                                (Ee = ve[m][0]), (oe = !1 !== ve[m][2]);
                                break;
                            }
                        if (null == Ee) return void (d._isValid = !1);
                        if (Y[3]) {
                            for (m = 0, S = Gr; m < S; m++)
                                if (He[m][1].exec(Y[3])) {
                                    xt = (Y[2] || ' ') + He[m][0];
                                    break;
                                }
                            if (null == xt) return void (d._isValid = !1);
                        }
                        if (!oe && null != xt) return void (d._isValid = !1);
                        if (Y[4]) {
                            if (!Ae.exec(Y[4])) return void (d._isValid = !1);
                            pn = 'Z';
                        }
                        (d._f = Ee + (xt || '') + (pn || '')), Ue(d);
                    } else d._isValid = !1;
                }
                function oo(d) {
                    var m = parseInt(d, 10);
                    return m <= 49 ? 2e3 + m : m <= 999 ? 1900 + m : m;
                }
                function mn(d) {
                    var S,
                        m = In.exec(
                            (function ao(d) {
                                return d
                                    .replace(/\([^()]*\)|[\n\t]/g, ' ')
                                    .replace(/(\s\s+)/g, ' ')
                                    .replace(/^\s\s*/, '')
                                    .replace(/\s\s*$/, '');
                            })(d._i),
                        );
                    if (m) {
                        if (
                            ((S = (function Vi(d, m, S, D, Y, oe) {
                                var Ee = [oo(d), Xo.indexOf(m), parseInt(S, 10), parseInt(D, 10), parseInt(Y, 10)];
                                return oe && Ee.push(parseInt(oe, 10)), Ee;
                            })(m[4], m[3], m[2], m[5], m[6], m[7])),
                            !(function wn(d, m, S) {
                                return (
                                    !d ||
                                    Nc.indexOf(d) === new Date(m[0], m[1], m[2]).getDay() ||
                                    ((j(S).weekdayMismatch = !0), (S._isValid = !1), !1)
                                );
                            })(m[1], S, d))
                        )
                            return;
                        (d._a = S),
                            (d._tzm = (function Jo(d, m, S) {
                                if (d) return Xt[d];
                                if (m) return 0;
                                var D = parseInt(S, 10),
                                    Y = D % 100;
                                return ((D - Y) / 100) * 60 + Y;
                            })(m[8], m[9], m[10])),
                            (d._d = qr.apply(null, d._a)),
                            d._d.setUTCMinutes(d._d.getUTCMinutes() - d._tzm),
                            (j(d).rfc2822 = !0);
                    } else d._isValid = !1;
                }
                function _r(d, m, S) {
                    return d ?? m ?? S;
                }
                function Se(d) {
                    var m,
                        S,
                        Y,
                        oe,
                        Ee,
                        D = [];
                    if (!d._d) {
                        for (
                            Y = (function Bc(d) {
                                var m = new Date(M.now());
                                return d._useUTC
                                    ? [m.getUTCFullYear(), m.getUTCMonth(), m.getUTCDate()]
                                    : [m.getFullYear(), m.getMonth(), m.getDate()];
                            })(d),
                                d._w &&
                                    null == d._a[dr] &&
                                    null == d._a[zr] &&
                                    (function Ha(d) {
                                        var m, S, D, Y, oe, Ee, xt, pn, vi;
                                        null != (m = d._w).GG || null != m.W || null != m.E
                                            ? ((oe = 1),
                                              (Ee = 4),
                                              (S = _r(m.GG, d._a[Me], ql(oi(), 1, 4).year)),
                                              (D = _r(m.W, 1)),
                                              ((Y = _r(m.E, 1)) < 1 || Y > 7) && (pn = !0))
                                            : ((oe = d._locale._week.dow),
                                              (Ee = d._locale._week.doy),
                                              (vi = ql(oi(), oe, Ee)),
                                              (S = _r(m.gg, d._a[Me], vi.year)),
                                              (D = _r(m.w, vi.week)),
                                              null != m.d
                                                  ? ((Y = m.d) < 0 || Y > 6) && (pn = !0)
                                                  : null != m.e
                                                  ? ((Y = m.e + oe), (m.e < 0 || m.e > 6) && (pn = !0))
                                                  : (Y = oe)),
                                            D < 1 || D > hr(S, oe, Ee)
                                                ? (j(d)._overflowWeeks = !0)
                                                : null != pn
                                                ? (j(d)._overflowWeekday = !0)
                                                : ((xt = g0(S, D, Y, oe, Ee)),
                                                  (d._a[Me] = xt.year),
                                                  (d._dayOfYear = xt.dayOfYear));
                                    })(d),
                                null != d._dayOfYear &&
                                    ((Ee = _r(d._a[Me], Y[Me])),
                                    (d._dayOfYear > vr(Ee) || 0 === d._dayOfYear) && (j(d)._overflowDayOfYear = !0),
                                    (S = qr(Ee, 0, d._dayOfYear)),
                                    (d._a[zr] = S.getUTCMonth()),
                                    (d._a[dr] = S.getUTCDate())),
                                m = 0;
                            m < 3 && null == d._a[m];
                            ++m
                        )
                            d._a[m] = D[m] = Y[m];
                        for (; m < 7; m++) d._a[m] = D[m] = null == d._a[m] ? (2 === m ? 1 : 0) : d._a[m];
                        24 === d._a[ri] &&
                            0 === d._a[er] &&
                            0 === d._a[Bs] &&
                            0 === d._a[ps] &&
                            ((d._nextDay = !0), (d._a[ri] = 0)),
                            (d._d = (d._useUTC ? qr : p0).apply(null, D)),
                            (oe = d._useUTC ? d._d.getUTCDay() : d._d.getDay()),
                            null != d._tzm && d._d.setUTCMinutes(d._d.getUTCMinutes() - d._tzm),
                            d._nextDay && (d._a[ri] = 24),
                            d._w && typeof d._w.d < 'u' && d._w.d !== oe && (j(d).weekdayMismatch = !0);
                    }
                }
                function Ue(d) {
                    if (d._f !== M.ISO_8601)
                        if (d._f !== M.RFC_2822) {
                            (d._a = []), (j(d).empty = !0);
                            var S,
                                D,
                                Y,
                                oe,
                                Ee,
                                vi,
                                Gr,
                                m = '' + d._i,
                                xt = m.length,
                                pn = 0;
                            for (Gr = (Y = Ht(d._f, d._locale).match(Vt) || []).length, S = 0; S < Gr; S++)
                                (D = (m.match(ro((oe = Y[S]), d)) || [])[0]) &&
                                    ((Ee = m.substr(0, m.indexOf(D))).length > 0 && j(d).unusedInput.push(Ee),
                                    (m = m.slice(m.indexOf(D) + D.length)),
                                    (pn += D.length)),
                                    ot[oe]
                                        ? (D ? (j(d).empty = !1) : j(d).unusedTokens.push(oe), fa(oe, D, d))
                                        : d._strict && !D && j(d).unusedTokens.push(oe);
                            (j(d).charsLeftOver = xt - pn),
                                m.length > 0 && j(d).unusedInput.push(m),
                                d._a[ri] <= 12 && !0 === j(d).bigHour && d._a[ri] > 0 && (j(d).bigHour = void 0),
                                (j(d).parsedDateParts = d._a.slice(0)),
                                (j(d).meridiem = d._meridiem),
                                (d._a[ri] = (function Ys(d, m, S) {
                                    var D;
                                    return null == S
                                        ? m
                                        : null != d.meridiemHour
                                        ? d.meridiemHour(m, S)
                                        : (null != d.isPM &&
                                              ((D = d.isPM(S)) && m < 12 && (m += 12), !D && 12 === m && (m = 0)),
                                          m);
                                })(d._locale, d._a[ri], d._meridiem)),
                                null !== (vi = j(d).era) && (d._a[Me] = d._locale.erasConvertYear(vi, d._a[Me])),
                                Se(d),
                                J(d);
                        } else mn(d);
                    else nr(d);
                }
                function co(d) {
                    var m = d._i,
                        S = d._f;
                    return (
                        (d._locale = d._locale || B(d._l)),
                        null === m || (void 0 === S && '' === m)
                            ? Q({ nullInput: !0 })
                            : ('string' == typeof m && (d._i = m = d._locale.preparse(m)),
                              Ve(m)
                                  ? new xe(J(m))
                                  : (x(m)
                                        ? (d._d = m)
                                        : G(S)
                                        ? (function lo(d) {
                                              var m,
                                                  S,
                                                  D,
                                                  Y,
                                                  oe,
                                                  Ee,
                                                  xt = !1,
                                                  pn = d._f.length;
                                              if (0 === pn)
                                                  return (j(d).invalidFormat = !0), void (d._d = new Date(NaN));
                                              for (Y = 0; Y < pn; Y++)
                                                  (oe = 0),
                                                      (Ee = !1),
                                                      (m = De({}, d)),
                                                      null != d._useUTC && (m._useUTC = d._useUTC),
                                                      (m._f = d._f[Y]),
                                                      Ue(m),
                                                      K(m) && (Ee = !0),
                                                      (oe += j(m).charsLeftOver),
                                                      (oe += 10 * j(m).unusedTokens.length),
                                                      (j(m).score = oe),
                                                      xt
                                                          ? oe < D && ((D = oe), (S = m))
                                                          : (null == D || oe < D || Ee) &&
                                                            ((D = oe), (S = m), Ee && (xt = !0));
                                              C(d, S || m);
                                          })(d)
                                        : S
                                        ? Ue(d)
                                        : (function Eo(d) {
                                              var m = d._i;
                                              _(m)
                                                  ? (d._d = new Date(M.now()))
                                                  : x(m)
                                                  ? (d._d = new Date(m.valueOf()))
                                                  : 'string' == typeof m
                                                  ? (function Hi(d) {
                                                        var m = Kt.exec(d._i);
                                                        null === m
                                                            ? (nr(d),
                                                              !1 === d._isValid &&
                                                                  (delete d._isValid,
                                                                  mn(d),
                                                                  !1 === d._isValid &&
                                                                      (delete d._isValid,
                                                                      d._strict
                                                                          ? (d._isValid = !1)
                                                                          : M.createFromInputFallback(d))))
                                                            : (d._d = new Date(+m[1]));
                                                    })(d)
                                                  : G(m)
                                                  ? ((d._a = F(m.slice(0), function (S) {
                                                        return parseInt(S, 10);
                                                    })),
                                                    Se(d))
                                                  : $(m)
                                                  ? (function Pr(d) {
                                                        if (!d._d) {
                                                            var m = Hs(d._i);
                                                            (d._a = F(
                                                                [
                                                                    m.year,
                                                                    m.month,
                                                                    void 0 === m.day ? m.date : m.day,
                                                                    m.hour,
                                                                    m.minute,
                                                                    m.second,
                                                                    m.millisecond,
                                                                ],
                                                                function (D) {
                                                                    return D && parseInt(D, 10);
                                                                },
                                                            )),
                                                                Se(d);
                                                        }
                                                    })(d)
                                                  : T(m)
                                                  ? (d._d = new Date(m))
                                                  : M.createFromInputFallback(d);
                                          })(d),
                                    K(d) || (d._d = null),
                                    d))
                    );
                }
                function Gu(d, m, S, D, Y) {
                    var oe = {};
                    return (
                        (!0 === m || !1 === m) && ((D = m), (m = void 0)),
                        (!0 === S || !1 === S) && ((D = S), (S = void 0)),
                        (($(d) && p(d)) || (G(d) && 0 === d.length)) && (d = void 0),
                        (oe._isAMomentObject = !0),
                        (oe._useUTC = oe._isUTC = Y),
                        (oe._l = S),
                        (oe._i = d),
                        (oe._f = m),
                        (oe._strict = D),
                        (function qc(d) {
                            var m = new xe(J(co(d)));
                            return m._nextDay && (m.add(1, 'd'), (m._nextDay = void 0)), m;
                        })(oe)
                    );
                }
                function oi(d, m, S, D) {
                    return Gu(d, m, S, D, !1);
                }
                (M.createFromInputFallback = je(
                    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
                    function (d) {
                        d._d = new Date(d._i + (d._useUTC ? ' UTC' : ''));
                    },
                )),
                    (M.ISO_8601 = function () {}),
                    (M.RFC_2822 = function () {});
                var C0 = je(
                        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
                        function () {
                            var d = oi.apply(null, arguments);
                            return this.isValid() && d.isValid() ? (d < this ? this : d) : Q();
                        },
                    ),
                    Vn = je(
                        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
                        function () {
                            var d = oi.apply(null, arguments);
                            return this.isValid() && d.isValid() ? (d > this ? this : d) : Q();
                        },
                    );
                function gl(d, m) {
                    var S, D;
                    if ((1 === m.length && G(m[0]) && (m = m[0]), !m.length)) return oi();
                    for (S = m[0], D = 1; D < m.length; ++D) (!m[D].isValid() || m[D][d](S)) && (S = m[D]);
                    return S;
                }
                var uo = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
                function gs(d) {
                    var m = Hs(d),
                        S = m.year || 0,
                        D = m.quarter || 0,
                        Y = m.month || 0,
                        oe = m.week || m.isoWeek || 0,
                        Ee = m.day || 0,
                        xt = m.hour || 0,
                        pn = m.minute || 0,
                        vi = m.second || 0,
                        Gr = m.millisecond || 0;
                    (this._isValid = (function Yc(d) {
                        var m,
                            D,
                            S = !1,
                            Y = uo.length;
                        for (m in d) if (v(d, m) && (-1 === pi.call(uo, m) || (null != d[m] && isNaN(d[m])))) return !1;
                        for (D = 0; D < Y; ++D)
                            if (d[uo[D]]) {
                                if (S) return !1;
                                parseFloat(d[uo[D]]) !== Ut(d[uo[D]]) && (S = !0);
                            }
                        return !0;
                    })(m)),
                        (this._milliseconds = +Gr + 1e3 * vi + 6e4 * pn + 1e3 * xt * 60 * 60),
                        (this._days = +Ee + 7 * oe),
                        (this._months = +Y + 3 * D + 12 * S),
                        (this._data = {}),
                        (this._locale = B()),
                        this._bubble();
                }
                function Wl(d) {
                    return d instanceof gs;
                }
                function ea(d) {
                    return d < 0 ? -1 * Math.round(-1 * d) : Math.round(d);
                }
                function br(d, m) {
                    ke(d, 0, 0, function () {
                        var S = this.utcOffset(),
                            D = '+';
                        return S < 0 && ((S = -S), (D = '-')), D + qt(~~(S / 60), 2) + m + qt(~~S % 60, 2);
                    });
                }
                br('Z', ':'),
                    br('ZZ', ''),
                    Ke('Z', So),
                    Ke('ZZ', So),
                    Ct(['Z', 'ZZ'], function (d, m, S) {
                        (S._useUTC = !0), (S._tzm = ta(So, d));
                    });
                var vl = /([\+\-]|\d\d)/gi;
                function ta(d, m) {
                    var Y,
                        oe,
                        S = (m || '').match(d);
                    return null === S
                        ? null
                        : 0 === (oe = 60 * (Y = ((S[S.length - 1] || []) + '').match(vl) || ['-', 0, 0])[1] + Ut(Y[2]))
                        ? 0
                        : '+' === Y[0]
                        ? oe
                        : -oe;
                }
                function _l(d, m) {
                    var S, D;
                    return m._isUTC
                        ? ((S = m.clone()),
                          (D = (Ve(d) || x(d) ? d.valueOf() : oi(d).valueOf()) - S.valueOf()),
                          S._d.setTime(S._d.valueOf() + D),
                          M.updateOffset(S, !1),
                          S)
                        : oi(d).local();
                }
                function qa(d) {
                    return -Math.round(d._d.getTimezoneOffset());
                }
                function it() {
                    return !!this.isValid() && this._isUTC && 0 === this._offset;
                }
                M.updateOffset = function () {};
                var pt = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
                    rt =
                        /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
                function It(d, m) {
                    var Y,
                        oe,
                        Ee,
                        S = d,
                        D = null;
                    return (
                        Wl(d)
                            ? (S = { ms: d._milliseconds, d: d._days, M: d._months })
                            : T(d) || !isNaN(+d)
                            ? ((S = {}), m ? (S[m] = +d) : (S.milliseconds = +d))
                            : (D = pt.exec(d))
                            ? ((Y = '-' === D[1] ? -1 : 1),
                              (S = {
                                  y: 0,
                                  d: Ut(D[dr]) * Y,
                                  h: Ut(D[ri]) * Y,
                                  m: Ut(D[er]) * Y,
                                  s: Ut(D[Bs]) * Y,
                                  ms: Ut(ea(1e3 * D[ps])) * Y,
                              }))
                            : (D = rt.exec(d))
                            ? (S = {
                                  y: wt(D[2], (Y = '-' === D[1] ? -1 : 1)),
                                  M: wt(D[3], Y),
                                  w: wt(D[4], Y),
                                  d: wt(D[5], Y),
                                  h: wt(D[6], Y),
                                  m: wt(D[7], Y),
                                  s: wt(D[8], Y),
                              })
                            : null == S
                            ? (S = {})
                            : 'object' == typeof S &&
                              ('from' in S || 'to' in S) &&
                              ((Ee = (function yn(d, m) {
                                  var S;
                                  return d.isValid() && m.isValid()
                                      ? ((m = _l(m, d)),
                                        d.isBefore(m)
                                            ? (S = Yt(d, m))
                                            : (((S = Yt(m, d)).milliseconds = -S.milliseconds), (S.months = -S.months)),
                                        S)
                                      : { milliseconds: 0, months: 0 };
                              })(oi(S.from), oi(S.to))),
                              ((S = {}).ms = Ee.milliseconds),
                              (S.M = Ee.months)),
                        (oe = new gs(S)),
                        Wl(d) && v(d, '_locale') && (oe._locale = d._locale),
                        Wl(d) && v(d, '_isValid') && (oe._isValid = d._isValid),
                        oe
                    );
                }
                function wt(d, m) {
                    var S = d && parseFloat(d.replace(',', '.'));
                    return (isNaN(S) ? 0 : S) * m;
                }
                function Yt(d, m) {
                    var S = {};
                    return (
                        (S.months = m.month() - d.month() + 12 * (m.year() - d.year())),
                        d.clone().add(S.months, 'M').isAfter(m) && --S.months,
                        (S.milliseconds = +m - +d.clone().add(S.months, 'M')),
                        S
                    );
                }
                function Mt(d, m) {
                    return function (S, D) {
                        var oe;
                        return (
                            null !== D &&
                                !isNaN(+D) &&
                                (at(
                                    m,
                                    'moment().' +
                                        m +
                                        '(period, number) is deprecated. Please use moment().' +
                                        m +
                                        '(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.',
                                ),
                                (oe = S),
                                (S = D),
                                (D = oe)),
                            ai(this, It(S, D), d),
                            this
                        );
                    };
                }
                function ai(d, m, S, D) {
                    var Y = m._milliseconds,
                        oe = ea(m._days),
                        Ee = ea(m._months);
                    d.isValid() &&
                        ((D = D ?? !0),
                        Ee && fl(d, Es(d, 'Month') + Ee * S),
                        oe && hl(d, 'Date', Es(d, 'Date') + oe * S),
                        Y && d._d.setTime(d._d.valueOf() + Y * S),
                        D && M.updateOffset(d, oe || Ee));
                }
                (It.fn = gs.prototype),
                    (It.invalid = function Ba() {
                        return It(NaN);
                    });
                var ss = Mt(1, 'add'),
                    gi = Mt(-1, 'subtract');
                function vs(d) {
                    return 'string' == typeof d || d instanceof String;
                }
                function js(d) {
                    return (
                        Ve(d) ||
                        x(d) ||
                        vs(d) ||
                        T(d) ||
                        (function Yr(d) {
                            var m = G(d),
                                S = !1;
                            return (
                                m &&
                                    (S =
                                        0 ===
                                        d.filter(function (D) {
                                            return !T(D) && vs(d);
                                        }).length),
                                m && S
                            );
                        })(d) ||
                        (function Ya(d) {
                            var Y,
                                m = $(d) && !p(d),
                                S = !1,
                                D = [
                                    'years',
                                    'year',
                                    'y',
                                    'months',
                                    'month',
                                    'M',
                                    'days',
                                    'day',
                                    'd',
                                    'dates',
                                    'date',
                                    'D',
                                    'hours',
                                    'hour',
                                    'h',
                                    'minutes',
                                    'minute',
                                    'm',
                                    'seconds',
                                    'second',
                                    's',
                                    'milliseconds',
                                    'millisecond',
                                    'ms',
                                ],
                                Ee = D.length;
                            for (Y = 0; Y < Ee; Y += 1) S = S || v(d, D[Y]);
                            return m && S;
                        })(d) ||
                        null == d
                    );
                }
                function gt(d, m) {
                    if (d.date() < m.date()) return -gt(m, d);
                    var S = 12 * (m.year() - d.year()) + (m.month() - d.month()),
                        D = d.clone().add(S, 'months');
                    return (
                        -(
                            S +
                            (m - D < 0
                                ? (m - D) / (D - d.clone().add(S - 1, 'months'))
                                : (m - D) / (d.clone().add(S + 1, 'months') - D))
                        ) || 0
                    );
                }
                function Gc(d) {
                    var m;
                    return void 0 === d ? this._locale._abbr : (null != (m = B(d)) && (this._locale = m), this);
                }
                (M.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ'), (M.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]');
                var Hh = je(
                    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
                    function (d) {
                        return void 0 === d ? this.localeData() : this.locale(d);
                    },
                );
                function Uh() {
                    return this._locale;
                }
                var Kl = 6e4,
                    Ql = 60 * Kl,
                    w0 = 3506328 * Ql;
                function pa(d, m) {
                    return ((d % m) + m) % m;
                }
                function M3(d, m, S) {
                    return d < 100 && d >= 0 ? new Date(d + 400, m, S) - w0 : new Date(d, m, S).valueOf();
                }
                function Wu(d, m, S) {
                    return d < 100 && d >= 0 ? Date.UTC(d + 400, m, S) - w0 : Date.UTC(d, m, S);
                }
                function Wc(d, m) {
                    return m.erasAbbrRegex(d);
                }
                function k0() {
                    var Y,
                        oe,
                        d = [],
                        m = [],
                        S = [],
                        D = [],
                        Ee = this.eras();
                    for (Y = 0, oe = Ee.length; Y < oe; ++Y)
                        m.push(ln(Ee[Y].name)),
                            d.push(ln(Ee[Y].abbr)),
                            S.push(ln(Ee[Y].narrow)),
                            D.push(ln(Ee[Y].name)),
                            D.push(ln(Ee[Y].abbr)),
                            D.push(ln(Ee[Y].narrow));
                    (this._erasRegex = new RegExp('^(' + D.join('|') + ')', 'i')),
                        (this._erasNameRegex = new RegExp('^(' + m.join('|') + ')', 'i')),
                        (this._erasAbbrRegex = new RegExp('^(' + d.join('|') + ')', 'i')),
                        (this._erasNarrowRegex = new RegExp('^(' + S.join('|') + ')', 'i'));
                }
                function Xu(d, m) {
                    ke(0, [d, d.length], 0, m);
                }
                function Wh(d, m, S, D, Y) {
                    var oe;
                    return null == d
                        ? ql(this, D, Y).year
                        : (m > (oe = hr(d, D, Y)) && (m = oe), z3.call(this, d, m, S, D, Y));
                }
                function z3(d, m, S, D, Y) {
                    var oe = g0(d, m, S, D, Y),
                        Ee = qr(oe.year, 0, oe.dayOfYear);
                    return (
                        this.year(Ee.getUTCFullYear()), this.month(Ee.getUTCMonth()), this.date(Ee.getUTCDate()), this
                    );
                }
                ke('N', 0, 0, 'eraAbbr'),
                    ke('NN', 0, 0, 'eraAbbr'),
                    ke('NNN', 0, 0, 'eraAbbr'),
                    ke('NNNN', 0, 0, 'eraName'),
                    ke('NNNNN', 0, 0, 'eraNarrow'),
                    ke('y', ['y', 1], 'yo', 'eraYear'),
                    ke('y', ['yy', 2], 0, 'eraYear'),
                    ke('y', ['yyy', 3], 0, 'eraYear'),
                    ke('y', ['yyyy', 4], 0, 'eraYear'),
                    Ke('N', Wc),
                    Ke('NN', Wc),
                    Ke('NNN', Wc),
                    Ke('NNNN', function jh(d, m) {
                        return m.erasNameRegex(d);
                    }),
                    Ke('NNNNN', function Kc(d, m) {
                        return m.erasNarrowRegex(d);
                    }),
                    Ct(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (d, m, S, D) {
                        var Y = S._locale.erasParse(d, D, S._strict);
                        Y ? (j(S).era = Y) : (j(S).invalidEra = d);
                    }),
                    Ke('y', Tn),
                    Ke('yy', Tn),
                    Ke('yyy', Tn),
                    Ke('yyyy', Tn),
                    Ke('yo', function Jl(d, m) {
                        return m._eraYearOrdinalRegex || Tn;
                    }),
                    Ct(['y', 'yy', 'yyy', 'yyyy'], Me),
                    Ct(['yo'], function (d, m, S, D) {
                        var Y;
                        S._locale._eraYearOrdinalRegex && (Y = d.match(S._locale._eraYearOrdinalRegex)),
                            (m[Me] = S._locale.eraYearOrdinalParse
                                ? S._locale.eraYearOrdinalParse(d, Y)
                                : parseInt(d, 10));
                    }),
                    ke(0, ['gg', 2], 0, function () {
                        return this.weekYear() % 100;
                    }),
                    ke(0, ['GG', 2], 0, function () {
                        return this.isoWeekYear() % 100;
                    }),
                    Xu('gggg', 'weekYear'),
                    Xu('ggggg', 'weekYear'),
                    Xu('GGGG', 'isoWeekYear'),
                    Xu('GGGGG', 'isoWeekYear'),
                    Ri('weekYear', 'gg'),
                    Ri('isoWeekYear', 'GG'),
                    Kn('weekYear', 1),
                    Kn('isoWeekYear', 1),
                    Ke('G', ni),
                    Ke('g', ni),
                    Ke('GG', lt, ye),
                    Ke('gg', lt, ye),
                    Ke('GGGG', Br, kn),
                    Ke('gggg', Br, kn),
                    Ke('GGGGG', no, Qn),
                    Ke('ggggg', no, Qn),
                    ha(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (d, m, S, D) {
                        m[D.substr(0, 2)] = Ut(d);
                    }),
                    ha(['gg', 'GG'], function (d, m, S, D) {
                        m[D] = M.parseTwoDigitYear(d);
                    }),
                    ke('Q', 0, 'Qo', 'quarter'),
                    Ri('quarter', 'Q'),
                    Kn('quarter', 7),
                    Ke('Q', _e),
                    Ct('Q', function (d, m) {
                        m[zr] = 3 * (Ut(d) - 1);
                    }),
                    ke('D', ['DD', 2], 'Do', 'date'),
                    Ri('date', 'D'),
                    Kn('date', 9),
                    Ke('D', lt),
                    Ke('DD', lt, ye),
                    Ke('Do', function (d, m) {
                        return d ? m._dayOfMonthOrdinalParse || m._ordinalParse : m._dayOfMonthOrdinalParseLenient;
                    }),
                    Ct(['D', 'DD'], dr),
                    Ct('Do', function (d, m) {
                        m[dr] = Ut(d.match(lt)[0]);
                    });
                var Kh = sr('Date', !0);
                ke('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'),
                    Ri('dayOfYear', 'DDD'),
                    Kn('dayOfYear', 4),
                    Ke('DDD', Yn),
                    Ke('DDDD', on),
                    Ct(['DDD', 'DDDD'], function (d, m, S) {
                        S._dayOfYear = Ut(d);
                    }),
                    ke('m', ['mm', 2], 0, 'minute'),
                    Ri('minute', 'm'),
                    Kn('minute', 14),
                    Ke('m', lt),
                    Ke('mm', lt, ye),
                    Ct(['m', 'mm'], er);
                var Zu = sr('Minutes', !1);
                ke('s', ['ss', 2], 0, 'second'),
                    Ri('second', 's'),
                    Kn('second', 15),
                    Ke('s', lt),
                    Ke('ss', lt, ye),
                    Ct(['s', 'ss'], Bs);
                var Be,
                    St,
                    Ui = sr('Seconds', !1);
                for (
                    ke('S', 0, 0, function () {
                        return ~~(this.millisecond() / 100);
                    }),
                        ke(0, ['SS', 2], 0, function () {
                            return ~~(this.millisecond() / 10);
                        }),
                        ke(0, ['SSS', 3], 0, 'millisecond'),
                        ke(0, ['SSSS', 4], 0, function () {
                            return 10 * this.millisecond();
                        }),
                        ke(0, ['SSSSS', 5], 0, function () {
                            return 100 * this.millisecond();
                        }),
                        ke(0, ['SSSSSS', 6], 0, function () {
                            return 1e3 * this.millisecond();
                        }),
                        ke(0, ['SSSSSSS', 7], 0, function () {
                            return 1e4 * this.millisecond();
                        }),
                        ke(0, ['SSSSSSSS', 8], 0, function () {
                            return 1e5 * this.millisecond();
                        }),
                        ke(0, ['SSSSSSSSS', 9], 0, function () {
                            return 1e6 * this.millisecond();
                        }),
                        Ri('millisecond', 'ms'),
                        Kn('millisecond', 16),
                        Ke('S', Yn, _e),
                        Ke('SS', Yn, ye),
                        Ke('SSS', Yn, on),
                        Be = 'SSSS';
                    Be.length <= 9;
                    Be += 'S'
                )
                    Ke(Be, Tn);
                function ar(d, m) {
                    m[ps] = Ut(1e3 * ('0.' + d));
                }
                for (Be = 'S'; Be.length <= 9; Be += 'S') Ct(Be, ar);
                (St = sr('Milliseconds', !1)), ke('z', 0, 0, 'zoneAbbr'), ke('zz', 0, 0, 'zoneName');
                var Fe = xe.prototype;
                function lr(d) {
                    return d;
                }
                (Fe.add = ss),
                    (Fe.calendar = function Nh(d, m) {
                        1 === arguments.length &&
                            (arguments[0]
                                ? js(arguments[0])
                                    ? ((d = arguments[0]), (m = void 0))
                                    : (function g3(d) {
                                          var Y,
                                              m = $(d) && !p(d),
                                              S = !1,
                                              D = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'];
                                          for (Y = 0; Y < D.length; Y += 1) S = S || v(d, D[Y]);
                                          return m && S;
                                      })(arguments[0]) && ((m = arguments[0]), (d = void 0))
                                : ((d = void 0), (m = void 0)));
                        var S = d || oi(),
                            D = _l(S, this).startOf('day'),
                            Y = M.calendarFormat(this, D) || 'sameElse',
                            oe = m && (Et(m[Y]) ? m[Y].call(this, S) : m[Y]);
                        return this.format(oe || this.localeData().calendar(Y, this, oi(S)));
                    }),
                    (Fe.clone = function _3() {
                        return new xe(this);
                    }),
                    (Fe.diff = function Fh(d, m, S) {
                        var D, Y, oe;
                        if (!this.isValid()) return NaN;
                        if (!(D = _l(d, this)).isValid()) return NaN;
                        switch (((Y = 6e4 * (D.utcOffset() - this.utcOffset())), (m = Oi(m)))) {
                            case 'year':
                                oe = gt(this, D) / 12;
                                break;
                            case 'month':
                                oe = gt(this, D);
                                break;
                            case 'quarter':
                                oe = gt(this, D) / 3;
                                break;
                            case 'second':
                                oe = (this - D) / 1e3;
                                break;
                            case 'minute':
                                oe = (this - D) / 6e4;
                                break;
                            case 'hour':
                                oe = (this - D) / 36e5;
                                break;
                            case 'day':
                                oe = (this - D - Y) / 864e5;
                                break;
                            case 'week':
                                oe = (this - D - Y) / 6048e5;
                                break;
                            default:
                                oe = this - D;
                        }
                        return S ? oe : gn(oe);
                    }),
                    (Fe.endOf = function M0(d) {
                        var m, S;
                        if (void 0 === (d = Oi(d)) || 'millisecond' === d || !this.isValid()) return this;
                        switch (((S = this._isUTC ? Wu : M3), d)) {
                            case 'year':
                                m = S(this.year() + 1, 0, 1) - 1;
                                break;
                            case 'quarter':
                                m = S(this.year(), this.month() - (this.month() % 3) + 3, 1) - 1;
                                break;
                            case 'month':
                                m = S(this.year(), this.month() + 1, 1) - 1;
                                break;
                            case 'week':
                                m = S(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                                break;
                            case 'isoWeek':
                                m = S(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                                break;
                            case 'day':
                            case 'date':
                                m = S(this.year(), this.month(), this.date() + 1) - 1;
                                break;
                            case 'hour':
                                (m = this._d.valueOf()),
                                    (m += Ql - pa(m + (this._isUTC ? 0 : this.utcOffset() * Kl), Ql) - 1);
                                break;
                            case 'minute':
                                (m = this._d.valueOf()), (m += Kl - pa(m, Kl) - 1);
                                break;
                            case 'second':
                                (m = this._d.valueOf()), (m += 1e3 - pa(m, 1e3) - 1);
                        }
                        return this._d.setTime(m), M.updateOffset(this, !0), this;
                    }),
                    (Fe.format = function $r(d) {
                        d || (d = this.isUtc() ? M.defaultFormatUtc : M.defaultFormat);
                        var m = _t(this, d);
                        return this.localeData().postformat(m);
                    }),
                    (Fe.from = function yl(d, m) {
                        return this.isValid() && ((Ve(d) && d.isValid()) || oi(d).isValid())
                            ? It({ to: this, from: d }).locale(this.locale()).humanize(!m)
                            : this.localeData().invalidDate();
                    }),
                    (Fe.fromNow = function os(d) {
                        return this.from(oi(), d);
                    }),
                    (Fe.to = function Rh(d, m) {
                        return this.isValid() && ((Ve(d) && d.isValid()) || oi(d).isValid())
                            ? It({ from: this, to: d }).locale(this.locale()).humanize(!m)
                            : this.localeData().invalidDate();
                    }),
                    (Fe.toNow = function Vh(d) {
                        return this.to(oi(), d);
                    }),
                    (Fe.get = function Qo(d) {
                        return Et(this[(d = Oi(d))]) ? this[d]() : this;
                    }),
                    (Fe.invalidAt = function Qu() {
                        return j(this).overflow;
                    }),
                    (Fe.isAfter = function y3(d, m) {
                        var S = Ve(d) ? d : oi(d);
                        return (
                            !(!this.isValid() || !S.isValid()) &&
                            ('millisecond' === (m = Oi(m) || 'millisecond')
                                ? this.valueOf() > S.valueOf()
                                : S.valueOf() < this.clone().startOf(m).valueOf())
                        );
                    }),
                    (Fe.isBefore = function b3(d, m) {
                        var S = Ve(d) ? d : oi(d);
                        return (
                            !(!this.isValid() || !S.isValid()) &&
                            ('millisecond' === (m = Oi(m) || 'millisecond')
                                ? this.valueOf() < S.valueOf()
                                : this.clone().endOf(m).valueOf() < S.valueOf())
                        );
                    }),
                    (Fe.isBetween = function At(d, m, S, D) {
                        var Y = Ve(d) ? d : oi(d),
                            oe = Ve(m) ? m : oi(m);
                        return (
                            !!(this.isValid() && Y.isValid() && oe.isValid()) &&
                            ('(' === (D = D || '()')[0] ? this.isAfter(Y, S) : !this.isBefore(Y, S)) &&
                            (')' === D[1] ? this.isBefore(oe, S) : !this.isAfter(oe, S))
                        );
                    }),
                    (Fe.isSame = function C3(d, m) {
                        var D,
                            S = Ve(d) ? d : oi(d);
                        return (
                            !(!this.isValid() || !S.isValid()) &&
                            ('millisecond' === (m = Oi(m) || 'millisecond')
                                ? this.valueOf() === S.valueOf()
                                : ((D = S.valueOf()),
                                  this.clone().startOf(m).valueOf() <= D && D <= this.clone().endOf(m).valueOf()))
                        );
                    }),
                    (Fe.isSameOrAfter = function w3(d, m) {
                        return this.isSame(d, m) || this.isAfter(d, m);
                    }),
                    (Fe.isSameOrBefore = function Zn(d, m) {
                        return this.isSame(d, m) || this.isBefore(d, m);
                    }),
                    (Fe.isValid = function D3() {
                        return K(this);
                    }),
                    (Fe.lang = Hh),
                    (Fe.locale = Gc),
                    (Fe.localeData = Uh),
                    (Fe.max = Vn),
                    (Fe.min = C0),
                    (Fe.parsingFlags = function T0() {
                        return C({}, j(this));
                    }),
                    (Fe.set = function to(d, m) {
                        if ('object' == typeof d) {
                            var D,
                                S = (function Us(d) {
                                    var S,
                                        m = [];
                                    for (S in d) v(d, S) && m.push({ unit: S, priority: pr[S] });
                                    return (
                                        m.sort(function (D, Y) {
                                            return D.priority - Y.priority;
                                        }),
                                        m
                                    );
                                })((d = Hs(d))),
                                Y = S.length;
                            for (D = 0; D < Y; D++) this[S[D].unit](d[S[D].unit]);
                        } else if (Et(this[(d = Oi(d))])) return this[d](m);
                        return this;
                    }),
                    (Fe.startOf = function S3(d) {
                        var m, S;
                        if (void 0 === (d = Oi(d)) || 'millisecond' === d || !this.isValid()) return this;
                        switch (((S = this._isUTC ? Wu : M3), d)) {
                            case 'year':
                                m = S(this.year(), 0, 1);
                                break;
                            case 'quarter':
                                m = S(this.year(), this.month() - (this.month() % 3), 1);
                                break;
                            case 'month':
                                m = S(this.year(), this.month(), 1);
                                break;
                            case 'week':
                                m = S(this.year(), this.month(), this.date() - this.weekday());
                                break;
                            case 'isoWeek':
                                m = S(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                                break;
                            case 'day':
                            case 'date':
                                m = S(this.year(), this.month(), this.date());
                                break;
                            case 'hour':
                                (m = this._d.valueOf()), (m -= pa(m + (this._isUTC ? 0 : this.utcOffset() * Kl), Ql));
                                break;
                            case 'minute':
                                (m = this._d.valueOf()), (m -= pa(m, Kl));
                                break;
                            case 'second':
                                (m = this._d.valueOf()), (m -= pa(m, 1e3));
                        }
                        return this._d.setTime(m), M.updateOffset(this, !0), this;
                    }),
                    (Fe.subtract = gi),
                    (Fe.toArray = function T3() {
                        var d = this;
                        return [d.year(), d.month(), d.date(), d.hour(), d.minute(), d.second(), d.millisecond()];
                    }),
                    (Fe.toObject = function S0() {
                        var d = this;
                        return {
                            years: d.year(),
                            months: d.month(),
                            date: d.date(),
                            hours: d.hours(),
                            minutes: d.minutes(),
                            seconds: d.seconds(),
                            milliseconds: d.milliseconds(),
                        };
                    }),
                    (Fe.toDate = function bl() {
                        return new Date(this.valueOf());
                    }),
                    (Fe.toISOString = function bn(d) {
                        if (!this.isValid()) return null;
                        var m = !0 !== d,
                            S = m ? this.clone().utc() : this;
                        return S.year() < 0 || S.year() > 9999
                            ? _t(S, m ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ')
                            : Et(Date.prototype.toISOString)
                            ? m
                                ? this.toDate().toISOString()
                                : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3)
                                      .toISOString()
                                      .replace('Z', _t(S, 'Z'))
                            : _t(S, m ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
                    }),
                    (Fe.inspect = function Cr() {
                        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
                        var S,
                            D,
                            d = 'moment',
                            m = '';
                        return (
                            this.isLocal() ||
                                ((d = 0 === this.utcOffset() ? 'moment.utc' : 'moment.parseZone'), (m = 'Z')),
                            (S = '[' + d + '("]'),
                            (D = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY'),
                            this.format(S + D + '-MM-DD[T]HH:mm:ss.SSS' + m + '[")]')
                        );
                    }),
                    typeof Symbol < 'u' &&
                        null != Symbol.for &&
                        (Fe[Symbol.for('nodejs.util.inspect.custom')] = function () {
                            return 'Moment<' + this.format() + '>';
                        }),
                    (Fe.toJSON = function Ku() {
                        return this.isValid() ? this.toISOString() : null;
                    }),
                    (Fe.toString = function jr() {
                        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
                    }),
                    (Fe.unix = function qh() {
                        return Math.floor(this.valueOf() / 1e3);
                    }),
                    (Fe.valueOf = function Bh() {
                        return this._d.valueOf() - 6e4 * (this._offset || 0);
                    }),
                    (Fe.creationData = function Io() {
                        return {
                            input: this._i,
                            format: this._f,
                            locale: this._locale,
                            isUTC: this._isUTC,
                            strict: this._strict,
                        };
                    }),
                    (Fe.eraName = function k3() {
                        var d,
                            m,
                            S,
                            D = this.localeData().eras();
                        for (d = 0, m = D.length; d < m; ++d)
                            if (
                                ((S = this.clone().startOf('day').valueOf()),
                                (D[d].since <= S && S <= D[d].until) || (D[d].until <= S && S <= D[d].since))
                            )
                                return D[d].name;
                        return '';
                    }),
                    (Fe.eraNarrow = function Yh() {
                        var d,
                            m,
                            S,
                            D = this.localeData().eras();
                        for (d = 0, m = D.length; d < m; ++d)
                            if (
                                ((S = this.clone().startOf('day').valueOf()),
                                (D[d].since <= S && S <= D[d].until) || (D[d].until <= S && S <= D[d].since))
                            )
                                return D[d].narrow;
                        return '';
                    }),
                    (Fe.eraAbbr = function Zl() {
                        var d,
                            m,
                            S,
                            D = this.localeData().eras();
                        for (d = 0, m = D.length; d < m; ++d)
                            if (
                                ((S = this.clone().startOf('day').valueOf()),
                                (D[d].since <= S && S <= D[d].until) || (D[d].until <= S && S <= D[d].since))
                            )
                                return D[d].abbr;
                        return '';
                    }),
                    (Fe.eraYear = function E3() {
                        var d,
                            m,
                            S,
                            D,
                            Y = this.localeData().eras();
                        for (d = 0, m = Y.length; d < m; ++d)
                            if (
                                ((S = Y[d].since <= Y[d].until ? 1 : -1),
                                (D = this.clone().startOf('day').valueOf()),
                                (Y[d].since <= D && D <= Y[d].until) || (Y[d].until <= D && D <= Y[d].since))
                            )
                                return (this.year() - M(Y[d].since).year()) * S + Y[d].offset;
                        return this.year();
                    }),
                    (Fe.year = m0),
                    (Fe.isLeapYear = function Pc() {
                        return ft(this.year());
                    }),
                    (Fe.weekYear = function wr(d) {
                        return Wh.call(
                            this,
                            d,
                            this.week(),
                            this.weekday(),
                            this.localeData()._week.dow,
                            this.localeData()._week.doy,
                        );
                    }),
                    (Fe.isoWeekYear = function $h(d) {
                        return Wh.call(this, d, this.isoWeek(), this.isoWeekday(), 1, 4);
                    }),
                    (Fe.quarter = Fe.quarters =
                        function P3(d) {
                            return null == d
                                ? Math.ceil((this.month() + 1) / 3)
                                : this.month(3 * (d - 1) + (this.month() % 3));
                        }),
                    (Fe.month = zc),
                    (Fe.daysInMonth = function Hu() {
                        return Do(this.year(), this.month());
                    }),
                    (Fe.week = Fe.weeks =
                        function or(d) {
                            var m = this.localeData().week(this);
                            return null == d ? m : this.add(7 * (d - m), 'd');
                        }),
                    (Fe.isoWeek = Fe.isoWeeks =
                        function bt(d) {
                            var m = ql(this, 1, 4).week;
                            return null == d ? m : this.add(7 * (d - m), 'd');
                        }),
                    (Fe.weeksInYear = function L3() {
                        var d = this.localeData()._week;
                        return hr(this.year(), d.dow, d.doy);
                    }),
                    (Fe.weeksInWeekYear = function O3() {
                        var d = this.localeData()._week;
                        return hr(this.weekYear(), d.dow, d.doy);
                    }),
                    (Fe.isoWeeksInYear = function Gh() {
                        return hr(this.year(), 1, 4);
                    }),
                    (Fe.isoWeeksInISOWeekYear = function Qc() {
                        return hr(this.isoWeekYear(), 1, 4);
                    }),
                    (Fe.date = Kh),
                    (Fe.day = Fe.days =
                        function Rc(d) {
                            if (!this.isValid()) return null != d ? this : NaN;
                            var m = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                            return null != d
                                ? ((d = (function Bu(d, m) {
                                      return 'string' != typeof d
                                          ? d
                                          : isNaN(d)
                                          ? 'number' == typeof (d = m.weekdaysParse(d))
                                              ? d
                                              : null
                                          : parseInt(d, 10);
                                  })(d, this.localeData())),
                                  this.add(d - m, 'd'))
                                : m;
                        }),
                    (Fe.weekday = function Yu(d) {
                        if (!this.isValid()) return null != d ? this : NaN;
                        var m = (this.day() + 7 - this.localeData()._week.dow) % 7;
                        return null == d ? m : this.add(d - m, 'd');
                    }),
                    (Fe.isoWeekday = function b0(d) {
                        if (!this.isValid()) return null != d ? this : NaN;
                        if (null != d) {
                            var m = (function Lh(d, m) {
                                return 'string' == typeof d ? m.weekdaysParse(d) % 7 || 7 : isNaN(d) ? null : d;
                            })(d, this.localeData());
                            return this.day(this.day() % 7 ? m : m - 7);
                        }
                        return this.day() || 7;
                    }),
                    (Fe.dayOfYear = function E0(d) {
                        var m = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
                        return null == d ? m : this.add(d - m, 'd');
                    }),
                    (Fe.hour = Fe.hours = Ph),
                    (Fe.minute = Fe.minutes = Zu),
                    (Fe.second = Fe.seconds = Ui),
                    (Fe.millisecond = Fe.milliseconds = St),
                    (Fe.utcOffset = function Ls(d, m, S) {
                        var Y,
                            D = this._offset || 0;
                        if (!this.isValid()) return null != d ? this : NaN;
                        if (null != d) {
                            if ('string' == typeof d) {
                                if (null === (d = ta(So, d))) return this;
                            } else Math.abs(d) < 16 && !S && (d *= 60);
                            return (
                                !this._isUTC && m && (Y = qa(this)),
                                (this._offset = d),
                                (this._isUTC = !0),
                                null != Y && this.add(Y, 'm'),
                                D !== d &&
                                    (!m || this._changeInProgress
                                        ? ai(this, It(d - D, 'm'), 1, !1)
                                        : this._changeInProgress ||
                                          ((this._changeInProgress = !0),
                                          M.updateOffset(this, !0),
                                          (this._changeInProgress = null))),
                                this
                            );
                        }
                        return this._isUTC ? D : qa(this);
                    }),
                    (Fe.utc = function na(d) {
                        return this.utcOffset(0, d);
                    }),
                    (Fe.local = function $c(d) {
                        return (
                            this._isUTC &&
                                (this.utcOffset(0, d), (this._isUTC = !1), d && this.subtract(qa(this), 'm')),
                            this
                        );
                    }),
                    (Fe.parseZone = function X() {
                        if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
                        else if ('string' == typeof this._i) {
                            var d = ta(gr, this._i);
                            null != d ? this.utcOffset(d) : this.utcOffset(0, !0);
                        }
                        return this;
                    }),
                    (Fe.hasAlignedHourOffset = function le(d) {
                        return !!this.isValid() && ((d = d ? oi(d).utcOffset() : 0), (this.utcOffset() - d) % 60 == 0);
                    }),
                    (Fe.isDST = function be() {
                        return (
                            this.utcOffset() > this.clone().month(0).utcOffset() ||
                            this.utcOffset() > this.clone().month(5).utcOffset()
                        );
                    }),
                    (Fe.isLocal = function de() {
                        return !!this.isValid() && !this._isUTC;
                    }),
                    (Fe.isUtcOffset = function Qe() {
                        return !!this.isValid() && this._isUTC;
                    }),
                    (Fe.isUtc = it),
                    (Fe.isUTC = it),
                    (Fe.zoneAbbr = function Ao() {
                        return this._isUTC ? 'UTC' : '';
                    }),
                    (Fe.zoneName = function as() {
                        return this._isUTC ? 'Coordinated Universal Time' : '';
                    }),
                    (Fe.dates = je('dates accessor is deprecated. Use date instead.', Kh)),
                    (Fe.months = je('months accessor is deprecated. Use month instead', zc)),
                    (Fe.years = je('years accessor is deprecated. Use year instead', m0)),
                    (Fe.zone = je(
                        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
                        function An(d, m) {
                            return null != d
                                ? ('string' != typeof d && (d = -d), this.utcOffset(d, m), this)
                                : -this.utcOffset();
                        },
                    )),
                    (Fe.isDSTShifted = je(
                        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
                        function we() {
                            if (!_(this._isDSTShifted)) return this._isDSTShifted;
                            var m,
                                d = {};
                            return (
                                De(d, this),
                                (d = co(d))._a
                                    ? ((m = d._isUTC ? k(d._a) : oi(d._a)),
                                      (this._isDSTShifted =
                                          this.isValid() &&
                                          (function jc(d, m, S) {
                                              var Ee,
                                                  D = Math.min(d.length, m.length),
                                                  Y = Math.abs(d.length - m.length),
                                                  oe = 0;
                                              for (Ee = 0; Ee < D; Ee++)
                                                  ((S && d[Ee] !== m[Ee]) || (!S && Ut(d[Ee]) !== Ut(m[Ee]))) && oe++;
                                              return oe + Y;
                                          })(d._a, m.toArray()) > 0))
                                    : (this._isDSTShifted = !1),
                                this._isDSTShifted
                            );
                        },
                    ));
                var cn = Pt.prototype;
                function Nt(d, m, S, D) {
                    var Y = B(),
                        oe = k().set(D, m);
                    return Y[S](oe, d);
                }
                function tc(d, m, S) {
                    if ((T(d) && ((m = d), (d = void 0)), (d = d || ''), null != m)) return Nt(d, m, S, 'month');
                    var D,
                        Y = [];
                    for (D = 0; D < 12; D++) Y[D] = Nt(d, D, S, 'month');
                    return Y;
                }
                function Ju(d, m, S, D) {
                    'boolean' == typeof d
                        ? (T(m) && ((S = m), (m = void 0)), (m = m || ''))
                        : ((S = m = d), (d = !1), T(m) && ((S = m), (m = void 0)), (m = m || ''));
                    var Ee,
                        Y = B(),
                        oe = d ? Y._week.dow : 0,
                        xt = [];
                    if (null != S) return Nt(m, (S + oe) % 7, D, 'day');
                    for (Ee = 0; Ee < 7; Ee++) xt[Ee] = Nt(m, (Ee + oe) % 7, D, 'day');
                    return xt;
                }
                (cn.calendar = function Sn(d, m, S) {
                    var D = this._calendar[d] || this._calendar.sameElse;
                    return Et(D) ? D.call(m, S) : D;
                }),
                    (cn.longDateFormat = function _n(d) {
                        var m = this._longDateFormat[d],
                            S = this._longDateFormat[d.toUpperCase()];
                        return m || !S
                            ? m
                            : ((this._longDateFormat[d] = S.match(Vt)
                                  .map(function (D) {
                                      return 'MMMM' === D || 'MM' === D || 'DD' === D || 'dddd' === D ? D.slice(1) : D;
                                  })
                                  .join('')),
                              this._longDateFormat[d]);
                    }),
                    (cn.invalidDate = function xn() {
                        return this._invalidDate;
                    }),
                    (cn.ordinal = function Ji(d) {
                        return this._ordinal.replace('%d', d);
                    }),
                    (cn.preparse = lr),
                    (cn.postformat = lr),
                    (cn.relativeTime = function ii(d, m, S, D) {
                        var Y = this._relativeTime[S];
                        return Et(Y) ? Y(d, m, S, D) : Y.replace(/%d/i, d);
                    }),
                    (cn.pastFuture = function Vs(d, m) {
                        var S = this._relativeTime[d > 0 ? 'future' : 'past'];
                        return Et(S) ? S(m) : S.replace(/%s/i, m);
                    }),
                    (cn.set = function ht(d) {
                        var m, S;
                        for (S in d) v(d, S) && (Et((m = d[S])) ? (this[S] = m) : (this['_' + S] = m));
                        (this._config = d),
                            (this._dayOfMonthOrdinalParseLenient = new RegExp(
                                (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                                    '|' +
                                    /\d{1,2}/.source,
                            ));
                    }),
                    (cn.eras = function Xl(d, m) {
                        var S,
                            D,
                            Y,
                            oe = this._eras || B('en')._eras;
                        for (S = 0, D = oe.length; S < D; ++S)
                            switch (
                                ('string' == typeof oe[S].since &&
                                    ((Y = M(oe[S].since).startOf('day')), (oe[S].since = Y.valueOf())),
                                typeof oe[S].until)
                            ) {
                                case 'undefined':
                                    oe[S].until = 1 / 0;
                                    break;
                                case 'string':
                                    (Y = M(oe[S].until).startOf('day').valueOf()), (oe[S].until = Y.valueOf());
                            }
                        return oe;
                    }),
                    (cn.erasParse = function D0(d, m, S) {
                        var D,
                            Y,
                            Ee,
                            xt,
                            pn,
                            oe = this.eras();
                        for (d = d.toUpperCase(), D = 0, Y = oe.length; D < Y; ++D)
                            if (
                                ((Ee = oe[D].name.toUpperCase()),
                                (xt = oe[D].abbr.toUpperCase()),
                                (pn = oe[D].narrow.toUpperCase()),
                                S)
                            )
                                switch (m) {
                                    case 'N':
                                    case 'NN':
                                    case 'NNN':
                                        if (xt === d) return oe[D];
                                        break;
                                    case 'NNNN':
                                        if (Ee === d) return oe[D];
                                        break;
                                    case 'NNNNN':
                                        if (pn === d) return oe[D];
                                }
                            else if ([Ee, xt, pn].indexOf(d) >= 0) return oe[D];
                    }),
                    (cn.erasConvertYear = function x3(d, m) {
                        var S = d.since <= d.until ? 1 : -1;
                        return void 0 === m ? M(d.since).year() : M(d.since).year() + (m - d.offset) * S;
                    }),
                    (cn.erasAbbrRegex = function A3(d) {
                        return v(this, '_erasAbbrRegex') || k0.call(this), d ? this._erasAbbrRegex : this._erasRegex;
                    }),
                    (cn.erasNameRegex = function I3(d) {
                        return v(this, '_erasNameRegex') || k0.call(this), d ? this._erasNameRegex : this._erasRegex;
                    }),
                    (cn.erasNarrowRegex = function x0(d) {
                        return (
                            v(this, '_erasNarrowRegex') || k0.call(this), d ? this._erasNarrowRegex : this._erasRegex
                        );
                    }),
                    (cn.months = function Vu(d, m) {
                        return d
                            ? G(this._months)
                                ? this._months[d.month()]
                                : this._months[(this._months.isFormat || Ru).test(m) ? 'format' : 'standalone'][
                                      d.month()
                                  ]
                            : G(this._months)
                            ? this._months
                            : this._months.standalone;
                    }),
                    (cn.monthsShort = function Xn(d, m) {
                        return d
                            ? G(this._monthsShort)
                                ? this._monthsShort[d.month()]
                                : this._monthsShort[Ru.test(m) ? 'format' : 'standalone'][d.month()]
                            : G(this._monthsShort)
                            ? this._monthsShort
                            : this._monthsShort.standalone;
                    }),
                    (cn.monthsParse = function tr(d, m, S) {
                        var D, Y, oe;
                        if (this._monthsParseExact) return f0.call(this, d, m, S);
                        for (
                            this._monthsParse ||
                                ((this._monthsParse = []), (this._longMonthsParse = []), (this._shortMonthsParse = [])),
                                D = 0;
                            D < 12;
                            D++
                        ) {
                            if (
                                ((Y = k([2e3, D])),
                                S &&
                                    !this._longMonthsParse[D] &&
                                    ((this._longMonthsParse[D] = new RegExp(
                                        '^' + this.months(Y, '').replace('.', '') + '$',
                                        'i',
                                    )),
                                    (this._shortMonthsParse[D] = new RegExp(
                                        '^' + this.monthsShort(Y, '').replace('.', '') + '$',
                                        'i',
                                    ))),
                                !S &&
                                    !this._monthsParse[D] &&
                                    ((oe = '^' + this.months(Y, '') + '|^' + this.monthsShort(Y, '')),
                                    (this._monthsParse[D] = new RegExp(oe.replace('.', ''), 'i'))),
                                S && 'MMMM' === m && this._longMonthsParse[D].test(d))
                            )
                                return D;
                            if (S && 'MMM' === m && this._shortMonthsParse[D].test(d)) return D;
                            if (!S && this._monthsParse[D].test(d)) return D;
                        }
                    }),
                    (cn.monthsRegex = function Dt(d) {
                        return this._monthsParseExact
                            ? (v(this, '_monthsRegex') || Zo.call(this),
                              d ? this._monthsStrictRegex : this._monthsRegex)
                            : (v(this, '_monthsRegex') || (this._monthsRegex = Ih),
                              this._monthsStrictRegex && d ? this._monthsStrictRegex : this._monthsRegex);
                    }),
                    (cn.monthsShortRegex = function Wt(d) {
                        return this._monthsParseExact
                            ? (v(this, '_monthsRegex') || Zo.call(this),
                              d ? this._monthsShortStrictRegex : this._monthsShortRegex)
                            : (v(this, '_monthsShortRegex') || (this._monthsShortRegex = Rn),
                              this._monthsShortStrictRegex && d
                                  ? this._monthsShortStrictRegex
                                  : this._monthsShortRegex);
                    }),
                    (cn.week = function Uu(d) {
                        return ql(d, this._week.dow, this._week.doy).week;
                    }),
                    (cn.firstDayOfYear = function Ah() {
                        return this._week.doy;
                    }),
                    (cn.firstDayOfWeek = function v0() {
                        return this._week.dow;
                    }),
                    (cn.weekdays = function Oh(d, m) {
                        var S = G(this._weekdays)
                            ? this._weekdays
                            : this._weekdays[
                                  d && !0 !== d && this._weekdays.isFormat.test(m) ? 'format' : 'standalone'
                              ];
                        return !0 === d ? Pa(S, this._week.dow) : d ? S[d.day()] : S;
                    }),
                    (cn.weekdaysMin = function Fc(d) {
                        return !0 === d
                            ? Pa(this._weekdaysMin, this._week.dow)
                            : d
                            ? this._weekdaysMin[d.day()]
                            : this._weekdaysMin;
                    }),
                    (cn.weekdaysShort = function qu(d) {
                        return !0 === d
                            ? Pa(this._weekdaysShort, this._week.dow)
                            : d
                            ? this._weekdaysShort[d.day()]
                            : this._weekdaysShort;
                    }),
                    (cn.weekdaysParse = function $l(d, m, S) {
                        var D, Y, oe;
                        if (this._weekdaysParseExact) return jl.call(this, d, m, S);
                        for (
                            this._weekdaysParse ||
                                ((this._weekdaysParse = []),
                                (this._minWeekdaysParse = []),
                                (this._shortWeekdaysParse = []),
                                (this._fullWeekdaysParse = [])),
                                D = 0;
                            D < 7;
                            D++
                        ) {
                            if (
                                ((Y = k([2e3, 1]).day(D)),
                                S &&
                                    !this._fullWeekdaysParse[D] &&
                                    ((this._fullWeekdaysParse[D] = new RegExp(
                                        '^' + this.weekdays(Y, '').replace('.', '\\.?') + '$',
                                        'i',
                                    )),
                                    (this._shortWeekdaysParse[D] = new RegExp(
                                        '^' + this.weekdaysShort(Y, '').replace('.', '\\.?') + '$',
                                        'i',
                                    )),
                                    (this._minWeekdaysParse[D] = new RegExp(
                                        '^' + this.weekdaysMin(Y, '').replace('.', '\\.?') + '$',
                                        'i',
                                    ))),
                                this._weekdaysParse[D] ||
                                    ((oe =
                                        '^' +
                                        this.weekdays(Y, '') +
                                        '|^' +
                                        this.weekdaysShort(Y, '') +
                                        '|^' +
                                        this.weekdaysMin(Y, '')),
                                    (this._weekdaysParse[D] = new RegExp(oe.replace('.', ''), 'i'))),
                                S && 'dddd' === m && this._fullWeekdaysParse[D].test(d))
                            )
                                return D;
                            if (S && 'ddd' === m && this._shortWeekdaysParse[D].test(d)) return D;
                            if (S && 'dd' === m && this._minWeekdaysParse[D].test(d)) return D;
                            if (!S && this._weekdaysParse[D].test(d)) return D;
                        }
                    }),
                    (cn.weekdaysRegex = function $e(d) {
                        return this._weekdaysParseExact
                            ? (v(this, '_weekdaysRegex') || Na.call(this),
                              d ? this._weekdaysStrictRegex : this._weekdaysRegex)
                            : (v(this, '_weekdaysRegex') || (this._weekdaysRegex = y0),
                              this._weekdaysStrictRegex && d ? this._weekdaysStrictRegex : this._weekdaysRegex);
                    }),
                    (cn.weekdaysShortRegex = function Vc(d) {
                        return this._weekdaysParseExact
                            ? (v(this, '_weekdaysRegex') || Na.call(this),
                              d ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
                            : (v(this, '_weekdaysShortRegex') || (this._weekdaysShortRegex = zn),
                              this._weekdaysShortStrictRegex && d
                                  ? this._weekdaysShortStrictRegex
                                  : this._weekdaysShortRegex);
                    }),
                    (cn.weekdaysMinRegex = function Gl(d) {
                        return this._weekdaysParseExact
                            ? (v(this, '_weekdaysRegex') || Na.call(this),
                              d ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
                            : (v(this, '_weekdaysMinRegex') || (this._weekdaysMinRegex = ml),
                              this._weekdaysMinStrictRegex && d
                                  ? this._weekdaysMinStrictRegex
                                  : this._weekdaysMinRegex);
                    }),
                    (cn.isPM = function $u(d) {
                        return 'p' === (d + '').toLowerCase().charAt(0);
                    }),
                    (cn.meridiem = function Uc(d, m, S) {
                        return d > 11 ? (S ? 'pm' : 'PM') : S ? 'am' : 'AM';
                    }),
                    w('en', {
                        eras: [
                            {
                                since: '0001-01-01',
                                until: 1 / 0,
                                offset: 1,
                                name: 'Anno Domini',
                                narrow: 'AD',
                                abbr: 'AD',
                            },
                            {
                                since: '0000-12-31',
                                until: -1 / 0,
                                offset: 1,
                                name: 'Before Christ',
                                narrow: 'BC',
                                abbr: 'BC',
                            },
                        ],
                        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                        ordinal: function (d) {
                            var m = d % 10;
                            return (
                                d +
                                (1 === Ut((d % 100) / 10)
                                    ? 'th'
                                    : 1 === m
                                    ? 'st'
                                    : 2 === m
                                    ? 'nd'
                                    : 3 === m
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                    }),
                    (M.lang = je('moment.lang is deprecated. Use moment.locale instead.', w)),
                    (M.langData = je('moment.langData is deprecated. Use moment.localeData instead.', B));
                var $s = Math.abs;
                function va(d, m, S, D) {
                    var Y = It(m, S);
                    return (
                        (d._milliseconds += D * Y._milliseconds),
                        (d._days += D * Y._days),
                        (d._months += D * Y._months),
                        d._bubble()
                    );
                }
                function Zt(d) {
                    return d < 0 ? Math.floor(d) : Math.ceil(d);
                }
                function rc(d) {
                    return (4800 * d) / 146097;
                }
                function fo(d) {
                    return (146097 * d) / 4800;
                }
                function li(d) {
                    return function () {
                        return this.as(d);
                    };
                }
                var A0 = li('ms'),
                    ls = li('s'),
                    cs = li('m'),
                    L0 = li('h'),
                    wl = li('d'),
                    n1 = li('w'),
                    Lo = li('M'),
                    O0 = li('Q'),
                    N3 = li('y');
                function ja(d) {
                    return function () {
                        return this.isValid() ? this._data[d] : NaN;
                    };
                }
                var R3 = ja('milliseconds'),
                    P0 = ja('seconds'),
                    T5 = ja('minutes'),
                    D5 = ja('hours'),
                    x5 = ja('days'),
                    k5 = ja('months'),
                    E5 = ja('years');
                var $a = Math.round,
                    Zc = { ss: 44, s: 45, m: 45, h: 22, d: 26, w: null, M: 11 };
                function A5(d, m, S, D, Y) {
                    return Y.relativeTime(m || 1, !!S, d, D);
                }
                var r1 = Math.abs;
                function Jc(d) {
                    return (d > 0) - (d < 0) || +d;
                }
                function N0() {
                    if (!this.isValid()) return this.localeData().invalidDate();
                    var D,
                        Y,
                        oe,
                        Ee,
                        pn,
                        vi,
                        Gr,
                        _a,
                        d = r1(this._milliseconds) / 1e3,
                        m = r1(this._days),
                        S = r1(this._months),
                        xt = this.asSeconds();
                    return xt
                        ? ((D = gn(d / 60)),
                          (Y = gn(D / 60)),
                          (d %= 60),
                          (D %= 60),
                          (oe = gn(S / 12)),
                          (S %= 12),
                          (Ee = d ? d.toFixed(3).replace(/\.?0+$/, '') : ''),
                          (pn = xt < 0 ? '-' : ''),
                          (vi = Jc(this._months) !== Jc(xt) ? '-' : ''),
                          (Gr = Jc(this._days) !== Jc(xt) ? '-' : ''),
                          (_a = Jc(this._milliseconds) !== Jc(xt) ? '-' : ''),
                          pn +
                              'P' +
                              (oe ? vi + oe + 'Y' : '') +
                              (S ? vi + S + 'M' : '') +
                              (m ? Gr + m + 'D' : '') +
                              (Y || D || d ? 'T' : '') +
                              (Y ? _a + Y + 'H' : '') +
                              (D ? _a + D + 'M' : '') +
                              (d ? _a + Ee + 'S' : ''))
                        : 'P0D';
                }
                var Hn = gs.prototype;
                //! moment.js
                return (
                    (Hn.isValid = function ho() {
                        return this._isValid;
                    }),
                    (Hn.abs = function Qh() {
                        var d = this._data;
                        return (
                            (this._milliseconds = $s(this._milliseconds)),
                            (this._days = $s(this._days)),
                            (this._months = $s(this._months)),
                            (d.milliseconds = $s(d.milliseconds)),
                            (d.seconds = $s(d.seconds)),
                            (d.minutes = $s(d.minutes)),
                            (d.hours = $s(d.hours)),
                            (d.months = $s(d.months)),
                            (d.years = $s(d.years)),
                            this
                        );
                    }),
                    (Hn.add = function e1(d, m) {
                        return va(this, d, m, 1);
                    }),
                    (Hn.subtract = function Cl(d, m) {
                        return va(this, d, m, -1);
                    }),
                    (Hn.as = function t1(d) {
                        if (!this.isValid()) return NaN;
                        var m,
                            S,
                            D = this._milliseconds;
                        if ('month' === (d = Oi(d)) || 'quarter' === d || 'year' === d)
                            switch (((m = this._days + D / 864e5), (S = this._months + rc(m)), d)) {
                                case 'month':
                                    return S;
                                case 'quarter':
                                    return S / 3;
                                case 'year':
                                    return S / 12;
                            }
                        else
                            switch (((m = this._days + Math.round(fo(this._months))), d)) {
                                case 'week':
                                    return m / 7 + D / 6048e5;
                                case 'day':
                                    return m + D / 864e5;
                                case 'hour':
                                    return 24 * m + D / 36e5;
                                case 'minute':
                                    return 1440 * m + D / 6e4;
                                case 'second':
                                    return 86400 * m + D / 1e3;
                                case 'millisecond':
                                    return Math.floor(864e5 * m) + D;
                                default:
                                    throw new Error('Unknown unit ' + d);
                            }
                    }),
                    (Hn.asMilliseconds = A0),
                    (Hn.asSeconds = ls),
                    (Hn.asMinutes = cs),
                    (Hn.asHours = L0),
                    (Hn.asDays = wl),
                    (Hn.asWeeks = n1),
                    (Hn.asMonths = Lo),
                    (Hn.asQuarters = O0),
                    (Hn.asYears = N3),
                    (Hn.valueOf = function sc() {
                        return this.isValid()
                            ? this._milliseconds +
                                  864e5 * this._days +
                                  (this._months % 12) * 2592e6 +
                                  31536e6 * Ut(this._months / 12)
                            : NaN;
                    }),
                    (Hn._bubble = function I0() {
                        var Y,
                            oe,
                            Ee,
                            xt,
                            pn,
                            d = this._milliseconds,
                            m = this._days,
                            S = this._months,
                            D = this._data;
                        return (
                            (d >= 0 && m >= 0 && S >= 0) ||
                                (d <= 0 && m <= 0 && S <= 0) ||
                                ((d += 864e5 * Zt(fo(S) + m)), (m = 0), (S = 0)),
                            (D.milliseconds = d % 1e3),
                            (Y = gn(d / 1e3)),
                            (D.seconds = Y % 60),
                            (oe = gn(Y / 60)),
                            (D.minutes = oe % 60),
                            (Ee = gn(oe / 60)),
                            (D.hours = Ee % 24),
                            (m += gn(Ee / 24)),
                            (S += pn = gn(rc(m))),
                            (m -= Zt(fo(pn))),
                            (xt = gn(S / 12)),
                            (S %= 12),
                            (D.days = m),
                            (D.months = S),
                            (D.years = xt),
                            this
                        );
                    }),
                    (Hn.clone = function F3() {
                        return It(this);
                    }),
                    (Hn.get = function z0(d) {
                        return (d = Oi(d)), this.isValid() ? this[d + 's']() : NaN;
                    }),
                    (Hn.milliseconds = R3),
                    (Hn.seconds = P0),
                    (Hn.minutes = T5),
                    (Hn.hours = D5),
                    (Hn.days = x5),
                    (Hn.weeks = function I5() {
                        return gn(this.days() / 7);
                    }),
                    (Hn.months = k5),
                    (Hn.years = E5),
                    (Hn.humanize = function Xh(d, m) {
                        if (!this.isValid()) return this.localeData().invalidDate();
                        var Y,
                            oe,
                            S = !1,
                            D = Zc;
                        return (
                            'object' == typeof d && ((m = d), (d = !1)),
                            'boolean' == typeof d && (S = d),
                            'object' == typeof m &&
                                ((D = Object.assign({}, Zc, m)), null != m.s && null == m.ss && (D.ss = m.s - 1)),
                            (oe = (function L5(d, m, S, D) {
                                var Y = It(d).abs(),
                                    oe = $a(Y.as('s')),
                                    Ee = $a(Y.as('m')),
                                    xt = $a(Y.as('h')),
                                    pn = $a(Y.as('d')),
                                    vi = $a(Y.as('M')),
                                    Gr = $a(Y.as('w')),
                                    _a = $a(Y.as('y')),
                                    Wr =
                                        (oe <= S.ss && ['s', oe]) ||
                                        (oe < S.s && ['ss', oe]) ||
                                        (Ee <= 1 && ['m']) ||
                                        (Ee < S.m && ['mm', Ee]) ||
                                        (xt <= 1 && ['h']) ||
                                        (xt < S.h && ['hh', xt]) ||
                                        (pn <= 1 && ['d']) ||
                                        (pn < S.d && ['dd', pn]);
                                return (
                                    null != S.w && (Wr = Wr || (Gr <= 1 && ['w']) || (Gr < S.w && ['ww', Gr])),
                                    ((Wr = Wr ||
                                        (vi <= 1 && ['M']) ||
                                        (vi < S.M && ['MM', vi]) ||
                                        (_a <= 1 && ['y']) || ['yy', _a])[2] = m),
                                    (Wr[3] = +d > 0),
                                    (Wr[4] = D),
                                    A5.apply(null, Wr)
                                );
                            })(this, !S, D, (Y = this.localeData()))),
                            S && (oe = Y.pastFuture(+this, oe)),
                            Y.postformat(oe)
                        );
                    }),
                    (Hn.toISOString = N0),
                    (Hn.toString = N0),
                    (Hn.toJSON = N0),
                    (Hn.locale = Gc),
                    (Hn.localeData = Uh),
                    (Hn.toIsoString = je(
                        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
                        N0,
                    )),
                    (Hn.lang = Hh),
                    ke('X', 0, 0, 'unix'),
                    ke('x', 0, 0, 'valueOf'),
                    Ke('x', ni),
                    Ke('X', /[+-]?\d+(\.\d{1,3})?/),
                    Ct('X', function (d, m, S) {
                        S._d = new Date(1e3 * parseFloat(d));
                    }),
                    Ct('x', function (d, m, S) {
                        S._d = new Date(Ut(d));
                    }),
                    (M.version = '2.29.4'),
                    (function q(d) {
                        O = d;
                    })(oi),
                    (M.fn = Fe),
                    (M.min = function yr() {
                        return gl('isBefore', [].slice.call(arguments, 0));
                    }),
                    (M.max = function Ua() {
                        return gl('isAfter', [].slice.call(arguments, 0));
                    }),
                    (M.now = function () {
                        return Date.now ? Date.now() : +new Date();
                    }),
                    (M.utc = k),
                    (M.unix = function ec(d) {
                        return oi(1e3 * d);
                    }),
                    (M.months = function nc(d, m) {
                        return tc(d, m, 'months');
                    }),
                    (M.isDate = x),
                    (M.locale = w),
                    (M.invalid = Q),
                    (M.duration = It),
                    (M.isMoment = Ve),
                    (M.weekdays = function Xc(d, m, S) {
                        return Ju(d, m, S, 'weekdays');
                    }),
                    (M.parseZone = function Di() {
                        return oi.apply(null, arguments).parseZone();
                    }),
                    (M.localeData = B),
                    (M.isDuration = Wl),
                    (M.monthsShort = function Ki(d, m) {
                        return tc(d, m, 'monthsShort');
                    }),
                    (M.weekdaysMin = function ga(d, m, S) {
                        return Ju(d, m, S, 'weekdaysMin');
                    }),
                    (M.defineLocale = I),
                    (M.updateLocale = function A(d, m) {
                        if (null != m) {
                            var S,
                                D,
                                Y = so;
                            null != si[d] && null != si[d].parentLocale
                                ? si[d].set(Re(si[d]._config, m))
                                : (null != (D = y(d)) && (Y = D._config),
                                  (m = Re(Y, m)),
                                  null == D && (m.abbr = d),
                                  ((S = new Pt(m)).parentLocale = si[d]),
                                  (si[d] = S)),
                                w(d);
                        } else
                            null != si[d] &&
                                (null != si[d].parentLocale
                                    ? ((si[d] = si[d].parentLocale), d === w() && w(d))
                                    : null != si[d] && delete si[d]);
                        return si[d];
                    }),
                    (M.locales = function ne() {
                        return Gt(si);
                    }),
                    (M.weekdaysShort = function ic(d, m, S) {
                        return Ju(d, m, S, 'weekdaysShort');
                    }),
                    (M.normalizeUnits = Oi),
                    (M.relativeTimeRounding = function O5(d) {
                        return void 0 === d ? $a : 'function' == typeof d && (($a = d), !0);
                    }),
                    (M.relativeTimeThreshold = function z5(d, m) {
                        return (
                            void 0 !== Zc[d] && (void 0 === m ? Zc[d] : ((Zc[d] = m), 's' === d && (Zc.ss = m - 1), !0))
                        );
                    }),
                    (M.calendarFormat = function v3(d, m) {
                        var S = d.diff(m, 'days', !0);
                        return S < -6
                            ? 'sameElse'
                            : S < -1
                            ? 'lastWeek'
                            : S < 0
                            ? 'lastDay'
                            : S < 1
                            ? 'sameDay'
                            : S < 2
                            ? 'nextDay'
                            : S < 7
                            ? 'nextWeek'
                            : 'sameElse';
                    }),
                    (M.prototype = Fe),
                    (M.HTML5_FMT = {
                        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
                        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
                        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
                        DATE: 'YYYY-MM-DD',
                        TIME: 'HH:mm',
                        TIME_SECONDS: 'HH:mm:ss',
                        TIME_MS: 'HH:mm:ss.SSS',
                        WEEK: 'GGGG-[W]WW',
                        MONTH: 'YYYY-MM',
                    }),
                    M
                );
            })();
        },
        3687: (se, ae, U) => {
            var O = 'function' == typeof Map && Map.prototype,
                M =
                    Object.getOwnPropertyDescriptor && O
                        ? Object.getOwnPropertyDescriptor(Map.prototype, 'size')
                        : null,
                q = O && M && 'function' == typeof M.get ? M.get : null,
                G = O && Map.prototype.forEach,
                $ = 'function' == typeof Set && Set.prototype,
                v =
                    Object.getOwnPropertyDescriptor && $
                        ? Object.getOwnPropertyDescriptor(Set.prototype, 'size')
                        : null,
                p = $ && v && 'function' == typeof v.get ? v.get : null,
                _ = $ && Set.prototype.forEach,
                x = 'function' == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
                C = 'function' == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
                R = 'function' == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
                j = Boolean.prototype.valueOf,
                N = Object.prototype.toString,
                K = Function.prototype.toString,
                Q = String.prototype.match,
                ce = String.prototype.slice,
                ge = String.prototype.replace,
                De = String.prototype.toUpperCase,
                xe = String.prototype.toLowerCase,
                Ve = RegExp.prototype.test,
                b = Array.prototype.concat,
                je = Array.prototype.join,
                Ne = Array.prototype.slice,
                at = Math.floor,
                Et = 'function' == typeof BigInt ? BigInt.prototype.valueOf : null,
                ht = Object.getOwnPropertySymbols,
                Re =
                    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? Symbol.prototype.toString
                        : null,
                Pt = 'function' == typeof Symbol && 'object' == typeof Symbol.iterator,
                Gt = 'function' == typeof Symbol && Symbol.toStringTag && (Symbol, 1) ? Symbol.toStringTag : null,
                ur = Object.prototype.propertyIsEnumerable,
                Sn =
                    ('function' == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) ||
                    ([].__proto__ === Array.prototype
                        ? function (_e) {
                              return _e.__proto__;
                          }
                        : null);
            function qt(_e, ye) {
                if (_e === 1 / 0 || _e === -1 / 0 || _e != _e || (_e && _e > -1e3 && _e < 1e3) || Ve.call(/e/, ye))
                    return ye;
                var on = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
                if ('number' == typeof _e) {
                    var kn = _e < 0 ? -at(-_e) : at(_e);
                    if (kn !== _e) {
                        var Qn = String(kn),
                            lt = ce.call(ye, Qn.length + 1);
                        return ge.call(Qn, on, '$&_') + '.' + ge.call(ge.call(lt, /([0-9]{3})/g, '$&_'), /_$/, '');
                    }
                }
                return ge.call(ye, on, '$&_');
            }
            var Vt = U(2634),
                an = Vt.custom,
                qe = xn(an) ? an : null;
            function ot(_e, ye, on) {
                var kn = 'double' === (on.quoteStyle || ye) ? '"' : "'";
                return kn + _e + kn;
            }
            function ke(_e) {
                return ge.call(String(_e), /"/g, '&quot;');
            }
            function Ce(_e) {
                return !('[object Array]' !== Ti(_e) || (Gt && 'object' == typeof _e && Gt in _e));
            }
            function _t(_e) {
                return !('[object RegExp]' !== Ti(_e) || (Gt && 'object' == typeof _e && Gt in _e));
            }
            function xn(_e) {
                if (Pt) return _e && 'object' == typeof _e && _e instanceof Symbol;
                if ('symbol' == typeof _e) return !0;
                if (!_e || 'object' != typeof _e || !Re) return !1;
                try {
                    return Re.call(_e), !0;
                } catch {}
                return !1;
            }
            se.exports = function _e(ye, on, kn, Qn) {
                var lt = on || {};
                if (Ji(lt, 'quoteStyle') && 'single' !== lt.quoteStyle && 'double' !== lt.quoteStyle)
                    throw new TypeError('option "quoteStyle" must be "single" or "double"');
                if (
                    Ji(lt, 'maxStringLength') &&
                    ('number' == typeof lt.maxStringLength
                        ? lt.maxStringLength < 0 && lt.maxStringLength !== 1 / 0
                        : null !== lt.maxStringLength)
                )
                    throw new TypeError(
                        'option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`',
                    );
                var Is = !Ji(lt, 'customInspect') || lt.customInspect;
                if ('boolean' != typeof Is && 'symbol' !== Is)
                    throw new TypeError(
                        'option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`',
                    );
                if (
                    Ji(lt, 'indent') &&
                    null !== lt.indent &&
                    '\t' !== lt.indent &&
                    !(parseInt(lt.indent, 10) === lt.indent && lt.indent > 0)
                )
                    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
                if (Ji(lt, 'numericSeparator') && 'boolean' != typeof lt.numericSeparator)
                    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
                var As = lt.numericSeparator;
                if (typeof ye > 'u') return 'undefined';
                if (null === ye) return 'null';
                if ('boolean' == typeof ye) return ye ? 'true' : 'false';
                if ('string' == typeof ye) return Us(ye, lt);
                if ('number' == typeof ye) {
                    if (0 === ye) return 1 / 0 / ye > 0 ? '0' : '-0';
                    var Yn = String(ye);
                    return As ? qt(ye, Yn) : Yn;
                }
                if ('bigint' == typeof ye) {
                    var Br = String(ye) + 'n';
                    return As ? qt(ye, Br) : Br;
                }
                var no = typeof lt.depth > 'u' ? 5 : lt.depth;
                if ((typeof kn > 'u' && (kn = 0), kn >= no && no > 0 && 'object' == typeof ye))
                    return Ce(ye) ? '[Array]' : '[Object]';
                var Tn = (function hl(_e, ye) {
                    var on;
                    if ('\t' === _e.indent) on = '\t';
                    else {
                        if (!('number' == typeof _e.indent && _e.indent > 0)) return null;
                        on = je.call(Array(_e.indent + 1), ' ');
                    }
                    return { base: on, prev: je.call(Array(ye + 1), on) };
                })(lt, kn);
                if (typeof Qn > 'u') Qn = [];
                else if (Vs(Qn, ye) >= 0) return '[Circular]';
                function ni(ri, er, Bs) {
                    if ((er && (Qn = Ne.call(Qn)).push(er), Bs)) {
                        var ps = { depth: lt.depth };
                        return Ji(lt, 'quoteStyle') && (ps.quoteStyle = lt.quoteStyle), _e(ri, ps, kn + 1, Qn);
                    }
                    return _e(ri, lt, kn + 1, Qn);
                }
                if ('function' == typeof ye && !_t(ye)) {
                    var gr = (function ii(_e) {
                            if (_e.name) return _e.name;
                            var ye = Q.call(K.call(_e), /^function\s*([\w$]+)/);
                            return ye ? ye[1] : null;
                        })(ye),
                        So = to(ye, ni);
                    return (
                        '[Function' +
                        (gr ? ': ' + gr : ' (anonymous)') +
                        ']' +
                        (So.length > 0 ? ' { ' + je.call(So, ', ') + ' }' : '')
                    );
                }
                if (xn(ye)) {
                    var Hl = Pt ? ge.call(String(ye), /^(Symbol\(.*\))_[^)]*$/, '$1') : Re.call(ye);
                    return 'object' != typeof ye || Pt ? Hl : gn(Hl);
                }
                if (
                    (function Kn(_e) {
                        return (
                            !(!_e || 'object' != typeof _e) &&
                            ((typeof HTMLElement < 'u' && _e instanceof HTMLElement) ||
                                ('string' == typeof _e.nodeName && 'function' == typeof _e.getAttribute))
                        );
                    })(ye)
                ) {
                    for (
                        var vt = '<' + xe.call(String(ye.nodeName)), io = ye.attributes || [], Ke = 0;
                        Ke < io.length;
                        Ke++
                    )
                        vt += ' ' + io[Ke].name + '=' + ot(ke(io[Ke].value), 'double', lt);
                    return (
                        (vt += '>'),
                        ye.childNodes && ye.childNodes.length && (vt += '...'),
                        vt + '</' + xe.call(String(ye.nodeName)) + '>'
                    );
                }
                if (Ce(ye)) {
                    if (0 === ye.length) return '[]';
                    var ro = to(ye, ni);
                    return Tn &&
                        !(function Es(_e) {
                            for (var ye = 0; ye < _e.length; ye++) if (Vs(_e[ye], '\n') >= 0) return !1;
                            return !0;
                        })(ro)
                        ? '[' + Qo(ro, Tn) + ']'
                        : '[ ' + je.call(ro, ', ') + ' ]';
                }
                if (
                    (function Ht(_e) {
                        return !('[object Error]' !== Ti(_e) || (Gt && 'object' == typeof _e && Gt in _e));
                    })(ye)
                ) {
                    var mi = to(ye, ni);
                    return 'cause' in Error.prototype || !('cause' in ye) || ur.call(ye, 'cause')
                        ? 0 === mi.length
                            ? '[' + String(ye) + ']'
                            : '{ [' + String(ye) + '] ' + je.call(mi, ', ') + ' }'
                        : '{ [' + String(ye) + '] ' + je.call(b.call('[cause]: ' + ni(ye.cause), mi), ', ') + ' }';
                }
                if ('object' == typeof ye && Is) {
                    if (qe && 'function' == typeof ye[qe] && Vt) return Vt(ye, { depth: no - kn });
                    if ('symbol' !== Is && 'function' == typeof ye.inspect) return ye.inspect();
                }
                if (
                    (function rr(_e) {
                        if (!q || !_e || 'object' != typeof _e) return !1;
                        try {
                            q.call(_e);
                            try {
                                p.call(_e);
                            } catch {
                                return !0;
                            }
                            return _e instanceof Map;
                        } catch {}
                        return !1;
                    })(ye)
                ) {
                    var ln = [];
                    return (
                        G &&
                            G.call(ye, function (ri, er) {
                                ln.push(ni(er, ye, !0) + ' => ' + ni(ri, ye));
                            }),
                        sr('Map', q.call(ye), ln, Tn)
                    );
                }
                if (
                    (function Hs(_e) {
                        if (!p || !_e || 'object' != typeof _e) return !1;
                        try {
                            p.call(_e);
                            try {
                                q.call(_e);
                            } catch {
                                return !0;
                            }
                            return _e instanceof Set;
                        } catch {}
                        return !1;
                    })(ye)
                ) {
                    var za = [];
                    return (
                        _ &&
                            _.call(ye, function (ri) {
                                za.push(ni(ri, ye));
                            }),
                        sr('Set', p.call(ye), za, Tn)
                    );
                }
                if (
                    (function Ri(_e) {
                        if (!x || !_e || 'object' != typeof _e) return !1;
                        try {
                            x.call(_e, x);
                            try {
                                C.call(_e, C);
                            } catch {
                                return !0;
                            }
                            return _e instanceof WeakMap;
                        } catch {}
                        return !1;
                    })(ye)
                )
                    return Ut('WeakMap');
                if (
                    (function pr(_e) {
                        if (!C || !_e || 'object' != typeof _e) return !1;
                        try {
                            C.call(_e, C);
                            try {
                                x.call(_e, x);
                            } catch {
                                return !0;
                            }
                            return _e instanceof WeakSet;
                        } catch {}
                        return !1;
                    })(ye)
                )
                    return Ut('WeakSet');
                if (
                    (function Oi(_e) {
                        if (!R || !_e || 'object' != typeof _e) return !1;
                        try {
                            return R.call(_e), !0;
                        } catch {}
                        return !1;
                    })(ye)
                )
                    return Ut('WeakRef');
                if (
                    (function _n(_e) {
                        return !('[object Number]' !== Ti(_e) || (Gt && 'object' == typeof _e && Gt in _e));
                    })(ye)
                )
                    return gn(ni(Number(ye)));
                if (
                    (function et(_e) {
                        if (!_e || 'object' != typeof _e || !Et) return !1;
                        try {
                            return Et.call(_e), !0;
                        } catch {}
                        return !1;
                    })(ye)
                )
                    return gn(ni(Et.call(ye)));
                if (
                    (function sn(_e) {
                        return !('[object Boolean]' !== Ti(_e) || (Gt && 'object' == typeof _e && Gt in _e));
                    })(ye)
                )
                    return gn(j.call(ye));
                if (
                    (function Qt(_e) {
                        return !('[object String]' !== Ti(_e) || (Gt && 'object' == typeof _e && Gt in _e));
                    })(ye)
                )
                    return gn(ni(String(ye)));
                if (typeof window < 'u' && ye === window) return '{ [object Window] }';
                if (ye === global) return '{ [object globalThis] }';
                if (
                    !(function Pe(_e) {
                        return !('[object Date]' !== Ti(_e) || (Gt && 'object' == typeof _e && Gt in _e));
                    })(ye) &&
                    !_t(ye)
                ) {
                    var Ct = to(ye, ni),
                        ha = Sn ? Sn(ye) === Object.prototype : ye instanceof Object || ye.constructor === Object,
                        fa = ye instanceof Object ? '' : 'null prototype',
                        Me = !ha && Gt && Object(ye) === ye && Gt in ye ? ce.call(Ti(ye), 8, -1) : fa ? 'Object' : '',
                        dr =
                            (ha || 'function' != typeof ye.constructor
                                ? ''
                                : ye.constructor.name
                                ? ye.constructor.name + ' '
                                : '') + (Me || fa ? '[' + je.call(b.call([], Me || [], fa || []), ': ') + '] ' : '');
                    return 0 === Ct.length
                        ? dr + '{}'
                        : Tn
                        ? dr + '{' + Qo(Ct, Tn) + '}'
                        : dr + '{ ' + je.call(Ct, ', ') + ' }';
                }
                return String(ye);
            };
            var qn =
                Object.prototype.hasOwnProperty ||
                function (_e) {
                    return _e in this;
                };
            function Ji(_e, ye) {
                return qn.call(_e, ye);
            }
            function Ti(_e) {
                return N.call(_e);
            }
            function Vs(_e, ye) {
                if (_e.indexOf) return _e.indexOf(ye);
                for (var on = 0, kn = _e.length; on < kn; on++) if (_e[on] === ye) return on;
                return -1;
            }
            function Us(_e, ye) {
                if (_e.length > ye.maxStringLength) {
                    var on = _e.length - ye.maxStringLength,
                        kn = '... ' + on + ' more character' + (on > 1 ? 's' : '');
                    return Us(ce.call(_e, 0, ye.maxStringLength), ye) + kn;
                }
                return ot(ge.call(ge.call(_e, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, ft), 'single', ye);
            }
            function ft(_e) {
                var ye = _e.charCodeAt(0),
                    on = { 8: 'b', 9: 't', 10: 'n', 12: 'f', 13: 'r' }[ye];
                return on ? '\\' + on : '\\x' + (ye < 16 ? '0' : '') + De.call(ye.toString(16));
            }
            function gn(_e) {
                return 'Object(' + _e + ')';
            }
            function Ut(_e) {
                return _e + ' { ? }';
            }
            function sr(_e, ye, on, kn) {
                return _e + ' (' + ye + ') {' + (kn ? Qo(on, kn) : je.call(on, ', ')) + '}';
            }
            function Qo(_e, ye) {
                if (0 === _e.length) return '';
                var on = '\n' + ye.prev + ye.base;
                return on + je.call(_e, ',' + on) + '\n' + ye.prev;
            }
            function to(_e, ye) {
                var on = Ce(_e),
                    kn = [];
                if (on) {
                    kn.length = _e.length;
                    for (var Qn = 0; Qn < _e.length; Qn++) kn[Qn] = Ji(_e, Qn) ? ye(_e[Qn], _e) : '';
                }
                var Is,
                    lt = 'function' == typeof ht ? ht(_e) : [];
                if (Pt) {
                    Is = {};
                    for (var As = 0; As < lt.length; As++) Is['$' + lt[As]] = lt[As];
                }
                for (var Yn in _e)
                    Ji(_e, Yn) &&
                        ((on && String(Number(Yn)) === Yn && Yn < _e.length) ||
                            (Pt && Is['$' + Yn] instanceof Symbol) ||
                            (Ve.call(/[^\w$]/, Yn)
                                ? kn.push(ye(Yn, _e) + ': ' + ye(_e[Yn], _e))
                                : kn.push(Yn + ': ' + ye(_e[Yn], _e))));
                if ('function' == typeof ht)
                    for (var Br = 0; Br < lt.length; Br++)
                        ur.call(_e, lt[Br]) && kn.push('[' + ye(lt[Br]) + ']: ' + ye(_e[lt[Br]], _e));
                return kn;
            }
        },
        9831: se => {
            'use strict';
            var ae = function (U) {
                return U != U;
            };
            se.exports = function (O, M) {
                return 0 === O && 0 === M ? 1 / O == 1 / M : !!(O === M || (ae(O) && ae(M)));
            };
        },
        545: (se, ae, U) => {
            'use strict';
            var O = U(592),
                M = U(6283),
                q = U(9831),
                G = U(9110),
                $ = U(5796),
                v = M(G(), Object);
            O(v, { getPolyfill: G, implementation: q, shim: $ }), (se.exports = v);
        },
        9110: (se, ae, U) => {
            'use strict';
            var O = U(9831);
            se.exports = function () {
                return 'function' == typeof Object.is ? Object.is : O;
            };
        },
        5796: (se, ae, U) => {
            'use strict';
            var O = U(9110),
                M = U(592);
            se.exports = function () {
                var G = O();
                return (
                    M(
                        Object,
                        { is: G },
                        {
                            is: function () {
                                return Object.is !== G;
                            },
                        },
                    ),
                    G
                );
            };
        },
        7935: (se, ae, U) => {
            'use strict';
            var O;
            if (!Object.keys) {
                var M = Object.prototype.hasOwnProperty,
                    q = Object.prototype.toString,
                    G = U(6321),
                    $ = Object.prototype.propertyIsEnumerable,
                    v = !$.call({ toString: null }, 'toString'),
                    p = $.call(function () {}, 'prototype'),
                    _ = [
                        'toString',
                        'toLocaleString',
                        'valueOf',
                        'hasOwnProperty',
                        'isPrototypeOf',
                        'propertyIsEnumerable',
                        'constructor',
                    ],
                    T = function (k) {
                        var R = k.constructor;
                        return R && R.prototype === k;
                    },
                    x = {
                        $applicationCache: !0,
                        $console: !0,
                        $external: !0,
                        $frame: !0,
                        $frameElement: !0,
                        $frames: !0,
                        $innerHeight: !0,
                        $innerWidth: !0,
                        $onmozfullscreenchange: !0,
                        $onmozfullscreenerror: !0,
                        $outerHeight: !0,
                        $outerWidth: !0,
                        $pageXOffset: !0,
                        $pageYOffset: !0,
                        $parent: !0,
                        $scrollLeft: !0,
                        $scrollTop: !0,
                        $scrollX: !0,
                        $scrollY: !0,
                        $self: !0,
                        $webkitIndexedDB: !0,
                        $webkitStorageInfo: !0,
                        $window: !0,
                    },
                    F = (function () {
                        if (typeof window > 'u') return !1;
                        for (var k in window)
                            try {
                                if (
                                    !x['$' + k] &&
                                    M.call(window, k) &&
                                    null !== window[k] &&
                                    'object' == typeof window[k]
                                )
                                    try {
                                        T(window[k]);
                                    } catch {
                                        return !0;
                                    }
                            } catch {
                                return !0;
                            }
                        return !1;
                    })();
                O = function (R) {
                    var j = null !== R && 'object' == typeof R,
                        N = '[object Function]' === q.call(R),
                        K = G(R),
                        Q = j && '[object String]' === q.call(R),
                        ce = [];
                    if (!j && !N && !K) throw new TypeError('Object.keys called on a non-object');
                    var ge = p && N;
                    if (Q && R.length > 0 && !M.call(R, 0)) for (var De = 0; De < R.length; ++De) ce.push(String(De));
                    if (K && R.length > 0) for (var xe = 0; xe < R.length; ++xe) ce.push(String(xe));
                    else for (var Ve in R) (!ge || 'prototype' !== Ve) && M.call(R, Ve) && ce.push(String(Ve));
                    if (v)
                        for (
                            var b = (function (k) {
                                    if (typeof window > 'u' || !F) return T(k);
                                    try {
                                        return T(k);
                                    } catch {
                                        return !1;
                                    }
                                })(R),
                                je = 0;
                            je < _.length;
                            ++je
                        )
                            (!b || 'constructor' !== _[je]) && M.call(R, _[je]) && ce.push(_[je]);
                    return ce;
                };
            }
            se.exports = O;
        },
        9209: (se, ae, U) => {
            'use strict';
            var O = Array.prototype.slice,
                M = U(6321),
                q = Object.keys,
                G = q
                    ? function (p) {
                          return q(p);
                      }
                    : U(7935),
                $ = Object.keys;
            (G.shim = function () {
                if (Object.keys) {
                    var p = (function () {
                        var _ = Object.keys(arguments);
                        return _ && _.length === arguments.length;
                    })(1, 2);
                    p ||
                        (Object.keys = function (T) {
                            return M(T) ? $(O.call(T)) : $(T);
                        });
                } else Object.keys = G;
                return Object.keys || G;
            }),
                (se.exports = G);
        },
        6321: se => {
            'use strict';
            var ae = Object.prototype.toString;
            se.exports = function (O) {
                var M = ae.call(O),
                    q = '[object Arguments]' === M;
                return (
                    q ||
                        (q =
                            '[object Array]' !== M &&
                            null !== O &&
                            'object' == typeof O &&
                            'number' == typeof O.length &&
                            O.length >= 0 &&
                            '[object Function]' === ae.call(O.callee)),
                    q
                );
            };
        },
        8447: (se, ae, U) => {
            'use strict';
            var O = U(9209),
                M = U(6497)(),
                q = U(3463),
                G = Object,
                $ = q('Array.prototype.push'),
                v = q('Object.prototype.propertyIsEnumerable'),
                p = M ? Object.getOwnPropertySymbols : null;
            se.exports = function (T, x) {
                if (null == T) throw new TypeError('target must be an object');
                var F = G(T);
                if (1 === arguments.length) return F;
                for (var C = 1; C < arguments.length; ++C) {
                    var k = G(arguments[C]),
                        R = O(k),
                        j = M && (Object.getOwnPropertySymbols || p);
                    if (j)
                        for (var N = j(k), K = 0; K < N.length; ++K) {
                            var Q = N[K];
                            v(k, Q) && $(R, Q);
                        }
                    for (var ce = 0; ce < R.length; ++ce) {
                        var ge = R[ce];
                        v(k, ge) && (F[ge] = k[ge]);
                    }
                }
                return F;
            };
        },
        6969: (se, ae, U) => {
            'use strict';
            var O = U(592),
                M = U(6283),
                q = U(8447),
                G = U(78),
                $ = U(7100),
                v = M.apply(G()),
                p = function (T, x) {
                    return v(Object, arguments);
                };
            O(p, { getPolyfill: G, implementation: q, shim: $ }), (se.exports = p);
        },
        78: (se, ae, U) => {
            'use strict';
            var O = U(8447);
            se.exports = function () {
                return !Object.assign ||
                    (function () {
                        if (!Object.assign) return !1;
                        for (var G = 'abcdefghijklmnopqrst', $ = G.split(''), v = {}, p = 0; p < $.length; ++p)
                            v[$[p]] = $[p];
                        var _ = Object.assign({}, v),
                            T = '';
                        for (var x in _) T += x;
                        return G !== T;
                    })() ||
                    (function () {
                        if (!Object.assign || !Object.preventExtensions) return !1;
                        var G = Object.preventExtensions({ 1: 2 });
                        try {
                            Object.assign(G, 'xy');
                        } catch {
                            return 'y' === G[1];
                        }
                        return !1;
                    })()
                    ? O
                    : Object.assign;
            };
        },
        7100: (se, ae, U) => {
            'use strict';
            var O = U(592),
                M = U(78);
            se.exports = function () {
                var G = M();
                return (
                    O(
                        Object,
                        { assign: G },
                        {
                            assign: function () {
                                return Object.assign !== G;
                            },
                        },
                    ),
                    G
                );
            };
        },
        6998: se => {
            'use strict';
            se.exports = [
                'Float32Array',
                'Float64Array',
                'Int8Array',
                'Int16Array',
                'Int32Array',
                'Uint8Array',
                'Uint8ClampedArray',
                'Uint16Array',
                'Uint32Array',
                'BigInt64Array',
                'BigUint64Array',
            ];
        },
        1143: (se, ae, U) => {
            'use strict';
            var O = U(6330),
                M = U(8519),
                q = Object;
            se.exports = O(
                function () {
                    if (null == this || this !== q(this))
                        throw new M('RegExp.prototype.flags getter called on non-object');
                    var $ = '';
                    return (
                        this.hasIndices && ($ += 'd'),
                        this.global && ($ += 'g'),
                        this.ignoreCase && ($ += 'i'),
                        this.multiline && ($ += 'm'),
                        this.dotAll && ($ += 's'),
                        this.unicode && ($ += 'u'),
                        this.unicodeSets && ($ += 'v'),
                        this.sticky && ($ += 'y'),
                        $
                    );
                },
                'get flags',
                !0,
            );
        },
        7057: (se, ae, U) => {
            'use strict';
            var O = U(592),
                M = U(6283),
                q = U(1143),
                G = U(4198),
                $ = U(8436),
                v = M(G());
            O(v, { getPolyfill: G, implementation: q, shim: $ }), (se.exports = v);
        },
        4198: (se, ae, U) => {
            'use strict';
            var O = U(1143),
                M = U(592).supportsDescriptors,
                q = Object.getOwnPropertyDescriptor;
            se.exports = function () {
                if (M && 'gim' === /a/gim.flags) {
                    var $ = q(RegExp.prototype, 'flags');
                    if (
                        $ &&
                        'function' == typeof $.get &&
                        'boolean' == typeof RegExp.prototype.dotAll &&
                        'boolean' == typeof RegExp.prototype.hasIndices
                    ) {
                        var v = '',
                            p = {};
                        if (
                            (Object.defineProperty(p, 'hasIndices', {
                                get: function () {
                                    v += 'd';
                                },
                            }),
                            Object.defineProperty(p, 'sticky', {
                                get: function () {
                                    v += 'y';
                                },
                            }),
                            'dy' === v)
                        )
                            return $.get;
                    }
                }
                return O;
            };
        },
        8436: (se, ae, U) => {
            'use strict';
            var O = U(592).supportsDescriptors,
                M = U(4198),
                q = Object.getOwnPropertyDescriptor,
                G = Object.defineProperty,
                $ = TypeError,
                v = Object.getPrototypeOf,
                p = /a/;
            se.exports = function () {
                if (!O || !v)
                    throw new $(
                        'RegExp.prototype.flags requires a true ES5 environment that supports property descriptors',
                    );
                var T = M(),
                    x = v(p),
                    F = q(x, 'flags');
                return (!F || F.get !== T) && G(x, 'flags', { configurable: !0, enumerable: !1, get: T }), T;
            };
        },
        5557: (se, ae, U) => {
            'use strict';
            var O = U(2521),
                M = U(1197),
                q = U(6652)(),
                G = U(9263),
                $ = U(8519),
                v = O('%Math.floor%');
            se.exports = function (_, T) {
                if ('function' != typeof _) throw new $('`fn` is not a function');
                if ('number' != typeof T || T < 0 || T > 4294967295 || v(T) !== T)
                    throw new $('`length` must be a positive 32-bit integer');
                var x = arguments.length > 2 && !!arguments[2],
                    F = !0,
                    C = !0;
                if ('length' in _ && G) {
                    var k = G(_, 'length');
                    k && !k.configurable && (F = !1), k && !k.writable && (C = !1);
                }
                return (F || C || !x) && (q ? M(_, 'length', T, !0, !0) : M(_, 'length', T)), _;
            };
        },
        6330: (se, ae, U) => {
            'use strict';
            var O = U(1197),
                M = U(6652)(),
                q = U(5370).functionsHaveConfigurableNames(),
                G = U(8519);
            se.exports = function (v, p) {
                if ('function' != typeof v) throw new G('`fn` is not a function');
                return (
                    (!(arguments.length > 2 && arguments[2]) || q) && (M ? O(v, 'name', p, !0, !0) : O(v, 'name', p)), v
                );
            };
        },
        5492: (se, ae, U) => {
            'use strict';
            var O = U(2521),
                M = U(3463),
                q = U(3687),
                G = U(8519),
                $ = O('%WeakMap%', !0),
                v = O('%Map%', !0),
                p = M('WeakMap.prototype.get', !0),
                _ = M('WeakMap.prototype.set', !0),
                T = M('WeakMap.prototype.has', !0),
                x = M('Map.prototype.get', !0),
                F = M('Map.prototype.set', !0),
                C = M('Map.prototype.has', !0),
                k = function (K, Q) {
                    for (var ge, ce = K; null !== (ge = ce.next); ce = ge)
                        if (ge.key === Q) return (ce.next = ge.next), (ge.next = K.next), (K.next = ge), ge;
                };
            se.exports = function () {
                var Q,
                    ce,
                    ge,
                    De = {
                        assert: function (xe) {
                            if (!De.has(xe)) throw new G('Side channel does not contain ' + q(xe));
                        },
                        get: function (xe) {
                            if ($ && xe && ('object' == typeof xe || 'function' == typeof xe)) {
                                if (Q) return p(Q, xe);
                            } else if (v) {
                                if (ce) return x(ce, xe);
                            } else if (ge)
                                return (function (K, Q) {
                                    var ce = k(K, Q);
                                    return ce && ce.value;
                                })(ge, xe);
                        },
                        has: function (xe) {
                            if ($ && xe && ('object' == typeof xe || 'function' == typeof xe)) {
                                if (Q) return T(Q, xe);
                            } else if (v) {
                                if (ce) return C(ce, xe);
                            } else if (ge)
                                return (function (K, Q) {
                                    return !!k(K, Q);
                                })(ge, xe);
                            return !1;
                        },
                        set: function (xe, Ve) {
                            $ && xe && ('object' == typeof xe || 'function' == typeof xe)
                                ? (Q || (Q = new $()), _(Q, xe, Ve))
                                : v
                                ? (ce || (ce = new v()), F(ce, xe, Ve))
                                : (ge || (ge = { key: {}, next: null }),
                                  (function (K, Q, ce) {
                                      var ge = k(K, Q);
                                      ge ? (ge.value = ce) : (K.next = { key: Q, next: K.next, value: ce });
                                  })(ge, xe, Ve));
                        },
                    };
                return De;
            };
        },
        5712: (se, ae, U) => {
            'use strict';
            var O = U(2179),
                M = SyntaxError,
                q = 'object' == typeof StopIteration ? StopIteration : null;
            se.exports = function ($) {
                if (!q) throw new M('this environment lacks StopIteration');
                O.set($, '[[Done]]', !1);
                var v = {
                    next: function () {
                        var _ = O.get(this, '[[Iterator]]'),
                            T = O.get(_, '[[Done]]');
                        try {
                            return { done: T, value: T ? void 0 : _.next() };
                        } catch (x) {
                            if ((O.set(_, '[[Done]]', !0), x !== q)) throw x;
                            return { done: !0, value: void 0 };
                        }
                    },
                };
                return O.set(v, '[[Iterator]]', $), v;
            };
        },
        561: function (se, ae, U) {
            'use strict';
            var O =
                (this && this.__importDefault) ||
                function (G) {
                    return G && G.__esModule ? G : { default: G };
                };
            Object.defineProperty(ae, '__esModule', { value: !0 }),
                (ae.default = function q(G, $) {
                    var v = null;
                    if (!G || 'string' != typeof G) return v;
                    var p = (0, M.default)(G),
                        _ = 'function' == typeof $;
                    return (
                        p.forEach(function (T) {
                            if ('declaration' === T.type) {
                                var x = T.property,
                                    F = T.value;
                                _ ? $(x, F, T) : F && ((v = v || {})[x] = F);
                            }
                        }),
                        v
                    );
                });
            var M = O(U(4584));
        },
        6959: (se, ae, U) => {
            'use strict';
            var O = U(6837),
                M = U(8979),
                q = U(6484),
                G = U(3016),
                $ = U(7671);
            se.exports = function (p) {
                return null == p || ('object' != typeof p && 'function' != typeof p)
                    ? null
                    : O(p)
                    ? 'String'
                    : M(p)
                    ? 'Number'
                    : q(p)
                    ? 'Boolean'
                    : G(p)
                    ? 'Symbol'
                    : $(p)
                    ? 'BigInt'
                    : void 0;
            };
        },
        5757: (se, ae, U) => {
            'use strict';
            var O = U(7598),
                M = U(9116),
                q = U(9462),
                G = U(5028);
            se.exports = function (v) {
                if (v && 'object' == typeof v) {
                    if (O(v)) return 'Map';
                    if (M(v)) return 'Set';
                    if (q(v)) return 'WeakMap';
                    if (G(v)) return 'WeakSet';
                }
                return !1;
            };
        },
        6547: (se, ae, U) => {
            'use strict';
            var O = U(6062),
                M = U(9819),
                q = U(6283),
                G = U(3463),
                $ = U(9263),
                v = G('Object.prototype.toString'),
                p = U(5328)(),
                _ = typeof globalThis > 'u' ? global : globalThis,
                T = M(),
                x = G('String.prototype.slice'),
                F = Object.getPrototypeOf,
                C =
                    G('Array.prototype.indexOf', !0) ||
                    function (K, Q) {
                        for (var ce = 0; ce < K.length; ce += 1) if (K[ce] === Q) return ce;
                        return -1;
                    },
                k = { __proto__: null };
            O(
                T,
                p && $ && F
                    ? function (N) {
                          var K = new _[N]();
                          if (Symbol.toStringTag in K) {
                              var Q = F(K),
                                  ce = $(Q, Symbol.toStringTag);
                              if (!ce) {
                                  var ge = F(Q);
                                  ce = $(ge, Symbol.toStringTag);
                              }
                              k['$' + N] = q(ce.get);
                          }
                      }
                    : function (N) {
                          var K = new _[N](),
                              Q = K.slice || K.set;
                          Q && (k['$' + N] = q(Q));
                      },
            ),
                (se.exports = function (K) {
                    if (!K || 'object' != typeof K) return !1;
                    if (!p) {
                        var Q = x(v(K), 8, -1);
                        return C(T, Q) > -1
                            ? Q
                            : 'Object' === Q &&
                                  (function (K) {
                                      var Q = !1;
                                      return (
                                          O(k, function (ce, ge) {
                                              if (!Q)
                                                  try {
                                                      ce(K), (Q = x(ge, 1));
                                                  } catch {}
                                          }),
                                          Q
                                      );
                                  })(K);
                    }
                    return $
                        ? (function (K) {
                              var Q = !1;
                              return (
                                  O(k, function (ce, ge) {
                                      if (!Q)
                                          try {
                                              '$' + ce(K) === ge && (Q = x(ge, 1));
                                          } catch {}
                                  }),
                                  Q
                              );
                          })(K)
                        : null;
                });
        },
        4527: se => {
            se.exports = { STU3: 'partial', R4: 'WIP', R4B: 'WIP', R5: 'WIP' };
        },
        2634: () => {},
        9819: (se, ae, U) => {
            'use strict';
            var O = U(6998),
                M = typeof globalThis > 'u' ? global : globalThis;
            se.exports = function () {
                for (var G = [], $ = 0; $ < O.length; $++) 'function' == typeof M[O[$]] && (G[G.length] = O[$]);
                return G;
            };
        },
        158: (se, ae, U) => {
            'use strict';
            var O = U(8344),
                M = U(5712);
            if (U(1459)() || U(6497)()) {
                var q = Symbol.iterator;
                se.exports = function (Ne) {
                    return null != Ne && typeof Ne[q] < 'u' ? Ne[q]() : O(Ne) ? Array.prototype[q].call(Ne) : void 0;
                };
            } else {
                var G = U(7638),
                    $ = U(6837),
                    v = U(2521),
                    p = v('%Map%', !0),
                    _ = v('%Set%', !0),
                    T = U(3463),
                    x = T('Array.prototype.push'),
                    F = T('String.prototype.charCodeAt'),
                    C = T('String.prototype.slice'),
                    R = function (Ne) {
                        var at = 0;
                        return {
                            next: function () {
                                var Re,
                                    ht = at >= Ne.length;
                                return ht || ((Re = Ne[at]), (at += 1)), { done: ht, value: Re };
                            },
                        };
                    },
                    j = function (Ne, at) {
                        if (G(Ne) || O(Ne)) return R(Ne);
                        if ($(Ne)) {
                            var Et = 0;
                            return {
                                next: function () {
                                    var Re = (function (Ne, at) {
                                            if (at + 1 >= Ne.length) return at + 1;
                                            var ht = F(Ne, at);
                                            if (ht < 55296 || ht > 56319) return at + 1;
                                            var Re = F(Ne, at + 1);
                                            return Re < 56320 || Re > 57343 ? at + 1 : at + 2;
                                        })(Ne, Et),
                                        Pt = C(Ne, Et, Re);
                                    return (Et = Re), { done: Re > Ne.length, value: Pt };
                                },
                            };
                        }
                        return at && typeof Ne['_es6-shim iterator_'] < 'u' ? Ne['_es6-shim iterator_']() : void 0;
                    };
                if (p || _) {
                    var N = U(7598),
                        K = U(9116),
                        Q = T('Map.prototype.forEach', !0),
                        ce = T('Set.prototype.forEach', !0);
                    if (typeof process > 'u' || !process.versions || !process.versions.node)
                        var ge = T('Map.prototype.iterator', !0),
                            De = T('Set.prototype.iterator', !0);
                    var xe = T('Map.prototype.@@iterator', !0) || T('Map.prototype._es6-shim iterator_', !0),
                        Ve = T('Set.prototype.@@iterator', !0) || T('Set.prototype._es6-shim iterator_', !0);
                    se.exports = function (Ne) {
                        return (
                            (function (Ne) {
                                if (N(Ne)) {
                                    if (ge) return M(ge(Ne));
                                    if (xe) return xe(Ne);
                                    if (Q) {
                                        var at = [];
                                        return (
                                            Q(Ne, function (ht, Re) {
                                                x(at, [Re, ht]);
                                            }),
                                            R(at)
                                        );
                                    }
                                }
                                if (K(Ne)) {
                                    if (De) return M(De(Ne));
                                    if (Ve) return Ve(Ne);
                                    if (ce) {
                                        var Et = [];
                                        return (
                                            ce(Ne, function (ht) {
                                                x(Et, ht);
                                            }),
                                            R(Et)
                                        );
                                    }
                                }
                            })(Ne) || j(Ne)
                        );
                    };
                } else
                    se.exports = function (Ne) {
                        if (null != Ne) return j(Ne, !0);
                    };
            }
        },
        3380: se => {
            'use strict';
            se.exports = JSON.parse(
                '{"license":"The following data (prefixes and units) was generated by the UCUM LHC code from the UCUM data and selected LOINC combinations of UCUM units.  The license for the UCUM LHC code (demo and library code as well as the combined units) is located at https://github.com/lhncbc/ucum-lhc/blob/LICENSE.md.","prefixes":{"config":["code_","ciCode_","name_","printSymbol_","value_","exp_"],"data":[["E","EX","exa","E",1000000000000000000,"18"],["G","GA","giga","G",1000000000,"9"],["Gi","GIB","gibi","Gi",1073741824,null],["Ki","KIB","kibi","Ki",1024,null],["M","MA","mega","M",1000000,"6"],["Mi","MIB","mebi","Mi",1048576,null],["P","PT","peta","P",1000000000000000,"15"],["T","TR","tera","T",1000000000000,"12"],["Ti","TIB","tebi","Ti",1099511627776,null],["Y","YA","yotta","Y",1e+24,"24"],["Z","ZA","zetta","Z",1e+21,"21"],["a","A","atto","a",1e-18,"-18"],["c","C","centi","c",0.01,"-2"],["d","D","deci","d",0.1,"-1"],["da","DA","deka","da",10,"1"],["f","F","femto","f",1e-15,"-15"],["h","H","hecto","h",100,"2"],["k","K","kilo","k",1000,"3"],["m","M","milli","m",0.001,"-3"],["n","N","nano","n",1e-9,"-9"],["p","P","pico","p",1e-12,"-12"],["u","U","micro","\u03bc",0.000001,"-6"],["y","YO","yocto","y",1e-24,"-24"],["z","ZO","zepto","z",1e-21,"-21"]]},"units":{"config":["isBase_","name_","csCode_","ciCode_","property_","magnitude_",["dim_","dimVec_"],"printSymbol_","class_","isMetric_","variable_","cnv_","cnvPfx_","isSpecial_","isArbitrary_","moleExp_","synonyms_","source_","loincProperty_","category_","guidance_","csUnitString_","ciUnitString_","baseFactorStr_","baseFactor_","defError_"],"data":[[true,"meter","m","M","length",1,[1,0,0,0,0,0,0],"m",null,false,"L",null,1,false,false,0,"meters; metres; distance","UCUM","Len","Clinical","unit of length = 1.09361 yards",null,null,null,null,false],[true,"second - time","s","S","time",1,[0,1,0,0,0,0,0],"s",null,false,"T",null,1,false,false,0,"seconds","UCUM","Time","Clinical","",null,null,null,null,false],[true,"gram","g","G","mass",1,[0,0,1,0,0,0,0],"g",null,false,"M",null,1,false,false,0,"grams; gm","UCUM","Mass","Clinical","",null,null,null,null,false],[true,"radian","rad","RAD","plane angle",1,[0,0,0,1,0,0,0],"rad",null,false,"A",null,1,false,false,0,"radians","UCUM","Angle","Clinical","unit of angular measure where 1 radian = 1/2\u03c0 turn =  57.296 degrees. ",null,null,null,null,false],[true,"degree Kelvin","K","K","temperature",1,[0,0,0,0,1,0,0],"K",null,false,"C",null,1,false,false,0,"Kelvin; degrees","UCUM","Temp","Clinical","absolute, thermodynamic temperature scale ",null,null,null,null,false],[true,"coulomb","C","C","electric charge",1,[0,0,0,0,0,1,0],"C",null,false,"Q",null,1,false,false,0,"coulombs","UCUM","","Clinical","defined as amount of 1 electron charge = 6.2415093\xd710^18 e, and equivalent to 1 Ampere-second",null,null,null,null,false],[true,"candela","cd","CD","luminous intensity",1,[0,0,0,0,0,0,1],"cd",null,false,"F",null,1,false,false,0,"candelas","UCUM","","Clinical","SI base unit of luminous intensity",null,null,null,null,false],[false,"the number ten for arbitrary powers","10*","10*","number",10,[0,0,0,0,0,0,0],"10","dimless",false,null,null,1,false,false,0,"10^; 10 to the arbitrary powers","UCUM","Num","Clinical","10* by itself is the same as 10, but users can add digits after the *. For example, 10*3 = 1000.","1","1","10",10,false],[false,"the number ten for arbitrary powers","10^","10^","number",10,[0,0,0,0,0,0,0],"10","dimless",false,null,null,1,false,false,0,"10*; 10 to the arbitrary power","UCUM","Num","Clinical","10* by itself is the same as 10, but users can add digits after the *. For example, 10*3 = 1000.","1","1","10",10,false],[false,"the number pi","[pi]","[PI]","number",3.141592653589793,[0,0,0,0,0,0,0],"\u03c0","dimless",false,null,null,1,false,false,0,"\u03c0","UCUM","","Constant","a mathematical constant; the ratio of a circle\'s circumference to its diameter \u2248 3.14159","1","1","3.1415926535897932384626433832795028841971693993751058209749445923",3.141592653589793,false],[false,"","%","%","fraction",0.01,[0,0,0,0,0,0,0],"%","dimless",false,null,null,1,false,false,0,"percents","UCUM","FR; NFR; MFR; CFR; SFR Rto; etc. ","Clinical","","10*-2","10*-2","1",1,false],[false,"parts per thousand","[ppth]","[PPTH]","fraction",0.001,[0,0,0,0,0,0,0],"ppth","dimless",false,null,null,1,false,false,0,"ppth; 10^-3","UCUM","MCnc; MCnt","Clinical","[ppth] is often used in solution concentrations as 1 g/L or 1 g/kg.\\n\\nCan be ambigous and would be better if the metric units was used directly. ","10*-3","10*-3","1",1,false],[false,"parts per million","[ppm]","[PPM]","fraction",0.000001,[0,0,0,0,0,0,0],"ppm","dimless",false,null,null,1,false,false,0,"ppm; 10^-6","UCUM","MCnt; MCnc; SFr","Clinical","[ppm] is often used in solution concentrations as 1 mg/L  or 1 mg/kg. Also used to express mole fractions as 1 mmol/mol.\\n\\n[ppm] is also used in nuclear magnetic resonance (NMR) to represent chemical shift - the difference of a measured frequency in parts per million from the reference frequency.\\n\\nCan be ambigous and would be better if the metric units was used directly. ","10*-6","10*-6","1",1,false],[false,"parts per billion","[ppb]","[PPB]","fraction",1e-9,[0,0,0,0,0,0,0],"ppb","dimless",false,null,null,1,false,false,0,"ppb; 10^-9","UCUM","MCnt; MCnc; SFr","Clinical","[ppb] is often used in solution concentrations as 1 ug/L  or 1 ug/kg. Also used to express mole fractions as 1 umol/mol.\\n\\nCan be ambigous and would be better if the metric units was used directly. ","10*-9","10*-9","1",1,false],[false,"parts per trillion","[pptr]","[PPTR]","fraction",1e-12,[0,0,0,0,0,0,0],"pptr","dimless",false,null,null,1,false,false,0,"pptr; 10^-12","UCUM","MCnt; MCnc; SFr","Clinical","[pptr] is often used in solution concentrations as 1 ng/L or 1 ng/kg. Also used to express mole fractions as 1 nmol/mol.\\n\\nCan be ambigous and would be better if the metric units was used directly. ","10*-12","10*-12","1",1,false],[false,"mole","mol","MOL","amount of substance",6.0221367e+23,[0,0,0,0,0,0,0],"mol","si",true,null,null,1,false,false,1,"moles","UCUM","Sub","Clinical","Measure the number of molecules ","10*23","10*23","6.0221367",6.0221367,false],[false,"steradian - solid angle","sr","SR","solid angle",1,[0,0,0,2,0,0,0],"sr","si",true,null,null,1,false,false,0,"square radian; rad2; rad^2","UCUM","Angle","Clinical","unit of solid angle in three-dimensional geometry analagous to radian; used in photometry which measures the perceived brightness of object by human eye (e.g. radiant intensity = watt/steradian)","rad2","RAD2","1",1,false],[false,"hertz","Hz","HZ","frequency",1,[0,-1,0,0,0,0,0],"Hz","si",true,null,null,1,false,false,0,"Herz; frequency; frequencies","UCUM","Freq; Num","Clinical","equal to one cycle per second","s-1","S-1","1",1,false],[false,"newton","N","N","force",1000,[1,-2,1,0,0,0,0],"N","si",true,null,null,1,false,false,0,"Newtons","UCUM","Force","Clinical","unit of force with base units kg.m/s2","kg.m/s2","KG.M/S2","1",1,false],[false,"pascal","Pa","PAL","pressure",1000,[-1,-2,1,0,0,0,0],"Pa","si",true,null,null,1,false,false,0,"pascals","UCUM","Pres","Clinical","standard unit of pressure equal to 1 newton per square meter (N/m2)","N/m2","N/M2","1",1,false],[false,"joule","J","J","energy",1000,[2,-2,1,0,0,0,0],"J","si",true,null,null,1,false,false,0,"joules","UCUM","Enrg","Clinical","unit of energy defined as the work required to move an object 1 m with a force of 1 N (N.m) or an electric charge of 1 C through 1 V (C.V), or to produce 1 W for 1 s (W.s) ","N.m","N.M","1",1,false],[false,"watt","W","W","power",1000,[2,-3,1,0,0,0,0],"W","si",true,null,null,1,false,false,0,"watts","UCUM","EngRat","Clinical","unit of power equal to 1 Joule per second (J/s) =  kg\u22c5m2\u22c5s\u22123","J/s","J/S","1",1,false],[false,"Ampere","A","A","electric current",1,[0,-1,0,0,0,1,0],"A","si",true,null,null,1,false,false,0,"Amperes","UCUM","ElpotRat","Clinical","unit of electric current equal to flow rate of electrons equal to 6.2415\xd710^18 elementary charges moving past a boundary in one second or 1 Coulomb/second","C/s","C/S","1",1,false],[false,"volt","V","V","electric potential",1000,[2,-2,1,0,0,-1,0],"V","si",true,null,null,1,false,false,0,"volts","UCUM","Elpot","Clinical","unit of electric potential (voltage) = 1 Joule per Coulomb (J/C)","J/C","J/C","1",1,false],[false,"farad","F","F","electric capacitance",0.001,[-2,2,-1,0,0,2,0],"F","si",true,null,null,1,false,false,0,"farads; electric capacitance","UCUM","","Clinical","CGS unit of electric capacitance with base units C/V (Coulomb per Volt)","C/V","C/V","1",1,false],[false,"ohm","Ohm","OHM","electric resistance",1000,[2,-1,1,0,0,-2,0],"\u03a9","si",true,null,null,1,false,false,0,"\u03a9; resistance; ohms","UCUM","","Clinical","unit of electrical resistance with units of Volt per Ampere","V/A","V/A","1",1,false],[false,"siemens","S","SIE","electric conductance",0.001,[-2,1,-1,0,0,2,0],"S","si",true,null,null,1,false,false,0,"Reciprocal ohm; mho; \u03a9\u22121; conductance","UCUM","","Clinical","unit of electric conductance (the inverse of electrical resistance) equal to ohm^-1","Ohm-1","OHM-1","1",1,false],[false,"weber","Wb","WB","magnetic flux",1000,[2,-1,1,0,0,-1,0],"Wb","si",true,null,null,1,false,false,0,"magnetic flux; webers","UCUM","","Clinical","unit of magnetic flux equal to Volt second","V.s","V.S","1",1,false],[false,"degree Celsius","Cel","CEL","temperature",1,[0,0,0,0,1,0,0],"\xb0C","si",true,null,"Cel",1,true,false,0,"\xb0C; degrees","UCUM","Temp","Clinical","","K",null,null,1,false],[false,"tesla","T","T","magnetic flux density",1000,[0,-1,1,0,0,-1,0],"T","si",true,null,null,1,false,false,0,"Teslas; magnetic field","UCUM","","Clinical","SI unit of magnetic field strength for magnetic field B equal to 1 Weber/square meter =  1 kg/(s2*A)","Wb/m2","WB/M2","1",1,false],[false,"henry","H","H","inductance",1000,[2,0,1,0,0,-2,0],"H","si",true,null,null,1,false,false,0,"henries; inductance","UCUM","","Clinical","unit of electrical inductance; usually expressed in millihenrys (mH) or microhenrys (uH).","Wb/A","WB/A","1",1,false],[false,"lumen","lm","LM","luminous flux",1,[0,0,0,2,0,0,1],"lm","si",true,null,null,1,false,false,0,"luminous flux; lumens","UCUM","","Clinical","unit of luminous flux defined as 1 lm = 1 cd\u22c5sr (candela times sphere)","cd.sr","CD.SR","1",1,false],[false,"lux","lx","LX","illuminance",1,[-2,0,0,2,0,0,1],"lx","si",true,null,null,1,false,false,0,"illuminance; luxes","UCUM","","Clinical","unit of illuminance equal to one lumen per square meter. ","lm/m2","LM/M2","1",1,false],[false,"becquerel","Bq","BQ","radioactivity",1,[0,-1,0,0,0,0,0],"Bq","si",true,null,null,1,false,false,0,"activity; radiation; becquerels","UCUM","","Clinical","measure of the atomic radiation rate with units s^-1","s-1","S-1","1",1,false],[false,"gray","Gy","GY","energy dose",1,[2,-2,0,0,0,0,0],"Gy","si",true,null,null,1,false,false,0,"absorbed doses; ionizing radiation doses; kerma; grays","UCUM","EngCnt","Clinical","unit of ionizing radiation dose with base units of 1 joule of radiation energy per kilogram of matter","J/kg","J/KG","1",1,false],[false,"sievert","Sv","SV","dose equivalent",1,[2,-2,0,0,0,0,0],"Sv","si",true,null,null,1,false,false,0,"sieverts; radiation dose quantities; equivalent doses; effective dose; operational dose; committed dose","UCUM","","Clinical","SI unit for radiation dose equivalent equal to 1 Joule/kilogram.","J/kg","J/KG","1",1,false],[false,"degree - plane angle","deg","DEG","plane angle",0.017453292519943295,[0,0,0,1,0,0,0],"\xb0","iso1000",false,null,null,1,false,false,0,"\xb0; degree of arc; arc degree; arcdegree; angle","UCUM","Angle","Clinical","one degree is equivalent to \u03c0/180 radians.","[pi].rad/360","[PI].RAD/360","2",2,false],[false,"gon","gon","GON","plane angle",0.015707963267948967,[0,0,0,1,0,0,0],"\u25a1<sup>g</sup>","iso1000",false,null,null,1,false,false,0,"gon (grade); gons","UCUM","Angle","Nonclinical","unit of plane angle measurement equal to 1/400 circle","deg","DEG","0.9",0.9,false],[false,"arc minute","\'","\'","plane angle",0.0002908882086657216,[0,0,0,1,0,0,0],"\'","iso1000",false,null,null,1,false,false,0,"arcminutes; arcmin; arc minutes; arc mins","UCUM","Angle","Clinical","equal to 1/60 degree; used in optometry and opthamology (e.g. visual acuity tests)","deg/60","DEG/60","1",1,false],[false,"arc second","\'\'","\'\'","plane angle",0.00000484813681109536,[0,0,0,1,0,0,0],"\'\'","iso1000",false,null,null,1,false,false,0,"arcseconds; arcsecs","UCUM","Angle","Clinical","equal to 1/60 arcminute = 1/3600 degree; used in optometry and opthamology (e.g. visual acuity tests)","\'/60","\'/60","1",1,false],[false,"Liters","l","L","volume",0.001,[3,0,0,0,0,0,0],"l","iso1000",true,null,null,1,false,false,0,"cubic decimeters; decimeters cubed; decimetres; dm3; dm^3; litres; liters, LT ","UCUM","Vol","Clinical","Because lower case \\"l\\" can be read as the number \\"1\\", though this is a valid UCUM units. UCUM strongly reccomends using  \\"L\\"","dm3","DM3","1",1,false],[false,"Liters","L","L","volume",0.001,[3,0,0,0,0,0,0],"L","iso1000",true,null,null,1,false,false,0,"cubic decimeters; decimeters cubed; decimetres; dm3; dm^3; litres; liters, LT ","UCUM","Vol","Clinical","Because lower case \\"l\\" can be read as the number \\"1\\", though this is a valid UCUM units. UCUM strongly reccomends using  \\"L\\"","l",null,"1",1,false],[false,"are","ar","AR","area",100,[2,0,0,0,0,0,0],"a","iso1000",true,null,null,1,false,false,0,"100 m2; 100 m^2; 100 square meter; meters squared; metres","UCUM","Area","Clinical","metric base unit for area defined as 100 m^2","m2","M2","100",100,false],[false,"minute","min","MIN","time",60,[0,1,0,0,0,0,0],"min","iso1000",false,null,null,1,false,false,0,"minutes","UCUM","Time","Clinical","","s","S","60",60,false],[false,"hour","h","HR","time",3600,[0,1,0,0,0,0,0],"h","iso1000",false,null,null,1,false,false,0,"hours; hrs; age","UCUM","Time","Clinical","","min","MIN","60",60,false],[false,"day","d","D","time",86400,[0,1,0,0,0,0,0],"d","iso1000",false,null,null,1,false,false,0,"days; age; dy; 24 hours; 24 hrs","UCUM","Time","Clinical","","h","HR","24",24,false],[false,"tropical year","a_t","ANN_T","time",31556925.216,[0,1,0,0,0,0,0],"a<sub>t</sub>","iso1000",false,null,null,1,false,false,0,"solar years; a tropical; years","UCUM","Time","Clinical","has an average of 365.242181 days but is constantly changing.","d","D","365.24219",365.24219,false],[false,"mean Julian year","a_j","ANN_J","time",31557600,[0,1,0,0,0,0,0],"a<sub>j</sub>","iso1000",false,null,null,1,false,false,0,"mean Julian yr; a julian; years","UCUM","Time","Clinical","has an average of 365.25 days, and in everyday use, has been replaced by the Gregorian year. However, this unit is used in astronomy to calculate light year. ","d","D","365.25",365.25,false],[false,"mean Gregorian year","a_g","ANN_G","time",31556952,[0,1,0,0,0,0,0],"a<sub>g</sub>","iso1000",false,null,null,1,false,false,0,"mean Gregorian yr; a gregorian; years","UCUM","Time","Clinical","has an average of 365.2425 days and is the most internationally used civil calendar.","d","D","365.2425",365.2425,false],[false,"year","a","ANN","time",31557600,[0,1,0,0,0,0,0],"a","iso1000",false,null,null,1,false,false,0,"years; a; yr, yrs; annum","UCUM","Time","Clinical","","a_j","ANN_J","1",1,false],[false,"week","wk","WK","time",604800,[0,1,0,0,0,0,0],"wk","iso1000",false,null,null,1,false,false,0,"weeks; wks","UCUM","Time","Clinical","","d","D","7",7,false],[false,"synodal month","mo_s","MO_S","time",2551442.976,[0,1,0,0,0,0,0],"mo<sub>s</sub>","iso1000",false,null,null,1,false,false,0,"Moon; synodic month; lunar month; mo-s; mo s; months; moons","UCUM","Time","Nonclinical","has an average of 29.53 days per month, unit used in astronomy","d","D","29.53059",29.53059,false],[false,"mean Julian month","mo_j","MO_J","time",2629800,[0,1,0,0,0,0,0],"mo<sub>j</sub>","iso1000",false,null,null,1,false,false,0,"mo-julian; mo Julian; months","UCUM","Time","Clinical","has an average of 30.435 days per month","a_j/12","ANN_J/12","1",1,false],[false,"mean Gregorian month","mo_g","MO_G","time",2629746,[0,1,0,0,0,0,0],"mo<sub>g</sub>","iso1000",false,null,null,1,false,false,0,"months; month-gregorian; mo-gregorian","UCUM","Time","Clinical","has an average 30.436875 days per month and is from the most internationally used civil calendar.","a_g/12","ANN_G/12","1",1,false],[false,"month","mo","MO","time",2629800,[0,1,0,0,0,0,0],"mo","iso1000",false,null,null,1,false,false,0,"months; duration","UCUM","Time","Clinical","based on Julian calendar which has an average of 30.435 days per month (this unit is used in astronomy but not in everyday life - see mo_g)","mo_j","MO_J","1",1,false],[false,"metric ton","t","TNE","mass",1000000,[0,0,1,0,0,0,0],"t","iso1000",true,null,null,1,false,false,0,"tonnes; megagrams; tons","UCUM","Mass","Nonclinical","equal to 1000 kg used in the US (recognized by NIST as metric ton), and internationally (recognized as tonne)","kg","KG","1e3",1000,false],[false,"bar","bar","BAR","pressure",100000000,[-1,-2,1,0,0,0,0],"bar","iso1000",true,null,null,1,false,false,0,"bars","UCUM","Pres","Nonclinical","unit of pressure equal to 10^5 Pascals, primarily used by meteorologists and in weather forecasting","Pa","PAL","1e5",100000,false],[false,"unified atomic mass unit","u","AMU","mass",1.6605402e-24,[0,0,1,0,0,0,0],"u","iso1000",true,null,null,1,false,false,0,"unified atomic mass units; amu; Dalton; Da","UCUM","Mass","Clinical","the mass of 1/12 of an unbound Carbon-12 atom nuclide equal to 1.6606x10^-27 kg ","g","G","1.6605402e-24",1.6605402e-24,false],[false,"astronomic unit","AU","ASU","length",149597870691,[1,0,0,0,0,0,0],"AU","iso1000",false,null,null,1,false,false,0,"AU; units","UCUM","Len","Clinical","unit of length used in astronomy for measuring distance in Solar system","Mm","MAM","149597.870691",149597.870691,false],[false,"parsec","pc","PRS","length",30856780000000000,[1,0,0,0,0,0,0],"pc","iso1000",true,null,null,1,false,false,0,"parsecs","UCUM","Len","Clinical","unit of length equal to 3.26 light years, and used to measure large distances to objects outside our Solar System","m","M","3.085678e16",30856780000000000,false],[false,"velocity of light in a vacuum","[c]","[C]","velocity",299792458,[1,-1,0,0,0,0,0],"<i>c</i>","const",true,null,null,1,false,false,0,"speed of light","UCUM","Vel","Constant","equal to 299792458 m/s (approximately 3 x 10^8 m/s)","m/s","M/S","299792458",299792458,false],[false,"Planck constant","[h]","[H]","action",6.6260755e-31,[2,-1,1,0,0,0,0],"<i>h</i>","const",true,null,null,1,false,false,0,"Planck\'s constant","UCUM","","Constant","constant = 6.62607004 \xd7 10-34 m2.kg/s; defined as quantum of action","J.s","J.S","6.6260755e-34",6.6260755e-34,false],[false,"Boltzmann constant","[k]","[K]","(unclassified)",1.380658e-20,[2,-2,1,0,-1,0,0],"<i>k</i>","const",true,null,null,1,false,false,0,"k; kB","UCUM","","Constant","physical constant relating energy at the individual particle level with temperature = 1.38064852 \xd710^\u221223 J/K","J/K","J/K","1.380658e-23",1.380658e-23,false],[false,"permittivity of vacuum - electric","[eps_0]","[EPS_0]","electric permittivity",8.854187817000001e-15,[-3,2,-1,0,0,2,0],"<i>\u03b5<sub><r>0</r></sub></i>","const",true,null,null,1,false,false,0,"\u03b50; Electric Constant; vacuum permittivity; permittivity of free space ","UCUM","","Constant","approximately equal to 8.854\u2009\xd7 10^\u221212 F/m (farads per meter)","F/m","F/M","8.854187817e-12",8.854187817e-12,false],[false,"permeability of vacuum - magnetic","[mu_0]","[MU_0]","magnetic permeability",0.0012566370614359172,[1,0,1,0,0,-2,0],"<i>\u03bc<sub><r>0</r></sub></i>","const",true,null,null,1,false,false,0,"\u03bc0; vacuum permeability; permeability of free space; magnetic constant","UCUM","","Constant","equal to 4\u03c0\xd710^\u22127 N/A2 (Newtons per square ampere) \u2248 1.2566\xd710^\u22126 H/m (Henry per meter)","N/A2","4.[PI].10*-7.N/A2","1",0.0000012566370614359173,false],[false,"elementary charge","[e]","[E]","electric charge",1.60217733e-19,[0,0,0,0,0,1,0],"<i>e</i>","const",true,null,null,1,false,false,0,"e; q; electric charges","UCUM","","Constant","the magnitude of the electric charge carried by a single electron or proton \u2248 1.60217\xd710^-19 Coulombs","C","C","1.60217733e-19",1.60217733e-19,false],[false,"electronvolt","eV","EV","energy",1.60217733e-16,[2,-2,1,0,0,0,0],"eV","iso1000",true,null,null,1,false,false,0,"Electron Volts; electronvolts","UCUM","Eng","Clinical","unit of kinetic energy = 1 V * 1.602\xd710^\u221219 C = 1.6\xd710\u221219 Joules","[e].V","[E].V","1",1,false],[false,"electron mass","[m_e]","[M_E]","mass",9.1093897e-28,[0,0,1,0,0,0,0],"<i>m<sub><r>e</r></sub></i>","const",true,null,null,1,false,false,0,"electron rest mass; me","UCUM","Mass","Constant","approximately equal to 9.10938356 \xd7 10-31 kg; defined as the mass of a stationary electron","g","g","9.1093897e-28",9.1093897e-28,false],[false,"proton mass","[m_p]","[M_P]","mass",1.6726231e-24,[0,0,1,0,0,0,0],"<i>m<sub><r>p</r></sub></i>","const",true,null,null,1,false,false,0,"mp; masses","UCUM","Mass","Constant","approximately equal to 1.672622\xd710\u221227 kg","g","g","1.6726231e-24",1.6726231e-24,false],[false,"Newtonian constant of gravitation","[G]","[GC]","(unclassified)",6.67259e-14,[3,-2,-1,0,0,0,0],"<i>G</i>","const",true,null,null,1,false,false,0,"G; gravitational constant; Newton\'s constant","UCUM","","Constant","gravitational constant = 6.674\xd710\u221211 N\u22c5m2/kg2","m3.kg-1.s-2","M3.KG-1.S-2","6.67259e-11",6.67259e-11,false],[false,"standard acceleration of free fall","[g]","[G]","acceleration",9.80665,[1,-2,0,0,0,0,0],"<i>g<sub>n</sub></i>","const",true,null,null,1,false,false,0,"standard gravity; g; \u02610; \u0261n","UCUM","Accel","Constant","defined by standard = 9.80665 m/s2","m/s2","M/S2","980665e-5",9.80665,false],[false,"Torr","Torr","Torr","pressure",133322,[-1,-2,1,0,0,0,0],"Torr","const",false,null,null,1,false,false,0,"torrs","UCUM","Pres","Clinical","1 torr = 1 mmHg; unit used to measure blood pressure","Pa","PAL","133.322",133.322,false],[false,"standard atmosphere","atm","ATM","pressure",101325000,[-1,-2,1,0,0,0,0],"atm","const",false,null,null,1,false,false,0,"reference pressure; atmos; std atmosphere","UCUM","Pres","Clinical","defined as being precisely equal to 101,325 Pa","Pa","PAL","101325",101325,false],[false,"light-year","[ly]","[LY]","length",9460730472580800,[1,0,0,0,0,0,0],"l.y.","const",true,null,null,1,false,false,0,"light years; ly","UCUM","Len","Constant","unit of astronomal distance = 5.88\xd710^12 mi","[c].a_j","[C].ANN_J","1",1,false],[false,"gram-force","gf","GF","force",9.80665,[1,-2,1,0,0,0,0],"gf","const",true,null,null,1,false,false,0,"Newtons; gram forces","UCUM","Force","Clinical","May be specific to unit related to cardiac output","g.[g]","G.[G]","1",1,false],[false,"Kayser","Ky","KY","lineic number",100,[-1,0,0,0,0,0,0],"K","cgs",true,null,null,1,false,false,0,"wavenumbers; kaysers","UCUM","InvLen","Clinical","unit of wavelength equal to cm^-1","cm-1","CM-1","1",1,false],[false,"Gal","Gal","GL","acceleration",0.01,[1,-2,0,0,0,0,0],"Gal","cgs",true,null,null,1,false,false,0,"galileos; Gals","UCUM","Accel","Clinical","unit of acceleration used in gravimetry; equivalent to cm/s2 ","cm/s2","CM/S2","1",1,false],[false,"dyne","dyn","DYN","force",0.01,[1,-2,1,0,0,0,0],"dyn","cgs",true,null,null,1,false,false,0,"dynes","UCUM","Force","Clinical","unit of force equal to 10^-5 Newtons","g.cm/s2","G.CM/S2","1",1,false],[false,"erg","erg","ERG","energy",0.0001,[2,-2,1,0,0,0,0],"erg","cgs",true,null,null,1,false,false,0,"10^-7 Joules, 10-7 Joules; 100 nJ; 100 nanoJoules; 1 dyne cm; 1 g.cm2/s2","UCUM","Eng","Clinical","unit of energy = 1 dyne centimeter = 10^-7 Joules","dyn.cm","DYN.CM","1",1,false],[false,"Poise","P","P","dynamic viscosity",100.00000000000001,[-1,-1,1,0,0,0,0],"P","cgs",true,null,null,1,false,false,0,"dynamic viscosity; poises","UCUM","Visc","Clinical","unit of dynamic viscosity where 1 Poise = 1/10 Pascal second","dyn.s/cm2","DYN.S/CM2","1",1,false],[false,"Biot","Bi","BI","electric current",10,[0,-1,0,0,0,1,0],"Bi","cgs",true,null,null,1,false,false,0,"Bi; abamperes; abA","UCUM","ElpotRat","Clinical","equal to 10 amperes","A","A","10",10,false],[false,"Stokes","St","ST","kinematic viscosity",0.00009999999999999999,[2,-1,0,0,0,0,0],"St","cgs",true,null,null,1,false,false,0,"kinematic viscosity","UCUM","Visc","Clinical","unit of kimematic viscosity with units cm2/s","cm2/s","CM2/S","1",1,false],[false,"Maxwell","Mx","MX","flux of magnetic induction",0.00001,[2,-1,1,0,0,-1,0],"Mx","cgs",true,null,null,1,false,false,0,"magnetix flux; Maxwells","UCUM","","Clinical","unit of magnetic flux","Wb","WB","1e-8",1e-8,false],[false,"Gauss","G","GS","magnetic flux density",0.1,[0,-1,1,0,0,-1,0],"Gs","cgs",true,null,null,1,false,false,0,"magnetic fields; magnetic flux density; induction; B","UCUM","magnetic","Clinical","CGS unit of magnetic flux density, known as magnetic field B; defined as one maxwell unit per square centimeter (see Oersted for CGS unit for H field)","T","T","1e-4",0.0001,false],[false,"Oersted","Oe","OE","magnetic field intensity",79.57747154594767,[-1,-1,0,0,0,1,0],"Oe","cgs",true,null,null,1,false,false,0,"H magnetic B field; Oersteds","UCUM","","Clinical","CGS unit of the auxiliary magnetic field H defined as 1 dyne per unit pole = 1000/4\u03c0 amperes per meter (see Gauss for CGS unit for B field)","A/m","/[PI].A/M","250",79.57747154594767,false],[false,"Gilbert","Gb","GB","magnetic tension",0.7957747154594768,[0,-1,0,0,0,1,0],"Gb","cgs",true,null,null,1,false,false,0,"Gi; magnetomotive force; Gilberts","UCUM","","Clinical","unit of magnetomotive force (magnetic potential)","Oe.cm","OE.CM","1",1,false],[false,"stilb","sb","SB","lum. intensity density",10000,[-2,0,0,0,0,0,1],"sb","cgs",true,null,null,1,false,false,0,"stilbs","UCUM","","Obsolete","unit of luminance; equal to and replaced by unit candela per square centimeter (cd/cm2)","cd/cm2","CD/CM2","1",1,false],[false,"Lambert","Lmb","LMB","brightness",3183.098861837907,[-2,0,0,0,0,0,1],"L","cgs",true,null,null,1,false,false,0,"luminance; lamberts","UCUM","","Clinical","unit of luminance defined as 1 lambert = 1/ \u03c0 candela per square meter","cd/cm2/[pi]","CD/CM2/[PI]","1",1,false],[false,"phot","ph","PHT","illuminance",0.0001,[-2,0,0,2,0,0,1],"ph","cgs",true,null,null,1,false,false,0,"phots","UCUM","","Clinical","CGS photometric unit of illuminance, or luminous flux through an area equal to 10000 lumens per square meter = 10000 lux","lx","LX","1e-4",0.0001,false],[false,"Curie","Ci","CI","radioactivity",37000000000,[0,-1,0,0,0,0,0],"Ci","cgs",true,null,null,1,false,false,0,"curies","UCUM","","Obsolete","unit for measuring atomic disintegration rate; replaced by the Bequerel (Bq) unit","Bq","BQ","37e9",37000000000,false],[false,"Roentgen","R","ROE","ion dose",2.58e-7,[0,0,-1,0,0,1,0],"R","cgs",true,null,null,1,false,false,0,"r\xf6ntgen; Roentgens","UCUM","","Clinical","unit of exposure of X-rays and gamma rays in air; unit used primarily in the US but strongly discouraged by NIST","C/kg","C/KG","2.58e-4",0.000258,false],[false,"radiation absorbed dose","RAD","[RAD]","energy dose",0.01,[2,-2,0,0,0,0,0],"RAD","cgs",true,null,null,1,false,false,0,"doses","UCUM","","Clinical","unit of radiation absorbed dose used primarily in the US with base units 100 ergs per gram of material. Also see the SI unit Gray (Gy).","erg/g","ERG/G","100",100,false],[false,"radiation equivalent man","REM","[REM]","dose equivalent",0.01,[2,-2,0,0,0,0,0],"REM","cgs",true,null,null,1,false,false,0,"Roentgen Equivalent in Man; rems; dose equivalents","UCUM","","Clinical","unit of equivalent dose which measures the effect of radiation on humans equal to 0.01 sievert. Used primarily in the US. Also see SI unit Sievert (Sv)","RAD","[RAD]","1",1,false],[false,"inch","[in_i]","[IN_I]","length",0.025400000000000002,[1,0,0,0,0,0,0],"in","intcust",false,null,null,1,false,false,0,"inches; in; international inch; body height","UCUM","Len","Clinical","standard unit for inch in the US and internationally","cm","CM","254e-2",2.54,false],[false,"foot","[ft_i]","[FT_I]","length",0.3048,[1,0,0,0,0,0,0],"ft","intcust",false,null,null,1,false,false,0,"ft; fts; foot; international foot; feet; international feet; height","UCUM","Len","Clinical","unit used in the US and internationally","[in_i]","[IN_I]","12",12,false],[false,"yard","[yd_i]","[YD_I]","length",0.9144000000000001,[1,0,0,0,0,0,0],"yd","intcust",false,null,null,1,false,false,0,"international yards; yds; distance","UCUM","Len","Clinical","standard unit used in the US and internationally","[ft_i]","[FT_I]","3",3,false],[false,"mile","[mi_i]","[MI_I]","length",1609.344,[1,0,0,0,0,0,0],"mi","intcust",false,null,null,1,false,false,0,"international miles; mi I; statute mile","UCUM","Len","Clinical","standard unit used in the US and internationally","[ft_i]","[FT_I]","5280",5280,false],[false,"fathom","[fth_i]","[FTH_I]","depth of water",1.8288000000000002,[1,0,0,0,0,0,0],"fth","intcust",false,null,null,1,false,false,0,"international fathoms","UCUM","Len","Nonclinical","unit used in the US and internationally to measure depth of water; same length as the US fathom","[ft_i]","[FT_I]","6",6,false],[false,"nautical mile","[nmi_i]","[NMI_I]","length",1852,[1,0,0,0,0,0,0],"n.mi","intcust",false,null,null,1,false,false,0,"nautical mile; nautical miles; international nautical mile; international nautical miles; nm; n.m.; nmi","UCUM","Len","Nonclinical","standard unit used in the US and internationally","m","M","1852",1852,false],[false,"knot","[kn_i]","[KN_I]","velocity",0.5144444444444445,[1,-1,0,0,0,0,0],"knot","intcust",false,null,null,1,false,false,0,"kn; kt; international knots","UCUM","Vel","Nonclinical","defined as equal to one nautical mile (1.852 km) per hour","[nmi_i]/h","[NMI_I]/H","1",1,false],[false,"square inch","[sin_i]","[SIN_I]","area",0.0006451600000000001,[2,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"in2; in^2; inches squared; sq inch; inches squared; international","UCUM","Area","Clinical","standard unit used in the US and internationally","[in_i]2","[IN_I]2","1",1,false],[false,"square foot","[sft_i]","[SFT_I]","area",0.09290304,[2,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"ft2; ft^2; ft squared; sq ft; feet; international","UCUM","Area","Clinical","standard unit used in the US and internationally","[ft_i]2","[FT_I]2","1",1,false],[false,"square yard","[syd_i]","[SYD_I]","area",0.8361273600000002,[2,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"yd2; yd^2; sq. yds; yards squared; international","UCUM","Area","Clinical","standard unit used in the US and internationally","[yd_i]2","[YD_I]2","1",1,false],[false,"cubic inch","[cin_i]","[CIN_I]","volume",0.000016387064000000006,[3,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"in3; in^3; in*3; inches^3; inches*3; cu. in; cu in; cubic inches; inches cubed; cin","UCUM","Vol","Clinical","standard unit used in the US and internationally","[in_i]3","[IN_I]3","1",1,false],[false,"cubic foot","[cft_i]","[CFT_I]","volume",0.028316846592000004,[3,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"ft3; ft^3; ft*3; cu. ft; cubic feet; cubed; [ft_i]3; international","UCUM","Vol","Clinical","","[ft_i]3","[FT_I]3","1",1,false],[false,"cubic yard","[cyd_i]","[CYD_I]","volume",0.7645548579840002,[3,0,0,0,0,0,0],"cu.yd","intcust",false,null,null,1,false,false,0,"cubic yards; cubic yds; cu yards; CYs; yards^3; yd^3; yds^3; yd3; yds3","UCUM","Vol","Nonclinical","standard unit used in the US and internationally","[yd_i]3","[YD_I]3","1",1,false],[false,"board foot","[bf_i]","[BF_I]","volume",0.0023597372160000006,[3,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"BDFT; FBM; BF; board feet; international","UCUM","Vol","Nonclinical","unit of volume used to measure lumber","[in_i]3","[IN_I]3","144",144,false],[false,"cord","[cr_i]","[CR_I]","volume",3.6245563637760005,[3,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"crd I; international cords","UCUM","Vol","Nonclinical","unit of measure of dry volume used to measure firewood equal 128 ft3","[ft_i]3","[FT_I]3","128",128,false],[false,"mil","[mil_i]","[MIL_I]","length",0.000025400000000000004,[1,0,0,0,0,0,0],"mil","intcust",false,null,null,1,false,false,0,"thou, thousandth; mils; international","UCUM","Len","Clinical","equal to 0.001 international inch","[in_i]","[IN_I]","1e-3",0.001,false],[false,"circular mil","[cml_i]","[CML_I]","area",5.067074790974979e-10,[2,0,0,0,0,0,0],"circ.mil","intcust",false,null,null,1,false,false,0,"circular mils; cml I; international","UCUM","Area","Clinical","","[pi]/4.[mil_i]2","[PI]/4.[MIL_I]2","1",1,false],[false,"hand","[hd_i]","[HD_I]","height of horses",0.10160000000000001,[1,0,0,0,0,0,0],"hd","intcust",false,null,null,1,false,false,0,"hands; international","UCUM","Len","Nonclinical","used to measure horse height","[in_i]","[IN_I]","4",4,false],[false,"foot - US","[ft_us]","[FT_US]","length",0.3048006096012192,[1,0,0,0,0,0,0],"ft<sub>us</sub>","us-lengths",false,null,null,1,false,false,0,"US foot; foot US; us ft; ft us; height; visual distance; feet","UCUM","Len","Obsolete","Better to use [ft_i] which refers to the length used worldwide, including in the US;  [ft_us] may be confused with land survey units. ","m/3937","M/3937","1200",1200,false],[false,"yard - US","[yd_us]","[YD_US]","length",0.9144018288036575,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US yards; us yds; distance","UCUM","Len; Nrat","Obsolete","Better to use [yd_i] which refers to the length used worldwide, including in the US; [yd_us] refers to unit used in land surveys in the US","[ft_us]","[FT_US]","3",3,false],[false,"inch - US","[in_us]","[IN_US]","length",0.0254000508001016,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US inches; in us; us in; inch US","UCUM","Len","Obsolete","Better to use [in_i] which refers to the length used worldwide, including in the US","[ft_us]/12","[FT_US]/12","1",1,false],[false,"rod - US","[rd_us]","[RD_US]","length",5.029210058420117,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US rod; US rods; rd US; US rd","UCUM","Len","Obsolete","","[ft_us]","[FT_US]","16.5",16.5,false],[false,"Gunter\'s chain - US","[ch_us]","[CH_US]","length",20.116840233680467,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"surveyor\'s chain; Surveyor\'s chain USA; Gunter\u2019s measurement; surveyor\u2019s measurement; Gunter\'s Chain USA","UCUM","Len","Obsolete","historical unit used for land survey used only in the US","[rd_us]","[RD_US]","4",4,false],[false,"link for Gunter\'s chain - US","[lk_us]","[LK_US]","length",0.20116840233680466,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"Links for Gunter\'s Chain USA","UCUM","Len","Obsolete","","[ch_us]/100","[CH_US]/100","1",1,false],[false,"Ramden\'s chain - US","[rch_us]","[RCH_US]","length",30.480060960121918,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"Ramsden\'s chain; engineer\'s chains","UCUM","Len","Obsolete","distance measuring device used for\xa0land survey","[ft_us]","[FT_US]","100",100,false],[false,"link for Ramden\'s chain - US","[rlk_us]","[RLK_US]","length",0.3048006096012192,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"links for Ramsden\'s chain","UCUM","Len","Obsolete","","[rch_us]/100","[RCH_US]/100","1",1,false],[false,"fathom - US","[fth_us]","[FTH_US]","length",1.828803657607315,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US fathoms; fathom USA; fth us","UCUM","Len","Obsolete","same length as the international fathom - better to use international fathom ([fth_i])","[ft_us]","[FT_US]","6",6,false],[false,"furlong - US","[fur_us]","[FUR_US]","length",201.16840233680466,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US furlongs; fur us","UCUM","Len","Nonclinical","distance unit in horse racing","[rd_us]","[RD_US]","40",40,false],[false,"mile - US","[mi_us]","[MI_US]","length",1609.3472186944373,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"U.S. Survey Miles; US statute miles; survey mi; US mi; distance","UCUM","Len","Nonclinical","Better to use [mi_i] which refers to the length used worldwide, including in the US","[fur_us]","[FUR_US]","8",8,false],[false,"acre - US","[acr_us]","[ACR_US]","area",4046.872609874252,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"Acre USA Survey; Acre USA; survey acres","UCUM","Area","Nonclinical","an older unit based on pre 1959 US statute lengths that is still sometimes used in the US only for land survey purposes. ","[rd_us]2","[RD_US]2","160",160,false],[false,"square rod - US","[srd_us]","[SRD_US]","area",25.292953811714074,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"rod2; rod^2; sq. rod; rods squared","UCUM","Area","Nonclinical","Used only in the US to measure land area, based on US statute land survey length units","[rd_us]2","[RD_US]2","1",1,false],[false,"square mile - US","[smi_us]","[SMI_US]","area",2589998.470319521,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"mi2; mi^2; sq mi; miles squared","UCUM","Area","Nonclinical","historical unit used only in the US for land survey purposes (based on the US survey mile), not the internationally recognized [mi_i]","[mi_us]2","[MI_US]2","1",1,false],[false,"section","[sct]","[SCT]","area",2589998.470319521,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"sct; sections","UCUM","Area","Nonclinical","tract of land approximately equal to 1 mile square containing 640 acres","[mi_us]2","[MI_US]2","1",1,false],[false,"township","[twp]","[TWP]","area",93239944.93150276,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"twp; townships","UCUM","Area","Nonclinical","land measurement equal to 6 mile square","[sct]","[SCT]","36",36,false],[false,"mil - US","[mil_us]","[MIL_US]","length",0.0000254000508001016,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"thou, thousandth; mils","UCUM","Len","Obsolete","better to use [mil_i] which is based on the internationally recognized inch","[in_us]","[IN_US]","1e-3",0.001,false],[false,"inch - British","[in_br]","[IN_BR]","length",0.025399980000000003,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"imperial inches; imp in; br in; british inches","UCUM","Len","Obsolete","","cm","CM","2.539998",2.539998,false],[false,"foot - British","[ft_br]","[FT_BR]","length",0.30479976000000003,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British Foot; Imperial Foot; feet; imp fts; br fts","UCUM","Len","Obsolete","","[in_br]","[IN_BR]","12",12,false],[false,"rod - British","[rd_br]","[RD_BR]","length",5.02919604,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British rods; br rd","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","16.5",16.5,false],[false,"Gunter\'s chain - British","[ch_br]","[CH_BR]","length",20.11678416,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"Gunter\'s Chain British; Gunters Chain British; Surveyor\'s Chain British","UCUM","Len","Obsolete","historical unit used for land survey used only in Great Britain","[rd_br]","[RD_BR]","4",4,false],[false,"link for Gunter\'s chain - British","[lk_br]","[LK_BR]","length",0.2011678416,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"Links for Gunter\'s Chain British","UCUM","Len","Obsolete","","[ch_br]/100","[CH_BR]/100","1",1,false],[false,"fathom - British","[fth_br]","[FTH_BR]","length",1.82879856,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British fathoms; imperial fathoms; br fth; imp fth","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","6",6,false],[false,"pace - British","[pc_br]","[PC_BR]","length",0.7619994000000001,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British paces; br pc","UCUM","Len","Nonclinical","traditional unit of length equal to 152.4 centimeters, or 1.52 meter. ","[ft_br]","[FT_BR]","2.5",2.5,false],[false,"yard - British","[yd_br]","[YD_BR]","length",0.91439928,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British yards; Br yds; distance","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","3",3,false],[false,"mile - British","[mi_br]","[MI_BR]","length",1609.3427328000002,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"imperial miles; British miles; English statute miles; imp mi, br mi","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","5280",5280,false],[false,"nautical mile - British","[nmi_br]","[NMI_BR]","length",1853.1825408000002,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British nautical miles; Imperial nautical miles; Admiralty miles; n.m. br; imp nm","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","6080",6080,false],[false,"knot - British","[kn_br]","[KN_BR]","velocity",0.5147729280000001,[1,-1,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British knots; kn br; kt","UCUM","Vel","Obsolete","based on obsolete British nautical mile ","[nmi_br]/h","[NMI_BR]/H","1",1,false],[false,"acre","[acr_br]","[ACR_BR]","area",4046.850049400269,[2,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"Imperial acres; British; a; ac; ar; acr","UCUM","Area","Nonclinical","the standard unit for acre used in the US and internationally","[yd_br]2","[YD_BR]2","4840",4840,false],[false,"gallon - US","[gal_us]","[GAL_US]","fluid volume",0.0037854117840000014,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US gallons; US liquid gallon; gal us; Queen Anne\'s wine gallon","UCUM","Vol","Nonclinical","only gallon unit used in the US; [gal_us] is only used in some other countries in South American and Africa to measure gasoline volume","[in_i]3","[IN_I]3","231",231,false],[false,"barrel - US","[bbl_us]","[BBL_US]","fluid volume",0.15898729492800007,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"bbl","UCUM","Vol","Nonclinical","[bbl_us] is the standard unit for oil barrel, which is a unit only used in the US to measure the volume oil. ","[gal_us]","[GAL_US]","42",42,false],[false,"quart - US","[qt_us]","[QT_US]","fluid volume",0.0009463529460000004,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US quarts; us qts","UCUM","Vol","Clinical","Used only in the US","[gal_us]/4","[GAL_US]/4","1",1,false],[false,"pint - US","[pt_us]","[PT_US]","fluid volume",0.0004731764730000002,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US pints; pint US; liquid pint; pt us; us pt","UCUM","Vol","Clinical","Used only in the US","[qt_us]/2","[QT_US]/2","1",1,false],[false,"gill - US","[gil_us]","[GIL_US]","fluid volume",0.00011829411825000005,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US gills; gil us","UCUM","Vol","Nonclinical","only used in the context of alcohol volume in the US","[pt_us]/4","[PT_US]/4","1",1,false],[false,"fluid ounce - US","[foz_us]","[FOZ_US]","fluid volume",0.00002957352956250001,[3,0,0,0,0,0,0],"oz fl","us-volumes",false,null,null,1,false,false,0,"US fluid ounces; fl ozs; FO; fl. oz.; foz us","UCUM","Vol","Clinical","unit used only in the US","[gil_us]/4","[GIL_US]/4","1",1,false],[false,"fluid dram - US","[fdr_us]","[FDR_US]","fluid volume",0.0000036966911953125014,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US fluid drams; fdr us","UCUM","Vol","Nonclinical","equal to 1/8 US fluid ounce = 3.69 mL; used informally to mean small amount of liquor, especially Scotch whiskey","[foz_us]/8","[FOZ_US]/8","1",1,false],[false,"minim - US","[min_us]","[MIN_US]","fluid volume",6.161151992187503e-8,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"min US; US min; \u264f US","UCUM","Vol","Obsolete","","[fdr_us]/60","[FDR_US]/60","1",1,false],[false,"cord - US","[crd_us]","[CRD_US]","fluid volume",3.6245563637760005,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US cord; US cords; crd us; us crd","UCUM","Vol","Nonclinical","unit of measure of dry volume used to measure firewood equal 128 ft3 (the same as international cord [cr_i])","[ft_i]3","[FT_I]3","128",128,false],[false,"bushel - US","[bu_us]","[BU_US]","dry volume",0.035239070166880014,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US bushels; US bsh; US bu","UCUM","Vol","Obsolete","Historical unit of dry volume that is rarely used today","[in_i]3","[IN_I]3","2150.42",2150.42,false],[false,"gallon - historical","[gal_wi]","[GAL_WI]","dry volume",0.004404883770860002,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"Corn Gallon British; Dry Gallon US; Gallons Historical; Grain Gallon British; Winchester Corn Gallon; historical winchester gallons; wi gal","UCUM","Vol","Obsolete","historical unit of dry volume no longer used","[bu_us]/8","[BU_US]/8","1",1,false],[false,"peck - US","[pk_us]","[PK_US]","dry volume",0.008809767541720004,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US pecks; US pk","UCUM","Vol","Nonclinical","unit of dry volume rarely used today (can be used to measure volume of apples)","[bu_us]/4","[BU_US]/4","1",1,false],[false,"dry quart - US","[dqt_us]","[DQT_US]","dry volume",0.0011012209427150004,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"dry quarts; dry quart US; US dry quart; dry qt; us dry qt; dqt; dqt us","UCUM","Vol","Nonclinical","historical unit of dry volume only in the US, but is rarely used today","[pk_us]/8","[PK_US]/8","1",1,false],[false,"dry pint - US","[dpt_us]","[DPT_US]","dry volume",0.0005506104713575002,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"dry pints; dry pint US; US dry pint; dry pt; dpt; dpt us","UCUM","Vol","Nonclinical","historical unit of dry volume only in the US, but is rarely used today","[dqt_us]/2","[DQT_US]/2","1",1,false],[false,"tablespoon - US","[tbs_us]","[TBS_US]","volume",0.000014786764781250006,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"Tbs; tbsp; tbs us; US tablespoons","UCUM","Vol","Clinical","unit defined as 0.5 US fluid ounces or 3 teaspoons - used only in the US. See [tbs_m] for the unit used internationally and in the US for nutrional labelling. ","[foz_us]/2","[FOZ_US]/2","1",1,false],[false,"teaspoon - US","[tsp_us]","[TSP_US]","volume",0.000004928921593750002,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"tsp; t; US teaspoons","UCUM","Vol","Nonclinical","unit defined as 1/6 US fluid ounces - used only in the US. See [tsp_m] for the unit used internationally and in the US for nutrional labelling. ","[tbs_us]/3","[TBS_US]/3","1",1,false],[false,"cup - US customary","[cup_us]","[CUP_US]","volume",0.0002365882365000001,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"cup us; us cups","UCUM","Vol","Nonclinical","Unit defined as 1/2 US pint or 16 US tablespoons \u2248 236.59 mL, which is not the standard unit defined by the FDA of 240 mL - see [cup_m] (metric cup)","[tbs_us]","[TBS_US]","16",16,false],[false,"fluid ounce - metric","[foz_m]","[FOZ_M]","fluid volume",0.000029999999999999997,[3,0,0,0,0,0,0],"oz fl","us-volumes",false,null,null,1,false,false,0,"metric fluid ounces; fozs m; fl ozs m","UCUM","Vol","Clinical","unit used only in the US for nutritional labelling, as set by the FDA","mL","ML","30",30,false],[false,"cup - US legal","[cup_m]","[CUP_M]","volume",0.00023999999999999998,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"cup m; metric cups","UCUM","Vol","Clinical","standard unit equal to 240 mL used in the US for nutritional labelling, as defined by the FDA. Note that this is different from the US customary cup (236.59 mL) and the metric cup used in Commonwealth nations (250 mL).","mL","ML","240",240,false],[false,"teaspoon - metric","[tsp_m]","[TSP_M]","volume",0.0000049999999999999996,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"tsp; t; metric teaspoons","UCUM","Vol","Clinical","standard unit used in the US and internationally","mL","mL","5",5,false],[false,"tablespoon - metric","[tbs_m]","[TBS_M]","volume",0.000014999999999999999,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"metric tablespoons; Tbs; tbsp; T; tbs m","UCUM","Vol","Clinical","standard unit used in the US and internationally","mL","mL","15",15,false],[false,"gallon- British","[gal_br]","[GAL_BR]","volume",0.004546090000000001,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"imperial gallons, UK gallons; British gallons; br gal; imp gal","UCUM","Vol","Nonclinical","Used only in Great Britain and other Commonwealth countries","l","L","4.54609",4.54609,false],[false,"peck - British","[pk_br]","[PK_BR]","volume",0.009092180000000002,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"imperial pecks; British pecks; br pk; imp pk","UCUM","Vol","Nonclinical","unit of dry volume rarely used today (can be used to measure volume of apples)","[gal_br]","[GAL_BR]","2",2,false],[false,"bushel - British","[bu_br]","[BU_BR]","volume",0.03636872000000001,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British bushels; imperial; br bsh; br bu; imp","UCUM","Vol","Obsolete","Historical unit of dry volume that is rarely used today","[pk_br]","[PK_BR]","4",4,false],[false,"quart - British","[qt_br]","[QT_BR]","volume",0.0011365225000000002,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British quarts; imperial quarts; br qts","UCUM","Vol","Clinical","Used only in Great Britain and other Commonwealth countries","[gal_br]/4","[GAL_BR]/4","1",1,false],[false,"pint - British","[pt_br]","[PT_BR]","volume",0.0005682612500000001,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British pints; imperial pints; pt br; br pt; imp pt; pt imp","UCUM","Vol","Clinical","Used only in Great Britain and other Commonwealth countries","[qt_br]/2","[QT_BR]/2","1",1,false],[false,"gill - British","[gil_br]","[GIL_BR]","volume",0.00014206531250000003,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"imperial gills; British gills; imp gill, br gill","UCUM","Vol","Nonclinical","only used in the context of alcohol volume in Great Britain","[pt_br]/4","[PT_BR]/4","1",1,false],[false,"fluid ounce - British","[foz_br]","[FOZ_BR]","volume",0.000028413062500000005,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British fluid ounces; Imperial fluid ounces; br fozs; imp fozs; br fl ozs","UCUM","Vol","Clinical","Used only in Great Britain and other Commonwealth countries","[gil_br]/5","[GIL_BR]/5","1",1,false],[false,"fluid dram - British","[fdr_br]","[FDR_BR]","volume",0.0000035516328125000006,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British fluid drams; fdr br","UCUM","Vol","Nonclinical","equal to 1/8 Imperial fluid ounce = 3.55 mL; used informally to mean small amount of liquor, especially Scotch whiskey","[foz_br]/8","[FOZ_BR]/8","1",1,false],[false,"minim - British","[min_br]","[MIN_BR]","volume",5.919388020833334e-8,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"min br; br min; \u264f br","UCUM","Vol","Obsolete","","[fdr_br]/60","[FDR_BR]/60","1",1,false],[false,"grain","[gr]","[GR]","mass",0.06479891,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"gr; grains","UCUM","Mass","Nonclinical","an apothecary measure of mass rarely used today","mg","MG","64.79891",64.79891,false],[false,"pound","[lb_av]","[LB_AV]","mass",453.59237,[0,0,1,0,0,0,0],"lb","avoirdupois",false,null,null,1,false,false,0,"avoirdupois pounds, international pounds; av lbs; pounds","UCUM","Mass","Clinical","standard unit used in the US and internationally","[gr]","[GR]","7000",7000,false],[false,"pound force - US","[lbf_av]","[LBF_AV]","force",4448.2216152605,[1,-2,1,0,0,0,0],"lbf","const",false,null,null,1,false,false,0,"lbfs; US lbf; US pound forces","UCUM","Force","Clinical","only rarely needed in health care - see [lb_av] which is the more common unit to express weight","[lb_av].[g]","[LB_AV].[G]","1",1,false],[false,"ounce","[oz_av]","[OZ_AV]","mass",28.349523125,[0,0,1,0,0,0,0],"oz","avoirdupois",false,null,null,1,false,false,0,"ounces; international ounces; avoirdupois ounces; av ozs","UCUM","Mass","Clinical","standard unit used in the US and internationally","[lb_av]/16","[LB_AV]/16","1",1,false],[false,"Dram mass unit","[dr_av]","[DR_AV]","mass",1.7718451953125,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"Dram; drams avoirdupois; avoidupois dram; international dram","UCUM","Mass","Clinical","unit from the avoirdupois system, which is used in the US and internationally","[oz_av]/16","[OZ_AV]/16","1",1,false],[false,"short hundredweight","[scwt_av]","[SCWT_AV]","mass",45359.237,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"hundredweights; s cwt; scwt; avoirdupois","UCUM","Mass","Nonclinical","Used only in the US to equal 100 pounds","[lb_av]","[LB_AV]","100",100,false],[false,"long hundredweight","[lcwt_av]","[LCWT_AV]","mass",50802.345440000005,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"imperial hundredweights; imp cwt; lcwt; avoirdupois","UCUM","Mass","Obsolete","","[lb_av]","[LB_AV]","112",112,false],[false,"short ton - US","[ston_av]","[STON_AV]","mass",907184.74,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"ton; US tons; avoirdupois tons","UCUM","Mass","Clinical","Used only in the US","[scwt_av]","[SCWT_AV]","20",20,false],[false,"long ton - British","[lton_av]","[LTON_AV]","mass",1016046.9088000001,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"imperial tons; weight tons; British long tons; long ton avoirdupois","UCUM","Mass","Nonclinical","Used only in Great Britain and other Commonwealth countries","[lcwt_av]","[LCWT_AV]","20",20,false],[false,"stone - British","[stone_av]","[STONE_AV]","mass",6350.293180000001,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"British stones; avoirdupois","UCUM","Mass","Nonclinical","Used primarily in the UK and Ireland to measure body weight","[lb_av]","[LB_AV]","14",14,false],[false,"pennyweight - troy","[pwt_tr]","[PWT_TR]","mass",1.5551738400000001,[0,0,1,0,0,0,0],null,"troy",false,null,null,1,false,false,0,"dwt; denarius weights","UCUM","Mass","Obsolete","historical unit used to measure mass and cost of precious metals","[gr]","[GR]","24",24,false],[false,"ounce - troy","[oz_tr]","[OZ_TR]","mass",31.103476800000003,[0,0,1,0,0,0,0],null,"troy",false,null,null,1,false,false,0,"troy ounces; tr ozs","UCUM","Mass","Nonclinical","unit of mass for precious metals and gemstones only","[pwt_tr]","[PWT_TR]","20",20,false],[false,"pound - troy","[lb_tr]","[LB_TR]","mass",373.2417216,[0,0,1,0,0,0,0],null,"troy",false,null,null,1,false,false,0,"troy pounds; tr lbs","UCUM","Mass","Nonclinical","only used for weighing precious metals","[oz_tr]","[OZ_TR]","12",12,false],[false,"scruple","[sc_ap]","[SC_AP]","mass",1.2959782,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"scruples; sc ap","UCUM","Mass","Obsolete","","[gr]","[GR]","20",20,false],[false,"dram - apothecary","[dr_ap]","[DR_AP]","mass",3.8879346,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"\u0292; drachm; apothecaries drams; dr ap; dram ap","UCUM","Mass","Nonclinical","unit still used in the US occasionally to measure amount of drugs in pharmacies","[sc_ap]","[SC_AP]","3",3,false],[false,"ounce - apothecary","[oz_ap]","[OZ_AP]","mass",31.1034768,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"apothecary ounces; oz ap; ap ozs; ozs ap","UCUM","Mass","Obsolete","","[dr_ap]","[DR_AP]","8",8,false],[false,"pound - apothecary","[lb_ap]","[LB_AP]","mass",373.2417216,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"apothecary pounds; apothecaries pounds; ap lb; lb ap; ap lbs; lbs ap","UCUM","Mass","Obsolete","","[oz_ap]","[OZ_AP]","12",12,false],[false,"ounce - metric","[oz_m]","[OZ_M]","mass",28,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"metric ounces; m ozs","UCUM","Mass","Clinical","see [oz_av] (the avoirdupois ounce) for the standard ounce used internationally; [oz_m] is equal to 28 grams and is based on the apothecaries\' system of mass units which is used in some US pharmacies. ","g","g","28",28,false],[false,"line","[lne]","[LNE]","length",0.002116666666666667,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"British lines; br L; L; l","UCUM","Len","Obsolete","","[in_i]/12","[IN_I]/12","1",1,false],[false,"point (typography)","[pnt]","[PNT]","length",0.0003527777777777778,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"DTP points; desktop publishing point; pt; pnt","UCUM","Len","Nonclinical","typography unit for typesetter\'s length","[lne]/6","[LNE]/6","1",1,false],[false,"pica (typography)","[pca]","[PCA]","length",0.004233333333333334,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"picas","UCUM","Len","Nonclinical","typography unit for typesetter\'s length","[pnt]","[PNT]","12",12,false],[false,"Printer\'s point (typography)","[pnt_pr]","[PNT_PR]","length",0.00035145980000000004,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"pnt pr","UCUM","Len","Nonclinical","typography unit for typesetter\'s length","[in_i]","[IN_I]","0.013837",0.013837,false],[false,"Printer\'s pica  (typography)","[pca_pr]","[PCA_PR]","length",0.004217517600000001,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"pca pr; Printer\'s picas","UCUM","Len","Nonclinical","typography unit for typesetter\'s length","[pnt_pr]","[PNT_PR]","12",12,false],[false,"pied","[pied]","[PIED]","length",0.3248,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"pieds du roi; Paris foot; royal; French; feet","UCUM","Len","Obsolete","","cm","CM","32.48",32.48,false],[false,"pouce","[pouce]","[POUCE]","length",0.027066666666666666,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"historical French inches; French royal inches","UCUM","Len","Obsolete","","[pied]/12","[PIED]/12","1",1,false],[false,"ligne","[ligne]","[LIGNE]","length",0.0022555555555555554,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"Paris lines; lignes","UCUM","Len","Obsolete","","[pouce]/12","[POUCE]/12","1",1,false],[false,"didot","[didot]","[DIDOT]","length",0.0003759259259259259,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"Didot point; dd; Didots Point; didots; points","UCUM","Len","Obsolete","typography unit for typesetter\'s length","[ligne]/6","[LIGNE]/6","1",1,false],[false,"cicero","[cicero]","[CICERO]","length",0.004511111111111111,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"Didot\'s pica; ciceros; picas","UCUM","Len","Obsolete","typography unit for typesetter\'s length","[didot]","[DIDOT]","12",12,false],[false,"degrees Fahrenheit","[degF]","[DEGF]","temperature",0.5555555555555556,[0,0,0,0,1,0,0],"\xb0F","heat",false,null,"degF",1,true,false,0,"\xb0F; deg F","UCUM","Temp","Clinical","","K",null,null,0.5555555555555556,false],[false,"degrees Rankine","[degR]","[degR]","temperature",0.5555555555555556,[0,0,0,0,1,0,0],"\xb0R","heat",false,null,null,1,false,false,0,"\xb0R; \xb0Ra; Rankine","UCUM","Temp","Obsolete","Replaced by Kelvin","K/9","K/9","5",5,false],[false,"degrees R\xe9aumur","[degRe]","[degRe]","temperature",1.25,[0,0,0,0,1,0,0],"\xb0R\xe9","heat",false,null,"degRe",1,true,false,0,"\xb0R\xe9, \xb0Re, \xb0r; R\xe9aumur; degree Reaumur; Reaumur","UCUM","Temp","Obsolete","replaced by Celsius","K",null,null,1.25,false],[false,"calorie at 15\xb0C","cal_[15]","CAL_[15]","energy",4185.8,[2,-2,1,0,0,0,0],"cal<sub>15\xb0C</sub>","heat",true,null,null,1,false,false,0,"calorie 15 C; cals 15 C; calories at 15 C","UCUM","Enrg","Nonclinical","equal to 4.1855 joules; calorie most often used in engineering","J","J","4.18580",4.1858,false],[false,"calorie at 20\xb0C","cal_[20]","CAL_[20]","energy",4181.9,[2,-2,1,0,0,0,0],"cal<sub>20\xb0C</sub>","heat",true,null,null,1,false,false,0,"calorie 20 C; cal 20 C; calories at 20 C","UCUM","Enrg","Clinical","equal to 4.18190  joules. ","J","J","4.18190",4.1819,false],[false,"mean calorie","cal_m","CAL_M","energy",4190.0199999999995,[2,-2,1,0,0,0,0],"cal<sub>m</sub>","heat",true,null,null,1,false,false,0,"mean cals; mean calories","UCUM","Enrg","Clinical","equal to 4.19002 joules. ","J","J","4.19002",4.19002,false],[false,"international table calorie","cal_IT","CAL_IT","energy",4186.8,[2,-2,1,0,0,0,0],"cal<sub>IT</sub>","heat",true,null,null,1,false,false,0,"calories IT; IT cals; international steam table calories","UCUM","Enrg","Nonclinical","used in engineering steam tables and defined as 1/860 international watt-hour; equal to 4.1868 joules","J","J","4.1868",4.1868,false],[false,"thermochemical calorie","cal_th","CAL_TH","energy",4184,[2,-2,1,0,0,0,0],"cal<sub>th</sub>","heat",true,null,null,1,false,false,0,"thermochemical calories; th cals","UCUM","Enrg","Clinical","equal to 4.184 joules; used as the unit in medicine and biochemistry (equal to cal)","J","J","4.184",4.184,false],[false,"calorie","cal","CAL","energy",4184,[2,-2,1,0,0,0,0],"cal","heat",true,null,null,1,false,false,0,"gram calories; small calories","UCUM","Enrg","Clinical","equal to 4.184 joules (the same value as the thermochemical calorie, which is the most common calorie used in medicine and biochemistry)","cal_th","CAL_TH","1",1,false],[false,"nutrition label Calories","[Cal]","[CAL]","energy",4184000,[2,-2,1,0,0,0,0],"Cal","heat",false,null,null,1,false,false,0,"food calories; Cal; kcal","UCUM","Eng","Clinical","","kcal_th","KCAL_TH","1",1,false],[false,"British thermal unit at 39\xb0F","[Btu_39]","[BTU_39]","energy",1059670,[2,-2,1,0,0,0,0],"Btu<sub>39\xb0F</sub>","heat",false,null,null,1,false,false,0,"BTU 39F; BTU 39 F; B.T.U. 39 F; B.Th.U. 39 F; BThU 39 F; British thermal units","UCUM","Eng","Nonclinical","equal to 1.05967 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05967",1.05967,false],[false,"British thermal unit at 59\xb0F","[Btu_59]","[BTU_59]","energy",1054800,[2,-2,1,0,0,0,0],"Btu<sub>59\xb0F</sub>","heat",false,null,null,1,false,false,0,"BTU 59 F; BTU 59F; B.T.U. 59 F; B.Th.U. 59 F; BThU 59F; British thermal units","UCUM","Eng","Nonclinical","equal to  1.05480 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05480",1.0548,false],[false,"British thermal unit at 60\xb0F","[Btu_60]","[BTU_60]","energy",1054680,[2,-2,1,0,0,0,0],"Btu<sub>60\xb0F</sub>","heat",false,null,null,1,false,false,0,"BTU 60 F; BTU 60F; B.T.U. 60 F; B.Th.U. 60 F; BThU 60 F; British thermal units 60 F","UCUM","Eng","Nonclinical","equal to 1.05468 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05468",1.05468,false],[false,"mean British thermal unit","[Btu_m]","[BTU_M]","energy",1055870,[2,-2,1,0,0,0,0],"Btu<sub>m</sub>","heat",false,null,null,1,false,false,0,"BTU mean; B.T.U. mean; B.Th.U. mean; BThU mean; British thermal units mean; ","UCUM","Eng","Nonclinical","equal to 1.05587 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05587",1.05587,false],[false,"international table British thermal unit","[Btu_IT]","[BTU_IT]","energy",1055055.85262,[2,-2,1,0,0,0,0],"Btu<sub>IT</sub>","heat",false,null,null,1,false,false,0,"BTU IT; B.T.U. IT; B.Th.U. IT; BThU IT; British thermal units IT","UCUM","Eng","Nonclinical","equal to 1.055 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05505585262",1.05505585262,false],[false,"thermochemical British thermal unit","[Btu_th]","[BTU_TH]","energy",1054350,[2,-2,1,0,0,0,0],"Btu<sub>th</sub>","heat",false,null,null,1,false,false,0,"BTU Th; B.T.U. Th; B.Th.U. Th; BThU Th; thermochemical British thermal units","UCUM","Eng","Nonclinical","equal to 1.054350 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.054350",1.05435,false],[false,"British thermal unit","[Btu]","[BTU]","energy",1054350,[2,-2,1,0,0,0,0],"btu","heat",false,null,null,1,false,false,0,"BTU; B.T.U. ; B.Th.U.; BThU; British thermal units","UCUM","Eng","Nonclinical","equal to the thermochemical British thermal unit equal to 1.054350 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","[Btu_th]","[BTU_TH]","1",1,false],[false,"horsepower - mechanical","[HP]","[HP]","power",745699.8715822703,[2,-3,1,0,0,0,0],null,"heat",false,null,null,1,false,false,0,"imperial horsepowers","UCUM","EngRat","Nonclinical","refers to mechanical horsepower, which is unit used to measure engine power primarily in the US. ","[ft_i].[lbf_av]/s","[FT_I].[LBF_AV]/S","550",550,false],[false,"tex","tex","TEX","linear mass density (of textile thread)",0.001,[-1,0,1,0,0,0,0],"tex","heat",true,null,null,1,false,false,0,"linear mass density; texes","UCUM","","Clinical","unit of linear mass density for fibers equal to gram per 1000 meters","g/km","G/KM","1",1,false],[false,"Denier (linear mass density)","[den]","[DEN]","linear mass density (of textile thread)",0.0001111111111111111,[-1,0,1,0,0,0,0],"den","heat",false,null,null,1,false,false,0,"den; deniers","UCUM","","Nonclinical","equal to the mass in grams per 9000 meters of the fiber (1 denier = 1 strand of silk)","g/9/km","G/9/KM","1",1,false],[false,"meter of water column","m[H2O]","M[H2O]","pressure",9806650,[-1,-2,1,0,0,0,0],"m\xa0HO<sub><r>2</r></sub>","clinical",true,null,null,1,false,false,0,"mH2O; m H2O; meters of water column; metres; pressure","UCUM","Pres","Clinical","","kPa","KPAL","980665e-5",9.80665,false],[false,"meter of mercury column","m[Hg]","M[HG]","pressure",133322000,[-1,-2,1,0,0,0,0],"m\xa0Hg","clinical",true,null,null,1,false,false,0,"mHg; m Hg; meters of mercury column; metres; pressure","UCUM","Pres","Clinical","","kPa","KPAL","133.3220",133.322,false],[false,"inch of water column","[in_i\'H2O]","[IN_I\'H2O]","pressure",249088.91000000003,[-1,-2,1,0,0,0,0],"in\xa0HO<sub><r>2</r></sub>","clinical",false,null,null,1,false,false,0,"inches WC; inAq; in H2O; inch of water gauge; iwg; pressure","UCUM","Pres","Clinical","unit of pressure, especially in respiratory and ventilation care","m[H2O].[in_i]/m","M[H2O].[IN_I]/M","1",1,false],[false,"inch of mercury column","[in_i\'Hg]","[IN_I\'HG]","pressure",3386378.8000000003,[-1,-2,1,0,0,0,0],"in\xa0Hg","clinical",false,null,null,1,false,false,0,"inHg; in Hg; pressure; inches","UCUM","Pres","Clinical","unit of pressure used in US to measure barometric pressure and occasionally blood pressure (see mm[Hg] for unit used internationally)","m[Hg].[in_i]/m","M[HG].[IN_I]/M","1",1,false],[false,"peripheral vascular resistance unit","[PRU]","[PRU]","fluid resistance",133322000000,[-4,-1,1,0,0,0,0],"P.R.U.","clinical",false,null,null,1,false,false,0,"peripheral vascular resistance units; peripheral resistance unit; peripheral resistance units; PRU","UCUM","FldResist","Clinical","used to assess blood flow in the capillaries; equal to 1 mmH.min/mL = 133.3 Pa\xb7min/mL","mm[Hg].s/ml","MM[HG].S/ML","1",1,false],[false,"Wood unit","[wood\'U]","[WOOD\'U]","fluid resistance",7999320000,[-4,-1,1,0,0,0,0],"Wood U.","clinical",false,null,null,1,false,false,0,"hybrid reference units; HRU; mmHg.min/L; vascular resistance","UCUM","Pres","Clinical","simplified unit of measurement for for measuring pulmonary vascular resistance that uses pressure; equal to mmHg.min/L","mm[Hg].min/L","MM[HG].MIN/L","1",1,false],[false,"diopter (lens)","[diop]","[DIOP]","refraction of a lens",1,[1,0,0,0,0,0,0],"dpt","clinical",false,null,"inv",1,false,false,0,"diopters; diop; dioptre; dpt; refractive power","UCUM","InvLen","Clinical","unit of optical power of lens represented by inverse meters (m^-1)","m","/M","1",1,false],[false,"prism diopter (magnifying power)","[p\'diop]","[P\'DIOP]","refraction of a prism",1,[0,0,0,1,0,0,0],"PD","clinical",false,null,"tanTimes100",1,true,false,0,"diopters; dioptres; p diops; pdiop; dpt; pdptr; \u0394; cm/m; centimeter per meter; centimetre; metre","UCUM","Angle","Clinical","unit for prism correction in eyeglass prescriptions","rad",null,null,1,false],[false,"percent of slope","%[slope]","%[SLOPE]","slope",0.017453292519943295,[0,0,0,1,0,0,0],"%","clinical",false,null,"100tan",1,true,false,0,"% slope; %slope; percents slopes","UCUM","VelFr; ElpotRatFr; VelRtoFr; AccelFr","Clinical","","deg",null,null,1,false],[false,"mesh","[mesh_i]","[MESH_I]","lineic number",0.025400000000000002,[1,0,0,0,0,0,0],null,"clinical",false,null,"inv",1,false,false,0,"meshes","UCUM","NLen (lineic number)","Clinical","traditional unit of length defined as the number of strands or particles per inch","[in_i]","/[IN_I]","1",1,false],[false,"French (catheter gauge) ","[Ch]","[CH]","gauge of catheters",0.0003333333333333333,[1,0,0,0,0,0,0],"Ch","clinical",false,null,null,1,false,false,0,"Charri\xe8res, French scales; French gauges; Fr, Fg, Ga, FR, Ch","UCUM","Len; Circ; Diam","Clinical","","mm/3","MM/3","1",1,false],[false,"drop - metric (1/20 mL)","[drp]","[DRP]","volume",5e-8,[3,0,0,0,0,0,0],"drp","clinical",false,null,null,1,false,false,0,"drop dosing units; metric drops; gtt","UCUM","Vol","Clinical","standard unit used in the US and internationally for clinical medicine but note that although [drp] is defined as 1/20 milliliter, in practice, drop sizes will vary due to external factors","ml/20","ML/20","1",1,false],[false,"Hounsfield unit","[hnsf\'U]","[HNSF\'U]","x-ray attenuation",1,[0,0,0,0,0,0,0],"HF","clinical",false,null,null,1,false,false,0,"HU; units","UCUM","","Clinical","used to measure X-ray attenuation, especially in CT scans.","1","1","1",1,false],[false,"Metabolic Equivalent of Task ","[MET]","[MET]","metabolic cost of physical activity",5.833333333333334e-11,[3,-1,-1,0,0,0,0],"MET","clinical",false,null,null,1,false,false,0,"metabolic equivalents","UCUM","RelEngRat","Clinical","unit used to measure rate of energy expenditure per power in treadmill and other functional tests","mL/min/kg","ML/MIN/KG","3.5",3.5,false],[false,"homeopathic potency of decimal series (retired)","[hp\'_X]","[HP\'_X]","homeopathic potency (retired)",1,[0,0,0,0,0,0,0],"X","clinical",false,null,"hpX",1,true,false,0,null,"UCUM",null,null,null,"1",null,null,1,false],[false,"homeopathic potency of centesimal series (retired)","[hp\'_C]","[HP\'_C]","homeopathic potency (retired)",1,[0,0,0,0,0,0,0],"C","clinical",false,null,"hpC",1,true,false,0,null,"UCUM",null,null,null,"1",null,null,1,false],[false,"homeopathic potency of millesimal series (retired)","[hp\'_M]","[HP\'_M]","homeopathic potency (retired)",1,[0,0,0,0,0,0,0],"M","clinical",false,null,"hpM",1,true,false,0,null,"UCUM",null,null,null,"1",null,null,1,false],[false,"homeopathic potency of quintamillesimal series (retired)","[hp\'_Q]","[HP\'_Q]","homeopathic potency (retired)",1,[0,0,0,0,0,0,0],"Q","clinical",false,null,"hpQ",1,true,false,0,null,"UCUM",null,null,null,"1",null,null,1,false],[false,"homeopathic potency of decimal hahnemannian series","[hp_X]","[HP_X]","homeopathic potency (Hahnemann)",1,[0,0,0,0,0,0,0],"X","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of centesimal hahnemannian series","[hp_C]","[HP_C]","homeopathic potency (Hahnemann)",1,[0,0,0,0,0,0,0],"C","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of millesimal hahnemannian series","[hp_M]","[HP_M]","homeopathic potency (Hahnemann)",1,[0,0,0,0,0,0,0],"M","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of quintamillesimal hahnemannian series","[hp_Q]","[HP_Q]","homeopathic potency (Hahnemann)",1,[0,0,0,0,0,0,0],"Q","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of decimal korsakovian series","[kp_X]","[KP_X]","homeopathic potency (Korsakov)",1,[0,0,0,0,0,0,0],"X","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of centesimal korsakovian series","[kp_C]","[KP_C]","homeopathic potency (Korsakov)",1,[0,0,0,0,0,0,0],"C","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of millesimal korsakovian series","[kp_M]","[KP_M]","homeopathic potency (Korsakov)",1,[0,0,0,0,0,0,0],"M","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of quintamillesimal korsakovian series","[kp_Q]","[KP_Q]","homeopathic potency (Korsakov)",1,[0,0,0,0,0,0,0],"Q","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"equivalent","eq","EQ","amount of substance",6.0221367e+23,[0,0,0,0,0,0,0],"eq","chemical",true,null,null,1,false,false,1,"equivalents","UCUM","Sub","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"osmole","osm","OSM","amount of substance (dissolved particles)",6.0221367e+23,[0,0,0,0,0,0,0],"osm","chemical",true,null,null,1,false,false,1,"osmoles; osmols","UCUM","Osmol","Clinical","the number of moles of solute that contribute to the osmotic pressure of a solution","mol","MOL","1",1,false],[false,"pH","[pH]","[PH]","acidity",6.0221366999999994e+26,[-3,0,0,0,0,0,0],"pH","chemical",false,null,"pH",1,true,false,0,"pH scale","UCUM","LogCnc","Clinical","Log concentration of H+","mol/l",null,null,1,false],[false,"gram percent","g%","G%","mass concentration",10000,[-3,0,1,0,0,0,0],"g%","chemical",true,null,null,1,false,false,0,"gram %; gram%; grams per deciliter; g/dL; gm per dL; gram percents","UCUM","MCnc","Clinical","equivalent to unit gram per deciliter (g/dL), a unit often used in medical tests to represent solution concentrations","g/dl","G/DL","1",1,false],[false,"Svedberg unit","[S]","[S]","sedimentation coefficient",1e-13,[0,1,0,0,0,0,0],"S","chemical",false,null,null,1,false,false,0,"Sv; 10^-13 seconds; 100 fs; 100 femtoseconds","UCUM","Time","Clinical","unit of time used in measuring particle\'s sedimentation rate, usually after centrifugation. ","s","10*-13.S","1",1e-13,false],[false,"high power field (microscope)","[HPF]","[HPF]","view area in microscope",1,[0,0,0,0,0,0,0],"HPF","chemical",false,null,null,1,false,false,0,"HPF","UCUM","Area","Clinical","area visible under the maximum magnification power of the objective in microscopy (usually 400x)\\n","1","1","1",1,false],[false,"low power field (microscope)","[LPF]","[LPF]","view area in microscope",1,[0,0,0,0,0,0,0],"LPF","chemical",false,null,null,1,false,false,0,"LPF; fields","UCUM","Area","Clinical","area visible under the low magnification of the objective in microscopy (usually 100 x)\\n","1","1","100",100,false],[false,"katal","kat","KAT","catalytic activity",6.0221367e+23,[0,-1,0,0,0,0,0],"kat","chemical",true,null,null,1,false,false,1,"mol/secs; moles per second; mol*sec-1; mol*s-1; mol.s-1; katals; catalytic activity; enzymatic; enzyme units; activities","UCUM","CAct","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"enzyme unit","U","U","catalytic activity",10036894500000000,[0,-1,0,0,0,0,0],"U","chemical",true,null,null,1,false,false,1,"micromoles per minute; umol/min; umol per minute; umol min-1; enzymatic activity; enzyme activity","UCUM","CAct","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"international unit - arbitrary","[iU]","[IU]","arbitrary",1,[0,0,0,0,0,0,0],"IU","chemical",true,null,null,1,false,true,0,"international units; IE; F2","UCUM","Arb","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","1","1","1",1,false],[false,"international unit - arbitrary","[IU]","[IU]","arbitrary",1,[0,0,0,0,0,0,0],"i.U.","chemical",true,null,null,1,false,true,0,"international units; IE; F2","UCUM","Arb","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"arbitary unit","[arb\'U]","[ARB\'U]","arbitrary",1,[0,0,0,0,0,0,0],"arb. U","chemical",false,null,null,1,false,true,0,"arbitary units; arb units; arbU","UCUM","Arb","Clinical","relative unit of measurement to show the ratio of test measurement to reference measurement","1","1","1",1,false],[false,"United States Pharmacopeia unit","[USP\'U]","[USP\'U]","arbitrary",1,[0,0,0,0,0,0,0],"U.S.P.","chemical",false,null,null,1,false,true,0,"USP U; USP\'U","UCUM","Arb","Clinical","a dose unit to express potency of drugs and vitamins defined by the United States Pharmacopoeia; usually 1 USP = 1 IU","1","1","1",1,false],[false,"GPL unit","[GPL\'U]","[GPL\'U]","biologic activity of anticardiolipin IgG",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"GPL Units; GPL U; IgG anticardiolipin units; IgG Phospholipid","UCUM","ACnc; AMass","Clinical","Units for an antiphospholipid test","1","1","1",1,false],[false,"MPL unit","[MPL\'U]","[MPL\'U]","biologic activity of anticardiolipin IgM",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"MPL units; MPL U; MPL\'U; IgM anticardiolipin units; IgM Phospholipid Units ","UCUM","ACnc","Clinical","units for antiphospholipid test","1","1","1",1,false],[false,"APL unit","[APL\'U]","[APL\'U]","biologic activity of anticardiolipin IgA",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"APL units; APL U; IgA anticardiolipin; IgA Phospholipid; biologic activity of","UCUM","AMass; ACnc","Clinical","Units for an anti phospholipid syndrome test","1","1","1",1,false],[false,"Bethesda unit","[beth\'U]","[BETH\'U]","biologic activity of factor VIII inhibitor",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"BU","UCUM","ACnc","Clinical","measures of blood coagulation inhibitior for many blood factors","1","1","1",1,false],[false,"anti factor Xa unit","[anti\'Xa\'U]","[ANTI\'XA\'U]","biologic activity of factor Xa inhibitor (heparin)",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"units","UCUM","ACnc","Clinical","[anti\'Xa\'U] unit is equivalent to and can be converted to IU/mL. ","1","1","1",1,false],[false,"Todd unit","[todd\'U]","[TODD\'U]","biologic activity antistreptolysin O",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"units","UCUM","InvThres; RtoThres","Clinical","the unit for the results of the testing for antistreptolysin O (ASO)","1","1","1",1,false],[false,"Dye unit","[dye\'U]","[DYE\'U]","biologic activity of amylase",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"units","UCUM","CCnc","Obsolete","equivalent to the Somogyi unit, which is an enzyme unit for amylase but better to use U, the standard enzyme unit for measuring catalytic activity","1","1","1",1,false],[false,"Somogyi unit","[smgy\'U]","[SMGY\'U]","biologic activity of amylase",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"Somogyi units; smgy U","UCUM","CAct","Clinical","measures the enzymatic activity of amylase in blood serum - better to use base units mg/mL ","1","1","1",1,false],[false,"Bodansky unit","[bdsk\'U]","[BDSK\'U]","biologic activity of phosphatase",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"","UCUM","ACnc","Obsolete","Enzyme unit specific to alkaline phosphatase - better to use standard enzyme unit of U","1","1","1",1,false],[false,"King-Armstrong unit","[ka\'U]","[KA\'U]","biologic activity of phosphatase",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"King-Armstrong Units; King units","UCUM","AMass","Obsolete","enzyme units for acid phosphatase - better to use enzyme unit [U]","1","1","1",1,false],[false,"Kunkel unit","[knk\'U]","[KNK\'U]","arbitrary biologic activity",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"Mac Lagan unit","[mclg\'U]","[MCLG\'U]","arbitrary biologic activity",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"galactose index; galactose tolerance test; thymol turbidity test unit; mclg U; units; indexes","UCUM","ACnc","Obsolete","unit for liver tests - previously used in thymol turbidity tests for liver disease diagnoses, and now is sometimes referred to in the oral galactose tolerance test","1","1","1",1,false],[false,"tuberculin unit","[tb\'U]","[TB\'U]","biologic activity of tuberculin",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"TU; units","UCUM","Arb","Clinical","amount of tuberculin antigen -usually in reference to a TB skin test ","1","1","1",1,false],[false,"50% cell culture infectious dose","[CCID_50]","[CCID_50]","biologic activity (infectivity) of an infectious agent preparation",1,[0,0,0,0,0,0,0],"CCID<sub>50</sub>","chemical",false,null,null,1,false,true,0,"CCID50; 50% cell culture infective doses","UCUM","NumThres","Clinical","","1","1","1",1,false],[false,"50% tissue culture infectious dose","[TCID_50]","[TCID_50]","biologic activity (infectivity) of an infectious agent preparation",1,[0,0,0,0,0,0,0],"TCID<sub>50</sub>","chemical",false,null,null,1,false,true,0,"TCID50; 50% tissue culture infective dose","UCUM","NumThres","Clinical","","1","1","1",1,false],[false,"50% embryo infectious dose","[EID_50]","[EID_50]","biologic activity (infectivity) of an infectious agent preparation",1,[0,0,0,0,0,0,0],"EID<sub>50</sub>","chemical",false,null,null,1,false,true,0,"EID50; 50% embryo infective doses; EID50 Egg Infective Dosage","UCUM","thresNum","Clinical","","1","1","1",1,false],[false,"plaque forming units","[PFU]","[PFU]","amount of an infectious agent",1,[0,0,0,0,0,0,0],"PFU","chemical",false,null,null,1,false,true,0,"PFU","UCUM","ACnc","Clinical","tests usually report unit as number of PFU per unit volume","1","1","1",1,false],[false,"focus forming units (cells)","[FFU]","[FFU]","amount of an infectious agent",1,[0,0,0,0,0,0,0],"FFU","chemical",false,null,null,1,false,true,0,"FFU","UCUM","EntNum","Clinical","","1","1","1",1,false],[false,"colony forming units","[CFU]","[CFU]","amount of a proliferating organism",1,[0,0,0,0,0,0,0],"CFU","chemical",false,null,null,1,false,true,0,"CFU","UCUM","Num","Clinical","","1","1","1",1,false],[false,"index of reactivity (allergen)","[IR]","[IR]","amount of an allergen callibrated through in-vivo testing using the Stallergenes\xae method.",1,[0,0,0,0,0,0,0],"IR","chemical",false,null,null,1,false,true,0,"IR; indexes","UCUM","Acnc","Clinical","amount of an allergen callibrated through in-vivo testing using the Stallergenes method. Usually reported in tests as IR/mL","1","1","1",1,false],[false,"bioequivalent allergen unit","[BAU]","[BAU]","amount of an allergen callibrated through in-vivo testing based on the ID50EAL method of (intradermal dilution for 50mm sum of erythema diameters",1,[0,0,0,0,0,0,0],"BAU","chemical",false,null,null,1,false,true,0,"BAU; Bioequivalent Allergy Units; bioequivalent allergen units","UCUM","Arb","Clinical","","1","1","1",1,false],[false,"allergy unit","[AU]","[AU]","procedure defined amount of an allergen using some reference standard",1,[0,0,0,0,0,0,0],"AU","chemical",false,null,null,1,false,true,0,"allergy units; allergen units; AU","UCUM","Arb","Clinical","Most standard test allergy units are reported as [IU] or as %. ","1","1","1",1,false],[false,"allergen unit for Ambrosia artemisiifolia","[Amb\'a\'1\'U]","[AMB\'A\'1\'U]","procedure defined amount of the major allergen of ragweed.",1,[0,0,0,0,0,0,0],"Amb a 1 U","chemical",false,null,null,1,false,true,0,"Amb a 1 unit; Antigen E; AgE U; allergen units","UCUM","Arb","Clinical","Amb a 1 is the major allergen in short ragweed, and can be converted Bioequivalent allergen units (BAU) where 350 Amb a 1 U/mL = 100,000 BAU/mL","1","1","1",1,false],[false,"protein nitrogen unit (allergen testing)","[PNU]","[PNU]","procedure defined amount of a protein substance",1,[0,0,0,0,0,0,0],"PNU","chemical",false,null,null,1,false,true,0,"protein nitrogen units; PNU","UCUM","Mass","Clinical","defined as 0.01 ug of phosphotungstic acid-precipitable protein nitrogen. Being replaced by bioequivalent allergy units (BAU).","1","1","1",1,false],[false,"Limit of flocculation","[Lf]","[LF]","procedure defined amount of an antigen substance",1,[0,0,0,0,0,0,0],"Lf","chemical",false,null,null,1,false,true,0,"Lf doses","UCUM","Arb","Clinical","the antigen content  forming 1:1 ratio against 1 unit of antitoxin","1","1","1",1,false],[false,"D-antigen unit (polio)","[D\'ag\'U]","[D\'AG\'U]","procedure defined amount of a poliomyelitis d-antigen substance",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"DAgU; units","UCUM","Acnc","Clinical","unit of potency of poliovirus vaccine used for poliomyelitis prevention reported as D antigen units/mL. The unit is poliovirus type-specific.","1","1","1",1,false],[false,"fibrinogen equivalent units","[FEU]","[FEU]","amount of fibrinogen broken down into the measured d-dimers",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"FEU","UCUM","MCnc","Clinical","Note both the FEU and DDU units are used to report D-dimer measurements. 1 DDU = 1/2 FFU","1","1","1",1,false],[false,"ELISA unit","[ELU]","[ELU]","arbitrary ELISA unit",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"Enzyme-Linked Immunosorbent Assay Units; ELU; EL. U","UCUM","ACnc","Clinical","","1","1","1",1,false],[false,"Ehrlich units (urobilinogen)","[EU]","[EU]","Ehrlich unit",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"EU/dL; mg{urobilinogen}/dL","UCUM","ACnc","Clinical","","1","1","1",1,false],[false,"neper","Np","NEP","level",1,[0,0,0,0,0,0,0],"Np","levels",true,null,"ln",1,true,false,0,"nepers","UCUM","LogRto","Clinical","logarithmic unit for ratios of measurements of physical field and power quantities, such as gain and loss of electronic signals","1",null,null,1,false],[false,"bel","B","B","level",1,[0,0,0,0,0,0,0],"B","levels",true,null,"lg",1,true,false,0,"bels","UCUM","LogRto","Clinical","Logarithm of the ratio of power- or field-type quantities; usually expressed in decibels ","1",null,null,1,false],[false,"bel sound pressure","B[SPL]","B[SPL]","pressure level",0.019999999999999997,[-1,-2,1,0,0,0,0],"B(SPL)","levels",true,null,"lgTimes2",1,true,false,0,"bel SPL; B SPL; sound pressure bels","UCUM","LogRto","Clinical","used to measure sound level in acoustics","Pa",null,null,0.000019999999999999998,false],[false,"bel volt","B[V]","B[V]","electric potential level",1000,[2,-2,1,0,0,-1,0],"B(V)","levels",true,null,"lgTimes2",1,true,false,0,"bel V; B V; volts bels","UCUM","LogRtoElp","Clinical","used to express power gain in electrical circuits","V",null,null,1,false],[false,"bel millivolt","B[mV]","B[MV]","electric potential level",1,[2,-2,1,0,0,-1,0],"B(mV)","levels",true,null,"lgTimes2",1,true,false,0,"bel mV; B mV; millivolt bels; 10^-3V bels; 10*-3V ","UCUM","LogRtoElp","Clinical","used to express power gain in electrical circuits","mV",null,null,1,false],[false,"bel microvolt","B[uV]","B[UV]","electric potential level",0.001,[2,-2,1,0,0,-1,0],"B(\u03bcV)","levels",true,null,"lgTimes2",1,true,false,0,"bel uV; B uV; microvolts bels; 10^-6V bel; 10*-6V bel","UCUM","LogRto","Clinical","used to express power gain in electrical circuits","uV",null,null,1,false],[false,"bel 10 nanovolt","B[10.nV]","B[10.NV]","electric potential level",0.000010000000000000003,[2,-2,1,0,0,-1,0],"B(10 nV)","levels",true,null,"lgTimes2",1,true,false,0,"bel 10 nV; B 10 nV; 10 nanovolts bels","UCUM","LogRtoElp","Clinical","used to express power gain in electrical circuits","nV",null,null,10,false],[false,"bel watt","B[W]","B[W]","power level",1000,[2,-3,1,0,0,0,0],"B(W)","levels",true,null,"lg",1,true,false,0,"bel W; b W; b Watt; Watts bels","UCUM","LogRto","Clinical","used to express power","W",null,null,1,false],[false,"bel kilowatt","B[kW]","B[KW]","power level",1000000,[2,-3,1,0,0,0,0],"B(kW)","levels",true,null,"lg",1,true,false,0,"bel kW; B kW; kilowatt bel; kW bel; kW B","UCUM","LogRto","Clinical","used to express power","kW",null,null,1,false],[false,"stere","st","STR","volume",1,[3,0,0,0,0,0,0],"st","misc",true,null,null,1,false,false,0,"st\xe8re; m3; cubic meter; m^3; meters cubed; metre","UCUM","Vol","Nonclinical","equal to one cubic meter, usually used for measuring firewood","m3","M3","1",1,false],[false,"\xc5ngstr\xf6m","Ao","AO","length",1.0000000000000002e-10,[1,0,0,0,0,0,0],"\xc5","misc",false,null,null,1,false,false,0,"\xc5; Angstroms; Ao; \xc5ngstr\xf6ms","UCUM","Len","Clinical","equal to 10^-10 meters; used to express wave lengths and atom scaled differences ","nm","NM","0.1",0.1,false],[false,"barn","b","BRN","action area",1.0000000000000001e-28,[2,0,0,0,0,0,0],"b","misc",false,null,null,1,false,false,0,"barns","UCUM","Area","Clinical","used in high-energy physics to express cross-sectional areas","fm2","FM2","100",100,false],[false,"technical atmosphere","att","ATT","pressure",98066500,[-1,-2,1,0,0,0,0],"at","misc",false,null,null,1,false,false,0,"at; tech atm; tech atmosphere; kgf/cm2; atms; atmospheres","UCUM","Pres","Obsolete","non-SI unit of pressure equal to one kilogram-force per square centimeter","kgf/cm2","KGF/CM2","1",1,false],[false,"mho","mho","MHO","electric conductance",0.001,[-2,1,-1,0,0,2,0],"mho","misc",true,null,null,1,false,false,0,"siemens; ohm reciprocals; \u03a9^\u22121; \u03a9-1 ","UCUM","","Obsolete","unit of electric conductance (the inverse of electrical resistance) equal to ohm^-1","S","S","1",1,false],[false,"pound per square inch","[psi]","[PSI]","pressure",6894757.293168359,[-1,-2,1,0,0,0,0],"psi","misc",false,null,null,1,false,false,0,"psi; lb/in2; lb per in2","UCUM","Pres","Clinical","","[lbf_av]/[in_i]2","[LBF_AV]/[IN_I]2","1",1,false],[false,"circle - plane angle","circ","CIRC","plane angle",6.283185307179586,[0,0,0,1,0,0,0],"circ","misc",false,null,null,1,false,false,0,"angles; circles","UCUM","Angle","Clinical","","[pi].rad","[PI].RAD","2",2,false],[false,"spere - solid angle","sph","SPH","solid angle",12.566370614359172,[0,0,0,2,0,0,0],"sph","misc",false,null,null,1,false,false,0,"speres","UCUM","Angle","Clinical","equal to the solid angle of an entire sphere = 4\u03c0sr (sr = steradian) ","[pi].sr","[PI].SR","4",4,false],[false,"metric carat","[car_m]","[CAR_M]","mass",0.2,[0,0,1,0,0,0,0],"ct<sub>m</sub>","misc",false,null,null,1,false,false,0,"carats; ct; car m","UCUM","Mass","Nonclinical","unit of mass for gemstones","g","G","2e-1",0.2,false],[false,"carat of gold alloys","[car_Au]","[CAR_AU]","mass fraction",0.041666666666666664,[0,0,0,0,0,0,0],"ct<sub><r>Au</r></sub>","misc",false,null,null,1,false,false,0,"karats; k; kt; car au; carats","UCUM","MFr","Nonclinical","unit of purity for gold alloys","/24","/24","1",1,false],[false,"Smoot","[smoot]","[SMOOT]","length",1.7018000000000002,[1,0,0,0,0,0,0],null,"misc",false,null,null,1,false,false,0,"","UCUM","Len","Nonclinical","prank unit of length from MIT","[in_i]","[IN_I]","67",67,false],[false,"meter per square seconds per square root of hertz","[m/s2/Hz^(1/2)]","[M/S2/HZ^(1/2)]","amplitude spectral density",1,[2,-3,0,0,0,0,0],null,"misc",false,null,"sqrt",1,true,false,0,"m/s2/(Hz^.5); m/s2/(Hz^(1/2)); m per s2 per Hz^1/2","UCUM","","Constant","measures amplitude spectral density, and is equal to the square root of power spectral density\\n ","m2/s4/Hz",null,null,1,false],[false,"bit - logarithmic","bit_s","BIT_S","amount of information",1,[0,0,0,0,0,0,0],"bit<sub>s</sub>","infotech",false,null,"ld",1,true,false,0,"bit-s; bit s; bit logarithmic","UCUM","LogA","Nonclinical","defined as the log base 2 of the number of distinct signals; cannot practically be used to express more than 1000 bits\\n\\nIn information theory, the definition of the amount of self-information and information entropy is often expressed with the binary logarithm (log base 2)","1",null,null,1,false],[false,"bit","bit","BIT","amount of information",1,[0,0,0,0,0,0,0],"bit","infotech",true,null,null,1,false,false,0,"bits","UCUM","","Nonclinical","dimensionless information unit of 1 used in computing and digital communications","1","1","1",1,false],[false,"byte","By","BY","amount of information",8,[0,0,0,0,0,0,0],"B","infotech",true,null,null,1,false,false,0,"bytes","UCUM","","Nonclinical","equal to 8 bits","bit","bit","8",8,false],[false,"baud","Bd","BD","signal transmission rate",1,[0,1,0,0,0,0,0],"Bd","infotech",true,null,"inv",1,false,false,0,"Bd; bauds","UCUM","Freq","Nonclinical","unit to express rate in symbols per second or pulses per second. ","s","/s","1",1,false],[false,"per twelve hour","/(12.h)","1/(12.HR)","",0.000023148148148148147,[0,-1,0,0,0,0,0],"/h",null,false,null,null,1,false,false,0,"per 12 hours; 12hrs; 12 hrs; /12hrs","LOINC","Rat","Clinical","",null,null,null,null,false],[false,"per arbitrary unit","/[arb\'U]","1/[ARB\'U]","",1,[0,0,0,0,0,0,0],"/arb/ U",null,false,null,null,1,false,true,0,"/arbU","LOINC","InvA ","Clinical","",null,null,null,null,false],[false,"per high power field","/[HPF]","1/[HPF]","",1,[0,0,0,0,0,0,0],"/HPF",null,false,null,null,1,false,false,0,"/HPF; per HPF","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"per international unit","/[IU]","1/[IU]","",1,[0,0,0,0,0,0,0],"/i/U.",null,false,null,null,1,false,true,0,"international units; /IU; per IU","LOINC","InvA","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)",null,null,null,null,false],[false,"per low power field","/[LPF]","1/[LPF]","",1,[0,0,0,0,0,0,0],"/LPF",null,false,null,null,1,false,false,0,"/LPF; per LPF","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"per 10 billion  ","/10*10","1/(10*10)","",1e-10,[0,0,0,0,0,0,0],"/10<sup>10</sup>",null,false,null,null,1,false,false,0,"/10^10; per 10*10","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per trillion ","/10*12","1/(10*12)","",1e-12,[0,0,0,0,0,0,0],"/10<sup>12</sup>",null,false,null,null,1,false,false,0,"/10^12; per 10*12","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per thousand","/10*3","1/(10*3)","",0.001,[0,0,0,0,0,0,0],"/10<sup>3</sup>",null,false,null,null,1,false,false,0,"/10^3; per 10*3","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per million","/10*6","1/(10*6)","",0.000001,[0,0,0,0,0,0,0],"/10<sup>6</sup>",null,false,null,null,1,false,false,0,"/10^6; per 10*6;","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per billion","/10*9","1/(10*9)","",1e-9,[0,0,0,0,0,0,0],"/10<sup>9</sup>",null,false,null,null,1,false,false,0,"/10^9; per 10*9","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per 100","/100","1/100","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"per hundred; 10^2; 10*2","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per 100 cells","/100{cells}","1/100","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"/100 cells; /100cells; per hundred","LOINC","EntMass; EntNum; NFr","Clinical","",null,null,null,null,false],[false,"per 100 neutrophils","/100{neutrophils}","1/100","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"/100 neutrophils; /100neutrophils; per hundred","LOINC","EntMass; EntNum; NFr","Clinical","",null,null,null,null,false],[false,"per 100 spermatozoa","/100{spermatozoa}","1/100","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"/100 spermatozoa; /100spermatozoa; per hundred","LOINC","NFr","Clinical","",null,null,null,null,false],[false,"per 100 white blood cells","/100{WBCs}","1/100","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"/100 WBCs; /100WBCs; per hundred","LOINC","Ratio; NFr","Clinical","",null,null,null,null,false],[false,"per year","/a","1/ANN","",3.168808781402895e-8,[0,-1,0,0,0,0,0],"/a",null,false,null,null,1,false,false,0,"/Years; /yrs; yearly","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per centimeter of water","/cm[H2O]","1/CM[H2O]","",0.000010197162129779282,[1,2,-1,0,0,0,0],"/cm\xa0HO<sub><r>2</r></sub>",null,false,null,null,1,false,false,0,"/cmH2O; /cm H2O; centimeters; centimetres","LOINC","InvPress","Clinical","",null,null,null,null,false],[false,"per day","/d","1/D","",0.000011574074074074073,[0,-1,0,0,0,0,0],"/d",null,false,null,null,1,false,false,0,"/dy; per day","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per deciliter","/dL","1/DL","",10000,[-3,0,0,0,0,0,0],"/dL",null,false,null,null,1,false,false,0,"per dL; /deciliter; decilitre","LOINC","NCnc","Clinical","",null,null,null,null,false],[false,"per gram","/g","1/G","",1,[0,0,-1,0,0,0,0],"/g",null,false,null,null,1,false,false,0,"/gm; /gram; per g","LOINC","NCnt","Clinical","",null,null,null,null,false],[false,"per hour","/h","1/HR","",0.0002777777777777778,[0,-1,0,0,0,0,0],"/h",null,false,null,null,1,false,false,0,"/hr; /hour; per hr","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per kilogram","/kg","1/KG","",0.001,[0,0,-1,0,0,0,0],"/kg",null,false,null,null,1,false,false,0,"per kg; per kilogram","LOINC","NCnt","Clinical","",null,null,null,null,false],[false,"per liter","/L","1/L","",1000,[-3,0,0,0,0,0,0],"/L",null,false,null,null,1,false,false,0,"/liter; litre","LOINC","NCnc","Clinical","",null,null,null,null,false],[false,"per square meter","/m2","1/M2","",1,[-2,0,0,0,0,0,0],"/m<sup>2</sup>",null,false,null,null,1,false,false,0,"/m^2; /m*2; /sq. m; per square meter; meter squared; metre","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"per cubic meter","/m3","1/M3","",1,[-3,0,0,0,0,0,0],"/m<sup>3</sup>",null,false,null,null,1,false,false,0,"/m^3; /m*3; /cu. m; per cubic meter; meter cubed; per m3; metre","LOINC","NCncn","Clinical","",null,null,null,null,false],[false,"per milligram","/mg","1/MG","",1000,[0,0,-1,0,0,0,0],"/mg",null,false,null,null,1,false,false,0,"/milligram; per mg","LOINC","NCnt","Clinical","",null,null,null,null,false],[false,"per minute","/min","1/MIN","",0.016666666666666666,[0,-1,0,0,0,0,0],"/min",null,false,null,null,1,false,false,0,"/minute; per mins; breaths beats per minute","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per milliliter","/mL","1/ML","",1000000,[-3,0,0,0,0,0,0],"/mL",null,false,null,null,1,false,false,0,"/milliliter; per mL; millilitre","LOINC","NCncn","Clinical","",null,null,null,null,false],[false,"per millimeter","/mm","1/MM","",1000,[-1,0,0,0,0,0,0],"/mm",null,false,null,null,1,false,false,0,"/millimeter; per mm; millimetre","LOINC","InvLen","Clinical","",null,null,null,null,false],[false,"per month","/mo","1/MO","",3.802570537683474e-7,[0,-1,0,0,0,0,0],"/mo",null,false,null,null,1,false,false,0,"/month; per mo; monthly; month","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per second","/s","1/S","",1,[0,-1,0,0,0,0,0],"/s",null,false,null,null,1,false,false,0,"/second; /sec; per sec; frequency; Hertz; Herz; Hz; becquerels; Bq; s-1; s^-1","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per enzyme unit","/U","1/U","",9.963241120049633e-17,[0,1,0,0,0,0,0],"/U",null,false,null,null,1,false,false,-1,"/enzyme units; per U","LOINC","InvC; NCat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)",null,null,null,null,false],[false,"per microliter","/uL","1/UL","",999999999.9999999,[-3,0,0,0,0,0,0],"/\u03bcL",null,false,null,null,1,false,false,0,"/microliter; microlitre; /mcl; per uL","LOINC","ACnc","Clinical","",null,null,null,null,false],[false,"per week","/wk","1/WK","",0.0000016534391534391535,[0,-1,0,0,0,0,0],"/wk",null,false,null,null,1,false,false,0,"/week; per wk; weekly, weeks","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"APL unit per milliliter","[APL\'U]/mL","[APL\'U]/ML","biologic activity of anticardiolipin IgA",1000000,[-3,0,0,0,0,0,0],"/mL","chemical",false,null,null,1,false,true,0,"APL/mL; APL\'U/mL; APL U/mL; APL/milliliter; IgA anticardiolipin units per milliliter; IgA Phospholipid Units; millilitre; biologic activity of","LOINC","ACnc","Clinical","Units for an anti phospholipid syndrome test","1","1","1",1,false],[false,"arbitrary unit per milliliter","[arb\'U]/mL","[ARB\'U]/ML","arbitrary",1000000,[-3,0,0,0,0,0,0],"(arb. U)/mL","chemical",false,null,null,1,false,true,0,"arb\'U/mL; arbU/mL; arb U/mL; arbitrary units per milliliter; millilitre","LOINC","ACnc","Clinical","relative unit of measurement to show the ratio of test measurement to reference measurement","1","1","1",1,false],[false,"colony forming units per liter","[CFU]/L","[CFU]/L","amount of a proliferating organism",1000,[-3,0,0,0,0,0,0],"CFU/L","chemical",false,null,null,1,false,true,0,"CFU per Liter; CFU/L","LOINC","NCnc","Clinical","","1","1","1",1,false],[false,"colony forming units per milliliter","[CFU]/mL","[CFU]/ML","amount of a proliferating organism",1000000,[-3,0,0,0,0,0,0],"CFU/mL","chemical",false,null,null,1,false,true,0,"CFU per mL; CFU/mL","LOINC","NCnc","Clinical","","1","1","1",1,false],[false,"foot per foot - US","[ft_us]/[ft_us]","[FT_US]/[FT_US]","length",1,[0,0,0,0,0,0,0],"(ft<sub>us</sub>)/(ft<sub>us</sub>)","us-lengths",false,null,null,1,false,false,0,"ft/ft; ft per ft; feet per feet; visual acuity","","LenRto","Clinical","distance ratio to measure 20:20 vision","m/3937","M/3937","1200",1200,false],[false,"GPL unit per milliliter","[GPL\'U]/mL","[GPL\'U]/ML","biologic activity of anticardiolipin IgG",1000000,[-3,0,0,0,0,0,0],"/mL","chemical",false,null,null,1,false,true,0,"GPL U/mL; GPL\'U/mL; GPL/mL; GPL U per mL; IgG Phospholipid Units per milliliters; IgG anticardiolipin units; millilitres ","LOINC","ACnc; AMass","Clinical","Units for an antiphospholipid test","1","1","1",1,false],[false,"international unit per 2 hour","[IU]/(2.h)","[IU]/(2.HR)","arbitrary",0.0001388888888888889,[0,-1,0,0,0,0,0],"(i.U.)/h","chemical",true,null,null,1,false,true,0,"IU/2hrs; IU/2 hours; IU per 2 hrs; international units per 2 hours","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per 24 hour","[IU]/(24.h)","[IU]/(24.HR)","arbitrary",0.000011574074074074073,[0,-1,0,0,0,0,0],"(i.U.)/h","chemical",true,null,null,1,false,true,0,"IU/24hr; IU/24 hours; IU per 24 hrs; international units per 24 hours","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per day","[IU]/d","[IU]/D","arbitrary",0.000011574074074074073,[0,-1,0,0,0,0,0],"(i.U.)/d","chemical",true,null,null,1,false,true,0,"IU/dy; IU/days; IU per dys; international units per day","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per deciliter","[IU]/dL","[IU]/DL","arbitrary",10000,[-3,0,0,0,0,0,0],"(i.U.)/dL","chemical",true,null,null,1,false,true,0,"IU/dL; IU per dL; international units per deciliters; decilitres","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per gram","[IU]/g","[IU]/G","arbitrary",1,[0,0,-1,0,0,0,0],"(i.U.)/g","chemical",true,null,null,1,false,true,0,"IU/gm; IU/gram; IU per gm; IU per g; international units per gram","LOINC","ACnt","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per hour","[IU]/h","[IU]/HR","arbitrary",0.0002777777777777778,[0,-1,0,0,0,0,0],"(i.U.)/h","chemical",true,null,null,1,false,true,0,"IU/hrs; IU per hours; international units per hour","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per kilogram","[IU]/kg","[IU]/KG","arbitrary",0.001,[0,0,-1,0,0,0,0],"(i.U.)/kg","chemical",true,null,null,1,false,true,0,"IU/kg; IU/kilogram; IU per kg; units","LOINC","ACnt","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per kilogram per day","[IU]/kg/d","([IU]/KG)/D","arbitrary",1.1574074074074074e-8,[0,-1,-1,0,0,0,0],"((i.U.)/kg)/d","chemical",true,null,null,1,false,true,0,"IU/kg/dy; IU/kg/day; IU/kilogram/day; IU per kg per day; units","LOINC","ACntRat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per liter","[IU]/L","[IU]/L","arbitrary",1000,[-3,0,0,0,0,0,0],"(i.U.)/L","chemical",true,null,null,1,false,true,0,"IU/L; IU/liter; IU per liter; units; litre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per minute","[IU]/min","[IU]/MIN","arbitrary",0.016666666666666666,[0,-1,0,0,0,0,0],"(i.U.)/min","chemical",true,null,null,1,false,true,0,"IU/min; IU/minute; IU per minute; international units","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per milliliter","[IU]/mL","[IU]/ML","arbitrary",1000000,[-3,0,0,0,0,0,0],"(i.U.)/mL","chemical",true,null,null,1,false,true,0,"IU/mL; IU per mL; international units per milliliter; millilitre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"MPL unit per milliliter","[MPL\'U]/mL","[MPL\'U]/ML","biologic activity of anticardiolipin IgM",1000000,[-3,0,0,0,0,0,0],"/mL","chemical",false,null,null,1,false,true,0,"MPL/mL; MPL U/mL; MPL\'U/mL; IgM anticardiolipin units; IgM Phospholipid Units; millilitre ","LOINC","ACnc","Clinical","units for antiphospholipid test\\n","1","1","1",1,false],[false,"number per high power field","{#}/[HPF]","{#}/[HPF]","",1,[0,0,0,0,0,0,0],"/HPF",null,false,null,null,1,false,false,0,"#/HPF; # per HPF; number/HPF; numbers per high power field","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"number per low power field","{#}/[LPF]","{#}/[LPF]","",1,[0,0,0,0,0,0,0],"/LPF",null,false,null,null,1,false,false,0,"#/LPF; # per LPF; number/LPF; numbers per low power field","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"IgA antiphosphatidylserine unit ","{APS\'U}","{APS\'U}","",1,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"APS Unit; Phosphatidylserine Antibody IgA Units","LOINC","ACnc","Clinical","unit for antiphospholipid test",null,null,null,null,false],[false,"EIA index","{EIA_index}","{EIA_index}","",1,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"enzyme immunoassay index","LOINC","ACnc","Clinical","",null,null,null,null,false],[false,"kaolin clotting time","{KCT\'U}","{KCT\'U}","",1,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"KCT","LOINC","Time","Clinical","sensitive\xa0test to detect\xa0lupus anticoagulants; measured in seconds",null,null,null,null,false],[false,"IgM antiphosphatidylserine unit","{MPS\'U}","{MPS\'U}","",1,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"Phosphatidylserine Antibody IgM Measurement ","LOINC","ACnc","Clinical","",null,null,null,null,false],[false,"trillion per liter","10*12/L","(10*12)/L","number",1000000000000000,[-3,0,0,0,0,0,0],"(10<sup>12</sup>)/L","dimless",false,null,null,1,false,false,0,"10^12/L; 10*12 per Liter; trillion per liter; litre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10^3 (used for cell count)","10*3","10*3","number",1000,[0,0,0,0,0,0,0],"10<sup>3</sup>","dimless",false,null,null,1,false,false,0,"10^3; thousand","LOINC","Num","Clinical","usually used for counting entities (e.g. blood cells) per volume","1","1","10",10,false],[false,"thousand per liter","10*3/L","(10*3)/L","number",1000000,[-3,0,0,0,0,0,0],"(10<sup>3</sup>)/L","dimless",false,null,null,1,false,false,0,"10^3/L; 10*3 per liter; litre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"thousand per milliliter","10*3/mL","(10*3)/ML","number",1000000000,[-3,0,0,0,0,0,0],"(10<sup>3</sup>)/mL","dimless",false,null,null,1,false,false,0,"10^3/mL; 10*3 per mL; thousand per milliliter; millilitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"thousand per microliter","10*3/uL","(10*3)/UL","number",999999999999.9999,[-3,0,0,0,0,0,0],"(10<sup>3</sup>)/\u03bcL","dimless",false,null,null,1,false,false,0,"10^3/uL; 10*3 per uL; thousand per microliter; microlitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10 thousand per microliter","10*4/uL","(10*4)/UL","number",10000000000000,[-3,0,0,0,0,0,0],"(10<sup>4</sup>)/\u03bcL","dimless",false,null,null,1,false,false,0,"10^4/uL; 10*4 per uL; microlitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10^5 ","10*5","10*5","number",100000,[0,0,0,0,0,0,0],"10<sup>5</sup>","dimless",false,null,null,1,false,false,0,"one hundred thousand","LOINC","Num","Clinical","","1","1","10",10,false],[false,"10^6","10*6","10*6","number",1000000,[0,0,0,0,0,0,0],"10<sup>6</sup>","dimless",false,null,null,1,false,false,0,"","LOINC","Num","Clinical","","1","1","10",10,false],[false,"million colony forming unit per liter","10*6.[CFU]/L","((10*6).[CFU])/L","number",1000000000,[-3,0,0,0,0,0,0],"((10<sup>6</sup>).CFU)/L","dimless",false,null,null,1,false,true,0,"10*6 CFU/L; 10^6 CFU/L; 10^6CFU; 10^6 CFU per liter; million colony forming units; litre","LOINC","ACnc","Clinical","","1","1","10",10,false],[false,"million international unit","10*6.[IU]","(10*6).[IU]","number",1000000,[0,0,0,0,0,0,0],"(10<sup>6</sup>).(i.U.)","dimless",false,null,null,1,false,true,0,"10*6 IU; 10^6 IU; international units","LOINC","arb","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","1","1","10",10,false],[false,"million per 24 hour","10*6/(24.h)","(10*6)/(24.HR)","number",11.574074074074074,[0,-1,0,0,0,0,0],"(10<sup>6</sup>)/h","dimless",false,null,null,1,false,false,0,"10*6/24hrs; 10^6/24 hrs; 10*6 per 24 hrs; 10^6 per 24 hours","LOINC","NRat","Clinical","","1","1","10",10,false],[false,"million per kilogram","10*6/kg","(10*6)/KG","number",1000,[0,0,-1,0,0,0,0],"(10<sup>6</sup>)/kg","dimless",false,null,null,1,false,false,0,"10^6/kg; 10*6 per kg; 10*6 per kilogram; millions","LOINC","NCnt","Clinical","","1","1","10",10,false],[false,"million per liter","10*6/L","(10*6)/L","number",1000000000,[-3,0,0,0,0,0,0],"(10<sup>6</sup>)/L","dimless",false,null,null,1,false,false,0,"10^6/L; 10*6 per Liter; 10^6 per Liter; litre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"million per milliliter","10*6/mL","(10*6)/ML","number",1000000000000,[-3,0,0,0,0,0,0],"(10<sup>6</sup>)/mL","dimless",false,null,null,1,false,false,0,"10^6/mL; 10*6 per mL; 10*6 per milliliter; millilitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"million per microliter","10*6/uL","(10*6)/UL","number",1000000000000000,[-3,0,0,0,0,0,0],"(10<sup>6</sup>)/\u03bcL","dimless",false,null,null,1,false,false,0,"10^6/uL; 10^6 per uL; 10^6/mcl; 10^6 per mcl; 10^6 per microliter; microlitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10^8","10*8","10*8","number",100000000,[0,0,0,0,0,0,0],"10<sup>8</sup>","dimless",false,null,null,1,false,false,0,"100 million; one hundred million; 10^8","LOINC","Num","Clinical","","1","1","10",10,false],[false,"billion per liter","10*9/L","(10*9)/L","number",1000000000000,[-3,0,0,0,0,0,0],"(10<sup>9</sup>)/L","dimless",false,null,null,1,false,false,0,"10^9/L; 10*9 per Liter; litre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"billion per milliliter","10*9/mL","(10*9)/ML","number",1000000000000000,[-3,0,0,0,0,0,0],"(10<sup>9</sup>)/mL","dimless",false,null,null,1,false,false,0,"10^9/mL; 10*9 per mL; 10^9 per mL; 10*9 per milliliter; millilitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"billion per microliter","10*9/uL","(10*9)/UL","number",1000000000000000000,[-3,0,0,0,0,0,0],"(10<sup>9</sup>)/\u03bcL","dimless",false,null,null,1,false,false,0,"10^9/uL; 10^9 per uL; 10^9/mcl; 10^9 per mcl; 10*9 per uL; 10*9 per mcl; 10*9/mcl; 10^9 per microliter; microlitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10 liter per minute per square meter","10.L/(min.m2)","(10.L)/(MIN.M2)","",0.00016666666666666666,[1,-1,0,0,0,0,0],"L/(min.(m<sup>2</sup>))",null,false,null,null,1,false,false,0,"10 liters per minutes per square meter; 10 L per min per m2; m^2; 10 L/(min*m2); 10L/(min*m^2); litres; sq. meter; metre; meters squared","LOINC","ArVRat","Clinical","",null,null,null,null,false],[false,"10 liter per minute","10.L/min","(10.L)/MIN","",0.00016666666666666666,[3,-1,0,0,0,0,0],"L/min",null,false,null,null,1,false,false,0,"10 liters per minute; 10 L per min; 10L; 10 L/min; litre","LOINC","VRat","Clinical","",null,null,null,null,false],[false,"10 micronewton second per centimeter to the fifth power per square meter","10.uN.s/(cm5.m2)","((10.UN).S)/(CM5.M2)","",100000000,[-6,-1,1,0,0,0,0],"(\u03bcN.s)/(cm<sup>5</sup>).(m<sup>2</sup>)",null,false,null,null,1,false,false,0,"dyne seconds per centimeter5 and square meter; dyn.s/(cm5.m2); dyn.s/cm5/m2; cm^5; m^2","LOINC","","Clinical","unit to measure systemic vascular resistance per body surface area",null,null,null,null,false],[false,"24 hour","24.h","24.HR","",86400,[0,1,0,0,0,0,0],"h",null,false,null,null,1,false,false,0,"24hrs; 24 hrs; 24 hours; days; dy","LOINC","Time","Clinical","",null,null,null,null,false],[false,"ampere per meter","A/m","A/M","electric current",1,[-1,-1,0,0,0,1,0],"A/m","si",true,null,null,1,false,false,0,"A/m; amp/meter; magnetic field strength; H; B; amperes per meter; metre","LOINC","","Clinical","unit of magnetic field strength","C/s","C/S","1",1,false],[false,"centigram","cg","CG","mass",0.01,[0,0,1,0,0,0,0],"cg",null,false,"M",null,1,false,false,0,"centigrams; cg; cgm","LOINC","Mass","Clinical","",null,null,null,null,false],[false,"centiliter","cL","CL","volume",0.00001,[3,0,0,0,0,0,0],"cL","iso1000",true,null,null,1,false,false,0,"centiliters; centilitres","LOINC","Vol","Clinical","","l",null,"1",1,false],[false,"centimeter","cm","CM","length",0.01,[1,0,0,0,0,0,0],"cm",null,false,"L",null,1,false,false,0,"centimeters; centimetres","LOINC","Len","Clinical","",null,null,null,null,false],[false,"centimeter of water","cm[H2O]","CM[H2O]","pressure",98066.5,[-1,-2,1,0,0,0,0],"cm\xa0HO<sub><r>2</r></sub>","clinical",true,null,null,1,false,false,0,"cm H2O; cmH2O; centimetres; pressure","LOINC","Pres","Clinical","unit of pressure mostly applies to blood pressure","kPa","KPAL","980665e-5",9.80665,false],[false,"centimeter of water per liter per second","cm[H2O]/L/s","(CM[H2O]/L)/S","pressure",98066500,[-4,-3,1,0,0,0,0],"((cm\xa0HO<sub><r>2</r></sub>)/L)/s","clinical",true,null,null,1,false,false,0,"cm[H2O]/(L/s); cm[H2O].s/L; cm H2O/L/sec; cmH2O/L/sec; cmH2O/Liter; cmH2O per L per secs; centimeters of water per liters per second; centimetres; litres; cm[H2O]/(L/s)","LOINC","PresRat","Clinical","unit used to measure mean pulmonary resistance","kPa","KPAL","980665e-5",9.80665,false],[false,"centimeter of water per second per meter","cm[H2O]/s/m","(CM[H2O]/S)/M","pressure",98066.5,[-2,-3,1,0,0,0,0],"((cm\xa0HO<sub><r>2</r></sub>)/s)/m","clinical",true,null,null,1,false,false,0,"cm[H2O]/(s.m); cm H2O/s/m; cmH2O; cmH2O/sec/m; cmH2O per secs per meters; centimeters of water per seconds per meter; centimetres; metre","LOINC","PresRat","Clinical","unit used to measure pulmonary pressure time product","kPa","KPAL","980665e-5",9.80665,false],[false,"centimeter of mercury","cm[Hg]","CM[HG]","pressure",1333220,[-1,-2,1,0,0,0,0],"cm\xa0Hg","clinical",true,null,null,1,false,false,0,"centimeters of mercury; centimetres; cmHg; cm Hg","LOINC","Pres","Clinical","unit of pressure where 1 cmHg = 10 torr","kPa","KPAL","133.3220",133.322,false],[false,"square centimeter","cm2","CM2","length",0.0001,[2,0,0,0,0,0,0],"cm<sup>2</sup>",null,false,"L",null,1,false,false,0,"cm^2; sq cm; centimeters squared; square centimeters; centimetre; area","LOINC","Area","Clinical","",null,null,null,null,false],[false,"square centimeter per second","cm2/s","CM2/S","length",0.0001,[2,-1,0,0,0,0,0],"(cm<sup>2</sup>)/s",null,false,"L",null,1,false,false,0,"cm^2/sec; square centimeters per second; sq cm per sec; cm2; centimeters squared; centimetres","LOINC","AreaRat","Clinical","",null,null,null,null,false],[false,"centipoise","cP","CP","dynamic viscosity",1.0000000000000002,[-1,-1,1,0,0,0,0],"cP","cgs",true,null,null,1,false,false,0,"cps; centiposes","LOINC","Visc","Clinical","unit of dynamic viscosity in the CGS system with base units: 10^\u22123 Pa.s = 1 mPa\xb7.s (1 millipascal second)","dyn.s/cm2","DYN.S/CM2","1",1,false],[false,"centistoke","cSt","CST","kinematic viscosity",0.000001,[2,-1,0,0,0,0,0],"cSt","cgs",true,null,null,1,false,false,0,"centistokes","LOINC","Visc","Clinical","unit for kinematic viscosity with base units of mm^2/s (square millimeter per second)","cm2/s","CM2/S","1",1,false],[false,"dekaliter per minute","daL/min","DAL/MIN","volume",0.00016666666666666666,[3,-1,0,0,0,0,0],"daL/min","iso1000",true,null,null,1,false,false,0,"dekalitres; dekaliters per minute; per min","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"dekaliter per minute per square meter","daL/min/m2","(DAL/MIN)/M2","volume",0.00016666666666666666,[1,-1,0,0,0,0,0],"(daL/min)/(m<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"daL/min/m^2; daL/minute/m2; sq. meter; dekaliters per minutes per square meter; meter squared; dekalitres; metre","LOINC","ArVRat","Clinical","The area usually is the body surface area used to normalize cardiovascular measures for patient\'s size","l",null,"1",1,false],[false,"decibel","dB","DB","level",1,[0,0,0,0,0,0,0],"dB","levels",true,null,"lg",0.1,true,false,0,"decibels","LOINC","LogRto","Clinical","unit most commonly used in acoustics as unit of sound pressure level. (also see B[SPL] or bel sound pressure level). ","1",null,null,1,false],[false,"degree per second","deg/s","DEG/S","plane angle",0.017453292519943295,[0,-1,0,1,0,0,0],"\xb0/s","iso1000",false,null,null,1,false,false,0,"deg/sec; deg per sec; \xb0/sec; twist rate; angular speed; rotational speed","LOINC","ARat","Clinical","unit of angular (rotational) speed used to express turning rate","[pi].rad/360","[PI].RAD/360","2",2,false],[false,"decigram","dg","DG","mass",0.1,[0,0,1,0,0,0,0],"dg",null,false,"M",null,1,false,false,0,"decigrams; dgm; 0.1 grams; 1/10 gm","LOINC","Mass","Clinical","equal to 1/10 gram",null,null,null,null,false],[false,"deciliter","dL","DL","volume",0.0001,[3,0,0,0,0,0,0],"dL","iso1000",true,null,null,1,false,false,0,"deciliters; decilitres; 0.1 liters; 1/10 L","LOINC","Vol","Clinical","equal to 1/10 liter","l",null,"1",1,false],[false,"decimeter","dm","DM","length",0.1,[1,0,0,0,0,0,0],"dm",null,false,"L",null,1,false,false,0,"decimeters; decimetres; 0.1 meters; 1/10 m; 10 cm; centimeters","LOINC","Len","Clinical","equal to 1/10 meter or 10 centimeters",null,null,null,null,false],[false,"square decimeter per square second","dm2/s2","DM2/S2","length",0.010000000000000002,[2,-2,0,0,0,0,0],"(dm<sup>2</sup>)/(s<sup>2</sup>)",null,false,"L",null,1,false,false,0,"dm2 per s2; dm^2/s^2; decimeters squared per second squared; sq dm; sq sec","LOINC","EngMass (massic energy)","Clinical","units for energy per unit mass or Joules per kilogram (J/kg = kg.m2/s2/kg = m2/s2) ",null,null,null,null,false],[false,"dyne second per centimeter per square meter","dyn.s/(cm.m2)","(DYN.S)/(CM.M2)","force",1,[-2,-1,1,0,0,0,0],"(dyn.s)/(cm.(m<sup>2</sup>))","cgs",true,null,null,1,false,false,0,"(dyn*s)/(cm*m2); (dyn*s)/(cm*m^2); dyn s per cm per m2; m^2; dyne seconds per centimeters per square meter; centimetres; sq. meter; squared","LOINC","","Clinical","","g.cm/s2","G.CM/S2","1",1,false],[false,"dyne second per centimeter","dyn.s/cm","(DYN.S)/CM","force",1,[0,-1,1,0,0,0,0],"(dyn.s)/cm","cgs",true,null,null,1,false,false,0,"(dyn*s)/cm; dyn sec per cm; seconds; centimetre; dyne seconds","LOINC","","Clinical","","g.cm/s2","G.CM/S2","1",1,false],[false,"equivalent per liter","eq/L","EQ/L","amount of substance",6.0221366999999994e+26,[-3,0,0,0,0,0,0],"eq/L","chemical",true,null,null,1,false,false,1,"eq/liter; eq/litre; eqs; equivalents per liter; litre","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"equivalent per milliliter","eq/mL","EQ/ML","amount of substance",6.0221367e+29,[-3,0,0,0,0,0,0],"eq/mL","chemical",true,null,null,1,false,false,1,"equivalent/milliliter; equivalents per milliliter; eq per mL; millilitre","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"equivalent per millimole","eq/mmol","EQ/MMOL","amount of substance",1000,[0,0,0,0,0,0,0],"eq/mmol","chemical",true,null,null,1,false,false,0,"equivalent/millimole; equivalents per millimole; eq per mmol","LOINC","SRto","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"equivalent per micromole","eq/umol","EQ/UMOL","amount of substance",1000000,[0,0,0,0,0,0,0],"eq/\u03bcmol","chemical",true,null,null,1,false,false,0,"equivalent/micromole; equivalents per micromole; eq per umol","LOINC","SRto","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"femtogram","fg","FG","mass",1e-15,[0,0,1,0,0,0,0],"fg",null,false,"M",null,1,false,false,0,"fg; fgm; femtograms; weight","LOINC","Mass","Clinical","equal to 10^-15 grams",null,null,null,null,false],[false,"femtoliter","fL","FL","volume",1e-18,[3,0,0,0,0,0,0],"fL","iso1000",true,null,null,1,false,false,0,"femtolitres; femtoliters","LOINC","Vol; EntVol","Clinical","equal to 10^-15 liters","l",null,"1",1,false],[false,"femtometer","fm","FM","length",1e-15,[1,0,0,0,0,0,0],"fm",null,false,"L",null,1,false,false,0,"femtometres; femtometers","LOINC","Len","Clinical","equal to 10^-15 meters",null,null,null,null,false],[false,"femtomole","fmol","FMOL","amount of substance",602213670,[0,0,0,0,0,0,0],"fmol","si",true,null,null,1,false,false,1,"femtomoles","LOINC","EntSub","Clinical","equal to 10^-15 moles","10*23","10*23","6.0221367",6.0221367,false],[false,"femtomole per gram","fmol/g","FMOL/G","amount of substance",602213670,[0,0,-1,0,0,0,0],"fmol/g","si",true,null,null,1,false,false,1,"femtomoles; fmol/gm; fmol per gm","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"femtomole per liter","fmol/L","FMOL/L","amount of substance",602213670000,[-3,0,0,0,0,0,0],"fmol/L","si",true,null,null,1,false,false,1,"femtomoles; fmol per liter; litre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"femtomole per milligram","fmol/mg","FMOL/MG","amount of substance",602213670000,[0,0,-1,0,0,0,0],"fmol/mg","si",true,null,null,1,false,false,1,"fmol per mg; femtomoles","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"femtomole per milliliter","fmol/mL","FMOL/ML","amount of substance",602213670000000,[-3,0,0,0,0,0,0],"fmol/mL","si",true,null,null,1,false,false,1,"femtomoles; millilitre; fmol per mL; fmol per milliliter","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"gram meter","g.m","G.M","mass",1,[1,0,1,0,0,0,0],"g.m",null,false,"M",null,1,false,false,0,"g*m; gxm; meters; metres","LOINC","Enrg","Clinical","Unit for measuring stroke work (heart work)",null,null,null,null,false],[false,"gram per 100 gram","g/(100.g)","G/(100.G)","mass",0.01,[0,0,0,0,0,0,0],"g/g",null,false,"M",null,1,false,false,0,"g/100 gm; 100gm; grams per 100 grams; gm per 100 gm","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"gram per 12 hour","g/(12.h)","G/(12.HR)","mass",0.000023148148148148147,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/12hrs; 12 hrs; gm per 12 hrs; 12hrs; grams per 12 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per 24 hour","g/(24.h)","G/(24.HR)","mass",0.000011574074074074073,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/24hrs; gm/24 hrs; gm per 24 hrs; 24hrs; grams per 24 hours; gm/dy; gm per dy; grams per day","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per 3 days","g/(3.d)","G/(3.D)","mass",0.000003858024691358025,[0,-1,1,0,0,0,0],"g/d",null,false,"M",null,1,false,false,0,"gm/3dy; gm/3 dy; gm per 3 days; grams","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per 4 hour","g/(4.h)","G/(4.HR)","mass",0.00006944444444444444,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/4hrs; gm/4 hrs; gm per 4 hrs; 4hrs; grams per 4 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per 48 hour","g/(48.h)","G/(48.HR)","mass",0.000005787037037037037,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/48hrs; gm/48 hrs; gm per 48 hrs; 48hrs; grams per 48 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per 5 hour","g/(5.h)","G/(5.HR)","mass",0.00005555555555555556,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/5hrs; gm/5 hrs; gm per 5 hrs; 5hrs; grams per 5 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per 6 hour","g/(6.h)","G/(6.HR)","mass",0.000046296296296296294,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/6hrs; gm/6 hrs; gm per 6 hrs; 6hrs; grams per 6 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per 72 hour","g/(72.h)","G/(72.HR)","mass",0.000003858024691358025,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/72hrs; gm/72 hrs; gm per 72 hrs; 72hrs; grams per 72 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per cubic centimeter","g/cm3","G/CM3","mass",999999.9999999999,[-3,0,1,0,0,0,0],"g/(cm<sup>3</sup>)",null,false,"M",null,1,false,false,0,"g/cm^3; gm per cm3; g per cm^3; grams per centimeter cubed; cu. cm; centimetre; g/mL; gram per milliliter; millilitre","LOINC","MCnc","Clinical","g/cm3 = g/mL",null,null,null,null,false],[false,"gram per day","g/d","G/D","mass",0.000011574074074074073,[0,-1,1,0,0,0,0],"g/d",null,false,"M",null,1,false,false,0,"gm/dy; gm per dy; grams per day; gm/24hrs; gm/24 hrs; gm per 24 hrs; 24hrs; grams per 24 hours; serving","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per deciliter","g/dL","G/DL","mass",10000,[-3,0,1,0,0,0,0],"g/dL",null,false,"M",null,1,false,false,0,"gm/dL; gm per dL; grams per deciliter; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"gram per gram","g/g","G/G","mass",1,[0,0,0,0,0,0,0],"g/g",null,false,"M",null,1,false,false,0,"gm; grams","LOINC","MRto ","Clinical","",null,null,null,null,false],[false,"gram per hour","g/h","G/HR","mass",0.0002777777777777778,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/hr; gm per hr; grams; intake; output","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per hour per square meter","g/h/m2","(G/HR)/M2","mass",0.0002777777777777778,[-2,-1,1,0,0,0,0],"(g/h)/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"gm/hr/m2; gm/h/m2; /m^2; sq. m; g per hr per m2; grams per hours per square meter; meter squared; metre","LOINC","ArMRat","Clinical","",null,null,null,null,false],[false,"gram per kilogram","g/kg ","G/KG","mass",0.001,[0,0,0,0,0,0,0],"g/kg",null,false,"M",null,1,false,false,0,"g per kg; gram per kilograms","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"gram per kilogram per 8 hour ","g/kg/(8.h)","(G/KG)/(8.HR)","mass",3.472222222222222e-8,[0,-1,0,0,0,0,0],"(g/kg)/h",null,false,"M",null,1,false,false,0,"g/(8.kg.h); gm/kg/8hrs; 8 hrs; g per kg per 8 hrs; 8hrs; grams per kilograms per 8 hours; shift","LOINC","MCntRat; RelMRat","Clinical","unit often used to describe mass in grams of protein consumed in a 8 hours, divided by the subject\'s body weight in kilograms. Also used to measure mass dose rate per body mass",null,null,null,null,false],[false,"gram per kilogram per day","g/kg/d","(G/KG)/D","mass",1.1574074074074074e-8,[0,-1,0,0,0,0,0],"(g/kg)/d",null,false,"M",null,1,false,false,0,"g/(kg.d); gm/kg/dy; gm per kg per dy; grams per kilograms per day","LOINC","RelMRat","Clinical","unit often used to describe mass in grams of protein consumed in a day, divided by the subject\'s body weight in kilograms. Also used to measure mass dose rate per body mass",null,null,null,null,false],[false,"gram per kilogram per hour","g/kg/h","(G/KG)/HR","mass",2.7777777777777776e-7,[0,-1,0,0,0,0,0],"(g/kg)/h",null,false,"M",null,1,false,false,0,"g/(kg.h); g/kg/hr; g per kg per hrs; grams per kilograms per hour","LOINC","MCntRat; RelMRat","Clinical","unit used to measure mass dose rate per body mass",null,null,null,null,false],[false,"gram per kilogram per minute","g/kg/min","(G/KG)/MIN","mass",0.000016666666666666667,[0,-1,0,0,0,0,0],"(g/kg)/min",null,false,"M",null,1,false,false,0,"g/(kg.min); g/kg/min; g per kg per min; grams per kilograms per minute","LOINC","MCntRat; RelMRat","Clinical","unit used to measure mass dose rate per body mass",null,null,null,null,false],[false,"gram per liter","g/L","G/L","mass",1000,[-3,0,1,0,0,0,0],"g/L",null,false,"M",null,1,false,false,0,"gm per liter; g/liter; grams per liter; litre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"gram per square meter","g/m2","G/M2","mass",1,[-2,0,1,0,0,0,0],"g/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"g/m^2; gram/square meter; g/sq m; g per m2; g per m^2; grams per square meter; meters squared; metre","LOINC","ArMass","Clinical","Tests measure myocardial mass (heart ventricle system) per body surface area; unit used to measure mass dose per body surface area",null,null,null,null,false],[false,"gram per milligram","g/mg","G/MG","mass",1000,[0,0,0,0,0,0,0],"g/mg",null,false,"M",null,1,false,false,0,"g per mg; grams per milligram","LOINC","MCnt; MRto","Clinical","",null,null,null,null,false],[false,"gram per minute","g/min","G/MIN","mass",0.016666666666666666,[0,-1,1,0,0,0,0],"g/min",null,false,"M",null,1,false,false,0,"g per min; grams per minute; gram/minute","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"gram per milliliter","g/mL","G/ML","mass",1000000,[-3,0,1,0,0,0,0],"g/mL",null,false,"M",null,1,false,false,0,"g per mL; grams per milliliter; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"gram per millimole","g/mmol","G/MMOL","mass",1.6605401866749388e-21,[0,0,1,0,0,0,0],"g/mmol",null,false,"M",null,1,false,false,-1,"grams per millimole; g per mmol","LOINC","Ratio","Clinical","",null,null,null,null,false],[false,"joule per liter","J/L","J/L","energy",1000000,[-1,-2,1,0,0,0,0],"J/L","si",true,null,null,1,false,false,0,"joules per liter; litre; J per L","LOINC","EngCnc","Clinical","","N.m","N.M","1",1,false],[false,"degree Kelvin per Watt","K/W","K/W","temperature",0.001,[-2,3,-1,0,1,0,0],"K/W",null,false,"C",null,1,false,false,0,"degree Kelvin/Watt; K per W; thermal ohm; thermal resistance; degrees","LOINC","TempEngRat","Clinical","unit for absolute thermal resistance equal to the reciprocal of thermal conductance. Unit used for tests to measure work of breathing",null,null,null,null,false],[false,"kilo international unit per liter","k[IU]/L","K[IU]/L","arbitrary",1000000,[-3,0,0,0,0,0,0],"(ki.U.)/L","chemical",true,null,null,1,false,true,0,"kIU/L; kIU per L; kIU per liter; kilo international units; litre; allergens; allergy units","LOINC","ACnc","Clinical","IgE has an WHO reference standard so IgE allergen testing can be reported as k[IU]/L","[iU]","[IU]","1",1,false],[false,"kilo international unit per milliliter","k[IU]/mL","K[IU]/ML","arbitrary",1000000000,[-3,0,0,0,0,0,0],"(ki.U.)/mL","chemical",true,null,null,1,false,true,0,"kIU/mL; kIU per mL; kIU per milliliter; kilo international units; millilitre; allergens; allergy units","LOINC","ACnc","Clinical","IgE has an WHO reference standard so IgE allergen testing can be reported as k[IU]/mL","[iU]","[IU]","1",1,false],[false,"katal per kilogram","kat/kg","KAT/KG","catalytic activity",602213670000000000000,[0,-1,-1,0,0,0,0],"kat/kg","chemical",true,null,null,1,false,false,1,"kat per kg; katals per kilogram; mol/s/kg; moles per seconds per kilogram","LOINC","CCnt","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"katal per liter","kat/L","KAT/L","catalytic activity",6.0221366999999994e+26,[-3,-1,0,0,0,0,0],"kat/L","chemical",true,null,null,1,false,false,1,"kat per L; katals per liter; litre; mol/s/L; moles per seconds per liter","LOINC","CCnc","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"kilocalorie","kcal","KCAL","energy",4184000,[2,-2,1,0,0,0,0],"kcal","heat",true,null,null,1,false,false,0,"kilogram calories; large calories; food calories; kcals","LOINC","EngRat","Clinical","It is equal to 1000 calories (equal to 4.184 kJ). But in practical usage, kcal refers to food calories which excludes caloric content in fiber and other constitutes that is not digestible by humans. Also see nutrition label Calories ([Cal])","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per 24 hour","kcal/(24.h)","KCAL/(24.HR)","energy",48.425925925925924,[2,-3,1,0,0,0,0],"kcal/h","heat",true,null,null,1,false,false,0,"kcal/24hrs; kcal/24 hrs; kcal per 24hrs; kilocalories per 24 hours; kilojoules; kJ/24hr; kJ/(24.h); kJ/dy; kilojoules per days; intake; calories burned; metabolic rate; food calories","","EngRat","Clinical","","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per ounce","kcal/[oz_av]","KCAL/[OZ_AV]","energy",147586.25679704445,[2,-2,0,0,0,0,0],"kcal/oz","heat",true,null,null,1,false,false,0,"kcal/oz; kcal per ozs; large calories per ounces; food calories; servings; international","LOINC","EngCnt","Clinical","used in nutrition to represent calorie of food","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per day","kcal/d","KCAL/D","energy",48.425925925925924,[2,-3,1,0,0,0,0],"kcal/d","heat",true,null,null,1,false,false,0,"kcal/dy; kcal per day; kilocalories per days; kilojoules; kJ/dy; kilojoules per days; intake; calories burned; metabolic rate; food calories","LOINC","EngRat","Clinical","unit in nutrition for food intake (measured in calories) in a day","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per hour","kcal/h","KCAL/HR","energy",1162.2222222222222,[2,-3,1,0,0,0,0],"kcal/h","heat",true,null,null,1,false,false,0,"kcal/hrs; kcals per hr; intake; kilocalories per hours; kilojoules","LOINC","EngRat","Clinical","used in nutrition to represent caloric requirement or consumption","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per kilogram per 24 hour","kcal/kg/(24.h)","(KCAL/KG)/(24.HR)","energy",0.04842592592592593,[2,-3,0,0,0,0,0],"(kcal/kg)/h","heat",true,null,null,1,false,false,0,"kcal/kg/24hrs; 24 hrs; kcal per kg per 24hrs; kilocalories per kilograms per 24 hours; kilojoules","LOINC","EngCntRat","Clinical","used in nutrition to represent caloric requirement per day based on subject\'s body weight in kilograms","cal_th","CAL_TH","1",1,false],[false,"kilogram","kg","KG","mass",1000,[0,0,1,0,0,0,0],"kg",null,false,"M",null,1,false,false,0,"kilograms; kgs","LOINC","Mass","Clinical","",null,null,null,null,false],[false,"kilogram meter per second","kg.m/s","(KG.M)/S","mass",1000,[1,-1,1,0,0,0,0],"(kg.m)/s",null,false,"M",null,1,false,false,0,"kg*m/s; kg.m per sec; kg*m per sec; p; momentum","LOINC","","Clinical","unit for momentum =  mass times velocity",null,null,null,null,false],[false,"kilogram per second per square meter","kg/(s.m2)","KG/(S.M2)","mass",1000,[-2,-1,1,0,0,0,0],"kg/(s.(m<sup>2</sup>))",null,false,"M",null,1,false,false,0,"kg/(s*m2); kg/(s*m^2); kg per s per m2; per sec; per m^2; kilograms per seconds per square meter; meter squared; metre","LOINC","ArMRat","Clinical","",null,null,null,null,false],[false,"kilogram per hour","kg/h","KG/HR","mass",0.2777777777777778,[0,-1,1,0,0,0,0],"kg/h",null,false,"M",null,1,false,false,0,"kg/hr; kg per hr; kilograms per hour","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"kilogram per liter","kg/L","KG/L","mass",1000000,[-3,0,1,0,0,0,0],"kg/L",null,false,"M",null,1,false,false,0,"kg per liter; litre; kilograms","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"kilogram per square meter","kg/m2","KG/M2","mass",1000,[-2,0,1,0,0,0,0],"kg/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"kg/m^2; kg/sq. m; kg per m2; per m^2; per sq. m; kilograms; meter squared; metre; BMI","LOINC","Ratio","Clinical","units for body mass index (BMI)",null,null,null,null,false],[false,"kilogram per cubic meter","kg/m3","KG/M3","mass",1000,[-3,0,1,0,0,0,0],"kg/(m<sup>3</sup>)",null,false,"M",null,1,false,false,0,"kg/m^3; kg/cu. m; kg per m3; per m^3; per cu. m; kilograms; meters cubed; metre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"kilogram per minute","kg/min","KG/MIN","mass",16.666666666666668,[0,-1,1,0,0,0,0],"kg/min",null,false,"M",null,1,false,false,0,"kilogram/minute; kg per min; kilograms per minute","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"kilogram per mole","kg/mol","KG/MOL","mass",1.6605401866749388e-21,[0,0,1,0,0,0,0],"kg/mol",null,false,"M",null,1,false,false,-1,"kilogram/mole; kg per mol; kilograms per mole","LOINC","SCnt","Clinical","",null,null,null,null,false],[false,"kilogram per second","kg/s","KG/S","mass",1000,[0,-1,1,0,0,0,0],"kg/s",null,false,"M",null,1,false,false,0,"kg/sec; kilogram/second; kg per sec; kilograms; second","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"kiloliter","kL","KL","volume",1,[3,0,0,0,0,0,0],"kL","iso1000",true,null,null,1,false,false,0,"kiloliters; kilolitres; m3; m^3; meters cubed; metre","LOINC","Vol","Clinical","","l",null,"1",1,false],[false,"kilometer","km","KM","length",1000,[1,0,0,0,0,0,0],"km",null,false,"L",null,1,false,false,0,"kilometers; kilometres; distance","LOINC","Len","Clinical","",null,null,null,null,false],[false,"kilopascal","kPa","KPAL","pressure",1000000,[-1,-2,1,0,0,0,0],"kPa","si",true,null,null,1,false,false,0,"kilopascals; pressure","LOINC","Pres; PPresDiff","Clinical","","N/m2","N/M2","1",1,false],[false,"kilosecond","ks","KS","time",1000,[0,1,0,0,0,0,0],"ks",null,false,"T",null,1,false,false,0,"kiloseconds; ksec","LOINC","Time","Clinical","",null,null,null,null,false],[false,"kilo enzyme unit","kU","KU","catalytic activity",10036894500000000000,[0,-1,0,0,0,0,0],"kU","chemical",true,null,null,1,false,false,1,"units; mmol/min; millimoles per minute","LOINC","CAct","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 kU = 1 mmol/min","umol/min","UMOL/MIN","1",1,false],[false,"kilo enzyme unit per gram","kU/g","KU/G","catalytic activity",10036894500000000000,[0,-1,-1,0,0,0,0],"kU/g","chemical",true,null,null,1,false,false,1,"units per grams; kU per gm","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 kU = 1 mmol/min","umol/min","UMOL/MIN","1",1,false],[false,"kilo enzyme unit per liter","kU/L","KU/L","catalytic activity",1.00368945e+22,[-3,-1,0,0,0,0,0],"kU/L","chemical",true,null,null,1,false,false,1,"units per liter; litre; enzymatic activity; enzyme activity per volume; activities","LOINC","ACnc; CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 kU = 1 mmol/min","umol/min","UMOL/MIN","1",1,false],[false,"kilo enzyme unit per milliliter","kU/mL","KU/ML","catalytic activity",1.00368945e+25,[-3,-1,0,0,0,0,0],"kU/mL","chemical",true,null,null,1,false,false,1,"kU per mL; units per milliliter; millilitre; enzymatic activity per volume; enzyme activities","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 kU = 1 mmol/min","umol/min","UMOL/MIN","1",1,false],[false,"Liters per 24 hour","L/(24.h)","L/(24.HR)","volume",1.1574074074074074e-8,[3,-1,0,0,0,0,0],"L/h","iso1000",true,null,null,1,false,false,0,"L/24hrs; L/24 hrs; L per 24hrs; liters per 24 hours; day; dy; litres; volume flow rate","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per 8 hour","L/(8.h)","L/(8.HR)","volume",3.472222222222222e-8,[3,-1,0,0,0,0,0],"L/h","iso1000",true,null,null,1,false,false,0,"L/8hrs; L/8 hrs; L per 8hrs; liters per 8 hours; litres; volume flow rate; shift","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per minute per square meter","L/(min.m2) ","L/(MIN.M2)","volume",0.000016666666666666667,[1,-1,0,0,0,0,0],"L/(min.(m<sup>2</sup>))","iso1000",true,null,null,1,false,false,0,"L/(min.m2); L/min/m^2; L/min/sq. meter; L per min per m2; m^2; liters per minutes per square meter; meter squared; litres; metre ","LOINC","ArVRat","Clinical","unit for tests that measure cardiac output per body surface area (cardiac index)","l",null,"1",1,false],[false,"Liters per day","L/d","L/D","volume",1.1574074074074074e-8,[3,-1,0,0,0,0,0],"L/d","iso1000",true,null,null,1,false,false,0,"L/dy; L per day; 24hrs; 24 hrs; 24 hours; liters; litres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per hour","L/h","L/HR","volume",2.7777777777777776e-7,[3,-1,0,0,0,0,0],"L/h","iso1000",true,null,null,1,false,false,0,"L/hr; L per hr; litres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per kilogram","L/kg","L/KG","volume",0.000001,[3,0,-1,0,0,0,0],"L/kg","iso1000",true,null,null,1,false,false,0,"L per kg; litre","LOINC","VCnt","Clinical","","l",null,"1",1,false],[false,"Liters per liter","L/L","L/L","volume",1,[0,0,0,0,0,0,0],"L/L","iso1000",true,null,null,1,false,false,0,"L per L; liter/liter; litre","LOINC","VFr","Clinical","","l",null,"1",1,false],[false,"Liters per minute","L/min","L/MIN","volume",0.000016666666666666667,[3,-1,0,0,0,0,0],"L/min","iso1000",true,null,null,1,false,false,0,"liters per minute; litre","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per minute per square meter","L/min/m2","(L/MIN)/M2","volume",0.000016666666666666667,[1,-1,0,0,0,0,0],"(L/min)/(m<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"L/(min.m2); L/min/m^2; L/min/sq. meter; L per min per m2; m^2; liters per minutes per square meter; meter squared; litres; metre ","","ArVRat","Clinical","unit for tests that measure cardiac output per body surface area (cardiac index)","l",null,"1",1,false],[false,"Liters per second","L/s","L/S","volume",0.001,[3,-1,0,0,0,0,0],"L/s","iso1000",true,null,null,1,false,false,0,"L per sec; litres","LOINC","VRat","Clinical","unit used often to measure gas flow and peak expiratory flow","l",null,"1",1,false],[false,"Liters per second per square second","L/s/s2","(L/S)/S2","volume",0.001,[3,-3,0,0,0,0,0],"(L/s)/(s<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"L/s/s^2; L/sec/sec2; L/sec/sec^2; L/sec/sq. sec; L per s per s2; L per sec per sec2; s^2; sec^2; liters per seconds per square second; second squared; litres ","LOINC","ArVRat","Clinical","unit for tests that measure cardiac output/body surface area","l",null,"1",1,false],[false,"lumen square meter","lm.m2","LM.M2","luminous flux",1,[2,0,0,2,0,0,1],"lm.(m<sup>2</sup>)","si",true,null,null,1,false,false,0,"lm*m2; lm*m^2; lumen meters squared; lumen sq. meters; metres","LOINC","","Clinical","","cd.sr","CD.SR","1",1,false],[false,"meter per second","m/s","M/S","length",1,[1,-1,0,0,0,0,0],"m/s",null,false,"L",null,1,false,false,0,"meter/second; m per sec; meters per second; metres; velocity; speed","LOINC","Vel","Clinical","unit of velocity",null,null,null,null,false],[false,"meter per square second","m/s2","M/S2","length",1,[1,-2,0,0,0,0,0],"m/(s<sup>2</sup>)",null,false,"L",null,1,false,false,0,"m/s^2; m/sq. sec; m per s2; per s^2; meters per square second; second squared; sq second; metres; acceleration","LOINC","Accel","Clinical","unit of acceleration",null,null,null,null,false],[false,"milli international unit per liter","m[IU]/L","M[IU]/L","arbitrary",1,[-3,0,0,0,0,0,0],"(mi.U.)/L","chemical",true,null,null,1,false,true,0,"mIU/L; m IU/L; mIU per liter; units; litre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"milli  international unit per milliliter","m[IU]/mL","M[IU]/ML","arbitrary",1000.0000000000001,[-3,0,0,0,0,0,0],"(mi.U.)/mL","chemical",true,null,null,1,false,true,0,"mIU/mL; m IU/mL; mIU per mL; milli international units per milliliter; millilitre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"square meter","m2","M2","length",1,[2,0,0,0,0,0,0],"m<sup>2</sup>",null,false,"L",null,1,false,false,0,"m^2; sq m; square meters; meters squared; metres","LOINC","Area","Clinical","unit often used to represent body surface area",null,null,null,null,false],[false,"square meter per second","m2/s","M2/S","length",1,[2,-1,0,0,0,0,0],"(m<sup>2</sup>)/s",null,false,"L",null,1,false,false,0,"m^2/sec; m2 per sec; m^2 per sec; sq m/sec; meters squared/seconds; sq m per sec; meters squared; metres","LOINC","ArRat","Clinical","",null,null,null,null,false],[false,"cubic meter per second","m3/s","M3/S","length",1,[3,-1,0,0,0,0,0],"(m<sup>3</sup>)/s",null,false,"L",null,1,false,false,0,"m^3/sec; m3 per sec; m^3 per sec; cu m/sec; cubic meters per seconds; meters cubed; metres","LOINC","VRat","Clinical","",null,null,null,null,false],[false,"milliampere","mA","MA","electric current",0.001,[0,-1,0,0,0,1,0],"mA","si",true,null,null,1,false,false,0,"mamp; milliamperes","LOINC","ElpotRat","Clinical","unit of electric current","C/s","C/S","1",1,false],[false,"millibar","mbar","MBAR","pressure",100000,[-1,-2,1,0,0,0,0],"mbar","iso1000",true,null,null,1,false,false,0,"millibars","LOINC","Pres","Clinical","unit of pressure","Pa","PAL","1e5",100000,false],[false,"millibar second per liter","mbar.s/L","(MBAR.S)/L","pressure",100000000,[-4,-1,1,0,0,0,0],"(mbar.s)/L","iso1000",true,null,null,1,false,false,0,"mbar*s/L; mbar.s per L; mbar*s per L; millibar seconds per liter; millibar second per litre","LOINC","","Clinical","unit to measure expiratory resistance","Pa","PAL","1e5",100000,false],[false,"millibar per liter per second","mbar/L/s","(MBAR/L)/S","pressure",100000000,[-4,-3,1,0,0,0,0],"(mbar/L)/s","iso1000",true,null,null,1,false,false,0,"mbar/(L.s); mbar/L/sec; mbar/liter/second; mbar per L per sec; mbar per liter per second; millibars per liters per seconds; litres","LOINC","PresCncRat","Clinical","unit to measure expiratory resistance","Pa","PAL","1e5",100000,false],[false,"milliequivalent","meq","MEQ","amount of substance",602213670000000000000,[0,0,0,0,0,0,0],"meq","chemical",true,null,null,1,false,false,1,"milliequivalents; meqs","LOINC","Sub","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per 2 hour","meq/(2.h)","MEQ/(2.HR)","amount of substance",83640787500000000,[0,-1,0,0,0,0,0],"meq/h","chemical",true,null,null,1,false,false,1,"meq/2hrs; meq/2 hrs; meq per 2 hrs; milliequivalents per 2 hours","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per 24 hour","meq/(24.h)","MEQ/(24.HR)","amount of substance",6970065625000000,[0,-1,0,0,0,0,0],"meq/h","chemical",true,null,null,1,false,false,1,"meq/24hrs; meq/24 hrs; meq per 24 hrs; milliequivalents per 24 hours","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per 8 hour","meq/(8.h)","MEQ/(8.HR)","amount of substance",20910196875000000,[0,-1,0,0,0,0,0],"meq/h","chemical",true,null,null,1,false,false,1,"meq/8hrs; meq/8 hrs; meq per 8 hrs; milliequivalents per 8 hours; shift","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per day","meq/d","MEQ/D","amount of substance",6970065625000000,[0,-1,0,0,0,0,0],"meq/d","chemical",true,null,null,1,false,false,1,"meq/dy; meq per day; milliquivalents per days; meq/24hrs; meq/24 hrs; meq per 24 hrs; milliequivalents per 24 hours","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per deciliter","meq/dL","MEQ/DL","amount of substance",6.022136699999999e+24,[-3,0,0,0,0,0,0],"meq/dL","chemical",true,null,null,1,false,false,1,"meq per dL; milliequivalents per deciliter; decilitre","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per gram","meq/g","MEQ/G","amount of substance",602213670000000000000,[0,0,-1,0,0,0,0],"meq/g","chemical",true,null,null,1,false,false,1,"mgq/gm; meq per gm; milliequivalents per gram","LOINC","MCnt","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per hour","meq/h","MEQ/HR","amount of substance",167281575000000000,[0,-1,0,0,0,0,0],"meq/h","chemical",true,null,null,1,false,false,1,"meq/hrs; meq per hrs; milliequivalents per hour","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per kilogram","meq/kg","MEQ/KG","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"meq/kg","chemical",true,null,null,1,false,false,1,"meq per kg; milliequivalents per kilogram","LOINC","SCnt","Clinical","equivalence equals moles per valence; used to measure dose per patient body mass","mol","MOL","1",1,false],[false,"milliequivalent per kilogram per hour","meq/kg/h","(MEQ/KG)/HR","amount of substance",167281575000000,[0,-1,-1,0,0,0,0],"(meq/kg)/h","chemical",true,null,null,1,false,false,1,"meq/(kg.h); meq/kg/hr; meq per kg per hr; milliequivalents per kilograms per hour","LOINC","SCntRat","Clinical","equivalence equals moles per valence; unit used to measure dose rate per patient body mass","mol","MOL","1",1,false],[false,"milliequivalent per liter","meq/L","MEQ/L","amount of substance",6.0221367e+23,[-3,0,0,0,0,0,0],"meq/L","chemical",true,null,null,1,false,false,1,"milliequivalents per liter; litre; meq per l; acidity","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per square meter","meq/m2","MEQ/M2","amount of substance",602213670000000000000,[-2,0,0,0,0,0,0],"meq/(m<sup>2</sup>)","chemical",true,null,null,1,false,false,1,"meq/m^2; meq/sq. m; milliequivalents per square meter; meter squared; metre","LOINC","ArSub","Clinical","equivalence equals moles per valence; note that the use of m2 in clinical units ofter refers to body surface area","mol","MOL","1",1,false],[false,"milliequivalent per minute","meq/min","MEQ/MIN","amount of substance",10036894500000000000,[0,-1,0,0,0,0,0],"meq/min","chemical",true,null,null,1,false,false,1,"meq per min; milliequivalents per minute","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per milliliter","meq/mL","MEQ/ML","amount of substance",6.0221367e+26,[-3,0,0,0,0,0,0],"meq/mL","chemical",true,null,null,1,false,false,1,"meq per mL; milliequivalents per milliliter; millilitre","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milligram","mg","MG","mass",0.001,[0,0,1,0,0,0,0],"mg",null,false,"M",null,1,false,false,0,"milligrams","LOINC","Mass","Clinical","",null,null,null,null,false],[false,"milligram per 10 hour","mg/(10.h)","MG/(10.HR)","mass",2.7777777777777777e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/10hrs; mg/10 hrs; mg per 10 hrs; milligrams per 10 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"milligram per 12 hour","mg/(12.h)","MG/(12.HR)","mass",2.3148148148148148e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/12hrs; mg/12 hrs; per 12 hrs; 12hrs; milligrams per 12 hours","LOINC","MRat","Clinical","units used for tests in urine",null,null,null,null,false],[false,"milligram per 2 hour","mg/(2.h)","MG/(2.HR)","mass",1.3888888888888888e-7,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/2hrs; mg/2 hrs; mg per 2 hrs; 2hrs; milligrams per 2 hours","LOINC","MRat","Clinical","units used for tests in urine",null,null,null,null,false],[false,"milligram per 24 hour","mg/(24.h)","MG/(24.HR)","mass",1.1574074074074074e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/24hrs; mg/24 hrs; milligrams per 24 hours; mg/kg/dy; mg per kg per day; milligrams per kilograms per days","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"milligram per 6 hour","mg/(6.h)","MG/(6.HR)","mass",4.6296296296296295e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/6hrs; mg/6 hrs; mg per 6 hrs; 6hrs; milligrams per 6 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"milligram per 72 hour","mg/(72.h)","MG/(72.HR)","mass",3.858024691358025e-9,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/72hrs; mg/72 hrs; 72 hrs; 72hrs; milligrams per 72 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"milligram per 8 hour","mg/(8.h)","MG/(8.HR)","mass",3.472222222222222e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/8hrs; mg/8 hrs; milligrams per 8 hours; shift","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"milligram per day","mg/d","MG/D","mass",1.1574074074074074e-8,[0,-1,1,0,0,0,0],"mg/d",null,false,"M",null,1,false,false,0,"mg/24hrs; mg/24 hrs; milligrams per 24 hours; mg/dy; mg per day; milligrams","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"milligram per deciliter","mg/dL","MG/DL","mass",10,[-3,0,1,0,0,0,0],"mg/dL",null,false,"M",null,1,false,false,0,"mg per dL; milligrams per deciliter; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"milligram per gram","mg/g","MG/G","mass",0.001,[0,0,0,0,0,0,0],"mg/g",null,false,"M",null,1,false,false,0,"mg per gm; milligrams per gram","LOINC","MCnt; MRto","Clinical","",null,null,null,null,false],[false,"milligram per hour","mg/h","MG/HR","mass",2.7777777777777776e-7,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/hr; mg per hr; milligrams","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"milligram per kilogram","mg/kg","MG/KG","mass",0.000001,[0,0,0,0,0,0,0],"mg/kg",null,false,"M",null,1,false,false,0,"mg per kg; milligrams per kilograms","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"milligram per kilogram per 8 hour","mg/kg/(8.h)","(MG/KG)/(8.HR)","mass",3.472222222222222e-11,[0,-1,0,0,0,0,0],"(mg/kg)/h",null,false,"M",null,1,false,false,0,"mg/(8.h.kg); mg/kg/8hrs; mg/kg/8 hrs; mg per kg per 8hrs; 8 hrs; milligrams per kilograms per 8 hours; shift","LOINC","RelMRat; MCntRat","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"milligram per kilogram per day","mg/kg/d","(MG/KG)/D","mass",1.1574074074074074e-11,[0,-1,0,0,0,0,0],"(mg/kg)/d",null,false,"M",null,1,false,false,0,"mg/(kg.d); mg/(kg.24.h)mg/kg/dy; mg per kg per day; milligrams per kilograms per days; mg/kg/(24.h); mg/kg/24hrs; 24 hrs; 24 hours","LOINC","RelMRat ","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"milligram per kilogram per hour","mg/kg/h","(MG/KG)/HR","mass",2.7777777777777777e-10,[0,-1,0,0,0,0,0],"(mg/kg)/h",null,false,"M",null,1,false,false,0,"mg/(kg.h); mg/kg/hr; mg per kg per hr; milligrams per kilograms per hour","LOINC","RelMRat; MCntRat","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"milligram per kilogram per minute","mg/kg/min","(MG/KG)/MIN","mass",1.6666666666666667e-8,[0,-1,0,0,0,0,0],"(mg/kg)/min",null,false,"M",null,1,false,false,0,"mg/(kg.min); mg per kg per min; milligrams per kilograms per minute","LOINC","RelMRat; MCntRat","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"milligram per liter","mg/L","MG/L","mass",1,[-3,0,1,0,0,0,0],"mg/L",null,false,"M",null,1,false,false,0,"mg per l; milligrams per liter; litre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"milligram per square meter","mg/m2","MG/M2","mass",0.001,[-2,0,1,0,0,0,0],"mg/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"mg/m^2; mg/sq. m; mg per m2; mg per m^2; mg per sq. milligrams; meter squared; metre","LOINC","ArMass","Clinical","",null,null,null,null,false],[false,"milligram per cubic meter","mg/m3","MG/M3","mass",0.001,[-3,0,1,0,0,0,0],"mg/(m<sup>3</sup>)",null,false,"M",null,1,false,false,0,"mg/m^3; mg/cu. m; mg per m3; milligrams per cubic meter; meter cubed; metre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"milligram per milligram","mg/mg","MG/MG","mass",1,[0,0,0,0,0,0,0],"mg/mg",null,false,"M",null,1,false,false,0,"mg per mg; milligrams; milligram/milligram","LOINC","MRto","Clinical","",null,null,null,null,false],[false,"milligram per minute","mg/min","MG/MIN","mass",0.000016666666666666667,[0,-1,1,0,0,0,0],"mg/min",null,false,"M",null,1,false,false,0,"mg per min; milligrams per minutes; milligram/minute","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"milligram per milliliter","mg/mL","MG/ML","mass",1000.0000000000001,[-3,0,1,0,0,0,0],"mg/mL",null,false,"M",null,1,false,false,0,"mg per mL; milligrams per milliliters; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"milligram per millimole","mg/mmol","MG/MMOL","mass",1.660540186674939e-24,[0,0,1,0,0,0,0],"mg/mmol",null,false,"M",null,1,false,false,-1,"mg per mmol; milligrams per millimole; ","LOINC","Ratio","Clinical","",null,null,null,null,false],[false,"milligram per week","mg/wk","MG/WK","mass",1.6534391534391535e-9,[0,-1,1,0,0,0,0],"mg/wk",null,false,"M",null,1,false,false,0,"mg/week; mg per wk; milligrams per weeks; milligram/week","LOINC","Mrat","Clinical","",null,null,null,null,false],[false,"milliliter","mL","ML","volume",0.000001,[3,0,0,0,0,0,0],"mL","iso1000",true,null,null,1,false,false,0,"milliliters; millilitres","LOINC","Vol","Clinical","","l",null,"1",1,false],[false,"milliliter per 10 hour","mL/(10.h)","ML/(10.HR)","volume",2.7777777777777777e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/10hrs; ml/10 hrs; mL per 10hrs; 10 hrs; milliliters per 10 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 12 hour","mL/(12.h)","ML/(12.HR)","volume",2.3148148148148147e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/12hrs; ml/12 hrs; mL per 12hrs; 12 hrs; milliliters per 12 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 2 hour","mL/(2.h)","ML/(2.HR)","volume",1.3888888888888888e-10,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/2hrs; ml/2 hrs; mL per 2hrs; 2 hrs; milliliters per 2 hours; millilitres ","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 24 hour","mL/(24.h)","ML/(24.HR)","volume",1.1574074074074074e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/24hrs; ml/24 hrs; mL per 24hrs; 24 hrs; milliliters per 24 hours; millilitres; ml/dy; /day; ml per dy; days; fluid outputs; fluid inputs; flow rate","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 4 hour","mL/(4.h)","ML/(4.HR)","volume",6.944444444444444e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/4hrs; ml/4 hrs; mL per 4hrs; 4 hrs; milliliters per 4 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 5 hour","mL/(5.h)","ML/(5.HR)","volume",5.5555555555555553e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/5hrs; ml/5 hrs; mL per 5hrs; 5 hrs; milliliters per 5 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 6 hour","mL/(6.h)","ML/(6.HR)","volume",4.6296296296296294e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/6hrs; ml/6 hrs; mL per 6hrs; 6 hrs; milliliters per 6 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 72 hour","mL/(72.h)","ML/(72.HR)","volume",3.8580246913580245e-12,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/72hrs; ml/72 hrs; mL per 72hrs; 72 hrs; milliliters per 72 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 8 hour","mL/(8.h)","ML/(8.HR)","volume",3.472222222222222e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/8hrs; ml/8 hrs; mL per 8hrs; 8 hrs; milliliters per 8 hours; millilitres; shift","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 8 hour per kilogram","mL/(8.h)/kg","(ML/(8.HR))/KG","volume",3.472222222222222e-14,[3,-1,-1,0,0,0,0],"(mL/h)/kg","iso1000",true,null,null,1,false,false,0,"mL/kg/(8.h); ml/8h/kg; ml/8 h/kg; ml/8hr/kg; ml/8 hr/kgr; mL per 8h per kg; 8 h; 8hr; 8 hr; milliliters per 8 hours per kilogram; millilitres; shift","LOINC","VRatCnt","Clinical","unit used to measure renal excretion volume rate per body mass","l",null,"1",1,false],[false,"milliliter per square inch (international)","mL/[sin_i]","ML/[SIN_I]","volume",0.0015500031000061998,[1,0,0,0,0,0,0],"mL","iso1000",true,null,null,1,false,false,0,"mL/sin; mL/in2; mL/in^2; mL per sin; in2; in^2; sq. in; milliliters per square inch; inch squared","LOINC","ArVol","Clinical","","l",null,"1",1,false],[false,"milliliter per centimeter of water","mL/cm[H2O]","ML/CM[H2O]","volume",1.0197162129779282e-11,[4,2,-1,0,0,0,0],"mL/(cm\xa0HO<sub><r>2</r></sub>)","iso1000",true,null,null,1,false,false,0,"milliliters per centimeter of water; millilitre per centimetre of water; millilitres per centimetre of water; mL/cmH2O; mL/cm H2O; mL per cmH2O; mL per cm H2O","LOINC","Compli","Clinical","unit used to measure dynamic lung compliance","l",null,"1",1,false],[false,"milliliter per day","mL/d","ML/D","volume",1.1574074074074074e-11,[3,-1,0,0,0,0,0],"mL/d","iso1000",true,null,null,1,false,false,0,"ml/day; ml per day; milliliters per day; 24 hours; 24hrs; millilitre;","LOINC","VRat","Clinical","usually used to measure fluid output or input; flow rate","l",null,"1",1,false],[false,"milliliter per deciliter","mL/dL","ML/DL","volume",0.009999999999999998,[0,0,0,0,0,0,0],"mL/dL","iso1000",true,null,null,1,false,false,0,"mL per dL; millilitres; decilitre; milliliters","LOINC","VFr; VFrDiff","Clinical","","l",null,"1",1,false],[false,"milliliter per hour","mL/h","ML/HR","volume",2.7777777777777777e-10,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"mL/hr; mL per hr; milliliters per hour; millilitres; fluid intake; fluid output","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per kilogram","mL/kg","ML/KG","volume",9.999999999999999e-10,[3,0,-1,0,0,0,0],"mL/kg","iso1000",true,null,null,1,false,false,0,"mL per kg; milliliters per kilogram; millilitres","LOINC","VCnt","Clinical","","l",null,"1",1,false],[false,"milliliter per kilogram per 8 hour","mL/kg/(8.h)","(ML/KG)/(8.HR)","volume",3.472222222222222e-14,[3,-1,-1,0,0,0,0],"(mL/kg)/h","iso1000",true,null,null,1,false,false,0,"mL/(8.h.kg); mL/kg/8hrs; mL/kg/8 hrs; mL per kg per 8hrs; 8 hrs; milliliters per kilograms per 8 hours; millilitres; shift","LOINC","VCntRat; RelEngRat","Clinical","unit used to measure renal excretion volume rate per body mass","l",null,"1",1,false],[false,"milliliter per kilogram per day","mL/kg/d","(ML/KG)/D","volume",1.1574074074074072e-14,[3,-1,-1,0,0,0,0],"(mL/kg)/d","iso1000",true,null,null,1,false,false,0,"mL/(kg.d); mL/kg/dy; mL per kg per day; milliliters per kilograms per day; mg/kg/24hrs; 24 hrs; per 24 hours millilitres","LOINC","VCntRat; RelEngRat","Clinical","unit used to measure renal excretion volume rate per body mass","l",null,"1",1,false],[false,"milliliter per kilogram per hour","mL/kg/h","(ML/KG)/HR","volume",2.7777777777777774e-13,[3,-1,-1,0,0,0,0],"(mL/kg)/h","iso1000",true,null,null,1,false,false,0,"mL/(kg.h); mL/kg/hr; mL per kg per hr; milliliters per kilograms per hour; millilitres","LOINC","VCntRat; RelEngRat","Clinical","unit used to measure renal excretion volume rate per body mass","l",null,"1",1,false],[false,"milliliter per kilogram per minute","mL/kg/min","(ML/KG)/MIN","volume",1.6666666666666664e-11,[3,-1,-1,0,0,0,0],"(mL/kg)/min","iso1000",true,null,null,1,false,false,0,"mL/(kg.min); mL/kg/dy; mL per kg per day; milliliters per kilograms per day; millilitres","LOINC","RelEngRat","Clinical","used for tests that measure activity metabolic rate compared to standard resting metabolic rate ","l",null,"1",1,false],[false,"milliliter per square meter","mL/m2","ML/M2","volume",0.000001,[1,0,0,0,0,0,0],"mL/(m<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"mL/m^2; mL/sq. meter; mL per m2; m^2; sq. meter; milliliters per square meter; millilitres; meter squared","LOINC","ArVol","Clinical","used for tests that relate to heart work - e.g. ventricular stroke volume; atrial volume per body surface area","l",null,"1",1,false],[false,"milliliter per millibar","mL/mbar","ML/MBAR","volume",1e-11,[4,2,-1,0,0,0,0],"mL/mbar","iso1000",true,null,null,1,false,false,0,"mL per mbar; milliliters per millibar; millilitres","LOINC","","Clinical","unit used to measure dynamic lung compliance","l",null,"1",1,false],[false,"milliliter per minute","mL/min","ML/MIN","volume",1.6666666666666667e-8,[3,-1,0,0,0,0,0],"mL/min","iso1000",true,null,null,1,false,false,0,"mL per min; milliliters; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per minute per square meter","mL/min/m2","(ML/MIN)/M2","volume",1.6666666666666667e-8,[1,-1,0,0,0,0,0],"(mL/min)/(m<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"ml/min/m^2; ml/min/sq. meter; mL per min per m2; m^2; sq. meter; milliliters per minutes per square meter; millilitres; metre; meter squared","LOINC","ArVRat","Clinical","unit used to measure volume per body surface area; oxygen consumption index","l",null,"1",1,false],[false,"milliliter per millimeter","mL/mm","ML/MM","volume",0.001,[2,0,0,0,0,0,0],"mL/mm","iso1000",true,null,null,1,false,false,0,"mL per mm; milliliters per millimeter; millilitres; millimetre","LOINC","Lineic Volume","Clinical","","l",null,"1",1,false],[false,"milliliter per second","mL/s","ML/S","volume",0.000001,[3,-1,0,0,0,0,0],"mL/s","iso1000",true,null,null,1,false,false,0,"ml/sec; mL per sec; milliliters per second; millilitres","LOINC","Vel; VelRat; VRat","Clinical","","l",null,"1",1,false],[false,"millimeter","mm","MM","length",0.001,[1,0,0,0,0,0,0],"mm",null,false,"L",null,1,false,false,0,"millimeters; millimetres; height; length; diameter; thickness; axis; curvature; size","LOINC","Len","Clinical","",null,null,null,null,false],[false,"millimeter per hour","mm/h","MM/HR","length",2.7777777777777776e-7,[1,-1,0,0,0,0,0],"mm/h",null,false,"L",null,1,false,false,0,"mm/hr; mm per hr; millimeters per hour; millimetres","LOINC","Vel","Clinical","unit to measure sedimentation rate",null,null,null,null,false],[false,"millimeter per minute","mm/min","MM/MIN","length",0.000016666666666666667,[1,-1,0,0,0,0,0],"mm/min",null,false,"L",null,1,false,false,0,"mm per min; millimeters per minute; millimetres","LOINC","Vel","Clinical","",null,null,null,null,false],[false,"millimeter of water","mm[H2O]","MM[H2O]","pressure",9806.65,[-1,-2,1,0,0,0,0],"mm\xa0HO<sub><r>2</r></sub>","clinical",true,null,null,1,false,false,0,"mmH2O; mm H2O; millimeters of water; millimetres","LOINC","Pres","Clinical","","kPa","KPAL","980665e-5",9.80665,false],[false,"millimeter of mercury","mm[Hg]","MM[HG]","pressure",133322,[-1,-2,1,0,0,0,0],"mm\xa0Hg","clinical",true,null,null,1,false,false,0,"mmHg; mm Hg; millimeters of mercury; millimetres","LOINC","Pres; PPres; Ratio","Clinical","1 mm[Hg] = 1 torr; unit to measure blood pressure","kPa","KPAL","133.3220",133.322,false],[false,"square millimeter","mm2","MM2","length",0.000001,[2,0,0,0,0,0,0],"mm<sup>2</sup>",null,false,"L",null,1,false,false,0,"mm^2; sq. mm.; sq. millimeters; millimeters squared; millimetres","LOINC","Area","Clinical","",null,null,null,null,false],[false,"millimole","mmol","MMOL","amount of substance",602213670000000000000,[0,0,0,0,0,0,0],"mmol","si",true,null,null,1,false,false,1,"millimoles","LOINC","Sub","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 12 hour","mmol/(12.h)","MMOL/(12.HR)","amount of substance",13940131250000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/12hrs; mmol/12 hrs; mmol per 12 hrs; 12hrs; millimoles per 12 hours","LOINC","SRat","Clinical","unit for tests related to urine","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 2 hour","mmol/(2.h)","MMOL/(2.HR)","amount of substance",83640787500000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/2hrs; mmol/2 hrs; mmol per 2 hrs; 2hrs; millimoles per 2 hours","LOINC","SRat","Clinical","unit for tests related to urine","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 24 hour","mmol/(24.h)","MMOL/(24.HR)","amount of substance",6970065625000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/24hrs; mmol/24 hrs; mmol per 24 hrs; 24hrs; millimoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 5 hour","mmol/(5.h)","MMOL/(5.HR)","amount of substance",33456315000000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/5hrs; mmol/5 hrs; mmol per 5 hrs; 5hrs; millimoles per 5 hours","LOINC","SRat","Clinical","unit for tests related to doses","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 6 hour","mmol/(6.h)","MMOL/(6.HR)","amount of substance",27880262500000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/6hrs; mmol/6 hrs; mmol per 6 hrs; 6hrs; millimoles per 6 hours","LOINC","SRat","Clinical","unit for tests related to urine","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 8 hour","mmol/(8.h)","MMOL/(8.HR)","amount of substance",20910196875000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/8hrs; mmol/8 hrs; mmol per 8 hrs; 8hrs; millimoles per 8 hours; shift","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per day","mmol/d","MMOL/D","amount of substance",6970065625000000,[0,-1,0,0,0,0,0],"mmol/d","si",true,null,null,1,false,false,1,"mmol/24hrs; mmol/24 hrs; mmol per 24 hrs; 24hrs; millimoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per deciliter","mmol/dL","MMOL/DL","amount of substance",6.022136699999999e+24,[-3,0,0,0,0,0,0],"mmol/dL","si",true,null,null,1,false,false,1,"mmol per dL; millimoles; decilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per gram","mmol/g","MMOL/G","amount of substance",602213670000000000000,[0,0,-1,0,0,0,0],"mmol/g","si",true,null,null,1,false,false,1,"mmol per gram; millimoles","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per hour","mmol/h","MMOL/HR","amount of substance",167281575000000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/hr; mmol per hr; millimoles per hour","LOINC","SRat","Clinical","unit for tests related to urine","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram","mmol/kg","MMOL/KG","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"mmol/kg","si",true,null,null,1,false,false,1,"mmol per kg; millimoles per kilogram","LOINC","SCnt","Clinical","unit for tests related to stool","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram per 8 hour","mmol/kg/(8.h)","(MMOL/KG)/(8.HR)","amount of substance",20910196875000,[0,-1,-1,0,0,0,0],"(mmol/kg)/h","si",true,null,null,1,false,false,1,"mmol/(8.h.kg); mmol/kg/8hrs; mmol/kg/8 hrs; mmol per kg per 8hrs; 8 hrs; millimoles per kilograms per 8 hours; shift","LOINC","CCnt","Clinical","unit used to measure molar dose rate per patient body mass","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram per day","mmol/kg/d","(MMOL/KG)/D","amount of substance",6970065625000,[0,-1,-1,0,0,0,0],"(mmol/kg)/d","si",true,null,null,1,false,false,1,"mmol/kg/dy; mmol/kg/day; mmol per kg per dy; millimoles per kilograms per day","LOINC","RelSRat","Clinical","unit used to measure molar dose rate per patient body mass","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram per hour","mmol/kg/h","(MMOL/KG)/HR","amount of substance",167281575000000,[0,-1,-1,0,0,0,0],"(mmol/kg)/h","si",true,null,null,1,false,false,1,"mmol/kg/hr; mmol per kg per hr; millimoles per kilograms per hour","LOINC","CCnt","Clinical","unit used to measure molar dose rate per patient body mass","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram per minute","mmol/kg/min","(MMOL/KG)/MIN","amount of substance",10036894500000000,[0,-1,-1,0,0,0,0],"(mmol/kg)/min","si",true,null,null,1,false,false,1,"mmol/(kg.min); mmol/kg/min; mmol per kg per min; millimoles per kilograms per minute","LOINC","CCnt","Clinical","unit used to measure molar dose rate per patient body mass; note that the unit for the enzyme unit U = umol/min. mmol/kg/min = kU/kg; ","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per liter","mmol/L","MMOL/L","amount of substance",6.0221367e+23,[-3,0,0,0,0,0,0],"mmol/L","si",true,null,null,1,false,false,1,"mmol per L; millimoles per liter; litre","LOINC","SCnc","Clinical","unit for tests related to doses","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per square meter","mmol/m2","MMOL/M2","amount of substance",602213670000000000000,[-2,0,0,0,0,0,0],"mmol/(m<sup>2</sup>)","si",true,null,null,1,false,false,1,"mmol/m^2; mmol/sq. meter; mmol per m2; m^2; sq. meter; millimoles; meter squared; metre","LOINC","ArSub","Clinical","unit used to measure molar dose per patient body surface area","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per minute","mmol/min","MMOL/MIN","amount of substance",10036894500000000000,[0,-1,0,0,0,0,0],"mmol/min","si",true,null,null,1,false,false,1,"mmol per min; millimoles per minute","LOINC","Srat; CAct","Clinical","unit for the enzyme unit U = umol/min. mmol/min = kU","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per millimole","mmol/mmol","MMOL/MMOL","amount of substance",1,[0,0,0,0,0,0,0],"mmol/mmol","si",true,null,null,1,false,false,0,"mmol per mmol; millimoles per millimole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per mole","mmol/mol","MMOL/MOL","amount of substance",0.001,[0,0,0,0,0,0,0],"mmol/mol","si",true,null,null,1,false,false,0,"mmol per mol; millimoles per mole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per second per liter","mmol/s/L","(MMOL/S)/L","amount of substance",6.0221367e+23,[-3,-1,0,0,0,0,0],"(mmol/s)/L","si",true,null,null,1,false,false,1,"mmol/sec/L; mmol per s per L; per sec; millimoles per seconds per liter; litre","LOINC","CCnc ","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per kilogram","mol/kg","MOL/KG","amount of substance",602213670000000000000,[0,0,-1,0,0,0,0],"mol/kg","si",true,null,null,1,false,false,1,"mol per kg; moles; mols","LOINC","SCnt","Clinical","unit for tests related to stool","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per kilogram per second","mol/kg/s","(MOL/KG)/S","amount of substance",602213670000000000000,[0,-1,-1,0,0,0,0],"(mol/kg)/s","si",true,null,null,1,false,false,1,"mol/kg/sec; mol per kg per sec; moles per kilograms per second; mols","LOINC","CCnt","Clinical","unit of catalytic activity (mol/s) per mass (kg)","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per liter","mol/L","MOL/L","amount of substance",6.0221366999999994e+26,[-3,0,0,0,0,0,0],"mol/L","si",true,null,null,1,false,false,1,"mol per L; moles per liter; litre; moles; mols","LOINC","SCnc","Clinical","unit often used in tests measuring oxygen content","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per cubic meter","mol/m3","MOL/M3","amount of substance",6.0221367e+23,[-3,0,0,0,0,0,0],"mol/(m<sup>3</sup>)","si",true,null,null,1,false,false,1,"mol/m^3; mol/cu. m; mol per m3; m^3; cu. meter; mols; moles; meters cubed; metre; mole per kiloliter; kilolitre; mol/kL","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per milliliter","mol/mL","MOL/ML","amount of substance",6.0221367e+29,[-3,0,0,0,0,0,0],"mol/mL","si",true,null,null,1,false,false,1,"mol per mL; moles; millilitre; mols","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per mole","mol/mol","MOL/MOL","amount of substance",1,[0,0,0,0,0,0,0],"mol/mol","si",true,null,null,1,false,false,0,"mol per mol; moles per mol; mols","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per second","mol/s","MOL/S","amount of substance",6.0221367e+23,[0,-1,0,0,0,0,0],"mol/s","si",true,null,null,1,false,false,1,"mol per sec; moles per second; mols","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"milliosmole","mosm","MOSM","amount of substance (dissolved particles)",602213670000000000000,[0,0,0,0,0,0,0],"mosm","chemical",true,null,null,1,false,false,1,"milliosmoles","LOINC","Osmol","Clinical","equal to 1/1000 of an osmole","mol","MOL","1",1,false],[false,"milliosmole per kilogram","mosm/kg","MOSM/KG","amount of substance (dissolved particles)",602213670000000000,[0,0,-1,0,0,0,0],"mosm/kg","chemical",true,null,null,1,false,false,1,"mosm per kg; milliosmoles per kilogram","LOINC","Osmol","Clinical","","mol","MOL","1",1,false],[false,"milliosmole per liter","mosm/L","MOSM/L","amount of substance (dissolved particles)",6.0221367e+23,[-3,0,0,0,0,0,0],"mosm/L","chemical",true,null,null,1,false,false,1,"mosm per liter; litre; milliosmoles","LOINC","Osmol","Clinical","","mol","MOL","1",1,false],[false,"millipascal","mPa","MPAL","pressure",1,[-1,-2,1,0,0,0,0],"mPa","si",true,null,null,1,false,false,0,"millipascals","LOINC","Pres","Clinical","unit of pressure","N/m2","N/M2","1",1,false],[false,"millipascal second","mPa.s","MPAL.S","pressure",1,[-1,-1,1,0,0,0,0],"mPa.s","si",true,null,null,1,false,false,0,"mPa*s; millipoise; mP; dynamic viscosity","LOINC","Visc","Clinical","base units for millipoise, a measurement of dynamic viscosity","N/m2","N/M2","1",1,false],[false,"megasecond","Ms","MAS","time",1000000,[0,1,0,0,0,0,0],"Ms",null,false,"T",null,1,false,false,0,"megaseconds","LOINC","Time","Clinical","",null,null,null,null,false],[false,"millisecond","ms","MS","time",0.001,[0,1,0,0,0,0,0],"ms",null,false,"T",null,1,false,false,0,"milliseconds; duration","LOINC","Time","Clinical","",null,null,null,null,false],[false,"milli enzyme unit per gram","mU/g","MU/G","catalytic activity",10036894500000,[0,-1,-1,0,0,0,0],"mU/g","chemical",true,null,null,1,false,false,1,"mU per gm; milli enzyme units per gram; enzyme activity; enzymatic activity per mass","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"milli enzyme unit per liter","mU/L","MU/L","catalytic activity",10036894500000000,[-3,-1,0,0,0,0,0],"mU/L","chemical",true,null,null,1,false,false,1,"mU per liter; litre; milli enzyme units enzymatic activity per volume; enzyme activity","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"milli enzyme unit per milligram","mU/mg","MU/MG","catalytic activity",10036894500000000,[0,-1,-1,0,0,0,0],"mU/mg","chemical",true,null,null,1,false,false,1,"mU per mg; milli enzyme units per milligram","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"milli enzyme unit per milliliter","mU/mL","MU/ML","catalytic activity",10036894500000000000,[-3,-1,0,0,0,0,0],"mU/mL","chemical",true,null,null,1,false,false,1,"mU per mL; milli enzyme units per milliliter; millilitre; enzymatic activity per volume; enzyme activity","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"milli enzyme unit per milliliter per minute","mU/mL/min","(MU/ML)/MIN","catalytic activity",167281575000000000,[-3,-2,0,0,0,0,0],"(mU/mL)/min","chemical",true,null,null,1,false,false,1,"mU per mL per min; mU per milliliters per minute; millilitres; milli enzyme units; enzymatic activity; enzyme activity","LOINC","CCncRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"millivolt","mV","MV","electric potential",1,[2,-2,1,0,0,-1,0],"mV","si",true,null,null,1,false,false,0,"millivolts","LOINC","Elpot","Clinical","unit of electric potential (voltage)","J/C","J/C","1",1,false],[false,"Newton centimeter","N.cm","N.CM","force",10,[2,-2,1,0,0,0,0],"N.cm","si",true,null,null,1,false,false,0,"N*cm; Ncm; N cm; Newton*centimeters; Newton* centimetres; torque; work","LOINC","","Clinical","as a measurement of work, N.cm = 1/100 Joules;\\nnote that N.m is the standard unit of measurement for torque (although dimensionally equivalent to Joule), and N.cm can also be thought of as a torqe unit","kg.m/s2","KG.M/S2","1",1,false],[false,"Newton second","N.s","N.S","force",1000,[1,-1,1,0,0,0,0],"N.s","si",true,null,null,1,false,false,0,"Newton*seconds; N*s; N s; Ns; impulse; imp","LOINC","","Clinical","standard unit of impulse","kg.m/s2","KG.M/S2","1",1,false],[false,"nanogram","ng","NG","mass",1e-9,[0,0,1,0,0,0,0],"ng",null,false,"M",null,1,false,false,0,"nanograms","LOINC","Mass","Clinical","",null,null,null,null,false],[false,"nanogram per 24 hour","ng/(24.h)","NG/(24.HR)","mass",1.1574074074074075e-14,[0,-1,1,0,0,0,0],"ng/h",null,false,"M",null,1,false,false,0,"ng/24hrs; ng/24 hrs; nanograms per 24 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"nanogram per 8 hour","ng/(8.h)","NG/(8.HR)","mass",3.4722222222222224e-14,[0,-1,1,0,0,0,0],"ng/h",null,false,"M",null,1,false,false,0,"ng/8hrs; ng/8 hrs; nanograms per 8 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"nanogram per million","ng/10*6","NG/(10*6)","mass",1e-15,[0,0,1,0,0,0,0],"ng/(10<sup>6</sup>)",null,false,"M",null,1,false,false,0,"ng/10^6; ng per 10*6; 10^6; nanograms","LOINC","MNum","Clinical","",null,null,null,null,false],[false,"nanogram per day","ng/d","NG/D","mass",1.1574074074074075e-14,[0,-1,1,0,0,0,0],"ng/d",null,false,"M",null,1,false,false,0,"ng/dy; ng per day; nanograms ","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"nanogram per deciliter","ng/dL","NG/DL","mass",0.00001,[-3,0,1,0,0,0,0],"ng/dL",null,false,"M",null,1,false,false,0,"ng per dL; nanograms per deciliter; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"nanogram per gram","ng/g","NG/G","mass",1e-9,[0,0,0,0,0,0,0],"ng/g",null,false,"M",null,1,false,false,0,"ng/gm; ng per gm; nanograms per gram","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"nanogram per hour","ng/h","NG/HR","mass",2.777777777777778e-13,[0,-1,1,0,0,0,0],"ng/h",null,false,"M",null,1,false,false,0,"ng/hr; ng per hr; nanograms per hour","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"nanogram per kilogram","ng/kg","NG/KG","mass",1e-12,[0,0,0,0,0,0,0],"ng/kg",null,false,"M",null,1,false,false,0,"ng per kg; nanograms per kilogram","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"nanogram per kilogram per 8 hour","ng/kg/(8.h)","(NG/KG)/(8.HR)","mass",3.472222222222222e-17,[0,-1,0,0,0,0,0],"(ng/kg)/h",null,false,"M",null,1,false,false,0,"ng/(8.h.kg); ng/kg/8hrs; ng/kg/8 hrs; ng per kg per 8hrs; 8 hrs; nanograms per kilograms per 8 hours; shift","LOINC","MRtoRat ","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"nanogram per kilogram per hour","ng/kg/h","(NG/KG)/HR","mass",2.7777777777777775e-16,[0,-1,0,0,0,0,0],"(ng/kg)/h",null,false,"M",null,1,false,false,0,"ng/(kg.h); ng/kg/hr; ng per kg per hr; nanograms per kilograms per hour","LOINC","MRtoRat ","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"nanogram per kilogram per minute","ng/kg/min","(NG/KG)/MIN","mass",1.6666666666666667e-14,[0,-1,0,0,0,0,0],"(ng/kg)/min",null,false,"M",null,1,false,false,0,"ng/(kg.min); ng per kg per min; nanograms per kilograms per minute","LOINC","MRtoRat ","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"nanogram per liter","ng/L","NG/L","mass",0.000001,[-3,0,1,0,0,0,0],"ng/L",null,false,"M",null,1,false,false,0,"ng per L; nanograms per liter; litre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"nanogram per square meter","ng/m2","NG/M2","mass",1e-9,[-2,0,1,0,0,0,0],"ng/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"ng/m^2; ng/sq. m; ng per m2; m^2; sq. meter; nanograms; meter squared; metre","LOINC","ArMass","Clinical","unit used to measure mass dose per patient body surface area",null,null,null,null,false],[false,"nanogram per milligram","ng/mg","NG/MG","mass",0.000001,[0,0,0,0,0,0,0],"ng/mg",null,false,"M",null,1,false,false,0,"ng per mg; nanograms","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"nanogram per milligram per hour","ng/mg/h","(NG/MG)/HR","mass",2.7777777777777777e-10,[0,-1,0,0,0,0,0],"(ng/mg)/h",null,false,"M",null,1,false,false,0,"ng/mg/hr; ng per mg per hr; nanograms per milligrams per hour","LOINC","MRtoRat ","Clinical","",null,null,null,null,false],[false,"nanogram per minute","ng/min","NG/MIN","mass",1.6666666666666667e-11,[0,-1,1,0,0,0,0],"ng/min",null,false,"M",null,1,false,false,0,"ng per min; nanograms","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"nanogram per millliiter","ng/mL","NG/ML","mass",0.001,[-3,0,1,0,0,0,0],"ng/mL",null,false,"M",null,1,false,false,0,"ng per mL; nanograms; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"nanogram per milliliter per hour","ng/mL/h","(NG/ML)/HR","mass",2.7777777777777776e-7,[-3,-1,1,0,0,0,0],"(ng/mL)/h",null,false,"M",null,1,false,false,0,"ng/mL/hr; ng per mL per mL; nanograms per milliliter per hour; nanogram per millilitre per hour; nanograms per millilitre per hour; enzymatic activity per volume; enzyme activity per milliliters","LOINC","CCnc","Clinical","tests that measure enzymatic activity",null,null,null,null,false],[false,"nanogram per second","ng/s","NG/S","mass",1e-9,[0,-1,1,0,0,0,0],"ng/s",null,false,"M",null,1,false,false,0,"ng/sec; ng per sec; nanograms per second","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"nanogram per enzyme unit","ng/U","NG/U","mass",9.963241120049634e-26,[0,1,1,0,0,0,0],"ng/U",null,false,"M",null,1,false,false,-1,"ng per U; nanograms per enzyme unit","LOINC","CMass","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)",null,null,null,null,false],[false,"nanokatal","nkat","NKAT","catalytic activity",602213670000000,[0,-1,0,0,0,0,0],"nkat","chemical",true,null,null,1,false,false,1,"nanokatals","LOINC","CAct","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"nanoliter","nL","NL","volume",1.0000000000000002e-12,[3,0,0,0,0,0,0],"nL","iso1000",true,null,null,1,false,false,0,"nanoliters; nanolitres","LOINC","Vol","Clinical","","l",null,"1",1,false],[false,"nanometer","nm","NM","length",1e-9,[1,0,0,0,0,0,0],"nm",null,false,"L",null,1,false,false,0,"nanometers; nanometres","LOINC","Len","Clinical","",null,null,null,null,false],[false,"nanometer per second per liter","nm/s/L","(NM/S)/L","length",0.000001,[-2,-1,0,0,0,0,0],"(nm/s)/L",null,false,"L",null,1,false,false,0,"nm/sec/liter; nm/sec/litre; nm per s per l; nm per sec per l; nanometers per second per liter; nanometre per second per litre; nanometres per second per litre","LOINC","VelCnc","Clinical","",null,null,null,null,false],[false,"nanomole","nmol","NMOL","amount of substance",602213670000000,[0,0,0,0,0,0,0],"nmol","si",true,null,null,1,false,false,1,"nanomoles","LOINC","Sub","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per 24 hour","nmol/(24.h)","NMOL/(24.HR)","amount of substance",6970065625,[0,-1,0,0,0,0,0],"nmol/h","si",true,null,null,1,false,false,1,"nmol/24hr; nmol/24 hr; nanomoles per 24 hours; nmol/day; nanomoles per day; nmol per day; nanomole/day; nanomol/day","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per day","nmol/d","NMOL/D","amount of substance",6970065625,[0,-1,0,0,0,0,0],"nmol/d","si",true,null,null,1,false,false,1,"nmol/day; nanomoles per day; nmol per day; nanomole/day; nanomol/day; nmol/24hr; nmol/24 hr; nanomoles per 24 hours; ","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per deciliter","nmol/dL","NMOL/DL","amount of substance",6022136700000000000,[-3,0,0,0,0,0,0],"nmol/dL","si",true,null,null,1,false,false,1,"nmol per dL; nanomoles per deciliter; nanomole per decilitre; nanomoles per decilitre; nanomole/deciliter; nanomole/decilitre; nanomol/deciliter; nanomol/decilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per gram","nmol/g","NMOL/G","amount of substance",602213670000000,[0,0,-1,0,0,0,0],"nmol/g","si",true,null,null,1,false,false,1,"nmol per gram; nanomoles per gram; nanomole/gram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per hour per liter","nmol/h/L","(NMOL/HR)/L","amount of substance",167281575000000,[-3,-1,0,0,0,0,0],"(nmol/h)/L","si",true,null,null,1,false,false,1,"nmol/hrs/L; nmol per hrs per L; nanomoles per hours per liter; litre; enzymatic activity per volume; enzyme activities","LOINC","CCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per liter","nmol/L","NMOL/L","amount of substance",602213670000000000,[-3,0,0,0,0,0,0],"nmol/L","si",true,null,null,1,false,false,1,"nmol per L; nanomoles per liter; litre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milligram","nmol/mg","NMOL/MG","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"nmol/mg","si",true,null,null,1,false,false,1,"nmol per mg; nanomoles per milligram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milligram per hour","nmol/mg/h","(NMOL/MG)/HR","amount of substance",167281575000000,[0,-1,-1,0,0,0,0],"(nmol/mg)/h","si",true,null,null,1,false,false,1,"nmol/mg/hr; nmol per mg per hr; nanomoles per milligrams per hour","LOINC","SCntRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milligram of protein","nmol/mg{prot}","NMOL/MG","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"nmol/mg","si",true,null,null,1,false,false,1,"nanomoles; nmol/mg prot; nmol per mg prot","LOINC","Ratio; CCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per minute","nmol/min","NMOL/MIN","amount of substance",10036894500000,[0,-1,0,0,0,0,0],"nmol/min","si",true,null,null,1,false,false,1,"nmol per min; nanomoles per minute; milli enzyme units; enzyme activity per volume; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. nmol/min = mU (milli enzyme unit)","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per minute per milliliter","nmol/min/mL","(NMOL/MIN)/ML","amount of substance",10036894500000000000,[-3,-1,0,0,0,0,0],"(nmol/min)/mL","si",true,null,null,1,false,false,1,"nmol per min per mL; nanomoles per minutes per milliliter; millilitre; milli enzyme units per volume; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. nmol/mL/min = mU/mL","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milliliter","nmol/mL","NMOL/ML","amount of substance",602213670000000000000,[-3,0,0,0,0,0,0],"nmol/mL","si",true,null,null,1,false,false,1,"nmol per mL; nanomoles per milliliter; millilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milliliter per hour","nmol/mL/h","(NMOL/ML)/HR","amount of substance",167281575000000000,[-3,-1,0,0,0,0,0],"(nmol/mL)/h","si",true,null,null,1,false,false,1,"nmol/mL/hr; nmol per mL per hr; nanomoles per milliliters per hour; millilitres; milli enzyme units per volume; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min.","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milliliter per minute","nmol/mL/min","(NMOL/ML)/MIN","amount of substance",10036894500000000000,[-3,-1,0,0,0,0,0],"(nmol/mL)/min","si",true,null,null,1,false,false,1,"nmol per mL per min; nanomoles per milliliters per min; millilitres; milli enzyme units per volume; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. nmol/mL/min = mU/mL","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per millimole","nmol/mmol","NMOL/MMOL","amount of substance",0.000001,[0,0,0,0,0,0,0],"nmol/mmol","si",true,null,null,1,false,false,0,"nmol per mmol; nanomoles per millimole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per millimole of creatinine","nmol/mmol{creat}","NMOL/MMOL","amount of substance",0.000001,[0,0,0,0,0,0,0],"nmol/mmol","si",true,null,null,1,false,false,0,"nanomoles","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per mole","nmol/mol","NMOL/MOL","amount of substance",1e-9,[0,0,0,0,0,0,0],"nmol/mol","si",true,null,null,1,false,false,0,"nmol per mole; nanomoles","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per nanomole","nmol/nmol","NMOL/NMOL","amount of substance",1,[0,0,0,0,0,0,0],"nmol/nmol","si",true,null,null,1,false,false,0,"nmol per nmol; nanomoles","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per second","nmol/s","NMOL/S","amount of substance",602213670000000,[0,-1,0,0,0,0,0],"nmol/s","si",true,null,null,1,false,false,1,"nmol/sec; nmol per sec; nanomoles per sercond; milli enzyme units; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min.","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per second per liter","nmol/s/L","(NMOL/S)/L","amount of substance",602213670000000000,[-3,-1,0,0,0,0,0],"(nmol/s)/L","si",true,null,null,1,false,false,1,"nmol/sec/L; nmol per s per L; nmol per sec per L; nanomoles per seconds per liter; litre; milli enzyme units per volume; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min.","10*23","10*23","6.0221367",6.0221367,false],[false,"nanosecond","ns","NS","time",1e-9,[0,1,0,0,0,0,0],"ns",null,false,"T",null,1,false,false,0,"nanoseconds","LOINC","Time","Clinical","",null,null,null,null,false],[false,"nanoenzyme unit per milliliter","nU/mL","NU/ML","catalytic activity",10036894500000,[-3,-1,0,0,0,0,0],"nU/mL","chemical",true,null,null,1,false,false,1,"nU per mL; nanoenzyme units per milliliter; millilitre; enzymatic activity per volume; enzyme activity","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 fU = pmol/min","umol/min","UMOL/MIN","1",1,false],[false,"Ohm meter","Ohm.m","OHM.M","electric resistance",1000,[3,-1,1,0,0,-2,0],"\u03a9.m","si",true,null,null,1,false,false,0,"electric resistivity; meters; metres","LOINC","","Clinical","unit of electric resistivity","V/A","V/A","1",1,false],[false,"osmole per kilogram","osm/kg","OSM/KG","amount of substance (dissolved particles)",602213670000000000000,[0,0,-1,0,0,0,0],"osm/kg","chemical",true,null,null,1,false,false,1,"osm per kg; osmoles per kilogram; osmols","LOINC","Osmol","Clinical","","mol","MOL","1",1,false],[false,"osmole per liter","osm/L","OSM/L","amount of substance (dissolved particles)",6.0221366999999994e+26,[-3,0,0,0,0,0,0],"osm/L","chemical",true,null,null,1,false,false,1,"osm per L; osmoles per liter; litre; osmols","LOINC","Osmol","Clinical","","mol","MOL","1",1,false],[false,"picoampere","pA","PA","electric current",1e-12,[0,-1,0,0,0,1,0],"pA","si",true,null,null,1,false,false,0,"picoamperes","LOINC","","Clinical","equal to 10^-12 amperes","C/s","C/S","1",1,false],[false,"picogram","pg","PG","mass",1e-12,[0,0,1,0,0,0,0],"pg",null,false,"M",null,1,false,false,0,"picograms","LOINC","Mass; EntMass","Clinical","",null,null,null,null,false],[false,"picogram per deciliter","pg/dL","PG/DL","mass",9.999999999999999e-9,[-3,0,1,0,0,0,0],"pg/dL",null,false,"M",null,1,false,false,0,"pg per dL; picograms; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"picogram per liter","pg/L","PG/L","mass",1e-9,[-3,0,1,0,0,0,0],"pg/L",null,false,"M",null,1,false,false,0,"pg per L; picograms; litre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"picogram per milligram","pg/mg","PG/MG","mass",1e-9,[0,0,0,0,0,0,0],"pg/mg",null,false,"M",null,1,false,false,0,"pg per mg; picograms","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"picogram per milliliter","pg/mL","PG/ML","mass",0.000001,[-3,0,1,0,0,0,0],"pg/mL",null,false,"M",null,1,false,false,0,"pg per mL; picograms per milliliter; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"picogram per millimeter","pg/mm","PG/MM","mass",1e-9,[-1,0,1,0,0,0,0],"pg/mm",null,false,"M",null,1,false,false,0,"pg per mm; picogram/millimeter; picogram/millimetre; picograms per millimeter; millimetre","LOINC","Lineic Mass","Clinical","",null,null,null,null,false],[false,"picokatal","pkat","PKAT","catalytic activity",602213670000,[0,-1,0,0,0,0,0],"pkat","chemical",true,null,null,1,false,false,1,"pkats; picokatals","LOINC","CAct","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"picoliter","pL","PL","volume",1e-15,[3,0,0,0,0,0,0],"pL","iso1000",true,null,null,1,false,false,0,"picoliters; picolitres","LOINC","Vol","Clinical","","l",null,"1",1,false],[false,"picometer","pm","PM","length",1e-12,[1,0,0,0,0,0,0],"pm",null,false,"L",null,1,false,false,0,"picometers; picometres","LOINC","Len","Clinical","",null,null,null,null,false],[false,"picomole","pmol","PMOL","amount of substance",602213670000,[0,0,0,0,0,0,0],"pmol","si",true,null,null,1,false,false,1,"picomoles; pmols","LOINC","Sub","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per 24 hour","pmol/(24.h)","PMOL/(24.HR)","amount of substance",6970065.625,[0,-1,0,0,0,0,0],"pmol/h","si",true,null,null,1,false,false,1,"pmol/24hrs; pmol/24 hrs; pmol per 24 hrs; 24hrs; days; dy; picomoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per day","pmol/d","PMOL/D","amount of substance",6970065.625,[0,-1,0,0,0,0,0],"pmol/d","si",true,null,null,1,false,false,1,"pmol/dy; pmol per day; 24 hours; 24hrs; 24 hrs; picomoles","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per deciliter","pmol/dL","PMOL/DL","amount of substance",6022136700000000,[-3,0,0,0,0,0,0],"pmol/dL","si",true,null,null,1,false,false,1,"pmol per dL; picomoles per deciliter; decilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per gram","pmol/g","PMOL/G","amount of substance",602213670000,[0,0,-1,0,0,0,0],"pmol/g","si",true,null,null,1,false,false,1,"pmol per gm; picomoles per gram; picomole/gram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per hour per milliliter ","pmol/h/mL","(PMOL/HR)/ML","amount of substance",167281575000000,[-3,-1,0,0,0,0,0],"(pmol/h)/mL","si",true,null,null,1,false,false,1,"pmol/hrs/mL; pmol per hrs per mL; picomoles per hour per milliliter; millilitre; micro enzyme units per volume; enzymatic activity; enzyme activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. ","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per liter","pmol/L","PMOL/L","amount of substance",602213670000000,[-3,0,0,0,0,0,0],"pmol/L","si",true,null,null,1,false,false,1,"picomole/liter; pmol per L; picomoles; litre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per minute","pmol/min","PMOL/MIN","amount of substance",10036894500,[0,-1,0,0,0,0,0],"pmol/min","si",true,null,null,1,false,false,1,"picomole/minute; pmol per min; picomoles per minute; micro enzyme units; enzymatic activity; enzyme activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. pmol/min = uU (micro enzyme unit)","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per milliliter","pmol/mL","PMOL/ML","amount of substance",602213670000000000,[-3,0,0,0,0,0,0],"pmol/mL","si",true,null,null,1,false,false,1,"picomole/milliliter; picomole/millilitre; pmol per mL; picomoles; millilitre; picomols; pmols","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per micromole","pmol/umol","PMOL/UMOL","amount of substance",0.000001,[0,0,0,0,0,0,0],"pmol/\u03bcmol","si",true,null,null,1,false,false,0,"pmol/mcgmol; picomole/micromole; pmol per umol; pmol per mcgmol; picomoles ","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picosecond","ps","PS","time",1e-12,[0,1,0,0,0,0,0],"ps",null,false,"T",null,1,false,false,0,"picoseconds; psec","LOINC","Time","Clinical","",null,null,null,null,false],[false,"picotesla","pT","PT","magnetic flux density",1e-9,[0,-1,1,0,0,-1,0],"pT","si",true,null,null,1,false,false,0,"picoteslas","LOINC","","Clinical","SI unit of magnetic field strength for magnetic field B","Wb/m2","WB/M2","1",1,false],[false,"enzyme unit per 12 hour","U/(12.h)","U/(12.HR)","catalytic activity",232335520833.33334,[0,-2,0,0,0,0,0],"U/h","chemical",true,null,null,1,false,false,1,"U/12hrs; U/ 12hrs; U per 12 hrs; 12hrs; enzyme units per 12 hours; enzyme activity; enzymatic activity per time; umol per min per 12 hours; micromoles per minute per 12 hours; umol/min/12hr","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per 2 hour","U/(2.h)","U/(2.HR)","catalytic activity",1394013125000,[0,-2,0,0,0,0,0],"U/h","chemical",true,null,null,1,false,false,1,"U/2hrs; U/ 2hrs; U per 2 hrs; 2hrs; enzyme units per 2 hours; enzyme activity; enzymatic activity per time; umol per minute per 2 hours; micromoles per minute; umol/min/2hr; umol per min per 2hr","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per 24 hour","U/(24.h)","U/(24.HR)","catalytic activity",116167760416.66667,[0,-2,0,0,0,0,0],"U/h","chemical",true,null,null,1,false,false,1,"U/24hrs; U/ 24hrs; U per 24 hrs; 24hrs; enzyme units per 24 hours; enzyme activity; enzymatic activity per time; micromoles per minute per 24 hours; umol/min/24hr; umol per min per 24hr","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per 10","U/10","U/10","catalytic activity",1003689450000000,[0,-1,0,0,0,0,0],"U","chemical",true,null,null,1,false,false,1,"enzyme unit/10; U per 10; enzyme units per 10; enzymatic activity; enzyme activity; micromoles per minute; umol/min/10","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per 10 billion","U/10*10","U/(10*10)","catalytic activity",1003689.45,[0,-1,0,0,0,0,0],"U/(10<sup>10</sup>)","chemical",true,null,null,1,false,false,1,"U per 10*10; enzyme units per 10*10; U per 10 billion; enzyme units; enzymatic activity; micromoles per minute per 10 billion; umol/min/10*10","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per trillion","U/10*12","U/(10*12)","catalytic activity",10036.8945,[0,-1,0,0,0,0,0],"U/(10<sup>12</sup>)","chemical",true,null,null,1,false,false,1,"enzyme unit/10*12; U per 10*12; enzyme units per 10*12; enzyme units per trillion; enzymatic activity; micromoles per minute per trillion; umol/min/10*12; umol per min per 10*12","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per million","U/10*6","U/(10*6)","catalytic activity",10036894500,[0,-1,0,0,0,0,0],"U/(10<sup>6</sup>)","chemical",true,null,null,1,false,false,1,"enzyme unit/10*6; U per 10*6; enzyme units per 10*6; enzyme units; enzymatic activity per volume; micromoles per minute per million; umol/min/10*6; umol per min per 10*6","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per billion","U/10*9","U/(10*9)","catalytic activity",10036894.5,[0,-1,0,0,0,0,0],"U/(10<sup>9</sup>)","chemical",true,null,null,1,false,false,1,"enzyme unit/10*9; U per 10*9; enzyme units per 10*9; enzymatic activity per volume; micromoles per minute per billion; umol/min/10*9; umol per min per 10*9","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per day","U/d","U/D","catalytic activity",116167760416.66667,[0,-2,0,0,0,0,0],"U/d","chemical",true,null,null,1,false,false,1,"U/dy; enzyme units per day; enzyme units; enzyme activity; enzymatic activity per time; micromoles per minute per day; umol/min/day; umol per min per day","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per deciliter","U/dL","U/DL","catalytic activity",100368945000000000000,[-3,-1,0,0,0,0,0],"U/dL","chemical",true,null,null,1,false,false,1,"U per dL; enzyme units per deciliter; decilitre; micromoles per minute per deciliter; umol/min/dL; umol per min per dL","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per gram","U/g","U/G","catalytic activity",10036894500000000,[0,-1,-1,0,0,0,0],"U/g","chemical",true,null,null,1,false,false,1,"U/gm; U per gm; enzyme units per gram; micromoles per minute per gram; umol/min/g; umol per min per g","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per hour","U/h","U/HR","catalytic activity",2788026250000,[0,-2,0,0,0,0,0],"U/h","chemical",true,null,null,1,false,false,1,"U/hr; U per hr; enzyme units per hour; micromoles per minute per hour; umol/min/hr; umol per min per hr","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per liter","U/L","U/L","catalytic activity",10036894500000000000,[-3,-1,0,0,0,0,0],"U/L","chemical",true,null,null,1,false,false,1,"enzyme unit/liter; enzyme unit/litre; U per L; enzyme units per liter; enzyme unit per litre; micromoles per minute per liter; umol/min/L; umol per min per L","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per minute","U/min","U/MIN","catalytic activity",167281575000000,[0,-2,0,0,0,0,0],"U/min","chemical",true,null,null,1,false,false,1,"enzyme unit/minute; U per min; enzyme units; umol/min/min; micromoles per minute per minute; micromoles per min per min; umol","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per milliliter","U/mL","U/ML","catalytic activity",1.00368945e+22,[-3,-1,0,0,0,0,0],"U/mL","chemical",true,null,null,1,false,false,1,"U per mL; enzyme units per milliliter; millilitre; micromoles per minute per milliliter; umol/min/mL; umol per min per mL","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per second","U/s","U/S","catalytic activity",10036894500000000,[0,-2,0,0,0,0,0],"U/s","chemical",true,null,null,1,false,false,1,"U/sec; U per second; enzyme units per second; micromoles per minute per second; umol/min/sec; umol per min per sec","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"micro international unit","u[IU]","U[IU]","arbitrary",0.000001,[0,0,0,0,0,0,0],"\u03bci.U.","chemical",true,null,null,1,false,true,0,"uIU; u IU; microinternational units","LOINC","Arb","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"micro international unit per liter","u[IU]/L","U[IU]/L","arbitrary",0.001,[-3,0,0,0,0,0,0],"(\u03bci.U.)/L","chemical",true,null,null,1,false,true,0,"uIU/L; u IU/L; uIU per L; microinternational units per liter; litre; ","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"micro international unit per milliliter","u[IU]/mL","U[IU]/ML","arbitrary",1,[-3,0,0,0,0,0,0],"(\u03bci.U.)/mL","chemical",true,null,null,1,false,true,0,"uIU/mL; u IU/mL; uIU per mL; microinternational units per milliliter; millilitre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"microequivalent","ueq","UEQ","amount of substance",602213670000000000,[0,0,0,0,0,0,0],"\u03bceq","chemical",true,null,null,1,false,false,1,"microequivalents; 10^-6 equivalents; 10-6 equivalents","LOINC","Sub","Clinical","","mol","MOL","1",1,false],[false,"microequivalent per liter","ueq/L","UEQ/L","amount of substance",602213670000000000000,[-3,0,0,0,0,0,0],"\u03bceq/L","chemical",true,null,null,1,false,false,1,"ueq per liter; litre; microequivalents","LOINC","MCnc","Clinical","","mol","MOL","1",1,false],[false,"microequivalent per milliliter","ueq/mL","UEQ/ML","amount of substance",6.0221367000000003e+23,[-3,0,0,0,0,0,0],"\u03bceq/mL","chemical",true,null,null,1,false,false,1,"ueq per milliliter; millilitre; microequivalents","LOINC","MCnc","Clinical","","mol","MOL","1",1,false],[false,"microgram","ug","UG","mass",0.000001,[0,0,1,0,0,0,0],"\u03bcg",null,false,"M",null,1,false,false,0,"mcg; micrograms; 10^-6 grams; 10-6 grams","LOINC","Mass","Clinical","",null,null,null,null,false],[false,"microgram per 100 gram","ug/(100.g)","UG/(100.G)","mass",1e-8,[0,0,0,0,0,0,0],"\u03bcg/g",null,false,"M",null,1,false,false,0,"ug/100gm; ug/100 gm; mcg; ug per 100g; 100 gm; mcg per 100g; micrograms per 100 grams","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"microgram per 24 hour","ug/(24.h)","UG/(24.HR)","mass",1.1574074074074074e-11,[0,-1,1,0,0,0,0],"\u03bcg/h",null,false,"M",null,1,false,false,0,"ug/24hrs; ug/24 hrs; mcg/24hrs; ug per 24hrs; mcg per 24hrs; 24 hrs; micrograms per 24 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"microgram per 8 hour","ug/(8.h)","UG/(8.HR)","mass",3.472222222222222e-11,[0,-1,1,0,0,0,0],"\u03bcg/h",null,false,"M",null,1,false,false,0,"ug/8hrs; ug/8 hrs; mcg/8hrs; ug per 8hrs; mcg per 8hrs; 8 hrs; micrograms per 8 hours; shift","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"microgram per square foot (international)","ug/[sft_i]","UG/[SFT_I]","mass",0.000010763910416709721,[-2,0,1,0,0,0,0],"\u03bcg",null,false,"M",null,1,false,false,0,"ug/sft; ug/ft2; ug/ft^2; ug/sq. ft; micrograms; sq. foot; foot squared","LOINC","ArMass","Clinical","",null,null,null,null,false],[false,"microgram per day","ug/d","UG/D","mass",1.1574074074074074e-11,[0,-1,1,0,0,0,0],"\u03bcg/d",null,false,"M",null,1,false,false,0,"ug/dy; mcg/dy; ug per day; mcg; micrograms per day","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"microgram per deciliter","ug/dL","UG/DL","mass",0.009999999999999998,[-3,0,1,0,0,0,0],"\u03bcg/dL",null,false,"M",null,1,false,false,0,"ug per dL; mcg/dl; mcg per dl; micrograms per deciliter; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"microgram per gram","ug/g","UG/G","mass",0.000001,[0,0,0,0,0,0,0],"\u03bcg/g",null,false,"M",null,1,false,false,0,"ug per gm; mcg/gm; mcg per g; micrograms per gram","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"microgram per hour","ug/h","UG/HR","mass",2.7777777777777777e-10,[0,-1,1,0,0,0,0],"\u03bcg/h",null,false,"M",null,1,false,false,0,"ug/hr; mcg/hr; mcg per hr; ug per hr; ug per hour; micrograms","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"microgram per kilogram","ug/kg","UG/KG","mass",9.999999999999999e-10,[0,0,0,0,0,0,0],"\u03bcg/kg",null,false,"M",null,1,false,false,0,"ug per kg; mcg/kg; mcg per kg; micrograms per kilogram","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"microgram per kilogram per 8 hour","ug/kg/(8.h)","(UG/KG)/(8.HR)","mass",3.472222222222222e-14,[0,-1,0,0,0,0,0],"(\u03bcg/kg)/h",null,false,"M",null,1,false,false,0,"ug/kg/8hrs; mcg/kg/8hrs; ug/kg/8 hrs; mcg/kg/8 hrs; ug per kg per 8hrs; 8 hrs; mcg per kg per 8hrs; micrograms per kilograms per 8 hours; shift","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"microgram per kilogram per day","ug/kg/d","(UG/KG)/D","mass",1.1574074074074072e-14,[0,-1,0,0,0,0,0],"(\u03bcg/kg)/d",null,false,"M",null,1,false,false,0,"ug/(kg.d); ug/kg/dy; mcg/kg/day; ug per kg per dy; 24 hours; 24hrs; mcg; kilograms; microgram per kilogram and day","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"microgram per kilogram per hour","ug/kg/h","(UG/KG)/HR","mass",2.7777777777777774e-13,[0,-1,0,0,0,0,0],"(\u03bcg/kg)/h",null,false,"M",null,1,false,false,0,"ug/(kg.h); ug/kg/hr; mcg/kg/hr; ug per kg per hr; mcg per kg per hr; kilograms","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"microgram per kilogram per minute","ug/kg/min","(UG/KG)/MIN","mass",1.6666666666666664e-11,[0,-1,0,0,0,0,0],"(\u03bcg/kg)/min",null,false,"M",null,1,false,false,0,"ug/kg/min; ug/kg/min; mcg/kg/min; ug per kg per min; mcg; micrograms per kilograms per minute ","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"microgram per liter","ug/L","UG/L","mass",0.001,[-3,0,1,0,0,0,0],"\u03bcg/L",null,false,"M",null,1,false,false,0,"mcg/L; ug per L; mcg; micrograms per liter; litre ","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"microgram per liter per 24 hour","ug/L/(24.h)","(UG/L)/(24.HR)","mass",1.1574074074074074e-8,[-3,-1,1,0,0,0,0],"(\u03bcg/L)/h",null,false,"M",null,1,false,false,0,"ug/L/24hrs; ug/L/24 hrs; mcg/L/24hrs; ug per L per 24hrs; 24 hrs; day; dy mcg; micrograms per liters per 24 hours; litres","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[false,"microgram per square meter","ug/m2","UG/M2","mass",0.000001,[-2,0,1,0,0,0,0],"\u03bcg/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"ug/m^2; ug/sq. m; mcg/m2; mcg/m^2; mcg/sq. m; ug per m2; m^2; sq. meter; mcg; micrograms per square meter; meter squared; metre","LOINC","ArMass","Clinical","unit used to measure mass dose per patient body surface area",null,null,null,null,false],[false,"microgram per cubic meter","ug/m3","UG/M3","mass",0.000001,[-3,0,1,0,0,0,0],"\u03bcg/(m<sup>3</sup>)",null,false,"M",null,1,false,false,0,"ug/m^3; ug/cu. m; mcg/m3; mcg/m^3; mcg/cu. m; ug per m3; ug per m^3; ug per cu. m; mcg; micrograms per cubic meter; meter cubed; metre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"microgram per milligram","ug/mg","UG/MG","mass",0.001,[0,0,0,0,0,0,0],"\u03bcg/mg",null,false,"M",null,1,false,false,0,"ug per mg; mcg/mg; mcg per mg; micromilligrams per milligram","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"microgram per minute","ug/min","UG/MIN","mass",1.6666666666666667e-8,[0,-1,1,0,0,0,0],"\u03bcg/min",null,false,"M",null,1,false,false,0,"ug per min; mcg/min; mcg per min; microminutes per minute","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"microgram per milliliter","ug/mL","UG/ML","mass",1,[-3,0,1,0,0,0,0],"\u03bcg/mL",null,false,"M",null,1,false,false,0,"ug per mL; mcg/mL; mcg per mL; micrograms per milliliter; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[false,"microgram per millimole","ug/mmol","UG/MMOL","mass",1.660540186674939e-27,[0,0,1,0,0,0,0],"\u03bcg/mmol",null,false,"M",null,1,false,false,-1,"ug per mmol; mcg/mmol; mcg per mmol; micrograms per millimole","LOINC","Ratio","Clinical","",null,null,null,null,false],[false,"microgram per nanogram","ug/ng","UG/NG","mass",999.9999999999999,[0,0,0,0,0,0,0],"\u03bcg/ng",null,false,"M",null,1,false,false,0,"ug per ng; mcg/ng; mcg per ng; micrograms per nanogram","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"microkatal","ukat","UKAT","catalytic activity",602213670000000000,[0,-1,0,0,0,0,0],"\u03bckat","chemical",true,null,null,1,false,false,1,"microkatals; ukats","LOINC","CAct","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"microliter","uL","UL","volume",1e-9,[3,0,0,0,0,0,0],"\u03bcL","iso1000",true,null,null,1,false,false,0,"microliters; microlitres; mcl","LOINC","Vol","Clinical","","l",null,"1",1,false],[false,"microliter per 2 hour","uL/(2.h)","UL/(2.HR)","volume",1.388888888888889e-13,[3,-1,0,0,0,0,0],"\u03bcL/h","iso1000",true,null,null,1,false,false,0,"uL/2hrs; uL/2 hrs; mcg/2hr; mcg per 2hr; uL per 2hr; uL per 2 hrs; microliters per 2 hours; microlitres ","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"microliter per hour","uL/h","UL/HR","volume",2.777777777777778e-13,[3,-1,0,0,0,0,0],"\u03bcL/h","iso1000",true,null,null,1,false,false,0,"uL/hr; mcg/hr; mcg per hr; uL per hr; microliters per hour; microlitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"micrometer","um","UM","length",0.000001,[1,0,0,0,0,0,0],"\u03bcm",null,false,"L",null,1,false,false,0,"micrometers; micrometres; \u03bcm; microns","LOINC","Len","Clinical","Unit of length that is usually used in tests related to the eye",null,null,null,null,false],[false,"microns per second","um/s","UM/S","length",0.000001,[1,-1,0,0,0,0,0],"\u03bcm/s",null,false,"L",null,1,false,false,0,"um/sec; micron/second; microns/second; um per sec; micrometers per second; micrometres","LOINC","Vel","Clinical","",null,null,null,null,false],[false,"micromole","umol","UMOL","amount of substance",602213670000000000,[0,0,0,0,0,0,0],"\u03bcmol","si",true,null,null,1,false,false,1,"micromoles; umols","LOINC","Sub","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per 2 hour","umol/(2.h)","UMOL/(2.HR)","amount of substance",83640787500000,[0,-1,0,0,0,0,0],"\u03bcmol/h","si",true,null,null,1,false,false,1,"umol/2hrs; umol/2 hrs; umol per 2 hrs; 2hrs; micromoles per 2 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per 24 hour","umol/(24.h)","UMOL/(24.HR)","amount of substance",6970065625000,[0,-1,0,0,0,0,0],"\u03bcmol/h","si",true,null,null,1,false,false,1,"umol/24hrs; umol/24 hrs; umol per 24 hrs; per 24hrs; micromoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per 8 hour","umol/(8.h)","UMOL/(8.HR)","amount of substance",20910196875000,[0,-1,0,0,0,0,0],"\u03bcmol/h","si",true,null,null,1,false,false,1,"umol/8hr; umol/8 hr; umol per 8 hr; umol per 8hr; umols per 8hr; umol per 8 hours; micromoles per 8 hours; shift","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per day","umol/d","UMOL/D","amount of substance",6970065625000,[0,-1,0,0,0,0,0],"\u03bcmol/d","si",true,null,null,1,false,false,1,"umol/day; umol per day; umols per day; umol per days; micromoles per days; umol/24hr; umol/24 hr; umol per 24 hr; umol per 24hr; umols per 24hr; umol per 24 hours; micromoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per deciliter","umol/dL","UMOL/DL","amount of substance",6.0221367e+21,[-3,0,0,0,0,0,0],"\u03bcmol/dL","si",true,null,null,1,false,false,1,"micromole/deciliter; micromole/decilitre; umol per dL; micromoles per deciliters; micromole per decilitres","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per gram","umol/g","UMOL/G","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"\u03bcmol/g","si",true,null,null,1,false,false,1,"micromole/gram; umol per g; micromoles per gram","LOINC","SCnt; Ratio","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per hour","umol/h","UMOL/HR","amount of substance",167281575000000,[0,-1,0,0,0,0,0],"\u03bcmol/h","si",true,null,null,1,false,false,1,"umol/hr; umol per hr; umol per hour; micromoles per hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per kilogram","umol/kg","UMOL/KG","amount of substance",602213670000000,[0,0,-1,0,0,0,0],"\u03bcmol/kg","si",true,null,null,1,false,false,1,"umol per kg; micromoles per kilogram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per liter","umol/L","UMOL/L","amount of substance",602213670000000000000,[-3,0,0,0,0,0,0],"\u03bcmol/L","si",true,null,null,1,false,false,1,"micromole/liter; micromole/litre; umol per liter; micromoles per liter; litre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per liter per hour","umol/L/h","(UMOL/L)/HR","amount of substance",167281575000000000,[-3,-1,0,0,0,0,0],"(\u03bcmol/L)/h","si",true,null,null,1,false,false,1,"umol/liter/hr; umol/litre/hr; umol per L per hr; umol per liter per hour; micromoles per liters per hour; litre","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min; umol/L/h is a derived unit of enzyme units","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per milligram","umol/mg","UMOL/MG","amount of substance",602213670000000000000,[0,0,-1,0,0,0,0],"\u03bcmol/mg","si",true,null,null,1,false,false,1,"micromole/milligram; umol per mg; micromoles per milligram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per minute","umol/min","UMOL/MIN","amount of substance",10036894500000000,[0,-1,0,0,0,0,0],"\u03bcmol/min","si",true,null,null,1,false,false,1,"micromole/minute; umol per min; micromoles per minute; enzyme units","LOINC","CAct","Clinical","unit for the enzyme unit U = umol/min","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per minute per gram","umol/min/g","(UMOL/MIN)/G","amount of substance",10036894500000000,[0,-1,-1,0,0,0,0],"(\u03bcmol/min)/g","si",true,null,null,1,false,false,1,"umol/min/gm; umol per min per gm; micromoles per minutes per gram; U/g; enzyme units","LOINC","CCnt","Clinical","unit for the enzyme unit U = umol/min. umol/min/g = U/g","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per minute per liter","umol/min/L","(UMOL/MIN)/L","amount of substance",10036894500000000000,[-3,-1,0,0,0,0,0],"(\u03bcmol/min)/L","si",true,null,null,1,false,false,1,"umol/min/liter; umol/minute/liter; micromoles per minutes per liter; litre; enzyme units; U/L","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. umol/min/L = U/L","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per milliliter","umol/mL","UMOL/ML","amount of substance",6.0221367000000003e+23,[-3,0,0,0,0,0,0],"\u03bcmol/mL","si",true,null,null,1,false,false,1,"umol per mL; micromoles per milliliter; millilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per milliliter per minute","umol/mL/min","(UMOL/ML)/MIN","amount of substance",1.00368945e+22,[-3,-1,0,0,0,0,0],"(\u03bcmol/mL)/min","si",true,null,null,1,false,false,1,"umol per mL per min; micromoles per milliliters per minute; millilitres","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. umol/mL/min = U/mL","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per millimole","umol/mmol","UMOL/MMOL","amount of substance",0.001,[0,0,0,0,0,0,0],"\u03bcmol/mmol","si",true,null,null,1,false,false,0,"umol per mmol; micromoles per millimole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per mole","umol/mol","UMOL/MOL","amount of substance",0.000001,[0,0,0,0,0,0,0],"\u03bcmol/mol","si",true,null,null,1,false,false,0,"umol per mol; micromoles per mole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per micromole","umol/umol","UMOL/UMOL","amount of substance",1,[0,0,0,0,0,0,0],"\u03bcmol/\u03bcmol","si",true,null,null,1,false,false,0,"umol per umol; micromoles per micromole","LOINC","Srto; SFr; EntSRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"microOhm","uOhm","UOHM","electric resistance",0.001,[2,-1,1,0,0,-2,0],"\u03bc\u03a9","si",true,null,null,1,false,false,0,"microOhms; \xb5\u03a9","LOINC","","Clinical","unit of electric resistance","V/A","V/A","1",1,false],[false,"microsecond","us","US","time",0.000001,[0,1,0,0,0,0,0],"\u03bcs",null,false,"T",null,1,false,false,0,"microseconds","LOINC","Time","Clinical","",null,null,null,null,false],[false,"micro enzyme unit per gram","uU/g","UU/G","catalytic activity",10036894500,[0,-1,-1,0,0,0,0],"\u03bcU/g","chemical",true,null,null,1,false,false,1,"uU per gm; micro enzyme units per gram; micro enzymatic activity per mass; enzyme activity","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 uU = 1pmol/min","umol/min","UMOL/MIN","1",1,false],[false,"micro enzyme unit per liter","uU/L","UU/L","catalytic activity",10036894500000,[-3,-1,0,0,0,0,0],"\u03bcU/L","chemical",true,null,null,1,false,false,1,"uU per L; micro enzyme units per liter; litre; enzymatic activity per volume; enzyme activity ","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 uU = 1pmol/min","umol/min","UMOL/MIN","1",1,false],[false,"micro enzyme unit per milliliter","uU/mL","UU/ML","catalytic activity",10036894500000000,[-3,-1,0,0,0,0,0],"\u03bcU/mL","chemical",true,null,null,1,false,false,1,"uU per mL; micro enzyme units per milliliter; millilitre; enzymatic activity per volume; enzyme activity","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 uU = 1pmol/min","umol/min","UMOL/MIN","1",1,false],[false,"microvolt","uV","UV","electric potential",0.001,[2,-2,1,0,0,-1,0],"\u03bcV","si",true,null,null,1,false,false,0,"microvolts","LOINC","Elpot","Clinical","unit of electric potential (voltage)","J/C","J/C","1",1,false]]}}',
            );
        },
    },
    se => {
        se((se.s = 3759));
    },
]);

//# sourceMappingURL=lhc-forms.js.map
